/* eslint-disable */
                      import { SyncDocumentMsg } from "@/components/ContentEditor/contentEditorScalars.ts";
                      import { TypographyStyles } from "@/pages/BrandKitPage/types/scalars";
                      import { BlockCanvasElement } from "@/components/MessageBuilder/model";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * BigInt is an extension of the regular Int field
   *     that supports Integers bigger than a signed
   *     32-bit integer.
   */
  BigInt: { input: number; output: number; }
  ContactQuery: { input: any; output: any; }
  DataQuery: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateRange` scalar type represents a range of Date values as
   * specified by [iso8601](https://en.wikipedia.org/wiki/ISO_8601) and
   * their bounds.
   *
   * Examples:
   * - As object (deprecated)
   *     {
   *         "lower": "2020-12-08",
   *         "upper": "2020-12-09"
   *     }
   * - As string `"[2020-12-08,2020-12-09)"`
   */
  DateRange: { input: { lower: string, upper: string }; output: { lower: string, upper: string }; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /**
   * The `DateTimeRange` scalar type represents a range of DateTime values as
   * specified by [iso8601](https://en.wikipedia.org/wiki/ISO_8601) and
   * their bounds.
   *
   * Examples:
   * - As object (deprecated)
   *     {
   *         "lower": "2020-12-08T05:00:00+00:00",
   *         "upper": "2020-12-09T04:00:00+00:00"
   *     }
   * - As string `"[2020-12-08,2020-12-09)"`
   */
  DateTimeRange: { input: { lower: string, upper: string }; output: { lower: string, upper: string }; }
  /** The `Duration` scalar type represents a ISO8601 duration value. */
  Duration: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  InkQLQuery: { input: any; output: any; }
  InkQLQuerySelect: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string; }
  /**
   * Custom GraphQL Scalar for a language code.
   *
   * This scalar accepts a string value and validates it as a BCP 47 language tag.
   * If valid, it returns the normalized language tag.
   */
  Language: { input: any; output: any; }
  /**
   * The `LayoutDocument` scalar type is the representation of the Layout
   * Template Tag. The Layout can be saved as either SyncDocumentV1Msg or
   * SyncDocumentV1FlatMsg.
   */
  LayoutDocument: { input: SyncDocumentMsg; output: SyncDocumentMsg; }
  /**
   * Nested-tree representation of a RecurringCampaignMessage's layout document.
   *
   * Mirrors content_library.spa_graphql.scalars.layout_document.LayoutDocument, but
   * always nested (no v1/v1-flat envelope) since the RC message builder always sends
   * a nested tree.
   */
  RecurringCampaignMessageLayoutDocument: { input: BlockCanvasElement; output: BlockCanvasElement; }
  /**
   * Search input for recurring campaigns: free text or a campaign hashid,
   * mirroring SearchEventUID for one-time campaigns. A value that decodes as
   * a hashid resolves to the campaign's pk; anything else is passed through
   * to be matched against the title.
   */
  SearchRecurringCampaignUID: { input: any; output: any; }
  /** Search input for triggered campaigns: free text or a campaign hashid. */
  SearchTriggeredCampaignUID: { input: any; output: any; }
  SearchUID: { input: string; output: string; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any; }
  TimeZone: { input: string; output: string; }
  /**
   * Nested-tree representation of a TriggeredCampaignMessage's layout document.
   * Mirrors RecurringCampaignMessageLayoutDocument.
   */
  TriggeredCampaignMessageLayoutDocument: { input: BlockCanvasElement; output: BlockCanvasElement; }
  /**
   * The `TypographyStyles` scalar type represents CSS styles for typography.
   *
   * Allowed properties: fontFamily, fontSize, fontWeight, fontStyle,
   * lineHeight, letterSpacing, color, backgroundColor, textDecorationLine,
   * textAlign, marginTop, marginRight, marginBottom, marginLeft,
   * paddingTop, paddingRight, paddingBottom, paddingLeft, borderTopWidth,
   * borderRightWidth, borderBottomWidth, borderLeftWidth, borderTopStyle,
   * borderRightStyle, borderBottomStyle, borderLeftStyle, borderTopLeftRadius,
   * borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius,
   * borderTopColor, borderRightColor, borderBottomColor, borderLeftColor
   */
  TypographyStyles: { input: TypographyStyles; output: TypographyStyles; }
  /** The `UID` scalar type represents a unique identifier. */
  UID: { input: any; output: any; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
};

export type Account2 = {
  __typename?: 'Account2';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deactivated: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  members: Array<AccountMember>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountCreateSuccess = {
  __typename?: 'AccountCreateSuccess';
  account: Account2;
  success: Scalars['Boolean']['output'];
};

/** Associates an account to a user with a status and their account roles and permissions. */
export type AccountMember = {
  __typename?: 'AccountMember';
  account: Account2;
  canDeactivateUser: AuthorizationResult;
  canEditUser: AuthorizationResult;
  canInviteUser: AuthorizationResult;
  canViewUser: AuthorizationResult;
  createdAt: Scalars['DateTime']['output'];
  inviteExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  invitedBy?: Maybe<OrganizationUser2>;
  isAdmin: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  organizationRole?: Maybe<OrganizationRole>;
  permissions: Array<Permission>;
  roles: Array<Role>;
  status: AccountMemberStatus;
  user: OrganizationUser2;
};

export enum AccountMemberStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Declined = 'DECLINED',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Requested = 'REQUESTED',
  Suspended = 'SUSPENDED',
  Unspecified = 'UNSPECIFIED'
}

export type AccountReactivateSuccess = {
  __typename?: 'AccountReactivateSuccess';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type AccountRoleCreate = {
  __typename?: 'AccountRoleCreate';
  accountRole: Role;
  success: Scalars['Boolean']['output'];
};

export type AccountRoleDelete = {
  __typename?: 'AccountRoleDelete';
  success: Scalars['Boolean']['output'];
};

export type AccountRoleInput = {
  accountId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountRolePermissions = {
  __typename?: 'AccountRolePermissions';
  permissions: Array<PermissionObject>;
};

export type AccountRolePermissionsSuccess = {
  __typename?: 'AccountRolePermissionsSuccess';
  accountRole?: Maybe<Role>;
  success: Scalars['Boolean']['output'];
};

export type AccountRoleUpdate = {
  __typename?: 'AccountRoleUpdate';
  accountRole: Role;
  success: Scalars['Boolean']['output'];
};

export type AccountRoleWithRequiredRoleInput = {
  accountId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type AccountSuccess = {
  __typename?: 'AccountSuccess';
  success: Scalars['Boolean']['output'];
};

/** Represents a summary of customer account. */
export type AccountSummary = {
  __typename?: 'AccountSummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deactivated: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  roles: Array<Role>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userCount: Scalars['Int']['output'];
};

export type AccountUpdateSuccess = {
  __typename?: 'AccountUpdateSuccess';
  account: Account2;
  success: Scalars['Boolean']['output'];
};

export type AccountUserAdd = {
  __typename?: 'AccountUserAdd';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserAssignRole = {
  __typename?: 'AccountUserAssignRole';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserBulkCreate = {
  __typename?: 'AccountUserBulkCreate';
  account: Account2;
  success: Scalars['Boolean']['output'];
};

export type AccountUserBulkCreateWithRoles = {
  __typename?: 'AccountUserBulkCreateWithRoles';
  account: Account2;
  results: AccountUserBulkCreateWithRolesResults;
  success: Scalars['Boolean']['output'];
};

export type AccountUserBulkCreateWithRolesResults = {
  __typename?: 'AccountUserBulkCreateWithRolesResults';
  failureEmailList: Array<Scalars['String']['output']>;
  successfulEmailList: Array<Scalars['String']['output']>;
};

export type AccountUserByEmail = {
  __typename?: 'AccountUserByEmail';
  accountMembershipStatus?: Maybe<AccountMemberStatus>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homeOrganizationId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<MemberStatus>;
};

export type AccountUserInvitationAccept2 = {
  __typename?: 'AccountUserInvitationAccept2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserInvitationDecline = {
  __typename?: 'AccountUserInvitationDecline';
  success: Scalars['Boolean']['output'];
  user?: Maybe<OrganizationUser2>;
};

export type AccountUserInvite = {
  __typename?: 'AccountUserInvite';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserInviteCancel = {
  __typename?: 'AccountUserInviteCancel';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserReactivate = {
  __typename?: 'AccountUserReactivate';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserReinvite = {
  __typename?: 'AccountUserReinvite';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserRemove = {
  __typename?: 'AccountUserRemove';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserRoleCreate2 = {
  __typename?: 'AccountUserRoleCreate2';
  account: Account2;
  success: Scalars['Boolean']['output'];
};

export type AccountUserRoleDelete2 = {
  __typename?: 'AccountUserRoleDelete2';
  account: Account2;
  success: Scalars['Boolean']['output'];
};

export type AccountUserSuspend2 = {
  __typename?: 'AccountUserSuspend2';
  account: Account2;
  success: Scalars['Boolean']['output'];
};

export type AccountUserSwitchRole = {
  __typename?: 'AccountUserSwitchRole';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AccountUserUnassignRole = {
  __typename?: 'AccountUserUnassignRole';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type AcousticCampaign = {
  __typename?: 'AcousticCampaign';
  defaultLinkMetadata?: Maybe<AcousticCampaignDefaultLinkMetadata>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredLinkMetadataFields: Array<AcousticCampaignRequiredLinkMetaDataFields>;
};

export type AcousticCampaignDefaultLinkMetadata = {
  __typename?: 'AcousticCampaignDefaultLinkMetadata';
  requiresLinkType: Scalars['Boolean']['output'];
  requiresName: Scalars['Boolean']['output'];
};

export enum AcousticCampaignRequiredLinkMetaDataFields {
  LinkType = 'LINK_TYPE',
  Name = 'NAME'
}

export type ActivatePlatformApplicationSuccess = {
  __typename?: 'ActivatePlatformApplicationSuccess';
  application: PlatformApplication;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum ActiveSubStatus {
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  WaitingToSend = 'WAITING_TO_SEND'
}

export type AdobeCampaign = {
  __typename?: 'AdobeCampaign';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredLinkMetadataFields: Array<AdobeCampaignRequiredLinkMetaDataFields>;
};

export type AdobeCampaignDeliveryNature = {
  __typename?: 'AdobeCampaignDeliveryNature';
  availableDeliveryNatureId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type AdobeCampaignDeliveryVariable = {
  __typename?: 'AdobeCampaignDeliveryVariable';
  availableDeliveryVariableId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export enum AdobeCampaignRequiredLinkMetaDataFields {
  TrackingType = 'TRACKING_TYPE'
}

export type AdobeJourneyOptimizer = {
  __typename?: 'AdobeJourneyOptimizer';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredLinkMetadataFields: Array<AdobeJourneyOptimizerRequiredLinkMetaDataFields>;
};

export type AdobeJourneyOptimizerConfig = {
  __typename?: 'AdobeJourneyOptimizerConfig';
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  id: Scalars['ID']['output'];
};

export enum AdobeJourneyOptimizerRequiredLinkMetaDataFields {
  TrackingType = 'TRACKING_TYPE'
}

export type AlertCriterionInput = {
  metricId: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  threshold: Scalars['String']['input'];
};

export type AlertCriterionType = {
  __typename?: 'AlertCriterionType';
  metricId: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  threshold: Scalars['String']['output'];
};

export type AlertEligibilityInput = {
  config: Scalars['GenericScalar']['input'];
  id: Scalars['String']['input'];
};

export type AlertEligibilityType = {
  __typename?: 'AlertEligibilityType';
  config: Scalars['GenericScalar']['output'];
  id: Scalars['String']['output'];
};

export type AlertRuleCreateSuccess = {
  __typename?: 'AlertRuleCreateSuccess';
  rule: AlertRuleType;
};

export type AlertRuleDeleteSuccess = {
  __typename?: 'AlertRuleDeleteSuccess';
  success: Scalars['Boolean']['output'];
};

export type AlertRuleModifySuccess = {
  __typename?: 'AlertRuleModifySuccess';
  rule: AlertRuleType;
};

export type AlertRuleSubscribeSuccess = {
  __typename?: 'AlertRuleSubscribeSuccess';
  success: Scalars['Boolean']['output'];
};

export type AlertRuleType = {
  __typename?: 'AlertRuleType';
  createdAt: Scalars['DateTime']['output'];
  criteria: Array<AlertCriterionType>;
  eligibility: Array<AlertEligibilityType>;
  entityId?: Maybe<Scalars['String']['output']>;
  hashid: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  sourceId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type AlertRuleUnsubscribeSuccess = {
  __typename?: 'AlertRuleUnsubscribeSuccess';
  success: Scalars['Boolean']['output'];
};

export type AlertRuleWithSubscriptionsType = {
  __typename?: 'AlertRuleWithSubscriptionsType';
  createdAt: Scalars['DateTime']['output'];
  criteria: Array<AlertCriterionType>;
  eligibility: Array<AlertEligibilityType>;
  entityId?: Maybe<Scalars['String']['output']>;
  hashid: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  sourceId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userSubscriptions: Array<AlertSubscriptionType>;
  version: Scalars['Int']['output'];
};

export type AlertSubscriptionType = {
  __typename?: 'AlertSubscriptionType';
  channel: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type AmazonSes = {
  __typename?: 'AmazonSES';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AmazonSesConfig = {
  __typename?: 'AmazonSESConfig';
  availableEmailTags: Array<AvailableEmailTag>;
  configurationSet: Scalars['String']['output'];
  emailTags: Array<EmailTag>;
  fromAddress: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  replyToAddress: Scalars['String']['output'];
  replyToName: Scalars['String']['output'];
};

export type AmazonSesConfigUpdateSuccess = {
  __typename?: 'AmazonSESConfigUpdateSuccess';
  amazonSesConfig: AmazonSesConfig;
  success: Scalars['Boolean']['output'];
};

export type AnalyticsActivity = {
  __typename?: 'AnalyticsActivity';
  autoOpenRate?: Maybe<Scalars['Float']['output']>;
  autoOpens: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['BigInt']['output'];
  clickthroughRate?: Maybe<Scalars['Float']['output']>;
  complaintRate?: Maybe<Scalars['Float']['output']>;
  complaints: Scalars['BigInt']['output'];
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['BigInt']['output'];
  hardBounceRate?: Maybe<Scalars['Float']['output']>;
  hardBounces: Scalars['BigInt']['output'];
  openRate?: Maybe<Scalars['Float']['output']>;
  opens: Scalars['BigInt']['output'];
  revenue: Scalars['BigInt']['output'];
  revenuePerSend?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSends?: Maybe<Scalars['Float']['output']>;
  sends: Scalars['BigInt']['output'];
  softBounceRate?: Maybe<Scalars['Float']['output']>;
  softBounces: Scalars['BigInt']['output'];
  uniqueAutoOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueAutoOpens: Scalars['BigInt']['output'];
  uniqueClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueClickthroughRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueOpens: Scalars['BigInt']['output'];
  unknownBounceRate?: Maybe<Scalars['Float']['output']>;
  unknownBounces: Scalars['BigInt']['output'];
  unsubscribeRate?: Maybe<Scalars['Float']['output']>;
  unsubscribes: Scalars['BigInt']['output'];
};

export enum AnalyticsAttributionWindow {
  AttributionWindow_1D = 'ATTRIBUTION_WINDOW_1D',
  AttributionWindow_1H = 'ATTRIBUTION_WINDOW_1H',
  AttributionWindow_2D = 'ATTRIBUTION_WINDOW_2D',
  AttributionWindow_3H = 'ATTRIBUTION_WINDOW_3H',
  AttributionWindow_6H = 'ATTRIBUTION_WINDOW_6H',
  AttributionWindow_7D = 'ATTRIBUTION_WINDOW_7D',
  AttributionWindow_12H = 'ATTRIBUTION_WINDOW_12H',
  AttributionWindow_14D = 'ATTRIBUTION_WINDOW_14D',
  AttributionWindow_21D = 'ATTRIBUTION_WINDOW_21D',
  AttributionWindow_30D = 'ATTRIBUTION_WINDOW_30D'
}

export type AnalyticsBaseCreativeActivity = {
  __typename?: 'AnalyticsBaseCreativeActivity';
  autoImpressionRate?: Maybe<Scalars['Float']['output']>;
  autoImpressions: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['BigInt']['output'];
  clickthroughRate?: Maybe<Scalars['Float']['output']>;
  complaintRate?: Maybe<Scalars['Float']['output']>;
  complaints: Scalars['BigInt']['output'];
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['BigInt']['output'];
  impressionRate?: Maybe<Scalars['Float']['output']>;
  impressions: Scalars['BigInt']['output'];
  placements: Scalars['BigInt']['output'];
  revenue: Scalars['BigInt']['output'];
  revenuePerPlacement?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacements?: Maybe<Scalars['Float']['output']>;
  uniqueAutoImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueAutoImpressions: Scalars['BigInt']['output'];
  uniqueClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueClickthroughRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueImpressions: Scalars['BigInt']['output'];
  unsubscribeRate?: Maybe<Scalars['Float']['output']>;
  unsubscribes: Scalars['BigInt']['output'];
};

export enum AnalyticsCalendar {
  Fiscal = 'FISCAL',
  Gregorian = 'GREGORIAN'
}

export type AnalyticsCampaignActivities = {
  __typename?: 'AnalyticsCampaignActivities';
  campaigns: Array<AnalyticsCampaignActivity>;
};

export type AnalyticsCampaignActivity = {
  __typename?: 'AnalyticsCampaignActivity';
  activity: AnalyticsActivity;
  campaign: Campaign;
};

export type AnalyticsCampaignCreativeActivity = {
  __typename?: 'AnalyticsCampaignCreativeActivity';
  activity: AnalyticsBaseCreativeActivity;
  creative: Creative;
};

export type AnalyticsCampaignExperimentActivity = {
  __typename?: 'AnalyticsCampaignExperimentActivity';
  control: AnalyticsControlActivity;
  experiment: Experiment;
  treatments: Array<AnalyticsTreatmentActivity>;
};

export type AnalyticsCampaignMailingActivity = {
  __typename?: 'AnalyticsCampaignMailingActivity';
  activity: AnalyticsActivity;
  mailing: Mailing;
};

export type AnalyticsCampaignSegmentActivity = {
  __typename?: 'AnalyticsCampaignSegmentActivity';
  activity: AnalyticsActivity;
  segment: ContactSegment;
};

export type AnalyticsComparativeStatistics = {
  __typename?: 'AnalyticsComparativeStatistics';
  autoOpenRate: AnalyticsRateStatistics;
  averageOrderValue: AnalyticsRateStatistics;
  clickRate: AnalyticsRateStatistics;
  clickthroughRate: AnalyticsRateStatistics;
  conversionRate: AnalyticsRateStatistics;
  openRate: AnalyticsRateStatistics;
  revenuePerSend: AnalyticsRateStatistics;
  revenuePerThousandSends: AnalyticsRateStatistics;
  uniqueAutoOpenRate: AnalyticsRateStatistics;
  uniqueClickRate: AnalyticsRateStatistics;
  uniqueClickthroughRate: AnalyticsRateStatistics;
  uniqueConversionRate: AnalyticsRateStatistics;
  uniqueOpenRate: AnalyticsRateStatistics;
  unsubscribeRate: AnalyticsRateStatistics;
};

export type AnalyticsConfiguration = {
  __typename?: 'AnalyticsConfiguration';
  analyticsAttributionWindow: AnalyticsAttributionWindow;
  analyticsCalendar: AnalyticsCalendar;
  analyticsCurrency: AnalyticsCurrency;
  analyticsExportDecimalPrecision: Scalars['Int']['output'];
  analyticsExportRateFormat: AnalyticsExportRateFormat;
  analyticsRevenueCap?: Maybe<Scalars['Float']['output']>;
  analyticsRevenueCapEnabled: Scalars['Boolean']['output'];
  analyticsShowProjectedMetrics: Scalars['Boolean']['output'];
  analyticsStatSigThreshold: Scalars['Float']['output'];
  kpiDefinition: AnalyticsKpiDefinition;
};

export type AnalyticsConfigurationUpdate = {
  __typename?: 'AnalyticsConfigurationUpdate';
  client: Client;
};

export type AnalyticsControlActivity = {
  __typename?: 'AnalyticsControlActivity';
  activity: AnalyticsActivity;
  sendRatio?: Maybe<Scalars['Float']['output']>;
  treatment: Treatment;
};

export type AnalyticsCreativeActivities = {
  __typename?: 'AnalyticsCreativeActivities';
  creatives: Array<AnalyticsCreativeActivity>;
};

export type AnalyticsCreativeActivitiesV2 = {
  __typename?: 'AnalyticsCreativeActivitiesV2';
  creatives: Array<AnalyticsCreativeActivityV2>;
};

export type AnalyticsCreativeActivity = {
  __typename?: 'AnalyticsCreativeActivity';
  activity: AnalyticsBaseCreativeActivity;
  creative: Creative;
};

export type AnalyticsCreativeActivityV2 = {
  __typename?: 'AnalyticsCreativeActivityV2';
  activity: AnalyticsBaseCreativeActivity;
  creative: Creative;
  scores: AnalyticsCreativeScoresV2;
};

export type AnalyticsCreativeCampaignActivity = {
  __typename?: 'AnalyticsCreativeCampaignActivity';
  activity: AnalyticsBaseCreativeActivity;
  campaign: Campaign;
};

export type AnalyticsCreativeScores = {
  __typename?: 'AnalyticsCreativeScores';
  clickEffectiveness?: Maybe<Scalars['Float']['output']>;
  conversionEffectiveness?: Maybe<Scalars['Float']['output']>;
  count: Scalars['BigInt']['output'];
  creativeId: Scalars['ID']['output'];
  effectiveness?: Maybe<Scalars['Float']['output']>;
  openEffectiveness?: Maybe<Scalars['Float']['output']>;
  percentPositiveReaction?: Maybe<Scalars['Float']['output']>;
  runId: Scalars['BigInt']['output'];
};

export type AnalyticsCreativeScoresV2 = {
  __typename?: 'AnalyticsCreativeScoresV2';
  clickBucket?: Maybe<Scalars['String']['output']>;
  clickEffectiveness?: Maybe<Scalars['Float']['output']>;
  conversionBucket?: Maybe<Scalars['String']['output']>;
  conversionEffectiveness?: Maybe<Scalars['Float']['output']>;
  creativeBucket?: Maybe<Scalars['String']['output']>;
  creativeEffectiveness?: Maybe<Scalars['Float']['output']>;
  creativeId: Scalars['ID']['output'];
  openBucket?: Maybe<Scalars['String']['output']>;
  openEffectiveness?: Maybe<Scalars['Float']['output']>;
  retentionBucket?: Maybe<Scalars['String']['output']>;
  retentionEffectiveness?: Maybe<Scalars['Float']['output']>;
  revenueBucket?: Maybe<Scalars['String']['output']>;
  revenueEffectiveness?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsCreativeSegmentActivity = {
  __typename?: 'AnalyticsCreativeSegmentActivity';
  activity: AnalyticsBaseCreativeActivity;
  segment: ContactSegment;
};

export type AnalyticsCreativeSubjectLineActivity = {
  __typename?: 'AnalyticsCreativeSubjectLineActivity';
  activity: AnalyticsBaseCreativeActivity;
  subjectline: SubjectLine;
};

export enum AnalyticsCurrency {
  Cad = 'CAD',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type AnalyticsDashboardConfigUpdateResponse = {
  __typename?: 'AnalyticsDashboardConfigUpdateResponse';
  success: Scalars['Boolean']['output'];
};

export type AnalyticsEventActivity = {
  __typename?: 'AnalyticsEventActivity';
  count: Scalars['BigInt']['output'];
  eventType: AnalyticsEventType;
  mostRecent?: Maybe<Scalars['DateTime']['output']>;
};

export enum AnalyticsEventType {
  CollectionPageView = 'COLLECTION_PAGE_VIEW',
  OrderCancelation = 'ORDER_CANCELATION',
  OrderCompletion = 'ORDER_COMPLETION',
  OrderRefund = 'ORDER_REFUND',
  ProductPageView = 'PRODUCT_PAGE_VIEW',
  ProductSearch = 'PRODUCT_SEARCH',
  WebsiteIdentity = 'WEBSITE_IDENTITY',
  WebsitePageView = 'WEBSITE_PAGE_VIEW'
}

export type AnalyticsExperimentActivities = {
  __typename?: 'AnalyticsExperimentActivities';
  experiments: Array<AnalyticsExperimentActivity>;
};

export type AnalyticsExperimentActivity = {
  __typename?: 'AnalyticsExperimentActivity';
  control: AnalyticsControlActivity;
  earliestCampaignUsage?: Maybe<Scalars['Date']['output']>;
  experiment: Experiment;
  latestCampaignUsage?: Maybe<Scalars['Date']['output']>;
  treatments: Array<AnalyticsTreatmentActivity>;
};

export enum AnalyticsExportRateFormat {
  Fractional = 'FRACTIONAL',
  Percent = 'PERCENT'
}

export type AnalyticsExportReponse = {
  __typename?: 'AnalyticsExportReponse';
  signedUrl: Scalars['String']['output'];
};

export type AnalyticsFilterInput = {
  field: Scalars['String']['input'];
  operator: FilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type AnalyticsKpiDefinition = {
  __typename?: 'AnalyticsKPIDefinition';
  eventSelections: Array<AnalyticsKpiEventSelection>;
};

export type AnalyticsKpiEventSelection = {
  __typename?: 'AnalyticsKPIEventSelection';
  eventSourceId?: Maybe<Scalars['ID']['output']>;
  eventType: AnalyticsKpiEventType;
};

export type AnalyticsKpiEventSelectionInput = {
  eventSourceId?: InputMaybe<Scalars['ID']['input']>;
  eventType: AnalyticsKpiEventType;
};

/** An enumeration. */
export enum AnalyticsKpiEventType {
  Conversion = 'CONVERSION',
  CustomEvent = 'CUSTOM_EVENT'
}

export type AnalyticsRateStatistics = {
  __typename?: 'AnalyticsRateStatistics';
  ciLower?: Maybe<Scalars['Float']['output']>;
  ciUpper?: Maybe<Scalars['Float']['output']>;
  confidenceLevel?: Maybe<Scalars['Float']['output']>;
  isStatisticallySignificant: Scalars['Boolean']['output'];
  lift?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsReport = {
  __typename?: 'AnalyticsReport';
  reportRows: Array<AnalyticsReportRow>;
};

export type AnalyticsReportColumn = {
  __typename?: 'AnalyticsReportColumn';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  sortable: Scalars['Boolean']['output'];
  visibleByDefault: Scalars['Boolean']['output'];
};

export type AnalyticsReportEntry = {
  __typename?: 'AnalyticsReportEntry';
  columnId: Scalars['String']['output'];
  value?: Maybe<AnalyticsReportValue>;
};

export type AnalyticsReportRow = {
  __typename?: 'AnalyticsReportRow';
  row: Array<AnalyticsReportEntry>;
};

export type AnalyticsReportValue = AnalyticsReportValueBoolean | AnalyticsReportValueDate | AnalyticsReportValueDateTime | AnalyticsReportValueFloat | AnalyticsReportValueInteger | AnalyticsReportValueString;

export type AnalyticsReportValueBoolean = {
  __typename?: 'AnalyticsReportValueBoolean';
  value: Scalars['Boolean']['output'];
};

export type AnalyticsReportValueDate = {
  __typename?: 'AnalyticsReportValueDate';
  value: Scalars['Date']['output'];
};

export type AnalyticsReportValueDateTime = {
  __typename?: 'AnalyticsReportValueDateTime';
  value: Scalars['DateTime']['output'];
};

export type AnalyticsReportValueFloat = {
  __typename?: 'AnalyticsReportValueFloat';
  value: Scalars['Float']['output'];
};

export type AnalyticsReportValueInteger = {
  __typename?: 'AnalyticsReportValueInteger';
  value: Scalars['BigInt']['output'];
};

export type AnalyticsReportValueString = {
  __typename?: 'AnalyticsReportValueString';
  value: Scalars['String']['output'];
};

export type AnalyticsSegmentActivity = {
  __typename?: 'AnalyticsSegmentActivity';
  activity: AnalyticsActivity;
  segment: ContactSegment;
};

export type AnalyticsSegmentCampaignActivity = {
  __typename?: 'AnalyticsSegmentCampaignActivity';
  activity: AnalyticsActivity;
  campaign: Campaign;
};

export type AnalyticsSegmentCreativeActivity = {
  __typename?: 'AnalyticsSegmentCreativeActivity';
  activity: AnalyticsBaseCreativeActivity;
  creative: Creative;
};

export type AnalyticsSegmentGroupActivity = {
  __typename?: 'AnalyticsSegmentGroupActivity';
  segmentGroup: ContactSegmentGroup;
  segments?: Maybe<Array<Maybe<AnalyticsSegmentActivity>>>;
};

export type AnalyticsTreatmentActivity = {
  __typename?: 'AnalyticsTreatmentActivity';
  activity: AnalyticsActivity;
  sendRatio?: Maybe<Scalars['Float']['output']>;
  statistics: AnalyticsComparativeStatistics;
  treatment: Treatment;
};

export type AnalyticsV2BaseCreativeMetrics = {
  __typename?: 'AnalyticsV2BaseCreativeMetrics';
  autoImpressionRate?: Maybe<Scalars['Float']['output']>;
  autoImpressions: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clickToImpressionRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['BigInt']['output'];
  clickthroughRate?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversionToClickRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['BigInt']['output'];
  decayedClicks: Scalars['Float']['output'];
  impressionRate?: Maybe<Scalars['Float']['output']>;
  impressions: Scalars['BigInt']['output'];
  orderRevenueVariance?: Maybe<Scalars['Float']['output']>;
  placementRevenueVariance?: Maybe<Scalars['Float']['output']>;
  placements: Scalars['BigInt']['output'];
  revenue: Scalars['BigInt']['output'];
  revenuePerPlacement?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacements?: Maybe<Scalars['Float']['output']>;
  uniqueAutoImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueAutoImpressions: Scalars['BigInt']['output'];
  uniqueClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueClickToImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueClickthroughRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueImpressions: Scalars['BigInt']['output'];
};

export type AnalyticsV2BaseMetrics = {
  __typename?: 'AnalyticsV2BaseMetrics';
  autoOpenRate?: Maybe<Scalars['Float']['output']>;
  autoOpens: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clickToOpenRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['BigInt']['output'];
  clickthroughRate?: Maybe<Scalars['Float']['output']>;
  complaintRate?: Maybe<Scalars['Float']['output']>;
  complaints: Scalars['BigInt']['output'];
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversionToClickRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['BigInt']['output'];
  hardBounceRate?: Maybe<Scalars['Float']['output']>;
  hardBounces: Scalars['BigInt']['output'];
  messageRevenueVariance?: Maybe<Scalars['Float']['output']>;
  openRate?: Maybe<Scalars['Float']['output']>;
  opens: Scalars['BigInt']['output'];
  orderRevenueVariance?: Maybe<Scalars['Float']['output']>;
  revenue: Scalars['BigInt']['output'];
  revenuePerSend?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSends?: Maybe<Scalars['Float']['output']>;
  sends: Scalars['BigInt']['output'];
  softBounceRate?: Maybe<Scalars['Float']['output']>;
  softBounces: Scalars['BigInt']['output'];
  uniqueAutoOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueAutoOpens: Scalars['BigInt']['output'];
  uniqueClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueClickToOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueClickthroughRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueOpens: Scalars['BigInt']['output'];
  unknownBounceRate?: Maybe<Scalars['Float']['output']>;
  unknownBounces: Scalars['BigInt']['output'];
  unsubscribeRate?: Maybe<Scalars['Float']['output']>;
  unsubscribes: Scalars['BigInt']['output'];
};

export type AnalyticsV2BaseTreatmentCreativeMetrics = {
  __typename?: 'AnalyticsV2BaseTreatmentCreativeMetrics';
  autoImpressionRate?: Maybe<Scalars['Float']['output']>;
  autoImpressionRateCiLower?: Maybe<Scalars['Float']['output']>;
  autoImpressionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  autoImpressionRateConfidence?: Maybe<Scalars['Float']['output']>;
  autoImpressionRateLift?: Maybe<Scalars['Float']['output']>;
  autoImpressionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  autoImpressions: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueCiLower?: Maybe<Scalars['Float']['output']>;
  averageOrderValueCiUpper?: Maybe<Scalars['Float']['output']>;
  averageOrderValueConfidence?: Maybe<Scalars['Float']['output']>;
  averageOrderValueLift?: Maybe<Scalars['Float']['output']>;
  averageOrderValueSignificant?: Maybe<Scalars['Boolean']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clickRateCiLower?: Maybe<Scalars['Float']['output']>;
  clickRateCiUpper?: Maybe<Scalars['Float']['output']>;
  clickRateConfidence?: Maybe<Scalars['Float']['output']>;
  clickRateLift?: Maybe<Scalars['Float']['output']>;
  clickRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  clickToImpressionRate?: Maybe<Scalars['Float']['output']>;
  clickToImpressionRateCiLower?: Maybe<Scalars['Float']['output']>;
  clickToImpressionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  clickToImpressionRateConfidence?: Maybe<Scalars['Float']['output']>;
  clickToImpressionRateLift?: Maybe<Scalars['Float']['output']>;
  clickToImpressionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  clicks: Scalars['BigInt']['output'];
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversionRateCiLower?: Maybe<Scalars['Float']['output']>;
  conversionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  conversionRateConfidence?: Maybe<Scalars['Float']['output']>;
  conversionRateLift?: Maybe<Scalars['Float']['output']>;
  conversionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  conversionToClickRate?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateCiLower?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateCiUpper?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateConfidence?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateLift?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  conversions: Scalars['BigInt']['output'];
  impressionRate?: Maybe<Scalars['Float']['output']>;
  impressionRateCiLower?: Maybe<Scalars['Float']['output']>;
  impressionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  impressionRateConfidence?: Maybe<Scalars['Float']['output']>;
  impressionRateLift?: Maybe<Scalars['Float']['output']>;
  impressionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  impressions: Scalars['BigInt']['output'];
  placementRatio: Scalars['Float']['output'];
  placements: Scalars['BigInt']['output'];
  revenue: Scalars['BigInt']['output'];
  revenuePerPlacement?: Maybe<Scalars['Float']['output']>;
  revenuePerPlacementCiLower?: Maybe<Scalars['Float']['output']>;
  revenuePerPlacementCiUpper?: Maybe<Scalars['Float']['output']>;
  revenuePerPlacementConfidence?: Maybe<Scalars['Float']['output']>;
  revenuePerPlacementLift?: Maybe<Scalars['Float']['output']>;
  revenuePerPlacementSignificant?: Maybe<Scalars['Boolean']['output']>;
  revenuePerThousandPlacements?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacementsCiLower?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacementsCiUpper?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacementsConfidence?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacementsLift?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandPlacementsSignificant?: Maybe<Scalars['Boolean']['output']>;
  uniqueAutoImpressions: Scalars['BigInt']['output'];
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateCiLower?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateConfidence?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateLift?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueImpressions: Scalars['BigInt']['output'];
};

export type AnalyticsV2BaseTreatmentMetrics = {
  __typename?: 'AnalyticsV2BaseTreatmentMetrics';
  autoOpenRate?: Maybe<Scalars['Float']['output']>;
  autoOpenRateCiLower?: Maybe<Scalars['Float']['output']>;
  autoOpenRateCiUpper?: Maybe<Scalars['Float']['output']>;
  autoOpenRateConfidence?: Maybe<Scalars['Float']['output']>;
  autoOpenRateLift?: Maybe<Scalars['Float']['output']>;
  autoOpenRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  autoOpens: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  averageOrderValueCiLower?: Maybe<Scalars['Float']['output']>;
  averageOrderValueCiUpper?: Maybe<Scalars['Float']['output']>;
  averageOrderValueConfidence?: Maybe<Scalars['Float']['output']>;
  averageOrderValueLift?: Maybe<Scalars['Float']['output']>;
  averageOrderValueSignificant?: Maybe<Scalars['Boolean']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clickRateCiLower?: Maybe<Scalars['Float']['output']>;
  clickRateCiUpper?: Maybe<Scalars['Float']['output']>;
  clickRateConfidence?: Maybe<Scalars['Float']['output']>;
  clickRateLift?: Maybe<Scalars['Float']['output']>;
  clickRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  clickToOpenRate?: Maybe<Scalars['Float']['output']>;
  clickToOpenRateCiLower?: Maybe<Scalars['Float']['output']>;
  clickToOpenRateCiUpper?: Maybe<Scalars['Float']['output']>;
  clickToOpenRateConfidence?: Maybe<Scalars['Float']['output']>;
  clickToOpenRateLift?: Maybe<Scalars['Float']['output']>;
  clickToOpenRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  clicks: Scalars['BigInt']['output'];
  complaintRate?: Maybe<Scalars['Float']['output']>;
  complaints: Scalars['BigInt']['output'];
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversionRateCiLower?: Maybe<Scalars['Float']['output']>;
  conversionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  conversionRateConfidence?: Maybe<Scalars['Float']['output']>;
  conversionRateLift?: Maybe<Scalars['Float']['output']>;
  conversionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  conversionToClickRate?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateCiLower?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateCiUpper?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateConfidence?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateLift?: Maybe<Scalars['Float']['output']>;
  conversionToClickRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  conversions: Scalars['BigInt']['output'];
  hardBounceRate?: Maybe<Scalars['Float']['output']>;
  hardBounces: Scalars['BigInt']['output'];
  messageRevenueVariance?: Maybe<Scalars['Float']['output']>;
  openRate?: Maybe<Scalars['Float']['output']>;
  openRateCiLower?: Maybe<Scalars['Float']['output']>;
  openRateCiUpper?: Maybe<Scalars['Float']['output']>;
  openRateConfidence?: Maybe<Scalars['Float']['output']>;
  openRateLift?: Maybe<Scalars['Float']['output']>;
  openRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  opens: Scalars['BigInt']['output'];
  orderRevenueVariance?: Maybe<Scalars['Float']['output']>;
  revenue: Scalars['BigInt']['output'];
  revenuePerSend?: Maybe<Scalars['Float']['output']>;
  revenuePerSendCiLower?: Maybe<Scalars['Float']['output']>;
  revenuePerSendCiUpper?: Maybe<Scalars['Float']['output']>;
  revenuePerSendConfidence?: Maybe<Scalars['Float']['output']>;
  revenuePerSendLift?: Maybe<Scalars['Float']['output']>;
  revenuePerSendSignificant?: Maybe<Scalars['Boolean']['output']>;
  revenuePerThousandSends?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSendsCiLower?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSendsCiUpper?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSendsConfidence?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSendsLift?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSendsSignificant?: Maybe<Scalars['Boolean']['output']>;
  sendRatio: Scalars['Float']['output'];
  sends: Scalars['BigInt']['output'];
  softBounceRate?: Maybe<Scalars['Float']['output']>;
  softBounces: Scalars['BigInt']['output'];
  uniqueAutoOpens: Scalars['BigInt']['output'];
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateCiLower?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateCiUpper?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateConfidence?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateLift?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  uniqueConversionToClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRateCiLower?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRateCiUpper?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRateConfidence?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRateLift?: Maybe<Scalars['Float']['output']>;
  uniqueConversionToClickRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueOpens: Scalars['BigInt']['output'];
  unknownBounceRate?: Maybe<Scalars['Float']['output']>;
  unknownBounces: Scalars['BigInt']['output'];
  unsubscribeRate?: Maybe<Scalars['Float']['output']>;
  unsubscribeRateCiLower?: Maybe<Scalars['Float']['output']>;
  unsubscribeRateCiUpper?: Maybe<Scalars['Float']['output']>;
  unsubscribeRateConfidence?: Maybe<Scalars['Float']['output']>;
  unsubscribeRateLift?: Maybe<Scalars['Float']['output']>;
  unsubscribeRateSignificant?: Maybe<Scalars['Boolean']['output']>;
  unsubscribes: Scalars['BigInt']['output'];
};

export type AnalyticsV2Campaign = {
  __typename?: 'AnalyticsV2Campaign';
  campaign: Campaign;
  metrics: AnalyticsV2BaseMetrics;
};

export type AnalyticsV2Creative = {
  __typename?: 'AnalyticsV2Creative';
  creative: Creative;
  metrics: AnalyticsV2BaseCreativeMetrics;
  scores: AnalyticsCreativeScores;
};

export type AnalyticsV2CreativeSegment = {
  __typename?: 'AnalyticsV2CreativeSegment';
  metrics: AnalyticsV2BaseCreativeMetrics;
  segment: ContactSegment;
};

export type AnalyticsV2CreativeTreatment = {
  __typename?: 'AnalyticsV2CreativeTreatment';
  metrics: AnalyticsV2BaseTreatmentCreativeMetrics;
  treatment: Treatment;
};

export type AnalyticsV2CreativeV2 = {
  __typename?: 'AnalyticsV2CreativeV2';
  creative: Creative;
  metrics: AnalyticsV2BaseCreativeMetrics;
  scores: AnalyticsCreativeScoresV2;
};

export type AnalyticsV2ExperimentCampaign = {
  __typename?: 'AnalyticsV2ExperimentCampaign';
  campaign: Campaign;
  treatments: Array<AnalyticsV2Treatment>;
};

export type AnalyticsV2ExperimentCreative = {
  __typename?: 'AnalyticsV2ExperimentCreative';
  creative: Creative;
  treatments: Array<AnalyticsV2CreativeTreatment>;
};

export type AnalyticsV2GroupedCampaigns = {
  __typename?: 'AnalyticsV2GroupedCampaigns';
  campaigns: Array<AnalyticsV2Campaign>;
  group: Scalars['String']['output'];
  metrics: AnalyticsV2BaseMetrics;
};

export type AnalyticsV2GroupedCreatives = {
  __typename?: 'AnalyticsV2GroupedCreatives';
  creativeCount: Scalars['Int']['output'];
  creativeUsageRatio: Scalars['Float']['output'];
  creatives: Array<AnalyticsV2Creative>;
  group: Scalars['String']['output'];
  metrics: AnalyticsV2BaseCreativeMetrics;
  scores: AnalyticsCreativeScores;
};

export type AnalyticsV2GroupedCreativesV2 = {
  __typename?: 'AnalyticsV2GroupedCreativesV2';
  creativeCount: Scalars['Int']['output'];
  creativeUsageRatio: Scalars['Float']['output'];
  creatives: Array<AnalyticsV2CreativeV2>;
  group: Scalars['String']['output'];
  metrics: AnalyticsV2BaseCreativeMetrics;
  scores: AnalyticsCreativeScoresV2;
};

export type AnalyticsV2Segment = {
  __typename?: 'AnalyticsV2Segment';
  metrics: AnalyticsV2BaseMetrics;
  segment: ContactSegment;
};

export type AnalyticsV2SegmentGroupCampaign = {
  __typename?: 'AnalyticsV2SegmentGroupCampaign';
  campaign: Campaign;
  segments: Array<AnalyticsV2Segment>;
};

export type AnalyticsV2SegmentGroupCreative = {
  __typename?: 'AnalyticsV2SegmentGroupCreative';
  creative: Creative;
  segments: Array<AnalyticsV2CreativeSegment>;
};

export type AnalyticsV2Treatment = {
  __typename?: 'AnalyticsV2Treatment';
  metrics: AnalyticsV2BaseTreatmentMetrics;
  treatment: Treatment;
};

export type AnalyticsWidget = {
  __typename?: 'AnalyticsWidget';
  config?: Maybe<Scalars['JSONString']['output']>;
  enabled: Scalars['Boolean']['output'];
  expandedMetricIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  option?: Maybe<AnalyticsWidgetOption>;
  order: Scalars['Int']['output'];
};

export type AnalyticsWidgetInput = {
  config?: InputMaybe<Scalars['JSONString']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  option?: InputMaybe<AnalyticsWidgetOptionInput>;
  order: Scalars['Int']['input'];
};

export type AnalyticsWidgetOption = {
  __typename?: 'AnalyticsWidgetOption';
  selected: Array<Scalars['String']['output']>;
};

export type AnalyticsWidgetOptionInput = {
  selected: Array<Scalars['String']['input']>;
};

export type ApplicationRole = {
  __typename?: 'ApplicationRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  title: Scalars['String']['output'];
};

export type Attribute = {
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
};

export type AttributeDefinition = {
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type AttributeOption = {
  __typename?: 'AttributeOption';
  id: Scalars['ID']['output'];
  selected: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type AttributeOption2 = {
  __typename?: 'AttributeOption2';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** Attribution type for custom event categories. */
export enum AttributionType {
  AttributionTypeDirect = 'ATTRIBUTION_TYPE_DIRECT',
  AttributionTypeIndirect = 'ATTRIBUTION_TYPE_INDIRECT',
  AttributionTypeUnspecified = 'ATTRIBUTION_TYPE_UNSPECIFIED'
}

export type Audience = {
  __typename?: 'Audience';
  archived: Scalars['Boolean']['output'];
  campaigns: Array<Campaign>;
  client: Client;
  creatives: Array<Creative>;
  defaultType?: Maybe<AudienceType>;
  groups: Array<PredefinedAudienceGroupType>;
  id: Scalars['ID']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  types: Array<AudienceType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  usageCount: Scalars['Int']['output'];
};

export type AudienceCombinationInput = {
  audienceIds: Array<Scalars['ID']['input']>;
  treatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AudienceCreate = {
  __typename?: 'AudienceCreate';
  audience: Audience;
};

export type AudienceDescription = {
  __typename?: 'AudienceDescription';
  audiences: Array<CampaignAudience>;
  splitConfigs: Array<ContactAudienceConfigSplit>;
  treatments?: Maybe<Array<TreatmentEligibleCreatives>>;
};

export type AudienceDuplicate = {
  __typename?: 'AudienceDuplicate';
  audience: Audience;
  success: Scalars['Boolean']['output'];
};

export type AudienceGroupCreate = {
  __typename?: 'AudienceGroupCreate';
  audienceGroup: PredefinedAudienceGroupType;
};

export type AudienceGroupUpdate = {
  __typename?: 'AudienceGroupUpdate';
  audienceGroup: PredefinedAudienceGroupType;
};

export type AudiencePaginatedType = {
  __typename?: 'AudiencePaginatedType';
  page: Scalars['Int']['output'];
  results: Array<Audience>;
  total: Scalars['Int']['output'];
};

export enum AudienceSortType {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type AudienceSummary = {
  __typename?: 'AudienceSummary';
  excluded: Scalars['Int']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  net: Scalars['Int']['output'];
  seed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum AudienceType {
  CreativeFilter = 'CREATIVE_FILTER',
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED',
  Proof = 'PROOF',
  Seed = 'SEED'
}

export type AudienceUpdate = {
  __typename?: 'AudienceUpdate';
  audience: Audience;
};

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  allowed: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export enum AutoInclude {
  Disabled = 'DISABLED',
  EnabledAutoFill = 'ENABLED_AUTO_FILL',
  EnabledNoAutoFill = 'ENABLED_NO_AUTO_FILL'
}

export type Availability = {
  __typename?: 'Availability';
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  startDatetime: Scalars['DateTime']['output'];
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Upcoming = 'UPCOMING'
}

export type AvailableAdobeCampaignDeliveryNature = {
  __typename?: 'AvailableAdobeCampaignDeliveryNature';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type AvailableAdobeCampaignDeliveryVariable = {
  __typename?: 'AvailableAdobeCampaignDeliveryVariable';
  defaultValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AvailableCreative = {
  __typename?: 'AvailableCreative';
  /** @deprecated Use availibility2 */
  availability: CreativeAvailability;
  availability2: Array<CreativeAvailability>;
  configuredAt?: Maybe<Scalars['DateTime']['output']>;
  creative: Creative;
  id: Scalars['ID']['output'];
  inclusion: CreativeInclusion;
  incomplete: Array<CreativeIncompleteReason>;
  /** @deprecated Use inclusion */
  status: CreativeInclusion;
  thumbnail: Thumbnail;
};

export type AvailableCustomField = {
  __typename?: 'AvailableCustomField';
  dataType: DataType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AvailableEmailTag = {
  __typename?: 'AvailableEmailTag';
  defaultValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tagName: Scalars['String']['output'];
};

export type AvailablePermission = {
  __typename?: 'AvailablePermission';
  dependsOn: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BaseCreativeMetrics = {
  __typename?: 'BaseCreativeMetrics';
  autoImpressionRate?: Maybe<Scalars['Float']['output']>;
  autoImpressions: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['BigInt']['output'];
  clickthroughRate?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['BigInt']['output'];
  impressionRate?: Maybe<Scalars['Float']['output']>;
  impressions: Scalars['BigInt']['output'];
  placements: Scalars['BigInt']['output'];
  revenue: Scalars['BigInt']['output'];
  revenuePerPlacement?: Maybe<Scalars['Float']['output']>;
  uniqueAutoImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueAutoImpressions: Scalars['BigInt']['output'];
  uniqueClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueClickthroughRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueImpressionRate?: Maybe<Scalars['Float']['output']>;
  uniqueImpressions: Scalars['BigInt']['output'];
};

export type BaseMetrics = {
  __typename?: 'BaseMetrics';
  autoOpenRate?: Maybe<Scalars['Float']['output']>;
  autoOpens: Scalars['BigInt']['output'];
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  clickRate?: Maybe<Scalars['Float']['output']>;
  clicks: Scalars['BigInt']['output'];
  clickthroughRate?: Maybe<Scalars['Float']['output']>;
  complaintRate?: Maybe<Scalars['Float']['output']>;
  complaints: Scalars['BigInt']['output'];
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['BigInt']['output'];
  hardBounceRate?: Maybe<Scalars['Float']['output']>;
  hardBounces: Scalars['BigInt']['output'];
  openRate?: Maybe<Scalars['Float']['output']>;
  opens: Scalars['BigInt']['output'];
  revenue: Scalars['BigInt']['output'];
  revenuePerSend?: Maybe<Scalars['Float']['output']>;
  revenuePerThousandSends?: Maybe<Scalars['Float']['output']>;
  sends: Scalars['BigInt']['output'];
  softBounceRate?: Maybe<Scalars['Float']['output']>;
  softBounces: Scalars['BigInt']['output'];
  uniqueAutoOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueAutoOpens: Scalars['BigInt']['output'];
  uniqueClickRate?: Maybe<Scalars['Float']['output']>;
  uniqueClicks: Scalars['BigInt']['output'];
  uniqueClickthroughRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversionRate?: Maybe<Scalars['Float']['output']>;
  uniqueConversions: Scalars['BigInt']['output'];
  uniqueOpenRate?: Maybe<Scalars['Float']['output']>;
  uniqueOpens: Scalars['BigInt']['output'];
  unknownBounceRate?: Maybe<Scalars['Float']['output']>;
  unknownBounces: Scalars['BigInt']['output'];
  unsubscribeRate?: Maybe<Scalars['Float']['output']>;
  unsubscribes: Scalars['BigInt']['output'];
};

export type BaseTemplate = {
  __typename?: 'BaseTemplate';
  sections: Array<BaseTemplateSection>;
  template: Template;
};

export type BaseTemplateSection = {
  __typename?: 'BaseTemplateSection';
  contentBlock: ContentBlock;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  zone?: Maybe<Zone>;
};

export type BaseTemplateSectionInput = {
  contentBlockId?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  zone?: InputMaybe<Zone>;
};

export type BaseTemplateUpdate = {
  __typename?: 'BaseTemplateUpdate';
  baseTemplate: BaseTemplate;
  success: Scalars['Boolean']['output'];
};

export type Blackhole = {
  __typename?: 'Blackhole';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type BlackholeConfig = {
  __typename?: 'BlackholeConfig';
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  clientErrorRate: Scalars['Float']['output'];
  emitSentEvents: Scalars['Boolean']['output'];
  emitTelemetry: Scalars['Boolean']['output'];
  emitWebhooks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latencyMs: Scalars['Int']['output'];
  printToStdout: Scalars['Boolean']['output'];
  serverErrorRate: Scalars['Float']['output'];
  webhookEndpointId: Scalars['String']['output'];
  webhookEndpointToken: Scalars['String']['output'];
};

export type BlackholeConfigUpdateSuccess = {
  __typename?: 'BlackholeConfigUpdateSuccess';
  blackholeConfig: BlackholeConfig;
  success: Scalars['Boolean']['output'];
};

export type Block = {
  __typename?: 'Block';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latestVersion?: Maybe<BlockVersion>;
  name: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  versions: Array<BlockVersion>;
};

export type BlockConfiguration = {
  __typename?: 'BlockConfiguration';
  failurePolicy?: Maybe<FailurePolicy>;
  personalizationMode: Personalization;
};

export type BlockConfiguration2 = {
  __typename?: 'BlockConfiguration2';
  mode: ExperienceMode;
  personalization?: Maybe<Personalization2>;
};

export type BlockConfigurationInput = {
  failurePolicy?: InputMaybe<FailurePolicy>;
  personalizationMode?: InputMaybe<Personalization>;
};

export type BlockConfigurationInput2 = {
  mode: ExperienceMode;
  personalization?: InputMaybe<Personalization2>;
};

export type BlockConnection = {
  __typename?: 'BlockConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BlockEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Block` and its cursor. */
export type BlockEdge = {
  __typename?: 'BlockEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Block;
};

export type BlockFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State>;
};

export type BlockPagination = {
  __typename?: 'BlockPagination';
  page: Scalars['Int']['output'];
  results: Array<Block>;
  total: Scalars['Int']['output'];
};

export type BlockSuccess = {
  __typename?: 'BlockSuccess';
  block: Block;
  success: Scalars['Boolean']['output'];
};

export type BlockVersion = {
  __typename?: 'BlockVersion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  layout: ComponentLayout;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  version: Scalars['Int']['output'];
};

export type Bluecore = {
  __typename?: 'Bluecore';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type BothPreviewPreheader = {
  __typename?: 'BothPreviewPreheader';
  preheaderWithPreview?: Maybe<PreheaderWithPreview>;
};

export type BrandKit = {
  __typename?: 'BrandKit';
  colors: Array<Color>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logos: Array<Logo>;
  name: Scalars['String']['output'];
  primaryLogoId?: Maybe<Scalars['ID']['output']>;
  typographies: Array<Typography>;
  updatedBy?: Maybe<User>;
  version: Scalars['Int']['output'];
};

export type BrandKitCreateInput = {
  colors: Array<ColorInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  logos: Array<LogoInput>;
  name: Scalars['String']['input'];
  typographies: Array<TypographyInput>;
};

export type BrandKitGeneration = {
  __typename?: 'BrandKitGeneration';
  approvedBy?: Maybe<User>;
  brandKit?: Maybe<BrandKit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  rejectedBy?: Maybe<User>;
  status: BrandKitGenerationStatus;
  threadId: Scalars['String']['output'];
  type: BrandKitGenerationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type BrandKitGenerationCreateInput = {
  threadId: Scalars['String']['input'];
  type: BrandKitGenerationType;
};

export enum BrandKitGenerationStatus {
  Accepted = 'ACCEPTED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Rejected = 'REJECTED',
  Success = 'SUCCESS'
}

export type BrandKitGenerationSuccess = {
  __typename?: 'BrandKitGenerationSuccess';
  brandKitGeneration: BrandKitGeneration;
  success: Scalars['Boolean']['output'];
};

export enum BrandKitGenerationType {
  Campaign = 'CAMPAIGN',
  NewUser = 'NEW_USER'
}

export type BrandKitGenerationUpdateStatusInput = {
  brandKitId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  status: BrandKitGenerationStatus;
};

export type BrandKitSuccess = {
  __typename?: 'BrandKitSuccess';
  brandKit: BrandKit;
  success: Scalars['Boolean']['output'];
};

export type Braze = {
  __typename?: 'Braze';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Calendar = {
  __typename?: 'Calendar';
  currentMonth: Scalars['Int']['output'];
  currentQuarter: Scalars['Int']['output'];
  currentWeek: Scalars['Int']['output'];
  currentYear: Scalars['Int']['output'];
  month: DateSpan;
  monthRange: Array<Maybe<Month>>;
  months: Array<Maybe<DateSpan>>;
  quarter: DateSpan;
  quarterRange: Array<Maybe<Quarter>>;
  quarters: Array<Maybe<DateSpan>>;
  week: DateSpan;
  weekRange: Array<Maybe<Week>>;
  weeks: Array<Maybe<DateSpan>>;
  year: DateSpan;
  yearRange: Array<Maybe<Year>>;
};


export type CalendarMonthArgs = {
  period: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CalendarMonthRangeArgs = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};


export type CalendarMonthsArgs = {
  year: Scalars['Int']['input'];
};


export type CalendarQuarterArgs = {
  period: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CalendarQuarterRangeArgs = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};


export type CalendarQuartersArgs = {
  year: Scalars['Int']['input'];
};


export type CalendarWeekArgs = {
  period: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CalendarWeekRangeArgs = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};


export type CalendarWeeksArgs = {
  year: Scalars['Int']['input'];
};


export type CalendarYearArgs = {
  year: Scalars['Int']['input'];
};


export type CalendarYearRangeArgs = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type Campaign = {
  __typename?: 'Campaign';
  attributes: Array<Attribute>;
  audienceSummary?: Maybe<AudienceSummary>;
  autoCreativeInclusionPaused: Scalars['Boolean']['output'];
  autoSchedule: Scalars['Boolean']['output'];
  availableCreativeTags: Array<Tag>;
  availableSendTimes: Array<Scalars['DateTime']['output']>;
  campaignTemplate?: Maybe<CampaignTemplate>;
  channel: ChannelSpec;
  creativesWithContentChanges: Array<Creative>;
  customFields: Array<CustomField>;
  /** @deprecated Use Campaign.subjectline instead */
  dynamicSubjectLines: Array<DynamicSubjectLineType>;
  emailServiceProvider?: Maybe<EmailServiceProvider>;
  error: Scalars['Boolean']['output'];
  espConfig?: Maybe<EspConfig>;
  excludedAudiences: Array<CampaignAudience>;
  excludedContactAudiences?: Maybe<Array<ContactAudienceConfig>>;
  experienceExperiment?: Maybe<Experiment>;
  experiments: Array<Experiment>;
  featureFlagExperiences2: CampaignFeatureFlagState;
  fields?: Maybe<Array<CampaignField>>;
  frequencyModel: FrequencyModel;
  hasContactAudiences: Scalars['Boolean']['output'];
  /** @deprecated Campaigns without experiences deprecated as of 2021-03 */
  hasExperiences: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inboxPreview?: Maybe<InboxPreview>;
  includedAudienceGroups: Array<CampaignAudienceGroup>;
  /** @deprecated Use includedAudienceGroups */
  includedAudiences: Array<CampaignAudience>;
  includedContactAudiences?: Maybe<Array<ContactAudienceConfig>>;
  isSubjectLineComplete: Scalars['Boolean']['output'];
  lastStage: CampaignStage;
  lastStatus: CampaignStatus;
  legacyId: Scalars['ID']['output'];
  messageExtraKeys: Array<MessageExtraKey>;
  messageExtras: Array<MessageExtra>;
  persadoCampaign?: Maybe<PersadoCampaign>;
  prefix?: Maybe<SubjectLineChunk>;
  preheaderAndPreview?: Maybe<PreheaderAndPreview>;
  problems: Array<Maybe<Problem>>;
  proofAudiences: Array<CampaignAudience>;
  pushSettings?: Maybe<CampaignPushSettings>;
  scheduleInterval: Scalars['Duration']['output'];
  section: Section;
  /** @deprecated Use campaignTemplate */
  sections: Array<Section>;
  seedAudiences: Array<CampaignAudience>;
  seedContactAudiences?: Maybe<Array<ContactAudience>>;
  sendDate: Scalars['Date']['output'];
  /** @deprecated Use sendSchedule instead */
  sendDatetimes: Array<CampaignSendDatetime>;
  sendSchedule: Array<SendScheduleVariant>;
  sendTimezone: Scalars['TimeZone']['output'];
  sendWindow?: Maybe<SendWindow>;
  shortUuid: Scalars['String']['output'];
  stage: CampaignStageType;
  staticSubjectLine: Scalars['String']['output'];
  /** @deprecated Use Campaign.subjectline instead */
  staticSubjectLines: Scalars['String']['output'];
  status: CampaignStatusType;
  /** @deprecated Use Campaign.subjectline instead */
  subjectLineStrategyVariants: Array<SubjectLineStrategyVariant>;
  /** @deprecated Use Campaign.subjectline instead */
  subjectLineType: SubjectLineType;
  subjectline?: Maybe<CampaignSubjectLine>;
  suffix?: Maybe<SubjectLineChunk>;
  tags: Array<Tag>;
  /** @deprecated Use campaignTemplate */
  template?: Maybe<Template>;
  /** @deprecated Use campaignTemplate */
  templateDrift?: Maybe<TemplateDrift>;
  title: Scalars['String']['output'];
  trackingParameters: Array<Attribute>;
};


export type CampaignAvailableCreativeTagsArgs = {
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignExperimentsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  experimentTypes?: InputMaybe<Array<ExperimentType>>;
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignSectionArgs = {
  id: Scalars['ID']['input'];
};


export type CampaignSectionsArgs = {
  contentBlockType?: InputMaybe<ContentBlockType>;
};

export type CampaignAcousticCampaignConfig = {
  __typename?: 'CampaignAcousticCampaignConfig';
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  /** @deprecated Use preprocessing instead */
  enablePreprocessing: Scalars['Boolean']['output'];
  fromAddress: SelectAttribute;
  fromAddress2: Attribute;
  fromName: SelectAttribute;
  fromName2: Attribute;
  id: Scalars['ID']['output'];
  preprocessing?: Maybe<CampaignAcousticCampaignPreprocessing>;
  /** @deprecated Use preprocessing instead */
  preprocessingHours?: Maybe<Scalars['Int']['output']>;
  replyTo: SelectAttribute;
  replyTo2: Attribute;
};

export type CampaignAcousticCampaignConfigUpdateSuccess = {
  __typename?: 'CampaignAcousticCampaignConfigUpdateSuccess';
  acousticCampaignConfig: CampaignAcousticCampaignConfig;
  success: Scalars['Boolean']['output'];
};

export type CampaignAcousticCampaignPreprocessing = {
  __typename?: 'CampaignAcousticCampaignPreprocessing';
  enabled: Scalars['Boolean']['output'];
  hours?: Maybe<Scalars['Int']['output']>;
};

export type CampaignAddToRecommendationRun = {
  __typename?: 'CampaignAddToRecommendationRun';
  recommendationRun: RecommendationRun;
  success: Scalars['Boolean']['output'];
};

export type CampaignAdobeCampaignConfig = {
  __typename?: 'CampaignAdobeCampaignConfig';
  availableDeliveryNatures: Array<AvailableAdobeCampaignDeliveryNature>;
  availableDeliveryVariables: Array<AvailableAdobeCampaignDeliveryVariable>;
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  deliveryCode: Scalars['String']['output'];
  deliveryNature?: Maybe<AdobeCampaignDeliveryNature>;
  deliveryVariables: Array<AdobeCampaignDeliveryVariable>;
  fromAddress: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  replyToAddress: Scalars['String']['output'];
  replyToName: Scalars['String']['output'];
  routingId: Scalars['Int']['output'];
  targetMappingId: Scalars['Int']['output'];
  typologyId?: Maybe<Scalars['Int']['output']>;
  webAnalyticsAccount?: Maybe<Scalars['Int']['output']>;
};

export type CampaignAdobeCampaignConfigUpdateSuccess = {
  __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess';
  adobeCampaignConfig: CampaignAdobeCampaignConfig;
  success: Scalars['Boolean']['output'];
};

export type CampaignApprove = {
  __typename?: 'CampaignApprove';
  campaign: Campaign;
};

export type CampaignAudience = {
  __typename?: 'CampaignAudience';
  archived: Scalars['Boolean']['output'];
  audience: Audience;
  campaign: Campaign;
  count?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<CampaignAudienceGroup>;
  id: Scalars['ID']['output'];
  /** @deprecated Rely on confirmation support in mutations */
  inUse: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type CampaignAudienceCreate = {
  __typename?: 'CampaignAudienceCreate';
  campaign: Campaign;
};

export type CampaignAudienceGroup = {
  __typename?: 'CampaignAudienceGroup';
  audiences: Array<CampaignAudience>;
  campaign: Campaign;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type CampaignAudienceGroupCreateResult = CampaignAudienceGroupCreateSuccess | ConflictError;

export type CampaignAudienceGroupCreateSuccess = {
  __typename?: 'CampaignAudienceGroupCreateSuccess';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignAudienceGroupPriorityUpdate = {
  __typename?: 'CampaignAudienceGroupPriorityUpdate';
  campaign: Campaign;
};

export type CampaignAudienceGroupRename = {
  __typename?: 'CampaignAudienceGroupRename';
  campaign: Campaign;
};

export type CampaignAudiencePriorityUpdate = {
  __typename?: 'CampaignAudiencePriorityUpdate';
  campaign: Campaign;
};

export enum CampaignAudienceType {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED',
  Proof = 'PROOF',
  Seed = 'SEED'
}

export type CampaignAudienceUpdate = {
  __typename?: 'CampaignAudienceUpdate';
  campaign: Campaign;
};

export type CampaignCancel = {
  __typename?: 'CampaignCancel';
  campaign: Campaign;
};

export type CampaignCancelApproval = {
  __typename?: 'CampaignCancelApproval';
  campaign: Campaign;
};

export type CampaignContentBlocks = {
  __typename?: 'CampaignContentBlocks';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  opens: Scalars['Int']['output'];
  renderedHtml: Scalars['String']['output'];
  sendDatetime?: Maybe<Scalars['DateTime']['output']>;
};

export type CampaignContentblockMetrics = {
  __typename?: 'CampaignContentblockMetrics';
  contentblock: ContentBlock;
  metrics: Array<Maybe<Metric>>;
};

export type CampaignCordialConfig = {
  __typename?: 'CampaignCordialConfig';
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  defaultSendProperties: Array<DefaultCordialSendProperty>;
  excludeAudiences: MultiSelectAttribute;
  excludeAudiences2: Attribute;
  fromDescription: Scalars['String']['output'];
  fromEmail: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  replyEmail: Scalars['String']['output'];
  sendProperties?: Maybe<Array<Maybe<CordialSendProperty>>>;
  senderProfile: SelectAttribute2;
  tags: Array<Scalars['String']['output']>;
};

export type CampaignCordialConfigUpdateSuccess = {
  __typename?: 'CampaignCordialConfigUpdateSuccess';
  cordialConfig: CampaignCordialConfig;
  success: Scalars['Boolean']['output'];
};

export type CampaignCreateResult = CampaignSuccess | ValidationErrors;

export type CampaignCustomFieldAdd = {
  __typename?: 'CampaignCustomFieldAdd';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignCustomFieldMetadataInput = {
  overrideMode?: InputMaybe<OverrideMode>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCustomFieldRemove = {
  __typename?: 'CampaignCustomFieldRemove';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignCustomFieldUpdate = {
  __typename?: 'CampaignCustomFieldUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignDateRangeFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignDetailsUpdateResult = CampaignSuccess | ValidationErrors;

export type CampaignDisableAutoScheduling = {
  __typename?: 'CampaignDisableAutoScheduling';
  campaign: Campaign;
};

export type CampaignDuplicate = {
  __typename?: 'CampaignDuplicate';
  newCampaign: Campaign;
};

export type CampaignDuplicateResult = CampaignDuplicate | ValidationErrors;

export type CampaignEnableAutoScheduling = {
  __typename?: 'CampaignEnableAutoScheduling';
  campaign: Campaign;
};

export type CampaignEpsilonConfig = {
  __typename?: 'CampaignEpsilonConfig';
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  fromAddress: SelectAttribute;
  fromName: SelectAttribute;
  id: Scalars['ID']['output'];
  replyTo: SelectAttribute;
};

export type CampaignEpsilonConfigUpdateSuccess = {
  __typename?: 'CampaignEpsilonConfigUpdateSuccess';
  epsilonConfig: CampaignEpsilonConfig;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2AutoIncludeCreatives = {
  __typename?: 'CampaignExperience2AutoIncludeCreatives';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2Delete = {
  __typename?: 'CampaignExperience2Delete';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2DetachAll = {
  __typename?: 'CampaignExperience2DetachAll';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2DetachCreatives = {
  __typename?: 'CampaignExperience2DetachCreatives';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2SectionReset = {
  __typename?: 'CampaignExperience2SectionReset';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2UpdateName = {
  __typename?: 'CampaignExperience2UpdateName';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperience2UpdateVisibility = {
  __typename?: 'CampaignExperience2UpdateVisibility';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceAttachAllCreatives = {
  __typename?: 'CampaignExperienceAttachAllCreatives';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceAttachCreatives = {
  __typename?: 'CampaignExperienceAttachCreatives';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceDelete = {
  __typename?: 'CampaignExperienceDelete';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceDeleteAll = {
  __typename?: 'CampaignExperienceDeleteAll';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceDetachAllCreatives = {
  __typename?: 'CampaignExperienceDetachAllCreatives';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceDetachCreatives = {
  __typename?: 'CampaignExperienceDetachCreatives';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceMerge = {
  __typename?: 'CampaignExperienceMerge';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceReset = {
  __typename?: 'CampaignExperienceReset';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceSetHidden = {
  __typename?: 'CampaignExperienceSetHidden';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperienceUpdate = {
  __typename?: 'CampaignExperienceUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperiences2AttachAllCreativesResult = CampaignExperiences2MutateSuccess | ValidationErrors;

export type CampaignExperiences2AttachCreativesResult = CampaignExperiences2MutateSuccess | ValidationErrors;

export type CampaignExperiences2BlockResetResult = CampaignExperiences2BlockResetSuccess | ValidationErrors;

/** Success response for block reset operation. */
export type CampaignExperiences2BlockResetSuccess = {
  __typename?: 'CampaignExperiences2BlockResetSuccess';
  campaign: Campaign;
  section: Section;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperiences2CreateResult = CampaignExperiences2CreateSuccess | ValidationErrors;

/** Success response for creating a campaign experience. */
export type CampaignExperiences2CreateSuccess = {
  __typename?: 'CampaignExperiences2CreateSuccess';
  campaign: Campaign;
  experience: Experience2;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperiences2DeleteResult = CampaignExperiences2DeleteSuccess | ValidationErrors;

/** Success response for deleting experience(s). */
export type CampaignExperiences2DeleteSuccess = {
  __typename?: 'CampaignExperiences2DeleteSuccess';
  campaign: Campaign;
  deletedExperienceId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CampaignExperiences2DetachAllCreativesResult = CampaignExperiences2MutateSuccess | ValidationErrors;

export type CampaignExperiences2DetachCreativesResult = CampaignExperiences2MutateSuccess | ValidationErrors;

/** Generic success response for experience mutations. */
export type CampaignExperiences2MutateSuccess = {
  __typename?: 'CampaignExperiences2MutateSuccess';
  campaign: Campaign;
  experience: Experience2;
  success: Scalars['Boolean']['output'];
};

/** Success response for updating experience name/title. */
export type CampaignExperiences2SetNameSuccess = {
  __typename?: 'CampaignExperiences2SetNameSuccess';
  campaign: Campaign;
  experience: Experience2;
  success: Scalars['Boolean']['output'];
};

export type CampaignExperiences2UpdateAutoIncludeResult = CampaignExperiences2MutateSuccess | ValidationErrors;

export type CampaignExperiences2UpdateNameResult = CampaignExperiences2SetNameSuccess | ValidationErrors;

export type CampaignExperiences2UpdateRecsSettingsResult = CampaignExperiences2MutateSuccess | ValidationErrors;

export type CampaignExperiences2UpdateVisibilityResult = CampaignExperiences2MutateSuccess | ValidationErrors;

/** An enumeration. */
export enum CampaignFeatureFlagState {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Undecided = 'UNDECIDED'
}

export type CampaignField = {
  __typename?: 'CampaignField';
  dataFieldId: Scalars['ID']['output'];
  isAccountLevel: Scalars['Boolean']['output'];
  override?: Maybe<ContactAudienceOverrideValue>;
};

export type CampaignFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** An enumeration. */
export enum CampaignGroupBy {
  Day = 'day',
  Month = 'month',
  Quarter = 'quarter',
  Tags = 'tags',
  TagsIndividual = 'tags_individual',
  Week = 'week',
  Year = 'year'
}

export type CampaignInboxUpdateSuccess = {
  __typename?: 'CampaignInboxUpdateSuccess';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignLockForProofing = {
  __typename?: 'CampaignLockForProofing';
  campaign: Campaign;
};

export type CampaignMarkAsPrepared = {
  __typename?: 'CampaignMarkAsPrepared';
  campaign: Campaign;
};

export type CampaignMessageExtraMutationSuccess = {
  __typename?: 'CampaignMessageExtraMutationSuccess';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignMetric = {
  __typename?: 'CampaignMetric';
  campaign: Campaign;
  metrics: Array<Maybe<Metric>>;
};

export type CampaignMetrics = {
  __typename?: 'CampaignMetrics';
  campaigns?: Maybe<Array<CampaignMetric>>;
  summary: Array<Maybe<Metric>>;
};

export type CampaignMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CampaignOracleResponsysConfig = {
  __typename?: 'CampaignOracleResponsysConfig';
  additionalDataSources: MultiSelectAttribute;
  additionalDataSources2: Attribute;
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  campaignVariables: Array<Attribute>;
  externalTrackingParameters: Array<Attribute>;
  folderName: Scalars['String']['output'];
  fromEmail: SelectAttribute;
  fromEmail2: Attribute;
  fromName: SelectAttribute;
  fromName2: Attribute;
  id: Scalars['ID']['output'];
  marketingProgram: SelectAttribute;
  marketingProgram2: Attribute;
  marketingStrategy: SelectAttribute;
  marketingStrategy2: Attribute;
  profileList: SelectAttribute;
  profileList2: Attribute;
  refiningSourceSqlViewName: Scalars['String']['output'];
  refiningSourceSupplementalTableName: Scalars['String']['output'];
  replyTo: SelectAttribute;
  replyTo2: Attribute;
  suppressions?: Maybe<MultiSelectAttribute>;
  suppressions2?: Maybe<Attribute>;
};

export type CampaignOracleResponsysConfigUpdateSuccess = {
  __typename?: 'CampaignOracleResponsysConfigUpdateSuccess';
  oracleResponsysConfig: CampaignOracleResponsysConfig;
  success: Scalars['Boolean']['output'];
};

export type CampaignPaginatedType = {
  __typename?: 'CampaignPaginatedType';
  page: Scalars['Int']['output'];
  results: Array<Campaign>;
  total: Scalars['Int']['output'];
};

export type CampaignPersonalizedSendScheduleUpdate = {
  __typename?: 'CampaignPersonalizedSendScheduleUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignPreview = {
  __typename?: 'CampaignPreview';
  finalsStatus: CampaignPreviewStatusType;
  proofVariantCount?: Maybe<Scalars['Int']['output']>;
  proofsStatus: CampaignPreviewStatusType;
};

export enum CampaignPreviewStatusType {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE'
}

export type CampaignPushSettings = {
  __typename?: 'CampaignPushSettings';
  expirationTimeSeconds: Scalars['Int']['output'];
};

export type CampaignPushSettingsUpdateSuccess = {
  __typename?: 'CampaignPushSettingsUpdateSuccess';
  pushSettings: CampaignPushSettings;
  success: Scalars['Boolean']['output'];
};

export type CampaignResume = {
  __typename?: 'CampaignResume';
  campaign: Campaign;
};

export type CampaignRevertToDraft = {
  __typename?: 'CampaignRevertToDraft';
  campaign: Campaign;
};

export type CampaignSalesforceMarketingCloudConfig = {
  __typename?: 'CampaignSalesforceMarketingCloudConfig';
  /** @deprecated Used for campaigns and programs */
  campaign?: Maybe<Campaign>;
  delayedDelivery?: Maybe<CampaignSalesforceMarketingCloudDelayedDelivery>;
  /** @deprecated Use delayed_delivery instead */
  enableDelayedDelivery: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSendLogging: Scalars['Boolean']['output'];
  messageDeliveryType: MessageDeliveryType;
  /** @deprecated Use delayed_delivery instead */
  prebuildDuration?: Maybe<Scalars['Float']['output']>;
  publicationList: SelectAttribute;
  publicationList2: Attribute;
  sendClassification: SelectAttribute;
  sendClassification2: Attribute;
  sendLimit?: Maybe<Scalars['Int']['output']>;
  senderProfile: SelectAttribute;
  senderProfile2: Attribute;
  suppressionDataExtensions: MultiSelectAttribute;
  suppressionDataExtensions2: Attribute;
};

export type CampaignSalesforceMarketingCloudConfigUpdateSuccess = {
  __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess';
  salesforceMarketingCloudConfig: CampaignSalesforceMarketingCloudConfig;
  success: Scalars['Boolean']['output'];
};

export type CampaignSalesforceMarketingCloudDelayedDelivery = {
  __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery';
  enabled: Scalars['Boolean']['output'];
  prebuildDuration?: Maybe<Scalars['Float']['output']>;
};

export type CampaignSavedViewCreateResponse = {
  __typename?: 'CampaignSavedViewCreateResponse';
  campaignSavedViews: Array<CampaignSavedViewType>;
  createdSavedView: CampaignSavedViewType;
};

export type CampaignSavedViewType = {
  __typename?: 'CampaignSavedViewType';
  columns: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customDateRange?: Maybe<Scalars['DateRange']['output']>;
  filters: Array<SavedViewFilter>;
  groupBy?: Maybe<CampaignGroupBy>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  predefinedDateRange?: Maybe<PredefinedDateRange>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CampaignSavedViewUpdateOrDeleteResponse = {
  __typename?: 'CampaignSavedViewUpdateOrDeleteResponse';
  campaignSavedViews: Array<CampaignSavedViewType>;
};

export type CampaignSchedule = {
  __typename?: 'CampaignSchedule';
  campaign: Campaign;
};

export type CampaignSectionAdd = {
  __typename?: 'CampaignSectionAdd';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignSegmentMetrics = {
  __typename?: 'CampaignSegmentMetrics';
  metrics: Array<Maybe<Metric>>;
  segment?: Maybe<ContactSegment>;
  split?: Maybe<ContactAudienceSplit>;
};

export type CampaignSendDateUpdate = {
  __typename?: 'CampaignSendDateUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignSendDatetime = {
  __typename?: 'CampaignSendDatetime';
  sendDatetime?: Maybe<Scalars['DateTime']['output']>;
  sendDatetimeRanges: Array<Scalars['DateTimeRange']['output']>;
  sendDatetimeType?: Maybe<SendDatetimeType>;
  /** @deprecated This field is deprecated use treatment_new instead */
  treatment?: Maybe<SendDatetimeTreatment>;
  treatmentNew?: Maybe<TreatmentSendDatetime>;
};

export type CampaignSendDatetimeUpdate = {
  __typename?: 'CampaignSendDatetimeUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignSendTimeMetrics = {
  __typename?: 'CampaignSendTimeMetrics';
  sendTime: Scalars['DateTime']['output'];
  sends: Scalars['BigInt']['output'];
};

export enum CampaignSortType {
  SendDateAsc = 'SEND_DATE_ASC',
  SendDateDesc = 'SEND_DATE_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type CampaignStage = {
  __typename?: 'CampaignStage';
  stage: CampaignStageType;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type CampaignStageCountType = {
  __typename?: 'CampaignStageCountType';
  count: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  stage: CampaignStageType;
};

export type CampaignStageGroupCountType = {
  __typename?: 'CampaignStageGroupCountType';
  count: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  group: CampaignStageGroupType;
};

export enum CampaignStageGroupType {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Proofing = 'PROOFING',
  Scheduled = 'SCHEDULED'
}

export enum CampaignStageType {
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Exporting = 'EXPORTING',
  ExportingProofs = 'EXPORTING_PROOFS',
  Failed = 'FAILED',
  Prepared = 'PREPARED',
  Preparing = 'PREPARING',
  PreparingProofs = 'PREPARING_PROOFS',
  Proofed = 'PROOFED',
  Proofing = 'PROOFING',
  Queuing = 'QUEUING',
  ReadyToExport = 'READY_TO_EXPORT',
  ReadyToExportProofs = 'READY_TO_EXPORT_PROOFS',
  ReadyToPrepare = 'READY_TO_PREPARE',
  ReadyToPrepareProofs = 'READY_TO_PREPARE_PROOFS',
  ReadyToProof = 'READY_TO_PROOF',
  ReadyToSchedule = 'READY_TO_SCHEDULE',
  ReadyToSend = 'READY_TO_SEND',
  Resuming = 'RESUMING',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING',
  Sending = 'SENDING',
  Suspended = 'SUSPENDED',
  Suspending = 'SUSPENDING',
  Syncing = 'SYNCING',
  Terminated = 'TERMINATED',
  Terminating = 'TERMINATING',
  Unscheduling = 'UNSCHEDULING'
}

export type CampaignStaticSendScheduleUpdate = {
  __typename?: 'CampaignStaticSendScheduleUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignStatus = {
  __typename?: 'CampaignStatus';
  status: CampaignStatusType;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type CampaignStatusGroupCountType = {
  __typename?: 'CampaignStatusGroupCountType';
  count: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  statusGroup: CampaignStatusGroupType;
};

/** The campaign index status filter, shared by every campaign type. */
export enum CampaignStatusGroupType {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Preparing = 'PREPARING',
  Proofing = 'PROOFING',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED'
}

export enum CampaignStatusType {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Locked = 'LOCKED'
}

export type CampaignSubjectLine = DynamicSubjectLine | PersadoSubjectLine | StaticMessage;

export type CampaignSuccess = {
  __typename?: 'CampaignSuccess';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignSuspend = {
  __typename?: 'CampaignSuspend';
  campaign: Campaign;
};

export type CampaignTagUpdateSuccess = {
  __typename?: 'CampaignTagUpdateSuccess';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignTemplate = {
  __typename?: 'CampaignTemplate';
  drift?: Maybe<TemplateDrift>;
  dynamicContentBlockCount: Scalars['Int']['output'];
  section: Section;
  sections: Array<Section>;
  staticContentBlockCount: Scalars['Int']['output'];
  template: Template;
  title: Scalars['String']['output'];
};


export type CampaignTemplateSectionArgs = {
  id: Scalars['ID']['input'];
};


export type CampaignTemplateSectionsArgs = {
  contentBlockType?: InputMaybe<ContentBlockType>;
};

export type CampaignTemplateSave = {
  __typename?: 'CampaignTemplateSave';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignTemplateSectionInput = {
  contentBlockId?: InputMaybe<Scalars['ID']['input']>;
  isExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  zone?: InputMaybe<Zone>;
};

export type CampaignTemplateUpdate = {
  __typename?: 'CampaignTemplateUpdate';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignTerminate = {
  __typename?: 'CampaignTerminate';
  campaign: Campaign;
};

export type CampaignTimelineChildType = {
  __typename?: 'CampaignTimelineChildType';
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type CampaignTimelineGroupType = {
  __typename?: 'CampaignTimelineGroupType';
  children?: Maybe<Array<CampaignTimelineChildType>>;
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type CampaignTimelineType = CampaignStage | CampaignStatus;

export type CampaignUnschedule = {
  __typename?: 'CampaignUnschedule';
  campaign: Campaign;
};

export type CampaignUpdatePossibleSuccess = CampaignUpdateSuccess | NeedsConfirmation;

export type CampaignUpdateSuccess = {
  __typename?: 'CampaignUpdateSuccess';
  campaign: Campaign;
  success: Scalars['Boolean']['output'];
};

export type CampaignView = {
  __typename?: 'CampaignView';
  creativeTags: Array<Tag>;
  tags: Array<Tag>;
};

export type CategoryArticle = {
  __typename?: 'CategoryArticle';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CategoryMetric = Metric & {
  __typename?: 'CategoryMetric';
  category?: Maybe<Scalars['String']['output']>;
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Channels through which messages can be delivered.
 *
 * This is the definitive list of channels, which is used to define
 * valid database values and API inputs. Be careful removing or
 * editing any value from the list.
 *
 * NOTE: A test case ensures this enum always matches ink-api
 *
 */
export enum Channel {
  AppInbox = 'APP_INBOX',
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Mms = 'MMS',
  Push = 'PUSH',
  Rcs = 'RCS',
  Sms = 'SMS'
}

/**
 * Categories of channels based on how they're keyed in helios.
 *
 * Ex: channels backed by a phone number would all belong to the same category.
 *
 */
export enum ChannelCategory {
  Email = 'EMAIL',
  MobileApp = 'MOBILE_APP',
  TextMessage = 'TEXT_MESSAGE'
}

export type ChannelCountType = {
  __typename?: 'ChannelCountType';
  channel: ChannelSpec;
  count: Scalars['Int']['output'];
};

export type ChannelSpec = {
  __typename?: 'ChannelSpec';
  category: ChannelCategory;
  channel: Channel;
};

export type CheckboxAttribute = Attribute & {
  __typename?: 'CheckboxAttribute';
  definition: CheckboxAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckboxAttributeDefinition = AttributeDefinition & {
  __typename?: 'CheckboxAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type CheckboxTemplateTag = TemplateTag & {
  __typename?: 'CheckboxTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type Client = {
  __typename?: 'Client';
  analyticsAttributionWindow?: Maybe<AnalyticsAttributionWindow>;
  analyticsCalendar?: Maybe<AnalyticsCalendar>;
  analyticsConfiguration: AnalyticsConfiguration;
  analyticsCurrency?: Maybe<AnalyticsCurrency>;
  analyticsExportDecimalPrecision: Scalars['Int']['output'];
  analyticsExportRateFormat: AnalyticsExportRateFormat;
  analyticsRevenueCap?: Maybe<Scalars['Float']['output']>;
  analyticsRevenueCapEnabled: Scalars['Boolean']['output'];
  analyticsShowProjectedMetrics: Scalars['Boolean']['output'];
  analyticsStatSigThreshold?: Maybe<Scalars['Float']['output']>;
  autoInclude: AutoInclude;
  /** @deprecated Use brandKitGenerations field on the root Query instead */
  brandKitGenerations?: Maybe<Array<BrandKitGeneration>>;
  /** @deprecated Use brandKits field on the root Query instead */
  brandKits?: Maybe<Array<BrandKit>>;
  canUploadImages: Scalars['Boolean']['output'];
  /** @deprecated Use customFonts field on the root Query instead */
  customFonts?: Maybe<Array<CustomFont>>;
  defaultBlockConfiguration: DefaultBlockConfiguration;
  defaultStoInterval: Scalars['Int']['output'];
  desktopEmailWidth: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  /** @deprecated Access the email service provider from the campaign or the email service providers field on the client. */
  emailServiceProvider?: Maybe<EmailServiceProvider>;
  emailServiceProviders: Array<EmailServiceProvider>;
  enableConversionTracking: Scalars['Boolean']['output'];
  enableDisclaimerLayouts: Scalars['Boolean']['output'];
  enableNewProofRecommendationRun: Scalars['Boolean']['output'];
  enablePersadoCampaign: Scalars['Boolean']['output'];
  /** @deprecated Proofing are enabled for all clients. This field always returns the value of True. */
  enableProofing: Scalars['Boolean']['output'];
  enabledChannels: Array<Maybe<ChannelSpec>>;
  enforceLinkDomainAllowlist: Scalars['Boolean']['output'];
  fiscalCalendar?: Maybe<Calendar>;
  hasCdnConfig: Scalars['Boolean']['output'];
  hasFeature: Scalars['Boolean']['output'];
  headerLogo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  lastAccessed?: Maybe<Scalars['DateTime']['output']>;
  linkDomainAllowlist: Array<Scalars['String']['output']>;
  locales?: Maybe<Array<Locale>>;
  mobileEmailWidth: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  persadoCampaigns: Array<PersadoCampaignItem>;
  preheaderTextSetting: InboxPreviewFieldSetting;
  primarySubjectLineRequired: Scalars['Boolean']['output'];
  reuseRule?: Maybe<ReuseRule>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['TimeZone']['output'];
  tones?: Maybe<Array<Scalars['String']['output']>>;
};


export type ClientHasFeatureArgs = {
  feature: Scalars['String']['input'];
};


export type ClientPersadoCampaignsArgs = {
  forCreatives?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientUpdateSuccess = {
  __typename?: 'ClientUpdateSuccess';
  client: Client;
  success: Scalars['Boolean']['output'];
};

export type ClientUserUpdate = {
  __typename?: 'ClientUserUpdate';
  client: Client;
};

export type Color = {
  __typename?: 'Color';
  createdBy?: Maybe<User>;
  hex: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
};

export type ColorInput = {
  hex: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type ComparativeCreativeMetricSeries = {
  __typename?: 'ComparativeCreativeMetricSeries';
  clicks: MetricSeries;
  conversions: MetricSeries;
  impressions: MetricSeries;
  placements: MetricSeries;
  revenue: MetricSeries;
  uniqueClicks: MetricSeries;
  uniqueConversions: MetricSeries;
  uniqueImpressions: MetricSeries;
};

export type ComparativeCreativeStatistics = {
  __typename?: 'ComparativeCreativeStatistics';
  autoImpressionRate: RateStatistics;
  averageOrderValue: RateStatistics;
  clickRate: RateStatistics;
  clickToImpressionRate: RateStatistics;
  clickthroughRate: RateStatistics;
  conversionRate: RateStatistics;
  conversionToClickRate: RateStatistics;
  impressionRate: RateStatistics;
  revenuePerPlacement: RateStatistics;
  revenuePerThousandPlacements: RateStatistics;
  uniqueAutoImpressionRate: RateStatistics;
  uniqueClickRate: RateStatistics;
  uniqueClickToImpressionRate: RateStatistics;
  uniqueClickthroughRate: RateStatistics;
  uniqueConversionRate: RateStatistics;
  uniqueConversionToClickRate: RateStatistics;
  uniqueImpressionRate: RateStatistics;
};

export type ComparativeMetricSeries = {
  __typename?: 'ComparativeMetricSeries';
  clicks: MetricSeries;
  conversions: MetricSeries;
  opens: MetricSeries;
  revenue: MetricSeries;
  sends: MetricSeries;
  uniqueClicks: MetricSeries;
  uniqueConversions: MetricSeries;
  uniqueOpens: MetricSeries;
};

export type ComparativeStatistics = {
  __typename?: 'ComparativeStatistics';
  autoOpenRate: RateStatistics;
  averageOrderValue: RateStatistics;
  clickRate: RateStatistics;
  clickToOpenRate: RateStatistics;
  conversionRate: RateStatistics;
  conversionToClickRate: RateStatistics;
  openRate: RateStatistics;
  revenuePerSend: RateStatistics;
  revenuePerThousandSends: RateStatistics;
  uniqueAutoOpenRate: RateStatistics;
  uniqueClickRate: RateStatistics;
  uniqueClickToOpenRate: RateStatistics;
  uniqueConversionRate: RateStatistics;
  uniqueConversionToClickRate: RateStatistics;
  uniqueOpenRate: RateStatistics;
  unsubscribeRate: RateStatistics;
};

export type ComparisonCreativeFilterInput = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ComparisonCreativeMetric = {
  __typename?: 'ComparisonCreativeMetric';
  baselines?: Maybe<AnalyticsV2BaseCreativeMetrics>;
  groups?: Maybe<AnalyticsV2BaseCreativeMetrics>;
  series?: Maybe<ComparativeCreativeMetricSeries>;
  statistics?: Maybe<ComparativeCreativeStatistics>;
};

export type ComparisonCreativeMetricV2 = {
  __typename?: 'ComparisonCreativeMetricV2';
  baselines?: Maybe<Array<Maybe<Metric>>>;
  groups?: Maybe<Array<Maybe<Metric>>>;
  series?: Maybe<ComparativeCreativeMetricSeries>;
};

export type ComparisonFilterInput = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ComparisonMetric = {
  __typename?: 'ComparisonMetric';
  baselines?: Maybe<AnalyticsV2BaseMetrics>;
  groups?: Maybe<AnalyticsV2BaseMetrics>;
  series?: Maybe<ComparativeMetricSeries>;
  statistics?: Maybe<ComparativeStatistics>;
};

export type ComparisonMetricV2 = {
  __typename?: 'ComparisonMetricV2';
  baselines?: Maybe<Array<Maybe<Metric>>>;
  groups?: Maybe<Array<Maybe<Metric>>>;
  metricSeries?: Maybe<Array<Maybe<NamedMetricSeries>>>;
  /** @deprecated Deprecated. Use metricSeries where available. */
  series?: Maybe<ComparativeMetricSeries>;
};

export type ComponentLayout = {
  __typename?: 'ComponentLayout';
  id: Scalars['ID']['output'];
  linkLibrary: Array<Link2>;
  mediaLibrary: Array<Media2>;
  snapshot?: Maybe<Scalars['LayoutDocument']['output']>;
};


export type ComponentLayoutSnapshotArgs = {
  format?: InputMaybe<DocumentFormat>;
};

export type Conflict = {
  __typename?: 'Conflict';
  what: Scalars['String']['output'];
  where?: Maybe<Scalars['String']['output']>;
};

export type ConflictError = {
  __typename?: 'ConflictError';
  conflicts: Array<Conflict>;
  success: Scalars['Boolean']['output'];
};

export type ContactAudience = {
  __typename?: 'ContactAudience';
  analyticsTracking: ContactAudienceAnalyticsTracking;
  archived: Scalars['Boolean']['output'];
  campaignIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creativeIds: Array<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  experimentSeed?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use splits instead */
  experimentSplits: Array<ContactAudienceExperimentSplit>;
  id: Scalars['ID']['output'];
  inUse?: Maybe<Scalars['Boolean']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use type instead */
  isExperiment: Scalars['Boolean']['output'];
  lastCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  overrides: Array<ContactAudienceOverride>;
  query: Scalars['ContactQuery']['output'];
  splits: Array<ContactAudienceSplit>;
  type: ContactAudienceType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ContactAudienceAnalyticsTracking {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unspecified = 'UNSPECIFIED'
}

export type ContactAudienceAnalyticsTrackingSuccess = {
  __typename?: 'ContactAudienceAnalyticsTrackingSuccess';
  contactAudience: ContactAudience;
};

export type ContactAudienceArchive = {
  __typename?: 'ContactAudienceArchive';
  contactAudience: ContactAudience;
  success: Scalars['Boolean']['output'];
};

export type ContactAudienceAutoBuildSuccess = {
  __typename?: 'ContactAudienceAutoBuildSuccess';
  splits?: Maybe<Array<ContactAudienceSplit>>;
  success: Scalars['Boolean']['output'];
};

export type ContactAudienceConfig = {
  __typename?: 'ContactAudienceConfig';
  contactAudience?: Maybe<ContactAudience>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  splitConfigs?: Maybe<Array<ContactAudienceConfigSplit>>;
};

export type ContactAudienceConfigRemoveResult = CampaignSuccess | NeedsConfirmation;

export type ContactAudienceConfigSplit = {
  __typename?: 'ContactAudienceConfigSplit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  split?: Maybe<ContactAudienceSplit>;
};

export type ContactAudienceCount = {
  __typename?: 'ContactAudienceCount';
  /** @deprecated Use splits instead */
  experimentSplits?: Maybe<Array<ContactAudienceExperimentSplitCount>>;
  id: Scalars['ID']['output'];
  splits?: Maybe<Array<ContactAudienceSplitCount>>;
  total: Scalars['Int']['output'];
};

export type ContactAudienceCreate = {
  __typename?: 'ContactAudienceCreate';
  contactAudience: ContactAudience;
  success: Scalars['Boolean']['output'];
};

export type ContactAudienceDelete = {
  __typename?: 'ContactAudienceDelete';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContactAudienceExperimentAudienceInput = {
  experimentSeed: Scalars['String']['input'];
  /** @deprecated Use splits instead */
  experimentSplits?: InputMaybe<Array<ContactAudienceExperimentSplitInput>>;
};

export type ContactAudienceExperimentAudienceUpdateInput = {
  experimentSeed: Scalars['String']['input'];
  /** @deprecated Use splits instead */
  experimentSplits?: InputMaybe<Array<ContactAudienceExperimentSplitUpdateInput>>;
};

export type ContactAudienceExperimentSplit = {
  __typename?: 'ContactAudienceExperimentSplit';
  contactAudience: ContactAudience;
  control: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ratio: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactAudienceExperimentSplitCount = {
  __typename?: 'ContactAudienceExperimentSplitCount';
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type ContactAudienceExperimentSplitInput = {
  control: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ratio: Scalars['Float']['input'];
};

export type ContactAudienceExperimentSplitUpdateInput = {
  control: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  ratio: Scalars['Float']['input'];
};

export type ContactAudienceFiltersCounts = {
  __typename?: 'ContactAudienceFiltersCounts';
  archived: Scalars['Int']['output'];
  inUse: Scalars['Int']['output'];
  notInUse: Scalars['Int']['output'];
  perType: Array<ContactAudienceTypeCount>;
};

export type ContactAudienceIncludeResult = CampaignSuccess | NeedsConfirmation;

export type ContactAudienceList = {
  __typename?: 'ContactAudienceList';
  audiences: Array<ContactAudience>;
  total: Scalars['Int']['output'];
};

export type ContactAudienceOverride = {
  __typename?: 'ContactAudienceOverride';
  fieldId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  splitId?: Maybe<Scalars['ID']['output']>;
  value: ContactAudienceOverrideValue;
};

export type ContactAudienceOverrideInput = {
  fieldId: Scalars['ID']['input'];
  value: ContactAudienceOverrideValueInput;
};

export type ContactAudienceOverrideUpdateInput = {
  fieldId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  splitId?: InputMaybe<Scalars['ID']['input']>;
  value: ContactAudienceOverrideValueInput;
};

export type ContactAudienceOverrideValue = ContactAudienceOverrideValueBoolean | ContactAudienceOverrideValueDate | ContactAudienceOverrideValueDateTime | ContactAudienceOverrideValueFloat | ContactAudienceOverrideValueInteger | ContactAudienceOverrideValueString;

export type ContactAudienceOverrideValueBoolean = {
  __typename?: 'ContactAudienceOverrideValueBoolean';
  boolean?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactAudienceOverrideValueDate = {
  __typename?: 'ContactAudienceOverrideValueDate';
  date?: Maybe<Scalars['String']['output']>;
};

export type ContactAudienceOverrideValueDateTime = {
  __typename?: 'ContactAudienceOverrideValueDateTime';
  datetime?: Maybe<Scalars['String']['output']>;
};

export type ContactAudienceOverrideValueFloat = {
  __typename?: 'ContactAudienceOverrideValueFloat';
  float?: Maybe<Scalars['String']['output']>;
};

export type ContactAudienceOverrideValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  datetime?: InputMaybe<Scalars['String']['input']>;
  float?: InputMaybe<Scalars['String']['input']>;
  integer?: InputMaybe<Scalars['Int']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
};

export type ContactAudienceOverrideValueInteger = {
  __typename?: 'ContactAudienceOverrideValueInteger';
  integer?: Maybe<Scalars['Int']['output']>;
};

export type ContactAudienceOverrideValueString = {
  __typename?: 'ContactAudienceOverrideValueString';
  string?: Maybe<Scalars['String']['output']>;
};

export type ContactAudienceSplit = {
  __typename?: 'ContactAudienceSplit';
  contactAudience: ContactAudience;
  control: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  fallback: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  query: Scalars['ContactQuery']['output'];
  ratio: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactAudienceSplitCount = {
  __typename?: 'ContactAudienceSplitCount';
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type ContactAudienceSplitInput = {
  control?: InputMaybe<Scalars['Boolean']['input']>;
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  query?: InputMaybe<Scalars['ContactQuery']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type ContactAudienceSplitUpdateInput = {
  control?: InputMaybe<Scalars['Boolean']['input']>;
  fallback?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  query?: InputMaybe<Scalars['ContactQuery']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export enum ContactAudienceType {
  Broken = 'BROKEN',
  Experiment = 'EXPERIMENT',
  Filter = 'FILTER',
  Segment = 'SEGMENT',
  Unspecified = 'UNSPECIFIED'
}

export type ContactAudienceTypeCount = {
  __typename?: 'ContactAudienceTypeCount';
  count: Scalars['Int']['output'];
  type: ContactAudienceType;
};

export type ContactAudienceUpdate = {
  __typename?: 'ContactAudienceUpdate';
  contactAudience: ContactAudience;
  success: Scalars['Boolean']['output'];
};

export enum ContactAudiencesOrderBy {
  LastCountAsc = 'LAST_COUNT_ASC',
  LastCountDesc = 'LAST_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ContactSegment = {
  __typename?: 'ContactSegment';
  createdAt: Scalars['DateTime']['output'];
  fallback: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  query: Scalars['ContactQuery']['output'];
  segmentGroupId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactSegmentContact = {
  __typename?: 'ContactSegmentContact';
  contactFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContactSegmentCount = {
  __typename?: 'ContactSegmentCount';
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type ContactSegmentCreate = {
  __typename?: 'ContactSegmentCreate';
  contactSegment: ContactSegment;
};

export type ContactSegmentDelete = {
  __typename?: 'ContactSegmentDelete';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContactSegmentGroup = {
  __typename?: 'ContactSegmentGroup';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  segments: Array<ContactSegment>;
  status: ContactSegmentGroupStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactSegmentGroupArchive = {
  __typename?: 'ContactSegmentGroupArchive';
  contactSegmentGroup: ContactSegmentGroup;
};

export type ContactSegmentGroupAutoSegmentCreate = {
  __typename?: 'ContactSegmentGroupAutoSegmentCreate';
  contactSegmentGroup: ContactSegmentGroup;
};

export type ContactSegmentGroupCounts = {
  __typename?: 'ContactSegmentGroupCounts';
  segmentCounts: Array<ContactSegmentCount>;
  total: Scalars['Int']['output'];
};

export type ContactSegmentGroupCreate = {
  __typename?: 'ContactSegmentGroupCreate';
  contactSegmentGroup: ContactSegmentGroup;
};

export type ContactSegmentGroupDelete = {
  __typename?: 'ContactSegmentGroupDelete';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContactSegmentGroupPriorityInput = {
  priority: Scalars['Int']['input'];
  segmentId: Scalars['ID']['input'];
};

export type ContactSegmentGroupPriorityUpdate = {
  __typename?: 'ContactSegmentGroupPriorityUpdate';
  contactSegmentGroup: ContactSegmentGroup;
};

export enum ContactSegmentGroupStatus {
  Active = 'ACTIVE',
  Review = 'REVIEW'
}

export type ContactSegmentGroupUpdate = {
  __typename?: 'ContactSegmentGroupUpdate';
  contactSegmentGroup: ContactSegmentGroup;
};

export type ContactSegmentUpdate = {
  __typename?: 'ContactSegmentUpdate';
  contactSegment: ContactSegment;
};

export type ContactSnapshotAudienceCount = {
  __typename?: 'ContactSnapshotAudienceCount';
  audienceSplits?: Maybe<Array<Maybe<SnapshotCount>>>;
  id: Scalars['ID']['output'];
  /** @deprecated Removed upstream. Do not use this field */
  initTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContactSnapshotAudienceInput = {
  id: Scalars['ID']['input'];
  splitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ContactSnapshotCount = {
  __typename?: 'ContactSnapshotCount';
  excludeAudiences?: Maybe<Array<ContactSnapshotAudienceCount>>;
  includeAudiences?: Maybe<Array<ContactSnapshotAudienceCount>>;
  total: Scalars['Int']['output'];
};

export type ContactSnapshotCountSuccess = {
  __typename?: 'ContactSnapshotCountSuccess';
  count: ContactSnapshotCount;
  success: Scalars['Boolean']['output'];
};

/** Interface for all content types (PushNotification, TextMessage, future Html). */
export type Content = {
  channel: Channel;
  id: Scalars['ID']['output'];
  languageCode: Scalars['Language']['output'];
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  blockImageUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<Image>;
  links: Array<Link>;
  minifiedHtml: Scalars['String']['output'];
  minify: Scalars['Boolean']['output'];
  numPositions: Scalars['Int']['output'];
  placeholderType: ContentBlockPlaceholderType;
  previewData?: Maybe<Scalars['JSONString']['output']>;
  status: ContentBlockStatus;
  title: Scalars['String']['output'];
  type: ContentBlockType;
};

export type ContentBlockConfig = {
  __typename?: 'ContentBlockConfig';
  configuredTemplateTags?: Maybe<Array<ContentBlockTemplateTag>>;
  contentBlock: ContentBlock;
  id: Scalars['ID']['output'];
  incompleteCount: Scalars['Int']['output'];
  thumbnails?: Maybe<Array<Thumbnail>>;
};

export enum ContentBlockPlaceholderType {
  Default = 'DEFAULT',
  FourCol_4Image = 'FOUR_COL_4_IMAGE',
  FourCol_8Image = 'FOUR_COL_8_IMAGE',
  FourColTitle_4Image = 'FOUR_COL_TITLE_4_IMAGE',
  FourColTitle_8Image = 'FOUR_COL_TITLE_8_IMAGE',
  OneColImage = 'ONE_COL_IMAGE',
  OneColImageTitle = 'ONE_COL_IMAGE_TITLE',
  OneColImageTitleCta = 'ONE_COL_IMAGE_TITLE_CTA',
  OneColImageTitleText = 'ONE_COL_IMAGE_TITLE_TEXT',
  OneColImageTitleTextCta = 'ONE_COL_IMAGE_TITLE_TEXT_CTA',
  OneColMenu = 'ONE_COL_MENU',
  OneColTitle = 'ONE_COL_TITLE',
  OneColTitleCta = 'ONE_COL_TITLE_CTA',
  OneColTitleText = 'ONE_COL_TITLE_TEXT',
  OneColTitleTextCta = 'ONE_COL_TITLE_TEXT_CTA',
  ThreeCol_3Image = 'THREE_COL_3_IMAGE',
  ThreeCol_6Image = 'THREE_COL_6_IMAGE',
  ThreeColTitle_3Image = 'THREE_COL_TITLE_3_IMAGE',
  ThreeColTitle_6Image = 'THREE_COL_TITLE_6_IMAGE',
  TwoCol_2Image = 'TWO_COL_2_IMAGE',
  TwoCol_4Image = 'TWO_COL_4_IMAGE',
  TwoColImageTitleCta = 'TWO_COL_IMAGE_TITLE_CTA',
  TwoColImageTitleTextCta = 'TWO_COL_IMAGE_TITLE_TEXT_CTA',
  TwoColTitle_2Image = 'TWO_COL_TITLE_2_IMAGE',
  TwoColTitle_4Image = 'TWO_COL_TITLE_4_IMAGE',
  TwoColTitleCtaImage = 'TWO_COL_TITLE_CTA_IMAGE',
  TwoColTitleTextCtaImage = 'TWO_COL_TITLE_TEXT_CTA_IMAGE'
}

export enum ContentBlockStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type ContentBlockTemplateTag = {
  __typename?: 'ContentBlockTemplateTag';
  constraint: TemplateTagConstraint;
  id: Scalars['ID']['output'];
  templateTag: TemplateTag;
};

export enum ContentBlockType {
  Disclaimer = 'DISCLAIMER',
  Dynamic = 'DYNAMIC',
  PlacementExperimental = 'PLACEMENT_EXPERIMENTAL',
  Preheader = 'PREHEADER',
  Static = 'STATIC'
}

/** An enumeration. */
export enum ContentLibraryProgramStateStateChoices {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** DRAFT */
  Draft = 'DRAFT',
  /** LOCKED */
  Locked = 'LOCKED',
  /** SUSPENDED */
  Suspended = 'SUSPENDED',
  /** SUSPENDING */
  Suspending = 'SUSPENDING'
}

export type ContentVariant = {
  __typename?: 'ContentVariant';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<User>;
  availabilities: Array<Scalars['DateTimeRange']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  disclaimer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inboxPreheaderLink: InboxPreheaderLink;
  inboxPreheaderText: InboxPreheaderText;
  inboxPreviewText: InboxPreviewText;
  languageCode: Scalars['Language']['output'];
  subjectLinePrefix?: Maybe<Scalars['String']['output']>;
  subjectLineSuffix: Scalars['String']['output'];
  subjectLines: Array<SubjectLine>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type ContentVariantSuccess = {
  __typename?: 'ContentVariantSuccess';
  success: Scalars['Boolean']['output'];
  variant: ContentVariant;
};

export type Cordial = {
  __typename?: 'Cordial';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredLinkMetadataFields: Array<CordialRequiredLinkMetaDataFields>;
};

export enum CordialRequiredLinkMetaDataFields {
  Name = 'NAME'
}

export type CordialSendProperty = {
  __typename?: 'CordialSendProperty';
  defaultSendPropertyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type CountMetric = Metric & {
  __typename?: 'CountMetric';
  count?: Maybe<Scalars['BigInt']['output']>;
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stats?: Maybe<CountStatMetric>;
};

export type CountStatMetric = {
  __typename?: 'CountStatMetric';
  ciLower?: Maybe<Scalars['Float']['output']>;
  ciUpper?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  diff?: Maybe<Scalars['BigInt']['output']>;
  significant: Scalars['Boolean']['output'];
};

export type CreatePlatformApplication2Input = {
  accountIds: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type CreatePlatformApplication2Success = {
  __typename?: 'CreatePlatformApplication2Success';
  application: PlatformApplication2;
  success: Scalars['Boolean']['output'];
};

export type CreatePlatformApplicationInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreatePlatformApplicationSuccess = {
  __typename?: 'CreatePlatformApplicationSuccess';
  application: PlatformApplication;
  success: Scalars['Boolean']['output'];
};

export type CreateVariableInput = {
  expression: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateVariablePayload = {
  __typename?: 'CreateVariablePayload';
  success: Scalars['Boolean']['output'];
  variable: Variable;
};

export type Creative = {
  __typename?: 'Creative';
  approvedBy?: Maybe<User>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  attributes: Array<Attribute>;
  audienceTypes: Array<CreativeAudienceType>;
  /** @deprecated Use availabilities2 */
  availabilities: Array<Availability>;
  availabilities2: Array<Scalars['DateTimeRange']['output']>;
  bestThumbnail: Thumbnail;
  campaignsWithNewerCreativeVersion: Array<Campaign>;
  content?: Maybe<Content>;
  contentBlockConfigs: Array<Maybe<ContentBlockConfig>>;
  contentVariants: Array<ContentVariant>;
  contents: Array<Content>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  creativeFilters: Array<CreativeFilter2>;
  daysAvailable?: Maybe<Scalars['Int']['output']>;
  disableReuseRules: Scalars['Boolean']['output'];
  disclaimer?: Maybe<Scalars['String']['output']>;
  disclaimerLayout?: Maybe<DisclaimerLayout>;
  hasCreativeDescription: Scalars['Boolean']['output'];
  hasCreativeFilters: Scalars['Boolean']['output'];
  hasProhibitedCreativePairings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedInFutureLockedCampaigns: FutureLockedCampaigns;
  incomplete: Array<CreativeIncompleteReason>;
  layout: Layout;
  legacyFilter?: Maybe<Audience>;
  legacyId: Scalars['ID']['output'];
  maxEndDate?: Maybe<Scalars['Date']['output']>;
  minStartDate?: Maybe<Scalars['Date']['output']>;
  pairedCreatives: Array<Creative>;
  pairedTags: Array<Tag>;
  persadoCampaign?: Maybe<PersadoCampaign>;
  /** @deprecated Use preheaderLink2 */
  preheaderLink?: Maybe<Link>;
  preheaderLink2: InboxPreheaderLink;
  /** @deprecated Use preheaderText2 */
  preheaderText?: Maybe<Scalars['String']['output']>;
  preheaderText2: InboxPreheaderText;
  /** @deprecated Use previewText2 */
  previewText?: Maybe<Scalars['String']['output']>;
  previewText2: InboxPreviewText;
  prohibitedCreatives: Array<Creative>;
  prohibitedTags: Array<Tag>;
  purpose?: Maybe<CreativePurpose>;
  reuseRule?: Maybe<ReuseRule>;
  shortUuid: Scalars['String']['output'];
  sidneySession?: Maybe<SidneySession>;
  slug: Scalars['String']['output'];
  status: CreativeStatus;
  subjectLinePrefix?: Maybe<Scalars['String']['output']>;
  subjectLineSuffix?: Maybe<Scalars['String']['output']>;
  subjectLines: Array<SubjectLine>;
  tags: Array<Tag>;
  thumbnails: Array<Render>;
  title: Scalars['String']['output'];
  trackingParameters: Array<Attribute>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


export type CreativeContentArgs = {
  id: Scalars['ID']['input'];
};


export type CreativeDaysAvailableArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type CreativeLayoutArgs = {
  id: Scalars['ID']['input'];
};

export type CreativeAttribute = {
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export enum CreativeAudienceType {
  Contact = 'CONTACT',
  Legacy = 'LEGACY'
}

export type CreativeAvailabilitiesUpdateResult = CreativeSuccess | ImpactsLockedCampaigns;

export enum CreativeAvailability {
  AlreadyUsed = 'ALREADY_USED',
  Available = 'AVAILABLE',
  Incomplete = 'INCOMPLETE',
  ProhibitedPairing = 'PROHIBITED_PAIRING'
}

export type CreativeAvailabilityCount = {
  __typename?: 'CreativeAvailabilityCount';
  availability: AvailabilityStatus;
  total: Scalars['Int']['output'];
};

export type CreativeCampaignMetrics = {
  __typename?: 'CreativeCampaignMetrics';
  campaign: Campaign;
  metrics: Array<Maybe<Metric>>;
};

export type CreativeConnection = {
  __typename?: 'CreativeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreativeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type CreativeContentblockMetrics = {
  __typename?: 'CreativeContentblockMetrics';
  contentblock: ContentBlock;
  metrics: BaseCreativeMetrics;
};

export type CreativeContentblockMetricsV2 = {
  __typename?: 'CreativeContentblockMetricsV2';
  contentblock: ContentBlock;
  metrics: Array<Maybe<Metric>>;
};

export type CreativeCreateResult = CreativeSuccess | ValidationErrors;

export type CreativeDetailMetricsFilter = {
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** A Relay edge containing a `Creative` and its cursor. */
export type CreativeEdge = {
  __typename?: 'CreativeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Creative;
};

export type CreativeExperimentMetrics = {
  __typename?: 'CreativeExperimentMetrics';
  experiment: Experiment;
  treatments?: Maybe<Array<CreativeTreatmentMetrics>>;
};

export type CreativeExpireResult = CreativeSuccess | NeedsConfirmationExpireCreative;

export type CreativeFilter = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<CreativeAttribute>>;
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audienceType?: InputMaybe<Array<CreativeAudienceType>>;
  availabilityStatuses?: InputMaybe<Array<AvailabilityStatus>>;
  channels?: InputMaybe<Array<Channel>>;
  incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  referenceTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<CreativeStatus>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreativeFilter2 = {
  __typename?: 'CreativeFilter2';
  archived: Scalars['Boolean']['output'];
  audienceId: Scalars['ID']['output'];
  audienceName: Scalars['String']['output'];
  splitId: Scalars['ID']['output'];
  splitName: Scalars['String']['output'];
};

export type CreativeFilterInput = {
  availability?: InputMaybe<Array<CreativeAvailability>>;
  creativeId?: InputMaybe<Scalars['ID']['input']>;
  creativeStatus?: InputMaybe<Array<CreativeStatus>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreativeFiltersCounts = {
  __typename?: 'CreativeFiltersCounts';
  archived: Scalars['Int']['output'];
  incomplete: Scalars['Int']['output'];
  perAvailability: Array<CreativeAvailabilityCount>;
  perStatus: Array<CreativeStatusCount>;
};

/** An enumeration. */
export enum CreativeGroupBy {
  Day = 'day',
  Month = 'month',
  Quarter = 'quarter',
  Tags = 'tags',
  TagsIndividual = 'tags_individual',
  Week = 'week',
  Year = 'year'
}

export enum CreativeInclusion {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED'
}

export enum CreativeIncompleteReason {
  FiltersDontMatchIncluded = 'FILTERS_DONT_MATCH_INCLUDED',
  NoContactAudienceSplits = 'NO_CONTACT_AUDIENCE_SPLITS',
  NoSubjectLineData = 'NO_SUBJECT_LINE_DATA'
}

export type CreativeMetric = {
  __typename?: 'CreativeMetric';
  creative: Creative;
  metrics: Array<Maybe<Metric>>;
};

export type CreativeMetrics = {
  __typename?: 'CreativeMetrics';
  creatives?: Maybe<Array<CreativeMetric>>;
  summary: Array<Maybe<Metric>>;
};

export type CreativeMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum CreativeOrderBy {
  AvailableFromAsc = 'AVAILABLE_FROM_ASC',
  AvailableFromDesc = 'AVAILABLE_FROM_DESC',
  AvailableToAsc = 'AVAILABLE_TO_ASC',
  AvailableToDesc = 'AVAILABLE_TO_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type CreativePagination = {
  __typename?: 'CreativePagination';
  /** @deprecated Replaced by creativeFiltersCounts */
  approvedTotal: Scalars['Int']['output'];
  /** @deprecated Replaced by creativeFiltersCounts */
  draftTotal: Scalars['Int']['output'];
  /** @deprecated Replaced by creativeFiltersCounts */
  expiredTotal: Scalars['Int']['output'];
  /** @deprecated Replaced by creativeFiltersCounts */
  incompleteTotal: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** @deprecated Replaced by creativeFiltersCounts */
  perStatusTotals: Array<CreativeStatusCount>;
  /** @deprecated Replaced by creativeFiltersCounts */
  rejectedTotal: Scalars['Int']['output'];
  results: Array<Creative>;
  total: Scalars['Int']['output'];
};

export type CreativePreheaderAndPreviewUpdateResult = CreativeSuccess | ValidationErrors;

export type CreativePurpose = {
  __typename?: 'CreativePurpose';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type CreativePurposeArchiveResult = CreativePurposeSuccess | ValidationErrors;

export type CreativePurposeCreateResult = CreativePurposeSuccess | ValidationErrors;

export type CreativePurposeEditResult = CreativePurposeSuccess | ValidationErrors;

export type CreativePurposeSuccess = {
  __typename?: 'CreativePurposeSuccess';
  purpose: CreativePurpose;
  success: Scalars['Boolean']['output'];
};

export type CreativePurposeUnarchiveResult = CreativePurposeSuccess | ValidationErrors;

export type CreativeRenameResult = CreativeSuccess | ValidationErrors;

export type CreativeReuseRuleUpdate = {
  __typename?: 'CreativeReuseRuleUpdate';
  reuseRule: ReuseRule;
  success: Scalars['Boolean']['output'];
};

export type CreativeReuseRuleUpdateResult = CreativeReuseRuleUpdate | ValidationErrors;

export type CreativeSavedViewCreateResponse = {
  __typename?: 'CreativeSavedViewCreateResponse';
  createdSavedView: CreativeSavedViewType;
  creativeSavedViews: Array<CreativeSavedViewType>;
};

export type CreativeSavedViewType = {
  __typename?: 'CreativeSavedViewType';
  columns: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customDateRange?: Maybe<Scalars['DateRange']['output']>;
  filters: Array<SavedViewFilter>;
  groupBy?: Maybe<CreativeGroupBy>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  predefinedDateRange?: Maybe<PredefinedDateRange>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreativeSavedViewUpdateOrDeleteResponse = {
  __typename?: 'CreativeSavedViewUpdateOrDeleteResponse';
  creativeSavedViews: Array<CreativeSavedViewType>;
};

export type CreativeSegmentGroupMetrics = {
  __typename?: 'CreativeSegmentGroupMetrics';
  audience?: Maybe<ContactAudience>;
  segmentGroup?: Maybe<ContactSegmentGroup>;
  segments?: Maybe<Array<CreativeSegmentMetricsV2>>;
};

export type CreativeSegmentMetrics = {
  __typename?: 'CreativeSegmentMetrics';
  metrics: Array<Maybe<Metric>>;
  segment?: Maybe<ContactSegment>;
  split?: Maybe<ContactAudienceSplit>;
};

export type CreativeSegmentMetricsV2 = {
  __typename?: 'CreativeSegmentMetricsV2';
  metrics: Array<Maybe<Metric>>;
  segment?: Maybe<ContactSegment>;
  split?: Maybe<ContactAudienceSplit>;
};

export enum CreativeStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED'
}

export type CreativeStatusCount = {
  __typename?: 'CreativeStatusCount';
  status: CreativeStatus;
  total: Scalars['Int']['output'];
};

export type CreativeSubjectlineMetrics = {
  __typename?: 'CreativeSubjectlineMetrics';
  metrics: Array<Maybe<Metric>>;
  subjectline: SubjectLine;
};

export type CreativeSuccess = {
  __typename?: 'CreativeSuccess';
  creative: Creative;
  success: Scalars['Boolean']['output'];
};

export type CreativeTreatmentMetrics = {
  __typename?: 'CreativeTreatmentMetrics';
  metrics: Array<Maybe<Metric>>;
  treatment: ExperimentTreatment;
};

export type Credential = {
  __typename?: 'Credential';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<OrganizationUser2>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  metaData?: Maybe<Scalars['JSONString']['output']>;
  name: Scalars['String']['output'];
  status: CredentialStatus;
};

export type CredentialCreateSuccess = {
  __typename?: 'CredentialCreateSuccess';
  credential: CredentialRegistration;
  success: Scalars['Boolean']['output'];
};

export type CredentialRegistration = {
  __typename?: 'CredentialRegistration';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type CredentialRevokeSuccess = {
  __typename?: 'CredentialRevokeSuccess';
  credential: Credential;
  success: Scalars['Boolean']['output'];
};

export enum CredentialStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Suspended = 'SUSPENDED',
  Unspecified = 'UNSPECIFIED'
}

export type CurrencyMetric = Metric & {
  __typename?: 'CurrencyMetric';
  currency?: Maybe<Scalars['BigInt']['output']>;
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stats?: Maybe<CountStatMetric>;
};

export type CurrencyRateMetric = Metric & {
  __typename?: 'CurrencyRateMetric';
  currencyRate?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stats?: Maybe<StatMetric>;
};

export type CurrentUserAcknowledgeCampaignV2Intro = {
  __typename?: 'CurrentUserAcknowledgeCampaignV2Intro';
  success: Scalars['Boolean']['output'];
};

export type CustomEventCategoryAttachTagResult = {
  __typename?: 'CustomEventCategoryAttachTagResult';
  category: CustomEventCategoryType;
};

export type CustomEventCategoryDeleteResult = {
  __typename?: 'CustomEventCategoryDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type CustomEventCategoryDetachTagResult = {
  __typename?: 'CustomEventCategoryDetachTagResult';
  category: CustomEventCategoryType;
};

export type CustomEventCategoryImportJobResult = {
  __typename?: 'CustomEventCategoryImportJobResult';
  importJob: CustomEventImportJobType;
};

export type CustomEventCategoryType = {
  __typename?: 'CustomEventCategoryType';
  attributionType: AttributionType;
  contactIdentifierField?: Maybe<DataField>;
  hasSubidentifier: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  table?: Maybe<DataTable>;
  tags?: Maybe<Array<Maybe<CustomEventTagType>>>;
  timestampType: TimestampType;
};

export type CustomEventImportJobType = {
  __typename?: 'CustomEventImportJobType';
  customEventCategoryId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomEventTagType = {
  __typename?: 'CustomEventTagType';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomField = {
  id: Scalars['ID']['output'];
  /** @deprecated Removed from API */
  overrideMode?: Maybe<OverrideMode>;
  title: Scalars['String']['output'];
};

export type CustomFieldMetadataInput = {
  overrideMode?: InputMaybe<OverrideMode>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFont = {
  __typename?: 'CustomFont';
  createdBy?: Maybe<User>;
  fallback: Scalars['String']['output'];
  fontFaces: Array<FontFace>;
  fontName: Scalars['String']['output'];
  fontSource: FontSource;
  fontStyles: Array<Scalars['String']['output']>;
  fontWeights: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  linkHref: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
};

export type DsrInput = {
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};

export type DataConnection = {
  __typename?: 'DataConnection';
  connector: DataConnectionConnector;
  createdAt: Scalars['DateTime']['output'];
  errors: Array<DataConnectionError>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<DataConnectionStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataConnectionConnector = DataConnectionExternalGcsBucket | DataConnectionExternalS3Bucket | DataConnectionExternalSftpServer | DataConnectionHostedGcsBucket | DataConnectionHostedSftpServer;

export type DataConnectionCreate = {
  __typename?: 'DataConnectionCreate';
  dataConnection: DataConnection;
};

export type DataConnectionDelete = {
  __typename?: 'DataConnectionDelete';
  success: Scalars['Boolean']['output'];
};

export type DataConnectionError = {
  __typename?: 'DataConnectionError';
  occurredAt: Scalars['DateTime']['output'];
  reason: DataConnectionErrorReason;
};

export enum DataConnectionErrorReason {
  GcsAuthorizationError = 'GCS_AUTHORIZATION_ERROR',
  GcsBucketNotFound = 'GCS_BUCKET_NOT_FOUND',
  GcsConnectionTimeout = 'GCS_CONNECTION_TIMEOUT',
  GcsError = 'GCS_ERROR',
  GcsNxdomain = 'GCS_NXDOMAIN',
  GcsObjectNotFound = 'GCS_OBJECT_NOT_FOUND',
  GcsUriError = 'GCS_URI_ERROR',
  LocalDirectoryError = 'LOCAL_DIRECTORY_ERROR',
  S3AuthorizationError = 'S3_AUTHORIZATION_ERROR',
  S3BucketNotFound = 'S3_BUCKET_NOT_FOUND',
  S3ObjectNotFound = 'S3_OBJECT_NOT_FOUND',
  S3PermissionDenied = 'S3_PERMISSION_DENIED',
  S3UriError = 'S3_URI_ERROR',
  SftpConnectionClosed = 'SFTP_CONNECTION_CLOSED',
  SftpConnectionRefused = 'SFTP_CONNECTION_REFUSED',
  SftpConnectionTimeout = 'SFTP_CONNECTION_TIMEOUT',
  SftpNoSuchFile = 'SFTP_NO_SUCH_FILE',
  SftpNxdomain = 'SFTP_NXDOMAIN',
  SftpPermissionDenied = 'SFTP_PERMISSION_DENIED',
  Unknown = 'UNKNOWN'
}

export type DataConnectionExternalGcsBucket = {
  __typename?: 'DataConnectionExternalGCSBucket';
  name: Scalars['String']['output'];
  serviceAccountEmail: Scalars['String']['output'];
};

export type DataConnectionExternalGcsBucketInput = {
  name: Scalars['String']['input'];
};

export type DataConnectionExternalS3Bucket = {
  __typename?: 'DataConnectionExternalS3Bucket';
  externalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  roleArn: Scalars['String']['output'];
};

export type DataConnectionExternalS3BucketInput = {
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  roleArn: Scalars['String']['input'];
};

export type DataConnectionExternalSftpServer = {
  __typename?: 'DataConnectionExternalSFTPServer';
  authentication: DataConnectionExternalSftpServerAuthentication;
  directory: Scalars['String']['output'];
  host: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  port: Scalars['Int']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
  user: Scalars['String']['output'];
};

export enum DataConnectionExternalSftpServerAuthentication {
  Password = 'PASSWORD',
  PrivateKey = 'PRIVATE_KEY'
}

export type DataConnectionExternalSftpServerInput = {
  authentication: DataConnectionExternalSftpServerAuthentication;
  directory: Scalars['String']['input'];
  host: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  publicKey?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type DataConnectionGcsObject = {
  __typename?: 'DataConnectionGCSObject';
  name: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type DataConnectionHealthcheck = {
  __typename?: 'DataConnectionHealthcheck';
  dataConnection: DataConnection;
};

export type DataConnectionHostedGcsBucket = {
  __typename?: 'DataConnectionHostedGCSBucket';
  hmacKeys?: Maybe<Array<HmacKey>>;
  name: Scalars['String']['output'];
  serviceAccountEmail?: Maybe<Scalars['String']['output']>;
};

export type DataConnectionHostedGcsBucketInput = {
  generateHmacKey?: InputMaybe<Scalars['Boolean']['input']>;
  hmacKeys?: InputMaybe<Array<HmacKeyInput>>;
  serviceAccountEmail?: InputMaybe<Scalars['String']['input']>;
};

export type DataConnectionHostedSftpServer = {
  __typename?: 'DataConnectionHostedSFTPServer';
  host: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  publicKey: Scalars['String']['output'];
  publicKeys?: Maybe<Array<PublicKey>>;
  user: Scalars['String']['output'];
};

export type DataConnectionHostedSftpServerInput = {
  publicKey: Scalars['String']['input'];
  publicKeys?: InputMaybe<Array<PublicKeyInput>>;
};

export type DataConnectionS3Object = {
  __typename?: 'DataConnectionS3Object';
  name: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type DataConnectionSftpFile = {
  __typename?: 'DataConnectionSFTPFile';
  path: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type DataConnectionSchema = {
  __typename?: 'DataConnectionSchema';
  columns: Array<DataConnectionSchemaColumn>;
  compression: DataConnectionSchemaCompression;
  encryption: DataConnectionSchemaEncryption;
  format: DataConnectionSchemaFormatCsv;
  uri: Scalars['String']['output'];
};

export enum DataConnectionSchemaColumType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type DataConnectionSchemaColumn = {
  __typename?: 'DataConnectionSchemaColumn';
  name: Scalars['String']['output'];
  type?: Maybe<DataConnectionSchemaColumType>;
  values: Array<Scalars['String']['output']>;
};

export enum DataConnectionSchemaCompression {
  Bzip = 'BZIP',
  Gzip = 'GZIP',
  None = 'NONE',
  Zip = 'ZIP'
}

export enum DataConnectionSchemaEncryption {
  Gpg = 'GPG',
  None = 'NONE'
}

export type DataConnectionSchemaFormatCsv = {
  __typename?: 'DataConnectionSchemaFormatCSV';
  delimiter: Scalars['String']['output'];
  header: Scalars['Boolean']['output'];
  null: Scalars['String']['output'];
};

/** An enumeration. */
export enum DataConnectionStatus {
  Healthy = 'HEALTHY',
  Unhealthy = 'UNHEALTHY'
}

export type DataConnectionStream = {
  __typename?: 'DataConnectionStream';
  modifiedAt: Scalars['DateTime']['output'];
  stream: DataConnectionStreamType;
  uri: Scalars['String']['output'];
};

export type DataConnectionStreamSchema = {
  __typename?: 'DataConnectionStreamSchema';
  schema: DataConnectionSchema;
};

export type DataConnectionStreamType = DataConnectionGcsObject | DataConnectionS3Object | DataConnectionSftpFile;

export type DataConnectionStreams = {
  __typename?: 'DataConnectionStreams';
  streams: Array<DataConnectionStream>;
};

export type DataConnectionTest = {
  __typename?: 'DataConnectionTest';
  error?: Maybe<DataConnectionError>;
  status: DataConnectionStatus;
};

export type DataConnectionTestSftpServer = {
  __typename?: 'DataConnectionTestSFTPServer';
  dataConnectionTest: DataConnectionTest;
};

export type DataConnectionUpdateSuccess = {
  __typename?: 'DataConnectionUpdateSuccess';
  dataConnection: DataConnection;
  success: Scalars['Boolean']['output'];
};

export type DataEncryptionConfig = {
  __typename?: 'DataEncryptionConfig';
  createdAt: Scalars['DateTime']['output'];
  gpgAppPublicKey: Scalars['String']['output'];
  gpgPublicKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DataEncryptionConfigUpdate = {
  __typename?: 'DataEncryptionConfigUpdate';
  config: DataEncryptionConfig;
};

export type DataEncryptionConnectionPgpKeyAttachResult = {
  __typename?: 'DataEncryptionConnectionPGPKeyAttachResult';
  connection: DataEncryptionConnectionPgpKeys;
  success: Scalars['Boolean']['output'];
};

export type DataEncryptionConnectionPgpKeyUnattachResult = {
  __typename?: 'DataEncryptionConnectionPGPKeyUnattachResult';
  connection: DataEncryptionConnectionPgpKeys;
  success: Scalars['Boolean']['output'];
};

export type DataEncryptionConnectionPgpKeys = {
  __typename?: 'DataEncryptionConnectionPGPKeys';
  id: Scalars['ID']['output'];
  pgpKeys: DataEncryptionPgpKeysList;
};

export type DataEncryptionPgpDecryptKey = {
  __typename?: 'DataEncryptionPGPDecryptKey';
  expirationReminderDays?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  publicKey: Scalars['String']['output'];
};

export type DataEncryptionPgpDecryptKeyInput = {
  expirationReminderDays?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
};

export type DataEncryptionPgpEncryptKey = {
  __typename?: 'DataEncryptionPGPEncryptKey';
  publicKey: Scalars['String']['output'];
};

export type DataEncryptionPgpEncryptKeyInput = {
  publicKey: Scalars['String']['input'];
};

export type DataEncryptionPgpKey = {
  __typename?: 'DataEncryptionPGPKey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  spec: DataEncryptionPgpKeySpec;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataEncryptionPgpKeyCreateResult = {
  __typename?: 'DataEncryptionPGPKeyCreateResult';
  pgpKey: DataEncryptionPgpKey;
};

export type DataEncryptionPgpKeyDeleteResult = {
  __typename?: 'DataEncryptionPGPKeyDeleteResult';
  pgpKeys: DataEncryptionPgpKeysList;
  success: Scalars['Boolean']['output'];
};

export type DataEncryptionPgpKeySpec = DataEncryptionPgpDecryptKey | DataEncryptionPgpEncryptKey;

export type DataEncryptionPgpKeyUpdateResult = {
  __typename?: 'DataEncryptionPGPKeyUpdateResult';
  pgpKey: DataEncryptionPgpKey;
};

export type DataEncryptionPgpKeysList = {
  __typename?: 'DataEncryptionPGPKeysList';
  decryptPgpKeys: Array<DataEncryptionPgpKey>;
  encryptPgpKeys: Array<DataEncryptionPgpKey>;
};

export type DataField = {
  __typename?: 'DataField';
  /** @deprecated Use channelsV2 instead. */
  channels: Array<InkDavinciDataV1ChannelEnum>;
  channelsV2: Array<Channel>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryKey: Scalars['Boolean']['output'];
  semanticFeature?: Maybe<SemanticFeature>;
  type: DataFieldType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataFieldDeleteSuccess = {
  __typename?: 'DataFieldDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DataFieldSuccess = {
  __typename?: 'DataFieldSuccess';
  field: DataField;
  success: Scalars['Boolean']['output'];
};

export enum DataFieldType {
  Boolean = 'BOOLEAN',
  Category = 'CATEGORY',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type DataImportJobColumnInput = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type DataJobConfig = {
  importJob?: InputMaybe<DataJobConfigImportJob>;
  taggingJob?: InputMaybe<DataJobConfigTaggingJob>;
};

export type DataJobConfigImportJob = {
  columns?: InputMaybe<Array<DataImportJobColumnInput>>;
  resource: DataJobResource;
  tableId: Scalars['ID']['input'];
  type: DataJobConfigImportJobType;
};

export enum DataJobConfigImportJobType {
  Insert = 'INSERT',
  Replace = 'REPLACE',
  Update = 'UPDATE',
  Upsert = 'UPSERT'
}

export type DataJobConfigTaggingJob = {
  columns?: InputMaybe<Array<DataTaggingJobColumnInput>>;
  removeFromMissingRecords: Scalars['Boolean']['input'];
  resource: DataJobResource;
  tableId: Scalars['ID']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: DataTaggingJobType;
};

export type DataJobDeleteSuccess = {
  __typename?: 'DataJobDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DataJobResource = {
  compression: DataJobResourceCompression;
  connectionId: Scalars['ID']['input'];
  format: DataJobResourceFormatCsv;
  uri: Scalars['String']['input'];
};

export enum DataJobResourceCompression {
  Bzip = 'BZIP',
  Gzip = 'GZIP',
  None = 'NONE',
  Zip = 'ZIP'
}

export type DataJobResourceFormatCsv = {
  delimiter: Scalars['String']['input'];
  header: Scalars['Boolean']['input'];
  null: Scalars['String']['input'];
};

export type DataJobScheduleDailyInput = {
  hour?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type DataJobScheduleHourlyInput = {
  minute?: InputMaybe<Scalars['Int']['input']>;
};

export type DataJobScheduleInput = {
  daily?: InputMaybe<DataJobScheduleDailyInput>;
  hourly?: InputMaybe<DataJobScheduleHourlyInput>;
};

export type DataRelationDeleteSuccess = {
  __typename?: 'DataRelationDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * The full alerts data-source catalog for one source — drives the
 * "create alert" form. Assembled from `content_library.alerts.data_sources`.
 */
export type DataSourceConfigType = {
  __typename?: 'DataSourceConfigType';
  availableMetrics: Array<MetricDefType>;
  eligibilityPredicates: Array<EligibilityPredicateDefType>;
  label: Scalars['String']['output'];
  operators: Array<OperatorDefType>;
  sourceId: Scalars['String']['output'];
  valueTypeByCategory: Array<ValueTypeByCategoryEntry>;
};

export type DataSubjectRequest = {
  __typename?: 'DataSubjectRequest';
  actorName?: Maybe<Scalars['String']['output']>;
  actorType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  datasourceStatuses?: Maybe<Array<DatasourceStatus>>;
  fieldName: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DataSubjectRequestCreateSuccess = {
  __typename?: 'DataSubjectRequestCreateSuccess';
  dataSubjectRequest: DataSubjectRequest;
};

export type DataSubjectRequestsBatchCreateSuccess = {
  __typename?: 'DataSubjectRequestsBatchCreateSuccess';
  dataSubjectRequests: Array<DataSubjectRequest>;
};

export type DataTable = {
  __typename?: 'DataTable';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  query: InkDavinciDataV1TableQueryResponse;
  rowCount?: Maybe<Scalars['Int']['output']>;
  rowTtlDays?: Maybe<Scalars['Int']['output']>;
  semanticCategory?: Maybe<SemanticCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataTableCreateSuccess = {
  __typename?: 'DataTableCreateSuccess';
  success: Scalars['Boolean']['output'];
  table: DataTable;
};

export type DataTableDeleteSuccess = {
  __typename?: 'DataTableDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DataTableUpdateSuccess = {
  __typename?: 'DataTableUpdateSuccess';
  success: Scalars['Boolean']['output'];
  table: DataTable;
};

export type DataTagDeletableResponse = {
  __typename?: 'DataTagDeletableResponse';
  deletable?: Maybe<Scalars['Boolean']['output']>;
};

export type DataTagDeleteSuccess = {
  __typename?: 'DataTagDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DataTaggingJobColumnInput = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  isTag: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export enum DataTaggingJobType {
  Append = 'APPEND',
  Replace = 'REPLACE'
}

/** An enumeration. */
export enum DataType {
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type DatasetDeleteSuccess = {
  __typename?: 'DatasetDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DatasourceStatus = {
  __typename?: 'DatasourceStatus';
  datasource: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DateAttribute = Attribute & {
  __typename?: 'DateAttribute';
  definition: DateAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Date']['output']>;
};

export type DateAttributeDefinition = AttributeDefinition & {
  __typename?: 'DateAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type DateSpan = {
  __typename?: 'DateSpan';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
};

export type DateTemplateTag = TemplateTag & {
  __typename?: 'DateTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Date']['output']>;
};

export type DateTimeAttribute = Attribute & {
  __typename?: 'DateTimeAttribute';
  definition: DateTimeAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['DateTime']['output']>;
};

export type DateTimeAttributeDefinition = AttributeDefinition & {
  __typename?: 'DateTimeAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type DatetimeCustomField = CustomField & {
  __typename?: 'DatetimeCustomField';
  id: Scalars['ID']['output'];
  /** @deprecated Removed from API */
  overrideMode?: Maybe<OverrideMode>;
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['DateTime']['output']>;
};

export enum DaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DefaultBlockConfiguration = {
  __typename?: 'DefaultBlockConfiguration';
  mode?: Maybe<DefaultExperienceMode>;
  personalization?: Maybe<DefaultPersonalization>;
};

export type DefaultCordialSendProperty = {
  __typename?: 'DefaultCordialSendProperty';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum DefaultExperienceMode {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum DefaultPersonalization {
  Personalized = 'PERSONALIZED',
  SameForAll = 'SAME_FOR_ALL'
}

export type DisclaimerImportSuccess = {
  __typename?: 'DisclaimerImportSuccess';
  layout: DisclaimerLayout;
  success: Scalars['Boolean']['output'];
};

export type DisclaimerLayout = {
  __typename?: 'DisclaimerLayout';
  document?: Maybe<Scalars['LayoutDocument']['output']>;
  id: Scalars['ID']['output'];
  linkLibrary: Array<Link2>;
  mediaLibrary: Array<Media2>;
  studioCampaigns: Array<StudioCampaignImport>;
  supportedLayoutComplexity: LayoutComplexity;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type DisclaimerLayoutDocumentArgs = {
  format?: InputMaybe<DocumentFormat>;
};

export type DisclaimerLayoutUpdateSuccess = {
  __typename?: 'DisclaimerLayoutUpdateSuccess';
  layout: DisclaimerLayout;
  success: Scalars['Boolean']['output'];
};

export enum DocumentFormat {
  V1 = 'V1',
  V1Flat = 'V1_FLAT'
}

export type DynamicContent = {
  __typename?: 'DynamicContent';
  complete?: Maybe<Scalars['Boolean']['output']>;
  incompleteCreatives?: Maybe<Array<Creative>>;
  missingAudiences?: Maybe<Array<AudienceDescription>>;
  missingExperiences2?: Maybe<Array<Experience2>>;
  missingTargetRuleset?: Maybe<Array<TargetRule>>;
  section?: Maybe<DynamicSection>;
};

export type DynamicField = {
  __typename?: 'DynamicField';
  isDynamic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  readonly: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DynamicPreheader = {
  __typename?: 'DynamicPreheader';
  section?: Maybe<DynamicSection>;
};

export type DynamicSection = Section & {
  __typename?: 'DynamicSection';
  complete: Scalars['Boolean']['output'];
  contentBlock: ContentBlock;
  experience?: Maybe<Experience>;
  experience2: Experience2;
  experienceCount: Scalars['Int']['output'];
  experienceLens: ExperienceLens;
  experiences: Array<Experience>;
  experiences2: Array<Experience2>;
  experiences2Axes: SectionAxes;
  experiences2Complete: Scalars['Boolean']['output'];
  experiences2Count?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use experiences2_creatives */
  experiences2CreativeCounts: Experiences2CreativeCounts;
  experiences2Creatives?: Maybe<Experiences2CreativeConnection>;
  experiences2IncompleteExperiences: Array<Experience2>;
  /** @deprecated Use experiences2_creatives */
  experiences2Lens: Experiences2Lens;
  experiences2UncoveredRuleset?: Maybe<Array<Maybe<TargetRule>>>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  missingAudiences: Array<Maybe<AudienceDescription>>;
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  zone?: Maybe<Zone>;
};


export type DynamicSectionExperienceArgs = {
  id: Scalars['ID']['input'];
};


export type DynamicSectionExperience2Args = {
  id: Scalars['ID']['input'];
};


export type DynamicSectionExperienceLensArgs = {
  audienceCombination: AudienceCombinationInput;
};


export type DynamicSectionExperiences2CreativeCountsArgs = {
  filter?: InputMaybe<Experience2CreativeFilterInput>;
  targetRuleset: Array<TargetRuleInput>;
};


export type DynamicSectionExperiences2CreativesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  targetRuleset: Array<TargetRuleInput>;
};


export type DynamicSectionExperiences2LensArgs = {
  targetRuleset: Array<TargetRuleInput>;
};

export type DynamicSubjectLine = {
  __typename?: 'DynamicSubjectLine';
  complete: Scalars['Boolean']['output'];
  /** @deprecated Use DynamicSubjectLineRule.creativesMissingSubjectLines */
  creativesMissingSubjectLines?: Maybe<Array<Creative>>;
  experiment?: Maybe<Experiment>;
  /** @deprecated Use DynamicSubjectLineRule.missingAudiences */
  missingAudiences?: Maybe<Array<AudienceDescription>>;
  rules: Array<DynamicSubjectLineRule>;
  strategies: Array<SubjectlineStrategyVariant>;
};

export type DynamicSubjectLinePrefix = {
  __typename?: 'DynamicSubjectLinePrefix';
  section?: Maybe<DynamicSection>;
};

export type DynamicSubjectLineRule = {
  __typename?: 'DynamicSubjectLineRule';
  creativesMissingSubjectLines: Array<Creative>;
  id: Scalars['ID']['output'];
  missingAudiences: Array<AudienceDescription>;
  missingExperiences2: Array<Experience2>;
  missingTargetRuleset?: Maybe<Array<TargetRule>>;
  section: DynamicSection;
};

export type DynamicSubjectLineSuffix = {
  __typename?: 'DynamicSubjectLineSuffix';
  section?: Maybe<DynamicSection>;
};

export type DynamicSubjectLineType = {
  __typename?: 'DynamicSubjectLineType';
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  section?: Maybe<DynamicSection>;
};

export enum ElementPseudoState {
  Active = 'ACTIVE',
  Hover = 'HOVER',
  Visited = 'VISITED'
}

/**
 * An eligibility predicate the user can apply to a rule (e.g.,
 * "min_hours_since_send"). `config` is a JSON object describing the inputs
 * the user must fill in, keyed by field name. Example:
 *
 *     { "value": { "type": "integer", "min": 1, "max": 168 } }
 */
export type EligibilityPredicateDefType = {
  __typename?: 'EligibilityPredicateDefType';
  config: Scalars['GenericScalar']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type EmailCreativeUsage = MediaUsageLocation & {
  __typename?: 'EmailCreativeUsage';
  channel: Channel;
  creativeId: Scalars['ID']['output'];
  creativeTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  layoutId: Scalars['ID']['output'];
  templateTagId: Scalars['ID']['output'];
};

export type EmailServiceProvider = AcousticCampaign | AdobeCampaign | AdobeJourneyOptimizer | AmazonSes | Blackhole | Bluecore | Braze | Cordial | Epsilon | OracleResponsys | SfNext | SalesForceMarketingCloud | Zeta;

export type EmailTag = {
  __typename?: 'EmailTag';
  emailTagId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type EmailVersion = {
  __typename?: 'EmailVersion';
  contentBlocks: Array<EmailVersionContentBlock>;
  desktopImageUrl?: Maybe<Scalars['String']['output']>;
  emailId: Scalars['String']['output'];
  preheaderText?: Maybe<Scalars['String']['output']>;
  previewText?: Maybe<Scalars['String']['output']>;
  recipients: Scalars['Int']['output'];
  runId: Scalars['Int']['output'];
  subjectline?: Maybe<Scalars['String']['output']>;
  subjectlinePrefix?: Maybe<Scalars['String']['output']>;
  subjectlineSuffix?: Maybe<Scalars['String']['output']>;
  type: ProofVariantTypeChoices;
};

export type EmailVersionContentBlock = {
  __typename?: 'EmailVersionContentBlock';
  creativeTitle?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type EmailVersionSearchCriteria = {
  __typename?: 'EmailVersionSearchCriteria';
  audienceSplitIds?: Maybe<Array<Maybe<Array<Scalars['ID']['output']>>>>;
  audiences: Array<Audience>;
  creativeTags: Array<Tag>;
  creatives: Array<Creative>;
  emailAddresses: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  preheaderTextContains: Scalars['String']['output'];
  previewTextContains: Scalars['String']['output'];
  subjectlineContains: Scalars['String']['output'];
  subjectlinePrefixContains: Scalars['String']['output'];
  subjectlineSuffixContains: Scalars['String']['output'];
  subjectlines: Array<SubjectLine>;
  treatments: Array<Treatment>;
};

export type EmailVersionSend = {
  __typename?: 'EmailVersionSend';
  emailId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  recipients: Scalars['Int']['output'];
  searchCriteria?: Maybe<EmailVersionSearchCriteria>;
};

export type EmailVersionSendAdditionalAttributes = {
  __typename?: 'EmailVersionSendAdditionalAttributes';
  defaultProofLabel: Scalars['String']['output'];
  enableProofLabel: Scalars['Boolean']['output'];
};

export type EmailVersionSendContact = {
  __typename?: 'EmailVersionSendContact';
  campaign: Campaign;
  channel: Channel;
  channelId: Scalars['String']['output'];
  contact?: Maybe<PreviewContact>;
  contactGroup?: Maybe<PreviewContactGroup>;
  contactType: EmailVersionSendContactType;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type EmailVersionSendContactCreate = {
  __typename?: 'EmailVersionSendContactCreate';
  emailVersionSendContact: EmailVersionSendContact;
};

export type EmailVersionSendContactDelete = {
  __typename?: 'EmailVersionSendContactDelete';
  campaign: Campaign;
};

export enum EmailVersionSendContactType {
  Contact = 'CONTACT',
  ContactGroup = 'CONTACT_GROUP',
  EmailAddress = 'EMAIL_ADDRESS'
}

export type EmailVersionSendCreate = {
  __typename?: 'EmailVersionSendCreate';
  emailVersionSend: EmailVersionSend;
};

export type EmailVersionSendDelete = {
  __typename?: 'EmailVersionSendDelete';
  emailVersionSend: EmailVersionSend;
};

export type EmailVersionSendDeliver = {
  __typename?: 'EmailVersionSendDeliver';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum EmailVersionSendFormatType {
  Individual = 'INDIVIDUAL'
}

export type Epsilon = {
  __typename?: 'Epsilon';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredLinkMetadataFields: Array<EpsilonRequiredLinkMetaDataFields>;
};

export enum EpsilonRequiredLinkMetaDataFields {
  LinkType = 'LINK_TYPE'
}

export type EspConfig = AdobeJourneyOptimizerConfig | AmazonSesConfig | BlackholeConfig | CampaignAcousticCampaignConfig | CampaignAdobeCampaignConfig | CampaignCordialConfig | CampaignEpsilonConfig | CampaignOracleResponsysConfig | CampaignSalesforceMarketingCloudConfig | ZetaConfig;

export type ExactMatch = {
  __typename?: 'ExactMatch';
  availableCreatives: PaginatedAvailableCreatives;
  experience: Experience;
  id: Scalars['ID']['output'];
};


export type ExactMatchAvailableCreativesArgs = {
  filter?: InputMaybe<CreativeFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Experience = {
  __typename?: 'Experience';
  audienceCombinations: Array<AudienceDescription>;
  availableCreatives: PaginatedAvailableCreatives;
  blockConfiguration: BlockConfiguration;
  blockConfiguration2: BlockConfiguration2;
  creativeCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  section: Section;
};


export type ExperienceAvailableCreativesArgs = {
  filter?: InputMaybe<CreativeFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Experience2 = {
  __typename?: 'Experience2';
  autoInclude: Experience2AutoInclude;
  /** @deprecated Use included_tags and excluded_tags instead */
  autoIncludeCreativeTags: Array<Maybe<Scalars['ID']['output']>>;
  /** @deprecated use auto_include */
  autoIncludeCreatives: Scalars['Boolean']['output'];
  complete: Scalars['Boolean']['output'];
  excludedCreatives: CreativeConnection;
  excludedTags: Array<Maybe<Tag>>;
  id: Scalars['ID']['output'];
  includedCreatives: Experiences2PaginatedAvailableCreatives;
  includedTags: Array<Maybe<Tag>>;
  /** @deprecated use visibility */
  mode: Experience2Mode;
  /** @deprecated Use title instead */
  name?: Maybe<Scalars['String']['output']>;
  personalization: Experience2Personalization;
  recsSettings: Experience2RecsSettingsOutput;
  section: Section;
  targetRuleset: Array<TargetRule>;
  title: Scalars['String']['output'];
  visibility: Experience2Visibility;
};


export type Experience2ExcludedCreativesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Experience2IncludedCreativesArgs = {
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
};

export enum Experience2AutoInclude {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Suspended = 'SUSPENDED'
}

export type Experience2CampaignLocation = {
  campaignId: Scalars['ID']['input'];
  contentBlockId: Scalars['ID']['input'];
  targetRuleset: Array<InputMaybe<TargetRuleInput>>;
};

export type Experience2ContactCountSuccess = {
  __typename?: 'Experience2ContactCountSuccess';
  count: ContactSnapshotCount;
};

export type Experience2CreateResult = Experience2Success | ValidationErrors;

export type Experience2CreativeFilterInput = {
  availability?: InputMaybe<Array<CreativeAvailability>>;
  creativeStatus?: InputMaybe<Array<CreativeStatus>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type Experience2DeleteResult = Experience2Success | ValidationErrors;

export enum Experience2Mode {
  Empty = 'EMPTY',
  Hidden = 'HIDDEN',
  Optional = 'OPTIONAL',
  Override = 'OVERRIDE',
  Required = 'REQUIRED'
}

export enum Experience2Personalization {
  Hidden = 'HIDDEN',
  Personalized = 'PERSONALIZED',
  SameForAll = 'SAME_FOR_ALL'
}

export type Experience2RecsSettings = {
  ignoreCreativeFilters: Scalars['Boolean']['input'];
  ignoreReuseRules: Scalars['Boolean']['input'];
};

export type Experience2RecsSettingsOutput = {
  __typename?: 'Experience2RecsSettingsOutput';
  ignoreCreativeFilters: Scalars['Boolean']['output'];
  ignoreReuseRules: Scalars['Boolean']['output'];
};

export type Experience2Success = {
  __typename?: 'Experience2Success';
  experience2: Experience2;
  success: Scalars['Boolean']['output'];
};

/**
 * The visibility setting of an experience.
 *
 * The visibility is just the user's intention, which is used along with context
 * about the section and experience to derive a mode and personalization value that is
 * passed along to recs to control how the content block is filled for the experience.
 *
 */
export enum Experience2Visibility {
  Hidden = 'HIDDEN',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type ExperienceLens = ExactMatch | Overlapping | Unconfigured | WillDivide;

export enum ExperienceMode {
  Hidden = 'HIDDEN',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type Experiences2CreativeConnection = {
  __typename?: 'Experiences2CreativeConnection';
  counts: Experiences2CreativeCount;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Experiences2CreativeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type Experiences2CreativeCount = {
  __typename?: 'Experiences2CreativeCount';
  allEligibleIncluded: Scalars['Boolean']['output'];
  available: Scalars['Int']['output'];
  availableDraft: Scalars['Int']['output'];
  inUse: Scalars['Int']['output'];
  included: Scalars['Int']['output'];
  includedApproved: Scalars['Int']['output'];
  incomplete: Scalars['Int']['output'];
  prohibited: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Experiences2CreativeCounts = {
  __typename?: 'Experiences2CreativeCounts';
  available: Scalars['Int']['output'];
  availableDraft: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inUse: Scalars['Int']['output'];
  included: Scalars['Int']['output'];
  includedApproved: Scalars['Int']['output'];
  incomplete: Scalars['Int']['output'];
  prohibited: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** A Relay edge containing a `Experiences2Creative` and its cursor. */
export type Experiences2CreativeEdge = {
  __typename?: 'Experiences2CreativeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Experiences2CreativeInfo>;
};

export type Experiences2CreativeFilter = {
  availability?: InputMaybe<Array<CreativeAvailability>>;
  hasCreativeFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasProhibitedCreativePairings?: InputMaybe<Scalars['Boolean']['input']>;
  inclusion?: InputMaybe<CreativeInclusion>;
  status?: InputMaybe<Array<CreativeStatus>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

export type Experiences2CreativeInfo = Node & {
  __typename?: 'Experiences2CreativeInfo';
  availability: Array<CreativeAvailability>;
  creative: Creative;
  id: Scalars['ID']['output'];
  inclusion: CreativeInclusion;
  incomplete: Array<CreativeIncompleteReason>;
  thumbnail: Thumbnail;
};

export type Experiences2Lens = {
  __typename?: 'Experiences2Lens';
  availableCreatives: Experiences2PaginatedAvailableCreatives;
  id: Scalars['ID']['output'];
};


export type Experiences2LensAvailableCreativesArgs = {
  filter?: InputMaybe<Experience2CreativeFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Experiences2PaginatedAvailableCreatives = {
  __typename?: 'Experiences2PaginatedAvailableCreatives';
  available: Scalars['Int']['output'];
  availableDraft: Scalars['Int']['output'];
  inUse: Scalars['Int']['output'];
  included: Scalars['Int']['output'];
  includedApproved: Scalars['Int']['output'];
  incomplete: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  prohibited: Scalars['Int']['output'];
  results: Array<AvailableCreative>;
  total: Scalars['Int']['output'];
};

export type Experiment = {
  __typename?: 'Experiment';
  configurationRestrictedToStaff: Scalars['Boolean']['output'];
  experimentGroup?: Maybe<ExperimentGroup>;
  experimentType: ExperimentType;
  id: Scalars['ID']['output'];
  /** @deprecated No longer disclosed */
  internal: Scalars['Boolean']['output'];
  maxDate?: Maybe<Scalars['Date']['output']>;
  minDate?: Maybe<Scalars['Date']['output']>;
  resultsRestrictedToStaff: Scalars['Boolean']['output'];
  status: ExperimentStatus;
  title: Scalars['String']['output'];
  treatments: Array<ExperimentTreatment>;
  treatmentsCount: Scalars['Int']['output'];
};

export type ExperimentAudienceBuildInputConfig = {
  experimentSeed: Scalars['String']['input'];
  splitRatios: Array<Scalars['Float']['input']>;
};

export type ExperimentCampaignMetrics = {
  __typename?: 'ExperimentCampaignMetrics';
  campaign: Campaign;
  treatments?: Maybe<Array<TreatmentMetrics>>;
};

export type ExperimentCampaignMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentId?: InputMaybe<Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExperimentContactMetrics = {
  __typename?: 'ExperimentContactMetrics';
  experiment: Experiment;
  treatments?: Maybe<Array<TreatmentContactMetrics>>;
};

export type ExperimentCreativeMetrics = {
  __typename?: 'ExperimentCreativeMetrics';
  creative: Creative;
  treatments?: Maybe<Array<TreatmentMetrics>>;
};

export type ExperimentCreativeMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentId?: InputMaybe<Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExperimentGroup = {
  __typename?: 'ExperimentGroup';
  configurationRestrictedToStaff: Scalars['Boolean']['output'];
  experimentType: ExperimentType;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  treatmentDefinitions: Array<ExperimentGroupTreatmentDefinition>;
};

export type ExperimentGroupTreatmentDefinition = {
  __typename?: 'ExperimentGroupTreatmentDefinition';
  id: Scalars['ID']['output'];
  isControl: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

export type ExperimentMetrics = {
  __typename?: 'ExperimentMetrics';
  experiment: Experiment;
  treatments?: Maybe<Array<TreatmentMetrics>>;
};

export type ExperimentMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentStatuses?: InputMaybe<Array<ExperimentStatus>>;
  experimentTypes?: InputMaybe<Array<ExperimentType>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExperimentSegmentsMetrics = {
  __typename?: 'ExperimentSegmentsMetrics';
  audience: ContactAudience;
  splits?: Maybe<Array<TreatmentSegmentMetrics>>;
};

export type ExperimentSegmentsMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentId?: InputMaybe<Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** An enumeration. */
export enum ExperimentStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Upcoming = 'UPCOMING'
}

export type ExperimentTreatment = {
  __typename?: 'ExperimentTreatment';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** An enumeration. */
export enum ExperimentType {
  Adhoc = 'ADHOC',
  ContentPersonalizationModel = 'CONTENT_PERSONALIZATION_MODEL',
  EligibleCreatives = 'ELIGIBLE_CREATIVES',
  MultiModel = 'MULTI_MODEL',
  ProxyControl = 'PROXY_CONTROL',
  SendDatetime = 'SEND_DATETIME',
  SendTimePersonalizationModel = 'SEND_TIME_PERSONALIZATION_MODEL',
  SubjectLinePersonalizationModel = 'SUBJECT_LINE_PERSONALIZATION_MODEL',
  SubjectLineStrategy = 'SUBJECT_LINE_STRATEGY',
  Template = 'TEMPLATE'
}

export type ExportResponse = {
  __typename?: 'ExportResponse';
  signedUrl: Scalars['String']['output'];
};

export type ExternalMedia = Media2 & {
  __typename?: 'ExternalMedia';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  externalUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  uri: Scalars['String']['output'];
};

export enum FailurePolicy {
  DontSend = 'DONT_SEND',
  Hide = 'HIDE',
  Override = 'OVERRIDE'
}

export type FeedbackCreate = {
  __typename?: 'FeedbackCreate';
  success: Scalars['Boolean']['output'];
};

export enum FeedbackKind {
  Bug = 'BUG',
  FeatureRequest = 'FEATURE_REQUEST',
  Question = 'QUESTION'
}

export enum FeedbackPriority {
  Critical = 'CRITICAL',
  Important = 'IMPORTANT',
  NiceToHave = 'NICE_TO_HAVE'
}

/** An enumeration. */
export enum FilterOperator {
  Excludes = 'EXCLUDES',
  Includes = 'INCLUDES'
}

export type FontFace = {
  __typename?: 'FontFace';
  createdBy?: Maybe<User>;
  fontStyle: Scalars['String']['output'];
  fontWeight: Scalars['String']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  src: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
};

export enum FontSource {
  Google = 'GOOGLE',
  Hosted = 'HOSTED',
  WebSafe = 'WEB_SAFE'
}

export type FormatStringAttribute = Attribute & {
  __typename?: 'FormatStringAttribute';
  definition: FormatStringAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FormatStringAttributeDefinition = AttributeDefinition & {
  __typename?: 'FormatStringAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type FractionalCountMetric = Metric & {
  __typename?: 'FractionalCountMetric';
  fractionalCount?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stats?: Maybe<CountStatMetric>;
};

/** An enumeration. */
export enum FrequencyModel {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type FutureLockedCampaigns = {
  __typename?: 'FutureLockedCampaigns';
  futureLockedCampaigns: Array<Campaign>;
  latestSendDatetime?: Maybe<Scalars['DateTime']['output']>;
  total: Scalars['Int']['output'];
};

export type GroupDimension = {
  __typename?: 'GroupDimension';
  dimension: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GroupedCampaignsMetrics = {
  __typename?: 'GroupedCampaignsMetrics';
  campaigns?: Maybe<Array<CampaignMetric>>;
  group: Scalars['String']['output'];
  metrics: Array<Maybe<Metric>>;
};

export type GroupedCreativesMetrics = {
  __typename?: 'GroupedCreativesMetrics';
  creatives?: Maybe<Array<CreativeMetric>>;
  group: Scalars['String']['output'];
  metrics: Array<Maybe<Metric>>;
};

export type GroupedExperimentCampaignMetrics = {
  __typename?: 'GroupedExperimentCampaignMetrics';
  group: Scalars['String']['output'];
  treatments?: Maybe<Array<TreatmentMetrics>>;
};

export type GroupedExperimentCreativeMetrics = {
  __typename?: 'GroupedExperimentCreativeMetrics';
  group: Scalars['String']['output'];
  treatments?: Maybe<Array<TreatmentMetrics>>;
};

export type GroupedSegmentGroupCampaignMetrics = {
  __typename?: 'GroupedSegmentGroupCampaignMetrics';
  group: Scalars['String']['output'];
  segments?: Maybe<Array<CampaignSegmentMetrics>>;
};

export type GroupedSegmentGroupCreativeMetrics = {
  __typename?: 'GroupedSegmentGroupCreativeMetrics';
  group: Scalars['String']['output'];
  segments?: Maybe<Array<CreativeSegmentMetrics>>;
};

export type HmacKey = {
  __typename?: 'HMACKey';
  id: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
};

export type HmacKeyInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export type HtmlBundle = {
  __typename?: 'HTMLBundle';
  id: Scalars['ID']['output'];
  legacyId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type HtmlBundleTemplateTag = TemplateTag & {
  __typename?: 'HTMLBundleTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<HtmlBundle>;
};

export type Image = {
  __typename?: 'Image';
  altText: Scalars['String']['output'];
  contentsMd5: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  hosted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  publicUrl: Scalars['String']['output'];
  /** @deprecated Use publicUrl */
  source: Scalars['String']['output'];
  titleText: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ImageContentInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  hosted?: InputMaybe<Scalars['Boolean']['input']>;
  titleText?: InputMaybe<Scalars['String']['input']>;
  updateExisting?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ImageTemplateTag = TemplateTag & {
  __typename?: 'ImageTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Image>;
};

export enum ImageUrlContentTypeErrorCode {
  Blocked = 'BLOCKED',
  InvalidUrl = 'INVALID_URL',
  Timeout = 'TIMEOUT',
  TooManyRedirects = 'TOO_MANY_REDIRECTS',
  Unreachable = 'UNREACHABLE'
}

export type ImageUrlContentTypeResult = {
  __typename?: 'ImageUrlContentTypeResult';
  contentType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<ImageUrlContentTypeErrorCode>;
};

export type ImpactsLockedCampaigns = {
  __typename?: 'ImpactsLockedCampaigns';
  lockedCampaigns?: Maybe<Array<Campaign>>;
  success: Scalars['Boolean']['output'];
};

export type ImportSuccess = {
  __typename?: 'ImportSuccess';
  layout: Layout;
  success: Scalars['Boolean']['output'];
};

export type InboxLinkSetting = {
  __typename?: 'InboxLinkSetting';
  enabled: Scalars['Boolean']['output'];
  link?: Maybe<Link>;
};

export type InboxPreheaderLink = InboxLinkSetting | InboxUnconfiguredSetting;

export type InboxPreheaderText = InboxTextSetting | InboxUnconfiguredSetting;

export type InboxPreview = {
  __typename?: 'InboxPreview';
  id: Scalars['ID']['output'];
  /** @deprecated Use Campaign.preheader_and_preview instead. */
  preheader?: Maybe<Preheader>;
  /** @deprecated Use Campaign.prefix instead. */
  subjectLinePrefix?: Maybe<SubjectLinePrefix>;
  /** @deprecated Use Campaign.suffix instead. */
  subjectLineSuffix?: Maybe<SubjectLineSuffix>;
};

export enum InboxPreviewFieldSetting {
  Disabled = 'DISABLED',
  Optional = 'OPTIONAL'
}

export type InboxPreviewText = InboxTextSetting | InboxUnconfiguredSetting;

export type InboxTextSetting = {
  __typename?: 'InboxTextSetting';
  content?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type InboxUnconfiguredSetting = {
  __typename?: 'InboxUnconfiguredSetting';
  enabled: Scalars['Boolean']['output'];
};

export type InkDataV1Connection = {
  __typename?: 'InkDataV1Connection';
  capabilities: Array<InkDataV1ConnectionCapabilityEnum>;
  conduitId?: Maybe<Scalars['Int']['output']>;
  connector: InkDataV1ConnectionConnector;
  createdAt: Scalars['DateTime']['output'];
  errors: Array<InkDataV1ConnectionError>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  namespace: InkDataV1NamespaceRef;
  status: InkDataV1ConnectionStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum InkDataV1ConnectionCapabilityEnum {
  CapabilityIncrementalRead = 'CAPABILITY_INCREMENTAL_READ',
  CapabilityRead = 'CAPABILITY_READ',
  CapabilityUnspecified = 'CAPABILITY_UNSPECIFIED',
  CapabilityWrite = 'CAPABILITY_WRITE'
}

export type InkDataV1ConnectionConnector = {
  __typename?: 'InkDataV1ConnectionConnector';
  deltaShare?: Maybe<InkDataV1ConnectionConnectorDeltaShare>;
  demoDatabase?: Maybe<InkDataV1ConnectionConnectorDemoDatabase>;
  demoDirectory?: Maybe<InkDataV1ConnectionConnectorDemoDirectory>;
  externalGcsBucket?: Maybe<InkDataV1ConnectionConnectorExternalGcsBucket>;
  externalS3Bucket?: Maybe<InkDataV1ConnectionConnectorExternalS3Bucket>;
  externalSftpServer?: Maybe<InkDataV1ConnectionConnectorExternalSftpServer>;
  hostedGcsBucket?: Maybe<InkDataV1ConnectionConnectorHostedGcsBucket>;
  hostedSftpServer?: Maybe<InkDataV1ConnectionConnectorHostedSftpServer>;
  internalGcsBucket?: Maybe<InkDataV1ConnectionConnectorInternalGcsBucket>;
  legacyExternalSftpServer?: Maybe<InkDataV1ConnectionConnectorLegacyExternalSftpServer>;
  localDirectory?: Maybe<InkDataV1ConnectionConnectorLocalDirectory>;
  snowflake?: Maybe<InkDataV1ConnectionConnectorSnowflake>;
};

export type InkDataV1ConnectionConnectorDeltaShare = {
  __typename?: 'InkDataV1ConnectionConnectorDeltaShare';
  bearerToken?: Maybe<InkDataV1ConnectionConnectorDeltaShareBearerToken>;
  oidcFederation?: Maybe<InkDataV1ConnectionConnectorDeltaShareOidcFederation>;
  share: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorDeltaShareBearerToken = {
  __typename?: 'InkDataV1ConnectionConnectorDeltaShareBearerToken';
  endpoint: Scalars['String']['output'];
  expirationTime?: Maybe<Scalars['String']['output']>;
};

export type InkDataV1ConnectionConnectorDeltaShareOidcFederation = {
  __typename?: 'InkDataV1ConnectionConnectorDeltaShareOIDCFederation';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1ConnectionConnectorDemoDatabase = {
  __typename?: 'InkDataV1ConnectionConnectorDemoDatabase';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1ConnectionConnectorDemoDirectory = {
  __typename?: 'InkDataV1ConnectionConnectorDemoDirectory';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1ConnectionConnectorExternalGcsBucket = {
  __typename?: 'InkDataV1ConnectionConnectorExternalGCSBucket';
  name: Scalars['String']['output'];
  serviceAccount?: Maybe<InkDataV1ConnectionConnectorExternalGcsBucketServiceAccount>;
};

export type InkDataV1ConnectionConnectorExternalGcsBucketServiceAccount = {
  __typename?: 'InkDataV1ConnectionConnectorExternalGCSBucketServiceAccount';
  email: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorExternalS3Bucket = {
  __typename?: 'InkDataV1ConnectionConnectorExternalS3Bucket';
  externalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  roleArn: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorExternalSftpServer = {
  __typename?: 'InkDataV1ConnectionConnectorExternalSFTPServer';
  host: Scalars['String']['output'];
  publicKey?: Maybe<InkDataV1ConnectionConnectorExternalSftpServerPublicKey>;
};

export type InkDataV1ConnectionConnectorExternalSftpServerPublicKey = {
  __typename?: 'InkDataV1ConnectionConnectorExternalSFTPServerPublicKey';
  value?: Maybe<Scalars['String']['output']>;
};

export type InkDataV1ConnectionConnectorHostedGcsBucket = {
  __typename?: 'InkDataV1ConnectionConnectorHostedGCSBucket';
  generateHmacKey?: Maybe<Scalars['Boolean']['output']>;
  hmacKeys: Array<InkDataV1ConnectionConnectorHostedGcsBucketHmacKey>;
  name?: Maybe<Scalars['String']['output']>;
  serviceAccounts: Array<InkDataV1ConnectionConnectorHostedGcsBucketServiceAccount>;
};

export type InkDataV1ConnectionConnectorHostedGcsBucketHmacKey = {
  __typename?: 'InkDataV1ConnectionConnectorHostedGCSBucketHMACKey';
  delete?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorHostedGcsBucketServiceAccount = {
  __typename?: 'InkDataV1ConnectionConnectorHostedGCSBucketServiceAccount';
  delete?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorHostedSftpServer = {
  __typename?: 'InkDataV1ConnectionConnectorHostedSFTPServer';
  host: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  publicKeys: Array<InkDataV1ConnectionConnectorHostedSftpServerPublicKey>;
  user: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorHostedSftpServerPublicKey = {
  __typename?: 'InkDataV1ConnectionConnectorHostedSFTPServerPublicKey';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorInternalGcsBucket = {
  __typename?: 'InkDataV1ConnectionConnectorInternalGCSBucket';
  name: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
};

export type InkDataV1ConnectionConnectorLegacyExternalSftpServer = {
  __typename?: 'InkDataV1ConnectionConnectorLegacyExternalSFTPServer';
  directory: Scalars['String']['output'];
  host: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  privateKey: InkDataV1ConnectionConnectorLegacyExternalSftpServerPrivateKey;
  user: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorLegacyExternalSftpServerPrivateKey = {
  __typename?: 'InkDataV1ConnectionConnectorLegacyExternalSFTPServerPrivateKey';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1ConnectionConnectorLocalDirectory = {
  __typename?: 'InkDataV1ConnectionConnectorLocalDirectory';
  path: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorSnowflake = {
  __typename?: 'InkDataV1ConnectionConnectorSnowflake';
  accountIdentifier: Scalars['String']['output'];
  database: Scalars['String']['output'];
  role: Scalars['String']['output'];
  rsaKeyPair?: Maybe<InkDataV1ConnectionConnectorSnowflakeRsaKeyPair>;
  schema: Scalars['String']['output'];
  username: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type InkDataV1ConnectionConnectorSnowflakeRsaKeyPair = {
  __typename?: 'InkDataV1ConnectionConnectorSnowflakeRSAKeyPair';
  publicKey?: Maybe<InkDataV1ConnectionConnectorSnowflakeRsaKeyPairPublicKey>;
};

export type InkDataV1ConnectionConnectorSnowflakeRsaKeyPairPublicKey = {
  __typename?: 'InkDataV1ConnectionConnectorSnowflakeRSAKeyPairPublicKey';
  value: Scalars['String']['output'];
};

export type InkDataV1ConnectionError = {
  __typename?: 'InkDataV1ConnectionError';
  occurredAt: Scalars['DateTime']['output'];
  reason: InkDataV1ConnectionErrorReasonEnum;
};

/** An enumeration. */
export enum InkDataV1ConnectionErrorReasonEnum {
  ReasonDeltaShareNotFound = 'REASON_DELTA_SHARE_NOT_FOUND',
  ReasonDeltaShareServerError = 'REASON_DELTA_SHARE_SERVER_ERROR',
  ReasonDeltaShareTokenExpired = 'REASON_DELTA_SHARE_TOKEN_EXPIRED',
  ReasonDeltaShareUnauthorized = 'REASON_DELTA_SHARE_UNAUTHORIZED',
  ReasonGcsAuthorizationError = 'REASON_GCS_AUTHORIZATION_ERROR',
  ReasonGcsBucketNotFound = 'REASON_GCS_BUCKET_NOT_FOUND',
  ReasonGcsConnectionTimeout = 'REASON_GCS_CONNECTION_TIMEOUT',
  ReasonGcsError = 'REASON_GCS_ERROR',
  ReasonGcsNxdomain = 'REASON_GCS_NXDOMAIN',
  ReasonGcsObjectNotFound = 'REASON_GCS_OBJECT_NOT_FOUND',
  ReasonGcsUriError = 'REASON_GCS_URI_ERROR',
  ReasonLocalDirectoryError = 'REASON_LOCAL_DIRECTORY_ERROR',
  ReasonS3AuthorizationError = 'REASON_S3_AUTHORIZATION_ERROR',
  ReasonS3BucketNotFound = 'REASON_S3_BUCKET_NOT_FOUND',
  ReasonS3ObjectNotFound = 'REASON_S3_OBJECT_NOT_FOUND',
  ReasonS3PermissionDenied = 'REASON_S3_PERMISSION_DENIED',
  ReasonS3UriError = 'REASON_S3_URI_ERROR',
  ReasonSftpConnectionClosed = 'REASON_SFTP_CONNECTION_CLOSED',
  ReasonSftpConnectionRefused = 'REASON_SFTP_CONNECTION_REFUSED',
  ReasonSftpConnectionTimeout = 'REASON_SFTP_CONNECTION_TIMEOUT',
  ReasonSftpNoSuchFile = 'REASON_SFTP_NO_SUCH_FILE',
  ReasonSftpNxdomain = 'REASON_SFTP_NXDOMAIN',
  ReasonSftpPermissionDenied = 'REASON_SFTP_PERMISSION_DENIED',
  ReasonSnowflakeAuthenticationError = 'REASON_SNOWFLAKE_AUTHENTICATION_ERROR',
  ReasonSnowflakeError = 'REASON_SNOWFLAKE_ERROR',
  ReasonUnimplemented = 'REASON_UNIMPLEMENTED',
  ReasonUnknown = 'REASON_UNKNOWN',
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type InkDataV1ConnectionListResponse = {
  __typename?: 'InkDataV1ConnectionListResponse';
  connections: Array<InkDataV1Connection>;
};

/** An enumeration. */
export enum InkDataV1ConnectionStatusEnum {
  StatusHealthy = 'STATUS_HEALTHY',
  StatusUnhealthy = 'STATUS_UNHEALTHY',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export type InkDataV1ConnectionStreamListResponse = {
  __typename?: 'InkDataV1ConnectionStreamListResponse';
  streams: Array<InkDataV1Stream>;
};

export type InkDataV1Dataset = {
  __typename?: 'InkDataV1Dataset';
  cdcEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<InkDataV1DatasetModelRef>;
  name: Scalars['String']['output'];
  namespace: InkDataV1NamespaceRef;
  partitions: Array<InkDataV1DatasetPartition>;
  sources: Array<InkDataV1DatasetSource>;
  type: InkDataV1DatasetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDataV1DatasetCreateRequestFieldSpecInput = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryKey: Scalars['Boolean']['input'];
  standardLabel?: InputMaybe<Scalars['String']['input']>;
  type: InkDataV1DatasetFieldTypeEnum;
};

export type InkDataV1DatasetCreateResponse = {
  __typename?: 'InkDataV1DatasetCreateResponse';
  dataset: InkDataV1Dataset;
  fields: Array<InkDataV1DatasetField>;
};

export type InkDataV1DatasetFetchResponse = {
  __typename?: 'InkDataV1DatasetFetchResponse';
  dataset: InkDataV1Dataset;
};

export type InkDataV1DatasetField = {
  __typename?: 'InkDataV1DatasetField';
  createdAt: Scalars['DateTime']['output'];
  datasetId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modelField: InkDataV1DatasetFieldModelFieldRef;
  name: Scalars['String']['output'];
  primaryKey: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  type: InkDataV1DatasetFieldTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDataV1DatasetFieldListResponse = {
  __typename?: 'InkDataV1DatasetFieldListResponse';
  fields: Array<InkDataV1DatasetField>;
};

export type InkDataV1DatasetFieldModelFieldRef = {
  __typename?: 'InkDataV1DatasetFieldModelFieldRef';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDataV1DatasetFieldTypeEnum {
  TypeBoolean = 'TYPE_BOOLEAN',
  TypeCategory = 'TYPE_CATEGORY',
  TypeDate = 'TYPE_DATE',
  TypeDatetime = 'TYPE_DATETIME',
  TypeDatetimeArray = 'TYPE_DATETIME_ARRAY',
  TypeDateArray = 'TYPE_DATE_ARRAY',
  TypeFloat = 'TYPE_FLOAT',
  TypeFloatArray = 'TYPE_FLOAT_ARRAY',
  TypeInteger = 'TYPE_INTEGER',
  TypeIntegerArray = 'TYPE_INTEGER_ARRAY',
  TypeString = 'TYPE_STRING',
  TypeStringArray = 'TYPE_STRING_ARRAY'
}

export type InkDataV1DatasetListResponse = {
  __typename?: 'InkDataV1DatasetListResponse';
  datasets: Array<InkDataV1Dataset>;
};

export type InkDataV1DatasetModelCreateResponse = {
  __typename?: 'InkDataV1DatasetModelCreateResponse';
  dataset: InkDataV1Dataset;
  fields: Array<InkDataV1DatasetField>;
};

export type InkDataV1DatasetModelRef = {
  __typename?: 'InkDataV1DatasetModelRef';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InkDataV1DatasetPartition = {
  __typename?: 'InkDataV1DatasetPartition';
  fieldId: Scalars['Int']['output'];
  transform?: Maybe<InkDataV1DatasetPartitionTransformEnum>;
};

/** An enumeration. */
export enum InkDataV1DatasetPartitionTransformEnum {
  TransformDay = 'TRANSFORM_DAY',
  TransformHour = 'TRANSFORM_HOUR',
  TransformMonth = 'TRANSFORM_MONTH',
  TransformUnspecified = 'TRANSFORM_UNSPECIFIED',
  TransformYear = 'TRANSFORM_YEAR'
}

export type InkDataV1DatasetSource = {
  __typename?: 'InkDataV1DatasetSource';
  archived: Scalars['Boolean']['output'];
  connection: InkDataV1DatasetSourceConnectionRef;
  id: Scalars['Int']['output'];
  lastCompletedRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunFailureAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: InkDataV1JobStatusEnum;
};

export type InkDataV1DatasetSourceConnectionRef = {
  __typename?: 'InkDataV1DatasetSourceConnectionRef';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: InkDataV1ConnectionStatusEnum;
};

export type InkDataV1DatasetStatisticsResponse = {
  __typename?: 'InkDataV1DatasetStatisticsResponse';
  rowCount: Scalars['BigInt']['output'];
  sizeOnDisk?: Maybe<Scalars['BigInt']['output']>;
};

export type InkDataV1DatasetType = {
  __typename?: 'InkDataV1DatasetType';
  delta?: Maybe<InkDataV1DatasetTypeDelta>;
  view?: Maybe<InkDataV1DatasetTypeView>;
};

export type InkDataV1DatasetTypeDelta = {
  __typename?: 'InkDataV1DatasetTypeDelta';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1DatasetTypeView = {
  __typename?: 'InkDataV1DatasetTypeView';
  table?: Maybe<InkDataV1DatasetTypeViewTableRef>;
};

export type InkDataV1DatasetTypeViewTableRef = {
  __typename?: 'InkDataV1DatasetTypeViewTableRef';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InkDataV1Job = {
  __typename?: 'InkDataV1Job';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metrics: InkDataV1JobMetrics;
  name: Scalars['String']['output'];
  namespace: InkDataV1NamespaceRef;
  parentJobRun?: Maybe<InkDataV1JobParentJobRun>;
  schedule?: Maybe<InkDataV1JobSchedule>;
  spec: InkDataV1JobSpec;
  status: InkDataV1JobStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDataV1JobCreateResponse = {
  __typename?: 'InkDataV1JobCreateResponse';
  job: InkDataV1Job;
};

export type InkDataV1JobFetchResponse = {
  __typename?: 'InkDataV1JobFetchResponse';
  job: InkDataV1Job;
};

export type InkDataV1JobListResponse = {
  __typename?: 'InkDataV1JobListResponse';
  jobs: Array<InkDataV1Job>;
  nextPageToken: Scalars['String']['output'];
};

export type InkDataV1JobMetrics = {
  __typename?: 'InkDataV1JobMetrics';
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunFailureAt?: Maybe<Scalars['DateTime']['output']>;
  totalRunFailures: Scalars['Int']['output'];
  totalRuns: Scalars['Int']['output'];
};

export type InkDataV1JobParentJobRun = {
  __typename?: 'InkDataV1JobParentJobRun';
  jobId: Scalars['Int']['output'];
  jobName: Scalars['String']['output'];
  jobRunId: Scalars['Int']['output'];
};

export type InkDataV1JobPauseResponse = {
  __typename?: 'InkDataV1JobPauseResponse';
  job: InkDataV1Job;
};

export type InkDataV1JobResumeResponse = {
  __typename?: 'InkDataV1JobResumeResponse';
  job: InkDataV1Job;
};

export type InkDataV1JobRun = {
  __typename?: 'InkDataV1JobRun';
  archived: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  childJobs: Array<InkDataV1JobRunChildJob>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  failures: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  lastNackedAt?: Maybe<Scalars['DateTime']['output']>;
  lastPingedAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  maxFailures: Scalars['Int']['output'];
  metrics: InkDataV1JobRunMetrics;
  spec: InkDataV1JobRunSpec;
  status: InkDataV1JobRunStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['Int']['output'];
};

export type InkDataV1JobRunArchiveResponse = {
  __typename?: 'InkDataV1JobRunArchiveResponse';
  jobRun: InkDataV1JobRun;
};

export type InkDataV1JobRunCancelResponse = {
  __typename?: 'InkDataV1JobRunCancelResponse';
  jobRun: InkDataV1JobRun;
};

export type InkDataV1JobRunChildJob = {
  __typename?: 'InkDataV1JobRunChildJob';
  jobId: Scalars['Int']['output'];
  jobName: Scalars['String']['output'];
};

export type InkDataV1JobRunFetchResponse = {
  __typename?: 'InkDataV1JobRunFetchResponse';
  jobRun: InkDataV1JobRun;
};

export type InkDataV1JobRunListResponse = {
  __typename?: 'InkDataV1JobRunListResponse';
  jobRuns: Array<InkDataV1JobRun>;
  nextPageToken: Scalars['String']['output'];
};

export type InkDataV1JobRunMetrics = {
  __typename?: 'InkDataV1JobRunMetrics';
  runDuration: Scalars['Int']['output'];
};

export type InkDataV1JobRunResumeResponse = {
  __typename?: 'InkDataV1JobRunResumeResponse';
  jobRun: InkDataV1JobRun;
};

export type InkDataV1JobRunSpec = {
  __typename?: 'InkDataV1JobRunSpec';
  eventExport?: Maybe<InkDataV1JobRunSpecEventExport>;
};

export type InkDataV1JobRunSpecEventExport = {
  __typename?: 'InkDataV1JobRunSpecEventExport';
  accountId: Scalars['Int']['output'];
  columns: Array<InkDataV1JobSpecEventExportColumnEnum>;
  contactDataTableConfig?: Maybe<InkDataV1JobSpecEventExportContactDataTableConfig>;
  dataConnectionIds: Array<Scalars['Int']['output']>;
  dataprocBatchId: Scalars['String']['output'];
  eventType: InkDataV1JobSpecEventExportTypeEnum;
  exportWindowStart: Scalars['String']['output'];
  filterDateEnd: Scalars['String']['output'];
  filterDateStart: Scalars['String']['output'];
  filterTsEnd: Scalars['DateTime']['output'];
  filterTsStart: Scalars['DateTime']['output'];
  format: InkDataV1JobSpecEventExportFormat;
  gcsOutputPath: Scalars['String']['output'];
  maxRecordsPerFile?: Maybe<Scalars['Int']['output']>;
  transferJobId: Scalars['Int']['output'];
};

/** An enumeration. */
export enum InkDataV1JobRunStatusEnum {
  StatusCanceled = 'STATUS_CANCELED',
  StatusCanceling = 'STATUS_CANCELING',
  StatusCompleted = 'STATUS_COMPLETED',
  StatusError = 'STATUS_ERROR',
  StatusFailed = 'STATUS_FAILED',
  StatusReady = 'STATUS_READY',
  StatusRunning = 'STATUS_RUNNING',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export type InkDataV1JobSchedule = {
  __typename?: 'InkDataV1JobSchedule';
  daily?: Maybe<InkDataV1JobScheduleDaily>;
  hourly?: Maybe<InkDataV1JobScheduleHourly>;
  minutely?: Maybe<InkDataV1JobScheduleMinutely>;
};

export type InkDataV1JobScheduleDaily = {
  __typename?: 'InkDataV1JobScheduleDaily';
  hour: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type InkDataV1JobScheduleDailyInput = {
  hour: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type InkDataV1JobScheduleHourly = {
  __typename?: 'InkDataV1JobScheduleHourly';
  minute: Scalars['Int']['output'];
};

export type InkDataV1JobScheduleHourlyInput = {
  minute: Scalars['Int']['input'];
};

export type InkDataV1JobScheduleInput = {
  daily?: InputMaybe<InkDataV1JobScheduleDailyInput>;
  hourly?: InputMaybe<InkDataV1JobScheduleHourlyInput>;
  minutely?: InputMaybe<InkDataV1JobScheduleMinutelyInput>;
};

export type InkDataV1JobScheduleMinutely = {
  __typename?: 'InkDataV1JobScheduleMinutely';
  interval: Scalars['Int']['output'];
};

export type InkDataV1JobScheduleMinutelyInput = {
  interval: Scalars['Int']['input'];
};

export type InkDataV1JobSpec = {
  __typename?: 'InkDataV1JobSpec';
  dataImport?: Maybe<InkDataV1JobSpecImport>;
  eventExport?: Maybe<InkDataV1JobSpecEventExport>;
};

export type InkDataV1JobSpecCompression = {
  __typename?: 'InkDataV1JobSpecCompression';
  codec: InkDataV1JobSpecCompressionCodecEnum;
  level?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum InkDataV1JobSpecCompressionCodecEnum {
  CodecBzip2 = 'CODEC_BZIP2',
  CodecGzip = 'CODEC_GZIP',
  CodecLz4 = 'CODEC_LZ4',
  CodecUnspecified = 'CODEC_UNSPECIFIED',
  CodecZstd = 'CODEC_ZSTD'
}

export type InkDataV1JobSpecCompressionInput = {
  codec: InkDataV1JobSpecCompressionCodecEnum;
  level?: InputMaybe<Scalars['Int']['input']>;
};

export type InkDataV1JobSpecEventExport = {
  __typename?: 'InkDataV1JobSpecEventExport';
  columns: Array<InkDataV1JobSpecEventExportColumnEnum>;
  contactDataTableConfig?: Maybe<InkDataV1JobSpecEventExportContactDataTableConfig>;
  dataConnectionIds: Array<Scalars['ID']['output']>;
  eventType: InkDataV1JobSpecEventExportTypeEnum;
  format: InkDataV1JobSpecEventExportFormat;
  maxRecordsPerFile?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum InkDataV1JobSpecEventExportColumnEnum {
  ColumnAccountId = 'COLUMN_ACCOUNT_ID',
  ColumnCampaignId = 'COLUMN_CAMPAIGN_ID',
  ColumnCampaignSendDate = 'COLUMN_CAMPAIGN_SEND_DATE',
  ColumnChannel = 'COLUMN_CHANNEL',
  ColumnClickLinkId = 'COLUMN_CLICK_LINK_ID',
  ColumnClickLinkRedirectUrl = 'COLUMN_CLICK_LINK_REDIRECT_URL',
  ColumnContactId = 'COLUMN_CONTACT_ID',
  ColumnContentblockId = 'COLUMN_CONTENTBLOCK_ID',
  ColumnConversionValue = 'COLUMN_CONVERSION_VALUE',
  ColumnCreatedAt = 'COLUMN_CREATED_AT',
  ColumnCreativeId = 'COLUMN_CREATIVE_ID',
  ColumnCurrency = 'COLUMN_CURRENCY',
  ColumnExperimentIds = 'COLUMN_EXPERIMENT_IDS',
  ColumnOrderReferenceId = 'COLUMN_ORDER_REFERENCE_ID',
  ColumnSegmentIds = 'COLUMN_SEGMENT_IDS',
  ColumnSubjectlineId = 'COLUMN_SUBJECTLINE_ID',
  ColumnTreatmentIds = 'COLUMN_TREATMENT_IDS',
  ColumnType = 'COLUMN_TYPE',
  ColumnUnspecified = 'COLUMN_UNSPECIFIED'
}

export type InkDataV1JobSpecEventExportContactDataTableConfig = {
  __typename?: 'InkDataV1JobSpecEventExportContactDataTableConfig';
  dedupeByContactId: Scalars['Boolean']['output'];
  fields: Array<Scalars['String']['output']>;
};

export type InkDataV1JobSpecEventExportContactDataTableConfigInput = {
  dedupeByContactId: Scalars['Boolean']['input'];
  fields: Array<Scalars['String']['input']>;
};

export type InkDataV1JobSpecEventExportFormat = {
  __typename?: 'InkDataV1JobSpecEventExportFormat';
  csv?: Maybe<InkDataV1JobSpecEventExportFormatCsv>;
  parquet?: Maybe<InkDataV1JobSpecEventExportFormatParquet>;
};

export type InkDataV1JobSpecEventExportFormatCsv = {
  __typename?: 'InkDataV1JobSpecEventExportFormatCSV';
  arrayFormat: InkDataV1JobSpecEventExportFormatCsvArrayFormatEnum;
  compression: InkDataV1JobSpecEventExportFormatCsvCompressionEnum;
  customEmptyValue?: Maybe<Scalars['String']['output']>;
  delimiter: InkDataV1JobSpecEventExportFormatCsvDelimiterEnum;
  emptyValueFormat: InkDataV1JobSpecEventExportFormatCsvEmptyValueEnum;
  flattenSeparator: InkDataV1JobSpecEventExportFormatCsvSeparatorEnum;
  quoteCharacter: InkDataV1JobSpecEventExportFormatCsvQuoteCharacterEnum;
  quotingStrategy: InkDataV1JobSpecEventExportFormatCsvQuotingStrategyEnum;
};

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvArrayFormatEnum {
  ArrayFormatFlatten = 'ARRAY_FORMAT_FLATTEN',
  ArrayFormatUnspecified = 'ARRAY_FORMAT_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvCompressionEnum {
  CompressionGzip = 'COMPRESSION_GZIP',
  CompressionLz4 = 'COMPRESSION_LZ4',
  CompressionNone = 'COMPRESSION_NONE',
  CompressionUnspecified = 'COMPRESSION_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvDelimiterEnum {
  DelimiterComma = 'DELIMITER_COMMA',
  DelimiterPipe = 'DELIMITER_PIPE',
  DelimiterTab = 'DELIMITER_TAB',
  DelimiterUnspecified = 'DELIMITER_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvEmptyValueEnum {
  EmptyValueCustom = 'EMPTY_VALUE_CUSTOM',
  EmptyValueEmptyString = 'EMPTY_VALUE_EMPTY_STRING',
  EmptyValueQuotedEmpty = 'EMPTY_VALUE_QUOTED_EMPTY',
  EmptyValueUnspecified = 'EMPTY_VALUE_UNSPECIFIED'
}

export type InkDataV1JobSpecEventExportFormatCsvInput = {
  arrayFormat: InkDataV1JobSpecEventExportFormatCsvArrayFormatEnum;
  compression: InkDataV1JobSpecEventExportFormatCsvCompressionEnum;
  customEmptyValue?: InputMaybe<Scalars['String']['input']>;
  delimiter: InkDataV1JobSpecEventExportFormatCsvDelimiterEnum;
  emptyValueFormat: InkDataV1JobSpecEventExportFormatCsvEmptyValueEnum;
  flattenSeparator: InkDataV1JobSpecEventExportFormatCsvSeparatorEnum;
  quoteCharacter: InkDataV1JobSpecEventExportFormatCsvQuoteCharacterEnum;
  quotingStrategy: InkDataV1JobSpecEventExportFormatCsvQuotingStrategyEnum;
};

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvQuoteCharacterEnum {
  QuoteCharacterDouble = 'QUOTE_CHARACTER_DOUBLE',
  QuoteCharacterUnspecified = 'QUOTE_CHARACTER_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvQuotingStrategyEnum {
  QuotingStrategyEverything = 'QUOTING_STRATEGY_EVERYTHING',
  QuotingStrategyUnspecified = 'QUOTING_STRATEGY_UNSPECIFIED',
  QuotingStrategyWhenNecessary = 'QUOTING_STRATEGY_WHEN_NECESSARY'
}

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatCsvSeparatorEnum {
  SeparatorColon = 'SEPARATOR_COLON',
  SeparatorComma = 'SEPARATOR_COMMA',
  SeparatorPipe = 'SEPARATOR_PIPE',
  SeparatorSemicolon = 'SEPARATOR_SEMICOLON',
  SeparatorUnspecified = 'SEPARATOR_UNSPECIFIED'
}

export type InkDataV1JobSpecEventExportFormatInput = {
  csv?: InputMaybe<InkDataV1JobSpecEventExportFormatCsvInput>;
  parquet?: InputMaybe<InkDataV1JobSpecEventExportFormatParquetInput>;
};

export type InkDataV1JobSpecEventExportFormatParquet = {
  __typename?: 'InkDataV1JobSpecEventExportFormatParquet';
  compression: InkDataV1JobSpecEventExportFormatParquetCompressionEnum;
};

/** An enumeration. */
export enum InkDataV1JobSpecEventExportFormatParquetCompressionEnum {
  CompressionSnappy = 'COMPRESSION_SNAPPY',
  CompressionUnspecified = 'COMPRESSION_UNSPECIFIED',
  CompressionZstd = 'COMPRESSION_ZSTD'
}

export type InkDataV1JobSpecEventExportFormatParquetInput = {
  compression: InkDataV1JobSpecEventExportFormatParquetCompressionEnum;
};

export type InkDataV1JobSpecEventExportInput = {
  columns: Array<InkDataV1JobSpecEventExportColumnEnum>;
  contactDataTableConfig?: InputMaybe<InkDataV1JobSpecEventExportContactDataTableConfigInput>;
  dataConnectionIds: Array<Scalars['ID']['input']>;
  eventType: InkDataV1JobSpecEventExportTypeEnum;
  format: InkDataV1JobSpecEventExportFormatInput;
  maxRecordsPerFile?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum InkDataV1JobSpecEventExportTypeEnum {
  TypeAutoImpression = 'TYPE_AUTO_IMPRESSION',
  TypeAutoOpen = 'TYPE_AUTO_OPEN',
  TypeClick = 'TYPE_CLICK',
  TypeConversion = 'TYPE_CONVERSION',
  TypeImpression = 'TYPE_IMPRESSION',
  TypeOpen = 'TYPE_OPEN',
  TypePlacement = 'TYPE_PLACEMENT',
  TypeSend = 'TYPE_SEND',
  TypeUnsubscribe = 'TYPE_UNSUBSCRIBE'
}

export type InkDataV1JobSpecImport = {
  __typename?: 'InkDataV1JobSpecImport';
  destination: InkDataV1JobSpecImportDestination;
  initialLoad?: Maybe<InkDataV1JobSpecImportInitialLoad>;
  source: InkDataV1JobSpecImportSource;
};

export type InkDataV1JobSpecImportDestination = {
  __typename?: 'InkDataV1JobSpecImportDestination';
  dataset: InkDataV1JobSpecImportDestinationDataset;
  fieldMappings: Array<InkDataV1JobSpecImportDestinationFieldMapping>;
  type: InkDataV1JobSpecImportDestinationTypeEnum;
};

export type InkDataV1JobSpecImportDestinationDataset = {
  __typename?: 'InkDataV1JobSpecImportDestinationDataset';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type InkDataV1JobSpecImportDestinationDatasetInput = {
  id: Scalars['ID']['input'];
};

export type InkDataV1JobSpecImportDestinationFieldMapping = {
  __typename?: 'InkDataV1JobSpecImportDestinationFieldMapping';
  fieldId?: Maybe<Scalars['ID']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  sourceName: Scalars['String']['output'];
};

export type InkDataV1JobSpecImportDestinationFieldMappingInput = {
  fieldId: Scalars['ID']['input'];
  sourceName: Scalars['String']['input'];
};

export type InkDataV1JobSpecImportDestinationInput = {
  dataset: InkDataV1JobSpecImportDestinationDatasetInput;
  fieldMappings: Array<InkDataV1JobSpecImportDestinationFieldMappingInput>;
  type: InkDataV1JobSpecImportDestinationTypeEnum;
};

/** An enumeration. */
export enum InkDataV1JobSpecImportDestinationTypeEnum {
  TypeInsert = 'TYPE_INSERT',
  TypeReplace = 'TYPE_REPLACE',
  TypeUpdate = 'TYPE_UPDATE',
  TypeUpsert = 'TYPE_UPSERT'
}

export type InkDataV1JobSpecImportInitialLoad = {
  __typename?: 'InkDataV1JobSpecImportInitialLoad';
  full?: Maybe<InkDataV1JobSpecImportInitialLoadFull>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InkDataV1JobSpecImportInitialLoadFull = {
  __typename?: 'InkDataV1JobSpecImportInitialLoadFull';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1JobSpecImportInput = {
  destination: InkDataV1JobSpecImportDestinationInput;
  source: InkDataV1JobSpecImportSourceInput;
};

export type InkDataV1JobSpecImportSource = {
  __typename?: 'InkDataV1JobSpecImportSource';
  exact?: Maybe<InkDataV1JobSpecImportSourceExact>;
  incremental?: Maybe<InkDataV1JobSpecImportSourceIncremental>;
  pattern?: Maybe<InkDataV1JobSpecImportSourcePattern>;
};

export type InkDataV1JobSpecImportSourceConnection = {
  __typename?: 'InkDataV1JobSpecImportSourceConnection';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type InkDataV1JobSpecImportSourceConnectionInput = {
  id: Scalars['ID']['input'];
};

export type InkDataV1JobSpecImportSourceExact = {
  __typename?: 'InkDataV1JobSpecImportSourceExact';
  compression?: Maybe<InkDataV1JobSpecCompression>;
  connection: InkDataV1JobSpecImportSourceConnection;
  format: InkDataV1JobSpecImportSourceFormat;
  streamKey: Scalars['String']['output'];
};

export type InkDataV1JobSpecImportSourceExactInput = {
  compression?: InputMaybe<InkDataV1JobSpecCompressionInput>;
  connection: InkDataV1JobSpecImportSourceConnectionInput;
  format: InkDataV1JobSpecImportSourceFormatInput;
  streamKey: Scalars['String']['input'];
};

export type InkDataV1JobSpecImportSourceFormat = {
  __typename?: 'InkDataV1JobSpecImportSourceFormat';
  csv?: Maybe<InkDataV1JobSpecImportSourceFormatCsv>;
  ndjson?: Maybe<InkDataV1JobSpecImportSourceFormatNdjson>;
  parquet?: Maybe<InkDataV1JobSpecImportSourceFormatParquet>;
};

export type InkDataV1JobSpecImportSourceFormatCsv = {
  __typename?: 'InkDataV1JobSpecImportSourceFormatCSV';
  delimiter: Scalars['String']['output'];
  header: Scalars['Boolean']['output'];
  null: Scalars['String']['output'];
};

export type InkDataV1JobSpecImportSourceFormatCsvInput = {
  delimiter: Scalars['String']['input'];
  header: Scalars['Boolean']['input'];
  null?: InputMaybe<Scalars['String']['input']>;
};

export type InkDataV1JobSpecImportSourceFormatInput = {
  csv?: InputMaybe<InkDataV1JobSpecImportSourceFormatCsvInput>;
  ndjson?: InputMaybe<InkDataV1JobSpecImportSourceFormatNdjsonInput>;
};

export type InkDataV1JobSpecImportSourceFormatNdjson = {
  __typename?: 'InkDataV1JobSpecImportSourceFormatNDJSON';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1JobSpecImportSourceFormatNdjsonInput = {
  placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InkDataV1JobSpecImportSourceFormatParquet = {
  __typename?: 'InkDataV1JobSpecImportSourceFormatParquet';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1JobSpecImportSourceIncremental = {
  __typename?: 'InkDataV1JobSpecImportSourceIncremental';
  connection: InkDataV1JobSpecImportSourceConnection;
  cursor: InkDataV1JobSpecImportSourceIncrementalCursor;
  initialLoad?: Maybe<InkDataV1JobSpecImportSourceIncrementalInitialLoad>;
  streamKey: Scalars['String']['output'];
};

export type InkDataV1JobSpecImportSourceIncrementalCursor = {
  __typename?: 'InkDataV1JobSpecImportSourceIncrementalCursor';
  field: Scalars['String']['output'];
};

export type InkDataV1JobSpecImportSourceIncrementalInitialLoad = {
  __typename?: 'InkDataV1JobSpecImportSourceIncrementalInitialLoad';
  full?: Maybe<InkDataV1JobSpecImportSourceIncrementalInitialLoadFull>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InkDataV1JobSpecImportSourceIncrementalInitialLoadFull = {
  __typename?: 'InkDataV1JobSpecImportSourceIncrementalInitialLoadFull';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1JobSpecImportSourceInput = {
  exact?: InputMaybe<InkDataV1JobSpecImportSourceExactInput>;
  pattern?: InputMaybe<InkDataV1JobSpecImportSourcePatternInput>;
};

export type InkDataV1JobSpecImportSourcePattern = {
  __typename?: 'InkDataV1JobSpecImportSourcePattern';
  compression?: Maybe<InkDataV1JobSpecCompression>;
  connection: InkDataV1JobSpecImportSourceConnection;
  format: InkDataV1JobSpecImportSourceFormat;
  streamKeyPattern: Scalars['String']['output'];
};

export type InkDataV1JobSpecImportSourcePatternInput = {
  compression?: InputMaybe<InkDataV1JobSpecCompressionInput>;
  connection: InkDataV1JobSpecImportSourceConnectionInput;
  format: InkDataV1JobSpecImportSourceFormatInput;
  streamKeyPattern: Scalars['String']['input'];
};

export type InkDataV1JobSpecInput = {
  dataImport?: InputMaybe<InkDataV1JobSpecImportInput>;
  eventExport?: InputMaybe<InkDataV1JobSpecEventExportInput>;
};

/** An enumeration. */
export enum InkDataV1JobStatusEnum {
  StatusActive = 'STATUS_ACTIVE',
  StatusPaused = 'STATUS_PAUSED',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export type InkDataV1Model = {
  __typename?: 'InkDataV1Model';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  fields: Array<InkDataV1ModelField>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  namespace?: Maybe<InkDataV1NamespaceRef>;
  table?: Maybe<InkDataV1ModelTableRef>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDataV1ModelFetchResponse = {
  __typename?: 'InkDataV1ModelFetchResponse';
  model: InkDataV1Model;
};

export type InkDataV1ModelField = {
  __typename?: 'InkDataV1ModelField';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryKey: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  type: InkDataV1ModelFieldTypeEnum;
};

/** An enumeration. */
export enum InkDataV1ModelFieldTypeEnum {
  TypeBoolean = 'TYPE_BOOLEAN',
  TypeCategory = 'TYPE_CATEGORY',
  TypeDate = 'TYPE_DATE',
  TypeDatetime = 'TYPE_DATETIME',
  TypeDatetimeArray = 'TYPE_DATETIME_ARRAY',
  TypeDateArray = 'TYPE_DATE_ARRAY',
  TypeFloat = 'TYPE_FLOAT',
  TypeFloatArray = 'TYPE_FLOAT_ARRAY',
  TypeInteger = 'TYPE_INTEGER',
  TypeIntegerArray = 'TYPE_INTEGER_ARRAY',
  TypeString = 'TYPE_STRING',
  TypeStringArray = 'TYPE_STRING_ARRAY'
}

export type InkDataV1ModelListResponse = {
  __typename?: 'InkDataV1ModelListResponse';
  models: Array<InkDataV1Model>;
};

export type InkDataV1ModelTableRef = {
  __typename?: 'InkDataV1ModelTableRef';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InkDataV1NamespaceRef = {
  __typename?: 'InkDataV1NamespaceRef';
  access?: Maybe<InkDataV1NamespaceRefAccessEnum>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDataV1NamespaceRefAccessEnum {
  AccessLinked = 'ACCESS_LINKED',
  AccessOwned = 'ACCESS_OWNED',
  AccessShared = 'ACCESS_SHARED',
  AccessUnspecified = 'ACCESS_UNSPECIFIED'
}

export type InkDataV1QueryCatalog = {
  __typename?: 'InkDataV1QueryCatalog';
  categories: Array<InkDataV1QueryCatalogCategory>;
  categoryRelations: Array<InkDataV1QueryCatalogCategoryRelation>;
  datasetRelations: Array<InkDataV1QueryCatalogDatasetRelation>;
  datasets: Array<InkDataV1QueryCatalogDataset>;
};

/** An enumeration. */
export enum InkDataV1QueryCatalogCardinalityEnum {
  CardinalityManyToMany = 'CARDINALITY_MANY_TO_MANY',
  CardinalityOneToMany = 'CARDINALITY_ONE_TO_MANY',
  CardinalityOneToOne = 'CARDINALITY_ONE_TO_ONE',
  CardinalityUnspecified = 'CARDINALITY_UNSPECIFIED'
}

export type InkDataV1QueryCatalogCategory = {
  __typename?: 'InkDataV1QueryCatalogCategory';
  id: Scalars['Int']['output'];
  labels: Array<InkDataV1QueryCatalogCategoryLabel>;
  name: Scalars['String']['output'];
};

export type InkDataV1QueryCatalogCategoryLabel = {
  __typename?: 'InkDataV1QueryCatalogCategoryLabel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  types: Array<InkDataV1QueryCatalogType>;
};

export type InkDataV1QueryCatalogCategoryRelation = {
  __typename?: 'InkDataV1QueryCatalogCategoryRelation';
  cardinality: InkDataV1QueryCatalogCardinalityEnum;
  id: Scalars['Int']['output'];
  sourceCategoryId: Scalars['Int']['output'];
  sourceLabelId: Scalars['Int']['output'];
  targetCategoryId: Scalars['Int']['output'];
  targetLabelId: Scalars['Int']['output'];
};

export type InkDataV1QueryCatalogDataset = {
  __typename?: 'InkDataV1QueryCatalogDataset';
  fields: Array<InkDataV1QueryCatalogDatasetField>;
  id: Scalars['Int']['output'];
  model: InkDataV1QueryCatalogDatasetModelRef;
  name: Scalars['String']['output'];
};

export type InkDataV1QueryCatalogDatasetField = {
  __typename?: 'InkDataV1QueryCatalogDatasetField';
  id: Scalars['Int']['output'];
  modelField: InkDataV1QueryCatalogDatasetFieldModelFieldRef;
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  primaryKey: Scalars['Boolean']['output'];
  type: InkDataV1QueryCatalogType;
};

export type InkDataV1QueryCatalogDatasetFieldModelFieldRef = {
  __typename?: 'InkDataV1QueryCatalogDatasetFieldModelFieldRef';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InkDataV1QueryCatalogDatasetModelRef = {
  __typename?: 'InkDataV1QueryCatalogDatasetModelRef';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InkDataV1QueryCatalogDatasetRelation = {
  __typename?: 'InkDataV1QueryCatalogDatasetRelation';
  cardinality: InkDataV1QueryCatalogCardinalityEnum;
  id: Scalars['Int']['output'];
  sourceDatasetId: Scalars['Int']['output'];
  sourceFieldId: Scalars['Int']['output'];
  targetDatasetId: Scalars['Int']['output'];
  targetFieldId: Scalars['Int']['output'];
};

export type InkDataV1QueryCatalogFetchResponse = {
  __typename?: 'InkDataV1QueryCatalogFetchResponse';
  catalog: InkDataV1QueryCatalog;
};

export type InkDataV1QueryCatalogType = {
  __typename?: 'InkDataV1QueryCatalogType';
  boolean?: Maybe<InkDataV1QueryCatalogTypeBoolean>;
  date?: Maybe<InkDataV1QueryCatalogTypeDate>;
  dateArray?: Maybe<InkDataV1QueryCatalogTypeDateArray>;
  datetime?: Maybe<InkDataV1QueryCatalogTypeDateTime>;
  datetimeArray?: Maybe<InkDataV1QueryCatalogTypeDateTimeArray>;
  float?: Maybe<InkDataV1QueryCatalogTypeFloat>;
  floatArray?: Maybe<InkDataV1QueryCatalogTypeFloatArray>;
  integer?: Maybe<InkDataV1QueryCatalogTypeInteger>;
  integerArray?: Maybe<InkDataV1QueryCatalogTypeIntegerArray>;
  string?: Maybe<InkDataV1QueryCatalogTypeString>;
  stringArray?: Maybe<InkDataV1QueryCatalogTypeStringArray>;
};

export type InkDataV1QueryCatalogTypeBoolean = {
  __typename?: 'InkDataV1QueryCatalogTypeBoolean';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeDate = {
  __typename?: 'InkDataV1QueryCatalogTypeDate';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeDateArray = {
  __typename?: 'InkDataV1QueryCatalogTypeDateArray';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeDateTime = {
  __typename?: 'InkDataV1QueryCatalogTypeDateTime';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeDateTimeArray = {
  __typename?: 'InkDataV1QueryCatalogTypeDateTimeArray';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeFloat = {
  __typename?: 'InkDataV1QueryCatalogTypeFloat';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeFloatArray = {
  __typename?: 'InkDataV1QueryCatalogTypeFloatArray';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeInteger = {
  __typename?: 'InkDataV1QueryCatalogTypeInteger';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeIntegerArray = {
  __typename?: 'InkDataV1QueryCatalogTypeIntegerArray';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeString = {
  __typename?: 'InkDataV1QueryCatalogTypeString';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCatalogTypeStringArray = {
  __typename?: 'InkDataV1QueryCatalogTypeStringArray';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1QueryCreateResponse = {
  __typename?: 'InkDataV1QueryCreateResponse';
  query?: Maybe<Scalars['InkQLQuery']['output']>;
  queryId: Scalars['ID']['output'];
};

export type InkDataV1QueryFetchResponse = {
  __typename?: 'InkDataV1QueryFetchResponse';
  query?: Maybe<Scalars['InkQLQuery']['output']>;
  queryId: Scalars['ID']['output'];
};

export type InkDataV1QuerySelectCreateResponse = {
  __typename?: 'InkDataV1QuerySelectCreateResponse';
  querySelect?: Maybe<Scalars['InkQLQuerySelect']['output']>;
  querySelectId: Scalars['ID']['output'];
};

export type InkDataV1QuerySelectFetchResponse = {
  __typename?: 'InkDataV1QuerySelectFetchResponse';
  querySelect?: Maybe<Scalars['InkQLQuerySelect']['output']>;
  querySelectId: Scalars['ID']['output'];
};

export type InkDataV1QuerySelectUpdateResponse = {
  __typename?: 'InkDataV1QuerySelectUpdateResponse';
  querySelect?: Maybe<Scalars['InkQLQuerySelect']['output']>;
  querySelectId: Scalars['ID']['output'];
};

export type InkDataV1QueryUpdateResponse = {
  __typename?: 'InkDataV1QueryUpdateResponse';
  query?: Maybe<Scalars['InkQLQuery']['output']>;
  queryId: Scalars['ID']['output'];
};

export type InkDataV1Stream = {
  __typename?: 'InkDataV1Stream';
  deltaShareTable?: Maybe<InkDataV1StreamDeltaShareTable>;
  demoTable?: Maybe<InkDataV1StreamDemoTable>;
  gcsObject?: Maybe<InkDataV1StreamGcsObject>;
  key: Scalars['String']['output'];
  localFile?: Maybe<InkDataV1StreamLocalFile>;
  modifiedAt: Scalars['DateTime']['output'];
  s3Object?: Maybe<InkDataV1StreamS3Object>;
  sftpFile?: Maybe<InkDataV1StreamSftpFile>;
  snowflakeTable?: Maybe<InkDataV1StreamSnowflakeTable>;
};

export type InkDataV1StreamDeltaShareTable = {
  __typename?: 'InkDataV1StreamDeltaShareTable';
  id?: Maybe<Scalars['String']['output']>;
  schema: Scalars['String']['output'];
  share: Scalars['String']['output'];
  table: Scalars['String']['output'];
  version: Scalars['BigInt']['output'];
};

export type InkDataV1StreamDemoTable = {
  __typename?: 'InkDataV1StreamDemoTable';
  name: Scalars['String']['output'];
};

export type InkDataV1StreamGcsObject = {
  __typename?: 'InkDataV1StreamGCSObject';
  bucket: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type InkDataV1StreamLocalFile = {
  __typename?: 'InkDataV1StreamLocalFile';
  path: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type InkDataV1StreamS3Object = {
  __typename?: 'InkDataV1StreamS3Object';
  bucket: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type InkDataV1StreamSftpFile = {
  __typename?: 'InkDataV1StreamSFTPFile';
  path: Scalars['String']['output'];
  size: Scalars['BigInt']['output'];
};

export type InkDataV1StreamSchema = {
  __typename?: 'InkDataV1StreamSchema';
  compression: InkDataV1StreamSchemaCompressionEnum;
  encryption: InkDataV1StreamSchemaEncryptionEnum;
  fields: Array<InkDataV1StreamSchemaField>;
  format: InkDataV1StreamSchemaFormat;
  key: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDataV1StreamSchemaCompressionEnum {
  CompressionBzip = 'COMPRESSION_BZIP',
  CompressionGzip = 'COMPRESSION_GZIP',
  CompressionNone = 'COMPRESSION_NONE',
  CompressionUnspecified = 'COMPRESSION_UNSPECIFIED',
  CompressionZip = 'COMPRESSION_ZIP'
}

/** An enumeration. */
export enum InkDataV1StreamSchemaEncryptionEnum {
  EncryptionGpg = 'ENCRYPTION_GPG',
  EncryptionNone = 'ENCRYPTION_NONE',
  EncryptionUnspecified = 'ENCRYPTION_UNSPECIFIED'
}

export type InkDataV1StreamSchemaFetchResponse = {
  __typename?: 'InkDataV1StreamSchemaFetchResponse';
  schema: InkDataV1StreamSchema;
};

export type InkDataV1StreamSchemaField = {
  __typename?: 'InkDataV1StreamSchemaField';
  name: Scalars['String']['output'];
  type: InkDataV1StreamSchemaFieldTypeEnum;
  values: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export enum InkDataV1StreamSchemaFieldTypeEnum {
  TypeArray = 'TYPE_ARRAY',
  TypeBoolean = 'TYPE_BOOLEAN',
  TypeDate = 'TYPE_DATE',
  TypeDatetime = 'TYPE_DATETIME',
  TypeFloat = 'TYPE_FLOAT',
  TypeInteger = 'TYPE_INTEGER',
  TypeObject = 'TYPE_OBJECT',
  TypeString = 'TYPE_STRING'
}

export type InkDataV1StreamSchemaFormat = {
  __typename?: 'InkDataV1StreamSchemaFormat';
  csv?: Maybe<InkDataV1StreamSchemaFormatCsv>;
  ndjson?: Maybe<InkDataV1StreamSchemaFormatNdjson>;
};

export type InkDataV1StreamSchemaFormatCsv = {
  __typename?: 'InkDataV1StreamSchemaFormatCSV';
  delimiter: Scalars['String']['output'];
  header: Scalars['Boolean']['output'];
  null: Scalars['String']['output'];
};

export type InkDataV1StreamSchemaFormatNdjson = {
  __typename?: 'InkDataV1StreamSchemaFormatNDJSON';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1StreamSnowflakeTable = {
  __typename?: 'InkDataV1StreamSnowflakeTable';
  isView: Scalars['Boolean']['output'];
  schema: Scalars['String']['output'];
  table: Scalars['String']['output'];
};

export type InkDataV1Warehouse = {
  __typename?: 'InkDataV1Warehouse';
  createdAt: Scalars['DateTime']['output'];
  databricks?: Maybe<InkDataV1WarehouseDatabricks>;
  default: Scalars['Boolean']['output'];
  demo?: Maybe<InkDataV1WarehouseDemo>;
  ducklake?: Maybe<InkDataV1WarehouseDuckLake>;
  id: Scalars['Int']['output'];
  namespace: InkDataV1NamespaceRef;
  status: InkDataV1WarehouseStatusEnum;
  type: InkDataV1WarehouseTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDataV1WarehouseDatabricks = {
  __typename?: 'InkDataV1WarehouseDatabricks';
  workspaceHost: Scalars['String']['output'];
};

export type InkDataV1WarehouseDemo = {
  __typename?: 'InkDataV1WarehouseDemo';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1WarehouseDuckLake = {
  __typename?: 'InkDataV1WarehouseDuckLake';
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

export type InkDataV1WarehouseListResponse = {
  __typename?: 'InkDataV1WarehouseListResponse';
  warehouses: Array<InkDataV1Warehouse>;
};

/** An enumeration. */
export enum InkDataV1WarehouseStatusEnum {
  StatusError = 'STATUS_ERROR',
  StatusPending = 'STATUS_PENDING',
  StatusReady = 'STATUS_READY',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDataV1WarehouseTypeEnum {
  TypeDatabricks = 'TYPE_DATABRICKS',
  TypeDemo = 'TYPE_DEMO',
  TypeDucklake = 'TYPE_DUCKLAKE'
}

export type InkDavinciContactsV1AudienceFieldListResponse = {
  __typename?: 'InkDavinciContactsV1AudienceFieldListResponse';
  tables: Array<InkDavinciContactsV1AudienceFieldListResponseTable>;
};

export type InkDavinciContactsV1AudienceFieldListResponseTable = {
  __typename?: 'InkDavinciContactsV1AudienceFieldListResponseTable';
  fields: Array<InkDavinciContactsV1AudienceFieldListResponseTableField>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InkDavinciContactsV1AudienceFieldListResponseTableField = {
  __typename?: 'InkDavinciContactsV1AudienceFieldListResponseTableField';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: InkDavinciContactsV1AudienceFieldListResponseTableFieldTypeEnum;
};

/** An enumeration. */
export enum InkDavinciContactsV1AudienceFieldListResponseTableFieldTypeEnum {
  TypeBoolean = 'TYPE_BOOLEAN',
  TypeCategory = 'TYPE_CATEGORY',
  TypeDate = 'TYPE_DATE',
  TypeDatetime = 'TYPE_DATETIME',
  TypeEmail = 'TYPE_EMAIL',
  TypeFloat = 'TYPE_FLOAT',
  TypeInteger = 'TYPE_INTEGER',
  TypeString = 'TYPE_STRING'
}

export type InkDavinciContactsV1AudienceTagListResponse = {
  __typename?: 'InkDavinciContactsV1AudienceTagListResponse';
  tables: Array<InkDavinciContactsV1AudienceTagListResponseTable>;
};

export type InkDavinciContactsV1AudienceTagListResponseTable = {
  __typename?: 'InkDavinciContactsV1AudienceTagListResponseTable';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<InkDavinciContactsV1AudienceTagListResponseTableTag>;
};

export type InkDavinciContactsV1AudienceTagListResponseTableTag = {
  __typename?: 'InkDavinciContactsV1AudienceTagListResponseTableTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDavinciDataV1ChannelEnum {
  ChannelAppInbox = 'CHANNEL_APP_INBOX',
  ChannelEmail = 'CHANNEL_EMAIL',
  ChannelInApp = 'CHANNEL_IN_APP',
  ChannelMms = 'CHANNEL_MMS',
  ChannelMobileApp = 'CHANNEL_MOBILE_APP',
  ChannelPush = 'CHANNEL_PUSH',
  ChannelRcs = 'CHANNEL_RCS',
  ChannelSms = 'CHANNEL_SMS',
  ChannelTextMessage = 'CHANNEL_TEXT_MESSAGE'
}

export type InkDavinciDataV1Field = {
  __typename?: 'InkDavinciDataV1Field';
  channels: Array<InkDavinciMessagesV1ChannelEnum>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryKey: Scalars['Boolean']['output'];
  semanticFeature?: Maybe<InkDavinciDataV1FieldSemanticFeature>;
  tableId: Scalars['Int']['output'];
  type: InkDavinciDataV1FieldTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDavinciDataV1FieldSemanticFeature = {
  __typename?: 'InkDavinciDataV1FieldSemanticFeature';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDavinciDataV1FieldTypeEnum {
  TypeBoolean = 'TYPE_BOOLEAN',
  TypeCategory = 'TYPE_CATEGORY',
  TypeDate = 'TYPE_DATE',
  TypeDatetime = 'TYPE_DATETIME',
  TypeEmail = 'TYPE_EMAIL',
  TypeFloat = 'TYPE_FLOAT',
  TypeInteger = 'TYPE_INTEGER',
  TypeString = 'TYPE_STRING'
}

export type InkDavinciDataV1Relation = {
  __typename?: 'InkDavinciDataV1Relation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  relatedField: InkDavinciDataV1RelationField;
  relatedTable: InkDavinciDataV1RelationTable;
  sourceField: InkDavinciDataV1RelationField;
  sourceTable: InkDavinciDataV1RelationTable;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDavinciDataV1RelationCreateResponse = {
  __typename?: 'InkDavinciDataV1RelationCreateResponse';
  relation: InkDavinciDataV1Relation;
};

export type InkDavinciDataV1RelationField = {
  __typename?: 'InkDavinciDataV1RelationField';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InkDavinciDataV1RelationListResponse = {
  __typename?: 'InkDavinciDataV1RelationListResponse';
  relations: Array<InkDavinciDataV1Relation>;
};

export type InkDavinciDataV1RelationTable = {
  __typename?: 'InkDavinciDataV1RelationTable';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InkDavinciDataV1SemanticCategory = {
  __typename?: 'InkDavinciDataV1SemanticCategory';
  description: Scalars['String']['output'];
  features: Array<InkDavinciDataV1SemanticCategoryFeature>;
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InkDavinciDataV1SemanticCategoryFeature = {
  __typename?: 'InkDavinciDataV1SemanticCategoryFeature';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  types: Array<InkDavinciDataV1SemanticTypeEnum>;
};

export type InkDavinciDataV1SemanticCategoryListResponse = {
  __typename?: 'InkDavinciDataV1SemanticCategoryListResponse';
  categories: Array<InkDavinciDataV1SemanticCategory>;
};

/** An enumeration. */
export enum InkDavinciDataV1SemanticTypeEnum {
  TypeBoolean = 'TYPE_BOOLEAN',
  TypeCategory = 'TYPE_CATEGORY',
  TypeDate = 'TYPE_DATE',
  TypeDatetime = 'TYPE_DATETIME',
  TypeEmail = 'TYPE_EMAIL',
  TypeFloat = 'TYPE_FLOAT',
  TypeInteger = 'TYPE_INTEGER',
  TypeString = 'TYPE_STRING'
}

export type InkDavinciDataV1StreamCacheItemListResponse = {
  __typename?: 'InkDavinciDataV1StreamCacheItemListResponse';
  cacheItems: Array<InkDavinciDataV1StreamCacheItemListResponseCacheItem>;
};

export type InkDavinciDataV1StreamCacheItemListResponseCacheItem = {
  __typename?: 'InkDavinciDataV1StreamCacheItemListResponseCacheItem';
  exists: Scalars['Boolean']['output'];
  uri: Scalars['String']['output'];
};

export type InkDavinciDataV1Table = {
  __typename?: 'InkDavinciDataV1Table';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rowCount?: Maybe<Scalars['Int']['output']>;
  rowTtlDays?: Maybe<Scalars['Int']['output']>;
  semanticCategory?: Maybe<InkDavinciDataV1TableSemanticCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDavinciDataV1TableLock = {
  __typename?: 'InkDavinciDataV1TableLock';
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
};

export type InkDavinciDataV1TableLockFetchResponse = {
  __typename?: 'InkDavinciDataV1TableLockFetchResponse';
  tableLock: InkDavinciDataV1TableLock;
};

export type InkDavinciDataV1TableQueryResponse = {
  __typename?: 'InkDavinciDataV1TableQueryResponse';
  fields: Array<InkDavinciDataV1TableQueryResponseField>;
  rows: Array<InkDavinciDataV1TableQueryResponseRow>;
};

export type InkDavinciDataV1TableQueryResponseField = {
  __typename?: 'InkDavinciDataV1TableQueryResponseField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  semanticFeature?: Maybe<InkDavinciDataV1TableQueryResponseFieldSemanticFeature>;
};

export type InkDavinciDataV1TableQueryResponseFieldSemanticFeature = {
  __typename?: 'InkDavinciDataV1TableQueryResponseFieldSemanticFeature';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InkDavinciDataV1TableQueryResponseRow = {
  __typename?: 'InkDavinciDataV1TableQueryResponseRow';
  values: Array<Scalars['String']['output']>;
};

export type InkDavinciDataV1TableSemanticCategory = {
  __typename?: 'InkDavinciDataV1TableSemanticCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InkDavinciDataV1Tag = {
  __typename?: 'InkDavinciDataV1Tag';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDavinciDataV1TagCreateResponse = {
  __typename?: 'InkDavinciDataV1TagCreateResponse';
  tag: InkDavinciDataV1Tag;
};

export type InkDavinciDataV1TagFetchResponse = {
  __typename?: 'InkDavinciDataV1TagFetchResponse';
  tag: InkDavinciDataV1Tag;
};

export type InkDavinciDataV1TagListResponse = {
  __typename?: 'InkDavinciDataV1TagListResponse';
  tags: Array<InkDavinciDataV1Tag>;
};

export type InkDavinciDataV1TagUpdateResponse = {
  __typename?: 'InkDavinciDataV1TagUpdateResponse';
  tag: InkDavinciDataV1Tag;
};

export type InkDavinciDataV2Job = {
  __typename?: 'InkDavinciDataV2Job';
  archived: Scalars['Boolean']['output'];
  config: InkDavinciDataV2JobConfig;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metrics: InkDavinciDataV2JobMetrics;
  name: Scalars['String']['output'];
  schedule?: Maybe<InkDavinciDataV2JobSchedule>;
  status: InkDavinciDataV2JobStatusEnum;
  type: InkDavinciDataV2JobTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDavinciDataV2JobArchiveResponse = {
  __typename?: 'InkDavinciDataV2JobArchiveResponse';
  job: InkDavinciDataV2Job;
};

export type InkDavinciDataV2JobConfig = {
  __typename?: 'InkDavinciDataV2JobConfig';
  importJob?: Maybe<InkDavinciDataV2JobConfigImportJob>;
  taggingJob?: Maybe<InkDavinciDataV2JobConfigTaggingJob>;
};

export type InkDavinciDataV2JobConfigImportJob = {
  __typename?: 'InkDavinciDataV2JobConfigImportJob';
  columns: Array<InkDavinciDataV2JobConfigImportJobColumn>;
  query?: Maybe<Scalars['DataQuery']['output']>;
  resource: InkDavinciDataV2JobResource;
  tableId: Scalars['ID']['output'];
  type: InkDavinciDataV2JobConfigImportJobTypeEnum;
};

export type InkDavinciDataV2JobConfigImportJobColumn = {
  __typename?: 'InkDavinciDataV2JobConfigImportJobColumn';
  fieldId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDavinciDataV2JobConfigImportJobTypeEnum {
  TypeInsert = 'TYPE_INSERT',
  TypeReplace = 'TYPE_REPLACE',
  TypeUpdate = 'TYPE_UPDATE',
  TypeUpsert = 'TYPE_UPSERT'
}

export type InkDavinciDataV2JobConfigTaggingJob = {
  __typename?: 'InkDavinciDataV2JobConfigTaggingJob';
  columns: Array<InkDavinciDataV2JobConfigTaggingJobColumn>;
  permitTagCreation: Scalars['Boolean']['output'];
  removeFromMissingRecords: Scalars['Boolean']['output'];
  resource: InkDavinciDataV2JobResource;
  tableId: Scalars['ID']['output'];
  tags: Array<InkDavinciDataV2JobConfigTaggingJobTag>;
  type: InkDavinciDataV2JobConfigTaggingJobTypeEnum;
};

export type InkDavinciDataV2JobConfigTaggingJobColumn = {
  __typename?: 'InkDavinciDataV2JobConfigTaggingJobColumn';
  fieldId?: Maybe<Scalars['ID']['output']>;
  isTag: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type InkDavinciDataV2JobConfigTaggingJobTag = {
  __typename?: 'InkDavinciDataV2JobConfigTaggingJobTag';
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum InkDavinciDataV2JobConfigTaggingJobTypeEnum {
  TypeAppend = 'TYPE_APPEND',
  TypeReplace = 'TYPE_REPLACE'
}

export type InkDavinciDataV2JobCreateResponse = {
  __typename?: 'InkDavinciDataV2JobCreateResponse';
  job: InkDavinciDataV2Job;
};

export type InkDavinciDataV2JobFetchResponse = {
  __typename?: 'InkDavinciDataV2JobFetchResponse';
  job: InkDavinciDataV2Job;
};

export type InkDavinciDataV2JobListResponse = {
  __typename?: 'InkDavinciDataV2JobListResponse';
  jobs: Array<InkDavinciDataV2Job>;
};

export type InkDavinciDataV2JobMetrics = {
  __typename?: 'InkDavinciDataV2JobMetrics';
  avgRunDuration: Scalars['Int']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunRecords: Scalars['BigInt']['output'];
  totalRunErrors: Scalars['Int']['output'];
  totalRuns: Scalars['Int']['output'];
};

export type InkDavinciDataV2JobPauseResponse = {
  __typename?: 'InkDavinciDataV2JobPauseResponse';
  job: InkDavinciDataV2Job;
};

export type InkDavinciDataV2JobResource = {
  __typename?: 'InkDavinciDataV2JobResource';
  compression: InkDavinciDataV2JobResourceCompressionEnum;
  connectionId: Scalars['ID']['output'];
  format: InkDavinciDataV2JobResourceFormat;
  uri: Scalars['String']['output'];
  uris: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export enum InkDavinciDataV2JobResourceCompressionEnum {
  CompressionBzip = 'COMPRESSION_BZIP',
  CompressionGzip = 'COMPRESSION_GZIP',
  CompressionNone = 'COMPRESSION_NONE',
  CompressionUnspecified = 'COMPRESSION_UNSPECIFIED',
  CompressionZip = 'COMPRESSION_ZIP'
}

export type InkDavinciDataV2JobResourceFormat = {
  __typename?: 'InkDavinciDataV2JobResourceFormat';
  csv?: Maybe<InkDavinciDataV2JobResourceFormatCsv>;
};

export type InkDavinciDataV2JobResourceFormatCsv = {
  __typename?: 'InkDavinciDataV2JobResourceFormatCSV';
  delimiter: Scalars['String']['output'];
  header: Scalars['Boolean']['output'];
  null: Scalars['String']['output'];
};

export type InkDavinciDataV2JobResumeResponse = {
  __typename?: 'InkDavinciDataV2JobResumeResponse';
  job: InkDavinciDataV2Job;
};

export type InkDavinciDataV2JobRun = {
  __typename?: 'InkDavinciDataV2JobRun';
  archived: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  config: InkDavinciDataV2JobConfig;
  createdAt: Scalars['DateTime']['output'];
  failures: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  lastNackedAt?: Maybe<Scalars['DateTime']['output']>;
  lastPingedAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  maxFailures: Scalars['Int']['output'];
  metrics: InkDavinciDataV2JobRunMetrics;
  status: InkDavinciDataV2JobRunStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type InkDavinciDataV2JobRunArchiveResponse = {
  __typename?: 'InkDavinciDataV2JobRunArchiveResponse';
  jobRun: InkDavinciDataV2JobRun;
};

export type InkDavinciDataV2JobRunCancelResponse = {
  __typename?: 'InkDavinciDataV2JobRunCancelResponse';
  jobRun: InkDavinciDataV2JobRun;
};

export type InkDavinciDataV2JobRunListResponse = {
  __typename?: 'InkDavinciDataV2JobRunListResponse';
  jobRuns: Array<InkDavinciDataV2JobRun>;
};

export type InkDavinciDataV2JobRunMetrics = {
  __typename?: 'InkDavinciDataV2JobRunMetrics';
  downloadDuration: Scalars['Int']['output'];
  runDuration: Scalars['Int']['output'];
  totalRecords: Scalars['BigInt']['output'];
  validRecords: Scalars['BigInt']['output'];
};

export type InkDavinciDataV2JobRunResumeResponse = {
  __typename?: 'InkDavinciDataV2JobRunResumeResponse';
  jobRun: InkDavinciDataV2JobRun;
};

/** An enumeration. */
export enum InkDavinciDataV2JobRunStatusEnum {
  StatusCanceled = 'STATUS_CANCELED',
  StatusCanceling = 'STATUS_CANCELING',
  StatusCompleted = 'STATUS_COMPLETED',
  StatusError = 'STATUS_ERROR',
  StatusFailed = 'STATUS_FAILED',
  StatusReady = 'STATUS_READY',
  StatusRunning = 'STATUS_RUNNING',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export type InkDavinciDataV2JobSchedule = {
  __typename?: 'InkDavinciDataV2JobSchedule';
  daily?: Maybe<InkDavinciDataV2JobScheduleDaily>;
  hourly?: Maybe<InkDavinciDataV2JobScheduleHourly>;
};

export type InkDavinciDataV2JobScheduleDaily = {
  __typename?: 'InkDavinciDataV2JobScheduleDaily';
  hour: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type InkDavinciDataV2JobScheduleHourly = {
  __typename?: 'InkDavinciDataV2JobScheduleHourly';
  minute: Scalars['Int']['output'];
};

/** An enumeration. */
export enum InkDavinciDataV2JobStatusEnum {
  StatusActive = 'STATUS_ACTIVE',
  StatusPaused = 'STATUS_PAUSED',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDavinciDataV2JobTypeEnum {
  TypeImport = 'TYPE_IMPORT',
  TypeTagging = 'TYPE_TAGGING'
}

export enum InkDavinciDsrV1DsrStatusEnum {
  StatusCompleted = 'STATUS_COMPLETED',
  StatusError = 'STATUS_ERROR',
  StatusInProgress = 'STATUS_IN_PROGRESS',
  StatusPending = 'STATUS_PENDING',
  StatusQueued = 'STATUS_QUEUED',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export enum InkDavinciDsrV1DsrTypeEnum {
  TypeAccess = 'TYPE_ACCESS',
  TypeErasure = 'TYPE_ERASURE',
  TypePortability = 'TYPE_PORTABILITY'
}

/** An enumeration. */
export enum InkDavinciEventsV1AttributionTypeEnum {
  AttributionTypeDirect = 'ATTRIBUTION_TYPE_DIRECT',
  AttributionTypeIndirect = 'ATTRIBUTION_TYPE_INDIRECT',
  AttributionTypeUnspecified = 'ATTRIBUTION_TYPE_UNSPECIFIED'
}

export type InkDavinciEventsV1CustomEventCategory = {
  __typename?: 'InkDavinciEventsV1CustomEventCategory';
  attributionType: InkDavinciEventsV1AttributionTypeEnum;
  contactIdentifierField: InkDavinciDataV1Field;
  hasSubidentifier: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  table: InkDavinciDataV1Table;
  tags: Array<InkDavinciEventsV1CustomEventTag>;
  timestampType: InkDavinciEventsV1TimestampTypeEnum;
};

export type InkDavinciEventsV1CustomEventCategoryCreateResponse = {
  __typename?: 'InkDavinciEventsV1CustomEventCategoryCreateResponse';
  category: InkDavinciEventsV1CustomEventCategory;
};

export type InkDavinciEventsV1CustomEventCategoryUpdateResponse = {
  __typename?: 'InkDavinciEventsV1CustomEventCategoryUpdateResponse';
  category: InkDavinciEventsV1CustomEventCategory;
};

export type InkDavinciEventsV1CustomEventTag = {
  __typename?: 'InkDavinciEventsV1CustomEventTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum InkDavinciEventsV1TimestampTypeEnum {
  TimestampTypeDate = 'TIMESTAMP_TYPE_DATE',
  TimestampTypeDatetime = 'TIMESTAMP_TYPE_DATETIME',
  TimestampTypeUnspecified = 'TIMESTAMP_TYPE_UNSPECIFIED'
}

/** An enumeration. */
export enum InkDavinciMessagesV1ChannelEnum {
  ChannelAppInbox = 'CHANNEL_APP_INBOX',
  ChannelEmail = 'CHANNEL_EMAIL',
  ChannelInApp = 'CHANNEL_IN_APP',
  ChannelMms = 'CHANNEL_MMS',
  ChannelPush = 'CHANNEL_PUSH',
  ChannelRcs = 'CHANNEL_RCS',
  ChannelSms = 'CHANNEL_SMS'
}

/**
 * One metric available to alert on for a job, from the jobs metric
 * catalog (content_library.alerts.jobs.JOBS_METRICS).
 */
export type JobAlertMetricType = {
  __typename?: 'JobAlertMetricType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

/**
 * One Import job, as offered by the job picker in the jobs "create
 * alert" modal.
 */
export type JobAlertPickerEntryType = {
  __typename?: 'JobAlertPickerEntryType';
  availableMetrics: Array<JobAlertMetricType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type JobDeleteSuccess = {
  __typename?: 'JobDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

/** The variants of the ``Job.Spec`` oneof; values match the proto field names. */
export enum JobSpecKind {
  DataImport = 'DATA_IMPORT',
  EventExport = 'EVENT_EXPORT',
  Synthetic = 'SYNTHETIC',
  Transfer = 'TRANSFER'
}

export type Journey = {
  __typename?: 'Journey';
  config?: Maybe<JourneyConfig>;
  /** @deprecated Use the typed config field instead. */
  configJson: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  namespaceId: Scalars['Int']['output'];
  status?: Maybe<JourneyStatus>;
  tags?: Maybe<Array<Maybe<JourneyTag>>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type JourneyCancel = {
  __typename?: 'JourneyCancel';
  journey: Journey;
};

export type JourneyConfig = {
  __typename?: 'JourneyConfig';
  edges: Array<JourneyEdge>;
  nodes: Array<JourneyNode>;
  settings?: Maybe<JourneySettings>;
};

export type JourneyConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  edges: Array<JourneyEdgeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nodes: Array<JourneyNodeInput>;
  settings?: InputMaybe<JourneySettingsInput>;
  tags?: InputMaybe<Array<JourneyTagInput>>;
};

export type JourneyCreate = {
  __typename?: 'JourneyCreate';
  journey: Journey;
};

export type JourneyDelete = {
  __typename?: 'JourneyDelete';
  success: Scalars['Boolean']['output'];
};

export type JourneyEdge = {
  __typename?: 'JourneyEdge';
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type JourneyEdgeInput = {
  id: Scalars['String']['input'];
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

export type JourneyEnrollmentSettings = {
  __typename?: 'JourneyEnrollmentSettings';
  allowReEntry?: Maybe<Scalars['Boolean']['output']>;
  skipContactsAlreadyInJourney?: Maybe<Scalars['Boolean']['output']>;
};

export type JourneyEnrollmentSettingsInput = {
  allowReEntry?: InputMaybe<Scalars['Boolean']['input']>;
  skipContactsAlreadyInJourney?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JourneyEventConfig = {
  __typename?: 'JourneyEventConfig';
  eventName?: Maybe<JourneyEventType>;
  queryId: Scalars['Int']['output'];
};

export type JourneyEventConfigInput = {
  eventName: JourneyEventType;
  queryId: Scalars['Int']['input'];
};

export enum JourneyEventType {
  TypeAutoClick = 'TYPE_AUTO_CLICK',
  TypeAutoImpression = 'TYPE_AUTO_IMPRESSION',
  TypeAutoOpen = 'TYPE_AUTO_OPEN',
  TypeBackInStockRequested = 'TYPE_BACK_IN_STOCK_REQUESTED',
  TypeBrowser = 'TYPE_BROWSER',
  TypeCartAddition = 'TYPE_CART_ADDITION',
  TypeCartRemoval = 'TYPE_CART_REMOVAL',
  TypeCategoryViewed = 'TYPE_CATEGORY_VIEWED',
  TypeCheckoutStarted = 'TYPE_CHECKOUT_STARTED',
  TypeClick = 'TYPE_CLICK',
  TypeCollectionPageView = 'TYPE_COLLECTION_PAGE_VIEW',
  TypeConversion = 'TYPE_CONVERSION',
  TypeCustomEvent = 'TYPE_CUSTOM_EVENT',
  TypeHardBounce = 'TYPE_HARD_BOUNCE',
  TypeIdentity = 'TYPE_IDENTITY',
  TypeImpression = 'TYPE_IMPRESSION',
  TypeOpen = 'TYPE_OPEN',
  TypeOrderCancelation = 'TYPE_ORDER_CANCELATION',
  TypeOrderCompletion = 'TYPE_ORDER_COMPLETION',
  TypeOrderRefund = 'TYPE_ORDER_REFUND',
  TypePageView = 'TYPE_PAGE_VIEW',
  TypePlacement = 'TYPE_PLACEMENT',
  TypeProductPageView = 'TYPE_PRODUCT_PAGE_VIEW',
  TypeProductSearch = 'TYPE_PRODUCT_SEARCH',
  TypePromotionApplied = 'TYPE_PROMOTION_APPLIED',
  TypeReviewSubmission = 'TYPE_REVIEW_SUBMISSION',
  TypeSend = 'TYPE_SEND',
  TypeSession = 'TYPE_SESSION',
  TypeSoftBounce = 'TYPE_SOFT_BOUNCE',
  TypeSpamComplaint = 'TYPE_SPAM_COMPLAINT',
  TypeUnknownBounce = 'TYPE_UNKNOWN_BOUNCE',
  TypeUnsubscribe = 'TYPE_UNSUBSCRIBE',
  TypeUserRegistered = 'TYPE_USER_REGISTERED',
  TypeUserSubscribed = 'TYPE_USER_SUBSCRIBED',
  TypeWishlistAddition = 'TYPE_WISHLIST_ADDITION'
}

export type JourneyExitSettings = {
  __typename?: 'JourneyExitSettings';
  config?: Maybe<JourneyEventConfig>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  rules: Array<JourneyRuleCondition>;
};

export type JourneyExitSettingsInput = {
  config?: InputMaybe<JourneyEventConfigInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<JourneyRuleConditionInput>>;
};

export type JourneyInstance = {
  __typename?: 'JourneyInstance';
  id: Scalars['ID']['output'];
};

export type JourneyNode = {
  __typename?: 'JourneyNode';
  data?: Maybe<JourneyNodeData>;
  id: Scalars['String']['output'];
  type?: Maybe<JourneyNodeType>;
};

export type JourneyNodeConfig = {
  __typename?: 'JourneyNodeConfig';
  campaignId: Scalars['String']['output'];
  eventName?: Maybe<JourneyEventType>;
  queryId: Scalars['Int']['output'];
  timeout?: Maybe<JourneyTimeout>;
};

export type JourneyNodeConfigInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<JourneyEventType>;
  queryId?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<JourneyTimeoutInput>;
};

export type JourneyNodeData = {
  __typename?: 'JourneyNodeData';
  config?: Maybe<JourneyNodeConfig>;
  rules: Array<JourneyNodeRule>;
};

export type JourneyNodeDataInput = {
  config?: InputMaybe<JourneyNodeConfigInput>;
  rules?: InputMaybe<Array<JourneyNodeRuleInput>>;
};

export type JourneyNodeInput = {
  data?: InputMaybe<JourneyNodeDataInput>;
  id: Scalars['String']['input'];
  type: JourneyNodeType;
};

export type JourneyNodeRule = {
  __typename?: 'JourneyNodeRule';
  nextNodeId: Scalars['String']['output'];
  rule?: Maybe<JourneyRuleCondition>;
};

export type JourneyNodeRuleInput = {
  nextNodeId: Scalars['String']['input'];
  rule?: InputMaybe<JourneyRuleConditionInput>;
};

export enum JourneyNodeType {
  Click = 'CLICK',
  Exit = 'EXIT',
  Open = 'OPEN',
  SendCampaign = 'SEND_CAMPAIGN',
  Trigger = 'TRIGGER',
  WaitForEvent = 'WAIT_FOR_EVENT',
  WaitForTime = 'WAIT_FOR_TIME'
}

export type JourneyPause = {
  __typename?: 'JourneyPause';
  journey: Journey;
};

export type JourneyPublish = {
  __typename?: 'JourneyPublish';
  journey: Journey;
};

export type JourneyRename = {
  __typename?: 'JourneyRename';
  journey: Journey;
};

export type JourneyResume = {
  __typename?: 'JourneyResume';
  journey: Journey;
};

export type JourneyRuleCondition = {
  __typename?: 'JourneyRuleCondition';
  conditions: Scalars['String']['output'];
  on: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type JourneyRuleConditionInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  on?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type JourneySettings = {
  __typename?: 'JourneySettings';
  enrollment?: Maybe<JourneyEnrollmentSettings>;
  exit?: Maybe<JourneyExitSettings>;
};

export type JourneySettingsInput = {
  enrollment?: InputMaybe<JourneyEnrollmentSettingsInput>;
  exit?: InputMaybe<JourneyExitSettingsInput>;
};

export enum JourneyStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  Unspecified = 'UNSPECIFIED'
}

export type JourneyTag = {
  __typename?: 'JourneyTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type JourneyTagInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type JourneyTimeout = {
  __typename?: 'JourneyTimeout';
  unit?: Maybe<JourneyTimeoutUnit>;
  value: Scalars['Int']['output'];
};

export type JourneyTimeoutInput = {
  unit: JourneyTimeoutUnit;
  value: Scalars['Int']['input'];
};

export enum JourneyTimeoutUnit {
  UnitDays = 'UNIT_DAYS',
  UnitHours = 'UNIT_HOURS',
  UnitMinutes = 'UNIT_MINUTES',
  UnitWeeks = 'UNIT_WEEKS'
}

export type JourneyTrigger = {
  __typename?: 'JourneyTrigger';
  journeyInstance: JourneyInstance;
};

export type JourneyUpdateSuccess = {
  __typename?: 'JourneyUpdateSuccess';
  journey: Journey;
  success: Scalars['Boolean']['output'];
};

export type KnockTokenResult = {
  __typename?: 'KnockTokenResult';
  success: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

export type Layout = {
  __typename?: 'Layout';
  /** @deprecated Use has_unpublished_changes instead (typo fix) */
  hasUnpublishedChanged?: Maybe<Scalars['Boolean']['output']>;
  hasUnpublishedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  linkLibrary: Array<Link2>;
  mediaLibrary: Array<Media2>;
  name: Scalars['String']['output'];
  published?: Maybe<Scalars['LayoutDocument']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<User>;
  snapshot?: Maybe<Scalars['LayoutDocument']['output']>;
  studioCampaigns: Array<StudioCampaignImport>;
  supportedLayoutComplexity: LayoutComplexity;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  upgradeStatus: LayoutUpgradeStatus;
  usedBrandKit?: Maybe<BrandKit>;
  variables: Array<Variable>;
};


export type LayoutPublishedArgs = {
  format?: InputMaybe<DocumentFormat>;
};


export type LayoutSnapshotArgs = {
  format?: InputMaybe<DocumentFormat>;
};

export enum LayoutComplexity {
  Full = 'FULL',
  Mosaic = 'MOSAIC',
  Simple = 'SIMPLE'
}

export type LayoutComponent = {
  __typename?: 'LayoutComponent';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  versions: Array<LayoutComponentVersion>;
};

export type LayoutComponentConnection = {
  __typename?: 'LayoutComponentConnection';
  counts: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LayoutComponentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LayoutComponent` and its cursor. */
export type LayoutComponentEdge = {
  __typename?: 'LayoutComponentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LayoutComponent;
};

export type LayoutComponentFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<State>;
};

export type LayoutComponentPagination = {
  __typename?: 'LayoutComponentPagination';
  page: Scalars['Int']['output'];
  results: Array<LayoutComponent>;
  total: Scalars['Int']['output'];
};

export type LayoutComponentSuccess = {
  __typename?: 'LayoutComponentSuccess';
  layoutComponent: LayoutComponent;
  success: Scalars['Boolean']['output'];
};

export enum LayoutComponentTypeEnum {
  Block = 'BLOCK',
  Component = 'COMPONENT'
}

export type LayoutComponentUsage = MediaUsageLocation & {
  __typename?: 'LayoutComponentUsage';
  channel: Channel;
  componentId: Scalars['ID']['output'];
  componentName: Scalars['String']['output'];
  componentType: LayoutComponentTypeEnum;
  id: Scalars['ID']['output'];
  layoutId: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type LayoutComponentVersion = {
  __typename?: 'LayoutComponentVersion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  layout: ComponentLayout;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  version: Scalars['Int']['output'];
};

export type LayoutTemplateTag = TemplateTag & {
  __typename?: 'LayoutTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Layout>;
};

export type LayoutUpdateSuccess = {
  __typename?: 'LayoutUpdateSuccess';
  layout: Layout;
  success: Scalars['Boolean']['output'];
};

export enum LayoutUpgradeStatus {
  Basic = 'BASIC',
  Upgradable = 'UPGRADABLE',
  Upgraded = 'UPGRADED'
}

export type Link = {
  __typename?: 'Link';
  acousticCampaignMetadata?: Maybe<LinkAcousticCampaignMetadata>;
  adobeCampaignMetadata?: Maybe<LinkAdobeCampaignMetadata>;
  adobeJourneyOptimizerMetadata?: Maybe<LinkAdobeJourneyOptimizerMetadata>;
  amazonSesMetadata?: Maybe<LinkAmazonSesMetadata>;
  bluecoreMetadata?: Maybe<LinkBluecoreMetadata>;
  brazeMetadata?: Maybe<LinkBrazeMetadata>;
  cordialMetadata?: Maybe<LinkCordialMetadata>;
  createdAt: Scalars['DateTime']['output'];
  enableConversionTracking: Scalars['Boolean']['output'];
  enableTracking: Scalars['Boolean']['output'];
  epsilonMetadata?: Maybe<LinkEpsilonMetadata>;
  id: Scalars['ID']['output'];
  linkGroup?: Maybe<LinkGroup>;
  oracleResponsysMetadata?: Maybe<LinkOracleResponsysMetadata>;
  queryStringParameters: Array<Array<Scalars['String']['output']>>;
  salesforceMetadata?: Maybe<LinkSalesForceMarketingCloudMetadata>;
  shortUuid: Scalars['String']['output'];
  trackingParameters: Array<Attribute>;
  url: Scalars['String']['output'];
  zetaMetadata?: Maybe<LinkZetaMetadata>;
};

export type Link2 = {
  __typename?: 'Link2';
  createdAt: Scalars['DateTime']['output'];
  enableConversionTracking: Scalars['Boolean']['output'];
  enableTracking: Scalars['Boolean']['output'];
  espMetadata: Array<Link2Metadata>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  queryStringParameters: Array<Array<Scalars['String']['output']>>;
  trackingParameters: Array<Attribute>;
  url: Scalars['String']['output'];
};

export type Link2AcousticCampaignMetadata = {
  __typename?: 'Link2AcousticCampaignMetadata';
  linkType: LinkTypeAcousticCampaign;
  name: Scalars['String']['output'];
};

export type Link2AdobeCampaignMetadata = {
  __typename?: 'Link2AdobeCampaignMetadata';
  label: Scalars['String']['output'];
  trackingType: LinkTrackingTypeAdobeCampaign;
};

export type Link2AdobeJourneyOptimizerMetadata = {
  __typename?: 'Link2AdobeJourneyOptimizerMetadata';
  trackingType: LinkTrackingTypeAdobeJourneyOptimizer;
};

export type Link2AmazonSesMetadata = {
  __typename?: 'Link2AmazonSESMetadata';
  enableTracking: Scalars['Boolean']['output'];
  tags: Scalars['JSONString']['output'];
};

export type Link2BluecoreMetadata = {
  __typename?: 'Link2BluecoreMetadata';
  enableTracking: Scalars['Boolean']['output'];
};

export type Link2BrazeMetadata = {
  __typename?: 'Link2BrazeMetadata';
  alias: Scalars['String']['output'];
};

export type Link2Connection = {
  __typename?: 'Link2Connection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<Link2Edge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type Link2CordialMetadata = {
  __typename?: 'Link2CordialMetadata';
  enableTracking: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** A Relay edge containing a `Link2` and its cursor. */
export type Link2Edge = {
  __typename?: 'Link2Edge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Link2;
};

export type Link2EpsilonMetadata = {
  __typename?: 'Link2EpsilonMetadata';
  linkType: LinkTypeEpsilon;
  tracked: Scalars['Boolean']['output'];
};

export type Link2FilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Link2Metadata = Link2AcousticCampaignMetadata | Link2AdobeCampaignMetadata | Link2AdobeJourneyOptimizerMetadata | Link2AmazonSesMetadata | Link2BluecoreMetadata | Link2BrazeMetadata | Link2CordialMetadata | Link2EpsilonMetadata | Link2OracleResponsysMetadata | Link2SalesForceMarketingCloudMetadata | Link2ZetaMetadata;

export type Link2OracleResponsysMetadata = {
  __typename?: 'Link2OracleResponsysMetadata';
  category?: Maybe<OracleResponsysLinkCategory>;
  enableTracking: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Link2SalesForceMarketingCloudMetadata = {
  __typename?: 'Link2SalesForceMarketingCloudMetadata';
  alias: Scalars['String']['output'];
  enableConversionTracking: Scalars['Boolean']['output'];
  enableDeepLinks: Scalars['Boolean']['output'];
};

export type Link2Success = {
  __typename?: 'Link2Success';
  link: Link2;
  success: Scalars['Boolean']['output'];
};

export type Link2ZetaMetadata = {
  __typename?: 'Link2ZetaMetadata';
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type LinkAcousticCampaignMetadata = {
  __typename?: 'LinkAcousticCampaignMetadata';
  linkType: LinkTypeAcousticCampaign;
  name: Scalars['String']['output'];
};

export type LinkAcousticCampaignMetadataInput = {
  linkType?: InputMaybe<LinkTypeAcousticCampaign>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LinkAcousticCampaignMetadataInput2 = {
  linkType: LinkTypeAcousticCampaign;
  name: Scalars['String']['input'];
};

export type LinkAdobeCampaignMetadata = {
  __typename?: 'LinkAdobeCampaignMetadata';
  label: Scalars['String']['output'];
  trackingType: LinkTrackingTypeAdobeCampaign;
};

export type LinkAdobeCampaignMetadataInput2 = {
  label: Scalars['String']['input'];
  trackingType: LinkTrackingTypeAdobeCampaign;
};

export type LinkAdobeJourneyOptimizerMetadata = {
  __typename?: 'LinkAdobeJourneyOptimizerMetadata';
  trackingType: LinkTrackingTypeAdobeJourneyOptimizer;
};

export type LinkAdobeJourneyOptimizerMetadataInput2 = {
  trackingType: LinkTrackingTypeAdobeJourneyOptimizer;
};

export type LinkAmazonSesMetadata = {
  __typename?: 'LinkAmazonSESMetadata';
  enableTracking: Scalars['Boolean']['output'];
  tags: Scalars['JSONString']['output'];
};

export type LinkAmazonSesMetadataInput2 = {
  enableTracking: Scalars['Boolean']['input'];
  tags: Scalars['JSONString']['input'];
};

export enum LinkBehaviorEnum {
  AppLink = 'APP_LINK',
  WebLink = 'WEB_LINK'
}

export type LinkBluecoreMetadata = {
  __typename?: 'LinkBluecoreMetadata';
  enableTracking: Scalars['Boolean']['output'];
};

export type LinkBluecoreMetadataInput2 = {
  enableTracking: Scalars['Boolean']['input'];
};

export type LinkBrazeMetadata = {
  __typename?: 'LinkBrazeMetadata';
  alias: Scalars['String']['output'];
};

export type LinkBrazeMetadataInput2 = {
  alias: Scalars['String']['input'];
};

export type LinkCordialMetadata = {
  __typename?: 'LinkCordialMetadata';
  enableTracking: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type LinkCordialMetadataInput = {
  enableTracking?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LinkCordialMetadataInput2 = {
  enableTracking: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type LinkCreate = {
  __typename?: 'LinkCreate';
  link: Link;
};

export type LinkEpsilonMetadata = {
  __typename?: 'LinkEpsilonMetadata';
  linkType: LinkTypeEpsilon;
  tracked: Scalars['Boolean']['output'];
};

export type LinkEpsilonMetadataInput = {
  linkType?: InputMaybe<LinkTypeEpsilon>;
  tracked: Scalars['Boolean']['input'];
};

export type LinkEpsilonMetadataInput2 = {
  linkType: LinkTypeEpsilon;
  tracked: Scalars['Boolean']['input'];
};

export type LinkGroup = {
  __typename?: 'LinkGroup';
  id: Scalars['ID']['output'];
  links: Array<Link>;
  linksCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LinkGroupCreate = {
  __typename?: 'LinkGroupCreate';
  linkGroup: LinkGroup;
};

export type LinkGroupCreateLink = {
  __typename?: 'LinkGroupCreateLink';
  link: Link;
};

export type LinkMetadataInput = {
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput2>;
  adobeCampaignMetadata?: InputMaybe<LinkAdobeCampaignMetadataInput2>;
  adobeJourneyOptimizerMetadata?: InputMaybe<LinkAdobeJourneyOptimizerMetadataInput2>;
  amazonSesMetadata?: InputMaybe<LinkAmazonSesMetadataInput2>;
  bluecoreMetadata?: InputMaybe<LinkBluecoreMetadataInput2>;
  brazeMetadata?: InputMaybe<LinkBrazeMetadataInput2>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput2>;
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput2>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput2>;
  salesforceMetadata?: InputMaybe<LinkSalesforceMarketingCloudMetadataInput2>;
  zetaMetadata?: InputMaybe<LinkZetaMetadataInput2>;
};

export type LinkOracleResponsysMetadata = {
  __typename?: 'LinkOracleResponsysMetadata';
  category?: Maybe<OracleResponsysLinkCategory>;
  enableTracking: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type LinkOracleResponsysMetadataInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  enableTracking?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LinkOracleResponsysMetadataInput2 = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  enableTracking: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type LinkSalesForceMarketingCloudMetadata = {
  __typename?: 'LinkSalesForceMarketingCloudMetadata';
  alias: Scalars['String']['output'];
  enableConversionTracking: Scalars['Boolean']['output'];
  enableDeepLinks: Scalars['Boolean']['output'];
};

export type LinkSalesForceMarketingCloudMetadataInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  enableConversionTracking?: InputMaybe<Scalars['Boolean']['input']>;
  enableDeepLinks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkSalesforceMarketingCloudMetadataInput2 = {
  alias: Scalars['String']['input'];
  enableConversionTracking: Scalars['Boolean']['input'];
  enableDeepLinks: Scalars['Boolean']['input'];
};

export type LinkSuccess = {
  __typename?: 'LinkSuccess';
  link: Link;
  success: Scalars['Boolean']['output'];
};

export type LinkTemplateTag = TemplateTag & {
  __typename?: 'LinkTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Link>;
};

/** An enumeration. */
export enum LinkTrackingTypeAdobeCampaign {
  AlwaysEnabled = 'ALWAYS_ENABLED',
  Enabled = 'ENABLED',
  MirrorPage = 'MIRROR_PAGE',
  NeverTracked = 'NEVER_TRACKED',
  NotTracked = 'NOT_TRACKED',
  OptOut = 'OPT_OUT'
}

/** An enumeration. */
export enum LinkTrackingTypeAdobeJourneyOptimizer {
  ExternalLink = 'EXTERNAL_LINK',
  LandingPage = 'LANDING_PAGE',
  MirrorPage = 'MIRROR_PAGE',
  NotTracked = 'NOT_TRACKED',
  OneClickOptOut = 'ONE_CLICK_OPT_OUT',
  Subscription = 'SUBSCRIPTION',
  Unsubscription = 'UNSUBSCRIPTION'
}

/** An enumeration. */
export enum LinkTypeAcousticCampaign {
  Spclick = 'SPCLICK',
  Spclickstream = 'SPCLICKSTREAM',
  Spclicktoview = 'SPCLICKTOVIEW',
  Spcustomoptout = 'SPCUSTOMOPTOUT',
  Spnotrack = 'SPNOTRACK',
  Sponeclickoptout = 'SPONECLICKOPTOUT'
}

/** An enumeration. */
export enum LinkTypeEpsilon {
  Form = 'FORM',
  ForwardToAFriend = 'FORWARD_TO_A_FRIEND',
  Image = 'IMAGE',
  LinkToASocialPost = 'LINK_TO_A_SOCIAL_POST',
  PrivacyPolicy = 'PRIVACY_POLICY',
  Redirect = 'REDIRECT',
  ShareToSocial = 'SHARE_TO_SOCIAL',
  Static = 'STATIC'
}

export type LinkUpdate = {
  __typename?: 'LinkUpdate';
  link: Link;
};

export type LinkZetaMetadata = {
  __typename?: 'LinkZetaMetadata';
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type LinkZetaMetadataInput2 = {
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type ListAttribute = Attribute & {
  __typename?: 'ListAttribute';
  definition: ListAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ListAttributeDefinition = AttributeDefinition & {
  __typename?: 'ListAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  id: Scalars['ID']['output'];
  languageCode: Scalars['Language']['output'];
  languageName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Logo = {
  __typename?: 'Logo';
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  updatedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};

export type LogoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export type MmsProofVariant = {
  __typename?: 'MMSProofVariant';
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mediaUrl?: Maybe<Scalars['String']['output']>;
  recipients: Scalars['Int']['output'];
  runId: Scalars['Int']['output'];
  type: ProofVariantType;
};

export type Mailing = {
  __typename?: 'Mailing';
  campaign: Campaign;
  id: Scalars['ID']['output'];
  sendDatetime: Scalars['DateTime']['output'];
  stage?: Maybe<MailingStage>;
  type: MailingType;
};

export type MailingMetrics = {
  __typename?: 'MailingMetrics';
  mailing: Mailing;
  metrics: Array<Maybe<Metric>>;
};

export enum MailingStage {
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queueing = 'QUEUEING',
  Resuming = 'RESUMING',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING',
  Sending = 'SENDING',
  Suspended = 'SUSPENDED',
  Suspending = 'SUSPENDING',
  Unscheduling = 'UNSCHEDULING',
  Waiting = 'WAITING'
}

export enum MailingType {
  Proof = 'PROOF',
  Seed = 'SEED',
  Standard = 'STANDARD'
}

export type ManagedMedia = Media2 & {
  __typename?: 'ManagedMedia';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `ManagedMedia.usages` instead */
  creativeUsages?: Maybe<Array<Creative>>;
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use `url` */
  internalUrl: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  uri: Scalars['String']['output'];
  /** The CDN URL if it has been uploaded to the client's CDN, otherwise the internal storage URL. */
  url: Scalars['String']['output'];
  usages: Array<MediaUsage>;
};

export type Media = {
  __typename?: 'Media';
  /** @deprecated Use media2 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use media2 */
  id: Scalars['ID']['output'];
  /** @deprecated Use media2 */
  imageUrl: Scalars['String']['output'];
  /** @deprecated Use media2 */
  thumbnailUrl: Scalars['String']['output'];
  /** @deprecated Use media2 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use media2 */
  uri: Scalars['String']['output'];
};

export type Media2 = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  uri: Scalars['String']['output'];
};

export type MediaCreate = {
  __typename?: 'MediaCreate';
  media: Media;
  success: Scalars['Boolean']['output'];
};

export type MediaCreate2 = {
  __typename?: 'MediaCreate2';
  media: Media2;
  success: Scalars['Boolean']['output'];
};

export type MediaDelete = {
  __typename?: 'MediaDelete';
  success: Scalars['Boolean']['output'];
};

export type MediaUsage = EmailCreativeUsage | LayoutComponentUsage | MmsCreativeUsage | PushCreativeUsage;

export type MediaUsageLocation = {
  channel: Channel;
  id: Scalars['ID']['output'];
};

export enum MemberStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Declined = 'DECLINED',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Requested = 'REQUESTED',
  Suspended = 'SUSPENDED'
}

/** An enumeration. */
export enum MessageDeliveryType {
  DelayedDeliveryMta = 'DELAYED_DELIVERY_MTA',
  DelayedDeliveryOmm = 'DELAYED_DELIVERY_OMM',
  Standard = 'STANDARD'
}

export type MessageExtra = {
  __typename?: 'MessageExtra';
  id: Scalars['ID']['output'];
  messageExtraKeyId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type MessageExtraKey = {
  __typename?: 'MessageExtraKey';
  defaultValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  keyName: Scalars['String']['output'];
};

/** One segment (split selection) on a MessageSourceAudience row. */
export type MessageSourceAudienceSegmentType = {
  __typename?: 'MessageSourceAudienceSegmentType';
  externalId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<ContactAudienceSplit>;
  selected: Scalars['Boolean']['output'];
};

/** One audience entry (include or exclude) on a message source. */
export type MessageSourceAudienceType = {
  __typename?: 'MessageSourceAudienceType';
  audience?: Maybe<ContactAudience>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  segments: Array<MessageSourceAudienceSegmentType>;
};

export type Metric = {
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum MetricCategory {
  Category = 'CATEGORY',
  Count = 'COUNT',
  Currency = 'CURRENCY',
  CurrencyRate = 'CURRENCY_RATE',
  FractionalCount = 'FRACTIONAL_COUNT',
  Rate = 'RATE',
  Score = 'SCORE',
  Variance = 'VARIANCE'
}

/** An enumeration. */
export enum MetricClass {
  Creative = 'CREATIVE',
  Message = 'MESSAGE',
  Program = 'PROGRAM'
}

/**
 * A metric a user can configure an alert against. Per-account: custom
 * events and feature-flagged metrics show up here when applicable.
 */
export type MetricDefType = {
  __typename?: 'MetricDefType';
  category: Scalars['String']['output'];
  customEventCategory?: Maybe<Scalars['String']['output']>;
  displayByDefault: Scalars['Boolean']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  positivelyCorrelated: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum MetricGroup {
  Churn = 'CHURN',
  ContactBased = 'CONTACT_BASED',
  CustomEvent = 'CUSTOM_EVENT',
  Engagement = 'ENGAGEMENT',
  Intelligence = 'INTELLIGENCE',
  Reach = 'REACH',
  Revenue = 'REVENUE'
}

export type MetricPoint = {
  __typename?: 'MetricPoint';
  label: Scalars['String']['output'];
  value: Scalars['BigInt']['output'];
};

export type MetricSeries = {
  __typename?: 'MetricSeries';
  baselines?: Maybe<Array<MetricPoint>>;
  groups?: Maybe<Array<MetricPoint>>;
};

export type MetricType = {
  __typename?: 'MetricType';
  category: MetricCategory;
  customEventCategory?: Maybe<Scalars['String']['output']>;
  displayByDefault: Scalars['Boolean']['output'];
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  positivelyCorrelated: Scalars['Boolean']['output'];
  supportsSeries: Scalars['Boolean']['output'];
};

export type MetricValuePoint = {
  __typename?: 'MetricValuePoint';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum MetricView {
  ContentBlock = 'CONTENT_BLOCK',
  Default = 'DEFAULT',
  Detail = 'DETAIL',
  Experiment = 'EXPERIMENT',
  Grouped = 'GROUPED',
  Index = 'INDEX',
  MultiGrouped = 'MULTI_GROUPED'
}

/**
 * Tagged-union filter for exportMetrics.
 *
 * Exactly one field must be set. Each field corresponds to a ViewType member, so
 * the populated field selects the view type to export.
 */
export type MetricsExportFilterInput = {
  campaignSegmentComparison?: InputMaybe<SegmentComparisonFilter>;
  campaignTreatmentComparison?: InputMaybe<TreatmentComparisonFilter>;
  campaigns?: InputMaybe<CampaignMetricsFilter>;
  creativeSegmentComparison?: InputMaybe<SegmentComparisonFilter>;
  creativeTreatmentComparison?: InputMaybe<TreatmentComparisonFilter>;
  creatives?: InputMaybe<CreativeMetricsFilter>;
  creativesHeatmap?: InputMaybe<CreativeMetricsFilter>;
  experimentCampaigns?: InputMaybe<ExperimentCampaignMetricsFilter>;
  experimentCreatives?: InputMaybe<ExperimentCreativeMetricsFilter>;
  experimentSegments?: InputMaybe<ExperimentSegmentsMetricsFilter>;
  experiments?: InputMaybe<ExperimentMetricsFilter>;
  segmentCampaigns?: InputMaybe<SegmentGroupCampaignMetricsFilter>;
  segmentCreatives?: InputMaybe<SegmentGroupCreativeMetricsFilter>;
  segmentExperiments?: InputMaybe<SegmentExperimentMetricsFilter>;
  segments?: InputMaybe<SegmentGroupMetricsFilter>;
  subjectlines?: InputMaybe<SubjectLineMetricsFilter>;
};

/**
 * Union of every view type's group-by values, used by exportMetrics.
 *
 * Each view type's ViewTypeExportConfig.group_by_enum is the valid subset.
 *
 */
export enum MetricsGroupBy {
  Day = 'day',
  Month = 'month',
  Quarter = 'quarter',
  Tags = 'tags',
  TagsIndividual = 'tags_individual',
  Week = 'week',
  Year = 'year'
}

export type MmsCreativeUsage = MediaUsageLocation & {
  __typename?: 'MmsCreativeUsage';
  channel: Channel;
  contentId: Scalars['ID']['output'];
  creativeId: Scalars['ID']['output'];
  creativeTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum MobilePlatformEnum {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** Represents a month of a fiscal calendar. */
export type Month = {
  __typename?: 'Month';
  id: Scalars['ID']['output'];
  /** The month of the Gregorian calendar (1-12) */
  month: Scalars['Int']['output'];
  /** The date range of the month */
  span: DateSpan;
  /** The year of the Gregorian calendar */
  year: Scalars['Int']['output'];
};

export type MultiGroupedCampaignsMetrics = {
  __typename?: 'MultiGroupedCampaignsMetrics';
  campaigns?: Maybe<Array<CampaignMetric>>;
  groups?: Maybe<Array<GroupDimension>>;
  metrics: Array<Maybe<Metric>>;
};

export type MultiGroupedCreativesMetrics = {
  __typename?: 'MultiGroupedCreativesMetrics';
  creatives?: Maybe<Array<CreativeMetric>>;
  groups?: Maybe<Array<GroupDimension>>;
  metrics: Array<Maybe<Metric>>;
};

export type MultiSelectAttribute = Attribute & {
  __typename?: 'MultiSelectAttribute';
  definition: MultiSelectAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<AttributeOption>;
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
};

export type MultiSelectAttribute2 = Attribute & {
  __typename?: 'MultiSelectAttribute2';
  definition: MultiSelectAttributeDefinition2;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  selectedIds: Array<Scalars['ID']['output']>;
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
};

export type MultiSelectAttributeDefinition = AttributeDefinition & {
  __typename?: 'MultiSelectAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<AttributeOption>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type MultiSelectAttributeDefinition2 = AttributeDefinition & {
  __typename?: 'MultiSelectAttributeDefinition2';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<AttributeOption2>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type MultiSelectTemplateTag = TemplateTag & {
  __typename?: 'MultiSelectTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Array<Maybe<TemplateTagOption>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accountCreate: AccountCreateSuccess;
  accountDeactivate: AccountSuccess;
  accountReactivate: AccountReactivateSuccess;
  accountRoleCreate: AccountRoleCreate;
  accountRoleDelete: AccountRoleDelete;
  accountRolePermissionsAdd: AccountRolePermissionsSuccess;
  accountRolePermissionsRemove: AccountRolePermissionsSuccess;
  accountRoleUpdate: AccountRoleUpdate;
  accountUpdate: AccountUpdateSuccess;
  accountUserAdd: AccountUserAdd;
  accountUserAssignRole: AccountUserAssignRole;
  accountUserBulkCreate: AccountUserBulkCreate;
  accountUserBulkCreateWithRoles: AccountUserBulkCreateWithRoles;
  accountUserInvitationAccept2: AccountUserInvitationAccept2;
  accountUserInvitationDecline: AccountUserInvitationDecline;
  accountUserInvite: AccountUserInvite;
  accountUserInviteCancel: AccountUserInviteCancel;
  accountUserReactivate: AccountUserReactivate;
  accountUserReinvite: AccountUserReinvite;
  accountUserRemove: AccountUserRemove;
  accountUserRoleCreate2: AccountUserRoleCreate2;
  accountUserRoleDelete2: AccountUserRoleDelete2;
  accountUserSuspend2: AccountUserSuspend2;
  accountUserSwitchRole: AccountUserSwitchRole;
  accountUserUnassignRole: AccountUserUnassignRole;
  adobeCampaignConfigDeliveryNatureUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  adobeCampaignConfigDeliveryVariableCreate: CampaignAdobeCampaignConfigUpdateSuccess;
  adobeCampaignConfigDeliveryVariableDelete: CampaignAdobeCampaignConfigUpdateSuccess;
  adobeCampaignConfigDeliveryVariableUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  alertRuleCreate: AlertRuleCreateSuccess;
  alertRuleDelete: AlertRuleDeleteSuccess;
  alertRuleModify: AlertRuleModifySuccess;
  alertRuleSubscribe: AlertRuleSubscribeSuccess;
  alertRuleUnsubscribe: AlertRuleUnsubscribeSuccess;
  amazonSesConfigEmailTagCreate: AmazonSesConfigUpdateSuccess;
  amazonSesConfigEmailTagDelete: AmazonSesConfigUpdateSuccess;
  amazonSesConfigEmailTagUpdate: AmazonSesConfigUpdateSuccess;
  analyticsConfigurationUpdate: AnalyticsConfigurationUpdate;
  analyticsKpiEventSelectionsReplace: AnalyticsConfigurationUpdate;
  analyticsV2CampaignExport: AnalyticsExportReponse;
  analyticsV2CampaignSegmentExport: AnalyticsExportReponse;
  analyticsV2CampaignTreatmentExport: AnalyticsExportReponse;
  analyticsV2CreativeExperimentExport: AnalyticsExportReponse;
  analyticsV2CreativeExport: AnalyticsExportReponse;
  analyticsV2CreativeSegmentExport: AnalyticsExportReponse;
  analyticsV2CreativeTreatmentExport: AnalyticsExportReponse;
  analyticsV2ExperimentExport: AnalyticsExportReponse;
  analyticsV2SegmentExport: AnalyticsExportReponse;
  analyticsV2SubjectlineExport: AnalyticsExportReponse;
  audienceCreate: AudienceCreate;
  audienceDuplicate: AudienceDuplicate;
  audienceGroupCreate: AudienceGroupCreate;
  audienceGroupUpdate: AudienceGroupUpdate;
  audienceUpdate: AudienceUpdate;
  baseTemplateUpdate: BaseTemplateUpdate;
  blackholeConfigClientErrorRateUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigEmitSentEventsUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigEmitTelemetryUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigEmitWebhooksUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigLatencyMsUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigPrintToStdoutUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigServerErrorRateUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigWebhookEndpointIdUpdate: BlackholeConfigUpdateSuccess;
  blackholeConfigWebhookEndpointTokenUpdate: BlackholeConfigUpdateSuccess;
  blockArchive: BlockSuccess;
  blockDuplicate: BlockSuccess;
  blockRename: BlockSuccess;
  blockSave: BlockSuccess;
  brandKitCreate: BrandKitSuccess;
  brandKitDelete: Ok;
  brandKitGenerationCreate: BrandKitGenerationSuccess;
  brandKitGenerationUpdateStatus: BrandKitGenerationSuccess;
  /** @deprecated Use brandKitUpdate instead */
  brandKitUpdate: BrandKitSuccess;
  brandKitUpdate2: BrandKitSuccess;
  campaignAcousticCampaignConfigFromAddressUpdate: CampaignAcousticCampaignConfigUpdateSuccess;
  campaignAcousticCampaignConfigFromNameUpdate: CampaignAcousticCampaignConfigUpdateSuccess;
  campaignAcousticCampaignConfigPreprocessingHoursUpdate: CampaignAcousticCampaignConfigUpdateSuccess;
  campaignAcousticCampaignConfigPreprocessingUpdate: CampaignAcousticCampaignConfigUpdateSuccess;
  campaignAcousticCampaignConfigReplyToUpdate: CampaignAcousticCampaignConfigUpdateSuccess;
  campaignAddExperimentGroup: CampaignSuccess;
  campaignAddToRecommendationRun: CampaignAddToRecommendationRun;
  campaignAdobeCampaignConfigDeliveryCodeUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigFromAddressUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigFromNameUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigLabelUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigReplyToAddressUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigReplyToNameUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigRoutingIdUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigTargetMappingIdUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigTypologyIdUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignAdobeCampaignConfigWebAnalyticsAccountUpdate: CampaignAdobeCampaignConfigUpdateSuccess;
  campaignApprove: CampaignApprove;
  campaignAudienceCreate: CampaignAudienceCreate;
  campaignAudienceDelete: CampaignUpdateSuccess;
  campaignAudienceDelete2: CampaignUpdatePossibleSuccess;
  campaignAudienceGroupCreate: CampaignAudienceGroupCreateResult;
  campaignAudienceGroupDelete: CampaignUpdateSuccess;
  campaignAudienceGroupDelete2: CampaignUpdatePossibleSuccess;
  campaignAudienceGroupPriorityUpdate: CampaignAudienceGroupPriorityUpdate;
  campaignAudienceGroupRename: CampaignAudienceGroupRename;
  campaignAudiencePriorityUpdate: CampaignAudiencePriorityUpdate;
  campaignAudienceUpdate: CampaignAudienceUpdate;
  campaignAutoCreativeInclusionEnable: CampaignSuccess;
  campaignCancel: CampaignCancel;
  campaignCancelApproval: CampaignCancelApproval;
  campaignCheckboxAttributeUpdate: CampaignSuccess;
  campaignCordialConfigExcludeAudienceAdd: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigExcludeAudienceRemove: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigFromDescriptionUpdate: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigFromEmailUpdate: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigReplyEmailUpdate: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigSendPropertyCreate2: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigSendPropertyDelete: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigSendPropertyUpdate2: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigSenderProfileUpdate: CampaignCordialConfigUpdateSuccess;
  campaignCordialConfigTagsUpdate: CampaignCordialConfigUpdateSuccess;
  campaignCreate: CampaignCreateResult;
  campaignCustomFieldAdd: CampaignCustomFieldAdd;
  campaignCustomFieldRemove: CampaignCustomFieldRemove;
  campaignCustomFieldUpdate: CampaignCustomFieldUpdate;
  campaignDateAttributeUpdate: CampaignSuccess;
  campaignDelete: Ok;
  campaignDetailsUpdate: CampaignDetailsUpdateResult;
  campaignDisableAutoScheduling: CampaignDisableAutoScheduling;
  campaignDuplicate: CampaignDuplicateResult;
  campaignDynamicPreheaderAndPreviewUpdate: CampaignInboxUpdateSuccess;
  campaignDynamicSubjectLinePrefixUpdate: CampaignInboxUpdateSuccess;
  campaignDynamicSubjectLineSuffixUpdate: CampaignInboxUpdateSuccess;
  campaignDynamicSubjectLineUpdate: CampaignInboxUpdateSuccess;
  campaignEmailServiceProviderUpdate: CampaignSuccess;
  campaignEnableAutoScheduling: CampaignEnableAutoScheduling;
  campaignEpsilonConfigFromAddressUpdate: CampaignEpsilonConfigUpdateSuccess;
  campaignEpsilonConfigFromNameUpdate: CampaignEpsilonConfigUpdateSuccess;
  campaignEpsilonConfigReplyToUpdate: CampaignEpsilonConfigUpdateSuccess;
  campaignExperience2AttachAllCreatives: CampaignExperienceAttachCreatives;
  campaignExperience2AttachCreatives: CampaignExperienceAttachCreatives;
  campaignExperience2AutoIncludeCreatives: CampaignExperience2AutoIncludeCreatives;
  campaignExperience2Delete: CampaignExperience2Delete;
  campaignExperience2DetachAll: CampaignExperience2DetachAll;
  campaignExperience2DetachCreatives: CampaignExperience2DetachCreatives;
  campaignExperience2SectionReset: CampaignExperience2SectionReset;
  campaignExperience2UpdateName: CampaignExperience2UpdateName;
  campaignExperience2UpdateVisibility: CampaignExperience2UpdateVisibility;
  campaignExperienceAttachAllCreatives: CampaignExperienceAttachAllCreatives;
  campaignExperienceAttachAllCreatives2: CampaignExperienceAttachAllCreatives;
  campaignExperienceAttachCreatives: CampaignExperienceAttachCreatives;
  campaignExperienceAttachCreatives2: CampaignExperienceAttachCreatives;
  campaignExperienceDelete: CampaignExperienceDelete;
  campaignExperienceDeleteAll: CampaignExperienceDeleteAll;
  campaignExperienceDetachAllCreatives: CampaignExperienceDetachAllCreatives;
  campaignExperienceDetachAllCreatives2: CampaignExperienceDetachAllCreatives;
  campaignExperienceDetachCreatives: CampaignExperienceDetachCreatives;
  campaignExperienceDetachCreatives2: CampaignExperienceDetachCreatives;
  campaignExperienceMerge: CampaignExperienceMerge;
  campaignExperienceReset: CampaignExperienceReset;
  campaignExperienceSetHidden: CampaignExperienceSetHidden;
  campaignExperienceUpdate: CampaignExperienceUpdate;
  campaignExperiences2AttachAllCreatives: CampaignExperiences2AttachAllCreativesResult;
  campaignExperiences2AttachCreatives: CampaignExperiences2AttachCreativesResult;
  campaignExperiences2BlockReset: CampaignExperiences2BlockResetResult;
  campaignExperiences2Create: CampaignExperiences2CreateResult;
  campaignExperiences2Delete: CampaignExperiences2DeleteResult;
  campaignExperiences2DetachAllCreatives: CampaignExperiences2DetachAllCreativesResult;
  campaignExperiences2DetachCreatives: CampaignExperiences2DetachCreativesResult;
  campaignExperiences2UpdateAutoInclude: CampaignExperiences2UpdateAutoIncludeResult;
  campaignExperiences2UpdateName: CampaignExperiences2UpdateNameResult;
  campaignExperiences2UpdateRecsSettings: CampaignExperiences2UpdateRecsSettingsResult;
  campaignExperiences2UpdateVisibility: CampaignExperiences2UpdateVisibilityResult;
  campaignExperimentCreate: CampaignSuccess;
  campaignExperimentDelete: CampaignSuccess;
  campaignFieldCreate: Campaign;
  campaignFieldDelete: Campaign;
  campaignFieldUpdate: Campaign;
  campaignListAttributeUpdate: CampaignSuccess;
  campaignLockForProofing: CampaignLockForProofing;
  /** @deprecated MarkAsPrepared should no longer be used. */
  campaignMarkAsPrepared: CampaignMarkAsPrepared;
  campaignMessageExtraCreate: CampaignMessageExtraMutationSuccess;
  campaignMessageExtraDelete: CampaignMessageExtraMutationSuccess;
  campaignMessageExtraUpdate: CampaignMessageExtraMutationSuccess;
  campaignOracleResponsysConfigAdditionalDataSourceAdd: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigAdditionalDataSourceRemove: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigFromEmailUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigFromNameUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigMarketingProgramUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigMarketingStrategyUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigProfileListUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigReplyToUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigSelectCampaignVariableUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigSelectExternalTrackingParameterUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigSuppressionListAdd: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigSuppressionListRemove: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigTextCampaignVariableUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  campaignOracleResponsysConfigTextExternalTrackingParameterUpdate: CampaignOracleResponsysConfigUpdateSuccess;
  /** @deprecated Associating a persado campaign directly with a campaign is deprecated */
  campaignPersadoSubjectlineUpdate: CampaignInboxUpdateSuccess;
  campaignPersonalizedSendScheduleUpdate: CampaignPersonalizedSendScheduleUpdate;
  campaignPickupChanges: CampaignSuccess;
  campaignPreheaderAndPreviewModeUpdate: CampaignInboxUpdateSuccess;
  campaignPushSettingsUpdate: CampaignPushSettingsUpdateSuccess;
  campaignResume: CampaignResume;
  campaignRevertToDraft: CampaignRevertToDraft;
  campaignSalesforceMarketingCloudConfigDelayedDeliveryUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudConfigSendClassificationUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudConfigSendLoggingUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudConfigSendThrottlingUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudConfigSenderProfileUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudConfigSuppressionDataExtensionAdd: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudConfigSuppressionDataExtensionRemove: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudPrebuildDurationUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSalesforceMarketingCloudPublicationListUpdate: CampaignSalesforceMarketingCloudConfigUpdateSuccess;
  campaignSavedViewCreate: CampaignSavedViewCreateResponse;
  campaignSavedViewDelete: CampaignSavedViewUpdateOrDeleteResponse;
  campaignSavedViewUpdate: CampaignSavedViewUpdateOrDeleteResponse;
  campaignSchedule: CampaignSchedule;
  campaignSectionAdd: CampaignSectionAdd;
  campaignSectionPrimaryUpdate: CampaignSuccess;
  campaignSectionPriorityUpdate: CampaignSuccess;
  campaignSectionRemove: CampaignUpdateSuccess;
  campaignSectionRemove2: CampaignUpdatePossibleSuccess;
  campaignSeedAudienceAdd: CampaignSuccess;
  campaignSeedAudienceRemove: CampaignSuccess;
  campaignSegmentComparisonExport: ExportResponse;
  campaignSelectAttributeUpdate: CampaignSuccess;
  campaignSelectTrackingParameterUpdate: CampaignSuccess;
  campaignSendDateUpdate: CampaignSendDateUpdate;
  /** @deprecated Use campaignStaticSendScheduleUpdate or campiangPersonalizeSendScheduleUpdate */
  campaignSendDatetimeUpdate: CampaignSendDatetimeUpdate;
  campaignSendProofs: CampaignSuccess;
  campaignSetFeatureFlagExperiences2: Campaign;
  campaignSetFrequencyModel: CampaignSuccess;
  campaignStaticPreheaderAndPreviewLinkUpdate: CampaignInboxUpdateSuccess;
  campaignStaticPreheaderAndPreviewUpdate: CampaignInboxUpdateSuccess;
  campaignStaticSendScheduleUpdate: CampaignStaticSendScheduleUpdate;
  campaignStaticSubjectLinePrefixUpdate: CampaignInboxUpdateSuccess;
  campaignStaticSubjectLineSuffixUpdate: CampaignInboxUpdateSuccess;
  campaignStaticSubjectLineUpdate: CampaignInboxUpdateSuccess;
  campaignSubjectLineModeUpdate: CampaignInboxUpdateSuccess;
  campaignSubjectLinePrefixModeUpdate: CampaignInboxUpdateSuccess;
  campaignSubjectLineStrategyUpdate: CampaignInboxUpdateSuccess;
  campaignSubjectLineSuffixModeUpdate: CampaignInboxUpdateSuccess;
  campaignSuspend: CampaignSuspend;
  campaignTagCreate: CampaignTagUpdateSuccess;
  campaignTagDelete: CampaignTagUpdateSuccess;
  campaignTemplateSave: CampaignTemplateSave;
  campaignTemplateUpdate: CampaignTemplateUpdate;
  campaignTerminate: CampaignTerminate;
  campaignTextAttributeUpdate: CampaignSuccess;
  campaignTextTrackingParameterUpdate: CampaignSuccess;
  campaignTitleUpdate: CampaignSuccess;
  campaignTreatmentComparisonExport: ExportResponse;
  campaignUnschedule: CampaignUnschedule;
  campaignsMetricsExport: ExportResponse;
  clientUserUpdate: ClientUserUpdate;
  contactAudienceAnalyticsTracking: ContactAudienceAnalyticsTrackingSuccess;
  contactAudienceArchive: ContactAudienceArchive;
  contactAudienceAutoBuild: ContactAudienceAutoBuildSuccess;
  contactAudienceConfigRemove: ContactAudienceConfigRemoveResult;
  contactAudienceCreate: ContactAudienceCreate;
  contactAudienceDelete: ContactAudienceDelete;
  contactAudienceExclude: CampaignSuccess;
  contactAudienceInclude: ContactAudienceIncludeResult;
  contactAudienceReorder: CampaignSuccess;
  contactAudienceUpdate: ContactAudienceUpdate;
  contactSegmentCreate: ContactSegmentCreate;
  contactSegmentDelete: ContactSegmentDelete;
  contactSegmentGroupArchive: ContactSegmentGroupArchive;
  contactSegmentGroupAutoSegmentCreate: ContactSegmentGroupAutoSegmentCreate;
  contactSegmentGroupCreate: ContactSegmentGroupCreate;
  contactSegmentGroupDelete: ContactSegmentGroupDelete;
  contactSegmentGroupPriorityUpdate: ContactSegmentGroupPriorityUpdate;
  contactSegmentGroupUpdate: ContactSegmentGroupUpdate;
  contactSegmentUpdate: ContactSegmentUpdate;
  contactSnapshotCount: ContactSnapshotCountSuccess;
  contentVariantAvailabilitiesCreate: ContentVariantSuccess;
  contentVariantCreate: ContentVariantSuccess;
  createCredential: CredentialCreateSuccess;
  createRecurringExportReminder: RecurringExportReminderResponse;
  createSavedFilter: SavedFilterResponse;
  createVariable: CreateVariablePayload;
  creativeApprove: CreativeSuccess;
  creativeArchive: CreativeSuccess;
  creativeAvailabilitiesUpdate: CreativeAvailabilitiesUpdateResult;
  creativeCheckboxTemplateTagUpdate: CreativeSuccess;
  creativeCreate: CreativeCreateResult;
  creativeDateTemplateTagUpdate: CreativeSuccess;
  creativeDelete: Ok;
  creativeDisableReuseRulesUpdate: CreativeSuccess;
  creativeDisclaimerUpdate: CreativeSuccess;
  creativeDuplicate: CreativeSuccess;
  creativeExpire: CreativeExpireResult;
  creativeExport: ExportResponse;
  creativeFiltersAdd: CreativeSuccess;
  creativeFiltersRemove: CreativeSuccess;
  creativeImageTemplateTagUpdate: CreativeSuccess;
  creativeLegacyFilterAdd: CreativeSuccess;
  creativeLegacyFilterRemove: CreativeSuccess;
  creativeMultiSelectTemplateTagUpdate: CreativeSuccess;
  creativePairedCreativeAdd: CreativeSuccess;
  creativePairedCreativeByTagAdd: CreativeSuccess;
  creativePairedCreativeByTagRemove: CreativeSuccess;
  creativePairedCreativeRemove: CreativeSuccess;
  creativePersadoCampaignUpdate: CreativeSuccess;
  creativePreheaderAndPreviewUpdate: CreativePreheaderAndPreviewUpdateResult;
  creativeProhibitedCreativePairingAdd: CreativeSuccess;
  creativeProhibitedCreativePairingByTagAdd: CreativeSuccess;
  creativeProhibitedCreativePairingByTagRemove: CreativeSuccess;
  creativeProhibitedCreativePairingRemove: CreativeSuccess;
  creativePurposeArchive: CreativePurposeArchiveResult;
  creativePurposeCreate: CreativePurposeCreateResult;
  creativePurposeEdit: CreativePurposeEditResult;
  creativePurposeUnarchive: CreativePurposeUnarchiveResult;
  creativePurposeUpdate: CreativeSuccess;
  creativeReject: CreativeSuccess;
  creativeRename: CreativeRenameResult;
  creativeResetSidneySession: CreativeSuccess;
  creativeReuseRuleUpdate: CreativeReuseRuleUpdateResult;
  creativeRevertToDraft: CreativeSuccess;
  creativeSavedViewCreate: CreativeSavedViewCreateResponse;
  creativeSavedViewDelete: CreativeSavedViewUpdateOrDeleteResponse;
  creativeSavedViewUpdate: CreativeSavedViewUpdateOrDeleteResponse;
  creativeSegmentComparisonExport: ExportResponse;
  creativeSelectAttributeUpdate: CreativeSuccess;
  creativeSelectTemplateTagUpdate: CreativeSuccess;
  creativeSelectTrackingParameterUpdate: CreativeSuccess;
  creativeSubjectLineArchive: CreativeSuccess;
  creativeSubjectLineCreate: CreativeSuccess;
  creativeSubjectLinePrefixUpdate: CreativeSuccess;
  creativeSubjectLineRemove: CreativeSuccess;
  creativeSubjectLineRestore: CreativeSuccess;
  creativeSubjectLineSuffixUpdate: CreativeSuccess;
  creativeSubjectLineUpdate: CreativeSuccess;
  creativeSubjectLinesReorder: CreativeSuccess;
  creativeSyncToEsp: CreativeSuccess;
  creativeTagCreate: CreativeSuccess;
  creativeTagDelete: CreativeSuccess;
  creativeTemplateTagClear: CreativeSuccess;
  creativeTemplateTagHtmlBundleCreate: CreativeSuccess;
  creativeTextAttributeUpdate: CreativeSuccess;
  creativeTextTemplateTagUpdate: CreativeSuccess;
  creativeTextTrackingParameterUpdate: CreativeSuccess;
  creativeTreatmentComparisonExport: ExportResponse;
  creativeUnarchive: CreativeSuccess;
  creativeUrlTemplateTagUpdate: CreativeSuccess;
  creativesMetricsExport: ExportResponse;
  creativesMultiGroupedMetricsExport: ExportResponse;
  creativesProof: Ok;
  currentUserAcknowledgeCampaignV2Intro: CurrentUserAcknowledgeCampaignV2Intro;
  customEventCategoryAttachCesTag: CustomEventCategoryAttachTagResult;
  customEventCategoryAttachTag: CustomEventCategoryAttachTagResult;
  customEventCategoryCreate: InkDavinciEventsV1CustomEventCategoryCreateResponse;
  customEventCategoryDelete: CustomEventCategoryDeleteResult;
  customEventCategoryDetachCesTag: CustomEventCategoryDetachTagResult;
  customEventCategoryDetachTag: CustomEventCategoryDetachTagResult;
  customEventCategoryUpdate: InkDavinciEventsV1CustomEventCategoryUpdateResponse;
  customEventImportJobCreate: CustomEventImportJobType;
  customEventImportJobCreateV2: CustomEventCategoryImportJobResult;
  dataConnectionCreate: DataConnectionCreate;
  dataConnectionDelete: DataConnectionDelete;
  dataConnectionHealthcheck: DataConnectionHealthcheck;
  dataConnectionStreamSchema: DataConnectionStreamSchema;
  dataConnectionStreams: DataConnectionStreams;
  dataConnectionTestExternalSftpServer: DataConnectionTestSftpServer;
  dataConnectionUpdate: DataConnectionUpdateSuccess;
  dataEncryptionConfigUpdate: DataEncryptionConfigUpdate;
  dataEncryptionConnectionPgpKeyAttach: DataEncryptionConnectionPgpKeyAttachResult;
  dataEncryptionConnectionPgpKeyUnattach: DataEncryptionConnectionPgpKeyUnattachResult;
  dataEncryptionPgpKeyCreate: DataEncryptionPgpKeyCreateResult;
  dataEncryptionPgpKeyDelete: DataEncryptionPgpKeyDeleteResult;
  dataEncryptionPgpKeyUpdate: DataEncryptionPgpKeyUpdateResult;
  dataFieldCreate: DataFieldSuccess;
  dataFieldDelete: DataFieldDeleteSuccess;
  dataFieldUpdate: DataFieldSuccess;
  dataJobArchive: InkDavinciDataV2JobArchiveResponse;
  dataJobCreate: InkDavinciDataV2JobCreateResponse;
  dataJobDelete: DataJobDeleteSuccess;
  dataJobPause: InkDavinciDataV2JobPauseResponse;
  dataJobResume: InkDavinciDataV2JobResumeResponse;
  dataJobRunArchive: InkDavinciDataV2JobRunArchiveResponse;
  dataJobRunCancel: InkDavinciDataV2JobRunCancelResponse;
  dataJobRunResume: InkDavinciDataV2JobRunResumeResponse;
  dataRelationsCreate: InkDavinciDataV1RelationCreateResponse;
  dataRelationsDelete: DataRelationDeleteSuccess;
  dataSubjectRequestCreate: DataSubjectRequestCreateSuccess;
  dataSubjectRequestsBatchCreate: DataSubjectRequestsBatchCreateSuccess;
  dataTableCreate: DataTableCreateSuccess;
  dataTableDelete: DataTableDeleteSuccess;
  dataTableQuery: InkDavinciDataV1TableQueryResponse;
  dataTableUpdate: DataTableUpdateSuccess;
  dataTagCreate: InkDavinciDataV1TagCreateResponse;
  dataTagDelete: DataTagDeleteSuccess;
  dataTagUpdate: InkDavinciDataV1TagUpdateResponse;
  datasetCreate: InkDataV1DatasetCreateResponse;
  datasetCreateFromModel: InkDataV1DatasetModelCreateResponse;
  datasetDelete: DatasetDeleteSuccess;
  deleteRecurringExportReminder: RecurringExportReminderDeleteResponse;
  deleteSavedFilter: SavedFilterDeleteResponse;
  detectImageUrlContentType: ImageUrlContentTypeResult;
  disclaimerLayoutClear: CreativeSuccess;
  disclaimerLayoutSave: DisclaimerLayoutUpdateSuccess;
  disclaimerStudioCampaignImport: DisclaimerImportSuccess;
  emailVersionSendContactCreate: EmailVersionSendContactCreate;
  emailVersionSendContactDelete: EmailVersionSendContactDelete;
  emailVersionSendCreate: EmailVersionSendCreate;
  emailVersionSendDelete: EmailVersionSendDelete;
  emailVersionSendDeliver: EmailVersionSendDeliver;
  experience2ContactCount: Experience2ContactCountSuccess;
  experience2Create: Experience2CreateResult;
  experience2Delete: Experience2DeleteResult;
  experience2Update: Experience2Success;
  experimentCampaignsMetricsExport: ExportResponse;
  experimentCreativesMetricsExport: ExportResponse;
  experimentMetricsExport: ExportResponse;
  experimentSegmentsMetricsExport: ExportResponse;
  exportMetrics: ExportResponse;
  feedbackCreate: FeedbackCreate;
  jobCreate: InkDataV1JobCreateResponse;
  jobDelete: JobDeleteSuccess;
  jobPause: InkDataV1JobPauseResponse;
  jobResume: InkDataV1JobResumeResponse;
  jobRunArchive: InkDataV1JobRunArchiveResponse;
  jobRunCancel: InkDataV1JobRunCancelResponse;
  jobRunResume: InkDataV1JobRunResumeResponse;
  journeyCancel: JourneyCancel;
  journeyCreate: JourneyCreate;
  journeyDelete: JourneyDelete;
  journeyPause: JourneyPause;
  journeyPublish: JourneyPublish;
  journeyRename: JourneyRename;
  journeyResume: JourneyResume;
  journeyTrigger: JourneyTrigger;
  journeyUpdate: JourneyUpdateSuccess;
  knockToken: KnockTokenResult;
  layoutComponentArchive: LayoutComponentSuccess;
  layoutComponentDuplicate: LayoutComponentSuccess;
  layoutComponentRename: LayoutComponentSuccess;
  layoutComponentSave: LayoutComponentSuccess;
  layoutPublish: LayoutUpdateSuccess;
  layoutSave: LayoutUpdateSuccess;
  layoutUpgrade: LayoutUpdateSuccess;
  link2Create: Link2Success;
  link2Update: Link2Success;
  /** @deprecated Use linkCreate2 */
  linkCreate: LinkCreate;
  linkCreate2: LinkSuccess;
  /** @deprecated Use new linkCreate2 or linkUpdate2 */
  linkGroupCreate: LinkGroupCreate;
  /** @deprecated Use new linkCreate2 or linkUpdate2 */
  linkGroupCreateLink: LinkGroupCreateLink;
  /** @deprecated Use linkUpdate2 */
  linkUpdate: LinkUpdate;
  linkUpdate2: LinkSuccess;
  mediaCdnUpload: MediaCreate2;
  /** @deprecated Use media_create2 */
  mediaCreate: MediaCreate;
  mediaCreate2: MediaCreate2;
  mediaDelete: MediaDelete;
  /** @deprecated Use media_upload2 */
  mediaUpload: MediaCreate;
  mediaUpload2: MediaCreate2;
  organizationAddOwner: OwnerSuccess;
  organizationCreate: OrganizationCreateSuccess;
  organizationDeactivate: OrganizationSuccess;
  organizationReactivate: OrganizationReactivateSuccess;
  organizationRemoveOwner: OwnerSuccess;
  organizationUpdate: OrganizationUpdateSuccess;
  organizationUserInvite: OrganizationUserInvite;
  organizationUserInviteApprove: OrganizationUserInviteApprove;
  organizationUserInviteCancel: OrganizationUserInviteCancel;
  organizationUserInviteDecline: OrganizationUserInviteDecline;
  organizationUserReactivate: OrganizationUserReactivate;
  organizationUserReinvite: OrganizationUserReinvite;
  organizationUserRemove: OrganizationUserRemove;
  organizationUserRoleAssign: OrganizationUserRoleAssign;
  organizationUserUpdate: OrganizationUserUpdate;
  platformApplicationActivate: ActivatePlatformApplicationSuccess;
  platformApplicationCreate: CreatePlatformApplicationSuccess;
  platformApplicationCreate2: CreatePlatformApplication2Success;
  platformApplicationSuspend: SuspendPlatformApplicationSuccess;
  platformApplicationUpdate: UpdatePlatformApplicationSuccess;
  platformApplicationUpdate2: UpdatePlatformApplication2Success;
  programAudienceExclude: ProgramSuccess;
  programAudienceInclude: ProgramSuccess;
  programAudienceRemove: ProgramSuccess;
  programAudienceReorder: ProgramSuccess;
  programCreate: ProgramCreateResult;
  programCustomFieldAdd: ProgramSuccess;
  programCustomFieldRemove: ProgramSuccess;
  programCustomFieldUpdate: ProgramSuccess;
  programFieldAdd: ProgramSuccess;
  programFieldRemove: ProgramSuccess;
  programFieldUpdate: ProgramSuccess;
  programSeedAudienceAdd: ProgramSuccess;
  programSeedAudienceRemove: ProgramSuccess;
  programSelectTrackingParameterUpdate: ProgramSuccess;
  programStateTransition: ProgramSuccess;
  programTagAdd: ProgramSuccess;
  programTagRemove: ProgramSuccess;
  programTemplateAdd: ProgramSuccess;
  programTextTrackingParameterUpdate: ProgramSuccess;
  programUberTemplateVariationRemove: ProgramSuccess;
  programUpdate: ProgramUpdateResult;
  pushNotificationDelete: Ok;
  pushNotificationSave: PushNotificationSuccess;
  queryCreate: InkDataV1QueryCreateResponse;
  queryDelete: QueryDeleteSuccess;
  querySelectCreate: InkDataV1QuerySelectCreateResponse;
  querySelectDelete: QuerySelectDeleteSuccess;
  querySelectUpdate: InkDataV1QuerySelectUpdateResponse;
  queryUpdate: InkDataV1QueryUpdateResponse;
  quietHourRuleAdd: ProgramSuccess;
  quietHourRuleUpdate: ProgramSuccess;
  quietPeriodRuleAdd: ProgramSuccess;
  quietPeriodRuleUpdate: ProgramSuccess;
  quietRuleRemove: ProgramSuccess;
  recommendationRunCancel: RecommendationRunCancel;
  recommendationRunStart: RecommendationRunStart;
  recurringCampaignAudienceExclude: RecurringCampaignAudienceExcludeResult;
  recurringCampaignAudienceInclude: RecurringCampaignAudienceIncludeResult;
  recurringCampaignAudienceRemove: RecurringCampaignAudienceRemoveResult;
  recurringCampaignAudienceReorder: RecurringCampaignAudienceReorderResult;
  recurringCampaignCheckboxAttributeUpdate: RecurringCampaignCheckboxAttributeUpdateResult;
  recurringCampaignCreate: RecurringCampaignCreateResult;
  recurringCampaignCustomFieldAdd: RecurringCampaignCustomFieldAddResult;
  recurringCampaignCustomFieldRemove: RecurringCampaignCustomFieldRemoveResult;
  recurringCampaignCustomFieldUpdate: RecurringCampaignCustomFieldUpdateResult;
  recurringCampaignDateAttributeUpdate: RecurringCampaignDateAttributeUpdateResult;
  recurringCampaignDelete: RecurringCampaignDeleteResult;
  recurringCampaignDetailsUpdate: RecurringCampaignDetailsUpdateResult;
  recurringCampaignDuplicate: RecurringCampaignDuplicateResult;
  recurringCampaignEmailServiceProviderUpdate: RecurringCampaignEmailServiceProviderUpdateResult;
  recurringCampaignFieldAdd: RecurringCampaignFieldAddResult;
  recurringCampaignFieldRemove: RecurringCampaignFieldRemoveResult;
  recurringCampaignFieldUpdate: RecurringCampaignFieldUpdateResult;
  recurringCampaignListAttributeUpdate: RecurringCampaignListAttributeUpdateResult;
  recurringCampaignMessageAddDynamicBlock: RecurringCampaignMessageAddDynamicBlockResult;
  recurringCampaignMessageDiscard: RecurringCampaignMessageDiscardResult;
  recurringCampaignMessageDynamicBlockExperienceCreate: RecurringCampaignMessageDynamicBlockExperienceCreateResult;
  recurringCampaignMessageExperienceSelectCreative: RecurringCampaignMessageExperienceSelectCreativeResult;
  recurringCampaignMessageInboxPreviewUpdate: RecurringCampaignMessageInboxPreviewUpdateResult;
  recurringCampaignMessageLayoutUpdate: RecurringCampaignMessageLayoutUpdateResult;
  recurringCampaignMessageSave: RecurringCampaignMessageSaveResult;
  recurringCampaignScheduleUpdate: RecurringCampaignScheduleUpdateResult;
  recurringCampaignSeedAudienceAdd: RecurringCampaignSeedAudienceAddResult;
  recurringCampaignSeedAudienceRemove: RecurringCampaignSeedAudienceRemoveResult;
  recurringCampaignSelectAttributeUpdate: RecurringCampaignSelectAttributeUpdateResult;
  recurringCampaignSelectTrackingParameterUpdate: RecurringCampaignSelectTrackingParameterUpdateResult;
  recurringCampaignStateTransition: RecurringCampaignStateTransitionResult;
  recurringCampaignTextAttributeUpdate: RecurringCampaignTextAttributeUpdateResult;
  recurringCampaignTextTrackingParameterUpdate: RecurringCampaignTextTrackingParameterUpdateResult;
  revokeCredential: CredentialRevokeSuccess;
  segmentExperimentMetricsExport: ExportResponse;
  segmentGroupCampaignMetricsExport: ExportResponse;
  segmentGroupCreativeMetricsExport: ExportResponse;
  segmentGroupsMetricsExport: ExportResponse;
  sendSupportTicket: SendSupportTicket;
  studioAuthorizationComplete: Scalars['Boolean']['output'];
  studioCampaignImport: ImportSuccess;
  subjectlinesMetricsExport: ExportResponse;
  textMessageDelete: Ok;
  textMessageSave: TextMessageSuccess;
  trackingTokenCreate: TrackingTokenCreate;
  trackingTokenDelete: TrackingTokenDelete;
  trackingTokenRename: TrackingTokenRename;
  triggeredCampaignAudienceExclude: TriggeredCampaignAudienceExcludeResult;
  triggeredCampaignAudienceInclude: TriggeredCampaignAudienceIncludeResult;
  triggeredCampaignAudienceRemove: TriggeredCampaignAudienceRemoveResult;
  triggeredCampaignAudienceReorder: TriggeredCampaignAudienceReorderResult;
  triggeredCampaignCheckboxAttributeUpdate: TriggeredCampaignCheckboxAttributeUpdateResult;
  triggeredCampaignCreate: TriggeredCampaignCreateResult;
  triggeredCampaignCustomFieldAdd: TriggeredCampaignCustomFieldAddResult;
  triggeredCampaignCustomFieldRemove: TriggeredCampaignCustomFieldRemoveResult;
  triggeredCampaignCustomFieldUpdate: TriggeredCampaignCustomFieldUpdateResult;
  triggeredCampaignDateAttributeUpdate: TriggeredCampaignDateAttributeUpdateResult;
  triggeredCampaignDelete: TriggeredCampaignDeleteResult;
  triggeredCampaignDetailsUpdate: TriggeredCampaignDetailsUpdateResult;
  triggeredCampaignEmailServiceProviderUpdate: TriggeredCampaignEmailServiceProviderUpdateResult;
  triggeredCampaignListAttributeUpdate: TriggeredCampaignListAttributeUpdateResult;
  triggeredCampaignMessageAddDynamicBlock: TriggeredCampaignMessageAddDynamicBlockResult;
  triggeredCampaignMessageDiscard: TriggeredCampaignMessageDiscardResult;
  triggeredCampaignMessageDynamicBlockExperienceCreate: TriggeredCampaignMessageDynamicBlockExperienceCreateResult;
  triggeredCampaignMessageExperienceSelectCreative: TriggeredCampaignMessageExperienceSelectCreativeResult;
  triggeredCampaignMessageInboxPreviewUpdate: TriggeredCampaignMessageInboxPreviewUpdateResult;
  triggeredCampaignMessageLayoutUpdate: TriggeredCampaignMessageLayoutUpdateResult;
  triggeredCampaignMessageSave: TriggeredCampaignMessageSaveResult;
  triggeredCampaignReEntryCriteriaUpdate: TriggeredCampaignReEntryCriteriaUpdateResult;
  triggeredCampaignSeedAudienceAdd: TriggeredCampaignSeedAudienceAddResult;
  triggeredCampaignSeedAudienceRemove: TriggeredCampaignSeedAudienceRemoveResult;
  triggeredCampaignSelectAttributeUpdate: TriggeredCampaignSelectAttributeUpdateResult;
  triggeredCampaignSelectTrackingParameterUpdate: TriggeredCampaignSelectTrackingParameterUpdateResult;
  triggeredCampaignStateTransition: TriggeredCampaignStateTransitionResult;
  triggeredCampaignTextAttributeUpdate: TriggeredCampaignTextAttributeUpdateResult;
  triggeredCampaignTextTrackingParameterUpdate: TriggeredCampaignTextTrackingParameterUpdateResult;
  triggeredCampaignTriggerRuleUpdate: TriggeredCampaignTriggerRuleUpdateResult;
  uberTemplateVariationContentblockAdd: ProgramSuccess;
  uberTemplateVariationContentblockPriorityUpdate: ProgramSuccess;
  uberTemplateVariationContentblockRemove: UberTemplateVariationContentblockRemoveResult;
  uberTemplateVariationPrimaryContentblockUpdate: ProgramSuccess;
  updateAnalyticsDashboardConfig: AnalyticsDashboardConfigUpdateResponse;
  updateLinkDomainAllowlist: ClientUpdateSuccess;
  updateNotificationsSetting: UpdateNotificationsSetting;
  updateRecurringExportReminder: RecurringExportReminderResponse;
  updateSavedFilter: SavedFilterResponse;
  userAccountInviteApprove: AccountUserInvitationAccept2;
  userAccountInviteDecline: AccountUserInvitationDecline;
  userAssignOrganizationRole: UserAssignOrganizationRole;
  userCreate2: UserCreate2;
  userCreateWithRole: UserCreateWithRole;
  userInvitationCancel2: UserInvitationCancel2;
  userInvitationResend2: UserInvitationResend2;
  userRoleCreate2: UserRoleCreate2;
  userRoleDelete2: UserRoleDelete2;
  userSuspend2: UserSuspend;
  userUnsuspend2: UserUnsuspend2;
  userUpdate2: UserUpdate2;
  zetaConfigEmailTagCreate: ZetaConfigUpdateSuccess;
  zetaConfigEmailTagDelete: ZetaConfigUpdateSuccess;
  zetaConfigEmailTagUpdate: ZetaConfigUpdateSuccess;
};


export type MutationAccountCreateArgs = {
  displayName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationAccountDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAccountReactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAccountRoleCreateArgs = {
  accountId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationAccountRoleDeleteArgs = {
  accountRoleId: Scalars['ID']['input'];
  replacementAccountRoleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAccountRolePermissionsAddArgs = {
  accountRoleId: Scalars['ID']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};


export type MutationAccountRolePermissionsRemoveArgs = {
  accountRoleId: Scalars['ID']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};


export type MutationAccountRoleUpdateArgs = {
  accountRoleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationAccountUpdateArgs = {
  allowlistedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAccountUserAddArgs = {
  accountId: Scalars['ID']['input'];
  accountRoleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserAssignRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserBulkCreateArgs = {
  accountId: Scalars['ID']['input'];
  emailAddresses: Array<Scalars['String']['input']>;
};


export type MutationAccountUserBulkCreateWithRolesArgs = {
  accountId: Scalars['ID']['input'];
  emailAddresses: Array<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};


export type MutationAccountUserInvitationAccept2Args = {
  accountId: Scalars['ID']['input'];
};


export type MutationAccountUserInvitationDeclineArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationAccountUserInviteArgs = {
  accountId: Scalars['ID']['input'];
  accountRoleId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAccountUserInviteCancelArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserReactivateArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserReinviteArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserRemoveArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserRoleCreate2Args = {
  accountId: Scalars['ID']['input'];
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserRoleDelete2Args = {
  accountId: Scalars['ID']['input'];
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserSuspend2Args = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserSwitchRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAccountUserUnassignRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdobeCampaignConfigDeliveryNatureUpdateArgs = {
  availableDeliveryNatureId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAdobeCampaignConfigDeliveryVariableCreateArgs = {
  availableDeliveryVariableId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationAdobeCampaignConfigDeliveryVariableDeleteArgs = {
  deliveryVariableId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdobeCampaignConfigDeliveryVariableUpdateArgs = {
  availableDeliveryVariableId: Scalars['ID']['input'];
  deliveryVariableId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationAlertRuleCreateArgs = {
  criteria: Array<AlertCriterionInput>;
  eligibility: Array<AlertEligibilityInput>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationAlertRuleDeleteArgs = {
  ruleHashid: Scalars['String']['input'];
};


export type MutationAlertRuleModifyArgs = {
  criteria?: InputMaybe<Array<AlertCriterionInput>>;
  eligibility?: InputMaybe<Array<AlertEligibilityInput>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  ruleHashid: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAlertRuleSubscribeArgs = {
  channel: Scalars['String']['input'];
  ruleHashid: Scalars['String']['input'];
};


export type MutationAlertRuleUnsubscribeArgs = {
  channel: Scalars['String']['input'];
  ruleHashid: Scalars['String']['input'];
};


export type MutationAmazonSesConfigEmailTagCreateArgs = {
  availableEmailTagId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationAmazonSesConfigEmailTagDeleteArgs = {
  emailTagId: Scalars['ID']['input'];
};


export type MutationAmazonSesConfigEmailTagUpdateArgs = {
  availableEmailTagId: Scalars['ID']['input'];
  emailTagId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationAnalyticsConfigurationUpdateArgs = {
  analyticsAttributionWindow?: InputMaybe<AnalyticsAttributionWindow>;
  analyticsCalendar?: InputMaybe<AnalyticsCalendar>;
  analyticsCurrency?: InputMaybe<AnalyticsCurrency>;
  analyticsExportDecimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  analyticsExportRateFormat?: InputMaybe<AnalyticsExportRateFormat>;
  analyticsRevenueCap?: InputMaybe<Scalars['Float']['input']>;
  analyticsRevenueCapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  analyticsShowProjectedMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  analyticsStatSigThreshold?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAnalyticsKpiEventSelectionsReplaceArgs = {
  selections: Array<AnalyticsKpiEventSelectionInput>;
};


export type MutationAnalyticsV2CampaignExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  groupBy?: InputMaybe<CampaignGroupBy>;
};


export type MutationAnalyticsV2CampaignSegmentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  segmentGroupId: Scalars['ID']['input'];
};


export type MutationAnalyticsV2CampaignTreatmentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  experimentId: Scalars['ID']['input'];
  filters: Array<AnalyticsFilterInput>;
};


export type MutationAnalyticsV2CreativeExperimentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  creativeId: Scalars['ID']['input'];
  dateRange: Scalars['DateRange']['input'];
};


export type MutationAnalyticsV2CreativeExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  groupBy?: InputMaybe<CreativeGroupBy>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAnalyticsV2CreativeSegmentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  segmentGroupId: Scalars['ID']['input'];
};


export type MutationAnalyticsV2CreativeTreatmentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  experimentId: Scalars['ID']['input'];
  filters: Array<AnalyticsFilterInput>;
};


export type MutationAnalyticsV2ExperimentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  experimentId?: InputMaybe<Scalars['ID']['input']>;
  filters: Array<AnalyticsFilterInput>;
};


export type MutationAnalyticsV2SegmentExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  segmentGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAnalyticsV2SubjectlineExportArgs = {
  columns: Array<Scalars['String']['input']>;
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
};


export type MutationAudienceCreateArgs = {
  defaultType?: InputMaybe<AudienceType>;
  title: Scalars['String']['input'];
  types: Array<AudienceType>;
};


export type MutationAudienceDuplicateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAudienceGroupCreateArgs = {
  title: Scalars['String']['input'];
};


export type MutationAudienceGroupUpdateArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAudienceUpdateArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  defaultType?: InputMaybe<AudienceType>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<AudienceType>>;
};


export type MutationBaseTemplateUpdateArgs = {
  baseTemplateId: Scalars['ID']['input'];
  sections: Array<BaseTemplateSectionInput>;
};


export type MutationBlackholeConfigClientErrorRateUpdateArgs = {
  clientErrorRate: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
};


export type MutationBlackholeConfigEmitSentEventsUpdateArgs = {
  emitSentEvents: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationBlackholeConfigEmitTelemetryUpdateArgs = {
  emitTelemetry: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationBlackholeConfigEmitWebhooksUpdateArgs = {
  emitWebhooks: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationBlackholeConfigLatencyMsUpdateArgs = {
  id: Scalars['ID']['input'];
  latencyMs: Scalars['Int']['input'];
};


export type MutationBlackholeConfigPrintToStdoutUpdateArgs = {
  id: Scalars['ID']['input'];
  printToStdout: Scalars['Boolean']['input'];
};


export type MutationBlackholeConfigServerErrorRateUpdateArgs = {
  id: Scalars['ID']['input'];
  serverErrorRate: Scalars['Float']['input'];
};


export type MutationBlackholeConfigWebhookEndpointIdUpdateArgs = {
  id: Scalars['ID']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationBlackholeConfigWebhookEndpointTokenUpdateArgs = {
  id: Scalars['ID']['input'];
  webhookEndpointToken: Scalars['String']['input'];
};


export type MutationBlockArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBlockDuplicateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBlockRenameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationBlockSaveArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  document: Scalars['LayoutDocument']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBrandKitCreateArgs = {
  input: BrandKitCreateInput;
};


export type MutationBrandKitDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBrandKitGenerationCreateArgs = {
  input: BrandKitGenerationCreateInput;
};


export type MutationBrandKitGenerationUpdateStatusArgs = {
  input: BrandKitGenerationUpdateStatusInput;
};


export type MutationBrandKitUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBrandKitUpdate2Args = {
  id: Scalars['ID']['input'];
  input: BrandKitCreateInput;
};


export type MutationCampaignAcousticCampaignConfigFromAddressUpdateArgs = {
  fromAddressId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAcousticCampaignConfigFromNameUpdateArgs = {
  fromNameId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAcousticCampaignConfigPreprocessingHoursUpdateArgs = {
  id: Scalars['ID']['input'];
  preprocessingHours: Scalars['Int']['input'];
};


export type MutationCampaignAcousticCampaignConfigPreprocessingUpdateArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignAcousticCampaignConfigReplyToUpdateArgs = {
  id: Scalars['ID']['input'];
  replyToId: Scalars['ID']['input'];
};


export type MutationCampaignAddExperimentGroupArgs = {
  experimentGroupId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAddToRecommendationRunArgs = {
  id: Scalars['ID']['input'];
  runType: RecommendationRunType;
};


export type MutationCampaignAdobeCampaignConfigDeliveryCodeUpdateArgs = {
  deliveryCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAdobeCampaignConfigFromAddressUpdateArgs = {
  fromAddress: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAdobeCampaignConfigFromNameUpdateArgs = {
  fromName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAdobeCampaignConfigLabelUpdateArgs = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};


export type MutationCampaignAdobeCampaignConfigReplyToAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  replyToAddress: Scalars['String']['input'];
};


export type MutationCampaignAdobeCampaignConfigReplyToNameUpdateArgs = {
  id: Scalars['ID']['input'];
  replyToName: Scalars['String']['input'];
};


export type MutationCampaignAdobeCampaignConfigRoutingIdUpdateArgs = {
  id: Scalars['ID']['input'];
  routingId: Scalars['Int']['input'];
};


export type MutationCampaignAdobeCampaignConfigTargetMappingIdUpdateArgs = {
  id: Scalars['ID']['input'];
  targetMappingId: Scalars['Int']['input'];
};


export type MutationCampaignAdobeCampaignConfigTypologyIdUpdateArgs = {
  id: Scalars['ID']['input'];
  typologyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCampaignAdobeCampaignConfigWebAnalyticsAccountUpdateArgs = {
  id: Scalars['ID']['input'];
  webAnalyticsAccount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCampaignApproveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceCreateArgs = {
  audienceGroupId?: InputMaybe<Scalars['ID']['input']>;
  audienceId: Scalars['ID']['input'];
  audienceType?: InputMaybe<CampaignAudienceType>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceDeleteArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceDelete2Args = {
  audienceId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceGroupCreateArgs = {
  campaignId: Scalars['ID']['input'];
  predefinedAudienceGroupId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignAudienceGroupDeleteArgs = {
  audienceGroupId: Scalars['ID']['input'];
};


export type MutationCampaignAudienceGroupDelete2Args = {
  audienceGroupId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceGroupPriorityUpdateArgs = {
  audienceGroupIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceGroupRenameArgs = {
  audienceGroupId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCampaignAudiencePriorityUpdateArgs = {
  audienceType: CampaignAudienceType;
  audiences: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignAudienceUpdateArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newAudienceId: Scalars['ID']['input'];
};


export type MutationCampaignAutoCreativeInclusionEnableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignCancelApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignCheckboxAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  checked: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignCordialConfigExcludeAudienceAddArgs = {
  excludeAudienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignCordialConfigExcludeAudienceRemoveArgs = {
  excludeAudienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignCordialConfigFromDescriptionUpdateArgs = {
  fromDescription: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignCordialConfigFromEmailUpdateArgs = {
  fromEmail: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignCordialConfigReplyEmailUpdateArgs = {
  id: Scalars['ID']['input'];
  replyEmail: Scalars['String']['input'];
};


export type MutationCampaignCordialConfigSendPropertyCreate2Args = {
  defaultPropertyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationCampaignCordialConfigSendPropertyDeleteArgs = {
  sendPropertyId: Scalars['ID']['input'];
};


export type MutationCampaignCordialConfigSendPropertyUpdate2Args = {
  defaultPropertyId?: InputMaybe<Scalars['ID']['input']>;
  sendPropertyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationCampaignCordialConfigSenderProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  senderProfileId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignCordialConfigTagsUpdateArgs = {
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type MutationCampaignCreateArgs = {
  channel?: InputMaybe<Channel>;
  sendDate: Scalars['Date']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
  withContactAudiences?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCampaignCustomFieldAddArgs = {
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
};


export type MutationCampaignCustomFieldRemoveArgs = {
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
};


export type MutationCampaignCustomFieldUpdateArgs = {
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
  metadata: CampaignCustomFieldMetadataInput;
};


export type MutationCampaignDateAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCampaignDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignDetailsUpdateArgs = {
  id: Scalars['ID']['input'];
  sendDate?: InputMaybe<Scalars['Date']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignDisableAutoSchedulingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignDuplicateArgs = {
  id: Scalars['ID']['input'];
  sendDate?: InputMaybe<Scalars['Date']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  withContactAudiences?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCampaignDynamicPreheaderAndPreviewUpdateArgs = {
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignDynamicSubjectLinePrefixUpdateArgs = {
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignDynamicSubjectLineSuffixUpdateArgs = {
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignDynamicSubjectLineUpdateArgs = {
  id: Scalars['ID']['input'];
  sectionIds: Array<Scalars['ID']['input']>;
};


export type MutationCampaignEmailServiceProviderUpdateArgs = {
  emailServiceProviderId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignEnableAutoSchedulingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignEpsilonConfigFromAddressUpdateArgs = {
  fromAddressId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignEpsilonConfigFromNameUpdateArgs = {
  fromNameId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignEpsilonConfigReplyToUpdateArgs = {
  id: Scalars['ID']['input'];
  replyToId: Scalars['ID']['input'];
};


export type MutationCampaignExperience2AttachAllCreativesArgs = {
  filter?: InputMaybe<Experience2CreativeFilterInput>;
  id: Scalars['ID']['input'];
  recsSettings?: InputMaybe<Experience2RecsSettings>;
  sectionId: Scalars['ID']['input'];
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  targetRuleset: Array<TargetRuleInput>;
  visibility: Experience2Visibility;
};


export type MutationCampaignExperience2AttachCreativesArgs = {
  creativeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  mode?: InputMaybe<Experience2Mode>;
  recsSettings?: InputMaybe<Experience2RecsSettings>;
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput>;
  visibility?: InputMaybe<Experience2Visibility>;
};


export type MutationCampaignExperience2AutoIncludeCreativesArgs = {
  creativeTagIds: Array<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput>;
  visibility: Experience2Visibility;
};


export type MutationCampaignExperience2DeleteArgs = {
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignExperience2DetachAllArgs = {
  filter?: InputMaybe<Experience2CreativeFilterInput>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  targetRuleset: Array<TargetRuleInput>;
};


export type MutationCampaignExperience2DetachCreativesArgs = {
  creativeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput>;
};


export type MutationCampaignExperience2SectionResetArgs = {
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperience2UpdateNameArgs = {
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignExperience2UpdateVisibilityArgs = {
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  recsSettings?: InputMaybe<Experience2RecsSettings>;
  visibility: Experience2Visibility;
};


export type MutationCampaignExperienceAttachAllCreativesArgs = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput;
  filter?: InputMaybe<CreativeFilterInput>;
  id: Scalars['ID']['input'];
  includeDraft?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceAttachAllCreatives2Args = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput2;
  filter?: InputMaybe<CreativeFilterInput>;
  id: Scalars['ID']['input'];
  includeDraft?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceAttachCreativesArgs = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput;
  creativeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceAttachCreatives2Args = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput2;
  creativeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceDeleteArgs = {
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignExperienceDeleteAllArgs = {
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceDetachAllCreativesArgs = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput;
  filter?: InputMaybe<CreativeFilterInput>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceDetachAllCreatives2Args = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput2;
  filter?: InputMaybe<CreativeFilterInput>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceDetachCreativesArgs = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput;
  creativeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceDetachCreatives2Args = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput2;
  creativeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceMergeArgs = {
  audienceCombination: AudienceCombinationInput;
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceResetArgs = {
  audienceCombination: AudienceCombinationInput;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceSetHiddenArgs = {
  audienceCombination: AudienceCombinationInput;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperienceUpdateArgs = {
  audienceCombination: AudienceCombinationInput;
  blockConfiguration: BlockConfigurationInput2;
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignExperiences2AttachAllCreativesArgs = {
  experienceId: Scalars['ID']['input'];
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
};


export type MutationCampaignExperiences2AttachCreativesArgs = {
  creativeIds: Array<Scalars['ID']['input']>;
  experienceId: Scalars['ID']['input'];
};


export type MutationCampaignExperiences2BlockResetArgs = {
  blockId: Scalars['ID']['input'];
};


export type MutationCampaignExperiences2CreateArgs = {
  blockId: Scalars['ID']['input'];
  recsSettings: Experience2RecsSettings;
  targetRuleset: Array<TargetRuleInput>;
  visibility: Experience2Visibility;
};


export type MutationCampaignExperiences2DeleteArgs = {
  experienceId: Scalars['ID']['input'];
};


export type MutationCampaignExperiences2DetachAllCreativesArgs = {
  experienceId: Scalars['ID']['input'];
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
};


export type MutationCampaignExperiences2DetachCreativesArgs = {
  creativeIds: Array<Scalars['ID']['input']>;
  experienceId: Scalars['ID']['input'];
};


export type MutationCampaignExperiences2UpdateAutoIncludeArgs = {
  enabled: Scalars['Boolean']['input'];
  experienceId: Scalars['ID']['input'];
};


export type MutationCampaignExperiences2UpdateNameArgs = {
  experienceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCampaignExperiences2UpdateRecsSettingsArgs = {
  experienceId: Scalars['ID']['input'];
  recsSettings: Experience2RecsSettings;
};


export type MutationCampaignExperiences2UpdateVisibilityArgs = {
  experienceId: Scalars['ID']['input'];
  visibility: Experience2Visibility;
};


export type MutationCampaignExperimentCreateArgs = {
  experimentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignExperimentDeleteArgs = {
  experimentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignFieldCreateArgs = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
};


export type MutationCampaignFieldDeleteArgs = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignFieldUpdateArgs = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newFieldId?: InputMaybe<Scalars['ID']['input']>;
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
};


export type MutationCampaignListAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};


export type MutationCampaignLockForProofingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignMarkAsPreparedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignMessageExtraCreateArgs = {
  campaignId: Scalars['ID']['input'];
  messageExtraKeyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationCampaignMessageExtraDeleteArgs = {
  messageExtraId: Scalars['ID']['input'];
};


export type MutationCampaignMessageExtraUpdateArgs = {
  messageExtraId: Scalars['ID']['input'];
  messageExtraKeyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationCampaignOracleResponsysConfigAdditionalDataSourceAddArgs = {
  additionalDataSourceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigAdditionalDataSourceRemoveArgs = {
  additionalDataSourceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigFromEmailUpdateArgs = {
  fromEmailId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigFromNameUpdateArgs = {
  fromNameId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigMarketingProgramUpdateArgs = {
  id: Scalars['ID']['input'];
  marketingProgramId: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigMarketingStrategyUpdateArgs = {
  id: Scalars['ID']['input'];
  marketingStrategyId: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigProfileListUpdateArgs = {
  id: Scalars['ID']['input'];
  profileListId: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigReplyToUpdateArgs = {
  id: Scalars['ID']['input'];
  replyToId: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigSelectCampaignVariableUpdateArgs = {
  campaignVariableId: Scalars['ID']['input'];
  choiceId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigSelectExternalTrackingParameterUpdateArgs = {
  externalTrackingParamId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignOracleResponsysConfigSuppressionListAddArgs = {
  id: Scalars['ID']['input'];
  suppressionId: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigSuppressionListRemoveArgs = {
  id: Scalars['ID']['input'];
  suppressionId: Scalars['ID']['input'];
};


export type MutationCampaignOracleResponsysConfigTextCampaignVariableUpdateArgs = {
  campaignVariableId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignOracleResponsysConfigTextExternalTrackingParameterUpdateArgs = {
  externalTrackingParamId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignPersadoSubjectlineUpdateArgs = {
  id: Scalars['ID']['input'];
  persadoCampaignInput: PersadoCampaignInput;
};


export type MutationCampaignPersonalizedSendScheduleUpdateArgs = {
  datetimeRanges?: InputMaybe<Array<Scalars['DateTimeRange']['input']>>;
  id: Scalars['ID']['input'];
  treatmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignPickupChangesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignPreheaderAndPreviewModeUpdateArgs = {
  id: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
};


export type MutationCampaignPushSettingsUpdateArgs = {
  campaignId: Scalars['ID']['input'];
  expirationTimeSeconds: Scalars['Int']['input'];
};


export type MutationCampaignResumeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignRevertToDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignSalesforceMarketingCloudConfigDelayedDeliveryUpdateArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCampaignSalesforceMarketingCloudConfigSendClassificationUpdateArgs = {
  id: Scalars['ID']['input'];
  sendClassificationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignSalesforceMarketingCloudConfigSendLoggingUpdateArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateArgs = {
  id: Scalars['ID']['input'];
  sendLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCampaignSalesforceMarketingCloudConfigSenderProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  senderProfileId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignSalesforceMarketingCloudConfigSuppressionDataExtensionAddArgs = {
  id: Scalars['ID']['input'];
  suppressionDataExtensionId: Scalars['ID']['input'];
};


export type MutationCampaignSalesforceMarketingCloudConfigSuppressionDataExtensionRemoveArgs = {
  id: Scalars['ID']['input'];
  suppressionDataExtensionId: Scalars['ID']['input'];
};


export type MutationCampaignSalesforceMarketingCloudPrebuildDurationUpdateArgs = {
  id: Scalars['ID']['input'];
  prebuildDuration: Scalars['Float']['input'];
};


export type MutationCampaignSalesforceMarketingCloudPublicationListUpdateArgs = {
  id: Scalars['ID']['input'];
  publicationListId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignSavedViewCreateArgs = {
  columns: Array<Scalars['String']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filters?: InputMaybe<Array<SavedViewFilterInput>>;
  groupBy?: InputMaybe<CampaignGroupBy>;
  isDefault: Scalars['Boolean']['input'];
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  title: Scalars['String']['input'];
};


export type MutationCampaignSavedViewDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignSavedViewUpdateArgs = {
  columns: Array<Scalars['String']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filters?: InputMaybe<Array<SavedViewFilterInput>>;
  groupBy?: InputMaybe<CampaignGroupBy>;
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  title: Scalars['String']['input'];
};


export type MutationCampaignScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignSectionAddArgs = {
  campaignId: Scalars['ID']['input'];
  contentBlockId: Scalars['ID']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCampaignSectionPrimaryUpdateArgs = {
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignSectionPriorityUpdateArgs = {
  id: Scalars['ID']['input'];
  sectionIds: Array<Scalars['ID']['input']>;
};


export type MutationCampaignSectionRemoveArgs = {
  campaignId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignSectionRemove2Args = {
  campaignId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['ID']['input'];
};


export type MutationCampaignSeedAudienceAddArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignSeedAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignSegmentComparisonExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SegmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCampaignSelectAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignSelectTrackingParameterUpdateArgs = {
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
  trackingParameterId: Scalars['ID']['input'];
};


export type MutationCampaignSendDateUpdateArgs = {
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignSendDatetimeUpdateArgs = {
  id: Scalars['ID']['input'];
  sendDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  sendDatetimeRanges?: InputMaybe<Array<Scalars['DateTimeRange']['input']>>;
  sendDatetimeType: SendDatetimeType;
  treatmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignSendProofsArgs = {
  emails: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  numVariants?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCampaignSetFeatureFlagExperiences2Args = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCampaignSetFrequencyModelArgs = {
  frequencyModel: FrequencyModel;
  id: Scalars['ID']['input'];
};


export type MutationCampaignStaticPreheaderAndPreviewLinkUpdateArgs = {
  id: Scalars['ID']['input'];
  linkGroupId: Scalars['ID']['input'];
};


export type MutationCampaignStaticPreheaderAndPreviewUpdateArgs = {
  config: StaticPreheaderAndPreview;
  id: Scalars['ID']['input'];
};


export type MutationCampaignStaticSendScheduleUpdateArgs = {
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  treatmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCampaignStaticSubjectLinePrefixUpdateArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationCampaignStaticSubjectLineSuffixUpdateArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationCampaignStaticSubjectLineUpdateArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationCampaignSubjectLineModeUpdateArgs = {
  id: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
};


export type MutationCampaignSubjectLinePrefixModeUpdateArgs = {
  id: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
};


export type MutationCampaignSubjectLineStrategyUpdateArgs = {
  id: Scalars['ID']['input'];
  strategy: SubjectLineStrategy;
  treatmentId: Scalars['ID']['input'];
};


export type MutationCampaignSubjectLineSuffixModeUpdateArgs = {
  id: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
};


export type MutationCampaignSuspendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignTagCreateArgs = {
  id: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationCampaignTagDeleteArgs = {
  id: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationCampaignTemplateSaveArgs = {
  campaignId: Scalars['ID']['input'];
  sections: Array<CampaignTemplateSectionInput>;
};


export type MutationCampaignTemplateUpdateArgs = {
  id: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationCampaignTerminateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignTextAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignTextTrackingParameterUpdateArgs = {
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCampaignTitleUpdateArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCampaignTreatmentComparisonExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: TreatmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCampaignUnscheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCampaignsMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: CampaignMetricsFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationClientUserUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContactAudienceAnalyticsTrackingArgs = {
  analyticsTracking: ContactAudienceAnalyticsTracking;
  id: Scalars['ID']['input'];
};


export type MutationContactAudienceArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContactAudienceAutoBuildArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
};


export type MutationContactAudienceConfigRemoveArgs = {
  campaignId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  contactAudienceConfigId: Scalars['ID']['input'];
};


export type MutationContactAudienceCreateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  experimentInput?: InputMaybe<ContactAudienceExperimentAudienceInput>;
  name: Scalars['String']['input'];
  overrides?: InputMaybe<Array<InputMaybe<ContactAudienceOverrideInput>>>;
  query: Scalars['ContactQuery']['input'];
  splits?: InputMaybe<Array<InputMaybe<ContactAudienceSplitInput>>>;
};


export type MutationContactAudienceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContactAudienceExcludeArgs = {
  campaignId: Scalars['ID']['input'];
  contactAudienceId: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']>;
  unselectedSplits: Array<Scalars['ID']['input']>;
};


export type MutationContactAudienceIncludeArgs = {
  campaignId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  contactAudienceId: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']>;
  unselectedSplits: Array<Scalars['ID']['input']>;
};


export type MutationContactAudienceReorderArgs = {
  campaignId: Scalars['ID']['input'];
  contactAudienceIds: Array<Scalars['ID']['input']>;
};


export type MutationContactAudienceUpdateArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  experimentUpdateInput?: InputMaybe<ContactAudienceExperimentAudienceUpdateInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Array<InputMaybe<ContactAudienceOverrideUpdateInput>>>;
  query?: InputMaybe<Scalars['ContactQuery']['input']>;
  splits?: InputMaybe<Array<InputMaybe<ContactAudienceSplitUpdateInput>>>;
};


export type MutationContactSegmentCreateArgs = {
  name: Scalars['String']['input'];
  query: Scalars['ContactQuery']['input'];
  segmentGroupId: Scalars['ID']['input'];
};


export type MutationContactSegmentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContactSegmentGroupArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContactSegmentGroupAutoSegmentCreateArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationContactSegmentGroupCreateArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationContactSegmentGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContactSegmentGroupPriorityUpdateArgs = {
  id: Scalars['ID']['input'];
  segmentPriorities: Array<ContactSegmentGroupPriorityInput>;
};


export type MutationContactSegmentGroupUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContactSegmentGroupStatus>;
};


export type MutationContactSegmentUpdateArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  query: Scalars['ContactQuery']['input'];
};


export type MutationContactSnapshotCountArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  channelV2: Channel;
  excludeAudiences: Array<ContactSnapshotAudienceInput>;
  includeAudiences: Array<ContactSnapshotAudienceInput>;
};


export type MutationContentVariantAvailabilitiesCreateArgs = {
  availabilityRange: Scalars['DateTimeRange']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationContentVariantCreateArgs = {
  creativeId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
  variantTagsInput: VariantTagsInput;
};


export type MutationCreateCredentialArgs = {
  applicationId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  metaData?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRecurringExportReminderArgs = {
  attachCsv?: InputMaybe<Scalars['Boolean']['input']>;
  columns: Array<Scalars['String']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filterData: Scalars['JSONString']['input'];
  groupBy?: InputMaybe<CampaignGroupBy>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  recipients: Array<Scalars['String']['input']>;
  schedule: ReminderScheduleInput;
  title: Scalars['String']['input'];
  viewType: ViewType;
};


export type MutationCreateSavedFilterArgs = {
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filterData: Scalars['JSONString']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  title: Scalars['String']['input'];
  viewType: ViewType;
};


export type MutationCreateVariableArgs = {
  input: CreateVariableInput;
};


export type MutationCreativeApproveArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeArchiveArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeAvailabilitiesUpdateArgs = {
  availabilities?: InputMaybe<Array<Scalars['DateTimeRange']['input']>>;
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeCheckboxTemplateTagUpdateArgs = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativeCreateArgs = {
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};


export type MutationCreativeDateTemplateTagUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativeDeleteArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeDisableReuseRulesUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  disableReuseRules: Scalars['Boolean']['input'];
};


export type MutationCreativeDisclaimerUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  disclaimer: Scalars['String']['input'];
};


export type MutationCreativeDuplicateArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeExpireArgs = {
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: CreativeFilter;
};


export type MutationCreativeFiltersAddArgs = {
  audienceId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
  splitId: Scalars['ID']['input'];
};


export type MutationCreativeFiltersRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
  splitId: Scalars['ID']['input'];
};


export type MutationCreativeImageTemplateTagUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  image?: InputMaybe<ImageContentInput>;
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativeLegacyFilterAddArgs = {
  audienceId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeLegacyFilterRemoveArgs = {
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeMultiSelectTemplateTagUpdateArgs = {
  choiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativePairedCreativeAddArgs = {
  creativeId: Scalars['ID']['input'];
  pairedCreativeId: Scalars['ID']['input'];
};


export type MutationCreativePairedCreativeByTagAddArgs = {
  creativeId: Scalars['ID']['input'];
  pairedTagId: Scalars['ID']['input'];
};


export type MutationCreativePairedCreativeByTagRemoveArgs = {
  creativeId: Scalars['ID']['input'];
  pairedTagId: Scalars['ID']['input'];
};


export type MutationCreativePairedCreativeRemoveArgs = {
  creativeId: Scalars['ID']['input'];
  pairedCreativeId: Scalars['ID']['input'];
};


export type MutationCreativePersadoCampaignUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  persadoCampaignInput?: InputMaybe<PersadoCampaignInput>;
};


export type MutationCreativePreheaderAndPreviewUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  preheaderLinkId?: InputMaybe<Scalars['ID']['input']>;
  preheaderText?: InputMaybe<Scalars['String']['input']>;
  previewText?: InputMaybe<Scalars['String']['input']>;
  usePreheaderTextAsPreviewText?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreativeProhibitedCreativePairingAddArgs = {
  creativeId: Scalars['ID']['input'];
  prohibitedCreativeId: Scalars['ID']['input'];
};


export type MutationCreativeProhibitedCreativePairingByTagAddArgs = {
  creativeId: Scalars['ID']['input'];
  prohibitedTagId: Scalars['ID']['input'];
};


export type MutationCreativeProhibitedCreativePairingByTagRemoveArgs = {
  creativeId: Scalars['ID']['input'];
  prohibitedTagId: Scalars['ID']['input'];
};


export type MutationCreativeProhibitedCreativePairingRemoveArgs = {
  creativeId: Scalars['ID']['input'];
  prohibitedCreativeId: Scalars['ID']['input'];
};


export type MutationCreativePurposeArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreativePurposeCreateArgs = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreativePurposeEditArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreativePurposeUnarchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreativePurposeUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  purposeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreativeRejectArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeRenameArgs = {
  creativeId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreativeResetSidneySessionArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeReuseRuleUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  reuseRule: ReuseRuleInput;
};


export type MutationCreativeRevertToDraftArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeSavedViewCreateArgs = {
  columns: Array<Scalars['String']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filters?: InputMaybe<Array<SavedViewFilterInput>>;
  groupBy?: InputMaybe<CreativeGroupBy>;
  isDefault: Scalars['Boolean']['input'];
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  title: Scalars['String']['input'];
};


export type MutationCreativeSavedViewDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreativeSavedViewUpdateArgs = {
  columns: Array<Scalars['String']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filters?: InputMaybe<Array<SavedViewFilterInput>>;
  groupBy?: InputMaybe<CreativeGroupBy>;
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  title: Scalars['String']['input'];
};


export type MutationCreativeSegmentComparisonExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SegmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreativeSelectAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  choiceId?: InputMaybe<Scalars['ID']['input']>;
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeSelectTemplateTagUpdateArgs = {
  choiceId?: InputMaybe<Scalars['ID']['input']>;
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativeSelectTrackingParameterUpdateArgs = {
  choiceId?: InputMaybe<Scalars['ID']['input']>;
  creativeId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
};


export type MutationCreativeSubjectLineArchiveArgs = {
  subjectLineId: Scalars['ID']['input'];
};


export type MutationCreativeSubjectLineCreateArgs = {
  content: Scalars['String']['input'];
  creativeId: Scalars['ID']['input'];
  isPrimary: Scalars['Boolean']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreativeSubjectLinePrefixUpdateArgs = {
  content: Scalars['String']['input'];
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeSubjectLineRemoveArgs = {
  subjectLineId: Scalars['ID']['input'];
};


export type MutationCreativeSubjectLineRestoreArgs = {
  subjectLineId: Scalars['ID']['input'];
};


export type MutationCreativeSubjectLineSuffixUpdateArgs = {
  content: Scalars['String']['input'];
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeSubjectLineUpdateArgs = {
  content: Scalars['String']['input'];
  isPrimary: Scalars['Boolean']['input'];
  subjectLineId: Scalars['ID']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreativeSubjectLinesReorderArgs = {
  creativeId: Scalars['ID']['input'];
  subjectLineIds: Array<Scalars['ID']['input']>;
};


export type MutationCreativeSyncToEspArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeTagCreateArgs = {
  creativeId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationCreativeTagDeleteArgs = {
  creativeId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationCreativeTemplateTagClearArgs = {
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativeTemplateTagHtmlBundleCreateArgs = {
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreativeTextAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  creativeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationCreativeTextTemplateTagUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreativeTextTrackingParameterUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  trackingParameterId: Scalars['ID']['input'];
};


export type MutationCreativeTreatmentComparisonExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: TreatmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreativeUnarchiveArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationCreativeUrlTemplateTagUpdateArgs = {
  creativeId: Scalars['ID']['input'];
  linkId?: InputMaybe<Scalars['ID']['input']>;
  templateTagId: Scalars['ID']['input'];
};


export type MutationCreativesMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: CreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreativesMultiGroupedMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: CreativeMetricsFilter;
  groupBy: Array<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreativesProofArgs = {
  channel?: InputMaybe<Channel>;
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeIds: Array<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCustomEventCategoryAttachCesTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomEventCategoryAttachTagArgs = {
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCustomEventCategoryCreateArgs = {
  attributionType?: InputMaybe<AttributionType>;
  contactIdentifierFieldId?: InputMaybe<Scalars['ID']['input']>;
  hasSubidentifier?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  timestampType?: InputMaybe<TimestampType>;
};


export type MutationCustomEventCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomEventCategoryDetachCesTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomEventCategoryDetachTagArgs = {
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCustomEventCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCustomEventImportJobCreateArgs = {
  columns: Array<DataImportJobColumnInput>;
  customEventCategoryId: Scalars['Int']['input'];
  jobDescription: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query?: InputMaybe<Scalars['DataQuery']['input']>;
  resource: DataJobResource;
  schedule?: InputMaybe<DataJobScheduleInput>;
};


export type MutationCustomEventImportJobCreateV2Args = {
  columns: Array<DataImportJobColumnInput>;
  customEventCategoryId: Scalars['ID']['input'];
  jobDescription: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query?: InputMaybe<Scalars['DataQuery']['input']>;
  resource: DataJobResource;
  schedule?: InputMaybe<DataJobScheduleInput>;
};


export type MutationDataConnectionCreateArgs = {
  externalGcsBucket?: InputMaybe<DataConnectionExternalGcsBucketInput>;
  externalS3Bucket?: InputMaybe<DataConnectionExternalS3BucketInput>;
  externalSftpServer?: InputMaybe<DataConnectionExternalSftpServerInput>;
  hostedGcsBucket?: InputMaybe<DataConnectionHostedGcsBucketInput>;
  hostedSftpServer?: InputMaybe<DataConnectionHostedSftpServerInput>;
  name: Scalars['String']['input'];
};


export type MutationDataConnectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataConnectionHealthcheckArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataConnectionStreamSchemaArgs = {
  id: Scalars['ID']['input'];
  streamUri: Scalars['String']['input'];
};


export type MutationDataConnectionStreamsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataConnectionTestExternalSftpServerArgs = {
  directory: Scalars['String']['input'];
  host: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDataConnectionUpdateArgs = {
  externalGcsBucket?: InputMaybe<DataConnectionExternalGcsBucketInput>;
  externalS3Bucket?: InputMaybe<DataConnectionExternalS3BucketInput>;
  externalSftpServer?: InputMaybe<DataConnectionExternalSftpServerInput>;
  hostedGcsBucket?: InputMaybe<DataConnectionHostedGcsBucketInput>;
  hostedSftpServer?: InputMaybe<DataConnectionHostedSftpServerInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDataEncryptionConfigUpdateArgs = {
  gpgPublicKey: Scalars['String']['input'];
};


export type MutationDataEncryptionConnectionPgpKeyAttachArgs = {
  connectionId: Scalars['String']['input'];
  pgpKeyId: Scalars['String']['input'];
};


export type MutationDataEncryptionConnectionPgpKeyUnattachArgs = {
  connectionId: Scalars['String']['input'];
  pgpKeyId: Scalars['String']['input'];
};


export type MutationDataEncryptionPgpKeyCreateArgs = {
  decryptKey?: InputMaybe<DataEncryptionPgpDecryptKeyInput>;
  encryptKey?: InputMaybe<DataEncryptionPgpEncryptKeyInput>;
  name: Scalars['String']['input'];
};


export type MutationDataEncryptionPgpKeyDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDataEncryptionPgpKeyUpdateArgs = {
  decryptKey?: InputMaybe<DataEncryptionPgpDecryptKeyInput>;
  encryptKey?: InputMaybe<DataEncryptionPgpEncryptKeyInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDataFieldCreateArgs = {
  channelsV2?: InputMaybe<Array<Channel>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryKey: Scalars['Boolean']['input'];
  semanticFeature?: InputMaybe<Scalars['ID']['input']>;
  tableId: Scalars['ID']['input'];
  type: DataFieldType;
};


export type MutationDataFieldDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataFieldUpdateArgs = {
  channelsV2?: InputMaybe<Array<Channel>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  semanticFeature?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DataFieldType>;
};


export type MutationDataJobArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataJobCreateArgs = {
  config: DataJobConfig;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<DataJobScheduleInput>;
};


export type MutationDataJobDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataJobPauseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataJobResumeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataJobRunArchiveArgs = {
  jobRunId: Scalars['ID']['input'];
};


export type MutationDataJobRunCancelArgs = {
  jobRunId: Scalars['ID']['input'];
};


export type MutationDataJobRunResumeArgs = {
  jobRunId: Scalars['ID']['input'];
};


export type MutationDataRelationsCreateArgs = {
  relatedFieldId: Scalars['ID']['input'];
  sourceFieldId: Scalars['ID']['input'];
};


export type MutationDataRelationsDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataSubjectRequestCreateArgs = {
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};


export type MutationDataSubjectRequestsBatchCreateArgs = {
  requests: Array<DsrInput>;
};


export type MutationDataTableCreateArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rowTtlDays?: InputMaybe<Scalars['Int']['input']>;
  semanticCategory?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDataTableDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataTableQueryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataTableUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rowTtlDays?: InputMaybe<Scalars['Int']['input']>;
  semanticCategory?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDataTagCreateArgs = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  tableId: Scalars['ID']['input'];
};


export type MutationDataTagDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDataTagUpdateArgs = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDatasetCreateArgs = {
  description: Scalars['String']['input'];
  fields: Array<InkDataV1DatasetCreateRequestFieldSpecInput>;
  name: Scalars['String']['input'];
  storageType: Scalars['String']['input'];
};


export type MutationDatasetCreateFromModelArgs = {
  modelId: Scalars['ID']['input'];
};


export type MutationDatasetDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRecurringExportReminderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSavedFilterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDetectImageUrlContentTypeArgs = {
  url: Scalars['String']['input'];
};


export type MutationDisclaimerLayoutClearArgs = {
  creativeId: Scalars['ID']['input'];
};


export type MutationDisclaimerLayoutSaveArgs = {
  creativeId: Scalars['ID']['input'];
  document: Scalars['LayoutDocument']['input'];
};


export type MutationDisclaimerStudioCampaignImportArgs = {
  creativeId: Scalars['ID']['input'];
  studioBlockIds: Array<Scalars['ID']['input']>;
  studioCampaignId: Scalars['ID']['input'];
};


export type MutationEmailVersionSendContactCreateArgs = {
  campaignId: Scalars['ID']['input'];
  channel?: InputMaybe<Channel>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  contactGroupId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  contactType: EmailVersionSendContactType;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEmailVersionSendContactDeleteArgs = {
  campaignId: Scalars['ID']['input'];
  emailVersionSendContactId: Scalars['ID']['input'];
};


export type MutationEmailVersionSendCreateArgs = {
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audienceSplitIds?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>>>;
  campaignId: Scalars['ID']['input'];
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  emailId: Scalars['String']['input'];
  preheaderTextContains?: InputMaybe<Scalars['String']['input']>;
  previewTextContains?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['Int']['input']>;
  subjectlineContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectlinePrefixContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineSuffixContains?: InputMaybe<Scalars['String']['input']>;
  treatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationEmailVersionSendDeleteArgs = {
  emailVersionSendId: Scalars['ID']['input'];
};


export type MutationEmailVersionSendDeliverArgs = {
  campaignId: Scalars['ID']['input'];
  proofLabel?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['Int']['input']>;
  sendFormat: EmailVersionSendFormatType;
};


export type MutationExperience2ContactCountArgs = {
  experienceId: Scalars['ID']['input'];
};


export type MutationExperience2CreateArgs = {
  excludedCreativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  location: Experience2CampaignLocation;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility: Experience2Visibility;
};


export type MutationExperience2DeleteArgs = {
  experienceId: Scalars['ID']['input'];
};


export type MutationExperience2UpdateArgs = {
  excludedCreativeIds: Array<Scalars['ID']['input']>;
  excludedTagIds: Array<Scalars['ID']['input']>;
  experienceId: Scalars['ID']['input'];
  includedTagIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  visibility: Experience2Visibility;
};


export type MutationExperimentCampaignsMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: ExperimentCampaignMetricsFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExperimentCreativesMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: ExperimentCreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExperimentMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: ExperimentMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExperimentSegmentsMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: ExperimentSegmentsMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExportMetricsArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: MetricsExportFilterInput;
  groupBy?: InputMaybe<Array<MetricsGroupBy>>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFeedbackCreateArgs = {
  feedback: Scalars['String']['input'];
  kind?: InputMaybe<FeedbackKind>;
  priority?: InputMaybe<FeedbackPriority>;
  url: Scalars['String']['input'];
};


export type MutationJobCreateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<InkDataV1JobScheduleInput>;
  spec: InkDataV1JobSpecInput;
};


export type MutationJobDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJobPauseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJobResumeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJobRunArchiveArgs = {
  jobRunId: Scalars['ID']['input'];
};


export type MutationJobRunCancelArgs = {
  jobRunId: Scalars['ID']['input'];
};


export type MutationJobRunResumeArgs = {
  jobRunId: Scalars['ID']['input'];
};


export type MutationJourneyCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJourneyCreateArgs = {
  config?: InputMaybe<JourneyConfigInput>;
  configJson?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  namespaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationJourneyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJourneyPauseArgs = {
  abortRunningContacts: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationJourneyPublishArgs = {
  config?: InputMaybe<JourneyConfigInput>;
  configJson?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  namespaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationJourneyRenameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationJourneyResumeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJourneyTriggerArgs = {
  journeyId: Scalars['ID']['input'];
  payload: Scalars['String']['input'];
};


export type MutationJourneyUpdateArgs = {
  config?: InputMaybe<JourneyConfigInput>;
  configJson?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  namespaceId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<JourneyStatus>;
};


export type MutationLayoutComponentArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLayoutComponentDuplicateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLayoutComponentRenameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationLayoutComponentSaveArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  document: Scalars['LayoutDocument']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLayoutPublishArgs = {
  creativeId: Scalars['ID']['input'];
  document: Scalars['LayoutDocument']['input'];
  templateTagId: Scalars['ID']['input'];
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLayoutSaveArgs = {
  creativeId: Scalars['ID']['input'];
  document: Scalars['LayoutDocument']['input'];
  templateTagId: Scalars['ID']['input'];
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLayoutUpgradeArgs = {
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
};


export type MutationLink2CreateArgs = {
  enableConversionTracking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTracking?: InputMaybe<Scalars['Boolean']['input']>;
  linkMetadata?: InputMaybe<LinkMetadataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  queryStringParameters: Array<Array<Scalars['String']['input']>>;
  trackingParameters?: InputMaybe<Array<TrackingParameterInput>>;
  url: Scalars['String']['input'];
};


export type MutationLink2UpdateArgs = {
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  linkMetadata?: InputMaybe<LinkMetadataInput>;
  queryStringParameters: Array<Array<Scalars['String']['input']>>;
  trackingParameters?: InputMaybe<Array<TrackingParameterInput>>;
  url: Scalars['String']['input'];
};


export type MutationLinkCreateArgs = {
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput>;
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput>;
  queryStringParameters?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  salesforceMetadata?: InputMaybe<LinkSalesForceMarketingCloudMetadataInput>;
  url: Scalars['String']['input'];
};


export type MutationLinkCreate2Args = {
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput2>;
  adobeCampaignMetadata?: InputMaybe<LinkAdobeCampaignMetadataInput2>;
  adobeJourneyOptimizerMetadata?: InputMaybe<LinkAdobeJourneyOptimizerMetadataInput2>;
  amazonSesMetadata?: InputMaybe<LinkAmazonSesMetadataInput2>;
  bluecoreMetadata?: InputMaybe<LinkBluecoreMetadataInput2>;
  brazeMetadata?: InputMaybe<LinkBrazeMetadataInput2>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput2>;
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput2>;
  linkGroupName?: InputMaybe<Scalars['String']['input']>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput2>;
  queryStringParameters: Array<Array<Scalars['String']['input']>>;
  salesforceMetadata?: InputMaybe<LinkSalesforceMarketingCloudMetadataInput2>;
  trackingParameters?: InputMaybe<Array<TrackingParameterInput>>;
  url: Scalars['String']['input'];
  zetaMetadata?: InputMaybe<LinkZetaMetadataInput2>;
};


export type MutationLinkGroupCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationLinkGroupCreateLinkArgs = {
  linkGroupId: Scalars['ID']['input'];
};


export type MutationLinkUpdateArgs = {
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput>;
  enableConversionTracking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTracking?: InputMaybe<Scalars['Boolean']['input']>;
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput>;
  id: Scalars['ID']['input'];
  linkGroupId?: InputMaybe<Scalars['ID']['input']>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput>;
  queryStringParameters?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  salesforceMetadata?: InputMaybe<LinkSalesForceMarketingCloudMetadataInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLinkUpdate2Args = {
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput2>;
  adobeCampaignMetadata?: InputMaybe<LinkAdobeCampaignMetadataInput2>;
  adobeJourneyOptimizerMetadata?: InputMaybe<LinkAdobeJourneyOptimizerMetadataInput2>;
  amazonSesMetadata?: InputMaybe<LinkAmazonSesMetadataInput2>;
  bluecoreMetadata?: InputMaybe<LinkBluecoreMetadataInput2>;
  brazeMetadata?: InputMaybe<LinkBrazeMetadataInput2>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput2>;
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput2>;
  id: Scalars['ID']['input'];
  linkGroupName?: InputMaybe<Scalars['String']['input']>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput2>;
  queryStringParameters: Array<Array<Scalars['String']['input']>>;
  salesforceMetadata?: InputMaybe<LinkSalesforceMarketingCloudMetadataInput2>;
  trackingParameters?: InputMaybe<Array<TrackingParameterInput>>;
  url: Scalars['String']['input'];
  zetaMetadata?: InputMaybe<LinkZetaMetadataInput2>;
};


export type MutationMediaCdnUploadArgs = {
  existingMediaId?: InputMaybe<Scalars['ID']['input']>;
  image: Scalars['Upload']['input'];
};


export type MutationMediaCreateArgs = {
  externalUrl: Scalars['String']['input'];
};


export type MutationMediaCreate2Args = {
  externalUrl: Scalars['String']['input'];
};


export type MutationMediaDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationMediaUploadArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationMediaUpload2Args = {
  image: Scalars['Upload']['input'];
};


export type MutationOrganizationAddOwnerArgs = {
  userIdentifier: UserIdentifierInput;
};


export type MutationOrganizationCreateArgs = {
  allowlistedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  authConnection?: InputMaybe<Scalars['String']['input']>;
  enableMfa?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type MutationOrganizationDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganizationReactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganizationRemoveOwnerArgs = {
  userIdentifier: UserIdentifierInput;
};


export type MutationOrganizationUpdateArgs = {
  allowlistedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  authConnection?: InputMaybe<Scalars['String']['input']>;
  enableMfa?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganizationUserInviteArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountRoleId?: InputMaybe<Scalars['ID']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUserInviteApproveArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserInviteCancelArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserInviteDeclineArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserReactivateArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserReinviteArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserRemoveArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserRoleAssignArgs = {
  organizationRoleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationOrganizationUserUpdateArgs = {
  accountRoles: Array<AccountRoleWithRequiredRoleInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationPlatformApplicationActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformApplicationCreateArgs = {
  input: CreatePlatformApplicationInput;
};


export type MutationPlatformApplicationCreate2Args = {
  input: CreatePlatformApplication2Input;
};


export type MutationPlatformApplicationSuspendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformApplicationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformApplicationInput;
};


export type MutationPlatformApplicationUpdate2Args = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformApplication2Input;
};


export type MutationProgramAudienceExcludeArgs = {
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramAudienceIncludeArgs = {
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  selected: Array<Scalars['ID']['input']>;
  unselected: Array<Scalars['ID']['input']>;
};


export type MutationProgramAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramAudienceReorderArgs = {
  audienceIds: Array<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
};


export type MutationProgramCreateArgs = {
  description: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProgramCustomFieldAddArgs = {
  customFieldId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramCustomFieldRemoveArgs = {
  customFieldId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramCustomFieldUpdateArgs = {
  customFieldId: Scalars['ID']['input'];
  metadata: CustomFieldMetadataInput;
  programId: Scalars['ID']['input'];
};


export type MutationProgramFieldAddArgs = {
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
  programId: Scalars['ID']['input'];
};


export type MutationProgramFieldRemoveArgs = {
  fieldId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramFieldUpdateArgs = {
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
  programId: Scalars['ID']['input'];
};


export type MutationProgramSeedAudienceAddArgs = {
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramSeedAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationProgramSelectTrackingParameterUpdateArgs = {
  optionId?: InputMaybe<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
};


export type MutationProgramStateTransitionArgs = {
  programId: Scalars['ID']['input'];
  state: ProgramStateType;
};


export type MutationProgramTagAddArgs = {
  programId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationProgramTagRemoveArgs = {
  programId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationProgramTemplateAddArgs = {
  programId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProgramTextTrackingParameterUpdateArgs = {
  programId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProgramUberTemplateVariationRemoveArgs = {
  programId: Scalars['ID']['input'];
  variationId: Scalars['ID']['input'];
};


export type MutationProgramUpdateArgs = {
  description: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  programId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationPushNotificationDeleteArgs = {
  pushNotificationId: Scalars['ID']['input'];
};


export type MutationPushNotificationSaveArgs = {
  creativeId: Scalars['ID']['input'];
  input: PushNotificationInput;
};


export type MutationQueryCreateArgs = {
  query: Scalars['InkQLQuery']['input'];
};


export type MutationQueryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationQuerySelectCreateArgs = {
  querySelect: Scalars['InkQLQuerySelect']['input'];
};


export type MutationQuerySelectDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationQuerySelectUpdateArgs = {
  id: Scalars['ID']['input'];
  querySelect: Scalars['InkQLQuerySelect']['input'];
};


export type MutationQueryUpdateArgs = {
  id: Scalars['ID']['input'];
  query: Scalars['InkQLQuery']['input'];
};


export type MutationQuietHourRuleAddArgs = {
  daysOfWeek: Array<DaysOfWeek>;
  endTime: Scalars['Time']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  startTime: Scalars['Time']['input'];
};


export type MutationQuietHourRuleUpdateArgs = {
  daysOfWeek: Array<DaysOfWeek>;
  endTime: Scalars['Time']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
  startTime: Scalars['Time']['input'];
};


export type MutationQuietPeriodRuleAddArgs = {
  endDatetime: Scalars['DateTime']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  startDatetime: Scalars['DateTime']['input'];
};


export type MutationQuietPeriodRuleUpdateArgs = {
  endDatetime: Scalars['DateTime']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
  startDatetime: Scalars['DateTime']['input'];
};


export type MutationQuietRuleRemoveArgs = {
  programId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
};


export type MutationRecommendationRunCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecommendationRunStartArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignAudienceExcludeArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignAudienceIncludeArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']>;
  unselectedSplits: Array<Scalars['ID']['input']>;
};


export type MutationRecurringCampaignAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignAudienceReorderArgs = {
  audienceIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignCheckboxAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  checked: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignCreateArgs = {
  channel: Channel;
  startDate: Scalars['Date']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};


export type MutationRecurringCampaignCustomFieldAddArgs = {
  customFieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignCustomFieldRemoveArgs = {
  customFieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignCustomFieldUpdateArgs = {
  customFieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecurringCampaignDateAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationRecurringCampaignDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignDetailsUpdateArgs = {
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecurringCampaignDuplicateArgs = {
  id: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};


export type MutationRecurringCampaignEmailServiceProviderUpdateArgs = {
  emailServiceProviderId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignFieldAddArgs = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
};


export type MutationRecurringCampaignFieldRemoveArgs = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignFieldUpdateArgs = {
  fieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newFieldId?: InputMaybe<Scalars['ID']['input']>;
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
};


export type MutationRecurringCampaignListAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};


export type MutationRecurringCampaignMessageAddDynamicBlockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignMessageDiscardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignMessageDynamicBlockExperienceCreateArgs = {
  blockId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignMessageExperienceSelectCreativeArgs = {
  creativeId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignMessageInboxPreviewUpdateArgs = {
  id: Scalars['ID']['input'];
  input: RecurringCampaignMessageInboxPreviewUpdateInput;
};


export type MutationRecurringCampaignMessageLayoutUpdateArgs = {
  document: Scalars['RecurringCampaignMessageLayoutDocument']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignMessageSaveArgs = {
  document?: InputMaybe<Scalars['RecurringCampaignMessageLayoutDocument']['input']>;
  id: Scalars['ID']['input'];
  inboxPreview?: InputMaybe<RecurringCampaignMessageInboxPreviewUpdateInput>;
};


export type MutationRecurringCampaignScheduleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: RecurringCampaignScheduleUpdateInput;
};


export type MutationRecurringCampaignSeedAudienceAddArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignSeedAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecurringCampaignSelectAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRecurringCampaignSelectTrackingParameterUpdateArgs = {
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
  trackingParameterId: Scalars['ID']['input'];
};


export type MutationRecurringCampaignStateTransitionArgs = {
  id: Scalars['ID']['input'];
  state: RecurringCampaignStatus;
};


export type MutationRecurringCampaignTextAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecurringCampaignTextTrackingParameterUpdateArgs = {
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeCredentialArgs = {
  applicationId: Scalars['ID']['input'];
  credentialId: Scalars['ID']['input'];
};


export type MutationSegmentExperimentMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SegmentExperimentMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSegmentGroupCampaignMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SegmentGroupCampaignMetricsFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSegmentGroupCreativeMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SegmentGroupCreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSegmentGroupsMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SegmentGroupMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendSupportTicketArgs = {
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};


export type MutationStudioAuthorizationCompleteArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationStudioCampaignImportArgs = {
  creativeId: Scalars['ID']['input'];
  studioBlockIds: Array<Scalars['ID']['input']>;
  studioCampaignId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
};


export type MutationSubjectlinesMetricsExportArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: SubjectLineMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationTextMessageDeleteArgs = {
  textMessageId: Scalars['ID']['input'];
};


export type MutationTextMessageSaveArgs = {
  channel: Scalars['String']['input'];
  creativeId: Scalars['ID']['input'];
  input: TextMessageInput;
};


export type MutationTrackingTokenCreateArgs = {
  mode: TrackingTokenMode;
  name: Scalars['String']['input'];
};


export type MutationTrackingTokenDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTrackingTokenRenameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationTriggeredCampaignAudienceExcludeArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignAudienceIncludeArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']>;
  unselectedSplits: Array<Scalars['ID']['input']>;
};


export type MutationTriggeredCampaignAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignAudienceReorderArgs = {
  audienceIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignCheckboxAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  checked: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignCreateArgs = {
  channel: Channel;
  journeyId?: InputMaybe<Scalars['String']['input']>;
  journeyNodeId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  triggerRule?: InputMaybe<Scalars['JSONString']['input']>;
  triggerSource: TriggerSource;
};


export type MutationTriggeredCampaignCustomFieldAddArgs = {
  customFieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignCustomFieldRemoveArgs = {
  customFieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignCustomFieldUpdateArgs = {
  customFieldId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggeredCampaignDateAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationTriggeredCampaignDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignDetailsUpdateArgs = {
  id: Scalars['ID']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggeredCampaignEmailServiceProviderUpdateArgs = {
  emailServiceProviderId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignListAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};


export type MutationTriggeredCampaignMessageAddDynamicBlockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignMessageDiscardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignMessageDynamicBlockExperienceCreateArgs = {
  blockId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignMessageExperienceSelectCreativeArgs = {
  creativeId: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignMessageInboxPreviewUpdateArgs = {
  id: Scalars['ID']['input'];
  input: TriggeredCampaignMessageInboxPreviewUpdateInput;
};


export type MutationTriggeredCampaignMessageLayoutUpdateArgs = {
  document: Scalars['TriggeredCampaignMessageLayoutDocument']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignMessageSaveArgs = {
  document?: InputMaybe<Scalars['TriggeredCampaignMessageLayoutDocument']['input']>;
  id: Scalars['ID']['input'];
  inboxPreview?: InputMaybe<TriggeredCampaignMessageInboxPreviewUpdateInput>;
};


export type MutationTriggeredCampaignReEntryCriteriaUpdateArgs = {
  id: Scalars['ID']['input'];
  reEntryCriteria: TriggeredCampaignReEntryCriteria;
};


export type MutationTriggeredCampaignSeedAudienceAddArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignSeedAudienceRemoveArgs = {
  audienceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignSelectAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationTriggeredCampaignSelectTrackingParameterUpdateArgs = {
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
  trackingParameterId: Scalars['ID']['input'];
};


export type MutationTriggeredCampaignStateTransitionArgs = {
  id: Scalars['ID']['input'];
  state: TriggeredCampaignStatus;
};


export type MutationTriggeredCampaignTextAttributeUpdateArgs = {
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggeredCampaignTextTrackingParameterUpdateArgs = {
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggeredCampaignTriggerRuleUpdateArgs = {
  id: Scalars['ID']['input'];
  triggerRule: Scalars['JSONString']['input'];
};


export type MutationUberTemplateVariationContentblockAddArgs = {
  contentBlockId: Scalars['ID']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  programId: Scalars['ID']['input'];
  variationId: Scalars['ID']['input'];
};


export type MutationUberTemplateVariationContentblockPriorityUpdateArgs = {
  programId: Scalars['ID']['input'];
  uberTemplateContentBlockIds: Array<Scalars['ID']['input']>;
  variationId: Scalars['ID']['input'];
};


export type MutationUberTemplateVariationContentblockRemoveArgs = {
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  programId: Scalars['ID']['input'];
  uberTemplateContentBlockId: Scalars['ID']['input'];
};


export type MutationUberTemplateVariationPrimaryContentblockUpdateArgs = {
  programId: Scalars['ID']['input'];
  uberTemplateContentBlockId: Scalars['ID']['input'];
};


export type MutationUpdateAnalyticsDashboardConfigArgs = {
  widgets: Array<AnalyticsWidgetInput>;
};


export type MutationUpdateLinkDomainAllowlistArgs = {
  enforceLinkDomainAllowlist: Scalars['Boolean']['input'];
  linkDomainAllowlist: Array<Scalars['String']['input']>;
};


export type MutationUpdateNotificationsSettingArgs = {
  category: Scalars['String']['input'];
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  event: Scalars['String']['input'];
  inAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timingPreference?: InputMaybe<NotificationTimingPreferenceInput>;
};


export type MutationUpdateRecurringExportReminderArgs = {
  attachCsv?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filterData?: InputMaybe<Scalars['JSONString']['input']>;
  groupBy?: InputMaybe<CampaignGroupBy>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  schedule?: InputMaybe<ReminderScheduleInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
};


export type MutationUpdateSavedFilterArgs = {
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filterData?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserAccountInviteApproveArgs = {
  accountId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
};


export type MutationUserAccountInviteDeclineArgs = {
  accountId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
};


export type MutationUserAssignOrganizationRoleArgs = {
  role: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserCreate2Args = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountRoles?: InputMaybe<Array<AccountRoleInput>>;
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationUserCreateWithRoleArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountRoles?: InputMaybe<Array<AccountRoleWithRequiredRoleInput>>;
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationUserInvitationCancel2Args = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserInvitationResend2Args = {
  userIdentifier: UserIdentifierInput;
};


export type MutationUserRoleCreate2Args = {
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserRoleDelete2Args = {
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserSuspend2Args = {
  userId: Scalars['ID']['input'];
};


export type MutationUserUnsuspend2Args = {
  userId: Scalars['ID']['input'];
};


export type MutationUserUpdate2Args = {
  accountRoles?: InputMaybe<Array<AccountRoleInput>>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};


export type MutationZetaConfigEmailTagCreateArgs = {
  availableEmailTagId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationZetaConfigEmailTagDeleteArgs = {
  emailTagId: Scalars['ID']['input'];
};


export type MutationZetaConfigEmailTagUpdateArgs = {
  availableEmailTagId: Scalars['ID']['input'];
  emailTagId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type NamedMetricSeries = {
  __typename?: 'NamedMetricSeries';
  baselines?: Maybe<Array<MetricValuePoint>>;
  groups?: Maybe<Array<MetricValuePoint>>;
  metric: Scalars['String']['output'];
};

export type NeedsConfirmation = {
  __typename?: 'NeedsConfirmation';
  success: Scalars['Boolean']['output'];
};

export type NeedsConfirmationExpireCreative = {
  __typename?: 'NeedsConfirmationExpireCreative';
  earliestTime?: Maybe<Scalars['DateTime']['output']>;
  latestTime?: Maybe<Scalars['DateTime']['output']>;
  lockedCampaigns?: Maybe<Array<Campaign>>;
  success: Scalars['Boolean']['output'];
};

export type NoContent = {
  __typename?: 'NoContent';
  _: Scalars['Boolean']['output'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type NotificationTimingPreference = {
  __typename?: 'NotificationTimingPreference';
  absoluteTime?: Maybe<Scalars['Time']['output']>;
  daysBefore?: Maybe<Scalars['Int']['output']>;
  excludeWeekends: Scalars['Boolean']['output'];
  hoursBefore?: Maybe<Scalars['Int']['output']>;
};

export type NotificationTimingPreferenceInput = {
  absoluteTime?: InputMaybe<Scalars['Time']['input']>;
  daysBefore?: InputMaybe<Scalars['Int']['input']>;
  excludeWeekends?: InputMaybe<Scalars['Boolean']['input']>;
  hoursBefore?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationsSetting = {
  __typename?: 'NotificationsSetting';
  category: Scalars['String']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  event: Scalars['String']['output'];
  inAppEnabled?: Maybe<Scalars['Boolean']['output']>;
  timingPreference?: Maybe<NotificationTimingPreference>;
};

export type NumberAttribute = Attribute & {
  __typename?: 'NumberAttribute';
  definition: NumberAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type NumberAttributeDefinition = AttributeDefinition & {
  __typename?: 'NumberAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type NumberCustomField = CustomField & {
  __typename?: 'NumberCustomField';
  id: Scalars['ID']['output'];
  /** @deprecated Removed from API */
  overrideMode?: Maybe<OverrideMode>;
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type Ok = {
  __typename?: 'Ok';
  /** @deprecated Standardized on success */
  ok: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type OnlyPreheader = {
  __typename?: 'OnlyPreheader';
  preheader?: Maybe<PreheaderChunk>;
};

export type OnlyPreview = {
  __typename?: 'OnlyPreview';
  preview?: Maybe<PreviewChunk>;
};

/**
 * A comparison operator (e.g., lt, gt). `applicableCategories` declares
 * which metric categories this operator is valid against.
 */
export type OperatorDefType = {
  __typename?: 'OperatorDefType';
  applicableCategories: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type OracleResponsys = {
  __typename?: 'OracleResponsys';
  defaultLinkMetadata?: Maybe<OracleResponsysDefaultLinkMetadata>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  linkCategories: Array<OracleResponsysLinkCategory>;
  requiredLinkMetadataFields: Array<OracleResponsysRequiredLinkMetaDataFields>;
};

export type OracleResponsysDefaultLinkMetadata = {
  __typename?: 'OracleResponsysDefaultLinkMetadata';
  requiresCategory: Scalars['Boolean']['output'];
  requiresName: Scalars['Boolean']['output'];
};

export type OracleResponsysLinkCategory = {
  __typename?: 'OracleResponsysLinkCategory';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum OracleResponsysRequiredLinkMetaDataFields {
  Category = 'CATEGORY',
  Name = 'NAME'
}

/** Represents a customer organization. */
export type Organization = {
  __typename?: 'Organization';
  accountSummaries: Array<AccountSummary>;
  allowlistedDomains: Array<Scalars['String']['output']>;
  authConnection?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivated: Scalars['Boolean']['output'];
  enableMfa: Scalars['Boolean']['output'];
  hasFeature: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  members2: Array<OrganizationUser2>;
  name: Scalars['String']['output'];
  organizationRoles: Array<OrganizationRoleInfo>;
  updatedAt: Scalars['DateTime']['output'];
  user2: OrganizationUser2;
};


/** Represents a customer organization. */
export type OrganizationAccountSummariesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a customer organization. */
export type OrganizationHasFeatureArgs = {
  feature: Scalars['String']['input'];
};


/** Represents a customer organization. */
export type OrganizationMembers2Args = {
  userType?: InputMaybe<UserType>;
};


/** Represents a customer organization. */
export type OrganizationUser2Args = {
  userId: Scalars['ID']['input'];
};

export type OrganizationCreateSuccess = {
  __typename?: 'OrganizationCreateSuccess';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type OrganizationReactivateSuccess = {
  __typename?: 'OrganizationReactivateSuccess';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export enum OrganizationRole {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  User = 'USER'
}

export type OrganizationRoleInfo = {
  __typename?: 'OrganizationRoleInfo';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type OrganizationRolePermissions = {
  __typename?: 'OrganizationRolePermissions';
  permissions: Array<PermissionObject>;
};

export type OrganizationSuccess = {
  __typename?: 'OrganizationSuccess';
  success: Scalars['Boolean']['output'];
};

export type OrganizationUpdateSuccess = {
  __typename?: 'OrganizationUpdateSuccess';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

/** Represents a user within their organization (and all users belong to one and only one organization). */
export type OrganizationUser2 = {
  __typename?: 'OrganizationUser2';
  accountMembers: Array<AccountMember>;
  canDeactivateUser: AuthorizationResult;
  canEditUser: AuthorizationResult;
  canInviteUser: AuthorizationResult;
  canViewUser: AuthorizationResult;
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  organization: Organization;
  organizationAccountMembers: Array<AccountMember>;
  organizationRole?: Maybe<OrganizationRole>;
  organizationRoleInfo?: Maybe<OrganizationRoleInfo>;
  roles: Array<Role>;
  status: MemberStatus;
  userType: UserType;
};

export type OrganizationUserInvite = {
  __typename?: 'OrganizationUserInvite';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserInviteApprove = {
  __typename?: 'OrganizationUserInviteApprove';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserInviteCancel = {
  __typename?: 'OrganizationUserInviteCancel';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserInviteDecline = {
  __typename?: 'OrganizationUserInviteDecline';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserReactivate = {
  __typename?: 'OrganizationUserReactivate';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserReinvite = {
  __typename?: 'OrganizationUserReinvite';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserRemove = {
  __typename?: 'OrganizationUserRemove';
  accountUser?: Maybe<AccountMember>;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserRoleAssign = {
  __typename?: 'OrganizationUserRoleAssign';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserUpdate = {
  __typename?: 'OrganizationUserUpdate';
  results: OrganizationUserUpdateResults;
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type OrganizationUserUpdateResults = {
  __typename?: 'OrganizationUserUpdateResults';
  failedAccountIds: Array<Scalars['String']['output']>;
  successfulAccountIds: Array<Scalars['String']['output']>;
  userUpdateFailed: Scalars['Boolean']['output'];
};

export type Overlapping = {
  __typename?: 'Overlapping';
  id: Scalars['ID']['output'];
  missingAudiences: Array<Maybe<AudienceDescription>>;
  overlappingExperiences: Array<Experience>;
};

export enum OverrideMode {
  Append = 'APPEND',
  Replace = 'REPLACE'
}

export type OwnerSuccess = {
  __typename?: 'OwnerSuccess';
  success: Scalars['Boolean']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedAvailableCreatives = {
  __typename?: 'PaginatedAvailableCreatives';
  available: Scalars['Int']['output'];
  availableDraft: Scalars['Int']['output'];
  included: Scalars['Int']['output'];
  includedApproved: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  results: Array<AvailableCreative>;
  total: Scalars['Int']['output'];
};

export type PastCampaignContentBlocks = {
  __typename?: 'PastCampaignContentBlocks';
  campaigns: Array<CampaignContentBlocks>;
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String']['output'];
  name: PermissionName;
  title: Scalars['String']['output'];
};

export enum PermissionName {
  AccountsCreate = 'ACCOUNTS_CREATE',
  AccountsDelete = 'ACCOUNTS_DELETE',
  AccountsRead = 'ACCOUNTS_READ',
  AccountusersCreate = 'ACCOUNTUSERS_CREATE',
  AccountusersRead = 'ACCOUNTUSERS_READ',
  AccountusersUpdate = 'ACCOUNTUSERS_UPDATE',
  AnalyticsCreate = 'ANALYTICS_CREATE',
  AnalyticsDelete = 'ANALYTICS_DELETE',
  AnalyticsRead = 'ANALYTICS_READ',
  AnalyticsUpdate = 'ANALYTICS_UPDATE',
  AppsCreate = 'APPS_CREATE',
  AppsDelete = 'APPS_DELETE',
  AppsRead = 'APPS_READ',
  AppsUpdate = 'APPS_UPDATE',
  AudienceCreate = 'AUDIENCE_CREATE',
  AudienceDelete = 'AUDIENCE_DELETE',
  AudienceRead = 'AUDIENCE_READ',
  AudienceUpdate = 'AUDIENCE_UPDATE',
  BrandkitCreate = 'BRANDKIT_CREATE',
  BrandkitRead = 'BRANDKIT_READ',
  BrandkitUpdate = 'BRANDKIT_UPDATE',
  CampaignsCreate = 'CAMPAIGNS_CREATE',
  CampaignsDelete = 'CAMPAIGNS_DELETE',
  CampaignsRead = 'CAMPAIGNS_READ',
  CampaignsUpdate = 'CAMPAIGNS_UPDATE',
  CreativesCreate = 'CREATIVES_CREATE',
  CreativesDelete = 'CREATIVES_DELETE',
  CreativesRead = 'CREATIVES_READ',
  CreativesUpdate = 'CREATIVES_UPDATE',
  DataCreate = 'DATA_CREATE',
  DataDelete = 'DATA_DELETE',
  DataRead = 'DATA_READ',
  DataUpdate = 'DATA_UPDATE',
  DsrCreate = 'DSR_CREATE',
  DsrRead = 'DSR_READ',
  NotificationsConfigure = 'NOTIFICATIONS_CONFIGURE',
  RolesCreate = 'ROLES_CREATE',
  RolesDelete = 'ROLES_DELETE',
  RolesRead = 'ROLES_READ',
  RolesUpdate = 'ROLES_UPDATE',
  SettingsCreate = 'SETTINGS_CREATE',
  SettingsRead = 'SETTINGS_READ',
  SettingsUpdate = 'SETTINGS_UPDATE',
  UsersCreate = 'USERS_CREATE',
  UsersRead = 'USERS_READ',
  UsersUpdate = 'USERS_UPDATE',
  UserDetailsRead = 'USER_DETAILS_READ'
}

export type PermissionObject = {
  __typename?: 'PermissionObject';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PersadoCampaign = {
  __typename?: 'PersadoCampaign';
  bodyAmpScript: Scalars['String']['output'];
  externalId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  subjectLineScript: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PersadoCampaignInput = {
  campaignName: Scalars['String']['input'];
  externalId: Scalars['ID']['input'];
};

export type PersadoCampaignItem = {
  __typename?: 'PersadoCampaignItem';
  externalId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type PersadoSubjectLine = {
  __typename?: 'PersadoSubjectLine';
  persadoCampaign?: Maybe<PersadoCampaign>;
};

/** An enumeration. */
export enum Personalization {
  Hidden = 'HIDDEN',
  Personalized = 'PERSONALIZED',
  SameForAll = 'SAME_FOR_ALL'
}

export enum Personalization2 {
  Personalized = 'PERSONALIZED',
  SameForAll = 'SAME_FOR_ALL'
}

export type PersonalizedSendSchedule = {
  __typename?: 'PersonalizedSendSchedule';
  datetimeRanges: Array<Scalars['DateTimeRange']['output']>;
  isFullDay: Scalars['Boolean']['output'];
};

export type PlatformApplication = {
  __typename?: 'PlatformApplication';
  accountSummaries: Array<AccountSummary>;
  accounts: Array<Account2>;
  createdAt: Scalars['DateTime']['output'];
  credentials: Array<Credential>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  requester?: Maybe<OrganizationUser2>;
  scopes: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type PlatformApplicationAccountSummariesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformApplication2 = {
  __typename?: 'PlatformApplication2';
  accountSummaries: Array<AccountSummary>;
  accounts: Array<Account2>;
  createdAt: Scalars['DateTime']['output'];
  credentials: Array<Credential>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  requester?: Maybe<OrganizationUser2>;
  role?: Maybe<ApplicationRole>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type PlatformApplication2AccountSummariesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedAudienceGroupType = {
  __typename?: 'PredefinedAudienceGroupType';
  archived: Scalars['Boolean']['output'];
  audiences: Array<Audience>;
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** Fixed date ranges. */
export enum PredefinedDateRange {
  FiscalLastMonth = 'FISCAL_LAST_MONTH',
  FiscalLastQuarter = 'FISCAL_LAST_QUARTER',
  FiscalLastWeek = 'FISCAL_LAST_WEEK',
  FiscalLastYear = 'FISCAL_LAST_YEAR',
  FiscalThisMonth = 'FISCAL_THIS_MONTH',
  FiscalThisQuarter = 'FISCAL_THIS_QUARTER',
  FiscalThisWeek = 'FISCAL_THIS_WEEK',
  FiscalThisYear = 'FISCAL_THIS_YEAR',
  GregorianLastMonth = 'GREGORIAN_LAST_MONTH',
  GregorianLastQuarter = 'GREGORIAN_LAST_QUARTER',
  GregorianLastWeek = 'GREGORIAN_LAST_WEEK',
  GregorianLastYear = 'GREGORIAN_LAST_YEAR',
  GregorianThisMonth = 'GREGORIAN_THIS_MONTH',
  GregorianThisQuarter = 'GREGORIAN_THIS_QUARTER',
  GregorianThisWeek = 'GREGORIAN_THIS_WEEK',
  GregorianThisYear = 'GREGORIAN_THIS_YEAR',
  Last_3Days = 'LAST_3DAYS',
  Last_7Days = 'LAST_7DAYS',
  Last_30Days = 'LAST_30DAYS',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type Preheader = DynamicPreheader | StaticPreheader;

export type PreheaderAndPreview = BothPreviewPreheader | OnlyPreheader | OnlyPreview;

export type PreheaderChunk = DynamicContent | NoContent | StaticMessageWithLink;

export type PreheaderWithPreview = DynamicContent | NoContent | StaticPreheaderWithPreview;

export type PreviewChunk = DynamicContent | NoContent | StaticMessage;

export type PreviewContact = {
  __typename?: 'PreviewContact';
  channel: Channel;
  channelId: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  previewContactGroups: Array<PreviewContactGroup>;
  sends: Scalars['Int']['output'];
};

export type PreviewContactGroup = {
  __typename?: 'PreviewContactGroup';
  channel: Channel;
  contactCount: Scalars['Int']['output'];
  contacts: Array<PreviewContact>;
  id: Scalars['ID']['output'];
  sends: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum PreviewContactGroupSortType {
  SendsAsc = 'SENDS_ASC',
  SendsDesc = 'SENDS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export enum PreviewContactSortType {
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  SendsAsc = 'SENDS_ASC',
  SendsDesc = 'SENDS_DESC'
}

export type Problem = {
  __typename?: 'Problem';
  blocks?: Maybe<Array<Maybe<System>>>;
  message: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  where: System;
};

export type ProductboardResult = {
  __typename?: 'ProductboardResult';
  token: Scalars['String']['output'];
};

export type Program = {
  __typename?: 'Program';
  availableCreativeTags: Array<Tag>;
  customFields: Array<CustomField>;
  description: Scalars['String']['output'];
  emailServiceProvider: EmailServiceProvider;
  espConfig?: Maybe<EspConfig>;
  excludedAudiences: Array<ProgramAudience>;
  fields: Array<CampaignField>;
  id: Scalars['ID']['output'];
  includedAudiences: Array<ProgramAudience>;
  isArchived: Scalars['Boolean']['output'];
  isQuiet: Scalars['Boolean']['output'];
  lastSendTime?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use title */
  name: Scalars['String']['output'];
  quietHourRules: Array<QuietHourRule>;
  quietPeriodRules: Array<QuietPeriodRule>;
  seedContactAudiences: Array<ContactAudience>;
  stateInfo: ProgramStateInfo;
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  trackingParameters: Array<Attribute>;
  uberTemplate: UberTemplate;
};


export type ProgramAvailableCreativeTagsArgs = {
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAudience = {
  __typename?: 'ProgramAudience';
  audience: ContactAudience;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  segments: Array<ProgramAudienceSegment>;
};

export type ProgramAudienceSegment = {
  __typename?: 'ProgramAudienceSegment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  segment?: Maybe<ContactAudienceSplit>;
  selected: Scalars['Boolean']['output'];
};

export type ProgramConnection = {
  __typename?: 'ProgramConnection';
  counts: ProgramCounts;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProgramEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type ProgramCounts = {
  __typename?: 'ProgramCounts';
  active: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  locked: Scalars['Int']['output'];
  suspended: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProgramCreateResult = ProgramSuccess | ValidationErrors;

/** A Relay edge containing a `Program` and its cursor. */
export type ProgramEdge = {
  __typename?: 'ProgramEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Program;
};

export type ProgramFilterInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramStateInfo = {
  __typename?: 'ProgramStateInfo';
  actions?: Maybe<Array<StateAction>>;
  history?: Maybe<Array<Maybe<ProgramStateLog>>>;
  state: ProgramStateType;
  transitions: Array<Transition>;
};

export type ProgramStateLog = {
  __typename?: 'ProgramStateLog';
  state: ContentLibraryProgramStateStateChoices;
  timestamp: Scalars['DateTime']['output'];
  user: User;
};

export enum ProgramStateType {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Locked = 'LOCKED',
  Suspended = 'SUSPENDED',
  Suspending = 'SUSPENDING'
}

export type ProgramSuccess = {
  __typename?: 'ProgramSuccess';
  program: Program;
  success: Scalars['Boolean']['output'];
};

export type ProgramUpdateResult = ProgramSuccess | ValidationErrors;

export type ProofVariant = {
  __typename?: 'ProofVariant';
  contentBlocks: Array<ProofVariantContentBlock>;
  desktopImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  preheaderText?: Maybe<Scalars['String']['output']>;
  previewText?: Maybe<Scalars['String']['output']>;
  recipients: Scalars['Int']['output'];
  runId: Scalars['Int']['output'];
  subjectline?: Maybe<Scalars['String']['output']>;
  subjectlinePrefix?: Maybe<Scalars['String']['output']>;
  subjectlineSuffix?: Maybe<Scalars['String']['output']>;
  type: ProofVariantType;
};

export type ProofVariant2 = MmsProofVariant | PushProofVariant | SmsProofVariant;

export type ProofVariantContentBlock = {
  __typename?: 'ProofVariantContentBlock';
  contentBlockId?: Maybe<Scalars['ID']['output']>;
  creativeIds?: Maybe<Array<Scalars['ID']['output']>>;
  creativeTitle?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type ProofVariantFilterInput = {
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audienceSplitIds?: InputMaybe<Array<InputMaybe<Array<Scalars['ID']['input']>>>>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy: ProofVariantOrderByType;
  preheaderTextContains?: InputMaybe<Scalars['String']['input']>;
  previewTextContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectlinePrefixContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineSuffixContains?: InputMaybe<Scalars['String']['input']>;
  treatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProofVariantFilterInput2 = {
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audienceSplitIds?: InputMaybe<Array<InputMaybe<Array<Scalars['ID']['input']>>>>;
  bodyTextContains?: InputMaybe<Scalars['String']['input']>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy: ProofVariantOrderByType;
  treatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProofVariantListMeta = {
  __typename?: 'ProofVariantListMeta';
  recipients: Scalars['Int']['output'];
  totalRecipients: Scalars['Int']['output'];
  totalResults: Scalars['Int']['output'];
  totalVariants: Scalars['Int']['output'];
  variants: Scalars['Int']['output'];
};

export type ProofVariantListResults = {
  __typename?: 'ProofVariantListResults';
  meta: ProofVariantListMeta;
  results: Array<ProofVariant>;
};

export type ProofVariantListResults2 = {
  __typename?: 'ProofVariantListResults2';
  meta: ProofVariantListMeta;
  results: Array<ProofVariant2>;
};

/** An enumeration. */
export enum ProofVariantOrderByType {
  RecipientsAsc = 'RECIPIENTS_ASC',
  RecipientsDesc = 'RECIPIENTS_DESC'
}

export enum ProofVariantType {
  Final = 'FINAL',
  Proof = 'PROOF'
}

export enum ProofVariantTypeChoices {
  Final = 'FINAL',
  Proof = 'PROOF'
}

export type ProviderVariable = {
  __typename?: 'ProviderVariable';
  expression: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PublicKey = {
  __typename?: 'PublicKey';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublicKeyInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PushCreativeUsage = MediaUsageLocation & {
  __typename?: 'PushCreativeUsage';
  channel: Channel;
  contentId: Scalars['ID']['output'];
  creativeId: Scalars['ID']['output'];
  creativeTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PushNotification = Content & {
  __typename?: 'PushNotification';
  body: Scalars['String']['output'];
  channel: Channel;
  id: Scalars['ID']['output'];
  languageCode: Scalars['Language']['output'];
  media?: Maybe<Media2>;
  platformLinks: Array<PushNotificationPlatformLink>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationInput = {
  body: Scalars['String']['input'];
  mediaUri?: InputMaybe<Scalars['String']['input']>;
  platformLinks?: InputMaybe<Array<PushNotificationPlatformLinkInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationPlatformLink = {
  __typename?: 'PushNotificationPlatformLink';
  behavior: LinkBehaviorEnum;
  id: Scalars['ID']['output'];
  link: Link2;
  platform: MobilePlatformEnum;
};

export type PushNotificationPlatformLinkInput = {
  behavior: LinkBehaviorEnum;
  linkId: Scalars['ID']['input'];
  platform: MobilePlatformEnum;
};

export type PushNotificationSuccess = {
  __typename?: 'PushNotificationSuccess';
  pushNotification: PushNotification;
  success: Scalars['Boolean']['output'];
};

export type PushProofVariant = {
  __typename?: 'PushProofVariant';
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  recipients: Scalars['Int']['output'];
  runId: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: ProofVariantType;
};

/** Represents a quarter of a fiscal calendar. */
export type Quarter = {
  __typename?: 'Quarter';
  id: Scalars['ID']['output'];
  /** The quarter of the Fiscal calendar (1-4) */
  quarter: Scalars['Int']['output'];
  /** The date range of the quarter */
  span: DateSpan;
  /** The year of the Fiscal calendar */
  year: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  account: Account2;
  accountUserByEmail: AccountUserByEmail;
  alertRules: Array<AlertRuleType>;
  alertRulesWithSubscriptions: Array<AlertRuleWithSubscriptionsType>;
  analyticsCampaignActivity: AnalyticsCampaignActivity;
  analyticsCampaignCreativeActivity: Array<AnalyticsCampaignCreativeActivity>;
  analyticsCampaignExperimentActivity: Array<AnalyticsCampaignExperimentActivity>;
  analyticsCampaignMailingActivity: Array<AnalyticsCampaignMailingActivity>;
  analyticsCampaignMostSentVariant: EmailVersion;
  analyticsCampaignSegmentActivity: Array<AnalyticsCampaignSegmentActivity>;
  analyticsCampaignSendTimeMetrics: Array<CampaignSendTimeMetrics>;
  analyticsCampaignsActivity: AnalyticsCampaignActivities;
  analyticsCreativeActivity: AnalyticsCreativeActivity;
  analyticsCreativeCampaignActivity: Array<AnalyticsCreativeCampaignActivity>;
  analyticsCreativeContentblockMetrics: Array<CreativeContentblockMetrics>;
  analyticsCreativeScores?: Maybe<Array<AnalyticsCreativeScores>>;
  analyticsCreativeSegmentActivity: Array<AnalyticsCreativeSegmentActivity>;
  analyticsCreativeSubjectlineActivity: Array<AnalyticsCreativeSubjectLineActivity>;
  analyticsCreativesActivity: AnalyticsCreativeActivities;
  analyticsCreativesActivityV2: AnalyticsCreativeActivitiesV2;
  analyticsDashboardConfig: Array<AnalyticsWidget>;
  analyticsExperimentActivity: AnalyticsExperimentActivity;
  analyticsExperimentsActivity: AnalyticsExperimentActivities;
  analyticsSegmentActivity: AnalyticsSegmentActivity;
  analyticsSegmentCampaignActivity: Array<Maybe<AnalyticsSegmentCampaignActivity>>;
  analyticsSegmentCreativeActivity: Array<Maybe<AnalyticsSegmentCreativeActivity>>;
  analyticsSegmentGroupActivity: AnalyticsSegmentGroupActivity;
  analyticsSegmentGroupsActivity: Array<Maybe<AnalyticsSegmentGroupActivity>>;
  analyticsSegmentsActivity: Array<Maybe<AnalyticsSegmentActivity>>;
  analyticsSubjectlineMetrics: Array<SubjectlineMetrics>;
  analyticsV2CampaignReportColumns: Array<AnalyticsReportColumn>;
  analyticsV2CampaignTreatmentReportColumns: Array<AnalyticsReportColumn>;
  analyticsV2CampaignsMetricsGroupedByTag: Array<AnalyticsV2GroupedCampaigns>;
  analyticsV2CampaignsReport: AnalyticsReport;
  analyticsV2CreativeExperimentReportColumns: Array<AnalyticsReportColumn>;
  analyticsV2CreativeExperimentsReport: AnalyticsReport;
  analyticsV2CreativeReportColumns: Array<AnalyticsReportColumn>;
  analyticsV2CreativeTreatmentReportColumns: Array<AnalyticsReportColumn>;
  analyticsV2Creatives?: Maybe<Array<Creative>>;
  analyticsV2CreativesMetricsGroupedByTag: Array<AnalyticsV2GroupedCreatives>;
  analyticsV2CreativesMetricsGroupedByTagV2: Array<AnalyticsV2GroupedCreativesV2>;
  analyticsV2CreativesReport: AnalyticsReport;
  analyticsV2ExperimentCampaignMetrics: Array<AnalyticsV2ExperimentCampaign>;
  analyticsV2ExperimentCreativeMetrics: Array<AnalyticsV2ExperimentCreative>;
  analyticsV2ExperimentReportColumns: Array<AnalyticsReportColumn>;
  analyticsV2Experiments?: Maybe<Array<Experiment>>;
  analyticsV2ExperimentsReport: AnalyticsReport;
  analyticsV2GroupedCampaignMetrics: Array<AnalyticsV2GroupedCampaigns>;
  analyticsV2SegmentGroupCampaignMetrics: Array<AnalyticsV2SegmentGroupCampaign>;
  analyticsV2SegmentGroupCreativeMetrics: Array<AnalyticsV2SegmentGroupCreative>;
  analyticsWebEventsActivity: Array<AnalyticsEventActivity>;
  applicationRoles2: Array<ApplicationRole>;
  audience: Audience;
  audienceBuild: Scalars['Int']['output'];
  audiences: AudiencePaginatedType;
  availableClients: Array<Client>;
  availableCustomFields: Array<AvailableCustomField>;
  availablePermissions?: Maybe<Array<AvailablePermission>>;
  baseTemplate: BaseTemplate;
  block: Block;
  blocks: BlockConnection;
  blocksPage: BlockPagination;
  brandKit?: Maybe<BrandKit>;
  brandKitGeneration?: Maybe<BrandKitGeneration>;
  brandKitGenerations?: Maybe<Array<BrandKitGeneration>>;
  brandKits?: Maybe<Array<BrandKit>>;
  campaign: Campaign;
  campaignAlertConfig: DataSourceConfigType;
  /** Count contacts shared by the snapshot audiences of two campaigns. Null when either campaign has no include audiences. */
  campaignAudienceOverlapCount?: Maybe<Scalars['Int']['output']>;
  campaignAudiences: Array<Audience>;
  campaignChannelsCount: Array<ChannelCountType>;
  campaignComparisonByDate: ComparisonMetricV2;
  campaignComparisonBySegment: ComparisonMetric;
  campaignComparisonBySegmentV2: ComparisonMetricV2;
  campaignComparisonByTreatment: ComparisonMetric;
  campaignComparisonByTreatmentV2: ComparisonMetricV2;
  campaignContentblocksMetrics: Array<Maybe<CampaignContentblockMetrics>>;
  campaignCreativesMetrics: Array<Maybe<CreativeMetric>>;
  campaignExperimentsMetrics: Array<Maybe<ExperimentMetrics>>;
  campaignIncludedCreativeSubjectLines: Array<SubjectLine>;
  campaignIncludedCreativeTags: Array<Tag>;
  campaignIncludedCreatives: Array<Creative>;
  campaignMailingsMetrics: Array<Maybe<MailingMetrics>>;
  campaignPreview: CampaignPreview;
  campaignProofVariantList: ProofVariantListResults;
  campaignProofVariants2: ProofVariantListResults2;
  campaignSavedViewsV2: Array<CampaignSavedViewType>;
  campaignSegmentsMetrics: Array<Maybe<SegmentGroupMetrics>>;
  campaignStageCount: Array<CampaignStageCountType>;
  /** @deprecated Use campaignStatusGroupCount instead. */
  campaignStageGroupCount: Array<CampaignStageGroupCountType>;
  campaignStages: Array<CampaignStage>;
  campaignStatusGroupCount: Array<CampaignStatusGroupCountType>;
  campaignTimeline: Array<Maybe<CampaignTimelineType>>;
  campaignTimelineNew: Array<CampaignTimelineGroupType>;
  campaignView?: Maybe<CampaignView>;
  campaigns: CampaignPaginatedType;
  campaignsMetrics: CampaignMetrics;
  /** Find campaigns with overlapping send times for a given campaign */
  campaignsWithOverlappingSendTimes?: Maybe<Array<Campaign>>;
  /** List of configured channels for the account */
  channels: Array<ChannelSpec>;
  connectionStreamSchema: InkDataV1StreamSchemaFetchResponse;
  connectionStreams: InkDataV1ConnectionStreamListResponse;
  connections: InkDataV1ConnectionListResponse;
  contactAudience: ContactAudience;
  contactAudienceBuild: ContactAudienceCount;
  contactAudienceBuildV2: ContactAudienceCount;
  contactAudienceEditValidation: Scalars['Boolean']['output'];
  contactAudienceFields: InkDavinciContactsV1AudienceFieldListResponse;
  contactAudienceFiltersCounts: ContactAudienceFiltersCounts;
  contactAudienceTags: InkDavinciContactsV1AudienceTagListResponse;
  contactAudiences: ContactAudienceList;
  contactSegmentContacts: Array<Maybe<ContactSegmentContact>>;
  contactSegmentGroup: ContactSegmentGroup;
  contactSegmentGroupCounts: ContactSegmentGroupCounts;
  contactSegmentGroups: Array<ContactSegmentGroup>;
  contactTableCount: Scalars['Int']['output'];
  contactTableDataFields: Array<DataField>;
  contentBlock: ContentBlock;
  contentBlocks: Array<ContentBlock>;
  creative: Creative;
  creativeAttributeDefinitions: Array<AttributeDefinition>;
  creativeCampaignsMetrics: Array<Maybe<CreativeCampaignMetrics>>;
  creativeComparisonBySegment: ComparisonCreativeMetric;
  creativeComparisonBySegmentV2: ComparisonCreativeMetricV2;
  creativeComparisonByTreatment: ComparisonCreativeMetric;
  creativeComparisonByTreatmentV2: ComparisonCreativeMetricV2;
  creativeContentblocksMetrics: Array<Maybe<CreativeContentblockMetricsV2>>;
  creativeExperimentsMetrics: Array<Maybe<CreativeExperimentMetrics>>;
  creativeFiltersCounts: CreativeFiltersCounts;
  creativePurposes: Array<CreativePurpose>;
  creativeSavedViewsV2: Array<CreativeSavedViewType>;
  creativeSegmentsMetrics: Array<Maybe<CreativeSegmentGroupMetrics>>;
  creativeSubjectlinesMetrics: Array<Maybe<CreativeSubjectlineMetrics>>;
  creatives: CreativePagination;
  creativesMetrics: CreativeMetrics;
  currentClient: Client;
  currentUser: User;
  /** List all custom event categories for the account */
  customEventCategories?: Maybe<Array<Maybe<CustomEventCategoryType>>>;
  /** List all available tags for custom events */
  customEventTags?: Maybe<Array<Maybe<CustomEventTagType>>>;
  customFonts?: Maybe<Array<CustomFont>>;
  dataConnection: DataConnection;
  dataConnectionStreamSchema: DataConnectionStreamSchema;
  dataConnectionStreams: DataConnectionStreams;
  dataConnections: Array<DataConnection>;
  dataEncryptionConfig: DataEncryptionConfig;
  dataEncryptionConnectionPgpKeys: DataEncryptionPgpKeysList;
  dataEncryptionPgpKey: DataEncryptionPgpKey;
  dataEncryptionPgpKeys: DataEncryptionPgpKeysList;
  dataField: DataField;
  dataFieldChannelsV2: Array<Channel>;
  dataFieldValueList: Array<Scalars['String']['output']>;
  dataFields: Array<DataField>;
  dataJobRunCacheItemList: InkDavinciDataV1StreamCacheItemListResponse;
  dataJobRuns: InkDavinciDataV2JobRunListResponse;
  dataJobsFetch: InkDavinciDataV2JobFetchResponse;
  dataJobsList: InkDavinciDataV2JobListResponse;
  dataRelations: InkDavinciDataV1RelationListResponse;
  dataSubjectRequests: Array<DataSubjectRequest>;
  dataTable: DataTable;
  dataTableLock: InkDavinciDataV1TableLockFetchResponse;
  dataTables: Array<DataTable>;
  dataTag: InkDavinciDataV1TagFetchResponse;
  dataTagDeletable?: Maybe<DataTagDeletableResponse>;
  dataTags: InkDavinciDataV1TagListResponse;
  dataTagsDeletable: InkDavinciDataV1TagListResponse;
  dataset: InkDataV1DatasetFetchResponse;
  datasetFields: InkDataV1DatasetFieldListResponse;
  datasetStatistics: InkDataV1DatasetStatisticsResponse;
  datasets: InkDataV1DatasetListResponse;
  emailVersionSendAdditionalAttributes: EmailVersionSendAdditionalAttributes;
  emailVersionSendContacts: Array<EmailVersionSendContact>;
  emailVersionSends?: Maybe<Array<EmailVersionSend>>;
  experimentCampaignsMetrics: Array<Maybe<ExperimentCampaignMetrics>>;
  experimentContactsMetrics: Array<Maybe<ExperimentContactMetrics>>;
  experimentCreativesMetrics: Array<Maybe<ExperimentCreativeMetrics>>;
  experimentGroups: Array<ExperimentGroup>;
  experimentSegmentsMetrics: Array<Maybe<ExperimentSegmentsMetrics>>;
  experiments: Array<Experiment>;
  experimentsMetrics: Array<Maybe<ExperimentMetrics>>;
  groupedCampaignsMetrics: Array<Maybe<GroupedCampaignsMetrics>>;
  groupedCreativesMetrics: Array<Maybe<GroupedCreativesMetrics>>;
  groupedExperimentCampaignsMetrics: Array<Maybe<GroupedExperimentCampaignMetrics>>;
  groupedExperimentCreativesMetrics: Array<Maybe<GroupedExperimentCreativeMetrics>>;
  groupedSegmentGroupCampaignMetrics: Array<Maybe<GroupedSegmentGroupCampaignMetrics>>;
  groupedSegmentGroupCreativeMetrics: Array<Maybe<GroupedSegmentGroupCreativeMetrics>>;
  job: InkDataV1JobFetchResponse;
  jobRun: InkDataV1JobRunFetchResponse;
  jobRuns: InkDataV1JobRunListResponse;
  jobs: InkDataV1JobListResponse;
  jobsAlertPickerList: Array<JobAlertPickerEntryType>;
  journey: Journey;
  journeys: Array<Maybe<Journey>>;
  layoutComponent: LayoutComponent;
  layoutComponents: LayoutComponentConnection;
  layoutComponentsPage: LayoutComponentPagination;
  link: Link;
  link2: Link2;
  link2s: Link2Connection;
  linkGroup: LinkGroup;
  linkGroups: Array<LinkGroup>;
  /** @deprecated Use media_library2 */
  mediaLibrary: Array<Media>;
  mediaLibrary2: Array<Media2>;
  metricTypes?: Maybe<Array<Maybe<MetricType>>>;
  model: InkDataV1ModelFetchResponse;
  models: InkDataV1ModelListResponse;
  multiGroupedCampaignsMetrics: Array<Maybe<MultiGroupedCampaignsMetrics>>;
  multiGroupedCreativesMetrics: Array<Maybe<MultiGroupedCreativesMetrics>>;
  notificationsSettings?: Maybe<Array<NotificationsSetting>>;
  organization: Organization;
  organizationUser2: OrganizationUser2;
  organizations?: Maybe<Array<Organization>>;
  pastCampaignContentBlocks: PastCampaignContentBlocks;
  platformApplication?: Maybe<PlatformApplication>;
  platformApplication2?: Maybe<PlatformApplication2>;
  platformApplications?: Maybe<Array<PlatformApplication>>;
  platformApplications2?: Maybe<Array<PlatformApplication2>>;
  predefinedAudienceGroup: PredefinedAudienceGroupType;
  predefinedAudienceGroups: Array<PredefinedAudienceGroupType>;
  /** @deprecated Renamed to proofContactGroup */
  previewContactGroup: PreviewContactGroup;
  /** @deprecated Renamed to proofContactGroups */
  previewContactGroups: Array<PreviewContactGroup>;
  /** @deprecated Renamed to proofContacts */
  previewContacts: Array<PreviewContact>;
  productUpdates: Array<CategoryArticle>;
  productboardToken: ProductboardResult;
  program: Program;
  programProofVariantList: ProofVariantListResults;
  programs: ProgramConnection;
  proofContactGroup: PreviewContactGroup;
  proofContactGroups: Array<PreviewContactGroup>;
  proofContacts: Array<PreviewContact>;
  queryCatalog: InkDataV1QueryCatalogFetchResponse;
  queryFetch: InkDataV1QueryFetchResponse;
  querySelectFetch: InkDataV1QuerySelectFetchResponse;
  recommendationRunSchedule?: Maybe<RecommendationRunSchedule>;
  recommendationRuns: Array<RecommendationRun>;
  recurringCampaign?: Maybe<RecurringCampaignType>;
  recurringCampaignMessage?: Maybe<RecurringCampaignMessageType>;
  recurringCampaignMessageAvailableCreatives: RecurringCampaignAvailableCreativesConnection;
  recurringCampaignMetricsV2: RecurringCampaignMetricsV2;
  recurringCampaignOccurrences: Array<RcCalendarItem>;
  recurringCampaignProofVariantList: ProofVariantListResults;
  recurringCampaigns: RecurringCampaignConnection;
  recurringExportReminders: Array<Maybe<RecurringExportReminderType>>;
  savedFilters: Array<SavedFilterType>;
  scopesByCategory?: Maybe<Array<ScopeCategory>>;
  segmentExperimentMetrics: Array<Maybe<SegmentExperimentMetrics>>;
  segmentGroupCampaignMetrics: Array<Maybe<SegmentGroupCampaignMetrics>>;
  segmentGroupCreativeMetrics: Array<Maybe<SegmentGroupCreativeMetrics>>;
  segmentGroupsMetrics: Array<Maybe<SegmentGroupMetrics>>;
  semanticCategories: InkDavinciDataV1SemanticCategoryListResponse;
  studioCampaign: StudioCampaignResult;
  studioCampaigns: StudioCampaignsResult;
  subjectlinesMetrics: SubjectLineMetrics;
  tags: Array<Tag>;
  templates: TemplatePaginatedType;
  trackingParameterDefinitions: Array<AttributeDefinition>;
  trackingTokenList: Array<TrackingToken>;
  triggeredCampaign?: Maybe<TriggeredCampaignType>;
  triggeredCampaignMessage?: Maybe<TriggeredCampaignMessageType>;
  triggeredCampaignMessageAvailableCreatives: TriggeredCampaignAvailableCreativesConnection;
  triggeredCampaigns: TriggeredCampaignConnection;
  userPermissionsForAccount: AccountRolePermissions;
  userPermissionsForOrganization: OrganizationRolePermissions;
  variables: Array<Variable>;
  warehouses: InkDataV1WarehouseListResponse;
};


export type QueryAccountArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountUserByEmailArgs = {
  accountId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
};


export type QueryAnalyticsCampaignActivityArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignCreativeActivityArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignExperimentActivityArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignMailingActivityArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignMostSentVariantArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignSegmentActivityArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignSendTimeMetricsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAnalyticsCampaignsActivityArgs = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  stages?: InputMaybe<Array<CampaignStageType>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativeActivityArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativeCampaignActivityArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativeContentblockMetricsArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativeScoresArgs = {
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAnalyticsCreativeSegmentActivityArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativeSubjectlineActivityArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativesActivityArgs = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  stages?: InputMaybe<Array<CampaignStageType>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsCreativesActivityV2Args = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  stages?: InputMaybe<Array<CampaignStageType>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsExperimentActivityArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentId: Scalars['ID']['input'];
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsExperimentsActivityArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  statuses?: InputMaybe<Array<ExperimentStatus>>;
  types?: InputMaybe<Array<ExperimentType>>;
};


export type QueryAnalyticsSegmentActivityArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  segmentId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsSegmentCampaignActivityArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsSegmentCreativeActivityArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsSegmentGroupActivityArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentGroupId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsSegmentGroupsActivityArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsSegmentsActivityArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  include?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsSubjectlineMetricsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  sources?: InputMaybe<Array<SourceType>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  subjectlineIdsOrContents?: InputMaybe<Array<Scalars['String']['input']>>;
  tones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAnalyticsV2CampaignsMetricsGroupedByTagArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2CampaignsReportArgs = {
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  groupBy?: InputMaybe<CampaignGroupBy>;
};


export type QueryAnalyticsV2CreativeExperimentsReportArgs = {
  creativeId: Scalars['ID']['input'];
  dateRange: Scalars['DateRange']['input'];
};


export type QueryAnalyticsV2CreativesArgs = {
  filter?: InputMaybe<CreativeMetricsFilter>;
};


export type QueryAnalyticsV2CreativesMetricsGroupedByTagArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2CreativesMetricsGroupedByTagV2Args = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2CreativesReportArgs = {
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
  groupBy?: InputMaybe<CreativeGroupBy>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAnalyticsV2ExperimentCampaignMetricsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentId: Scalars['ID']['input'];
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2ExperimentCreativeMetricsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentId: Scalars['ID']['input'];
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2ExperimentsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channels?: InputMaybe<Array<Channel>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2ExperimentsReportArgs = {
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput>;
};


export type QueryAnalyticsV2GroupedCampaignMetricsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2SegmentGroupCampaignMetricsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentGroupId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsV2SegmentGroupCreativeMetricsArgs = {
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentGroupId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAnalyticsWebEventsActivityArgs = {
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  tokenId: Scalars['ID']['input'];
};


export type QueryApplicationRoles2Args = {
  defaultsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryAudienceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAudienceBuildArgs = {
  query: Scalars['ContactQuery']['input'];
};


export type QueryAudiencesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<AudienceSortType>>;
  types?: InputMaybe<Array<AudienceType>>;
};


export type QueryAvailableCustomFieldsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBaseTemplateArgs = {
  baseTemplateId: Scalars['ID']['input'];
};


export type QueryBlockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BlockFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlocksPageArgs = {
  filters?: InputMaybe<BlockFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandKitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandKitGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandKitsArgs = {
  latestVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignAudienceOverlapCountArgs = {
  campaignId: Scalars['ID']['input'];
  overlappingCampaignId: Scalars['ID']['input'];
};


export type QueryCampaignAudiencesArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  audienceType: CampaignAudienceType;
  id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignChannelsCountArgs = {
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
};


export type QueryCampaignComparisonByDateArgs = {
  baselineEndDate: Scalars['Date']['input'];
  baselineStartDate: Scalars['Date']['input'];
  filter: CampaignDateRangeFilter;
  groupEndDate: Scalars['Date']['input'];
  groupStartDate: Scalars['Date']['input'];
  seriesMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCampaignComparisonBySegmentArgs = {
  baselineSegmentIds: Array<Scalars['ID']['input']>;
  campaignFilter: ComparisonFilterInput;
  groupSegmentIds: Array<Scalars['ID']['input']>;
};


export type QueryCampaignComparisonBySegmentV2Args = {
  baselineSegmentIds: Array<Scalars['ID']['input']>;
  filter: CampaignMetricsFilter;
  groupSegmentIds: Array<Scalars['ID']['input']>;
  seriesMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCampaignComparisonByTreatmentArgs = {
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignFilter: ComparisonFilterInput;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCampaignComparisonByTreatmentV2Args = {
  baselineTreatmentDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter: CampaignMetricsFilter;
  groupTreatmentDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  seriesMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCampaignContentblocksMetricsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignCreativesMetricsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignExperimentsMetricsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignIncludedCreativeSubjectLinesArgs = {
  campaignId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignIncludedCreativeTagsArgs = {
  campaignId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignIncludedCreativesArgs = {
  campaignId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignMailingsMetricsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignPreviewArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignProofVariantListArgs = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  proofVariantFilter: ProofVariantFilterInput;
};


export type QueryCampaignProofVariants2Args = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  proofVariantFilter: ProofVariantFilterInput2;
};


export type QueryCampaignSegmentsMetricsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCampaignStageCountArgs = {
  search?: InputMaybe<Scalars['SearchUID']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
};


export type QueryCampaignStageGroupCountArgs = {
  search?: InputMaybe<Scalars['SearchUID']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
};


export type QueryCampaignStagesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignStatusGroupCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
};


export type QueryCampaignTimelineArgs = {
  campaignId: Scalars['UID']['input'];
};


export type QueryCampaignTimelineNewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignViewArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCampaignsArgs = {
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channels?: InputMaybe<Array<Channel>>;
  error?: InputMaybe<Scalars['Boolean']['input']>;
  hasNewerCreativeVersions?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['SearchUID']['input']>;
  sort?: InputMaybe<Array<CampaignSortType>>;
  stages?: InputMaybe<Array<CampaignStageType>>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  statusGroups?: InputMaybe<Array<CampaignStatusGroupType>>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCampaignsMetricsArgs = {
  filter: CampaignFilter;
};


export type QueryCampaignsWithOverlappingSendTimesArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryConnectionStreamSchemaArgs = {
  id: Scalars['ID']['input'];
  streamKey: Scalars['String']['input'];
};


export type QueryConnectionStreamsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactAudienceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactAudienceBuildArgs = {
  channelV2?: InputMaybe<Channel>;
  query: Scalars['ContactQuery']['input'];
  splits?: InputMaybe<Array<Scalars['ContactQuery']['input']>>;
};


export type QueryContactAudienceBuildV2Args = {
  channelV2?: InputMaybe<Channel>;
  experimentConfig?: InputMaybe<ExperimentAudienceBuildInputConfig>;
  query?: InputMaybe<Scalars['ContactQuery']['input']>;
  segmentConfig?: InputMaybe<SegmentAudienceBuildInputConfig>;
};


export type QueryContactAudienceEditValidationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactAudienceFiltersCountsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<ContactAudienceType>>;
};


export type QueryContactAudiencesArgs = {
  analyticsTracking?: InputMaybe<ContactAudienceAnalyticsTracking>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countLessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  includeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContactAudiencesOrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ContactAudienceType>>;
};


export type QueryContactSegmentContactsArgs = {
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryContactSegmentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactSegmentGroupCountsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentBlockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentBlocksArgs = {
  contentBlockType?: InputMaybe<ContentBlockType>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreativeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreativeAttributeDefinitionsArgs = {
  filterable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCreativeCampaignsMetricsArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCreativeComparisonBySegmentArgs = {
  baselineSegmentIds: Array<Scalars['ID']['input']>;
  creativeFilter: ComparisonCreativeFilterInput;
  groupSegmentIds: Array<Scalars['ID']['input']>;
};


export type QueryCreativeComparisonBySegmentV2Args = {
  baselineSegmentIds: Array<Scalars['ID']['input']>;
  filter: CreativeMetricsFilter;
  groupSegmentIds: Array<Scalars['ID']['input']>;
};


export type QueryCreativeComparisonByTreatmentArgs = {
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeFilter: ComparisonCreativeFilterInput;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCreativeComparisonByTreatmentV2Args = {
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter: CreativeMetricsFilter;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCreativeContentblocksMetricsArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCreativeExperimentsMetricsArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCreativeFiltersCountsArgs = {
  filter?: InputMaybe<CreativeFilter>;
};


export type QueryCreativeSegmentsMetricsArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCreativeSubjectlinesMetricsArgs = {
  creativeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCreativesArgs = {
  filter?: InputMaybe<CreativeFilter>;
  orderBy?: InputMaybe<Array<CreativeOrderBy>>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCreativesMetricsArgs = {
  filter: CreativeMetricsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataConnectionStreamSchemaArgs = {
  id: Scalars['ID']['input'];
  streamUri: Scalars['String']['input'];
};


export type QueryDataConnectionStreamsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataEncryptionConnectionPgpKeysArgs = {
  connectionId: Scalars['ID']['input'];
};


export type QueryDataEncryptionPgpKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataFieldValueListArgs = {
  distinct: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDataFieldsArgs = {
  tableId: Scalars['ID']['input'];
  types?: InputMaybe<Array<DataFieldType>>;
};


export type QueryDataJobRunCacheItemListArgs = {
  jobId: Scalars['ID']['input'];
  jobRunId: Scalars['ID']['input'];
};


export type QueryDataJobRunsArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryDataJobsFetchArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDataRelationsArgs = {
  tableId: Scalars['ID']['input'];
};


export type QueryDataSubjectRequestsArgs = {
  status?: InputMaybe<InkDavinciDsrV1DsrStatusEnum>;
  subjectFieldName?: InputMaybe<Scalars['String']['input']>;
  subjectFieldValue?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InkDavinciDsrV1DsrTypeEnum>;
};


export type QueryDataTableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataTableLockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataTagDeletableArgs = {
  id: Scalars['String']['input'];
};


export type QueryDataTagsArgs = {
  tableId: Scalars['ID']['input'];
};


export type QueryDatasetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDatasetFieldsArgs = {
  datasetId: Scalars['ID']['input'];
};


export type QueryDatasetStatisticsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailVersionSendAdditionalAttributesArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryEmailVersionSendContactsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryEmailVersionSendsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryExperimentCampaignsMetricsArgs = {
  filter: ExperimentCampaignMetricsFilter;
};


export type QueryExperimentContactsMetricsArgs = {
  filter: ExperimentMetricsFilter;
};


export type QueryExperimentCreativesMetricsArgs = {
  filter: ExperimentCreativeMetricsFilter;
};


export type QueryExperimentGroupsArgs = {
  experimentTypes?: InputMaybe<Array<ExperimentType>>;
};


export type QueryExperimentSegmentsMetricsArgs = {
  filter: ExperimentSegmentsMetricsFilter;
};


export type QueryExperimentsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  experimentType?: InputMaybe<ExperimentType>;
  experimentTypes?: InputMaybe<Array<ExperimentType>>;
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExperimentsMetricsArgs = {
  filter: ExperimentMetricsFilter;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupedCampaignsMetricsArgs = {
  filter: CampaignFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
};


export type QueryGroupedCreativesMetricsArgs = {
  filter: CreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
};


export type QueryGroupedExperimentCampaignsMetricsArgs = {
  filter: ExperimentCampaignMetricsFilter;
  groupBy: CampaignGroupBy;
};


export type QueryGroupedExperimentCreativesMetricsArgs = {
  filter: ExperimentCreativeMetricsFilter;
  groupBy: CreativeGroupBy;
};


export type QueryGroupedSegmentGroupCampaignMetricsArgs = {
  filter: SegmentGroupCampaignMetricsFilter;
  groupBy: CampaignGroupBy;
};


export type QueryGroupedSegmentGroupCreativeMetricsArgs = {
  filter: SegmentGroupCreativeMetricsFilter;
  groupBy: CreativeGroupBy;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobRunsArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  spec: JobSpecKind;
};


export type QueryJourneyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLayoutComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLayoutComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<LayoutComponentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLayoutComponentsPageArgs = {
  filters?: InputMaybe<LayoutComponentFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLink2Args = {
  id: Scalars['ID']['input'];
};


export type QueryLink2sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Link2FilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLinkGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLinkGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMediaLibraryArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMediaLibrary2Args = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMetricTypesArgs = {
  channel?: InputMaybe<Channel>;
  metricClass: MetricClass;
  metricView?: InputMaybe<MetricView>;
};


export type QueryModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMultiGroupedCampaignsMetricsArgs = {
  filter: CampaignFilter;
  groupBy: Array<CampaignGroupBy>;
};


export type QueryMultiGroupedCreativesMetricsArgs = {
  filter: CreativeMetricsFilter;
  groupBy: Array<CreativeGroupBy>;
};


export type QueryOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationUser2Args = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlatformApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformApplication2Args = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformApplicationsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryPlatformApplications2Args = {
  organizationId: Scalars['ID']['input'];
};


export type QueryPredefinedAudienceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPredefinedAudienceGroupsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewContactGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPreviewContactGroupsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<PreviewContactGroupSortType>>;
};


export type QueryPreviewContactsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<PreviewContactSortType>>;
};


export type QueryProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramProofVariantListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
  proofVariantFilter: ProofVariantFilterInput;
  sendDate: Scalars['Date']['input'];
};


export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProofContactGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProofContactGroupsArgs = {
  channel?: InputMaybe<Channel>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<PreviewContactGroupSortType>>;
};


export type QueryProofContactsArgs = {
  channel?: InputMaybe<Channel>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<PreviewContactSortType>>;
};


export type QueryQueryCatalogArgs = {
  modelKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryQueryFetchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuerySelectFetchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecurringCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecurringCampaignMessageArgs = {
  id: Scalars['ID']['input'];
  useDraft?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRecurringCampaignMessageAvailableCreativesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RecurringCampaignAvailableCreativesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecurringCampaignMetricsV2Args = {
  filter: RecurringCampaignMetricsV2Filter;
};


export type QueryRecurringCampaignOccurrencesArgs = {
  filter?: InputMaybe<RecurringCampaignFilterInput>;
  startEndRange: Scalars['DateRange']['input'];
};


export type QueryRecurringCampaignProofVariantListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  proofVariantFilter: ProofVariantFilterInput;
  recurringCampaignId: Scalars['ID']['input'];
};


export type QueryRecurringCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RecurringCampaignFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecurringExportRemindersArgs = {
  viewType: ViewType;
};


export type QuerySavedFiltersArgs = {
  viewType: ViewType;
};


export type QuerySegmentExperimentMetricsArgs = {
  filter: SegmentExperimentMetricsFilter;
};


export type QuerySegmentGroupCampaignMetricsArgs = {
  filter: SegmentGroupCampaignMetricsFilter;
};


export type QuerySegmentGroupCreativeMetricsArgs = {
  filter: SegmentGroupCreativeMetricsFilter;
};


export type QuerySegmentGroupsMetricsArgs = {
  filter: SegmentGroupMetricsFilter;
};


export type QueryStudioCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryStudioCampaignsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubjectlinesMetricsArgs = {
  filter: SubjectLineMetricsFilter;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplatesArgs = {
  isMessageBuilderTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggeredCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTriggeredCampaignMessageArgs = {
  id: Scalars['ID']['input'];
  useDraft?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTriggeredCampaignMessageAvailableCreativesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TriggeredCampaignAvailableCreativesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTriggeredCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TriggeredCampaignFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPermissionsForAccountArgs = {
  clientId: Scalars['ID']['input'];
};

export type QueryDeleteSuccess = {
  __typename?: 'QueryDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type QuerySelectDeleteSuccess = {
  __typename?: 'QuerySelectDeleteSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type QuietHourRule = {
  __typename?: 'QuietHourRule';
  daysOfWeek: Array<DaysOfWeek>;
  endTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['Time']['output'];
};

export type QuietPeriodRule = {
  __typename?: 'QuietPeriodRule';
  endDatetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDatetime: Scalars['DateTime']['output'];
};

/** One calendar card — an RC's RRULE expanded to a single send date. */
export type RcCalendarItem = {
  __typename?: 'RCCalendarItem';
  isProjected: Scalars['Boolean']['output'];
  occurrenceId?: Maybe<Scalars['ID']['output']>;
  recurringCampaign: RecurringCampaignType;
  scheduledFor: Scalars['DateTime']['output'];
  status: RcCalendarItemStatus;
};

/** An enumeration. */
export enum RcCalendarItemStatus {
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED'
}

export type RateMetric = Metric & {
  __typename?: 'RateMetric';
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  stats?: Maybe<StatMetric>;
};

export type RateStatistics = {
  __typename?: 'RateStatistics';
  ciLower?: Maybe<Scalars['Float']['output']>;
  ciUpper?: Maybe<Scalars['Float']['output']>;
  confidenceLevel?: Maybe<Scalars['Float']['output']>;
  isStatisticallySignificant: Scalars['Boolean']['output'];
  lift?: Maybe<Scalars['Float']['output']>;
};

export type RecommendationRun = {
  __typename?: 'RecommendationRun';
  campaigns: Array<Campaign>;
  flowRunId?: Maybe<Scalars['UUID']['output']>;
  flowRunUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  runId: Scalars['Int']['output'];
  runType: RecommendationRunType;
  status: RecommendationRunStatus;
};

export type RecommendationRunCancel = {
  __typename?: 'RecommendationRunCancel';
  success: Scalars['Boolean']['output'];
};

export type RecommendationRunSchedule = {
  __typename?: 'RecommendationRunSchedule';
  campaignsIncluded: Array<Campaign>;
  campaignsNotIncluded: Array<Campaign>;
  runTime: Scalars['String']['output'];
  sendDate: Scalars['Date']['output'];
};

export type RecommendationRunStart = {
  __typename?: 'RecommendationRunStart';
  recommendationRun: RecommendationRun;
  success: Scalars['Boolean']['output'];
};

export enum RecommendationRunStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Open = 'OPEN',
  Running = 'RUNNING',
  Submitted = 'SUBMITTED',
  Terminated = 'TERMINATED',
  Terminating = 'TERMINATING',
  Unknown = 'UNKNOWN'
}

export enum RecommendationRunType {
  Dry = 'DRY',
  Proof = 'PROOF',
  Standard = 'STANDARD'
}

/** Cadence definition embedded in a RecurringCampaign. */
export type RecurrenceScheduleType = {
  __typename?: 'RecurrenceScheduleType';
  endDate?: Maybe<Scalars['Date']['output']>;
  rrule: Scalars['String']['output'];
  sendTime?: Maybe<Scalars['Time']['output']>;
  startDate: Scalars['Date']['output'];
  timezone: Scalars['String']['output'];
};

/**
 * A non-state verb available in the current stage. Availability is
 * inclusion in the list.
 */
export type RecurringCampaignAction = {
  __typename?: 'RecurringCampaignAction';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type RecurringCampaignAttributeUpdateSuccess = {
  __typename?: 'RecurringCampaignAttributeUpdateSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignAudienceExcludeResult = RecurringCampaignAudienceSuccess | ValidationErrors;

export type RecurringCampaignAudienceIncludeResult = RecurringCampaignAudienceSuccess | ValidationErrors;

export type RecurringCampaignAudienceRemoveResult = RecurringCampaignAudienceSuccess | ValidationErrors;

export type RecurringCampaignAudienceReorderResult = RecurringCampaignAudienceSuccess | ValidationErrors;

export type RecurringCampaignAudienceSuccess = {
  __typename?: 'RecurringCampaignAudienceSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignAvailableCreativesConnection = {
  __typename?: 'RecurringCampaignAvailableCreativesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecurringCampaignAvailableCreativesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RecurringCampaignAvailableCreatives` and its cursor. */
export type RecurringCampaignAvailableCreativesEdge = {
  __typename?: 'RecurringCampaignAvailableCreativesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Creative;
};

export type RecurringCampaignAvailableCreativesFilter = {
  pattern?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<RecurringCampaignCreativeStatus>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RecurringCampaignCheckboxAttributeUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignConnection = {
  __typename?: 'RecurringCampaignConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecurringCampaignEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type RecurringCampaignCreateResult = RecurringCampaignCreateSuccess | ValidationErrors;

export type RecurringCampaignCreateSuccess = {
  __typename?: 'RecurringCampaignCreateSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum RecurringCampaignCreativeStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Rejected = 'REJECTED'
}

export type RecurringCampaignCustomFieldAddResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignCustomFieldRemoveResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignCustomFieldUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignDateAttributeUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignDeleteResult = RecurringCampaignDeleteSuccess | ValidationErrors;

export type RecurringCampaignDeleteSuccess = {
  __typename?: 'RecurringCampaignDeleteSuccess';
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignDetailsUpdateResult = RecurringCampaignDetailsUpdateSuccess | ValidationErrors;

export type RecurringCampaignDetailsUpdateSuccess = {
  __typename?: 'RecurringCampaignDetailsUpdateSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignDuplicateResult = RecurringCampaignDuplicateSuccess | ValidationErrors;

export type RecurringCampaignDuplicateSuccess = {
  __typename?: 'RecurringCampaignDuplicateSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

/** A Relay edge containing a `RecurringCampaign` and its cursor. */
export type RecurringCampaignEdge = {
  __typename?: 'RecurringCampaignEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RecurringCampaignType;
};

export type RecurringCampaignEmailServiceProviderUpdateResult = RecurringCampaignEspConfigUpdateSuccess | ValidationErrors;

export type RecurringCampaignEspConfigUpdateSuccess = {
  __typename?: 'RecurringCampaignEspConfigUpdateSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignField = {
  __typename?: 'RecurringCampaignField';
  dataFieldId: Scalars['ID']['output'];
  isAccountLevel: Scalars['Boolean']['output'];
  override?: Maybe<ContactAudienceOverrideValue>;
};

export type RecurringCampaignFieldAddResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignFieldRemoveResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignFieldUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignFilterInput = {
  channel?: InputMaybe<Array<InputMaybe<Channel>>>;
  search?: InputMaybe<Scalars['SearchRecurringCampaignUID']['input']>;
  /** @deprecated Use statusGroups. */
  stageGroup?: InputMaybe<Array<InputMaybe<RecurringCampaignStageGroup>>>;
  statusGroups?: InputMaybe<Array<CampaignStatusGroupType>>;
};

export type RecurringCampaignInboxPreviewType = {
  __typename?: 'RecurringCampaignInboxPreviewType';
  id: Scalars['ID']['output'];
  preheaderDynamicBlockId?: Maybe<Scalars['ID']['output']>;
  preheaderType?: Maybe<Scalars['String']['output']>;
  subjectLineDynamicBlockId?: Maybe<Scalars['ID']['output']>;
  subjectLinePrefix: Scalars['String']['output'];
  subjectLineSuffix: Scalars['String']['output'];
  subjectLineType?: Maybe<Scalars['String']['output']>;
};

export type RecurringCampaignListAttributeUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignMessageAddDynamicBlockResult = RecurringCampaignMessageAddDynamicBlockSuccess | ValidationErrors;

export type RecurringCampaignMessageAddDynamicBlockSuccess = {
  __typename?: 'RecurringCampaignMessageAddDynamicBlockSuccess';
  blockId: Scalars['String']['output'];
  slotUri: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignMessageDiscardResult = RecurringCampaignMessageDiscardSuccess | ValidationErrors;

export type RecurringCampaignMessageDiscardSuccess = {
  __typename?: 'RecurringCampaignMessageDiscardSuccess';
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignMessageDynamicBlockExperienceCreateResult = RecurringCampaignMessageDynamicBlockExperienceCreateSuccess | ValidationErrors;

export type RecurringCampaignMessageDynamicBlockExperienceCreateSuccess = {
  __typename?: 'RecurringCampaignMessageDynamicBlockExperienceCreateSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignMessageDynamicBlockExperienceType = {
  __typename?: 'RecurringCampaignMessageDynamicBlockExperienceType';
  creativeLayout?: Maybe<Layout>;
  id: Scalars['ID']['output'];
  selectedCreative?: Maybe<Creative>;
};

export type RecurringCampaignMessageDynamicBlockType = {
  __typename?: 'RecurringCampaignMessageDynamicBlockType';
  experience?: Maybe<RecurringCampaignMessageDynamicBlockExperienceType>;
  id: Scalars['ID']['output'];
  slot: Scalars['String']['output'];
};

export type RecurringCampaignMessageExperienceSelectCreativeResult = RecurringCampaignMessageExperienceSelectCreativeSuccess | ValidationErrors;

export type RecurringCampaignMessageExperienceSelectCreativeSuccess = {
  __typename?: 'RecurringCampaignMessageExperienceSelectCreativeSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignMessageInboxPreviewUpdateInput = {
  preheaderDynamicBlockId?: InputMaybe<Scalars['ID']['input']>;
  subjectLineDynamicBlockId?: InputMaybe<Scalars['ID']['input']>;
  subjectLinePrefix?: InputMaybe<Scalars['String']['input']>;
  subjectLineSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringCampaignMessageInboxPreviewUpdateResult = RecurringCampaignMessageInboxPreviewUpdateSuccess | ValidationErrors;

export type RecurringCampaignMessageInboxPreviewUpdateSuccess = {
  __typename?: 'RecurringCampaignMessageInboxPreviewUpdateSuccess';
  inboxPreview: RecurringCampaignInboxPreviewType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignMessageLayoutUpdateResult = RecurringCampaignMessageLayoutUpdateSuccess | ValidationErrors;

export type RecurringCampaignMessageLayoutUpdateSuccess = {
  __typename?: 'RecurringCampaignMessageLayoutUpdateSuccess';
  success: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RecurringCampaignMessageSaveResult = RecurringCampaignMessageSaveSuccess | ValidationErrors;

export type RecurringCampaignMessageSaveSuccess = {
  __typename?: 'RecurringCampaignMessageSaveSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignMessageType = {
  __typename?: 'RecurringCampaignMessageType';
  dynamicBlocks: Array<RecurringCampaignMessageDynamicBlockType>;
  id: Scalars['ID']['output'];
  inboxPreview?: Maybe<RecurringCampaignInboxPreviewType>;
  layoutDocument?: Maybe<Scalars['RecurringCampaignMessageLayoutDocument']['output']>;
  recurringCampaign?: Maybe<RecurringCampaignType>;
};


export type RecurringCampaignMessageTypeDynamicBlocksArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RecurringCampaignMetricV2 = {
  __typename?: 'RecurringCampaignMetricV2';
  metrics: Array<Maybe<Metric>>;
  recurringCampaign: RecurringCampaignType;
};

export type RecurringCampaignMetricsV2 = {
  __typename?: 'RecurringCampaignMetricsV2';
  recurringCampaigns?: Maybe<Array<RecurringCampaignMetricV2>>;
  summary: Array<Maybe<Metric>>;
};

export type RecurringCampaignMetricsV2Filter = {
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeRecurringCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeRecurringCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeRecurringCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringCampaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringCampaignStages?: InputMaybe<Array<RecurringCampaignStage>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type RecurringCampaignScheduleUpdateInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  sendTime?: InputMaybe<Scalars['Time']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type RecurringCampaignScheduleUpdateResult = RecurringCampaignScheduleUpdateSuccess | ValidationErrors;

export type RecurringCampaignScheduleUpdateSuccess = {
  __typename?: 'RecurringCampaignScheduleUpdateSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

export type RecurringCampaignSeedAudienceAddResult = RecurringCampaignAudienceSuccess | ValidationErrors;

export type RecurringCampaignSeedAudienceRemoveResult = RecurringCampaignAudienceSuccess | ValidationErrors;

export type RecurringCampaignSelectAttributeUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignSelectTrackingParameterUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

/** An enumeration. */
export enum RecurringCampaignStage {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Preparing = 'PREPARING',
  PreparingProofs = 'PREPARING_PROOFS',
  Proofed = 'PROOFED',
  ReadyToPrepare = 'READY_TO_PREPARE',
  ReadyToPrepareProofs = 'READY_TO_PREPARE_PROOFS',
  ReadyToProof = 'READY_TO_PROOF',
  ReadyToSchedule = 'READY_TO_SCHEDULE',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT',
  Suspended = 'SUSPENDED',
  Syncing = 'SYNCING',
  Terminated = 'TERMINATED',
  Upcoming = 'UPCOMING'
}

/** An enumeration. */
export enum RecurringCampaignStageGroup {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Proofing = 'PROOFING',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

/**
 * Legal user status transitions, CTA-priority ordered, plus the
 * stage's non-state actions.
 */
export type RecurringCampaignStateInfo = {
  __typename?: 'RecurringCampaignStateInfo';
  actions: Array<RecurringCampaignAction>;
  state: RecurringCampaignStatus;
  transitions: Array<RecurringCampaignTransition>;
};

export type RecurringCampaignStateTransitionResult = RecurringCampaignStateTransitionSuccess | ValidationErrors;

export type RecurringCampaignStateTransitionSuccess = {
  __typename?: 'RecurringCampaignStateTransitionSuccess';
  recurringCampaign: RecurringCampaignType;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum RecurringCampaignStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Locked = 'LOCKED',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

/**
 * Latest status change; drives the header's "{label} {date} by {user}"
 * string. user is null only for system rows (ERROR).
 */
export type RecurringCampaignStatusLog = {
  __typename?: 'RecurringCampaignStatusLog';
  label: Scalars['String']['output'];
  status: RecurringCampaignStatus;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<RecurringCampaignStatusUser>;
};

export type RecurringCampaignStatusUser = {
  __typename?: 'RecurringCampaignStatusUser';
  fullName: Scalars['String']['output'];
};

export type RecurringCampaignTextAttributeUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignTextTrackingParameterUpdateResult = RecurringCampaignAttributeUpdateSuccess | ValidationErrors;

export type RecurringCampaignTransition = {
  __typename?: 'RecurringCampaignTransition';
  label: Scalars['String']['output'];
  permission: RecurringCampaignTransitionPermission;
  state: RecurringCampaignStatus;
};

export type RecurringCampaignTransitionPermission = RecurringCampaignTransitionPermissionAllowed | RecurringCampaignTransitionPermissionDenied;

export type RecurringCampaignTransitionPermissionAllowed = {
  __typename?: 'RecurringCampaignTransitionPermissionAllowed';
  allowed: Scalars['Boolean']['output'];
};

export type RecurringCampaignTransitionPermissionDenied = {
  __typename?: 'RecurringCampaignTransitionPermissionDenied';
  allowed: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/**
 * A recurring campaign. Resolves both a RecurringCampaign row and, until
 * the remaining mutations cut over, a mock campaign from the fixture store.
 */
export type RecurringCampaignType = {
  __typename?: 'RecurringCampaignType';
  /** @deprecated Folded into `stage` (UPCOMING/SCHEDULED/SENDING/SENT). Always null; will be removed once the FE drops its selections. */
  activeSubStatus?: Maybe<ActiveSubStatus>;
  attributes: Array<Attribute>;
  availableSendTimes: Array<Scalars['Time']['output']>;
  campaignTemplate?: Maybe<CampaignTemplate>;
  channel: ChannelSpec;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<CustomField>;
  emailServiceProvider?: Maybe<EmailServiceProvider>;
  espConfig?: Maybe<EspConfig>;
  excludedAudiences: Array<MessageSourceAudienceType>;
  fields?: Maybe<Array<RecurringCampaignField>>;
  hasPastMailings: Scalars['Boolean']['output'];
  hashid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  includedAudiences: Array<MessageSourceAudienceType>;
  lastStatus: RecurringCampaignStatusLog;
  messageExtraKeys: Array<MessageExtraKey>;
  messageExtras: Array<MessageExtra>;
  nextOccurrence?: Maybe<Scalars['DateTime']['output']>;
  preheaderText?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<RecurrenceScheduleType>;
  seedContactAudiences?: Maybe<Array<ContactAudience>>;
  stage: RecurringCampaignStage;
  stageGroup: RecurringCampaignStageGroup;
  stateInfo: RecurringCampaignStateInfo;
  status: RecurringCampaignStatus;
  subjectLine?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  trackingParameters: Array<Attribute>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RecurringExportReminderDeleteResponse = {
  __typename?: 'RecurringExportReminderDeleteResponse';
  success: Scalars['Boolean']['output'];
};

export type RecurringExportReminderResponse = {
  __typename?: 'RecurringExportReminderResponse';
  reminder: RecurringExportReminderType;
};

export type RecurringExportReminderType = {
  __typename?: 'RecurringExportReminderType';
  attachCsv?: Maybe<Scalars['Boolean']['output']>;
  columns: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customDateRange?: Maybe<Scalars['DateRange']['output']>;
  filterData: Scalars['JSONString']['output'];
  /** @deprecated Use groupByFields; groupBy only supports a single grouping. */
  groupBy?: Maybe<CampaignGroupBy>;
  groupByFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  includeMetadata: Scalars['Boolean']['output'];
  predefinedDateRange?: Maybe<PredefinedDateRange>;
  recipients: Array<Scalars['String']['output']>;
  schedule: ReminderSchedule;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewType: ViewType;
};

export type ReminderSchedule = {
  __typename?: 'ReminderSchedule';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
};

export type ReminderScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
};

export type Render = {
  __typename?: 'Render';
  contentBlock: ContentBlock;
  downloadLink?: Maybe<Scalars['String']['output']>;
  size: RenderSize;
  url: Scalars['String']['output'];
};

export enum RenderSize {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type ReuseRule = {
  __typename?: 'ReuseRule';
  id: Scalars['ID']['output'];
  otherClickDelay?: Maybe<Scalars['Duration']['output']>;
  otherConversionDelay?: Maybe<Scalars['Duration']['output']>;
  otherMaxUses?: Maybe<Scalars['Int']['output']>;
  otherOpenDelay?: Maybe<Scalars['Duration']['output']>;
  otherSendDelay?: Maybe<Scalars['Duration']['output']>;
  primaryClickDelay?: Maybe<Scalars['Duration']['output']>;
  primaryConversionDelay?: Maybe<Scalars['Duration']['output']>;
  primaryMaxUses?: Maybe<Scalars['Int']['output']>;
  primaryOpenDelay?: Maybe<Scalars['Duration']['output']>;
  primarySendDelay?: Maybe<Scalars['Duration']['output']>;
};

export type ReuseRuleInput = {
  otherClickDelay?: InputMaybe<Scalars['Duration']['input']>;
  otherConversionDelay?: InputMaybe<Scalars['Duration']['input']>;
  otherMaxUses: Scalars['Int']['input'];
  otherOpenDelay?: InputMaybe<Scalars['Duration']['input']>;
  otherSendDelay?: InputMaybe<Scalars['Duration']['input']>;
  primaryClickDelay?: InputMaybe<Scalars['Duration']['input']>;
  primaryConversionDelay?: InputMaybe<Scalars['Duration']['input']>;
  primaryMaxUses: Scalars['Int']['input'];
  primaryOpenDelay?: InputMaybe<Scalars['Duration']['input']>;
  primarySendDelay?: InputMaybe<Scalars['Duration']['input']>;
};

export type Role = {
  __typename?: 'Role';
  accountId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  title: Scalars['String']['output'];
};

export type SfNext = {
  __typename?: 'SFNext';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SmsProofVariant = {
  __typename?: 'SMSProofVariant';
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  recipients: Scalars['Int']['output'];
  runId: Scalars['Int']['output'];
  type: ProofVariantType;
};

export type SalesForceMarketingCloud = {
  __typename?: 'SalesForceMarketingCloud';
  defaultLinkMetadata?: Maybe<SalesforceMarketingCloudDefaultLinkMetadata>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredLinkMetadataFields: Array<SalesForceRequiredLinkMetaDataFields>;
};

export enum SalesForceRequiredLinkMetaDataFields {
  Alias = 'ALIAS'
}

export type SalesforceMarketingCloudDefaultLinkMetadata = {
  __typename?: 'SalesforceMarketingCloudDefaultLinkMetadata';
  enableConversionTracking: Scalars['Boolean']['output'];
  enableDeepLinks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  requiresAlias: Scalars['Boolean']['output'];
};

export type SavedFilterDeleteResponse = {
  __typename?: 'SavedFilterDeleteResponse';
  success: Scalars['Boolean']['output'];
};

export type SavedFilterMetadataEntry = {
  __typename?: 'SavedFilterMetadataEntry';
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SavedFilterResponse = {
  __typename?: 'SavedFilterResponse';
  savedFilter: SavedFilterType;
};

export type SavedFilterType = {
  __typename?: 'SavedFilterType';
  createdAt: Scalars['DateTime']['output'];
  customDateRange?: Maybe<Scalars['DateRange']['output']>;
  filterData: Scalars['JSONString']['output'];
  filterMetadata: Array<SavedFilterMetadataEntry>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  predefinedDateRange?: Maybe<PredefinedDateRange>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewType: ViewType;
};

export type SavedViewFilter = {
  __typename?: 'SavedViewFilter';
  field: Scalars['String']['output'];
  operator: FilterOperator;
  values: Array<Scalars['String']['output']>;
};

export type SavedViewFilterInput = {
  field: Scalars['String']['input'];
  operator: FilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type Scope = {
  __typename?: 'Scope';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ScopeCategory = {
  __typename?: 'ScopeCategory';
  name: Scalars['String']['output'];
  scopes: Array<Scope>;
};

export type ScoreMetric = Metric & {
  __typename?: 'ScoreMetric';
  group?: Maybe<MetricGroup>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export type Section = {
  contentBlock: ContentBlock;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  zone?: Maybe<Zone>;
};

export type SectionAxes = {
  __typename?: 'SectionAxes';
  audiences: Array<Scalars['ID']['output']>;
  experiment?: Maybe<Scalars['ID']['output']>;
};

export type SegmentAudienceBuildInputConfig = {
  splits: Array<Scalars['ContactQuery']['input']>;
};

export type SegmentComparisonFilter = {
  baselineSegmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupSegmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SegmentExperimentMetrics = {
  __typename?: 'SegmentExperimentMetrics';
  experiment: Experiment;
  treatments?: Maybe<Array<SegmentTreatmentMetrics>>;
};

export type SegmentExperimentMetricsFilter = {
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SegmentGroupCampaignMetrics = {
  __typename?: 'SegmentGroupCampaignMetrics';
  campaign: Campaign;
  segments?: Maybe<Array<CampaignSegmentMetrics>>;
};

export type SegmentGroupCampaignMetricsFilter = {
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SegmentGroupCreativeMetrics = {
  __typename?: 'SegmentGroupCreativeMetrics';
  creative: Creative;
  segments?: Maybe<Array<CreativeSegmentMetrics>>;
};

export type SegmentGroupCreativeMetricsFilter = {
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SegmentGroupMetrics = {
  __typename?: 'SegmentGroupMetrics';
  audience: ContactAudience;
  segments?: Maybe<Array<SegmentMetrics>>;
};

export type SegmentGroupMetricsFilter = {
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SegmentMetrics = {
  __typename?: 'SegmentMetrics';
  metrics: Array<Maybe<Metric>>;
  segment?: Maybe<ContactSegment>;
  split?: Maybe<ContactAudienceSplit>;
};

export type SegmentTreatmentMetrics = {
  __typename?: 'SegmentTreatmentMetrics';
  splits?: Maybe<Array<SegmentMetrics>>;
  treatment: ExperimentTreatment;
};

export type SelectAttribute = Attribute & {
  __typename?: 'SelectAttribute';
  definition: SelectAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  options: Array<AttributeOption>;
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
};

export type SelectAttribute2 = Attribute & {
  __typename?: 'SelectAttribute2';
  definition: SelectAttributeDefinition2;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  selectedId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
};

export type SelectAttributeDefinition = AttributeDefinition & {
  __typename?: 'SelectAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<AttributeOption>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type SelectAttributeDefinition2 = AttributeDefinition & {
  __typename?: 'SelectAttributeDefinition2';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<AttributeOption2>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type SelectTemplateTag = TemplateTag & {
  __typename?: 'SelectTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Array<Maybe<TemplateTagOption>>>;
};

export type SemanticCategory = {
  __typename?: 'SemanticCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SemanticFeature = {
  __typename?: 'SemanticFeature';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SendDatetimeTreatment = {
  __typename?: 'SendDatetimeTreatment';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum SendDatetimeType {
  Ranges = 'RANGES',
  Static = 'STATIC'
}

export type SendSchedule = PersonalizedSendSchedule | StaticSendSchedule;

export type SendScheduleVariant = {
  __typename?: 'SendScheduleVariant';
  id: Scalars['ID']['output'];
  schedule?: Maybe<SendSchedule>;
  treatment?: Maybe<TreatmentSendDatetime>;
};

export type SendSupportTicket = {
  __typename?: 'SendSupportTicket';
  success: Scalars['Boolean']['output'];
  ticketId: Scalars['Int']['output'];
};

export type SendWindow = {
  __typename?: 'SendWindow';
  endTime: Scalars['Time']['output'];
  startTime: Scalars['Time']['output'];
};

export type SidneySession = {
  __typename?: 'SidneySession';
  id: Scalars['ID']['output'];
  subjectLines: Array<SubjectLine>;
};

export type SnapshotCount = {
  __typename?: 'SnapshotCount';
  id: Scalars['ID']['output'];
  /** @deprecated Removed upstream. Do not use this field */
  initTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SourceType {
  AiAssisted = 'AI_ASSISTED',
  AiGenerated = 'AI_GENERATED',
  Handcrafted = 'HANDCRAFTED'
}

export type StatMetric = {
  __typename?: 'StatMetric';
  ciLower?: Maybe<Scalars['Float']['output']>;
  ciUpper?: Maybe<Scalars['Float']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  lift?: Maybe<Scalars['Float']['output']>;
  significant: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum State {
  Active = 'ACTIVE',
  Draft = 'DRAFT'
}

export type StateAction = {
  __typename?: 'StateAction';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type StaticMessage = {
  __typename?: 'StaticMessage';
  message?: Maybe<Scalars['String']['output']>;
};

export type StaticMessageWithLink = {
  __typename?: 'StaticMessageWithLink';
  link?: Maybe<Link>;
  message?: Maybe<Scalars['String']['output']>;
};

export type StaticPreheader = {
  __typename?: 'StaticPreheader';
  link?: Maybe<Link>;
  preheaderText?: Maybe<Scalars['String']['output']>;
  previewText?: Maybe<Scalars['String']['output']>;
};

export type StaticPreheaderAndPreview = {
  linkId?: InputMaybe<Scalars['ID']['input']>;
  preheader?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
};

export type StaticPreheaderWithPreview = {
  __typename?: 'StaticPreheaderWithPreview';
  link?: Maybe<Link>;
  preheader?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
};

export type StaticSection = Section & {
  __typename?: 'StaticSection';
  contentBlock: ContentBlock;
  id: Scalars['ID']['output'];
  isExpanded: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  zone?: Maybe<Zone>;
};

export type StaticSendSchedule = {
  __typename?: 'StaticSendSchedule';
  datetime: Scalars['DateTime']['output'];
};

export type StaticSubjectLinePrefix = {
  __typename?: 'StaticSubjectLinePrefix';
  value?: Maybe<Scalars['String']['output']>;
};

export type StaticSubjectLineSuffix = {
  __typename?: 'StaticSubjectLineSuffix';
  value?: Maybe<Scalars['String']['output']>;
};

export type StudioAuthorizationRequired = {
  __typename?: 'StudioAuthorizationRequired';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioBlock = {
  __typename?: 'StudioBlock';
  altText?: Maybe<Scalars['String']['output']>;
  clickthroughUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dynamicFields: Array<DynamicField>;
  embedCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  titleText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StudioBlockImport = {
  __typename?: 'StudioBlockImport';
  altText?: Maybe<Scalars['String']['output']>;
  backingLink?: Maybe<Link2>;
  dynamicFields?: Maybe<Array<Maybe<DynamicField>>>;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  studioBlockId: Scalars['ID']['output'];
};

export type StudioCampaign = {
  __typename?: 'StudioCampaign';
  blockCount: Scalars['Int']['output'];
  blocks: Array<StudioBlock>;
  campaignCode?: Maybe<Scalars['String']['output']>;
  campaignTrackingUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StudioCampaignImport = {
  __typename?: 'StudioCampaignImport';
  blocks: Array<StudioBlockImport>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  studioId: Scalars['ID']['output'];
};

export type StudioCampaignPagination = {
  __typename?: 'StudioCampaignPagination';
  page: Scalars['Int']['output'];
  results: Array<StudioCampaign>;
};

export type StudioCampaignResult = StudioAuthorizationRequired | StudioCampaign;

export type StudioCampaignsResult = StudioAuthorizationRequired | StudioCampaignPagination;

export type SubjectLine = {
  __typename?: 'SubjectLine';
  content: Scalars['String']['output'];
  creative: Creative;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  source?: Maybe<SourceType>;
  tone?: Maybe<Scalars['String']['output']>;
};

export type SubjectLineChunk = DynamicContent | NoContent | StaticMessage;

export enum SubjectLineChunkMode {
  Dynamic = 'Dynamic',
  NoContent = 'NoContent',
  Persado = 'Persado',
  SameForAll = 'SameForAll'
}

export type SubjectLineMetric = {
  __typename?: 'SubjectLineMetric';
  metrics: Array<Maybe<Metric>>;
  subjectline: SubjectLine;
};

export type SubjectLineMetrics = {
  __typename?: 'SubjectLineMetrics';
  subjectlines?: Maybe<Array<SubjectLineMetric>>;
};

export type SubjectLineMetricsFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<SubjectLineSourceType>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  subjectlineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tones?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubjectLinePrefix = DynamicSubjectLinePrefix | StaticSubjectLinePrefix;

/** An enumeration. */
export enum SubjectLineSourceType {
  AiAssisted = 'AI_ASSISTED',
  Generated = 'GENERATED',
  Manual = 'MANUAL',
  Prompt = 'PROMPT'
}

export enum SubjectLineStrategy {
  None = 'NONE',
  Personalized = 'PERSONALIZED',
  Primary = 'PRIMARY',
  Random = 'RANDOM',
  Rotating = 'ROTATING'
}

export type SubjectLineStrategyTreatment = {
  __typename?: 'SubjectLineStrategyTreatment';
  control: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type SubjectLineStrategyVariant = {
  __typename?: 'SubjectLineStrategyVariant';
  id: Scalars['String']['output'];
  strategy: SubjectLineStrategy;
  /** @deprecated This field is deprecated use treatment_new instead */
  treatment?: Maybe<SubjectLineStrategyTreatment>;
  treatmentNew?: Maybe<TreatmentSubjectLineStrategy>;
};

export type SubjectLineSuffix = DynamicSubjectLineSuffix | StaticSubjectLineSuffix;

export enum SubjectLineType {
  Dynamic = 'DYNAMIC',
  Persado = 'PERSADO',
  Static = 'STATIC'
}

export type SubjectlineMetrics = {
  __typename?: 'SubjectlineMetrics';
  metrics: BaseMetrics;
  subjectline: SubjectLine;
};

/** An enumeration. */
export enum SubjectlineStrategy {
  None = 'NONE',
  Personalized = 'PERSONALIZED',
  Primary = 'PRIMARY',
  Random = 'RANDOM',
  Rotating = 'ROTATING'
}

export type SubjectlineStrategyVariant = {
  __typename?: 'SubjectlineStrategyVariant';
  strategy: SubjectlineStrategy;
  treatment?: Maybe<TreatmentSubjectLineStrategy>;
};

export type SuspendPlatformApplicationSuccess = {
  __typename?: 'SuspendPlatformApplicationSuccess';
  application: PlatformApplication;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum System {
  Approval = 'APPROVAL',
  Audience = 'AUDIENCE',
  Deletion = 'DELETION',
  Experiences = 'EXPERIENCES',
  Inbox = 'INBOX',
  LockForProofing = 'LOCK_FOR_PROOFING',
  Schedule = 'SCHEDULE',
  Settings = 'SETTINGS',
  System = 'SYSTEM',
  Template = 'TEMPLATE'
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TargetRule = {
  __typename?: 'TargetRule';
  splits: Array<Scalars['ID']['output']>;
  treatment?: Maybe<Scalars['ID']['output']>;
};

export type TargetRuleInput = {
  splits: Array<Scalars['ID']['input']>;
  treatment?: InputMaybe<Scalars['ID']['input']>;
};

export type Template = {
  __typename?: 'Template';
  contentBlocks?: Maybe<Array<ContentBlock>>;
  description?: Maybe<Scalars['String']['output']>;
  dynamicContentBlockCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isMessageBuilderTemplate: Scalars['Boolean']['output'];
  staticContentBlockCount?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type TemplateDrift = {
  __typename?: 'TemplateDrift';
  sectionChanged: Scalars['Boolean']['output'];
  templateChanged: Scalars['Boolean']['output'];
};

export type TemplatePaginatedType = {
  __typename?: 'TemplatePaginatedType';
  page: Scalars['Int']['output'];
  results: Array<Template>;
  total: Scalars['Int']['output'];
};

export type TemplateTag = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum TemplateTagConstraint {
  Empty = 'EMPTY',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type TemplateTagOption = {
  __typename?: 'TemplateTagOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type TextAreaTemplateTag = TemplateTag & {
  __typename?: 'TextAreaTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TextAttribute = Attribute & {
  __typename?: 'TextAttribute';
  definition: TextAttributeDefinition;
  /** @deprecated Use definition */
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use definition */
  multiline: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use definition */
  required: Scalars['Boolean']['output'];
  /** @deprecated Use definition */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TextAttributeDefinition = AttributeDefinition & {
  __typename?: 'TextAttributeDefinition';
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  multiline: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type TextCustomField = CustomField & {
  __typename?: 'TextCustomField';
  id: Scalars['ID']['output'];
  /** @deprecated Removed from API */
  overrideMode?: Maybe<OverrideMode>;
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TextMessage = Content & {
  __typename?: 'TextMessage';
  body: Scalars['String']['output'];
  channel: Channel;
  id: Scalars['ID']['output'];
  languageCode: Scalars['Language']['output'];
  media?: Maybe<Media2>;
  shortenLinks: Scalars['Boolean']['output'];
};

export type TextMessageInput = {
  body: Scalars['String']['input'];
  mediaUri?: InputMaybe<Scalars['String']['input']>;
  shortenLinks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextMessageSuccess = {
  __typename?: 'TextMessageSuccess';
  success: Scalars['Boolean']['output'];
  textMessage: TextMessage;
};

export type TextTemplateTag = TemplateTag & {
  __typename?: 'TextTemplateTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  downloadLink?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** Timestamp granularity (date vs datetime) for custom event categories. */
export enum TimestampType {
  TimestampTypeDate = 'TIMESTAMP_TYPE_DATE',
  TimestampTypeDatetime = 'TIMESTAMP_TYPE_DATETIME',
  TimestampTypeUnspecified = 'TIMESTAMP_TYPE_UNSPECIFIED'
}

export type TrackingParameterInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TrackingToken = {
  __typename?: 'TrackingToken';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  mode: TrackingTokenMode;
  name: Scalars['String']['output'];
  scope: TrackingTokenScope;
  updatedAt: Scalars['DateTime']['output'];
};

export type TrackingTokenCreate = {
  __typename?: 'TrackingTokenCreate';
  success: Scalars['Boolean']['output'];
  token: TrackingToken;
};

export type TrackingTokenDelete = {
  __typename?: 'TrackingTokenDelete';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export enum TrackingTokenMode {
  Live = 'LIVE',
  Test = 'TEST'
}

export type TrackingTokenRename = {
  __typename?: 'TrackingTokenRename';
  success: Scalars['Boolean']['output'];
  token: TrackingToken;
};

export enum TrackingTokenScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Transition = {
  __typename?: 'Transition';
  label: Scalars['String']['output'];
  permission: TransitionPermission;
  state: ProgramStateType;
};

export type TransitionPermission = TransitionPermissionAllowed | TransitionPermissionDenied;

export type TransitionPermissionAllowed = {
  __typename?: 'TransitionPermissionAllowed';
  allowed: Scalars['Boolean']['output'];
};

export type TransitionPermissionDenied = {
  __typename?: 'TransitionPermissionDenied';
  allowed: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Treatment = TreatmentAdhoc | TreatmentContentPersonalizationModel | TreatmentEligibleCreatives | TreatmentProxyControl | TreatmentSendDatetime | TreatmentSendTimePersonalizationModel | TreatmentSubjectLinePersonalizationModel | TreatmentSubjectLineStrategy | TreatmentTemplate;

export type TreatmentAdhoc = {
  __typename?: 'TreatmentAdhoc';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentComparisonFilter = {
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaignStages?: InputMaybe<Array<CampaignStageType>>;
  channel?: InputMaybe<Channel>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isStatic?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TreatmentContactMetrics = {
  __typename?: 'TreatmentContactMetrics';
  metrics: Array<Maybe<Metric>>;
  treatment: ExperimentTreatment;
};

export type TreatmentContentPersonalizationModel = {
  __typename?: 'TreatmentContentPersonalizationModel';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentEligibleCreatives = {
  __typename?: 'TreatmentEligibleCreatives';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentMetrics = {
  __typename?: 'TreatmentMetrics';
  metrics: Array<Maybe<Metric>>;
  treatment: ExperimentTreatment;
};

export type TreatmentProxyControl = {
  __typename?: 'TreatmentProxyControl';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentSegmentMetrics = {
  __typename?: 'TreatmentSegmentMetrics';
  split: ContactAudienceSplit;
  treatments?: Maybe<Array<TreatmentMetrics>>;
};

export type TreatmentSendDatetime = {
  __typename?: 'TreatmentSendDatetime';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentSendTimePersonalizationModel = {
  __typename?: 'TreatmentSendTimePersonalizationModel';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentSubjectLinePersonalizationModel = {
  __typename?: 'TreatmentSubjectLinePersonalizationModel';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentSubjectLineStrategy = {
  __typename?: 'TreatmentSubjectLineStrategy';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TreatmentTemplate = {
  __typename?: 'TreatmentTemplate';
  control: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** An enumeration. */
export enum TriggerSource {
  Journey = 'JOURNEY',
  PatternEngine = 'PATTERN_ENGINE',
  PublicApi = 'PUBLIC_API'
}

export type TriggeredCampaignAttributeUpdateSuccess = {
  __typename?: 'TriggeredCampaignAttributeUpdateSuccess';
  success: Scalars['Boolean']['output'];
  triggeredCampaign: TriggeredCampaignType;
};

export type TriggeredCampaignAudienceExcludeResult = TriggeredCampaignAudienceSuccess | ValidationErrors;

export type TriggeredCampaignAudienceIncludeResult = TriggeredCampaignAudienceSuccess | ValidationErrors;

export type TriggeredCampaignAudienceRemoveResult = TriggeredCampaignAudienceSuccess | ValidationErrors;

export type TriggeredCampaignAudienceReorderResult = TriggeredCampaignAudienceSuccess | ValidationErrors;

export type TriggeredCampaignAudienceSuccess = {
  __typename?: 'TriggeredCampaignAudienceSuccess';
  success: Scalars['Boolean']['output'];
  triggeredCampaign: TriggeredCampaignType;
};

export type TriggeredCampaignAvailableCreativesConnection = {
  __typename?: 'TriggeredCampaignAvailableCreativesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TriggeredCampaignAvailableCreativesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TriggeredCampaignAvailableCreatives` and its cursor. */
export type TriggeredCampaignAvailableCreativesEdge = {
  __typename?: 'TriggeredCampaignAvailableCreativesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Creative;
};

export type TriggeredCampaignAvailableCreativesFilter = {
  pattern?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TriggeredCampaignCreativeStatus>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TriggeredCampaignCheckboxAttributeUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignConnection = {
  __typename?: 'TriggeredCampaignConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TriggeredCampaignEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type TriggeredCampaignCreateResult = TriggeredCampaignCreateSuccess | ValidationErrors;

export type TriggeredCampaignCreateSuccess = {
  __typename?: 'TriggeredCampaignCreateSuccess';
  success: Scalars['Boolean']['output'];
  triggeredCampaign: TriggeredCampaignType;
};

/** An enumeration. */
export enum TriggeredCampaignCreativeStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Rejected = 'REJECTED'
}

export type TriggeredCampaignCustomFieldAddResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignCustomFieldRemoveResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignCustomFieldUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignDateAttributeUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignDeleteResult = TriggeredCampaignDeleteSuccess | ValidationErrors;

export type TriggeredCampaignDeleteSuccess = {
  __typename?: 'TriggeredCampaignDeleteSuccess';
  success: Scalars['Boolean']['output'];
};

export type TriggeredCampaignDetailsUpdateResult = TriggeredCampaignDetailsUpdateSuccess | ValidationErrors;

export type TriggeredCampaignDetailsUpdateSuccess = {
  __typename?: 'TriggeredCampaignDetailsUpdateSuccess';
  success: Scalars['Boolean']['output'];
  triggeredCampaign: TriggeredCampaignType;
};

/** A Relay edge containing a `TriggeredCampaign` and its cursor. */
export type TriggeredCampaignEdge = {
  __typename?: 'TriggeredCampaignEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TriggeredCampaignType;
};

export type TriggeredCampaignEmailServiceProviderUpdateResult = TriggeredCampaignEspConfigUpdateSuccess | ValidationErrors;

export type TriggeredCampaignEspConfigUpdateSuccess = {
  __typename?: 'TriggeredCampaignEspConfigUpdateSuccess';
  success: Scalars['Boolean']['output'];
  triggeredCampaign: TriggeredCampaignType;
};

export type TriggeredCampaignFilterInput = {
  channel?: InputMaybe<Array<InputMaybe<Channel>>>;
  search?: InputMaybe<Scalars['SearchTriggeredCampaignUID']['input']>;
  status?: InputMaybe<Array<InputMaybe<TriggeredCampaignStatus>>>;
  triggerSource?: InputMaybe<Array<InputMaybe<TriggerSource>>>;
};

export type TriggeredCampaignInboxPreviewType = {
  __typename?: 'TriggeredCampaignInboxPreviewType';
  id: Scalars['ID']['output'];
  preheaderDynamicBlockId?: Maybe<Scalars['ID']['output']>;
  preheaderType?: Maybe<Scalars['String']['output']>;
  subjectLineDynamicBlockId?: Maybe<Scalars['ID']['output']>;
  subjectLinePrefix: Scalars['String']['output'];
  subjectLineSuffix: Scalars['String']['output'];
  subjectLineType?: Maybe<Scalars['String']['output']>;
};

export type TriggeredCampaignJourneyBindingType = {
  __typename?: 'TriggeredCampaignJourneyBindingType';
  journeyId: Scalars['String']['output'];
  journeyNodeId: Scalars['String']['output'];
};

export type TriggeredCampaignListAttributeUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignMessageAddDynamicBlockResult = TriggeredCampaignMessageAddDynamicBlockSuccess | ValidationErrors;

export type TriggeredCampaignMessageAddDynamicBlockSuccess = {
  __typename?: 'TriggeredCampaignMessageAddDynamicBlockSuccess';
  blockId: Scalars['String']['output'];
  slotUri: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TriggeredCampaignMessageDiscardResult = TriggeredCampaignMessageDiscardSuccess | ValidationErrors;

export type TriggeredCampaignMessageDiscardSuccess = {
  __typename?: 'TriggeredCampaignMessageDiscardSuccess';
  success: Scalars['Boolean']['output'];
};

export type TriggeredCampaignMessageDynamicBlockExperienceCreateResult = TriggeredCampaignMessageDynamicBlockExperienceCreateSuccess | ValidationErrors;

export type TriggeredCampaignMessageDynamicBlockExperienceCreateSuccess = {
  __typename?: 'TriggeredCampaignMessageDynamicBlockExperienceCreateSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type TriggeredCampaignMessageDynamicBlockExperienceType = {
  __typename?: 'TriggeredCampaignMessageDynamicBlockExperienceType';
  creativeLayout?: Maybe<Layout>;
  id: Scalars['ID']['output'];
  selectedCreative?: Maybe<Creative>;
};

export type TriggeredCampaignMessageDynamicBlockType = {
  __typename?: 'TriggeredCampaignMessageDynamicBlockType';
  experience?: Maybe<TriggeredCampaignMessageDynamicBlockExperienceType>;
  id: Scalars['ID']['output'];
  slot: Scalars['String']['output'];
};

export type TriggeredCampaignMessageExperienceSelectCreativeResult = TriggeredCampaignMessageExperienceSelectCreativeSuccess | ValidationErrors;

export type TriggeredCampaignMessageExperienceSelectCreativeSuccess = {
  __typename?: 'TriggeredCampaignMessageExperienceSelectCreativeSuccess';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type TriggeredCampaignMessageInboxPreviewUpdateInput = {
  preheaderDynamicBlockId?: InputMaybe<Scalars['ID']['input']>;
  subjectLineDynamicBlockId?: InputMaybe<Scalars['ID']['input']>;
  subjectLinePrefix?: InputMaybe<Scalars['String']['input']>;
  subjectLineSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type TriggeredCampaignMessageInboxPreviewUpdateResult = TriggeredCampaignMessageInboxPreviewUpdateSuccess | ValidationErrors;

export type TriggeredCampaignMessageInboxPreviewUpdateSuccess = {
  __typename?: 'TriggeredCampaignMessageInboxPreviewUpdateSuccess';
  inboxPreview: TriggeredCampaignInboxPreviewType;
  success: Scalars['Boolean']['output'];
};

export type TriggeredCampaignMessageLayoutUpdateResult = TriggeredCampaignMessageLayoutUpdateSuccess | ValidationErrors;

export type TriggeredCampaignMessageLayoutUpdateSuccess = {
  __typename?: 'TriggeredCampaignMessageLayoutUpdateSuccess';
  success: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TriggeredCampaignMessageSaveResult = TriggeredCampaignMessageSaveSuccess | ValidationErrors;

export type TriggeredCampaignMessageSaveSuccess = {
  __typename?: 'TriggeredCampaignMessageSaveSuccess';
  success: Scalars['Boolean']['output'];
  triggeredCampaign: TriggeredCampaignType;
};

export type TriggeredCampaignMessageType = {
  __typename?: 'TriggeredCampaignMessageType';
  dynamicBlocks: Array<TriggeredCampaignMessageDynamicBlockType>;
  id: Scalars['ID']['output'];
  inboxPreview?: Maybe<TriggeredCampaignInboxPreviewType>;
  layoutDocument?: Maybe<Scalars['TriggeredCampaignMessageLayoutDocument']['output']>;
  triggeredCampaign?: Maybe<TriggeredCampaignType>;
};


export type TriggeredCampaignMessageTypeDynamicBlocksArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TriggeredCampaignPatternEngineBindingType = {
  __typename?: 'TriggeredCampaignPatternEngineBindingType';
  patternUuid?: Maybe<Scalars['String']['output']>;
  triggerRule?: Maybe<Scalars['JSONString']['output']>;
};

/** An enumeration. */
export enum TriggeredCampaignReEntryCriteria {
  AllowReentry = 'ALLOW_REENTRY',
  NoReentry = 'NO_REENTRY'
}

export type TriggeredCampaignReEntryCriteriaUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignSeedAudienceAddResult = TriggeredCampaignAudienceSuccess | ValidationErrors;

export type TriggeredCampaignSeedAudienceRemoveResult = TriggeredCampaignAudienceSuccess | ValidationErrors;

export type TriggeredCampaignSelectAttributeUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignSelectTrackingParameterUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

/** An enumeration. */
export enum TriggeredCampaignStage {
  Active = 'ACTIVE',
  Draft = 'DRAFT'
}

export type TriggeredCampaignStateTransitionResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

/** An enumeration. */
export enum TriggeredCampaignStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT'
}

export type TriggeredCampaignTextAttributeUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignTextTrackingParameterUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignTriggerRuleUpdateResult = TriggeredCampaignAttributeUpdateSuccess | ValidationErrors;

export type TriggeredCampaignType = {
  __typename?: 'TriggeredCampaignType';
  attributes: Array<Attribute>;
  channel: ChannelSpec;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<CustomField>;
  emailServiceProvider?: Maybe<EmailServiceProvider>;
  espConfig?: Maybe<EspConfig>;
  excludedAudiences: Array<MessageSourceAudienceType>;
  hashid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  includedAudiences: Array<MessageSourceAudienceType>;
  journeyBinding?: Maybe<TriggeredCampaignJourneyBindingType>;
  patternEngineBinding?: Maybe<TriggeredCampaignPatternEngineBindingType>;
  preheaderText?: Maybe<Scalars['String']['output']>;
  reEntryCriteria?: Maybe<TriggeredCampaignReEntryCriteria>;
  seedContactAudiences?: Maybe<Array<ContactAudience>>;
  stage: TriggeredCampaignStage;
  status: TriggeredCampaignStatus;
  subjectLine?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  trackingParameters: Array<Attribute>;
  triggerSource: TriggerSource;
  updatedAt: Scalars['DateTime']['output'];
};

export type Typography = {
  __typename?: 'Typography';
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  mobileStyles: Scalars['TypographyStyles']['output'];
  name: Scalars['String']['output'];
  pseudoState?: Maybe<ElementPseudoState>;
  semanticElement?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  styles: Scalars['TypographyStyles']['output'];
  type: TypographyType;
  updatedBy?: Maybe<User>;
};

export type TypographyInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mobileStyles?: InputMaybe<Scalars['TypographyStyles']['input']>;
  name: Scalars['String']['input'];
  pseudoState?: InputMaybe<ElementPseudoState>;
  semanticElement?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  styles: Scalars['TypographyStyles']['input'];
  type: TypographyType;
};

export enum TypographyType {
  Button = 'BUTTON',
  Link = 'LINK',
  Text = 'TEXT'
}

export type UberTemplate = {
  __typename?: 'UberTemplate';
  id: Scalars['ID']['output'];
  variations: Array<UberTemplateVariation>;
};

export type UberTemplateContentBlock = {
  __typename?: 'UberTemplateContentBlock';
  contentBlock: ContentBlock;
  experiences2: Array<Experience2>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
};

export type UberTemplateVariation = {
  __typename?: 'UberTemplateVariation';
  blueprint: Template;
  contentBlocks: Array<UberTemplateContentBlock>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type UberTemplateVariationContentblockRemoveResult = NeedsConfirmation | ProgramSuccess;

export type Unconfigured = {
  __typename?: 'Unconfigured';
  availableCreatives: PaginatedAvailableCreatives;
  id: Scalars['ID']['output'];
};


export type UnconfiguredAvailableCreativesArgs = {
  filter?: InputMaybe<CreativeFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNotificationsSetting = {
  __typename?: 'UpdateNotificationsSetting';
  setting: NotificationsSetting;
  success: Scalars['Boolean']['output'];
};

export type UpdatePlatformApplication2Input = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlatformApplication2Success = {
  __typename?: 'UpdatePlatformApplication2Success';
  application: PlatformApplication2;
  success: Scalars['Boolean']['output'];
};

export type UpdatePlatformApplicationInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePlatformApplicationSuccess = {
  __typename?: 'UpdatePlatformApplicationSuccess';
  application: PlatformApplication;
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  featureAccess: UserFeatureAccessType;
  fullName?: Maybe<Scalars['String']['output']>;
  hasSeenCampaignV2Intro: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  /** Can the user see developer tools. */
  isDeveloper: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
};

export type UserAssignOrganizationRole = {
  __typename?: 'UserAssignOrganizationRole';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserCreate2 = {
  __typename?: 'UserCreate2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserCreateWithRole = {
  __typename?: 'UserCreateWithRole';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export enum UserFeatureAccessType {
  Alpha = 'ALPHA',
  Beta = 'BETA',
  Early = 'EARLY',
  Experimental = 'EXPERIMENTAL',
  Release = 'RELEASE'
}

export type UserIdentifierInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserInvitationCancel2 = {
  __typename?: 'UserInvitationCancel2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserInvitationResend2 = {
  __typename?: 'UserInvitationResend2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserRoleCreate2 = {
  __typename?: 'UserRoleCreate2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserRoleDelete2 = {
  __typename?: 'UserRoleDelete2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserSuspend = {
  __typename?: 'UserSuspend';
  success: Scalars['Boolean']['output'];
};

export enum UserType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type UserUnsuspend2 = {
  __typename?: 'UserUnsuspend2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type UserUpdate2 = {
  __typename?: 'UserUpdate2';
  success: Scalars['Boolean']['output'];
  user: OrganizationUser2;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  /** The validation error code */
  code?: Maybe<Scalars['String']['output']>;
  /** The field with the validation error */
  field?: Maybe<Scalars['String']['output']>;
  /** The validation error */
  reason: Scalars['String']['output'];
};

export type ValidationErrors = {
  __typename?: 'ValidationErrors';
  errors: Array<ValidationError>;
  success: Scalars['Boolean']['output'];
};

/**
 * One (metric category → UI value-rendering hint) entry. `min`/`max` are
 * the threshold bounds the alerts form should clamp inputs to; `max` is null
 * when unbounded (currency amounts, counts).
 */
export type ValueTypeByCategoryEntry = {
  __typename?: 'ValueTypeByCategoryEntry';
  category: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
  valueType: Scalars['String']['output'];
};

export type Variable = {
  __typename?: 'Variable';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  providerVariable?: Maybe<ProviderVariable>;
};

export type VariantTagsInput = {
  languageCode: Scalars['Language']['input'];
};

/** View type constants for analytics persistence models. */
export enum ViewType {
  Campaigns = 'CAMPAIGNS',
  CampaignCreatives = 'CAMPAIGN_CREATIVES',
  CampaignExperiments = 'CAMPAIGN_EXPERIMENTS',
  CampaignMailings = 'CAMPAIGN_MAILINGS',
  CampaignSegments = 'CAMPAIGN_SEGMENTS',
  CampaignSegmentComparison = 'CAMPAIGN_SEGMENT_COMPARISON',
  CampaignTreatmentComparison = 'CAMPAIGN_TREATMENT_COMPARISON',
  Creatives = 'CREATIVES',
  CreativesHeatmap = 'CREATIVES_HEATMAP',
  CreativeSegmentComparison = 'CREATIVE_SEGMENT_COMPARISON',
  CreativeTreatmentComparison = 'CREATIVE_TREATMENT_COMPARISON',
  Experiments = 'EXPERIMENTS',
  ExperimentCampaigns = 'EXPERIMENT_CAMPAIGNS',
  ExperimentCreatives = 'EXPERIMENT_CREATIVES',
  ExperimentSegments = 'EXPERIMENT_SEGMENTS',
  Segments = 'SEGMENTS',
  SegmentCampaigns = 'SEGMENT_CAMPAIGNS',
  SegmentCreatives = 'SEGMENT_CREATIVES',
  SegmentExperiments = 'SEGMENT_EXPERIMENTS',
  Subjectlines = 'SUBJECTLINES'
}

/** Represents a week of a fiscal calendar. */
export type Week = {
  __typename?: 'Week';
  id: Scalars['ID']['output'];
  /** The date range of the week */
  span: DateSpan;
  /** The week of the Fiscal calendar (1-53) */
  week: Scalars['Int']['output'];
  /** The year of the Fiscal calendar */
  year: Scalars['Int']['output'];
};

export type WillDivide = {
  __typename?: 'WillDivide';
  availableCreatives: PaginatedAvailableCreatives;
  experience: Experience;
  id: Scalars['ID']['output'];
};


export type WillDivideAvailableCreativesArgs = {
  filter?: InputMaybe<CreativeFilterInput>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a fiscal year. */
export type Year = {
  __typename?: 'Year';
  id: Scalars['ID']['output'];
  /** The date range of the year. */
  span: DateSpan;
  /** The year of the Fiscal calendar */
  year: Scalars['Int']['output'];
};

export type Zeta = {
  __typename?: 'Zeta';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ZetaConfig = {
  __typename?: 'ZetaConfig';
  availableEmailTags: Array<AvailableEmailTag>;
  emailTags: Array<EmailTag>;
  fromAddress: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  replyToAddress: Scalars['String']['output'];
  replyToName: Scalars['String']['output'];
};

export type ZetaConfigUpdateSuccess = {
  __typename?: 'ZetaConfigUpdateSuccess';
  success: Scalars['Boolean']['output'];
  zetaConfig: ZetaConfig;
};

/** An enumeration. */
export enum Zone {
  Footer = 'FOOTER',
  Header = 'HEADER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type CampaignContactAudienceConfigQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignContactAudienceConfigQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, frequencyModel: FrequencyModel, hasContactAudiences: boolean, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, espConfig?: { __typename: 'AdobeJourneyOptimizerConfig' } | { __typename: 'AmazonSESConfig' } | { __typename: 'BlackholeConfig' } | { __typename: 'CampaignAcousticCampaignConfig' } | { __typename: 'CampaignAdobeCampaignConfig' } | { __typename: 'CampaignCordialConfig' } | { __typename: 'CampaignEpsilonConfig' } | { __typename: 'CampaignOracleResponsysConfig' } | { __typename: 'CampaignSalesforceMarketingCloudConfig' } | { __typename: 'ZetaConfig' } | null, fields?: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null, excludedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null, experienceExperiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string }> } | null, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null } };

export type CampaignFieldCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
}>;


export type CampaignFieldCreateMutation = { __typename?: 'Mutation', campaignFieldCreate: { __typename?: 'Campaign', fields?: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null } };

export type CampaignFieldDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
}>;


export type CampaignFieldDeleteMutation = { __typename?: 'Mutation', campaignFieldDelete: { __typename?: 'Campaign', fields?: Array<{ __typename?: 'CampaignField', dataFieldId: string, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null } };

export type CampaignFieldUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
  newFieldId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CampaignFieldUpdateMutation = { __typename?: 'Mutation', campaignFieldUpdate: { __typename?: 'Campaign', fields?: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null } };

export type EspSalesForceFragmentFragment = { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null };

export type EspAcousticFragmentFragment = { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } };

export type EspOracleFragmentFragment = { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> };

export type EspCordialFragmentFragment = { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null };

export type EspAmazonSesFragmentFragment = { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> };

export type EspZetaFragmentFragment = { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> };

export type EspAdobeCampaignFragmentFragment = { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> };

export type EspAdobeJourneyOptimizerFragmentFragment = { __typename?: 'AdobeJourneyOptimizerConfig', id: string };

export type EspBlackholeFragmentFragment = { __typename?: 'BlackholeConfig', id: string };

export type EspEpsilonFragmentFragment = { __typename?: 'CampaignEpsilonConfig', id: string };

export type SalesForceSenderProfileUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  senderProfileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SalesForceSenderProfileUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigSenderProfileUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type SalesForceSuppressionDataExtensionAddMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  suppressionDataExtensionId: Scalars['ID']['input'];
}>;


export type SalesForceSuppressionDataExtensionAddMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigSuppressionDataExtensionAdd: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } } } };

export type SalesForceSuppressionDataExtensionRemoveMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  suppressionDataExtensionId: Scalars['ID']['input'];
}>;


export type SalesForceSuppressionDataExtensionRemoveMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigSuppressionDataExtensionRemove: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } } } };

export type SalesForceSendClassificationUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  sendClassificationId: Scalars['ID']['input'];
}>;


export type SalesForceSendClassificationUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigSendClassificationUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type SalesForcePublicationListUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  publicationListId: Scalars['ID']['input'];
}>;


export type SalesForcePublicationListUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudPublicationListUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type SalesForceSuppressionPrebuildDurationUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  prebuildDuration: Scalars['Float']['input'];
}>;


export type SalesForceSuppressionPrebuildDurationUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudPrebuildDurationUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', prebuildDuration?: number | null } | null } } };

export type SalesForceConfigSendLoggingUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SalesForceConfigSendLoggingUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigSendLoggingUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean } } };

export type SalesforceDelayedDeliveryUpdateMutationVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
}>;


export type SalesforceDelayedDeliveryUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigDelayedDeliveryUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean } | null } } };

export type CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sendLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation = { __typename?: 'Mutation', campaignSalesforceMarketingCloudConfigSendThrottlingUpdate: { __typename?: 'CampaignSalesforceMarketingCloudConfigUpdateSuccess', salesforceMarketingCloudConfig: { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, sendLimit?: number | null } } };

export type AcousticFromNameUpdateMutationVariables = Exact<{
  fromNameId: Scalars['ID']['input'];
  espId: Scalars['ID']['input'];
}>;


export type AcousticFromNameUpdateMutation = { __typename?: 'Mutation', campaignAcousticCampaignConfigFromNameUpdate: { __typename?: 'CampaignAcousticCampaignConfigUpdateSuccess', acousticCampaignConfig: { __typename?: 'CampaignAcousticCampaignConfig', id: string, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type AcousticFromAddressUpdateMutationVariables = Exact<{
  fromAddressId: Scalars['ID']['input'];
  espId: Scalars['ID']['input'];
}>;


export type AcousticFromAddressUpdateMutation = { __typename?: 'Mutation', campaignAcousticCampaignConfigFromAddressUpdate: { __typename?: 'CampaignAcousticCampaignConfigUpdateSuccess', acousticCampaignConfig: { __typename?: 'CampaignAcousticCampaignConfig', id: string, fromAddress2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type AcousticReplyToUpdateMutationVariables = Exact<{
  replyToId: Scalars['ID']['input'];
  espId: Scalars['ID']['input'];
}>;


export type AcousticReplyToUpdateMutation = { __typename?: 'Mutation', campaignAcousticCampaignConfigReplyToUpdate: { __typename?: 'CampaignAcousticCampaignConfigUpdateSuccess', acousticCampaignConfig: { __typename?: 'CampaignAcousticCampaignConfig', id: string, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type AcousticPreprocessingUpdateMutationVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  espId: Scalars['ID']['input'];
}>;


export type AcousticPreprocessingUpdateMutation = { __typename?: 'Mutation', campaignAcousticCampaignConfigPreprocessingUpdate: { __typename?: 'CampaignAcousticCampaignConfigUpdateSuccess', acousticCampaignConfig: { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean } | null } } };

export type AcousticPreprocessingHoursUpdateMutationVariables = Exact<{
  preprocessingHours: Scalars['Int']['input'];
  espId: Scalars['ID']['input'];
}>;


export type AcousticPreprocessingHoursUpdateMutation = { __typename?: 'Mutation', campaignAcousticCampaignConfigPreprocessingHoursUpdate: { __typename?: 'CampaignAcousticCampaignConfigUpdateSuccess', acousticCampaignConfig: { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', hours?: number | null } | null } } };

export type OracleSuppressionListAddMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  suppressionId: Scalars['ID']['input'];
}>;


export type OracleSuppressionListAddMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigSuppressionListAdd: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', id: string, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null } } };

export type OracleSuppressionListRemoveMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  suppressionId: Scalars['ID']['input'];
}>;


export type OracleSuppressionListRemoveMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigSuppressionListRemove: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', id: string, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null } } };

export type OracleAdditionalDataSourceAddMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  additionalDataSourceId: Scalars['ID']['input'];
}>;


export type OracleAdditionalDataSourceAddMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigAdditionalDataSourceAdd: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } } } };

export type OracleAdditionalDataSourceRemoveMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  additionalDataSourceId: Scalars['ID']['input'];
}>;


export type OracleAdditionalDataSourceRemoveMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigAdditionalDataSourceRemove: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } } } };

export type OracleTextVariableUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  campaignVariableId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
}>;


export type OracleTextVariableUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigTextCampaignVariableUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', campaignVariables: Array<{ __typename?: 'CheckboxAttribute', id: string } | { __typename?: 'DateAttribute', id: string } | { __typename?: 'DateTimeAttribute', id: string } | { __typename?: 'FormatStringAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'MultiSelectAttribute', id: string } | { __typename?: 'MultiSelectAttribute2', id: string } | { __typename?: 'NumberAttribute', id: string } | { __typename?: 'SelectAttribute', id: string } | { __typename?: 'SelectAttribute2', id: string } | { __typename?: 'TextAttribute', id: string, value?: string | null }> } } };

export type OracleSelectVariableUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  campaignVariableId: Scalars['ID']['input'];
  choiceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OracleSelectVariableUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigSelectCampaignVariableUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', campaignVariables: Array<{ __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }> } } };

export type OracleMarketingProgramUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  marketingProgramId: Scalars['ID']['input'];
}>;


export type OracleMarketingProgramUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigMarketingProgramUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type OracleMarketingStrategyUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  marketingStrategyId: Scalars['ID']['input'];
}>;


export type OracleMarketingStrategyUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigMarketingStrategyUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type OracleFromEmailUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  fromEmailId: Scalars['ID']['input'];
}>;


export type OracleFromEmailUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigFromEmailUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type OracleReplyToUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  replyToId: Scalars['ID']['input'];
}>;


export type OracleReplyToUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigReplyToUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type OracleFromNameUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  fromNameId: Scalars['ID']['input'];
}>;


export type OracleFromNameUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigFromNameUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type OracleProfileListUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  profileListId: Scalars['ID']['input'];
}>;


export type OracleProfileListUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigProfileListUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', id: string, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } } };

export type OracleTextTrackingParameterUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  externalTrackingParamId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type OracleTextTrackingParameterUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigTextExternalTrackingParameterUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', externalTrackingParameters: Array<{ __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute', id: string, value?: string | null }> } } };

export type OracleSelectTrackingParameterUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  externalTrackingParamId: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OracleSelectTrackingParameterUpdateMutation = { __typename?: 'Mutation', campaignOracleResponsysConfigSelectExternalTrackingParameterUpdate: { __typename?: 'CampaignOracleResponsysConfigUpdateSuccess', oracleResponsysConfig: { __typename?: 'CampaignOracleResponsysConfig', externalTrackingParameters: Array<{ __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }> } } };

export type CampaignEmailServiceProviderUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  emailServiceProviderId: Scalars['ID']['input'];
}>;


export type CampaignEmailServiceProviderUpdateMutation = { __typename?: 'Mutation', campaignEmailServiceProviderUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string } | null, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | { __typename?: 'BlackholeConfig' } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig' } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null } } };

export type CordialExcludeAudienceAddMutationVariables = Exact<{
  excludeAudienceId: Scalars['ID']['input'];
  espId: Scalars['ID']['input'];
}>;


export type CordialExcludeAudienceAddMutation = { __typename?: 'Mutation', campaignCordialConfigExcludeAudienceAdd: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } } } };

export type CordialExcludeAudienceRemoveMutationVariables = Exact<{
  excludeAudienceId: Scalars['ID']['input'];
  espId: Scalars['ID']['input'];
}>;


export type CordialExcludeAudienceRemoveMutation = { __typename?: 'Mutation', campaignCordialConfigExcludeAudienceRemove: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } } } };

export type CordialSendPropertyCreate2MutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  defaultSendPropertyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type CordialSendPropertyCreate2Mutation = { __typename?: 'Mutation', campaignCordialConfigSendPropertyCreate2: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', id: string, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } } };

export type CordialSendPropertyUpdate2MutationVariables = Exact<{
  sendPropertyId: Scalars['ID']['input'];
  defaultSendPropertyId?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
}>;


export type CordialSendPropertyUpdate2Mutation = { __typename?: 'Mutation', campaignCordialConfigSendPropertyUpdate2: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', id: string, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } } };

export type CordialSendPropertyDeleteMutationVariables = Exact<{
  sendPropertyId: Scalars['ID']['input'];
}>;


export type CordialSendPropertyDeleteMutation = { __typename?: 'Mutation', campaignCordialConfigSendPropertyDelete: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', id: string, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } } };

export type CordialTagsUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CordialTagsUpdateMutation = { __typename?: 'Mutation', campaignCordialConfigTagsUpdate: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string> } } };

export type CordialSenderProfileUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  senderProfileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CordialSenderProfileUpdateMutation = { __typename?: 'Mutation', campaignCordialConfigSenderProfileUpdate: { __typename?: 'CampaignCordialConfigUpdateSuccess', cordialConfig: { __typename?: 'CampaignCordialConfig', id: string, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } } } };

export type AdobeCampaignLabelUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
}>;


export type AdobeCampaignLabelUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigLabelUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', label: string } } };

export type AdobeCampaignDeliveryCodeUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  deliveryCode: Scalars['String']['input'];
}>;


export type AdobeCampaignDeliveryCodeUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigDeliveryCodeUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', deliveryCode: string } } };

export type AdobeCampaignFromNameUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  fromName: Scalars['String']['input'];
}>;


export type AdobeCampaignFromNameUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigFromNameUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', fromName: string } } };

export type AdobeCampaignFromAddressUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  fromAddress: Scalars['String']['input'];
}>;


export type AdobeCampaignFromAddressUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigFromAddressUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', fromAddress: string } } };

export type AdobeCampaignReplyToNameUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  replyToName: Scalars['String']['input'];
}>;


export type AdobeCampaignReplyToNameUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigReplyToNameUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', replyToName: string } } };

export type AdobeCampaignReplyToAddressUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  replyToAddress: Scalars['String']['input'];
}>;


export type AdobeCampaignReplyToAddressUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigReplyToAddressUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', replyToAddress: string } } };

export type AdobeCampaignTargetMappingIdUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  targetMappingId: Scalars['Int']['input'];
}>;


export type AdobeCampaignTargetMappingIdUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigTargetMappingIdUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', targetMappingId: number } } };

export type AdobeCampaignTypologyIdUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  typologyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdobeCampaignTypologyIdUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigTypologyIdUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', typologyId?: number | null } } };

export type AdobeCampaignWebAnalyticsAccountUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  webAnalyticsAccount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdobeCampaignWebAnalyticsAccountUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigWebAnalyticsAccountUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', webAnalyticsAccount?: number | null } } };

export type AdobeCampaignRoutingIdUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  routingId: Scalars['Int']['input'];
}>;


export type AdobeCampaignRoutingIdUpdateMutation = { __typename?: 'Mutation', campaignAdobeCampaignConfigRoutingIdUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', routingId: number } } };

export type AdobeCampaignDeliveryNatureUpdateMutationVariables = Exact<{
  espId: Scalars['ID']['input'];
  availableDeliveryNatureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AdobeCampaignDeliveryNatureUpdateMutation = { __typename?: 'Mutation', adobeCampaignConfigDeliveryNatureUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', deliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null } } };

export type AdobeCampaignDeliveryVariableCreateMutationVariables = Exact<{
  espConfigId: Scalars['ID']['input'];
  availableDeliveryVariableId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type AdobeCampaignDeliveryVariableCreateMutation = { __typename?: 'Mutation', adobeCampaignConfigDeliveryVariableCreate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', id: string, deliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }> } } };

export type AdobeCampaignDeliveryVariableUpdateMutationVariables = Exact<{
  espConfigId: Scalars['ID']['input'];
  deliveryVariableId: Scalars['ID']['input'];
  availableDeliveryVariableId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type AdobeCampaignDeliveryVariableUpdateMutation = { __typename?: 'Mutation', adobeCampaignConfigDeliveryVariableUpdate: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', id: string, deliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }> } } };

export type AdobeCampaignDeliveryVariableDeleteMutationVariables = Exact<{
  espConfigId: Scalars['ID']['input'];
  deliveryVariableId: Scalars['ID']['input'];
}>;


export type AdobeCampaignDeliveryVariableDeleteMutation = { __typename?: 'Mutation', adobeCampaignConfigDeliveryVariableDelete: { __typename?: 'CampaignAdobeCampaignConfigUpdateSuccess', adobeCampaignConfig: { __typename?: 'CampaignAdobeCampaignConfig', id: string, deliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }> } } };

export type AmazonSesEmailTagCreateMutationVariables = Exact<{
  espConfigId: Scalars['ID']['input'];
  availableEmailTagId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type AmazonSesEmailTagCreateMutation = { __typename?: 'Mutation', amazonSesConfigEmailTagCreate: { __typename?: 'AmazonSESConfigUpdateSuccess', amazonSesConfig: { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }> } } };

export type AmazonSesEmailTagUpdateMutationVariables = Exact<{
  emailTagId: Scalars['ID']['input'];
  availableEmailTagId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type AmazonSesEmailTagUpdateMutation = { __typename?: 'Mutation', amazonSesConfigEmailTagUpdate: { __typename?: 'AmazonSESConfigUpdateSuccess', amazonSesConfig: { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }> } } };

export type AmazonSesEmailTagDeleteMutationVariables = Exact<{
  emailTagId: Scalars['ID']['input'];
}>;


export type AmazonSesEmailTagDeleteMutation = { __typename?: 'Mutation', amazonSesConfigEmailTagDelete: { __typename?: 'AmazonSESConfigUpdateSuccess', amazonSesConfig: { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }> } } };

export type ZetaEmailTagCreateMutationVariables = Exact<{
  espConfigId: Scalars['ID']['input'];
  availableEmailTagId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type ZetaEmailTagCreateMutation = { __typename?: 'Mutation', zetaConfigEmailTagCreate: { __typename?: 'ZetaConfigUpdateSuccess', zetaConfig: { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }> } } };

export type ZetaEmailTagUpdateMutationVariables = Exact<{
  emailTagId: Scalars['ID']['input'];
  availableEmailTagId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type ZetaEmailTagUpdateMutation = { __typename?: 'Mutation', zetaConfigEmailTagUpdate: { __typename?: 'ZetaConfigUpdateSuccess', zetaConfig: { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }> } } };

export type ZetaEmailTagDeleteMutationVariables = Exact<{
  emailTagId: Scalars['ID']['input'];
}>;


export type ZetaEmailTagDeleteMutation = { __typename?: 'Mutation', zetaConfigEmailTagDelete: { __typename?: 'ZetaConfigUpdateSuccess', zetaConfig: { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }> } } };

export type LayoutUpgradeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
}>;


export type LayoutUpgradeMutation = { __typename?: 'Mutation', layoutUpgrade: { __typename?: 'LayoutUpdateSuccess', success: boolean, layout: { __typename?: 'Layout', id: string } } };

export type MediaUploadMutationVariables = Exact<{
  image: Scalars['Upload']['input'];
}>;


export type MediaUploadMutation = { __typename?: 'Mutation', mediaUpload2: { __typename?: 'MediaCreate2', success: boolean, media: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } } };

export type MediaCdnUploadMutationVariables = Exact<{
  image: Scalars['Upload']['input'];
  existingMediaId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MediaCdnUploadMutation = { __typename?: 'Mutation', mediaCdnUpload: { __typename?: 'MediaCreate2', success: boolean, media: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } } };

export type MediaCreateMutationVariables = Exact<{
  externalUrl: Scalars['String']['input'];
}>;


export type MediaCreateMutation = { __typename?: 'Mutation', mediaCreate2: { __typename?: 'MediaCreate2', success: boolean, media: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } } };

export type StudioDynamicFieldFragmentFragment = { __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean };

export type CatalogFieldTypeFragment = { __typename?: 'InkDataV1QueryCatalogType', string?: { __typename: 'InkDataV1QueryCatalogTypeString' } | null, integer?: { __typename: 'InkDataV1QueryCatalogTypeInteger' } | null, float?: { __typename: 'InkDataV1QueryCatalogTypeFloat' } | null, boolean?: { __typename: 'InkDataV1QueryCatalogTypeBoolean' } | null, date?: { __typename: 'InkDataV1QueryCatalogTypeDate' } | null, datetime?: { __typename: 'InkDataV1QueryCatalogTypeDateTime' } | null, stringArray?: { __typename: 'InkDataV1QueryCatalogTypeStringArray' } | null, integerArray?: { __typename: 'InkDataV1QueryCatalogTypeIntegerArray' } | null, floatArray?: { __typename: 'InkDataV1QueryCatalogTypeFloatArray' } | null, dateArray?: { __typename: 'InkDataV1QueryCatalogTypeDateArray' } | null, datetimeArray?: { __typename: 'InkDataV1QueryCatalogTypeDateTimeArray' } | null };

export type QueryCatalogQueryVariables = Exact<{
  modelKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type QueryCatalogQuery = { __typename?: 'Query', queryCatalog: { __typename?: 'InkDataV1QueryCatalogFetchResponse', catalog: { __typename?: 'InkDataV1QueryCatalog', datasets: Array<{ __typename?: 'InkDataV1QueryCatalogDataset', id: number, name: string, fields: Array<{ __typename?: 'InkDataV1QueryCatalogDatasetField', id: number, name: string, nullable: boolean, primaryKey: boolean, type: { __typename?: 'InkDataV1QueryCatalogType', string?: { __typename: 'InkDataV1QueryCatalogTypeString' } | null, integer?: { __typename: 'InkDataV1QueryCatalogTypeInteger' } | null, float?: { __typename: 'InkDataV1QueryCatalogTypeFloat' } | null, boolean?: { __typename: 'InkDataV1QueryCatalogTypeBoolean' } | null, date?: { __typename: 'InkDataV1QueryCatalogTypeDate' } | null, datetime?: { __typename: 'InkDataV1QueryCatalogTypeDateTime' } | null, stringArray?: { __typename: 'InkDataV1QueryCatalogTypeStringArray' } | null, integerArray?: { __typename: 'InkDataV1QueryCatalogTypeIntegerArray' } | null, floatArray?: { __typename: 'InkDataV1QueryCatalogTypeFloatArray' } | null, dateArray?: { __typename: 'InkDataV1QueryCatalogTypeDateArray' } | null, datetimeArray?: { __typename: 'InkDataV1QueryCatalogTypeDateTimeArray' } | null } }> }>, datasetRelations: Array<{ __typename?: 'InkDataV1QueryCatalogDatasetRelation', id: number, sourceDatasetId: number, sourceFieldId: number, targetDatasetId: number, targetFieldId: number, cardinality: InkDataV1QueryCatalogCardinalityEnum }> } } };

export type BlocksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BlockFilterInput>;
}>;


export type BlocksQuery = { __typename?: 'Query', blocks: { __typename?: 'BlockConnection', edges: Array<{ __typename?: 'BlockEdge', cursor: string, node: { __typename?: 'Block', id: string, name: string, description: string, thumbnail: string, latestVersion?: { __typename?: 'BlockVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', id: string, snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }> } } | null } } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DataFieldValueListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  distinct: Scalars['Boolean']['input'];
}>;


export type DataFieldValueListQuery = { __typename?: 'Query', dataFieldValueList: Array<string> };

export type ContactAudienceTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactAudienceTagsQuery = { __typename?: 'Query', contactAudienceTags: { __typename?: 'InkDavinciContactsV1AudienceTagListResponse', tables: Array<{ __typename?: 'InkDavinciContactsV1AudienceTagListResponseTable', id: string, name: string, tags: Array<{ __typename?: 'InkDavinciContactsV1AudienceTagListResponseTableTag', id: string, name: string }> }> } };

export type JourneyFieldsFragment = { __typename?: 'Journey', id: string, status?: JourneyStatus | null, configJson: string, updatedAt: string, tags?: Array<{ __typename?: 'JourneyTag', id: string, name: string } | null> | null };

export type RenameJourneyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameJourneyMutation = { __typename?: 'Mutation', journeyRename: { __typename?: 'JourneyRename', journey: { __typename?: 'Journey', id: string } } };

export type PauseJourneyMutationVariables = Exact<{
  abortRunningContacts: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}>;


export type PauseJourneyMutation = { __typename?: 'Mutation', journeyPause: { __typename?: 'JourneyPause', journey: { __typename?: 'Journey', id: string, status?: JourneyStatus | null } } };

export type ResumeJourneyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResumeJourneyMutation = { __typename?: 'Mutation', journeyResume: { __typename?: 'JourneyResume', journey: { __typename?: 'Journey', id: string, status?: JourneyStatus | null, updatedAt: string } } };

export type CancelJourneyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelJourneyMutation = { __typename?: 'Mutation', journeyCancel: { __typename?: 'JourneyCancel', journey: { __typename?: 'Journey', id: string, status?: JourneyStatus | null } } };

export type CreateQueryMutationVariables = Exact<{
  query: Scalars['InkQLQuery']['input'];
}>;


export type CreateQueryMutation = { __typename?: 'Mutation', queryCreate: { __typename?: 'InkDataV1QueryCreateResponse', queryId: string } };

export type UpdateQueryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  query: Scalars['InkQLQuery']['input'];
}>;


export type UpdateQueryMutation = { __typename?: 'Mutation', queryUpdate: { __typename?: 'InkDataV1QueryUpdateResponse', queryId: string } };

export type JourneysQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneysQuery = { __typename?: 'Query', journeys: Array<{ __typename?: 'Journey', id: string, status?: JourneyStatus | null, configJson: string, updatedAt: string, tags?: Array<{ __typename?: 'JourneyTag', id: string, name: string } | null> | null } | null> };

export type JourneyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JourneyQuery = { __typename?: 'Query', journey: { __typename?: 'Journey', createdAt: string, id: string, status?: JourneyStatus | null, configJson: string, updatedAt: string, tags?: Array<{ __typename?: 'JourneyTag', id: string, name: string } | null> | null } };

export type FiscalCalendarMonthRangeQueryVariables = Exact<{
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
}>;


export type FiscalCalendarMonthRangeQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, fiscalCalendar?: { __typename?: 'Calendar', monthRange: Array<{ __typename?: 'Month', id: string, year: number, month: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null> } | null } };

export type FiscalCalendarPredefinedRangesQueryVariables = Exact<{
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
}>;


export type FiscalCalendarPredefinedRangesQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, fiscalCalendar?: { __typename?: 'Calendar', weekRange: Array<{ __typename?: 'Week', id: string, year: number, week: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null>, monthRange: Array<{ __typename?: 'Month', id: string, year: number, month: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null>, quarterRange: Array<{ __typename?: 'Quarter', id: string, year: number, quarter: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null>, yearRange: Array<{ __typename?: 'Year', id: string, year: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null> } | null } };

export type FiscalCalendarCurrentWeekQueryVariables = Exact<{ [key: string]: never; }>;


export type FiscalCalendarCurrentWeekQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, fiscalCalendar?: { __typename?: 'Calendar', currentWeek: number } | null } };

type BaseAttributeDefinitionFields_CheckboxAttributeDefinition_Fragment = { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_DateAttributeDefinition_Fragment = { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_DateTimeAttributeDefinition_Fragment = { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_FormatStringAttributeDefinition_Fragment = { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_ListAttributeDefinition_Fragment = { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_MultiSelectAttributeDefinition_Fragment = { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_MultiSelectAttributeDefinition2_Fragment = { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_NumberAttributeDefinition_Fragment = { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_SelectAttributeDefinition_Fragment = { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_SelectAttributeDefinition2_Fragment = { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

type BaseAttributeDefinitionFields_TextAttributeDefinition_Fragment = { __typename: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null };

export type BaseAttributeDefinitionFieldsFragment = BaseAttributeDefinitionFields_CheckboxAttributeDefinition_Fragment | BaseAttributeDefinitionFields_DateAttributeDefinition_Fragment | BaseAttributeDefinitionFields_DateTimeAttributeDefinition_Fragment | BaseAttributeDefinitionFields_FormatStringAttributeDefinition_Fragment | BaseAttributeDefinitionFields_ListAttributeDefinition_Fragment | BaseAttributeDefinitionFields_MultiSelectAttributeDefinition_Fragment | BaseAttributeDefinitionFields_MultiSelectAttributeDefinition2_Fragment | BaseAttributeDefinitionFields_NumberAttributeDefinition_Fragment | BaseAttributeDefinitionFields_SelectAttributeDefinition_Fragment | BaseAttributeDefinitionFields_SelectAttributeDefinition2_Fragment | BaseAttributeDefinitionFields_TextAttributeDefinition_Fragment;

type DynamicFieldAttributes_CheckboxAttribute_Fragment = { __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type DynamicFieldAttributes_DateAttribute_Fragment = { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type DynamicFieldAttributes_DateTimeAttribute_Fragment = { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type DynamicFieldAttributes_FormatStringAttribute_Fragment = { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type DynamicFieldAttributes_ListAttribute_Fragment = { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type DynamicFieldAttributes_MultiSelectAttribute_Fragment = { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } };

type DynamicFieldAttributes_MultiSelectAttribute2_Fragment = { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } };

type DynamicFieldAttributes_NumberAttribute_Fragment = { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type DynamicFieldAttributes_SelectAttribute_Fragment = { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } };

type DynamicFieldAttributes_SelectAttribute2_Fragment = { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } };

type DynamicFieldAttributes_TextAttribute_Fragment = { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

export type DynamicFieldAttributesFragment = DynamicFieldAttributes_CheckboxAttribute_Fragment | DynamicFieldAttributes_DateAttribute_Fragment | DynamicFieldAttributes_DateTimeAttribute_Fragment | DynamicFieldAttributes_FormatStringAttribute_Fragment | DynamicFieldAttributes_ListAttribute_Fragment | DynamicFieldAttributes_MultiSelectAttribute_Fragment | DynamicFieldAttributes_MultiSelectAttribute2_Fragment | DynamicFieldAttributes_NumberAttribute_Fragment | DynamicFieldAttributes_SelectAttribute_Fragment | DynamicFieldAttributes_SelectAttribute2_Fragment | DynamicFieldAttributes_TextAttribute_Fragment;

export type StudioCampaignFragmentFragment = { __typename?: 'StudioCampaign', id: string, name: string, key: string, blockCount: number, blocks: Array<{ __typename?: 'StudioBlock', id: string, name?: string | null, altText?: string | null, clickthroughUrl?: string | null, imageUrl?: string | null, embedCode?: string | null, createdAt: string, updatedAt: string, dynamicFields: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean }> }> };

export type GetStudioCampaignsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStudioCampaignsQuery = { __typename?: 'Query', studioCampaigns: { __typename: 'StudioAuthorizationRequired' } | { __typename: 'StudioCampaignPagination', page: number, results: Array<{ __typename?: 'StudioCampaign', id: string, name: string }> } };

export type GetStudioCampaignBlocksQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetStudioCampaignBlocksQuery = { __typename?: 'Query', studioCampaign: { __typename: 'StudioAuthorizationRequired' } | { __typename: 'StudioCampaign', id: string, name: string, key: string, blockCount: number, blocks: Array<{ __typename?: 'StudioBlock', id: string, name?: string | null, altText?: string | null, clickthroughUrl?: string | null, imageUrl?: string | null, embedCode?: string | null, createdAt: string, updatedAt: string, dynamicFields: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean }> }> } };

export type StudioAuthorizationCompleteMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;


export type StudioAuthorizationCompleteMutation = { __typename?: 'Mutation', studioAuthorizationComplete: boolean };

export type VariablesQueryVariables = Exact<{ [key: string]: never; }>;


export type VariablesQuery = { __typename?: 'Query', variables: Array<{ __typename?: 'Variable', id: string, name: string, providerVariable?: { __typename?: 'ProviderVariable', id: string, expression: string } | null }> };

export type CreateVariableMutationVariables = Exact<{
  input: CreateVariableInput;
}>;


export type CreateVariableMutation = { __typename?: 'Mutation', createVariable: { __typename?: 'CreateVariablePayload', success: boolean, variable: { __typename?: 'Variable', id: string, name: string, providerVariable?: { __typename?: 'ProviderVariable', id: string, expression: string } | null } } };

type Link2EspMetadataFields_Link2AcousticCampaignMetadata_Fragment = { __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign };

type Link2EspMetadataFields_Link2AdobeCampaignMetadata_Fragment = { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign };

type Link2EspMetadataFields_Link2AdobeJourneyOptimizerMetadata_Fragment = { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer };

type Link2EspMetadataFields_Link2AmazonSesMetadata_Fragment = { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean };

type Link2EspMetadataFields_Link2BluecoreMetadata_Fragment = { __typename: 'Link2BluecoreMetadata', enableTracking: boolean };

type Link2EspMetadataFields_Link2BrazeMetadata_Fragment = { __typename: 'Link2BrazeMetadata', alias: string };

type Link2EspMetadataFields_Link2CordialMetadata_Fragment = { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean };

type Link2EspMetadataFields_Link2EpsilonMetadata_Fragment = { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon };

type Link2EspMetadataFields_Link2OracleResponsysMetadata_Fragment = { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null };

type Link2EspMetadataFields_Link2SalesForceMarketingCloudMetadata_Fragment = { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean };

type Link2EspMetadataFields_Link2ZetaMetadata_Fragment = { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> };

export type Link2EspMetadataFieldsFragment = Link2EspMetadataFields_Link2AcousticCampaignMetadata_Fragment | Link2EspMetadataFields_Link2AdobeCampaignMetadata_Fragment | Link2EspMetadataFields_Link2AdobeJourneyOptimizerMetadata_Fragment | Link2EspMetadataFields_Link2AmazonSesMetadata_Fragment | Link2EspMetadataFields_Link2BluecoreMetadata_Fragment | Link2EspMetadataFields_Link2BrazeMetadata_Fragment | Link2EspMetadataFields_Link2CordialMetadata_Fragment | Link2EspMetadataFields_Link2EpsilonMetadata_Fragment | Link2EspMetadataFields_Link2OracleResponsysMetadata_Fragment | Link2EspMetadataFields_Link2SalesForceMarketingCloudMetadata_Fragment | Link2EspMetadataFields_Link2ZetaMetadata_Fragment;

export type Link2FieldsFragment = { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> };

export type Link2ListQueryVariables = Exact<{
  filters?: InputMaybe<Link2FilterInput>;
}>;


export type Link2ListQuery = { __typename?: 'Query', link2s: { __typename: 'Link2Connection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'Link2Edge', node: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } } | null> } };

export type Link2DetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type Link2DetailsQuery = { __typename?: 'Query', link2: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } };

export type CreateLink2MutationVariables = Exact<{
  url: Scalars['String']['input'];
  queryStringParameters: Array<Array<Scalars['String']['input']> | Scalars['String']['input']> | Array<Scalars['String']['input']> | Scalars['String']['input'];
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  linkMetadata?: InputMaybe<LinkMetadataInput>;
  trackingParameters: Array<TrackingParameterInput> | TrackingParameterInput;
}>;


export type CreateLink2Mutation = { __typename?: 'Mutation', link2Create: { __typename?: 'Link2Success', link: { __typename?: 'Link2', id: string, name?: string | null } } };

export type UpdateLink2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  queryStringParameters: Array<Array<Scalars['String']['input']> | Scalars['String']['input']> | Array<Scalars['String']['input']> | Scalars['String']['input'];
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  linkMetadata?: InputMaybe<LinkMetadataInput>;
  trackingParameters: Array<TrackingParameterInput> | TrackingParameterInput;
}>;


export type UpdateLink2Mutation = { __typename?: 'Mutation', link2Update: { __typename?: 'Link2Success', link: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } } };

type EspMetadataFieldsWithDefaults_AcousticCampaign_Fragment = { __typename: 'AcousticCampaign', id: string, displayName: string, defaultLinkMetadata?: { __typename: 'AcousticCampaignDefaultLinkMetadata', requiresName: boolean, requiresLinkType: boolean } | null };

type EspMetadataFieldsWithDefaults_AdobeCampaign_Fragment = { __typename: 'AdobeCampaign', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_AdobeJourneyOptimizer_Fragment = { __typename: 'AdobeJourneyOptimizer', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_AmazonSes_Fragment = { __typename: 'AmazonSES', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_Blackhole_Fragment = { __typename: 'Blackhole', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_Bluecore_Fragment = { __typename: 'Bluecore', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_Braze_Fragment = { __typename: 'Braze', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_Cordial_Fragment = { __typename: 'Cordial', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_Epsilon_Fragment = { __typename: 'Epsilon', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_OracleResponsys_Fragment = { __typename: 'OracleResponsys', id: string, displayName: string, linkCategories: Array<{ __typename?: 'OracleResponsysLinkCategory', id: string, title: string }>, defaultLinkMetadata?: { __typename: 'OracleResponsysDefaultLinkMetadata', requiresName: boolean, requiresCategory: boolean } | null };

type EspMetadataFieldsWithDefaults_SfNext_Fragment = { __typename: 'SFNext', id: string, displayName: string };

type EspMetadataFieldsWithDefaults_SalesForceMarketingCloud_Fragment = { __typename: 'SalesForceMarketingCloud', id: string, displayName: string, defaultLinkMetadata?: { __typename: 'SalesforceMarketingCloudDefaultLinkMetadata', id: string, enableDeepLinks: boolean, enableConversionTracking: boolean, requiresAlias: boolean } | null };

type EspMetadataFieldsWithDefaults_Zeta_Fragment = { __typename: 'Zeta', id: string, displayName: string };

export type EspMetadataFieldsWithDefaultsFragment = EspMetadataFieldsWithDefaults_AcousticCampaign_Fragment | EspMetadataFieldsWithDefaults_AdobeCampaign_Fragment | EspMetadataFieldsWithDefaults_AdobeJourneyOptimizer_Fragment | EspMetadataFieldsWithDefaults_AmazonSes_Fragment | EspMetadataFieldsWithDefaults_Blackhole_Fragment | EspMetadataFieldsWithDefaults_Bluecore_Fragment | EspMetadataFieldsWithDefaults_Braze_Fragment | EspMetadataFieldsWithDefaults_Cordial_Fragment | EspMetadataFieldsWithDefaults_Epsilon_Fragment | EspMetadataFieldsWithDefaults_OracleResponsys_Fragment | EspMetadataFieldsWithDefaults_SfNext_Fragment | EspMetadataFieldsWithDefaults_SalesForceMarketingCloud_Fragment | EspMetadataFieldsWithDefaults_Zeta_Fragment;

export type EspMetadataFieldsWithDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type EspMetadataFieldsWithDefaultsQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, enableConversionTracking: boolean, supportMultipleEsps: boolean, emailServiceProviders: Array<{ __typename: 'AcousticCampaign', id: string, displayName: string, defaultLinkMetadata?: { __typename: 'AcousticCampaignDefaultLinkMetadata', requiresName: boolean, requiresLinkType: boolean } | null } | { __typename: 'AdobeCampaign', id: string, displayName: string } | { __typename: 'AdobeJourneyOptimizer', id: string, displayName: string } | { __typename: 'AmazonSES', id: string, displayName: string } | { __typename: 'Blackhole', id: string, displayName: string } | { __typename: 'Bluecore', id: string, displayName: string } | { __typename: 'Braze', id: string, displayName: string } | { __typename: 'Cordial', id: string, displayName: string } | { __typename: 'Epsilon', id: string, displayName: string } | { __typename: 'OracleResponsys', id: string, displayName: string, linkCategories: Array<{ __typename?: 'OracleResponsysLinkCategory', id: string, title: string }>, defaultLinkMetadata?: { __typename: 'OracleResponsysDefaultLinkMetadata', requiresName: boolean, requiresCategory: boolean } | null } | { __typename: 'SFNext', id: string, displayName: string } | { __typename: 'SalesForceMarketingCloud', id: string, displayName: string, defaultLinkMetadata?: { __typename: 'SalesforceMarketingCloudDefaultLinkMetadata', id: string, enableDeepLinks: boolean, enableConversionTracking: boolean, requiresAlias: boolean } | null } | { __typename: 'Zeta', id: string, displayName: string }> } };

export type LinkFieldsFragment = { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null };

export type LinkGroupsQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkGroupsQuery = { __typename?: 'Query', linkGroups: Array<{ __typename: 'LinkGroup', id: string, name: string }> };

export type CreateLinkMutationVariables = Exact<{
  url: Scalars['String']['input'];
  queryStringParameters: Array<Array<Scalars['String']['input']> | Scalars['String']['input']> | Array<Scalars['String']['input']> | Scalars['String']['input'];
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput2>;
  adobeCampaignMetadata?: InputMaybe<LinkAdobeCampaignMetadataInput2>;
  adobeJourneyOptimizerMetadata?: InputMaybe<LinkAdobeJourneyOptimizerMetadataInput2>;
  amazonSesMetadata?: InputMaybe<LinkAmazonSesMetadataInput2>;
  brazeMetadata?: InputMaybe<LinkBrazeMetadataInput2>;
  bluecoreMetadata?: InputMaybe<LinkBluecoreMetadataInput2>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput2>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput2>;
  salesforceMetadata?: InputMaybe<LinkSalesforceMarketingCloudMetadataInput2>;
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput2>;
  zetaMetadata?: InputMaybe<LinkZetaMetadataInput2>;
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  linkGroupName?: InputMaybe<Scalars['String']['input']>;
  trackingParameters: Array<TrackingParameterInput> | TrackingParameterInput;
}>;


export type CreateLinkMutation = { __typename?: 'Mutation', linkCreate2: { __typename: 'LinkSuccess', link: { __typename: 'Link', id: string } } };

export type EditLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  queryStringParameters: Array<Array<Scalars['String']['input']> | Scalars['String']['input']> | Array<Scalars['String']['input']> | Scalars['String']['input'];
  acousticCampaignMetadata?: InputMaybe<LinkAcousticCampaignMetadataInput2>;
  adobeCampaignMetadata?: InputMaybe<LinkAdobeCampaignMetadataInput2>;
  adobeJourneyOptimizerMetadata?: InputMaybe<LinkAdobeJourneyOptimizerMetadataInput2>;
  amazonSesMetadata?: InputMaybe<LinkAmazonSesMetadataInput2>;
  brazeMetadata?: InputMaybe<LinkBrazeMetadataInput2>;
  bluecoreMetadata?: InputMaybe<LinkBluecoreMetadataInput2>;
  cordialMetadata?: InputMaybe<LinkCordialMetadataInput2>;
  oracleResponsysMetadata?: InputMaybe<LinkOracleResponsysMetadataInput2>;
  salesforceMetadata?: InputMaybe<LinkSalesforceMarketingCloudMetadataInput2>;
  epsilonMetadata?: InputMaybe<LinkEpsilonMetadataInput2>;
  zetaMetadata?: InputMaybe<LinkZetaMetadataInput2>;
  enableConversionTracking: Scalars['Boolean']['input'];
  enableTracking: Scalars['Boolean']['input'];
  linkGroupName?: InputMaybe<Scalars['String']['input']>;
  trackingParameters: Array<TrackingParameterInput> | TrackingParameterInput;
}>;


export type EditLinkMutation = { __typename?: 'Mutation', linkUpdate2: { __typename?: 'LinkSuccess', link: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } } };

export type CreateLinkFromLinkGroupMutationVariables = Exact<{
  linkGroupId: Scalars['ID']['input'];
}>;


export type CreateLinkFromLinkGroupMutation = { __typename?: 'Mutation', linkGroupCreateLink: { __typename?: 'LinkGroupCreateLink', link: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } } };

export type SendSupportTicketMutationVariables = Exact<{
  contextUrl?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
}>;


export type SendSupportTicketMutation = { __typename?: 'Mutation', sendSupportTicket: { __typename?: 'SendSupportTicket', ticketId: number } };

export type ProductBoardTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductBoardTokenQuery = { __typename?: 'Query', productboardToken: { __typename?: 'ProductboardResult', token: string } };

export type ProductUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductUpdatesQuery = { __typename?: 'Query', productUpdates: Array<{ __typename?: 'CategoryArticle', title: string, url: string }> };

export type ClientUserUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientUserUpdateMutation = { __typename?: 'Mutation', clientUserUpdate: { __typename?: 'ClientUserUpdate', client: { __typename?: 'Client', id: string } } };

export type GetTrackingParameterDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrackingParameterDefinitionsQuery = { __typename?: 'Query', trackingParameterDefinitions: Array<{ __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename: 'AttributeOption2', id: string, title: string }> } | { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }> };

export type ManagedMediaUsagesQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type ManagedMediaUsagesQuery = { __typename?: 'Query', mediaLibrary2: Array<{ __typename?: 'ExternalMedia' } | { __typename?: 'ManagedMedia', id: string, usages: Array<{ __typename: 'EmailCreativeUsage', id: string, channel: Channel, creativeId: string, creativeTitle: string, layoutId: string, templateTagId: string } | { __typename: 'LayoutComponentUsage', id: string, channel: Channel, componentId: string, componentName: string, componentType: LayoutComponentTypeEnum, layoutId: string, versionNumber: number } | { __typename: 'MmsCreativeUsage', id: string, channel: Channel, creativeId: string, creativeTitle: string, contentId: string } | { __typename: 'PushCreativeUsage', id: string, channel: Channel, creativeId: string, creativeTitle: string, contentId: string }> }> };

export type MediaLibraryQueryVariables = Exact<{
  mediaIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MediaLibraryQuery = { __typename?: 'Query', mediaLibrary2: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }> };

export type AccountUserInvitationAcceptMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountUserInvitationAcceptMutation = { __typename?: 'Mutation', accountUserInvitationAccept2: { __typename?: 'AccountUserInvitationAccept2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type AccountUserInvitationDeclineMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountUserInvitationDeclineMutation = { __typename?: 'Mutation', accountUserInvitationDecline: { __typename?: 'AccountUserInvitationDecline', success: boolean } };

export type ReportingCampaignContentBlocksMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ReportingCampaignContentBlocksMetricsQuery = { __typename?: 'Query', campaignContentblocksMetrics: Array<{ __typename?: 'CampaignContentblockMetrics', contentblock: { __typename?: 'ContentBlock', id: string, title: string, type: ContentBlockType }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type ReportingCampaignCreativesMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ReportingCampaignCreativesMetricsQuery = { __typename?: 'Query', campaignCreativesMetrics: Array<{ __typename?: 'CreativeMetric', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, minStartDate?: string | null, maxEndDate?: string | null, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type ReportingCampaignExperimentsMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ReportingCampaignExperimentsMetricsQuery = { __typename?: 'Query', campaignExperimentsMetrics: Array<{ __typename?: 'ExperimentMetrics', experiment: { __typename?: 'Experiment', id: string, title: string, status: ExperimentStatus, minDate?: string | null, maxDate?: string | null }, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type ReportingCampaignsHeaderQueryVariables = Exact<{
  filter: CampaignFilter;
}>;


export type ReportingCampaignsHeaderQuery = { __typename?: 'Query', campaignsMetrics: { __typename?: 'CampaignMetrics', campaigns?: Array<{ __typename?: 'CampaignMetric', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel } } }> | null } };

export type ReportingCampaignMailingsMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ReportingCampaignMailingsMetricsQuery = { __typename?: 'Query', campaignMailingsMetrics: Array<{ __typename?: 'MailingMetrics', mailing: { __typename?: 'Mailing', id: string, sendDatetime: string, type: MailingType }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type AnalyticsCampaignMailingActivityQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AnalyticsCampaignMailingActivityQuery = { __typename?: 'Query', analyticsCampaignMailingActivity: Array<{ __typename?: 'AnalyticsCampaignMailingActivity', mailing: { __typename?: 'Mailing', id: string, sendDatetime: string, type: MailingType }, activity: { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, uniqueConversionRate?: number | null, unknownBounceRate?: number | null, unknownBounces: number, unsubscribes: number, unsubscribeRate?: number | null } }> };

export type AnalyticsSendTimeMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AnalyticsSendTimeMetricsQuery = { __typename?: 'Query', analyticsCampaignSendTimeMetrics: Array<{ __typename?: 'CampaignSendTimeMetrics', sendTime: string, sends: number }> };

export type ReportingCampaignOverviewMetricsQueryVariables = Exact<{
  filter: CampaignFilter;
}>;


export type ReportingCampaignOverviewMetricsQuery = { __typename?: 'Query', campaignsMetrics: { __typename?: 'CampaignMetrics', campaigns?: Array<{ __typename?: 'CampaignMetric', campaign: { __typename?: 'Campaign', id: string, sendDate: string }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null, summary: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } };

export type ReportingCampaignSegmentsMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ReportingCampaignSegmentsMetricsQuery = { __typename?: 'Query', campaignSegmentsMetrics: Array<{ __typename?: 'SegmentGroupMetrics', audience: { __typename?: 'ContactAudience', id: string, name: string, description: string, updatedAt: string }, segments?: Array<{ __typename?: 'SegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type AnalyticsV2CampaignsMetricsGroupedByQueryVariables = Exact<{
  groupBy?: InputMaybe<CampaignGroupBy>;
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  campaignStages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsV2CampaignsMetricsGroupedByQuery = { __typename?: 'Query', analyticsV2GroupedCampaignMetrics: Array<{ __typename?: 'AnalyticsV2GroupedCampaigns', group: string, metrics: { __typename?: 'AnalyticsV2BaseMetrics', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clickToOpenRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversionToClickRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, messageRevenueVariance?: number | null, openRate?: number | null, opens: number, orderRevenueVariance?: number | null, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClickToOpenRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribes: number }, campaigns: Array<{ __typename?: 'AnalyticsV2Campaign', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, experiments: Array<{ __typename?: 'Experiment', id: string, title: string }> }, metrics: { __typename?: 'AnalyticsV2BaseMetrics', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clickToOpenRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversionToClickRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, messageRevenueVariance?: number | null, openRate?: number | null, opens: number, orderRevenueVariance?: number | null, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClickToOpenRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribes: number } }> }> };

export type GroupedCampaignsMetricsQueryVariables = Exact<{
  filter: CampaignFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
}>;


export type GroupedCampaignsMetricsQuery = { __typename?: 'Query', groupedCampaignsMetrics: Array<{ __typename?: 'GroupedCampaignsMetrics', group: string, campaigns?: Array<{ __typename?: 'CampaignMetric', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, experiments: Array<{ __typename?: 'Experiment', id: string, title: string }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type MetricSeriesFieldsFragment = { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null };

type CampaignComparisonBaseFieldsV2_CategoryMetric_Fragment = { __typename: 'CategoryMetric', id: string, name: string, category?: string | null };

type CampaignComparisonBaseFieldsV2_CountMetric_Fragment = { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CampaignComparisonBaseFieldsV2_CurrencyMetric_Fragment = { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CampaignComparisonBaseFieldsV2_CurrencyRateMetric_Fragment = { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CampaignComparisonBaseFieldsV2_FractionalCountMetric_Fragment = { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null };

type CampaignComparisonBaseFieldsV2_RateMetric_Fragment = { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CampaignComparisonBaseFieldsV2_ScoreMetric_Fragment = { __typename: 'ScoreMetric' };

export type CampaignComparisonBaseFieldsV2Fragment = CampaignComparisonBaseFieldsV2_CategoryMetric_Fragment | CampaignComparisonBaseFieldsV2_CountMetric_Fragment | CampaignComparisonBaseFieldsV2_CurrencyMetric_Fragment | CampaignComparisonBaseFieldsV2_CurrencyRateMetric_Fragment | CampaignComparisonBaseFieldsV2_FractionalCountMetric_Fragment | CampaignComparisonBaseFieldsV2_RateMetric_Fragment | CampaignComparisonBaseFieldsV2_ScoreMetric_Fragment;

export type CampaignComparativeStatisticsFieldsV2Fragment = { __typename?: 'ComparativeStatistics', averageOrderValue: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueOpenRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerThousandSends: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, openRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null } };

export type CampaignComparativeSeriesFieldsV2Fragment = { __typename?: 'ComparativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueOpens: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, sends: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } };

export type CampaignsActivityFieldsFragment = { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, uniqueConversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueOpenRate?: number | null, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribes: number };

export type AnalyticsCampaignsActivityQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  include?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  stages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
}>;


export type AnalyticsCampaignsActivityQuery = { __typename?: 'Query', analyticsCampaignsActivity: { __typename?: 'AnalyticsCampaignActivities', campaigns: Array<{ __typename?: 'AnalyticsCampaignActivity', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, experiments: Array<{ __typename?: 'Experiment', id: string, title: string }> }, activity: { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, uniqueConversionRate?: number | null, unknownBounceRate?: number | null, unknownBounces: number, unsubscribes: number, unsubscribeRate?: number | null } }> } };

export type AnalyticsV2CampaignExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput> | AnalyticsFilterInput;
  groupBy?: InputMaybe<CampaignGroupBy>;
}>;


export type AnalyticsV2CampaignExportMutation = { __typename?: 'Mutation', analyticsV2CampaignExport: { __typename?: 'AnalyticsExportReponse', signedUrl: string } };

export type AnalyticsCampaignFiltersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  creativeChannel?: InputMaybe<Channel>;
  campaignChannels?: InputMaybe<Array<Channel> | Channel>;
}>;


export type AnalyticsCampaignFiltersQuery = { __typename?: 'Query', analyticsV2Creatives?: Array<{ __typename?: 'Creative', id: string, title: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> | null, campaigns: { __typename?: 'CampaignPaginatedType', results: Array<{ __typename?: 'Campaign', id: string, title: string }> }, analyticsV2Experiments?: Array<{ __typename?: 'Experiment', id: string, title: string }> | null, campaignView?: { __typename?: 'CampaignView', tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type CampaignFilterOptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['SearchUID']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  channels?: InputMaybe<Array<Channel> | Channel>;
}>;


export type CampaignFilterOptionsQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginatedType', page: number, total: number, results: Array<{ __typename?: 'Campaign', id: string, title: string }> } };

export type AnalyticsCampaignComparisonTreatmentV2QueryVariables = Exact<{
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  campaignFilter: CampaignMetricsFilter;
}>;


export type AnalyticsCampaignComparisonTreatmentV2Query = { __typename?: 'Query', campaignComparisonByTreatmentV2: { __typename?: 'ComparisonMetricV2', baselines?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, groups?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, series?: { __typename?: 'ComparativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueOpens: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, sends: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } } | null } };

export type AnalyticsCampaignComparisonSegmentV2QueryVariables = Exact<{
  baselineSegmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  campaignFilter: CampaignMetricsFilter;
  groupSegmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AnalyticsCampaignComparisonSegmentV2Query = { __typename?: 'Query', campaignComparisonBySegmentV2: { __typename?: 'ComparisonMetricV2', baselines?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, groups?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, series?: { __typename?: 'ComparativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueOpens: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, sends: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } } | null } };

export type CampaignsMetricsQueryVariables = Exact<{
  filter: CampaignFilter;
}>;


export type CampaignsMetricsQuery = { __typename?: 'Query', campaignsMetrics: { __typename?: 'CampaignMetrics', campaigns?: Array<{ __typename?: 'CampaignMetric', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null, summary: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } };

export type RecurringCampaignsMetricsV2QueryVariables = Exact<{
  filter: RecurringCampaignMetricsV2Filter;
}>;


export type RecurringCampaignsMetricsV2Query = { __typename?: 'Query', recurringCampaignMetricsV2: { __typename?: 'RecurringCampaignMetricsV2', campaigns?: Array<{ __typename?: 'RecurringCampaignMetricV2', campaign: { __typename?: 'RecurringCampaignType', id: string, title: string, stage: RecurringCampaignStage, sendDate?: string | null, schedule?: { __typename?: 'RecurrenceScheduleType', sendTime?: any | null, timezone: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null, summary: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } };

export type CampaignsMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: CampaignMetricsFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CampaignsMetricsExportMutation = { __typename?: 'Mutation', campaignsMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type CampaignTreatmentComparisonExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: TreatmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CampaignTreatmentComparisonExportMutation = { __typename?: 'Mutation', campaignTreatmentComparisonExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type CampaignSegmentComparisonExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SegmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CampaignSegmentComparisonExportMutation = { __typename?: 'Mutation', campaignSegmentComparisonExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type AnalyticsCreativeCampaignsActivityQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsCreativeCampaignsActivityQuery = { __typename?: 'Query', analyticsCreativeCampaignActivity: Array<{ __typename?: 'AnalyticsCreativeCampaignActivity', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, activity: { __typename?: 'AnalyticsBaseCreativeActivity', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number, unsubscribeRate?: number | null, unsubscribes: number } }> };

export type AnalyticsCreativeContentBlocksQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsCreativeContentBlocksQuery = { __typename?: 'Query', analyticsCreativeContentblockMetrics: Array<{ __typename?: 'CreativeContentblockMetrics', contentblock: { __typename?: 'ContentBlock', id: string, title: string, images: Array<{ __typename?: 'Image', id: string, url: string }> }, metrics: { __typename?: 'BaseCreativeMetrics', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number } }> };

export type AnalyticsV2CreativeExperimentReportColumnsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsV2CreativeExperimentReportColumnsQuery = { __typename?: 'Query', analyticsV2CreativeExperimentReportColumns: Array<{ __typename?: 'AnalyticsReportColumn', id: string, label: string, sortable: boolean, visibleByDefault: boolean }> };

export type AnalyticsV2CreativeExperimentsReportQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  dateRange: Scalars['DateRange']['input'];
}>;


export type AnalyticsV2CreativeExperimentsReportQuery = { __typename?: 'Query', analyticsV2CreativeExperimentsReport: { __typename?: 'AnalyticsReport', reportRows: Array<{ __typename?: 'AnalyticsReportRow', row: Array<{ __typename?: 'AnalyticsReportEntry', columnId: string, value?: { __typename?: 'AnalyticsReportValueBoolean', boolValue: boolean } | { __typename?: 'AnalyticsReportValueDate', dateValue: string } | { __typename?: 'AnalyticsReportValueDateTime', datetimeValue: string } | { __typename?: 'AnalyticsReportValueFloat', floatValue: number } | { __typename?: 'AnalyticsReportValueInteger', intValue: number } | { __typename?: 'AnalyticsReportValueString', strValue: string } | null }> }> } };

export type AnalyticsV2CreativeExperimentExportMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  dateRange: Scalars['DateRange']['input'];
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AnalyticsV2CreativeExperimentExportMutation = { __typename?: 'Mutation', analyticsV2CreativeExperimentExport: { __typename?: 'AnalyticsExportReponse', signedUrl: string } };

export type AnalyticsCreativeActivityQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsCreativeActivityQuery = { __typename?: 'Query', analyticsCreativeActivity: { __typename?: 'AnalyticsCreativeActivity', creative: { __typename?: 'Creative', id: string, title: string, shortUuid: string, createdAt: string, status: CreativeStatus, bestThumbnail: { __typename?: 'Thumbnail', url: string }, availabilities: Array<{ __typename?: 'Availability', id: string, startDatetime: string, endDatetime?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, activity: { __typename?: 'AnalyticsBaseCreativeActivity', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number, unsubscribeRate?: number | null, unsubscribes: number } }, analyticsCreativeCampaignActivity: Array<{ __typename?: 'AnalyticsCreativeCampaignActivity', campaign: { __typename?: 'Campaign', id: string, sendDate: string }, activity: { __typename?: 'AnalyticsBaseCreativeActivity', placements: number, uniqueClicks: number, uniqueImpressions: number, revenue: number } }> };

export type CreativeDetailsSegmentsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreativeDetailsSegmentsQuery = { __typename?: 'Query', analyticsCreativeSegmentActivity: Array<{ __typename?: 'AnalyticsCreativeSegmentActivity', segment: { __typename?: 'ContactSegment', id: string }, activity: { __typename?: 'AnalyticsBaseCreativeActivity', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number, unsubscribeRate?: number | null, unsubscribes: number } }>, contactSegmentGroups: Array<{ __typename?: 'ContactSegmentGroup', id: string, archived: boolean, status: ContactSegmentGroupStatus, createdAt: string, description: string, name: string, updatedAt: string, segments: Array<{ __typename?: 'ContactSegment', id: string, segmentGroupId: string, createdAt: string, fallback: boolean, priority: number, query: any, updatedAt: string, segment: string }> }> };

export type CreativeDetailsOverviewQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreativeDetailsOverviewQuery = { __typename?: 'Query', analyticsCreativeActivity: { __typename?: 'AnalyticsCreativeActivity', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CreativeDetailsSubjectLinesQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  include?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CreativeDetailsSubjectLinesQuery = { __typename?: 'Query', analyticsCreativeSubjectlineActivity: Array<{ __typename?: 'AnalyticsCreativeSubjectLineActivity', subjectline: { __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null }, activity: { __typename?: 'AnalyticsBaseCreativeActivity', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number, unsubscribeRate?: number | null, unsubscribes: number } }> };

export type CreativeComparisonBaseFieldsFragment = { __typename?: 'AnalyticsV2BaseCreativeMetrics', averageOrderValue?: number | null, clicks: number, uniqueClickRate?: number | null, uniqueConversionRate?: number | null, conversions: number, uniqueImpressionRate?: number | null, impressions: number, uniqueImpressions: number, placements: number, revenue: number, revenuePerThousandPlacements?: number | null, uniqueClicks: number, uniqueConversions: number };

export type CreativeComparativeStatisticsFieldsFragment = { __typename?: 'ComparativeCreativeStatistics', uniqueAutoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, autoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, averageOrderValue: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, impressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerPlacement: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerThousandPlacements: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null } };

export type CreativeComparativeSeriesFieldsFragment = { __typename?: 'ComparativeCreativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueImpressions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, placements: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } };

export type AnalyticsCreativeComparisonTreatmentQueryVariables = Exact<{
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  creativeFilter: ComparisonCreativeFilterInput;
}>;


export type AnalyticsCreativeComparisonTreatmentQuery = { __typename?: 'Query', creativeComparisonByTreatment: { __typename?: 'ComparisonCreativeMetric', baselines?: { __typename?: 'AnalyticsV2BaseCreativeMetrics', averageOrderValue?: number | null, clicks: number, uniqueClickRate?: number | null, uniqueConversionRate?: number | null, conversions: number, uniqueImpressionRate?: number | null, impressions: number, uniqueImpressions: number, placements: number, revenue: number, revenuePerThousandPlacements?: number | null, uniqueClicks: number, uniqueConversions: number } | null, groups?: { __typename?: 'AnalyticsV2BaseCreativeMetrics', averageOrderValue?: number | null, clicks: number, uniqueClickRate?: number | null, uniqueConversionRate?: number | null, conversions: number, uniqueImpressionRate?: number | null, impressions: number, uniqueImpressions: number, placements: number, revenue: number, revenuePerThousandPlacements?: number | null, uniqueClicks: number, uniqueConversions: number } | null, statistics?: { __typename?: 'ComparativeCreativeStatistics', uniqueAutoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, autoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, averageOrderValue: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, impressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerPlacement: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerThousandPlacements: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null } } | null, series?: { __typename?: 'ComparativeCreativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueImpressions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, placements: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } } | null } };

export type AnalyticsCreativeComparisonSegmentsQueryVariables = Exact<{
  baselineSegmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  creativeFilter: ComparisonCreativeFilterInput;
  groupSegmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AnalyticsCreativeComparisonSegmentsQuery = { __typename?: 'Query', creativeComparisonBySegment: { __typename?: 'ComparisonCreativeMetric', baselines?: { __typename?: 'AnalyticsV2BaseCreativeMetrics', averageOrderValue?: number | null, clicks: number, uniqueClickRate?: number | null, uniqueConversionRate?: number | null, conversions: number, uniqueImpressionRate?: number | null, impressions: number, uniqueImpressions: number, placements: number, revenue: number, revenuePerThousandPlacements?: number | null, uniqueClicks: number, uniqueConversions: number } | null, groups?: { __typename?: 'AnalyticsV2BaseCreativeMetrics', averageOrderValue?: number | null, clicks: number, uniqueClickRate?: number | null, uniqueConversionRate?: number | null, conversions: number, uniqueImpressionRate?: number | null, impressions: number, uniqueImpressions: number, placements: number, revenue: number, revenuePerThousandPlacements?: number | null, uniqueClicks: number, uniqueConversions: number } | null, statistics?: { __typename?: 'ComparativeCreativeStatistics', uniqueAutoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, autoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, averageOrderValue: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, impressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerPlacement: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerThousandPlacements: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null } } | null, series?: { __typename?: 'ComparativeCreativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueImpressions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, placements: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } } | null } };

export type ReportingCreativeCampaignsMetricsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
}>;


export type ReportingCreativeCampaignsMetricsQuery = { __typename?: 'Query', creativeCampaignsMetrics: Array<{ __typename?: 'CreativeCampaignMetrics', campaign: { __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, sendDate: string, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type ReportingCreativeContentBlocksQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
}>;


export type ReportingCreativeContentBlocksQuery = { __typename?: 'Query', creativeContentblocksMetrics: Array<{ __typename?: 'CreativeContentblockMetricsV2', contentblock: { __typename?: 'ContentBlock', id: string, title: string, images: Array<{ __typename?: 'Image', id: string, url: string }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type ReportingCreativeExperimentsMetricsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
}>;


export type ReportingCreativeExperimentsMetricsQuery = { __typename?: 'Query', creativeExperimentsMetrics: Array<{ __typename?: 'CreativeExperimentMetrics', experiment: { __typename?: 'Experiment', id: string, title: string, status: ExperimentStatus, minDate?: string | null, maxDate?: string | null, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean, order: number }> }, treatments?: Array<{ __typename?: 'CreativeTreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type CreativeHeaderIdentityQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeHeaderIdentityQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type ReportingCreativeSegmentsMetricsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
}>;


export type ReportingCreativeSegmentsMetricsQuery = { __typename?: 'Query', creativeSegmentsMetrics: Array<{ __typename?: 'CreativeSegmentGroupMetrics', audience?: { __typename?: 'ContactAudience', id: string, name: string, description: string, updatedAt: string } | null, segments?: Array<{ __typename?: 'CreativeSegmentMetricsV2', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type ReportingCreativeDetailsSubjectLinesQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<CreativeDetailMetricsFilter>;
}>;


export type ReportingCreativeDetailsSubjectLinesQuery = { __typename?: 'Query', creativeSubjectlinesMetrics: Array<{ __typename?: 'CreativeSubjectlineMetrics', subjectline: { __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type AnalyticsV2CreativesMetricsGroupedByTagQueryVariables = Exact<{
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  campaignStages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus> | CreativeStatus>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<CreativeGroupBy>;
}>;


export type AnalyticsV2CreativesMetricsGroupedByTagQuery = { __typename?: 'Query', analyticsV2CreativesMetricsGroupedByTag: Array<{ __typename?: 'AnalyticsV2GroupedCreatives', group: string, creativeCount: number, creativeUsageRatio: number, metrics: { __typename?: 'AnalyticsV2BaseCreativeMetrics', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clicks: number, conversionRate?: number | null, conversions: number, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressions: number, uniqueClicks: number, uniqueConversions: number, uniqueImpressions: number, uniqueClickRate?: number | null, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueImpressionRate?: number | null }, scores: { __typename?: 'AnalyticsCreativeScores', creativeId: string, effectiveness?: number | null, openEffectiveness?: number | null, clickEffectiveness?: number | null, conversionEffectiveness?: number | null, percentPositiveReaction?: number | null }, creatives: Array<{ __typename?: 'AnalyticsV2Creative', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, metrics: { __typename?: 'AnalyticsV2BaseCreativeMetrics', placements: number, autoImpressions: number, uniqueAutoImpressions: number, autoImpressionRate?: number | null, impressions: number, uniqueImpressions: number, clicks: number, uniqueClicks: number, conversions: number, uniqueConversions: number, conversionRate?: number | null, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, averageOrderValue?: number | null, uniqueImpressionRate?: number | null, uniqueClickRate?: number | null, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null }, scores: { __typename?: 'AnalyticsCreativeScores', creativeId: string, effectiveness?: number | null, openEffectiveness?: number | null, clickEffectiveness?: number | null, conversionEffectiveness?: number | null, percentPositiveReaction?: number | null } }> }> };

type CreativeComparisonBaseFieldsV2_CategoryMetric_Fragment = { __typename: 'CategoryMetric', id: string, name: string, category?: string | null };

type CreativeComparisonBaseFieldsV2_CountMetric_Fragment = { __typename: 'CountMetric', id: string, name: string, count?: number | null };

type CreativeComparisonBaseFieldsV2_CurrencyMetric_Fragment = { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CreativeComparisonBaseFieldsV2_CurrencyRateMetric_Fragment = { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CreativeComparisonBaseFieldsV2_FractionalCountMetric_Fragment = { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CreativeComparisonBaseFieldsV2_RateMetric_Fragment = { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null };

type CreativeComparisonBaseFieldsV2_ScoreMetric_Fragment = { __typename: 'ScoreMetric' };

export type CreativeComparisonBaseFieldsV2Fragment = CreativeComparisonBaseFieldsV2_CategoryMetric_Fragment | CreativeComparisonBaseFieldsV2_CountMetric_Fragment | CreativeComparisonBaseFieldsV2_CurrencyMetric_Fragment | CreativeComparisonBaseFieldsV2_CurrencyRateMetric_Fragment | CreativeComparisonBaseFieldsV2_FractionalCountMetric_Fragment | CreativeComparisonBaseFieldsV2_RateMetric_Fragment | CreativeComparisonBaseFieldsV2_ScoreMetric_Fragment;

export type CreativeComparativeStatisticsFieldsV2Fragment = { __typename?: 'ComparativeCreativeStatistics', uniqueAutoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, autoImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, averageOrderValue: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickToImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueClickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, clickthroughRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueConversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, conversionToClickRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, uniqueImpressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, impressionRate: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerPlacement: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null }, revenuePerThousandPlacements: { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null } };

export type CreativeComparativeSeriesFieldsV2Fragment = { __typename?: 'ComparativeCreativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueImpressions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, placements: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } };

export type AnalyticsV2CreativeExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput> | AnalyticsFilterInput;
  groupBy?: InputMaybe<CreativeGroupBy>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AnalyticsV2CreativeExportMutation = { __typename?: 'Mutation', analyticsV2CreativeExport: { __typename?: 'AnalyticsExportReponse', signedUrl: string } };

export type AnalyticsCreativeFiltersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  creativeChannel?: InputMaybe<Channel>;
  campaignChannels?: InputMaybe<Array<Channel> | Channel>;
  recurringCampaignFilter?: InputMaybe<RecurringCampaignFilterInput>;
  includeRecurringCampaigns: Scalars['Boolean']['input'];
}>;


export type AnalyticsCreativeFiltersQuery = { __typename?: 'Query', analyticsV2Creatives?: Array<{ __typename?: 'Creative', id: string, title: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> | null, campaigns: { __typename?: 'CampaignPaginatedType', results: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType }> }, recurringCampaigns?: { __typename?: 'RecurringCampaignConnection', edges: Array<{ __typename?: 'RecurringCampaignEdge', node: { __typename?: 'RecurringCampaignType', id: string, title: string } } | null> }, analyticsV2Experiments?: Array<{ __typename?: 'Experiment', id: string, title: string }> | null, campaignView?: { __typename?: 'CampaignView', tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type AnalyticsCreativeComparisonTreatmentV2QueryVariables = Exact<{
  baselineTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groupTreatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  creativeFilter: CreativeMetricsFilter;
}>;


export type AnalyticsCreativeComparisonTreatmentV2Query = { __typename?: 'Query', creativeComparisonByTreatmentV2: { __typename?: 'ComparisonCreativeMetricV2', baselines?: Array<{ __typename?: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename?: 'CountMetric', id: string, name: string, count?: number | null } | { __typename?: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null } | { __typename?: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric' } | null> | null, groups?: Array<{ __typename?: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename?: 'CountMetric', id: string, name: string, count?: number | null } | { __typename?: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null } | { __typename?: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric' } | null> | null, series?: { __typename?: 'ComparativeCreativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueImpressions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, placements: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } } | null } };

export type AnalyticsCreativeComparisonSegmentsV2QueryVariables = Exact<{
  baselineSegmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  creativeFilter: CreativeMetricsFilter;
  groupSegmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AnalyticsCreativeComparisonSegmentsV2Query = { __typename?: 'Query', creativeComparisonBySegmentV2: { __typename?: 'ComparisonCreativeMetricV2', baselines?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, groups?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, series?: { __typename?: 'ComparativeCreativeMetricSeries', uniqueClicks: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueConversions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, uniqueImpressions: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, revenue: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null }, placements: { __typename?: 'MetricSeries', baselines?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null, groups?: Array<{ __typename?: 'MetricPoint', label: string, value: number }> | null } } | null } };

export type CreativeMetricsQueryVariables = Exact<{
  filter: CreativeMetricsFilter;
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type CreativeMetricsQuery = { __typename?: 'Query', creativesMetrics: { __typename?: 'CreativeMetrics', creatives?: Array<{ __typename?: 'CreativeMetric', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, createdAt: string, minStartDate?: string | null, maxEndDate?: string | null, daysAvailable?: number | null, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null, summary: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } };

export type CreativeTreatmentComparisonExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: TreatmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreativeTreatmentComparisonExportMutation = { __typename?: 'Mutation', creativeTreatmentComparisonExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type CreativeSegmentComparisonExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SegmentComparisonFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreativeSegmentComparisonExportMutation = { __typename?: 'Mutation', creativeSegmentComparisonExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type CreativesMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: CreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreativesMetricsExportMutation = { __typename?: 'Mutation', creativesMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type CreativesMultiGroupedMetricsExportMutationVariables = Exact<{
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filter: CreativeMetricsFilter;
  groupBy: Array<CreativeGroupBy> | CreativeGroupBy;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreativesMultiGroupedMetricsExportMutation = { __typename?: 'Mutation', creativesMultiGroupedMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type GroupedCreativeMetricsQueryVariables = Exact<{
  filter: CreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GroupedCreativeMetricsQuery = { __typename?: 'Query', groupedCreativesMetrics: Array<{ __typename?: 'GroupedCreativesMetrics', group: string, creatives?: Array<{ __typename?: 'CreativeMetric', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, createdAt: string, minStartDate?: string | null, maxEndDate?: string | null, daysAvailable?: number | null, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type MultiGroupedCreativesMetricsQueryVariables = Exact<{
  filter: CreativeMetricsFilter;
  groupBy: Array<CreativeGroupBy> | CreativeGroupBy;
}>;


export type MultiGroupedCreativesMetricsQuery = { __typename?: 'Query', multiGroupedCreativesMetrics: Array<{ __typename?: 'MultiGroupedCreativesMetrics', groups?: Array<{ __typename?: 'GroupDimension', dimension: string, value: string }> | null, creatives?: Array<{ __typename?: 'CreativeMetric', creative: { __typename?: 'Creative', id: string } }> | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> } | null> };

export type AnalyticsCreativesActivityV2QueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus> | CreativeStatus>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  experimentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeCreativeTags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeCampaignTags?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AnalyticsCreativesActivityV2Query = { __typename?: 'Query', analyticsCreativesActivityV2: { __typename?: 'AnalyticsCreativeActivitiesV2', creatives: Array<{ __typename?: 'AnalyticsCreativeActivityV2', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, activity: { __typename?: 'AnalyticsBaseCreativeActivity', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number }, scores: { __typename?: 'AnalyticsCreativeScoresV2', creativeId: string, creativeEffectiveness?: number | null, openEffectiveness?: number | null, clickEffectiveness?: number | null, revenueEffectiveness?: number | null, retentionEffectiveness?: number | null, conversionEffectiveness?: number | null, creativeBucket?: string | null, openBucket?: string | null, clickBucket?: string | null, revenueBucket?: string | null, retentionBucket?: string | null, conversionBucket?: string | null } }> } };

export type AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables = Exact<{
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  campaignStages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus> | CreativeStatus>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<CreativeGroupBy>;
}>;


export type AnalyticsV2CreativesMetricsGroupedByTagV2Query = { __typename?: 'Query', analyticsV2CreativesMetricsGroupedByTagV2: Array<{ __typename?: 'AnalyticsV2GroupedCreativesV2', group: string, creativeCount: number, creativeUsageRatio: number, metrics: { __typename?: 'AnalyticsV2BaseCreativeMetrics', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clicks: number, conversionRate?: number | null, conversions: number, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressions: number, uniqueClicks: number, uniqueConversions: number, uniqueImpressions: number, uniqueClickRate?: number | null, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueImpressionRate?: number | null }, scores: { __typename?: 'AnalyticsCreativeScoresV2', creativeId: string, openEffectiveness?: number | null, retentionEffectiveness?: number | null, revenueEffectiveness?: number | null, creativeEffectiveness?: number | null, clickEffectiveness?: number | null, conversionEffectiveness?: number | null, clickBucket?: string | null, openBucket?: string | null, creativeBucket?: string | null, conversionBucket?: string | null, retentionBucket?: string | null, revenueBucket?: string | null }, creatives: Array<{ __typename?: 'AnalyticsV2CreativeV2', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, metrics: { __typename?: 'AnalyticsV2BaseCreativeMetrics', placements: number, autoImpressions: number, uniqueAutoImpressions: number, autoImpressionRate?: number | null, impressions: number, uniqueImpressions: number, clicks: number, uniqueClicks: number, conversions: number, uniqueConversions: number, conversionRate?: number | null, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, averageOrderValue?: number | null, uniqueImpressionRate?: number | null, uniqueClickRate?: number | null, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null }, scores: { __typename?: 'AnalyticsCreativeScoresV2', creativeId: string, openEffectiveness?: number | null, clickEffectiveness?: number | null, conversionEffectiveness?: number | null, retentionEffectiveness?: number | null, revenueEffectiveness?: number | null, creativeEffectiveness?: number | null, clickBucket?: string | null, openBucket?: string | null, creativeBucket?: string | null, conversionBucket?: string | null, retentionBucket?: string | null, revenueBucket?: string | null } }> }> };

export type AnalyticsDashboardConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsDashboardConfigQuery = { __typename?: 'Query', analyticsDashboardConfig: Array<{ __typename?: 'AnalyticsWidget', id: string, name: string, enabled: boolean, order: number, config?: string | null, expandedMetricIds?: Array<string> | null, option?: { __typename?: 'AnalyticsWidgetOption', selected: Array<string> } | null }> };

export type UpdateAnalyticsDashboardConfigMutationVariables = Exact<{
  widgets: Array<AnalyticsWidgetInput> | AnalyticsWidgetInput;
}>;


export type UpdateAnalyticsDashboardConfigMutation = { __typename?: 'Mutation', updateAnalyticsDashboardConfig: { __typename: 'AnalyticsDashboardConfigUpdateResponse' } };

export type DashboardCampaignMetricsQueryVariables = Exact<{
  filter: CampaignFilter;
}>;


export type DashboardCampaignMetricsQuery = { __typename?: 'Query', campaignsMetrics: { __typename?: 'CampaignMetrics', summary: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', id: string, currency?: number | null } | { __typename?: 'CurrencyRateMetric', id: string, currencyRate?: number | null } | { __typename?: 'FractionalCountMetric', id: string, fractionalCount?: number | null } | { __typename?: 'RateMetric', id: string, rate?: number | null } | { __typename?: 'ScoreMetric', id: string, score?: number | null, label?: string | null } | null> } };

export type DashboardCreativeMetricsQueryVariables = Exact<{
  filter: CreativeMetricsFilter;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardCreativeMetricsQuery = { __typename?: 'Query', creativesMetrics: { __typename?: 'CreativeMetrics', creatives?: Array<{ __typename?: 'CreativeMetric', creative: { __typename?: 'Creative', id: string, title: string, bestThumbnail: { __typename?: 'Thumbnail', url: string } }, metrics: Array<{ __typename?: 'CategoryMetric', id: string } | { __typename?: 'CountMetric', count?: number | null, id: string } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', id: string } | { __typename?: 'FractionalCountMetric', id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', label?: string | null, id: string } | null> }> | null } };

export type DashboardExperimentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardExperimentGroupsQuery = { __typename?: 'Query', experimentGroups: Array<{ __typename?: 'ExperimentGroup', id: string, title: string, experimentType: ExperimentType }> };

export type DashboardExperimentGroupsWithDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardExperimentGroupsWithDefinitionsQuery = { __typename?: 'Query', experimentGroups: Array<{ __typename?: 'ExperimentGroup', id: string, title: string, experimentType: ExperimentType, treatmentDefinitions: Array<{ __typename?: 'ExperimentGroupTreatmentDefinition', id: string, title: string, order: number, size?: number | null, isControl: boolean }> }> };

export type DashboardTreatmentDefinitionComparisonQueryVariables = Exact<{
  baselineTreatmentDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groupTreatmentDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  campaignFilter: CampaignMetricsFilter;
}>;


export type DashboardTreatmentDefinitionComparisonQuery = { __typename?: 'Query', campaignComparisonByTreatmentV2: { __typename?: 'ComparisonMetricV2', baselines?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null, groups?: Array<{ __typename: 'CategoryMetric', id: string, name: string, category?: string | null } | { __typename: 'CountMetric', id: string, name: string, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyMetric', id: string, name: string, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'CurrencyRateMetric', id: string, name: string, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'FractionalCountMetric', id: string, name: string, fractionalCount?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'RateMetric', id: string, name: string, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, ciUpper?: number | null, ciLower?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename: 'ScoreMetric' } | null> | null } };

export type NamedMetricSeriesFieldsFragment = { __typename?: 'NamedMetricSeries', metric: string, baselines?: Array<{ __typename?: 'MetricValuePoint', label: string, value?: number | null }> | null, groups?: Array<{ __typename?: 'MetricValuePoint', label: string, value?: number | null }> | null };

export type DashboardTreatmentTrendQueryVariables = Exact<{
  baselineTreatmentDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groupTreatmentDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  campaignFilter: CampaignMetricsFilter;
  seriesMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DashboardTreatmentTrendQuery = { __typename?: 'Query', campaignComparisonByTreatmentV2: { __typename?: 'ComparisonMetricV2', metricSeries?: Array<{ __typename?: 'NamedMetricSeries', metric: string, baselines?: Array<{ __typename?: 'MetricValuePoint', label: string, value?: number | null }> | null, groups?: Array<{ __typename?: 'MetricValuePoint', label: string, value?: number | null }> | null } | null> | null } };

export type AnalyticsExperimentHeaderQueryVariables = Exact<{
  experimentId: Scalars['ID']['input'];
}>;


export type AnalyticsExperimentHeaderQuery = { __typename?: 'Query', analyticsExperimentActivity: { __typename?: 'AnalyticsExperimentActivity', earliestCampaignUsage?: string | null, latestCampaignUsage?: string | null, experiment: { __typename?: 'Experiment', id: string, title: string, status: ExperimentStatus } } };

export type ExperimentDetailsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: ExperimentMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExperimentDetailsExportMutation = { __typename?: 'Mutation', experimentMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ExperimentCampaignsMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: ExperimentCampaignMetricsFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExperimentCampaignsMetricsExportMutation = { __typename?: 'Mutation', experimentCampaignsMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ExperimentCreativesMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: ExperimentCreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExperimentCreativesMetricsExportMutation = { __typename?: 'Mutation', experimentCreativesMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ExperimentCampaignsMetricsQueryVariables = Exact<{
  filter: ExperimentCampaignMetricsFilter;
}>;


export type ExperimentCampaignsMetricsQuery = { __typename?: 'Query', experimentCampaignsMetrics: Array<{ __typename?: 'ExperimentCampaignMetrics', campaign: { __typename?: 'Campaign', id: string, title: string }, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type ExperimentCreativesMetricsQueryVariables = Exact<{
  filter: ExperimentCreativeMetricsFilter;
}>;


export type ExperimentCreativesMetricsQuery = { __typename?: 'Query', experimentCreativesMetrics: Array<{ __typename?: 'ExperimentCreativeMetrics', creative: { __typename?: 'Creative', id: string, title: string }, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type ReportingExperimentSegmentsMetricsQueryVariables = Exact<{
  filter: ExperimentSegmentsMetricsFilter;
}>;


export type ReportingExperimentSegmentsMetricsQuery = { __typename?: 'Query', experimentSegmentsMetrics: Array<{ __typename?: 'ExperimentSegmentsMetrics', audience: { __typename?: 'ContactAudience', id: string, name: string, description: string, updatedAt: string }, splits?: Array<{ __typename?: 'TreatmentSegmentMetrics', split: { __typename?: 'ContactAudienceSplit', id: string, name: string }, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null }> | null } | null> };

export type ExperimentSegmentsMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: ExperimentSegmentsMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExperimentSegmentsMetricsExportMutation = { __typename?: 'Mutation', experimentSegmentsMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ReportingExperimentGroupedCreativesMetricsQueryVariables = Exact<{
  filter: ExperimentCreativeMetricsFilter;
  groupBy: CreativeGroupBy;
}>;


export type ReportingExperimentGroupedCreativesMetricsQuery = { __typename?: 'Query', groupedExperimentCreativesMetrics: Array<{ __typename?: 'GroupedExperimentCreativeMetrics', group: string, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type ReportingExperimentGroupedCampaignsMetricsQueryVariables = Exact<{
  filter: ExperimentCampaignMetricsFilter;
  groupBy: CampaignGroupBy;
}>;


export type ReportingExperimentGroupedCampaignsMetricsQuery = { __typename?: 'Query', groupedExperimentCampaignsMetrics: Array<{ __typename?: 'GroupedExperimentCampaignMetrics', group: string, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type ExperimentMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: ExperimentMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExperimentMetricsExportMutation = { __typename?: 'Mutation', experimentMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ExperimentsMetricsQueryVariables = Exact<{
  filter: ExperimentMetricsFilter;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExperimentsMetricsQuery = { __typename?: 'Query', experimentsMetrics: Array<{ __typename?: 'ExperimentMetrics', experiment: { __typename?: 'Experiment', id: string, title: string, status: ExperimentStatus, experimentType: ExperimentType, minDate?: string | null, maxDate?: string | null, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean, order: number }> }, treatments?: Array<{ __typename?: 'TreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type ExperimentContactsMetricsQueryVariables = Exact<{
  filter: ExperimentMetricsFilter;
}>;


export type ExperimentContactsMetricsQuery = { __typename?: 'Query', experimentContactsMetrics: Array<{ __typename?: 'ExperimentContactMetrics', treatments?: Array<{ __typename?: 'TreatmentContactMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }, metrics: Array<{ __typename?: 'CategoryMetric', category?: string | null, id: string } | { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null } | { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null } | { __typename?: 'ScoreMetric', id: string } | null> }> | null } | null> };

export type AnalyticsCampaignActivityQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AnalyticsCampaignActivityQuery = { __typename?: 'Query', analyticsCampaignActivity: { __typename?: 'AnalyticsCampaignActivity', campaign: { __typename?: 'Campaign', id: string, title: string, sendDate: string, stage: CampaignStageType, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, activity: { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, uniqueConversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueOpenRate?: number | null, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribes: number } }, analyticsCampaignSendTimeMetrics: Array<{ __typename?: 'CampaignSendTimeMetrics', sendTime: string, sends: number }> };

export type ReportingSegmentDetailsHeaderQueryVariables = Exact<{
  filter: SegmentGroupMetricsFilter;
}>;


export type ReportingSegmentDetailsHeaderQuery = { __typename?: 'Query', segmentGroupsMetrics: Array<{ __typename?: 'SegmentGroupMetrics', audience: { __typename?: 'ContactAudience', id: string, name: string, createdAt: string } } | null> };

export type ContactSegmentFieldsFragment = { __typename?: 'ContactSegment', id: string, segmentGroupId: string, createdAt: string, fallback: boolean, priority: number, query: any, updatedAt: string, segment: string };

export type AnalyticsSegmentsActivityQueryVariables = Exact<{
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  include?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AnalyticsSegmentsActivityQuery = { __typename?: 'Query', contactSegmentGroups: Array<{ __typename?: 'ContactSegmentGroup', id: string, archived: boolean, status: ContactSegmentGroupStatus, createdAt: string, description: string, name: string, updatedAt: string, segments: Array<{ __typename?: 'ContactSegment', id: string, segmentGroupId: string, createdAt: string, fallback: boolean, priority: number, query: any, updatedAt: string, segment: string }> }>, analyticsSegmentsActivity: Array<{ __typename?: 'AnalyticsSegmentActivity', segment: { __typename?: 'ContactSegment', id: string }, activity: { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, uniqueConversionRate?: number | null, unknownBounceRate?: number | null, unknownBounces: number, unsubscribes: number, unsubscribeRate?: number | null } } | null> };

export type SegmentGroupsAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentGroupsAnalyticsQuery = { __typename?: 'Query', contactSegmentGroups: Array<{ __typename?: 'ContactSegmentGroup', id: string, archived: boolean, status: ContactSegmentGroupStatus, createdAt: string, description: string, name: string, updatedAt: string, segments: Array<{ __typename?: 'ContactSegment', id: string, name: string, segmentGroupId: string, createdAt: string, updatedAt: string, priority: number, fallback: boolean }> }> };

export type ContactTableCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactTableCountQuery = { __typename?: 'Query', contactTableCount: number };

export type AnalyticsSegmentCampaignsActivityQueryVariables = Exact<{
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  campaignStages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  segmentGroupId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsSegmentCampaignsActivityQuery = { __typename?: 'Query', analyticsV2SegmentGroupCampaignMetrics: Array<{ __typename?: 'AnalyticsV2SegmentGroupCampaign', campaign: { __typename?: 'Campaign', id: string, title: string }, segments: Array<{ __typename?: 'AnalyticsV2Segment', segment: { __typename?: 'ContactSegment', id: string, name: string }, metrics: { __typename?: 'AnalyticsV2BaseMetrics', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clickToOpenRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversionToClickRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, messageRevenueVariance?: number | null, openRate?: number | null, opens: number, orderRevenueVariance?: number | null, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClickToOpenRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribes: number } }> }> };

export type ReportingSegmentsCampaignsMetricsQueryVariables = Exact<{
  filter: SegmentGroupCampaignMetricsFilter;
}>;


export type ReportingSegmentsCampaignsMetricsQuery = { __typename?: 'Query', segmentGroupCampaignMetrics: Array<{ __typename?: 'SegmentGroupCampaignMetrics', campaign: { __typename?: 'Campaign', id: string, title: string }, segments?: Array<{ __typename?: 'CampaignSegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type AnalyticsSegmentGroupActivityQueryVariables = Exact<{
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  include?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  segmentGroupId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsSegmentGroupActivityQuery = { __typename?: 'Query', analyticsSegmentGroupActivity: { __typename?: 'AnalyticsSegmentGroupActivity', segmentGroup: { __typename?: 'ContactSegmentGroup', id: string, name: string, createdAt: string }, segments?: Array<{ __typename?: 'AnalyticsSegmentActivity', segment: { __typename?: 'ContactSegment', id: string, segment: string }, activity: { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, uniqueConversionRate?: number | null, unknownBounceRate?: number | null, unknownBounces: number, unsubscribes: number, unsubscribeRate?: number | null } } | null> | null } };

export type AnalyticsSegmentCreativesActivityQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  campaignStages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
  creativeIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  creativeStatuses?: InputMaybe<Array<CreativeStatus> | CreativeStatus>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCreativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  segmentGroupId: Scalars['ID']['input'];
}>;


export type AnalyticsSegmentCreativesActivityQuery = { __typename?: 'Query', analyticsV2SegmentGroupCreativeMetrics: Array<{ __typename?: 'AnalyticsV2SegmentGroupCreative', creative: { __typename?: 'Creative', id: string, title: string }, segments: Array<{ __typename?: 'AnalyticsV2CreativeSegment', segment: { __typename?: 'ContactSegment', id: string, name: string }, metrics: { __typename?: 'AnalyticsV2BaseCreativeMetrics', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clickToImpressionRate?: number | null, clicks: number, clickthroughRate?: number | null, conversionRate?: number | null, uniqueConversionRate?: number | null, conversionToClickRate?: number | null, conversions: number, decayedClicks: number, impressionRate?: number | null, impressions: number, orderRevenueVariance?: number | null, placementRevenueVariance?: number | null, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressions: number, uniqueClicks: number, uniqueConversions: number, uniqueImpressions: number } }> }> };

export type ReportingSegmentCreativesMetricsQueryVariables = Exact<{
  filter: SegmentGroupCreativeMetricsFilter;
}>;


export type ReportingSegmentCreativesMetricsQuery = { __typename?: 'Query', segmentGroupCreativeMetrics: Array<{ __typename?: 'SegmentGroupCreativeMetrics', creative: { __typename?: 'Creative', id: string, title: string }, segments?: Array<{ __typename?: 'CreativeSegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type AnalyticsV2SegmentExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput> | AnalyticsFilterInput;
  segmentGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AnalyticsV2SegmentExportMutation = { __typename?: 'Mutation', analyticsV2SegmentExport: { __typename?: 'AnalyticsExportReponse', signedUrl: string } };

export type AnalyticsV2SegmentCampaignExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput> | AnalyticsFilterInput;
  segmentGroupId: Scalars['ID']['input'];
}>;


export type AnalyticsV2SegmentCampaignExportMutation = { __typename?: 'Mutation', analyticsV2CampaignSegmentExport: { __typename?: 'AnalyticsExportReponse', signedUrl: string } };

export type AnalyticsV2SegmentCreativeExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dateRange: Scalars['DateRange']['input'];
  filters: Array<AnalyticsFilterInput> | AnalyticsFilterInput;
  segmentGroupId: Scalars['ID']['input'];
}>;


export type AnalyticsV2SegmentCreativeExportMutation = { __typename?: 'Mutation', analyticsV2CreativeSegmentExport: { __typename?: 'AnalyticsExportReponse', signedUrl: string } };

export type SegmentGroupsMetricsQueryVariables = Exact<{
  filter: SegmentGroupMetricsFilter;
}>;


export type SegmentGroupsMetricsQuery = { __typename?: 'Query', segmentGroupsMetrics: Array<{ __typename?: 'SegmentGroupMetrics', audience: { __typename?: 'ContactAudience', id: string, name: string, description: string, updatedAt: string, createdAt: string }, segments?: Array<{ __typename?: 'SegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type SegmentGroupsMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SegmentGroupMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SegmentGroupsMetricsExportMutation = { __typename?: 'Mutation', segmentGroupsMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type SegmentGroupCampaignMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SegmentGroupCampaignMetricsFilter;
  groupBy?: InputMaybe<CampaignGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SegmentGroupCampaignMetricsExportMutation = { __typename?: 'Mutation', segmentGroupCampaignMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type SegmentGroupCreativeMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SegmentGroupCreativeMetricsFilter;
  groupBy?: InputMaybe<CreativeGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SegmentGroupCreativeMetricsExportMutation = { __typename?: 'Mutation', segmentGroupCreativeMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ReportingGroupedSegmentGroupCampaignMetricsQueryVariables = Exact<{
  filter: SegmentGroupCampaignMetricsFilter;
  groupBy: CampaignGroupBy;
}>;


export type ReportingGroupedSegmentGroupCampaignMetricsQuery = { __typename?: 'Query', groupedSegmentGroupCampaignMetrics: Array<{ __typename?: 'GroupedSegmentGroupCampaignMetrics', group: string, segments?: Array<{ __typename?: 'CampaignSegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type ReportingGroupedSegmentGroupCreativeMetricsQueryVariables = Exact<{
  filter: SegmentGroupCreativeMetricsFilter;
  groupBy: CreativeGroupBy;
}>;


export type ReportingGroupedSegmentGroupCreativeMetricsQuery = { __typename?: 'Query', groupedSegmentGroupCreativeMetrics: Array<{ __typename?: 'GroupedSegmentGroupCreativeMetrics', group: string, segments?: Array<{ __typename?: 'CreativeSegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } | null> };

export type ReportingSegmentExperimentsMetricsQueryVariables = Exact<{
  filter: SegmentExperimentMetricsFilter;
}>;


export type ReportingSegmentExperimentsMetricsQuery = { __typename?: 'Query', segmentExperimentMetrics: Array<{ __typename?: 'SegmentExperimentMetrics', experiment: { __typename?: 'Experiment', id: string, title: string, status: ExperimentStatus, resultsRestrictedToStaff: boolean, minDate?: string | null, maxDate?: string | null }, treatments?: Array<{ __typename?: 'SegmentTreatmentMetrics', treatment: { __typename?: 'ExperimentTreatment', id: string, title: string }, splits?: Array<{ __typename?: 'SegmentMetrics', split?: { __typename?: 'ContactAudienceSplit', id: string, name: string } | null, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null }> | null } | null> };

export type SegmentExperimentMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SegmentExperimentMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SegmentExperimentMetricsExportMutation = { __typename?: 'Mutation', segmentExperimentMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type ContactSegmentGroupCountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactSegmentGroupCountsQuery = { __typename?: 'Query', contactSegmentGroupCounts: { __typename?: 'ContactSegmentGroupCounts', total: number, segmentCounts: Array<{ __typename?: 'ContactSegmentCount', id: string, total: number }> } };

export type ContactSegmentGroupAutoSegmentCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ContactSegmentGroupAutoSegmentCreateMutation = { __typename?: 'Mutation', contactSegmentGroupAutoSegmentCreate: { __typename?: 'ContactSegmentGroupAutoSegmentCreate', contactSegmentGroup: { __typename?: 'ContactSegmentGroup', id: string, name: string, segments: Array<{ __typename?: 'ContactSegment', id: string, segmentGroupId: string, name: string, query: any }> } } };

export type DataCategoryFieldsQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type DataCategoryFieldsQuery = { __typename?: 'Query', dataFields: Array<{ __typename?: 'DataField', id: string, name: string, displayName: string, type: DataFieldType, primaryKey: boolean }> };

export type ContactSegmentUpdate2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  query: Scalars['ContactQuery']['input'];
}>;


export type ContactSegmentUpdate2Mutation = { __typename?: 'Mutation', contactSegmentUpdate: { __typename?: 'ContactSegmentUpdate', contactSegment: { __typename?: 'ContactSegment', id: string, segmentGroupId: string, query: any } } };

export type ContactSegmentGroupAndCountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactSegmentGroupAndCountsQuery = { __typename?: 'Query', contactSegmentGroup: { __typename?: 'ContactSegmentGroup', id: string, name: string, description: string, status: ContactSegmentGroupStatus, segments: Array<{ __typename?: 'ContactSegment', id: string, segmentGroupId: string, name: string, query: any }> }, contactSegmentGroupCounts: { __typename?: 'ContactSegmentGroupCounts', total: number, segmentCounts: Array<{ __typename?: 'ContactSegmentCount', id: string, total: number }> } };

export type ContactSegmentGroupUpdate2MutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContactSegmentGroupStatus>;
}>;


export type ContactSegmentGroupUpdate2Mutation = { __typename?: 'Mutation', contactSegmentGroupUpdate: { __typename?: 'ContactSegmentGroupUpdate', contactSegmentGroup: { __typename?: 'ContactSegmentGroup', id: string, description: string, name: string, status: ContactSegmentGroupStatus } } };

export type ContactSegmentGroupPriorityUpdate2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  segmentPriorities: Array<ContactSegmentGroupPriorityInput> | ContactSegmentGroupPriorityInput;
}>;


export type ContactSegmentGroupPriorityUpdate2Mutation = { __typename?: 'Mutation', contactSegmentGroupPriorityUpdate: { __typename?: 'ContactSegmentGroupPriorityUpdate', contactSegmentGroup: { __typename?: 'ContactSegmentGroup', id: string, archived: boolean, createdAt: string, updatedAt: string, description: string, name: string, segments: Array<{ __typename?: 'ContactSegment', id: string, priority: number }> } } };

export type ContactSegmentDelete2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactSegmentDelete2Mutation = { __typename?: 'Mutation', contactSegmentDelete: { __typename?: 'ContactSegmentDelete', id: string, success: boolean } };

export type ContactSegmentCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  query: Scalars['ContactQuery']['input'];
  segmentGroupId: Scalars['ID']['input'];
}>;


export type ContactSegmentCreateMutation = { __typename?: 'Mutation', contactSegmentCreate: { __typename?: 'ContactSegmentCreate', contactSegment: { __typename?: 'ContactSegment', id: string, segmentGroupId: string, createdAt: string, updatedAt: string, name: string, priority: number, query: any } } };

export type SubjectLinesMetricsQueryVariables = Exact<{
  filter: SubjectLineMetricsFilter;
}>;


export type SubjectLinesMetricsQuery = { __typename?: 'Query', subjectlinesMetrics: { __typename?: 'SubjectLineMetrics', subjectlines?: Array<{ __typename?: 'SubjectLineMetric', subjectline: { __typename?: 'SubjectLine', id: string, content: string, source?: SourceType | null, tone?: string | null, creative: { __typename?: 'Creative', id: string, title: string } }, metrics: Array<{ __typename?: 'CategoryMetric', id: string, category?: string | null } | { __typename?: 'CountMetric', id: string, count?: number | null } | { __typename?: 'CurrencyMetric', currency?: number | null, id: string } | { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string } | { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string } | { __typename?: 'RateMetric', rate?: number | null, id: string } | { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string } | null> }> | null } };

export type SubjectlinesMetricsExportMutationVariables = Exact<{
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filter: SubjectLineMetricsFilter;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SubjectlinesMetricsExportMutation = { __typename?: 'Mutation', subjectlinesMetricsExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type CampaignSavedViewFragmentFragment = { __typename?: 'CampaignSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CampaignGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> };

export type CreativeSavedViewFragmentFragment = { __typename?: 'CreativeSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CreativeGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> };

export type CampaignSavedViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignSavedViewsQuery = { __typename?: 'Query', campaignSavedViewsV2: Array<{ __typename?: 'CampaignSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CampaignGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> };

export type CampaignSavedViewCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filters: Array<SavedViewFilterInput> | SavedViewFilterInput;
  isDefault: Scalars['Boolean']['input'];
  groupBy?: InputMaybe<CampaignGroupBy>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
}>;


export type CampaignSavedViewCreateMutation = { __typename?: 'Mutation', campaignSavedViewCreate: { __typename?: 'CampaignSavedViewCreateResponse', createdSavedView: { __typename?: 'CampaignSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CampaignGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }, campaignSavedViews: Array<{ __typename?: 'CampaignSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CampaignGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> } };

export type CampaignSavedViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignSavedViewDeleteMutation = { __typename?: 'Mutation', campaignSavedViewDelete: { __typename?: 'CampaignSavedViewUpdateOrDeleteResponse', campaignSavedViews: Array<{ __typename?: 'CampaignSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CampaignGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> } };

export type CampaignSavedViewUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  isDefault: Scalars['Boolean']['input'];
  groupBy?: InputMaybe<CampaignGroupBy>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  filters?: InputMaybe<Array<SavedViewFilterInput> | SavedViewFilterInput>;
}>;


export type CampaignSavedViewUpdateMutation = { __typename?: 'Mutation', campaignSavedViewUpdate: { __typename?: 'CampaignSavedViewUpdateOrDeleteResponse', campaignSavedViews: Array<{ __typename?: 'CampaignSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CampaignGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> } };

export type CreativeSavedViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreativeSavedViewsQuery = { __typename?: 'Query', creativeSavedViewsV2: Array<{ __typename?: 'CreativeSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CreativeGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> };

export type CreativeSavedViewCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filters: Array<SavedViewFilterInput> | SavedViewFilterInput;
  groupBy?: InputMaybe<CreativeGroupBy>;
  isDefault: Scalars['Boolean']['input'];
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
}>;


export type CreativeSavedViewCreateMutation = { __typename?: 'Mutation', creativeSavedViewCreate: { __typename?: 'CreativeSavedViewCreateResponse', createdSavedView: { __typename?: 'CreativeSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CreativeGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }, creativeSavedViews: Array<{ __typename?: 'CreativeSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CreativeGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> } };

export type CreativeSavedViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreativeSavedViewDeleteMutation = { __typename?: 'Mutation', creativeSavedViewDelete: { __typename?: 'CreativeSavedViewUpdateOrDeleteResponse', creativeSavedViews: Array<{ __typename?: 'CreativeSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CreativeGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> } };

export type CreativeSavedViewUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  isDefault: Scalars['Boolean']['input'];
  groupBy?: InputMaybe<CreativeGroupBy>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  filters?: InputMaybe<Array<SavedViewFilterInput> | SavedViewFilterInput>;
}>;


export type CreativeSavedViewUpdateMutation = { __typename?: 'Mutation', creativeSavedViewUpdate: { __typename?: 'CreativeSavedViewUpdateOrDeleteResponse', creativeSavedViews: Array<{ __typename?: 'CreativeSavedViewType', id: string, title: string, createdAt: string, updatedAt: string, isDefault: boolean, columns: Array<string>, predefinedDateRange?: PredefinedDateRange | null, customDateRange?: { lower: string, upper: string } | null, groupBy?: CreativeGroupBy | null, filters: Array<{ __typename?: 'SavedViewFilter', field: string, operator: FilterOperator, values: Array<string> }> }> } };

export type AnalyticsFiscalCalendarRangesQueryVariables = Exact<{
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
}>;


export type AnalyticsFiscalCalendarRangesQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, analyticsCalendar?: AnalyticsCalendar | null, fiscalCalendar?: { __typename?: 'Calendar', weekRange: Array<{ __typename?: 'Week', id: string, year: number, week: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null>, monthRange: Array<{ __typename?: 'Month', id: string, year: number, month: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null>, quarterRange: Array<{ __typename?: 'Quarter', id: string, year: number, quarter: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null>, yearRange: Array<{ __typename?: 'Year', id: string, year: number, span: { __typename?: 'DateSpan', start: string, end: string } } | null> } | null } };

export type CampaignViewTagsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CampaignViewTagsQuery = { __typename?: 'Query', campaignView?: { __typename?: 'CampaignView', tags: Array<{ __typename?: 'Tag', id: string, name: string }>, creativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type ProgramsNamesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProgramsNamesQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', edges: Array<{ __typename?: 'ProgramEdge', cursor: string, node: { __typename?: 'Program', id: string, title: string } } | null> } };

export type AccountMembersQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountMembersQuery = { __typename?: 'Query', account: { __typename?: 'Account2', id: string, members: Array<{ __typename?: 'AccountMember', status: AccountMemberStatus, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } }> } };

export type AnalyticsRateStatisticsFieldsFragment = { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean };

export type AnalyticsComparativeStatisticsFieldsFragment = { __typename?: 'AnalyticsComparativeStatistics', statAutoOpenRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statAverageOrderValue: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statClickRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statClickthroughRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statConversionRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statUniqueConversionRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statOpenRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statRevenuePerSend: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statRevenuePerThousandSends: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statUniqueAutoOpenRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statUniqueClickRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statUniqueClickthroughRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statUniqueOpenRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean }, statUnsubscribeRate: { __typename?: 'AnalyticsRateStatistics', lift?: number | null, confidenceLevel?: number | null, ciLower?: number | null, ciUpper?: number | null, isStatisticallySignificant: boolean } };

export type AnalyticsActivityFieldsFragment = { __typename?: 'AnalyticsActivity', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, openRate?: number | null, opens: number, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, uniqueConversionRate?: number | null, unknownBounceRate?: number | null, unknownBounces: number, unsubscribes: number, unsubscribeRate?: number | null };

export type AnalyticsV2BaseTreatmentMetricsFieldsFragment = { __typename?: 'AnalyticsV2BaseTreatmentMetrics', autoOpenRate?: number | null, autoOpenRateCiLower?: number | null, autoOpenRateCiUpper?: number | null, autoOpenRateConfidence?: number | null, autoOpenRateLift?: number | null, autoOpenRateSignificant?: boolean | null, autoOpens: number, averageOrderValue?: number | null, averageOrderValueCiLower?: number | null, averageOrderValueCiUpper?: number | null, averageOrderValueConfidence?: number | null, averageOrderValueLift?: number | null, averageOrderValueSignificant?: boolean | null, clickRate?: number | null, clickRateCiLower?: number | null, clickRateCiUpper?: number | null, clickRateConfidence?: number | null, clickRateLift?: number | null, clickRateSignificant?: boolean | null, clickToOpenRate?: number | null, clickToOpenRateCiLower?: number | null, clickToOpenRateCiUpper?: number | null, clickToOpenRateConfidence?: number | null, clickToOpenRateLift?: number | null, clickToOpenRateSignificant?: boolean | null, clicks: number, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversionRateCiLower?: number | null, conversionRateCiUpper?: number | null, conversionRateConfidence?: number | null, conversionRateLift?: number | null, conversionRateSignificant?: boolean | null, conversionToClickRate?: number | null, conversionToClickRateCiLower?: number | null, conversionToClickRateCiUpper?: number | null, conversionToClickRateConfidence?: number | null, conversionToClickRateLift?: number | null, conversionToClickRateSignificant?: boolean | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, messageRevenueVariance?: number | null, openRate?: number | null, openRateCiLower?: number | null, openRateCiUpper?: number | null, openRateConfidence?: number | null, openRateLift?: number | null, openRateSignificant?: boolean | null, opens: number, orderRevenueVariance?: number | null, revenue: number, revenuePerSend?: number | null, revenuePerSendCiLower?: number | null, revenuePerSendCiUpper?: number | null, revenuePerSendConfidence?: number | null, revenuePerSendLift?: number | null, revenuePerSendSignificant?: boolean | null, revenuePerThousandSends?: number | null, revenuePerThousandSendsCiLower?: number | null, revenuePerThousandSendsCiUpper?: number | null, revenuePerThousandSendsConfidence?: number | null, revenuePerThousandSendsLift?: number | null, revenuePerThousandSendsSignificant?: boolean | null, sendRatio: number, sends: number, uniqueConversionRate?: number | null, uniqueConversionRateLift?: number | null, uniqueConversionRateCiLower?: number | null, uniqueConversionRateCiUpper?: number | null, uniqueConversionRateConfidence?: number | null, uniqueConversionRateSignificant?: boolean | null, softBounceRate?: number | null, softBounces: number, uniqueAutoOpens: number, uniqueClicks: number, uniqueConversions: number, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribeRateCiLower?: number | null, unsubscribeRateCiUpper?: number | null, unsubscribeRateConfidence?: number | null, unsubscribeRateLift?: number | null, unsubscribeRateSignificant?: boolean | null };

export type AnalyticsV2BaseMetricsFieldsFragment = { __typename?: 'AnalyticsV2BaseMetrics', autoOpenRate?: number | null, autoOpens: number, averageOrderValue?: number | null, clickRate?: number | null, clickToOpenRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversionToClickRate?: number | null, conversions: number, hardBounceRate?: number | null, hardBounces: number, messageRevenueVariance?: number | null, openRate?: number | null, opens: number, orderRevenueVariance?: number | null, revenue: number, revenuePerSend?: number | null, revenuePerThousandSends?: number | null, sends: number, softBounceRate?: number | null, softBounces: number, uniqueAutoOpenRate?: number | null, uniqueAutoOpens: number, uniqueClickRate?: number | null, uniqueClickToOpenRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionRate?: number | null, uniqueConversions: number, uniqueOpenRate?: number | null, uniqueOpens: number, unknownBounceRate?: number | null, unknownBounces: number, unsubscribeRate?: number | null, unsubscribes: number };

export type AnalyticsV2BaseCreativeMetricsFieldsFragment = { __typename?: 'AnalyticsV2BaseCreativeMetrics', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clickToImpressionRate?: number | null, clicks: number, clickthroughRate?: number | null, conversionRate?: number | null, uniqueConversionRate?: number | null, conversionToClickRate?: number | null, conversions: number, decayedClicks: number, impressionRate?: number | null, impressions: number, orderRevenueVariance?: number | null, placementRevenueVariance?: number | null, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressions: number, uniqueClicks: number, uniqueConversions: number, uniqueImpressions: number };

export type AnalyticsBaseCreativeActivityFieldsFragment = { __typename?: 'AnalyticsBaseCreativeActivity', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, complaintRate?: number | null, complaints: number, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, revenuePerThousandPlacements?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversionToClickRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number, unsubscribeRate?: number | null, unsubscribes: number };

export type BaseCreativeMetricsFieldsFragment = { __typename?: 'BaseCreativeMetrics', autoImpressionRate?: number | null, autoImpressions: number, averageOrderValue?: number | null, clickRate?: number | null, clicks: number, clickthroughRate?: number | null, conversionRate?: number | null, conversions: number, impressionRate?: number | null, impressions: number, placements: number, revenue: number, revenuePerPlacement?: number | null, uniqueAutoImpressionRate?: number | null, uniqueAutoImpressions: number, uniqueClickRate?: number | null, uniqueClicks: number, uniqueClickthroughRate?: number | null, uniqueConversions: number, uniqueImpressionRate?: number | null, uniqueImpressions: number };

export type CategoryMetricFieldsFragment = { __typename?: 'CategoryMetric', id: string, name: string, group?: MetricGroup | null, category?: string | null };

export type CountMetricFieldsFragment = { __typename?: 'CountMetric', id: string, name: string, group?: MetricGroup | null, count?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null };

export type CurrencyMetricFieldsFragment = { __typename?: 'CurrencyMetric', id: string, name: string, group?: MetricGroup | null, currency?: number | null, stats?: { __typename?: 'CountStatMetric', diff?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null };

export type CurrencyRateMetricFieldsFragment = { __typename?: 'CurrencyRateMetric', id: string, name: string, group?: MetricGroup | null, currencyRate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null };

export type RateMetricFieldsFragment = { __typename?: 'RateMetric', id: string, name: string, group?: MetricGroup | null, rate?: number | null, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null };

type MetricWithStatsFields_CategoryMetric_Fragment = { __typename?: 'CategoryMetric', category?: string | null, id: string };

type MetricWithStatsFields_CountMetric_Fragment = { __typename?: 'CountMetric', count?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null };

type MetricWithStatsFields_CurrencyMetric_Fragment = { __typename?: 'CurrencyMetric', currency?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null };

type MetricWithStatsFields_CurrencyRateMetric_Fragment = { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null };

type MetricWithStatsFields_FractionalCountMetric_Fragment = { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string, stats?: { __typename?: 'CountStatMetric', diff?: number | null, ciLower?: number | null, ciUpper?: number | null, confidence?: number | null, significant: boolean } | null };

type MetricWithStatsFields_RateMetric_Fragment = { __typename?: 'RateMetric', rate?: number | null, id: string, stats?: { __typename?: 'StatMetric', lift?: number | null, confidence?: number | null, ciLower?: number | null, ciUpper?: number | null, significant: boolean } | null };

type MetricWithStatsFields_ScoreMetric_Fragment = { __typename?: 'ScoreMetric', id: string };

export type MetricWithStatsFieldsFragment = MetricWithStatsFields_CategoryMetric_Fragment | MetricWithStatsFields_CountMetric_Fragment | MetricWithStatsFields_CurrencyMetric_Fragment | MetricWithStatsFields_CurrencyRateMetric_Fragment | MetricWithStatsFields_FractionalCountMetric_Fragment | MetricWithStatsFields_RateMetric_Fragment | MetricWithStatsFields_ScoreMetric_Fragment;

type MetricFields_CategoryMetric_Fragment = { __typename?: 'CategoryMetric', id: string, category?: string | null };

type MetricFields_CountMetric_Fragment = { __typename?: 'CountMetric', id: string, count?: number | null };

type MetricFields_CurrencyMetric_Fragment = { __typename?: 'CurrencyMetric', currency?: number | null, id: string };

type MetricFields_CurrencyRateMetric_Fragment = { __typename?: 'CurrencyRateMetric', currencyRate?: number | null, id: string };

type MetricFields_FractionalCountMetric_Fragment = { __typename?: 'FractionalCountMetric', fractionalCount?: number | null, id: string };

type MetricFields_RateMetric_Fragment = { __typename?: 'RateMetric', rate?: number | null, id: string };

type MetricFields_ScoreMetric_Fragment = { __typename?: 'ScoreMetric', score?: number | null, label?: string | null, id: string };

export type MetricFieldsFragment = MetricFields_CategoryMetric_Fragment | MetricFields_CountMetric_Fragment | MetricFields_CurrencyMetric_Fragment | MetricFields_CurrencyRateMetric_Fragment | MetricFields_FractionalCountMetric_Fragment | MetricFields_RateMetric_Fragment | MetricFields_ScoreMetric_Fragment;

export type ComparativeRateStatisticsFieldsFragment = { __typename?: 'RateStatistics', ciLower?: number | null, ciUpper?: number | null, confidenceLevel?: number | null, isStatisticallySignificant: boolean, lift?: number | null };

export type AnalyticsExperimentsQueryVariables = Exact<{
  campaignIdsOrTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  campaignStages?: InputMaybe<Array<CampaignStageType> | CampaignStageType>;
  channels?: InputMaybe<Array<Channel> | Channel>;
  excludeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeCampaignTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AnalyticsExperimentsQuery = { __typename?: 'Query', analyticsV2Experiments?: Array<{ __typename?: 'Experiment', id: string, title: string, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string }> }> | null };

export type AnalyticsComparisonViewSegmentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsComparisonViewSegmentOptionsQuery = { __typename?: 'Query', contactAudiences: { __typename?: 'ContactAudienceList', audiences: Array<{ __typename?: 'ContactAudience', id: string, name: string, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, name: string }> }> } };

export type MetricTypesQueryVariables = Exact<{
  metricClass: MetricClass;
  metricView?: InputMaybe<MetricView>;
  channel?: InputMaybe<Channel>;
}>;


export type MetricTypesQuery = { __typename?: 'Query', metricTypes?: Array<{ __typename?: 'MetricType', id: string, name: string, category: MetricCategory, customEventCategory?: string | null, group?: MetricGroup | null, positivelyCorrelated: boolean, displayByDefault: boolean, supportsSeries: boolean } | null> | null };

export type RecurringExportRemindersQueryVariables = Exact<{
  viewType: ViewType;
}>;


export type RecurringExportRemindersQuery = { __typename?: 'Query', recurringExportReminders: Array<{ __typename?: 'RecurringExportReminderType', id: string, title: string, attachCsv?: boolean | null, columns: Array<string>, createdAt: string, customDateRange?: { lower: string, upper: string } | null, filterData: string, groupBy?: CampaignGroupBy | null, groupByFields?: Array<string | null> | null, includeMetadata: boolean, predefinedDateRange?: PredefinedDateRange | null, recipients: Array<string>, updatedAt: string, viewType: ViewType, schedule: { __typename?: 'ReminderSchedule', hour: number, minute: number, dayOfWeek?: number | null, dayOfMonth?: number | null } } | null> };

export type DeleteRecurringExportReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRecurringExportReminderMutation = { __typename?: 'Mutation', deleteRecurringExportReminder: { __typename?: 'RecurringExportReminderDeleteResponse', success: boolean } };

export type CreateRecurringExportReminderMutationVariables = Exact<{
  attachCsv?: InputMaybe<Scalars['Boolean']['input']>;
  columns: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filterData: Scalars['JSONString']['input'];
  groupBy?: InputMaybe<CampaignGroupBy>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  recipients: Array<Scalars['String']['input']> | Scalars['String']['input'];
  schedule: ReminderScheduleInput;
  title: Scalars['String']['input'];
  viewType: ViewType;
}>;


export type CreateRecurringExportReminderMutation = { __typename?: 'Mutation', createRecurringExportReminder: { __typename?: 'RecurringExportReminderResponse', reminder: { __typename?: 'RecurringExportReminderType', id: string } } };

export type UpdateRecurringExportReminderMutationVariables = Exact<{
  attachCsv?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  filterData?: InputMaybe<Scalars['JSONString']['input']>;
  groupBy?: InputMaybe<CampaignGroupBy>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  recipients?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  schedule?: InputMaybe<ReminderScheduleInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
}>;


export type UpdateRecurringExportReminderMutation = { __typename?: 'Mutation', updateRecurringExportReminder: { __typename?: 'RecurringExportReminderResponse', reminder: { __typename?: 'RecurringExportReminderType', id: string } } };

export type ExportMetricsMutationVariables = Exact<{
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filter: MetricsExportFilterInput;
  groupBy?: InputMaybe<Array<MetricsGroupBy> | MetricsGroupBy>;
  includeMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  recurringExportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExportMetricsMutation = { __typename?: 'Mutation', exportMetrics: { __typename?: 'ExportResponse', signedUrl: string } };

export type SavedFilterFragmentFragment = { __typename?: 'SavedFilterType', id: string, title: string, isDefault: boolean, viewType: ViewType, filterData: string, customDateRange?: { lower: string, upper: string } | null, predefinedDateRange?: PredefinedDateRange | null, createdAt: string, updatedAt: string, filterMetadata: Array<{ __typename?: 'SavedFilterMetadataEntry', field: string, id: string, title: string }> };

export type SavedFiltersQueryVariables = Exact<{
  viewType: ViewType;
}>;


export type SavedFiltersQuery = { __typename?: 'Query', savedFilters: Array<{ __typename?: 'SavedFilterType', id: string, title: string, isDefault: boolean, viewType: ViewType, filterData: string, customDateRange?: { lower: string, upper: string } | null, predefinedDateRange?: PredefinedDateRange | null, createdAt: string, updatedAt: string, filterMetadata: Array<{ __typename?: 'SavedFilterMetadataEntry', field: string, id: string, title: string }> }> };

export type CreateSavedFilterMutationVariables = Exact<{
  title: Scalars['String']['input'];
  viewType: ViewType;
  filterData: Scalars['JSONString']['input'];
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSavedFilterMutation = { __typename?: 'Mutation', createSavedFilter: { __typename?: 'SavedFilterResponse', savedFilter: { __typename?: 'SavedFilterType', id: string, title: string, isDefault: boolean, viewType: ViewType, filterData: string, customDateRange?: { lower: string, upper: string } | null, predefinedDateRange?: PredefinedDateRange | null, createdAt: string, updatedAt: string, filterMetadata: Array<{ __typename?: 'SavedFilterMetadataEntry', field: string, id: string, title: string }> } } };

export type UpdateSavedFilterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  filterData?: InputMaybe<Scalars['JSONString']['input']>;
  customDateRange?: InputMaybe<Scalars['DateRange']['input']>;
  predefinedDateRange?: InputMaybe<PredefinedDateRange>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSavedFilterMutation = { __typename?: 'Mutation', updateSavedFilter: { __typename?: 'SavedFilterResponse', savedFilter: { __typename?: 'SavedFilterType', id: string, title: string, isDefault: boolean, viewType: ViewType, filterData: string, customDateRange?: { lower: string, upper: string } | null, predefinedDateRange?: PredefinedDateRange | null, createdAt: string, updatedAt: string, filterMetadata: Array<{ __typename?: 'SavedFilterMetadataEntry', field: string, id: string, title: string }> } } };

export type DeleteSavedFilterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSavedFilterMutation = { __typename?: 'Mutation', deleteSavedFilter: { __typename?: 'SavedFilterDeleteResponse', success: boolean } };

export type ContactAudienceExperimentCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  query: Scalars['ContactQuery']['input'];
  description: Scalars['String']['input'];
  experimentInput?: InputMaybe<ContactAudienceExperimentAudienceInput>;
  splits?: InputMaybe<Array<InputMaybe<ContactAudienceSplitInput>> | InputMaybe<ContactAudienceSplitInput>>;
}>;


export type ContactAudienceExperimentCreateMutation = { __typename?: 'Mutation', contactAudienceCreate: { __typename?: 'ContactAudienceCreate', success: boolean, contactAudience: { __typename?: 'ContactAudience', id: string, name: string } } };

export type ContactAudienceExperimentUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['ContactQuery']['input'];
  experimentUpdateInput?: InputMaybe<ContactAudienceExperimentAudienceUpdateInput>;
  splits?: InputMaybe<Array<InputMaybe<ContactAudienceSplitUpdateInput>> | InputMaybe<ContactAudienceSplitUpdateInput>>;
}>;


export type ContactAudienceExperimentUpdateMutation = { __typename?: 'Mutation', contactAudienceUpdate: { __typename?: 'ContactAudienceUpdate', success: boolean, contactAudience: { __typename?: 'ContactAudience', id: string, name: string } } };

export type GetActiveChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveChannelsQuery = { __typename?: 'Query', channels: Array<{ __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }> };

export type ContactAudienceAutoBuildMutationVariables = Exact<{
  attributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ContactAudienceAutoBuildMutation = { __typename?: 'Mutation', contactAudienceAutoBuild: { __typename?: 'ContactAudienceAutoBuildSuccess', success: boolean, splits?: Array<{ __typename?: 'ContactAudienceSplit', name: string, query: any }> | null } };

export type ContactAudienceBuildQueryVariables = Exact<{
  query: Scalars['ContactQuery']['input'];
  splits?: InputMaybe<Array<Scalars['ContactQuery']['input']> | Scalars['ContactQuery']['input']>;
  channelV2?: InputMaybe<Channel>;
}>;


export type ContactAudienceBuildQuery = { __typename?: 'Query', contactAudienceBuild: { __typename?: 'ContactAudienceCount', id: string, total: number, splits?: Array<{ __typename?: 'ContactAudienceSplitCount', total: number }> | null } };

export type ContactAudienceBuildV2QueryVariables = Exact<{
  experimentConfig?: InputMaybe<ExperimentAudienceBuildInputConfig>;
  channelV2?: InputMaybe<Channel>;
}>;


export type ContactAudienceBuildV2Query = { __typename?: 'Query', contactAudienceBuildV2: { __typename?: 'ContactAudienceCount', id: string, total: number, splits?: Array<{ __typename?: 'ContactAudienceSplitCount', total: number }> | null } };

export type ContactAudienceBuildFieldsFragment = { __typename?: 'ContactAudience', id: string, name: string, description: string, query: any, isEditable?: boolean | null, type: ContactAudienceType, experimentSeed?: string | null, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any, fallback: boolean, ratio: number, control: boolean }>, overrides: Array<{ __typename?: 'ContactAudienceOverride', fieldId: string, id: string, splitId?: string | null, value: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } }> };

export type ContactAudienceCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['ContactQuery']['input'];
  splits?: InputMaybe<Array<InputMaybe<ContactAudienceSplitInput>> | InputMaybe<ContactAudienceSplitInput>>;
  overrides?: InputMaybe<Array<InputMaybe<ContactAudienceOverrideInput>> | InputMaybe<ContactAudienceOverrideInput>>;
}>;


export type ContactAudienceCreateMutation = { __typename?: 'Mutation', contactAudienceCreate: { __typename?: 'ContactAudienceCreate', success: boolean, contactAudience: { __typename?: 'ContactAudience', updatedAt: string, lastCount?: number | null, id: string, name: string, description: string, query: any, isEditable?: boolean | null, type: ContactAudienceType, experimentSeed?: string | null, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any, fallback: boolean, ratio: number, control: boolean }>, overrides: Array<{ __typename?: 'ContactAudienceOverride', fieldId: string, id: string, splitId?: string | null, value: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } }> } } };

export type ContactAudienceUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['ContactQuery']['input']>;
  splits?: InputMaybe<Array<InputMaybe<ContactAudienceSplitUpdateInput>> | InputMaybe<ContactAudienceSplitUpdateInput>>;
  overrides?: InputMaybe<Array<InputMaybe<ContactAudienceOverrideUpdateInput>> | InputMaybe<ContactAudienceOverrideUpdateInput>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  experimentUpdateInput?: InputMaybe<ContactAudienceExperimentAudienceUpdateInput>;
}>;


export type ContactAudienceUpdateMutation = { __typename?: 'Mutation', contactAudienceUpdate: { __typename?: 'ContactAudienceUpdate', success: boolean, contactAudience: { __typename?: 'ContactAudience', id: string, name: string, description: string, query: any, isEditable?: boolean | null, type: ContactAudienceType, experimentSeed?: string | null, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any, fallback: boolean, ratio: number, control: boolean }>, overrides: Array<{ __typename?: 'ContactAudienceOverride', fieldId: string, id: string, splitId?: string | null, value: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } }> } } };

export type ContactAudienceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactAudienceQuery = { __typename?: 'Query', contactAudience: { __typename?: 'ContactAudience', id: string, name: string, description: string, query: any, isEditable?: boolean | null, type: ContactAudienceType, experimentSeed?: string | null, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any, fallback: boolean, ratio: number, control: boolean }>, overrides: Array<{ __typename?: 'ContactAudienceOverride', fieldId: string, id: string, splitId?: string | null, value: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } }> } };

export type ContactAudienceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactAudienceDetailQuery = { __typename?: 'Query', contactAudience: { __typename?: 'ContactAudience', id: string, name: string, description: string, type: ContactAudienceType, createdAt: string, updatedAt: string, query: any, archived: boolean, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, name: string, query: any }> } };

export type AudienceCampaignsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CampaignSortType> | CampaignSortType>;
}>;


export type AudienceCampaignsQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginatedType', page: number, total: number, results: Array<{ __typename?: 'Campaign', id: string, legacyId: string, title: string, stage: CampaignStageType, sendDate: string, autoSchedule: boolean, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }> }> } };

export type TotalAudienceCampaignsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
}>;


export type TotalAudienceCampaignsQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginatedType', page: number, total: number } };

export type AudiencesIndexFiltersQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<ContactAudienceType> | ContactAudienceType>;
}>;


export type AudiencesIndexFiltersQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginatedType', results: Array<{ __typename?: 'Campaign', id: string, title: string }> }, contactAudienceFiltersCounts: { __typename?: 'ContactAudienceFiltersCounts', archived: number, inUse: number, notInUse: number, perType: Array<{ __typename?: 'ContactAudienceTypeCount', type: ContactAudienceType, count: number }> } };

export type ContactAudiencesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ContactAudiencesOrderBy>;
  types?: InputMaybe<Array<ContactAudienceType> | ContactAudienceType>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ContactAudiencesQuery = { __typename?: 'Query', contactAudiences: { __typename?: 'ContactAudienceList', total: number, audiences: Array<{ __typename?: 'ContactAudience', id: string, name: string, description: string, updatedAt: string, lastCount?: number | null, archived: boolean, type: ContactAudienceType, query: any, experimentSeed?: string | null, creativeIds: Array<string>, campaignIds: Array<string>, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, name: string, query: any, fallback: boolean, ratio: number, control: boolean }>, overrides: Array<{ __typename?: 'ContactAudienceOverride', fieldId: string, id: string, splitId?: string | null, value: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } }> }> } };

export type ContactAudienceArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactAudienceArchiveMutation = { __typename?: 'Mutation', contactAudienceArchive: { __typename?: 'ContactAudienceArchive', success: boolean, contactAudience: { __typename?: 'ContactAudience', id: string, archived: boolean } } };

export type CustomFontFragmentFragment = { __typename?: 'CustomFont', id: string, fontName: string, fallback: string, isDefault: boolean, fontWeights: Array<string>, fontStyles: Array<string>, fontSource: FontSource, linkHref: string, fontFaces: Array<{ __typename?: 'FontFace', id: string, src: string, fontWeight: string, fontStyle: string, format: string }> };

export type ColorFragmentFragment = { __typename?: 'Color', id: string, name: string, slug: string, hex: string };

export type LogoFragmentFragment = { __typename?: 'Logo', id: string, url: string };

export type TypographyFragmentFragment = { __typename?: 'Typography', id: string, name: string, slug: string, type: TypographyType, pseudoState?: ElementPseudoState | null, semanticElement?: string | null, styles: TypographyStyles, mobileStyles: TypographyStyles };

export type BrandKitFragmentFragment = { __typename?: 'BrandKit', id: string, name: string, description?: string | null, primaryLogoId?: string | null, logos: Array<{ __typename?: 'Logo', id: string, url: string }>, colors: Array<{ __typename?: 'Color', id: string, name: string, slug: string, hex: string }>, typographies: Array<{ __typename?: 'Typography', id: string, name: string, slug: string, type: TypographyType, pseudoState?: ElementPseudoState | null, semanticElement?: string | null, styles: TypographyStyles, mobileStyles: TypographyStyles }> };

export type CreateBrandKitMutationVariables = Exact<{
  input: BrandKitCreateInput;
}>;


export type CreateBrandKitMutation = { __typename?: 'Mutation', brandKitCreate: { __typename?: 'BrandKitSuccess', success: boolean, brandKit: { __typename?: 'BrandKit', id: string, name: string, description?: string | null, primaryLogoId?: string | null, logos: Array<{ __typename?: 'Logo', id: string, url: string }>, colors: Array<{ __typename?: 'Color', id: string, name: string, slug: string, hex: string }>, typographies: Array<{ __typename?: 'Typography', id: string, name: string, slug: string, type: TypographyType, pseudoState?: ElementPseudoState | null, semanticElement?: string | null, styles: TypographyStyles, mobileStyles: TypographyStyles }> } } };

export type UpdateBrandKitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: BrandKitCreateInput;
}>;


export type UpdateBrandKitMutation = { __typename?: 'Mutation', brandKitUpdate2: { __typename?: 'BrandKitSuccess', success: boolean, brandKit: { __typename?: 'BrandKit', id: string, name: string, description?: string | null, primaryLogoId?: string | null, logos: Array<{ __typename?: 'Logo', id: string, url: string }>, colors: Array<{ __typename?: 'Color', id: string, name: string, slug: string, hex: string }>, typographies: Array<{ __typename?: 'Typography', id: string, name: string, slug: string, type: TypographyType, pseudoState?: ElementPseudoState | null, semanticElement?: string | null, styles: TypographyStyles, mobileStyles: TypographyStyles }> } } };

export type CustomFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomFontsQuery = { __typename?: 'Query', customFonts?: Array<{ __typename?: 'CustomFont', id: string, fontName: string, fallback: string, isDefault: boolean, fontWeights: Array<string>, fontStyles: Array<string>, fontSource: FontSource, linkHref: string, fontFaces: Array<{ __typename?: 'FontFace', id: string, src: string, fontWeight: string, fontStyle: string, format: string }> }> | null };

export type BrandKitsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandKitsQuery = { __typename?: 'Query', brandKits?: Array<{ __typename?: 'BrandKit', id: string, name: string, description?: string | null, primaryLogoId?: string | null, logos: Array<{ __typename?: 'Logo', id: string, url: string }>, colors: Array<{ __typename?: 'Color', id: string, name: string, slug: string, hex: string }>, typographies: Array<{ __typename?: 'Typography', id: string, name: string, slug: string, type: TypographyType, pseudoState?: ElementPseudoState | null, semanticElement?: string | null, styles: TypographyStyles, mobileStyles: TypographyStyles }> }> | null };

export type LayoutComponentsPaginatedQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<LayoutComponentFilterInput>;
}>;


export type LayoutComponentsPaginatedQuery = { __typename?: 'Query', layoutComponentsPage: { __typename?: 'LayoutComponentPagination', page: number, total: number, results: Array<{ __typename?: 'LayoutComponent', id: string, name: string, description: string, thumbnail: string }> } };

export type LayoutComponentArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayoutComponentArchiveMutation = { __typename?: 'Mutation', layoutComponentArchive: { __typename?: 'LayoutComponentSuccess', success: boolean, layoutComponent: { __typename?: 'LayoutComponent', id: string } } };

export type LayoutComponentDuplicateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayoutComponentDuplicateMutation = { __typename?: 'Mutation', layoutComponentDuplicate: { __typename?: 'LayoutComponentSuccess', success: boolean, layoutComponent: { __typename?: 'LayoutComponent', id: string, name: string } } };

export type BlocksPaginatedQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BlockFilterInput>;
}>;


export type BlocksPaginatedQuery = { __typename?: 'Query', blocksPage: { __typename?: 'BlockPagination', page: number, total: number, results: Array<{ __typename?: 'Block', id: string, name: string, description: string, thumbnail: string }> } };

export type BlockArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BlockArchiveMutation = { __typename?: 'Mutation', blockArchive: { __typename?: 'BlockSuccess', success: boolean, block: { __typename?: 'Block', id: string } } };

export type BlockDuplicateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BlockDuplicateMutation = { __typename?: 'Mutation', blockDuplicate: { __typename?: 'BlockSuccess', success: boolean, block: { __typename?: 'Block', id: string, name: string } } };

export type BrandKitGenerationCreateMutationVariables = Exact<{
  input: BrandKitGenerationCreateInput;
}>;


export type BrandKitGenerationCreateMutation = { __typename?: 'Mutation', brandKitGenerationCreate: { __typename?: 'BrandKitGenerationSuccess', success: boolean, brandKitGeneration: { __typename?: 'BrandKitGeneration', id: string, threadId: string, status: BrandKitGenerationStatus, type: BrandKitGenerationType } } };

export type BrandKitGenerationUpdateStatusMutationVariables = Exact<{
  input: BrandKitGenerationUpdateStatusInput;
}>;


export type BrandKitGenerationUpdateStatusMutation = { __typename?: 'Mutation', brandKitGenerationUpdateStatus: { __typename?: 'BrandKitGenerationSuccess', success: boolean, brandKitGeneration: { __typename?: 'BrandKitGeneration', id: string, status: BrandKitGenerationStatus } } };

export type BrandKitGenerationsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandKitGenerationsQuery = { __typename?: 'Query', brandKitGenerations?: Array<{ __typename?: 'BrandKitGeneration', id: string, threadId: string, status: BrandKitGenerationStatus, type: BrandKitGenerationType, createdAt: string }> | null };

export type CampaignsWithOverlappingSendTimesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignsWithOverlappingSendTimesQuery = { __typename?: 'Query', campaignsWithOverlappingSendTimes?: Array<{ __typename?: 'Campaign', id: string, title: string }> | null };

export type CampaignAudienceOverlapCountQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  overlappingCampaignId: Scalars['ID']['input'];
}>;


export type CampaignAudienceOverlapCountQuery = { __typename?: 'Query', campaignAudienceOverlapCount?: number | null };

export type ContactAudienceConfigFragmentFragment = { __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null };

export type ExperienceExperimentFieldsFragment = { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string }> };

export type AudiencesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ContactAudiencesOrderBy>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AudiencesQuery = { __typename?: 'Query', contactAudiences: { __typename?: 'ContactAudienceList', total: number, audiences: Array<{ __typename?: 'ContactAudience', id: string, name: string, description: string, archived: boolean, lastCount?: number | null, type: ContactAudienceType, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string }> }> } };

export type ContactAudienceIncludeMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  contactAudienceId: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  unselectedSplits: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactAudienceIncludeMutation = { __typename?: 'Mutation', contactAudienceInclude: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null, excludedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null } } | { __typename?: 'NeedsConfirmation', success: boolean } };

export type ContactAudienceExcludeMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  contactAudienceId: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  unselectedSplits: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ContactAudienceExcludeMutation = { __typename?: 'Mutation', contactAudienceExclude: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null, excludedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null } } };

export type ContactAudienceConfigRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  contactAudienceConfigId: Scalars['ID']['input'];
}>;


export type ContactAudienceConfigRemoveMutation = { __typename?: 'Mutation', contactAudienceConfigRemove: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null, excludedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null } } | { __typename?: 'NeedsConfirmation', success: boolean } };

export type ContactAudienceReorderMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  contactAudienceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ContactAudienceReorderMutation = { __typename?: 'Mutation', contactAudienceReorder: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null, excludedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string, archived: boolean, type: ContactAudienceType } | null }> | null } } };

export type ContactSnapshotCountMutationVariables = Exact<{
  excludeAudiences: Array<ContactSnapshotAudienceInput> | ContactSnapshotAudienceInput;
  includeAudiences: Array<ContactSnapshotAudienceInput> | ContactSnapshotAudienceInput;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  channel: Channel;
}>;


export type ContactSnapshotCountMutation = { __typename?: 'Mutation', contactSnapshotCount: { __typename?: 'ContactSnapshotCountSuccess', count: { __typename?: 'ContactSnapshotCount', total: number, includeAudiences?: Array<{ __typename?: 'ContactSnapshotAudienceCount', id: string, total: number, audienceSplits?: Array<{ __typename?: 'SnapshotCount', id: string, total: number } | null> | null }> | null, excludeAudiences?: Array<{ __typename?: 'ContactSnapshotAudienceCount', id: string, total: number, audienceSplits?: Array<{ __typename?: 'SnapshotCount', id: string, total: number } | null> | null }> | null } } };

export type CampaignExperienceExperimentDeleteMutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignExperienceExperimentDeleteMutation = { __typename?: 'Mutation', campaignExperimentDelete: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, experienceExperiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string }> } | null } } };

export type CampaignAddExperienceExperimentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experimentGroupId: Scalars['ID']['input'];
}>;


export type CampaignAddExperienceExperimentGroupMutation = { __typename?: 'Mutation', campaignAddExperimentGroup: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, experienceExperiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string }> } | null } } };

export type CampaignSetFrequencyModelMutationVariables = Exact<{
  frequencyModel: FrequencyModel;
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignSetFrequencyModelMutation = { __typename?: 'Mutation', campaignSetFrequencyModel: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, frequencyModel: FrequencyModel } } };

export type CampaignAudiencesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceType: CampaignAudienceType;
  search?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CampaignAudiencesQuery = { __typename?: 'Query', campaignAudiences: Array<{ __typename?: 'Audience', id: string, title: string }> };

export type CampaignDetailFieldsFragment = { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type CampaignDetailsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignDetailsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type CampaignTimelineNewQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignTimelineNewQuery = { __typename?: 'Query', campaignTimelineNew: Array<{ __typename?: 'CampaignTimelineGroupType', title: string, timestamp: string, user?: { __typename?: 'User', id: string, email: string } | null, children?: Array<{ __typename?: 'CampaignTimelineChildType', title: string, timestamp: string, user?: { __typename?: 'User', id: string, email: string } | null }> | null }> };

export type CampaignDetailsUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  sendDate?: InputMaybe<Scalars['Date']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CampaignDetailsUpdateMutation = { __typename?: 'Mutation', campaignDetailsUpdate: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, title: string, sendDate: string, availableSendTimes: Array<string>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', treatment?: { __typename?: 'TreatmentSendDatetime', id: string, control: boolean } | null, schedule?: { __typename: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename: 'StaticSendSchedule', datetime: string } | null }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignCancelMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignCancelMutation = { __typename?: 'Mutation', campaignCancel: { __typename?: 'CampaignCancel', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignDeleteMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignDeleteMutation = { __typename?: 'Mutation', campaignDelete: { __typename?: 'Ok', ok: boolean } };

export type CampaignDuplicateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sendDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  withContactAudiences?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CampaignDuplicateMutation = { __typename?: 'Mutation', campaignDuplicate: { __typename?: 'CampaignDuplicate', newCampaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignProblemsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignProblemsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, problems: Array<{ __typename?: 'Problem', where: System, message: string, blocks?: Array<System | null> | null, severity: string } | null> } };

export type CampaignApproveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignApproveMutation = { __typename?: 'Mutation', campaignApprove: { __typename?: 'CampaignApprove', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignEnableAutoSchedulingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignEnableAutoSchedulingMutation = { __typename?: 'Mutation', campaignEnableAutoScheduling: { __typename?: 'CampaignEnableAutoScheduling', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignDisableAutoSchedulingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignDisableAutoSchedulingMutation = { __typename?: 'Mutation', campaignDisableAutoScheduling: { __typename?: 'CampaignDisableAutoScheduling', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignRevertToDraftMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignRevertToDraftMutation = { __typename?: 'Mutation', campaignRevertToDraft: { __typename?: 'CampaignRevertToDraft', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignCancelApprovalMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignCancelApprovalMutation = { __typename?: 'Mutation', campaignCancelApproval: { __typename?: 'CampaignCancelApproval', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignUnscheduleMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignUnscheduleMutation = { __typename?: 'Mutation', campaignUnschedule: { __typename?: 'CampaignUnschedule', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignSuspendMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignSuspendMutation = { __typename?: 'Mutation', campaignSuspend: { __typename?: 'CampaignSuspend', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignTerminateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignTerminateMutation = { __typename?: 'Mutation', campaignTerminate: { __typename?: 'CampaignTerminate', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignLockForProofingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignLockForProofingMutation = { __typename?: 'Mutation', campaignLockForProofing: { __typename?: 'CampaignLockForProofing', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignScheduleMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignScheduleMutation = { __typename?: 'Mutation', campaignSchedule: { __typename?: 'CampaignSchedule', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignResumeMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignResumeMutation = { __typename?: 'Mutation', campaignResume: { __typename?: 'CampaignResume', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignMarkAsPreparedMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignMarkAsPreparedMutation = { __typename?: 'Mutation', campaignMarkAsPrepared: { __typename?: 'CampaignMarkAsPrepared', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, sendDate: string, autoSchedule: boolean, autoCreativeInclusionPaused: boolean, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignAddToRecommendationRunMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  runType: RecommendationRunType;
}>;


export type CampaignAddToRecommendationRunMutation = { __typename?: 'Mutation', campaignAddToRecommendationRun: { __typename?: 'CampaignAddToRecommendationRun', success: boolean, recommendationRun: { __typename?: 'RecommendationRun', id: string, runId: number, status: RecommendationRunStatus, runType: RecommendationRunType, flowRunId?: any | null, flowRunUrl?: string | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType }> } } };

export type FetchRecommendationRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRecommendationRunsQuery = { __typename?: 'Query', recommendationRuns: Array<{ __typename?: 'RecommendationRun', id: string, runId: number, status: RecommendationRunStatus, runType: RecommendationRunType, flowRunId?: any | null, flowRunUrl?: string | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string }> }> };

export type CampaignCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  sendDate: Scalars['Date']['input'];
  withContactAudiences?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<Channel>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CampaignCreateMutation = { __typename?: 'Mutation', campaignCreate: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, legacyId: string, title: string, stage: CampaignStageType, sendDate: string, status: CampaignStatusType, error: boolean, autoSchedule: boolean, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel } } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  channel: Channel;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecurringCampaignCreateMutation = { __typename?: 'Mutation', recurringCampaignCreate: { __typename?: 'RecurringCampaignCreateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, title: string, status: RecurringCampaignStatus, nextOccurrence?: string | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignCreateMutationVariables = Exact<{
  channel: Channel;
  journeyId?: InputMaybe<Scalars['String']['input']>;
  journeyNodeId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  triggerRule?: InputMaybe<Scalars['JSONString']['input']>;
  triggerSource: TriggerSource;
}>;


export type TriggeredCampaignCreateMutation = { __typename?: 'Mutation', triggeredCampaignCreate: { __typename?: 'TriggeredCampaignCreateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, title: string, status: TriggeredCampaignStatus, stage: TriggeredCampaignStage, triggerSource: TriggerSource, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignAutoCreativeInclusionEnableMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignAutoCreativeInclusionEnableMutation = { __typename?: 'Mutation', campaignAutoCreativeInclusionEnable: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, autoCreativeInclusionPaused: boolean } } };

export type CreativesWithContentChangesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CreativesWithContentChangesQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, creativesWithContentChanges: Array<{ __typename?: 'Creative', id: string, title: string }> } };

export type CampaignPickupChangesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignPickupChangesMutation = { __typename?: 'Mutation', campaignPickupChanges: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, creativesWithContentChanges: Array<{ __typename?: 'Creative', id: string, title: string }> } } };

type ContentFields_PushNotification_Fragment = { __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null };

type ContentFields_TextMessage_Fragment = { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null };

export type ContentFieldsFragment = ContentFields_PushNotification_Fragment | ContentFields_TextMessage_Fragment;

export type Experiences2FieldsFragment = { __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> };

export type ExperiencesCreativesFieldsFragment = { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type DynamicSectionsFieldsFragment = { __typename?: 'DynamicSection', id: string, title: string, experiences2Count?: number | null, experiences2Complete: boolean, isPrimary: boolean, position: number, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null }, experiences2UncoveredRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null } | null> | null, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, type: ContentBlockType } };

export type IncompleteDynamicSectionsFieldsFragment = { __typename?: 'DynamicSection', id: string, title: string, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null } };

export type CampaignDynamicBlocks2QueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type CampaignDynamicBlocks2Query = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', dynamicContentBlockCount: number, sections: Array<{ __typename?: 'DynamicSection', id: string, title: string, experiences2Count?: number | null, experiences2Complete: boolean, isPrimary: boolean, position: number, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null }, experiences2UncoveredRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null } | null> | null, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, type: ContentBlockType } } | { __typename?: 'StaticSection' }> } | null } };

export type CampaignIncompleteExperiencesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignIncompleteExperiencesQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', sections: Array<{ __typename?: 'DynamicSection', id: string, title: string, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null } } | { __typename?: 'StaticSection' }> } | null } };

export type ExperiencesAvailableCreativesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
}>;


export type ExperiencesAvailableCreativesQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Complete: boolean, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, experiences2: Array<{ __typename?: 'Experience2', id: string, autoInclude: Experience2AutoInclude, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } }> } | { __typename?: 'StaticSection' } } | null } };

export type ExperiencesFilterCountsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type ExperiencesFilterCountsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number } } | null } | { __typename?: 'StaticSection' } } | null } };

export type CampaignExperiences2CreateMutationVariables = Exact<{
  blockId: Scalars['ID']['input'];
  recsSettings: Experience2RecsSettings;
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
  visibility: Experience2Visibility;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type CampaignExperiences2CreateMutation = { __typename?: 'Mutation', campaignExperiences2Create: { __typename?: 'CampaignExperiences2CreateSuccess', success: boolean, experience: { __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, section: { __typename?: 'DynamicSection', id: string } | { __typename?: 'StaticSection', id: string }, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, title: string, experiences2Count?: number | null, experiences2Complete: boolean, isPrimary: boolean, position: number, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null }, experiences2UncoveredRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null } | null> | null, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, type: ContentBlockType } } | { __typename?: 'StaticSection' } } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2AttachCreativesMutationVariables = Exact<{
  creativeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  experienceId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignExperiences2AttachCreativesMutation = { __typename?: 'Mutation', campaignExperiences2AttachCreatives: { __typename?: 'CampaignExperiences2MutateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Complete: boolean, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, experiences2: Array<{ __typename?: 'Experience2', id: string, autoInclude: Experience2AutoInclude, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } }> } | { __typename?: 'StaticSection' } } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2AttachAllCreativesMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
}>;


export type CampaignExperiences2AttachAllCreativesMutation = { __typename?: 'Mutation', campaignExperiences2AttachAllCreatives: { __typename?: 'CampaignExperiences2MutateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Complete: boolean, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, experiences2: Array<{ __typename?: 'Experience2', id: string, autoInclude: Experience2AutoInclude, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } }> } | { __typename?: 'StaticSection' } } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2DetachAllCreativesMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
}>;


export type CampaignExperiences2DetachAllCreativesMutation = { __typename?: 'Mutation', campaignExperiences2DetachAllCreatives: { __typename?: 'CampaignExperiences2MutateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Complete: boolean, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, experiences2: Array<{ __typename?: 'Experience2', id: string, autoInclude: Experience2AutoInclude, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } }> } | { __typename?: 'StaticSection' } } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2DetachCreativesMutationVariables = Exact<{
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
  creativeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
}>;


export type CampaignExperiences2DetachCreativesMutation = { __typename?: 'Mutation', campaignExperiences2DetachCreatives: { __typename?: 'CampaignExperiences2MutateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Complete: boolean, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, experiences2: Array<{ __typename?: 'Experience2', id: string, autoInclude: Experience2AutoInclude, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } }> } | { __typename?: 'StaticSection' } } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2UpdateVisibilityMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
  visibility: Experience2Visibility;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type CampaignExperiences2UpdateVisibilityMutation = { __typename?: 'Mutation', campaignExperiences2UpdateVisibility: { __typename?: 'CampaignExperiences2MutateSuccess', success: boolean, experience: { __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, section: { __typename?: 'DynamicSection', id: string } | { __typename?: 'StaticSection', id: string }, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', sections: Array<{ __typename?: 'DynamicSection', id: string, title: string, experiences2Count?: number | null, experiences2Complete: boolean, isPrimary: boolean, position: number, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null }, experiences2UncoveredRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null } | null> | null, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, type: ContentBlockType } } | { __typename?: 'StaticSection' }> } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2BlockResetMutationVariables = Exact<{
  blockId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type CampaignExperiences2BlockResetMutation = { __typename?: 'Mutation', campaignExperiences2BlockReset: { __typename?: 'CampaignExperiences2BlockResetSuccess', success: boolean, section: { __typename?: 'DynamicSection', id: string, experiences2: Array<{ __typename?: 'Experience2', id: string }> } | { __typename?: 'StaticSection' }, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', sections: Array<{ __typename?: 'DynamicSection', id: string, title: string, experiences2Count?: number | null, experiences2Complete: boolean, isPrimary: boolean, position: number, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null }, experiences2UncoveredRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null } | null> | null, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, type: ContentBlockType } } | { __typename?: 'StaticSection' }> } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2DeleteMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type CampaignExperiences2DeleteMutation = { __typename?: 'Mutation', campaignExperiences2Delete: { __typename?: 'CampaignExperiences2DeleteSuccess', success: boolean, deletedExperienceId: string, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', sections: Array<{ __typename?: 'DynamicSection', id: string, title: string, experiences2Count?: number | null, experiences2Complete: boolean, isPrimary: boolean, position: number, experiences2IncompleteExperiences: Array<{ __typename?: 'Experience2', id: string, title: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, availability2: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }, thumbnail: { __typename?: 'Thumbnail', url: string } }> }, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, experiences2Axes: { __typename?: 'SectionAxes', audiences: Array<string>, experiment?: string | null }, experiences2UncoveredRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null } | null> | null, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, type: ContentBlockType } } | { __typename?: 'StaticSection' }> } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type AvailableCreativeTagsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AvailableCreativeTagsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, availableCreativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type ExperienceExperiment2QueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type ExperienceExperiment2Query = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, experienceExperiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, status: ExperimentStatus, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string }> } | null } };

export type CampaignExperiencesAutoIncludeCreativesMutationVariables = Exact<{
  creativeTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sectionId: Scalars['ID']['input'];
  targetRuleset: Array<TargetRuleInput> | TargetRuleInput;
  visibility: Experience2Visibility;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type CampaignExperiencesAutoIncludeCreativesMutation = { __typename?: 'Mutation', campaignExperience2AutoIncludeCreatives: { __typename?: 'CampaignExperience2AutoIncludeCreatives', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', section: { __typename?: 'DynamicSection', id: string, experiences2Complete: boolean, experiences2Creatives?: { __typename?: 'Experiences2CreativeConnection', counts: { __typename?: 'Experiences2CreativeCount', allEligibleIncluded: boolean, available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, prohibited: number, total: number }, edges: Array<{ __typename?: 'Experiences2CreativeEdge', node?: { __typename?: 'Experiences2CreativeInfo', id: string, availability: Array<CreativeAvailability>, inclusion: CreativeInclusion, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', id: string, uri: string, externalUrl: string } | { __typename?: 'ManagedMedia', internalUrl: string, id: string, uri: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, experiences2: Array<{ __typename?: 'Experience2', id: string, autoInclude: Experience2AutoInclude, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } }> } | { __typename?: 'StaticSection' } } | null } } };

export type Experience2ContactCountMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
}>;


export type Experience2ContactCountMutation = { __typename?: 'Mutation', experience2ContactCount: { __typename?: 'Experience2ContactCountSuccess', count: { __typename?: 'ContactSnapshotCount', total: number, includeAudiences?: Array<{ __typename?: 'ContactSnapshotAudienceCount', id: string, total: number }> | null, excludeAudiences?: Array<{ __typename?: 'ContactSnapshotAudienceCount', id: string, total: number }> | null } } };

export type CampaignExperiences2UpdateNameMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CampaignExperiences2UpdateNameMutation = { __typename?: 'Mutation', campaignExperiences2UpdateName: { __typename?: 'CampaignExperiences2SetNameSuccess', success: boolean, experience: { __typename?: 'Experience2', id: string, title: string } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignExperiences2UpdateRecsSettingsMutationVariables = Exact<{
  experienceId: Scalars['ID']['input'];
  recsSettings: Experience2RecsSettings;
}>;


export type CampaignExperiences2UpdateRecsSettingsMutation = { __typename?: 'Mutation', campaignExperiences2UpdateRecsSettings: { __typename?: 'CampaignExperiences2MutateSuccess', success: boolean, experience: { __typename?: 'Experience2', id: string, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean } } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CampaignAudienceAndTreatmentsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignAudienceAndTreatmentsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string, createdAt: string, updatedAt: string, name: string, query: any } | null }> | null, contactAudience?: { __typename?: 'ContactAudience', id: string } | null }> | null } };

export type PrefixQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type PrefixQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, prefix?: { __typename: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', title: string } } | null } | { __typename: 'NoContent' } | { __typename: 'StaticMessage', message?: string | null } | null } };

export type CampaignSubjectLinePrefixModeUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
}>;


export type CampaignSubjectLinePrefixModeUpdateMutation = { __typename?: 'Mutation', campaignSubjectLinePrefixModeUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, prefix?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticMessage' } | null } } };

export type CampaignStaticSubjectLinePrefixUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type CampaignStaticSubjectLinePrefixUpdateMutation = { __typename?: 'Mutation', campaignStaticSubjectLinePrefixUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, prefix?: { __typename?: 'DynamicContent' } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null } } };

export type CampaignDynamicSubjectLinePrefixUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
}>;


export type CampaignDynamicSubjectLinePrefixUpdateMutation = { __typename?: 'Mutation', campaignDynamicSubjectLinePrefixUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, prefix?: { __typename?: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', title: string } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage' } | null } } };

export type PreHeaderLinkDrawerQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type PreHeaderLinkDrawerQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, espConfig?: { __typename: 'AdobeJourneyOptimizerConfig' } | { __typename: 'AmazonSESConfig' } | { __typename: 'BlackholeConfig' } | { __typename: 'CampaignAcousticCampaignConfig' } | { __typename: 'CampaignAdobeCampaignConfig' } | { __typename: 'CampaignCordialConfig' } | { __typename: 'CampaignEpsilonConfig' } | { __typename: 'CampaignOracleResponsysConfig' } | { __typename: 'CampaignSalesforceMarketingCloudConfig' } | { __typename: 'ZetaConfig' } | null, emailServiceProvider?: { __typename: 'AcousticCampaign', acousticCampaignRequiredLinkMetadataFields: Array<AcousticCampaignRequiredLinkMetaDataFields> } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial', cordialRequiredLinkMetadataFields: Array<CordialRequiredLinkMetaDataFields> } | { __typename: 'Epsilon', epsilonRequiredLinkMetadataFields: Array<EpsilonRequiredLinkMetaDataFields> } | { __typename: 'OracleResponsys', oracleResponsysRequiredLinkMetadataFields: Array<OracleResponsysRequiredLinkMetaDataFields>, linkCategories: Array<{ __typename?: 'OracleResponsysLinkCategory', id: string, title: string }> } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud', salesforceRequiredLinkMetadataFields: Array<SalesForceRequiredLinkMetaDataFields>, defaultLinkMetadata?: { __typename?: 'SalesforceMarketingCloudDefaultLinkMetadata', enableDeepLinks: boolean, enableConversionTracking: boolean } | null } | { __typename: 'Zeta' } | null, preheaderAndPreview?: { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticPreheaderWithPreview', preview?: string | null, preheader?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | null } | { __typename?: 'OnlyPreheader', preheader?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticMessageWithLink', message?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | null } | { __typename?: 'OnlyPreview' } | null } };

export type CampaignPreheaderAndPreviewModeUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
}>;


export type CampaignPreheaderAndPreviewModeUpdateMutation = { __typename?: 'Mutation', campaignPreheaderAndPreviewModeUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, preheaderAndPreview?: { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticPreheaderWithPreview' } | null } | { __typename?: 'OnlyPreheader', preheader?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticMessageWithLink' } | null } | { __typename?: 'OnlyPreview', preview?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticMessage' } | null } | null } } };

export type CampaignDynamicPreheaderAndPreviewUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
}>;


export type CampaignDynamicPreheaderAndPreviewUpdateMutation = { __typename?: 'Mutation', campaignDynamicPreheaderAndPreviewUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, preheaderAndPreview?: { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename?: 'DynamicContent', incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticPreheaderWithPreview', preview?: string | null, preheader?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null } | null } | null } | { __typename?: 'OnlyPreheader', preheader?: { __typename?: 'DynamicContent', incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessageWithLink', message?: string | null, link?: { __typename?: 'Link', id: string, url: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null } | null } | null } | { __typename?: 'OnlyPreview', preview?: { __typename?: 'DynamicContent', incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null } | null } } };

export type CampaignStaticPreheaderAndPreviewUpdateMutationVariables = Exact<{
  config: StaticPreheaderAndPreview;
  id: Scalars['ID']['input'];
}>;


export type CampaignStaticPreheaderAndPreviewUpdateMutation = { __typename?: 'Mutation', campaignStaticPreheaderAndPreviewUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, preheaderAndPreview?: { __typename: 'BothPreviewPreheader' } | { __typename: 'OnlyPreheader' } | { __typename: 'OnlyPreview' } | null } } };

export type RemoveCampaignPreheaderLinkMutationVariables = Exact<{
  config: StaticPreheaderAndPreview;
  id: Scalars['ID']['input'];
}>;


export type RemoveCampaignPreheaderLinkMutation = { __typename?: 'Mutation', campaignStaticPreheaderAndPreviewUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, preheaderAndPreview?: { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename?: 'DynamicContent', incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticPreheaderWithPreview', preview?: string | null, preheader?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null } | null } | null } | { __typename?: 'OnlyPreheader', preheader?: { __typename?: 'DynamicContent', incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessageWithLink', message?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null } | null } | null } | { __typename?: 'OnlyPreview', preview?: { __typename?: 'DynamicContent', incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null } | null } } };

export type CampaignStaticPreheaderAndPreviewLinkUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  linkGroupId: Scalars['ID']['input'];
}>;


export type CampaignStaticPreheaderAndPreviewLinkUpdateMutation = { __typename?: 'Mutation', campaignStaticPreheaderAndPreviewLinkUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, preheaderAndPreview?: { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename?: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticPreheaderWithPreview', preview?: string | null, preheader?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null } | null } | null } | { __typename?: 'OnlyPreheader', preheader?: { __typename?: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessageWithLink', message?: string | null, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null } | null } | null } | { __typename?: 'OnlyPreview', preview?: { __typename?: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, title: string } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null } | null } } };

export type CampaignAddInboxExperimentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experimentGroupId: Scalars['ID']['input'];
}>;


export type CampaignAddInboxExperimentGroupMutation = { __typename?: 'Mutation', campaignAddExperimentGroup: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, title: string, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType }>, subjectline?: { __typename?: 'DynamicSubjectLine', strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine' } | { __typename?: 'StaticMessage' } | null } } };

export type CampaignInboxExperimentDeleteMutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignInboxExperimentDeleteMutation = { __typename?: 'Mutation', campaignExperimentDelete: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, title: string, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType }>, subjectline?: { __typename?: 'DynamicSubjectLine', strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine' } | { __typename?: 'StaticMessage' } | null } } };

export type SubjectLineStrategyUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  treatmentId: Scalars['ID']['input'];
  strategy: SubjectLineStrategy;
}>;


export type SubjectLineStrategyUpdateMutation = { __typename?: 'Mutation', campaignSubjectLineStrategyUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, title: string, subjectline?: { __typename?: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine' } | { __typename?: 'StaticMessage' } | null, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> }> } } };

export type SuffixQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type SuffixQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, suffix?: { __typename: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', title: string } } | null } | { __typename: 'NoContent' } | { __typename: 'StaticMessage', message?: string | null } | null } };

export type CampaignSubjectLineSuffixModeUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
}>;


export type CampaignSubjectLineSuffixModeUpdateMutation = { __typename?: 'Mutation', campaignSubjectLineSuffixModeUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, suffix?: { __typename: 'DynamicContent' } | { __typename: 'NoContent' } | { __typename: 'StaticMessage' } | null } } };

export type CampaignStaticSubjectLineSuffixUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type CampaignStaticSubjectLineSuffixUpdateMutation = { __typename?: 'Mutation', campaignStaticSubjectLineSuffixUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, suffix?: { __typename?: 'DynamicContent' } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null } } };

export type CampaignDynamicSubjectLineSuffixUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
}>;


export type CampaignDynamicSubjectLineSuffixUpdateMutation = { __typename?: 'Mutation', campaignDynamicSubjectLineSuffixUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, suffix?: { __typename?: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', title: string } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage' } | null } } };

type SubjectlineFields_DynamicSubjectLine_Fragment = { __typename: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } } }> };

type SubjectlineFields_PersadoSubjectLine_Fragment = { __typename: 'PersadoSubjectLine' };

type SubjectlineFields_StaticMessage_Fragment = { __typename: 'StaticMessage', message?: string | null };

export type SubjectlineFieldsFragment = SubjectlineFields_DynamicSubjectLine_Fragment | SubjectlineFields_PersadoSubjectLine_Fragment | SubjectlineFields_StaticMessage_Fragment;

export type SubjectLineQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type SubjectLineQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, subjectline?: { __typename: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename: 'PersadoSubjectLine' } | { __typename: 'StaticMessage', message?: string | null } | null } };

export type CampaignSubjectLineModeUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  mode: SubjectLineChunkMode;
}>;


export type CampaignSubjectLineModeUpdateMutation = { __typename?: 'Mutation', campaignSubjectLineModeUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, subjectline?: { __typename: 'DynamicSubjectLine' } | { __typename: 'PersadoSubjectLine' } | { __typename: 'StaticMessage' } | null } } };

export type CampaignStaticSubjectLineUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type CampaignStaticSubjectLineUpdateMutation = { __typename?: 'Mutation', campaignStaticSubjectLineUpdate: { __typename?: 'CampaignInboxUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, subjectline?: { __typename: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } } }> } | { __typename: 'PersadoSubjectLine' } | { __typename: 'StaticMessage', message?: string | null } | null } } };

export type CampaignDynamicSubjectLineUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sectionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CampaignDynamicSubjectLineUpdateMutation = { __typename?: 'Mutation', campaignDynamicSubjectLineUpdate: { __typename?: 'CampaignInboxUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, subjectline?: { __typename?: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine' } | { __typename?: 'StaticMessage' } | null } } };

export type DynamicContentBlockOptionsFieldsFragment = { __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType } };

export type InboxStaticFieldsFragment = { __typename?: 'StaticMessage', message?: string | null };

export type InboxDynamicFieldsFragment = { __typename?: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } } | null };

export type InboxSubjectLinePersadoFieldsFragment = { __typename?: 'PersadoSubjectLine', persadoCampaign?: { __typename?: 'PersadoCampaign', id: string, title: string, externalId: number, subjectLineScript: string } | null };

export type InboxOnlyPreheaderFieldsFragment = { __typename?: 'OnlyPreheader', preheader?: { __typename?: 'DynamicContent', missingExperiences2?: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }> | null, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null, incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessageWithLink', message?: string | null, link?: { __typename?: 'Link', id: string, url: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string } | null } | null } | null };

export type InboxOnlyPreviewFieldsFragment = { __typename?: 'OnlyPreview', preview?: { __typename?: 'DynamicContent', missingExperiences2?: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }> | null, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null, incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, numPositions: number, type: ContentBlockType } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null };

export type InboxBothPreviewPreheaderFieldsFragment = { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename?: 'DynamicContent', missingExperiences2?: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }> | null, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null, incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticPreheaderWithPreview', preview?: string | null, preheader?: string | null, link?: { __typename?: 'Link', id: string, url: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string } | null } | null } | null };

export type AllInboxStepsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AllInboxStepsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, title: string, featureFlagExperiences2: CampaignFeatureFlagState, campaignTemplate?: { __typename?: 'CampaignTemplate', sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType } } | { __typename?: 'StaticSection' }> } | null, subjectline?: { __typename?: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine', persadoCampaign?: { __typename?: 'PersadoCampaign', id: string, title: string, externalId: number, subjectLineScript: string } | null } | { __typename?: 'StaticMessage', message?: string | null } | null, suffix?: { __typename: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } } | null } | { __typename: 'NoContent' } | { __typename: 'StaticMessage', message?: string | null } | null, prefix?: { __typename: 'DynamicContent', section?: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } } | null } | { __typename: 'NoContent' } | { __typename: 'StaticMessage', message?: string | null } | null, preheaderAndPreview?: { __typename?: 'BothPreviewPreheader', preheaderWithPreview?: { __typename?: 'DynamicContent', missingExperiences2?: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }> | null, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null, incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticPreheaderWithPreview', preview?: string | null, preheader?: string | null, link?: { __typename?: 'Link', id: string, url: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string } | null } | null } | null } | { __typename?: 'OnlyPreheader', preheader?: { __typename?: 'DynamicContent', missingExperiences2?: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }> | null, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null, incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessageWithLink', message?: string | null, link?: { __typename?: 'Link', id: string, url: string, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string } | null } | null } | null } | { __typename?: 'OnlyPreview', preview?: { __typename?: 'DynamicContent', missingExperiences2?: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }> | null, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null, incompleteCreatives?: Array<{ __typename?: 'Creative', id: string, title: string }> | null, section?: { __typename?: 'DynamicSection', id: string, title: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, numPositions: number, type: ContentBlockType } } | null } | { __typename?: 'NoContent' } | { __typename?: 'StaticMessage', message?: string | null } | null } | null } };

export type CampaignContactIncludedAudiencesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignContactIncludedAudiencesQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string } | null }> | null }> | null } };

export type CampaignIncludedCreativeTagsSearchQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignIncludedCreativeTagsSearchQuery = { __typename?: 'Query', campaignIncludedCreativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type CampaignIncludedCreativesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignIncludedCreativesQuery = { __typename?: 'Query', campaignIncludedCreatives: Array<{ __typename?: 'Creative', title: string, id: string }> };

export type EmailVersionSendContactsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type EmailVersionSendContactsQuery = { __typename?: 'Query', emailVersionSendContacts: Array<{ __typename?: 'EmailVersionSendContact', id: string, emailAddress: string, contactType: EmailVersionSendContactType, channel: Channel, channelId: string, contact?: { __typename?: 'PreviewContact', id: string, firstName?: string | null, lastName?: string | null } | null, contactGroup?: { __typename?: 'PreviewContactGroup', id: string, title: string, contactCount: number, sends: number, contacts: Array<{ __typename?: 'PreviewContact', id: string, emailAddress: string, firstName?: string | null, lastName?: string | null }> } | null }> };

export type EmailVersionSendContactCreateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  contactType: EmailVersionSendContactType;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  contactGroupId?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Channel>;
  channelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailVersionSendContactCreateMutation = { __typename?: 'Mutation', emailVersionSendContactCreate: { __typename?: 'EmailVersionSendContactCreate', emailVersionSendContact: { __typename?: 'EmailVersionSendContact', id: string, emailAddress: string, channel: Channel, channelId: string, contactType: EmailVersionSendContactType, contact?: { __typename?: 'PreviewContact', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string, sends: number } | null, contactGroup?: { __typename?: 'PreviewContactGroup', id: string, title: string, contactCount: number, sends: number, contacts: Array<{ __typename?: 'PreviewContact', id: string, emailAddress: string, firstName?: string | null, lastName?: string | null }> } | null } } };

export type EmailVersionSendContactDeleteMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  emailVersionSendContactId: Scalars['ID']['input'];
}>;


export type EmailVersionSendContactDeleteMutation = { __typename?: 'Mutation', emailVersionSendContactDelete: { __typename?: 'EmailVersionSendContactDelete', campaign: { __typename?: 'Campaign', id: string, title: string } } };

export type EmailVersionSendAdditionalAttributesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type EmailVersionSendAdditionalAttributesQuery = { __typename?: 'Query', emailVersionSendAdditionalAttributes: { __typename?: 'EmailVersionSendAdditionalAttributes', enableProofLabel: boolean, defaultProofLabel: string } };

export type EmailVersionSendDeliverMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sendFormat: EmailVersionSendFormatType;
  proofLabel: Scalars['String']['input'];
}>;


export type EmailVersionSendDeliverMutation = { __typename?: 'Mutation', emailVersionSendDeliver: { __typename?: 'EmailVersionSendDeliver', success?: boolean | null } };

export type CampaignProofTabQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignProofTabQuery = { __typename?: 'Query', campaignPreview: { __typename?: 'CampaignPreview', finalsStatus: CampaignPreviewStatusType, proofsStatus: CampaignPreviewStatusType, proofVariantCount?: number | null }, campaign: { __typename?: 'Campaign', id: string, stage: CampaignStageType, hasContactAudiences: boolean, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, splitConfigs?: Array<{ __typename?: 'ContactAudienceConfigSplit', id: string, selected: boolean, name: string, split?: { __typename?: 'ContactAudienceSplit', id: string } | null }> | null }> | null, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }> }> }, emailVersionSendAdditionalAttributes: { __typename?: 'EmailVersionSendAdditionalAttributes', enableProofLabel: boolean, defaultProofLabel: string } };

export type CampaignProofVariantListQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  proofVariantFilter: ProofVariantFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignProofVariantListQuery = { __typename?: 'Query', campaignProofVariantList: { __typename?: 'ProofVariantListResults', results: Array<{ __typename?: 'ProofVariant', runId: number, id: string, subjectline?: string | null, subjectlinePrefix?: string | null, subjectlineSuffix?: string | null, previewText?: string | null, preheaderText?: string | null, recipients: number, type: ProofVariantType, desktopImageUrl?: string | null, contentBlocks: Array<{ __typename?: 'ProofVariantContentBlock', position?: number | null, title: string, creativeTitle?: string | null }> }>, meta: { __typename?: 'ProofVariantListMeta', totalResults: number, variants: number, recipients: number, totalVariants: number, totalRecipients: number } } };

export type EmailVersionSendsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type EmailVersionSendsQuery = { __typename?: 'Query', emailVersionSends?: Array<{ __typename?: 'EmailVersionSend', id: string, emailId: string }> | null };

export type EmailVersionSendCreateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  emailId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['Int']['input']>;
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  audienceSplitIds?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>> | InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>>;
  creativeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  creativeTagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  preheaderTextContains?: InputMaybe<Scalars['String']['input']>;
  previewTextContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineContains?: InputMaybe<Scalars['String']['input']>;
  subjectlinePrefixContains?: InputMaybe<Scalars['String']['input']>;
  subjectlineSuffixContains?: InputMaybe<Scalars['String']['input']>;
  treatmentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EmailVersionSendCreateMutation = { __typename?: 'Mutation', emailVersionSendCreate: { __typename?: 'EmailVersionSendCreate', emailVersionSend: { __typename?: 'EmailVersionSend', id: string, emailId: string } } };

export type EmailVersionSendDeleteMutationVariables = Exact<{
  emailVersionSendId: Scalars['ID']['input'];
}>;


export type EmailVersionSendDeleteMutation = { __typename?: 'Mutation', emailVersionSendDelete: { __typename?: 'EmailVersionSendDelete', emailVersionSend: { __typename?: 'EmailVersionSend', id: string, emailId: string } } };

export type CampaignProofVariants2QueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  proofVariantFilter: ProofVariantFilterInput2;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignProofVariants2Query = { __typename?: 'Query', campaignProofVariants2: { __typename?: 'ProofVariantListResults2', results: Array<{ __typename?: 'MMSProofVariant', id: string, runId: number, body?: string | null, mediaUrl?: string | null, recipients: number, type: ProofVariantType } | { __typename?: 'PushProofVariant', id: string, runId: number, title?: string | null, body?: string | null, imageUrl?: string | null, recipients: number, type: ProofVariantType } | { __typename?: 'SMSProofVariant', id: string, runId: number, body?: string | null, recipients: number, type: ProofVariantType }>, meta: { __typename?: 'ProofVariantListMeta', variants: number, recipients: number, totalVariants: number, totalResults: number, totalRecipients: number } } };

export type CampaignSendDateTimeExperimentDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experimentId: Scalars['ID']['input'];
}>;


export type CampaignSendDateTimeExperimentDeleteMutation = { __typename?: 'Mutation', campaignExperimentDelete: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', title: string, shortUuid: string, sendDate: string, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }> }>, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', treatment?: { __typename?: 'TreatmentSendDatetime', id: string, control: boolean } | null, schedule?: { __typename: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename: 'StaticSendSchedule', datetime: string } | null }> } } };

export type CampaignStaticSendScheduleUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  treatmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CampaignStaticSendScheduleUpdateMutation = { __typename?: 'Mutation', campaignStaticSendScheduleUpdate: { __typename?: 'CampaignStaticSendScheduleUpdate', campaign: { __typename?: 'Campaign', id: string, sendDate: string, availableSendTimes: Array<string>, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', schedule?: { __typename: 'PersonalizedSendSchedule' } | { __typename: 'StaticSendSchedule', datetime: string } | null }> } } };

export type SendScheduleFragmentFragment = { __typename?: 'Campaign', sendSchedule: Array<{ __typename?: 'SendScheduleVariant', treatment?: { __typename?: 'TreatmentSendDatetime', id: string, control: boolean } | null, schedule?: { __typename: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename: 'StaticSendSchedule', datetime: string } | null }> };

export type CampaignScheduleTabQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignScheduleTabQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, sendDate: string, sendTimezone: string, availableSendTimes: Array<string>, scheduleInterval: any, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string }> }>, pushSettings?: { __typename?: 'CampaignPushSettings', expirationTimeSeconds: number } | null, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', treatment?: { __typename?: 'TreatmentSendDatetime', id: string, control: boolean } | null, schedule?: { __typename: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename: 'StaticSendSchedule', datetime: string } | null }> } };

export type CampaignPersonalizedSendScheduleUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  datetimeRanges?: InputMaybe<Array<Scalars['DateTimeRange']['input']> | Scalars['DateTimeRange']['input']>;
  treatmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CampaignPersonalizedSendScheduleUpdateMutation = { __typename?: 'Mutation', campaignPersonalizedSendScheduleUpdate: { __typename?: 'CampaignPersonalizedSendScheduleUpdate', campaign: { __typename?: 'Campaign', id: string, sendDate: string, availableSendTimes: Array<string>, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', treatment?: { __typename?: 'TreatmentSendDatetime', id: string, control: boolean } | null, schedule?: { __typename: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename: 'StaticSendSchedule', datetime: string } | null }> } } };

export type CampaignAddScheduleExperimentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experimentGroupId: Scalars['ID']['input'];
}>;


export type CampaignAddScheduleExperimentGroupMutation = { __typename?: 'Mutation', campaignAddExperimentGroup: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, sendDate: string, availableSendTimes: Array<string>, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatmentsCount: number, status: ExperimentStatus, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, control: boolean }> }>, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', treatment?: { __typename?: 'TreatmentSendDatetime', id: string, control: boolean } | null, schedule?: { __typename: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename: 'StaticSendSchedule', datetime: string } | null }> } } };

export type CampaignPushSettingsUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  expirationTimeSeconds: Scalars['Int']['input'];
}>;


export type CampaignPushSettingsUpdateMutation = { __typename?: 'Mutation', campaignPushSettingsUpdate: { __typename?: 'CampaignPushSettingsUpdateSuccess', success: boolean, pushSettings: { __typename?: 'CampaignPushSettings', expirationTimeSeconds: number } } };

export type CampaignTextAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignTextAttributeUpdateMutation = { __typename?: 'Mutation', campaignTextAttributeUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } };

export type CampaignListAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CampaignListAttributeUpdateMutation = { __typename?: 'Mutation', campaignListAttributeUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } };

export type CampaignDateAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CampaignDateAttributeUpdateMutation = { __typename?: 'Mutation', campaignDateAttributeUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } };

export type CampaignSelectAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CampaignSelectAttributeUpdateMutation = { __typename?: 'Mutation', campaignSelectAttributeUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } };

export type SettingsCustomFieldAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
}>;


export type SettingsCustomFieldAddMutation = { __typename?: 'Mutation', campaignCustomFieldAdd: { __typename?: 'CampaignCustomFieldAdd', campaign: { __typename?: 'Campaign', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } };

export type SettingsCustomFieldUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
  metadata: CampaignCustomFieldMetadataInput;
}>;


export type SettingsCustomFieldUpdateMutation = { __typename?: 'Mutation', campaignCustomFieldUpdate: { __typename?: 'CampaignCustomFieldUpdate', campaign: { __typename?: 'Campaign', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } };

export type SettingsCustomFieldRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
}>;


export type SettingsCustomFieldRemoveMutation = { __typename?: 'Mutation', campaignCustomFieldRemove: { __typename?: 'CampaignCustomFieldRemove', campaign: { __typename?: 'Campaign', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } };

export type CampaignAddSettingsExperimentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experimentGroupId: Scalars['ID']['input'];
}>;


export type CampaignAddSettingsExperimentGroupMutation = { __typename?: 'Mutation', campaignAddExperimentGroup: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> }> } } };

export type CampaignSettingsExperimentDeleteMutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignSettingsExperimentDeleteMutation = { __typename?: 'Mutation', campaignExperimentDelete: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> }> } } };

export type MessageExtrasFragmentFragment = { __typename?: 'Campaign', id: string, messageExtras: Array<{ __typename?: 'MessageExtra', id: string, messageExtraKeyId: string, value: string }>, messageExtraKeys: Array<{ __typename?: 'MessageExtraKey', id: string, keyName: string, defaultValue: string }> };

export type CampaignMessageExtraCreateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  messageExtraKeyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type CampaignMessageExtraCreateMutation = { __typename?: 'Mutation', campaignMessageExtraCreate: { __typename?: 'CampaignMessageExtraMutationSuccess', campaign: { __typename?: 'Campaign', id: string, messageExtras: Array<{ __typename?: 'MessageExtra', id: string, messageExtraKeyId: string, value: string }> } } };

export type CampaignMessageExtraUpdateMutationVariables = Exact<{
  messageExtraId: Scalars['ID']['input'];
  messageExtraKeyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type CampaignMessageExtraUpdateMutation = { __typename?: 'Mutation', campaignMessageExtraUpdate: { __typename?: 'CampaignMessageExtraMutationSuccess', campaign: { __typename?: 'Campaign', id: string, messageExtras: Array<{ __typename?: 'MessageExtra', id: string, messageExtraKeyId: string, value: string }> } } };

export type CampaignMessageExtraDeleteMutationVariables = Exact<{
  messageExtraId: Scalars['ID']['input'];
}>;


export type CampaignMessageExtraDeleteMutation = { __typename?: 'Mutation', campaignMessageExtraDelete: { __typename?: 'CampaignMessageExtraMutationSuccess', campaign: { __typename?: 'Campaign', id: string, messageExtras: Array<{ __typename?: 'MessageExtra', id: string, messageExtraKeyId: string, value: string }> } } };

export type ContactAudiencesSettingsQueryVariables = Exact<{
  countLessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<ContactAudienceType> | ContactAudienceType>;
}>;


export type ContactAudiencesSettingsQuery = { __typename?: 'Query', contactAudiences: { __typename?: 'ContactAudienceList', audiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }> } };

export type CampaignSeedAudienceAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type CampaignSeedAudienceAddMutation = { __typename?: 'Mutation', campaignSeedAudienceAdd: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null } } };

export type CampaignSeedAudienceRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type CampaignSeedAudienceRemoveMutation = { __typename?: 'Mutation', campaignSeedAudienceRemove: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null } } };

export type CampaignTextTrackingParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignTextTrackingParameterUpdateMutation = { __typename?: 'Mutation', campaignTextTrackingParameterUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } };

export type CampaignSelectTrackingParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CampaignSelectTrackingParameterUpdateMutation = { __typename?: 'Mutation', campaignSelectTrackingParameterUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } };

type CampaignAttributesFragment_CheckboxAttribute_Fragment = { __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_DateAttribute_Fragment = { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_DateTimeAttribute_Fragment = { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_FormatStringAttribute_Fragment = { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_ListAttribute_Fragment = { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_MultiSelectAttribute_Fragment = { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_MultiSelectAttribute2_Fragment = { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_NumberAttribute_Fragment = { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_SelectAttribute_Fragment = { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignAttributesFragment_SelectAttribute2_Fragment = { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } };

type CampaignAttributesFragment_TextAttribute_Fragment = { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

export type CampaignAttributesFragmentFragment = CampaignAttributesFragment_CheckboxAttribute_Fragment | CampaignAttributesFragment_DateAttribute_Fragment | CampaignAttributesFragment_DateTimeAttribute_Fragment | CampaignAttributesFragment_FormatStringAttribute_Fragment | CampaignAttributesFragment_ListAttribute_Fragment | CampaignAttributesFragment_MultiSelectAttribute_Fragment | CampaignAttributesFragment_MultiSelectAttribute2_Fragment | CampaignAttributesFragment_NumberAttribute_Fragment | CampaignAttributesFragment_SelectAttribute_Fragment | CampaignAttributesFragment_SelectAttribute2_Fragment | CampaignAttributesFragment_TextAttribute_Fragment;

type CampaignTrackingParametersFragment_CheckboxAttribute_Fragment = { __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_DateAttribute_Fragment = { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_DateTimeAttribute_Fragment = { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_FormatStringAttribute_Fragment = { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_ListAttribute_Fragment = { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_MultiSelectAttribute_Fragment = { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_MultiSelectAttribute2_Fragment = { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_NumberAttribute_Fragment = { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_SelectAttribute_Fragment = { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type CampaignTrackingParametersFragment_SelectAttribute2_Fragment = { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } };

type CampaignTrackingParametersFragment_TextAttribute_Fragment = { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

export type CampaignTrackingParametersFragmentFragment = CampaignTrackingParametersFragment_CheckboxAttribute_Fragment | CampaignTrackingParametersFragment_DateAttribute_Fragment | CampaignTrackingParametersFragment_DateTimeAttribute_Fragment | CampaignTrackingParametersFragment_FormatStringAttribute_Fragment | CampaignTrackingParametersFragment_ListAttribute_Fragment | CampaignTrackingParametersFragment_MultiSelectAttribute_Fragment | CampaignTrackingParametersFragment_MultiSelectAttribute2_Fragment | CampaignTrackingParametersFragment_NumberAttribute_Fragment | CampaignTrackingParametersFragment_SelectAttribute_Fragment | CampaignTrackingParametersFragment_SelectAttribute2_Fragment | CampaignTrackingParametersFragment_TextAttribute_Fragment;

type CustomFieldsFragment_DatetimeCustomField_Fragment = { __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null };

type CustomFieldsFragment_NumberCustomField_Fragment = { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null };

type CustomFieldsFragment_TextCustomField_Fragment = { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null };

export type CustomFieldsFragmentFragment = CustomFieldsFragment_DatetimeCustomField_Fragment | CustomFieldsFragment_NumberCustomField_Fragment | CustomFieldsFragment_TextCustomField_Fragment;

export type ExperimentsFragmentFragment = { __typename?: 'Experiment', id: string, title: string, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> };

export type CampaignEditSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignEditSettingsQuery = { __typename?: 'Query', availableCustomFields: Array<{ __typename?: 'AvailableCustomField', id: string, name: string, title: string }>, campaign: { __typename?: 'Campaign', id: string, hasContactAudiences: boolean, stage: CampaignStageType, status: CampaignStatusType, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string } | null, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, experiments: Array<{ __typename?: 'Experiment', id: string, title: string, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, experimentType: ExperimentType, treatmentsCount: number, status: ExperimentStatus, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, messageExtras: Array<{ __typename?: 'MessageExtra', id: string, messageExtraKeyId: string, value: string }>, messageExtraKeys: Array<{ __typename?: 'MessageExtraKey', id: string, keyName: string, defaultValue: string }> } };

export type TemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  isMessageBuilderTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'TemplatePaginatedType', page: number, total: number, results: Array<{ __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null, staticContentBlockCount?: number | null, contentBlocks?: Array<{ __typename?: 'ContentBlock', id: string, title: string, placeholderType: ContentBlockPlaceholderType }> | null }> } };

export type CampaignTemplateUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type CampaignTemplateUpdateMutation = { __typename?: 'Mutation', campaignTemplateUpdate: { __typename?: 'CampaignTemplateUpdate', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } | null, availableCreativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type ContentBlocksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentBlocksQuery = { __typename?: 'Query', contentBlocks: Array<{ __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, status: ContentBlockStatus, blockImageUrl?: string | null }> };

export type CampaignSectionRemoveV2MutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  confirm: Scalars['Boolean']['input'];
  sectionId: Scalars['ID']['input'];
}>;


export type CampaignSectionRemoveV2Mutation = { __typename?: 'Mutation', campaignSectionRemove2: { __typename?: 'CampaignUpdateSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } | null, subjectline?: { __typename?: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine' } | { __typename?: 'StaticMessage' } | null, availableCreativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'NeedsConfirmation', success: boolean } };

export type CampaignSectionPrimaryUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
}>;


export type CampaignSectionPrimaryUpdateMutation = { __typename?: 'Mutation', campaignSectionPrimaryUpdate: { __typename?: 'CampaignSuccess', success: boolean, campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } | null } } };

export type CampaignSectionAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  contentBlockId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignSectionAddMutation = { __typename?: 'Mutation', campaignSectionAdd: { __typename?: 'CampaignSectionAdd', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } | null, subjectline?: { __typename?: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> } | { __typename?: 'PersadoSubjectLine' } | { __typename?: 'StaticMessage' } | null, availableCreativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignSectionPriorityUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CampaignSectionPriorityUpdateMutation = { __typename?: 'Mutation', campaignSectionPriorityUpdate: { __typename?: 'CampaignSuccess', campaign: { __typename?: 'Campaign', id: string, campaignTemplate?: { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } | null } } };

export type CampaignTemplateFieldsFragment = { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> };

export type GetCampaignTemplateDataQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetCampaignTemplateDataQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, status: CampaignStatusType, campaignTemplate?: { __typename?: 'CampaignTemplate', template: { __typename?: 'Template', id: string, title: string, description?: string | null, dynamicContentBlockCount?: number | null }, drift?: { __typename?: 'TemplateDrift', sectionChanged: boolean, templateChanged: boolean } | null, sections: Array<{ __typename?: 'DynamicSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } } | { __typename?: 'StaticSection', isExpanded: boolean, id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } | null } };

export type CampaignTemplateSaveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  sections: Array<CampaignTemplateSectionInput> | CampaignTemplateSectionInput;
}>;


export type CampaignTemplateSaveMutation = { __typename?: 'Mutation', campaignTemplateSave: { __typename?: 'CampaignTemplateSave', success: boolean } };

export type GetBaseTemplateQueryVariables = Exact<{
  baseTemplateId: Scalars['ID']['input'];
}>;


export type GetBaseTemplateQuery = { __typename?: 'Query', baseTemplate: { __typename?: 'BaseTemplate', template: { __typename?: 'Template', id: string, title: string }, sections: Array<{ __typename?: 'BaseTemplateSection', id: string, isPrimary: boolean, position: number, zone?: Zone | null, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, numPositions: number, type: ContentBlockType, blockImageUrl?: string | null } }> } };

export type BaseTemplateUpdateMutationVariables = Exact<{
  baseTemplateId: Scalars['ID']['input'];
  sections: Array<BaseTemplateSectionInput> | BaseTemplateSectionInput;
}>;


export type BaseTemplateUpdateMutation = { __typename?: 'Mutation', baseTemplateUpdate: { __typename?: 'BaseTemplateUpdate', success: boolean } };

export type ExperimentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExperimentGroupsQuery = { __typename?: 'Query', experimentGroups: Array<{ __typename?: 'ExperimentGroup', id: string, title: string, experimentType: ExperimentType, configurationRestrictedToStaff: boolean }> };

export type InboxSubjectLineDynamicFieldsFragment = { __typename?: 'DynamicSubjectLine', complete: boolean, rules: Array<{ __typename?: 'DynamicSubjectLineRule', id: string, section: { __typename?: 'DynamicSection', id: string, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, numPositions: number, title: string, type: ContentBlockType } }, creativesMissingSubjectLines: Array<{ __typename?: 'Creative', id: string, title: string }>, missingExperiences2: Array<{ __typename?: 'Experience2', id: string, visibility: Experience2Visibility, recsSettings: { __typename?: 'Experience2RecsSettingsOutput', ignoreReuseRules: boolean, ignoreCreativeFilters: boolean }, targetRuleset: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> }>, missingTargetRuleset?: Array<{ __typename?: 'TargetRule', splits: Array<string>, treatment?: string | null }> | null }>, experiment?: { __typename?: 'Experiment', id: string, title: string, experimentType: ExperimentType, resultsRestrictedToStaff: boolean, configurationRestrictedToStaff: boolean, treatments: Array<{ __typename?: 'ExperimentTreatment', id: string, title: string, order: number, control: boolean }> } | null, strategies: Array<{ __typename?: 'SubjectlineStrategyVariant', strategy: SubjectlineStrategy, treatment?: { __typename?: 'TreatmentSubjectLineStrategy', id: string, title: string, control: boolean, order: number } | null }> };

export type CampaignSendDateUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type CampaignSendDateUpdateMutation = { __typename?: 'Mutation', campaignSendDateUpdate: { __typename?: 'CampaignSendDateUpdate', success: boolean, campaign: { __typename?: 'Campaign', id: string, sendDate: string } } };

export type TagsFragmentFragment = { __typename?: 'Tag', id: string, name: string };

export type ListAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type CampaignTagAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type CampaignTagAddMutation = { __typename?: 'Mutation', campaignTagCreate: { __typename?: 'CampaignTagUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignTagDeleteMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type CampaignTagDeleteMutation = { __typename?: 'Mutation', campaignTagDelete: { __typename?: 'CampaignTagUpdateSuccess', campaign: { __typename?: 'Campaign', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type CampaignFieldsFragment = { __typename?: 'Campaign', id: string, legacyId: string, title: string, stage: CampaignStageType, sendDate: string, status: CampaignStatusType, error: boolean, autoSchedule: boolean, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel } };

export type FetchCampaignsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  statusGroups?: InputMaybe<Array<CampaignStatusGroupType> | CampaignStatusGroupType>;
  sort?: InputMaybe<Array<CampaignSortType> | CampaignSortType>;
  search?: InputMaybe<Scalars['SearchUID']['input']>;
  error?: InputMaybe<Scalars['Boolean']['input']>;
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  channels?: InputMaybe<Array<Channel> | Channel>;
  hasNewerCreativeVersions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchCampaignsQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginatedType', page: number, total: number, results: Array<{ __typename?: 'Campaign', id: string, legacyId: string, title: string, stage: CampaignStageType, sendDate: string, status: CampaignStatusType, error: boolean, autoSchedule: boolean, sendSchedule: Array<{ __typename?: 'SendScheduleVariant', id: string, schedule?: { __typename?: 'PersonalizedSendSchedule', isFullDay: boolean, datetimeRanges: Array<{ lower: string, upper: string }> } | { __typename?: 'StaticSendSchedule', datetime: string } | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel } }> } };

export type CampaignStatusGroupCountQueryVariables = Exact<{
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignStatusGroupCountQuery = { __typename?: 'Query', campaignStatusGroupCount: Array<{ __typename?: 'CampaignStatusGroupCountType', statusGroup: CampaignStatusGroupType, count: number, errors: number }> };

export type RecurringCampaignOccurrenceFieldsFragment = { __typename?: 'RCCalendarItem', occurrenceId?: string | null, scheduledFor: string, status: RcCalendarItemStatus, isProjected: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, title: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', rrule: string, sendTime?: any | null, startDate: string, endDate?: string | null, timezone: string } | null } };

export type RecurringCampaignOccurrencesQueryVariables = Exact<{
  startEndRange: Scalars['DateRange']['input'];
  filter?: InputMaybe<RecurringCampaignFilterInput>;
}>;


export type RecurringCampaignOccurrencesQuery = { __typename?: 'Query', recurringCampaignOccurrences: Array<{ __typename?: 'RCCalendarItem', occurrenceId?: string | null, scheduledFor: string, status: RcCalendarItemStatus, isProjected: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, title: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', rrule: string, sendTime?: any | null, startDate: string, endDate?: string | null, timezone: string } | null } }> };

export type FetchCampaignsAudiencesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startEndRange?: InputMaybe<Scalars['DateRange']['input']>;
  statusGroups?: InputMaybe<Array<CampaignStatusGroupType> | CampaignStatusGroupType>;
  sort?: InputMaybe<Array<CampaignSortType> | CampaignSortType>;
  search?: InputMaybe<Scalars['SearchUID']['input']>;
  error?: InputMaybe<Scalars['Boolean']['input']>;
  audienceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  hasNewerCreativeVersions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchCampaignsAudiencesQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginatedType', results: Array<{ __typename?: 'Campaign', id: string, status: CampaignStatusType, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null }> } };

export type RecurringCampaignsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RecurringCampaignFilterInput>;
}>;


export type RecurringCampaignsQuery = { __typename?: 'Query', recurringCampaigns: { __typename?: 'RecurringCampaignConnection', edges: Array<{ __typename?: 'RecurringCampaignEdge', node: { __typename?: 'RecurringCampaignType', id: string, title: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, hasPastMailings: boolean, nextOccurrence?: string | null, stateInfo: { __typename?: 'RecurringCampaignStateInfo', state: RecurringCampaignStatus, transitions: Array<{ __typename?: 'RecurringCampaignTransition', label: string, state: RecurringCampaignStatus }>, actions: Array<{ __typename?: 'RecurringCampaignAction', id: string, label: string }> }, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', rrule: string, sendTime?: any | null, startDate: string, endDate?: string | null, timezone: string } | null } } | null> } };

export type TriggeredCampaignFieldsFragment = { __typename?: 'TriggeredCampaignType', id: string, title: string, status: TriggeredCampaignStatus, stage: TriggeredCampaignStage, triggerSource: TriggerSource, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type TriggeredCampaignsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TriggeredCampaignFilterInput>;
}>;


export type TriggeredCampaignsQuery = { __typename?: 'Query', triggeredCampaigns: { __typename?: 'TriggeredCampaignConnection', edges: Array<{ __typename?: 'TriggeredCampaignEdge', node: { __typename?: 'TriggeredCampaignType', id: string, title: string, status: TriggeredCampaignStatus, stage: TriggeredCampaignStage, triggerSource: TriggerSource, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null> } };

export type RecommendationRunScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendationRunScheduleQuery = { __typename?: 'Query', recommendationRunSchedule?: { __typename?: 'RecommendationRunSchedule', runTime: string, sendDate: string, campaignsIncluded: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, status: CampaignStatusType, autoSchedule: boolean }>, campaignsNotIncluded: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, status: CampaignStatusType, autoSchedule: boolean }> } | null };

export type RecommendationRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendationRunsQuery = { __typename?: 'Query', recommendationRuns: Array<{ __typename?: 'RecommendationRun', id: string, runId: number, status: RecommendationRunStatus, runType: RecommendationRunType, flowRunId?: any | null, flowRunUrl?: string | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType }> }> };

export type RecommendationRunCancelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecommendationRunCancelMutation = { __typename?: 'Mutation', recommendationRunCancel: { __typename?: 'RecommendationRunCancel', success: boolean } };

export type RecommendationRunStartMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecommendationRunStartMutation = { __typename?: 'Mutation', recommendationRunStart: { __typename?: 'RecommendationRunStart', success: boolean, recommendationRun: { __typename?: 'RecommendationRun', id: string, runId: number, status: RecommendationRunStatus, runType: RecommendationRunType, flowRunId?: any | null, flowRunUrl?: string | null, campaigns: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType }> } } };

export type StudioImportCampaignsFieldsFragment = { __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> };

export type StudioCampaignsFragmentFragment = { __typename?: 'Layout', studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }> };

export type FetchLayoutQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  layoutId: Scalars['ID']['input'];
  format: DocumentFormat;
}>;


export type FetchLayoutQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, layout: { __typename: 'Layout', id: string, snapshot?: SyncDocumentMsg | null, supportedLayoutComplexity: LayoutComplexity, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus, updatedAt?: string | null, publishedAt?: string | null, updatedBy?: { __typename?: 'User', fullName?: string | null } | null, publishedBy?: { __typename?: 'User', fullName?: string | null } | null, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, variables: Array<{ __typename?: 'Variable', id: string, name: string, providerVariable?: { __typename?: 'ProviderVariable', id: string, expression: string } | null }>, usedBrandKit?: { __typename?: 'BrandKit', id: string, name: string, description?: string | null, primaryLogoId?: string | null, logos: Array<{ __typename?: 'Logo', id: string, url: string }>, colors: Array<{ __typename?: 'Color', id: string, name: string, slug: string, hex: string }>, typographies: Array<{ __typename?: 'Typography', id: string, name: string, slug: string, type: TypographyType, pseudoState?: ElementPseudoState | null, semanticElement?: string | null, styles: TypographyStyles, mobileStyles: TypographyStyles }> } | null, studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }> } } };

export type FetchLayoutSavedQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  layoutId: Scalars['ID']['input'];
  format: DocumentFormat;
}>;


export type FetchLayoutSavedQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, layout: { __typename: 'Layout', id: string, snapshot?: SyncDocumentMsg | null, published?: SyncDocumentMsg | null, variables: Array<{ __typename?: 'Variable', id: string, name: string, providerVariable?: { __typename?: 'ProviderVariable', id: string, expression: string } | null }> } } };

export type StudioCampaignImportMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  studioCampaignId: Scalars['ID']['input'];
  studioBlockIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  format: DocumentFormat;
}>;


export type StudioCampaignImportMutation = { __typename?: 'Mutation', studioCampaignImport: { __typename?: 'ImportSuccess', success: boolean, layout: { __typename?: 'Layout', id: string, snapshot?: SyncDocumentMsg | null, studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }> } } };

export type LayoutAutoSaveMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  document: Scalars['LayoutDocument']['input'];
  templateTagId: Scalars['ID']['input'];
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LayoutAutoSaveMutation = { __typename?: 'Mutation', layoutSave: { __typename?: 'LayoutUpdateSuccess', success: boolean } };

export type LayoutSaveMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  document: Scalars['LayoutDocument']['input'];
  templateTagId: Scalars['ID']['input'];
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LayoutSaveMutation = { __typename?: 'Mutation', layoutPublish: { __typename?: 'LayoutUpdateSuccess', success: boolean } };

export type LayoutComponentsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<LayoutComponentFilterInput>;
}>;


export type LayoutComponentsQuery = { __typename?: 'Query', layoutComponents: { __typename?: 'LayoutComponentConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'LayoutComponentEdge', node: { __typename?: 'LayoutComponent', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'LayoutComponentVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> } } | null> } };

export type ImageFieldsFragment = { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string };

type TemplateTagFields_CheckboxTemplateTag_Fragment = { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null };

type TemplateTagFields_DateTemplateTag_Fragment = { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null };

type TemplateTagFields_HtmlBundleTemplateTag_Fragment = { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null };

type TemplateTagFields_ImageTemplateTag_Fragment = { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null };

type TemplateTagFields_LayoutTemplateTag_Fragment = { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null };

type TemplateTagFields_LinkTemplateTag_Fragment = { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null };

type TemplateTagFields_MultiSelectTemplateTag_Fragment = { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null };

type TemplateTagFields_SelectTemplateTag_Fragment = { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null };

type TemplateTagFields_TextAreaTemplateTag_Fragment = { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null };

type TemplateTagFields_TextTemplateTag_Fragment = { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null };

export type TemplateTagFieldsFragment = TemplateTagFields_CheckboxTemplateTag_Fragment | TemplateTagFields_DateTemplateTag_Fragment | TemplateTagFields_HtmlBundleTemplateTag_Fragment | TemplateTagFields_ImageTemplateTag_Fragment | TemplateTagFields_LayoutTemplateTag_Fragment | TemplateTagFields_LinkTemplateTag_Fragment | TemplateTagFields_MultiSelectTemplateTag_Fragment | TemplateTagFields_SelectTemplateTag_Fragment | TemplateTagFields_TextAreaTemplateTag_Fragment | TemplateTagFields_TextTemplateTag_Fragment;

export type ContentBlockConfigsFieldsFragment = { __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null };

export type GetCreativeContentBlockConfigsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeContentBlockConfigsQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } };

export type CreateEmptyHtmlBundleMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type CreateEmptyHtmlBundleMutation = { __typename?: 'Mutation', creativeTemplateTagHtmlBundleCreate: { __typename?: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeTextTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateCreativeTextTemplateTagMutation = { __typename?: 'Mutation', creativeTextTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeCheckboxTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  checkboxValue?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCreativeCheckboxTemplateTagMutation = { __typename?: 'Mutation', creativeCheckboxTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeDateTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  dateValue?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateCreativeDateTemplateTagMutation = { __typename?: 'Mutation', creativeDateTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeLinkTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  linkValue?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateCreativeLinkTemplateTagMutation = { __typename?: 'Mutation', creativeUrlTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeSelectTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  choiceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateCreativeSelectTemplateTagMutation = { __typename?: 'Mutation', creativeSelectTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeMultiSelectTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  choiceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateCreativeMultiSelectTemplateTagMutation = { __typename?: 'Mutation', creativeMultiSelectTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type UpdateCreativeImageTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
  image?: InputMaybe<ImageContentInput>;
}>;


export type UpdateCreativeImageTemplateTagMutation = { __typename?: 'Mutation', creativeImageTemplateTagUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type ClearCreativeTemplateTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  templateTagId: Scalars['ID']['input'];
}>;


export type ClearCreativeTemplateTagMutation = { __typename?: 'Mutation', creativeTemplateTagClear: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', incompleteCount: number, thumbnails?: Array<{ __typename: 'Thumbnail', url: string, downloadLink?: string | null }> | null, contentBlock: { __typename: 'ContentBlock', id: string, title: string, status: ContentBlockStatus }, configuredTemplateTags?: Array<{ __typename: 'ContentBlockTemplateTag', id: string, constraint: TemplateTagConstraint, templateTag: { __typename: 'CheckboxTemplateTag', id: string, name: string, checkboxValue?: boolean | null } | { __typename: 'DateTemplateTag', id: string, name: string, dateValue?: string | null } | { __typename: 'HTMLBundleTemplateTag', id: string, name: string, htmlBundleValue?: { __typename?: 'HTMLBundle', id: string, title: string, legacyId: string } | null } | { __typename: 'ImageTemplateTag', id: string, name: string, imageValue?: { __typename?: 'Image', id: string, filename: string, publicUrl: string, url: string, hosted: boolean, titleText: string, altText: string } | null } | { __typename: 'LayoutTemplateTag', id: string, name: string, layoutValue?: { __typename?: 'Layout', id: string, hasUnpublishedChanges?: boolean | null, name: string, upgradeStatus: LayoutUpgradeStatus } | null } | { __typename: 'LinkTemplateTag', id: string, name: string, linkValue?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'MultiSelectTemplateTag', id: string, name: string, multiSelectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'SelectTemplateTag', id: string, name: string, selectValue?: Array<{ __typename?: 'TemplateTagOption', id: string, name: string, selected: boolean } | null> | null } | { __typename: 'TextAreaTemplateTag', id: string, name: string, textAreaValue?: string | null } | { __typename: 'TextTemplateTag', id: string, name: string, textValue?: string | null } }> | null } | null> } } };

export type GetCreativeContentBlockConfigThumbnailsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeContentBlockConfigThumbnailsQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, contentBlockConfigs: Array<{ __typename: 'ContentBlockConfig', thumbnails?: Array<{ __typename: 'Thumbnail', url: string }> | null } | null> } };

export type GetCreativeContentsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeContentsQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, thumbnails: Array<{ __typename?: 'Render', url: string }>, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, languageCode: any, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, languageCode: any, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } };

export type GetContentVariantsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentVariantsQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, title: string, contentVariants: Array<{ __typename?: 'ContentVariant', id: string, languageCode: any, disclaimer: string, subjectLinePrefix?: string | null, subjectLineSuffix: string, availabilities: Array<{ lower: string, upper: string }>, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string }> }> } };

export type GetCampaignsWithContentChangesQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCampaignsWithContentChangesQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, campaignsWithNewerCreativeVersion: Array<{ __typename?: 'Campaign', id: string, title: string, stage: CampaignStageType, status: CampaignStatusType }> } };

export type CreativeDisclaimerTextFragmentFragment = { __typename: 'Creative', id: string, disclaimer?: string | null };

export type GetCreativeDisclaimerTextQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeDisclaimerTextQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, disclaimer?: string | null } };

export type UpdateCreativeDisclaimerTextMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  disclaimer: Scalars['String']['input'];
}>;


export type UpdateCreativeDisclaimerTextMutation = { __typename?: 'Mutation', creativeDisclaimerUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, disclaimer?: string | null } } };

export type DisclaimerLayoutFragmentFragment = { __typename: 'DisclaimerLayout', id: string, supportedLayoutComplexity: LayoutComplexity, studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> };

export type GetCreativeDisclaimerLayoutQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  format: DocumentFormat;
}>;


export type GetCreativeDisclaimerLayoutQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, disclaimerLayout?: { __typename: 'DisclaimerLayout', document?: SyncDocumentMsg | null, id: string, supportedLayoutComplexity: LayoutComplexity, studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } | null } };

export type UpdateCreativeDisclaimerLayoutMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  document: Scalars['LayoutDocument']['input'];
}>;


export type UpdateCreativeDisclaimerLayoutMutation = { __typename?: 'Mutation', disclaimerLayoutSave: { __typename?: 'DisclaimerLayoutUpdateSuccess', success: boolean } };

export type ClearCreativeDisclaimerLayoutMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type ClearCreativeDisclaimerLayoutMutation = { __typename?: 'Mutation', disclaimerLayoutClear: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, disclaimerLayout?: { __typename: 'DisclaimerLayout', document?: SyncDocumentMsg | null, id: string, supportedLayoutComplexity: LayoutComplexity, studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } | null } } };

export type DisclaimerLayoutStudioCampaignImportMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  studioCampaignId: Scalars['ID']['input'];
  studioBlockIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  format: DocumentFormat;
}>;


export type DisclaimerLayoutStudioCampaignImportMutation = { __typename?: 'Mutation', disclaimerStudioCampaignImport: { __typename?: 'DisclaimerImportSuccess', success: boolean, layout: { __typename: 'DisclaimerLayout', id: string, document?: SyncDocumentMsg | null, supportedLayoutComplexity: LayoutComplexity, studioCampaigns: Array<{ __typename?: 'StudioCampaignImport', name: string, studioId: string, blocks: Array<{ __typename?: 'StudioBlockImport', studioBlockId: string, name: string, image: string, link?: string | null, altText?: string | null, backingLink?: { __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> } | null, dynamicFields?: Array<{ __typename?: 'DynamicField', name: string, type: string, options?: Array<string> | null, value?: string | null, readonly: boolean, isDynamic: boolean } | null> | null }> }>, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } } };

export type CreativesContactAudiencesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ContactAudienceType> | ContactAudienceType>;
  orderBy?: InputMaybe<ContactAudiencesOrderBy>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreativesContactAudiencesQuery = { __typename?: 'Query', contactAudiences: { __typename?: 'ContactAudienceList', audiences: Array<{ __typename?: 'ContactAudience', id: string, name: string, type: ContactAudienceType, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string, name: string }> }> } };

export type GetLegacyAudiencesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<AudienceType> | AudienceType>;
}>;


export type GetLegacyAudiencesQuery = { __typename?: 'Query', audiences: { __typename: 'AudiencePaginatedType', results: Array<{ __typename?: 'Audience', id: string, title: string }> } };

export type GetFiltersTabValuesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFiltersTabValuesQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, status: CreativeStatus, pairedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, pairedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, prohibitedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, prohibitedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, creativeFilters: Array<{ __typename?: 'CreativeFilter2', audienceId: string, splitId: string, audienceName: string, splitName: string, archived: boolean }>, legacyFilter?: { __typename?: 'Audience', id: string, title: string } | null } };

export type GetFiltersTabTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFiltersTabTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type GetFiltersTabCreativesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CreativeOrderBy> | CreativeOrderBy>;
  filter?: InputMaybe<CreativeFilter>;
}>;


export type GetFiltersTabCreativesQuery = { __typename?: 'Query', creatives: { __typename: 'CreativePagination', results: Array<{ __typename?: 'Creative', id: string, title: string }> } };

export type AddAudienceToCreativeMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
  splitId: Scalars['ID']['input'];
}>;


export type AddAudienceToCreativeMutation = { __typename?: 'Mutation', creativeFiltersAdd: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, creativeFilters: Array<{ __typename?: 'CreativeFilter2', audienceId: string, splitId: string }> } } };

export type RemoveAudienceFromCreativeMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
  splitId: Scalars['ID']['input'];
}>;


export type RemoveAudienceFromCreativeMutation = { __typename?: 'Mutation', creativeFiltersRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, creativeFilters: Array<{ __typename?: 'CreativeFilter2', audienceId: string, splitId: string }> } } };

export type RemoveLegacyAudienceFromCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type RemoveLegacyAudienceFromCreativeMutation = { __typename?: 'Mutation', creativeLegacyFilterRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, legacyFilter?: { __typename?: 'Audience', id: string, title: string } | null } } };

export type AddLegacyAudienceToCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type AddLegacyAudienceToCreativeMutation = { __typename?: 'Mutation', creativeLegacyFilterAdd: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, legacyFilter?: { __typename?: 'Audience', id: string, title: string } | null } } };

export type AddPairedCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  pairedCreativeId: Scalars['ID']['input'];
}>;


export type AddPairedCreativeMutation = { __typename?: 'Mutation', creativePairedCreativeAdd: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, pairedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }> } } };

export type RemovePairedCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  pairedCreativeId: Scalars['ID']['input'];
}>;


export type RemovePairedCreativeMutation = { __typename?: 'Mutation', creativePairedCreativeRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, pairedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }> } } };

export type AddPairedTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  pairedTagId: Scalars['ID']['input'];
}>;


export type AddPairedTagMutation = { __typename?: 'Mutation', creativePairedCreativeByTagAdd: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, pairedTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type RemovePairedTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  pairedTagId: Scalars['ID']['input'];
}>;


export type RemovePairedTagMutation = { __typename?: 'Mutation', creativePairedCreativeByTagRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, pairedTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type AddProhibitedCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  prohibitedCreativeId: Scalars['ID']['input'];
}>;


export type AddProhibitedCreativeMutation = { __typename?: 'Mutation', creativeProhibitedCreativePairingAdd: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, prohibitedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }> } } };

export type RemoveProhibitedCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  prohibitedCreativeId: Scalars['ID']['input'];
}>;


export type RemoveProhibitedCreativeMutation = { __typename?: 'Mutation', creativeProhibitedCreativePairingRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, prohibitedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }> } } };

export type AddProhibitedTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  prohibitedTagId: Scalars['ID']['input'];
}>;


export type AddProhibitedTagMutation = { __typename?: 'Mutation', creativeProhibitedCreativePairingByTagAdd: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, prohibitedTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type RemoveProhibitedTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  prohibitedTagId: Scalars['ID']['input'];
}>;


export type RemoveProhibitedTagMutation = { __typename?: 'Mutation', creativeProhibitedCreativePairingByTagRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, prohibitedTags: Array<{ __typename?: 'Tag', id: string, name: string }> } } };

export type GetPersadoCampaignsQueryVariables = Exact<{
  forCreatives?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersadoCampaignsQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', persadoCampaigns: Array<{ __typename?: 'PersadoCampaignItem', externalId: string, title: string }> } };

export type GetCreativePreheaderAndPreviewQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativePreheaderAndPreviewQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, status: CreativeStatus, preheaderText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean }, preheaderLink2: { __typename: 'InboxLinkSetting', enabled: boolean, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean }, previewText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean } } };

export type UpdateCreativeSubjectLinePrefixMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type UpdateCreativeSubjectLinePrefixMutation = { __typename?: 'Mutation', creativeSubjectLinePrefixUpdate: { __typename?: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, subjectLinePrefix?: string | null } } };

export type UpdateCreativeSubjectLineSuffixMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type UpdateCreativeSubjectLineSuffixMutation = { __typename?: 'Mutation', creativeSubjectLineSuffixUpdate: { __typename?: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, subjectLineSuffix?: string | null } } };

export type SubjectLinesFragmentFragment = { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> };

export type AddCreativeSubjectLineMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  isPrimary: Scalars['Boolean']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCreativeSubjectLineMutation = { __typename?: 'Mutation', creativeSubjectLineCreate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> } } };

export type UpdateCreativeSubjectLineMutationVariables = Exact<{
  subjectLineId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  isPrimary: Scalars['Boolean']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCreativeSubjectLineMutation = { __typename?: 'Mutation', creativeSubjectLineUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> } } };

export type RemoveCreativeSubjectLineMutationVariables = Exact<{
  subjectLineId: Scalars['ID']['input'];
}>;


export type RemoveCreativeSubjectLineMutation = { __typename?: 'Mutation', creativeSubjectLineRemove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> } } };

export type ReorderCreativeSubjectLineMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  subjectLineIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderCreativeSubjectLineMutation = { __typename?: 'Mutation', creativeSubjectLinesReorder: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string }> } } };

export type UpdateCreativePersadoCampaignMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  persadoCampaignInput?: InputMaybe<PersadoCampaignInput>;
}>;


export type UpdateCreativePersadoCampaignMutation = { __typename?: 'Mutation', creativePersadoCampaignUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, persadoCampaign?: { __typename?: 'PersadoCampaign', id: string, title: string, externalId: number, subjectLineScript: string, bodyAmpScript: string } | null, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> } } };

export type ArchiveCreativeSubjectLineMutationVariables = Exact<{
  subjectLineId: Scalars['ID']['input'];
}>;


export type ArchiveCreativeSubjectLineMutation = { __typename?: 'Mutation', creativeSubjectLineArchive: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> } } };

export type RestoreCreativeSubjectLineMutationVariables = Exact<{
  subjectLineId: Scalars['ID']['input'];
}>;


export type RestoreCreativeSubjectLineMutation = { __typename?: 'Mutation', creativeSubjectLineRestore: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }> } } };

export type UpdateCreativePreheaderAndPreviewMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  preheaderLinkId?: InputMaybe<Scalars['ID']['input']>;
  preheaderText?: InputMaybe<Scalars['String']['input']>;
  previewText?: InputMaybe<Scalars['String']['input']>;
  usePreheaderTextAsPreviewText?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCreativePreheaderAndPreviewMutation = { __typename?: 'Mutation', creativePreheaderAndPreviewUpdate: { __typename: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, preheaderText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean }, preheaderLink2: { __typename: 'InboxLinkSetting', enabled: boolean, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean }, previewText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean } } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type ReuseRuleFieldsFragment = { __typename: 'ReuseRule', id: string, primaryClickDelay?: any | null, primaryConversionDelay?: any | null, primaryMaxUses?: number | null, primaryOpenDelay?: any | null, primarySendDelay?: any | null, otherClickDelay?: any | null, otherConversionDelay?: any | null, otherMaxUses?: number | null, otherOpenDelay?: any | null, otherSendDelay?: any | null };

export type GetCreativeReuseRuleQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeReuseRuleQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, disableReuseRules: boolean, reuseRule?: { __typename: 'ReuseRule', id: string, primaryClickDelay?: any | null, primaryConversionDelay?: any | null, primaryMaxUses?: number | null, primaryOpenDelay?: any | null, primarySendDelay?: any | null, otherClickDelay?: any | null, otherConversionDelay?: any | null, otherMaxUses?: number | null, otherOpenDelay?: any | null, otherSendDelay?: any | null } | null } };

export type CreativeDisableReuseRulesUpdateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  disableReuseRules: Scalars['Boolean']['input'];
}>;


export type CreativeDisableReuseRulesUpdateMutation = { __typename?: 'Mutation', creativeDisableReuseRulesUpdate: { __typename: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, disableReuseRules: boolean } } };

export type CreativeReuseRuleUpdateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  reuseRule: ReuseRuleInput;
}>;


export type CreativeReuseRuleUpdateMutation = { __typename?: 'Mutation', creativeReuseRuleUpdate: { __typename: 'CreativeReuseRuleUpdate', reuseRule: { __typename: 'ReuseRule', id: string, primaryClickDelay?: any | null, primaryConversionDelay?: any | null, primaryMaxUses?: number | null, primaryOpenDelay?: any | null, primarySendDelay?: any | null, otherClickDelay?: any | null, otherConversionDelay?: any | null, otherMaxUses?: number | null, otherOpenDelay?: any | null, otherSendDelay?: any | null } } | { __typename: 'ValidationErrors' } };

export type CreativeTextAttributeUpdateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  attributeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreativeTextAttributeUpdateMutation = { __typename?: 'Mutation', creativeTextAttributeUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, attributes: Array<{ __typename: 'CheckboxAttribute', id: string } | { __typename: 'DateAttribute', id: string } | { __typename: 'DateTimeAttribute', id: string } | { __typename: 'FormatStringAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'MultiSelectAttribute', id: string } | { __typename: 'MultiSelectAttribute2', id: string } | { __typename: 'NumberAttribute', id: string } | { __typename: 'SelectAttribute', id: string } | { __typename: 'SelectAttribute2', id: string } | { __typename: 'TextAttribute', id: string, value?: string | null }> } } };

export type CreativeSelectAttributeUpdateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  attributeId: Scalars['ID']['input'];
  choiceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreativeSelectAttributeUpdateMutation = { __typename?: 'Mutation', creativeSelectAttributeUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, attributes: Array<{ __typename: 'CheckboxAttribute', id: string } | { __typename: 'DateAttribute', id: string } | { __typename: 'DateTimeAttribute', id: string } | { __typename: 'FormatStringAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'MultiSelectAttribute', id: string } | { __typename: 'MultiSelectAttribute2', id: string } | { __typename: 'NumberAttribute', id: string } | { __typename: 'SelectAttribute', id: string } | { __typename: 'SelectAttribute2', id: string, selectedId?: string | null } | { __typename: 'TextAttribute', id: string }> } } };

export type CreativeTextTrackingParameterUpdateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreativeTextTrackingParameterUpdateMutation = { __typename?: 'Mutation', creativeTextTrackingParameterUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string } | { __typename: 'DateAttribute', id: string } | { __typename: 'DateTimeAttribute', id: string } | { __typename: 'FormatStringAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'MultiSelectAttribute', id: string } | { __typename: 'MultiSelectAttribute2', id: string } | { __typename: 'NumberAttribute', id: string } | { __typename: 'SelectAttribute', id: string } | { __typename: 'SelectAttribute2', id: string } | { __typename: 'TextAttribute', id: string, value?: string | null }> } } };

export type CreativeSelectTrackingParameterUpdateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  choiceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreativeSelectTrackingParameterUpdateMutation = { __typename?: 'Mutation', creativeSelectTrackingParameterUpdate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string } | { __typename: 'DateAttribute', id: string } | { __typename: 'DateTimeAttribute', id: string } | { __typename: 'FormatStringAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'MultiSelectAttribute', id: string } | { __typename: 'MultiSelectAttribute2', id: string } | { __typename: 'NumberAttribute', id: string } | { __typename: 'SelectAttribute', id: string } | { __typename: 'SelectAttribute2', id: string, selectedId?: string | null } | { __typename: 'TextAttribute', id: string }> } } };

export type UpdateCreativeAvailabilitiesMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  availabilities?: InputMaybe<Array<Scalars['DateTimeRange']['input']> | Scalars['DateTimeRange']['input']>;
}>;


export type UpdateCreativeAvailabilitiesMutation = { __typename?: 'Mutation', creativeAvailabilitiesUpdate: { __typename: 'CreativeSuccess', success: boolean, creative: { __typename: 'Creative', id: string, availabilities2: Array<{ lower: string, upper: string }>, status: CreativeStatus } } | { __typename: 'ImpactsLockedCampaigns', lockedCampaigns?: Array<{ __typename?: 'Campaign', id: string, title: string }> | null } };

export type ExpireCreativeMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type ExpireCreativeMutation = { __typename?: 'Mutation', creativeExpire: { __typename?: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, availabilities2: Array<{ lower: string, upper: string }>, status: CreativeStatus } } | { __typename?: 'NeedsConfirmationExpireCreative', earliestTime?: string | null, latestTime?: string | null } };

export type AddCreativeTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type AddCreativeTagMutation = { __typename?: 'Mutation', creativeTagCreate: { __typename?: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string }> } } };

export type DeleteCreativeTagMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type DeleteCreativeTagMutation = { __typename?: 'Mutation', creativeTagDelete: { __typename?: 'CreativeSuccess', creative: { __typename: 'Creative', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string }> } } };

export type LockedCampaignsIncludingCreativeQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type LockedCampaignsIncludingCreativeQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, includedInFutureLockedCampaigns: { __typename?: 'FutureLockedCampaigns', total: number, latestSendDatetime?: string | null, futureLockedCampaigns: Array<{ __typename?: 'Campaign', id: string, title: string }> } } };

export type GetCreativeAvailabilitiesQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeAvailabilitiesQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, availabilities2: Array<{ lower: string, upper: string }> } };

export type UserFieldsFragment = { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean };

export type CreativePreheaderAndPreviewFieldsFragment = { __typename?: 'Creative', preheaderText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean }, preheaderLink2: { __typename: 'InboxLinkSetting', enabled: boolean, link?: { __typename?: 'Link', id: string, url: string, shortUuid: string, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, linkGroup?: { __typename?: 'LinkGroup', id: string, name: string, linksCount: number } | null, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, salesforceMetadata?: { __typename?: 'LinkSalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | null, oracleResponsysMetadata?: { __typename?: 'LinkOracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename?: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | null, cordialMetadata?: { __typename?: 'LinkCordialMetadata', name: string, enableTracking: boolean } | null, acousticCampaignMetadata?: { __typename?: 'LinkAcousticCampaignMetadata', name: string, linkType: LinkTypeAcousticCampaign } | null, epsilonMetadata?: { __typename?: 'LinkEpsilonMetadata', linkType: LinkTypeEpsilon, tracked: boolean } | null, adobeCampaignMetadata?: { __typename?: 'LinkAdobeCampaignMetadata', label: string, trackingType: LinkTrackingTypeAdobeCampaign } | null, adobeJourneyOptimizerMetadata?: { __typename?: 'LinkAdobeJourneyOptimizerMetadata', trackingType: LinkTrackingTypeAdobeJourneyOptimizer } | null, amazonSesMetadata?: { __typename?: 'LinkAmazonSESMetadata', tags: string, enableTracking: boolean } | null, brazeMetadata?: { __typename?: 'LinkBrazeMetadata', alias: string } | null, bluecoreMetadata?: { __typename?: 'LinkBluecoreMetadata', enableTracking: boolean } | null, zetaMetadata?: { __typename?: 'LinkZetaMetadata', name: string, tags: Array<string> } | null } | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean }, previewText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting', enabled: boolean } };

export type CreativeDetailsFieldsFragment = { __typename?: 'Creative', id: string, title: string, legacyId: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, createdAt: string, updatedAt: string, slug: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, availabilities2: Array<{ lower: string, upper: string }>, hasCreativeDescription: boolean, createdBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, updatedBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, approvedBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, tags: Array<{ __typename: 'Tag', id: string, name: string }>, prohibitedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }>, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, attributes: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, pairedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, pairedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, prohibitedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, persadoCampaign?: { __typename?: 'PersadoCampaign', id: string, title: string, externalId: number, subjectLineScript: string } | null };

export type GetCreativeDetailsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeDetailsQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, title: string, legacyId: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, createdAt: string, updatedAt: string, slug: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, availabilities2: Array<{ lower: string, upper: string }>, hasCreativeDescription: boolean, createdBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, updatedBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, approvedBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, tags: Array<{ __typename: 'Tag', id: string, name: string }>, prohibitedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }>, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, attributes: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, pairedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, pairedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, prohibitedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, persadoCampaign?: { __typename?: 'PersadoCampaign', id: string, title: string, externalId: number, subjectLineScript: string } | null } };

export type GetCreativeHeaderDetailsQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeHeaderDetailsQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, legacyId: string, shortUuid: string, createdAt: string, updatedAt: string, archivedAt?: string | null, createdBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, approvedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, creativeFilters: Array<{ __typename?: 'CreativeFilter2', archived: boolean }> } };

export type CreativeUpdateTitleMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type CreativeUpdateTitleMutation = { __typename?: 'Mutation', creativeRename: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', id: string, title: string, legacyId: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, createdAt: string, updatedAt: string, slug: string, status: CreativeStatus, incomplete: Array<CreativeIncompleteReason>, availabilities2: Array<{ lower: string, upper: string }>, hasCreativeDescription: boolean, createdBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, updatedBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, approvedBy?: { __typename?: 'User', id: string, isStaff: boolean, email: string, initials?: string | null, fullName?: string | null, hasSeenCampaignV2Intro: boolean, isDeveloper: boolean, isSuspended: boolean } | null, tags: Array<{ __typename: 'Tag', id: string, name: string }>, prohibitedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string, tone?: string | null, source?: SourceType | null, isPrimary: boolean, isArchived: boolean }>, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, attributes: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, pairedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, pairedTags: Array<{ __typename?: 'Tag', id: string, name: string }>, prohibitedCreatives: Array<{ __typename?: 'Creative', id: string, title: string }>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, persadoCampaign?: { __typename?: 'PersadoCampaign', id: string, title: string, externalId: number, subjectLineScript: string } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CreativeApproveMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeApproveMutation = { __typename?: 'Mutation', creativeApprove: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativeRevertToDraftMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeRevertToDraftMutation = { __typename?: 'Mutation', creativeRevertToDraft: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativeRejectMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeRejectMutation = { __typename?: 'Mutation', creativeReject: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativeSyncToEspMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeSyncToEspMutation = { __typename?: 'Mutation', creativeSyncToEsp: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativeDuplicateMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeDuplicateMutation = { __typename?: 'Mutation', creativeDuplicate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativeDeleteMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeDeleteMutation = { __typename?: 'Mutation', creativeDelete: { __typename?: 'Ok', success: boolean } };

export type CreativeArchiveMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeArchiveMutation = { __typename?: 'Mutation', creativeArchive: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativeUnarchiveMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeUnarchiveMutation = { __typename?: 'Mutation', creativeUnarchive: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } };

export type CreativesProofMutationVariables = Exact<{
  channel?: InputMaybe<Channel>;
  channelIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  contactGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  creativeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreativesProofMutation = { __typename?: 'Mutation', creativesProof: { __typename?: 'Ok', success: boolean } };

export type CreativeFieldsFragment = { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> };

export type FetchCreativesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CreativeFilter>;
  orderBy?: InputMaybe<Array<CreativeOrderBy> | CreativeOrderBy>;
}>;


export type FetchCreativesQuery = { __typename?: 'Query', creatives: { __typename?: 'CreativePagination', page: number, total: number, results: Array<{ __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> }> } };

export type FetchCreativesFiltersCountsQueryVariables = Exact<{
  filter?: InputMaybe<CreativeFilter>;
}>;


export type FetchCreativesFiltersCountsQuery = { __typename?: 'Query', creativeFiltersCounts: { __typename?: 'CreativeFiltersCounts', incomplete: number, archived: number, perStatus: Array<{ __typename?: 'CreativeStatusCount', status: CreativeStatus, total: number }>, perAvailability: Array<{ __typename?: 'CreativeAvailabilityCount', availability: AvailabilityStatus, total: number }> } };

export type FetchCreativesFiltersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CreativeFilter>;
  orderBy?: InputMaybe<Array<CreativeOrderBy> | CreativeOrderBy>;
}>;


export type FetchCreativesFiltersQuery = { __typename?: 'Query', creatives: { __typename?: 'CreativePagination', results: Array<{ __typename?: 'Creative', id: string, status: CreativeStatus, creativeFilters: Array<{ __typename?: 'CreativeFilter2', archived: boolean }> }> } };

export type FetchCreativeAttributeDefinitionsQueryVariables = Exact<{
  filterable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchCreativeAttributeDefinitionsQuery = { __typename?: 'Query', creativeAttributeDefinitions: Array<{ __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }> };

export type CreativeContentVersionsFragment = { __typename?: 'Creative', id: string, title: string, contents: Array<{ __typename?: 'PushNotification', id: string, channel: Channel } | { __typename?: 'TextMessage', id: string, channel: Channel }>, thumbnails: Array<{ __typename?: 'Render', size: RenderSize }> };

export type CreativeCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CreativeCreateMutation = { __typename?: 'Mutation', creativeCreate: { __typename?: 'CreativeSuccess', success: boolean, creative: { __typename?: 'Creative', title: string, shortUuid: string, previewText?: string | null, preheaderText?: string | null, subjectLinePrefix?: string | null, subjectLineSuffix?: string | null, slug: string, id: string, status: CreativeStatus, legacyId: string, archivedAt?: string | null, availabilities2: Array<{ lower: string, upper: string }>, archivedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'DateTimeAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'FormatStringAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'ListAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'MultiSelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'NumberAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'SelectAttribute2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } | { __typename?: 'TextAttribute', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, purpose?: { __typename?: 'CreativePurpose', id: string, name: string, color: string } | null, thumbnails: Array<{ __typename?: 'Render', url: string, size: RenderSize, contentBlock: { __typename?: 'ContentBlock', id: string, title: string } }>, bestThumbnail: { __typename?: 'Thumbnail', url: string }, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type CreativeExportMutationVariables = Exact<{
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filter: CreativeFilter;
}>;


export type CreativeExportMutation = { __typename?: 'Mutation', creativeExport: { __typename?: 'ExportResponse', signedUrl: string } };

export type DataConnectionTestExternalSftpServerMutationVariables = Exact<{
  directory: Scalars['String']['input'];
  host: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
}>;


export type DataConnectionTestExternalSftpServerMutation = { __typename?: 'Mutation', dataConnectionTestExternalSftpServer: { __typename?: 'DataConnectionTestSFTPServer', dataConnectionTest: { __typename?: 'DataConnectionTest', status: DataConnectionStatus, error?: { __typename?: 'DataConnectionError', reason: DataConnectionErrorReason, occurredAt: string } | null } } };

export type DataConnectionCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  hostedSftpServer?: InputMaybe<DataConnectionHostedSftpServerInput>;
  externalSftpServer?: InputMaybe<DataConnectionExternalSftpServerInput>;
  externalGcsBucket?: InputMaybe<DataConnectionExternalGcsBucketInput>;
  hostedGcsBucket?: InputMaybe<DataConnectionHostedGcsBucketInput>;
  externalS3Bucket?: InputMaybe<DataConnectionExternalS3BucketInput>;
}>;


export type DataConnectionCreateMutation = { __typename?: 'Mutation', dataConnectionCreate: { __typename?: 'DataConnectionCreate', dataConnection: { __typename?: 'DataConnection', id: string, createdAt: string, updatedAt: string, name: string, status?: DataConnectionStatus | null, errors: Array<{ __typename?: 'DataConnectionError', reason: DataConnectionErrorReason, occurredAt: string }>, connector: { __typename: 'DataConnectionExternalGCSBucket', name: string, externalGcsBucketServiceAccountEmail: string } | { __typename: 'DataConnectionExternalS3Bucket', name: string, region: string, roleArn: string, externalId: string, prefix?: string | null } | { __typename: 'DataConnectionExternalSFTPServer', host: string, port: number, user: string, authentication: DataConnectionExternalSftpServerAuthentication, password?: string | null, directory: string, externalSftpPublicKey?: string | null } | { __typename: 'DataConnectionHostedGCSBucket', name: string, hostedGcsBucketServiceAccountEmail?: string | null, hmacKeys?: Array<{ __typename?: 'HMACKey', id: string, secret?: string | null }> | null } | { __typename: 'DataConnectionHostedSFTPServer', host: string, user: string, port: number, hostedSftpPublicKey: string, publicKeys?: Array<{ __typename?: 'PublicKey', name: string, key: string }> | null } } } };

export type DataConnectionUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  hostedSftpServer?: InputMaybe<DataConnectionHostedSftpServerInput>;
}>;


export type DataConnectionUpdateMutation = { __typename?: 'Mutation', dataConnectionUpdate: { __typename?: 'DataConnectionUpdateSuccess', dataConnection: { __typename?: 'DataConnection', id: string, name: string, connector: { __typename?: 'DataConnectionExternalGCSBucket' } | { __typename?: 'DataConnectionExternalS3Bucket' } | { __typename?: 'DataConnectionExternalSFTPServer' } | { __typename?: 'DataConnectionHostedGCSBucket' } | { __typename?: 'DataConnectionHostedSFTPServer', host: string, port: number, user: string, publicKey: string, publicKeys?: Array<{ __typename?: 'PublicKey', name: string, key: string }> | null } } } };

export type DataConnectionHealthcheckMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataConnectionHealthcheckMutation = { __typename?: 'Mutation', dataConnectionHealthcheck: { __typename?: 'DataConnectionHealthcheck', dataConnection: { __typename?: 'DataConnection', id: string, createdAt: string, updatedAt: string, name: string, status?: DataConnectionStatus | null, connector: { __typename: 'DataConnectionExternalGCSBucket', name: string, externalGcsBucketServiceAccountEmail: string } | { __typename: 'DataConnectionExternalS3Bucket', name: string, region: string, roleArn: string, externalId: string, prefix?: string | null } | { __typename: 'DataConnectionExternalSFTPServer', host: string, user: string, password?: string | null, directory: string, port: number, publicKeyExternalSFTP?: string | null } | { __typename: 'DataConnectionHostedGCSBucket', name: string, hostedGcsBucketServiceAccountEmail?: string | null } | { __typename: 'DataConnectionHostedSFTPServer', host: string, port: number, user: string, publicKey: string }, errors: Array<{ __typename?: 'DataConnectionError', reason: DataConnectionErrorReason, occurredAt: string }> } } };

export type DataConnectionDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataConnectionDetailQuery = { __typename?: 'Query', dataConnection: { __typename?: 'DataConnection', id: string, createdAt: string, updatedAt: string, name: string, status?: DataConnectionStatus | null, connector: { __typename: 'DataConnectionExternalGCSBucket', name: string, externalGcsBucketServiceAccountEmail: string } | { __typename: 'DataConnectionExternalS3Bucket', name: string, region: string, roleArn: string, externalId: string, prefix?: string | null } | { __typename: 'DataConnectionExternalSFTPServer', host: string, user: string, password?: string | null, directory: string, port: number, publicKeyExternalSFTP?: string | null } | { __typename: 'DataConnectionHostedGCSBucket', name: string, hostedGcsBucketServiceAccountEmail?: string | null, hmacKeys?: Array<{ __typename?: 'HMACKey', id: string, secret?: string | null }> | null } | { __typename: 'DataConnectionHostedSFTPServer', host: string, port: number, user: string, publicKey: string, publicKeys?: Array<{ __typename?: 'PublicKey', name: string, key: string }> | null }, errors: Array<{ __typename?: 'DataConnectionError', reason: DataConnectionErrorReason, occurredAt: string }> } };

export type GenerateHmacKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hmacKeys?: InputMaybe<Array<HmacKeyInput> | HmacKeyInput>;
}>;


export type GenerateHmacKeyMutation = { __typename?: 'Mutation', dataConnectionUpdate: { __typename?: 'DataConnectionUpdateSuccess', dataConnection: { __typename?: 'DataConnection', id: string, connector: { __typename?: 'DataConnectionExternalGCSBucket' } | { __typename?: 'DataConnectionExternalS3Bucket' } | { __typename?: 'DataConnectionExternalSFTPServer' } | { __typename?: 'DataConnectionHostedGCSBucket', hmacKeys?: Array<{ __typename?: 'HMACKey', id: string, secret?: string | null }> | null } | { __typename?: 'DataConnectionHostedSFTPServer' } } } };

export type DeleteHmacKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hmacKeys: Array<HmacKeyInput> | HmacKeyInput;
}>;


export type DeleteHmacKeyMutation = { __typename?: 'Mutation', dataConnectionUpdate: { __typename?: 'DataConnectionUpdateSuccess', dataConnection: { __typename?: 'DataConnection', id: string, connector: { __typename?: 'DataConnectionExternalGCSBucket' } | { __typename?: 'DataConnectionExternalS3Bucket' } | { __typename?: 'DataConnectionExternalSFTPServer' } | { __typename?: 'DataConnectionHostedGCSBucket', hmacKeys?: Array<{ __typename?: 'HMACKey', id: string, secret?: string | null }> | null } | { __typename?: 'DataConnectionHostedSFTPServer' } } } };

export type DataEncryptionConnectionPgpKeysQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type DataEncryptionConnectionPgpKeysQuery = { __typename?: 'Query', dataEncryptionConnectionPgpKeys: { __typename?: 'DataEncryptionPGPKeysList', encryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }>, decryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }> } };

export type DataEncryptionConnectionPgpKeyAttachMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
  pgpKeyId: Scalars['String']['input'];
}>;


export type DataEncryptionConnectionPgpKeyAttachMutation = { __typename?: 'Mutation', dataEncryptionConnectionPgpKeyAttach: { __typename?: 'DataEncryptionConnectionPGPKeyAttachResult', success: boolean, connection: { __typename?: 'DataEncryptionConnectionPGPKeys', id: string, pgpKeys: { __typename?: 'DataEncryptionPGPKeysList', encryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }>, decryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }> } } } };

export type DataEncryptionConnectionPgpKeyUnattachMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
  pgpKeyId: Scalars['String']['input'];
}>;


export type DataEncryptionConnectionPgpKeyUnattachMutation = { __typename?: 'Mutation', dataEncryptionConnectionPgpKeyUnattach: { __typename?: 'DataEncryptionConnectionPGPKeyUnattachResult', success: boolean, connection: { __typename?: 'DataEncryptionConnectionPGPKeys', id: string, pgpKeys: { __typename?: 'DataEncryptionPGPKeysList', encryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }>, decryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }> } } } };

export type DataConnectionDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataConnectionDeleteMutation = { __typename?: 'Mutation', dataConnectionDelete: { __typename?: 'DataConnectionDelete', success: boolean } };

export type DataConnectionsIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type DataConnectionsIndexQuery = { __typename?: 'Query', dataConnections: Array<{ __typename?: 'DataConnection', id: string, createdAt: string, updatedAt: string, name: string, status?: DataConnectionStatus | null, errors: Array<{ __typename?: 'DataConnectionError', reason: DataConnectionErrorReason, occurredAt: string }>, connector: { __typename: 'DataConnectionExternalGCSBucket', name: string, externalGcsBucketServiceAccountEmail: string } | { __typename: 'DataConnectionExternalS3Bucket', name: string, region: string, roleArn: string, externalId: string, prefix?: string | null } | { __typename: 'DataConnectionExternalSFTPServer', host: string, password?: string | null, user: string } | { __typename: 'DataConnectionHostedGCSBucket', name: string, hostedGcsBucketServiceAccountEmail?: string | null } | { __typename: 'DataConnectionHostedSFTPServer', host: string, port: number, user: string, publicKey: string } }> };

export type DatasetsListFragmentFragment = { __typename?: 'InkDataV1Dataset', id: string, name: string, createdAt: string, updatedAt: string, type: { __typename?: 'InkDataV1DatasetType', delta?: { __typename: 'InkDataV1DatasetTypeDelta' } | null } };

export type DatasetFetchFragmentFragment = { __typename?: 'InkDataV1Dataset', id: string, name: string, description: string, createdAt: string, type: { __typename?: 'InkDataV1DatasetType', delta?: { __typename: 'InkDataV1DatasetTypeDelta' } | null } };

export type DatasetFieldsFragmentFragment = { __typename?: 'InkDataV1DatasetField', id: string, name: string, displayName: string, primaryKey: boolean, type: InkDataV1DatasetFieldTypeEnum };

export type ModelsListFragmentFragment = { __typename?: 'InkDataV1Model', id: string, key: string, name: string, description: string, fields: Array<{ __typename?: 'InkDataV1ModelField', id: number, name: string, displayName: string, description: string, primaryKey: boolean, type: InkDataV1ModelFieldTypeEnum }> };

export type DatasetsListQueryVariables = Exact<{ [key: string]: never; }>;


export type DatasetsListQuery = { __typename?: 'Query', datasets: { __typename?: 'InkDataV1DatasetListResponse', datasets: Array<{ __typename?: 'InkDataV1Dataset', id: string, name: string, createdAt: string, updatedAt: string, type: { __typename?: 'InkDataV1DatasetType', delta?: { __typename: 'InkDataV1DatasetTypeDelta' } | null } }> } };

export type DatasetFetchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DatasetFetchQuery = { __typename?: 'Query', dataset: { __typename?: 'InkDataV1DatasetFetchResponse', dataset: { __typename?: 'InkDataV1Dataset', id: string, name: string, description: string, createdAt: string, type: { __typename?: 'InkDataV1DatasetType', delta?: { __typename: 'InkDataV1DatasetTypeDelta' } | null } } } };

export type DatasetFieldsQueryVariables = Exact<{
  datasetId: Scalars['ID']['input'];
}>;


export type DatasetFieldsQuery = { __typename?: 'Query', datasetFields: { __typename?: 'InkDataV1DatasetFieldListResponse', fields: Array<{ __typename?: 'InkDataV1DatasetField', id: string, name: string, displayName: string, primaryKey: boolean, type: InkDataV1DatasetFieldTypeEnum }> } };

export type DatasetStatisticsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DatasetStatisticsQuery = { __typename?: 'Query', datasetStatistics: { __typename?: 'InkDataV1DatasetStatisticsResponse', rowCount: number, sizeOnDisk?: number | null } };

export type WarehousesListQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehousesListQuery = { __typename?: 'Query', warehouses: { __typename?: 'InkDataV1WarehouseListResponse', warehouses: Array<{ __typename?: 'InkDataV1Warehouse', type: InkDataV1WarehouseTypeEnum, default: boolean }> } };

export type ConnectionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsListQuery = { __typename?: 'Query', connections: { __typename?: 'InkDataV1ConnectionListResponse', connections: Array<{ __typename?: 'InkDataV1Connection', id: string, name: string }> } };

export type ConnectionStreamsQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type ConnectionStreamsQuery = { __typename?: 'Query', connectionStreams: { __typename?: 'InkDataV1ConnectionStreamListResponse', streams: Array<{ __typename?: 'InkDataV1Stream', key: string, modifiedAt: string, sftpFile?: { __typename?: 'InkDataV1StreamSFTPFile', size: number } | null, gcsObject?: { __typename?: 'InkDataV1StreamGCSObject', size: number } | null, s3Object?: { __typename?: 'InkDataV1StreamS3Object', size: number } | null, localFile?: { __typename?: 'InkDataV1StreamLocalFile', size: number } | null }> } };

export type ConnectionStreamSchemaQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
  streamKey: Scalars['String']['input'];
}>;


export type ConnectionStreamSchemaQuery = { __typename?: 'Query', connectionStreamSchema: { __typename?: 'InkDataV1StreamSchemaFetchResponse', schema: { __typename?: 'InkDataV1StreamSchema', compression: InkDataV1StreamSchemaCompressionEnum, format: { __typename?: 'InkDataV1StreamSchemaFormat', csv?: { __typename?: 'InkDataV1StreamSchemaFormatCSV', delimiter: string, header: boolean, null: string } | null, ndjson?: { __typename?: 'InkDataV1StreamSchemaFormatNDJSON', placeholder?: boolean | null } | null }, fields: Array<{ __typename?: 'InkDataV1StreamSchemaField', name: string, type: InkDataV1StreamSchemaFieldTypeEnum }> } } };

export type DatasetCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  fields: Array<InkDataV1DatasetCreateRequestFieldSpecInput> | InkDataV1DatasetCreateRequestFieldSpecInput;
  storageType: Scalars['String']['input'];
}>;


export type DatasetCreateMutation = { __typename?: 'Mutation', datasetCreate: { __typename?: 'InkDataV1DatasetCreateResponse', dataset: { __typename?: 'InkDataV1Dataset', id: string, name: string } } };

export type ModelsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelsListQuery = { __typename?: 'Query', models: { __typename?: 'InkDataV1ModelListResponse', models: Array<{ __typename?: 'InkDataV1Model', id: string, key: string, name: string, description: string, fields: Array<{ __typename?: 'InkDataV1ModelField', id: number, name: string, displayName: string, description: string, primaryKey: boolean, type: InkDataV1ModelFieldTypeEnum }> }> } };

export type DatasetCreateFromModelMutationVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type DatasetCreateFromModelMutation = { __typename?: 'Mutation', datasetCreateFromModel: { __typename?: 'InkDataV1DatasetModelCreateResponse', dataset: { __typename?: 'InkDataV1Dataset', id: string, name: string } } };

export type DatasetDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DatasetDeleteMutation = { __typename?: 'Mutation', datasetDelete: { __typename?: 'DatasetDeleteSuccess', success: boolean } };

export type DatasetSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type DatasetSourcesQuery = { __typename?: 'Query', jobs: { __typename?: 'InkDataV1JobListResponse', jobs: Array<{ __typename?: 'InkDataV1Job', id: string, name: string, status: InkDataV1JobStatusEnum, metrics: { __typename?: 'InkDataV1JobMetrics', lastRunAt?: string | null }, schedule?: { __typename?: 'InkDataV1JobSchedule', minutely?: { __typename?: 'InkDataV1JobScheduleMinutely', interval: number } | null, hourly?: { __typename?: 'InkDataV1JobScheduleHourly', minute: number } | null, daily?: { __typename?: 'InkDataV1JobScheduleDaily', hour: number, timezone: string } | null } | null, spec: { __typename?: 'InkDataV1JobSpec', dataImport?: { __typename?: 'InkDataV1JobSpecImport', destination: { __typename?: 'InkDataV1JobSpecImportDestination', dataset: { __typename?: 'InkDataV1JobSpecImportDestinationDataset', id: string } } } | null } }> } };

export type DataJobRunCacheItemListQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  jobRunId: Scalars['ID']['input'];
}>;


export type DataJobRunCacheItemListQuery = { __typename?: 'Query', dataJobRunCacheItemList: { __typename?: 'InkDavinciDataV1StreamCacheItemListResponse', cacheItems: Array<{ __typename?: 'InkDavinciDataV1StreamCacheItemListResponseCacheItem', exists: boolean, uri: string }> } };

export type DataJobRunsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type DataJobRunsQuery = { __typename?: 'Query', dataJobRuns: { __typename?: 'InkDavinciDataV2JobRunListResponse', jobRuns: Array<{ __typename?: 'InkDavinciDataV2JobRun', id: string, lastRunAt?: string | null, lastErrorAt?: string | null, status: InkDavinciDataV2JobRunStatusEnum, metrics: { __typename?: 'InkDavinciDataV2JobRunMetrics', totalRecords: number, validRecords: number, runDuration: number, downloadDuration: number } }> } };

export type DataJobRunCancelMutationVariables = Exact<{
  jobRunId: Scalars['ID']['input'];
}>;


export type DataJobRunCancelMutation = { __typename?: 'Mutation', dataJobRunCancel: { __typename?: 'InkDavinciDataV2JobRunCancelResponse', jobRun: { __typename?: 'InkDavinciDataV2JobRun', id: string, status: InkDavinciDataV2JobRunStatusEnum, canceledAt?: string | null } } };

export type DataJobRunResumeMutationVariables = Exact<{
  jobRunId: Scalars['ID']['input'];
}>;


export type DataJobRunResumeMutation = { __typename?: 'Mutation', dataJobRunResume: { __typename?: 'InkDavinciDataV2JobRunResumeResponse', jobRun: { __typename?: 'InkDavinciDataV2JobRun', id: string, status: InkDavinciDataV2JobRunStatusEnum, canceledAt?: string | null, updatedAt: string } } };

export type DataJobsFetchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataJobsFetchQuery = { __typename?: 'Query', dataJobsFetch: { __typename?: 'InkDavinciDataV2JobFetchResponse', job: { __typename?: 'InkDavinciDataV2Job', id: string, name: string, createdAt: string, type: InkDavinciDataV2JobTypeEnum, archived: boolean, status: InkDavinciDataV2JobStatusEnum, schedule?: { __typename?: 'InkDavinciDataV2JobSchedule', daily?: { __typename?: 'InkDavinciDataV2JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDavinciDataV2JobScheduleHourly', minute: number } | null } | null, metrics: { __typename?: 'InkDavinciDataV2JobMetrics', totalRuns: number, lastRunAt?: string | null, lastRunRecords: number, avgRunDuration: number, totalRunErrors: number }, config: { __typename?: 'InkDavinciDataV2JobConfig', importJob?: { __typename?: 'InkDavinciDataV2JobConfigImportJob', query?: any | null, tableId: string, type: InkDavinciDataV2JobConfigImportJobTypeEnum, columns: Array<{ __typename?: 'InkDavinciDataV2JobConfigImportJobColumn', fieldId?: string | null, name: string }>, resource: { __typename?: 'InkDavinciDataV2JobResource', compression: InkDavinciDataV2JobResourceCompressionEnum, connectionId: string, uri: string, format: { __typename?: 'InkDavinciDataV2JobResourceFormat', csv?: { __typename?: 'InkDavinciDataV2JobResourceFormatCSV', delimiter: string, header: boolean, null: string } | null } } } | null, taggingJob?: { __typename?: 'InkDavinciDataV2JobConfigTaggingJob', tableId: string, type: InkDavinciDataV2JobConfigTaggingJobTypeEnum, tags: Array<{ __typename?: 'InkDavinciDataV2JobConfigTaggingJobTag', id: string }>, columns: Array<{ __typename?: 'InkDavinciDataV2JobConfigTaggingJobColumn', fieldId?: string | null, name: string, isTag: boolean }>, resource: { __typename?: 'InkDavinciDataV2JobResource', compression: InkDavinciDataV2JobResourceCompressionEnum, connectionId: string, uri: string, format: { __typename?: 'InkDavinciDataV2JobResourceFormat', csv?: { __typename?: 'InkDavinciDataV2JobResourceFormatCSV', delimiter: string, header: boolean, null: string } | null } } } | null } } } };

export type DataTablesColumnMappingQueryVariables = Exact<{ [key: string]: never; }>;


export type DataTablesColumnMappingQuery = { __typename?: 'Query', dataTables: Array<{ __typename?: 'DataTable', id: string, name: string }> };

export type DataFieldsColumnMappingQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type DataFieldsColumnMappingQuery = { __typename?: 'Query', dataFields: Array<{ __typename?: 'DataField', id: string, name: string, displayName: string, primaryKey: boolean }> };

export type DataJobCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  config: DataJobConfig;
  schedule?: InputMaybe<DataJobScheduleInput>;
}>;


export type DataJobCreateMutation = { __typename?: 'Mutation', dataJobCreate: { __typename?: 'InkDavinciDataV2JobCreateResponse', job: { __typename?: 'InkDavinciDataV2Job', name: string, id: string, status: InkDavinciDataV2JobStatusEnum, type: InkDavinciDataV2JobTypeEnum, archived: boolean, schedule?: { __typename?: 'InkDavinciDataV2JobSchedule', daily?: { __typename?: 'InkDavinciDataV2JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDavinciDataV2JobScheduleHourly', minute: number } | null } | null, metrics: { __typename?: 'InkDavinciDataV2JobMetrics', lastRunAt?: string | null, totalRuns: number }, config: { __typename?: 'InkDavinciDataV2JobConfig', importJob?: { __typename?: 'InkDavinciDataV2JobConfigImportJob', tableId: string, type: InkDavinciDataV2JobConfigImportJobTypeEnum, columns: Array<{ __typename?: 'InkDavinciDataV2JobConfigImportJobColumn', fieldId?: string | null, name: string }>, resource: { __typename?: 'InkDavinciDataV2JobResource', compression: InkDavinciDataV2JobResourceCompressionEnum, connectionId: string, uri: string, format: { __typename?: 'InkDavinciDataV2JobResourceFormat', csv?: { __typename?: 'InkDavinciDataV2JobResourceFormatCSV', delimiter: string, header: boolean, null: string } | null } } } | null, taggingJob?: { __typename?: 'InkDavinciDataV2JobConfigTaggingJob', tableId: string } | null } } } };

export type JobCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  spec: InkDataV1JobSpecInput;
  description?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<InkDataV1JobScheduleInput>;
}>;


export type JobCreateMutation = { __typename?: 'Mutation', jobCreate: { __typename?: 'InkDataV1JobCreateResponse', job: { __typename?: 'InkDataV1Job', id: string, name: string, description?: string | null, createdAt: string, archived: boolean, status: InkDataV1JobStatusEnum, schedule?: { __typename?: 'InkDataV1JobSchedule', daily?: { __typename?: 'InkDataV1JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDataV1JobScheduleHourly', minute: number } | null, minutely?: { __typename?: 'InkDataV1JobScheduleMinutely', interval: number } | null } | null, metrics: { __typename?: 'InkDataV1JobMetrics', totalRuns: number, lastRunAt?: string | null, totalRunFailures: number, lastRunFailureAt?: string | null }, spec: { __typename?: 'InkDataV1JobSpec', eventExport?: { __typename?: 'InkDataV1JobSpecEventExport', eventType: InkDataV1JobSpecEventExportTypeEnum } | null } } } };

export type GetCustomEventCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomEventCategoriesQuery = { __typename?: 'Query', customEventCategories?: Array<{ __typename?: 'CustomEventCategoryType', id: string, name: string, attributionType: AttributionType, hasSubidentifier: boolean, timestampType: TimestampType, contactIdentifierField?: { __typename?: 'DataField', id: string, displayName: string } | null, table?: { __typename?: 'DataTable', id: string, name: string } | null } | null> | null };

export type CreateCustomEventImportJobMutationVariables = Exact<{
  customEventCategoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  jobDescription: Scalars['String']['input'];
  schedule?: InputMaybe<DataJobScheduleInput>;
  resource: DataJobResource;
  columns: Array<DataImportJobColumnInput> | DataImportJobColumnInput;
  query?: InputMaybe<Scalars['DataQuery']['input']>;
}>;


export type CreateCustomEventImportJobMutation = { __typename?: 'Mutation', customEventImportJobCreateV2: { __typename?: 'CustomEventCategoryImportJobResult', importJob: { __typename?: 'CustomEventImportJobType', id: string, name: string, description?: string | null, customEventCategoryId: string } } };

export type GetEventExportContactFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventExportContactFieldsQuery = { __typename?: 'Query', contactTableDataFields: Array<{ __typename?: 'DataField', id: string, name: string, displayName: string, primaryKey: boolean, channelsV2: Array<Channel>, semanticFeature?: { __typename?: 'SemanticFeature', name: string } | null }> };

export type JobsListV1FragmentFragment = { __typename?: 'InkDataV1Job', id: string, name: string, description?: string | null, createdAt: string, archived: boolean, status: InkDataV1JobStatusEnum, schedule?: { __typename?: 'InkDataV1JobSchedule', daily?: { __typename?: 'InkDataV1JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDataV1JobScheduleHourly', minute: number } | null, minutely?: { __typename?: 'InkDataV1JobScheduleMinutely', interval: number } | null } | null, metrics: { __typename?: 'InkDataV1JobMetrics', totalRuns: number, lastRunAt?: string | null, totalRunFailures: number, lastRunFailureAt?: string | null }, spec: { __typename?: 'InkDataV1JobSpec', eventExport?: { __typename?: 'InkDataV1JobSpecEventExport', eventType: InkDataV1JobSpecEventExportTypeEnum } | null } };

export type JobsListQueryVariables = Exact<{
  spec: JobSpecKind;
}>;


export type JobsListQuery = { __typename?: 'Query', jobs: { __typename?: 'InkDataV1JobListResponse', jobs: Array<{ __typename?: 'InkDataV1Job', id: string, name: string, description?: string | null, createdAt: string, archived: boolean, status: InkDataV1JobStatusEnum, schedule?: { __typename?: 'InkDataV1JobSchedule', daily?: { __typename?: 'InkDataV1JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDataV1JobScheduleHourly', minute: number } | null, minutely?: { __typename?: 'InkDataV1JobScheduleMinutely', interval: number } | null } | null, metrics: { __typename?: 'InkDataV1JobMetrics', totalRuns: number, lastRunAt?: string | null, totalRunFailures: number, lastRunFailureAt?: string | null }, spec: { __typename?: 'InkDataV1JobSpec', eventExport?: { __typename?: 'InkDataV1JobSpecEventExport', eventType: InkDataV1JobSpecEventExportTypeEnum } | null } }> } };

export type JobFetchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobFetchQuery = { __typename?: 'Query', job: { __typename?: 'InkDataV1JobFetchResponse', job: { __typename?: 'InkDataV1Job', id: string, name: string, description?: string | null, createdAt: string, status: InkDataV1JobStatusEnum, schedule?: { __typename?: 'InkDataV1JobSchedule', daily?: { __typename?: 'InkDataV1JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDataV1JobScheduleHourly', minute: number } | null, minutely?: { __typename?: 'InkDataV1JobScheduleMinutely', interval: number } | null } | null, metrics: { __typename?: 'InkDataV1JobMetrics', totalRuns: number, lastRunAt?: string | null, totalRunFailures: number, lastRunFailureAt?: string | null }, spec: { __typename?: 'InkDataV1JobSpec', eventExport?: { __typename?: 'InkDataV1JobSpecEventExport', eventType: InkDataV1JobSpecEventExportTypeEnum, columns: Array<InkDataV1JobSpecEventExportColumnEnum>, dataConnectionIds: Array<string>, maxRecordsPerFile?: number | null, contactDataTableConfig?: { __typename?: 'InkDataV1JobSpecEventExportContactDataTableConfig', dedupeByContactId: boolean, fields: Array<string> } | null, format: { __typename?: 'InkDataV1JobSpecEventExportFormat', csv?: { __typename?: 'InkDataV1JobSpecEventExportFormatCSV', compression: InkDataV1JobSpecEventExportFormatCsvCompressionEnum, delimiter: InkDataV1JobSpecEventExportFormatCsvDelimiterEnum, arrayFormat: InkDataV1JobSpecEventExportFormatCsvArrayFormatEnum, emptyValueFormat: InkDataV1JobSpecEventExportFormatCsvEmptyValueEnum, customEmptyValue?: string | null, flattenSeparator: InkDataV1JobSpecEventExportFormatCsvSeparatorEnum, quoteCharacter: InkDataV1JobSpecEventExportFormatCsvQuoteCharacterEnum, quotingStrategy: InkDataV1JobSpecEventExportFormatCsvQuotingStrategyEnum } | null, parquet?: { __typename?: 'InkDataV1JobSpecEventExportFormatParquet', compression: InkDataV1JobSpecEventExportFormatParquetCompressionEnum } | null } } | null } } } };

export type JobRunsListQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type JobRunsListQuery = { __typename?: 'Query', jobRuns: { __typename?: 'InkDataV1JobRunListResponse', jobRuns: Array<{ __typename?: 'InkDataV1JobRun', id: string, jobId: string, status: InkDataV1JobRunStatusEnum, lastRunAt?: string | null, completedAt?: string | null, createdAt: string, metrics: { __typename?: 'InkDataV1JobRunMetrics', runDuration: number } }> } };

export type JobPauseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobPauseMutation = { __typename?: 'Mutation', jobPause: { __typename?: 'InkDataV1JobPauseResponse', job: { __typename?: 'InkDataV1Job', id: string, status: InkDataV1JobStatusEnum } } };

export type JobResumeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobResumeMutation = { __typename?: 'Mutation', jobResume: { __typename?: 'InkDataV1JobResumeResponse', job: { __typename?: 'InkDataV1Job', id: string, status: InkDataV1JobStatusEnum } } };

export type JobDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobDeleteMutation = { __typename?: 'Mutation', jobDelete: { __typename?: 'JobDeleteSuccess', id: string, success: boolean } };

export type ConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsQuery = { __typename?: 'Query', connections: { __typename?: 'InkDataV1ConnectionListResponse', connections: Array<{ __typename?: 'InkDataV1Connection', id: string, name: string, status: InkDataV1ConnectionStatusEnum }> } };

export type DataJobsListFragmentFragment = { __typename?: 'InkDavinciDataV2Job', name: string, id: string, status: InkDavinciDataV2JobStatusEnum, type: InkDavinciDataV2JobTypeEnum, archived: boolean, schedule?: { __typename?: 'InkDavinciDataV2JobSchedule', daily?: { __typename?: 'InkDavinciDataV2JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDavinciDataV2JobScheduleHourly', minute: number } | null } | null, metrics: { __typename?: 'InkDavinciDataV2JobMetrics', lastRunAt?: string | null, totalRuns: number }, config: { __typename?: 'InkDavinciDataV2JobConfig', importJob?: { __typename?: 'InkDavinciDataV2JobConfigImportJob', tableId: string, type: InkDavinciDataV2JobConfigImportJobTypeEnum, columns: Array<{ __typename?: 'InkDavinciDataV2JobConfigImportJobColumn', fieldId?: string | null, name: string }>, resource: { __typename?: 'InkDavinciDataV2JobResource', compression: InkDavinciDataV2JobResourceCompressionEnum, connectionId: string, uri: string, format: { __typename?: 'InkDavinciDataV2JobResourceFormat', csv?: { __typename?: 'InkDavinciDataV2JobResourceFormatCSV', delimiter: string, header: boolean, null: string } | null } } } | null, taggingJob?: { __typename?: 'InkDavinciDataV2JobConfigTaggingJob', tableId: string } | null } };

export type DataJobsListQueryVariables = Exact<{ [key: string]: never; }>;


export type DataJobsListQuery = { __typename?: 'Query', dataJobsList: { __typename?: 'InkDavinciDataV2JobListResponse', jobs: Array<{ __typename?: 'InkDavinciDataV2Job', name: string, id: string, status: InkDavinciDataV2JobStatusEnum, type: InkDavinciDataV2JobTypeEnum, archived: boolean, schedule?: { __typename?: 'InkDavinciDataV2JobSchedule', daily?: { __typename?: 'InkDavinciDataV2JobScheduleDaily', hour: number, timezone: string } | null, hourly?: { __typename?: 'InkDavinciDataV2JobScheduleHourly', minute: number } | null } | null, metrics: { __typename?: 'InkDavinciDataV2JobMetrics', lastRunAt?: string | null, totalRuns: number }, config: { __typename?: 'InkDavinciDataV2JobConfig', importJob?: { __typename?: 'InkDavinciDataV2JobConfigImportJob', tableId: string, type: InkDavinciDataV2JobConfigImportJobTypeEnum, columns: Array<{ __typename?: 'InkDavinciDataV2JobConfigImportJobColumn', fieldId?: string | null, name: string }>, resource: { __typename?: 'InkDavinciDataV2JobResource', compression: InkDavinciDataV2JobResourceCompressionEnum, connectionId: string, uri: string, format: { __typename?: 'InkDavinciDataV2JobResourceFormat', csv?: { __typename?: 'InkDavinciDataV2JobResourceFormatCSV', delimiter: string, header: boolean, null: string } | null } } } | null, taggingJob?: { __typename?: 'InkDavinciDataV2JobConfigTaggingJob', tableId: string } | null } }> } };

export type JobsTablesListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsTablesListQuery = { __typename?: 'Query', dataTables: Array<{ __typename?: 'DataTable', id: string, name: string }> };

export type DataJobArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataJobArchiveMutation = { __typename?: 'Mutation', dataJobArchive: { __typename?: 'InkDavinciDataV2JobArchiveResponse', job: { __typename?: 'InkDavinciDataV2Job', id: string, status: InkDavinciDataV2JobStatusEnum, archived: boolean } } };

export type DataJobPauseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataJobPauseMutation = { __typename?: 'Mutation', dataJobPause: { __typename?: 'InkDavinciDataV2JobPauseResponse', job: { __typename?: 'InkDavinciDataV2Job', id: string, status: InkDavinciDataV2JobStatusEnum } } };

export type DataJobResumeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataJobResumeMutation = { __typename?: 'Mutation', dataJobResume: { __typename?: 'InkDavinciDataV2JobResumeResponse', job: { __typename?: 'InkDavinciDataV2Job', id: string, status: InkDavinciDataV2JobStatusEnum } } };

export type DataJobDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataJobDeleteMutation = { __typename?: 'Mutation', dataJobDelete: { __typename?: 'DataJobDeleteSuccess', id: string } };

export type DataConnectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataConnectionQuery = { __typename?: 'Query', dataConnection: { __typename?: 'DataConnection', name: string } };

export type DataConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataConnectionsQuery = { __typename?: 'Query', dataConnections: Array<{ __typename?: 'DataConnection', id: string, name: string, status?: DataConnectionStatus | null }> };

export type DataConnectionStreamsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataConnectionStreamsQuery = { __typename?: 'Query', dataConnectionStreams: { __typename?: 'DataConnectionStreams', streams: Array<{ __typename?: 'DataConnectionStream', uri: string, modifiedAt: string, stream: { __typename?: 'DataConnectionGCSObject', name: string, size: number } | { __typename?: 'DataConnectionS3Object', name: string, size: number } | { __typename?: 'DataConnectionSFTPFile', path: string, size: number } }> } };

export type DataConnectionStreamSchemaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  streamUri: Scalars['String']['input'];
}>;


export type DataConnectionStreamSchemaQuery = { __typename?: 'Query', dataConnectionStreamSchema: { __typename?: 'DataConnectionStreamSchema', schema: { __typename?: 'DataConnectionSchema', uri: string, compression: DataConnectionSchemaCompression, columns: Array<{ __typename?: 'DataConnectionSchemaColumn', name: string, type?: DataConnectionSchemaColumType | null, values: Array<string> }>, format: { __typename?: 'DataConnectionSchemaFormatCSV', delimiter: string, header: boolean, null: string } } } };

export type PlatformLinksFieldsFragment = { __typename?: 'PushNotification', platformLinks: Array<{ __typename?: 'PushNotificationPlatformLink', id: string, platform: MobilePlatformEnum, behavior: LinkBehaviorEnum, link: { __typename?: 'Link2', id: string, url: string, queryStringParameters: Array<Array<string>>, enableTracking: boolean, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } }> };

export type GetCreativeContentQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeContentQuery = { __typename?: 'Query', creative: { __typename?: 'Creative', id: string, contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, languageCode: any, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null, platformLinks: Array<{ __typename?: 'PushNotificationPlatformLink', id: string, platform: MobilePlatformEnum, behavior: LinkBehaviorEnum, link: { __typename?: 'Link2', id: string, url: string, queryStringParameters: Array<Array<string>>, enableTracking: boolean, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } }> } | { __typename?: 'TextMessage', body: string, shortenLinks: boolean, id: string, channel: Channel, languageCode: any, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> } };

export type SavePushNotificationMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  input: PushNotificationInput;
}>;


export type SavePushNotificationMutation = { __typename?: 'Mutation', pushNotificationSave: { __typename?: 'PushNotificationSuccess', success: boolean, pushNotification: { __typename?: 'PushNotification', id: string, title?: string | null, body: string, media?: { __typename?: 'ExternalMedia', uri: string } | { __typename?: 'ManagedMedia', uri: string } | null, platformLinks: Array<{ __typename?: 'PushNotificationPlatformLink', id: string, platform: MobilePlatformEnum, behavior: LinkBehaviorEnum, link: { __typename?: 'Link2', id: string, url: string, queryStringParameters: Array<Array<string>>, enableTracking: boolean, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } }> } } };

export type DeletePushNotificationMutationVariables = Exact<{
  pushNotificationId: Scalars['ID']['input'];
}>;


export type DeletePushNotificationMutation = { __typename?: 'Mutation', pushNotificationDelete: { __typename?: 'Ok', success: boolean } };

export type SaveTextMessageMutationVariables = Exact<{
  creativeId: Scalars['ID']['input'];
  channel: Scalars['String']['input'];
  input: TextMessageInput;
}>;


export type SaveTextMessageMutation = { __typename?: 'Mutation', textMessageSave: { __typename?: 'TextMessageSuccess', success: boolean, textMessage: { __typename?: 'TextMessage', id: string, body: string, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } } };

export type DeleteTextMessageMutationVariables = Exact<{
  textMessageId: Scalars['ID']['input'];
}>;


export type DeleteTextMessageMutation = { __typename?: 'Mutation', textMessageDelete: { __typename?: 'Ok', success: boolean } };

export type AlertRuleFieldsFragment = { __typename?: 'AlertRuleWithSubscriptionsType', hashid: string, title: string, sourceId: string, entityId?: string | null, isEnabled: boolean, version: number, createdAt: string, updatedAt: string, criteria: Array<{ __typename?: 'AlertCriterionType', metricId: string, operator: string, threshold: string }>, eligibility: Array<{ __typename?: 'AlertEligibilityType', id: string, config: any }>, userSubscriptions: Array<{ __typename?: 'AlertSubscriptionType', channel: string, isActive: boolean }> };

export type NotificationsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsSettingsQuery = { __typename?: 'Query', notificationsSettings?: Array<{ __typename?: 'NotificationsSetting', category: string, emailEnabled: boolean, event: string, inAppEnabled?: boolean | null, timingPreference?: { __typename?: 'NotificationTimingPreference', hoursBefore?: number | null, daysBefore?: number | null, absoluteTime?: any | null, excludeWeekends: boolean } | null }> | null };

export type UpdateNotificationsSettingMutationVariables = Exact<{
  category: Scalars['String']['input'];
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  event: Scalars['String']['input'];
  timingPreference?: InputMaybe<NotificationTimingPreferenceInput>;
}>;


export type UpdateNotificationsSettingMutation = { __typename?: 'Mutation', updateNotificationsSetting: { __typename?: 'UpdateNotificationsSetting', setting: { __typename?: 'NotificationsSetting', category: string, emailEnabled: boolean, inAppEnabled?: boolean | null, event: string, timingPreference?: { __typename?: 'NotificationTimingPreference', hoursBefore?: number | null, daysBefore?: number | null, absoluteTime?: any | null, excludeWeekends: boolean } | null } } };

export type KnockTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type KnockTokenMutation = { __typename?: 'Mutation', knockToken: { __typename?: 'KnockTokenResult', token: string } };

export type CampaignAlertConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignAlertConfigQuery = { __typename?: 'Query', campaignAlertConfig: { __typename?: 'DataSourceConfigType', sourceId: string, label: string, operators: Array<{ __typename?: 'OperatorDefType', id: string, label: string, applicableCategories: Array<string> }>, eligibilityPredicates: Array<{ __typename?: 'EligibilityPredicateDefType', id: string, label: string, config: any }>, valueTypeByCategory: Array<{ __typename?: 'ValueTypeByCategoryEntry', category: string, valueType: string, min: number, max?: number | null }>, availableMetrics: Array<{ __typename?: 'MetricDefType', id: string, name: string, category: string, customEventCategory?: string | null, group?: string | null, positivelyCorrelated: boolean, displayByDefault: boolean }> } };

export type AlertRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type AlertRulesQuery = { __typename?: 'Query', alertRulesWithSubscriptions: Array<{ __typename?: 'AlertRuleWithSubscriptionsType', hashid: string, title: string, sourceId: string, entityId?: string | null, isEnabled: boolean, version: number, createdAt: string, updatedAt: string, criteria: Array<{ __typename?: 'AlertCriterionType', metricId: string, operator: string, threshold: string }>, eligibility: Array<{ __typename?: 'AlertEligibilityType', id: string, config: any }>, userSubscriptions: Array<{ __typename?: 'AlertSubscriptionType', channel: string, isActive: boolean }> }> };

export type CreateAlertRuleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
  criteria: Array<AlertCriterionInput> | AlertCriterionInput;
  eligibility: Array<AlertEligibilityInput> | AlertEligibilityInput;
}>;


export type CreateAlertRuleMutation = { __typename?: 'Mutation', alertRuleCreate: { __typename?: 'AlertRuleCreateSuccess', rule: { __typename?: 'AlertRuleType', hashid: string, title: string, entityId?: string | null } } };

export type UpdateAlertRuleMutationVariables = Exact<{
  ruleHashid: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<Array<AlertCriterionInput> | AlertCriterionInput>;
  eligibility?: InputMaybe<Array<AlertEligibilityInput> | AlertEligibilityInput>;
}>;


export type UpdateAlertRuleMutation = { __typename?: 'Mutation', alertRuleModify: { __typename?: 'AlertRuleModifySuccess', rule: { __typename?: 'AlertRuleType', hashid: string, title: string, entityId?: string | null } } };

export type DeleteAlertRuleMutationVariables = Exact<{
  ruleHashid: Scalars['String']['input'];
}>;


export type DeleteAlertRuleMutation = { __typename?: 'Mutation', alertRuleDelete: { __typename?: 'AlertRuleDeleteSuccess', success: boolean } };

export type SubscribeAlertRuleMutationVariables = Exact<{
  ruleHashid: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type SubscribeAlertRuleMutation = { __typename?: 'Mutation', alertRuleSubscribe: { __typename?: 'AlertRuleSubscribeSuccess', success: boolean } };

export type UnsubscribeAlertRuleMutationVariables = Exact<{
  ruleHashid: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type UnsubscribeAlertRuleMutation = { __typename?: 'Mutation', alertRuleUnsubscribe: { __typename?: 'AlertRuleUnsubscribeSuccess', success: boolean } };

export type JobsAlertPickerListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsAlertPickerListQuery = { __typename?: 'Query', jobsAlertPickerList: Array<{ __typename?: 'JobAlertPickerEntryType', id: string, name: string }> };

export type ProgramAudienceIncludeMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  selected: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  unselected: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProgramAudienceIncludeMutation = { __typename?: 'Mutation', programAudienceInclude: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramAudienceExcludeMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type ProgramAudienceExcludeMutation = { __typename?: 'Mutation', programAudienceExclude: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramAudienceRemoveMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type ProgramAudienceRemoveMutation = { __typename?: 'Mutation', programAudienceRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramAudienceReorderMutationVariables = Exact<{
  audienceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type ProgramAudienceReorderMutation = { __typename?: 'Mutation', programAudienceReorder: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramFieldAddMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
}>;


export type ProgramFieldAddMutation = { __typename?: 'Mutation', programFieldAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramFieldRemoveMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
}>;


export type ProgramFieldRemoveMutation = { __typename?: 'Mutation', programFieldRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramFieldUpdateMutationVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
}>;


export type ProgramFieldUpdateMutation = { __typename?: 'Mutation', programFieldUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramExperience2FieldsFragment = { __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, excludedTags: Array<{ __typename?: 'Tag', id: string, name: string } | null>, includedTags: Array<{ __typename?: 'Tag', id: string, name: string } | null>, excludedCreatives: { __typename?: 'CreativeConnection', edges: Array<{ __typename?: 'CreativeEdge', cursor: string, node: { __typename?: 'Creative', id: string, title: string } } | null> }, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, page: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, inclusion: CreativeInclusion, availability2: Array<CreativeAvailability>, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } }> } };

export type ProgramContentQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type ProgramContentQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, type: ContentBlockType, numPositions: number }, experiences2: Array<{ __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, excludedTags: Array<{ __typename?: 'Tag', id: string, name: string } | null>, includedTags: Array<{ __typename?: 'Tag', id: string, name: string } | null>, excludedCreatives: { __typename?: 'CreativeConnection', edges: Array<{ __typename?: 'CreativeEdge', cursor: string, node: { __typename?: 'Creative', id: string, title: string } } | null> }, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, page: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, inclusion: CreativeInclusion, availability2: Array<CreativeAvailability>, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } }> } }> }> }> } } };

export type Experience2UpdateMutationVariables = Exact<{
  excludedCreativeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  excludedTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  includedTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  title: Scalars['String']['input'];
  visibility: Experience2Visibility;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  selectOnly?: InputMaybe<Experiences2CreativeFilter>;
}>;


export type Experience2UpdateMutation = { __typename?: 'Mutation', experience2Update: { __typename?: 'Experience2Success', success: boolean, experience2: { __typename?: 'Experience2', id: string, title: string, autoInclude: Experience2AutoInclude, visibility: Experience2Visibility, excludedTags: Array<{ __typename?: 'Tag', id: string, name: string } | null>, includedTags: Array<{ __typename?: 'Tag', id: string, name: string } | null>, excludedCreatives: { __typename?: 'CreativeConnection', edges: Array<{ __typename?: 'CreativeEdge', cursor: string, node: { __typename?: 'Creative', id: string, title: string } } | null> }, includedCreatives: { __typename?: 'Experiences2PaginatedAvailableCreatives', available: number, availableDraft: number, inUse: number, included: number, includedApproved: number, incomplete: number, page: number, prohibited: number, total: number, results: Array<{ __typename?: 'AvailableCreative', id: string, inclusion: CreativeInclusion, availability2: Array<CreativeAvailability>, incomplete: Array<CreativeIncompleteReason>, thumbnail: { __typename?: 'Thumbnail', url: string }, creative: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } }> } } } };

export type TagsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type UberTemplateFieldsFragment = { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> };

export type ProgramTemplateQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramTemplateQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } };

export type ProgramTemplateAddMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProgramTemplateAddMutation = { __typename?: 'Mutation', programTemplateAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } } };

export type ProgramUberTemplateVariationRemoveMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  variationId: Scalars['ID']['input'];
}>;


export type ProgramUberTemplateVariationRemoveMutation = { __typename?: 'Mutation', programUberTemplateVariationRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } } };

export type UberTemplateVariationContentblockRemoveMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  contentBlockId: Scalars['ID']['input'];
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UberTemplateVariationContentblockRemoveMutation = { __typename?: 'Mutation', uberTemplateVariationContentblockRemove: { __typename?: 'NeedsConfirmation', success: boolean } | { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } } };

export type UberTemplateVariationContentblockAddMutationVariables = Exact<{
  contentBlockId: Scalars['ID']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  programId: Scalars['ID']['input'];
  variationId: Scalars['ID']['input'];
}>;


export type UberTemplateVariationContentblockAddMutation = { __typename?: 'Mutation', uberTemplateVariationContentblockAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } } };

export type UberTemplateVariationContentblockPriorityUpdateMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  contentBlockIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  variationId: Scalars['ID']['input'];
}>;


export type UberTemplateVariationContentblockPriorityUpdateMutation = { __typename?: 'Mutation', uberTemplateVariationContentblockPriorityUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } } };

export type UberTemplateVariationPrimaryContentblockUpdateMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  contentBlockId: Scalars['ID']['input'];
}>;


export type UberTemplateVariationPrimaryContentblockUpdateMutation = { __typename?: 'Mutation', uberTemplateVariationPrimaryContentblockUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType }, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string, blueprint: { __typename?: 'Template', id: string }, contentBlocks: Array<{ __typename?: 'UberTemplateContentBlock', id: string, isPrimary: boolean, position: number, contentBlock: { __typename?: 'ContentBlock', id: string, title: string, description?: string | null, type: ContentBlockType, numPositions: number } }> }> } } } };

type EmailServiceProviderFields_AcousticCampaign_Fragment = { __typename: 'AcousticCampaign', id: string };

type EmailServiceProviderFields_AdobeCampaign_Fragment = { __typename: 'AdobeCampaign', id: string };

type EmailServiceProviderFields_AdobeJourneyOptimizer_Fragment = { __typename: 'AdobeJourneyOptimizer', id: string };

type EmailServiceProviderFields_AmazonSes_Fragment = { __typename: 'AmazonSES', id: string };

type EmailServiceProviderFields_Blackhole_Fragment = { __typename: 'Blackhole', id: string };

type EmailServiceProviderFields_Bluecore_Fragment = { __typename: 'Bluecore', id: string };

type EmailServiceProviderFields_Braze_Fragment = { __typename: 'Braze', id: string };

type EmailServiceProviderFields_Cordial_Fragment = { __typename: 'Cordial', id: string };

type EmailServiceProviderFields_Epsilon_Fragment = { __typename: 'Epsilon', id: string };

type EmailServiceProviderFields_OracleResponsys_Fragment = { __typename: 'OracleResponsys', id: string };

type EmailServiceProviderFields_SfNext_Fragment = { __typename: 'SFNext', id: string };

type EmailServiceProviderFields_SalesForceMarketingCloud_Fragment = { __typename: 'SalesForceMarketingCloud', id: string };

type EmailServiceProviderFields_Zeta_Fragment = { __typename: 'Zeta', id: string };

export type EmailServiceProviderFieldsFragment = EmailServiceProviderFields_AcousticCampaign_Fragment | EmailServiceProviderFields_AdobeCampaign_Fragment | EmailServiceProviderFields_AdobeJourneyOptimizer_Fragment | EmailServiceProviderFields_AmazonSes_Fragment | EmailServiceProviderFields_Blackhole_Fragment | EmailServiceProviderFields_Bluecore_Fragment | EmailServiceProviderFields_Braze_Fragment | EmailServiceProviderFields_Cordial_Fragment | EmailServiceProviderFields_Epsilon_Fragment | EmailServiceProviderFields_OracleResponsys_Fragment | EmailServiceProviderFields_SfNext_Fragment | EmailServiceProviderFields_SalesForceMarketingCloud_Fragment | EmailServiceProviderFields_Zeta_Fragment;

export type ProgramStateInfoFieldsFragment = { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null };

type TrackingParametersFields_CheckboxAttribute_Fragment = { __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } };

type TrackingParametersFields_DateAttribute_Fragment = { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type TrackingParametersFields_DateTimeAttribute_Fragment = { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type TrackingParametersFields_FormatStringAttribute_Fragment = { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type TrackingParametersFields_ListAttribute_Fragment = { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } };

type TrackingParametersFields_MultiSelectAttribute_Fragment = { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } };

type TrackingParametersFields_MultiSelectAttribute2_Fragment = { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } };

type TrackingParametersFields_NumberAttribute_Fragment = { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } };

type TrackingParametersFields_SelectAttribute_Fragment = { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } };

type TrackingParametersFields_SelectAttribute2_Fragment = { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } };

type TrackingParametersFields_TextAttribute_Fragment = { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } };

export type TrackingParametersFieldsFragment = TrackingParametersFields_CheckboxAttribute_Fragment | TrackingParametersFields_DateAttribute_Fragment | TrackingParametersFields_DateTimeAttribute_Fragment | TrackingParametersFields_FormatStringAttribute_Fragment | TrackingParametersFields_ListAttribute_Fragment | TrackingParametersFields_MultiSelectAttribute_Fragment | TrackingParametersFields_MultiSelectAttribute2_Fragment | TrackingParametersFields_NumberAttribute_Fragment | TrackingParametersFields_SelectAttribute_Fragment | TrackingParametersFields_SelectAttribute2_Fragment | TrackingParametersFields_TextAttribute_Fragment;

type CustomFieldFields_DatetimeCustomField_Fragment = { __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null };

type CustomFieldFields_NumberCustomField_Fragment = { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null };

type CustomFieldFields_TextCustomField_Fragment = { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null };

export type CustomFieldFieldsFragment = CustomFieldFields_DatetimeCustomField_Fragment | CustomFieldFields_NumberCustomField_Fragment | CustomFieldFields_TextCustomField_Fragment;

export type FieldsFieldsFragment = { __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null };

type EspConfigFields_AdobeJourneyOptimizerConfig_Fragment = { __typename?: 'AdobeJourneyOptimizerConfig', id: string };

type EspConfigFields_AmazonSesConfig_Fragment = { __typename?: 'AmazonSESConfig' };

type EspConfigFields_BlackholeConfig_Fragment = { __typename?: 'BlackholeConfig', id: string };

type EspConfigFields_CampaignAcousticCampaignConfig_Fragment = { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } };

type EspConfigFields_CampaignAdobeCampaignConfig_Fragment = { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> };

type EspConfigFields_CampaignCordialConfig_Fragment = { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null };

type EspConfigFields_CampaignEpsilonConfig_Fragment = { __typename?: 'CampaignEpsilonConfig', id: string };

type EspConfigFields_CampaignOracleResponsysConfig_Fragment = { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> };

type EspConfigFields_CampaignSalesforceMarketingCloudConfig_Fragment = { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null };

type EspConfigFields_ZetaConfig_Fragment = { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> };

export type EspConfigFieldsFragment = EspConfigFields_AdobeJourneyOptimizerConfig_Fragment | EspConfigFields_AmazonSesConfig_Fragment | EspConfigFields_BlackholeConfig_Fragment | EspConfigFields_CampaignAcousticCampaignConfig_Fragment | EspConfigFields_CampaignAdobeCampaignConfig_Fragment | EspConfigFields_CampaignCordialConfig_Fragment | EspConfigFields_CampaignEpsilonConfig_Fragment | EspConfigFields_CampaignOracleResponsysConfig_Fragment | EspConfigFields_CampaignSalesforceMarketingCloudConfig_Fragment | EspConfigFields_ZetaConfig_Fragment;

export type ProgramFieldsFragment = { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } };

export type ProgramAvailableCreativeTagsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramAvailableCreativeTagsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, availableCreativeTags: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type ProgramCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ProgramCreateMutation = { __typename?: 'Mutation', programCreate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', code?: string | null, field?: string | null, reason: string }> } };

export type ProgramUpdateMutationVariables = Exact<{
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProgramUpdateMutation = { __typename?: 'Mutation', programUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', code?: string | null, field?: string | null, reason: string }> } };

export type ProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } };

export type ProgramStateQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramStateQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, title: string, isQuiet: boolean, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null } } };

export type ProgramsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProgramFilterInput>;
}>;


export type ProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', counts: { __typename?: 'ProgramCounts', total: number, draft: number, locked: number, active: number, completed: number, suspended: number, archived: number }, edges: Array<{ __typename?: 'ProgramEdge', cursor: string, node: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ProgramsCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramsCountsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', counts: { __typename?: 'ProgramCounts', total: number, draft: number, locked: number, active: number, completed: number, suspended: number, archived: number } } };

export type AvailableCustomFieldsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type AvailableCustomFieldsQuery = { __typename?: 'Query', availableCustomFields: Array<{ __typename?: 'AvailableCustomField', id: string, name: string, title: string, dataType: DataType }> };

export type ProgramStateTransitionMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  state: ProgramStateType;
}>;


export type ProgramStateTransitionMutation = { __typename?: 'Mutation', programStateTransition: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null } } } };

export type ProgramSeedAudienceAddMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type ProgramSeedAudienceAddMutation = { __typename?: 'Mutation', programSeedAudienceAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramSeedAudienceRemoveMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type ProgramSeedAudienceRemoveMutation = { __typename?: 'Mutation', programSeedAudienceRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type QuietHourRuleAddMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
  daysOfWeek: Array<DaysOfWeek> | DaysOfWeek;
}>;


export type QuietHourRuleAddMutation = { __typename?: 'Mutation', quietHourRuleAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type QuietHourRuleUpdateMutationVariables = Exact<{
  daysOfWeek: Array<DaysOfWeek> | DaysOfWeek;
  endTime: Scalars['Time']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
  startTime: Scalars['Time']['input'];
}>;


export type QuietHourRuleUpdateMutation = { __typename?: 'Mutation', quietHourRuleUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type QuietPeriodRuleAddMutationVariables = Exact<{
  endDatetime: Scalars['DateTime']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  startDatetime: Scalars['DateTime']['input'];
}>;


export type QuietPeriodRuleAddMutation = { __typename?: 'Mutation', quietPeriodRuleAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type QuietPeriodRuleUpdateMutationVariables = Exact<{
  endDatetime: Scalars['DateTime']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
  startDatetime: Scalars['DateTime']['input'];
}>;


export type QuietPeriodRuleUpdateMutation = { __typename?: 'Mutation', quietPeriodRuleUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type QuietRuleRemoveMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
}>;


export type QuietRuleRemoveMutation = { __typename?: 'Mutation', quietRuleRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramTagAddMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type ProgramTagAddMutation = { __typename?: 'Mutation', programTagAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramTagRemoveMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type ProgramTagRemoveMutation = { __typename?: 'Mutation', programTagRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramTextTrackingParameterUpdateMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProgramTextTrackingParameterUpdateMutation = { __typename?: 'Mutation', programTextTrackingParameterUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramSelectTrackingParameterUpdateMutationVariables = Exact<{
  optionId?: InputMaybe<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
}>;


export type ProgramSelectTrackingParameterUpdateMutation = { __typename?: 'Mutation', programSelectTrackingParameterUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramCustomFieldRemoveMutationVariables = Exact<{
  customFieldId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type ProgramCustomFieldRemoveMutation = { __typename?: 'Mutation', programCustomFieldRemove: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramCustomFieldAddMutationVariables = Exact<{
  customFieldId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type ProgramCustomFieldAddMutation = { __typename?: 'Mutation', programCustomFieldAdd: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramCustomFieldUpdateMutationVariables = Exact<{
  customFieldId: Scalars['ID']['input'];
  metadata: CustomFieldMetadataInput;
  programId: Scalars['ID']['input'];
}>;


export type ProgramCustomFieldUpdateMutation = { __typename?: 'Mutation', programCustomFieldUpdate: { __typename?: 'ProgramSuccess', success: boolean, program: { __typename?: 'Program', id: string, title: string, description: string, isQuiet: boolean, isArchived: boolean, lastSendTime?: string | null, quietHourRules: Array<{ __typename?: 'QuietHourRule', id: string, name: string, startTime: any, endTime: any, daysOfWeek: Array<DaysOfWeek> }>, quietPeriodRules: Array<{ __typename?: 'QuietPeriodRule', id: string, name: string, endDatetime: string, startDatetime: string }>, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }>, stateInfo: { __typename?: 'ProgramStateInfo', state: ProgramStateType, history?: Array<{ __typename?: 'ProgramStateLog', state: ContentLibraryProgramStateStateChoices, timestamp: string, user: { __typename?: 'User', fullName?: string | null } } | null> | null, transitions: Array<{ __typename?: 'Transition', label: string, state: ProgramStateType, permission: { __typename?: 'TransitionPermissionAllowed', allowed: boolean } | { __typename?: 'TransitionPermissionDenied', allowed: boolean, code: string, message: string } }>, actions?: Array<{ __typename?: 'StateAction', id: string, label: string }> | null }, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig' } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, emailServiceProvider: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole', id: string } | { __typename: 'Bluecore', id: string } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon', id: string } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext', id: string } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename?: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename?: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename?: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, value?: string | null, definition: { __typename?: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', id: string, values: Array<string>, definition: { __typename?: 'ListAttributeDefinition', id: string, title: string, required: boolean, help?: string | null, placeholder?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename?: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename?: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename?: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, definition: { __typename?: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename?: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename?: 'TextAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, multiline: boolean } }>, seedContactAudiences: Array<{ __typename?: 'ContactAudience', id: string, name: string }>, includedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string, name: string, contactAudience: { __typename?: 'ContactAudience', name: string, id: string } } | null }> }>, excludedAudiences: Array<{ __typename?: 'ProgramAudience', id: string, name: string, audience: { __typename?: 'ContactAudience', id: string }, segments: Array<{ __typename?: 'ProgramAudienceSegment', id: string, name: string, selected: boolean }> }>, fields: Array<{ __typename?: 'CampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }>, uberTemplate: { __typename?: 'UberTemplate', id: string, variations: Array<{ __typename?: 'UberTemplateVariation', id: string, title: string }> } } } };

export type ProgramProofVariantListQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  proofVariantFilter: ProofVariantFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sendDate: Scalars['Date']['input'];
}>;


export type ProgramProofVariantListQuery = { __typename?: 'Query', programProofVariantList: { __typename?: 'ProofVariantListResults', results: Array<{ __typename?: 'ProofVariant', runId: number, id: string, subjectline?: string | null, subjectlinePrefix?: string | null, subjectlineSuffix?: string | null, previewText?: string | null, preheaderText?: string | null, recipients: number, type: ProofVariantType, desktopImageUrl?: string | null, contentBlocks: Array<{ __typename?: 'ProofVariantContentBlock', position?: number | null, title: string, creativeTitle?: string | null }> }>, meta: { __typename?: 'ProofVariantListMeta', totalResults: number, variants: number, recipients: number, totalVariants: number, totalRecipients: number } } };

export type RecurringCampaignAudienceFieldsFragment = { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> };

export type RecurringCampaignAudienceConfigQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RecurringCampaignAudienceConfigQuery = { __typename?: 'Query', recurringCampaign?: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } | null };

export type RecurringCampaignAudienceIncludeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
  selectedSplits: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  unselectedSplits: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RecurringCampaignAudienceIncludeMutation = { __typename?: 'Mutation', recurringCampaignAudienceInclude: { __typename?: 'RecurringCampaignAudienceSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null }> } };

export type RecurringCampaignAudienceExcludeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type RecurringCampaignAudienceExcludeMutation = { __typename?: 'Mutation', recurringCampaignAudienceExclude: { __typename?: 'RecurringCampaignAudienceSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null }> } };

export type RecurringCampaignAudienceRemoveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type RecurringCampaignAudienceRemoveMutation = { __typename?: 'Mutation', recurringCampaignAudienceRemove: { __typename?: 'RecurringCampaignAudienceSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null }> } };

export type RecurringCampaignAudienceReorderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  audienceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RecurringCampaignAudienceReorderMutation = { __typename?: 'Mutation', recurringCampaignAudienceReorder: { __typename?: 'RecurringCampaignAudienceSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null }> } };

export type RecurringCampaignFieldAddMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
}>;


export type RecurringCampaignFieldAddMutation = { __typename?: 'Mutation', recurringCampaignFieldAdd: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type RecurringCampaignFieldUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  override?: InputMaybe<ContactAudienceOverrideValueInput>;
  newFieldId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RecurringCampaignFieldUpdateMutation = { __typename?: 'Mutation', recurringCampaignFieldUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type RecurringCampaignFieldRemoveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
}>;


export type RecurringCampaignFieldRemoveMutation = { __typename?: 'Mutation', recurringCampaignFieldRemove: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, channel: { __typename?: 'ChannelSpec', channel: Channel, category: ChannelCategory }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, fields?: Array<{ __typename?: 'RecurringCampaignField', dataFieldId: string, isAccountLevel: boolean, override?: { __typename?: 'ContactAudienceOverrideValueBoolean', boolean?: boolean | null } | { __typename?: 'ContactAudienceOverrideValueDate', date?: string | null } | { __typename?: 'ContactAudienceOverrideValueDateTime', datetime?: string | null } | { __typename?: 'ContactAudienceOverrideValueFloat', float?: string | null } | { __typename?: 'ContactAudienceOverrideValueInteger', integer?: number | null } | { __typename?: 'ContactAudienceOverrideValueString', string?: string | null } | null }> | null, includedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean, segment?: { __typename?: 'ContactAudienceSplit', id: string } | null }> }>, excludedAudiences: Array<{ __typename?: 'MessageSourceAudienceType', id: string, name: string, priority: number, audience?: { __typename?: 'ContactAudience', id: string } | null, segments: Array<{ __typename?: 'MessageSourceAudienceSegmentType', id: string, name?: string | null, selected: boolean }> }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type RecurringCampaignDetailFieldsFragment = { __typename?: 'Campaign', id: string, status: CampaignStatusType, stage: CampaignStageType, title: string, error: boolean, legacyId: string, hasContactAudiences: boolean, featureFlagExperiences2: CampaignFeatureFlagState, lastStatus: { __typename?: 'CampaignStatus', timestamp: string, status: CampaignStatusType, user?: { __typename?: 'User', id: string, fullName?: string | null } | null }, emailServiceProvider?: { __typename: 'AcousticCampaign' } | { __typename: 'AdobeCampaign' } | { __typename: 'AdobeJourneyOptimizer' } | { __typename: 'AmazonSES' } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze' } | { __typename: 'Cordial' } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys' } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud' } | { __typename: 'Zeta' } | null, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, includedContactAudiences?: Array<{ __typename?: 'ContactAudienceConfig', id: string, name: string, contactAudience?: { __typename?: 'ContactAudience', id: string, name: string, archived: boolean } | null }> | null };

export type RecurringCampaignFieldsFragment = { __typename?: 'RecurringCampaignType', id: string, hashid: string, title: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, nextOccurrence?: string | null, hasPastMailings: boolean, lastStatus: { __typename?: 'RecurringCampaignStatusLog', status: RecurringCampaignStatus, label: string, timestamp: string, user?: { __typename?: 'RecurringCampaignStatusUser', fullName: string } | null }, stateInfo: { __typename?: 'RecurringCampaignStateInfo', state: RecurringCampaignStatus, transitions: Array<{ __typename?: 'RecurringCampaignTransition', state: RecurringCampaignStatus, label: string, permission: { __typename?: 'RecurringCampaignTransitionPermissionAllowed', allowed: boolean } | { __typename?: 'RecurringCampaignTransitionPermissionDenied', allowed: boolean, message: string, code: string } }>, actions: Array<{ __typename?: 'RecurringCampaignAction', id: string, label: string }> }, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type RecurringCampaignDetailsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RecurringCampaignDetailsQuery = { __typename?: 'Query', recurringCampaign?: { __typename?: 'RecurringCampaignType', id: string, hashid: string, title: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, nextOccurrence?: string | null, hasPastMailings: boolean, lastStatus: { __typename?: 'RecurringCampaignStatusLog', status: RecurringCampaignStatus, label: string, timestamp: string, user?: { __typename?: 'RecurringCampaignStatusUser', fullName: string } | null }, stateInfo: { __typename?: 'RecurringCampaignStateInfo', state: RecurringCampaignStatus, transitions: Array<{ __typename?: 'RecurringCampaignTransition', state: RecurringCampaignStatus, label: string, permission: { __typename?: 'RecurringCampaignTransitionPermissionAllowed', allowed: boolean } | { __typename?: 'RecurringCampaignTransitionPermissionDenied', allowed: boolean, message: string, code: string } }>, actions: Array<{ __typename?: 'RecurringCampaignAction', id: string, label: string }> }, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type RecurringCampaignDeleteMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RecurringCampaignDeleteMutation = { __typename?: 'Mutation', recurringCampaignDelete: { __typename?: 'RecurringCampaignDeleteSuccess', success: boolean } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignDetailsUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecurringCampaignDetailsUpdateMutation = { __typename?: 'Mutation', recurringCampaignDetailsUpdate: { __typename?: 'RecurringCampaignDetailsUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, title: string, availableSendTimes: Array<any>, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignDuplicateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  title: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecurringCampaignDuplicateMutation = { __typename?: 'Mutation', recurringCampaignDuplicate: { __typename?: 'RecurringCampaignDuplicateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, hashid: string, title: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, nextOccurrence?: string | null, hasPastMailings: boolean, lastStatus: { __typename?: 'RecurringCampaignStatusLog', status: RecurringCampaignStatus, label: string, timestamp: string, user?: { __typename?: 'RecurringCampaignStatusUser', fullName: string } | null }, stateInfo: { __typename?: 'RecurringCampaignStateInfo', state: RecurringCampaignStatus, transitions: Array<{ __typename?: 'RecurringCampaignTransition', state: RecurringCampaignStatus, label: string, permission: { __typename?: 'RecurringCampaignTransitionPermissionAllowed', allowed: boolean } | { __typename?: 'RecurringCampaignTransitionPermissionDenied', allowed: boolean, message: string, code: string } }>, actions: Array<{ __typename?: 'RecurringCampaignAction', id: string, label: string }> }, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignStateTransitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  state: RecurringCampaignStatus;
}>;


export type RecurringCampaignStateTransitionMutation = { __typename?: 'Mutation', recurringCampaignStateTransition: { __typename?: 'RecurringCampaignStateTransitionSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, status: RecurringCampaignStatus, stage: RecurringCampaignStage, stageGroup: RecurringCampaignStageGroup, lastStatus: { __typename?: 'RecurringCampaignStatusLog', status: RecurringCampaignStatus, label: string, timestamp: string, user?: { __typename?: 'RecurringCampaignStatusUser', fullName: string } | null }, stateInfo: { __typename?: 'RecurringCampaignStateInfo', state: RecurringCampaignStatus, transitions: Array<{ __typename?: 'RecurringCampaignTransition', state: RecurringCampaignStatus, label: string, permission: { __typename?: 'RecurringCampaignTransitionPermissionAllowed', allowed: boolean } | { __typename?: 'RecurringCampaignTransitionPermissionDenied', allowed: boolean, message: string, code: string } }>, actions: Array<{ __typename?: 'RecurringCampaignAction', id: string, label: string }> } } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', code?: string | null, field?: string | null, reason: string }> } };

export type RecurringCampaignMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  useDraft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RecurringCampaignMessageQuery = { __typename?: 'Query', recurringCampaignMessage?: { __typename?: 'RecurringCampaignMessageType', id: string, layoutDocument?: BlockCanvasElement | null, inboxPreview?: { __typename?: 'RecurringCampaignInboxPreviewType', id: string, subjectLineDynamicBlockId?: string | null, subjectLinePrefix: string, subjectLineSuffix: string, preheaderDynamicBlockId?: string | null } | null } | null };

export type RecurringCampaignMessageAddDynamicBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecurringCampaignMessageAddDynamicBlockMutation = { __typename?: 'Mutation', recurringCampaignMessageAddDynamicBlock: { __typename: 'RecurringCampaignMessageAddDynamicBlockSuccess', success: boolean, slotUri: string, blockId: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignMessageLayoutUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  document: Scalars['RecurringCampaignMessageLayoutDocument']['input'];
}>;


export type RecurringCampaignMessageLayoutUpdateMutation = { __typename?: 'Mutation', recurringCampaignMessageLayoutUpdate: { __typename: 'RecurringCampaignMessageLayoutUpdateSuccess', success: boolean, updatedAt: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignMessageSaveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  document: Scalars['RecurringCampaignMessageLayoutDocument']['input'];
  inboxPreview?: InputMaybe<RecurringCampaignMessageInboxPreviewUpdateInput>;
}>;


export type RecurringCampaignMessageSaveMutation = { __typename?: 'Mutation', recurringCampaignMessageSave: { __typename: 'RecurringCampaignMessageSaveSuccess', success: boolean } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignMessageDiscardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecurringCampaignMessageDiscardMutation = { __typename?: 'Mutation', recurringCampaignMessageDiscard: { __typename: 'RecurringCampaignMessageDiscardSuccess', success: boolean } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignMessageDynamicBlockInboxContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  blockIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecurringCampaignMessageDynamicBlockInboxContentQuery = { __typename?: 'Query', recurringCampaignMessage?: { __typename?: 'RecurringCampaignMessageType', id: string, dynamicBlocks: Array<{ __typename?: 'RecurringCampaignMessageDynamicBlockType', id: string, experience?: { __typename?: 'RecurringCampaignMessageDynamicBlockExperienceType', id: string, selectedCreative?: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string }>, preheaderText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting' }, previewText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting' } } | null } | null }> } | null };

export type RecurringCampaignMessageInboxPreviewUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RecurringCampaignMessageInboxPreviewUpdateInput;
}>;


export type RecurringCampaignMessageInboxPreviewUpdateMutation = { __typename?: 'Mutation', recurringCampaignMessageInboxPreviewUpdate: { __typename: 'RecurringCampaignMessageInboxPreviewUpdateSuccess', success: boolean } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  blockIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecurringCampaignMessageDynamicBlockCreativeContentQuery = { __typename?: 'Query', recurringCampaignMessage?: { __typename?: 'RecurringCampaignMessageType', id: string, dynamicBlocks: Array<{ __typename?: 'RecurringCampaignMessageDynamicBlockType', id: string, experience?: { __typename?: 'RecurringCampaignMessageDynamicBlockExperienceType', id: string, creativeLayout?: { __typename?: 'Layout', published?: SyncDocumentMsg | null } | null } | null }> } | null };

export type RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  blockIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecurringCampaignMessageDynamicBlockDisclaimerContentQuery = { __typename?: 'Query', recurringCampaignMessage?: { __typename?: 'RecurringCampaignMessageType', id: string, dynamicBlocks: Array<{ __typename?: 'RecurringCampaignMessageDynamicBlockType', id: string, experience?: { __typename?: 'RecurringCampaignMessageDynamicBlockExperienceType', id: string, selectedCreative?: { __typename?: 'Creative', id: string, disclaimer?: string | null } | null } | null }> } | null };

export type RecurringCampaignMessageAvailableCreativesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filter?: InputMaybe<RecurringCampaignAvailableCreativesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringCampaignMessageAvailableCreativesQuery = { __typename?: 'Query', recurringCampaignMessageAvailableCreatives: { __typename?: 'RecurringCampaignAvailableCreativesConnection', edges: Array<{ __typename?: 'RecurringCampaignAvailableCreativesEdge', cursor: string, node: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type RecurringCampaignMessageDynamicBlockExperienceCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  blockId: Scalars['ID']['input'];
}>;


export type RecurringCampaignMessageDynamicBlockExperienceCreateMutation = { __typename?: 'Mutation', recurringCampaignMessageDynamicBlockExperienceCreate: { __typename: 'RecurringCampaignMessageDynamicBlockExperienceCreateSuccess', success: boolean, id: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignMessageExperienceSelectCreativeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  creativeId: Scalars['ID']['input'];
}>;


export type RecurringCampaignMessageExperienceSelectCreativeMutation = { __typename?: 'Mutation', recurringCampaignMessageExperienceSelectCreative: { __typename: 'RecurringCampaignMessageExperienceSelectCreativeSuccess', success: boolean, id: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type RecurringCampaignScheduleQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RecurringCampaignScheduleQuery = { __typename?: 'Query', recurringCampaign?: { __typename?: 'RecurringCampaignType', id: string, availableSendTimes: Array<any>, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null } | null };

export type RecurringCampaignScheduleUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RecurringCampaignScheduleUpdateInput;
}>;


export type RecurringCampaignScheduleUpdateMutation = { __typename?: 'Mutation', recurringCampaignScheduleUpdate: { __typename?: 'RecurringCampaignScheduleUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, schedule?: { __typename?: 'RecurrenceScheduleType', startDate: string, sendTime?: any | null, rrule: string, endDate?: string | null, timezone: string } | null } } | { __typename?: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignTextAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringCampaignTextAttributeUpdateMutation = { __typename?: 'Mutation', recurringCampaignTextAttributeUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignDateAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Date']['input']>;
}>;


export type RecurringCampaignDateAttributeUpdateMutation = { __typename?: 'Mutation', recurringCampaignDateAttributeUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignSelectAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RecurringCampaignSelectAttributeUpdateMutation = { __typename?: 'Mutation', recurringCampaignSelectAttributeUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignListAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RecurringCampaignListAttributeUpdateMutation = { __typename?: 'Mutation', recurringCampaignListAttributeUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringSettingsCustomFieldAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
}>;


export type RecurringSettingsCustomFieldAddMutation = { __typename?: 'Mutation', recurringCampaignCustomFieldAdd: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringSettingsCustomFieldUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringSettingsCustomFieldUpdateMutation = { __typename?: 'Mutation', recurringCampaignCustomFieldUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringSettingsCustomFieldRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
}>;


export type RecurringSettingsCustomFieldRemoveMutation = { __typename?: 'Mutation', recurringCampaignCustomFieldRemove: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignEmailServiceProviderUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  emailServiceProviderId: Scalars['ID']['input'];
}>;


export type RecurringCampaignEmailServiceProviderUpdateMutation = { __typename?: 'Mutation', recurringCampaignEmailServiceProviderUpdate: { __typename?: 'RecurringCampaignEspConfigUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string } | null, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type RecurringCampaignSeedAudienceAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type RecurringCampaignSeedAudienceAddMutation = { __typename?: 'Mutation', recurringCampaignSeedAudienceAdd: { __typename?: 'RecurringCampaignAudienceSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignSeedAudienceRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type RecurringCampaignSeedAudienceRemoveMutation = { __typename?: 'Mutation', recurringCampaignSeedAudienceRemove: { __typename?: 'RecurringCampaignAudienceSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignTextTrackingParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringCampaignTextTrackingParameterUpdateMutation = { __typename?: 'Mutation', recurringCampaignTextTrackingParameterUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type RecurringCampaignSelectTrackingParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RecurringCampaignSelectTrackingParameterUpdateMutation = { __typename?: 'Mutation', recurringCampaignSelectTrackingParameterUpdate: { __typename?: 'RecurringCampaignAttributeUpdateSuccess', success: boolean, recurringCampaign: { __typename?: 'RecurringCampaignType', id: string, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

type RecurringCustomFieldsFragment_DatetimeCustomField_Fragment = { __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null };

type RecurringCustomFieldsFragment_NumberCustomField_Fragment = { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null };

type RecurringCustomFieldsFragment_TextCustomField_Fragment = { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null };

export type RecurringCustomFieldsFragmentFragment = RecurringCustomFieldsFragment_DatetimeCustomField_Fragment | RecurringCustomFieldsFragment_NumberCustomField_Fragment | RecurringCustomFieldsFragment_TextCustomField_Fragment;

export type RecurringCampaignSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type RecurringCampaignSettingsQuery = { __typename?: 'Query', availableCustomFields: Array<{ __typename?: 'AvailableCustomField', id: string, name: string, title: string }>, recurringCampaign?: { __typename?: 'RecurringCampaignType', id: string, status: RecurringCampaignStatus, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string } | null, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } | null };

export type AnalyticsCustomEventCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsCustomEventCategoriesQuery = { __typename?: 'Query', customEventCategories?: Array<{ __typename?: 'CustomEventCategoryType', id: string, name: string, attributionType: AttributionType, hasSubidentifier: boolean, timestampType: TimestampType, contactIdentifierField?: { __typename?: 'DataField', id: string, displayName: string } | null, table?: { __typename?: 'DataTable', id: string, name: string, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null } | null, tags?: Array<{ __typename?: 'CustomEventTagType', id: string, key: string, value: string } | null> | null } | null> | null };

export type AnalyticsCustomEventTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsCustomEventTagsQuery = { __typename?: 'Query', customEventTags?: Array<{ __typename?: 'CustomEventTagType', id: string, key: string, value: string } | null> | null };

export type AnalyticsCustomEventCategoryCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  attributionType?: InputMaybe<AttributionType>;
  contactIdentifierFieldId?: InputMaybe<Scalars['ID']['input']>;
  hasSubidentifier?: InputMaybe<Scalars['Boolean']['input']>;
  timestampType?: InputMaybe<TimestampType>;
}>;


export type AnalyticsCustomEventCategoryCreateMutation = { __typename?: 'Mutation', customEventCategoryCreate: { __typename?: 'InkDavinciEventsV1CustomEventCategoryCreateResponse', category: { __typename?: 'InkDavinciEventsV1CustomEventCategory', id: string, name: string, attributionType: InkDavinciEventsV1AttributionTypeEnum, hasSubidentifier: boolean, timestampType: InkDavinciEventsV1TimestampTypeEnum, tags: Array<{ __typename?: 'InkDavinciEventsV1CustomEventTag', id: string, name: string }> } } };

export type AnalyticsCustomEventCategoryUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type AnalyticsCustomEventCategoryUpdateMutation = { __typename?: 'Mutation', customEventCategoryUpdate: { __typename?: 'InkDavinciEventsV1CustomEventCategoryUpdateResponse', category: { __typename?: 'InkDavinciEventsV1CustomEventCategory', id: string, name: string, tags: Array<{ __typename?: 'InkDavinciEventsV1CustomEventTag', id: string, name: string }> } } };

export type AnalyticsCustomEventCategoryDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AnalyticsCustomEventCategoryDeleteMutation = { __typename?: 'Mutation', customEventCategoryDelete: { __typename?: 'CustomEventCategoryDeleteResult', success: boolean } };

export type AnalyticsCustomEventCategoryAttachTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type AnalyticsCustomEventCategoryAttachTagMutation = { __typename?: 'Mutation', customEventCategoryAttachTag: { __typename?: 'CustomEventCategoryAttachTagResult', category: { __typename?: 'CustomEventCategoryType', id: string, name: string, tags?: Array<{ __typename?: 'CustomEventTagType', id: string, key: string, value: string } | null> | null } } };

export type AnalyticsCustomEventCategoryDetachTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type AnalyticsCustomEventCategoryDetachTagMutation = { __typename?: 'Mutation', customEventCategoryDetachTag: { __typename?: 'CustomEventCategoryDetachTagResult', category: { __typename?: 'CustomEventCategoryType', id: string, name: string, tags?: Array<{ __typename?: 'CustomEventTagType', id: string, key: string, value: string } | null> | null } } };

export type AnalyticsCustomEventCategoryAttachCesTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AnalyticsCustomEventCategoryAttachCesTagMutation = { __typename?: 'Mutation', customEventCategoryAttachCesTag: { __typename?: 'CustomEventCategoryAttachTagResult', category: { __typename?: 'CustomEventCategoryType', id: string, name: string, tags?: Array<{ __typename?: 'CustomEventTagType', id: string, key: string, value: string } | null> | null } } };

export type AnalyticsCustomEventCategoryDetachCesTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AnalyticsCustomEventCategoryDetachCesTagMutation = { __typename?: 'Mutation', customEventCategoryDetachCesTag: { __typename?: 'CustomEventCategoryDetachTagResult', category: { __typename?: 'CustomEventCategoryType', id: string, name: string, tags?: Array<{ __typename?: 'CustomEventTagType', id: string, key: string, value: string } | null> | null } } };

export type GetContactTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactTablesQuery = { __typename?: 'Query', dataTables: Array<{ __typename?: 'DataTable', id: string, name: string, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null }> };

export type GetDataTableFieldsQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type GetDataTableFieldsQuery = { __typename?: 'Query', dataFields: Array<{ __typename?: 'DataField', id: string, name: string, displayName: string, type: DataFieldType }> };

export type AnalyticsSettingSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsSettingSegmentsQuery = { __typename?: 'Query', contactAudiences: { __typename?: 'ContactAudienceList', audiences: Array<{ __typename?: 'ContactAudience', id: string, name: string, analyticsTracking: ContactAudienceAnalyticsTracking, splits: Array<{ __typename?: 'ContactAudienceSplit', id: string }> }> } };

export type ContactAudienceAnalyticsTrackingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  analyticsTracking: ContactAudienceAnalyticsTracking;
}>;


export type ContactAudienceAnalyticsTrackingMutation = { __typename?: 'Mutation', contactAudienceAnalyticsTracking: { __typename?: 'ContactAudienceAnalyticsTrackingSuccess', contactAudience: { __typename?: 'ContactAudience', id: string, name: string, analyticsTracking: ContactAudienceAnalyticsTracking } } };

export type AnalyticsKpiDefinitionQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsKpiDefinitionQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, analyticsConfiguration: { __typename?: 'AnalyticsConfiguration', kpiDefinition: { __typename?: 'AnalyticsKPIDefinition', eventSelections: Array<{ __typename?: 'AnalyticsKPIEventSelection', eventType: AnalyticsKpiEventType, eventSourceId?: string | null }> } } } };

export type AnalyticsKpiEventSelectionsReplaceMutationVariables = Exact<{
  selections: Array<AnalyticsKpiEventSelectionInput> | AnalyticsKpiEventSelectionInput;
}>;


export type AnalyticsKpiEventSelectionsReplaceMutation = { __typename?: 'Mutation', analyticsKpiEventSelectionsReplace: { __typename?: 'AnalyticsConfigurationUpdate', client: { __typename?: 'Client', id: string, analyticsConfiguration: { __typename?: 'AnalyticsConfiguration', kpiDefinition: { __typename?: 'AnalyticsKPIDefinition', eventSelections: Array<{ __typename?: 'AnalyticsKPIEventSelection', eventType: AnalyticsKpiEventType, eventSourceId?: string | null }> } } } } };

export type AnalyticsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsSettingsQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, analyticsCalendar?: AnalyticsCalendar | null, analyticsCurrency?: AnalyticsCurrency | null, analyticsStatSigThreshold?: number | null, analyticsAttributionWindow?: AnalyticsAttributionWindow | null, analyticsRevenueCap?: number | null, analyticsRevenueCapEnabled: boolean, analyticsExportDecimalPrecision: number, analyticsExportRateFormat: AnalyticsExportRateFormat, analyticsShowProjectedMetrics: boolean, fiscalCalendar?: { __typename?: 'Calendar', currentWeek: number } | null } };

export type AnalyticsConfigUpdateMutationVariables = Exact<{
  analyticsAttributionWindow?: InputMaybe<AnalyticsAttributionWindow>;
  analyticsCalendar?: InputMaybe<AnalyticsCalendar>;
  analyticsCurrency?: InputMaybe<AnalyticsCurrency>;
  analyticsStatSigThreshold?: InputMaybe<Scalars['Float']['input']>;
  analyticsRevenueCap?: InputMaybe<Scalars['Float']['input']>;
  analyticsRevenueCapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  analyticsExportDecimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  analyticsExportRateFormat?: InputMaybe<AnalyticsExportRateFormat>;
  analyticsShowProjectedMetrics?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AnalyticsConfigUpdateMutation = { __typename?: 'Mutation', analyticsConfigurationUpdate: { __typename?: 'AnalyticsConfigurationUpdate', client: { __typename?: 'Client', id: string, analyticsCalendar?: AnalyticsCalendar | null, analyticsCurrency?: AnalyticsCurrency | null, analyticsStatSigThreshold?: number | null, analyticsRevenueCap?: number | null, analyticsRevenueCapEnabled: boolean, analyticsExportDecimalPrecision: number, analyticsExportRateFormat: AnalyticsExportRateFormat, analyticsAttributionWindow?: AnalyticsAttributionWindow | null, analyticsShowProjectedMetrics: boolean, fiscalCalendar?: { __typename?: 'Calendar', currentWeek: number } | null } } };

export type CreativePurposesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreativePurposesQuery = { __typename?: 'Query', creativePurposes: Array<{ __typename?: 'CreativePurpose', id: string, name: string, description: string, color: string, position: number, isArchived: boolean }> };

export type CreativePurposeCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreativePurposeCreateMutation = { __typename?: 'Mutation', creativePurposeCreate: { __typename: 'CreativePurposeSuccess', success: boolean, purpose: { __typename?: 'CreativePurpose', id: string, name: string, description: string, color: string, position: number, isArchived: boolean } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type CreativePurposeEditMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreativePurposeEditMutation = { __typename?: 'Mutation', creativePurposeEdit: { __typename: 'CreativePurposeSuccess', success: boolean, purpose: { __typename?: 'CreativePurpose', id: string, name: string, description: string, color: string, position: number, isArchived: boolean } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type CreativePurposeArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreativePurposeArchiveMutation = { __typename?: 'Mutation', creativePurposeArchive: { __typename: 'CreativePurposeSuccess', success: boolean, purpose: { __typename?: 'CreativePurpose', id: string, name: string, description: string, color: string, position: number, isArchived: boolean } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type CreativePurposeUnarchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreativePurposeUnarchiveMutation = { __typename?: 'Mutation', creativePurposeUnarchive: { __typename: 'CreativePurposeSuccess', success: boolean, purpose: { __typename?: 'CreativePurpose', id: string, name: string, description: string, color: string, position: number, isArchived: boolean } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type UpdateLinkDomainAllowlistMutationVariables = Exact<{
  enforceLinkDomainAllowlist: Scalars['Boolean']['input'];
  linkDomainAllowlist: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateLinkDomainAllowlistMutation = { __typename?: 'Mutation', updateLinkDomainAllowlist: { __typename?: 'ClientUpdateSuccess', success: boolean, client: { __typename?: 'Client', id: string, enforceLinkDomainAllowlist: boolean, linkDomainAllowlist: Array<string> } } };

export type PgpKeyFragmentFragment = { __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } };

export type PgpKeysListFragmentFragment = { __typename?: 'DataEncryptionPGPKeysList', encryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }>, decryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }> };

export type DataEncryptionConfigFragmentFragment = { __typename?: 'DataEncryptionConfig', id: string, createdAt: string, updatedAt: string, gpgPublicKey: string, gpgAppPublicKey: string };

export type DataEncryptionConfigUpdateMutationVariables = Exact<{
  gpgPublicKey: Scalars['String']['input'];
}>;


export type DataEncryptionConfigUpdateMutation = { __typename?: 'Mutation', dataEncryptionConfigUpdate: { __typename?: 'DataEncryptionConfigUpdate', config: { __typename?: 'DataEncryptionConfig', id: string, createdAt: string, updatedAt: string, gpgPublicKey: string, gpgAppPublicKey: string } } };

export type DataEncryptionConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type DataEncryptionConfigQuery = { __typename?: 'Query', dataEncryptionConfig: { __typename?: 'DataEncryptionConfig', id: string, createdAt: string, updatedAt: string, gpgPublicKey: string, gpgAppPublicKey: string } };

export type DataEncryptionPgpKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type DataEncryptionPgpKeysQuery = { __typename?: 'Query', dataEncryptionPgpKeys: { __typename?: 'DataEncryptionPGPKeysList', encryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }>, decryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }> } };

export type DataEncryptionPgpKeyCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  encryptKey?: InputMaybe<DataEncryptionPgpEncryptKeyInput>;
  decryptKey?: InputMaybe<DataEncryptionPgpDecryptKeyInput>;
}>;


export type DataEncryptionPgpKeyCreateMutation = { __typename?: 'Mutation', dataEncryptionPgpKeyCreate: { __typename?: 'DataEncryptionPGPKeyCreateResult', pgpKey: { __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } } } };

export type DataEncryptionPgpKeyUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  encryptKey?: InputMaybe<DataEncryptionPgpEncryptKeyInput>;
  decryptKey?: InputMaybe<DataEncryptionPgpDecryptKeyInput>;
}>;


export type DataEncryptionPgpKeyUpdateMutation = { __typename?: 'Mutation', dataEncryptionPgpKeyUpdate: { __typename?: 'DataEncryptionPGPKeyUpdateResult', pgpKey: { __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } } } };

export type DataEncryptionPgpKeyDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DataEncryptionPgpKeyDeleteMutation = { __typename?: 'Mutation', dataEncryptionPgpKeyDelete: { __typename?: 'DataEncryptionPGPKeyDeleteResult', success: boolean, pgpKeys: { __typename?: 'DataEncryptionPGPKeysList', encryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }>, decryptPgpKeys: Array<{ __typename?: 'DataEncryptionPGPKey', id: string, name: string, createdAt: string, updatedAt: string, spec: { __typename?: 'DataEncryptionPGPDecryptKey', publicKey: string, expiresAt?: string | null } | { __typename?: 'DataEncryptionPGPEncryptKey', publicKey: string } }> } } };

export type TrackingTokenCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  mode: TrackingTokenMode;
}>;


export type TrackingTokenCreateMutation = { __typename?: 'Mutation', trackingTokenCreate: { __typename?: 'TrackingTokenCreate', token: { __typename?: 'TrackingToken', id: string, createdAt: string, name: string, key: string, mode: TrackingTokenMode } } };

export type TrackingTokenDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TrackingTokenDeleteMutation = { __typename?: 'Mutation', trackingTokenDelete: { __typename?: 'TrackingTokenDelete', id: string } };

export type TrackingTokenListQueryVariables = Exact<{ [key: string]: never; }>;


export type TrackingTokenListQuery = { __typename?: 'Query', trackingTokenList: Array<{ __typename?: 'TrackingToken', id: string, createdAt: string, name: string, key: string, mode: TrackingTokenMode }> };

export type AnalyticsWebEventsActivityQueryVariables = Exact<{
  tokenId: Scalars['ID']['input'];
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AnalyticsWebEventsActivityQuery = { __typename?: 'Query', analyticsWebEventsActivity: Array<{ __typename?: 'AnalyticsEventActivity', eventType: AnalyticsEventType, count: number, mostRecent?: string | null }> };

export type DataSubjectRequestsCreateBatchMutationVariables = Exact<{
  requests: Array<DsrInput> | DsrInput;
}>;


export type DataSubjectRequestsCreateBatchMutation = { __typename?: 'Mutation', dataSubjectRequestsBatchCreate: { __typename?: 'DataSubjectRequestsBatchCreateSuccess', dataSubjectRequests: Array<{ __typename?: 'DataSubjectRequest', id: string, actorName?: string | null, status: string, source: string, createdAt: string, updatedAt: string }> } };

export type DataTablesUserPrivacyQueryVariables = Exact<{ [key: string]: never; }>;


export type DataTablesUserPrivacyQuery = { __typename?: 'Query', dataTables: Array<{ __typename?: 'DataTable', id: string, name: string, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null }> };

export type DataFieldsUserPrivacyQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type DataFieldsUserPrivacyQuery = { __typename?: 'Query', dataFields: Array<{ __typename?: 'DataField', id: string, name: string, displayName: string, primaryKey: boolean }> };

export type DataSubjectRequestsQueryVariables = Exact<{
  type?: InputMaybe<InkDavinciDsrV1DsrTypeEnum>;
  status?: InputMaybe<InkDavinciDsrV1DsrStatusEnum>;
  subjectFieldName?: InputMaybe<Scalars['String']['input']>;
  subjectFieldValue?: InputMaybe<Scalars['String']['input']>;
}>;


export type DataSubjectRequestsQuery = { __typename?: 'Query', dataSubjectRequests: Array<{ __typename?: 'DataSubjectRequest', id: string, actorName?: string | null, status: string, source: string, createdAt: string, updatedAt: string, datasourceStatuses?: Array<{ __typename?: 'DatasourceStatus', datasource: string, status: string, errorMessage?: string | null }> | null }> };

export type CredentialsFieldsFragment = { __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null };

export type PlatformApplicationFieldsFragment = { __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> };

export type PlatformApplicationsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type PlatformApplicationsQuery = { __typename?: 'Query', platformApplications?: Array<{ __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> }> | null };

export type PlatformApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformApplicationQuery = { __typename?: 'Query', platformApplication?: { __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> } | null };

export type PlatformApplicationCreateMutationVariables = Exact<{
  input: CreatePlatformApplicationInput;
}>;


export type PlatformApplicationCreateMutation = { __typename?: 'Mutation', platformApplicationCreate: { __typename?: 'CreatePlatformApplicationSuccess', application: { __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> } } };

export type PlatformApplicationUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformApplicationInput;
}>;


export type PlatformApplicationUpdateMutation = { __typename?: 'Mutation', platformApplicationUpdate: { __typename?: 'UpdatePlatformApplicationSuccess', application: { __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> } } };

export type PlatformApplicationSuspendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformApplicationSuspendMutation = { __typename?: 'Mutation', platformApplicationSuspend: { __typename?: 'SuspendPlatformApplicationSuccess', application: { __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> } } };

export type PlatformApplicationActivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformApplicationActivateMutation = { __typename?: 'Mutation', platformApplicationActivate: { __typename?: 'ActivatePlatformApplicationSuccess', application: { __typename?: 'PlatformApplication', id: string, name: string, status: string, createdAt: string, updatedAt: string, description?: string | null, scopes: Array<string>, credentials: Array<{ __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null }>, accounts: Array<{ __typename?: 'Account2', id: string, displayName: string }>, requester?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string }> } } };

export type CreateCredentialMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
}>;


export type CreateCredentialMutation = { __typename?: 'Mutation', createCredential: { __typename?: 'CredentialCreateSuccess', credential: { __typename?: 'CredentialRegistration', id: string, name: string, secret: string } } };

export type RevokeCredentialMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  credentialId: Scalars['ID']['input'];
}>;


export type RevokeCredentialMutation = { __typename?: 'Mutation', revokeCredential: { __typename?: 'CredentialRevokeSuccess', credential: { __typename?: 'Credential', id: string, name: string, metaData?: string | null, expiresAt?: string | null, createdAt: string, lastUsedAt?: string | null, status: CredentialStatus, createdBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, status: MemberStatus } | null } } };

export type ScopesByCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type ScopesByCategoryQuery = { __typename?: 'Query', scopesByCategory?: Array<{ __typename?: 'ScopeCategory', name: string, scopes: Array<{ __typename?: 'Scope', category: string, description: string, value: string }> }> | null };

export type OrganizationUser2FieldsFragment = { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } };

export type AccountRoleFieldsFragment = { __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> };

export type AccountFieldsFragment = { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, createdAt: string, deactivated: boolean, allowlistedDomains: Array<string>, authConnection?: string | null, enableMfa: boolean };

export type UserCreateMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountRoles?: InputMaybe<Array<AccountRoleInput> | AccountRoleInput>;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate2: { __typename?: 'UserCreate2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type UserCreateWithRoleMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountRoles: Array<AccountRoleWithRequiredRoleInput> | AccountRoleWithRequiredRoleInput;
}>;


export type UserCreateWithRoleMutation = { __typename?: 'Mutation', userCreateWithRole: { __typename?: 'UserCreateWithRole', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type UserUpdateMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  accountRoles?: InputMaybe<Array<AccountRoleInput> | AccountRoleInput>;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate2: { __typename?: 'UserUpdate2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type UserSuspendMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserSuspendMutation = { __typename?: 'Mutation', userSuspend2: { __typename?: 'UserSuspend', success: boolean } };

export type UserUnsuspendMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserUnsuspendMutation = { __typename?: 'Mutation', userUnsuspend2: { __typename?: 'UserUnsuspend2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type AccountUserCreateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  emailAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AccountUserCreateMutation = { __typename?: 'Mutation', accountUserBulkCreate: { __typename?: 'AccountUserBulkCreate', success: boolean, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> } } };

export type AccountUserBulkCreateWithRolesMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  emailAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
}>;


export type AccountUserBulkCreateWithRolesMutation = { __typename?: 'Mutation', accountUserBulkCreateWithRoles: { __typename?: 'AccountUserBulkCreateWithRoles', success: boolean, results: { __typename?: 'AccountUserBulkCreateWithRolesResults', successfulEmailList: Array<string>, failureEmailList: Array<string> }, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> } } };

export type AccountUserInviteMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  accountRoleId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountUserInviteMutation = { __typename?: 'Mutation', accountUserInvite: { __typename?: 'AccountUserInvite', success: boolean } };

export type AccountUserByEmailQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
}>;


export type AccountUserByEmailQuery = { __typename?: 'Query', accountUserByEmail: { __typename?: 'AccountUserByEmail', id?: string | null, firstName?: string | null, lastName?: string | null, emailAddress?: string | null, userStatus?: MemberStatus | null, homeOrganizationId?: string | null, accountMembershipStatus?: AccountMemberStatus | null } };

export type AccountUserSuspendMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserSuspendMutation = { __typename?: 'Mutation', accountUserSuspend2: { __typename?: 'AccountUserSuspend2', success: boolean, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> } } };

export type AccountMemberStatusFieldsFragment = { __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string }, user: { __typename?: 'OrganizationUser2', id: string, status: MemberStatus } };

export type AccountUserInviteCancelMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserInviteCancelMutation = { __typename?: 'Mutation', accountUserInviteCancel: { __typename?: 'AccountUserInviteCancel', success: boolean, accountUser?: { __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string }, user: { __typename?: 'OrganizationUser2', id: string, status: MemberStatus } } | null } };

export type AccountUserReinviteMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserReinviteMutation = { __typename?: 'Mutation', accountUserReinvite: { __typename?: 'AccountUserReinvite', success: boolean, accountUser?: { __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string }, user: { __typename?: 'OrganizationUser2', id: string, status: MemberStatus } } | null } };

export type AccountUserReactivateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserReactivateMutation = { __typename?: 'Mutation', accountUserReactivate: { __typename?: 'AccountUserReactivate', success: boolean, accountUser?: { __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string }, user: { __typename?: 'OrganizationUser2', id: string, status: MemberStatus } } | null } };

export type AccountUserRemoveMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserRemoveMutation = { __typename?: 'Mutation', accountUserRemove: { __typename?: 'AccountUserRemove', success: boolean, accountUser?: { __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string }, user: { __typename?: 'OrganizationUser2', id: string, status: MemberStatus } } | null } };

export type UserRoleCreateMutationVariables = Exact<{
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserRoleCreateMutation = { __typename?: 'Mutation', userRoleCreate2: { __typename?: 'UserRoleCreate2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type UserRoleDeleteMutationVariables = Exact<{
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserRoleDeleteMutation = { __typename?: 'Mutation', userRoleDelete2: { __typename?: 'UserRoleDelete2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserRoleAssignMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  organizationRoleId: Scalars['ID']['input'];
}>;


export type OrganizationUserRoleAssignMutation = { __typename?: 'Mutation', organizationUserRoleAssign: { __typename?: 'OrganizationUserRoleAssign', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type AccountUserRoleCreateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserRoleCreateMutation = { __typename?: 'Mutation', accountUserRoleCreate2: { __typename?: 'AccountUserRoleCreate2', success: boolean, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> } } };

export type AccountUserRoleDeleteMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  roleName: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AccountUserRoleDeleteMutation = { __typename?: 'Mutation', accountUserRoleDelete2: { __typename?: 'AccountUserRoleDelete2', success: boolean, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> } } };

export type AccountUserSwitchRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;


export type AccountUserSwitchRoleMutation = { __typename?: 'Mutation', accountUserSwitchRole: { __typename?: 'AccountUserSwitchRole', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserUpdateMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  accountRoles: Array<AccountRoleWithRequiredRoleInput> | AccountRoleWithRequiredRoleInput;
}>;


export type OrganizationUserUpdateMutation = { __typename?: 'Mutation', organizationUserUpdate: { __typename?: 'OrganizationUserUpdate', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } }, results: { __typename?: 'OrganizationUserUpdateResults', userUpdateFailed: boolean, successfulAccountIds: Array<string>, failedAccountIds: Array<string> } } };

export type OrganizationQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, deactivated: boolean, createdAt: string, authConnection?: string | null, updatedAt: string, organizationRoles: Array<{ __typename?: 'OrganizationRoleInfo', id: string, name: string }>, members2: Array<{ __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string, accountId: string }>, organizationAccountMembers: Array<{ __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null } }> }>, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string, deactivated: boolean, createdAt?: string | null, updatedAt?: string | null, userCount: number, roles: Array<{ __typename?: 'Role', id: string, title: string }> }> } };

export type AccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, updatedAt?: string | null, roles?: Array<{ __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> }> | null, members: Array<{ __typename?: 'AccountMember', createdAt: string, status: AccountMemberStatus, lastActivityAt?: string | null, organizationRole?: OrganizationRole | null, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, userType: UserType, roles: Array<{ __typename?: 'Role', id: string, name: string }> }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }> }> } };

export type AccountCreateMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type AccountCreateMutation = { __typename?: 'Mutation', accountCreate: { __typename?: 'AccountCreateSuccess', success: boolean, account: { __typename?: 'Account2', id: string, displayName: string, createdAt?: string | null, members: Array<{ __typename?: 'AccountMember', user: { __typename?: 'OrganizationUser2', id: string } }> } } };

export type AccountDeactivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountDeactivateMutation = { __typename?: 'Mutation', accountDeactivate: { __typename?: 'AccountSuccess', success: boolean } };

export type AccountReactivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccountReactivateMutation = { __typename?: 'Mutation', accountReactivate: { __typename?: 'AccountReactivateSuccess', success: boolean, organization: { __typename?: 'Organization', id: string, name: string, updatedAt: string, accountSummaries: Array<{ __typename?: 'AccountSummary', id: string, displayName: string, deactivated: boolean, createdAt?: string | null, updatedAt?: string | null, userCount: number }> } } };

export type OrganizationUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrganizationUserQuery = { __typename?: 'Query', organizationUser2: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } };

export type OrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: string, name: string, createdAt: string, deactivated: boolean, allowlistedDomains: Array<string>, authConnection?: string | null, enableMfa: boolean }> | null };

export type OrganizationCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  allowlistedDomains?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  authConnectionId?: InputMaybe<Scalars['String']['input']>;
  enableMfa?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationCreateMutation = { __typename?: 'Mutation', organizationCreate: { __typename?: 'OrganizationCreateSuccess', success: boolean, organization: { __typename?: 'Organization', id: string, name: string, createdAt: string, deactivated: boolean, allowlistedDomains: Array<string>, authConnection?: string | null, enableMfa: boolean } } };

export type OrganizationDeactivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationDeactivateMutation = { __typename?: 'Mutation', organizationDeactivate: { __typename?: 'OrganizationSuccess', success: boolean } };

export type OrganizationReactivateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationReactivateMutation = { __typename?: 'Mutation', organizationReactivate: { __typename?: 'OrganizationReactivateSuccess', success: boolean, organization: { __typename?: 'Organization', id: string, name: string, createdAt: string, deactivated: boolean, allowlistedDomains: Array<string>, authConnection?: string | null, enableMfa: boolean } } };

export type OrganizationUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  allowlistedDomains?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  authConnectionId?: InputMaybe<Scalars['String']['input']>;
  enableMfa?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationUpdateMutation = { __typename?: 'Mutation', organizationUpdate: { __typename?: 'OrganizationUpdateSuccess', success: boolean, organization: { __typename?: 'Organization', id: string, name: string, createdAt: string, deactivated: boolean, allowlistedDomains: Array<string>, authConnection?: string | null, enableMfa: boolean } } };

export type UserInvitationResendMutationVariables = Exact<{
  userIdentifier: UserIdentifierInput;
}>;


export type UserInvitationResendMutation = { __typename?: 'Mutation', userInvitationResend2: { __typename?: 'UserInvitationResend2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type UserAccountInviteApproveMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
}>;


export type UserAccountInviteApproveMutation = { __typename?: 'Mutation', userAccountInviteApprove: { __typename?: 'AccountUserInvitationAccept2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type UserAccountInviteDeclineMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
}>;


export type UserAccountInviteDeclineMutation = { __typename?: 'Mutation', userAccountInviteDecline: { __typename?: 'AccountUserInvitationDecline', success: boolean, user?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } | null } };

export type UserInvitationCancelMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
}>;


export type UserInvitationCancelMutation = { __typename?: 'Mutation', userInvitationCancel2: { __typename?: 'UserInvitationCancel2', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserInviteMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountRoleId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrganizationUserInviteMutation = { __typename?: 'Mutation', organizationUserInvite: { __typename?: 'OrganizationUserInvite', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type AccountUserAddMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  accountRoleId: Scalars['ID']['input'];
}>;


export type AccountUserAddMutation = { __typename?: 'Mutation', accountUserAdd: { __typename?: 'AccountUserAdd', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } }, accountUser?: { __typename?: 'AccountMember', status: AccountMemberStatus, account: { __typename?: 'Account2', id: string }, user: { __typename?: 'OrganizationUser2', id: string, status: MemberStatus } } | null } };

export type OrganizationUserInviteCancelMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OrganizationUserInviteCancelMutation = { __typename?: 'Mutation', organizationUserInviteCancel: { __typename?: 'OrganizationUserInviteCancel', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserInviteApproveMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OrganizationUserInviteApproveMutation = { __typename?: 'Mutation', organizationUserInviteApprove: { __typename?: 'OrganizationUserInviteApprove', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserInviteDeclineMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OrganizationUserInviteDeclineMutation = { __typename?: 'Mutation', organizationUserInviteDecline: { __typename?: 'OrganizationUserInviteDecline', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserReinviteMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OrganizationUserReinviteMutation = { __typename?: 'Mutation', organizationUserReinvite: { __typename?: 'OrganizationUserReinvite', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserReactivateMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OrganizationUserReactivateMutation = { __typename?: 'Mutation', organizationUserReactivate: { __typename?: 'OrganizationUserReactivate', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type OrganizationUserRemoveMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OrganizationUserRemoveMutation = { __typename?: 'Mutation', organizationUserRemove: { __typename?: 'OrganizationUserRemove', success: boolean, user: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string, lastLogin?: string | null, status: MemberStatus, userType: UserType, inviteExpiresAt?: string | null, createdAt: string, isAdmin: boolean, isOwner: boolean, organizationRole?: OrganizationRole | null, isSuperuser: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string }>, organization: { __typename?: 'Organization', id: string }, accountMembers: Array<{ __typename?: 'AccountMember', isOwner: boolean, isAdmin: boolean, status: AccountMemberStatus, createdAt: string, inviteExpiresAt?: string | null, account: { __typename?: 'Account2', id: string, name: string, displayName: string, createdAt?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, invitedBy?: { __typename?: 'OrganizationUser2', id: string, firstName: string, lastName: string, emailAddress: string } | null, roles: Array<{ __typename?: 'Role', id: string, title: string }> }>, canInviteUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canEditUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canDeactivateUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null }, canViewUser: { __typename?: 'AuthorizationResult', allowed: boolean, reason?: string | null } } } };

export type AccountRoleCreateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type AccountRoleCreateMutation = { __typename?: 'Mutation', accountRoleCreate: { __typename?: 'AccountRoleCreate', success: boolean, accountRole: { __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> } } };

export type AccountRoleUpdateMutationVariables = Exact<{
  accountRoleId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountRoleUpdateMutation = { __typename?: 'Mutation', accountRoleUpdate: { __typename?: 'AccountRoleUpdate', success: boolean, accountRole: { __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> } } };

export type AccountRoleDeleteMutationVariables = Exact<{
  accountRoleId: Scalars['ID']['input'];
  replacementAccountRoleId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AccountRoleDeleteMutation = { __typename?: 'Mutation', accountRoleDelete: { __typename?: 'AccountRoleDelete', success: boolean } };

export type AvailablePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailablePermissionsQuery = { __typename?: 'Query', availablePermissions?: Array<{ __typename?: 'AvailablePermission', id: string, title: string, description: string, permissions: Array<string>, dependsOn: Array<string> }> | null };

export type AccountRolePermissionsAddMutationVariables = Exact<{
  accountRoleId: Scalars['ID']['input'];
  permissionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AccountRolePermissionsAddMutation = { __typename?: 'Mutation', accountRolePermissionsAdd: { __typename?: 'AccountRolePermissionsSuccess', success: boolean, accountRole?: { __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> } | null } };

export type AccountRolePermissionsRemoveMutationVariables = Exact<{
  accountRoleId: Scalars['ID']['input'];
  permissionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AccountRolePermissionsRemoveMutation = { __typename?: 'Mutation', accountRolePermissionsRemove: { __typename?: 'AccountRolePermissionsSuccess', success: boolean, accountRole?: { __typename?: 'Role', id: string, name: string, title: string, description: string, permissions: Array<{ __typename?: 'Permission', name: PermissionName, title: string, description: string }> } | null } };

export type DataTableDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataTableDeleteMutation = { __typename?: 'Mutation', dataTableDelete: { __typename?: 'DataTableDeleteSuccess', success: boolean, id: string } };

export type DataTableCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  semanticCategory?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DataTableCreateMutation = { __typename?: 'Mutation', dataTableCreate: { __typename?: 'DataTableCreateSuccess', success: boolean, table: { __typename?: 'DataTable', id: string, name: string, description: string, updatedAt: string, rowTtlDays?: number | null, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null } } };

export type DataFieldsCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  primaryKey: Scalars['Boolean']['input'];
  tableId: Scalars['ID']['input'];
  type: DataFieldType;
  semanticFeature?: InputMaybe<Scalars['ID']['input']>;
  channels?: InputMaybe<Array<Channel> | Channel>;
}>;


export type DataFieldsCreateMutation = { __typename?: 'Mutation', dataFieldCreate: { __typename?: 'DataFieldSuccess', success: boolean, field: { __typename?: 'DataField', id: string, name: string, displayName: string, description: string, type: DataFieldType, primaryKey: boolean, channelsV2: Array<Channel>, semanticFeature?: { __typename?: 'SemanticFeature', id: string, name: string } | null } } };

export type DataFieldUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  semanticFeature?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DataFieldType>;
  channels?: InputMaybe<Array<Channel> | Channel>;
}>;


export type DataFieldUpdateMutation = { __typename?: 'Mutation', dataFieldUpdate: { __typename?: 'DataFieldSuccess', success: boolean, field: { __typename?: 'DataField', id: string, name: string, displayName: string, description: string, type: DataFieldType, primaryKey: boolean, channelsV2: Array<Channel>, semanticFeature?: { __typename?: 'SemanticFeature', id: string, name: string } | null } } };

export type DataFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataFieldQuery = { __typename?: 'Query', dataField: { __typename?: 'DataField', id: string, name: string, displayName: string, description: string, type: DataFieldType, primaryKey: boolean, channelsV2: Array<Channel>, semanticFeature?: { __typename?: 'SemanticFeature', id: string, name: string } | null } };

export type DataFieldDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataFieldDeleteMutation = { __typename?: 'Mutation', dataFieldDelete: { __typename?: 'DataFieldDeleteSuccess', success: boolean, id: string } };

export type DataRelationsCreateMutationVariables = Exact<{
  sourceFieldId: Scalars['ID']['input'];
  relatedFieldId: Scalars['ID']['input'];
}>;


export type DataRelationsCreateMutation = { __typename?: 'Mutation', dataRelationsCreate: { __typename?: 'InkDavinciDataV1RelationCreateResponse', relation: { __typename?: 'InkDavinciDataV1Relation', id: string, updatedAt: string, createdAt: string, sourceField: { __typename?: 'InkDavinciDataV1RelationField', id: string, name: string }, relatedField: { __typename?: 'InkDavinciDataV1RelationField', id: string, name: string }, sourceTable: { __typename?: 'InkDavinciDataV1RelationTable', id: string, name: string }, relatedTable: { __typename?: 'InkDavinciDataV1RelationTable', id: string, name: string } } } };

export type DataRelationsDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataRelationsDeleteMutation = { __typename?: 'Mutation', dataRelationsDelete: { __typename?: 'DataRelationDeleteSuccess', success: boolean, id: string } };

export type DataRelationsQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type DataRelationsQuery = { __typename?: 'Query', dataRelations: { __typename?: 'InkDavinciDataV1RelationListResponse', relations: Array<{ __typename?: 'InkDavinciDataV1Relation', id: string, updatedAt: string, createdAt: string, sourceField: { __typename?: 'InkDavinciDataV1RelationField', id: string, name: string }, relatedField: { __typename?: 'InkDavinciDataV1RelationField', id: string, name: string }, sourceTable: { __typename?: 'InkDavinciDataV1RelationTable', id: string, name: string }, relatedTable: { __typename?: 'InkDavinciDataV1RelationTable', id: string, name: string } }> } };

export type DataTagUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type DataTagUpdateMutation = { __typename?: 'Mutation', dataTagUpdate: { __typename?: 'InkDavinciDataV1TagUpdateResponse', tag: { __typename?: 'InkDavinciDataV1Tag', id: string, name: string, expiresAt?: string | null } } };

export type DataTagCreateMutationVariables = Exact<{
  tableId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type DataTagCreateMutation = { __typename?: 'Mutation', dataTagCreate: { __typename?: 'InkDavinciDataV1TagCreateResponse', tag: { __typename?: 'InkDavinciDataV1Tag', id: string, name: string, expiresAt?: string | null } } };

export type DataTagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataTagQuery = { __typename?: 'Query', dataTag: { __typename?: 'InkDavinciDataV1TagFetchResponse', tag: { __typename?: 'InkDavinciDataV1Tag', id: string, name: string, expiresAt?: string | null } } };

export type DataTagDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataTagDeleteMutation = { __typename?: 'Mutation', dataTagDelete: { __typename?: 'DataTagDeleteSuccess', id: string, success: boolean } };

export type DataTagDeletableQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DataTagDeletableQuery = { __typename?: 'Query', dataTagDeletable?: { __typename?: 'DataTagDeletableResponse', deletable?: boolean | null } | null };

export type DataTagsDeletableQueryVariables = Exact<{ [key: string]: never; }>;


export type DataTagsDeletableQuery = { __typename?: 'Query', dataTagsDeletable: { __typename?: 'InkDavinciDataV1TagListResponse', tags: Array<{ __typename?: 'InkDavinciDataV1Tag', id: string, name: string }> } };

export type DataTagsFragmentFragment = { __typename?: 'InkDavinciDataV1Tag', id: string, name: string };

export type DataTagsQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type DataTagsQuery = { __typename?: 'Query', dataTags: { __typename?: 'InkDavinciDataV1TagListResponse', tags: Array<{ __typename?: 'InkDavinciDataV1Tag', id: string, name: string, expiresAt?: string | null }> } };

export type DataTableUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  semanticCategory?: InputMaybe<Scalars['ID']['input']>;
  rowTtlDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DataTableUpdateMutation = { __typename?: 'Mutation', dataTableUpdate: { __typename?: 'DataTableUpdateSuccess', success: boolean, table: { __typename?: 'DataTable', id: string, name: string, description: string, updatedAt: string, rowTtlDays?: number | null, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null } } };

export type DataTableQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataTableQuery = { __typename?: 'Query', dataTable: { __typename?: 'DataTable', rowCount?: number | null, id: string, name: string, description: string, updatedAt: string, rowTtlDays?: number | null, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null } };

export type DataFieldsFragmentFragment = { __typename?: 'DataField', id: string, name: string, displayName: string, description: string, type: DataFieldType, primaryKey: boolean, channelsV2: Array<Channel>, semanticFeature?: { __typename?: 'SemanticFeature', id: string, name: string } | null };

export type DataFieldsQueryVariables = Exact<{
  tableId: Scalars['ID']['input'];
}>;


export type DataFieldsQuery = { __typename?: 'Query', dataFields: Array<{ __typename?: 'DataField', id: string, name: string, displayName: string, description: string, type: DataFieldType, primaryKey: boolean, channelsV2: Array<Channel>, semanticFeature?: { __typename?: 'SemanticFeature', id: string, name: string } | null }> };

export type SemanticCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SemanticCategoriesQuery = { __typename?: 'Query', semanticCategories: { __typename?: 'InkDavinciDataV1SemanticCategoryListResponse', categories: Array<{ __typename?: 'InkDavinciDataV1SemanticCategory', id: string, name: string, title: string, description: string, isUsed: boolean, features: Array<{ __typename?: 'InkDavinciDataV1SemanticCategoryFeature', id: string, name: string, title: string, description: string, types: Array<InkDavinciDataV1SemanticTypeEnum>, isUsed: boolean }> }> } };

export type DataTableLockQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DataTableLockQuery = { __typename?: 'Query', dataTableLock: { __typename?: 'InkDavinciDataV1TableLockFetchResponse', tableLock: { __typename?: 'InkDavinciDataV1TableLock', id: string, locked: boolean } } };

export type DataTablesFragmentFragment = { __typename?: 'DataTable', id: string, name: string, description: string, updatedAt: string, rowTtlDays?: number | null, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null };

export type DataTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type DataTablesQuery = { __typename?: 'Query', dataTables: Array<{ __typename?: 'DataTable', id: string, name: string, description: string, updatedAt: string, rowTtlDays?: number | null, semanticCategory?: { __typename?: 'SemanticCategory', id: string, name: string } | null }> };

export type TriggeredCampaignMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  useDraft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TriggeredCampaignMessageQuery = { __typename?: 'Query', triggeredCampaignMessage?: { __typename?: 'TriggeredCampaignMessageType', id: string, layoutDocument?: BlockCanvasElement | null, inboxPreview?: { __typename?: 'TriggeredCampaignInboxPreviewType', id: string, subjectLineDynamicBlockId?: string | null, subjectLinePrefix: string, subjectLineSuffix: string, preheaderDynamicBlockId?: string | null } | null } | null };

export type TriggeredCampaignMessageAddDynamicBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggeredCampaignMessageAddDynamicBlockMutation = { __typename?: 'Mutation', triggeredCampaignMessageAddDynamicBlock: { __typename: 'TriggeredCampaignMessageAddDynamicBlockSuccess', success: boolean, slotUri: string, blockId: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignMessageLayoutUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  document: Scalars['TriggeredCampaignMessageLayoutDocument']['input'];
}>;


export type TriggeredCampaignMessageLayoutUpdateMutation = { __typename?: 'Mutation', triggeredCampaignMessageLayoutUpdate: { __typename: 'TriggeredCampaignMessageLayoutUpdateSuccess', success: boolean, updatedAt: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignMessageSaveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  document: Scalars['TriggeredCampaignMessageLayoutDocument']['input'];
  inboxPreview?: InputMaybe<TriggeredCampaignMessageInboxPreviewUpdateInput>;
}>;


export type TriggeredCampaignMessageSaveMutation = { __typename?: 'Mutation', triggeredCampaignMessageSave: { __typename: 'TriggeredCampaignMessageSaveSuccess', success: boolean } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignMessageDiscardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggeredCampaignMessageDiscardMutation = { __typename?: 'Mutation', triggeredCampaignMessageDiscard: { __typename: 'TriggeredCampaignMessageDiscardSuccess', success: boolean } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  blockIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TriggeredCampaignMessageDynamicBlockInboxContentQuery = { __typename?: 'Query', triggeredCampaignMessage?: { __typename?: 'TriggeredCampaignMessageType', id: string, dynamicBlocks: Array<{ __typename?: 'TriggeredCampaignMessageDynamicBlockType', id: string, experience?: { __typename?: 'TriggeredCampaignMessageDynamicBlockExperienceType', id: string, selectedCreative?: { __typename?: 'Creative', id: string, subjectLines: Array<{ __typename?: 'SubjectLine', id: string, content: string }>, preheaderText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting' }, previewText2: { __typename: 'InboxTextSetting', enabled: boolean, content?: string | null } | { __typename: 'InboxUnconfiguredSetting' } } | null } | null }> } | null };

export type TriggeredCampaignMessageInboxPreviewUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TriggeredCampaignMessageInboxPreviewUpdateInput;
}>;


export type TriggeredCampaignMessageInboxPreviewUpdateMutation = { __typename?: 'Mutation', triggeredCampaignMessageInboxPreviewUpdate: { __typename: 'TriggeredCampaignMessageInboxPreviewUpdateSuccess', success: boolean } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  blockIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TriggeredCampaignMessageDynamicBlockCreativeContentQuery = { __typename?: 'Query', triggeredCampaignMessage?: { __typename?: 'TriggeredCampaignMessageType', id: string, dynamicBlocks: Array<{ __typename?: 'TriggeredCampaignMessageDynamicBlockType', id: string, experience?: { __typename?: 'TriggeredCampaignMessageDynamicBlockExperienceType', id: string, creativeLayout?: { __typename?: 'Layout', published?: SyncDocumentMsg | null } | null } | null }> } | null };

export type TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  blockIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery = { __typename?: 'Query', triggeredCampaignMessage?: { __typename?: 'TriggeredCampaignMessageType', id: string, dynamicBlocks: Array<{ __typename?: 'TriggeredCampaignMessageDynamicBlockType', id: string, experience?: { __typename?: 'TriggeredCampaignMessageDynamicBlockExperienceType', id: string, selectedCreative?: { __typename?: 'Creative', id: string, disclaimer?: string | null } | null } | null }> } | null };

export type TriggeredCampaignMessageAvailableCreativesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filter?: InputMaybe<TriggeredCampaignAvailableCreativesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggeredCampaignMessageAvailableCreativesQuery = { __typename?: 'Query', triggeredCampaignMessageAvailableCreatives: { __typename?: 'TriggeredCampaignAvailableCreativesConnection', edges: Array<{ __typename?: 'TriggeredCampaignAvailableCreativesEdge', cursor: string, node: { __typename?: 'Creative', id: string, title: string, status: CreativeStatus, bestThumbnail: { __typename?: 'Thumbnail', url: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TriggeredCampaignMessageDynamicBlockExperienceCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  blockId: Scalars['ID']['input'];
}>;


export type TriggeredCampaignMessageDynamicBlockExperienceCreateMutation = { __typename?: 'Mutation', triggeredCampaignMessageDynamicBlockExperienceCreate: { __typename: 'TriggeredCampaignMessageDynamicBlockExperienceCreateSuccess', success: boolean, id: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignMessageExperienceSelectCreativeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  experienceId: Scalars['ID']['input'];
  creativeId: Scalars['ID']['input'];
}>;


export type TriggeredCampaignMessageExperienceSelectCreativeMutation = { __typename?: 'Mutation', triggeredCampaignMessageExperienceSelectCreative: { __typename: 'TriggeredCampaignMessageExperienceSelectCreativeSuccess', success: boolean, id: string } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', reason: string }> } };

export type TriggeredCampaignTextAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggeredCampaignTextAttributeUpdateMutation = { __typename?: 'Mutation', triggeredCampaignTextAttributeUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignSelectAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TriggeredCampaignSelectAttributeUpdateMutation = { __typename?: 'Mutation', triggeredCampaignSelectAttributeUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignListAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TriggeredCampaignListAttributeUpdateMutation = { __typename?: 'Mutation', triggeredCampaignListAttributeUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignDateAttributeUpdateMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Date']['input']>;
}>;


export type TriggeredCampaignDateAttributeUpdateMutation = { __typename?: 'Mutation', triggeredCampaignDateAttributeUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredSettingsCustomFieldAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
}>;


export type TriggeredSettingsCustomFieldAddMutation = { __typename?: 'Mutation', triggeredCampaignCustomFieldAdd: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredSettingsCustomFieldUpdateMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggeredSettingsCustomFieldUpdateMutation = { __typename?: 'Mutation', triggeredCampaignCustomFieldUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredSettingsCustomFieldRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  customFieldId: Scalars['ID']['input'];
}>;


export type TriggeredSettingsCustomFieldRemoveMutation = { __typename?: 'Mutation', triggeredCampaignCustomFieldRemove: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignEmailServiceProviderUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  emailServiceProviderId: Scalars['ID']['input'];
}>;


export type TriggeredCampaignEmailServiceProviderUpdateMutation = { __typename?: 'Mutation', triggeredCampaignEmailServiceProviderUpdate: { __typename?: 'TriggeredCampaignEspConfigUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string } | null, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type TriggeredCampaignSeedAudienceAddMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type TriggeredCampaignSeedAudienceAddMutation = { __typename?: 'Mutation', triggeredCampaignSeedAudienceAdd: { __typename?: 'TriggeredCampaignAudienceSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignSeedAudienceRemoveMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type TriggeredCampaignSeedAudienceRemoveMutation = { __typename?: 'Mutation', triggeredCampaignSeedAudienceRemove: { __typename?: 'TriggeredCampaignAudienceSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignTextTrackingParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggeredCampaignTextTrackingParameterUpdateMutation = { __typename?: 'Mutation', triggeredCampaignTextTrackingParameterUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignSelectTrackingParameterUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  trackingParameterId: Scalars['ID']['input'];
  optionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TriggeredCampaignSelectTrackingParameterUpdateMutation = { __typename?: 'Mutation', triggeredCampaignSelectTrackingParameterUpdate: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

type TriggeredCustomFieldsFragment_DatetimeCustomField_Fragment = { __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null };

type TriggeredCustomFieldsFragment_NumberCustomField_Fragment = { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null };

type TriggeredCustomFieldsFragment_TextCustomField_Fragment = { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null };

export type TriggeredCustomFieldsFragmentFragment = TriggeredCustomFieldsFragment_DatetimeCustomField_Fragment | TriggeredCustomFieldsFragment_NumberCustomField_Fragment | TriggeredCustomFieldsFragment_TextCustomField_Fragment;

export type TriggeredCampaignSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type TriggeredCampaignSettingsQuery = { __typename?: 'Query', availableCustomFields: Array<{ __typename?: 'AvailableCustomField', id: string, name: string, title: string }>, triggeredCampaign?: { __typename?: 'TriggeredCampaignType', id: string, status: TriggeredCampaignStatus, seedContactAudiences?: Array<{ __typename?: 'ContactAudience', id: string, name: string }> | null, attributes: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, trackingParameters: Array<{ __typename?: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename?: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string } | { __typename: 'AdobeCampaign', id: string } | { __typename: 'AdobeJourneyOptimizer', id: string } | { __typename: 'AmazonSES', id: string } | { __typename: 'Blackhole' } | { __typename: 'Bluecore' } | { __typename: 'Braze', id: string } | { __typename: 'Cordial', id: string } | { __typename: 'Epsilon' } | { __typename: 'OracleResponsys', id: string } | { __typename: 'SFNext' } | { __typename: 'SalesForceMarketingCloud', id: string } | { __typename: 'Zeta', id: string } | null, espConfig?: { __typename?: 'AdobeJourneyOptimizerConfig', id: string } | { __typename?: 'AmazonSESConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | { __typename?: 'BlackholeConfig', id: string } | { __typename?: 'CampaignAcousticCampaignConfig', id: string, preprocessing?: { __typename?: 'CampaignAcousticCampaignPreprocessing', enabled: boolean, hours?: number | null } | null, acousticFromName: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticFromAddress: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, acousticReplyTo: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' } } | { __typename?: 'CampaignAdobeCampaignConfig', id: string, adobeCampaignLabel: string, adobeCampaignDeliveryCode: string, adobeCampaignFromName: string, adobeCampaignFromAddress: string, adobeCampaignReplyToName: string, adobeCampaignReplyToAddress: string, adobeCampaignTargetMappingId: number, adobeCampaignTypologyId?: number | null, adobeCampaignWebAnalyticsAccount?: number | null, adobeCampaignRoutingId: number, adobeCampaignDeliveryVariables: Array<{ __typename?: 'AdobeCampaignDeliveryVariable', id: string, value: string, availableDeliveryVariableId?: string | null }>, adobeCampaignAvailableDeliveryVariables: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryVariable', id: string, name: string, defaultValue: string }>, adobeCampaignDeliveryNature?: { __typename?: 'AdobeCampaignDeliveryNature', id: string, label: string, availableDeliveryNatureId?: string | null } | null, adobeCampaignAvailableDeliveryNatures: Array<{ __typename?: 'AvailableAdobeCampaignDeliveryNature', id: string, label: string }> } | { __typename?: 'CampaignCordialConfig', id: string, tags: Array<string>, senderProfile: { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } }, excludeAudiences2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, defaultSendProperties: Array<{ __typename?: 'DefaultCordialSendProperty', id: string, name: string }>, sendProperties?: Array<{ __typename?: 'CordialSendProperty', id: string, defaultSendPropertyId?: string | null, value: string } | null> | null } | { __typename?: 'CampaignEpsilonConfig', id: string } | { __typename?: 'CampaignOracleResponsysConfig', id: string, marketingProgram2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, marketingStrategy2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressions2?: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' } | null, fromName2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, fromEmail2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, replyTo2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, profileList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, campaignVariables: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, additionalDataSources2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, externalTrackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatString?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute2', id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'NumberAttribute', id: string, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }> } | { __typename?: 'CampaignSalesforceMarketingCloudConfig', id: string, isSendLogging: boolean, sendLimit?: number | null, messageDeliveryType: MessageDeliveryType, senderProfile2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, sendClassification2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, publicationList2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2' } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2', id: string, selectedId?: string | null, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'TextAttribute' }, suppressionDataExtensions2: { __typename?: 'CheckboxAttribute' } | { __typename?: 'DateAttribute' } | { __typename?: 'DateTimeAttribute' } | { __typename?: 'FormatStringAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'MultiSelectAttribute' } | { __typename?: 'MultiSelectAttribute2', id: string, selectedIds: Array<string>, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename?: 'NumberAttribute' } | { __typename?: 'SelectAttribute' } | { __typename?: 'SelectAttribute2' } | { __typename?: 'TextAttribute' }, delayedDelivery?: { __typename?: 'CampaignSalesforceMarketingCloudDelayedDelivery', enabled: boolean, prebuildDuration?: number | null } | null } | { __typename?: 'ZetaConfig', id: string, emailTags: Array<{ __typename?: 'EmailTag', id: string, emailTagId: string, value: string }>, availableEmailTags: Array<{ __typename?: 'AvailableEmailTag', id: string, tagName: string, defaultValue: string }> } | null, customFields: Array<{ __typename?: 'DatetimeCustomField', id: string, title: string, dateTimeValue?: string | null } | { __typename?: 'NumberCustomField', id: string, title: string, intValue?: number | null } | { __typename?: 'TextCustomField', id: string, title: string, textValue?: string | null }> } | null };

export type TriggeredCampaignTriggerTabQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggeredCampaignTriggerTabQuery = { __typename?: 'Query', triggeredCampaign?: { __typename?: 'TriggeredCampaignType', id: string, triggerSource: TriggerSource, reEntryCriteria?: TriggeredCampaignReEntryCriteria | null, patternEngineBinding?: { __typename?: 'TriggeredCampaignPatternEngineBindingType', patternUuid?: string | null, triggerRule?: string | null } | null } | null };

export type TriggeredCampaignTriggerRuleUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  triggerRule: Scalars['JSONString']['input'];
}>;


export type TriggeredCampaignTriggerRuleUpdateMutation = { __typename?: 'Mutation', triggeredCampaignTriggerRuleUpdate: { __typename: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, triggerSource: TriggerSource, patternEngineBinding?: { __typename?: 'TriggeredCampaignPatternEngineBindingType', patternUuid?: string | null, triggerRule?: string | null } | null } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type TriggeredCampaignReEntryCriteriaUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reEntryCriteria: TriggeredCampaignReEntryCriteria;
}>;


export type TriggeredCampaignReEntryCriteriaUpdateMutation = { __typename?: 'Mutation', triggeredCampaignReEntryCriteriaUpdate: { __typename: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, reEntryCriteria?: TriggeredCampaignReEntryCriteria | null } } | { __typename: 'ValidationErrors', success: boolean, errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string }> } };

export type TriggeredCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggeredCampaignQuery = { __typename?: 'Query', triggeredCampaign?: { __typename?: 'TriggeredCampaignType', id: string, hashid: string, title: string, status: TriggeredCampaignStatus, stage: TriggeredCampaignStage, triggerSource: TriggerSource, channel: { __typename?: 'ChannelSpec', category: ChannelCategory, channel: Channel }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type TriggeredCampaignStateTransitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  state: TriggeredCampaignStatus;
}>;


export type TriggeredCampaignStateTransitionMutation = { __typename?: 'Mutation', triggeredCampaignStateTransition: { __typename?: 'TriggeredCampaignAttributeUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, status: TriggeredCampaignStatus, stage: TriggeredCampaignStage } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggeredCampaignDeleteMutation = { __typename?: 'Mutation', triggeredCampaignDelete: { __typename?: 'TriggeredCampaignDeleteSuccess', success: boolean } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type TriggeredCampaignDetailsUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TriggeredCampaignDetailsUpdateMutation = { __typename?: 'Mutation', triggeredCampaignDetailsUpdate: { __typename?: 'TriggeredCampaignDetailsUpdateSuccess', success: boolean, triggeredCampaign: { __typename?: 'TriggeredCampaignType', id: string, title: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } } | { __typename?: 'ValidationErrors', errors: Array<{ __typename?: 'ValidationError', field?: string | null, reason: string, code?: string | null }> } };

export type ChannelFeatureFlagsFragmentFragment = { __typename?: 'Client', hasSMSChannel: boolean, hasMMSChannel: boolean, hasRCSChannel: boolean, hasPushChannel: boolean, hasInAppChannel: boolean };

export type FeatureFlagsFragmentFragment = { __typename?: 'Client', hasHardRefreshClientSwitcher: boolean, hasMfa: boolean, hasCustomFields: boolean, aiGeneratedSl: boolean, canCreateSavedView: boolean, contactReplaceImports: boolean, analyticsV2Access: boolean, hasCampaignProofingAgent: boolean, hasAiAssistedSubjectLines: boolean, hasCreativeChannelConverterAssistant: boolean, semanticLabelsEnabled: boolean, shouldDisplayAuth0MigrationAlert: boolean, hasAudienceOverrides: boolean, hasTableRelationships: boolean, hasNewAudiencesByDefault: boolean, hasCampaignFieldOverrides: boolean, hasIdColumnTableFields: boolean, hasFrequencyToggle: boolean, hasPrograms: boolean, hasEmailDataTypeOption: boolean, isAbleToDeleteTags: boolean, isAbleToExpireTags: boolean, hasToneLabelDropdown: boolean, hasUnifiedAudienceBuilder: boolean, hasExperimentAudiences: boolean, hasAccountPermissions: boolean, hasAccountCustomRole: boolean, disableMixpanelSessionRecord: boolean, hasSubjectLineEnhancements: boolean, hasAudienceFilters: boolean, hasSlsV2: boolean, enableAiFeatures: boolean, hasCopilot: boolean, hasCreativeEffectivenessV2: boolean, hasAudiencesCampaignsFilter: boolean, hasPrimaryContentBlockFilter: boolean, supportMultipleEsps: boolean, hasAnalyticsCustomEvents: boolean, hasDirectCdnUpload: boolean, hasMobileImageUpload: boolean, hasContentVariants: boolean, hasChannelKey: boolean, hasNonWebsafeFontsInEditor: boolean, hasBackgroundImageInEditor: boolean, hasAccountPrivacy: boolean, hasAudienceUnarchiveOption: boolean, hasCampaignAudienceOverlap: boolean, hasAudienceDetailPage: boolean, hasAnalyticsIndexRecurringExports: boolean, hasExportAnalyticsDetailPage: boolean, hasReportingMultichannel: boolean, hasReportingPushMultichannel: boolean, hasDataFieldDescription: boolean, hasExperimentalAlertsRemoved: boolean, hasBrandKitLinkStyles: boolean, hasBrandKitMobileStyles: boolean, enableBrandKitStyleDuplication: boolean, hasEncryptionV2: boolean, hasManagedCardSummary: boolean, hasRawDataSubjectRequestError: boolean, hasEditorMobileControls: boolean, hasSendTimePersonalizationDisabled: boolean, hasEditorComponents: boolean, hasEditorVariables: boolean, hasNewDisclaimerRichtextEditor: boolean, hasCreativeEditorV2: boolean, hasJourneyBuilder: boolean, hasBrandKitComponents: boolean, hasBrandKitBlocks: boolean, hasBrandKitAiGuidelines: boolean, hasReportingDashboard: boolean, hasMessageBuilderStartFromScratch: boolean, hasMessageBuilder: boolean, hasMessageBuilderZones: boolean, hasMessageBuilderPreview: boolean, hasTableRowTtl: boolean, hasSmartStandardRerun: boolean, hasRecurringCampaigns: boolean, hasTriggeredCampaigns: boolean, hasReportingRecurringCampaigns: boolean, hasReportingTriggerCampaigns: boolean, hasTableRowCount: boolean, hasReportingDataFiltering: boolean, hasReportingIndirectAttribution: boolean, hasConfigureCreativeEligibility: boolean, hasDemoAudienceCounts: boolean, hasDemoPositiveMetrics: boolean, hasContactLevelEventExportUi: boolean, hasSavedFilter: boolean, hasDemoFriendlyUI: boolean, hasEligibilityTabUxUpdates: boolean, hasContactBasedMetrics: boolean, hasCreativeTagHeatmap: boolean, hasCreativePurpose: boolean, hasDatasetsUi: boolean, hasConfigurableKpi: boolean, hasDynamicAudiences: boolean, hasPushTrackingParams: boolean, hasUnifiedMessagingNav: boolean, hasUserLifecycle: boolean, hasUnlockComponents: boolean, hasAiAudienceBuilder: boolean, hasPlatformApplicationPermission: boolean };

export type CurrentSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSessionQuery = { __typename?: 'Query', availableClients: Array<{ __typename?: 'Client', id: string, displayName: string }>, currentUser: { __typename?: 'User', id: string, isStaff: boolean, initials?: string | null, fullName?: string | null, email: string, featureAccess: UserFeatureAccessType, hasSeenCampaignV2Intro: boolean, isSuspended: boolean, isDeveloper: boolean } };

type EspMetadataFields_AcousticCampaign_Fragment = { __typename: 'AcousticCampaign', id: string, displayName: string };

type EspMetadataFields_AdobeCampaign_Fragment = { __typename: 'AdobeCampaign', id: string, displayName: string };

type EspMetadataFields_AdobeJourneyOptimizer_Fragment = { __typename: 'AdobeJourneyOptimizer', id: string, displayName: string };

type EspMetadataFields_AmazonSes_Fragment = { __typename: 'AmazonSES', id: string, displayName: string };

type EspMetadataFields_Blackhole_Fragment = { __typename: 'Blackhole', id: string, displayName: string };

type EspMetadataFields_Bluecore_Fragment = { __typename: 'Bluecore', id: string, displayName: string };

type EspMetadataFields_Braze_Fragment = { __typename: 'Braze', id: string, displayName: string };

type EspMetadataFields_Cordial_Fragment = { __typename: 'Cordial', id: string, displayName: string };

type EspMetadataFields_Epsilon_Fragment = { __typename: 'Epsilon', id: string, displayName: string };

type EspMetadataFields_OracleResponsys_Fragment = { __typename: 'OracleResponsys', id: string, displayName: string, linkCategories: Array<{ __typename?: 'OracleResponsysLinkCategory', id: string, title: string }> };

type EspMetadataFields_SfNext_Fragment = { __typename: 'SFNext', id: string, displayName: string };

type EspMetadataFields_SalesForceMarketingCloud_Fragment = { __typename: 'SalesForceMarketingCloud', id: string, displayName: string };

type EspMetadataFields_Zeta_Fragment = { __typename: 'Zeta', id: string, displayName: string };

export type EspMetadataFieldsFragment = EspMetadataFields_AcousticCampaign_Fragment | EspMetadataFields_AdobeCampaign_Fragment | EspMetadataFields_AdobeJourneyOptimizer_Fragment | EspMetadataFields_AmazonSes_Fragment | EspMetadataFields_Blackhole_Fragment | EspMetadataFields_Bluecore_Fragment | EspMetadataFields_Braze_Fragment | EspMetadataFields_Cordial_Fragment | EspMetadataFields_Epsilon_Fragment | EspMetadataFields_OracleResponsys_Fragment | EspMetadataFields_SfNext_Fragment | EspMetadataFields_SalesForceMarketingCloud_Fragment | EspMetadataFields_Zeta_Fragment;

export type CurrentClientQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClientQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: string, name: string, displayName: string, squareLogo?: string | null, timezone: string, defaultStoInterval: number, analyticsCalendar?: AnalyticsCalendar | null, analyticsCurrency?: AnalyticsCurrency | null, analyticsStatSigThreshold?: number | null, analyticsAttributionWindow?: AnalyticsAttributionWindow | null, analyticsExportDecimalPrecision: number, analyticsExportRateFormat: AnalyticsExportRateFormat, autoInclude: AutoInclude, enablePersadoCampaign: boolean, enableProofing: boolean, enableNewProofRecommendationRun: boolean, enableConversionTracking: boolean, desktopEmailWidth: number, mobileEmailWidth: number, tones?: Array<string> | null, primarySubjectLineRequired: boolean, preheaderTextSetting: InboxPreviewFieldSetting, enableDisclaimerLayouts: boolean, enforceLinkDomainAllowlist: boolean, linkDomainAllowlist: Array<string>, canUploadImages: boolean, hasCdnConfig: boolean, hasHardRefreshClientSwitcher: boolean, hasMfa: boolean, hasCustomFields: boolean, aiGeneratedSl: boolean, canCreateSavedView: boolean, contactReplaceImports: boolean, analyticsV2Access: boolean, hasCampaignProofingAgent: boolean, hasAiAssistedSubjectLines: boolean, hasCreativeChannelConverterAssistant: boolean, semanticLabelsEnabled: boolean, shouldDisplayAuth0MigrationAlert: boolean, hasAudienceOverrides: boolean, hasTableRelationships: boolean, hasNewAudiencesByDefault: boolean, hasCampaignFieldOverrides: boolean, hasIdColumnTableFields: boolean, hasFrequencyToggle: boolean, hasPrograms: boolean, hasEmailDataTypeOption: boolean, isAbleToDeleteTags: boolean, isAbleToExpireTags: boolean, hasToneLabelDropdown: boolean, hasUnifiedAudienceBuilder: boolean, hasExperimentAudiences: boolean, hasAccountPermissions: boolean, hasAccountCustomRole: boolean, disableMixpanelSessionRecord: boolean, hasSubjectLineEnhancements: boolean, hasAudienceFilters: boolean, hasSlsV2: boolean, enableAiFeatures: boolean, hasCopilot: boolean, hasCreativeEffectivenessV2: boolean, hasAudiencesCampaignsFilter: boolean, hasPrimaryContentBlockFilter: boolean, supportMultipleEsps: boolean, hasAnalyticsCustomEvents: boolean, hasDirectCdnUpload: boolean, hasMobileImageUpload: boolean, hasContentVariants: boolean, hasChannelKey: boolean, hasNonWebsafeFontsInEditor: boolean, hasBackgroundImageInEditor: boolean, hasAccountPrivacy: boolean, hasAudienceUnarchiveOption: boolean, hasCampaignAudienceOverlap: boolean, hasAudienceDetailPage: boolean, hasAnalyticsIndexRecurringExports: boolean, hasExportAnalyticsDetailPage: boolean, hasReportingMultichannel: boolean, hasReportingPushMultichannel: boolean, hasDataFieldDescription: boolean, hasExperimentalAlertsRemoved: boolean, hasBrandKitLinkStyles: boolean, hasBrandKitMobileStyles: boolean, enableBrandKitStyleDuplication: boolean, hasEncryptionV2: boolean, hasManagedCardSummary: boolean, hasRawDataSubjectRequestError: boolean, hasEditorMobileControls: boolean, hasSendTimePersonalizationDisabled: boolean, hasEditorComponents: boolean, hasEditorVariables: boolean, hasNewDisclaimerRichtextEditor: boolean, hasCreativeEditorV2: boolean, hasJourneyBuilder: boolean, hasBrandKitComponents: boolean, hasBrandKitBlocks: boolean, hasBrandKitAiGuidelines: boolean, hasReportingDashboard: boolean, hasMessageBuilderStartFromScratch: boolean, hasMessageBuilder: boolean, hasMessageBuilderZones: boolean, hasMessageBuilderPreview: boolean, hasTableRowTtl: boolean, hasSmartStandardRerun: boolean, hasRecurringCampaigns: boolean, hasTriggeredCampaigns: boolean, hasReportingRecurringCampaigns: boolean, hasReportingTriggerCampaigns: boolean, hasTableRowCount: boolean, hasReportingDataFiltering: boolean, hasReportingIndirectAttribution: boolean, hasConfigureCreativeEligibility: boolean, hasDemoAudienceCounts: boolean, hasDemoPositiveMetrics: boolean, hasContactLevelEventExportUi: boolean, hasSavedFilter: boolean, hasDemoFriendlyUI: boolean, hasEligibilityTabUxUpdates: boolean, hasContactBasedMetrics: boolean, hasCreativeTagHeatmap: boolean, hasCreativePurpose: boolean, hasDatasetsUi: boolean, hasConfigurableKpi: boolean, hasDynamicAudiences: boolean, hasPushTrackingParams: boolean, hasUnifiedMessagingNav: boolean, hasUserLifecycle: boolean, hasUnlockComponents: boolean, hasAiAudienceBuilder: boolean, hasPlatformApplicationPermission: boolean, hasSMSChannel: boolean, hasMMSChannel: boolean, hasRCSChannel: boolean, hasPushChannel: boolean, hasInAppChannel: boolean, emailServiceProviders: Array<{ __typename: 'AcousticCampaign', id: string, displayName: string } | { __typename: 'AdobeCampaign', id: string, displayName: string } | { __typename: 'AdobeJourneyOptimizer', id: string, displayName: string } | { __typename: 'AmazonSES', id: string, displayName: string } | { __typename: 'Blackhole', id: string, displayName: string } | { __typename: 'Bluecore', id: string, displayName: string } | { __typename: 'Braze', id: string, displayName: string } | { __typename: 'Cordial', id: string, displayName: string } | { __typename: 'Epsilon', id: string, displayName: string } | { __typename: 'OracleResponsys', id: string, displayName: string, linkCategories: Array<{ __typename?: 'OracleResponsysLinkCategory', id: string, title: string }> } | { __typename: 'SFNext', id: string, displayName: string } | { __typename: 'SalesForceMarketingCloud', id: string, displayName: string } | { __typename: 'Zeta', id: string, displayName: string }>, defaultBlockConfiguration: { __typename?: 'DefaultBlockConfiguration', mode?: DefaultExperienceMode | null, personalization?: DefaultPersonalization | null }, emailServiceProvider?: { __typename: 'AcousticCampaign', id: string, displayName: string } | { __typename: 'AdobeCampaign', id: string, displayName: string } | { __typename: 'AdobeJourneyOptimizer', id: string, displayName: string } | { __typename: 'AmazonSES', id: string, displayName: string } | { __typename: 'Blackhole', id: string, displayName: string } | { __typename: 'Bluecore', id: string, displayName: string } | { __typename: 'Braze', id: string, displayName: string } | { __typename: 'Cordial', id: string, displayName: string } | { __typename: 'Epsilon', id: string, displayName: string } | { __typename: 'OracleResponsys', id: string, displayName: string, linkCategories: Array<{ __typename?: 'OracleResponsysLinkCategory', id: string, title: string }> } | { __typename: 'SFNext', id: string, displayName: string } | { __typename: 'SalesForceMarketingCloud', id: string, displayName: string } | { __typename: 'Zeta', id: string, displayName: string } | null, fiscalCalendar?: { __typename?: 'Calendar', currentWeek: number } | null, reuseRule?: { __typename: 'ReuseRule', id: string, primaryClickDelay?: any | null, primaryConversionDelay?: any | null, primaryMaxUses?: number | null, primaryOpenDelay?: any | null, primarySendDelay?: any | null, otherClickDelay?: any | null, otherConversionDelay?: any | null, otherMaxUses?: number | null, otherOpenDelay?: any | null, otherSendDelay?: any | null } | null } };

export type GetUserPermissionsForAccountQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetUserPermissionsForAccountQuery = { __typename?: 'Query', userPermissionsForAccount: { __typename?: 'AccountRolePermissions', permissions: Array<{ __typename?: 'PermissionObject', name: string, title: string, description: string }> } };

export type BlockFragmentFragment = { __typename?: 'Block', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'BlockVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> };

export type GetBlockQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBlockQuery = { __typename?: 'Query', block: { __typename?: 'Block', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'BlockVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> } };

export type BlockRenameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type BlockRenameMutation = { __typename?: 'Mutation', blockRename: { __typename?: 'BlockSuccess', success: boolean, block: { __typename?: 'Block', id: string, name: string, updatedAt: string } } };

export type BlockSaveMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  document: Scalars['LayoutDocument']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlockSaveMutation = { __typename?: 'Mutation', blockSave: { __typename?: 'BlockSuccess', success: boolean, block: { __typename?: 'Block', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'BlockVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> } } };

export type LayoutComponentFragmentFragment = { __typename?: 'LayoutComponent', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'LayoutComponentVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> };

export type ContentComponentSaveMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  document: Scalars['LayoutDocument']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  usedBrandKitId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ContentComponentSaveMutation = { __typename?: 'Mutation', layoutComponentSave: { __typename?: 'LayoutComponentSuccess', success: boolean, layoutComponent: { __typename?: 'LayoutComponent', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'LayoutComponentVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> } } };

export type LayoutComponentThumbnailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayoutComponentThumbnailQuery = { __typename?: 'Query', layoutComponent: { __typename?: 'LayoutComponent', id: string, thumbnail: string } };

export type ContentComponentRenameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type ContentComponentRenameMutation = { __typename?: 'Mutation', layoutComponentRename: { __typename?: 'LayoutComponentSuccess', success: boolean, layoutComponent: { __typename?: 'LayoutComponent', id: string, name: string } } };

export type LayoutComponentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayoutComponentQuery = { __typename?: 'Query', layoutComponent: { __typename?: 'LayoutComponent', id: string, name: string, description: string, thumbnail: string, versions: Array<{ __typename?: 'LayoutComponentVersion', id: string, version: number, layout: { __typename?: 'ComponentLayout', snapshot?: SyncDocumentMsg | null, mediaLibrary: Array<{ __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null }>, linkLibrary: Array<{ __typename: 'Link2', id: string, url: string, name?: string | null, createdAt: string, enableConversionTracking: boolean, enableTracking: boolean, queryStringParameters: Array<Array<string>>, trackingParameters: Array<{ __typename: 'CheckboxAttribute', id: string, checked?: boolean | null, definition: { __typename: 'CheckboxAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateAttribute', id: string, dateValue?: string | null, definition: { __typename: 'DateAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'DateTimeAttribute', id: string, dateTimeValue?: string | null, definition: { __typename: 'DateTimeAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'FormatStringAttribute', id: string, formatStringValue?: string | null, definition: { __typename: 'FormatStringAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'ListAttribute', values: Array<string>, id: string, definition: { __typename: 'ListAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'MultiSelectAttribute', id: string, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }>, definition: { __typename: 'MultiSelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'MultiSelectAttribute2', selectedIds: Array<string>, id: string, definition: { __typename: 'MultiSelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'NumberAttribute', id: string, numberValue?: number | null, definition: { __typename: 'NumberAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } } | { __typename: 'SelectAttribute', id: string, definition: { __typename: 'SelectAttributeDefinition', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption', id: string, selected: boolean, title: string }> } } | { __typename: 'SelectAttribute2', selectedId?: string | null, id: string, definition: { __typename: 'SelectAttributeDefinition2', id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null, options: Array<{ __typename?: 'AttributeOption2', id: string, title: string }> } } | { __typename: 'TextAttribute', id: string, textValue?: string | null, definition: { __typename: 'TextAttributeDefinition', multiline: boolean, id: string, title: string, required: boolean, placeholder?: string | null, help?: string | null } }>, espMetadata: Array<{ __typename: 'Link2AcousticCampaignMetadata', name: string, acousticLinkType: LinkTypeAcousticCampaign } | { __typename: 'Link2AdobeCampaignMetadata', label: string, adobeCampaignTrackingType: LinkTrackingTypeAdobeCampaign } | { __typename: 'Link2AdobeJourneyOptimizerMetadata', adobeJourneyOptimizerTrackingType: LinkTrackingTypeAdobeJourneyOptimizer } | { __typename: 'Link2AmazonSESMetadata', amazonSesTags: string, sesEnableTracking: boolean } | { __typename: 'Link2BluecoreMetadata', enableTracking: boolean } | { __typename: 'Link2BrazeMetadata', alias: string } | { __typename: 'Link2CordialMetadata', name: string, enableTracking: boolean } | { __typename: 'Link2EpsilonMetadata', tracked: boolean, epsilonLinkType: LinkTypeEpsilon } | { __typename: 'Link2OracleResponsysMetadata', name: string, enableTracking: boolean, category?: { __typename: 'OracleResponsysLinkCategory', id: string, title: string, value: string, position: number } | null } | { __typename: 'Link2SalesForceMarketingCloudMetadata', alias: string, enableDeepLinks: boolean, enableConversionTracking: boolean } | { __typename: 'Link2ZetaMetadata', name: string, zetaTags: Array<string> }> }> } }> } };

export type ProofContactsAndGroupsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  channel?: InputMaybe<Channel>;
}>;


export type ProofContactsAndGroupsQuery = { __typename?: 'Query', proofContacts: Array<{ __typename?: 'PreviewContact', id: string, channel: Channel, emailAddress: string, channelId: string, firstName?: string | null, lastName?: string | null, sends: number, previewContactGroups: Array<{ __typename?: 'PreviewContactGroup', id: string, title: string, contactCount: number }> }>, proofContactGroups: Array<{ __typename?: 'PreviewContactGroup', id: string, title: string, contactCount: number, sends: number, contacts: Array<{ __typename?: 'PreviewContact', id: string, channel: Channel, channelId: string, emailAddress: string, firstName?: string | null, lastName?: string | null }> }> };

type MediaFields_ExternalMedia_Fragment = { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null };

type MediaFields_ManagedMedia_Fragment = { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null };

export type MediaFieldsFragment = MediaFields_ExternalMedia_Fragment | MediaFields_ManagedMedia_Fragment;

export type CreativeContentsFieldsFragment = { __typename?: 'Creative', contents: Array<{ __typename?: 'PushNotification', title?: string | null, body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null } | { __typename?: 'TextMessage', body: string, id: string, channel: Channel, media?: { __typename?: 'ExternalMedia', externalUrl: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | { __typename?: 'ManagedMedia', internalUrl: string, fileName: string, fileSize?: number | null, mediaType: string, id: string, uri: string, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null }> };

export type ContactAudienceFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactAudienceFieldsQuery = { __typename?: 'Query', contactAudienceFields: { __typename?: 'InkDavinciContactsV1AudienceFieldListResponse', tables: Array<{ __typename?: 'InkDavinciContactsV1AudienceFieldListResponseTable', id: string, name: string, fields: Array<{ __typename?: 'InkDavinciContactsV1AudienceFieldListResponseTableField', id: string, displayName: string, name: string, type: InkDavinciContactsV1AudienceFieldListResponseTableFieldTypeEnum }> }> } };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags: Array<{ __typename: 'Tag', id: string, name: string }> };

export type GetCreativeMetadataQueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type GetCreativeMetadataQuery = { __typename?: 'Query', creative: { __typename: 'Creative', id: string, title: string, status: CreativeStatus } };

export type SendTimeMetricsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type SendTimeMetricsQuery = { __typename?: 'Query', analyticsCampaignSendTimeMetrics: Array<{ __typename?: 'CampaignSendTimeMetrics', sendTime: string, sends: number }> };

export const EspAmazonSesFragmentFragmentDoc = gql`
    fragment espAmazonSESFragment on AmazonSESConfig {
  id
  emailTags {
    id
    emailTagId
    value
  }
  availableEmailTags {
    id
    tagName
    defaultValue
  }
}
    `;
export const CatalogFieldTypeFragmentDoc = gql`
    fragment CatalogFieldType on InkDataV1QueryCatalogType {
  string {
    __typename
  }
  integer {
    __typename
  }
  float {
    __typename
  }
  boolean {
    __typename
  }
  date {
    __typename
  }
  datetime {
    __typename
  }
  stringArray {
    __typename
  }
  integerArray {
    __typename
  }
  floatArray {
    __typename
  }
  dateArray {
    __typename
  }
  datetimeArray {
    __typename
  }
}
    `;
export const JourneyFieldsFragmentDoc = gql`
    fragment JourneyFields on Journey {
  id
  status
  configJson
  updatedAt
  tags {
    id
    name
  }
}
    `;
export const StudioDynamicFieldFragmentFragmentDoc = gql`
    fragment studioDynamicFieldFragment on DynamicField {
  name
  type
  options
  value
  readonly
  isDynamic
}
    `;
export const StudioCampaignFragmentFragmentDoc = gql`
    fragment studioCampaignFragment on StudioCampaign {
  id
  name
  key
  blockCount
  blocks {
    id
    name
    altText
    clickthroughUrl
    imageUrl
    embedCode
    dynamicFields {
      ...studioDynamicFieldFragment
    }
    createdAt
    updatedAt
  }
}
    ${StudioDynamicFieldFragmentFragmentDoc}`;
export const EspMetadataFieldsWithDefaultsFragmentDoc = gql`
    fragment espMetadataFieldsWithDefaults on EmailServiceProvider {
  __typename
  ... on AcousticCampaign {
    id
    displayName
    defaultLinkMetadata {
      __typename
      requiresName
      requiresLinkType
    }
  }
  ... on Cordial {
    id
    displayName
  }
  ... on OracleResponsys {
    id
    displayName
    linkCategories {
      id
      title
    }
    defaultLinkMetadata {
      requiresName
      requiresCategory
      __typename
    }
  }
  ... on SalesForceMarketingCloud {
    __typename
    id
    displayName
    defaultLinkMetadata {
      __typename
      id
      enableDeepLinks
      enableConversionTracking
      requiresAlias
    }
  }
  ... on AdobeCampaign {
    id
    displayName
  }
  ... on AdobeJourneyOptimizer {
    id
    displayName
  }
  ... on Epsilon {
    id
    displayName
  }
  ... on Zeta {
    id
    displayName
  }
  ... on AmazonSES {
    id
    displayName
  }
  ... on Bluecore {
    id
    displayName
  }
  ... on Blackhole {
    id
    displayName
  }
  ... on Braze {
    id
    displayName
  }
  ... on SFNext {
    id
    displayName
  }
}
    `;
export const CampaignComparisonBaseFieldsV2FragmentDoc = gql`
    fragment CampaignComparisonBaseFieldsV2 on Metric {
  __typename
  ... on CountMetric {
    id
    name
    count
    stats {
      diff
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on RateMetric {
    id
    name
    rate
    stats {
      lift
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on CurrencyMetric {
    id
    name
    currency
    stats {
      diff
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on CurrencyRateMetric {
    id
    name
    currencyRate
    stats {
      lift
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on CategoryMetric {
    id
    name
    category
  }
  ... on FractionalCountMetric {
    id
    name
    fractionalCount
    stats {
      diff
      ciLower
      ciUpper
      confidence
      significant
    }
  }
}
    `;
export const ComparativeRateStatisticsFieldsFragmentDoc = gql`
    fragment comparativeRateStatisticsFields on RateStatistics {
  ciLower
  ciUpper
  confidenceLevel
  isStatisticallySignificant
  lift
}
    `;
export const CampaignComparativeStatisticsFieldsV2FragmentDoc = gql`
    fragment CampaignComparativeStatisticsFieldsV2 on ComparativeStatistics {
  averageOrderValue {
    ...comparativeRateStatisticsFields
  }
  uniqueClickRate {
    ...comparativeRateStatisticsFields
  }
  uniqueConversionRate {
    ...comparativeRateStatisticsFields
  }
  uniqueOpenRate {
    ...comparativeRateStatisticsFields
  }
  revenuePerThousandSends {
    ...comparativeRateStatisticsFields
  }
  openRate {
    ...comparativeRateStatisticsFields
  }
  clickRate {
    ...comparativeRateStatisticsFields
  }
  conversionRate {
    ...comparativeRateStatisticsFields
  }
}
    ${ComparativeRateStatisticsFieldsFragmentDoc}`;
export const MetricSeriesFieldsFragmentDoc = gql`
    fragment MetricSeriesFields on MetricSeries {
  baselines {
    label
    value
  }
  groups {
    label
    value
  }
}
    `;
export const CampaignComparativeSeriesFieldsV2FragmentDoc = gql`
    fragment CampaignComparativeSeriesFieldsV2 on ComparativeMetricSeries {
  uniqueClicks {
    ...MetricSeriesFields
  }
  uniqueConversions {
    ...MetricSeriesFields
  }
  uniqueOpens {
    ...MetricSeriesFields
  }
  revenue {
    ...MetricSeriesFields
  }
  sends {
    ...MetricSeriesFields
  }
}
    ${MetricSeriesFieldsFragmentDoc}`;
export const CampaignsActivityFieldsFragmentDoc = gql`
    fragment CampaignsActivityFields on AnalyticsActivity {
  autoOpenRate
  autoOpens
  averageOrderValue
  clickRate
  clicks
  clickthroughRate
  complaintRate
  complaints
  conversionRate
  conversions
  uniqueConversions
  hardBounceRate
  hardBounces
  openRate
  opens
  revenue
  revenuePerSend
  revenuePerThousandSends
  sends
  softBounceRate
  softBounces
  uniqueAutoOpenRate
  uniqueAutoOpens
  uniqueClickRate
  uniqueClicks
  uniqueClickthroughRate
  uniqueOpenRate
  uniqueOpens
  unknownBounceRate
  unknownBounces
  unsubscribeRate
  unsubscribes
}
    `;
export const CreativeComparisonBaseFieldsFragmentDoc = gql`
    fragment CreativeComparisonBaseFields on AnalyticsV2BaseCreativeMetrics {
  averageOrderValue
  clicks
  uniqueClickRate
  uniqueConversionRate
  conversions
  uniqueImpressionRate
  impressions
  uniqueImpressions
  placements
  revenue
  revenuePerThousandPlacements
  uniqueClicks
  uniqueConversions
  uniqueImpressions
}
    `;
export const CreativeComparativeStatisticsFieldsFragmentDoc = gql`
    fragment CreativeComparativeStatisticsFields on ComparativeCreativeStatistics {
  uniqueAutoImpressionRate {
    ...comparativeRateStatisticsFields
  }
  autoImpressionRate {
    ...comparativeRateStatisticsFields
  }
  averageOrderValue {
    ...comparativeRateStatisticsFields
  }
  uniqueClickRate {
    ...comparativeRateStatisticsFields
  }
  clickRate {
    ...comparativeRateStatisticsFields
  }
  uniqueClickToImpressionRate {
    ...comparativeRateStatisticsFields
  }
  clickToImpressionRate {
    ...comparativeRateStatisticsFields
  }
  uniqueClickthroughRate {
    ...comparativeRateStatisticsFields
  }
  clickthroughRate {
    ...comparativeRateStatisticsFields
  }
  uniqueConversionRate {
    ...comparativeRateStatisticsFields
  }
  conversionRate {
    ...comparativeRateStatisticsFields
  }
  uniqueConversionToClickRate {
    ...comparativeRateStatisticsFields
  }
  conversionToClickRate {
    ...comparativeRateStatisticsFields
  }
  uniqueImpressionRate {
    ...comparativeRateStatisticsFields
  }
  impressionRate {
    ...comparativeRateStatisticsFields
  }
  revenuePerPlacement {
    ...comparativeRateStatisticsFields
  }
  revenuePerThousandPlacements {
    ...comparativeRateStatisticsFields
  }
}
    ${ComparativeRateStatisticsFieldsFragmentDoc}`;
export const CreativeComparativeSeriesFieldsFragmentDoc = gql`
    fragment CreativeComparativeSeriesFields on ComparativeCreativeMetricSeries {
  uniqueClicks {
    ...MetricSeriesFields
  }
  uniqueConversions {
    ...MetricSeriesFields
  }
  uniqueImpressions {
    ...MetricSeriesFields
  }
  revenue {
    ...MetricSeriesFields
  }
  placements {
    ...MetricSeriesFields
  }
}
    ${MetricSeriesFieldsFragmentDoc}`;
export const CreativeComparisonBaseFieldsV2FragmentDoc = gql`
    fragment CreativeComparisonBaseFieldsV2 on Metric {
  __typename
  ... on CountMetric {
    id
    name
    count
  }
  ... on RateMetric {
    id
    name
    rate
    stats {
      lift
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on CurrencyMetric {
    id
    name
    currency
    stats {
      diff
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on CurrencyRateMetric {
    id
    name
    currencyRate
    stats {
      lift
      ciUpper
      ciLower
      confidence
      significant
    }
  }
  ... on CategoryMetric {
    id
    name
    category
  }
  ... on FractionalCountMetric {
    id
    name
    fractionalCount
    stats {
      diff
      ciUpper
      ciLower
      confidence
      significant
    }
  }
}
    `;
export const CreativeComparativeStatisticsFieldsV2FragmentDoc = gql`
    fragment CreativeComparativeStatisticsFieldsV2 on ComparativeCreativeStatistics {
  uniqueAutoImpressionRate {
    ...comparativeRateStatisticsFields
  }
  autoImpressionRate {
    ...comparativeRateStatisticsFields
  }
  averageOrderValue {
    ...comparativeRateStatisticsFields
  }
  uniqueClickRate {
    ...comparativeRateStatisticsFields
  }
  clickRate {
    ...comparativeRateStatisticsFields
  }
  uniqueClickToImpressionRate {
    ...comparativeRateStatisticsFields
  }
  clickToImpressionRate {
    ...comparativeRateStatisticsFields
  }
  uniqueClickthroughRate {
    ...comparativeRateStatisticsFields
  }
  clickthroughRate {
    ...comparativeRateStatisticsFields
  }
  uniqueConversionRate {
    ...comparativeRateStatisticsFields
  }
  conversionRate {
    ...comparativeRateStatisticsFields
  }
  uniqueConversionToClickRate {
    ...comparativeRateStatisticsFields
  }
  conversionToClickRate {
    ...comparativeRateStatisticsFields
  }
  uniqueImpressionRate {
    ...comparativeRateStatisticsFields
  }
  impressionRate {
    ...comparativeRateStatisticsFields
  }
  revenuePerPlacement {
    ...comparativeRateStatisticsFields
  }
  revenuePerThousandPlacements {
    ...comparativeRateStatisticsFields
  }
}
    ${ComparativeRateStatisticsFieldsFragmentDoc}`;
export const CreativeComparativeSeriesFieldsV2FragmentDoc = gql`
    fragment CreativeComparativeSeriesFieldsV2 on ComparativeCreativeMetricSeries {
  uniqueClicks {
    ...MetricSeriesFields
  }
  uniqueConversions {
    ...MetricSeriesFields
  }
  uniqueImpressions {
    ...MetricSeriesFields
  }
  revenue {
    ...MetricSeriesFields
  }
  placements {
    ...MetricSeriesFields
  }
}
    ${MetricSeriesFieldsFragmentDoc}`;
export const NamedMetricSeriesFieldsFragmentDoc = gql`
    fragment NamedMetricSeriesFields on NamedMetricSeries {
  metric
  baselines {
    label
    value
  }
  groups {
    label
    value
  }
}
    `;
export const ContactSegmentFieldsFragmentDoc = gql`
    fragment ContactSegmentFields on ContactSegment {
  id
  segmentGroupId
  createdAt
  fallback
  segment: name
  priority
  query
  updatedAt
}
    `;
export const CampaignSavedViewFragmentFragmentDoc = gql`
    fragment CampaignSavedViewFragment on CampaignSavedViewType {
  id
  title
  createdAt
  updatedAt
  isDefault
  columns
  predefinedDateRange
  customDateRange
  groupBy
  filters {
    field
    operator
    values
  }
}
    `;
export const CreativeSavedViewFragmentFragmentDoc = gql`
    fragment CreativeSavedViewFragment on CreativeSavedViewType {
  id
  title
  createdAt
  updatedAt
  isDefault
  columns
  predefinedDateRange
  customDateRange
  groupBy
  filters {
    field
    operator
    values
  }
}
    `;
export const AnalyticsRateStatisticsFieldsFragmentDoc = gql`
    fragment AnalyticsRateStatisticsFields on AnalyticsRateStatistics {
  lift
  confidenceLevel
  ciLower
  ciUpper
  isStatisticallySignificant
}
    `;
export const AnalyticsComparativeStatisticsFieldsFragmentDoc = gql`
    fragment AnalyticsComparativeStatisticsFields on AnalyticsComparativeStatistics {
  statAutoOpenRate: autoOpenRate {
    ...AnalyticsRateStatisticsFields
  }
  statAverageOrderValue: averageOrderValue {
    ...AnalyticsRateStatisticsFields
  }
  statClickRate: clickRate {
    ...AnalyticsRateStatisticsFields
  }
  statClickthroughRate: clickthroughRate {
    ...AnalyticsRateStatisticsFields
  }
  statConversionRate: conversionRate {
    ...AnalyticsRateStatisticsFields
  }
  statUniqueConversionRate: uniqueConversionRate {
    ...AnalyticsRateStatisticsFields
  }
  statOpenRate: openRate {
    ...AnalyticsRateStatisticsFields
  }
  statRevenuePerSend: revenuePerSend {
    ...AnalyticsRateStatisticsFields
  }
  statRevenuePerThousandSends: revenuePerThousandSends {
    ...AnalyticsRateStatisticsFields
  }
  statUniqueAutoOpenRate: uniqueAutoOpenRate {
    ...AnalyticsRateStatisticsFields
  }
  statUniqueClickRate: uniqueClickRate {
    ...AnalyticsRateStatisticsFields
  }
  statUniqueClickthroughRate: uniqueClickthroughRate {
    ...AnalyticsRateStatisticsFields
  }
  statUniqueOpenRate: uniqueOpenRate {
    ...AnalyticsRateStatisticsFields
  }
  statUnsubscribeRate: unsubscribeRate {
    ...AnalyticsRateStatisticsFields
  }
}
    ${AnalyticsRateStatisticsFieldsFragmentDoc}`;
export const AnalyticsActivityFieldsFragmentDoc = gql`
    fragment AnalyticsActivityFields on AnalyticsActivity {
  autoOpenRate
  autoOpens
  averageOrderValue
  clickRate
  clicks
  clickthroughRate
  complaintRate
  complaints
  conversionRate
  conversions
  hardBounceRate
  hardBounces
  openRate
  opens
  revenue
  revenuePerSend
  revenuePerThousandSends
  sends
  softBounceRate
  softBounces
  uniqueAutoOpenRate
  uniqueAutoOpens
  uniqueClickRate
  uniqueClicks
  uniqueClickthroughRate
  uniqueConversions
  uniqueOpenRate
  uniqueOpens
  uniqueConversionRate
  unknownBounceRate
  unknownBounces
  unsubscribes
  unsubscribeRate
}
    `;
export const AnalyticsV2BaseTreatmentMetricsFieldsFragmentDoc = gql`
    fragment AnalyticsV2BaseTreatmentMetricsFields on AnalyticsV2BaseTreatmentMetrics {
  autoOpenRate
  autoOpenRateCiLower
  autoOpenRateCiUpper
  autoOpenRateConfidence
  autoOpenRateLift
  autoOpenRateSignificant
  autoOpens
  averageOrderValue
  averageOrderValueCiLower
  averageOrderValueCiUpper
  averageOrderValueConfidence
  averageOrderValueLift
  averageOrderValueSignificant
  clickRate
  clickRateCiLower
  clickRateCiUpper
  clickRateConfidence
  clickRateLift
  clickRateSignificant
  clickToOpenRate
  clickToOpenRateCiLower
  clickToOpenRateCiUpper
  clickToOpenRateConfidence
  clickToOpenRateLift
  clickToOpenRateSignificant
  clicks
  complaintRate
  complaints
  conversionRate
  conversionRateCiLower
  conversionRateCiUpper
  conversionRateConfidence
  conversionRateLift
  conversionRateSignificant
  conversionToClickRate
  conversionToClickRateCiLower
  conversionToClickRateCiUpper
  conversionToClickRateConfidence
  conversionToClickRateLift
  conversionToClickRateSignificant
  conversions
  hardBounceRate
  hardBounces
  messageRevenueVariance
  openRate
  openRateCiLower
  openRateCiUpper
  openRateConfidence
  openRateLift
  openRateSignificant
  opens
  orderRevenueVariance
  revenue
  revenuePerSend
  revenuePerSendCiLower
  revenuePerSendCiUpper
  revenuePerSendConfidence
  revenuePerSendLift
  revenuePerSendSignificant
  revenuePerThousandSends
  revenuePerThousandSendsCiLower
  revenuePerThousandSendsCiUpper
  revenuePerThousandSendsConfidence
  revenuePerThousandSendsLift
  revenuePerThousandSendsSignificant
  sendRatio
  sends
  uniqueConversionRate
  uniqueConversionRateLift
  uniqueConversionRateCiLower
  uniqueConversionRateCiUpper
  uniqueConversionRateConfidence
  uniqueConversionRateSignificant
  softBounceRate
  softBounces
  uniqueAutoOpens
  uniqueClicks
  uniqueConversions
  uniqueOpens
  unknownBounceRate
  unknownBounces
  unsubscribeRate
  unsubscribeRateCiLower
  unsubscribeRateCiUpper
  unsubscribeRateConfidence
  unsubscribeRateLift
  unsubscribeRateSignificant
}
    `;
export const AnalyticsV2BaseMetricsFieldsFragmentDoc = gql`
    fragment AnalyticsV2BaseMetricsFields on AnalyticsV2BaseMetrics {
  autoOpenRate
  autoOpens
  averageOrderValue
  clickRate
  clickToOpenRate
  clicks
  clickthroughRate
  complaintRate
  complaints
  conversionRate
  conversionToClickRate
  conversions
  hardBounceRate
  hardBounces
  messageRevenueVariance
  openRate
  opens
  orderRevenueVariance
  revenue
  revenuePerSend
  revenuePerThousandSends
  sends
  softBounceRate
  softBounces
  uniqueAutoOpenRate
  uniqueAutoOpens
  uniqueClickRate
  uniqueClickToOpenRate
  uniqueClicks
  uniqueClickthroughRate
  uniqueConversionRate
  uniqueConversions
  uniqueOpenRate
  uniqueOpens
  unknownBounceRate
  unknownBounces
  unsubscribeRate
  unsubscribes
}
    `;
export const AnalyticsV2BaseCreativeMetricsFieldsFragmentDoc = gql`
    fragment AnalyticsV2BaseCreativeMetricsFields on AnalyticsV2BaseCreativeMetrics {
  autoImpressionRate
  autoImpressions
  averageOrderValue
  clickRate
  clickToImpressionRate
  clicks
  clickthroughRate
  conversionRate
  uniqueConversionRate
  conversionToClickRate
  conversions
  decayedClicks
  impressionRate
  impressions
  orderRevenueVariance
  placementRevenueVariance
  placements
  revenue
  revenuePerPlacement
  revenuePerThousandPlacements
  uniqueAutoImpressions
  uniqueClicks
  uniqueConversions
  uniqueImpressions
}
    `;
export const AnalyticsBaseCreativeActivityFieldsFragmentDoc = gql`
    fragment AnalyticsBaseCreativeActivityFields on AnalyticsBaseCreativeActivity {
  autoImpressionRate
  autoImpressions
  averageOrderValue
  clickRate
  clicks
  clickthroughRate
  complaintRate
  complaints
  conversionRate
  conversions
  impressionRate
  impressions
  placements
  revenue
  revenuePerPlacement
  revenuePerThousandPlacements
  uniqueAutoImpressionRate
  uniqueAutoImpressions
  uniqueClickRate
  uniqueClicks
  uniqueClickthroughRate
  uniqueConversionToClickRate
  uniqueConversions
  uniqueImpressionRate
  uniqueImpressions
  unsubscribeRate
  unsubscribes
}
    `;
export const BaseCreativeMetricsFieldsFragmentDoc = gql`
    fragment BaseCreativeMetricsFields on BaseCreativeMetrics {
  autoImpressionRate
  autoImpressions
  averageOrderValue
  clickRate
  clicks
  clickthroughRate
  conversionRate
  conversions
  impressionRate
  impressions
  placements
  revenue
  revenuePerPlacement
  uniqueAutoImpressionRate
  uniqueAutoImpressions
  uniqueClickRate
  uniqueClicks
  uniqueClickthroughRate
  uniqueConversions
  uniqueImpressionRate
  uniqueImpressions
}
    `;
export const CategoryMetricFieldsFragmentDoc = gql`
    fragment CategoryMetricFields on CategoryMetric {
  id
  name
  group
  category
}
    `;
export const CountMetricFieldsFragmentDoc = gql`
    fragment CountMetricFields on CountMetric {
  id
  name
  group
  count
  stats {
    diff
    confidence
    ciLower
    ciUpper
    significant
  }
}
    `;
export const CurrencyMetricFieldsFragmentDoc = gql`
    fragment CurrencyMetricFields on CurrencyMetric {
  id
  name
  group
  currency
  stats {
    diff
    confidence
    ciLower
    ciUpper
    significant
  }
}
    `;
export const CurrencyRateMetricFieldsFragmentDoc = gql`
    fragment CurrencyRateMetricFields on CurrencyRateMetric {
  id
  name
  group
  currencyRate
  stats {
    lift
    confidence
    ciLower
    ciUpper
    significant
  }
}
    `;
export const RateMetricFieldsFragmentDoc = gql`
    fragment RateMetricFields on RateMetric {
  id
  name
  group
  rate
  stats {
    lift
    confidence
    ciLower
    ciUpper
    significant
  }
}
    `;
export const MetricWithStatsFieldsFragmentDoc = gql`
    fragment MetricWithStatsFields on Metric {
  id
  ... on CategoryMetric {
    category
  }
  ... on CountMetric {
    count
    stats {
      diff
      ciLower
      ciUpper
      confidence
      significant
    }
  }
  ... on CurrencyMetric {
    currency
    stats {
      diff
      ciLower
      ciUpper
      confidence
      significant
    }
  }
  ... on CurrencyRateMetric {
    currencyRate
    stats {
      lift
      confidence
      ciLower
      ciUpper
      significant
    }
  }
  ... on RateMetric {
    rate
    stats {
      lift
      confidence
      ciLower
      ciUpper
      significant
    }
  }
  ... on FractionalCountMetric {
    fractionalCount
    stats {
      diff
      ciLower
      ciUpper
      confidence
      significant
    }
  }
}
    `;
export const MetricFieldsFragmentDoc = gql`
    fragment MetricFields on Metric {
  id
  ... on CategoryMetric {
    id
    category
  }
  ... on CountMetric {
    id
    count
  }
  ... on CurrencyMetric {
    currency
  }
  ... on CurrencyRateMetric {
    currencyRate
  }
  ... on RateMetric {
    rate
  }
  ... on FractionalCountMetric {
    fractionalCount
  }
  ... on ScoreMetric {
    score
    label
  }
}
    `;
export const SavedFilterFragmentFragmentDoc = gql`
    fragment SavedFilterFragment on SavedFilterType {
  id
  title
  isDefault
  viewType
  filterData
  customDateRange
  predefinedDateRange
  createdAt
  updatedAt
  filterMetadata {
    field
    id
    title
  }
}
    `;
export const ContactAudienceBuildFieldsFragmentDoc = gql`
    fragment ContactAudienceBuildFields on ContactAudience {
  id
  name
  description
  query
  isEditable
  type
  experimentSeed
  splits {
    id
    createdAt
    updatedAt
    name
    query
    fallback
    ratio
    control
  }
  overrides {
    fieldId
    id
    splitId
    value {
      ... on ContactAudienceOverrideValueString {
        string
      }
      ... on ContactAudienceOverrideValueInteger {
        integer
      }
      ... on ContactAudienceOverrideValueFloat {
        float
      }
      ... on ContactAudienceOverrideValueBoolean {
        boolean
      }
      ... on ContactAudienceOverrideValueDateTime {
        datetime
      }
      ... on ContactAudienceOverrideValueDate {
        date
      }
    }
  }
}
    `;
export const CustomFontFragmentFragmentDoc = gql`
    fragment customFontFragment on CustomFont {
  id
  fontName
  fallback
  isDefault
  fontWeights
  fontStyles
  fontSource
  linkHref
  fontFaces {
    id
    src
    fontWeight
    fontStyle
    format
  }
}
    `;
export const LogoFragmentFragmentDoc = gql`
    fragment logoFragment on Logo {
  id
  url
}
    `;
export const ColorFragmentFragmentDoc = gql`
    fragment colorFragment on Color {
  id
  name
  slug
  hex
}
    `;
export const TypographyFragmentFragmentDoc = gql`
    fragment typographyFragment on Typography {
  id
  name
  slug
  type
  pseudoState
  semanticElement
  styles
  mobileStyles
}
    `;
export const BrandKitFragmentFragmentDoc = gql`
    fragment brandKitFragment on BrandKit {
  id
  name
  description
  logos {
    ...logoFragment
  }
  primaryLogoId
  colors {
    ...colorFragment
  }
  typographies {
    ...typographyFragment
  }
}
    ${LogoFragmentFragmentDoc}
${ColorFragmentFragmentDoc}
${TypographyFragmentFragmentDoc}`;
export const ContactAudienceConfigFragmentFragmentDoc = gql`
    fragment contactAudienceConfigFragment on ContactAudienceConfig {
  id
  name
  splitConfigs {
    id
    selected
    name
    split {
      id
      createdAt
      updatedAt
      name
      query
    }
  }
  contactAudience {
    id
    archived
    type
  }
}
    `;
export const ExperienceExperimentFieldsFragmentDoc = gql`
    fragment experienceExperimentFields on Experiment {
  id
  title
  experimentType
  treatmentsCount
  status
  treatments {
    id
    title
  }
  resultsRestrictedToStaff
  configurationRestrictedToStaff
}
    `;
export const CampaignDetailFieldsFragmentDoc = gql`
    fragment campaignDetailFields on Campaign {
  id
  status
  lastStatus {
    user {
      id
      fullName
    }
    timestamp
    status
  }
  stage
  title
  error
  legacyId
  sendDate
  autoSchedule
  autoCreativeInclusionPaused
  hasContactAudiences
  featureFlagExperiences2
  emailServiceProvider {
    __typename
  }
  channel {
    category
    channel
  }
  includedContactAudiences {
    id
    name
    contactAudience {
      id
      name
      archived
    }
  }
  tags {
    id
    name
  }
}
    `;
export const ContentFieldsFragmentDoc = gql`
    fragment contentFields on Content {
  id
  channel
  ... on PushNotification {
    title
    body
    media {
      ... on Media2 {
        id
        uri
        ... on ExternalMedia {
          externalUrl
        }
        ... on ManagedMedia {
          internalUrl
        }
      }
    }
  }
  ... on TextMessage {
    body
    media {
      ... on Media2 {
        id
        uri
        ... on ExternalMedia {
          externalUrl
        }
        ... on ManagedMedia {
          internalUrl
        }
      }
    }
  }
}
    `;
export const ExperiencesCreativesFieldsFragmentDoc = gql`
    fragment ExperiencesCreativesFields on Experiences2CreativeConnection {
  counts {
    allEligibleIncluded
    available
    availableDraft
    inUse
    included
    includedApproved
    incomplete
    prohibited
    total
  }
  edges {
    node {
      id
      availability
      inclusion
      incomplete
      thumbnail {
        url
      }
      creative {
        id
        title
        contents {
          ...contentFields
        }
        status
        tags {
          id
          name
        }
      }
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${ContentFieldsFragmentDoc}`;
export const Experiences2FieldsFragmentDoc = gql`
    fragment experiences2Fields on Experience2 {
  id
  title
  autoInclude
  includedCreatives(page: $page, pageSize: $pageSize, selectOnly: $selectOnly) {
    available
    availableDraft
    inUse
    included
    includedApproved
    incomplete
    prohibited
    total
    results {
      id
      availability2
      inclusion
      creative {
        id
        title
        status
        incomplete
        contents {
          ...contentFields
        }
        tags {
          id
          name
        }
      }
      incomplete
      thumbnail {
        url
      }
    }
  }
  visibility
  recsSettings {
    ignoreReuseRules
    ignoreCreativeFilters
  }
  targetRuleset {
    splits
    treatment
  }
}
    ${ContentFieldsFragmentDoc}`;
export const DynamicSectionsFieldsFragmentDoc = gql`
    fragment DynamicSectionsFields on DynamicSection {
  id
  title
  experiences2IncompleteExperiences {
    id
    title
    visibility
    recsSettings {
      ignoreReuseRules
      ignoreCreativeFilters
    }
    targetRuleset {
      splits
      treatment
    }
  }
  experiences2Count
  experiences2 {
    ...experiences2Fields
  }
  experiences2Axes {
    audiences
    experiment
  }
  experiences2UncoveredRuleset {
    splits
    treatment
  }
  experiences2Complete
  contentBlock {
    id
    numPositions
    type
  }
  isPrimary
  position
}
    ${Experiences2FieldsFragmentDoc}`;
export const IncompleteDynamicSectionsFieldsFragmentDoc = gql`
    fragment IncompleteDynamicSectionsFields on DynamicSection {
  id
  title
  experiences2IncompleteExperiences {
    id
    title
    visibility
    recsSettings {
      ignoreReuseRules
      ignoreCreativeFilters
    }
    targetRuleset {
      splits
      treatment
    }
  }
  experiences2Axes {
    audiences
    experiment
  }
}
    `;
export const SubjectlineFieldsFragmentDoc = gql`
    fragment subjectlineFields on CampaignSubjectLine {
  __typename
  ... on StaticMessage {
    message
  }
  ... on DynamicSubjectLine {
    complete
    rules {
      section {
        id
        position
        contentBlock {
          id
          title
        }
      }
    }
  }
}
    `;
export const DynamicContentBlockOptionsFieldsFragmentDoc = gql`
    fragment dynamicContentBlockOptionsFields on DynamicSection {
  id
  isPrimary
  position
  contentBlock {
    id
    title
    description
    numPositions
    type
  }
}
    `;
export const InboxStaticFieldsFragmentDoc = gql`
    fragment inboxStaticFields on StaticMessage {
  message
}
    `;
export const InboxDynamicFieldsFragmentDoc = gql`
    fragment inboxDynamicFields on DynamicContent {
  section {
    id
    position
    contentBlock {
      id
      title
    }
  }
}
    `;
export const InboxSubjectLinePersadoFieldsFragmentDoc = gql`
    fragment inboxSubjectLinePersadoFields on PersadoSubjectLine {
  persadoCampaign {
    id
    title
    externalId
    subjectLineScript
  }
}
    `;
export const InboxOnlyPreheaderFieldsFragmentDoc = gql`
    fragment inboxOnlyPreheaderFields on OnlyPreheader {
  ... on OnlyPreheader {
    preheader {
      ... on StaticMessageWithLink {
        message
        link {
          id
          url
          linkGroup {
            id
            name
          }
        }
      }
      ... on DynamicContent {
        missingExperiences2 {
          id
          visibility
          recsSettings {
            ignoreReuseRules
            ignoreCreativeFilters
          }
          targetRuleset {
            splits
            treatment
          }
        }
        missingTargetRuleset {
          splits
          treatment
        }
        incompleteCreatives {
          id
          title
        }
        section {
          id
          title
          position
          contentBlock {
            id
            numPositions
            title
            type
          }
        }
      }
    }
  }
}
    `;
export const InboxOnlyPreviewFieldsFragmentDoc = gql`
    fragment inboxOnlyPreviewFields on OnlyPreview {
  ... on OnlyPreview {
    preview {
      ... on StaticMessage {
        message
      }
      ... on DynamicContent {
        missingExperiences2 {
          id
          visibility
          recsSettings {
            ignoreReuseRules
            ignoreCreativeFilters
          }
          targetRuleset {
            splits
            treatment
          }
        }
        missingTargetRuleset {
          splits
          treatment
        }
        incompleteCreatives {
          id
          title
        }
        section {
          id
          title
          position
          contentBlock {
            id
            title
            numPositions
            type
          }
        }
      }
    }
  }
}
    `;
export const InboxBothPreviewPreheaderFieldsFragmentDoc = gql`
    fragment inboxBothPreviewPreheaderFields on BothPreviewPreheader {
  ... on BothPreviewPreheader {
    preheaderWithPreview {
      ... on StaticPreheaderWithPreview {
        preview
        preheader
        link {
          id
          url
          linkGroup {
            id
            name
          }
        }
      }
      ... on DynamicContent {
        missingExperiences2 {
          id
          visibility
          recsSettings {
            ignoreReuseRules
            ignoreCreativeFilters
          }
          targetRuleset {
            splits
            treatment
          }
        }
        missingTargetRuleset {
          splits
          treatment
        }
        incompleteCreatives {
          id
          title
        }
        section {
          id
          title
          position
          contentBlock {
            id
            numPositions
            title
            type
          }
        }
      }
    }
  }
}
    `;
export const SendScheduleFragmentFragmentDoc = gql`
    fragment SendScheduleFragment on Campaign {
  sendSchedule {
    treatment {
      id
      control
    }
    schedule {
      __typename
      ... on StaticSendSchedule {
        datetime
      }
      ... on PersonalizedSendSchedule {
        isFullDay
        datetimeRanges
      }
    }
  }
}
    `;
export const MessageExtrasFragmentFragmentDoc = gql`
    fragment messageExtrasFragment on Campaign {
  id
  messageExtras {
    id
    messageExtraKeyId
    value
  }
  messageExtraKeys {
    id
    keyName
    defaultValue
  }
}
    `;
export const BaseAttributeDefinitionFieldsFragmentDoc = gql`
    fragment BaseAttributeDefinitionFields on AttributeDefinition {
  __typename
  id
  title
  required
  placeholder
  help
}
    `;
export const CampaignAttributesFragmentFragmentDoc = gql`
    fragment campaignAttributesFragment on Attribute {
  id
  ... on TextAttribute {
    textValue: value
    definition {
      ...BaseAttributeDefinitionFields
      multiline
    }
  }
  ... on FormatStringAttribute {
    formatString: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on CheckboxAttribute {
    checked: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on SelectAttribute {
    options {
      id
      selected
      title
    }
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on SelectAttribute2 {
    selectedId
    definition {
      ...BaseAttributeDefinitionFields
      options {
        id
        title
      }
    }
  }
  ... on MultiSelectAttribute {
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on MultiSelectAttribute2 {
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on NumberAttribute {
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on ListAttribute {
    values
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on DateAttribute {
    dateValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on DateTimeAttribute {
    dateTimeValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const CampaignTrackingParametersFragmentFragmentDoc = gql`
    fragment campaignTrackingParametersFragment on Attribute {
  id
  ... on TextAttribute {
    textValue: value
    definition {
      ...BaseAttributeDefinitionFields
      multiline
    }
  }
  ... on FormatStringAttribute {
    formatString: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on CheckboxAttribute {
    checked: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on SelectAttribute {
    options {
      id
      selected
      title
    }
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on SelectAttribute2 {
    selectedId
    definition {
      ...BaseAttributeDefinitionFields
      options {
        id
        title
      }
    }
  }
  ... on MultiSelectAttribute {
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on MultiSelectAttribute2 {
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on NumberAttribute {
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on ListAttribute {
    values
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on DateAttribute {
    dateValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on DateTimeAttribute {
    dateTimeValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const CustomFieldsFragmentFragmentDoc = gql`
    fragment customFieldsFragment on CustomField {
  ... on TextCustomField {
    id
    textValue: value
    title
  }
  ... on NumberCustomField {
    id
    intValue: value
    title
  }
  ... on DatetimeCustomField {
    id
    dateTimeValue: value
    title
  }
}
    `;
export const ExperimentsFragmentFragmentDoc = gql`
    fragment experimentsFragment on Experiment {
  id
  title
  resultsRestrictedToStaff
  configurationRestrictedToStaff
  experimentType
  treatmentsCount
  treatments {
    id
    title
    order
    control
  }
  status
}
    `;
export const CampaignTemplateFieldsFragmentDoc = gql`
    fragment campaignTemplateFields on CampaignTemplate {
  template {
    id
    title
    description
    dynamicContentBlockCount
  }
  drift {
    sectionChanged
    templateChanged
  }
  sections {
    id
    isPrimary
    position
    zone
    ... on StaticSection {
      isExpanded
    }
    contentBlock {
      id
      title
      description
      numPositions
      type
      blockImageUrl
    }
  }
}
    `;
export const InboxSubjectLineDynamicFieldsFragmentDoc = gql`
    fragment inboxSubjectLineDynamicFields on DynamicSubjectLine {
  complete
  rules {
    id
    section {
      id
      position
      contentBlock {
        id
        numPositions
        title
        type
      }
    }
    creativesMissingSubjectLines {
      id
      title
    }
    missingExperiences2 {
      id
      visibility
      recsSettings {
        ignoreReuseRules
        ignoreCreativeFilters
      }
      targetRuleset {
        splits
        treatment
      }
    }
    missingTargetRuleset {
      splits
      treatment
    }
  }
  experiment {
    id
    title
    experimentType
    treatments {
      id
      title
      order
      control
    }
    resultsRestrictedToStaff
    configurationRestrictedToStaff
  }
  strategies {
    strategy
    treatment {
      id
      title
      control
      order
    }
  }
}
    `;
export const TagsFragmentFragmentDoc = gql`
    fragment tagsFragment on Tag {
  id
  name
}
    `;
export const CampaignFieldsFragmentDoc = gql`
    fragment campaignFields on Campaign {
  id
  legacyId
  title
  stage
  sendDate
  sendSchedule {
    id
    schedule {
      ... on StaticSendSchedule {
        datetime
      }
      ... on PersonalizedSendSchedule {
        isFullDay
        datetimeRanges
      }
    }
  }
  tags {
    id
    name
  }
  status
  error
  autoSchedule
  channel {
    category
    channel
  }
}
    `;
export const RecurringCampaignOccurrenceFieldsFragmentDoc = gql`
    fragment recurringCampaignOccurrenceFields on RCCalendarItem {
  occurrenceId
  scheduledFor
  status
  isProjected
  recurringCampaign {
    id
    title
    status
    stage
    stageGroup
    channel {
      category
      channel
    }
    schedule {
      rrule
      sendTime
      startDate
      endDate
      timezone
    }
  }
}
    `;
export const TriggeredCampaignFieldsFragmentDoc = gql`
    fragment triggeredCampaignFields on TriggeredCampaignType {
  id
  title
  status
  stage
  triggerSource
  channel {
    category
    channel
  }
  tags {
    id
    name
  }
}
    `;
export const DynamicFieldAttributesFragmentDoc = gql`
    fragment DynamicFieldAttributes on Attribute {
  id
  __typename
  ... on CheckboxAttribute {
    definition {
      ...BaseAttributeDefinitionFields
    }
    checked: value
  }
  ... on SelectAttribute2 {
    selectedId
    definition {
      ...BaseAttributeDefinitionFields
      options {
        id
        title
      }
    }
  }
  ... on SelectAttribute {
    definition {
      ...BaseAttributeDefinitionFields
      options {
        id
        selected
        title
      }
    }
  }
  ... on ListAttribute {
    values
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on DateAttribute {
    dateValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on DateTimeAttribute {
    definition {
      ...BaseAttributeDefinitionFields
    }
    dateTimeValue: value
  }
  ... on TextAttribute {
    textValue: value
    definition {
      ...BaseAttributeDefinitionFields
      multiline
    }
  }
  ... on FormatStringAttribute {
    formatStringValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on NumberAttribute {
    numberValue: value
    definition {
      ...BaseAttributeDefinitionFields
    }
  }
  ... on MultiSelectAttribute {
    options {
      id
      selected
      title
    }
    definition {
      ...BaseAttributeDefinitionFields
      options {
        id
        selected
        title
      }
    }
  }
  ... on MultiSelectAttribute2 {
    selectedIds
    definition {
      ...BaseAttributeDefinitionFields
      options {
        id
        title
      }
    }
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const Link2EspMetadataFieldsFragmentDoc = gql`
    fragment link2EspMetadataFields on Link2Metadata {
  __typename
  ... on Link2AcousticCampaignMetadata {
    name
    acousticLinkType: linkType
    __typename
  }
  ... on Link2CordialMetadata {
    name
    enableTracking
    __typename
  }
  ... on Link2OracleResponsysMetadata {
    name
    category {
      id
      title
      value
      position
      __typename
    }
    enableTracking
    __typename
  }
  ... on Link2SalesForceMarketingCloudMetadata {
    alias
    enableDeepLinks
    enableConversionTracking
    __typename
  }
  ... on Link2AdobeCampaignMetadata {
    label
    adobeCampaignTrackingType: trackingType
  }
  ... on Link2AdobeJourneyOptimizerMetadata {
    adobeJourneyOptimizerTrackingType: trackingType
    __typename
  }
  ... on Link2AmazonSESMetadata {
    amazonSesTags: tags
    sesEnableTracking: enableTracking
    __typename
  }
  ... on Link2EpsilonMetadata {
    __typename
    tracked
    epsilonLinkType: linkType
  }
  ... on Link2BrazeMetadata {
    alias
    __typename
  }
  ... on Link2ZetaMetadata {
    name
    __typename
    zetaTags: tags
  }
  ... on Link2BluecoreMetadata {
    enableTracking
    __typename
  }
}
    `;
export const Link2FieldsFragmentDoc = gql`
    fragment link2Fields on Link2 {
  __typename
  id
  url
  name
  createdAt
  enableConversionTracking
  enableTracking
  queryStringParameters
  trackingParameters {
    ...DynamicFieldAttributes
  }
  espMetadata {
    __typename
    ...link2EspMetadataFields
  }
}
    ${DynamicFieldAttributesFragmentDoc}
${Link2EspMetadataFieldsFragmentDoc}`;
export const StudioImportCampaignsFieldsFragmentDoc = gql`
    fragment StudioImportCampaignsFields on StudioCampaignImport {
  name
  studioId
  blocks {
    studioBlockId
    name
    image
    link
    altText
    backingLink {
      ...link2Fields
    }
    dynamicFields {
      ...studioDynamicFieldFragment
    }
  }
}
    ${Link2FieldsFragmentDoc}
${StudioDynamicFieldFragmentFragmentDoc}`;
export const MediaFieldsFragmentDoc = gql`
    fragment mediaFields on Media2 {
  id
  uri
  ... on ManagedMedia {
    internalUrl
    fileName
    fileSize
    mediaType
  }
  ... on ExternalMedia {
    externalUrl
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `;
export const StudioCampaignsFragmentFragmentDoc = gql`
    fragment StudioCampaignsFragment on Layout {
  studioCampaigns {
    ...StudioImportCampaignsFields
  }
  linkLibrary {
    ...link2Fields
  }
  mediaLibrary {
    ...mediaFields
  }
}
    ${StudioImportCampaignsFieldsFragmentDoc}
${Link2FieldsFragmentDoc}
${MediaFieldsFragmentDoc}`;
export const ImageFieldsFragmentDoc = gql`
    fragment ImageFields on Image {
  id
  filename
  publicUrl
  url
  hosted
  titleText
  altText
}
    `;
export const LinkFieldsFragmentDoc = gql`
    fragment linkFields on Link {
  id
  url
  shortUuid
  createdAt
  enableConversionTracking
  enableTracking
  queryStringParameters
  trackingParameters {
    ...DynamicFieldAttributes
  }
  salesforceMetadata {
    alias
    enableDeepLinks
    enableConversionTracking
  }
  oracleResponsysMetadata {
    name
    category {
      id
      title
      value
      position
    }
    enableTracking
  }
  cordialMetadata {
    name
    enableTracking
  }
  acousticCampaignMetadata {
    name
    linkType
  }
  epsilonMetadata {
    linkType
    tracked
  }
  adobeCampaignMetadata {
    label
    trackingType
  }
  adobeJourneyOptimizerMetadata {
    trackingType
  }
  amazonSesMetadata {
    tags
    enableTracking
  }
  brazeMetadata {
    alias
  }
  bluecoreMetadata {
    enableTracking
  }
  zetaMetadata {
    name
    tags
  }
}
    ${DynamicFieldAttributesFragmentDoc}`;
export const TemplateTagFieldsFragmentDoc = gql`
    fragment TemplateTagFields on TemplateTag {
  __typename
  id
  name
  ... on CheckboxTemplateTag {
    checkboxValue: value
  }
  ... on DateTemplateTag {
    dateValue: value
  }
  ... on HTMLBundleTemplateTag {
    htmlBundleValue: value {
      id
      title
      legacyId
    }
  }
  ... on ImageTemplateTag {
    imageValue: value {
      ...ImageFields
    }
  }
  ... on LayoutTemplateTag {
    layoutValue: value {
      id
      hasUnpublishedChanges
      name
      upgradeStatus
    }
  }
  ... on LinkTemplateTag {
    linkValue: value {
      ...linkFields
      linkGroup {
        id
        name
        linksCount
      }
    }
  }
  ... on TextTemplateTag {
    textValue: value
  }
  ... on TextAreaTemplateTag {
    textAreaValue: value
  }
  ... on SelectTemplateTag {
    selectValue: value {
      id
      name
      selected
    }
  }
  ... on MultiSelectTemplateTag {
    multiSelectValue: value {
      id
      name
      selected
    }
  }
}
    ${ImageFieldsFragmentDoc}
${LinkFieldsFragmentDoc}`;
export const ContentBlockConfigsFieldsFragmentDoc = gql`
    fragment ContentBlockConfigsFields on ContentBlockConfig {
  __typename
  incompleteCount
  thumbnails {
    __typename
    url
    downloadLink
  }
  contentBlock {
    __typename
    id
    title
    status
  }
  configuredTemplateTags {
    __typename
    id
    constraint
    templateTag {
      ...TemplateTagFields
    }
  }
}
    ${TemplateTagFieldsFragmentDoc}`;
export const CreativeDisclaimerTextFragmentFragmentDoc = gql`
    fragment creativeDisclaimerTextFragment on Creative {
  id
  __typename
  disclaimer
}
    `;
export const DisclaimerLayoutFragmentFragmentDoc = gql`
    fragment disclaimerLayoutFragment on DisclaimerLayout {
  id
  __typename
  supportedLayoutComplexity
  studioCampaigns {
    ...StudioImportCampaignsFields
  }
  mediaLibrary {
    ...mediaFields
  }
  linkLibrary {
    ...link2Fields
  }
}
    ${StudioImportCampaignsFieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${Link2FieldsFragmentDoc}`;
export const SubjectLinesFragmentFragmentDoc = gql`
    fragment subjectLinesFragment on Creative {
  id
  subjectLines {
    id
    content
    tone
    source
    isPrimary
    isArchived
  }
}
    `;
export const ReuseRuleFieldsFragmentDoc = gql`
    fragment reuseRuleFields on ReuseRule {
  __typename
  id
  primaryClickDelay
  primaryConversionDelay
  primaryMaxUses
  primaryOpenDelay
  primarySendDelay
  otherClickDelay
  otherConversionDelay
  otherMaxUses
  otherOpenDelay
  otherSendDelay
}
    `;
export const CreativePreheaderAndPreviewFieldsFragmentDoc = gql`
    fragment creativePreheaderAndPreviewFields on Creative {
  preheaderText2 {
    __typename
    ... on InboxTextSetting {
      enabled
      content
    }
    ... on InboxUnconfiguredSetting {
      enabled
    }
  }
  preheaderLink2 {
    __typename
    ... on InboxLinkSetting {
      enabled
      link {
        ...linkFields
        linkGroup {
          id
          name
          linksCount
        }
      }
    }
    ... on InboxUnconfiguredSetting {
      enabled
    }
  }
  previewText2 {
    __typename
    ... on InboxTextSetting {
      enabled
      content
    }
    ... on InboxUnconfiguredSetting {
      enabled
    }
  }
}
    ${LinkFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  isStaff
  email
  initials
  fullName
  hasSeenCampaignV2Intro
  isDeveloper
  isSuspended
}
    `;
export const CreativeDetailsFieldsFragmentDoc = gql`
    fragment creativeDetailsFields on Creative {
  id
  title
  legacyId
  previewText
  preheaderText
  subjectLinePrefix
  subjectLineSuffix
  createdAt
  createdBy {
    ...userFields
  }
  updatedAt
  updatedBy {
    ...userFields
  }
  slug
  status
  approvedBy {
    ...userFields
  }
  tags {
    __typename
    id
    name
  }
  prohibitedTags {
    id
    name
  }
  subjectLines {
    id
    content
    tone
    source
    isPrimary
    isArchived
  }
  thumbnails {
    contentBlock {
      id
    }
    url
    size
  }
  bestThumbnail {
    url
  }
  attributes {
    id
  }
  pairedCreatives {
    id
    title
  }
  pairedTags {
    id
    name
  }
  prohibitedCreatives {
    id
    title
  }
  prohibitedTags {
    id
    name
  }
  incomplete
  availabilities2
  attributes {
    ...DynamicFieldAttributes
  }
  trackingParameters {
    ...DynamicFieldAttributes
  }
  persadoCampaign {
    id
    title
    externalId
    subjectLineScript
  }
  hasCreativeDescription
}
    ${UserFieldsFragmentDoc}
${DynamicFieldAttributesFragmentDoc}`;
export const CreativeContentsFieldsFragmentDoc = gql`
    fragment creativeContentsFields on Creative {
  contents {
    id
    channel
    ... on PushNotification {
      title
      body
      media {
        ...mediaFields
      }
    }
    ... on TextMessage {
      body
      media {
        ...mediaFields
      }
    }
  }
}
    ${MediaFieldsFragmentDoc}`;
export const CreativeFieldsFragmentDoc = gql`
    fragment creativeFields on Creative {
  title
  shortUuid
  previewText
  preheaderText
  subjectLinePrefix
  subjectLineSuffix
  slug
  id
  status
  legacyId
  archivedAt
  archivedBy {
    id
    fullName
  }
  attributes {
    id
    title
    required
    placeholder
    help
  }
  availabilities2
  tags {
    id
    name
  }
  purpose {
    id
    name
    color
  }
  thumbnails {
    url
    contentBlock {
      id
      title
    }
    size
  }
  bestThumbnail {
    url
  }
  ...creativeContentsFields
}
    ${CreativeContentsFieldsFragmentDoc}`;
export const CreativeContentVersionsFragmentDoc = gql`
    fragment creativeContentVersions on Creative {
  id
  title
  contents {
    id
    channel
  }
  thumbnails {
    size
  }
}
    `;
export const DatasetsListFragmentFragmentDoc = gql`
    fragment DatasetsListFragment on InkDataV1Dataset {
  id
  name
  createdAt
  updatedAt
  type {
    delta {
      __typename
    }
  }
}
    `;
export const DatasetFetchFragmentFragmentDoc = gql`
    fragment DatasetFetchFragment on InkDataV1Dataset {
  id
  name
  description
  createdAt
  type {
    delta {
      __typename
    }
  }
}
    `;
export const DatasetFieldsFragmentFragmentDoc = gql`
    fragment DatasetFieldsFragment on InkDataV1DatasetField {
  id
  name
  displayName
  primaryKey
  type
}
    `;
export const ModelsListFragmentFragmentDoc = gql`
    fragment ModelsListFragment on InkDataV1Model {
  id
  key
  name
  description
  fields {
    id
    name
    displayName
    description
    primaryKey
    type
  }
}
    `;
export const JobsListV1FragmentFragmentDoc = gql`
    fragment JobsListV1Fragment on InkDataV1Job {
  id
  name
  description
  createdAt
  archived
  status
  schedule {
    daily {
      hour
      timezone
    }
    hourly {
      minute
    }
    minutely {
      interval
    }
  }
  metrics {
    totalRuns
    lastRunAt
    totalRunFailures
    lastRunFailureAt
  }
  spec {
    eventExport {
      eventType
    }
  }
}
    `;
export const DataJobsListFragmentFragmentDoc = gql`
    fragment DataJobsListFragment on InkDavinciDataV2Job {
  name
  id
  status
  type
  archived
  schedule {
    daily {
      hour
      timezone
    }
    hourly {
      minute
    }
  }
  metrics {
    lastRunAt
    totalRuns
  }
  config {
    importJob {
      columns {
        fieldId
        name
      }
      resource {
        compression
        connectionId
        format {
          csv {
            delimiter
            header
            null
          }
        }
        uri
      }
      tableId
      type
    }
    taggingJob {
      tableId
    }
  }
}
    `;
export const PlatformLinksFieldsFragmentDoc = gql`
    fragment platformLinksFields on PushNotification {
  platformLinks {
    id
    platform
    behavior
    link {
      id
      url
      queryStringParameters
      enableTracking
      trackingParameters {
        ...DynamicFieldAttributes
      }
    }
  }
}
    ${DynamicFieldAttributesFragmentDoc}`;
export const AlertRuleFieldsFragmentDoc = gql`
    fragment AlertRuleFields on AlertRuleWithSubscriptionsType {
  hashid
  title
  sourceId
  entityId
  isEnabled
  version
  createdAt
  updatedAt
  criteria {
    metricId
    operator
    threshold
  }
  eligibility {
    id
    config
  }
  userSubscriptions {
    channel
    isActive
  }
}
    `;
export const ProgramExperience2FieldsFragmentDoc = gql`
    fragment ProgramExperience2Fields on Experience2 {
  id
  title
  autoInclude
  excludedTags {
    id
    name
  }
  includedTags {
    id
    name
  }
  excludedCreatives {
    edges {
      node {
        id
        title
      }
      cursor
    }
  }
  includedCreatives(page: $page, pageSize: $pageSize, selectOnly: $selectOnly) {
    available
    availableDraft
    inUse
    included
    includedApproved
    incomplete
    page
    prohibited
    results {
      id
      inclusion
      thumbnail {
        url
      }
      availability2
      incomplete
      creative {
        id
        title
        status
        tags {
          id
          name
        }
      }
    }
    total
  }
  visibility
}
    `;
export const UberTemplateFieldsFragmentDoc = gql`
    fragment UberTemplateFields on UberTemplate {
  id
  variations {
    id
    title
    blueprint {
      id
    }
    contentBlocks {
      id
      isPrimary
      position
      contentBlock {
        id
        title
        description
        type
        numPositions
      }
    }
  }
}
    `;
export const CustomFieldFieldsFragmentDoc = gql`
    fragment CustomFieldFields on CustomField {
  ... on DatetimeCustomField {
    id
    title
    dateTimeValue: value
  }
  ... on NumberCustomField {
    id
    title
    intValue: value
  }
  ... on TextCustomField {
    id
    title
    textValue: value
  }
}
    `;
export const ProgramStateInfoFieldsFragmentDoc = gql`
    fragment ProgramStateInfoFields on ProgramStateInfo {
  state
  history {
    state
    user {
      fullName
    }
    timestamp
  }
  transitions {
    label
    state
    permission {
      ... on TransitionPermissionAllowed {
        allowed
      }
      ... on TransitionPermissionDenied {
        allowed
        code
        message
      }
    }
  }
  actions {
    id
    label
  }
}
    `;
export const EspSalesForceFragmentFragmentDoc = gql`
    fragment espSalesForceFragment on CampaignSalesforceMarketingCloudConfig {
  id
  isSendLogging
  sendLimit
  messageDeliveryType
  senderProfile2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  sendClassification2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  publicationList2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  suppressionDataExtensions2 {
    ... on MultiSelectAttribute2 {
      id
      selectedIds
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  delayedDelivery {
    enabled
    prebuildDuration
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const EspAcousticFragmentFragmentDoc = gql`
    fragment espAcousticFragment on CampaignAcousticCampaignConfig {
  id
  preprocessing {
    enabled
    hours
  }
  acousticFromName: fromName2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  acousticFromAddress: fromAddress2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  acousticReplyTo: replyTo2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const EspOracleFragmentFragmentDoc = gql`
    fragment espOracleFragment on CampaignOracleResponsysConfig {
  id
  marketingProgram2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  marketingStrategy2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  suppressions2 {
    ... on MultiSelectAttribute2 {
      id
      selectedIds
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  fromName2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  fromEmail2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  replyTo2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  profileList2 {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  campaignVariables {
    __typename
    id
    ... on TextAttribute {
      textValue: value
      definition {
        ...BaseAttributeDefinitionFields
        multiline
      }
    }
    ... on FormatStringAttribute {
      formatString: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on CheckboxAttribute {
      checked: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on ListAttribute {
      values
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on DateAttribute {
      dateValue: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on DateTimeAttribute {
      dateTimeValue: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on SelectAttribute2 {
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
    ... on SelectAttribute {
      options {
        id
        selected
        title
      }
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on MultiSelectAttribute {
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on MultiSelectAttribute2 {
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on NumberAttribute {
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
  }
  additionalDataSources2 {
    ... on MultiSelectAttribute2 {
      id
      selectedIds
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  externalTrackingParameters {
    __typename
    id
    ... on TextAttribute {
      textValue: value
      definition {
        ...BaseAttributeDefinitionFields
        multiline
      }
    }
    ... on FormatStringAttribute {
      formatString: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on CheckboxAttribute {
      checked: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on ListAttribute {
      values
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on DateAttribute {
      dateValue: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on DateTimeAttribute {
      dateTimeValue: value
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on SelectAttribute2 {
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
    ... on SelectAttribute {
      options {
        id
        selected
        title
      }
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on MultiSelectAttribute {
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on MultiSelectAttribute2 {
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
    ... on NumberAttribute {
      definition {
        ...BaseAttributeDefinitionFields
      }
    }
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const EspCordialFragmentFragmentDoc = gql`
    fragment espCordialFragment on CampaignCordialConfig {
  id
  senderProfile {
    ... on SelectAttribute2 {
      id
      selectedId
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  excludeAudiences2 {
    ... on MultiSelectAttribute2 {
      id
      selectedIds
      definition {
        ...BaseAttributeDefinitionFields
        options {
          id
          title
        }
      }
    }
  }
  defaultSendProperties {
    id
    name
  }
  sendProperties {
    id
    defaultSendPropertyId
    value
  }
  tags
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;
export const EspAdobeCampaignFragmentFragmentDoc = gql`
    fragment espAdobeCampaignFragment on CampaignAdobeCampaignConfig {
  id
  adobeCampaignLabel: label
  adobeCampaignDeliveryCode: deliveryCode
  adobeCampaignFromName: fromName
  adobeCampaignFromAddress: fromAddress
  adobeCampaignReplyToName: replyToName
  adobeCampaignReplyToAddress: replyToAddress
  adobeCampaignTargetMappingId: targetMappingId
  adobeCampaignTypologyId: typologyId
  adobeCampaignWebAnalyticsAccount: webAnalyticsAccount
  adobeCampaignRoutingId: routingId
  adobeCampaignDeliveryVariables: deliveryVariables {
    id
    value
    availableDeliveryVariableId
  }
  adobeCampaignAvailableDeliveryVariables: availableDeliveryVariables {
    id
    name
    defaultValue
  }
  adobeCampaignDeliveryNature: deliveryNature {
    id
    label
    availableDeliveryNatureId
  }
  adobeCampaignAvailableDeliveryNatures: availableDeliveryNatures {
    id
    label
  }
}
    `;
export const EspAdobeJourneyOptimizerFragmentFragmentDoc = gql`
    fragment espAdobeJourneyOptimizerFragment on AdobeJourneyOptimizerConfig {
  id
}
    `;
export const EspBlackholeFragmentFragmentDoc = gql`
    fragment espBlackholeFragment on BlackholeConfig {
  id
}
    `;
export const EspEpsilonFragmentFragmentDoc = gql`
    fragment espEpsilonFragment on CampaignEpsilonConfig {
  id
}
    `;
export const EspZetaFragmentFragmentDoc = gql`
    fragment espZetaFragment on ZetaConfig {
  id
  emailTags {
    id
    emailTagId
    value
  }
  availableEmailTags {
    id
    tagName
    defaultValue
  }
}
    `;
export const EspConfigFieldsFragmentDoc = gql`
    fragment EspConfigFields on EspConfig {
  ... on CampaignSalesforceMarketingCloudConfig {
    ...espSalesForceFragment
  }
  ... on CampaignAcousticCampaignConfig {
    ...espAcousticFragment
  }
  ... on CampaignOracleResponsysConfig {
    ...espOracleFragment
  }
  ... on CampaignCordialConfig {
    ...espCordialFragment
  }
  ... on CampaignAdobeCampaignConfig {
    ...espAdobeCampaignFragment
  }
  ... on AdobeJourneyOptimizerConfig {
    ...espAdobeJourneyOptimizerFragment
  }
  ... on BlackholeConfig {
    ...espBlackholeFragment
  }
  ... on CampaignEpsilonConfig {
    ...espEpsilonFragment
  }
  ... on ZetaConfig {
    ...espZetaFragment
  }
}
    ${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspBlackholeFragmentFragmentDoc}
${EspEpsilonFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}`;
export const EmailServiceProviderFieldsFragmentDoc = gql`
    fragment EmailServiceProviderFields on EmailServiceProvider {
  __typename
  ... on AcousticCampaign {
    id
  }
  ... on AdobeCampaign {
    id
  }
  ... on AdobeJourneyOptimizer {
    id
  }
  ... on AmazonSES {
    id
  }
  ... on Braze {
    id
  }
  ... on Cordial {
    id
  }
  ... on OracleResponsys {
    id
  }
  ... on SalesForceMarketingCloud {
    id
  }
  ... on Epsilon {
    id
  }
  ... on Zeta {
    id
  }
  ... on Blackhole {
    id
  }
  ... on Bluecore {
    id
  }
  ... on SFNext {
    id
  }
}
    `;
export const TrackingParametersFieldsFragmentDoc = gql`
    fragment TrackingParametersFields on Attribute {
  id
  ... on CheckboxAttribute {
    id
    definition {
      id
      title
      required
      help
      placeholder
    }
    checked: value
  }
  ... on SelectAttribute2 {
    id
    selectedId
    definition {
      id
      title
      required
      options {
        id
        title
      }
      placeholder
      help
    }
  }
  ... on SelectAttribute {
    id
    definition {
      id
      title
      required
      options {
        id
        selected
        title
      }
      placeholder
    }
  }
  ... on ListAttribute {
    id
    values
    definition {
      id
      title
      required
      help
      placeholder
    }
  }
  ... on DateAttribute {
    id
    dateValue: value
    definition {
      id
      title
      required
      placeholder
      help
    }
  }
  ... on DateTimeAttribute {
    id
    definition {
      id
      title
      required
      placeholder
      help
    }
    dateTimeValue: value
  }
  ... on TextAttribute {
    id
    textValue: value
    definition {
      id
      title
      required
      placeholder
      help
      multiline
    }
  }
  ... on FormatStringAttribute {
    id
    value
    definition {
      id
      title
      required
      placeholder
      help
    }
  }
  ... on NumberAttribute {
    id
    numberValue: value
    definition {
      id
      title
      required
      placeholder
      help
    }
  }
  ... on MultiSelectAttribute {
    id
    options {
      id
      selected
      title
    }
    definition {
      id
      title
      options {
        id
        selected
        title
      }
      required
      placeholder
      help
    }
  }
  ... on MultiSelectAttribute2 {
    id
    selectedIds
    definition {
      id
      title
      options {
        id
        title
      }
      required
      placeholder
      help
    }
  }
}
    `;
export const FieldsFieldsFragmentDoc = gql`
    fragment FieldsFields on CampaignField {
  dataFieldId
  isAccountLevel
  override {
    ... on ContactAudienceOverrideValueString {
      string
    }
    ... on ContactAudienceOverrideValueInteger {
      integer
    }
    ... on ContactAudienceOverrideValueFloat {
      float
    }
    ... on ContactAudienceOverrideValueBoolean {
      boolean
    }
    ... on ContactAudienceOverrideValueDateTime {
      datetime
    }
    ... on ContactAudienceOverrideValueDate {
      date
    }
  }
}
    `;
export const ProgramFieldsFragmentDoc = gql`
    fragment ProgramFields on Program {
  id
  title
  description
  isQuiet
  isArchived
  quietHourRules {
    id
    name
    startTime
    endTime
    daysOfWeek
  }
  quietPeriodRules {
    id
    name
    endDatetime
    startDatetime
  }
  customFields {
    ...CustomFieldFields
  }
  stateInfo {
    ...ProgramStateInfoFields
  }
  lastSendTime
  espConfig {
    ...EspConfigFields
  }
  emailServiceProvider {
    ...EmailServiceProviderFields
  }
  tags {
    id
    name
  }
  trackingParameters {
    ...TrackingParametersFields
  }
  seedContactAudiences {
    id
    name
  }
  includedAudiences {
    id
    name
    audience {
      id
    }
    segments {
      id
      name
      selected
      segment {
        id
        name
        contactAudience {
          name
          id
        }
      }
    }
  }
  excludedAudiences {
    id
    name
    audience {
      id
    }
    segments {
      id
      name
      selected
    }
  }
  fields {
    ...FieldsFields
  }
  uberTemplate {
    id
    variations {
      id
      title
    }
  }
}
    ${CustomFieldFieldsFragmentDoc}
${ProgramStateInfoFieldsFragmentDoc}
${EspConfigFieldsFragmentDoc}
${EmailServiceProviderFieldsFragmentDoc}
${TrackingParametersFieldsFragmentDoc}
${FieldsFieldsFragmentDoc}`;
export const RecurringCampaignAudienceFieldsFragmentDoc = gql`
    fragment RecurringCampaignAudienceFields on RecurringCampaignType {
  id
  channel {
    channel
    category
  }
  emailServiceProvider {
    __typename
  }
  fields {
    dataFieldId
    isAccountLevel
    override {
      ... on ContactAudienceOverrideValueString {
        string
      }
      ... on ContactAudienceOverrideValueInteger {
        integer
      }
      ... on ContactAudienceOverrideValueFloat {
        float
      }
      ... on ContactAudienceOverrideValueBoolean {
        boolean
      }
      ... on ContactAudienceOverrideValueDateTime {
        datetime
      }
      ... on ContactAudienceOverrideValueDate {
        date
      }
    }
  }
  includedAudiences {
    audience {
      id
    }
    id
    name
    priority
    segments {
      id
      name
      selected
      segment {
        id
      }
    }
  }
  excludedAudiences {
    audience {
      id
    }
    id
    name
    priority
    segments {
      id
      name
      selected
    }
  }
}
    `;
export const RecurringCampaignDetailFieldsFragmentDoc = gql`
    fragment recurringCampaignDetailFields on Campaign {
  id
  status
  lastStatus {
    user {
      id
      fullName
    }
    timestamp
    status
  }
  stage
  title
  error
  legacyId
  hasContactAudiences
  featureFlagExperiences2
  emailServiceProvider {
    __typename
  }
  channel {
    category
    channel
  }
  includedContactAudiences {
    id
    name
    contactAudience {
      id
      name
      archived
    }
  }
}
    `;
export const RecurringCampaignFieldsFragmentDoc = gql`
    fragment recurringCampaignFields on RecurringCampaignType {
  id
  hashid
  title
  status
  stage
  stageGroup
  nextOccurrence
  hasPastMailings
  lastStatus {
    status
    label
    timestamp
    user {
      fullName
    }
  }
  stateInfo {
    state
    transitions {
      state
      label
      permission {
        ... on RecurringCampaignTransitionPermissionAllowed {
          allowed
        }
        ... on RecurringCampaignTransitionPermissionDenied {
          allowed
          message
          code
        }
      }
    }
    actions {
      id
      label
    }
  }
  channel {
    category
    channel
  }
  schedule {
    startDate
    sendTime
    rrule
    endDate
    timezone
  }
  tags {
    id
    name
  }
}
    `;
export const RecurringCustomFieldsFragmentFragmentDoc = gql`
    fragment recurringCustomFieldsFragment on CustomField {
  ... on TextCustomField {
    id
    textValue: value
    title
  }
  ... on NumberCustomField {
    id
    intValue: value
    title
  }
  ... on DatetimeCustomField {
    id
    dateTimeValue: value
    title
  }
}
    `;
export const PgpKeyFragmentFragmentDoc = gql`
    fragment PgpKeyFragment on DataEncryptionPGPKey {
  id
  name
  createdAt
  updatedAt
  spec {
    ... on DataEncryptionPGPDecryptKey {
      publicKey
      expiresAt
    }
    ... on DataEncryptionPGPEncryptKey {
      publicKey
    }
  }
}
    `;
export const PgpKeysListFragmentFragmentDoc = gql`
    fragment PgpKeysListFragment on DataEncryptionPGPKeysList {
  encryptPgpKeys {
    ...PgpKeyFragment
  }
  decryptPgpKeys {
    ...PgpKeyFragment
  }
}
    ${PgpKeyFragmentFragmentDoc}`;
export const DataEncryptionConfigFragmentFragmentDoc = gql`
    fragment DataEncryptionConfigFragment on DataEncryptionConfig {
  id
  createdAt
  updatedAt
  gpgPublicKey
  gpgAppPublicKey
}
    `;
export const CredentialsFieldsFragmentDoc = gql`
    fragment CredentialsFields on Credential {
  id
  name
  metaData
  expiresAt
  createdAt
  lastUsedAt
  status
  createdBy {
    id
    firstName
    lastName
    status
  }
}
    `;
export const PlatformApplicationFieldsFragmentDoc = gql`
    fragment PlatformApplicationFields on PlatformApplication {
  id
  name
  status
  createdAt
  updatedAt
  description
  scopes
  credentials {
    ...CredentialsFields
  }
  accounts {
    id
    displayName
  }
  requester {
    id
    firstName
    lastName
    status
  }
  accountSummaries {
    id
    displayName
  }
}
    ${CredentialsFieldsFragmentDoc}`;
export const OrganizationUser2FieldsFragmentDoc = gql`
    fragment OrganizationUser2Fields on OrganizationUser2 {
  id
  firstName
  lastName
  emailAddress
  lastLogin
  status
  userType
  inviteExpiresAt
  createdAt
  roles {
    id
    name
  }
  organization {
    id
  }
  accountMembers {
    account {
      id
      name
      displayName
      createdAt
    }
    canDeactivateUser {
      allowed
      reason
    }
    canInviteUser {
      allowed
      reason
    }
    canEditUser {
      allowed
      reason
    }
    canViewUser {
      allowed
      reason
    }
    invitedBy {
      id
      firstName
      lastName
      emailAddress
    }
    isOwner
    isAdmin
    status
    createdAt
    inviteExpiresAt
    roles {
      id
      title
    }
  }
  isAdmin
  isOwner
  organizationRole
  isSuperuser
  canInviteUser {
    allowed
    reason
  }
  canEditUser {
    allowed
    reason
  }
  canDeactivateUser {
    allowed
    reason
  }
  canViewUser {
    allowed
    reason
  }
}
    `;
export const AccountRoleFieldsFragmentDoc = gql`
    fragment AccountRoleFields on Role {
  id
  name
  title
  description
  permissions {
    name
    title
    description
  }
}
    `;
export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account2 {
  id
  displayName
  createdAt
  updatedAt
  roles {
    ...AccountRoleFields
  }
  members {
    user {
      id
      firstName
      lastName
      emailAddress
      lastLogin
      userType
      roles {
        id
        name
      }
    }
    invitedBy {
      id
      firstName
      lastName
      emailAddress
    }
    createdAt
    status
    lastActivityAt
    organizationRole
    roles {
      id
      name
    }
  }
}
    ${AccountRoleFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  createdAt
  deactivated
  allowlistedDomains
  authConnection
  enableMfa
}
    `;
export const AccountMemberStatusFieldsFragmentDoc = gql`
    fragment AccountMemberStatusFields on AccountMember {
  status
  account {
    id
  }
  user {
    id
    status
  }
}
    `;
export const DataTagsFragmentFragmentDoc = gql`
    fragment DataTagsFragment on InkDavinciDataV1Tag {
  id
  name
}
    `;
export const DataFieldsFragmentFragmentDoc = gql`
    fragment DataFieldsFragment on DataField {
  id
  name
  displayName
  description
  type
  primaryKey
  semanticFeature {
    id
    name
  }
  channelsV2
}
    `;
export const DataTablesFragmentFragmentDoc = gql`
    fragment DataTablesFragment on DataTable {
  id
  name
  description
  updatedAt
  rowTtlDays
  semanticCategory {
    id
    name
  }
}
    `;
export const TriggeredCustomFieldsFragmentFragmentDoc = gql`
    fragment triggeredCustomFieldsFragment on CustomField {
  ... on TextCustomField {
    id
    textValue: value
    title
  }
  ... on NumberCustomField {
    id
    intValue: value
    title
  }
  ... on DatetimeCustomField {
    id
    dateTimeValue: value
    title
  }
}
    `;
export const ChannelFeatureFlagsFragmentFragmentDoc = gql`
    fragment channelFeatureFlagsFragment on Client {
  hasSMSChannel: hasFeature(feature: "enable_channel_sms")
  hasMMSChannel: hasFeature(feature: "enable_channel_mms")
  hasRCSChannel: hasFeature(feature: "enable_channel_rcs")
  hasPushChannel: hasFeature(feature: "enable_channel_push")
  hasInAppChannel: hasFeature(feature: "enable_channel_inapp")
}
    `;
export const FeatureFlagsFragmentFragmentDoc = gql`
    fragment featureFlagsFragment on Client {
  hasHardRefreshClientSwitcher: hasFeature(
    feature: "hard_refresh_client_switcher"
  )
  hasMfa: hasFeature(feature: "has_mfa")
  hasCustomFields: hasFeature(feature: "has_custom_fields")
  aiGeneratedSl: hasFeature(feature: "ai_generated_sl")
  canCreateSavedView: hasFeature(feature: "create_savedView_access")
  contactReplaceImports: hasFeature(feature: "contact_replace_imports")
  analyticsV2Access: hasFeature(feature: "analytics_v2_access")
  hasCampaignProofingAgent: hasFeature(feature: "campaign_proofing_agent")
  hasAiAssistedSubjectLines: hasFeature(feature: "has_ai_assisted_subject_lines")
  hasCreativeChannelConverterAssistant: hasFeature(
    feature: "has_creative_channel_converter_assistant"
  )
  semanticLabelsEnabled: hasFeature(feature: "semantic_labels")
  shouldDisplayAuth0MigrationAlert: hasFeature(feature: "auth0_migration_alert")
  hasAudienceOverrides: hasFeature(feature: "has_audience_overrides")
  hasTableRelationships: hasFeature(feature: "has_table_relationships")
  hasNewAudiencesByDefault: hasFeature(feature: "has_new_audiences_by_default")
  hasCampaignFieldOverrides: hasFeature(feature: "has_campaign_field_overrides")
  hasIdColumnTableFields: hasFeature(feature: "has_id_column_table_fields")
  hasFrequencyToggle: hasFeature(feature: "frequency_toggle")
  hasPrograms: hasFeature(feature: "has_programs")
  hasEmailDataTypeOption: hasFeature(feature: "has_email_data_type_option")
  isAbleToDeleteTags: hasFeature(feature: "is_able_to_delete_tags")
  isAbleToExpireTags: hasFeature(feature: "is_able_to_expire_tags")
  hasToneLabelDropdown: hasFeature(feature: "show_tone_label_dropdown")
  hasUnifiedAudienceBuilder: hasFeature(feature: "has_unified_audience_builder")
  hasExperimentAudiences: hasFeature(feature: "has_experiment_audiences")
  hasAccountPermissions: hasFeature(feature: "has_account_permissions")
  hasAccountCustomRole: hasFeature(feature: "has_account_custom_role")
  disableMixpanelSessionRecord: hasFeature(
    feature: "disable_mixpanel_session_record"
  )
  hasSubjectLineEnhancements: hasFeature(feature: "has_subjectline_enhancements")
  hasAudienceFilters: hasFeature(feature: "has_audience_filters")
  hasSlsV2: hasFeature(feature: "has_sls_v2")
  enableAiFeatures: hasFeature(feature: "enable_ai_features")
  hasCopilot: hasFeature(feature: "has_copilot")
  hasCreativeEffectivenessV2: hasFeature(feature: "has_creative_effectiveness_v2")
  hasAudiencesCampaignsFilter: hasFeature(
    feature: "has_audiences_campaigns_filter"
  )
  hasPrimaryContentBlockFilter: hasFeature(
    feature: "has_primary_content_block_filter"
  )
  supportMultipleEsps: hasFeature(feature: "support_multiple_esps")
  hasAnalyticsCustomEvents: hasFeature(feature: "has_analytics_custom_events")
  hasDirectCdnUpload: hasFeature(feature: "use_direct_cdn_image_upload")
  hasMobileImageUpload: hasFeature(feature: "has_mobile_image_upload")
  hasContentVariants: hasFeature(feature: "has_content_variants")
  hasChannelKey: hasFeature(feature: "has_channel_keys")
  hasNonWebsafeFontsInEditor: hasFeature(
    feature: "has_non_websafe_fonts_in_editor"
  )
  hasBackgroundImageInEditor: hasFeature(feature: "has_bg_image_in_editor")
  hasAccountPrivacy: hasFeature(feature: "has_account_privacy")
  hasAudienceUnarchiveOption: hasFeature(feature: "has_audience_unarchive_option")
  hasCampaignAudienceOverlap: hasFeature(feature: "has_campaign_audience_overlap")
  hasAudienceDetailPage: hasFeature(feature: "has_audience_detail_page")
  hasAnalyticsIndexRecurringExports: hasFeature(
    feature: "has_analytics_index_recurring_exports"
  )
  hasExportAnalyticsDetailPage: hasFeature(
    feature: "has_export_analytics_detail_page"
  )
  hasReportingMultichannel: hasFeature(feature: "has_reporting_multichannel")
  hasReportingPushMultichannel: hasFeature(
    feature: "has_reporting_push_multichannel"
  )
  hasDataFieldDescription: hasFeature(feature: "has_data_field_description")
  hasExperimentalAlertsRemoved: hasFeature(
    feature: "has_experimental_alerts_removed"
  )
  hasBrandKitLinkStyles: hasFeature(feature: "has_brand_kit_link_styles")
  hasBrandKitMobileStyles: hasFeature(feature: "has_brand_kit_mobile_styles")
  enableBrandKitStyleDuplication: hasFeature(
    feature: "enable_brand_kit_style_duplication"
  )
  hasEncryptionV2: hasFeature(feature: "has_encryption_v2")
  hasManagedCardSummary: hasFeature(feature: "has_managed_card_summary")
  hasRawDataSubjectRequestError: hasFeature(
    feature: "has_raw_data_subject_request_error"
  )
  hasEditorMobileControls: hasFeature(feature: "editor_has_mobile_controls")
  hasSendTimePersonalizationDisabled: hasFeature(
    feature: "has_send_time_personalization_disabled"
  )
  hasEditorComponents: hasFeature(feature: "editor_has_components")
  hasEditorVariables: hasFeature(feature: "has_editor_variables")
  hasNewDisclaimerRichtextEditor: hasFeature(
    feature: "has_new_disclaimer_richtext_editor"
  )
  hasCreativeEditorV2: hasFeature(feature: "has_creative_editor_v2")
  hasJourneyBuilder: hasFeature(feature: "journey_builder")
  hasBrandKitComponents: hasFeature(feature: "has_brand_kit_components")
  hasBrandKitBlocks: hasFeature(feature: "has_brand_kit_blocks")
  hasBrandKitAiGuidelines: hasFeature(feature: "has_brand_kit_ai_guidelines")
  hasReportingDashboard: hasFeature(feature: "has_reporting_dashboard")
  hasMessageBuilderStartFromScratch: hasFeature(
    feature: "has_message_builder_new_flow"
  )
  hasMessageBuilder: hasFeature(feature: "message_builder")
  hasMessageBuilderZones: hasFeature(feature: "message_builder_zones")
  hasMessageBuilderPreview: hasFeature(feature: "message-builder-preview")
  hasTableRowTtl: hasFeature(feature: "has_table_row_ttl")
  hasSmartStandardRerun: hasFeature(feature: "smart_standard_reruns")
  hasRecurringCampaigns: hasFeature(feature: "has_recurring_campaigns")
  hasTriggeredCampaigns: hasFeature(feature: "has_triggered_campaigns")
  hasReportingRecurringCampaigns: hasFeature(
    feature: "has_reporting_recurring_campaigns"
  )
  hasReportingTriggerCampaigns: hasFeature(
    feature: "has_reporting_trigger_campaigns"
  )
  hasTableRowCount: hasFeature(feature: "has_table_row_count")
  hasReportingDataFiltering: hasFeature(feature: "has_reporting_data_filtering")
  hasReportingIndirectAttribution: hasFeature(
    feature: "has_reporting_indirect_attribution"
  )
  hasConfigureCreativeEligibility: hasFeature(
    feature: "has_configure_creative_eligibility"
  )
  hasDemoAudienceCounts: hasFeature(feature: "has_demo_audience_counts")
  hasDemoPositiveMetrics: hasFeature(feature: "has_demo_positive_metrics")
  hasContactLevelEventExportUi: hasFeature(
    feature: "has_contact_level_event_export_ui"
  )
  hasSavedFilter: hasFeature(feature: "has_saved_filter")
  hasDemoFriendlyUI: hasFeature(feature: "has_demo_friendly_ui")
  hasEligibilityTabUxUpdates: hasFeature(feature: "has_disable_reuse_rules")
  hasContactBasedMetrics: hasFeature(feature: "has_contact_based_metrics")
  hasCreativeTagHeatmap: hasFeature(feature: "has_creativetag_heatmap")
  hasCreativePurpose: hasFeature(feature: "has_creative_purpose")
  hasDatasetsUi: hasFeature(feature: "has_datasets_ui")
  hasConfigurableKpi: hasFeature(feature: "has_configurable_kpi")
  hasDynamicAudiences: hasFeature(feature: "has_value_mode_dates_in_audience")
  hasPushTrackingParams: hasFeature(feature: "has_push_tracking_params")
  hasUnifiedMessagingNav: hasFeature(feature: "has_unified_messaging_nav")
  hasUserLifecycle: hasFeature(feature: "has_user_lifecycle")
  hasUnlockComponents: hasFeature(feature: "has_unlock_components")
  hasAiAudienceBuilder: hasFeature(feature: "has_ai_audience_builder")
  hasPlatformApplicationPermission: hasFeature(
    feature: "has_platform_application_permission"
  )
}
    `;
export const EspMetadataFieldsFragmentDoc = gql`
    fragment espMetadataFields on EmailServiceProvider {
  __typename
  ... on AcousticCampaign {
    id
    displayName
  }
  ... on AdobeCampaign {
    id
    displayName
  }
  ... on AdobeJourneyOptimizer {
    id
    displayName
  }
  ... on AmazonSES {
    id
    displayName
  }
  ... on Braze {
    id
    displayName
  }
  ... on Cordial {
    id
    displayName
  }
  ... on Epsilon {
    id
    displayName
  }
  ... on OracleResponsys {
    id
    displayName
    linkCategories {
      id
      title
    }
  }
  ... on SalesForceMarketingCloud {
    id
    displayName
  }
  ... on Zeta {
    id
    displayName
  }
  ... on AmazonSES {
    id
    displayName
  }
  ... on Bluecore {
    id
    displayName
  }
  ... on Blackhole {
    id
    displayName
  }
  ... on SFNext {
    id
    displayName
  }
}
    `;
export const BlockFragmentFragmentDoc = gql`
    fragment blockFragment on Block {
  id
  name
  description
  thumbnail
  versions {
    id
    version
    layout {
      snapshot(format: V1)
      mediaLibrary {
        ...mediaFields
      }
      linkLibrary {
        ...link2Fields
      }
    }
  }
}
    ${MediaFieldsFragmentDoc}
${Link2FieldsFragmentDoc}`;
export const LayoutComponentFragmentFragmentDoc = gql`
    fragment layoutComponentFragment on LayoutComponent {
  id
  name
  description
  thumbnail
  versions {
    id
    version
    layout {
      snapshot(format: V1)
      mediaLibrary {
        ...mediaFields
      }
      linkLibrary {
        ...link2Fields
      }
    }
  }
}
    ${MediaFieldsFragmentDoc}
${Link2FieldsFragmentDoc}`;
export const CampaignContactAudienceConfigDocument = gql`
    query CampaignContactAudienceConfig($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    frequencyModel
    hasContactAudiences
    channel {
      channel
      category
    }
    espConfig {
      __typename
    }
    fields {
      dataFieldId
      isAccountLevel
      override {
        ... on ContactAudienceOverrideValueString {
          string
        }
        ... on ContactAudienceOverrideValueInteger {
          integer
        }
        ... on ContactAudienceOverrideValueFloat {
          float
        }
        ... on ContactAudienceOverrideValueBoolean {
          boolean
        }
        ... on ContactAudienceOverrideValueDateTime {
          datetime
        }
        ... on ContactAudienceOverrideValueDate {
          date
        }
      }
    }
    includedContactAudiences {
      id
      name
      splitConfigs {
        id
        selected
        name
        split {
          id
          createdAt
          updatedAt
          name
          query
        }
      }
      contactAudience {
        id
        archived
        type
      }
    }
    excludedContactAudiences {
      id
      name
      splitConfigs {
        id
        selected
        name
        split {
          id
          createdAt
          updatedAt
          name
          query
        }
      }
      contactAudience {
        id
        archived
        type
      }
    }
    experienceExperiment {
      id
      title
      experimentType
      treatmentsCount
      status
      treatments {
        id
        title
      }
      resultsRestrictedToStaff
      configurationRestrictedToStaff
    }
    emailServiceProvider {
      __typename
    }
  }
}
    `;

/**
 * __useCampaignContactAudienceConfigQuery__
 *
 * To run a query within a React component, call `useCampaignContactAudienceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignContactAudienceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignContactAudienceConfigQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignContactAudienceConfigQuery(baseOptions: Apollo.QueryHookOptions<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables> & ({ variables: CampaignContactAudienceConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables>(CampaignContactAudienceConfigDocument, options);
      }
export function useCampaignContactAudienceConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables>(CampaignContactAudienceConfigDocument, options);
        }
export function useCampaignContactAudienceConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables>(CampaignContactAudienceConfigDocument, options);
        }
export type CampaignContactAudienceConfigQueryHookResult = ReturnType<typeof useCampaignContactAudienceConfigQuery>;
export type CampaignContactAudienceConfigLazyQueryHookResult = ReturnType<typeof useCampaignContactAudienceConfigLazyQuery>;
export type CampaignContactAudienceConfigSuspenseQueryHookResult = ReturnType<typeof useCampaignContactAudienceConfigSuspenseQuery>;
export type CampaignContactAudienceConfigQueryResult = Apollo.QueryResult<CampaignContactAudienceConfigQuery, CampaignContactAudienceConfigQueryVariables>;
export const CampaignFieldCreateDocument = gql`
    mutation CampaignFieldCreate($id: ID!, $fieldId: ID!, $override: ContactAudienceOverrideValueInput) {
  campaignFieldCreate(override: $override, id: $id, fieldId: $fieldId) {
    fields {
      dataFieldId
      isAccountLevel
      override {
        ... on ContactAudienceOverrideValueString {
          string
        }
        ... on ContactAudienceOverrideValueInteger {
          integer
        }
        ... on ContactAudienceOverrideValueFloat {
          float
        }
        ... on ContactAudienceOverrideValueBoolean {
          boolean
        }
        ... on ContactAudienceOverrideValueDateTime {
          datetime
        }
        ... on ContactAudienceOverrideValueDate {
          date
        }
      }
    }
  }
}
    `;
export type CampaignFieldCreateMutationFn = Apollo.MutationFunction<CampaignFieldCreateMutation, CampaignFieldCreateMutationVariables>;

/**
 * __useCampaignFieldCreateMutation__
 *
 * To run a mutation, you first call `useCampaignFieldCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignFieldCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignFieldCreateMutation, { data, loading, error }] = useCampaignFieldCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldId: // value for 'fieldId'
 *      override: // value for 'override'
 *   },
 * });
 */
export function useCampaignFieldCreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignFieldCreateMutation, CampaignFieldCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignFieldCreateMutation, CampaignFieldCreateMutationVariables>(CampaignFieldCreateDocument, options);
      }
export type CampaignFieldCreateMutationHookResult = ReturnType<typeof useCampaignFieldCreateMutation>;
export type CampaignFieldCreateMutationResult = Apollo.MutationResult<CampaignFieldCreateMutation>;
export type CampaignFieldCreateMutationOptions = Apollo.BaseMutationOptions<CampaignFieldCreateMutation, CampaignFieldCreateMutationVariables>;
export const CampaignFieldDeleteDocument = gql`
    mutation CampaignFieldDelete($id: ID!, $fieldId: ID!) {
  campaignFieldDelete(id: $id, fieldId: $fieldId) {
    fields {
      dataFieldId
      override {
        ... on ContactAudienceOverrideValueString {
          string
        }
        ... on ContactAudienceOverrideValueInteger {
          integer
        }
        ... on ContactAudienceOverrideValueFloat {
          float
        }
        ... on ContactAudienceOverrideValueBoolean {
          boolean
        }
        ... on ContactAudienceOverrideValueDateTime {
          datetime
        }
        ... on ContactAudienceOverrideValueDate {
          date
        }
      }
    }
  }
}
    `;
export type CampaignFieldDeleteMutationFn = Apollo.MutationFunction<CampaignFieldDeleteMutation, CampaignFieldDeleteMutationVariables>;

/**
 * __useCampaignFieldDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignFieldDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignFieldDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignFieldDeleteMutation, { data, loading, error }] = useCampaignFieldDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useCampaignFieldDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignFieldDeleteMutation, CampaignFieldDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignFieldDeleteMutation, CampaignFieldDeleteMutationVariables>(CampaignFieldDeleteDocument, options);
      }
export type CampaignFieldDeleteMutationHookResult = ReturnType<typeof useCampaignFieldDeleteMutation>;
export type CampaignFieldDeleteMutationResult = Apollo.MutationResult<CampaignFieldDeleteMutation>;
export type CampaignFieldDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignFieldDeleteMutation, CampaignFieldDeleteMutationVariables>;
export const CampaignFieldUpdateDocument = gql`
    mutation CampaignFieldUpdate($id: ID!, $fieldId: ID!, $override: ContactAudienceOverrideValueInput, $newFieldId: ID) {
  campaignFieldUpdate(
    override: $override
    id: $id
    fieldId: $fieldId
    newFieldId: $newFieldId
  ) {
    fields {
      dataFieldId
      isAccountLevel
      override {
        ... on ContactAudienceOverrideValueString {
          string
        }
        ... on ContactAudienceOverrideValueInteger {
          integer
        }
        ... on ContactAudienceOverrideValueFloat {
          float
        }
        ... on ContactAudienceOverrideValueBoolean {
          boolean
        }
        ... on ContactAudienceOverrideValueDateTime {
          datetime
        }
        ... on ContactAudienceOverrideValueDate {
          date
        }
      }
    }
  }
}
    `;
export type CampaignFieldUpdateMutationFn = Apollo.MutationFunction<CampaignFieldUpdateMutation, CampaignFieldUpdateMutationVariables>;

/**
 * __useCampaignFieldUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignFieldUpdateMutation, { data, loading, error }] = useCampaignFieldUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldId: // value for 'fieldId'
 *      override: // value for 'override'
 *      newFieldId: // value for 'newFieldId'
 *   },
 * });
 */
export function useCampaignFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignFieldUpdateMutation, CampaignFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignFieldUpdateMutation, CampaignFieldUpdateMutationVariables>(CampaignFieldUpdateDocument, options);
      }
export type CampaignFieldUpdateMutationHookResult = ReturnType<typeof useCampaignFieldUpdateMutation>;
export type CampaignFieldUpdateMutationResult = Apollo.MutationResult<CampaignFieldUpdateMutation>;
export type CampaignFieldUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignFieldUpdateMutation, CampaignFieldUpdateMutationVariables>;
export const SalesForceSenderProfileUpdateDocument = gql`
    mutation SalesForceSenderProfileUpdate($espId: ID!, $senderProfileId: ID) {
  campaignSalesforceMarketingCloudConfigSenderProfileUpdate(
    id: $espId
    senderProfileId: $senderProfileId
  ) {
    salesforceMarketingCloudConfig {
      senderProfile2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type SalesForceSenderProfileUpdateMutationFn = Apollo.MutationFunction<SalesForceSenderProfileUpdateMutation, SalesForceSenderProfileUpdateMutationVariables>;

/**
 * __useSalesForceSenderProfileUpdateMutation__
 *
 * To run a mutation, you first call `useSalesForceSenderProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForceSenderProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForceSenderProfileUpdateMutation, { data, loading, error }] = useSalesForceSenderProfileUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      senderProfileId: // value for 'senderProfileId'
 *   },
 * });
 */
export function useSalesForceSenderProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesForceSenderProfileUpdateMutation, SalesForceSenderProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForceSenderProfileUpdateMutation, SalesForceSenderProfileUpdateMutationVariables>(SalesForceSenderProfileUpdateDocument, options);
      }
export type SalesForceSenderProfileUpdateMutationHookResult = ReturnType<typeof useSalesForceSenderProfileUpdateMutation>;
export type SalesForceSenderProfileUpdateMutationResult = Apollo.MutationResult<SalesForceSenderProfileUpdateMutation>;
export type SalesForceSenderProfileUpdateMutationOptions = Apollo.BaseMutationOptions<SalesForceSenderProfileUpdateMutation, SalesForceSenderProfileUpdateMutationVariables>;
export const SalesForceSuppressionDataExtensionAddDocument = gql`
    mutation SalesForceSuppressionDataExtensionAdd($espId: ID!, $suppressionDataExtensionId: ID!) {
  campaignSalesforceMarketingCloudConfigSuppressionDataExtensionAdd(
    id: $espId
    suppressionDataExtensionId: $suppressionDataExtensionId
  ) {
    salesforceMarketingCloudConfig {
      suppressionDataExtensions2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type SalesForceSuppressionDataExtensionAddMutationFn = Apollo.MutationFunction<SalesForceSuppressionDataExtensionAddMutation, SalesForceSuppressionDataExtensionAddMutationVariables>;

/**
 * __useSalesForceSuppressionDataExtensionAddMutation__
 *
 * To run a mutation, you first call `useSalesForceSuppressionDataExtensionAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForceSuppressionDataExtensionAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForceSuppressionDataExtensionAddMutation, { data, loading, error }] = useSalesForceSuppressionDataExtensionAddMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      suppressionDataExtensionId: // value for 'suppressionDataExtensionId'
 *   },
 * });
 */
export function useSalesForceSuppressionDataExtensionAddMutation(baseOptions?: Apollo.MutationHookOptions<SalesForceSuppressionDataExtensionAddMutation, SalesForceSuppressionDataExtensionAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForceSuppressionDataExtensionAddMutation, SalesForceSuppressionDataExtensionAddMutationVariables>(SalesForceSuppressionDataExtensionAddDocument, options);
      }
export type SalesForceSuppressionDataExtensionAddMutationHookResult = ReturnType<typeof useSalesForceSuppressionDataExtensionAddMutation>;
export type SalesForceSuppressionDataExtensionAddMutationResult = Apollo.MutationResult<SalesForceSuppressionDataExtensionAddMutation>;
export type SalesForceSuppressionDataExtensionAddMutationOptions = Apollo.BaseMutationOptions<SalesForceSuppressionDataExtensionAddMutation, SalesForceSuppressionDataExtensionAddMutationVariables>;
export const SalesForceSuppressionDataExtensionRemoveDocument = gql`
    mutation SalesForceSuppressionDataExtensionRemove($espId: ID!, $suppressionDataExtensionId: ID!) {
  campaignSalesforceMarketingCloudConfigSuppressionDataExtensionRemove(
    id: $espId
    suppressionDataExtensionId: $suppressionDataExtensionId
  ) {
    salesforceMarketingCloudConfig {
      suppressionDataExtensions2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type SalesForceSuppressionDataExtensionRemoveMutationFn = Apollo.MutationFunction<SalesForceSuppressionDataExtensionRemoveMutation, SalesForceSuppressionDataExtensionRemoveMutationVariables>;

/**
 * __useSalesForceSuppressionDataExtensionRemoveMutation__
 *
 * To run a mutation, you first call `useSalesForceSuppressionDataExtensionRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForceSuppressionDataExtensionRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForceSuppressionDataExtensionRemoveMutation, { data, loading, error }] = useSalesForceSuppressionDataExtensionRemoveMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      suppressionDataExtensionId: // value for 'suppressionDataExtensionId'
 *   },
 * });
 */
export function useSalesForceSuppressionDataExtensionRemoveMutation(baseOptions?: Apollo.MutationHookOptions<SalesForceSuppressionDataExtensionRemoveMutation, SalesForceSuppressionDataExtensionRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForceSuppressionDataExtensionRemoveMutation, SalesForceSuppressionDataExtensionRemoveMutationVariables>(SalesForceSuppressionDataExtensionRemoveDocument, options);
      }
export type SalesForceSuppressionDataExtensionRemoveMutationHookResult = ReturnType<typeof useSalesForceSuppressionDataExtensionRemoveMutation>;
export type SalesForceSuppressionDataExtensionRemoveMutationResult = Apollo.MutationResult<SalesForceSuppressionDataExtensionRemoveMutation>;
export type SalesForceSuppressionDataExtensionRemoveMutationOptions = Apollo.BaseMutationOptions<SalesForceSuppressionDataExtensionRemoveMutation, SalesForceSuppressionDataExtensionRemoveMutationVariables>;
export const SalesForceSendClassificationUpdateDocument = gql`
    mutation SalesForceSendClassificationUpdate($espId: ID!, $sendClassificationId: ID!) {
  campaignSalesforceMarketingCloudConfigSendClassificationUpdate(
    id: $espId
    sendClassificationId: $sendClassificationId
  ) {
    salesforceMarketingCloudConfig {
      sendClassification2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type SalesForceSendClassificationUpdateMutationFn = Apollo.MutationFunction<SalesForceSendClassificationUpdateMutation, SalesForceSendClassificationUpdateMutationVariables>;

/**
 * __useSalesForceSendClassificationUpdateMutation__
 *
 * To run a mutation, you first call `useSalesForceSendClassificationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForceSendClassificationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForceSendClassificationUpdateMutation, { data, loading, error }] = useSalesForceSendClassificationUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      sendClassificationId: // value for 'sendClassificationId'
 *   },
 * });
 */
export function useSalesForceSendClassificationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesForceSendClassificationUpdateMutation, SalesForceSendClassificationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForceSendClassificationUpdateMutation, SalesForceSendClassificationUpdateMutationVariables>(SalesForceSendClassificationUpdateDocument, options);
      }
export type SalesForceSendClassificationUpdateMutationHookResult = ReturnType<typeof useSalesForceSendClassificationUpdateMutation>;
export type SalesForceSendClassificationUpdateMutationResult = Apollo.MutationResult<SalesForceSendClassificationUpdateMutation>;
export type SalesForceSendClassificationUpdateMutationOptions = Apollo.BaseMutationOptions<SalesForceSendClassificationUpdateMutation, SalesForceSendClassificationUpdateMutationVariables>;
export const SalesForcePublicationListUpdateDocument = gql`
    mutation SalesForcePublicationListUpdate($espId: ID!, $publicationListId: ID!) {
  campaignSalesforceMarketingCloudPublicationListUpdate(
    id: $espId
    publicationListId: $publicationListId
  ) {
    salesforceMarketingCloudConfig {
      publicationList2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type SalesForcePublicationListUpdateMutationFn = Apollo.MutationFunction<SalesForcePublicationListUpdateMutation, SalesForcePublicationListUpdateMutationVariables>;

/**
 * __useSalesForcePublicationListUpdateMutation__
 *
 * To run a mutation, you first call `useSalesForcePublicationListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForcePublicationListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForcePublicationListUpdateMutation, { data, loading, error }] = useSalesForcePublicationListUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      publicationListId: // value for 'publicationListId'
 *   },
 * });
 */
export function useSalesForcePublicationListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesForcePublicationListUpdateMutation, SalesForcePublicationListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForcePublicationListUpdateMutation, SalesForcePublicationListUpdateMutationVariables>(SalesForcePublicationListUpdateDocument, options);
      }
export type SalesForcePublicationListUpdateMutationHookResult = ReturnType<typeof useSalesForcePublicationListUpdateMutation>;
export type SalesForcePublicationListUpdateMutationResult = Apollo.MutationResult<SalesForcePublicationListUpdateMutation>;
export type SalesForcePublicationListUpdateMutationOptions = Apollo.BaseMutationOptions<SalesForcePublicationListUpdateMutation, SalesForcePublicationListUpdateMutationVariables>;
export const SalesForceSuppressionPrebuildDurationUpdateDocument = gql`
    mutation SalesForceSuppressionPrebuildDurationUpdate($espId: ID!, $prebuildDuration: Float!) {
  campaignSalesforceMarketingCloudPrebuildDurationUpdate(
    id: $espId
    prebuildDuration: $prebuildDuration
  ) {
    salesforceMarketingCloudConfig {
      id
      delayedDelivery {
        prebuildDuration
      }
    }
  }
}
    `;
export type SalesForceSuppressionPrebuildDurationUpdateMutationFn = Apollo.MutationFunction<SalesForceSuppressionPrebuildDurationUpdateMutation, SalesForceSuppressionPrebuildDurationUpdateMutationVariables>;

/**
 * __useSalesForceSuppressionPrebuildDurationUpdateMutation__
 *
 * To run a mutation, you first call `useSalesForceSuppressionPrebuildDurationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForceSuppressionPrebuildDurationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForceSuppressionPrebuildDurationUpdateMutation, { data, loading, error }] = useSalesForceSuppressionPrebuildDurationUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      prebuildDuration: // value for 'prebuildDuration'
 *   },
 * });
 */
export function useSalesForceSuppressionPrebuildDurationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesForceSuppressionPrebuildDurationUpdateMutation, SalesForceSuppressionPrebuildDurationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForceSuppressionPrebuildDurationUpdateMutation, SalesForceSuppressionPrebuildDurationUpdateMutationVariables>(SalesForceSuppressionPrebuildDurationUpdateDocument, options);
      }
export type SalesForceSuppressionPrebuildDurationUpdateMutationHookResult = ReturnType<typeof useSalesForceSuppressionPrebuildDurationUpdateMutation>;
export type SalesForceSuppressionPrebuildDurationUpdateMutationResult = Apollo.MutationResult<SalesForceSuppressionPrebuildDurationUpdateMutation>;
export type SalesForceSuppressionPrebuildDurationUpdateMutationOptions = Apollo.BaseMutationOptions<SalesForceSuppressionPrebuildDurationUpdateMutation, SalesForceSuppressionPrebuildDurationUpdateMutationVariables>;
export const SalesForceConfigSendLoggingUpdateDocument = gql`
    mutation SalesForceConfigSendLoggingUpdate($espId: ID!, $enabled: Boolean!) {
  campaignSalesforceMarketingCloudConfigSendLoggingUpdate(
    id: $espId
    enabled: $enabled
  ) {
    salesforceMarketingCloudConfig {
      id
      isSendLogging
    }
  }
}
    `;
export type SalesForceConfigSendLoggingUpdateMutationFn = Apollo.MutationFunction<SalesForceConfigSendLoggingUpdateMutation, SalesForceConfigSendLoggingUpdateMutationVariables>;

/**
 * __useSalesForceConfigSendLoggingUpdateMutation__
 *
 * To run a mutation, you first call `useSalesForceConfigSendLoggingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesForceConfigSendLoggingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesForceConfigSendLoggingUpdateMutation, { data, loading, error }] = useSalesForceConfigSendLoggingUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSalesForceConfigSendLoggingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesForceConfigSendLoggingUpdateMutation, SalesForceConfigSendLoggingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesForceConfigSendLoggingUpdateMutation, SalesForceConfigSendLoggingUpdateMutationVariables>(SalesForceConfigSendLoggingUpdateDocument, options);
      }
export type SalesForceConfigSendLoggingUpdateMutationHookResult = ReturnType<typeof useSalesForceConfigSendLoggingUpdateMutation>;
export type SalesForceConfigSendLoggingUpdateMutationResult = Apollo.MutationResult<SalesForceConfigSendLoggingUpdateMutation>;
export type SalesForceConfigSendLoggingUpdateMutationOptions = Apollo.BaseMutationOptions<SalesForceConfigSendLoggingUpdateMutation, SalesForceConfigSendLoggingUpdateMutationVariables>;
export const SalesforceDelayedDeliveryUpdateDocument = gql`
    mutation SalesforceDelayedDeliveryUpdate($enabled: Boolean, $id: ID!) {
  campaignSalesforceMarketingCloudConfigDelayedDeliveryUpdate(
    enabled: $enabled
    id: $id
  ) {
    salesforceMarketingCloudConfig {
      id
      delayedDelivery {
        enabled
      }
    }
  }
}
    `;
export type SalesforceDelayedDeliveryUpdateMutationFn = Apollo.MutationFunction<SalesforceDelayedDeliveryUpdateMutation, SalesforceDelayedDeliveryUpdateMutationVariables>;

/**
 * __useSalesforceDelayedDeliveryUpdateMutation__
 *
 * To run a mutation, you first call `useSalesforceDelayedDeliveryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesforceDelayedDeliveryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesforceDelayedDeliveryUpdateMutation, { data, loading, error }] = useSalesforceDelayedDeliveryUpdateMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSalesforceDelayedDeliveryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SalesforceDelayedDeliveryUpdateMutation, SalesforceDelayedDeliveryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesforceDelayedDeliveryUpdateMutation, SalesforceDelayedDeliveryUpdateMutationVariables>(SalesforceDelayedDeliveryUpdateDocument, options);
      }
export type SalesforceDelayedDeliveryUpdateMutationHookResult = ReturnType<typeof useSalesforceDelayedDeliveryUpdateMutation>;
export type SalesforceDelayedDeliveryUpdateMutationResult = Apollo.MutationResult<SalesforceDelayedDeliveryUpdateMutation>;
export type SalesforceDelayedDeliveryUpdateMutationOptions = Apollo.BaseMutationOptions<SalesforceDelayedDeliveryUpdateMutation, SalesforceDelayedDeliveryUpdateMutationVariables>;
export const CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateDocument = gql`
    mutation CampaignSalesforceMarketingCloudConfigSendThrottlingUpdate($id: ID!, $sendLimit: Int) {
  campaignSalesforceMarketingCloudConfigSendThrottlingUpdate(
    id: $id
    sendLimit: $sendLimit
  ) {
    salesforceMarketingCloudConfig {
      id
      sendLimit
    }
  }
}
    `;
export type CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationFn = Apollo.MutationFunction<CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation, CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationVariables>;

/**
 * __useCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation, { data, loading, error }] = useCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sendLimit: // value for 'sendLimit'
 *   },
 * });
 */
export function useCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation, CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation, CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationVariables>(CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateDocument, options);
      }
export type CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationHookResult = ReturnType<typeof useCampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation>;
export type CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationResult = Apollo.MutationResult<CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation>;
export type CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutation, CampaignSalesforceMarketingCloudConfigSendThrottlingUpdateMutationVariables>;
export const AcousticFromNameUpdateDocument = gql`
    mutation AcousticFromNameUpdate($fromNameId: ID!, $espId: ID!) {
  campaignAcousticCampaignConfigFromNameUpdate(
    fromNameId: $fromNameId
    id: $espId
  ) {
    acousticCampaignConfig {
      id
      fromName2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type AcousticFromNameUpdateMutationFn = Apollo.MutationFunction<AcousticFromNameUpdateMutation, AcousticFromNameUpdateMutationVariables>;

/**
 * __useAcousticFromNameUpdateMutation__
 *
 * To run a mutation, you first call `useAcousticFromNameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcousticFromNameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acousticFromNameUpdateMutation, { data, loading, error }] = useAcousticFromNameUpdateMutation({
 *   variables: {
 *      fromNameId: // value for 'fromNameId'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useAcousticFromNameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AcousticFromNameUpdateMutation, AcousticFromNameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcousticFromNameUpdateMutation, AcousticFromNameUpdateMutationVariables>(AcousticFromNameUpdateDocument, options);
      }
export type AcousticFromNameUpdateMutationHookResult = ReturnType<typeof useAcousticFromNameUpdateMutation>;
export type AcousticFromNameUpdateMutationResult = Apollo.MutationResult<AcousticFromNameUpdateMutation>;
export type AcousticFromNameUpdateMutationOptions = Apollo.BaseMutationOptions<AcousticFromNameUpdateMutation, AcousticFromNameUpdateMutationVariables>;
export const AcousticFromAddressUpdateDocument = gql`
    mutation AcousticFromAddressUpdate($fromAddressId: ID!, $espId: ID!) {
  campaignAcousticCampaignConfigFromAddressUpdate(
    fromAddressId: $fromAddressId
    id: $espId
  ) {
    acousticCampaignConfig {
      id
      fromAddress2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type AcousticFromAddressUpdateMutationFn = Apollo.MutationFunction<AcousticFromAddressUpdateMutation, AcousticFromAddressUpdateMutationVariables>;

/**
 * __useAcousticFromAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAcousticFromAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcousticFromAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acousticFromAddressUpdateMutation, { data, loading, error }] = useAcousticFromAddressUpdateMutation({
 *   variables: {
 *      fromAddressId: // value for 'fromAddressId'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useAcousticFromAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AcousticFromAddressUpdateMutation, AcousticFromAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcousticFromAddressUpdateMutation, AcousticFromAddressUpdateMutationVariables>(AcousticFromAddressUpdateDocument, options);
      }
export type AcousticFromAddressUpdateMutationHookResult = ReturnType<typeof useAcousticFromAddressUpdateMutation>;
export type AcousticFromAddressUpdateMutationResult = Apollo.MutationResult<AcousticFromAddressUpdateMutation>;
export type AcousticFromAddressUpdateMutationOptions = Apollo.BaseMutationOptions<AcousticFromAddressUpdateMutation, AcousticFromAddressUpdateMutationVariables>;
export const AcousticReplyToUpdateDocument = gql`
    mutation AcousticReplyToUpdate($replyToId: ID!, $espId: ID!) {
  campaignAcousticCampaignConfigReplyToUpdate(replyToId: $replyToId, id: $espId) {
    acousticCampaignConfig {
      id
      replyTo2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type AcousticReplyToUpdateMutationFn = Apollo.MutationFunction<AcousticReplyToUpdateMutation, AcousticReplyToUpdateMutationVariables>;

/**
 * __useAcousticReplyToUpdateMutation__
 *
 * To run a mutation, you first call `useAcousticReplyToUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcousticReplyToUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acousticReplyToUpdateMutation, { data, loading, error }] = useAcousticReplyToUpdateMutation({
 *   variables: {
 *      replyToId: // value for 'replyToId'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useAcousticReplyToUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AcousticReplyToUpdateMutation, AcousticReplyToUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcousticReplyToUpdateMutation, AcousticReplyToUpdateMutationVariables>(AcousticReplyToUpdateDocument, options);
      }
export type AcousticReplyToUpdateMutationHookResult = ReturnType<typeof useAcousticReplyToUpdateMutation>;
export type AcousticReplyToUpdateMutationResult = Apollo.MutationResult<AcousticReplyToUpdateMutation>;
export type AcousticReplyToUpdateMutationOptions = Apollo.BaseMutationOptions<AcousticReplyToUpdateMutation, AcousticReplyToUpdateMutationVariables>;
export const AcousticPreprocessingUpdateDocument = gql`
    mutation AcousticPreprocessingUpdate($enabled: Boolean, $espId: ID!) {
  campaignAcousticCampaignConfigPreprocessingUpdate(enabled: $enabled, id: $espId) {
    acousticCampaignConfig {
      id
      preprocessing {
        enabled
      }
    }
  }
}
    `;
export type AcousticPreprocessingUpdateMutationFn = Apollo.MutationFunction<AcousticPreprocessingUpdateMutation, AcousticPreprocessingUpdateMutationVariables>;

/**
 * __useAcousticPreprocessingUpdateMutation__
 *
 * To run a mutation, you first call `useAcousticPreprocessingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcousticPreprocessingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acousticPreprocessingUpdateMutation, { data, loading, error }] = useAcousticPreprocessingUpdateMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useAcousticPreprocessingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AcousticPreprocessingUpdateMutation, AcousticPreprocessingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcousticPreprocessingUpdateMutation, AcousticPreprocessingUpdateMutationVariables>(AcousticPreprocessingUpdateDocument, options);
      }
export type AcousticPreprocessingUpdateMutationHookResult = ReturnType<typeof useAcousticPreprocessingUpdateMutation>;
export type AcousticPreprocessingUpdateMutationResult = Apollo.MutationResult<AcousticPreprocessingUpdateMutation>;
export type AcousticPreprocessingUpdateMutationOptions = Apollo.BaseMutationOptions<AcousticPreprocessingUpdateMutation, AcousticPreprocessingUpdateMutationVariables>;
export const AcousticPreprocessingHoursUpdateDocument = gql`
    mutation AcousticPreprocessingHoursUpdate($preprocessingHours: Int!, $espId: ID!) {
  campaignAcousticCampaignConfigPreprocessingHoursUpdate(
    preprocessingHours: $preprocessingHours
    id: $espId
  ) {
    acousticCampaignConfig {
      id
      preprocessing {
        hours
      }
    }
  }
}
    `;
export type AcousticPreprocessingHoursUpdateMutationFn = Apollo.MutationFunction<AcousticPreprocessingHoursUpdateMutation, AcousticPreprocessingHoursUpdateMutationVariables>;

/**
 * __useAcousticPreprocessingHoursUpdateMutation__
 *
 * To run a mutation, you first call `useAcousticPreprocessingHoursUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcousticPreprocessingHoursUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acousticPreprocessingHoursUpdateMutation, { data, loading, error }] = useAcousticPreprocessingHoursUpdateMutation({
 *   variables: {
 *      preprocessingHours: // value for 'preprocessingHours'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useAcousticPreprocessingHoursUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AcousticPreprocessingHoursUpdateMutation, AcousticPreprocessingHoursUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcousticPreprocessingHoursUpdateMutation, AcousticPreprocessingHoursUpdateMutationVariables>(AcousticPreprocessingHoursUpdateDocument, options);
      }
export type AcousticPreprocessingHoursUpdateMutationHookResult = ReturnType<typeof useAcousticPreprocessingHoursUpdateMutation>;
export type AcousticPreprocessingHoursUpdateMutationResult = Apollo.MutationResult<AcousticPreprocessingHoursUpdateMutation>;
export type AcousticPreprocessingHoursUpdateMutationOptions = Apollo.BaseMutationOptions<AcousticPreprocessingHoursUpdateMutation, AcousticPreprocessingHoursUpdateMutationVariables>;
export const OracleSuppressionListAddDocument = gql`
    mutation OracleSuppressionListAdd($espId: ID!, $suppressionId: ID!) {
  campaignOracleResponsysConfigSuppressionListAdd(
    suppressionId: $suppressionId
    id: $espId
  ) {
    oracleResponsysConfig {
      id
      suppressions2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleSuppressionListAddMutationFn = Apollo.MutationFunction<OracleSuppressionListAddMutation, OracleSuppressionListAddMutationVariables>;

/**
 * __useOracleSuppressionListAddMutation__
 *
 * To run a mutation, you first call `useOracleSuppressionListAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleSuppressionListAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleSuppressionListAddMutation, { data, loading, error }] = useOracleSuppressionListAddMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      suppressionId: // value for 'suppressionId'
 *   },
 * });
 */
export function useOracleSuppressionListAddMutation(baseOptions?: Apollo.MutationHookOptions<OracleSuppressionListAddMutation, OracleSuppressionListAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleSuppressionListAddMutation, OracleSuppressionListAddMutationVariables>(OracleSuppressionListAddDocument, options);
      }
export type OracleSuppressionListAddMutationHookResult = ReturnType<typeof useOracleSuppressionListAddMutation>;
export type OracleSuppressionListAddMutationResult = Apollo.MutationResult<OracleSuppressionListAddMutation>;
export type OracleSuppressionListAddMutationOptions = Apollo.BaseMutationOptions<OracleSuppressionListAddMutation, OracleSuppressionListAddMutationVariables>;
export const OracleSuppressionListRemoveDocument = gql`
    mutation OracleSuppressionListRemove($espId: ID!, $suppressionId: ID!) {
  campaignOracleResponsysConfigSuppressionListRemove(
    suppressionId: $suppressionId
    id: $espId
  ) {
    oracleResponsysConfig {
      id
      suppressions2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleSuppressionListRemoveMutationFn = Apollo.MutationFunction<OracleSuppressionListRemoveMutation, OracleSuppressionListRemoveMutationVariables>;

/**
 * __useOracleSuppressionListRemoveMutation__
 *
 * To run a mutation, you first call `useOracleSuppressionListRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleSuppressionListRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleSuppressionListRemoveMutation, { data, loading, error }] = useOracleSuppressionListRemoveMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      suppressionId: // value for 'suppressionId'
 *   },
 * });
 */
export function useOracleSuppressionListRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OracleSuppressionListRemoveMutation, OracleSuppressionListRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleSuppressionListRemoveMutation, OracleSuppressionListRemoveMutationVariables>(OracleSuppressionListRemoveDocument, options);
      }
export type OracleSuppressionListRemoveMutationHookResult = ReturnType<typeof useOracleSuppressionListRemoveMutation>;
export type OracleSuppressionListRemoveMutationResult = Apollo.MutationResult<OracleSuppressionListRemoveMutation>;
export type OracleSuppressionListRemoveMutationOptions = Apollo.BaseMutationOptions<OracleSuppressionListRemoveMutation, OracleSuppressionListRemoveMutationVariables>;
export const OracleAdditionalDataSourceAddDocument = gql`
    mutation OracleAdditionalDataSourceAdd($espId: ID!, $additionalDataSourceId: ID!) {
  campaignOracleResponsysConfigAdditionalDataSourceAdd(
    id: $espId
    additionalDataSourceId: $additionalDataSourceId
  ) {
    oracleResponsysConfig {
      additionalDataSources2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleAdditionalDataSourceAddMutationFn = Apollo.MutationFunction<OracleAdditionalDataSourceAddMutation, OracleAdditionalDataSourceAddMutationVariables>;

/**
 * __useOracleAdditionalDataSourceAddMutation__
 *
 * To run a mutation, you first call `useOracleAdditionalDataSourceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleAdditionalDataSourceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleAdditionalDataSourceAddMutation, { data, loading, error }] = useOracleAdditionalDataSourceAddMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      additionalDataSourceId: // value for 'additionalDataSourceId'
 *   },
 * });
 */
export function useOracleAdditionalDataSourceAddMutation(baseOptions?: Apollo.MutationHookOptions<OracleAdditionalDataSourceAddMutation, OracleAdditionalDataSourceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleAdditionalDataSourceAddMutation, OracleAdditionalDataSourceAddMutationVariables>(OracleAdditionalDataSourceAddDocument, options);
      }
export type OracleAdditionalDataSourceAddMutationHookResult = ReturnType<typeof useOracleAdditionalDataSourceAddMutation>;
export type OracleAdditionalDataSourceAddMutationResult = Apollo.MutationResult<OracleAdditionalDataSourceAddMutation>;
export type OracleAdditionalDataSourceAddMutationOptions = Apollo.BaseMutationOptions<OracleAdditionalDataSourceAddMutation, OracleAdditionalDataSourceAddMutationVariables>;
export const OracleAdditionalDataSourceRemoveDocument = gql`
    mutation OracleAdditionalDataSourceRemove($espId: ID!, $additionalDataSourceId: ID!) {
  campaignOracleResponsysConfigAdditionalDataSourceRemove(
    additionalDataSourceId: $additionalDataSourceId
    id: $espId
  ) {
    oracleResponsysConfig {
      additionalDataSources2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleAdditionalDataSourceRemoveMutationFn = Apollo.MutationFunction<OracleAdditionalDataSourceRemoveMutation, OracleAdditionalDataSourceRemoveMutationVariables>;

/**
 * __useOracleAdditionalDataSourceRemoveMutation__
 *
 * To run a mutation, you first call `useOracleAdditionalDataSourceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleAdditionalDataSourceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleAdditionalDataSourceRemoveMutation, { data, loading, error }] = useOracleAdditionalDataSourceRemoveMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      additionalDataSourceId: // value for 'additionalDataSourceId'
 *   },
 * });
 */
export function useOracleAdditionalDataSourceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OracleAdditionalDataSourceRemoveMutation, OracleAdditionalDataSourceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleAdditionalDataSourceRemoveMutation, OracleAdditionalDataSourceRemoveMutationVariables>(OracleAdditionalDataSourceRemoveDocument, options);
      }
export type OracleAdditionalDataSourceRemoveMutationHookResult = ReturnType<typeof useOracleAdditionalDataSourceRemoveMutation>;
export type OracleAdditionalDataSourceRemoveMutationResult = Apollo.MutationResult<OracleAdditionalDataSourceRemoveMutation>;
export type OracleAdditionalDataSourceRemoveMutationOptions = Apollo.BaseMutationOptions<OracleAdditionalDataSourceRemoveMutation, OracleAdditionalDataSourceRemoveMutationVariables>;
export const OracleTextVariableUpdateDocument = gql`
    mutation OracleTextVariableUpdate($espId: ID!, $campaignVariableId: ID!, $text: String) {
  campaignOracleResponsysConfigTextCampaignVariableUpdate(
    campaignVariableId: $campaignVariableId
    id: $espId
    text: $text
  ) {
    oracleResponsysConfig {
      campaignVariables {
        id
        ... on TextAttribute {
          id
          value
        }
      }
    }
  }
}
    `;
export type OracleTextVariableUpdateMutationFn = Apollo.MutationFunction<OracleTextVariableUpdateMutation, OracleTextVariableUpdateMutationVariables>;

/**
 * __useOracleTextVariableUpdateMutation__
 *
 * To run a mutation, you first call `useOracleTextVariableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleTextVariableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleTextVariableUpdateMutation, { data, loading, error }] = useOracleTextVariableUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      campaignVariableId: // value for 'campaignVariableId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useOracleTextVariableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleTextVariableUpdateMutation, OracleTextVariableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleTextVariableUpdateMutation, OracleTextVariableUpdateMutationVariables>(OracleTextVariableUpdateDocument, options);
      }
export type OracleTextVariableUpdateMutationHookResult = ReturnType<typeof useOracleTextVariableUpdateMutation>;
export type OracleTextVariableUpdateMutationResult = Apollo.MutationResult<OracleTextVariableUpdateMutation>;
export type OracleTextVariableUpdateMutationOptions = Apollo.BaseMutationOptions<OracleTextVariableUpdateMutation, OracleTextVariableUpdateMutationVariables>;
export const OracleSelectVariableUpdateDocument = gql`
    mutation OracleSelectVariableUpdate($espId: ID!, $campaignVariableId: ID!, $choiceId: ID) {
  campaignOracleResponsysConfigSelectCampaignVariableUpdate(
    campaignVariableId: $campaignVariableId
    id: $espId
    choiceId: $choiceId
  ) {
    oracleResponsysConfig {
      campaignVariables {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleSelectVariableUpdateMutationFn = Apollo.MutationFunction<OracleSelectVariableUpdateMutation, OracleSelectVariableUpdateMutationVariables>;

/**
 * __useOracleSelectVariableUpdateMutation__
 *
 * To run a mutation, you first call `useOracleSelectVariableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleSelectVariableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleSelectVariableUpdateMutation, { data, loading, error }] = useOracleSelectVariableUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      campaignVariableId: // value for 'campaignVariableId'
 *      choiceId: // value for 'choiceId'
 *   },
 * });
 */
export function useOracleSelectVariableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleSelectVariableUpdateMutation, OracleSelectVariableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleSelectVariableUpdateMutation, OracleSelectVariableUpdateMutationVariables>(OracleSelectVariableUpdateDocument, options);
      }
export type OracleSelectVariableUpdateMutationHookResult = ReturnType<typeof useOracleSelectVariableUpdateMutation>;
export type OracleSelectVariableUpdateMutationResult = Apollo.MutationResult<OracleSelectVariableUpdateMutation>;
export type OracleSelectVariableUpdateMutationOptions = Apollo.BaseMutationOptions<OracleSelectVariableUpdateMutation, OracleSelectVariableUpdateMutationVariables>;
export const OracleMarketingProgramUpdateDocument = gql`
    mutation OracleMarketingProgramUpdate($espId: ID!, $marketingProgramId: ID!) {
  campaignOracleResponsysConfigMarketingProgramUpdate(
    marketingProgramId: $marketingProgramId
    id: $espId
  ) {
    oracleResponsysConfig {
      marketingProgram2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleMarketingProgramUpdateMutationFn = Apollo.MutationFunction<OracleMarketingProgramUpdateMutation, OracleMarketingProgramUpdateMutationVariables>;

/**
 * __useOracleMarketingProgramUpdateMutation__
 *
 * To run a mutation, you first call `useOracleMarketingProgramUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleMarketingProgramUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleMarketingProgramUpdateMutation, { data, loading, error }] = useOracleMarketingProgramUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      marketingProgramId: // value for 'marketingProgramId'
 *   },
 * });
 */
export function useOracleMarketingProgramUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleMarketingProgramUpdateMutation, OracleMarketingProgramUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleMarketingProgramUpdateMutation, OracleMarketingProgramUpdateMutationVariables>(OracleMarketingProgramUpdateDocument, options);
      }
export type OracleMarketingProgramUpdateMutationHookResult = ReturnType<typeof useOracleMarketingProgramUpdateMutation>;
export type OracleMarketingProgramUpdateMutationResult = Apollo.MutationResult<OracleMarketingProgramUpdateMutation>;
export type OracleMarketingProgramUpdateMutationOptions = Apollo.BaseMutationOptions<OracleMarketingProgramUpdateMutation, OracleMarketingProgramUpdateMutationVariables>;
export const OracleMarketingStrategyUpdateDocument = gql`
    mutation OracleMarketingStrategyUpdate($espId: ID!, $marketingStrategyId: ID!) {
  campaignOracleResponsysConfigMarketingStrategyUpdate(
    marketingStrategyId: $marketingStrategyId
    id: $espId
  ) {
    oracleResponsysConfig {
      marketingStrategy2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleMarketingStrategyUpdateMutationFn = Apollo.MutationFunction<OracleMarketingStrategyUpdateMutation, OracleMarketingStrategyUpdateMutationVariables>;

/**
 * __useOracleMarketingStrategyUpdateMutation__
 *
 * To run a mutation, you first call `useOracleMarketingStrategyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleMarketingStrategyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleMarketingStrategyUpdateMutation, { data, loading, error }] = useOracleMarketingStrategyUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      marketingStrategyId: // value for 'marketingStrategyId'
 *   },
 * });
 */
export function useOracleMarketingStrategyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleMarketingStrategyUpdateMutation, OracleMarketingStrategyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleMarketingStrategyUpdateMutation, OracleMarketingStrategyUpdateMutationVariables>(OracleMarketingStrategyUpdateDocument, options);
      }
export type OracleMarketingStrategyUpdateMutationHookResult = ReturnType<typeof useOracleMarketingStrategyUpdateMutation>;
export type OracleMarketingStrategyUpdateMutationResult = Apollo.MutationResult<OracleMarketingStrategyUpdateMutation>;
export type OracleMarketingStrategyUpdateMutationOptions = Apollo.BaseMutationOptions<OracleMarketingStrategyUpdateMutation, OracleMarketingStrategyUpdateMutationVariables>;
export const OracleFromEmailUpdateDocument = gql`
    mutation OracleFromEmailUpdate($espId: ID!, $fromEmailId: ID!) {
  campaignOracleResponsysConfigFromEmailUpdate(
    fromEmailId: $fromEmailId
    id: $espId
  ) {
    oracleResponsysConfig {
      fromEmail2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleFromEmailUpdateMutationFn = Apollo.MutationFunction<OracleFromEmailUpdateMutation, OracleFromEmailUpdateMutationVariables>;

/**
 * __useOracleFromEmailUpdateMutation__
 *
 * To run a mutation, you first call `useOracleFromEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleFromEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleFromEmailUpdateMutation, { data, loading, error }] = useOracleFromEmailUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      fromEmailId: // value for 'fromEmailId'
 *   },
 * });
 */
export function useOracleFromEmailUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleFromEmailUpdateMutation, OracleFromEmailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleFromEmailUpdateMutation, OracleFromEmailUpdateMutationVariables>(OracleFromEmailUpdateDocument, options);
      }
export type OracleFromEmailUpdateMutationHookResult = ReturnType<typeof useOracleFromEmailUpdateMutation>;
export type OracleFromEmailUpdateMutationResult = Apollo.MutationResult<OracleFromEmailUpdateMutation>;
export type OracleFromEmailUpdateMutationOptions = Apollo.BaseMutationOptions<OracleFromEmailUpdateMutation, OracleFromEmailUpdateMutationVariables>;
export const OracleReplyToUpdateDocument = gql`
    mutation OracleReplyToUpdate($espId: ID!, $replyToId: ID!) {
  campaignOracleResponsysConfigReplyToUpdate(replyToId: $replyToId, id: $espId) {
    oracleResponsysConfig {
      replyTo2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleReplyToUpdateMutationFn = Apollo.MutationFunction<OracleReplyToUpdateMutation, OracleReplyToUpdateMutationVariables>;

/**
 * __useOracleReplyToUpdateMutation__
 *
 * To run a mutation, you first call `useOracleReplyToUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleReplyToUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleReplyToUpdateMutation, { data, loading, error }] = useOracleReplyToUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      replyToId: // value for 'replyToId'
 *   },
 * });
 */
export function useOracleReplyToUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleReplyToUpdateMutation, OracleReplyToUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleReplyToUpdateMutation, OracleReplyToUpdateMutationVariables>(OracleReplyToUpdateDocument, options);
      }
export type OracleReplyToUpdateMutationHookResult = ReturnType<typeof useOracleReplyToUpdateMutation>;
export type OracleReplyToUpdateMutationResult = Apollo.MutationResult<OracleReplyToUpdateMutation>;
export type OracleReplyToUpdateMutationOptions = Apollo.BaseMutationOptions<OracleReplyToUpdateMutation, OracleReplyToUpdateMutationVariables>;
export const OracleFromNameUpdateDocument = gql`
    mutation OracleFromNameUpdate($espId: ID!, $fromNameId: ID!) {
  campaignOracleResponsysConfigFromNameUpdate(fromNameId: $fromNameId, id: $espId) {
    oracleResponsysConfig {
      fromName2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleFromNameUpdateMutationFn = Apollo.MutationFunction<OracleFromNameUpdateMutation, OracleFromNameUpdateMutationVariables>;

/**
 * __useOracleFromNameUpdateMutation__
 *
 * To run a mutation, you first call `useOracleFromNameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleFromNameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleFromNameUpdateMutation, { data, loading, error }] = useOracleFromNameUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      fromNameId: // value for 'fromNameId'
 *   },
 * });
 */
export function useOracleFromNameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleFromNameUpdateMutation, OracleFromNameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleFromNameUpdateMutation, OracleFromNameUpdateMutationVariables>(OracleFromNameUpdateDocument, options);
      }
export type OracleFromNameUpdateMutationHookResult = ReturnType<typeof useOracleFromNameUpdateMutation>;
export type OracleFromNameUpdateMutationResult = Apollo.MutationResult<OracleFromNameUpdateMutation>;
export type OracleFromNameUpdateMutationOptions = Apollo.BaseMutationOptions<OracleFromNameUpdateMutation, OracleFromNameUpdateMutationVariables>;
export const OracleProfileListUpdateDocument = gql`
    mutation OracleProfileListUpdate($espId: ID!, $profileListId: ID!) {
  campaignOracleResponsysConfigProfileListUpdate(
    profileListId: $profileListId
    id: $espId
  ) {
    oracleResponsysConfig {
      id
      profileList2 {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleProfileListUpdateMutationFn = Apollo.MutationFunction<OracleProfileListUpdateMutation, OracleProfileListUpdateMutationVariables>;

/**
 * __useOracleProfileListUpdateMutation__
 *
 * To run a mutation, you first call `useOracleProfileListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleProfileListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleProfileListUpdateMutation, { data, loading, error }] = useOracleProfileListUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      profileListId: // value for 'profileListId'
 *   },
 * });
 */
export function useOracleProfileListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleProfileListUpdateMutation, OracleProfileListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleProfileListUpdateMutation, OracleProfileListUpdateMutationVariables>(OracleProfileListUpdateDocument, options);
      }
export type OracleProfileListUpdateMutationHookResult = ReturnType<typeof useOracleProfileListUpdateMutation>;
export type OracleProfileListUpdateMutationResult = Apollo.MutationResult<OracleProfileListUpdateMutation>;
export type OracleProfileListUpdateMutationOptions = Apollo.BaseMutationOptions<OracleProfileListUpdateMutation, OracleProfileListUpdateMutationVariables>;
export const OracleTextTrackingParameterUpdateDocument = gql`
    mutation OracleTextTrackingParameterUpdate($espId: ID!, $externalTrackingParamId: ID!, $value: String) {
  campaignOracleResponsysConfigTextExternalTrackingParameterUpdate(
    externalTrackingParamId: $externalTrackingParamId
    id: $espId
    value: $value
  ) {
    oracleResponsysConfig {
      externalTrackingParameters {
        ... on TextAttribute {
          id
          value
        }
      }
    }
  }
}
    `;
export type OracleTextTrackingParameterUpdateMutationFn = Apollo.MutationFunction<OracleTextTrackingParameterUpdateMutation, OracleTextTrackingParameterUpdateMutationVariables>;

/**
 * __useOracleTextTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useOracleTextTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleTextTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleTextTrackingParameterUpdateMutation, { data, loading, error }] = useOracleTextTrackingParameterUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      externalTrackingParamId: // value for 'externalTrackingParamId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useOracleTextTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleTextTrackingParameterUpdateMutation, OracleTextTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleTextTrackingParameterUpdateMutation, OracleTextTrackingParameterUpdateMutationVariables>(OracleTextTrackingParameterUpdateDocument, options);
      }
export type OracleTextTrackingParameterUpdateMutationHookResult = ReturnType<typeof useOracleTextTrackingParameterUpdateMutation>;
export type OracleTextTrackingParameterUpdateMutationResult = Apollo.MutationResult<OracleTextTrackingParameterUpdateMutation>;
export type OracleTextTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<OracleTextTrackingParameterUpdateMutation, OracleTextTrackingParameterUpdateMutationVariables>;
export const OracleSelectTrackingParameterUpdateDocument = gql`
    mutation OracleSelectTrackingParameterUpdate($espId: ID!, $externalTrackingParamId: ID!, $optionId: ID) {
  campaignOracleResponsysConfigSelectExternalTrackingParameterUpdate(
    externalTrackingParamId: $externalTrackingParamId
    id: $espId
    optionId: $optionId
  ) {
    oracleResponsysConfig {
      externalTrackingParameters {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type OracleSelectTrackingParameterUpdateMutationFn = Apollo.MutationFunction<OracleSelectTrackingParameterUpdateMutation, OracleSelectTrackingParameterUpdateMutationVariables>;

/**
 * __useOracleSelectTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useOracleSelectTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleSelectTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleSelectTrackingParameterUpdateMutation, { data, loading, error }] = useOracleSelectTrackingParameterUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      externalTrackingParamId: // value for 'externalTrackingParamId'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useOracleSelectTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OracleSelectTrackingParameterUpdateMutation, OracleSelectTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OracleSelectTrackingParameterUpdateMutation, OracleSelectTrackingParameterUpdateMutationVariables>(OracleSelectTrackingParameterUpdateDocument, options);
      }
export type OracleSelectTrackingParameterUpdateMutationHookResult = ReturnType<typeof useOracleSelectTrackingParameterUpdateMutation>;
export type OracleSelectTrackingParameterUpdateMutationResult = Apollo.MutationResult<OracleSelectTrackingParameterUpdateMutation>;
export type OracleSelectTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<OracleSelectTrackingParameterUpdateMutation, OracleSelectTrackingParameterUpdateMutationVariables>;
export const CampaignEmailServiceProviderUpdateDocument = gql`
    mutation CampaignEmailServiceProviderUpdate($id: ID!, $emailServiceProviderId: ID!) {
  campaignEmailServiceProviderUpdate(
    id: $id
    emailServiceProviderId: $emailServiceProviderId
  ) {
    campaign {
      id
      emailServiceProvider {
        __typename
        ... on AcousticCampaign {
          id
        }
        ... on AdobeCampaign {
          id
        }
        ... on AdobeJourneyOptimizer {
          id
        }
        ... on AmazonSES {
          id
        }
        ... on Braze {
          id
        }
        ... on Cordial {
          id
        }
        ... on OracleResponsys {
          id
        }
        ... on SalesForceMarketingCloud {
          id
        }
        ... on Epsilon {
          id
        }
        ... on Zeta {
          id
        }
        ... on Blackhole {
          id
        }
        ... on Bluecore {
          id
        }
        ... on SFNext {
          id
        }
      }
      espConfig {
        ... on CampaignSalesforceMarketingCloudConfig {
          ...espSalesForceFragment
        }
        ... on CampaignAcousticCampaignConfig {
          ...espAcousticFragment
        }
        ... on CampaignOracleResponsysConfig {
          ...espOracleFragment
        }
        ... on CampaignCordialConfig {
          ...espCordialFragment
        }
        ... on CampaignAdobeCampaignConfig {
          ...espAdobeCampaignFragment
        }
        ... on AdobeJourneyOptimizerConfig {
          ...espAdobeJourneyOptimizerFragment
        }
        ... on AmazonSESConfig {
          ...espAmazonSESFragment
        }
        ... on ZetaConfig {
          ...espZetaFragment
        }
      }
    }
  }
}
    ${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspAmazonSesFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}`;
export type CampaignEmailServiceProviderUpdateMutationFn = Apollo.MutationFunction<CampaignEmailServiceProviderUpdateMutation, CampaignEmailServiceProviderUpdateMutationVariables>;

/**
 * __useCampaignEmailServiceProviderUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignEmailServiceProviderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignEmailServiceProviderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignEmailServiceProviderUpdateMutation, { data, loading, error }] = useCampaignEmailServiceProviderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailServiceProviderId: // value for 'emailServiceProviderId'
 *   },
 * });
 */
export function useCampaignEmailServiceProviderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignEmailServiceProviderUpdateMutation, CampaignEmailServiceProviderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignEmailServiceProviderUpdateMutation, CampaignEmailServiceProviderUpdateMutationVariables>(CampaignEmailServiceProviderUpdateDocument, options);
      }
export type CampaignEmailServiceProviderUpdateMutationHookResult = ReturnType<typeof useCampaignEmailServiceProviderUpdateMutation>;
export type CampaignEmailServiceProviderUpdateMutationResult = Apollo.MutationResult<CampaignEmailServiceProviderUpdateMutation>;
export type CampaignEmailServiceProviderUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignEmailServiceProviderUpdateMutation, CampaignEmailServiceProviderUpdateMutationVariables>;
export const CordialExcludeAudienceAddDocument = gql`
    mutation CordialExcludeAudienceAdd($excludeAudienceId: ID!, $espId: ID!) {
  campaignCordialConfigExcludeAudienceAdd(
    id: $espId
    excludeAudienceId: $excludeAudienceId
  ) {
    cordialConfig {
      excludeAudiences2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type CordialExcludeAudienceAddMutationFn = Apollo.MutationFunction<CordialExcludeAudienceAddMutation, CordialExcludeAudienceAddMutationVariables>;

/**
 * __useCordialExcludeAudienceAddMutation__
 *
 * To run a mutation, you first call `useCordialExcludeAudienceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialExcludeAudienceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialExcludeAudienceAddMutation, { data, loading, error }] = useCordialExcludeAudienceAddMutation({
 *   variables: {
 *      excludeAudienceId: // value for 'excludeAudienceId'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useCordialExcludeAudienceAddMutation(baseOptions?: Apollo.MutationHookOptions<CordialExcludeAudienceAddMutation, CordialExcludeAudienceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialExcludeAudienceAddMutation, CordialExcludeAudienceAddMutationVariables>(CordialExcludeAudienceAddDocument, options);
      }
export type CordialExcludeAudienceAddMutationHookResult = ReturnType<typeof useCordialExcludeAudienceAddMutation>;
export type CordialExcludeAudienceAddMutationResult = Apollo.MutationResult<CordialExcludeAudienceAddMutation>;
export type CordialExcludeAudienceAddMutationOptions = Apollo.BaseMutationOptions<CordialExcludeAudienceAddMutation, CordialExcludeAudienceAddMutationVariables>;
export const CordialExcludeAudienceRemoveDocument = gql`
    mutation CordialExcludeAudienceRemove($excludeAudienceId: ID!, $espId: ID!) {
  campaignCordialConfigExcludeAudienceRemove(
    id: $espId
    excludeAudienceId: $excludeAudienceId
  ) {
    cordialConfig {
      excludeAudiences2 {
        ... on MultiSelectAttribute2 {
          id
          selectedIds
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type CordialExcludeAudienceRemoveMutationFn = Apollo.MutationFunction<CordialExcludeAudienceRemoveMutation, CordialExcludeAudienceRemoveMutationVariables>;

/**
 * __useCordialExcludeAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useCordialExcludeAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialExcludeAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialExcludeAudienceRemoveMutation, { data, loading, error }] = useCordialExcludeAudienceRemoveMutation({
 *   variables: {
 *      excludeAudienceId: // value for 'excludeAudienceId'
 *      espId: // value for 'espId'
 *   },
 * });
 */
export function useCordialExcludeAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CordialExcludeAudienceRemoveMutation, CordialExcludeAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialExcludeAudienceRemoveMutation, CordialExcludeAudienceRemoveMutationVariables>(CordialExcludeAudienceRemoveDocument, options);
      }
export type CordialExcludeAudienceRemoveMutationHookResult = ReturnType<typeof useCordialExcludeAudienceRemoveMutation>;
export type CordialExcludeAudienceRemoveMutationResult = Apollo.MutationResult<CordialExcludeAudienceRemoveMutation>;
export type CordialExcludeAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<CordialExcludeAudienceRemoveMutation, CordialExcludeAudienceRemoveMutationVariables>;
export const CordialSendPropertyCreate2Document = gql`
    mutation CordialSendPropertyCreate2($espId: ID!, $defaultSendPropertyId: ID!, $value: String!) {
  campaignCordialConfigSendPropertyCreate2(
    id: $espId
    defaultPropertyId: $defaultSendPropertyId
    value: $value
  ) {
    cordialConfig {
      id
      sendProperties {
        id
        defaultSendPropertyId
        value
      }
    }
  }
}
    `;
export type CordialSendPropertyCreate2MutationFn = Apollo.MutationFunction<CordialSendPropertyCreate2Mutation, CordialSendPropertyCreate2MutationVariables>;

/**
 * __useCordialSendPropertyCreate2Mutation__
 *
 * To run a mutation, you first call `useCordialSendPropertyCreate2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialSendPropertyCreate2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialSendPropertyCreate2Mutation, { data, loading, error }] = useCordialSendPropertyCreate2Mutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      defaultSendPropertyId: // value for 'defaultSendPropertyId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCordialSendPropertyCreate2Mutation(baseOptions?: Apollo.MutationHookOptions<CordialSendPropertyCreate2Mutation, CordialSendPropertyCreate2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialSendPropertyCreate2Mutation, CordialSendPropertyCreate2MutationVariables>(CordialSendPropertyCreate2Document, options);
      }
export type CordialSendPropertyCreate2MutationHookResult = ReturnType<typeof useCordialSendPropertyCreate2Mutation>;
export type CordialSendPropertyCreate2MutationResult = Apollo.MutationResult<CordialSendPropertyCreate2Mutation>;
export type CordialSendPropertyCreate2MutationOptions = Apollo.BaseMutationOptions<CordialSendPropertyCreate2Mutation, CordialSendPropertyCreate2MutationVariables>;
export const CordialSendPropertyUpdate2Document = gql`
    mutation CordialSendPropertyUpdate2($sendPropertyId: ID!, $defaultSendPropertyId: ID, $value: String!) {
  campaignCordialConfigSendPropertyUpdate2(
    sendPropertyId: $sendPropertyId
    defaultPropertyId: $defaultSendPropertyId
    value: $value
  ) {
    cordialConfig {
      id
      sendProperties {
        id
        defaultSendPropertyId
        value
      }
    }
  }
}
    `;
export type CordialSendPropertyUpdate2MutationFn = Apollo.MutationFunction<CordialSendPropertyUpdate2Mutation, CordialSendPropertyUpdate2MutationVariables>;

/**
 * __useCordialSendPropertyUpdate2Mutation__
 *
 * To run a mutation, you first call `useCordialSendPropertyUpdate2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialSendPropertyUpdate2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialSendPropertyUpdate2Mutation, { data, loading, error }] = useCordialSendPropertyUpdate2Mutation({
 *   variables: {
 *      sendPropertyId: // value for 'sendPropertyId'
 *      defaultSendPropertyId: // value for 'defaultSendPropertyId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCordialSendPropertyUpdate2Mutation(baseOptions?: Apollo.MutationHookOptions<CordialSendPropertyUpdate2Mutation, CordialSendPropertyUpdate2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialSendPropertyUpdate2Mutation, CordialSendPropertyUpdate2MutationVariables>(CordialSendPropertyUpdate2Document, options);
      }
export type CordialSendPropertyUpdate2MutationHookResult = ReturnType<typeof useCordialSendPropertyUpdate2Mutation>;
export type CordialSendPropertyUpdate2MutationResult = Apollo.MutationResult<CordialSendPropertyUpdate2Mutation>;
export type CordialSendPropertyUpdate2MutationOptions = Apollo.BaseMutationOptions<CordialSendPropertyUpdate2Mutation, CordialSendPropertyUpdate2MutationVariables>;
export const CordialSendPropertyDeleteDocument = gql`
    mutation CordialSendPropertyDelete($sendPropertyId: ID!) {
  campaignCordialConfigSendPropertyDelete(sendPropertyId: $sendPropertyId) {
    cordialConfig {
      id
      sendProperties {
        id
        defaultSendPropertyId
        value
      }
    }
  }
}
    `;
export type CordialSendPropertyDeleteMutationFn = Apollo.MutationFunction<CordialSendPropertyDeleteMutation, CordialSendPropertyDeleteMutationVariables>;

/**
 * __useCordialSendPropertyDeleteMutation__
 *
 * To run a mutation, you first call `useCordialSendPropertyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialSendPropertyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialSendPropertyDeleteMutation, { data, loading, error }] = useCordialSendPropertyDeleteMutation({
 *   variables: {
 *      sendPropertyId: // value for 'sendPropertyId'
 *   },
 * });
 */
export function useCordialSendPropertyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CordialSendPropertyDeleteMutation, CordialSendPropertyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialSendPropertyDeleteMutation, CordialSendPropertyDeleteMutationVariables>(CordialSendPropertyDeleteDocument, options);
      }
export type CordialSendPropertyDeleteMutationHookResult = ReturnType<typeof useCordialSendPropertyDeleteMutation>;
export type CordialSendPropertyDeleteMutationResult = Apollo.MutationResult<CordialSendPropertyDeleteMutation>;
export type CordialSendPropertyDeleteMutationOptions = Apollo.BaseMutationOptions<CordialSendPropertyDeleteMutation, CordialSendPropertyDeleteMutationVariables>;
export const CordialTagsUpdateDocument = gql`
    mutation CordialTagsUpdate($espId: ID!, $tags: [String!]!) {
  campaignCordialConfigTagsUpdate(id: $espId, tags: $tags) {
    cordialConfig {
      id
      tags
    }
  }
}
    `;
export type CordialTagsUpdateMutationFn = Apollo.MutationFunction<CordialTagsUpdateMutation, CordialTagsUpdateMutationVariables>;

/**
 * __useCordialTagsUpdateMutation__
 *
 * To run a mutation, you first call `useCordialTagsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialTagsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialTagsUpdateMutation, { data, loading, error }] = useCordialTagsUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCordialTagsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CordialTagsUpdateMutation, CordialTagsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialTagsUpdateMutation, CordialTagsUpdateMutationVariables>(CordialTagsUpdateDocument, options);
      }
export type CordialTagsUpdateMutationHookResult = ReturnType<typeof useCordialTagsUpdateMutation>;
export type CordialTagsUpdateMutationResult = Apollo.MutationResult<CordialTagsUpdateMutation>;
export type CordialTagsUpdateMutationOptions = Apollo.BaseMutationOptions<CordialTagsUpdateMutation, CordialTagsUpdateMutationVariables>;
export const CordialSenderProfileUpdateDocument = gql`
    mutation CordialSenderProfileUpdate($espId: ID!, $senderProfileId: ID) {
  campaignCordialConfigSenderProfileUpdate(
    id: $espId
    senderProfileId: $senderProfileId
  ) {
    cordialConfig {
      id
      senderProfile {
        ... on SelectAttribute2 {
          id
          selectedId
          definition {
            id
            options {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type CordialSenderProfileUpdateMutationFn = Apollo.MutationFunction<CordialSenderProfileUpdateMutation, CordialSenderProfileUpdateMutationVariables>;

/**
 * __useCordialSenderProfileUpdateMutation__
 *
 * To run a mutation, you first call `useCordialSenderProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCordialSenderProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cordialSenderProfileUpdateMutation, { data, loading, error }] = useCordialSenderProfileUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      senderProfileId: // value for 'senderProfileId'
 *   },
 * });
 */
export function useCordialSenderProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CordialSenderProfileUpdateMutation, CordialSenderProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CordialSenderProfileUpdateMutation, CordialSenderProfileUpdateMutationVariables>(CordialSenderProfileUpdateDocument, options);
      }
export type CordialSenderProfileUpdateMutationHookResult = ReturnType<typeof useCordialSenderProfileUpdateMutation>;
export type CordialSenderProfileUpdateMutationResult = Apollo.MutationResult<CordialSenderProfileUpdateMutation>;
export type CordialSenderProfileUpdateMutationOptions = Apollo.BaseMutationOptions<CordialSenderProfileUpdateMutation, CordialSenderProfileUpdateMutationVariables>;
export const AdobeCampaignLabelUpdateDocument = gql`
    mutation AdobeCampaignLabelUpdate($espId: ID!, $label: String!) {
  campaignAdobeCampaignConfigLabelUpdate(label: $label, id: $espId) {
    adobeCampaignConfig {
      label
    }
  }
}
    `;
export type AdobeCampaignLabelUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignLabelUpdateMutation, AdobeCampaignLabelUpdateMutationVariables>;

/**
 * __useAdobeCampaignLabelUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignLabelUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignLabelUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignLabelUpdateMutation, { data, loading, error }] = useAdobeCampaignLabelUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useAdobeCampaignLabelUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignLabelUpdateMutation, AdobeCampaignLabelUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignLabelUpdateMutation, AdobeCampaignLabelUpdateMutationVariables>(AdobeCampaignLabelUpdateDocument, options);
      }
export type AdobeCampaignLabelUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignLabelUpdateMutation>;
export type AdobeCampaignLabelUpdateMutationResult = Apollo.MutationResult<AdobeCampaignLabelUpdateMutation>;
export type AdobeCampaignLabelUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignLabelUpdateMutation, AdobeCampaignLabelUpdateMutationVariables>;
export const AdobeCampaignDeliveryCodeUpdateDocument = gql`
    mutation AdobeCampaignDeliveryCodeUpdate($espId: ID!, $deliveryCode: String!) {
  campaignAdobeCampaignConfigDeliveryCodeUpdate(
    deliveryCode: $deliveryCode
    id: $espId
  ) {
    adobeCampaignConfig {
      deliveryCode
    }
  }
}
    `;
export type AdobeCampaignDeliveryCodeUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignDeliveryCodeUpdateMutation, AdobeCampaignDeliveryCodeUpdateMutationVariables>;

/**
 * __useAdobeCampaignDeliveryCodeUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignDeliveryCodeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignDeliveryCodeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignDeliveryCodeUpdateMutation, { data, loading, error }] = useAdobeCampaignDeliveryCodeUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      deliveryCode: // value for 'deliveryCode'
 *   },
 * });
 */
export function useAdobeCampaignDeliveryCodeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignDeliveryCodeUpdateMutation, AdobeCampaignDeliveryCodeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignDeliveryCodeUpdateMutation, AdobeCampaignDeliveryCodeUpdateMutationVariables>(AdobeCampaignDeliveryCodeUpdateDocument, options);
      }
export type AdobeCampaignDeliveryCodeUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignDeliveryCodeUpdateMutation>;
export type AdobeCampaignDeliveryCodeUpdateMutationResult = Apollo.MutationResult<AdobeCampaignDeliveryCodeUpdateMutation>;
export type AdobeCampaignDeliveryCodeUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignDeliveryCodeUpdateMutation, AdobeCampaignDeliveryCodeUpdateMutationVariables>;
export const AdobeCampaignFromNameUpdateDocument = gql`
    mutation AdobeCampaignFromNameUpdate($espId: ID!, $fromName: String!) {
  campaignAdobeCampaignConfigFromNameUpdate(fromName: $fromName, id: $espId) {
    adobeCampaignConfig {
      fromName
    }
  }
}
    `;
export type AdobeCampaignFromNameUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignFromNameUpdateMutation, AdobeCampaignFromNameUpdateMutationVariables>;

/**
 * __useAdobeCampaignFromNameUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignFromNameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignFromNameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignFromNameUpdateMutation, { data, loading, error }] = useAdobeCampaignFromNameUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      fromName: // value for 'fromName'
 *   },
 * });
 */
export function useAdobeCampaignFromNameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignFromNameUpdateMutation, AdobeCampaignFromNameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignFromNameUpdateMutation, AdobeCampaignFromNameUpdateMutationVariables>(AdobeCampaignFromNameUpdateDocument, options);
      }
export type AdobeCampaignFromNameUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignFromNameUpdateMutation>;
export type AdobeCampaignFromNameUpdateMutationResult = Apollo.MutationResult<AdobeCampaignFromNameUpdateMutation>;
export type AdobeCampaignFromNameUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignFromNameUpdateMutation, AdobeCampaignFromNameUpdateMutationVariables>;
export const AdobeCampaignFromAddressUpdateDocument = gql`
    mutation AdobeCampaignFromAddressUpdate($espId: ID!, $fromAddress: String!) {
  campaignAdobeCampaignConfigFromAddressUpdate(
    fromAddress: $fromAddress
    id: $espId
  ) {
    adobeCampaignConfig {
      fromAddress
    }
  }
}
    `;
export type AdobeCampaignFromAddressUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignFromAddressUpdateMutation, AdobeCampaignFromAddressUpdateMutationVariables>;

/**
 * __useAdobeCampaignFromAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignFromAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignFromAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignFromAddressUpdateMutation, { data, loading, error }] = useAdobeCampaignFromAddressUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      fromAddress: // value for 'fromAddress'
 *   },
 * });
 */
export function useAdobeCampaignFromAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignFromAddressUpdateMutation, AdobeCampaignFromAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignFromAddressUpdateMutation, AdobeCampaignFromAddressUpdateMutationVariables>(AdobeCampaignFromAddressUpdateDocument, options);
      }
export type AdobeCampaignFromAddressUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignFromAddressUpdateMutation>;
export type AdobeCampaignFromAddressUpdateMutationResult = Apollo.MutationResult<AdobeCampaignFromAddressUpdateMutation>;
export type AdobeCampaignFromAddressUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignFromAddressUpdateMutation, AdobeCampaignFromAddressUpdateMutationVariables>;
export const AdobeCampaignReplyToNameUpdateDocument = gql`
    mutation AdobeCampaignReplyToNameUpdate($espId: ID!, $replyToName: String!) {
  campaignAdobeCampaignConfigReplyToNameUpdate(
    replyToName: $replyToName
    id: $espId
  ) {
    adobeCampaignConfig {
      replyToName
    }
  }
}
    `;
export type AdobeCampaignReplyToNameUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignReplyToNameUpdateMutation, AdobeCampaignReplyToNameUpdateMutationVariables>;

/**
 * __useAdobeCampaignReplyToNameUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignReplyToNameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignReplyToNameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignReplyToNameUpdateMutation, { data, loading, error }] = useAdobeCampaignReplyToNameUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      replyToName: // value for 'replyToName'
 *   },
 * });
 */
export function useAdobeCampaignReplyToNameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignReplyToNameUpdateMutation, AdobeCampaignReplyToNameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignReplyToNameUpdateMutation, AdobeCampaignReplyToNameUpdateMutationVariables>(AdobeCampaignReplyToNameUpdateDocument, options);
      }
export type AdobeCampaignReplyToNameUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignReplyToNameUpdateMutation>;
export type AdobeCampaignReplyToNameUpdateMutationResult = Apollo.MutationResult<AdobeCampaignReplyToNameUpdateMutation>;
export type AdobeCampaignReplyToNameUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignReplyToNameUpdateMutation, AdobeCampaignReplyToNameUpdateMutationVariables>;
export const AdobeCampaignReplyToAddressUpdateDocument = gql`
    mutation AdobeCampaignReplyToAddressUpdate($espId: ID!, $replyToAddress: String!) {
  campaignAdobeCampaignConfigReplyToAddressUpdate(
    replyToAddress: $replyToAddress
    id: $espId
  ) {
    adobeCampaignConfig {
      replyToAddress
    }
  }
}
    `;
export type AdobeCampaignReplyToAddressUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignReplyToAddressUpdateMutation, AdobeCampaignReplyToAddressUpdateMutationVariables>;

/**
 * __useAdobeCampaignReplyToAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignReplyToAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignReplyToAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignReplyToAddressUpdateMutation, { data, loading, error }] = useAdobeCampaignReplyToAddressUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      replyToAddress: // value for 'replyToAddress'
 *   },
 * });
 */
export function useAdobeCampaignReplyToAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignReplyToAddressUpdateMutation, AdobeCampaignReplyToAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignReplyToAddressUpdateMutation, AdobeCampaignReplyToAddressUpdateMutationVariables>(AdobeCampaignReplyToAddressUpdateDocument, options);
      }
export type AdobeCampaignReplyToAddressUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignReplyToAddressUpdateMutation>;
export type AdobeCampaignReplyToAddressUpdateMutationResult = Apollo.MutationResult<AdobeCampaignReplyToAddressUpdateMutation>;
export type AdobeCampaignReplyToAddressUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignReplyToAddressUpdateMutation, AdobeCampaignReplyToAddressUpdateMutationVariables>;
export const AdobeCampaignTargetMappingIdUpdateDocument = gql`
    mutation AdobeCampaignTargetMappingIdUpdate($espId: ID!, $targetMappingId: Int!) {
  campaignAdobeCampaignConfigTargetMappingIdUpdate(
    targetMappingId: $targetMappingId
    id: $espId
  ) {
    adobeCampaignConfig {
      targetMappingId
    }
  }
}
    `;
export type AdobeCampaignTargetMappingIdUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignTargetMappingIdUpdateMutation, AdobeCampaignTargetMappingIdUpdateMutationVariables>;

/**
 * __useAdobeCampaignTargetMappingIdUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignTargetMappingIdUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignTargetMappingIdUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignTargetMappingIdUpdateMutation, { data, loading, error }] = useAdobeCampaignTargetMappingIdUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      targetMappingId: // value for 'targetMappingId'
 *   },
 * });
 */
export function useAdobeCampaignTargetMappingIdUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignTargetMappingIdUpdateMutation, AdobeCampaignTargetMappingIdUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignTargetMappingIdUpdateMutation, AdobeCampaignTargetMappingIdUpdateMutationVariables>(AdobeCampaignTargetMappingIdUpdateDocument, options);
      }
export type AdobeCampaignTargetMappingIdUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignTargetMappingIdUpdateMutation>;
export type AdobeCampaignTargetMappingIdUpdateMutationResult = Apollo.MutationResult<AdobeCampaignTargetMappingIdUpdateMutation>;
export type AdobeCampaignTargetMappingIdUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignTargetMappingIdUpdateMutation, AdobeCampaignTargetMappingIdUpdateMutationVariables>;
export const AdobeCampaignTypologyIdUpdateDocument = gql`
    mutation AdobeCampaignTypologyIdUpdate($espId: ID!, $typologyId: Int) {
  campaignAdobeCampaignConfigTypologyIdUpdate(typologyId: $typologyId, id: $espId) {
    adobeCampaignConfig {
      typologyId
    }
  }
}
    `;
export type AdobeCampaignTypologyIdUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignTypologyIdUpdateMutation, AdobeCampaignTypologyIdUpdateMutationVariables>;

/**
 * __useAdobeCampaignTypologyIdUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignTypologyIdUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignTypologyIdUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignTypologyIdUpdateMutation, { data, loading, error }] = useAdobeCampaignTypologyIdUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      typologyId: // value for 'typologyId'
 *   },
 * });
 */
export function useAdobeCampaignTypologyIdUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignTypologyIdUpdateMutation, AdobeCampaignTypologyIdUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignTypologyIdUpdateMutation, AdobeCampaignTypologyIdUpdateMutationVariables>(AdobeCampaignTypologyIdUpdateDocument, options);
      }
export type AdobeCampaignTypologyIdUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignTypologyIdUpdateMutation>;
export type AdobeCampaignTypologyIdUpdateMutationResult = Apollo.MutationResult<AdobeCampaignTypologyIdUpdateMutation>;
export type AdobeCampaignTypologyIdUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignTypologyIdUpdateMutation, AdobeCampaignTypologyIdUpdateMutationVariables>;
export const AdobeCampaignWebAnalyticsAccountUpdateDocument = gql`
    mutation AdobeCampaignWebAnalyticsAccountUpdate($espId: ID!, $webAnalyticsAccount: Int) {
  campaignAdobeCampaignConfigWebAnalyticsAccountUpdate(
    webAnalyticsAccount: $webAnalyticsAccount
    id: $espId
  ) {
    adobeCampaignConfig {
      webAnalyticsAccount
    }
  }
}
    `;
export type AdobeCampaignWebAnalyticsAccountUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignWebAnalyticsAccountUpdateMutation, AdobeCampaignWebAnalyticsAccountUpdateMutationVariables>;

/**
 * __useAdobeCampaignWebAnalyticsAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignWebAnalyticsAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignWebAnalyticsAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignWebAnalyticsAccountUpdateMutation, { data, loading, error }] = useAdobeCampaignWebAnalyticsAccountUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      webAnalyticsAccount: // value for 'webAnalyticsAccount'
 *   },
 * });
 */
export function useAdobeCampaignWebAnalyticsAccountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignWebAnalyticsAccountUpdateMutation, AdobeCampaignWebAnalyticsAccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignWebAnalyticsAccountUpdateMutation, AdobeCampaignWebAnalyticsAccountUpdateMutationVariables>(AdobeCampaignWebAnalyticsAccountUpdateDocument, options);
      }
export type AdobeCampaignWebAnalyticsAccountUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignWebAnalyticsAccountUpdateMutation>;
export type AdobeCampaignWebAnalyticsAccountUpdateMutationResult = Apollo.MutationResult<AdobeCampaignWebAnalyticsAccountUpdateMutation>;
export type AdobeCampaignWebAnalyticsAccountUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignWebAnalyticsAccountUpdateMutation, AdobeCampaignWebAnalyticsAccountUpdateMutationVariables>;
export const AdobeCampaignRoutingIdUpdateDocument = gql`
    mutation AdobeCampaignRoutingIdUpdate($espId: ID!, $routingId: Int!) {
  campaignAdobeCampaignConfigRoutingIdUpdate(routingId: $routingId, id: $espId) {
    adobeCampaignConfig {
      routingId
    }
  }
}
    `;
export type AdobeCampaignRoutingIdUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignRoutingIdUpdateMutation, AdobeCampaignRoutingIdUpdateMutationVariables>;

/**
 * __useAdobeCampaignRoutingIdUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignRoutingIdUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignRoutingIdUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignRoutingIdUpdateMutation, { data, loading, error }] = useAdobeCampaignRoutingIdUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      routingId: // value for 'routingId'
 *   },
 * });
 */
export function useAdobeCampaignRoutingIdUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignRoutingIdUpdateMutation, AdobeCampaignRoutingIdUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignRoutingIdUpdateMutation, AdobeCampaignRoutingIdUpdateMutationVariables>(AdobeCampaignRoutingIdUpdateDocument, options);
      }
export type AdobeCampaignRoutingIdUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignRoutingIdUpdateMutation>;
export type AdobeCampaignRoutingIdUpdateMutationResult = Apollo.MutationResult<AdobeCampaignRoutingIdUpdateMutation>;
export type AdobeCampaignRoutingIdUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignRoutingIdUpdateMutation, AdobeCampaignRoutingIdUpdateMutationVariables>;
export const AdobeCampaignDeliveryNatureUpdateDocument = gql`
    mutation AdobeCampaignDeliveryNatureUpdate($espId: ID!, $availableDeliveryNatureId: ID) {
  adobeCampaignConfigDeliveryNatureUpdate(
    availableDeliveryNatureId: $availableDeliveryNatureId
    id: $espId
  ) {
    adobeCampaignConfig {
      deliveryNature {
        id
        label
        availableDeliveryNatureId
      }
    }
  }
}
    `;
export type AdobeCampaignDeliveryNatureUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignDeliveryNatureUpdateMutation, AdobeCampaignDeliveryNatureUpdateMutationVariables>;

/**
 * __useAdobeCampaignDeliveryNatureUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignDeliveryNatureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignDeliveryNatureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignDeliveryNatureUpdateMutation, { data, loading, error }] = useAdobeCampaignDeliveryNatureUpdateMutation({
 *   variables: {
 *      espId: // value for 'espId'
 *      availableDeliveryNatureId: // value for 'availableDeliveryNatureId'
 *   },
 * });
 */
export function useAdobeCampaignDeliveryNatureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignDeliveryNatureUpdateMutation, AdobeCampaignDeliveryNatureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignDeliveryNatureUpdateMutation, AdobeCampaignDeliveryNatureUpdateMutationVariables>(AdobeCampaignDeliveryNatureUpdateDocument, options);
      }
export type AdobeCampaignDeliveryNatureUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignDeliveryNatureUpdateMutation>;
export type AdobeCampaignDeliveryNatureUpdateMutationResult = Apollo.MutationResult<AdobeCampaignDeliveryNatureUpdateMutation>;
export type AdobeCampaignDeliveryNatureUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignDeliveryNatureUpdateMutation, AdobeCampaignDeliveryNatureUpdateMutationVariables>;
export const AdobeCampaignDeliveryVariableCreateDocument = gql`
    mutation AdobeCampaignDeliveryVariableCreate($espConfigId: ID!, $availableDeliveryVariableId: ID!, $value: String!) {
  adobeCampaignConfigDeliveryVariableCreate(
    id: $espConfigId
    availableDeliveryVariableId: $availableDeliveryVariableId
    value: $value
  ) {
    adobeCampaignConfig {
      id
      deliveryVariables {
        id
        value
        availableDeliveryVariableId
      }
    }
  }
}
    `;
export type AdobeCampaignDeliveryVariableCreateMutationFn = Apollo.MutationFunction<AdobeCampaignDeliveryVariableCreateMutation, AdobeCampaignDeliveryVariableCreateMutationVariables>;

/**
 * __useAdobeCampaignDeliveryVariableCreateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignDeliveryVariableCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignDeliveryVariableCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignDeliveryVariableCreateMutation, { data, loading, error }] = useAdobeCampaignDeliveryVariableCreateMutation({
 *   variables: {
 *      espConfigId: // value for 'espConfigId'
 *      availableDeliveryVariableId: // value for 'availableDeliveryVariableId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAdobeCampaignDeliveryVariableCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignDeliveryVariableCreateMutation, AdobeCampaignDeliveryVariableCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignDeliveryVariableCreateMutation, AdobeCampaignDeliveryVariableCreateMutationVariables>(AdobeCampaignDeliveryVariableCreateDocument, options);
      }
export type AdobeCampaignDeliveryVariableCreateMutationHookResult = ReturnType<typeof useAdobeCampaignDeliveryVariableCreateMutation>;
export type AdobeCampaignDeliveryVariableCreateMutationResult = Apollo.MutationResult<AdobeCampaignDeliveryVariableCreateMutation>;
export type AdobeCampaignDeliveryVariableCreateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignDeliveryVariableCreateMutation, AdobeCampaignDeliveryVariableCreateMutationVariables>;
export const AdobeCampaignDeliveryVariableUpdateDocument = gql`
    mutation AdobeCampaignDeliveryVariableUpdate($espConfigId: ID!, $deliveryVariableId: ID!, $availableDeliveryVariableId: ID!, $value: String!) {
  adobeCampaignConfigDeliveryVariableUpdate(
    id: $espConfigId
    deliveryVariableId: $deliveryVariableId
    availableDeliveryVariableId: $availableDeliveryVariableId
    value: $value
  ) {
    adobeCampaignConfig {
      id
      deliveryVariables {
        id
        value
        availableDeliveryVariableId
      }
    }
  }
}
    `;
export type AdobeCampaignDeliveryVariableUpdateMutationFn = Apollo.MutationFunction<AdobeCampaignDeliveryVariableUpdateMutation, AdobeCampaignDeliveryVariableUpdateMutationVariables>;

/**
 * __useAdobeCampaignDeliveryVariableUpdateMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignDeliveryVariableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignDeliveryVariableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignDeliveryVariableUpdateMutation, { data, loading, error }] = useAdobeCampaignDeliveryVariableUpdateMutation({
 *   variables: {
 *      espConfigId: // value for 'espConfigId'
 *      deliveryVariableId: // value for 'deliveryVariableId'
 *      availableDeliveryVariableId: // value for 'availableDeliveryVariableId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAdobeCampaignDeliveryVariableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignDeliveryVariableUpdateMutation, AdobeCampaignDeliveryVariableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignDeliveryVariableUpdateMutation, AdobeCampaignDeliveryVariableUpdateMutationVariables>(AdobeCampaignDeliveryVariableUpdateDocument, options);
      }
export type AdobeCampaignDeliveryVariableUpdateMutationHookResult = ReturnType<typeof useAdobeCampaignDeliveryVariableUpdateMutation>;
export type AdobeCampaignDeliveryVariableUpdateMutationResult = Apollo.MutationResult<AdobeCampaignDeliveryVariableUpdateMutation>;
export type AdobeCampaignDeliveryVariableUpdateMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignDeliveryVariableUpdateMutation, AdobeCampaignDeliveryVariableUpdateMutationVariables>;
export const AdobeCampaignDeliveryVariableDeleteDocument = gql`
    mutation AdobeCampaignDeliveryVariableDelete($espConfigId: ID!, $deliveryVariableId: ID!) {
  adobeCampaignConfigDeliveryVariableDelete(
    id: $espConfigId
    deliveryVariableId: $deliveryVariableId
  ) {
    adobeCampaignConfig {
      id
      deliveryVariables {
        id
        value
        availableDeliveryVariableId
      }
    }
  }
}
    `;
export type AdobeCampaignDeliveryVariableDeleteMutationFn = Apollo.MutationFunction<AdobeCampaignDeliveryVariableDeleteMutation, AdobeCampaignDeliveryVariableDeleteMutationVariables>;

/**
 * __useAdobeCampaignDeliveryVariableDeleteMutation__
 *
 * To run a mutation, you first call `useAdobeCampaignDeliveryVariableDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdobeCampaignDeliveryVariableDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adobeCampaignDeliveryVariableDeleteMutation, { data, loading, error }] = useAdobeCampaignDeliveryVariableDeleteMutation({
 *   variables: {
 *      espConfigId: // value for 'espConfigId'
 *      deliveryVariableId: // value for 'deliveryVariableId'
 *   },
 * });
 */
export function useAdobeCampaignDeliveryVariableDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdobeCampaignDeliveryVariableDeleteMutation, AdobeCampaignDeliveryVariableDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdobeCampaignDeliveryVariableDeleteMutation, AdobeCampaignDeliveryVariableDeleteMutationVariables>(AdobeCampaignDeliveryVariableDeleteDocument, options);
      }
export type AdobeCampaignDeliveryVariableDeleteMutationHookResult = ReturnType<typeof useAdobeCampaignDeliveryVariableDeleteMutation>;
export type AdobeCampaignDeliveryVariableDeleteMutationResult = Apollo.MutationResult<AdobeCampaignDeliveryVariableDeleteMutation>;
export type AdobeCampaignDeliveryVariableDeleteMutationOptions = Apollo.BaseMutationOptions<AdobeCampaignDeliveryVariableDeleteMutation, AdobeCampaignDeliveryVariableDeleteMutationVariables>;
export const AmazonSesEmailTagCreateDocument = gql`
    mutation AmazonSesEmailTagCreate($espConfigId: ID!, $availableEmailTagId: ID!, $value: String!) {
  amazonSesConfigEmailTagCreate(
    id: $espConfigId
    availableEmailTagId: $availableEmailTagId
    value: $value
  ) {
    amazonSesConfig {
      id
      emailTags {
        id
        emailTagId
        value
      }
    }
  }
}
    `;
export type AmazonSesEmailTagCreateMutationFn = Apollo.MutationFunction<AmazonSesEmailTagCreateMutation, AmazonSesEmailTagCreateMutationVariables>;

/**
 * __useAmazonSesEmailTagCreateMutation__
 *
 * To run a mutation, you first call `useAmazonSesEmailTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmazonSesEmailTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [amazonSesEmailTagCreateMutation, { data, loading, error }] = useAmazonSesEmailTagCreateMutation({
 *   variables: {
 *      espConfigId: // value for 'espConfigId'
 *      availableEmailTagId: // value for 'availableEmailTagId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAmazonSesEmailTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<AmazonSesEmailTagCreateMutation, AmazonSesEmailTagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AmazonSesEmailTagCreateMutation, AmazonSesEmailTagCreateMutationVariables>(AmazonSesEmailTagCreateDocument, options);
      }
export type AmazonSesEmailTagCreateMutationHookResult = ReturnType<typeof useAmazonSesEmailTagCreateMutation>;
export type AmazonSesEmailTagCreateMutationResult = Apollo.MutationResult<AmazonSesEmailTagCreateMutation>;
export type AmazonSesEmailTagCreateMutationOptions = Apollo.BaseMutationOptions<AmazonSesEmailTagCreateMutation, AmazonSesEmailTagCreateMutationVariables>;
export const AmazonSesEmailTagUpdateDocument = gql`
    mutation AmazonSesEmailTagUpdate($emailTagId: ID!, $availableEmailTagId: ID!, $value: String!) {
  amazonSesConfigEmailTagUpdate(
    emailTagId: $emailTagId
    availableEmailTagId: $availableEmailTagId
    value: $value
  ) {
    amazonSesConfig {
      id
      emailTags {
        id
        emailTagId
        value
      }
    }
  }
}
    `;
export type AmazonSesEmailTagUpdateMutationFn = Apollo.MutationFunction<AmazonSesEmailTagUpdateMutation, AmazonSesEmailTagUpdateMutationVariables>;

/**
 * __useAmazonSesEmailTagUpdateMutation__
 *
 * To run a mutation, you first call `useAmazonSesEmailTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmazonSesEmailTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [amazonSesEmailTagUpdateMutation, { data, loading, error }] = useAmazonSesEmailTagUpdateMutation({
 *   variables: {
 *      emailTagId: // value for 'emailTagId'
 *      availableEmailTagId: // value for 'availableEmailTagId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAmazonSesEmailTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AmazonSesEmailTagUpdateMutation, AmazonSesEmailTagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AmazonSesEmailTagUpdateMutation, AmazonSesEmailTagUpdateMutationVariables>(AmazonSesEmailTagUpdateDocument, options);
      }
export type AmazonSesEmailTagUpdateMutationHookResult = ReturnType<typeof useAmazonSesEmailTagUpdateMutation>;
export type AmazonSesEmailTagUpdateMutationResult = Apollo.MutationResult<AmazonSesEmailTagUpdateMutation>;
export type AmazonSesEmailTagUpdateMutationOptions = Apollo.BaseMutationOptions<AmazonSesEmailTagUpdateMutation, AmazonSesEmailTagUpdateMutationVariables>;
export const AmazonSesEmailTagDeleteDocument = gql`
    mutation AmazonSesEmailTagDelete($emailTagId: ID!) {
  amazonSesConfigEmailTagDelete(emailTagId: $emailTagId) {
    amazonSesConfig {
      id
      emailTags {
        id
        emailTagId
        value
      }
    }
  }
}
    `;
export type AmazonSesEmailTagDeleteMutationFn = Apollo.MutationFunction<AmazonSesEmailTagDeleteMutation, AmazonSesEmailTagDeleteMutationVariables>;

/**
 * __useAmazonSesEmailTagDeleteMutation__
 *
 * To run a mutation, you first call `useAmazonSesEmailTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmazonSesEmailTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [amazonSesEmailTagDeleteMutation, { data, loading, error }] = useAmazonSesEmailTagDeleteMutation({
 *   variables: {
 *      emailTagId: // value for 'emailTagId'
 *   },
 * });
 */
export function useAmazonSesEmailTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AmazonSesEmailTagDeleteMutation, AmazonSesEmailTagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AmazonSesEmailTagDeleteMutation, AmazonSesEmailTagDeleteMutationVariables>(AmazonSesEmailTagDeleteDocument, options);
      }
export type AmazonSesEmailTagDeleteMutationHookResult = ReturnType<typeof useAmazonSesEmailTagDeleteMutation>;
export type AmazonSesEmailTagDeleteMutationResult = Apollo.MutationResult<AmazonSesEmailTagDeleteMutation>;
export type AmazonSesEmailTagDeleteMutationOptions = Apollo.BaseMutationOptions<AmazonSesEmailTagDeleteMutation, AmazonSesEmailTagDeleteMutationVariables>;
export const ZetaEmailTagCreateDocument = gql`
    mutation ZetaEmailTagCreate($espConfigId: ID!, $availableEmailTagId: ID!, $value: String!) {
  zetaConfigEmailTagCreate(
    id: $espConfigId
    availableEmailTagId: $availableEmailTagId
    value: $value
  ) {
    zetaConfig {
      id
      emailTags {
        id
        emailTagId
        value
      }
    }
  }
}
    `;
export type ZetaEmailTagCreateMutationFn = Apollo.MutationFunction<ZetaEmailTagCreateMutation, ZetaEmailTagCreateMutationVariables>;

/**
 * __useZetaEmailTagCreateMutation__
 *
 * To run a mutation, you first call `useZetaEmailTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZetaEmailTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zetaEmailTagCreateMutation, { data, loading, error }] = useZetaEmailTagCreateMutation({
 *   variables: {
 *      espConfigId: // value for 'espConfigId'
 *      availableEmailTagId: // value for 'availableEmailTagId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useZetaEmailTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<ZetaEmailTagCreateMutation, ZetaEmailTagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZetaEmailTagCreateMutation, ZetaEmailTagCreateMutationVariables>(ZetaEmailTagCreateDocument, options);
      }
export type ZetaEmailTagCreateMutationHookResult = ReturnType<typeof useZetaEmailTagCreateMutation>;
export type ZetaEmailTagCreateMutationResult = Apollo.MutationResult<ZetaEmailTagCreateMutation>;
export type ZetaEmailTagCreateMutationOptions = Apollo.BaseMutationOptions<ZetaEmailTagCreateMutation, ZetaEmailTagCreateMutationVariables>;
export const ZetaEmailTagUpdateDocument = gql`
    mutation ZetaEmailTagUpdate($emailTagId: ID!, $availableEmailTagId: ID!, $value: String!) {
  zetaConfigEmailTagUpdate(
    emailTagId: $emailTagId
    availableEmailTagId: $availableEmailTagId
    value: $value
  ) {
    zetaConfig {
      id
      emailTags {
        id
        emailTagId
        value
      }
    }
  }
}
    `;
export type ZetaEmailTagUpdateMutationFn = Apollo.MutationFunction<ZetaEmailTagUpdateMutation, ZetaEmailTagUpdateMutationVariables>;

/**
 * __useZetaEmailTagUpdateMutation__
 *
 * To run a mutation, you first call `useZetaEmailTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZetaEmailTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zetaEmailTagUpdateMutation, { data, loading, error }] = useZetaEmailTagUpdateMutation({
 *   variables: {
 *      emailTagId: // value for 'emailTagId'
 *      availableEmailTagId: // value for 'availableEmailTagId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useZetaEmailTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ZetaEmailTagUpdateMutation, ZetaEmailTagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZetaEmailTagUpdateMutation, ZetaEmailTagUpdateMutationVariables>(ZetaEmailTagUpdateDocument, options);
      }
export type ZetaEmailTagUpdateMutationHookResult = ReturnType<typeof useZetaEmailTagUpdateMutation>;
export type ZetaEmailTagUpdateMutationResult = Apollo.MutationResult<ZetaEmailTagUpdateMutation>;
export type ZetaEmailTagUpdateMutationOptions = Apollo.BaseMutationOptions<ZetaEmailTagUpdateMutation, ZetaEmailTagUpdateMutationVariables>;
export const ZetaEmailTagDeleteDocument = gql`
    mutation ZetaEmailTagDelete($emailTagId: ID!) {
  zetaConfigEmailTagDelete(emailTagId: $emailTagId) {
    zetaConfig {
      id
      emailTags {
        id
        emailTagId
        value
      }
    }
  }
}
    `;
export type ZetaEmailTagDeleteMutationFn = Apollo.MutationFunction<ZetaEmailTagDeleteMutation, ZetaEmailTagDeleteMutationVariables>;

/**
 * __useZetaEmailTagDeleteMutation__
 *
 * To run a mutation, you first call `useZetaEmailTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZetaEmailTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zetaEmailTagDeleteMutation, { data, loading, error }] = useZetaEmailTagDeleteMutation({
 *   variables: {
 *      emailTagId: // value for 'emailTagId'
 *   },
 * });
 */
export function useZetaEmailTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ZetaEmailTagDeleteMutation, ZetaEmailTagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZetaEmailTagDeleteMutation, ZetaEmailTagDeleteMutationVariables>(ZetaEmailTagDeleteDocument, options);
      }
export type ZetaEmailTagDeleteMutationHookResult = ReturnType<typeof useZetaEmailTagDeleteMutation>;
export type ZetaEmailTagDeleteMutationResult = Apollo.MutationResult<ZetaEmailTagDeleteMutation>;
export type ZetaEmailTagDeleteMutationOptions = Apollo.BaseMutationOptions<ZetaEmailTagDeleteMutation, ZetaEmailTagDeleteMutationVariables>;
export const LayoutUpgradeDocument = gql`
    mutation LayoutUpgrade($creativeId: ID!, $templateTagId: ID!) {
  layoutUpgrade(creativeId: $creativeId, templateTagId: $templateTagId) {
    success
    layout {
      id
    }
  }
}
    `;
export type LayoutUpgradeMutationFn = Apollo.MutationFunction<LayoutUpgradeMutation, LayoutUpgradeMutationVariables>;

/**
 * __useLayoutUpgradeMutation__
 *
 * To run a mutation, you first call `useLayoutUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutUpgradeMutation, { data, loading, error }] = useLayoutUpgradeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *   },
 * });
 */
export function useLayoutUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<LayoutUpgradeMutation, LayoutUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LayoutUpgradeMutation, LayoutUpgradeMutationVariables>(LayoutUpgradeDocument, options);
      }
export type LayoutUpgradeMutationHookResult = ReturnType<typeof useLayoutUpgradeMutation>;
export type LayoutUpgradeMutationResult = Apollo.MutationResult<LayoutUpgradeMutation>;
export type LayoutUpgradeMutationOptions = Apollo.BaseMutationOptions<LayoutUpgradeMutation, LayoutUpgradeMutationVariables>;
export const MediaUploadDocument = gql`
    mutation MediaUpload($image: Upload!) {
  mediaUpload2(image: $image) {
    success
    media {
      ...mediaFields
    }
  }
}
    ${MediaFieldsFragmentDoc}`;
export type MediaUploadMutationFn = Apollo.MutationFunction<MediaUploadMutation, MediaUploadMutationVariables>;

/**
 * __useMediaUploadMutation__
 *
 * To run a mutation, you first call `useMediaUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaUploadMutation, { data, loading, error }] = useMediaUploadMutation({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useMediaUploadMutation(baseOptions?: Apollo.MutationHookOptions<MediaUploadMutation, MediaUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaUploadMutation, MediaUploadMutationVariables>(MediaUploadDocument, options);
      }
export type MediaUploadMutationHookResult = ReturnType<typeof useMediaUploadMutation>;
export type MediaUploadMutationResult = Apollo.MutationResult<MediaUploadMutation>;
export type MediaUploadMutationOptions = Apollo.BaseMutationOptions<MediaUploadMutation, MediaUploadMutationVariables>;
export const MediaCdnUploadDocument = gql`
    mutation MediaCdnUpload($image: Upload!, $existingMediaId: ID) {
  mediaCdnUpload(image: $image, existingMediaId: $existingMediaId) {
    success
    media {
      ...mediaFields
    }
  }
}
    ${MediaFieldsFragmentDoc}`;
export type MediaCdnUploadMutationFn = Apollo.MutationFunction<MediaCdnUploadMutation, MediaCdnUploadMutationVariables>;

/**
 * __useMediaCdnUploadMutation__
 *
 * To run a mutation, you first call `useMediaCdnUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaCdnUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaCdnUploadMutation, { data, loading, error }] = useMediaCdnUploadMutation({
 *   variables: {
 *      image: // value for 'image'
 *      existingMediaId: // value for 'existingMediaId'
 *   },
 * });
 */
export function useMediaCdnUploadMutation(baseOptions?: Apollo.MutationHookOptions<MediaCdnUploadMutation, MediaCdnUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaCdnUploadMutation, MediaCdnUploadMutationVariables>(MediaCdnUploadDocument, options);
      }
export type MediaCdnUploadMutationHookResult = ReturnType<typeof useMediaCdnUploadMutation>;
export type MediaCdnUploadMutationResult = Apollo.MutationResult<MediaCdnUploadMutation>;
export type MediaCdnUploadMutationOptions = Apollo.BaseMutationOptions<MediaCdnUploadMutation, MediaCdnUploadMutationVariables>;
export const MediaCreateDocument = gql`
    mutation MediaCreate($externalUrl: String!) {
  mediaCreate2(externalUrl: $externalUrl) {
    success
    media {
      ...mediaFields
    }
  }
}
    ${MediaFieldsFragmentDoc}`;
export type MediaCreateMutationFn = Apollo.MutationFunction<MediaCreateMutation, MediaCreateMutationVariables>;

/**
 * __useMediaCreateMutation__
 *
 * To run a mutation, you first call `useMediaCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaCreateMutation, { data, loading, error }] = useMediaCreateMutation({
 *   variables: {
 *      externalUrl: // value for 'externalUrl'
 *   },
 * });
 */
export function useMediaCreateMutation(baseOptions?: Apollo.MutationHookOptions<MediaCreateMutation, MediaCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaCreateMutation, MediaCreateMutationVariables>(MediaCreateDocument, options);
      }
export type MediaCreateMutationHookResult = ReturnType<typeof useMediaCreateMutation>;
export type MediaCreateMutationResult = Apollo.MutationResult<MediaCreateMutation>;
export type MediaCreateMutationOptions = Apollo.BaseMutationOptions<MediaCreateMutation, MediaCreateMutationVariables>;
export const QueryCatalogDocument = gql`
    query QueryCatalog($modelKeys: [String!]) {
  queryCatalog(modelKeys: $modelKeys) {
    catalog {
      datasets {
        id
        name
        fields {
          id
          name
          nullable
          primaryKey
          type {
            ...CatalogFieldType
          }
        }
      }
      datasetRelations {
        id
        sourceDatasetId
        sourceFieldId
        targetDatasetId
        targetFieldId
        cardinality
      }
    }
  }
}
    ${CatalogFieldTypeFragmentDoc}`;

/**
 * __useQueryCatalogQuery__
 *
 * To run a query within a React component, call `useQueryCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCatalogQuery({
 *   variables: {
 *      modelKeys: // value for 'modelKeys'
 *   },
 * });
 */
export function useQueryCatalogQuery(baseOptions?: Apollo.QueryHookOptions<QueryCatalogQuery, QueryCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCatalogQuery, QueryCatalogQueryVariables>(QueryCatalogDocument, options);
      }
export function useQueryCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCatalogQuery, QueryCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCatalogQuery, QueryCatalogQueryVariables>(QueryCatalogDocument, options);
        }
export function useQueryCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryCatalogQuery, QueryCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryCatalogQuery, QueryCatalogQueryVariables>(QueryCatalogDocument, options);
        }
export type QueryCatalogQueryHookResult = ReturnType<typeof useQueryCatalogQuery>;
export type QueryCatalogLazyQueryHookResult = ReturnType<typeof useQueryCatalogLazyQuery>;
export type QueryCatalogSuspenseQueryHookResult = ReturnType<typeof useQueryCatalogSuspenseQuery>;
export type QueryCatalogQueryResult = Apollo.QueryResult<QueryCatalogQuery, QueryCatalogQueryVariables>;
export const BlocksDocument = gql`
    query Blocks($first: Int, $after: String, $filters: BlockFilterInput) {
  blocks(first: $first, after: $after, filters: $filters) {
    edges {
      cursor
      node {
        id
        name
        description
        thumbnail
        latestVersion {
          id
          version
          layout {
            id
            snapshot(format: V1)
            mediaLibrary {
              ...mediaFields
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${MediaFieldsFragmentDoc}`;

/**
 * __useBlocksQuery__
 *
 * To run a query within a React component, call `useBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBlocksQuery(baseOptions?: Apollo.QueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
      }
export function useBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
        }
export function useBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
        }
export type BlocksQueryHookResult = ReturnType<typeof useBlocksQuery>;
export type BlocksLazyQueryHookResult = ReturnType<typeof useBlocksLazyQuery>;
export type BlocksSuspenseQueryHookResult = ReturnType<typeof useBlocksSuspenseQuery>;
export type BlocksQueryResult = Apollo.QueryResult<BlocksQuery, BlocksQueryVariables>;
export const DataFieldValueListDocument = gql`
    query DataFieldValueList($id: ID!, $distinct: Boolean!) {
  dataFieldValueList(id: $id, distinct: $distinct)
}
    `;

/**
 * __useDataFieldValueListQuery__
 *
 * To run a query within a React component, call `useDataFieldValueListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFieldValueListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataFieldValueListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      distinct: // value for 'distinct'
 *   },
 * });
 */
export function useDataFieldValueListQuery(baseOptions: Apollo.QueryHookOptions<DataFieldValueListQuery, DataFieldValueListQueryVariables> & ({ variables: DataFieldValueListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataFieldValueListQuery, DataFieldValueListQueryVariables>(DataFieldValueListDocument, options);
      }
export function useDataFieldValueListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataFieldValueListQuery, DataFieldValueListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataFieldValueListQuery, DataFieldValueListQueryVariables>(DataFieldValueListDocument, options);
        }
export function useDataFieldValueListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataFieldValueListQuery, DataFieldValueListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataFieldValueListQuery, DataFieldValueListQueryVariables>(DataFieldValueListDocument, options);
        }
export type DataFieldValueListQueryHookResult = ReturnType<typeof useDataFieldValueListQuery>;
export type DataFieldValueListLazyQueryHookResult = ReturnType<typeof useDataFieldValueListLazyQuery>;
export type DataFieldValueListSuspenseQueryHookResult = ReturnType<typeof useDataFieldValueListSuspenseQuery>;
export type DataFieldValueListQueryResult = Apollo.QueryResult<DataFieldValueListQuery, DataFieldValueListQueryVariables>;
export const ContactAudienceTagsDocument = gql`
    query ContactAudienceTags {
  contactAudienceTags {
    tables {
      id
      name
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useContactAudienceTagsQuery__
 *
 * To run a query within a React component, call `useContactAudienceTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudienceTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactAudienceTagsQuery(baseOptions?: Apollo.QueryHookOptions<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>(ContactAudienceTagsDocument, options);
      }
export function useContactAudienceTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>(ContactAudienceTagsDocument, options);
        }
export function useContactAudienceTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>(ContactAudienceTagsDocument, options);
        }
export type ContactAudienceTagsQueryHookResult = ReturnType<typeof useContactAudienceTagsQuery>;
export type ContactAudienceTagsLazyQueryHookResult = ReturnType<typeof useContactAudienceTagsLazyQuery>;
export type ContactAudienceTagsSuspenseQueryHookResult = ReturnType<typeof useContactAudienceTagsSuspenseQuery>;
export type ContactAudienceTagsQueryResult = Apollo.QueryResult<ContactAudienceTagsQuery, ContactAudienceTagsQueryVariables>;
export const RenameJourneyDocument = gql`
    mutation RenameJourney($id: ID!, $name: String!) {
  journeyRename(id: $id, name: $name) {
    journey {
      id
    }
  }
}
    `;
export type RenameJourneyMutationFn = Apollo.MutationFunction<RenameJourneyMutation, RenameJourneyMutationVariables>;

/**
 * __useRenameJourneyMutation__
 *
 * To run a mutation, you first call `useRenameJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameJourneyMutation, { data, loading, error }] = useRenameJourneyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameJourneyMutation(baseOptions?: Apollo.MutationHookOptions<RenameJourneyMutation, RenameJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameJourneyMutation, RenameJourneyMutationVariables>(RenameJourneyDocument, options);
      }
export type RenameJourneyMutationHookResult = ReturnType<typeof useRenameJourneyMutation>;
export type RenameJourneyMutationResult = Apollo.MutationResult<RenameJourneyMutation>;
export type RenameJourneyMutationOptions = Apollo.BaseMutationOptions<RenameJourneyMutation, RenameJourneyMutationVariables>;
export const PauseJourneyDocument = gql`
    mutation PauseJourney($abortRunningContacts: Boolean!, $id: ID!) {
  journeyPause(abortRunningContacts: $abortRunningContacts, id: $id) {
    journey {
      id
      status
    }
  }
}
    `;
export type PauseJourneyMutationFn = Apollo.MutationFunction<PauseJourneyMutation, PauseJourneyMutationVariables>;

/**
 * __usePauseJourneyMutation__
 *
 * To run a mutation, you first call `usePauseJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseJourneyMutation, { data, loading, error }] = usePauseJourneyMutation({
 *   variables: {
 *      abortRunningContacts: // value for 'abortRunningContacts'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseJourneyMutation(baseOptions?: Apollo.MutationHookOptions<PauseJourneyMutation, PauseJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseJourneyMutation, PauseJourneyMutationVariables>(PauseJourneyDocument, options);
      }
export type PauseJourneyMutationHookResult = ReturnType<typeof usePauseJourneyMutation>;
export type PauseJourneyMutationResult = Apollo.MutationResult<PauseJourneyMutation>;
export type PauseJourneyMutationOptions = Apollo.BaseMutationOptions<PauseJourneyMutation, PauseJourneyMutationVariables>;
export const ResumeJourneyDocument = gql`
    mutation ResumeJourney($id: ID!) {
  journeyResume(id: $id) {
    journey {
      id
      status
      updatedAt
    }
  }
}
    `;
export type ResumeJourneyMutationFn = Apollo.MutationFunction<ResumeJourneyMutation, ResumeJourneyMutationVariables>;

/**
 * __useResumeJourneyMutation__
 *
 * To run a mutation, you first call `useResumeJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeJourneyMutation, { data, loading, error }] = useResumeJourneyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeJourneyMutation(baseOptions?: Apollo.MutationHookOptions<ResumeJourneyMutation, ResumeJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeJourneyMutation, ResumeJourneyMutationVariables>(ResumeJourneyDocument, options);
      }
export type ResumeJourneyMutationHookResult = ReturnType<typeof useResumeJourneyMutation>;
export type ResumeJourneyMutationResult = Apollo.MutationResult<ResumeJourneyMutation>;
export type ResumeJourneyMutationOptions = Apollo.BaseMutationOptions<ResumeJourneyMutation, ResumeJourneyMutationVariables>;
export const CancelJourneyDocument = gql`
    mutation CancelJourney($id: ID!) {
  journeyCancel(id: $id) {
    journey {
      id
      status
    }
  }
}
    `;
export type CancelJourneyMutationFn = Apollo.MutationFunction<CancelJourneyMutation, CancelJourneyMutationVariables>;

/**
 * __useCancelJourneyMutation__
 *
 * To run a mutation, you first call `useCancelJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelJourneyMutation, { data, loading, error }] = useCancelJourneyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelJourneyMutation(baseOptions?: Apollo.MutationHookOptions<CancelJourneyMutation, CancelJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelJourneyMutation, CancelJourneyMutationVariables>(CancelJourneyDocument, options);
      }
export type CancelJourneyMutationHookResult = ReturnType<typeof useCancelJourneyMutation>;
export type CancelJourneyMutationResult = Apollo.MutationResult<CancelJourneyMutation>;
export type CancelJourneyMutationOptions = Apollo.BaseMutationOptions<CancelJourneyMutation, CancelJourneyMutationVariables>;
export const CreateQueryDocument = gql`
    mutation CreateQuery($query: InkQLQuery!) {
  queryCreate(query: $query) {
    queryId
  }
}
    `;
export type CreateQueryMutationFn = Apollo.MutationFunction<CreateQueryMutation, CreateQueryMutationVariables>;

/**
 * __useCreateQueryMutation__
 *
 * To run a mutation, you first call `useCreateQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueryMutation, { data, loading, error }] = useCreateQueryMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCreateQueryMutation(baseOptions?: Apollo.MutationHookOptions<CreateQueryMutation, CreateQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQueryMutation, CreateQueryMutationVariables>(CreateQueryDocument, options);
      }
export type CreateQueryMutationHookResult = ReturnType<typeof useCreateQueryMutation>;
export type CreateQueryMutationResult = Apollo.MutationResult<CreateQueryMutation>;
export type CreateQueryMutationOptions = Apollo.BaseMutationOptions<CreateQueryMutation, CreateQueryMutationVariables>;
export const UpdateQueryDocument = gql`
    mutation UpdateQuery($id: ID!, $query: InkQLQuery!) {
  queryUpdate(id: $id, query: $query) {
    queryId
  }
}
    `;
export type UpdateQueryMutationFn = Apollo.MutationFunction<UpdateQueryMutation, UpdateQueryMutationVariables>;

/**
 * __useUpdateQueryMutation__
 *
 * To run a mutation, you first call `useUpdateQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueryMutation, { data, loading, error }] = useUpdateQueryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdateQueryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueryMutation, UpdateQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueryMutation, UpdateQueryMutationVariables>(UpdateQueryDocument, options);
      }
export type UpdateQueryMutationHookResult = ReturnType<typeof useUpdateQueryMutation>;
export type UpdateQueryMutationResult = Apollo.MutationResult<UpdateQueryMutation>;
export type UpdateQueryMutationOptions = Apollo.BaseMutationOptions<UpdateQueryMutation, UpdateQueryMutationVariables>;
export const JourneysDocument = gql`
    query Journeys {
  journeys {
    ...JourneyFields
  }
}
    ${JourneyFieldsFragmentDoc}`;

/**
 * __useJourneysQuery__
 *
 * To run a query within a React component, call `useJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneysQuery({
 *   variables: {
 *   },
 * });
 */
export function useJourneysQuery(baseOptions?: Apollo.QueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
      }
export function useJourneysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
        }
export function useJourneysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
        }
export type JourneysQueryHookResult = ReturnType<typeof useJourneysQuery>;
export type JourneysLazyQueryHookResult = ReturnType<typeof useJourneysLazyQuery>;
export type JourneysSuspenseQueryHookResult = ReturnType<typeof useJourneysSuspenseQuery>;
export type JourneysQueryResult = Apollo.QueryResult<JourneysQuery, JourneysQueryVariables>;
export const JourneyDocument = gql`
    query Journey($id: ID!) {
  journey(id: $id) {
    ...JourneyFields
    createdAt
  }
}
    ${JourneyFieldsFragmentDoc}`;

/**
 * __useJourneyQuery__
 *
 * To run a query within a React component, call `useJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJourneyQuery(baseOptions: Apollo.QueryHookOptions<JourneyQuery, JourneyQueryVariables> & ({ variables: JourneyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
      }
export function useJourneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
export function useJourneySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
export type JourneyQueryHookResult = ReturnType<typeof useJourneyQuery>;
export type JourneyLazyQueryHookResult = ReturnType<typeof useJourneyLazyQuery>;
export type JourneySuspenseQueryHookResult = ReturnType<typeof useJourneySuspenseQuery>;
export type JourneyQueryResult = Apollo.QueryResult<JourneyQuery, JourneyQueryVariables>;
export const FiscalCalendarMonthRangeDocument = gql`
    query FiscalCalendarMonthRange($start: Int!, $end: Int!) {
  currentClient {
    id
    fiscalCalendar {
      monthRange(start: $start, end: $end) {
        id
        year
        month
        span {
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useFiscalCalendarMonthRangeQuery__
 *
 * To run a query within a React component, call `useFiscalCalendarMonthRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalCalendarMonthRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalCalendarMonthRangeQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useFiscalCalendarMonthRangeQuery(baseOptions: Apollo.QueryHookOptions<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables> & ({ variables: FiscalCalendarMonthRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables>(FiscalCalendarMonthRangeDocument, options);
      }
export function useFiscalCalendarMonthRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables>(FiscalCalendarMonthRangeDocument, options);
        }
export function useFiscalCalendarMonthRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables>(FiscalCalendarMonthRangeDocument, options);
        }
export type FiscalCalendarMonthRangeQueryHookResult = ReturnType<typeof useFiscalCalendarMonthRangeQuery>;
export type FiscalCalendarMonthRangeLazyQueryHookResult = ReturnType<typeof useFiscalCalendarMonthRangeLazyQuery>;
export type FiscalCalendarMonthRangeSuspenseQueryHookResult = ReturnType<typeof useFiscalCalendarMonthRangeSuspenseQuery>;
export type FiscalCalendarMonthRangeQueryResult = Apollo.QueryResult<FiscalCalendarMonthRangeQuery, FiscalCalendarMonthRangeQueryVariables>;
export const FiscalCalendarPredefinedRangesDocument = gql`
    query FiscalCalendarPredefinedRanges($start: Int!, $end: Int!) {
  currentClient {
    id
    fiscalCalendar {
      weekRange(start: $start, end: $end) {
        id
        year
        week
        span {
          start
          end
        }
      }
      monthRange(start: $start, end: $end) {
        id
        year
        month
        span {
          start
          end
        }
      }
      quarterRange(start: $start, end: $end) {
        id
        year
        quarter
        span {
          start
          end
        }
      }
      yearRange(start: $start, end: $end) {
        id
        year
        span {
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useFiscalCalendarPredefinedRangesQuery__
 *
 * To run a query within a React component, call `useFiscalCalendarPredefinedRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalCalendarPredefinedRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalCalendarPredefinedRangesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useFiscalCalendarPredefinedRangesQuery(baseOptions: Apollo.QueryHookOptions<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables> & ({ variables: FiscalCalendarPredefinedRangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables>(FiscalCalendarPredefinedRangesDocument, options);
      }
export function useFiscalCalendarPredefinedRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables>(FiscalCalendarPredefinedRangesDocument, options);
        }
export function useFiscalCalendarPredefinedRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables>(FiscalCalendarPredefinedRangesDocument, options);
        }
export type FiscalCalendarPredefinedRangesQueryHookResult = ReturnType<typeof useFiscalCalendarPredefinedRangesQuery>;
export type FiscalCalendarPredefinedRangesLazyQueryHookResult = ReturnType<typeof useFiscalCalendarPredefinedRangesLazyQuery>;
export type FiscalCalendarPredefinedRangesSuspenseQueryHookResult = ReturnType<typeof useFiscalCalendarPredefinedRangesSuspenseQuery>;
export type FiscalCalendarPredefinedRangesQueryResult = Apollo.QueryResult<FiscalCalendarPredefinedRangesQuery, FiscalCalendarPredefinedRangesQueryVariables>;
export const FiscalCalendarCurrentWeekDocument = gql`
    query FiscalCalendarCurrentWeek {
  currentClient {
    id
    fiscalCalendar {
      currentWeek
    }
  }
}
    `;

/**
 * __useFiscalCalendarCurrentWeekQuery__
 *
 * To run a query within a React component, call `useFiscalCalendarCurrentWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalCalendarCurrentWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalCalendarCurrentWeekQuery({
 *   variables: {
 *   },
 * });
 */
export function useFiscalCalendarCurrentWeekQuery(baseOptions?: Apollo.QueryHookOptions<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>(FiscalCalendarCurrentWeekDocument, options);
      }
export function useFiscalCalendarCurrentWeekLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>(FiscalCalendarCurrentWeekDocument, options);
        }
export function useFiscalCalendarCurrentWeekSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>(FiscalCalendarCurrentWeekDocument, options);
        }
export type FiscalCalendarCurrentWeekQueryHookResult = ReturnType<typeof useFiscalCalendarCurrentWeekQuery>;
export type FiscalCalendarCurrentWeekLazyQueryHookResult = ReturnType<typeof useFiscalCalendarCurrentWeekLazyQuery>;
export type FiscalCalendarCurrentWeekSuspenseQueryHookResult = ReturnType<typeof useFiscalCalendarCurrentWeekSuspenseQuery>;
export type FiscalCalendarCurrentWeekQueryResult = Apollo.QueryResult<FiscalCalendarCurrentWeekQuery, FiscalCalendarCurrentWeekQueryVariables>;
export const GetStudioCampaignsDocument = gql`
    query getStudioCampaigns($filter: String) {
  studioCampaigns(filter: $filter) {
    __typename
    ... on StudioCampaignPagination {
      page
      results {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStudioCampaignsQuery__
 *
 * To run a query within a React component, call `useGetStudioCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioCampaignsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetStudioCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>(GetStudioCampaignsDocument, options);
      }
export function useGetStudioCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>(GetStudioCampaignsDocument, options);
        }
export function useGetStudioCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>(GetStudioCampaignsDocument, options);
        }
export type GetStudioCampaignsQueryHookResult = ReturnType<typeof useGetStudioCampaignsQuery>;
export type GetStudioCampaignsLazyQueryHookResult = ReturnType<typeof useGetStudioCampaignsLazyQuery>;
export type GetStudioCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetStudioCampaignsSuspenseQuery>;
export type GetStudioCampaignsQueryResult = Apollo.QueryResult<GetStudioCampaignsQuery, GetStudioCampaignsQueryVariables>;
export const GetStudioCampaignBlocksDocument = gql`
    query getStudioCampaignBlocks($campaignId: ID!) {
  studioCampaign(campaignId: $campaignId) {
    __typename
    ... on StudioCampaign {
      ...studioCampaignFragment
    }
  }
}
    ${StudioCampaignFragmentFragmentDoc}`;

/**
 * __useGetStudioCampaignBlocksQuery__
 *
 * To run a query within a React component, call `useGetStudioCampaignBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioCampaignBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioCampaignBlocksQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetStudioCampaignBlocksQuery(baseOptions: Apollo.QueryHookOptions<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables> & ({ variables: GetStudioCampaignBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables>(GetStudioCampaignBlocksDocument, options);
      }
export function useGetStudioCampaignBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables>(GetStudioCampaignBlocksDocument, options);
        }
export function useGetStudioCampaignBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables>(GetStudioCampaignBlocksDocument, options);
        }
export type GetStudioCampaignBlocksQueryHookResult = ReturnType<typeof useGetStudioCampaignBlocksQuery>;
export type GetStudioCampaignBlocksLazyQueryHookResult = ReturnType<typeof useGetStudioCampaignBlocksLazyQuery>;
export type GetStudioCampaignBlocksSuspenseQueryHookResult = ReturnType<typeof useGetStudioCampaignBlocksSuspenseQuery>;
export type GetStudioCampaignBlocksQueryResult = Apollo.QueryResult<GetStudioCampaignBlocksQuery, GetStudioCampaignBlocksQueryVariables>;
export const StudioAuthorizationCompleteDocument = gql`
    mutation studioAuthorizationComplete($code: String!, $redirectUri: String!) {
  studioAuthorizationComplete(code: $code, redirectUri: $redirectUri)
}
    `;
export type StudioAuthorizationCompleteMutationFn = Apollo.MutationFunction<StudioAuthorizationCompleteMutation, StudioAuthorizationCompleteMutationVariables>;

/**
 * __useStudioAuthorizationCompleteMutation__
 *
 * To run a mutation, you first call `useStudioAuthorizationCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudioAuthorizationCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studioAuthorizationCompleteMutation, { data, loading, error }] = useStudioAuthorizationCompleteMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useStudioAuthorizationCompleteMutation(baseOptions?: Apollo.MutationHookOptions<StudioAuthorizationCompleteMutation, StudioAuthorizationCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudioAuthorizationCompleteMutation, StudioAuthorizationCompleteMutationVariables>(StudioAuthorizationCompleteDocument, options);
      }
export type StudioAuthorizationCompleteMutationHookResult = ReturnType<typeof useStudioAuthorizationCompleteMutation>;
export type StudioAuthorizationCompleteMutationResult = Apollo.MutationResult<StudioAuthorizationCompleteMutation>;
export type StudioAuthorizationCompleteMutationOptions = Apollo.BaseMutationOptions<StudioAuthorizationCompleteMutation, StudioAuthorizationCompleteMutationVariables>;
export const VariablesDocument = gql`
    query Variables {
  variables {
    id
    name
    providerVariable {
      id
      expression
    }
  }
}
    `;

/**
 * __useVariablesQuery__
 *
 * To run a query within a React component, call `useVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVariablesQuery(baseOptions?: Apollo.QueryHookOptions<VariablesQuery, VariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VariablesQuery, VariablesQueryVariables>(VariablesDocument, options);
      }
export function useVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VariablesQuery, VariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VariablesQuery, VariablesQueryVariables>(VariablesDocument, options);
        }
export function useVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VariablesQuery, VariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VariablesQuery, VariablesQueryVariables>(VariablesDocument, options);
        }
export type VariablesQueryHookResult = ReturnType<typeof useVariablesQuery>;
export type VariablesLazyQueryHookResult = ReturnType<typeof useVariablesLazyQuery>;
export type VariablesSuspenseQueryHookResult = ReturnType<typeof useVariablesSuspenseQuery>;
export type VariablesQueryResult = Apollo.QueryResult<VariablesQuery, VariablesQueryVariables>;
export const CreateVariableDocument = gql`
    mutation CreateVariable($input: CreateVariableInput!) {
  createVariable(input: $input) {
    success
    variable {
      id
      name
      providerVariable {
        id
        expression
      }
    }
  }
}
    `;
export type CreateVariableMutationFn = Apollo.MutationFunction<CreateVariableMutation, CreateVariableMutationVariables>;

/**
 * __useCreateVariableMutation__
 *
 * To run a mutation, you first call `useCreateVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVariableMutation, { data, loading, error }] = useCreateVariableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVariableMutation(baseOptions?: Apollo.MutationHookOptions<CreateVariableMutation, CreateVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVariableMutation, CreateVariableMutationVariables>(CreateVariableDocument, options);
      }
export type CreateVariableMutationHookResult = ReturnType<typeof useCreateVariableMutation>;
export type CreateVariableMutationResult = Apollo.MutationResult<CreateVariableMutation>;
export type CreateVariableMutationOptions = Apollo.BaseMutationOptions<CreateVariableMutation, CreateVariableMutationVariables>;
export const Link2ListDocument = gql`
    query link2List($filters: Link2FilterInput) {
  link2s(filters: $filters) {
    __typename
    pageInfo {
      __typename
      hasNextPage
      hasPreviousPage
    }
    edges {
      __typename
      node {
        ...link2Fields
      }
    }
  }
}
    ${Link2FieldsFragmentDoc}`;

/**
 * __useLink2ListQuery__
 *
 * To run a query within a React component, call `useLink2ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLink2ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLink2ListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLink2ListQuery(baseOptions?: Apollo.QueryHookOptions<Link2ListQuery, Link2ListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Link2ListQuery, Link2ListQueryVariables>(Link2ListDocument, options);
      }
export function useLink2ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Link2ListQuery, Link2ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Link2ListQuery, Link2ListQueryVariables>(Link2ListDocument, options);
        }
export function useLink2ListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Link2ListQuery, Link2ListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Link2ListQuery, Link2ListQueryVariables>(Link2ListDocument, options);
        }
export type Link2ListQueryHookResult = ReturnType<typeof useLink2ListQuery>;
export type Link2ListLazyQueryHookResult = ReturnType<typeof useLink2ListLazyQuery>;
export type Link2ListSuspenseQueryHookResult = ReturnType<typeof useLink2ListSuspenseQuery>;
export type Link2ListQueryResult = Apollo.QueryResult<Link2ListQuery, Link2ListQueryVariables>;
export const Link2DetailsDocument = gql`
    query link2Details($id: ID!) {
  link2(id: $id) {
    ...link2Fields
  }
}
    ${Link2FieldsFragmentDoc}`;

/**
 * __useLink2DetailsQuery__
 *
 * To run a query within a React component, call `useLink2DetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLink2DetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLink2DetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLink2DetailsQuery(baseOptions: Apollo.QueryHookOptions<Link2DetailsQuery, Link2DetailsQueryVariables> & ({ variables: Link2DetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Link2DetailsQuery, Link2DetailsQueryVariables>(Link2DetailsDocument, options);
      }
export function useLink2DetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Link2DetailsQuery, Link2DetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Link2DetailsQuery, Link2DetailsQueryVariables>(Link2DetailsDocument, options);
        }
export function useLink2DetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Link2DetailsQuery, Link2DetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Link2DetailsQuery, Link2DetailsQueryVariables>(Link2DetailsDocument, options);
        }
export type Link2DetailsQueryHookResult = ReturnType<typeof useLink2DetailsQuery>;
export type Link2DetailsLazyQueryHookResult = ReturnType<typeof useLink2DetailsLazyQuery>;
export type Link2DetailsSuspenseQueryHookResult = ReturnType<typeof useLink2DetailsSuspenseQuery>;
export type Link2DetailsQueryResult = Apollo.QueryResult<Link2DetailsQuery, Link2DetailsQueryVariables>;
export const CreateLink2Document = gql`
    mutation CreateLink2($url: String!, $queryStringParameters: [[String!]!]!, $enableConversionTracking: Boolean!, $enableTracking: Boolean!, $name: String, $linkMetadata: LinkMetadataInput, $trackingParameters: [TrackingParameterInput!]!) {
  link2Create(
    name: $name
    url: $url
    queryStringParameters: $queryStringParameters
    enableConversionTracking: $enableConversionTracking
    enableTracking: $enableTracking
    linkMetadata: $linkMetadata
    trackingParameters: $trackingParameters
  ) {
    link {
      id
      name
    }
  }
}
    `;
export type CreateLink2MutationFn = Apollo.MutationFunction<CreateLink2Mutation, CreateLink2MutationVariables>;

/**
 * __useCreateLink2Mutation__
 *
 * To run a mutation, you first call `useCreateLink2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLink2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLink2Mutation, { data, loading, error }] = useCreateLink2Mutation({
 *   variables: {
 *      url: // value for 'url'
 *      queryStringParameters: // value for 'queryStringParameters'
 *      enableConversionTracking: // value for 'enableConversionTracking'
 *      enableTracking: // value for 'enableTracking'
 *      name: // value for 'name'
 *      linkMetadata: // value for 'linkMetadata'
 *      trackingParameters: // value for 'trackingParameters'
 *   },
 * });
 */
export function useCreateLink2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateLink2Mutation, CreateLink2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLink2Mutation, CreateLink2MutationVariables>(CreateLink2Document, options);
      }
export type CreateLink2MutationHookResult = ReturnType<typeof useCreateLink2Mutation>;
export type CreateLink2MutationResult = Apollo.MutationResult<CreateLink2Mutation>;
export type CreateLink2MutationOptions = Apollo.BaseMutationOptions<CreateLink2Mutation, CreateLink2MutationVariables>;
export const UpdateLink2Document = gql`
    mutation UpdateLink2($id: ID!, $url: String!, $queryStringParameters: [[String!]!]!, $enableConversionTracking: Boolean!, $enableTracking: Boolean!, $linkMetadata: LinkMetadataInput, $trackingParameters: [TrackingParameterInput!]!) {
  link2Update(
    id: $id
    url: $url
    queryStringParameters: $queryStringParameters
    enableConversionTracking: $enableConversionTracking
    enableTracking: $enableTracking
    linkMetadata: $linkMetadata
    trackingParameters: $trackingParameters
  ) {
    link {
      ...link2Fields
    }
  }
}
    ${Link2FieldsFragmentDoc}`;
export type UpdateLink2MutationFn = Apollo.MutationFunction<UpdateLink2Mutation, UpdateLink2MutationVariables>;

/**
 * __useUpdateLink2Mutation__
 *
 * To run a mutation, you first call `useUpdateLink2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLink2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLink2Mutation, { data, loading, error }] = useUpdateLink2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      url: // value for 'url'
 *      queryStringParameters: // value for 'queryStringParameters'
 *      enableConversionTracking: // value for 'enableConversionTracking'
 *      enableTracking: // value for 'enableTracking'
 *      linkMetadata: // value for 'linkMetadata'
 *      trackingParameters: // value for 'trackingParameters'
 *   },
 * });
 */
export function useUpdateLink2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateLink2Mutation, UpdateLink2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLink2Mutation, UpdateLink2MutationVariables>(UpdateLink2Document, options);
      }
export type UpdateLink2MutationHookResult = ReturnType<typeof useUpdateLink2Mutation>;
export type UpdateLink2MutationResult = Apollo.MutationResult<UpdateLink2Mutation>;
export type UpdateLink2MutationOptions = Apollo.BaseMutationOptions<UpdateLink2Mutation, UpdateLink2MutationVariables>;
export const EspMetadataFieldsWithDefaultsDocument = gql`
    query EspMetadataFieldsWithDefaults {
  currentClient {
    id
    enableConversionTracking
    emailServiceProviders {
      ...espMetadataFieldsWithDefaults
    }
    supportMultipleEsps: hasFeature(feature: "support_multiple_esps")
  }
}
    ${EspMetadataFieldsWithDefaultsFragmentDoc}`;

/**
 * __useEspMetadataFieldsWithDefaultsQuery__
 *
 * To run a query within a React component, call `useEspMetadataFieldsWithDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEspMetadataFieldsWithDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEspMetadataFieldsWithDefaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEspMetadataFieldsWithDefaultsQuery(baseOptions?: Apollo.QueryHookOptions<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>(EspMetadataFieldsWithDefaultsDocument, options);
      }
export function useEspMetadataFieldsWithDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>(EspMetadataFieldsWithDefaultsDocument, options);
        }
export function useEspMetadataFieldsWithDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>(EspMetadataFieldsWithDefaultsDocument, options);
        }
export type EspMetadataFieldsWithDefaultsQueryHookResult = ReturnType<typeof useEspMetadataFieldsWithDefaultsQuery>;
export type EspMetadataFieldsWithDefaultsLazyQueryHookResult = ReturnType<typeof useEspMetadataFieldsWithDefaultsLazyQuery>;
export type EspMetadataFieldsWithDefaultsSuspenseQueryHookResult = ReturnType<typeof useEspMetadataFieldsWithDefaultsSuspenseQuery>;
export type EspMetadataFieldsWithDefaultsQueryResult = Apollo.QueryResult<EspMetadataFieldsWithDefaultsQuery, EspMetadataFieldsWithDefaultsQueryVariables>;
export const LinkGroupsDocument = gql`
    query LinkGroups($url: String, $name: String) {
  linkGroups(url: $url, name: $name) {
    id
    name
    __typename
  }
}
    `;

/**
 * __useLinkGroupsQuery__
 *
 * To run a query within a React component, call `useLinkGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkGroupsQuery({
 *   variables: {
 *      url: // value for 'url'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useLinkGroupsQuery(baseOptions?: Apollo.QueryHookOptions<LinkGroupsQuery, LinkGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkGroupsQuery, LinkGroupsQueryVariables>(LinkGroupsDocument, options);
      }
export function useLinkGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkGroupsQuery, LinkGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkGroupsQuery, LinkGroupsQueryVariables>(LinkGroupsDocument, options);
        }
export function useLinkGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkGroupsQuery, LinkGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkGroupsQuery, LinkGroupsQueryVariables>(LinkGroupsDocument, options);
        }
export type LinkGroupsQueryHookResult = ReturnType<typeof useLinkGroupsQuery>;
export type LinkGroupsLazyQueryHookResult = ReturnType<typeof useLinkGroupsLazyQuery>;
export type LinkGroupsSuspenseQueryHookResult = ReturnType<typeof useLinkGroupsSuspenseQuery>;
export type LinkGroupsQueryResult = Apollo.QueryResult<LinkGroupsQuery, LinkGroupsQueryVariables>;
export const CreateLinkDocument = gql`
    mutation CreateLink($url: String!, $queryStringParameters: [[String!]!]!, $acousticCampaignMetadata: LinkAcousticCampaignMetadataInput2, $adobeCampaignMetadata: LinkAdobeCampaignMetadataInput2, $adobeJourneyOptimizerMetadata: LinkAdobeJourneyOptimizerMetadataInput2, $amazonSesMetadata: LinkAmazonSESMetadataInput2, $brazeMetadata: LinkBrazeMetadataInput2, $bluecoreMetadata: LinkBluecoreMetadataInput2, $cordialMetadata: LinkCordialMetadataInput2, $oracleResponsysMetadata: LinkOracleResponsysMetadataInput2, $salesforceMetadata: LinkSalesforceMarketingCloudMetadataInput2, $epsilonMetadata: LinkEpsilonMetadataInput2, $zetaMetadata: LinkZetaMetadataInput2, $enableConversionTracking: Boolean!, $enableTracking: Boolean!, $linkGroupName: String, $trackingParameters: [TrackingParameterInput!]!) {
  linkCreate2(
    url: $url
    queryStringParameters: $queryStringParameters
    acousticCampaignMetadata: $acousticCampaignMetadata
    adobeCampaignMetadata: $adobeCampaignMetadata
    adobeJourneyOptimizerMetadata: $adobeJourneyOptimizerMetadata
    amazonSesMetadata: $amazonSesMetadata
    brazeMetadata: $brazeMetadata
    bluecoreMetadata: $bluecoreMetadata
    cordialMetadata: $cordialMetadata
    oracleResponsysMetadata: $oracleResponsysMetadata
    salesforceMetadata: $salesforceMetadata
    epsilonMetadata: $epsilonMetadata
    zetaMetadata: $zetaMetadata
    enableConversionTracking: $enableConversionTracking
    enableTracking: $enableTracking
    linkGroupName: $linkGroupName
    trackingParameters: $trackingParameters
  ) {
    link {
      id
      __typename
    }
    __typename
  }
}
    `;
export type CreateLinkMutationFn = Apollo.MutationFunction<CreateLinkMutation, CreateLinkMutationVariables>;

/**
 * __useCreateLinkMutation__
 *
 * To run a mutation, you first call `useCreateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkMutation, { data, loading, error }] = useCreateLinkMutation({
 *   variables: {
 *      url: // value for 'url'
 *      queryStringParameters: // value for 'queryStringParameters'
 *      acousticCampaignMetadata: // value for 'acousticCampaignMetadata'
 *      adobeCampaignMetadata: // value for 'adobeCampaignMetadata'
 *      adobeJourneyOptimizerMetadata: // value for 'adobeJourneyOptimizerMetadata'
 *      amazonSesMetadata: // value for 'amazonSesMetadata'
 *      brazeMetadata: // value for 'brazeMetadata'
 *      bluecoreMetadata: // value for 'bluecoreMetadata'
 *      cordialMetadata: // value for 'cordialMetadata'
 *      oracleResponsysMetadata: // value for 'oracleResponsysMetadata'
 *      salesforceMetadata: // value for 'salesforceMetadata'
 *      epsilonMetadata: // value for 'epsilonMetadata'
 *      zetaMetadata: // value for 'zetaMetadata'
 *      enableConversionTracking: // value for 'enableConversionTracking'
 *      enableTracking: // value for 'enableTracking'
 *      linkGroupName: // value for 'linkGroupName'
 *      trackingParameters: // value for 'trackingParameters'
 *   },
 * });
 */
export function useCreateLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkMutation, CreateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkMutation, CreateLinkMutationVariables>(CreateLinkDocument, options);
      }
export type CreateLinkMutationHookResult = ReturnType<typeof useCreateLinkMutation>;
export type CreateLinkMutationResult = Apollo.MutationResult<CreateLinkMutation>;
export type CreateLinkMutationOptions = Apollo.BaseMutationOptions<CreateLinkMutation, CreateLinkMutationVariables>;
export const EditLinkDocument = gql`
    mutation EditLink($id: ID!, $url: String!, $queryStringParameters: [[String!]!]!, $acousticCampaignMetadata: LinkAcousticCampaignMetadataInput2, $adobeCampaignMetadata: LinkAdobeCampaignMetadataInput2, $adobeJourneyOptimizerMetadata: LinkAdobeJourneyOptimizerMetadataInput2, $amazonSesMetadata: LinkAmazonSESMetadataInput2, $brazeMetadata: LinkBrazeMetadataInput2, $bluecoreMetadata: LinkBluecoreMetadataInput2, $cordialMetadata: LinkCordialMetadataInput2, $oracleResponsysMetadata: LinkOracleResponsysMetadataInput2, $salesforceMetadata: LinkSalesforceMarketingCloudMetadataInput2, $epsilonMetadata: LinkEpsilonMetadataInput2, $zetaMetadata: LinkZetaMetadataInput2, $enableConversionTracking: Boolean!, $enableTracking: Boolean!, $linkGroupName: String, $trackingParameters: [TrackingParameterInput!]!) {
  linkUpdate2(
    id: $id
    url: $url
    queryStringParameters: $queryStringParameters
    acousticCampaignMetadata: $acousticCampaignMetadata
    adobeCampaignMetadata: $adobeCampaignMetadata
    adobeJourneyOptimizerMetadata: $adobeJourneyOptimizerMetadata
    amazonSesMetadata: $amazonSesMetadata
    brazeMetadata: $brazeMetadata
    bluecoreMetadata: $bluecoreMetadata
    cordialMetadata: $cordialMetadata
    oracleResponsysMetadata: $oracleResponsysMetadata
    salesforceMetadata: $salesforceMetadata
    epsilonMetadata: $epsilonMetadata
    zetaMetadata: $zetaMetadata
    enableConversionTracking: $enableConversionTracking
    enableTracking: $enableTracking
    linkGroupName: $linkGroupName
    trackingParameters: $trackingParameters
  ) {
    link {
      ...linkFields
      linkGroup {
        id
        name
        linksCount
      }
    }
  }
}
    ${LinkFieldsFragmentDoc}`;
export type EditLinkMutationFn = Apollo.MutationFunction<EditLinkMutation, EditLinkMutationVariables>;

/**
 * __useEditLinkMutation__
 *
 * To run a mutation, you first call `useEditLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLinkMutation, { data, loading, error }] = useEditLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      url: // value for 'url'
 *      queryStringParameters: // value for 'queryStringParameters'
 *      acousticCampaignMetadata: // value for 'acousticCampaignMetadata'
 *      adobeCampaignMetadata: // value for 'adobeCampaignMetadata'
 *      adobeJourneyOptimizerMetadata: // value for 'adobeJourneyOptimizerMetadata'
 *      amazonSesMetadata: // value for 'amazonSesMetadata'
 *      brazeMetadata: // value for 'brazeMetadata'
 *      bluecoreMetadata: // value for 'bluecoreMetadata'
 *      cordialMetadata: // value for 'cordialMetadata'
 *      oracleResponsysMetadata: // value for 'oracleResponsysMetadata'
 *      salesforceMetadata: // value for 'salesforceMetadata'
 *      epsilonMetadata: // value for 'epsilonMetadata'
 *      zetaMetadata: // value for 'zetaMetadata'
 *      enableConversionTracking: // value for 'enableConversionTracking'
 *      enableTracking: // value for 'enableTracking'
 *      linkGroupName: // value for 'linkGroupName'
 *      trackingParameters: // value for 'trackingParameters'
 *   },
 * });
 */
export function useEditLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditLinkMutation, EditLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLinkMutation, EditLinkMutationVariables>(EditLinkDocument, options);
      }
export type EditLinkMutationHookResult = ReturnType<typeof useEditLinkMutation>;
export type EditLinkMutationResult = Apollo.MutationResult<EditLinkMutation>;
export type EditLinkMutationOptions = Apollo.BaseMutationOptions<EditLinkMutation, EditLinkMutationVariables>;
export const CreateLinkFromLinkGroupDocument = gql`
    mutation CreateLinkFromLinkGroup($linkGroupId: ID!) {
  linkGroupCreateLink(linkGroupId: $linkGroupId) {
    link {
      ...linkFields
      linkGroup {
        id
        name
        linksCount
      }
    }
  }
}
    ${LinkFieldsFragmentDoc}`;
export type CreateLinkFromLinkGroupMutationFn = Apollo.MutationFunction<CreateLinkFromLinkGroupMutation, CreateLinkFromLinkGroupMutationVariables>;

/**
 * __useCreateLinkFromLinkGroupMutation__
 *
 * To run a mutation, you first call `useCreateLinkFromLinkGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkFromLinkGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkFromLinkGroupMutation, { data, loading, error }] = useCreateLinkFromLinkGroupMutation({
 *   variables: {
 *      linkGroupId: // value for 'linkGroupId'
 *   },
 * });
 */
export function useCreateLinkFromLinkGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkFromLinkGroupMutation, CreateLinkFromLinkGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkFromLinkGroupMutation, CreateLinkFromLinkGroupMutationVariables>(CreateLinkFromLinkGroupDocument, options);
      }
export type CreateLinkFromLinkGroupMutationHookResult = ReturnType<typeof useCreateLinkFromLinkGroupMutation>;
export type CreateLinkFromLinkGroupMutationResult = Apollo.MutationResult<CreateLinkFromLinkGroupMutation>;
export type CreateLinkFromLinkGroupMutationOptions = Apollo.BaseMutationOptions<CreateLinkFromLinkGroupMutation, CreateLinkFromLinkGroupMutationVariables>;
export const SendSupportTicketDocument = gql`
    mutation SendSupportTicket($contextUrl: String, $message: String!) {
  sendSupportTicket(contextUrl: $contextUrl, message: $message) {
    ticketId
  }
}
    `;
export type SendSupportTicketMutationFn = Apollo.MutationFunction<SendSupportTicketMutation, SendSupportTicketMutationVariables>;

/**
 * __useSendSupportTicketMutation__
 *
 * To run a mutation, you first call `useSendSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportTicketMutation, { data, loading, error }] = useSendSupportTicketMutation({
 *   variables: {
 *      contextUrl: // value for 'contextUrl'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendSupportTicketMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportTicketMutation, SendSupportTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportTicketMutation, SendSupportTicketMutationVariables>(SendSupportTicketDocument, options);
      }
export type SendSupportTicketMutationHookResult = ReturnType<typeof useSendSupportTicketMutation>;
export type SendSupportTicketMutationResult = Apollo.MutationResult<SendSupportTicketMutation>;
export type SendSupportTicketMutationOptions = Apollo.BaseMutationOptions<SendSupportTicketMutation, SendSupportTicketMutationVariables>;
export const ProductBoardTokenDocument = gql`
    query ProductBoardToken {
  productboardToken {
    token
  }
}
    `;

/**
 * __useProductBoardTokenQuery__
 *
 * To run a query within a React component, call `useProductBoardTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBoardTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBoardTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductBoardTokenQuery(baseOptions?: Apollo.QueryHookOptions<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>(ProductBoardTokenDocument, options);
      }
export function useProductBoardTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>(ProductBoardTokenDocument, options);
        }
export function useProductBoardTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>(ProductBoardTokenDocument, options);
        }
export type ProductBoardTokenQueryHookResult = ReturnType<typeof useProductBoardTokenQuery>;
export type ProductBoardTokenLazyQueryHookResult = ReturnType<typeof useProductBoardTokenLazyQuery>;
export type ProductBoardTokenSuspenseQueryHookResult = ReturnType<typeof useProductBoardTokenSuspenseQuery>;
export type ProductBoardTokenQueryResult = Apollo.QueryResult<ProductBoardTokenQuery, ProductBoardTokenQueryVariables>;
export const ProductUpdatesDocument = gql`
    query ProductUpdates {
  productUpdates {
    title
    url
  }
}
    `;

/**
 * __useProductUpdatesQuery__
 *
 * To run a query within a React component, call `useProductUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<ProductUpdatesQuery, ProductUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductUpdatesQuery, ProductUpdatesQueryVariables>(ProductUpdatesDocument, options);
      }
export function useProductUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductUpdatesQuery, ProductUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductUpdatesQuery, ProductUpdatesQueryVariables>(ProductUpdatesDocument, options);
        }
export function useProductUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductUpdatesQuery, ProductUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductUpdatesQuery, ProductUpdatesQueryVariables>(ProductUpdatesDocument, options);
        }
export type ProductUpdatesQueryHookResult = ReturnType<typeof useProductUpdatesQuery>;
export type ProductUpdatesLazyQueryHookResult = ReturnType<typeof useProductUpdatesLazyQuery>;
export type ProductUpdatesSuspenseQueryHookResult = ReturnType<typeof useProductUpdatesSuspenseQuery>;
export type ProductUpdatesQueryResult = Apollo.QueryResult<ProductUpdatesQuery, ProductUpdatesQueryVariables>;
export const ClientUserUpdateDocument = gql`
    mutation ClientUserUpdate($id: ID!) {
  clientUserUpdate(id: $id) {
    client {
      id
    }
  }
}
    `;
export type ClientUserUpdateMutationFn = Apollo.MutationFunction<ClientUserUpdateMutation, ClientUserUpdateMutationVariables>;

/**
 * __useClientUserUpdateMutation__
 *
 * To run a mutation, you first call `useClientUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientUserUpdateMutation, { data, loading, error }] = useClientUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ClientUserUpdateMutation, ClientUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientUserUpdateMutation, ClientUserUpdateMutationVariables>(ClientUserUpdateDocument, options);
      }
export type ClientUserUpdateMutationHookResult = ReturnType<typeof useClientUserUpdateMutation>;
export type ClientUserUpdateMutationResult = Apollo.MutationResult<ClientUserUpdateMutation>;
export type ClientUserUpdateMutationOptions = Apollo.BaseMutationOptions<ClientUserUpdateMutation, ClientUserUpdateMutationVariables>;
export const GetTrackingParameterDefinitionsDocument = gql`
    query GetTrackingParameterDefinitions {
  trackingParameterDefinitions {
    ...BaseAttributeDefinitionFields
    ... on TextAttributeDefinition {
      multiline
    }
    ... on SelectAttributeDefinition2 {
      options {
        __typename
        id
        title
      }
    }
  }
}
    ${BaseAttributeDefinitionFieldsFragmentDoc}`;

/**
 * __useGetTrackingParameterDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetTrackingParameterDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackingParameterDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackingParameterDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrackingParameterDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>(GetTrackingParameterDefinitionsDocument, options);
      }
export function useGetTrackingParameterDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>(GetTrackingParameterDefinitionsDocument, options);
        }
export function useGetTrackingParameterDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>(GetTrackingParameterDefinitionsDocument, options);
        }
export type GetTrackingParameterDefinitionsQueryHookResult = ReturnType<typeof useGetTrackingParameterDefinitionsQuery>;
export type GetTrackingParameterDefinitionsLazyQueryHookResult = ReturnType<typeof useGetTrackingParameterDefinitionsLazyQuery>;
export type GetTrackingParameterDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetTrackingParameterDefinitionsSuspenseQuery>;
export type GetTrackingParameterDefinitionsQueryResult = Apollo.QueryResult<GetTrackingParameterDefinitionsQuery, GetTrackingParameterDefinitionsQueryVariables>;
export const ManagedMediaUsagesDocument = gql`
    query ManagedMediaUsages($mediaId: String!) {
  mediaLibrary2(ids: [$mediaId]) {
    ... on ManagedMedia {
      id
      usages {
        __typename
        ... on MediaUsageLocation {
          id
          channel
        }
        ... on EmailCreativeUsage {
          creativeId
          creativeTitle
          layoutId
          templateTagId
        }
        ... on PushCreativeUsage {
          creativeId
          creativeTitle
          contentId
        }
        ... on MmsCreativeUsage {
          creativeId
          creativeTitle
          contentId
        }
        ... on LayoutComponentUsage {
          componentId
          componentName
          componentType
          layoutId
          versionNumber
        }
      }
    }
  }
}
    `;

/**
 * __useManagedMediaUsagesQuery__
 *
 * To run a query within a React component, call `useManagedMediaUsagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedMediaUsagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedMediaUsagesQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useManagedMediaUsagesQuery(baseOptions: Apollo.QueryHookOptions<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables> & ({ variables: ManagedMediaUsagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables>(ManagedMediaUsagesDocument, options);
      }
export function useManagedMediaUsagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables>(ManagedMediaUsagesDocument, options);
        }
export function useManagedMediaUsagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables>(ManagedMediaUsagesDocument, options);
        }
export type ManagedMediaUsagesQueryHookResult = ReturnType<typeof useManagedMediaUsagesQuery>;
export type ManagedMediaUsagesLazyQueryHookResult = ReturnType<typeof useManagedMediaUsagesLazyQuery>;
export type ManagedMediaUsagesSuspenseQueryHookResult = ReturnType<typeof useManagedMediaUsagesSuspenseQuery>;
export type ManagedMediaUsagesQueryResult = Apollo.QueryResult<ManagedMediaUsagesQuery, ManagedMediaUsagesQueryVariables>;
export const MediaLibraryDocument = gql`
    query MediaLibrary($mediaIds: [String!]!) {
  mediaLibrary2(ids: $mediaIds) {
    ...mediaFields
  }
}
    ${MediaFieldsFragmentDoc}`;

/**
 * __useMediaLibraryQuery__
 *
 * To run a query within a React component, call `useMediaLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaLibraryQuery({
 *   variables: {
 *      mediaIds: // value for 'mediaIds'
 *   },
 * });
 */
export function useMediaLibraryQuery(baseOptions: Apollo.QueryHookOptions<MediaLibraryQuery, MediaLibraryQueryVariables> & ({ variables: MediaLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaLibraryQuery, MediaLibraryQueryVariables>(MediaLibraryDocument, options);
      }
export function useMediaLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaLibraryQuery, MediaLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaLibraryQuery, MediaLibraryQueryVariables>(MediaLibraryDocument, options);
        }
export function useMediaLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaLibraryQuery, MediaLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaLibraryQuery, MediaLibraryQueryVariables>(MediaLibraryDocument, options);
        }
export type MediaLibraryQueryHookResult = ReturnType<typeof useMediaLibraryQuery>;
export type MediaLibraryLazyQueryHookResult = ReturnType<typeof useMediaLibraryLazyQuery>;
export type MediaLibrarySuspenseQueryHookResult = ReturnType<typeof useMediaLibrarySuspenseQuery>;
export type MediaLibraryQueryResult = Apollo.QueryResult<MediaLibraryQuery, MediaLibraryQueryVariables>;
export const AccountUserInvitationAcceptDocument = gql`
    mutation AccountUserInvitationAccept($accountId: ID!) {
  accountUserInvitationAccept2(accountId: $accountId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type AccountUserInvitationAcceptMutationFn = Apollo.MutationFunction<AccountUserInvitationAcceptMutation, AccountUserInvitationAcceptMutationVariables>;

/**
 * __useAccountUserInvitationAcceptMutation__
 *
 * To run a mutation, you first call `useAccountUserInvitationAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserInvitationAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserInvitationAcceptMutation, { data, loading, error }] = useAccountUserInvitationAcceptMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountUserInvitationAcceptMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserInvitationAcceptMutation, AccountUserInvitationAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserInvitationAcceptMutation, AccountUserInvitationAcceptMutationVariables>(AccountUserInvitationAcceptDocument, options);
      }
export type AccountUserInvitationAcceptMutationHookResult = ReturnType<typeof useAccountUserInvitationAcceptMutation>;
export type AccountUserInvitationAcceptMutationResult = Apollo.MutationResult<AccountUserInvitationAcceptMutation>;
export type AccountUserInvitationAcceptMutationOptions = Apollo.BaseMutationOptions<AccountUserInvitationAcceptMutation, AccountUserInvitationAcceptMutationVariables>;
export const AccountUserInvitationDeclineDocument = gql`
    mutation AccountUserInvitationDecline($accountId: ID!) {
  accountUserInvitationDecline(accountId: $accountId) {
    success
  }
}
    `;
export type AccountUserInvitationDeclineMutationFn = Apollo.MutationFunction<AccountUserInvitationDeclineMutation, AccountUserInvitationDeclineMutationVariables>;

/**
 * __useAccountUserInvitationDeclineMutation__
 *
 * To run a mutation, you first call `useAccountUserInvitationDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserInvitationDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserInvitationDeclineMutation, { data, loading, error }] = useAccountUserInvitationDeclineMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountUserInvitationDeclineMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserInvitationDeclineMutation, AccountUserInvitationDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserInvitationDeclineMutation, AccountUserInvitationDeclineMutationVariables>(AccountUserInvitationDeclineDocument, options);
      }
export type AccountUserInvitationDeclineMutationHookResult = ReturnType<typeof useAccountUserInvitationDeclineMutation>;
export type AccountUserInvitationDeclineMutationResult = Apollo.MutationResult<AccountUserInvitationDeclineMutation>;
export type AccountUserInvitationDeclineMutationOptions = Apollo.BaseMutationOptions<AccountUserInvitationDeclineMutation, AccountUserInvitationDeclineMutationVariables>;
export const ReportingCampaignContentBlocksMetricsDocument = gql`
    query ReportingCampaignContentBlocksMetrics($campaignId: ID!) {
  campaignContentblocksMetrics(campaignId: $campaignId) {
    contentblock {
      id
      title
      type
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCampaignContentBlocksMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCampaignContentBlocksMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignContentBlocksMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignContentBlocksMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useReportingCampaignContentBlocksMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables> & ({ variables: ReportingCampaignContentBlocksMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables>(ReportingCampaignContentBlocksMetricsDocument, options);
      }
export function useReportingCampaignContentBlocksMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables>(ReportingCampaignContentBlocksMetricsDocument, options);
        }
export function useReportingCampaignContentBlocksMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables>(ReportingCampaignContentBlocksMetricsDocument, options);
        }
export type ReportingCampaignContentBlocksMetricsQueryHookResult = ReturnType<typeof useReportingCampaignContentBlocksMetricsQuery>;
export type ReportingCampaignContentBlocksMetricsLazyQueryHookResult = ReturnType<typeof useReportingCampaignContentBlocksMetricsLazyQuery>;
export type ReportingCampaignContentBlocksMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignContentBlocksMetricsSuspenseQuery>;
export type ReportingCampaignContentBlocksMetricsQueryResult = Apollo.QueryResult<ReportingCampaignContentBlocksMetricsQuery, ReportingCampaignContentBlocksMetricsQueryVariables>;
export const ReportingCampaignCreativesMetricsDocument = gql`
    query ReportingCampaignCreativesMetrics($campaignId: ID!) {
  campaignCreativesMetrics(campaignId: $campaignId) {
    creative {
      id
      title
      status
      minStartDate
      maxEndDate
      bestThumbnail {
        url
      }
      tags {
        id
        name
      }
      ...creativeContentsFields
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${CreativeContentsFieldsFragmentDoc}
${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCampaignCreativesMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCampaignCreativesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignCreativesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignCreativesMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useReportingCampaignCreativesMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables> & ({ variables: ReportingCampaignCreativesMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables>(ReportingCampaignCreativesMetricsDocument, options);
      }
export function useReportingCampaignCreativesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables>(ReportingCampaignCreativesMetricsDocument, options);
        }
export function useReportingCampaignCreativesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables>(ReportingCampaignCreativesMetricsDocument, options);
        }
export type ReportingCampaignCreativesMetricsQueryHookResult = ReturnType<typeof useReportingCampaignCreativesMetricsQuery>;
export type ReportingCampaignCreativesMetricsLazyQueryHookResult = ReturnType<typeof useReportingCampaignCreativesMetricsLazyQuery>;
export type ReportingCampaignCreativesMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignCreativesMetricsSuspenseQuery>;
export type ReportingCampaignCreativesMetricsQueryResult = Apollo.QueryResult<ReportingCampaignCreativesMetricsQuery, ReportingCampaignCreativesMetricsQueryVariables>;
export const ReportingCampaignExperimentsMetricsDocument = gql`
    query ReportingCampaignExperimentsMetrics($campaignId: ID!) {
  campaignExperimentsMetrics(campaignId: $campaignId) {
    experiment {
      id
      title
      status
      minDate
      maxDate
      status
    }
    treatments {
      treatment {
        id
        title
        order
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useReportingCampaignExperimentsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCampaignExperimentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignExperimentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignExperimentsMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useReportingCampaignExperimentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables> & ({ variables: ReportingCampaignExperimentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables>(ReportingCampaignExperimentsMetricsDocument, options);
      }
export function useReportingCampaignExperimentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables>(ReportingCampaignExperimentsMetricsDocument, options);
        }
export function useReportingCampaignExperimentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables>(ReportingCampaignExperimentsMetricsDocument, options);
        }
export type ReportingCampaignExperimentsMetricsQueryHookResult = ReturnType<typeof useReportingCampaignExperimentsMetricsQuery>;
export type ReportingCampaignExperimentsMetricsLazyQueryHookResult = ReturnType<typeof useReportingCampaignExperimentsMetricsLazyQuery>;
export type ReportingCampaignExperimentsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignExperimentsMetricsSuspenseQuery>;
export type ReportingCampaignExperimentsMetricsQueryResult = Apollo.QueryResult<ReportingCampaignExperimentsMetricsQuery, ReportingCampaignExperimentsMetricsQueryVariables>;
export const ReportingCampaignsHeaderDocument = gql`
    query ReportingCampaignsHeader($filter: CampaignFilter!) {
  campaignsMetrics(filter: $filter) {
    campaigns {
      campaign {
        id
        title
        stage
        sendDate
        tags {
          id
          name
        }
        channel {
          category
          channel
        }
      }
    }
  }
}
    `;

/**
 * __useReportingCampaignsHeaderQuery__
 *
 * To run a query within a React component, call `useReportingCampaignsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignsHeaderQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCampaignsHeaderQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables> & ({ variables: ReportingCampaignsHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables>(ReportingCampaignsHeaderDocument, options);
      }
export function useReportingCampaignsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables>(ReportingCampaignsHeaderDocument, options);
        }
export function useReportingCampaignsHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables>(ReportingCampaignsHeaderDocument, options);
        }
export type ReportingCampaignsHeaderQueryHookResult = ReturnType<typeof useReportingCampaignsHeaderQuery>;
export type ReportingCampaignsHeaderLazyQueryHookResult = ReturnType<typeof useReportingCampaignsHeaderLazyQuery>;
export type ReportingCampaignsHeaderSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignsHeaderSuspenseQuery>;
export type ReportingCampaignsHeaderQueryResult = Apollo.QueryResult<ReportingCampaignsHeaderQuery, ReportingCampaignsHeaderQueryVariables>;
export const ReportingCampaignMailingsMetricsDocument = gql`
    query ReportingCampaignMailingsMetrics($campaignId: ID!) {
  campaignMailingsMetrics(campaignId: $campaignId) {
    mailing {
      id
      sendDatetime
      type
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCampaignMailingsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCampaignMailingsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignMailingsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignMailingsMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useReportingCampaignMailingsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables> & ({ variables: ReportingCampaignMailingsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables>(ReportingCampaignMailingsMetricsDocument, options);
      }
export function useReportingCampaignMailingsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables>(ReportingCampaignMailingsMetricsDocument, options);
        }
export function useReportingCampaignMailingsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables>(ReportingCampaignMailingsMetricsDocument, options);
        }
export type ReportingCampaignMailingsMetricsQueryHookResult = ReturnType<typeof useReportingCampaignMailingsMetricsQuery>;
export type ReportingCampaignMailingsMetricsLazyQueryHookResult = ReturnType<typeof useReportingCampaignMailingsMetricsLazyQuery>;
export type ReportingCampaignMailingsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignMailingsMetricsSuspenseQuery>;
export type ReportingCampaignMailingsMetricsQueryResult = Apollo.QueryResult<ReportingCampaignMailingsMetricsQuery, ReportingCampaignMailingsMetricsQueryVariables>;
export const AnalyticsCampaignMailingActivityDocument = gql`
    query AnalyticsCampaignMailingActivity($campaignId: ID!) {
  analyticsCampaignMailingActivity(campaignId: $campaignId) {
    mailing {
      id
      sendDatetime
      type
    }
    activity {
      ...AnalyticsActivityFields
    }
  }
}
    ${AnalyticsActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsCampaignMailingActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsCampaignMailingActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCampaignMailingActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCampaignMailingActivityQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAnalyticsCampaignMailingActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables> & ({ variables: AnalyticsCampaignMailingActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables>(AnalyticsCampaignMailingActivityDocument, options);
      }
export function useAnalyticsCampaignMailingActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables>(AnalyticsCampaignMailingActivityDocument, options);
        }
export function useAnalyticsCampaignMailingActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables>(AnalyticsCampaignMailingActivityDocument, options);
        }
export type AnalyticsCampaignMailingActivityQueryHookResult = ReturnType<typeof useAnalyticsCampaignMailingActivityQuery>;
export type AnalyticsCampaignMailingActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsCampaignMailingActivityLazyQuery>;
export type AnalyticsCampaignMailingActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsCampaignMailingActivitySuspenseQuery>;
export type AnalyticsCampaignMailingActivityQueryResult = Apollo.QueryResult<AnalyticsCampaignMailingActivityQuery, AnalyticsCampaignMailingActivityQueryVariables>;
export const AnalyticsSendTimeMetricsDocument = gql`
    query AnalyticsSendTimeMetrics($campaignId: ID!) {
  analyticsCampaignSendTimeMetrics(campaignId: $campaignId) {
    sendTime
    sends
  }
}
    `;

/**
 * __useAnalyticsSendTimeMetricsQuery__
 *
 * To run a query within a React component, call `useAnalyticsSendTimeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSendTimeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSendTimeMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAnalyticsSendTimeMetricsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables> & ({ variables: AnalyticsSendTimeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables>(AnalyticsSendTimeMetricsDocument, options);
      }
export function useAnalyticsSendTimeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables>(AnalyticsSendTimeMetricsDocument, options);
        }
export function useAnalyticsSendTimeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables>(AnalyticsSendTimeMetricsDocument, options);
        }
export type AnalyticsSendTimeMetricsQueryHookResult = ReturnType<typeof useAnalyticsSendTimeMetricsQuery>;
export type AnalyticsSendTimeMetricsLazyQueryHookResult = ReturnType<typeof useAnalyticsSendTimeMetricsLazyQuery>;
export type AnalyticsSendTimeMetricsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSendTimeMetricsSuspenseQuery>;
export type AnalyticsSendTimeMetricsQueryResult = Apollo.QueryResult<AnalyticsSendTimeMetricsQuery, AnalyticsSendTimeMetricsQueryVariables>;
export const ReportingCampaignOverviewMetricsDocument = gql`
    query ReportingCampaignOverviewMetrics($filter: CampaignFilter!) {
  campaignsMetrics(filter: $filter) {
    campaigns {
      campaign {
        id
        sendDate
      }
      metrics {
        ...MetricFields
      }
    }
    summary {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCampaignOverviewMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCampaignOverviewMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignOverviewMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignOverviewMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCampaignOverviewMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables> & ({ variables: ReportingCampaignOverviewMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables>(ReportingCampaignOverviewMetricsDocument, options);
      }
export function useReportingCampaignOverviewMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables>(ReportingCampaignOverviewMetricsDocument, options);
        }
export function useReportingCampaignOverviewMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables>(ReportingCampaignOverviewMetricsDocument, options);
        }
export type ReportingCampaignOverviewMetricsQueryHookResult = ReturnType<typeof useReportingCampaignOverviewMetricsQuery>;
export type ReportingCampaignOverviewMetricsLazyQueryHookResult = ReturnType<typeof useReportingCampaignOverviewMetricsLazyQuery>;
export type ReportingCampaignOverviewMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignOverviewMetricsSuspenseQuery>;
export type ReportingCampaignOverviewMetricsQueryResult = Apollo.QueryResult<ReportingCampaignOverviewMetricsQuery, ReportingCampaignOverviewMetricsQueryVariables>;
export const ReportingCampaignSegmentsMetricsDocument = gql`
    query ReportingCampaignSegmentsMetrics($campaignId: ID!) {
  campaignSegmentsMetrics(campaignId: $campaignId) {
    audience {
      id
      name
      description
      updatedAt
    }
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCampaignSegmentsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCampaignSegmentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCampaignSegmentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCampaignSegmentsMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useReportingCampaignSegmentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables> & ({ variables: ReportingCampaignSegmentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables>(ReportingCampaignSegmentsMetricsDocument, options);
      }
export function useReportingCampaignSegmentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables>(ReportingCampaignSegmentsMetricsDocument, options);
        }
export function useReportingCampaignSegmentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables>(ReportingCampaignSegmentsMetricsDocument, options);
        }
export type ReportingCampaignSegmentsMetricsQueryHookResult = ReturnType<typeof useReportingCampaignSegmentsMetricsQuery>;
export type ReportingCampaignSegmentsMetricsLazyQueryHookResult = ReturnType<typeof useReportingCampaignSegmentsMetricsLazyQuery>;
export type ReportingCampaignSegmentsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCampaignSegmentsMetricsSuspenseQuery>;
export type ReportingCampaignSegmentsMetricsQueryResult = Apollo.QueryResult<ReportingCampaignSegmentsMetricsQuery, ReportingCampaignSegmentsMetricsQueryVariables>;
export const AnalyticsV2CampaignsMetricsGroupedByDocument = gql`
    query AnalyticsV2CampaignsMetricsGroupedBy($groupBy: CampaignGroupBy, $campaignIdsOrTitles: [String!], $campaignStages: [CampaignStageType!], $experimentIds: [ID!], $includeCampaignTagIds: [ID!], $excludeCampaignTagIds: [ID!], $startDate: Date, $endDate: Date) {
  analyticsV2GroupedCampaignMetrics(
    groupBy: $groupBy
    campaignIdsOrTitles: $campaignIdsOrTitles
    campaignStages: $campaignStages
    includeCampaignTagIds: $includeCampaignTagIds
    excludeCampaignTagIds: $excludeCampaignTagIds
    experimentIds: $experimentIds
    endDate: $endDate
    startDate: $startDate
  ) {
    group
    metrics {
      ...AnalyticsV2BaseMetricsFields
    }
    campaigns {
      campaign {
        id
        title
        stage
        sendDate
        sendSchedule {
          id
          schedule {
            ... on PersonalizedSendSchedule {
              datetimeRanges
            }
            ... on StaticSendSchedule {
              datetime
            }
          }
        }
        tags {
          id
          name
        }
        experiments {
          id
          title
        }
      }
      metrics {
        ...AnalyticsV2BaseMetricsFields
      }
    }
  }
}
    ${AnalyticsV2BaseMetricsFieldsFragmentDoc}`;

/**
 * __useAnalyticsV2CampaignsMetricsGroupedByQuery__
 *
 * To run a query within a React component, call `useAnalyticsV2CampaignsMetricsGroupedByQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CampaignsMetricsGroupedByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsV2CampaignsMetricsGroupedByQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      campaignStages: // value for 'campaignStages'
 *      experimentIds: // value for 'experimentIds'
 *      includeCampaignTagIds: // value for 'includeCampaignTagIds'
 *      excludeCampaignTagIds: // value for 'excludeCampaignTagIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAnalyticsV2CampaignsMetricsGroupedByQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>(AnalyticsV2CampaignsMetricsGroupedByDocument, options);
      }
export function useAnalyticsV2CampaignsMetricsGroupedByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>(AnalyticsV2CampaignsMetricsGroupedByDocument, options);
        }
export function useAnalyticsV2CampaignsMetricsGroupedBySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>(AnalyticsV2CampaignsMetricsGroupedByDocument, options);
        }
export type AnalyticsV2CampaignsMetricsGroupedByQueryHookResult = ReturnType<typeof useAnalyticsV2CampaignsMetricsGroupedByQuery>;
export type AnalyticsV2CampaignsMetricsGroupedByLazyQueryHookResult = ReturnType<typeof useAnalyticsV2CampaignsMetricsGroupedByLazyQuery>;
export type AnalyticsV2CampaignsMetricsGroupedBySuspenseQueryHookResult = ReturnType<typeof useAnalyticsV2CampaignsMetricsGroupedBySuspenseQuery>;
export type AnalyticsV2CampaignsMetricsGroupedByQueryResult = Apollo.QueryResult<AnalyticsV2CampaignsMetricsGroupedByQuery, AnalyticsV2CampaignsMetricsGroupedByQueryVariables>;
export const GroupedCampaignsMetricsDocument = gql`
    query GroupedCampaignsMetrics($filter: CampaignFilter!, $groupBy: CampaignGroupBy) {
  groupedCampaignsMetrics(filter: $filter, groupBy: $groupBy) {
    group
    campaigns {
      campaign {
        id
        title
        stage
        sendDate
        sendSchedule {
          id
          schedule {
            ... on PersonalizedSendSchedule {
              datetimeRanges
            }
            ... on StaticSendSchedule {
              datetime
            }
          }
        }
        tags {
          id
          name
        }
        experiments {
          id
          title
        }
      }
      metrics {
        ...MetricFields
      }
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useGroupedCampaignsMetricsQuery__
 *
 * To run a query within a React component, call `useGroupedCampaignsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedCampaignsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedCampaignsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useGroupedCampaignsMetricsQuery(baseOptions: Apollo.QueryHookOptions<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables> & ({ variables: GroupedCampaignsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables>(GroupedCampaignsMetricsDocument, options);
      }
export function useGroupedCampaignsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables>(GroupedCampaignsMetricsDocument, options);
        }
export function useGroupedCampaignsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables>(GroupedCampaignsMetricsDocument, options);
        }
export type GroupedCampaignsMetricsQueryHookResult = ReturnType<typeof useGroupedCampaignsMetricsQuery>;
export type GroupedCampaignsMetricsLazyQueryHookResult = ReturnType<typeof useGroupedCampaignsMetricsLazyQuery>;
export type GroupedCampaignsMetricsSuspenseQueryHookResult = ReturnType<typeof useGroupedCampaignsMetricsSuspenseQuery>;
export type GroupedCampaignsMetricsQueryResult = Apollo.QueryResult<GroupedCampaignsMetricsQuery, GroupedCampaignsMetricsQueryVariables>;
export const AnalyticsCampaignsActivityDocument = gql`
    query AnalyticsCampaignsActivity($startDate: Date, $endDate: Date, $campaignIds: [ID!], $experimentIds: [ID!], $include: [ID!], $exclude: [ID!], $stages: [CampaignStageType!]) {
  analyticsCampaignsActivity(
    startDate: $startDate
    endDate: $endDate
    campaignIds: $campaignIds
    experimentIds: $experimentIds
    include: $include
    exclude: $exclude
    stages: $stages
  ) {
    campaigns {
      campaign {
        id
        title
        stage
        sendDate
        sendSchedule {
          id
          schedule {
            ... on PersonalizedSendSchedule {
              datetimeRanges
            }
            ... on StaticSendSchedule {
              datetime
            }
          }
        }
        tags {
          id
          name
        }
        experiments {
          id
          title
        }
      }
      activity {
        ...AnalyticsActivityFields
      }
    }
  }
}
    ${AnalyticsActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsCampaignsActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsCampaignsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCampaignsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCampaignsActivityQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      campaignIds: // value for 'campaignIds'
 *      experimentIds: // value for 'experimentIds'
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *      stages: // value for 'stages'
 *   },
 * });
 */
export function useAnalyticsCampaignsActivityQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>(AnalyticsCampaignsActivityDocument, options);
      }
export function useAnalyticsCampaignsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>(AnalyticsCampaignsActivityDocument, options);
        }
export function useAnalyticsCampaignsActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>(AnalyticsCampaignsActivityDocument, options);
        }
export type AnalyticsCampaignsActivityQueryHookResult = ReturnType<typeof useAnalyticsCampaignsActivityQuery>;
export type AnalyticsCampaignsActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsCampaignsActivityLazyQuery>;
export type AnalyticsCampaignsActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsCampaignsActivitySuspenseQuery>;
export type AnalyticsCampaignsActivityQueryResult = Apollo.QueryResult<AnalyticsCampaignsActivityQuery, AnalyticsCampaignsActivityQueryVariables>;
export const AnalyticsV2CampaignExportDocument = gql`
    mutation AnalyticsV2CampaignExport($columns: [String!]!, $dateRange: DateRange!, $filters: [AnalyticsFilterInput!]!, $groupBy: CampaignGroupBy) {
  analyticsV2CampaignExport(
    columns: $columns
    dateRange: $dateRange
    filters: $filters
    groupBy: $groupBy
  ) {
    signedUrl
  }
}
    `;
export type AnalyticsV2CampaignExportMutationFn = Apollo.MutationFunction<AnalyticsV2CampaignExportMutation, AnalyticsV2CampaignExportMutationVariables>;

/**
 * __useAnalyticsV2CampaignExportMutation__
 *
 * To run a mutation, you first call `useAnalyticsV2CampaignExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CampaignExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsV2CampaignExportMutation, { data, loading, error }] = useAnalyticsV2CampaignExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useAnalyticsV2CampaignExportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsV2CampaignExportMutation, AnalyticsV2CampaignExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsV2CampaignExportMutation, AnalyticsV2CampaignExportMutationVariables>(AnalyticsV2CampaignExportDocument, options);
      }
export type AnalyticsV2CampaignExportMutationHookResult = ReturnType<typeof useAnalyticsV2CampaignExportMutation>;
export type AnalyticsV2CampaignExportMutationResult = Apollo.MutationResult<AnalyticsV2CampaignExportMutation>;
export type AnalyticsV2CampaignExportMutationOptions = Apollo.BaseMutationOptions<AnalyticsV2CampaignExportMutation, AnalyticsV2CampaignExportMutationVariables>;
export const AnalyticsCampaignFiltersDocument = gql`
    query AnalyticsCampaignFilters($page: Int!, $pageSize: Int, $startEndRange: DateRange, $startDate: Date, $endDate: Date, $creativeChannel: Channel, $campaignChannels: [Channel!]) {
  analyticsV2Creatives(
    filter: {startDate: $startDate, endDate: $endDate, channel: $creativeChannel}
  ) {
    id
    title
    tags {
      id
      name
    }
  }
  campaigns(
    page: $page
    pageSize: $pageSize
    startEndRange: $startEndRange
    channels: $campaignChannels
  ) {
    results {
      id
      title
    }
  }
  analyticsV2Experiments(
    startDate: $startDate
    endDate: $endDate
    channels: $campaignChannels
  ) {
    id
    title
  }
  campaignView(startDate: $startDate, endDate: $endDate) {
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useAnalyticsCampaignFiltersQuery__
 *
 * To run a query within a React component, call `useAnalyticsCampaignFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCampaignFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCampaignFiltersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      startEndRange: // value for 'startEndRange'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      creativeChannel: // value for 'creativeChannel'
 *      campaignChannels: // value for 'campaignChannels'
 *   },
 * });
 */
export function useAnalyticsCampaignFiltersQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables> & ({ variables: AnalyticsCampaignFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables>(AnalyticsCampaignFiltersDocument, options);
      }
export function useAnalyticsCampaignFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables>(AnalyticsCampaignFiltersDocument, options);
        }
export function useAnalyticsCampaignFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables>(AnalyticsCampaignFiltersDocument, options);
        }
export type AnalyticsCampaignFiltersQueryHookResult = ReturnType<typeof useAnalyticsCampaignFiltersQuery>;
export type AnalyticsCampaignFiltersLazyQueryHookResult = ReturnType<typeof useAnalyticsCampaignFiltersLazyQuery>;
export type AnalyticsCampaignFiltersSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCampaignFiltersSuspenseQuery>;
export type AnalyticsCampaignFiltersQueryResult = Apollo.QueryResult<AnalyticsCampaignFiltersQuery, AnalyticsCampaignFiltersQueryVariables>;
export const CampaignFilterOptionsDocument = gql`
    query CampaignFilterOptions($page: Int!, $pageSize: Int, $search: SearchUID, $startEndRange: DateRange, $channels: [Channel!]) {
  campaigns(
    page: $page
    pageSize: $pageSize
    search: $search
    startEndRange: $startEndRange
    channels: $channels
  ) {
    page
    total
    results {
      id
      title
    }
  }
}
    `;

/**
 * __useCampaignFilterOptionsQuery__
 *
 * To run a query within a React component, call `useCampaignFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignFilterOptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      startEndRange: // value for 'startEndRange'
 *      channels: // value for 'channels'
 *   },
 * });
 */
export function useCampaignFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables> & ({ variables: CampaignFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables>(CampaignFilterOptionsDocument, options);
      }
export function useCampaignFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables>(CampaignFilterOptionsDocument, options);
        }
export function useCampaignFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables>(CampaignFilterOptionsDocument, options);
        }
export type CampaignFilterOptionsQueryHookResult = ReturnType<typeof useCampaignFilterOptionsQuery>;
export type CampaignFilterOptionsLazyQueryHookResult = ReturnType<typeof useCampaignFilterOptionsLazyQuery>;
export type CampaignFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useCampaignFilterOptionsSuspenseQuery>;
export type CampaignFilterOptionsQueryResult = Apollo.QueryResult<CampaignFilterOptionsQuery, CampaignFilterOptionsQueryVariables>;
export const AnalyticsCampaignComparisonTreatmentV2Document = gql`
    query AnalyticsCampaignComparisonTreatmentV2($baselineTreatmentIds: [ID!], $groupTreatmentIds: [ID!], $campaignFilter: CampaignMetricsFilter!) {
  campaignComparisonByTreatmentV2(
    baselineTreatmentIds: $baselineTreatmentIds
    groupTreatmentIds: $groupTreatmentIds
    filter: $campaignFilter
  ) {
    baselines {
      ...CampaignComparisonBaseFieldsV2
    }
    groups {
      ...CampaignComparisonBaseFieldsV2
    }
    series {
      ...CampaignComparativeSeriesFieldsV2
    }
  }
}
    ${CampaignComparisonBaseFieldsV2FragmentDoc}
${CampaignComparativeSeriesFieldsV2FragmentDoc}`;

/**
 * __useAnalyticsCampaignComparisonTreatmentV2Query__
 *
 * To run a query within a React component, call `useAnalyticsCampaignComparisonTreatmentV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCampaignComparisonTreatmentV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCampaignComparisonTreatmentV2Query({
 *   variables: {
 *      baselineTreatmentIds: // value for 'baselineTreatmentIds'
 *      groupTreatmentIds: // value for 'groupTreatmentIds'
 *      campaignFilter: // value for 'campaignFilter'
 *   },
 * });
 */
export function useAnalyticsCampaignComparisonTreatmentV2Query(baseOptions: Apollo.QueryHookOptions<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables> & ({ variables: AnalyticsCampaignComparisonTreatmentV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables>(AnalyticsCampaignComparisonTreatmentV2Document, options);
      }
export function useAnalyticsCampaignComparisonTreatmentV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables>(AnalyticsCampaignComparisonTreatmentV2Document, options);
        }
export function useAnalyticsCampaignComparisonTreatmentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables>(AnalyticsCampaignComparisonTreatmentV2Document, options);
        }
export type AnalyticsCampaignComparisonTreatmentV2QueryHookResult = ReturnType<typeof useAnalyticsCampaignComparisonTreatmentV2Query>;
export type AnalyticsCampaignComparisonTreatmentV2LazyQueryHookResult = ReturnType<typeof useAnalyticsCampaignComparisonTreatmentV2LazyQuery>;
export type AnalyticsCampaignComparisonTreatmentV2SuspenseQueryHookResult = ReturnType<typeof useAnalyticsCampaignComparisonTreatmentV2SuspenseQuery>;
export type AnalyticsCampaignComparisonTreatmentV2QueryResult = Apollo.QueryResult<AnalyticsCampaignComparisonTreatmentV2Query, AnalyticsCampaignComparisonTreatmentV2QueryVariables>;
export const AnalyticsCampaignComparisonSegmentV2Document = gql`
    query AnalyticsCampaignComparisonSegmentV2($baselineSegmentIds: [ID!]!, $campaignFilter: CampaignMetricsFilter!, $groupSegmentIds: [ID!]!) {
  campaignComparisonBySegmentV2(
    baselineSegmentIds: $baselineSegmentIds
    filter: $campaignFilter
    groupSegmentIds: $groupSegmentIds
  ) {
    baselines {
      ...CampaignComparisonBaseFieldsV2
    }
    groups {
      ...CampaignComparisonBaseFieldsV2
    }
    series {
      ...CampaignComparativeSeriesFieldsV2
    }
  }
}
    ${CampaignComparisonBaseFieldsV2FragmentDoc}
${CampaignComparativeSeriesFieldsV2FragmentDoc}`;

/**
 * __useAnalyticsCampaignComparisonSegmentV2Query__
 *
 * To run a query within a React component, call `useAnalyticsCampaignComparisonSegmentV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCampaignComparisonSegmentV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCampaignComparisonSegmentV2Query({
 *   variables: {
 *      baselineSegmentIds: // value for 'baselineSegmentIds'
 *      campaignFilter: // value for 'campaignFilter'
 *      groupSegmentIds: // value for 'groupSegmentIds'
 *   },
 * });
 */
export function useAnalyticsCampaignComparisonSegmentV2Query(baseOptions: Apollo.QueryHookOptions<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables> & ({ variables: AnalyticsCampaignComparisonSegmentV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables>(AnalyticsCampaignComparisonSegmentV2Document, options);
      }
export function useAnalyticsCampaignComparisonSegmentV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables>(AnalyticsCampaignComparisonSegmentV2Document, options);
        }
export function useAnalyticsCampaignComparisonSegmentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables>(AnalyticsCampaignComparisonSegmentV2Document, options);
        }
export type AnalyticsCampaignComparisonSegmentV2QueryHookResult = ReturnType<typeof useAnalyticsCampaignComparisonSegmentV2Query>;
export type AnalyticsCampaignComparisonSegmentV2LazyQueryHookResult = ReturnType<typeof useAnalyticsCampaignComparisonSegmentV2LazyQuery>;
export type AnalyticsCampaignComparisonSegmentV2SuspenseQueryHookResult = ReturnType<typeof useAnalyticsCampaignComparisonSegmentV2SuspenseQuery>;
export type AnalyticsCampaignComparisonSegmentV2QueryResult = Apollo.QueryResult<AnalyticsCampaignComparisonSegmentV2Query, AnalyticsCampaignComparisonSegmentV2QueryVariables>;
export const CampaignsMetricsDocument = gql`
    query CampaignsMetrics($filter: CampaignFilter!) {
  campaignsMetrics(filter: $filter) {
    campaigns {
      campaign {
        id
        title
        stage
        sendDate
        sendSchedule {
          id
          schedule {
            ... on PersonalizedSendSchedule {
              datetimeRanges
            }
            ... on StaticSendSchedule {
              datetime
            }
          }
        }
        tags {
          id
          name
        }
      }
      metrics {
        ...MetricFields
      }
    }
    summary {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useCampaignsMetricsQuery__
 *
 * To run a query within a React component, call `useCampaignsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCampaignsMetricsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsMetricsQuery, CampaignsMetricsQueryVariables> & ({ variables: CampaignsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsMetricsQuery, CampaignsMetricsQueryVariables>(CampaignsMetricsDocument, options);
      }
export function useCampaignsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsMetricsQuery, CampaignsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsMetricsQuery, CampaignsMetricsQueryVariables>(CampaignsMetricsDocument, options);
        }
export function useCampaignsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsMetricsQuery, CampaignsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsMetricsQuery, CampaignsMetricsQueryVariables>(CampaignsMetricsDocument, options);
        }
export type CampaignsMetricsQueryHookResult = ReturnType<typeof useCampaignsMetricsQuery>;
export type CampaignsMetricsLazyQueryHookResult = ReturnType<typeof useCampaignsMetricsLazyQuery>;
export type CampaignsMetricsSuspenseQueryHookResult = ReturnType<typeof useCampaignsMetricsSuspenseQuery>;
export type CampaignsMetricsQueryResult = Apollo.QueryResult<CampaignsMetricsQuery, CampaignsMetricsQueryVariables>;
export const RecurringCampaignsMetricsV2Document = gql`
    query RecurringCampaignsMetricsV2($filter: RecurringCampaignMetricsV2Filter!) {
  recurringCampaignMetricsV2(filter: $filter) {
    campaigns: recurringCampaigns {
      campaign: recurringCampaign {
        id
        title
        stage
        sendDate: nextOccurrence
        schedule {
          sendTime
          timezone
        }
        tags {
          id
          name
        }
      }
      metrics {
        ...MetricFields
      }
    }
    summary {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useRecurringCampaignsMetricsV2Query__
 *
 * To run a query within a React component, call `useRecurringCampaignsMetricsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignsMetricsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignsMetricsV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRecurringCampaignsMetricsV2Query(baseOptions: Apollo.QueryHookOptions<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables> & ({ variables: RecurringCampaignsMetricsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables>(RecurringCampaignsMetricsV2Document, options);
      }
export function useRecurringCampaignsMetricsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables>(RecurringCampaignsMetricsV2Document, options);
        }
export function useRecurringCampaignsMetricsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables>(RecurringCampaignsMetricsV2Document, options);
        }
export type RecurringCampaignsMetricsV2QueryHookResult = ReturnType<typeof useRecurringCampaignsMetricsV2Query>;
export type RecurringCampaignsMetricsV2LazyQueryHookResult = ReturnType<typeof useRecurringCampaignsMetricsV2LazyQuery>;
export type RecurringCampaignsMetricsV2SuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignsMetricsV2SuspenseQuery>;
export type RecurringCampaignsMetricsV2QueryResult = Apollo.QueryResult<RecurringCampaignsMetricsV2Query, RecurringCampaignsMetricsV2QueryVariables>;
export const CampaignsMetricsExportDocument = gql`
    mutation CampaignsMetricsExport($columns: [String!]!, $filter: CampaignMetricsFilter!, $groupBy: CampaignGroupBy, $includeMetadata: Boolean, $recurringExportId: ID) {
  campaignsMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type CampaignsMetricsExportMutationFn = Apollo.MutationFunction<CampaignsMetricsExportMutation, CampaignsMetricsExportMutationVariables>;

/**
 * __useCampaignsMetricsExportMutation__
 *
 * To run a mutation, you first call `useCampaignsMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignsMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignsMetricsExportMutation, { data, loading, error }] = useCampaignsMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useCampaignsMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignsMetricsExportMutation, CampaignsMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignsMetricsExportMutation, CampaignsMetricsExportMutationVariables>(CampaignsMetricsExportDocument, options);
      }
export type CampaignsMetricsExportMutationHookResult = ReturnType<typeof useCampaignsMetricsExportMutation>;
export type CampaignsMetricsExportMutationResult = Apollo.MutationResult<CampaignsMetricsExportMutation>;
export type CampaignsMetricsExportMutationOptions = Apollo.BaseMutationOptions<CampaignsMetricsExportMutation, CampaignsMetricsExportMutationVariables>;
export const CampaignTreatmentComparisonExportDocument = gql`
    mutation CampaignTreatmentComparisonExport($columns: [String!]!, $filter: TreatmentComparisonFilter!, $includeMetadata: Boolean) {
  campaignTreatmentComparisonExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
  ) {
    signedUrl
  }
}
    `;
export type CampaignTreatmentComparisonExportMutationFn = Apollo.MutationFunction<CampaignTreatmentComparisonExportMutation, CampaignTreatmentComparisonExportMutationVariables>;

/**
 * __useCampaignTreatmentComparisonExportMutation__
 *
 * To run a mutation, you first call `useCampaignTreatmentComparisonExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTreatmentComparisonExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTreatmentComparisonExportMutation, { data, loading, error }] = useCampaignTreatmentComparisonExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *   },
 * });
 */
export function useCampaignTreatmentComparisonExportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTreatmentComparisonExportMutation, CampaignTreatmentComparisonExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTreatmentComparisonExportMutation, CampaignTreatmentComparisonExportMutationVariables>(CampaignTreatmentComparisonExportDocument, options);
      }
export type CampaignTreatmentComparisonExportMutationHookResult = ReturnType<typeof useCampaignTreatmentComparisonExportMutation>;
export type CampaignTreatmentComparisonExportMutationResult = Apollo.MutationResult<CampaignTreatmentComparisonExportMutation>;
export type CampaignTreatmentComparisonExportMutationOptions = Apollo.BaseMutationOptions<CampaignTreatmentComparisonExportMutation, CampaignTreatmentComparisonExportMutationVariables>;
export const CampaignSegmentComparisonExportDocument = gql`
    mutation CampaignSegmentComparisonExport($columns: [String!]!, $filter: SegmentComparisonFilter!, $includeMetadata: Boolean) {
  campaignSegmentComparisonExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
  ) {
    signedUrl
  }
}
    `;
export type CampaignSegmentComparisonExportMutationFn = Apollo.MutationFunction<CampaignSegmentComparisonExportMutation, CampaignSegmentComparisonExportMutationVariables>;

/**
 * __useCampaignSegmentComparisonExportMutation__
 *
 * To run a mutation, you first call `useCampaignSegmentComparisonExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSegmentComparisonExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSegmentComparisonExportMutation, { data, loading, error }] = useCampaignSegmentComparisonExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *   },
 * });
 */
export function useCampaignSegmentComparisonExportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSegmentComparisonExportMutation, CampaignSegmentComparisonExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSegmentComparisonExportMutation, CampaignSegmentComparisonExportMutationVariables>(CampaignSegmentComparisonExportDocument, options);
      }
export type CampaignSegmentComparisonExportMutationHookResult = ReturnType<typeof useCampaignSegmentComparisonExportMutation>;
export type CampaignSegmentComparisonExportMutationResult = Apollo.MutationResult<CampaignSegmentComparisonExportMutation>;
export type CampaignSegmentComparisonExportMutationOptions = Apollo.BaseMutationOptions<CampaignSegmentComparisonExportMutation, CampaignSegmentComparisonExportMutationVariables>;
export const AnalyticsCreativeCampaignsActivityDocument = gql`
    query AnalyticsCreativeCampaignsActivity($creativeId: ID!, $startDate: Date, $endDate: Date) {
  analyticsCreativeCampaignActivity(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
  ) {
    campaign {
      id
      title
      stage
      sendDate
      sendSchedule {
        id
        schedule {
          ... on PersonalizedSendSchedule {
            datetimeRanges
          }
          ... on StaticSendSchedule {
            datetime
          }
        }
      }
      tags {
        id
        name
      }
    }
    activity {
      ...AnalyticsBaseCreativeActivityFields
    }
  }
}
    ${AnalyticsBaseCreativeActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsCreativeCampaignsActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsCreativeCampaignsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeCampaignsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeCampaignsActivityQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAnalyticsCreativeCampaignsActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables> & ({ variables: AnalyticsCreativeCampaignsActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables>(AnalyticsCreativeCampaignsActivityDocument, options);
      }
export function useAnalyticsCreativeCampaignsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables>(AnalyticsCreativeCampaignsActivityDocument, options);
        }
export function useAnalyticsCreativeCampaignsActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables>(AnalyticsCreativeCampaignsActivityDocument, options);
        }
export type AnalyticsCreativeCampaignsActivityQueryHookResult = ReturnType<typeof useAnalyticsCreativeCampaignsActivityQuery>;
export type AnalyticsCreativeCampaignsActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeCampaignsActivityLazyQuery>;
export type AnalyticsCreativeCampaignsActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeCampaignsActivitySuspenseQuery>;
export type AnalyticsCreativeCampaignsActivityQueryResult = Apollo.QueryResult<AnalyticsCreativeCampaignsActivityQuery, AnalyticsCreativeCampaignsActivityQueryVariables>;
export const AnalyticsCreativeContentBlocksDocument = gql`
    query AnalyticsCreativeContentBlocks($creativeId: ID!, $startDate: Date, $endDate: Date) {
  analyticsCreativeContentblockMetrics(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
  ) {
    contentblock {
      id
      title
      images {
        id
        url
      }
    }
    metrics {
      ...BaseCreativeMetricsFields
    }
  }
}
    ${BaseCreativeMetricsFieldsFragmentDoc}`;

/**
 * __useAnalyticsCreativeContentBlocksQuery__
 *
 * To run a query within a React component, call `useAnalyticsCreativeContentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeContentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeContentBlocksQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAnalyticsCreativeContentBlocksQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables> & ({ variables: AnalyticsCreativeContentBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables>(AnalyticsCreativeContentBlocksDocument, options);
      }
export function useAnalyticsCreativeContentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables>(AnalyticsCreativeContentBlocksDocument, options);
        }
export function useAnalyticsCreativeContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables>(AnalyticsCreativeContentBlocksDocument, options);
        }
export type AnalyticsCreativeContentBlocksQueryHookResult = ReturnType<typeof useAnalyticsCreativeContentBlocksQuery>;
export type AnalyticsCreativeContentBlocksLazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeContentBlocksLazyQuery>;
export type AnalyticsCreativeContentBlocksSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeContentBlocksSuspenseQuery>;
export type AnalyticsCreativeContentBlocksQueryResult = Apollo.QueryResult<AnalyticsCreativeContentBlocksQuery, AnalyticsCreativeContentBlocksQueryVariables>;
export const AnalyticsV2CreativeExperimentReportColumnsDocument = gql`
    query AnalyticsV2CreativeExperimentReportColumns {
  analyticsV2CreativeExperimentReportColumns {
    id
    label
    sortable
    visibleByDefault
  }
}
    `;

/**
 * __useAnalyticsV2CreativeExperimentReportColumnsQuery__
 *
 * To run a query within a React component, call `useAnalyticsV2CreativeExperimentReportColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CreativeExperimentReportColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsV2CreativeExperimentReportColumnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsV2CreativeExperimentReportColumnsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>(AnalyticsV2CreativeExperimentReportColumnsDocument, options);
      }
export function useAnalyticsV2CreativeExperimentReportColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>(AnalyticsV2CreativeExperimentReportColumnsDocument, options);
        }
export function useAnalyticsV2CreativeExperimentReportColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>(AnalyticsV2CreativeExperimentReportColumnsDocument, options);
        }
export type AnalyticsV2CreativeExperimentReportColumnsQueryHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentReportColumnsQuery>;
export type AnalyticsV2CreativeExperimentReportColumnsLazyQueryHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentReportColumnsLazyQuery>;
export type AnalyticsV2CreativeExperimentReportColumnsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentReportColumnsSuspenseQuery>;
export type AnalyticsV2CreativeExperimentReportColumnsQueryResult = Apollo.QueryResult<AnalyticsV2CreativeExperimentReportColumnsQuery, AnalyticsV2CreativeExperimentReportColumnsQueryVariables>;
export const AnalyticsV2CreativeExperimentsReportDocument = gql`
    query AnalyticsV2CreativeExperimentsReport($creativeId: ID!, $dateRange: DateRange!) {
  analyticsV2CreativeExperimentsReport(
    creativeId: $creativeId
    dateRange: $dateRange
  ) {
    reportRows {
      row {
        columnId
        value {
          ... on AnalyticsReportValueBoolean {
            boolValue: value
          }
          ... on AnalyticsReportValueString {
            strValue: value
          }
          ... on AnalyticsReportValueInteger {
            intValue: value
          }
          ... on AnalyticsReportValueFloat {
            floatValue: value
          }
          ... on AnalyticsReportValueDate {
            dateValue: value
          }
          ... on AnalyticsReportValueDateTime {
            datetimeValue: value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsV2CreativeExperimentsReportQuery__
 *
 * To run a query within a React component, call `useAnalyticsV2CreativeExperimentsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CreativeExperimentsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsV2CreativeExperimentsReportQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useAnalyticsV2CreativeExperimentsReportQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables> & ({ variables: AnalyticsV2CreativeExperimentsReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables>(AnalyticsV2CreativeExperimentsReportDocument, options);
      }
export function useAnalyticsV2CreativeExperimentsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables>(AnalyticsV2CreativeExperimentsReportDocument, options);
        }
export function useAnalyticsV2CreativeExperimentsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables>(AnalyticsV2CreativeExperimentsReportDocument, options);
        }
export type AnalyticsV2CreativeExperimentsReportQueryHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentsReportQuery>;
export type AnalyticsV2CreativeExperimentsReportLazyQueryHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentsReportLazyQuery>;
export type AnalyticsV2CreativeExperimentsReportSuspenseQueryHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentsReportSuspenseQuery>;
export type AnalyticsV2CreativeExperimentsReportQueryResult = Apollo.QueryResult<AnalyticsV2CreativeExperimentsReportQuery, AnalyticsV2CreativeExperimentsReportQueryVariables>;
export const AnalyticsV2CreativeExperimentExportDocument = gql`
    mutation AnalyticsV2CreativeExperimentExport($creativeId: ID!, $dateRange: DateRange!, $columns: [String!]!) {
  analyticsV2CreativeExperimentExport(
    creativeId: $creativeId
    dateRange: $dateRange
    columns: $columns
  ) {
    signedUrl
  }
}
    `;
export type AnalyticsV2CreativeExperimentExportMutationFn = Apollo.MutationFunction<AnalyticsV2CreativeExperimentExportMutation, AnalyticsV2CreativeExperimentExportMutationVariables>;

/**
 * __useAnalyticsV2CreativeExperimentExportMutation__
 *
 * To run a mutation, you first call `useAnalyticsV2CreativeExperimentExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CreativeExperimentExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsV2CreativeExperimentExportMutation, { data, loading, error }] = useAnalyticsV2CreativeExperimentExportMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      dateRange: // value for 'dateRange'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useAnalyticsV2CreativeExperimentExportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsV2CreativeExperimentExportMutation, AnalyticsV2CreativeExperimentExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsV2CreativeExperimentExportMutation, AnalyticsV2CreativeExperimentExportMutationVariables>(AnalyticsV2CreativeExperimentExportDocument, options);
      }
export type AnalyticsV2CreativeExperimentExportMutationHookResult = ReturnType<typeof useAnalyticsV2CreativeExperimentExportMutation>;
export type AnalyticsV2CreativeExperimentExportMutationResult = Apollo.MutationResult<AnalyticsV2CreativeExperimentExportMutation>;
export type AnalyticsV2CreativeExperimentExportMutationOptions = Apollo.BaseMutationOptions<AnalyticsV2CreativeExperimentExportMutation, AnalyticsV2CreativeExperimentExportMutationVariables>;
export const AnalyticsCreativeActivityDocument = gql`
    query AnalyticsCreativeActivity($creativeId: ID!, $startDate: Date, $endDate: Date) {
  analyticsCreativeActivity(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
  ) {
    creative {
      id
      title
      shortUuid
      createdAt
      status
      bestThumbnail {
        url
      }
      availabilities {
        id
        startDatetime
        endDatetime
      }
      tags {
        id
        name
      }
    }
    activity {
      ...AnalyticsBaseCreativeActivityFields
    }
  }
  analyticsCreativeCampaignActivity(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
  ) {
    campaign {
      id
      sendDate
    }
    activity {
      placements
      uniqueClicks
      uniqueImpressions
      revenue
    }
  }
}
    ${AnalyticsBaseCreativeActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsCreativeActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsCreativeActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeActivityQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAnalyticsCreativeActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables> & ({ variables: AnalyticsCreativeActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables>(AnalyticsCreativeActivityDocument, options);
      }
export function useAnalyticsCreativeActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables>(AnalyticsCreativeActivityDocument, options);
        }
export function useAnalyticsCreativeActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables>(AnalyticsCreativeActivityDocument, options);
        }
export type AnalyticsCreativeActivityQueryHookResult = ReturnType<typeof useAnalyticsCreativeActivityQuery>;
export type AnalyticsCreativeActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeActivityLazyQuery>;
export type AnalyticsCreativeActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeActivitySuspenseQuery>;
export type AnalyticsCreativeActivityQueryResult = Apollo.QueryResult<AnalyticsCreativeActivityQuery, AnalyticsCreativeActivityQueryVariables>;
export const CreativeDetailsSegmentsDocument = gql`
    query CreativeDetailsSegments($creativeId: ID!, $startDate: Date, $endDate: Date) {
  analyticsCreativeSegmentActivity(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
  ) {
    segment {
      id
    }
    activity {
      ...AnalyticsBaseCreativeActivityFields
    }
  }
  contactSegmentGroups {
    id
    archived
    status
    createdAt
    description
    name
    updatedAt
    segments {
      ...ContactSegmentFields
    }
  }
}
    ${AnalyticsBaseCreativeActivityFieldsFragmentDoc}
${ContactSegmentFieldsFragmentDoc}`;

/**
 * __useCreativeDetailsSegmentsQuery__
 *
 * To run a query within a React component, call `useCreativeDetailsSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeDetailsSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeDetailsSegmentsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreativeDetailsSegmentsQuery(baseOptions: Apollo.QueryHookOptions<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables> & ({ variables: CreativeDetailsSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables>(CreativeDetailsSegmentsDocument, options);
      }
export function useCreativeDetailsSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables>(CreativeDetailsSegmentsDocument, options);
        }
export function useCreativeDetailsSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables>(CreativeDetailsSegmentsDocument, options);
        }
export type CreativeDetailsSegmentsQueryHookResult = ReturnType<typeof useCreativeDetailsSegmentsQuery>;
export type CreativeDetailsSegmentsLazyQueryHookResult = ReturnType<typeof useCreativeDetailsSegmentsLazyQuery>;
export type CreativeDetailsSegmentsSuspenseQueryHookResult = ReturnType<typeof useCreativeDetailsSegmentsSuspenseQuery>;
export type CreativeDetailsSegmentsQueryResult = Apollo.QueryResult<CreativeDetailsSegmentsQuery, CreativeDetailsSegmentsQueryVariables>;
export const CreativeDetailsOverviewDocument = gql`
    query CreativeDetailsOverview($creativeId: ID!, $startDate: Date, $endDate: Date) {
  analyticsCreativeActivity(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
  ) {
    creative {
      id
      title
      status
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCreativeDetailsOverviewQuery__
 *
 * To run a query within a React component, call `useCreativeDetailsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeDetailsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeDetailsOverviewQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreativeDetailsOverviewQuery(baseOptions: Apollo.QueryHookOptions<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables> & ({ variables: CreativeDetailsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables>(CreativeDetailsOverviewDocument, options);
      }
export function useCreativeDetailsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables>(CreativeDetailsOverviewDocument, options);
        }
export function useCreativeDetailsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables>(CreativeDetailsOverviewDocument, options);
        }
export type CreativeDetailsOverviewQueryHookResult = ReturnType<typeof useCreativeDetailsOverviewQuery>;
export type CreativeDetailsOverviewLazyQueryHookResult = ReturnType<typeof useCreativeDetailsOverviewLazyQuery>;
export type CreativeDetailsOverviewSuspenseQueryHookResult = ReturnType<typeof useCreativeDetailsOverviewSuspenseQuery>;
export type CreativeDetailsOverviewQueryResult = Apollo.QueryResult<CreativeDetailsOverviewQuery, CreativeDetailsOverviewQueryVariables>;
export const CreativeDetailsSubjectLinesDocument = gql`
    query CreativeDetailsSubjectLines($creativeId: ID!, $startDate: Date, $endDate: Date, $include: [ID!], $exclude: [ID!]) {
  analyticsCreativeSubjectlineActivity(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
    include: $include
    exclude: $exclude
  ) {
    subjectline {
      id
      content
      tone
      source
    }
    activity {
      ...AnalyticsBaseCreativeActivityFields
    }
  }
}
    ${AnalyticsBaseCreativeActivityFieldsFragmentDoc}`;

/**
 * __useCreativeDetailsSubjectLinesQuery__
 *
 * To run a query within a React component, call `useCreativeDetailsSubjectLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeDetailsSubjectLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeDetailsSubjectLinesQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useCreativeDetailsSubjectLinesQuery(baseOptions: Apollo.QueryHookOptions<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables> & ({ variables: CreativeDetailsSubjectLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables>(CreativeDetailsSubjectLinesDocument, options);
      }
export function useCreativeDetailsSubjectLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables>(CreativeDetailsSubjectLinesDocument, options);
        }
export function useCreativeDetailsSubjectLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables>(CreativeDetailsSubjectLinesDocument, options);
        }
export type CreativeDetailsSubjectLinesQueryHookResult = ReturnType<typeof useCreativeDetailsSubjectLinesQuery>;
export type CreativeDetailsSubjectLinesLazyQueryHookResult = ReturnType<typeof useCreativeDetailsSubjectLinesLazyQuery>;
export type CreativeDetailsSubjectLinesSuspenseQueryHookResult = ReturnType<typeof useCreativeDetailsSubjectLinesSuspenseQuery>;
export type CreativeDetailsSubjectLinesQueryResult = Apollo.QueryResult<CreativeDetailsSubjectLinesQuery, CreativeDetailsSubjectLinesQueryVariables>;
export const AnalyticsCreativeComparisonTreatmentDocument = gql`
    query AnalyticsCreativeComparisonTreatment($baselineTreatmentIds: [ID!], $groupTreatmentIds: [ID!], $creativeFilter: ComparisonCreativeFilterInput!) {
  creativeComparisonByTreatment(
    baselineTreatmentIds: $baselineTreatmentIds
    groupTreatmentIds: $groupTreatmentIds
    creativeFilter: $creativeFilter
  ) {
    baselines {
      ...CreativeComparisonBaseFields
    }
    groups {
      ...CreativeComparisonBaseFields
    }
    statistics {
      ...CreativeComparativeStatisticsFields
    }
    series {
      ...CreativeComparativeSeriesFields
    }
  }
}
    ${CreativeComparisonBaseFieldsFragmentDoc}
${CreativeComparativeStatisticsFieldsFragmentDoc}
${CreativeComparativeSeriesFieldsFragmentDoc}`;

/**
 * __useAnalyticsCreativeComparisonTreatmentQuery__
 *
 * To run a query within a React component, call `useAnalyticsCreativeComparisonTreatmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeComparisonTreatmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeComparisonTreatmentQuery({
 *   variables: {
 *      baselineTreatmentIds: // value for 'baselineTreatmentIds'
 *      groupTreatmentIds: // value for 'groupTreatmentIds'
 *      creativeFilter: // value for 'creativeFilter'
 *   },
 * });
 */
export function useAnalyticsCreativeComparisonTreatmentQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables> & ({ variables: AnalyticsCreativeComparisonTreatmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables>(AnalyticsCreativeComparisonTreatmentDocument, options);
      }
export function useAnalyticsCreativeComparisonTreatmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables>(AnalyticsCreativeComparisonTreatmentDocument, options);
        }
export function useAnalyticsCreativeComparisonTreatmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables>(AnalyticsCreativeComparisonTreatmentDocument, options);
        }
export type AnalyticsCreativeComparisonTreatmentQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonTreatmentQuery>;
export type AnalyticsCreativeComparisonTreatmentLazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonTreatmentLazyQuery>;
export type AnalyticsCreativeComparisonTreatmentSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonTreatmentSuspenseQuery>;
export type AnalyticsCreativeComparisonTreatmentQueryResult = Apollo.QueryResult<AnalyticsCreativeComparisonTreatmentQuery, AnalyticsCreativeComparisonTreatmentQueryVariables>;
export const AnalyticsCreativeComparisonSegmentsDocument = gql`
    query AnalyticsCreativeComparisonSegments($baselineSegmentIds: [ID!]!, $creativeFilter: ComparisonCreativeFilterInput!, $groupSegmentIds: [ID!]!) {
  creativeComparisonBySegment(
    baselineSegmentIds: $baselineSegmentIds
    creativeFilter: $creativeFilter
    groupSegmentIds: $groupSegmentIds
  ) {
    baselines {
      ...CreativeComparisonBaseFields
    }
    groups {
      ...CreativeComparisonBaseFields
    }
    statistics {
      ...CreativeComparativeStatisticsFields
    }
    series {
      ...CreativeComparativeSeriesFields
    }
  }
}
    ${CreativeComparisonBaseFieldsFragmentDoc}
${CreativeComparativeStatisticsFieldsFragmentDoc}
${CreativeComparativeSeriesFieldsFragmentDoc}`;

/**
 * __useAnalyticsCreativeComparisonSegmentsQuery__
 *
 * To run a query within a React component, call `useAnalyticsCreativeComparisonSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeComparisonSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeComparisonSegmentsQuery({
 *   variables: {
 *      baselineSegmentIds: // value for 'baselineSegmentIds'
 *      creativeFilter: // value for 'creativeFilter'
 *      groupSegmentIds: // value for 'groupSegmentIds'
 *   },
 * });
 */
export function useAnalyticsCreativeComparisonSegmentsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables> & ({ variables: AnalyticsCreativeComparisonSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables>(AnalyticsCreativeComparisonSegmentsDocument, options);
      }
export function useAnalyticsCreativeComparisonSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables>(AnalyticsCreativeComparisonSegmentsDocument, options);
        }
export function useAnalyticsCreativeComparisonSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables>(AnalyticsCreativeComparisonSegmentsDocument, options);
        }
export type AnalyticsCreativeComparisonSegmentsQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonSegmentsQuery>;
export type AnalyticsCreativeComparisonSegmentsLazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonSegmentsLazyQuery>;
export type AnalyticsCreativeComparisonSegmentsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonSegmentsSuspenseQuery>;
export type AnalyticsCreativeComparisonSegmentsQueryResult = Apollo.QueryResult<AnalyticsCreativeComparisonSegmentsQuery, AnalyticsCreativeComparisonSegmentsQueryVariables>;
export const ReportingCreativeCampaignsMetricsDocument = gql`
    query ReportingCreativeCampaignsMetrics($creativeId: ID!, $startDate: Date, $endDate: Date, $filter: CreativeDetailMetricsFilter) {
  creativeCampaignsMetrics(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    campaign {
      id
      title
      stage
      sendDate
      sendSchedule {
        id
        schedule {
          ... on PersonalizedSendSchedule {
            datetimeRanges
          }
          ... on StaticSendSchedule {
            datetime
          }
        }
      }
      tags {
        id
        name
      }
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCreativeCampaignsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCreativeCampaignsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCreativeCampaignsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCreativeCampaignsMetricsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCreativeCampaignsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables> & ({ variables: ReportingCreativeCampaignsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables>(ReportingCreativeCampaignsMetricsDocument, options);
      }
export function useReportingCreativeCampaignsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables>(ReportingCreativeCampaignsMetricsDocument, options);
        }
export function useReportingCreativeCampaignsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables>(ReportingCreativeCampaignsMetricsDocument, options);
        }
export type ReportingCreativeCampaignsMetricsQueryHookResult = ReturnType<typeof useReportingCreativeCampaignsMetricsQuery>;
export type ReportingCreativeCampaignsMetricsLazyQueryHookResult = ReturnType<typeof useReportingCreativeCampaignsMetricsLazyQuery>;
export type ReportingCreativeCampaignsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCreativeCampaignsMetricsSuspenseQuery>;
export type ReportingCreativeCampaignsMetricsQueryResult = Apollo.QueryResult<ReportingCreativeCampaignsMetricsQuery, ReportingCreativeCampaignsMetricsQueryVariables>;
export const ReportingCreativeContentBlocksDocument = gql`
    query ReportingCreativeContentBlocks($creativeId: ID!, $startDate: Date, $endDate: Date, $filter: CreativeDetailMetricsFilter) {
  creativeContentblocksMetrics(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    contentblock {
      id
      title
      images {
        id
        url
      }
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCreativeContentBlocksQuery__
 *
 * To run a query within a React component, call `useReportingCreativeContentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCreativeContentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCreativeContentBlocksQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCreativeContentBlocksQuery(baseOptions: Apollo.QueryHookOptions<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables> & ({ variables: ReportingCreativeContentBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables>(ReportingCreativeContentBlocksDocument, options);
      }
export function useReportingCreativeContentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables>(ReportingCreativeContentBlocksDocument, options);
        }
export function useReportingCreativeContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables>(ReportingCreativeContentBlocksDocument, options);
        }
export type ReportingCreativeContentBlocksQueryHookResult = ReturnType<typeof useReportingCreativeContentBlocksQuery>;
export type ReportingCreativeContentBlocksLazyQueryHookResult = ReturnType<typeof useReportingCreativeContentBlocksLazyQuery>;
export type ReportingCreativeContentBlocksSuspenseQueryHookResult = ReturnType<typeof useReportingCreativeContentBlocksSuspenseQuery>;
export type ReportingCreativeContentBlocksQueryResult = Apollo.QueryResult<ReportingCreativeContentBlocksQuery, ReportingCreativeContentBlocksQueryVariables>;
export const ReportingCreativeExperimentsMetricsDocument = gql`
    query ReportingCreativeExperimentsMetrics($creativeId: ID!, $startDate: Date, $endDate: Date, $filter: CreativeDetailMetricsFilter) {
  creativeExperimentsMetrics(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    experiment {
      id
      title
      status
      minDate
      maxDate
      configurationRestrictedToStaff
      treatments {
        id
        title
        control
        order
      }
    }
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useReportingCreativeExperimentsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCreativeExperimentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCreativeExperimentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCreativeExperimentsMetricsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCreativeExperimentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables> & ({ variables: ReportingCreativeExperimentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables>(ReportingCreativeExperimentsMetricsDocument, options);
      }
export function useReportingCreativeExperimentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables>(ReportingCreativeExperimentsMetricsDocument, options);
        }
export function useReportingCreativeExperimentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables>(ReportingCreativeExperimentsMetricsDocument, options);
        }
export type ReportingCreativeExperimentsMetricsQueryHookResult = ReturnType<typeof useReportingCreativeExperimentsMetricsQuery>;
export type ReportingCreativeExperimentsMetricsLazyQueryHookResult = ReturnType<typeof useReportingCreativeExperimentsMetricsLazyQuery>;
export type ReportingCreativeExperimentsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCreativeExperimentsMetricsSuspenseQuery>;
export type ReportingCreativeExperimentsMetricsQueryResult = Apollo.QueryResult<ReportingCreativeExperimentsMetricsQuery, ReportingCreativeExperimentsMetricsQueryVariables>;
export const CreativeHeaderIdentityDocument = gql`
    query CreativeHeaderIdentity($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    title
    status
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useCreativeHeaderIdentityQuery__
 *
 * To run a query within a React component, call `useCreativeHeaderIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeHeaderIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeHeaderIdentityQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeHeaderIdentityQuery(baseOptions: Apollo.QueryHookOptions<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables> & ({ variables: CreativeHeaderIdentityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables>(CreativeHeaderIdentityDocument, options);
      }
export function useCreativeHeaderIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables>(CreativeHeaderIdentityDocument, options);
        }
export function useCreativeHeaderIdentitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables>(CreativeHeaderIdentityDocument, options);
        }
export type CreativeHeaderIdentityQueryHookResult = ReturnType<typeof useCreativeHeaderIdentityQuery>;
export type CreativeHeaderIdentityLazyQueryHookResult = ReturnType<typeof useCreativeHeaderIdentityLazyQuery>;
export type CreativeHeaderIdentitySuspenseQueryHookResult = ReturnType<typeof useCreativeHeaderIdentitySuspenseQuery>;
export type CreativeHeaderIdentityQueryResult = Apollo.QueryResult<CreativeHeaderIdentityQuery, CreativeHeaderIdentityQueryVariables>;
export const ReportingCreativeSegmentsMetricsDocument = gql`
    query ReportingCreativeSegmentsMetrics($creativeId: ID!, $startDate: Date, $endDate: Date, $filter: CreativeDetailMetricsFilter) {
  creativeSegmentsMetrics(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    audience {
      id
      name
      description
      updatedAt
    }
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCreativeSegmentsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingCreativeSegmentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCreativeSegmentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCreativeSegmentsMetricsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCreativeSegmentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables> & ({ variables: ReportingCreativeSegmentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables>(ReportingCreativeSegmentsMetricsDocument, options);
      }
export function useReportingCreativeSegmentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables>(ReportingCreativeSegmentsMetricsDocument, options);
        }
export function useReportingCreativeSegmentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables>(ReportingCreativeSegmentsMetricsDocument, options);
        }
export type ReportingCreativeSegmentsMetricsQueryHookResult = ReturnType<typeof useReportingCreativeSegmentsMetricsQuery>;
export type ReportingCreativeSegmentsMetricsLazyQueryHookResult = ReturnType<typeof useReportingCreativeSegmentsMetricsLazyQuery>;
export type ReportingCreativeSegmentsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingCreativeSegmentsMetricsSuspenseQuery>;
export type ReportingCreativeSegmentsMetricsQueryResult = Apollo.QueryResult<ReportingCreativeSegmentsMetricsQuery, ReportingCreativeSegmentsMetricsQueryVariables>;
export const ReportingCreativeDetailsSubjectLinesDocument = gql`
    query ReportingCreativeDetailsSubjectLines($creativeId: ID!, $startDate: Date, $endDate: Date, $filter: CreativeDetailMetricsFilter) {
  creativeSubjectlinesMetrics(
    creativeId: $creativeId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    subjectline {
      id
      content
      tone
      source
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingCreativeDetailsSubjectLinesQuery__
 *
 * To run a query within a React component, call `useReportingCreativeDetailsSubjectLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingCreativeDetailsSubjectLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingCreativeDetailsSubjectLinesQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingCreativeDetailsSubjectLinesQuery(baseOptions: Apollo.QueryHookOptions<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables> & ({ variables: ReportingCreativeDetailsSubjectLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables>(ReportingCreativeDetailsSubjectLinesDocument, options);
      }
export function useReportingCreativeDetailsSubjectLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables>(ReportingCreativeDetailsSubjectLinesDocument, options);
        }
export function useReportingCreativeDetailsSubjectLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables>(ReportingCreativeDetailsSubjectLinesDocument, options);
        }
export type ReportingCreativeDetailsSubjectLinesQueryHookResult = ReturnType<typeof useReportingCreativeDetailsSubjectLinesQuery>;
export type ReportingCreativeDetailsSubjectLinesLazyQueryHookResult = ReturnType<typeof useReportingCreativeDetailsSubjectLinesLazyQuery>;
export type ReportingCreativeDetailsSubjectLinesSuspenseQueryHookResult = ReturnType<typeof useReportingCreativeDetailsSubjectLinesSuspenseQuery>;
export type ReportingCreativeDetailsSubjectLinesQueryResult = Apollo.QueryResult<ReportingCreativeDetailsSubjectLinesQuery, ReportingCreativeDetailsSubjectLinesQueryVariables>;
export const AnalyticsV2CreativesMetricsGroupedByTagDocument = gql`
    query AnalyticsV2CreativesMetricsGroupedByTag($campaignIdsOrTitles: [String!], $campaignStages: [CampaignStageType!], $creativeIdsOrTitles: [String!], $creativeStatuses: [CreativeStatus!], $excludeCampaignTagIds: [ID!], $excludeCreativeTagIds: [ID!], $includeCampaignTagIds: [ID!], $includeCreativeTagIds: [ID!], $startDate: Date, $endDate: Date, $isPrimary: Boolean, $groupBy: CreativeGroupBy) {
  analyticsV2CreativesMetricsGroupedByTag(
    campaignIdsOrTitles: $campaignIdsOrTitles
    campaignStages: $campaignStages
    creativeIdsOrTitles: $creativeIdsOrTitles
    creativeStatuses: $creativeStatuses
    endDate: $endDate
    excludeCampaignTagIds: $excludeCampaignTagIds
    excludeCreativeTagIds: $excludeCreativeTagIds
    includeCampaignTagIds: $includeCampaignTagIds
    includeCreativeTagIds: $includeCreativeTagIds
    startDate: $startDate
    isPrimary: $isPrimary
    groupBy: $groupBy
  ) {
    group
    metrics {
      autoImpressionRate
      autoImpressions
      averageOrderValue
      uniqueClickRate: clickRate
      uniqueClickthroughRate: clickToImpressionRate
      clicks
      conversionRate
      uniqueConversionToClickRate: conversionToClickRate
      conversions
      uniqueImpressionRate: impressionRate
      impressions
      placements
      revenue
      revenuePerPlacement
      revenuePerThousandPlacements
      uniqueAutoImpressions
      uniqueClicks
      uniqueConversions
      uniqueImpressions
    }
    scores {
      creativeId
      effectiveness
      openEffectiveness
      clickEffectiveness
      conversionEffectiveness
      percentPositiveReaction
    }
    creatives {
      creative {
        id
        title
        status
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
      }
      metrics {
        placements
        autoImpressions
        uniqueAutoImpressions
        autoImpressionRate
        impressions
        uniqueImpressions
        uniqueImpressionRate: impressionRate
        clicks
        uniqueClicks
        uniqueClickRate: clickRate
        uniqueClickthroughRate: clickToImpressionRate
        conversions
        uniqueConversions
        conversionRate
        uniqueConversionToClickRate: conversionToClickRate
        revenue
        revenuePerPlacement
        revenuePerThousandPlacements
        averageOrderValue
      }
      scores {
        creativeId
        effectiveness
        openEffectiveness
        clickEffectiveness
        conversionEffectiveness
        percentPositiveReaction
      }
    }
    creativeCount
    creativeUsageRatio
  }
}
    `;

/**
 * __useAnalyticsV2CreativesMetricsGroupedByTagQuery__
 *
 * To run a query within a React component, call `useAnalyticsV2CreativesMetricsGroupedByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CreativesMetricsGroupedByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsV2CreativesMetricsGroupedByTagQuery({
 *   variables: {
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      campaignStages: // value for 'campaignStages'
 *      creativeIdsOrTitles: // value for 'creativeIdsOrTitles'
 *      creativeStatuses: // value for 'creativeStatuses'
 *      excludeCampaignTagIds: // value for 'excludeCampaignTagIds'
 *      excludeCreativeTagIds: // value for 'excludeCreativeTagIds'
 *      includeCampaignTagIds: // value for 'includeCampaignTagIds'
 *      includeCreativeTagIds: // value for 'includeCreativeTagIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isPrimary: // value for 'isPrimary'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useAnalyticsV2CreativesMetricsGroupedByTagQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>(AnalyticsV2CreativesMetricsGroupedByTagDocument, options);
      }
export function useAnalyticsV2CreativesMetricsGroupedByTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>(AnalyticsV2CreativesMetricsGroupedByTagDocument, options);
        }
export function useAnalyticsV2CreativesMetricsGroupedByTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>(AnalyticsV2CreativesMetricsGroupedByTagDocument, options);
        }
export type AnalyticsV2CreativesMetricsGroupedByTagQueryHookResult = ReturnType<typeof useAnalyticsV2CreativesMetricsGroupedByTagQuery>;
export type AnalyticsV2CreativesMetricsGroupedByTagLazyQueryHookResult = ReturnType<typeof useAnalyticsV2CreativesMetricsGroupedByTagLazyQuery>;
export type AnalyticsV2CreativesMetricsGroupedByTagSuspenseQueryHookResult = ReturnType<typeof useAnalyticsV2CreativesMetricsGroupedByTagSuspenseQuery>;
export type AnalyticsV2CreativesMetricsGroupedByTagQueryResult = Apollo.QueryResult<AnalyticsV2CreativesMetricsGroupedByTagQuery, AnalyticsV2CreativesMetricsGroupedByTagQueryVariables>;
export const AnalyticsV2CreativeExportDocument = gql`
    mutation AnalyticsV2CreativeExport($columns: [String!]!, $dateRange: DateRange!, $filters: [AnalyticsFilterInput!]!, $groupBy: CreativeGroupBy, $isPrimary: Boolean) {
  analyticsV2CreativeExport(
    columns: $columns
    dateRange: $dateRange
    filters: $filters
    groupBy: $groupBy
    isPrimary: $isPrimary
  ) {
    signedUrl
  }
}
    `;
export type AnalyticsV2CreativeExportMutationFn = Apollo.MutationFunction<AnalyticsV2CreativeExportMutation, AnalyticsV2CreativeExportMutationVariables>;

/**
 * __useAnalyticsV2CreativeExportMutation__
 *
 * To run a mutation, you first call `useAnalyticsV2CreativeExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CreativeExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsV2CreativeExportMutation, { data, loading, error }] = useAnalyticsV2CreativeExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      groupBy: // value for 'groupBy'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useAnalyticsV2CreativeExportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsV2CreativeExportMutation, AnalyticsV2CreativeExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsV2CreativeExportMutation, AnalyticsV2CreativeExportMutationVariables>(AnalyticsV2CreativeExportDocument, options);
      }
export type AnalyticsV2CreativeExportMutationHookResult = ReturnType<typeof useAnalyticsV2CreativeExportMutation>;
export type AnalyticsV2CreativeExportMutationResult = Apollo.MutationResult<AnalyticsV2CreativeExportMutation>;
export type AnalyticsV2CreativeExportMutationOptions = Apollo.BaseMutationOptions<AnalyticsV2CreativeExportMutation, AnalyticsV2CreativeExportMutationVariables>;
export const AnalyticsCreativeFiltersDocument = gql`
    query AnalyticsCreativeFilters($page: Int!, $pageSize: Int, $startEndRange: DateRange, $startDate: Date, $endDate: Date, $creativeChannel: Channel, $campaignChannels: [Channel!], $recurringCampaignFilter: RecurringCampaignFilterInput, $includeRecurringCampaigns: Boolean!) {
  analyticsV2Creatives(
    filter: {startDate: $startDate, endDate: $endDate, channel: $creativeChannel}
  ) {
    id
    title
    tags {
      id
      name
    }
  }
  campaigns(
    page: $page
    pageSize: $pageSize
    startEndRange: $startEndRange
    channels: $campaignChannels
  ) {
    results {
      id
      title
      stage
    }
  }
  recurringCampaigns(first: $pageSize, filter: $recurringCampaignFilter) @include(if: $includeRecurringCampaigns) {
    edges {
      node {
        id
        title
      }
    }
  }
  analyticsV2Experiments(
    startDate: $startDate
    endDate: $endDate
    channels: $campaignChannels
  ) {
    id
    title
  }
  campaignView(startDate: $startDate, endDate: $endDate) {
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useAnalyticsCreativeFiltersQuery__
 *
 * To run a query within a React component, call `useAnalyticsCreativeFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeFiltersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      startEndRange: // value for 'startEndRange'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      creativeChannel: // value for 'creativeChannel'
 *      campaignChannels: // value for 'campaignChannels'
 *      recurringCampaignFilter: // value for 'recurringCampaignFilter'
 *      includeRecurringCampaigns: // value for 'includeRecurringCampaigns'
 *   },
 * });
 */
export function useAnalyticsCreativeFiltersQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables> & ({ variables: AnalyticsCreativeFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables>(AnalyticsCreativeFiltersDocument, options);
      }
export function useAnalyticsCreativeFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables>(AnalyticsCreativeFiltersDocument, options);
        }
export function useAnalyticsCreativeFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables>(AnalyticsCreativeFiltersDocument, options);
        }
export type AnalyticsCreativeFiltersQueryHookResult = ReturnType<typeof useAnalyticsCreativeFiltersQuery>;
export type AnalyticsCreativeFiltersLazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeFiltersLazyQuery>;
export type AnalyticsCreativeFiltersSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeFiltersSuspenseQuery>;
export type AnalyticsCreativeFiltersQueryResult = Apollo.QueryResult<AnalyticsCreativeFiltersQuery, AnalyticsCreativeFiltersQueryVariables>;
export const AnalyticsCreativeComparisonTreatmentV2Document = gql`
    query AnalyticsCreativeComparisonTreatmentV2($baselineTreatmentIds: [ID!], $groupTreatmentIds: [ID!], $creativeFilter: CreativeMetricsFilter!) {
  creativeComparisonByTreatmentV2(
    baselineTreatmentIds: $baselineTreatmentIds
    groupTreatmentIds: $groupTreatmentIds
    filter: $creativeFilter
  ) {
    baselines {
      ... on CountMetric {
        id
        name
        count
      }
      ... on RateMetric {
        id
        name
        rate
        stats {
          lift
          ciUpper
          ciLower
          confidence
          significant
        }
      }
      ... on CurrencyMetric {
        id
        name
        currency
        stats {
          diff
          ciUpper
          ciLower
          confidence
          significant
        }
      }
      ... on CurrencyRateMetric {
        id
        name
        currencyRate
        stats {
          lift
          ciUpper
          ciLower
          confidence
          significant
        }
      }
      ... on CategoryMetric {
        id
        name
        category
      }
      ... on FractionalCountMetric {
        id
        name
        fractionalCount
      }
    }
    groups {
      ... on CountMetric {
        id
        name
        count
      }
      ... on RateMetric {
        id
        name
        rate
        stats {
          lift
          ciUpper
          ciLower
          confidence
          significant
        }
      }
      ... on CurrencyMetric {
        id
        name
        currency
        stats {
          diff
          ciUpper
          ciLower
          confidence
          significant
        }
      }
      ... on CurrencyRateMetric {
        id
        name
        currencyRate
        stats {
          lift
          ciUpper
          ciLower
          confidence
          significant
        }
      }
      ... on CategoryMetric {
        id
        name
        category
      }
      ... on FractionalCountMetric {
        id
        name
        fractionalCount
      }
    }
    series {
      ...CreativeComparativeSeriesFieldsV2
    }
  }
}
    ${CreativeComparativeSeriesFieldsV2FragmentDoc}`;

/**
 * __useAnalyticsCreativeComparisonTreatmentV2Query__
 *
 * To run a query within a React component, call `useAnalyticsCreativeComparisonTreatmentV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeComparisonTreatmentV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeComparisonTreatmentV2Query({
 *   variables: {
 *      baselineTreatmentIds: // value for 'baselineTreatmentIds'
 *      groupTreatmentIds: // value for 'groupTreatmentIds'
 *      creativeFilter: // value for 'creativeFilter'
 *   },
 * });
 */
export function useAnalyticsCreativeComparisonTreatmentV2Query(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables> & ({ variables: AnalyticsCreativeComparisonTreatmentV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables>(AnalyticsCreativeComparisonTreatmentV2Document, options);
      }
export function useAnalyticsCreativeComparisonTreatmentV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables>(AnalyticsCreativeComparisonTreatmentV2Document, options);
        }
export function useAnalyticsCreativeComparisonTreatmentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables>(AnalyticsCreativeComparisonTreatmentV2Document, options);
        }
export type AnalyticsCreativeComparisonTreatmentV2QueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonTreatmentV2Query>;
export type AnalyticsCreativeComparisonTreatmentV2LazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonTreatmentV2LazyQuery>;
export type AnalyticsCreativeComparisonTreatmentV2SuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonTreatmentV2SuspenseQuery>;
export type AnalyticsCreativeComparisonTreatmentV2QueryResult = Apollo.QueryResult<AnalyticsCreativeComparisonTreatmentV2Query, AnalyticsCreativeComparisonTreatmentV2QueryVariables>;
export const AnalyticsCreativeComparisonSegmentsV2Document = gql`
    query AnalyticsCreativeComparisonSegmentsV2($baselineSegmentIds: [ID!]!, $creativeFilter: CreativeMetricsFilter!, $groupSegmentIds: [ID!]!) {
  creativeComparisonBySegmentV2(
    baselineSegmentIds: $baselineSegmentIds
    filter: $creativeFilter
    groupSegmentIds: $groupSegmentIds
  ) {
    baselines {
      ...CreativeComparisonBaseFieldsV2
    }
    groups {
      ...CreativeComparisonBaseFieldsV2
    }
    series {
      ...CreativeComparativeSeriesFieldsV2
    }
  }
}
    ${CreativeComparisonBaseFieldsV2FragmentDoc}
${CreativeComparativeSeriesFieldsV2FragmentDoc}`;

/**
 * __useAnalyticsCreativeComparisonSegmentsV2Query__
 *
 * To run a query within a React component, call `useAnalyticsCreativeComparisonSegmentsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativeComparisonSegmentsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativeComparisonSegmentsV2Query({
 *   variables: {
 *      baselineSegmentIds: // value for 'baselineSegmentIds'
 *      creativeFilter: // value for 'creativeFilter'
 *      groupSegmentIds: // value for 'groupSegmentIds'
 *   },
 * });
 */
export function useAnalyticsCreativeComparisonSegmentsV2Query(baseOptions: Apollo.QueryHookOptions<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables> & ({ variables: AnalyticsCreativeComparisonSegmentsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables>(AnalyticsCreativeComparisonSegmentsV2Document, options);
      }
export function useAnalyticsCreativeComparisonSegmentsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables>(AnalyticsCreativeComparisonSegmentsV2Document, options);
        }
export function useAnalyticsCreativeComparisonSegmentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables>(AnalyticsCreativeComparisonSegmentsV2Document, options);
        }
export type AnalyticsCreativeComparisonSegmentsV2QueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonSegmentsV2Query>;
export type AnalyticsCreativeComparisonSegmentsV2LazyQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonSegmentsV2LazyQuery>;
export type AnalyticsCreativeComparisonSegmentsV2SuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativeComparisonSegmentsV2SuspenseQuery>;
export type AnalyticsCreativeComparisonSegmentsV2QueryResult = Apollo.QueryResult<AnalyticsCreativeComparisonSegmentsV2Query, AnalyticsCreativeComparisonSegmentsV2QueryVariables>;
export const CreativeMetricsDocument = gql`
    query CreativeMetrics($filter: CreativeMetricsFilter!, $startDate: Date!, $endDate: Date!) {
  creativesMetrics(filter: $filter) {
    creatives {
      creative {
        id
        title
        status
        createdAt
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
        minStartDate
        maxEndDate
        daysAvailable(startDate: $startDate, endDate: $endDate)
        ...creativeContentsFields
      }
      metrics {
        ...MetricFields
      }
    }
    summary {
      ...MetricFields
    }
  }
}
    ${CreativeContentsFieldsFragmentDoc}
${MetricFieldsFragmentDoc}`;

/**
 * __useCreativeMetricsQuery__
 *
 * To run a query within a React component, call `useCreativeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreativeMetricsQuery(baseOptions: Apollo.QueryHookOptions<CreativeMetricsQuery, CreativeMetricsQueryVariables> & ({ variables: CreativeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeMetricsQuery, CreativeMetricsQueryVariables>(CreativeMetricsDocument, options);
      }
export function useCreativeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeMetricsQuery, CreativeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeMetricsQuery, CreativeMetricsQueryVariables>(CreativeMetricsDocument, options);
        }
export function useCreativeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativeMetricsQuery, CreativeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativeMetricsQuery, CreativeMetricsQueryVariables>(CreativeMetricsDocument, options);
        }
export type CreativeMetricsQueryHookResult = ReturnType<typeof useCreativeMetricsQuery>;
export type CreativeMetricsLazyQueryHookResult = ReturnType<typeof useCreativeMetricsLazyQuery>;
export type CreativeMetricsSuspenseQueryHookResult = ReturnType<typeof useCreativeMetricsSuspenseQuery>;
export type CreativeMetricsQueryResult = Apollo.QueryResult<CreativeMetricsQuery, CreativeMetricsQueryVariables>;
export const CreativeTreatmentComparisonExportDocument = gql`
    mutation CreativeTreatmentComparisonExport($columns: [String!]!, $filter: TreatmentComparisonFilter!, $includeMetadata: Boolean) {
  creativeTreatmentComparisonExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
  ) {
    signedUrl
  }
}
    `;
export type CreativeTreatmentComparisonExportMutationFn = Apollo.MutationFunction<CreativeTreatmentComparisonExportMutation, CreativeTreatmentComparisonExportMutationVariables>;

/**
 * __useCreativeTreatmentComparisonExportMutation__
 *
 * To run a mutation, you first call `useCreativeTreatmentComparisonExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeTreatmentComparisonExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeTreatmentComparisonExportMutation, { data, loading, error }] = useCreativeTreatmentComparisonExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *   },
 * });
 */
export function useCreativeTreatmentComparisonExportMutation(baseOptions?: Apollo.MutationHookOptions<CreativeTreatmentComparisonExportMutation, CreativeTreatmentComparisonExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeTreatmentComparisonExportMutation, CreativeTreatmentComparisonExportMutationVariables>(CreativeTreatmentComparisonExportDocument, options);
      }
export type CreativeTreatmentComparisonExportMutationHookResult = ReturnType<typeof useCreativeTreatmentComparisonExportMutation>;
export type CreativeTreatmentComparisonExportMutationResult = Apollo.MutationResult<CreativeTreatmentComparisonExportMutation>;
export type CreativeTreatmentComparisonExportMutationOptions = Apollo.BaseMutationOptions<CreativeTreatmentComparisonExportMutation, CreativeTreatmentComparisonExportMutationVariables>;
export const CreativeSegmentComparisonExportDocument = gql`
    mutation CreativeSegmentComparisonExport($columns: [String!]!, $filter: SegmentComparisonFilter!, $includeMetadata: Boolean) {
  creativeSegmentComparisonExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
  ) {
    signedUrl
  }
}
    `;
export type CreativeSegmentComparisonExportMutationFn = Apollo.MutationFunction<CreativeSegmentComparisonExportMutation, CreativeSegmentComparisonExportMutationVariables>;

/**
 * __useCreativeSegmentComparisonExportMutation__
 *
 * To run a mutation, you first call `useCreativeSegmentComparisonExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSegmentComparisonExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSegmentComparisonExportMutation, { data, loading, error }] = useCreativeSegmentComparisonExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *   },
 * });
 */
export function useCreativeSegmentComparisonExportMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSegmentComparisonExportMutation, CreativeSegmentComparisonExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSegmentComparisonExportMutation, CreativeSegmentComparisonExportMutationVariables>(CreativeSegmentComparisonExportDocument, options);
      }
export type CreativeSegmentComparisonExportMutationHookResult = ReturnType<typeof useCreativeSegmentComparisonExportMutation>;
export type CreativeSegmentComparisonExportMutationResult = Apollo.MutationResult<CreativeSegmentComparisonExportMutation>;
export type CreativeSegmentComparisonExportMutationOptions = Apollo.BaseMutationOptions<CreativeSegmentComparisonExportMutation, CreativeSegmentComparisonExportMutationVariables>;
export const CreativesMetricsExportDocument = gql`
    mutation CreativesMetricsExport($columns: [String!]!, $filter: CreativeMetricsFilter!, $groupBy: CreativeGroupBy, $includeMetadata: Boolean, $recurringExportId: ID) {
  creativesMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type CreativesMetricsExportMutationFn = Apollo.MutationFunction<CreativesMetricsExportMutation, CreativesMetricsExportMutationVariables>;

/**
 * __useCreativesMetricsExportMutation__
 *
 * To run a mutation, you first call `useCreativesMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativesMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativesMetricsExportMutation, { data, loading, error }] = useCreativesMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useCreativesMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<CreativesMetricsExportMutation, CreativesMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativesMetricsExportMutation, CreativesMetricsExportMutationVariables>(CreativesMetricsExportDocument, options);
      }
export type CreativesMetricsExportMutationHookResult = ReturnType<typeof useCreativesMetricsExportMutation>;
export type CreativesMetricsExportMutationResult = Apollo.MutationResult<CreativesMetricsExportMutation>;
export type CreativesMetricsExportMutationOptions = Apollo.BaseMutationOptions<CreativesMetricsExportMutation, CreativesMetricsExportMutationVariables>;
export const CreativesMultiGroupedMetricsExportDocument = gql`
    mutation CreativesMultiGroupedMetricsExport($columns: [String!], $filter: CreativeMetricsFilter!, $groupBy: [CreativeGroupBy!]!, $includeMetadata: Boolean, $recurringExportId: ID) {
  creativesMultiGroupedMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type CreativesMultiGroupedMetricsExportMutationFn = Apollo.MutationFunction<CreativesMultiGroupedMetricsExportMutation, CreativesMultiGroupedMetricsExportMutationVariables>;

/**
 * __useCreativesMultiGroupedMetricsExportMutation__
 *
 * To run a mutation, you first call `useCreativesMultiGroupedMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativesMultiGroupedMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativesMultiGroupedMetricsExportMutation, { data, loading, error }] = useCreativesMultiGroupedMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useCreativesMultiGroupedMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<CreativesMultiGroupedMetricsExportMutation, CreativesMultiGroupedMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativesMultiGroupedMetricsExportMutation, CreativesMultiGroupedMetricsExportMutationVariables>(CreativesMultiGroupedMetricsExportDocument, options);
      }
export type CreativesMultiGroupedMetricsExportMutationHookResult = ReturnType<typeof useCreativesMultiGroupedMetricsExportMutation>;
export type CreativesMultiGroupedMetricsExportMutationResult = Apollo.MutationResult<CreativesMultiGroupedMetricsExportMutation>;
export type CreativesMultiGroupedMetricsExportMutationOptions = Apollo.BaseMutationOptions<CreativesMultiGroupedMetricsExportMutation, CreativesMultiGroupedMetricsExportMutationVariables>;
export const GroupedCreativeMetricsDocument = gql`
    query GroupedCreativeMetrics($filter: CreativeMetricsFilter!, $groupBy: CreativeGroupBy, $startDate: Date!, $endDate: Date!) {
  groupedCreativesMetrics(filter: $filter, groupBy: $groupBy) {
    group
    creatives {
      creative {
        id
        title
        status
        createdAt
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
        minStartDate
        maxEndDate
        daysAvailable(startDate: $startDate, endDate: $endDate)
        ...creativeContentsFields
      }
      metrics {
        ...MetricFields
      }
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${CreativeContentsFieldsFragmentDoc}
${MetricFieldsFragmentDoc}`;

/**
 * __useGroupedCreativeMetricsQuery__
 *
 * To run a query within a React component, call `useGroupedCreativeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedCreativeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedCreativeMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGroupedCreativeMetricsQuery(baseOptions: Apollo.QueryHookOptions<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables> & ({ variables: GroupedCreativeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables>(GroupedCreativeMetricsDocument, options);
      }
export function useGroupedCreativeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables>(GroupedCreativeMetricsDocument, options);
        }
export function useGroupedCreativeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables>(GroupedCreativeMetricsDocument, options);
        }
export type GroupedCreativeMetricsQueryHookResult = ReturnType<typeof useGroupedCreativeMetricsQuery>;
export type GroupedCreativeMetricsLazyQueryHookResult = ReturnType<typeof useGroupedCreativeMetricsLazyQuery>;
export type GroupedCreativeMetricsSuspenseQueryHookResult = ReturnType<typeof useGroupedCreativeMetricsSuspenseQuery>;
export type GroupedCreativeMetricsQueryResult = Apollo.QueryResult<GroupedCreativeMetricsQuery, GroupedCreativeMetricsQueryVariables>;
export const MultiGroupedCreativesMetricsDocument = gql`
    query MultiGroupedCreativesMetrics($filter: CreativeMetricsFilter!, $groupBy: [CreativeGroupBy!]!) {
  multiGroupedCreativesMetrics(filter: $filter, groupBy: $groupBy) {
    groups {
      dimension
      value
    }
    creatives {
      creative {
        id
      }
    }
    metrics {
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useMultiGroupedCreativesMetricsQuery__
 *
 * To run a query within a React component, call `useMultiGroupedCreativesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiGroupedCreativesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiGroupedCreativesMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useMultiGroupedCreativesMetricsQuery(baseOptions: Apollo.QueryHookOptions<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables> & ({ variables: MultiGroupedCreativesMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables>(MultiGroupedCreativesMetricsDocument, options);
      }
export function useMultiGroupedCreativesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables>(MultiGroupedCreativesMetricsDocument, options);
        }
export function useMultiGroupedCreativesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables>(MultiGroupedCreativesMetricsDocument, options);
        }
export type MultiGroupedCreativesMetricsQueryHookResult = ReturnType<typeof useMultiGroupedCreativesMetricsQuery>;
export type MultiGroupedCreativesMetricsLazyQueryHookResult = ReturnType<typeof useMultiGroupedCreativesMetricsLazyQuery>;
export type MultiGroupedCreativesMetricsSuspenseQueryHookResult = ReturnType<typeof useMultiGroupedCreativesMetricsSuspenseQuery>;
export type MultiGroupedCreativesMetricsQueryResult = Apollo.QueryResult<MultiGroupedCreativesMetricsQuery, MultiGroupedCreativesMetricsQueryVariables>;
export const AnalyticsCreativesActivityV2Document = gql`
    query AnalyticsCreativesActivityV2($startDate: Date, $endDate: Date, $creativeStatuses: [CreativeStatus!], $campaignIds: [ID!], $creativeIds: [ID!], $experimentIds: [ID!], $includeCreativeTags: [ID!], $excludeCreativeTags: [ID!], $includeCampaignTags: [ID!], $excludeCampaignTags: [ID!], $isPrimary: Boolean) {
  analyticsCreativesActivityV2(
    startDate: $startDate
    endDate: $endDate
    campaignIds: $campaignIds
    creativeStatuses: $creativeStatuses
    creativeIds: $creativeIds
    experimentIds: $experimentIds
    includeCreativeTags: $includeCreativeTags
    excludeCreativeTags: $excludeCreativeTags
    includeCampaignTags: $includeCampaignTags
    excludeCampaignTags: $excludeCampaignTags
    isPrimary: $isPrimary
  ) {
    creatives {
      creative {
        id
        title
        status
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
      }
      activity {
        autoImpressionRate
        autoImpressions
        averageOrderValue
        clickRate
        clicks
        clickthroughRate
        conversionRate
        conversions
        impressionRate
        impressions
        placements
        revenue
        revenuePerPlacement
        revenuePerThousandPlacements
        uniqueAutoImpressionRate
        uniqueAutoImpressions
        uniqueClickRate
        uniqueClicks
        uniqueClickthroughRate
        uniqueConversionToClickRate
        uniqueConversions
        uniqueImpressionRate
        uniqueImpressions
      }
      scores {
        creativeId
        creativeEffectiveness
        openEffectiveness
        clickEffectiveness
        revenueEffectiveness
        retentionEffectiveness
        conversionEffectiveness
        creativeBucket
        openBucket
        clickBucket
        revenueBucket
        retentionBucket
        conversionBucket
      }
    }
  }
}
    `;

/**
 * __useAnalyticsCreativesActivityV2Query__
 *
 * To run a query within a React component, call `useAnalyticsCreativesActivityV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCreativesActivityV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCreativesActivityV2Query({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      creativeStatuses: // value for 'creativeStatuses'
 *      campaignIds: // value for 'campaignIds'
 *      creativeIds: // value for 'creativeIds'
 *      experimentIds: // value for 'experimentIds'
 *      includeCreativeTags: // value for 'includeCreativeTags'
 *      excludeCreativeTags: // value for 'excludeCreativeTags'
 *      includeCampaignTags: // value for 'includeCampaignTags'
 *      excludeCampaignTags: // value for 'excludeCampaignTags'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useAnalyticsCreativesActivityV2Query(baseOptions?: Apollo.QueryHookOptions<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>(AnalyticsCreativesActivityV2Document, options);
      }
export function useAnalyticsCreativesActivityV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>(AnalyticsCreativesActivityV2Document, options);
        }
export function useAnalyticsCreativesActivityV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>(AnalyticsCreativesActivityV2Document, options);
        }
export type AnalyticsCreativesActivityV2QueryHookResult = ReturnType<typeof useAnalyticsCreativesActivityV2Query>;
export type AnalyticsCreativesActivityV2LazyQueryHookResult = ReturnType<typeof useAnalyticsCreativesActivityV2LazyQuery>;
export type AnalyticsCreativesActivityV2SuspenseQueryHookResult = ReturnType<typeof useAnalyticsCreativesActivityV2SuspenseQuery>;
export type AnalyticsCreativesActivityV2QueryResult = Apollo.QueryResult<AnalyticsCreativesActivityV2Query, AnalyticsCreativesActivityV2QueryVariables>;
export const AnalyticsV2CreativesMetricsGroupedByTagV2Document = gql`
    query AnalyticsV2CreativesMetricsGroupedByTagV2($campaignIdsOrTitles: [String!], $campaignStages: [CampaignStageType!], $creativeIdsOrTitles: [String!], $creativeStatuses: [CreativeStatus!], $excludeCampaignTagIds: [ID!], $excludeCreativeTagIds: [ID!], $includeCampaignTagIds: [ID!], $includeCreativeTagIds: [ID!], $startDate: Date, $endDate: Date, $isPrimary: Boolean, $groupBy: CreativeGroupBy) {
  analyticsV2CreativesMetricsGroupedByTagV2(
    campaignIdsOrTitles: $campaignIdsOrTitles
    campaignStages: $campaignStages
    creativeIdsOrTitles: $creativeIdsOrTitles
    creativeStatuses: $creativeStatuses
    endDate: $endDate
    excludeCampaignTagIds: $excludeCampaignTagIds
    excludeCreativeTagIds: $excludeCreativeTagIds
    includeCampaignTagIds: $includeCampaignTagIds
    includeCreativeTagIds: $includeCreativeTagIds
    startDate: $startDate
    isPrimary: $isPrimary
    groupBy: $groupBy
  ) {
    group
    metrics {
      autoImpressionRate
      autoImpressions
      averageOrderValue
      uniqueClickRate: clickRate
      uniqueClickthroughRate: clickToImpressionRate
      clicks
      conversionRate
      uniqueConversionToClickRate: conversionToClickRate
      conversions
      uniqueImpressionRate: impressionRate
      impressions
      placements
      revenue
      revenuePerPlacement
      revenuePerThousandPlacements
      uniqueAutoImpressions
      uniqueClicks
      uniqueConversions
      uniqueImpressions
    }
    scores {
      creativeId
      openEffectiveness
      retentionEffectiveness
      revenueEffectiveness
      creativeEffectiveness
      clickEffectiveness
      conversionEffectiveness
      clickBucket
      openBucket
      creativeBucket
      conversionBucket
      retentionBucket
      revenueBucket
    }
    creatives {
      creative {
        id
        title
        status
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
      }
      metrics {
        placements
        autoImpressions
        uniqueAutoImpressions
        autoImpressionRate
        impressions
        uniqueImpressions
        uniqueImpressionRate: impressionRate
        clicks
        uniqueClicks
        uniqueClickRate: clickRate
        uniqueClickthroughRate: clickToImpressionRate
        conversions
        uniqueConversions
        conversionRate
        uniqueConversionToClickRate: conversionToClickRate
        revenue
        revenuePerPlacement
        revenuePerThousandPlacements
        averageOrderValue
      }
      scores {
        creativeId
        openEffectiveness
        clickEffectiveness
        conversionEffectiveness
        retentionEffectiveness
        revenueEffectiveness
        creativeEffectiveness
        clickBucket
        openBucket
        creativeBucket
        conversionBucket
        retentionBucket
        revenueBucket
      }
    }
    creativeCount
    creativeUsageRatio
  }
}
    `;

/**
 * __useAnalyticsV2CreativesMetricsGroupedByTagV2Query__
 *
 * To run a query within a React component, call `useAnalyticsV2CreativesMetricsGroupedByTagV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2CreativesMetricsGroupedByTagV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsV2CreativesMetricsGroupedByTagV2Query({
 *   variables: {
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      campaignStages: // value for 'campaignStages'
 *      creativeIdsOrTitles: // value for 'creativeIdsOrTitles'
 *      creativeStatuses: // value for 'creativeStatuses'
 *      excludeCampaignTagIds: // value for 'excludeCampaignTagIds'
 *      excludeCreativeTagIds: // value for 'excludeCreativeTagIds'
 *      includeCampaignTagIds: // value for 'includeCampaignTagIds'
 *      includeCreativeTagIds: // value for 'includeCreativeTagIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isPrimary: // value for 'isPrimary'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useAnalyticsV2CreativesMetricsGroupedByTagV2Query(baseOptions?: Apollo.QueryHookOptions<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>(AnalyticsV2CreativesMetricsGroupedByTagV2Document, options);
      }
export function useAnalyticsV2CreativesMetricsGroupedByTagV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>(AnalyticsV2CreativesMetricsGroupedByTagV2Document, options);
        }
export function useAnalyticsV2CreativesMetricsGroupedByTagV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>(AnalyticsV2CreativesMetricsGroupedByTagV2Document, options);
        }
export type AnalyticsV2CreativesMetricsGroupedByTagV2QueryHookResult = ReturnType<typeof useAnalyticsV2CreativesMetricsGroupedByTagV2Query>;
export type AnalyticsV2CreativesMetricsGroupedByTagV2LazyQueryHookResult = ReturnType<typeof useAnalyticsV2CreativesMetricsGroupedByTagV2LazyQuery>;
export type AnalyticsV2CreativesMetricsGroupedByTagV2SuspenseQueryHookResult = ReturnType<typeof useAnalyticsV2CreativesMetricsGroupedByTagV2SuspenseQuery>;
export type AnalyticsV2CreativesMetricsGroupedByTagV2QueryResult = Apollo.QueryResult<AnalyticsV2CreativesMetricsGroupedByTagV2Query, AnalyticsV2CreativesMetricsGroupedByTagV2QueryVariables>;
export const AnalyticsDashboardConfigDocument = gql`
    query AnalyticsDashboardConfig {
  analyticsDashboardConfig {
    id
    name
    enabled
    order
    option {
      selected
    }
    config
    expandedMetricIds
  }
}
    `;

/**
 * __useAnalyticsDashboardConfigQuery__
 *
 * To run a query within a React component, call `useAnalyticsDashboardConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsDashboardConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsDashboardConfigQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>(AnalyticsDashboardConfigDocument, options);
      }
export function useAnalyticsDashboardConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>(AnalyticsDashboardConfigDocument, options);
        }
export function useAnalyticsDashboardConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>(AnalyticsDashboardConfigDocument, options);
        }
export type AnalyticsDashboardConfigQueryHookResult = ReturnType<typeof useAnalyticsDashboardConfigQuery>;
export type AnalyticsDashboardConfigLazyQueryHookResult = ReturnType<typeof useAnalyticsDashboardConfigLazyQuery>;
export type AnalyticsDashboardConfigSuspenseQueryHookResult = ReturnType<typeof useAnalyticsDashboardConfigSuspenseQuery>;
export type AnalyticsDashboardConfigQueryResult = Apollo.QueryResult<AnalyticsDashboardConfigQuery, AnalyticsDashboardConfigQueryVariables>;
export const UpdateAnalyticsDashboardConfigDocument = gql`
    mutation UpdateAnalyticsDashboardConfig($widgets: [AnalyticsWidgetInput!]!) {
  updateAnalyticsDashboardConfig(widgets: $widgets) {
    __typename
  }
}
    `;
export type UpdateAnalyticsDashboardConfigMutationFn = Apollo.MutationFunction<UpdateAnalyticsDashboardConfigMutation, UpdateAnalyticsDashboardConfigMutationVariables>;

/**
 * __useUpdateAnalyticsDashboardConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAnalyticsDashboardConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalyticsDashboardConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalyticsDashboardConfigMutation, { data, loading, error }] = useUpdateAnalyticsDashboardConfigMutation({
 *   variables: {
 *      widgets: // value for 'widgets'
 *   },
 * });
 */
export function useUpdateAnalyticsDashboardConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalyticsDashboardConfigMutation, UpdateAnalyticsDashboardConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalyticsDashboardConfigMutation, UpdateAnalyticsDashboardConfigMutationVariables>(UpdateAnalyticsDashboardConfigDocument, options);
      }
export type UpdateAnalyticsDashboardConfigMutationHookResult = ReturnType<typeof useUpdateAnalyticsDashboardConfigMutation>;
export type UpdateAnalyticsDashboardConfigMutationResult = Apollo.MutationResult<UpdateAnalyticsDashboardConfigMutation>;
export type UpdateAnalyticsDashboardConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAnalyticsDashboardConfigMutation, UpdateAnalyticsDashboardConfigMutationVariables>;
export const DashboardCampaignMetricsDocument = gql`
    query DashboardCampaignMetrics($filter: CampaignFilter!) {
  campaignsMetrics(filter: $filter) {
    summary {
      id
      ...MetricFields
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useDashboardCampaignMetricsQuery__
 *
 * To run a query within a React component, call `useDashboardCampaignMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCampaignMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCampaignMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardCampaignMetricsQuery(baseOptions: Apollo.QueryHookOptions<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables> & ({ variables: DashboardCampaignMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables>(DashboardCampaignMetricsDocument, options);
      }
export function useDashboardCampaignMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables>(DashboardCampaignMetricsDocument, options);
        }
export function useDashboardCampaignMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables>(DashboardCampaignMetricsDocument, options);
        }
export type DashboardCampaignMetricsQueryHookResult = ReturnType<typeof useDashboardCampaignMetricsQuery>;
export type DashboardCampaignMetricsLazyQueryHookResult = ReturnType<typeof useDashboardCampaignMetricsLazyQuery>;
export type DashboardCampaignMetricsSuspenseQueryHookResult = ReturnType<typeof useDashboardCampaignMetricsSuspenseQuery>;
export type DashboardCampaignMetricsQueryResult = Apollo.QueryResult<DashboardCampaignMetricsQuery, DashboardCampaignMetricsQueryVariables>;
export const DashboardCreativeMetricsDocument = gql`
    query DashboardCreativeMetrics($filter: CreativeMetricsFilter!, $orderBy: String, $limit: Int) {
  creativesMetrics(filter: $filter, orderBy: $orderBy, limit: $limit) {
    creatives {
      creative {
        id
        title
        bestThumbnail {
          url
        }
      }
      metrics {
        id
        ... on CurrencyMetric {
          currency
        }
        ... on CountMetric {
          count
        }
        ... on ScoreMetric {
          label
        }
        ... on RateMetric {
          rate
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardCreativeMetricsQuery__
 *
 * To run a query within a React component, call `useDashboardCreativeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCreativeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCreativeMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDashboardCreativeMetricsQuery(baseOptions: Apollo.QueryHookOptions<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables> & ({ variables: DashboardCreativeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables>(DashboardCreativeMetricsDocument, options);
      }
export function useDashboardCreativeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables>(DashboardCreativeMetricsDocument, options);
        }
export function useDashboardCreativeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables>(DashboardCreativeMetricsDocument, options);
        }
export type DashboardCreativeMetricsQueryHookResult = ReturnType<typeof useDashboardCreativeMetricsQuery>;
export type DashboardCreativeMetricsLazyQueryHookResult = ReturnType<typeof useDashboardCreativeMetricsLazyQuery>;
export type DashboardCreativeMetricsSuspenseQueryHookResult = ReturnType<typeof useDashboardCreativeMetricsSuspenseQuery>;
export type DashboardCreativeMetricsQueryResult = Apollo.QueryResult<DashboardCreativeMetricsQuery, DashboardCreativeMetricsQueryVariables>;
export const DashboardExperimentGroupsDocument = gql`
    query DashboardExperimentGroups {
  experimentGroups {
    id
    title
    experimentType
  }
}
    `;

/**
 * __useDashboardExperimentGroupsQuery__
 *
 * To run a query within a React component, call `useDashboardExperimentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardExperimentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardExperimentGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardExperimentGroupsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>(DashboardExperimentGroupsDocument, options);
      }
export function useDashboardExperimentGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>(DashboardExperimentGroupsDocument, options);
        }
export function useDashboardExperimentGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>(DashboardExperimentGroupsDocument, options);
        }
export type DashboardExperimentGroupsQueryHookResult = ReturnType<typeof useDashboardExperimentGroupsQuery>;
export type DashboardExperimentGroupsLazyQueryHookResult = ReturnType<typeof useDashboardExperimentGroupsLazyQuery>;
export type DashboardExperimentGroupsSuspenseQueryHookResult = ReturnType<typeof useDashboardExperimentGroupsSuspenseQuery>;
export type DashboardExperimentGroupsQueryResult = Apollo.QueryResult<DashboardExperimentGroupsQuery, DashboardExperimentGroupsQueryVariables>;
export const DashboardExperimentGroupsWithDefinitionsDocument = gql`
    query DashboardExperimentGroupsWithDefinitions {
  experimentGroups {
    id
    title
    experimentType
    treatmentDefinitions {
      id
      title
      order
      size
      isControl
    }
  }
}
    `;

/**
 * __useDashboardExperimentGroupsWithDefinitionsQuery__
 *
 * To run a query within a React component, call `useDashboardExperimentGroupsWithDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardExperimentGroupsWithDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardExperimentGroupsWithDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardExperimentGroupsWithDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>(DashboardExperimentGroupsWithDefinitionsDocument, options);
      }
export function useDashboardExperimentGroupsWithDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>(DashboardExperimentGroupsWithDefinitionsDocument, options);
        }
export function useDashboardExperimentGroupsWithDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>(DashboardExperimentGroupsWithDefinitionsDocument, options);
        }
export type DashboardExperimentGroupsWithDefinitionsQueryHookResult = ReturnType<typeof useDashboardExperimentGroupsWithDefinitionsQuery>;
export type DashboardExperimentGroupsWithDefinitionsLazyQueryHookResult = ReturnType<typeof useDashboardExperimentGroupsWithDefinitionsLazyQuery>;
export type DashboardExperimentGroupsWithDefinitionsSuspenseQueryHookResult = ReturnType<typeof useDashboardExperimentGroupsWithDefinitionsSuspenseQuery>;
export type DashboardExperimentGroupsWithDefinitionsQueryResult = Apollo.QueryResult<DashboardExperimentGroupsWithDefinitionsQuery, DashboardExperimentGroupsWithDefinitionsQueryVariables>;
export const DashboardTreatmentDefinitionComparisonDocument = gql`
    query DashboardTreatmentDefinitionComparison($baselineTreatmentDefinitionIds: [ID!], $groupTreatmentDefinitionIds: [ID!], $campaignFilter: CampaignMetricsFilter!) {
  campaignComparisonByTreatmentV2(
    baselineTreatmentDefinitionIds: $baselineTreatmentDefinitionIds
    groupTreatmentDefinitionIds: $groupTreatmentDefinitionIds
    filter: $campaignFilter
  ) {
    baselines {
      ...CampaignComparisonBaseFieldsV2
    }
    groups {
      ...CampaignComparisonBaseFieldsV2
    }
  }
}
    ${CampaignComparisonBaseFieldsV2FragmentDoc}`;

/**
 * __useDashboardTreatmentDefinitionComparisonQuery__
 *
 * To run a query within a React component, call `useDashboardTreatmentDefinitionComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTreatmentDefinitionComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTreatmentDefinitionComparisonQuery({
 *   variables: {
 *      baselineTreatmentDefinitionIds: // value for 'baselineTreatmentDefinitionIds'
 *      groupTreatmentDefinitionIds: // value for 'groupTreatmentDefinitionIds'
 *      campaignFilter: // value for 'campaignFilter'
 *   },
 * });
 */
export function useDashboardTreatmentDefinitionComparisonQuery(baseOptions: Apollo.QueryHookOptions<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables> & ({ variables: DashboardTreatmentDefinitionComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables>(DashboardTreatmentDefinitionComparisonDocument, options);
      }
export function useDashboardTreatmentDefinitionComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables>(DashboardTreatmentDefinitionComparisonDocument, options);
        }
export function useDashboardTreatmentDefinitionComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables>(DashboardTreatmentDefinitionComparisonDocument, options);
        }
export type DashboardTreatmentDefinitionComparisonQueryHookResult = ReturnType<typeof useDashboardTreatmentDefinitionComparisonQuery>;
export type DashboardTreatmentDefinitionComparisonLazyQueryHookResult = ReturnType<typeof useDashboardTreatmentDefinitionComparisonLazyQuery>;
export type DashboardTreatmentDefinitionComparisonSuspenseQueryHookResult = ReturnType<typeof useDashboardTreatmentDefinitionComparisonSuspenseQuery>;
export type DashboardTreatmentDefinitionComparisonQueryResult = Apollo.QueryResult<DashboardTreatmentDefinitionComparisonQuery, DashboardTreatmentDefinitionComparisonQueryVariables>;
export const DashboardTreatmentTrendDocument = gql`
    query DashboardTreatmentTrend($baselineTreatmentDefinitionIds: [ID!], $groupTreatmentDefinitionIds: [ID!], $campaignFilter: CampaignMetricsFilter!, $seriesMetrics: [String!]!) {
  campaignComparisonByTreatmentV2(
    baselineTreatmentDefinitionIds: $baselineTreatmentDefinitionIds
    groupTreatmentDefinitionIds: $groupTreatmentDefinitionIds
    filter: $campaignFilter
    seriesMetrics: $seriesMetrics
  ) {
    metricSeries {
      ...NamedMetricSeriesFields
    }
  }
}
    ${NamedMetricSeriesFieldsFragmentDoc}`;

/**
 * __useDashboardTreatmentTrendQuery__
 *
 * To run a query within a React component, call `useDashboardTreatmentTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTreatmentTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTreatmentTrendQuery({
 *   variables: {
 *      baselineTreatmentDefinitionIds: // value for 'baselineTreatmentDefinitionIds'
 *      groupTreatmentDefinitionIds: // value for 'groupTreatmentDefinitionIds'
 *      campaignFilter: // value for 'campaignFilter'
 *      seriesMetrics: // value for 'seriesMetrics'
 *   },
 * });
 */
export function useDashboardTreatmentTrendQuery(baseOptions: Apollo.QueryHookOptions<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables> & ({ variables: DashboardTreatmentTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables>(DashboardTreatmentTrendDocument, options);
      }
export function useDashboardTreatmentTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables>(DashboardTreatmentTrendDocument, options);
        }
export function useDashboardTreatmentTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables>(DashboardTreatmentTrendDocument, options);
        }
export type DashboardTreatmentTrendQueryHookResult = ReturnType<typeof useDashboardTreatmentTrendQuery>;
export type DashboardTreatmentTrendLazyQueryHookResult = ReturnType<typeof useDashboardTreatmentTrendLazyQuery>;
export type DashboardTreatmentTrendSuspenseQueryHookResult = ReturnType<typeof useDashboardTreatmentTrendSuspenseQuery>;
export type DashboardTreatmentTrendQueryResult = Apollo.QueryResult<DashboardTreatmentTrendQuery, DashboardTreatmentTrendQueryVariables>;
export const AnalyticsExperimentHeaderDocument = gql`
    query AnalyticsExperimentHeader($experimentId: ID!) {
  analyticsExperimentActivity(experimentId: $experimentId) {
    earliestCampaignUsage
    latestCampaignUsage
    experiment {
      id
      title
      status
    }
  }
}
    `;

/**
 * __useAnalyticsExperimentHeaderQuery__
 *
 * To run a query within a React component, call `useAnalyticsExperimentHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExperimentHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsExperimentHeaderQuery({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useAnalyticsExperimentHeaderQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables> & ({ variables: AnalyticsExperimentHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables>(AnalyticsExperimentHeaderDocument, options);
      }
export function useAnalyticsExperimentHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables>(AnalyticsExperimentHeaderDocument, options);
        }
export function useAnalyticsExperimentHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables>(AnalyticsExperimentHeaderDocument, options);
        }
export type AnalyticsExperimentHeaderQueryHookResult = ReturnType<typeof useAnalyticsExperimentHeaderQuery>;
export type AnalyticsExperimentHeaderLazyQueryHookResult = ReturnType<typeof useAnalyticsExperimentHeaderLazyQuery>;
export type AnalyticsExperimentHeaderSuspenseQueryHookResult = ReturnType<typeof useAnalyticsExperimentHeaderSuspenseQuery>;
export type AnalyticsExperimentHeaderQueryResult = Apollo.QueryResult<AnalyticsExperimentHeaderQuery, AnalyticsExperimentHeaderQueryVariables>;
export const ExperimentDetailsExportDocument = gql`
    mutation ExperimentDetailsExport($columns: [String!]!, $filter: ExperimentMetricsFilter!, $includeMetadata: Boolean, $recurringExportId: ID) {
  experimentMetricsExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type ExperimentDetailsExportMutationFn = Apollo.MutationFunction<ExperimentDetailsExportMutation, ExperimentDetailsExportMutationVariables>;

/**
 * __useExperimentDetailsExportMutation__
 *
 * To run a mutation, you first call `useExperimentDetailsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperimentDetailsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experimentDetailsExportMutation, { data, loading, error }] = useExperimentDetailsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useExperimentDetailsExportMutation(baseOptions?: Apollo.MutationHookOptions<ExperimentDetailsExportMutation, ExperimentDetailsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExperimentDetailsExportMutation, ExperimentDetailsExportMutationVariables>(ExperimentDetailsExportDocument, options);
      }
export type ExperimentDetailsExportMutationHookResult = ReturnType<typeof useExperimentDetailsExportMutation>;
export type ExperimentDetailsExportMutationResult = Apollo.MutationResult<ExperimentDetailsExportMutation>;
export type ExperimentDetailsExportMutationOptions = Apollo.BaseMutationOptions<ExperimentDetailsExportMutation, ExperimentDetailsExportMutationVariables>;
export const ExperimentCampaignsMetricsExportDocument = gql`
    mutation ExperimentCampaignsMetricsExport($columns: [String!]!, $filter: ExperimentCampaignMetricsFilter!, $groupBy: CampaignGroupBy, $includeMetadata: Boolean, $recurringExportId: ID) {
  experimentCampaignsMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type ExperimentCampaignsMetricsExportMutationFn = Apollo.MutationFunction<ExperimentCampaignsMetricsExportMutation, ExperimentCampaignsMetricsExportMutationVariables>;

/**
 * __useExperimentCampaignsMetricsExportMutation__
 *
 * To run a mutation, you first call `useExperimentCampaignsMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperimentCampaignsMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experimentCampaignsMetricsExportMutation, { data, loading, error }] = useExperimentCampaignsMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useExperimentCampaignsMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<ExperimentCampaignsMetricsExportMutation, ExperimentCampaignsMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExperimentCampaignsMetricsExportMutation, ExperimentCampaignsMetricsExportMutationVariables>(ExperimentCampaignsMetricsExportDocument, options);
      }
export type ExperimentCampaignsMetricsExportMutationHookResult = ReturnType<typeof useExperimentCampaignsMetricsExportMutation>;
export type ExperimentCampaignsMetricsExportMutationResult = Apollo.MutationResult<ExperimentCampaignsMetricsExportMutation>;
export type ExperimentCampaignsMetricsExportMutationOptions = Apollo.BaseMutationOptions<ExperimentCampaignsMetricsExportMutation, ExperimentCampaignsMetricsExportMutationVariables>;
export const ExperimentCreativesMetricsExportDocument = gql`
    mutation ExperimentCreativesMetricsExport($columns: [String!]!, $filter: ExperimentCreativeMetricsFilter!, $groupBy: CreativeGroupBy, $includeMetadata: Boolean, $recurringExportId: ID) {
  experimentCreativesMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type ExperimentCreativesMetricsExportMutationFn = Apollo.MutationFunction<ExperimentCreativesMetricsExportMutation, ExperimentCreativesMetricsExportMutationVariables>;

/**
 * __useExperimentCreativesMetricsExportMutation__
 *
 * To run a mutation, you first call `useExperimentCreativesMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperimentCreativesMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experimentCreativesMetricsExportMutation, { data, loading, error }] = useExperimentCreativesMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useExperimentCreativesMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<ExperimentCreativesMetricsExportMutation, ExperimentCreativesMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExperimentCreativesMetricsExportMutation, ExperimentCreativesMetricsExportMutationVariables>(ExperimentCreativesMetricsExportDocument, options);
      }
export type ExperimentCreativesMetricsExportMutationHookResult = ReturnType<typeof useExperimentCreativesMetricsExportMutation>;
export type ExperimentCreativesMetricsExportMutationResult = Apollo.MutationResult<ExperimentCreativesMetricsExportMutation>;
export type ExperimentCreativesMetricsExportMutationOptions = Apollo.BaseMutationOptions<ExperimentCreativesMetricsExportMutation, ExperimentCreativesMetricsExportMutationVariables>;
export const ExperimentCampaignsMetricsDocument = gql`
    query ExperimentCampaignsMetrics($filter: ExperimentCampaignMetricsFilter!) {
  experimentCampaignsMetrics(filter: $filter) {
    campaign {
      id
      title
    }
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useExperimentCampaignsMetricsQuery__
 *
 * To run a query within a React component, call `useExperimentCampaignsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentCampaignsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentCampaignsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExperimentCampaignsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables> & ({ variables: ExperimentCampaignsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables>(ExperimentCampaignsMetricsDocument, options);
      }
export function useExperimentCampaignsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables>(ExperimentCampaignsMetricsDocument, options);
        }
export function useExperimentCampaignsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables>(ExperimentCampaignsMetricsDocument, options);
        }
export type ExperimentCampaignsMetricsQueryHookResult = ReturnType<typeof useExperimentCampaignsMetricsQuery>;
export type ExperimentCampaignsMetricsLazyQueryHookResult = ReturnType<typeof useExperimentCampaignsMetricsLazyQuery>;
export type ExperimentCampaignsMetricsSuspenseQueryHookResult = ReturnType<typeof useExperimentCampaignsMetricsSuspenseQuery>;
export type ExperimentCampaignsMetricsQueryResult = Apollo.QueryResult<ExperimentCampaignsMetricsQuery, ExperimentCampaignsMetricsQueryVariables>;
export const ExperimentCreativesMetricsDocument = gql`
    query ExperimentCreativesMetrics($filter: ExperimentCreativeMetricsFilter!) {
  experimentCreativesMetrics(filter: $filter) {
    creative {
      id
      title
    }
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useExperimentCreativesMetricsQuery__
 *
 * To run a query within a React component, call `useExperimentCreativesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentCreativesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentCreativesMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExperimentCreativesMetricsQuery(baseOptions: Apollo.QueryHookOptions<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables> & ({ variables: ExperimentCreativesMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables>(ExperimentCreativesMetricsDocument, options);
      }
export function useExperimentCreativesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables>(ExperimentCreativesMetricsDocument, options);
        }
export function useExperimentCreativesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables>(ExperimentCreativesMetricsDocument, options);
        }
export type ExperimentCreativesMetricsQueryHookResult = ReturnType<typeof useExperimentCreativesMetricsQuery>;
export type ExperimentCreativesMetricsLazyQueryHookResult = ReturnType<typeof useExperimentCreativesMetricsLazyQuery>;
export type ExperimentCreativesMetricsSuspenseQueryHookResult = ReturnType<typeof useExperimentCreativesMetricsSuspenseQuery>;
export type ExperimentCreativesMetricsQueryResult = Apollo.QueryResult<ExperimentCreativesMetricsQuery, ExperimentCreativesMetricsQueryVariables>;
export const ReportingExperimentSegmentsMetricsDocument = gql`
    query ReportingExperimentSegmentsMetrics($filter: ExperimentSegmentsMetricsFilter!) {
  experimentSegmentsMetrics(filter: $filter) {
    audience {
      id
      name
      description
      updatedAt
    }
    splits {
      split {
        id
        name
      }
      treatments {
        treatment {
          id
          title
          control
        }
        metrics {
          ...MetricWithStatsFields
        }
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useReportingExperimentSegmentsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingExperimentSegmentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingExperimentSegmentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingExperimentSegmentsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingExperimentSegmentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables> & ({ variables: ReportingExperimentSegmentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables>(ReportingExperimentSegmentsMetricsDocument, options);
      }
export function useReportingExperimentSegmentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables>(ReportingExperimentSegmentsMetricsDocument, options);
        }
export function useReportingExperimentSegmentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables>(ReportingExperimentSegmentsMetricsDocument, options);
        }
export type ReportingExperimentSegmentsMetricsQueryHookResult = ReturnType<typeof useReportingExperimentSegmentsMetricsQuery>;
export type ReportingExperimentSegmentsMetricsLazyQueryHookResult = ReturnType<typeof useReportingExperimentSegmentsMetricsLazyQuery>;
export type ReportingExperimentSegmentsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingExperimentSegmentsMetricsSuspenseQuery>;
export type ReportingExperimentSegmentsMetricsQueryResult = Apollo.QueryResult<ReportingExperimentSegmentsMetricsQuery, ReportingExperimentSegmentsMetricsQueryVariables>;
export const ExperimentSegmentsMetricsExportDocument = gql`
    mutation ExperimentSegmentsMetricsExport($columns: [String!]!, $filter: ExperimentSegmentsMetricsFilter!, $includeMetadata: Boolean, $recurringExportId: ID) {
  experimentSegmentsMetricsExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type ExperimentSegmentsMetricsExportMutationFn = Apollo.MutationFunction<ExperimentSegmentsMetricsExportMutation, ExperimentSegmentsMetricsExportMutationVariables>;

/**
 * __useExperimentSegmentsMetricsExportMutation__
 *
 * To run a mutation, you first call `useExperimentSegmentsMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperimentSegmentsMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experimentSegmentsMetricsExportMutation, { data, loading, error }] = useExperimentSegmentsMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useExperimentSegmentsMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<ExperimentSegmentsMetricsExportMutation, ExperimentSegmentsMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExperimentSegmentsMetricsExportMutation, ExperimentSegmentsMetricsExportMutationVariables>(ExperimentSegmentsMetricsExportDocument, options);
      }
export type ExperimentSegmentsMetricsExportMutationHookResult = ReturnType<typeof useExperimentSegmentsMetricsExportMutation>;
export type ExperimentSegmentsMetricsExportMutationResult = Apollo.MutationResult<ExperimentSegmentsMetricsExportMutation>;
export type ExperimentSegmentsMetricsExportMutationOptions = Apollo.BaseMutationOptions<ExperimentSegmentsMetricsExportMutation, ExperimentSegmentsMetricsExportMutationVariables>;
export const ReportingExperimentGroupedCreativesMetricsDocument = gql`
    query ReportingExperimentGroupedCreativesMetrics($filter: ExperimentCreativeMetricsFilter!, $groupBy: CreativeGroupBy!) {
  groupedExperimentCreativesMetrics(filter: $filter, groupBy: $groupBy) {
    group
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useReportingExperimentGroupedCreativesMetricsQuery__
 *
 * To run a query within a React component, call `useReportingExperimentGroupedCreativesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingExperimentGroupedCreativesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingExperimentGroupedCreativesMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useReportingExperimentGroupedCreativesMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables> & ({ variables: ReportingExperimentGroupedCreativesMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables>(ReportingExperimentGroupedCreativesMetricsDocument, options);
      }
export function useReportingExperimentGroupedCreativesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables>(ReportingExperimentGroupedCreativesMetricsDocument, options);
        }
export function useReportingExperimentGroupedCreativesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables>(ReportingExperimentGroupedCreativesMetricsDocument, options);
        }
export type ReportingExperimentGroupedCreativesMetricsQueryHookResult = ReturnType<typeof useReportingExperimentGroupedCreativesMetricsQuery>;
export type ReportingExperimentGroupedCreativesMetricsLazyQueryHookResult = ReturnType<typeof useReportingExperimentGroupedCreativesMetricsLazyQuery>;
export type ReportingExperimentGroupedCreativesMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingExperimentGroupedCreativesMetricsSuspenseQuery>;
export type ReportingExperimentGroupedCreativesMetricsQueryResult = Apollo.QueryResult<ReportingExperimentGroupedCreativesMetricsQuery, ReportingExperimentGroupedCreativesMetricsQueryVariables>;
export const ReportingExperimentGroupedCampaignsMetricsDocument = gql`
    query ReportingExperimentGroupedCampaignsMetrics($filter: ExperimentCampaignMetricsFilter!, $groupBy: CampaignGroupBy!) {
  groupedExperimentCampaignsMetrics(filter: $filter, groupBy: $groupBy) {
    group
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useReportingExperimentGroupedCampaignsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingExperimentGroupedCampaignsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingExperimentGroupedCampaignsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingExperimentGroupedCampaignsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useReportingExperimentGroupedCampaignsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables> & ({ variables: ReportingExperimentGroupedCampaignsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables>(ReportingExperimentGroupedCampaignsMetricsDocument, options);
      }
export function useReportingExperimentGroupedCampaignsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables>(ReportingExperimentGroupedCampaignsMetricsDocument, options);
        }
export function useReportingExperimentGroupedCampaignsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables>(ReportingExperimentGroupedCampaignsMetricsDocument, options);
        }
export type ReportingExperimentGroupedCampaignsMetricsQueryHookResult = ReturnType<typeof useReportingExperimentGroupedCampaignsMetricsQuery>;
export type ReportingExperimentGroupedCampaignsMetricsLazyQueryHookResult = ReturnType<typeof useReportingExperimentGroupedCampaignsMetricsLazyQuery>;
export type ReportingExperimentGroupedCampaignsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingExperimentGroupedCampaignsMetricsSuspenseQuery>;
export type ReportingExperimentGroupedCampaignsMetricsQueryResult = Apollo.QueryResult<ReportingExperimentGroupedCampaignsMetricsQuery, ReportingExperimentGroupedCampaignsMetricsQueryVariables>;
export const ExperimentMetricsExportDocument = gql`
    mutation ExperimentMetricsExport($columns: [String!]!, $filter: ExperimentMetricsFilter!, $includeMetadata: Boolean, $recurringExportId: ID) {
  experimentMetricsExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type ExperimentMetricsExportMutationFn = Apollo.MutationFunction<ExperimentMetricsExportMutation, ExperimentMetricsExportMutationVariables>;

/**
 * __useExperimentMetricsExportMutation__
 *
 * To run a mutation, you first call `useExperimentMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperimentMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experimentMetricsExportMutation, { data, loading, error }] = useExperimentMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useExperimentMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<ExperimentMetricsExportMutation, ExperimentMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExperimentMetricsExportMutation, ExperimentMetricsExportMutationVariables>(ExperimentMetricsExportDocument, options);
      }
export type ExperimentMetricsExportMutationHookResult = ReturnType<typeof useExperimentMetricsExportMutation>;
export type ExperimentMetricsExportMutationResult = Apollo.MutationResult<ExperimentMetricsExportMutation>;
export type ExperimentMetricsExportMutationOptions = Apollo.BaseMutationOptions<ExperimentMetricsExportMutation, ExperimentMetricsExportMutationVariables>;
export const ExperimentsMetricsDocument = gql`
    query ExperimentsMetrics($filter: ExperimentMetricsFilter!, $orderBy: String) {
  experimentsMetrics(filter: $filter, orderBy: $orderBy) {
    experiment {
      id
      title
      status
      experimentType
      minDate
      maxDate
      configurationRestrictedToStaff
      treatments {
        id
        title
        control
        order
      }
    }
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useExperimentsMetricsQuery__
 *
 * To run a query within a React component, call `useExperimentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useExperimentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables> & ({ variables: ExperimentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables>(ExperimentsMetricsDocument, options);
      }
export function useExperimentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables>(ExperimentsMetricsDocument, options);
        }
export function useExperimentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables>(ExperimentsMetricsDocument, options);
        }
export type ExperimentsMetricsQueryHookResult = ReturnType<typeof useExperimentsMetricsQuery>;
export type ExperimentsMetricsLazyQueryHookResult = ReturnType<typeof useExperimentsMetricsLazyQuery>;
export type ExperimentsMetricsSuspenseQueryHookResult = ReturnType<typeof useExperimentsMetricsSuspenseQuery>;
export type ExperimentsMetricsQueryResult = Apollo.QueryResult<ExperimentsMetricsQuery, ExperimentsMetricsQueryVariables>;
export const ExperimentContactsMetricsDocument = gql`
    query ExperimentContactsMetrics($filter: ExperimentMetricsFilter!) {
  experimentContactsMetrics(filter: $filter) {
    treatments {
      treatment {
        id
        title
        control
      }
      metrics {
        ...MetricWithStatsFields
      }
    }
  }
}
    ${MetricWithStatsFieldsFragmentDoc}`;

/**
 * __useExperimentContactsMetricsQuery__
 *
 * To run a query within a React component, call `useExperimentContactsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentContactsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentContactsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExperimentContactsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables> & ({ variables: ExperimentContactsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables>(ExperimentContactsMetricsDocument, options);
      }
export function useExperimentContactsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables>(ExperimentContactsMetricsDocument, options);
        }
export function useExperimentContactsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables>(ExperimentContactsMetricsDocument, options);
        }
export type ExperimentContactsMetricsQueryHookResult = ReturnType<typeof useExperimentContactsMetricsQuery>;
export type ExperimentContactsMetricsLazyQueryHookResult = ReturnType<typeof useExperimentContactsMetricsLazyQuery>;
export type ExperimentContactsMetricsSuspenseQueryHookResult = ReturnType<typeof useExperimentContactsMetricsSuspenseQuery>;
export type ExperimentContactsMetricsQueryResult = Apollo.QueryResult<ExperimentContactsMetricsQuery, ExperimentContactsMetricsQueryVariables>;
export const AnalyticsCampaignActivityDocument = gql`
    query AnalyticsCampaignActivity($campaignId: ID!) {
  analyticsCampaignActivity(campaignId: $campaignId) {
    campaign {
      id
      title
      sendDate
      stage
      tags {
        id
        name
      }
    }
    activity {
      ...CampaignsActivityFields
    }
  }
  analyticsCampaignSendTimeMetrics(campaignId: $campaignId) {
    sendTime
    sends
  }
}
    ${CampaignsActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsCampaignActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsCampaignActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCampaignActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCampaignActivityQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAnalyticsCampaignActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables> & ({ variables: AnalyticsCampaignActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables>(AnalyticsCampaignActivityDocument, options);
      }
export function useAnalyticsCampaignActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables>(AnalyticsCampaignActivityDocument, options);
        }
export function useAnalyticsCampaignActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables>(AnalyticsCampaignActivityDocument, options);
        }
export type AnalyticsCampaignActivityQueryHookResult = ReturnType<typeof useAnalyticsCampaignActivityQuery>;
export type AnalyticsCampaignActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsCampaignActivityLazyQuery>;
export type AnalyticsCampaignActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsCampaignActivitySuspenseQuery>;
export type AnalyticsCampaignActivityQueryResult = Apollo.QueryResult<AnalyticsCampaignActivityQuery, AnalyticsCampaignActivityQueryVariables>;
export const ReportingSegmentDetailsHeaderDocument = gql`
    query ReportingSegmentDetailsHeader($filter: SegmentGroupMetricsFilter!) {
  segmentGroupsMetrics(filter: $filter) {
    audience {
      id
      name
      createdAt
    }
  }
}
    `;

/**
 * __useReportingSegmentDetailsHeaderQuery__
 *
 * To run a query within a React component, call `useReportingSegmentDetailsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingSegmentDetailsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSegmentDetailsHeaderQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingSegmentDetailsHeaderQuery(baseOptions: Apollo.QueryHookOptions<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables> & ({ variables: ReportingSegmentDetailsHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables>(ReportingSegmentDetailsHeaderDocument, options);
      }
export function useReportingSegmentDetailsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables>(ReportingSegmentDetailsHeaderDocument, options);
        }
export function useReportingSegmentDetailsHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables>(ReportingSegmentDetailsHeaderDocument, options);
        }
export type ReportingSegmentDetailsHeaderQueryHookResult = ReturnType<typeof useReportingSegmentDetailsHeaderQuery>;
export type ReportingSegmentDetailsHeaderLazyQueryHookResult = ReturnType<typeof useReportingSegmentDetailsHeaderLazyQuery>;
export type ReportingSegmentDetailsHeaderSuspenseQueryHookResult = ReturnType<typeof useReportingSegmentDetailsHeaderSuspenseQuery>;
export type ReportingSegmentDetailsHeaderQueryResult = Apollo.QueryResult<ReportingSegmentDetailsHeaderQuery, ReportingSegmentDetailsHeaderQueryVariables>;
export const AnalyticsSegmentsActivityDocument = gql`
    query AnalyticsSegmentsActivity($campaignIdsOrTitles: [String!], $startDate: Date, $endDate: Date, $include: [ID!], $exclude: [ID!]) {
  contactSegmentGroups {
    id
    archived
    status
    createdAt
    description
    name
    updatedAt
    segments {
      ...ContactSegmentFields
    }
  }
  analyticsSegmentsActivity(
    campaignIdsOrTitles: $campaignIdsOrTitles
    startDate: $startDate
    endDate: $endDate
    include: $include
    exclude: $exclude
  ) {
    segment {
      id
    }
    activity {
      ...AnalyticsActivityFields
    }
  }
}
    ${ContactSegmentFieldsFragmentDoc}
${AnalyticsActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsSegmentsActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsSegmentsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSegmentsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSegmentsActivityQuery({
 *   variables: {
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useAnalyticsSegmentsActivityQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>(AnalyticsSegmentsActivityDocument, options);
      }
export function useAnalyticsSegmentsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>(AnalyticsSegmentsActivityDocument, options);
        }
export function useAnalyticsSegmentsActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>(AnalyticsSegmentsActivityDocument, options);
        }
export type AnalyticsSegmentsActivityQueryHookResult = ReturnType<typeof useAnalyticsSegmentsActivityQuery>;
export type AnalyticsSegmentsActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsSegmentsActivityLazyQuery>;
export type AnalyticsSegmentsActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsSegmentsActivitySuspenseQuery>;
export type AnalyticsSegmentsActivityQueryResult = Apollo.QueryResult<AnalyticsSegmentsActivityQuery, AnalyticsSegmentsActivityQueryVariables>;
export const SegmentGroupsAnalyticsDocument = gql`
    query SegmentGroupsAnalytics {
  contactSegmentGroups {
    id
    archived
    status
    createdAt
    description
    name
    updatedAt
    segments {
      id
      name
      segmentGroupId
      createdAt
      updatedAt
      priority
      fallback
    }
  }
}
    `;

/**
 * __useSegmentGroupsAnalyticsQuery__
 *
 * To run a query within a React component, call `useSegmentGroupsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentGroupsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentGroupsAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentGroupsAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>(SegmentGroupsAnalyticsDocument, options);
      }
export function useSegmentGroupsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>(SegmentGroupsAnalyticsDocument, options);
        }
export function useSegmentGroupsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>(SegmentGroupsAnalyticsDocument, options);
        }
export type SegmentGroupsAnalyticsQueryHookResult = ReturnType<typeof useSegmentGroupsAnalyticsQuery>;
export type SegmentGroupsAnalyticsLazyQueryHookResult = ReturnType<typeof useSegmentGroupsAnalyticsLazyQuery>;
export type SegmentGroupsAnalyticsSuspenseQueryHookResult = ReturnType<typeof useSegmentGroupsAnalyticsSuspenseQuery>;
export type SegmentGroupsAnalyticsQueryResult = Apollo.QueryResult<SegmentGroupsAnalyticsQuery, SegmentGroupsAnalyticsQueryVariables>;
export const ContactTableCountDocument = gql`
    query ContactTableCount {
  contactTableCount
}
    `;

/**
 * __useContactTableCountQuery__
 *
 * To run a query within a React component, call `useContactTableCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactTableCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactTableCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactTableCountQuery(baseOptions?: Apollo.QueryHookOptions<ContactTableCountQuery, ContactTableCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactTableCountQuery, ContactTableCountQueryVariables>(ContactTableCountDocument, options);
      }
export function useContactTableCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactTableCountQuery, ContactTableCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactTableCountQuery, ContactTableCountQueryVariables>(ContactTableCountDocument, options);
        }
export function useContactTableCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactTableCountQuery, ContactTableCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactTableCountQuery, ContactTableCountQueryVariables>(ContactTableCountDocument, options);
        }
export type ContactTableCountQueryHookResult = ReturnType<typeof useContactTableCountQuery>;
export type ContactTableCountLazyQueryHookResult = ReturnType<typeof useContactTableCountLazyQuery>;
export type ContactTableCountSuspenseQueryHookResult = ReturnType<typeof useContactTableCountSuspenseQuery>;
export type ContactTableCountQueryResult = Apollo.QueryResult<ContactTableCountQuery, ContactTableCountQueryVariables>;
export const AnalyticsSegmentCampaignsActivityDocument = gql`
    query AnalyticsSegmentCampaignsActivity($campaignIdsOrTitles: [String!], $campaignStages: [CampaignStageType!], $endDate: Date, $excludeCampaignTagIds: [ID!], $includeCampaignTagIds: [ID!], $segmentGroupId: ID!, $startDate: Date) {
  analyticsV2SegmentGroupCampaignMetrics(
    endDate: $endDate
    startDate: $startDate
    campaignIdsOrTitles: $campaignIdsOrTitles
    campaignStages: $campaignStages
    excludeCampaignTagIds: $excludeCampaignTagIds
    includeCampaignTagIds: $includeCampaignTagIds
    segmentGroupId: $segmentGroupId
  ) {
    campaign {
      id
      title
    }
    segments {
      segment {
        id
        name
      }
      metrics {
        ...AnalyticsV2BaseMetricsFields
      }
    }
  }
}
    ${AnalyticsV2BaseMetricsFieldsFragmentDoc}`;

/**
 * __useAnalyticsSegmentCampaignsActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsSegmentCampaignsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSegmentCampaignsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSegmentCampaignsActivityQuery({
 *   variables: {
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      campaignStages: // value for 'campaignStages'
 *      endDate: // value for 'endDate'
 *      excludeCampaignTagIds: // value for 'excludeCampaignTagIds'
 *      includeCampaignTagIds: // value for 'includeCampaignTagIds'
 *      segmentGroupId: // value for 'segmentGroupId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAnalyticsSegmentCampaignsActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables> & ({ variables: AnalyticsSegmentCampaignsActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables>(AnalyticsSegmentCampaignsActivityDocument, options);
      }
export function useAnalyticsSegmentCampaignsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables>(AnalyticsSegmentCampaignsActivityDocument, options);
        }
export function useAnalyticsSegmentCampaignsActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables>(AnalyticsSegmentCampaignsActivityDocument, options);
        }
export type AnalyticsSegmentCampaignsActivityQueryHookResult = ReturnType<typeof useAnalyticsSegmentCampaignsActivityQuery>;
export type AnalyticsSegmentCampaignsActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsSegmentCampaignsActivityLazyQuery>;
export type AnalyticsSegmentCampaignsActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsSegmentCampaignsActivitySuspenseQuery>;
export type AnalyticsSegmentCampaignsActivityQueryResult = Apollo.QueryResult<AnalyticsSegmentCampaignsActivityQuery, AnalyticsSegmentCampaignsActivityQueryVariables>;
export const ReportingSegmentsCampaignsMetricsDocument = gql`
    query ReportingSegmentsCampaignsMetrics($filter: SegmentGroupCampaignMetricsFilter!) {
  segmentGroupCampaignMetrics(filter: $filter) {
    campaign {
      id
      title
    }
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingSegmentsCampaignsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingSegmentsCampaignsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingSegmentsCampaignsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSegmentsCampaignsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingSegmentsCampaignsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables> & ({ variables: ReportingSegmentsCampaignsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables>(ReportingSegmentsCampaignsMetricsDocument, options);
      }
export function useReportingSegmentsCampaignsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables>(ReportingSegmentsCampaignsMetricsDocument, options);
        }
export function useReportingSegmentsCampaignsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables>(ReportingSegmentsCampaignsMetricsDocument, options);
        }
export type ReportingSegmentsCampaignsMetricsQueryHookResult = ReturnType<typeof useReportingSegmentsCampaignsMetricsQuery>;
export type ReportingSegmentsCampaignsMetricsLazyQueryHookResult = ReturnType<typeof useReportingSegmentsCampaignsMetricsLazyQuery>;
export type ReportingSegmentsCampaignsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingSegmentsCampaignsMetricsSuspenseQuery>;
export type ReportingSegmentsCampaignsMetricsQueryResult = Apollo.QueryResult<ReportingSegmentsCampaignsMetricsQuery, ReportingSegmentsCampaignsMetricsQueryVariables>;
export const AnalyticsSegmentGroupActivityDocument = gql`
    query AnalyticsSegmentGroupActivity($campaignIdsOrTitles: [String!], $endDate: Date, $exclude: [ID!], $include: [ID!], $segmentGroupId: ID!, $startDate: Date) {
  analyticsSegmentGroupActivity(
    startDate: $startDate
    endDate: $endDate
    campaignIdsOrTitles: $campaignIdsOrTitles
    exclude: $exclude
    include: $include
    segmentGroupId: $segmentGroupId
  ) {
    segmentGroup {
      id
      name
      createdAt
    }
    segments {
      segment {
        id
        segment: name
      }
      activity {
        ...AnalyticsActivityFields
      }
    }
  }
}
    ${AnalyticsActivityFieldsFragmentDoc}`;

/**
 * __useAnalyticsSegmentGroupActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsSegmentGroupActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSegmentGroupActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSegmentGroupActivityQuery({
 *   variables: {
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      endDate: // value for 'endDate'
 *      exclude: // value for 'exclude'
 *      include: // value for 'include'
 *      segmentGroupId: // value for 'segmentGroupId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAnalyticsSegmentGroupActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables> & ({ variables: AnalyticsSegmentGroupActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables>(AnalyticsSegmentGroupActivityDocument, options);
      }
export function useAnalyticsSegmentGroupActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables>(AnalyticsSegmentGroupActivityDocument, options);
        }
export function useAnalyticsSegmentGroupActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables>(AnalyticsSegmentGroupActivityDocument, options);
        }
export type AnalyticsSegmentGroupActivityQueryHookResult = ReturnType<typeof useAnalyticsSegmentGroupActivityQuery>;
export type AnalyticsSegmentGroupActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsSegmentGroupActivityLazyQuery>;
export type AnalyticsSegmentGroupActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsSegmentGroupActivitySuspenseQuery>;
export type AnalyticsSegmentGroupActivityQueryResult = Apollo.QueryResult<AnalyticsSegmentGroupActivityQuery, AnalyticsSegmentGroupActivityQueryVariables>;
export const AnalyticsSegmentCreativesActivityDocument = gql`
    query AnalyticsSegmentCreativesActivity($startDate: Date, $endDate: Date, $campaignIdsOrTitles: [String!], $campaignStages: [CampaignStageType!], $creativeIdsOrTitles: [String!], $creativeStatuses: [CreativeStatus!], $excludeCampaignTagIds: [ID!], $excludeCreativeTagIds: [ID!], $includeCampaignTagIds: [ID!], $includeCreativeTagIds: [ID!], $segmentGroupId: ID!) {
  analyticsV2SegmentGroupCreativeMetrics(
    startDate: $startDate
    endDate: $endDate
    campaignIdsOrTitles: $campaignIdsOrTitles
    campaignStages: $campaignStages
    creativeIdsOrTitles: $creativeIdsOrTitles
    creativeStatuses: $creativeStatuses
    excludeCampaignTagIds: $excludeCampaignTagIds
    excludeCreativeTagIds: $excludeCreativeTagIds
    includeCampaignTagIds: $includeCampaignTagIds
    includeCreativeTagIds: $includeCreativeTagIds
    segmentGroupId: $segmentGroupId
  ) {
    creative {
      id
      title
    }
    segments {
      segment {
        id
        name
      }
      metrics {
        ...AnalyticsV2BaseCreativeMetricsFields
      }
    }
  }
}
    ${AnalyticsV2BaseCreativeMetricsFieldsFragmentDoc}`;

/**
 * __useAnalyticsSegmentCreativesActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsSegmentCreativesActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSegmentCreativesActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSegmentCreativesActivityQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      campaignStages: // value for 'campaignStages'
 *      creativeIdsOrTitles: // value for 'creativeIdsOrTitles'
 *      creativeStatuses: // value for 'creativeStatuses'
 *      excludeCampaignTagIds: // value for 'excludeCampaignTagIds'
 *      excludeCreativeTagIds: // value for 'excludeCreativeTagIds'
 *      includeCampaignTagIds: // value for 'includeCampaignTagIds'
 *      includeCreativeTagIds: // value for 'includeCreativeTagIds'
 *      segmentGroupId: // value for 'segmentGroupId'
 *   },
 * });
 */
export function useAnalyticsSegmentCreativesActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables> & ({ variables: AnalyticsSegmentCreativesActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables>(AnalyticsSegmentCreativesActivityDocument, options);
      }
export function useAnalyticsSegmentCreativesActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables>(AnalyticsSegmentCreativesActivityDocument, options);
        }
export function useAnalyticsSegmentCreativesActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables>(AnalyticsSegmentCreativesActivityDocument, options);
        }
export type AnalyticsSegmentCreativesActivityQueryHookResult = ReturnType<typeof useAnalyticsSegmentCreativesActivityQuery>;
export type AnalyticsSegmentCreativesActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsSegmentCreativesActivityLazyQuery>;
export type AnalyticsSegmentCreativesActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsSegmentCreativesActivitySuspenseQuery>;
export type AnalyticsSegmentCreativesActivityQueryResult = Apollo.QueryResult<AnalyticsSegmentCreativesActivityQuery, AnalyticsSegmentCreativesActivityQueryVariables>;
export const ReportingSegmentCreativesMetricsDocument = gql`
    query ReportingSegmentCreativesMetrics($filter: SegmentGroupCreativeMetricsFilter!) {
  segmentGroupCreativeMetrics(filter: $filter) {
    creative {
      id
      title
    }
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingSegmentCreativesMetricsQuery__
 *
 * To run a query within a React component, call `useReportingSegmentCreativesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingSegmentCreativesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSegmentCreativesMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingSegmentCreativesMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables> & ({ variables: ReportingSegmentCreativesMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables>(ReportingSegmentCreativesMetricsDocument, options);
      }
export function useReportingSegmentCreativesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables>(ReportingSegmentCreativesMetricsDocument, options);
        }
export function useReportingSegmentCreativesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables>(ReportingSegmentCreativesMetricsDocument, options);
        }
export type ReportingSegmentCreativesMetricsQueryHookResult = ReturnType<typeof useReportingSegmentCreativesMetricsQuery>;
export type ReportingSegmentCreativesMetricsLazyQueryHookResult = ReturnType<typeof useReportingSegmentCreativesMetricsLazyQuery>;
export type ReportingSegmentCreativesMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingSegmentCreativesMetricsSuspenseQuery>;
export type ReportingSegmentCreativesMetricsQueryResult = Apollo.QueryResult<ReportingSegmentCreativesMetricsQuery, ReportingSegmentCreativesMetricsQueryVariables>;
export const AnalyticsV2SegmentExportDocument = gql`
    mutation AnalyticsV2SegmentExport($columns: [String!]!, $dateRange: DateRange!, $filters: [AnalyticsFilterInput!]!, $segmentGroupId: ID) {
  analyticsV2SegmentExport(
    columns: $columns
    dateRange: $dateRange
    filters: $filters
    segmentGroupId: $segmentGroupId
  ) {
    signedUrl
  }
}
    `;
export type AnalyticsV2SegmentExportMutationFn = Apollo.MutationFunction<AnalyticsV2SegmentExportMutation, AnalyticsV2SegmentExportMutationVariables>;

/**
 * __useAnalyticsV2SegmentExportMutation__
 *
 * To run a mutation, you first call `useAnalyticsV2SegmentExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2SegmentExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsV2SegmentExportMutation, { data, loading, error }] = useAnalyticsV2SegmentExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      segmentGroupId: // value for 'segmentGroupId'
 *   },
 * });
 */
export function useAnalyticsV2SegmentExportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsV2SegmentExportMutation, AnalyticsV2SegmentExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsV2SegmentExportMutation, AnalyticsV2SegmentExportMutationVariables>(AnalyticsV2SegmentExportDocument, options);
      }
export type AnalyticsV2SegmentExportMutationHookResult = ReturnType<typeof useAnalyticsV2SegmentExportMutation>;
export type AnalyticsV2SegmentExportMutationResult = Apollo.MutationResult<AnalyticsV2SegmentExportMutation>;
export type AnalyticsV2SegmentExportMutationOptions = Apollo.BaseMutationOptions<AnalyticsV2SegmentExportMutation, AnalyticsV2SegmentExportMutationVariables>;
export const AnalyticsV2SegmentCampaignExportDocument = gql`
    mutation AnalyticsV2SegmentCampaignExport($columns: [String!]!, $dateRange: DateRange!, $filters: [AnalyticsFilterInput!]!, $segmentGroupId: ID!) {
  analyticsV2CampaignSegmentExport(
    columns: $columns
    dateRange: $dateRange
    filters: $filters
    segmentGroupId: $segmentGroupId
  ) {
    signedUrl
  }
}
    `;
export type AnalyticsV2SegmentCampaignExportMutationFn = Apollo.MutationFunction<AnalyticsV2SegmentCampaignExportMutation, AnalyticsV2SegmentCampaignExportMutationVariables>;

/**
 * __useAnalyticsV2SegmentCampaignExportMutation__
 *
 * To run a mutation, you first call `useAnalyticsV2SegmentCampaignExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2SegmentCampaignExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsV2SegmentCampaignExportMutation, { data, loading, error }] = useAnalyticsV2SegmentCampaignExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      segmentGroupId: // value for 'segmentGroupId'
 *   },
 * });
 */
export function useAnalyticsV2SegmentCampaignExportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsV2SegmentCampaignExportMutation, AnalyticsV2SegmentCampaignExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsV2SegmentCampaignExportMutation, AnalyticsV2SegmentCampaignExportMutationVariables>(AnalyticsV2SegmentCampaignExportDocument, options);
      }
export type AnalyticsV2SegmentCampaignExportMutationHookResult = ReturnType<typeof useAnalyticsV2SegmentCampaignExportMutation>;
export type AnalyticsV2SegmentCampaignExportMutationResult = Apollo.MutationResult<AnalyticsV2SegmentCampaignExportMutation>;
export type AnalyticsV2SegmentCampaignExportMutationOptions = Apollo.BaseMutationOptions<AnalyticsV2SegmentCampaignExportMutation, AnalyticsV2SegmentCampaignExportMutationVariables>;
export const AnalyticsV2SegmentCreativeExportDocument = gql`
    mutation AnalyticsV2SegmentCreativeExport($columns: [String!]!, $dateRange: DateRange!, $filters: [AnalyticsFilterInput!]!, $segmentGroupId: ID!) {
  analyticsV2CreativeSegmentExport(
    columns: $columns
    dateRange: $dateRange
    filters: $filters
    segmentGroupId: $segmentGroupId
  ) {
    signedUrl
  }
}
    `;
export type AnalyticsV2SegmentCreativeExportMutationFn = Apollo.MutationFunction<AnalyticsV2SegmentCreativeExportMutation, AnalyticsV2SegmentCreativeExportMutationVariables>;

/**
 * __useAnalyticsV2SegmentCreativeExportMutation__
 *
 * To run a mutation, you first call `useAnalyticsV2SegmentCreativeExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsV2SegmentCreativeExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsV2SegmentCreativeExportMutation, { data, loading, error }] = useAnalyticsV2SegmentCreativeExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      segmentGroupId: // value for 'segmentGroupId'
 *   },
 * });
 */
export function useAnalyticsV2SegmentCreativeExportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsV2SegmentCreativeExportMutation, AnalyticsV2SegmentCreativeExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsV2SegmentCreativeExportMutation, AnalyticsV2SegmentCreativeExportMutationVariables>(AnalyticsV2SegmentCreativeExportDocument, options);
      }
export type AnalyticsV2SegmentCreativeExportMutationHookResult = ReturnType<typeof useAnalyticsV2SegmentCreativeExportMutation>;
export type AnalyticsV2SegmentCreativeExportMutationResult = Apollo.MutationResult<AnalyticsV2SegmentCreativeExportMutation>;
export type AnalyticsV2SegmentCreativeExportMutationOptions = Apollo.BaseMutationOptions<AnalyticsV2SegmentCreativeExportMutation, AnalyticsV2SegmentCreativeExportMutationVariables>;
export const SegmentGroupsMetricsDocument = gql`
    query SegmentGroupsMetrics($filter: SegmentGroupMetricsFilter!) {
  segmentGroupsMetrics(filter: $filter) {
    audience {
      id
      name
      description
      updatedAt
      createdAt
    }
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useSegmentGroupsMetricsQuery__
 *
 * To run a query within a React component, call `useSegmentGroupsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentGroupsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentGroupsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSegmentGroupsMetricsQuery(baseOptions: Apollo.QueryHookOptions<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables> & ({ variables: SegmentGroupsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables>(SegmentGroupsMetricsDocument, options);
      }
export function useSegmentGroupsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables>(SegmentGroupsMetricsDocument, options);
        }
export function useSegmentGroupsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables>(SegmentGroupsMetricsDocument, options);
        }
export type SegmentGroupsMetricsQueryHookResult = ReturnType<typeof useSegmentGroupsMetricsQuery>;
export type SegmentGroupsMetricsLazyQueryHookResult = ReturnType<typeof useSegmentGroupsMetricsLazyQuery>;
export type SegmentGroupsMetricsSuspenseQueryHookResult = ReturnType<typeof useSegmentGroupsMetricsSuspenseQuery>;
export type SegmentGroupsMetricsQueryResult = Apollo.QueryResult<SegmentGroupsMetricsQuery, SegmentGroupsMetricsQueryVariables>;
export const SegmentGroupsMetricsExportDocument = gql`
    mutation SegmentGroupsMetricsExport($columns: [String!]!, $filter: SegmentGroupMetricsFilter!, $includeMetadata: Boolean, $recurringExportId: ID) {
  segmentGroupsMetricsExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type SegmentGroupsMetricsExportMutationFn = Apollo.MutationFunction<SegmentGroupsMetricsExportMutation, SegmentGroupsMetricsExportMutationVariables>;

/**
 * __useSegmentGroupsMetricsExportMutation__
 *
 * To run a mutation, you first call `useSegmentGroupsMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentGroupsMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentGroupsMetricsExportMutation, { data, loading, error }] = useSegmentGroupsMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useSegmentGroupsMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<SegmentGroupsMetricsExportMutation, SegmentGroupsMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentGroupsMetricsExportMutation, SegmentGroupsMetricsExportMutationVariables>(SegmentGroupsMetricsExportDocument, options);
      }
export type SegmentGroupsMetricsExportMutationHookResult = ReturnType<typeof useSegmentGroupsMetricsExportMutation>;
export type SegmentGroupsMetricsExportMutationResult = Apollo.MutationResult<SegmentGroupsMetricsExportMutation>;
export type SegmentGroupsMetricsExportMutationOptions = Apollo.BaseMutationOptions<SegmentGroupsMetricsExportMutation, SegmentGroupsMetricsExportMutationVariables>;
export const SegmentGroupCampaignMetricsExportDocument = gql`
    mutation SegmentGroupCampaignMetricsExport($columns: [String!]!, $filter: SegmentGroupCampaignMetricsFilter!, $groupBy: CampaignGroupBy, $includeMetadata: Boolean, $recurringExportId: ID) {
  segmentGroupCampaignMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type SegmentGroupCampaignMetricsExportMutationFn = Apollo.MutationFunction<SegmentGroupCampaignMetricsExportMutation, SegmentGroupCampaignMetricsExportMutationVariables>;

/**
 * __useSegmentGroupCampaignMetricsExportMutation__
 *
 * To run a mutation, you first call `useSegmentGroupCampaignMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentGroupCampaignMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentGroupCampaignMetricsExportMutation, { data, loading, error }] = useSegmentGroupCampaignMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useSegmentGroupCampaignMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<SegmentGroupCampaignMetricsExportMutation, SegmentGroupCampaignMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentGroupCampaignMetricsExportMutation, SegmentGroupCampaignMetricsExportMutationVariables>(SegmentGroupCampaignMetricsExportDocument, options);
      }
export type SegmentGroupCampaignMetricsExportMutationHookResult = ReturnType<typeof useSegmentGroupCampaignMetricsExportMutation>;
export type SegmentGroupCampaignMetricsExportMutationResult = Apollo.MutationResult<SegmentGroupCampaignMetricsExportMutation>;
export type SegmentGroupCampaignMetricsExportMutationOptions = Apollo.BaseMutationOptions<SegmentGroupCampaignMetricsExportMutation, SegmentGroupCampaignMetricsExportMutationVariables>;
export const SegmentGroupCreativeMetricsExportDocument = gql`
    mutation SegmentGroupCreativeMetricsExport($columns: [String!]!, $filter: SegmentGroupCreativeMetricsFilter!, $groupBy: CreativeGroupBy, $includeMetadata: Boolean, $recurringExportId: ID) {
  segmentGroupCreativeMetricsExport(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type SegmentGroupCreativeMetricsExportMutationFn = Apollo.MutationFunction<SegmentGroupCreativeMetricsExportMutation, SegmentGroupCreativeMetricsExportMutationVariables>;

/**
 * __useSegmentGroupCreativeMetricsExportMutation__
 *
 * To run a mutation, you first call `useSegmentGroupCreativeMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentGroupCreativeMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentGroupCreativeMetricsExportMutation, { data, loading, error }] = useSegmentGroupCreativeMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useSegmentGroupCreativeMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<SegmentGroupCreativeMetricsExportMutation, SegmentGroupCreativeMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentGroupCreativeMetricsExportMutation, SegmentGroupCreativeMetricsExportMutationVariables>(SegmentGroupCreativeMetricsExportDocument, options);
      }
export type SegmentGroupCreativeMetricsExportMutationHookResult = ReturnType<typeof useSegmentGroupCreativeMetricsExportMutation>;
export type SegmentGroupCreativeMetricsExportMutationResult = Apollo.MutationResult<SegmentGroupCreativeMetricsExportMutation>;
export type SegmentGroupCreativeMetricsExportMutationOptions = Apollo.BaseMutationOptions<SegmentGroupCreativeMetricsExportMutation, SegmentGroupCreativeMetricsExportMutationVariables>;
export const ReportingGroupedSegmentGroupCampaignMetricsDocument = gql`
    query ReportingGroupedSegmentGroupCampaignMetrics($filter: SegmentGroupCampaignMetricsFilter!, $groupBy: CampaignGroupBy!) {
  groupedSegmentGroupCampaignMetrics(filter: $filter, groupBy: $groupBy) {
    group
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingGroupedSegmentGroupCampaignMetricsQuery__
 *
 * To run a query within a React component, call `useReportingGroupedSegmentGroupCampaignMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingGroupedSegmentGroupCampaignMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingGroupedSegmentGroupCampaignMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useReportingGroupedSegmentGroupCampaignMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables> & ({ variables: ReportingGroupedSegmentGroupCampaignMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables>(ReportingGroupedSegmentGroupCampaignMetricsDocument, options);
      }
export function useReportingGroupedSegmentGroupCampaignMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables>(ReportingGroupedSegmentGroupCampaignMetricsDocument, options);
        }
export function useReportingGroupedSegmentGroupCampaignMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables>(ReportingGroupedSegmentGroupCampaignMetricsDocument, options);
        }
export type ReportingGroupedSegmentGroupCampaignMetricsQueryHookResult = ReturnType<typeof useReportingGroupedSegmentGroupCampaignMetricsQuery>;
export type ReportingGroupedSegmentGroupCampaignMetricsLazyQueryHookResult = ReturnType<typeof useReportingGroupedSegmentGroupCampaignMetricsLazyQuery>;
export type ReportingGroupedSegmentGroupCampaignMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingGroupedSegmentGroupCampaignMetricsSuspenseQuery>;
export type ReportingGroupedSegmentGroupCampaignMetricsQueryResult = Apollo.QueryResult<ReportingGroupedSegmentGroupCampaignMetricsQuery, ReportingGroupedSegmentGroupCampaignMetricsQueryVariables>;
export const ReportingGroupedSegmentGroupCreativeMetricsDocument = gql`
    query ReportingGroupedSegmentGroupCreativeMetrics($filter: SegmentGroupCreativeMetricsFilter!, $groupBy: CreativeGroupBy!) {
  groupedSegmentGroupCreativeMetrics(filter: $filter, groupBy: $groupBy) {
    group
    segments {
      split {
        id
        name
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingGroupedSegmentGroupCreativeMetricsQuery__
 *
 * To run a query within a React component, call `useReportingGroupedSegmentGroupCreativeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingGroupedSegmentGroupCreativeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingGroupedSegmentGroupCreativeMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useReportingGroupedSegmentGroupCreativeMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables> & ({ variables: ReportingGroupedSegmentGroupCreativeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables>(ReportingGroupedSegmentGroupCreativeMetricsDocument, options);
      }
export function useReportingGroupedSegmentGroupCreativeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables>(ReportingGroupedSegmentGroupCreativeMetricsDocument, options);
        }
export function useReportingGroupedSegmentGroupCreativeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables>(ReportingGroupedSegmentGroupCreativeMetricsDocument, options);
        }
export type ReportingGroupedSegmentGroupCreativeMetricsQueryHookResult = ReturnType<typeof useReportingGroupedSegmentGroupCreativeMetricsQuery>;
export type ReportingGroupedSegmentGroupCreativeMetricsLazyQueryHookResult = ReturnType<typeof useReportingGroupedSegmentGroupCreativeMetricsLazyQuery>;
export type ReportingGroupedSegmentGroupCreativeMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingGroupedSegmentGroupCreativeMetricsSuspenseQuery>;
export type ReportingGroupedSegmentGroupCreativeMetricsQueryResult = Apollo.QueryResult<ReportingGroupedSegmentGroupCreativeMetricsQuery, ReportingGroupedSegmentGroupCreativeMetricsQueryVariables>;
export const ReportingSegmentExperimentsMetricsDocument = gql`
    query ReportingSegmentExperimentsMetrics($filter: SegmentExperimentMetricsFilter!) {
  segmentExperimentMetrics(filter: $filter) {
    experiment {
      id
      title
      status
      resultsRestrictedToStaff
      minDate
      maxDate
    }
    treatments {
      treatment {
        id
        title
      }
      splits {
        split {
          id
          name
        }
        metrics {
          ...MetricFields
        }
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useReportingSegmentExperimentsMetricsQuery__
 *
 * To run a query within a React component, call `useReportingSegmentExperimentsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingSegmentExperimentsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSegmentExperimentsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportingSegmentExperimentsMetricsQuery(baseOptions: Apollo.QueryHookOptions<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables> & ({ variables: ReportingSegmentExperimentsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables>(ReportingSegmentExperimentsMetricsDocument, options);
      }
export function useReportingSegmentExperimentsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables>(ReportingSegmentExperimentsMetricsDocument, options);
        }
export function useReportingSegmentExperimentsMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables>(ReportingSegmentExperimentsMetricsDocument, options);
        }
export type ReportingSegmentExperimentsMetricsQueryHookResult = ReturnType<typeof useReportingSegmentExperimentsMetricsQuery>;
export type ReportingSegmentExperimentsMetricsLazyQueryHookResult = ReturnType<typeof useReportingSegmentExperimentsMetricsLazyQuery>;
export type ReportingSegmentExperimentsMetricsSuspenseQueryHookResult = ReturnType<typeof useReportingSegmentExperimentsMetricsSuspenseQuery>;
export type ReportingSegmentExperimentsMetricsQueryResult = Apollo.QueryResult<ReportingSegmentExperimentsMetricsQuery, ReportingSegmentExperimentsMetricsQueryVariables>;
export const SegmentExperimentMetricsExportDocument = gql`
    mutation SegmentExperimentMetricsExport($columns: [String!]!, $filter: SegmentExperimentMetricsFilter!, $includeMetadata: Boolean, $recurringExportId: ID) {
  segmentExperimentMetricsExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type SegmentExperimentMetricsExportMutationFn = Apollo.MutationFunction<SegmentExperimentMetricsExportMutation, SegmentExperimentMetricsExportMutationVariables>;

/**
 * __useSegmentExperimentMetricsExportMutation__
 *
 * To run a mutation, you first call `useSegmentExperimentMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentExperimentMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentExperimentMetricsExportMutation, { data, loading, error }] = useSegmentExperimentMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useSegmentExperimentMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<SegmentExperimentMetricsExportMutation, SegmentExperimentMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentExperimentMetricsExportMutation, SegmentExperimentMetricsExportMutationVariables>(SegmentExperimentMetricsExportDocument, options);
      }
export type SegmentExperimentMetricsExportMutationHookResult = ReturnType<typeof useSegmentExperimentMetricsExportMutation>;
export type SegmentExperimentMetricsExportMutationResult = Apollo.MutationResult<SegmentExperimentMetricsExportMutation>;
export type SegmentExperimentMetricsExportMutationOptions = Apollo.BaseMutationOptions<SegmentExperimentMetricsExportMutation, SegmentExperimentMetricsExportMutationVariables>;
export const ContactSegmentGroupCountsDocument = gql`
    query ContactSegmentGroupCounts($id: ID!) {
  contactSegmentGroupCounts(id: $id) {
    total
    segmentCounts {
      id
      total
    }
  }
}
    `;

/**
 * __useContactSegmentGroupCountsQuery__
 *
 * To run a query within a React component, call `useContactSegmentGroupCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentGroupCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSegmentGroupCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactSegmentGroupCountsQuery(baseOptions: Apollo.QueryHookOptions<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables> & ({ variables: ContactSegmentGroupCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables>(ContactSegmentGroupCountsDocument, options);
      }
export function useContactSegmentGroupCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables>(ContactSegmentGroupCountsDocument, options);
        }
export function useContactSegmentGroupCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables>(ContactSegmentGroupCountsDocument, options);
        }
export type ContactSegmentGroupCountsQueryHookResult = ReturnType<typeof useContactSegmentGroupCountsQuery>;
export type ContactSegmentGroupCountsLazyQueryHookResult = ReturnType<typeof useContactSegmentGroupCountsLazyQuery>;
export type ContactSegmentGroupCountsSuspenseQueryHookResult = ReturnType<typeof useContactSegmentGroupCountsSuspenseQuery>;
export type ContactSegmentGroupCountsQueryResult = Apollo.QueryResult<ContactSegmentGroupCountsQuery, ContactSegmentGroupCountsQueryVariables>;
export const ContactSegmentGroupAutoSegmentCreateDocument = gql`
    mutation ContactSegmentGroupAutoSegmentCreate($id: ID!, $attributeIds: [ID!]!) {
  contactSegmentGroupAutoSegmentCreate(id: $id, attributeIds: $attributeIds) {
    contactSegmentGroup {
      id
      name
      segments {
        id
        segmentGroupId
        name
        query
      }
    }
  }
}
    `;
export type ContactSegmentGroupAutoSegmentCreateMutationFn = Apollo.MutationFunction<ContactSegmentGroupAutoSegmentCreateMutation, ContactSegmentGroupAutoSegmentCreateMutationVariables>;

/**
 * __useContactSegmentGroupAutoSegmentCreateMutation__
 *
 * To run a mutation, you first call `useContactSegmentGroupAutoSegmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentGroupAutoSegmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSegmentGroupAutoSegmentCreateMutation, { data, loading, error }] = useContactSegmentGroupAutoSegmentCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributeIds: // value for 'attributeIds'
 *   },
 * });
 */
export function useContactSegmentGroupAutoSegmentCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContactSegmentGroupAutoSegmentCreateMutation, ContactSegmentGroupAutoSegmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSegmentGroupAutoSegmentCreateMutation, ContactSegmentGroupAutoSegmentCreateMutationVariables>(ContactSegmentGroupAutoSegmentCreateDocument, options);
      }
export type ContactSegmentGroupAutoSegmentCreateMutationHookResult = ReturnType<typeof useContactSegmentGroupAutoSegmentCreateMutation>;
export type ContactSegmentGroupAutoSegmentCreateMutationResult = Apollo.MutationResult<ContactSegmentGroupAutoSegmentCreateMutation>;
export type ContactSegmentGroupAutoSegmentCreateMutationOptions = Apollo.BaseMutationOptions<ContactSegmentGroupAutoSegmentCreateMutation, ContactSegmentGroupAutoSegmentCreateMutationVariables>;
export const DataCategoryFieldsDocument = gql`
    query DataCategoryFields($tableId: ID!) {
  dataFields(tableId: $tableId, types: [CATEGORY]) {
    id
    name
    displayName
    type
    primaryKey
  }
}
    `;

/**
 * __useDataCategoryFieldsQuery__
 *
 * To run a query within a React component, call `useDataCategoryFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCategoryFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCategoryFieldsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDataCategoryFieldsQuery(baseOptions: Apollo.QueryHookOptions<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables> & ({ variables: DataCategoryFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables>(DataCategoryFieldsDocument, options);
      }
export function useDataCategoryFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables>(DataCategoryFieldsDocument, options);
        }
export function useDataCategoryFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables>(DataCategoryFieldsDocument, options);
        }
export type DataCategoryFieldsQueryHookResult = ReturnType<typeof useDataCategoryFieldsQuery>;
export type DataCategoryFieldsLazyQueryHookResult = ReturnType<typeof useDataCategoryFieldsLazyQuery>;
export type DataCategoryFieldsSuspenseQueryHookResult = ReturnType<typeof useDataCategoryFieldsSuspenseQuery>;
export type DataCategoryFieldsQueryResult = Apollo.QueryResult<DataCategoryFieldsQuery, DataCategoryFieldsQueryVariables>;
export const ContactSegmentUpdate2Document = gql`
    mutation ContactSegmentUpdate2($id: ID!, $name: String!, $query: ContactQuery!) {
  contactSegmentUpdate(id: $id, name: $name, query: $query) {
    contactSegment {
      id
      segmentGroupId
      query
    }
  }
}
    `;
export type ContactSegmentUpdate2MutationFn = Apollo.MutationFunction<ContactSegmentUpdate2Mutation, ContactSegmentUpdate2MutationVariables>;

/**
 * __useContactSegmentUpdate2Mutation__
 *
 * To run a mutation, you first call `useContactSegmentUpdate2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentUpdate2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSegmentUpdate2Mutation, { data, loading, error }] = useContactSegmentUpdate2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useContactSegmentUpdate2Mutation(baseOptions?: Apollo.MutationHookOptions<ContactSegmentUpdate2Mutation, ContactSegmentUpdate2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSegmentUpdate2Mutation, ContactSegmentUpdate2MutationVariables>(ContactSegmentUpdate2Document, options);
      }
export type ContactSegmentUpdate2MutationHookResult = ReturnType<typeof useContactSegmentUpdate2Mutation>;
export type ContactSegmentUpdate2MutationResult = Apollo.MutationResult<ContactSegmentUpdate2Mutation>;
export type ContactSegmentUpdate2MutationOptions = Apollo.BaseMutationOptions<ContactSegmentUpdate2Mutation, ContactSegmentUpdate2MutationVariables>;
export const ContactSegmentGroupAndCountsDocument = gql`
    query ContactSegmentGroupAndCounts($id: ID!) {
  contactSegmentGroup(id: $id) {
    id
    name
    description
    status
    segments {
      id
      segmentGroupId
      name
      query
    }
  }
  contactSegmentGroupCounts(id: $id) {
    total
    segmentCounts {
      id
      total
    }
  }
}
    `;

/**
 * __useContactSegmentGroupAndCountsQuery__
 *
 * To run a query within a React component, call `useContactSegmentGroupAndCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentGroupAndCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSegmentGroupAndCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactSegmentGroupAndCountsQuery(baseOptions: Apollo.QueryHookOptions<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables> & ({ variables: ContactSegmentGroupAndCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables>(ContactSegmentGroupAndCountsDocument, options);
      }
export function useContactSegmentGroupAndCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables>(ContactSegmentGroupAndCountsDocument, options);
        }
export function useContactSegmentGroupAndCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables>(ContactSegmentGroupAndCountsDocument, options);
        }
export type ContactSegmentGroupAndCountsQueryHookResult = ReturnType<typeof useContactSegmentGroupAndCountsQuery>;
export type ContactSegmentGroupAndCountsLazyQueryHookResult = ReturnType<typeof useContactSegmentGroupAndCountsLazyQuery>;
export type ContactSegmentGroupAndCountsSuspenseQueryHookResult = ReturnType<typeof useContactSegmentGroupAndCountsSuspenseQuery>;
export type ContactSegmentGroupAndCountsQueryResult = Apollo.QueryResult<ContactSegmentGroupAndCountsQuery, ContactSegmentGroupAndCountsQueryVariables>;
export const ContactSegmentGroupUpdate2Document = gql`
    mutation ContactSegmentGroupUpdate2($description: String, $id: ID!, $name: String, $status: ContactSegmentGroupStatus) {
  contactSegmentGroupUpdate(
    description: $description
    id: $id
    name: $name
    status: $status
  ) {
    contactSegmentGroup {
      id
      description
      name
      status
    }
  }
}
    `;
export type ContactSegmentGroupUpdate2MutationFn = Apollo.MutationFunction<ContactSegmentGroupUpdate2Mutation, ContactSegmentGroupUpdate2MutationVariables>;

/**
 * __useContactSegmentGroupUpdate2Mutation__
 *
 * To run a mutation, you first call `useContactSegmentGroupUpdate2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentGroupUpdate2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSegmentGroupUpdate2Mutation, { data, loading, error }] = useContactSegmentGroupUpdate2Mutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useContactSegmentGroupUpdate2Mutation(baseOptions?: Apollo.MutationHookOptions<ContactSegmentGroupUpdate2Mutation, ContactSegmentGroupUpdate2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSegmentGroupUpdate2Mutation, ContactSegmentGroupUpdate2MutationVariables>(ContactSegmentGroupUpdate2Document, options);
      }
export type ContactSegmentGroupUpdate2MutationHookResult = ReturnType<typeof useContactSegmentGroupUpdate2Mutation>;
export type ContactSegmentGroupUpdate2MutationResult = Apollo.MutationResult<ContactSegmentGroupUpdate2Mutation>;
export type ContactSegmentGroupUpdate2MutationOptions = Apollo.BaseMutationOptions<ContactSegmentGroupUpdate2Mutation, ContactSegmentGroupUpdate2MutationVariables>;
export const ContactSegmentGroupPriorityUpdate2Document = gql`
    mutation ContactSegmentGroupPriorityUpdate2($id: ID!, $segmentPriorities: [ContactSegmentGroupPriorityInput!]!) {
  contactSegmentGroupPriorityUpdate(
    id: $id
    segmentPriorities: $segmentPriorities
  ) {
    contactSegmentGroup {
      id
      archived
      createdAt
      updatedAt
      description
      name
      segments {
        id
        priority
      }
    }
  }
}
    `;
export type ContactSegmentGroupPriorityUpdate2MutationFn = Apollo.MutationFunction<ContactSegmentGroupPriorityUpdate2Mutation, ContactSegmentGroupPriorityUpdate2MutationVariables>;

/**
 * __useContactSegmentGroupPriorityUpdate2Mutation__
 *
 * To run a mutation, you first call `useContactSegmentGroupPriorityUpdate2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentGroupPriorityUpdate2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSegmentGroupPriorityUpdate2Mutation, { data, loading, error }] = useContactSegmentGroupPriorityUpdate2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      segmentPriorities: // value for 'segmentPriorities'
 *   },
 * });
 */
export function useContactSegmentGroupPriorityUpdate2Mutation(baseOptions?: Apollo.MutationHookOptions<ContactSegmentGroupPriorityUpdate2Mutation, ContactSegmentGroupPriorityUpdate2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSegmentGroupPriorityUpdate2Mutation, ContactSegmentGroupPriorityUpdate2MutationVariables>(ContactSegmentGroupPriorityUpdate2Document, options);
      }
export type ContactSegmentGroupPriorityUpdate2MutationHookResult = ReturnType<typeof useContactSegmentGroupPriorityUpdate2Mutation>;
export type ContactSegmentGroupPriorityUpdate2MutationResult = Apollo.MutationResult<ContactSegmentGroupPriorityUpdate2Mutation>;
export type ContactSegmentGroupPriorityUpdate2MutationOptions = Apollo.BaseMutationOptions<ContactSegmentGroupPriorityUpdate2Mutation, ContactSegmentGroupPriorityUpdate2MutationVariables>;
export const ContactSegmentDelete2Document = gql`
    mutation ContactSegmentDelete2($id: ID!) {
  contactSegmentDelete(id: $id) {
    id
    success
  }
}
    `;
export type ContactSegmentDelete2MutationFn = Apollo.MutationFunction<ContactSegmentDelete2Mutation, ContactSegmentDelete2MutationVariables>;

/**
 * __useContactSegmentDelete2Mutation__
 *
 * To run a mutation, you first call `useContactSegmentDelete2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentDelete2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSegmentDelete2Mutation, { data, loading, error }] = useContactSegmentDelete2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactSegmentDelete2Mutation(baseOptions?: Apollo.MutationHookOptions<ContactSegmentDelete2Mutation, ContactSegmentDelete2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSegmentDelete2Mutation, ContactSegmentDelete2MutationVariables>(ContactSegmentDelete2Document, options);
      }
export type ContactSegmentDelete2MutationHookResult = ReturnType<typeof useContactSegmentDelete2Mutation>;
export type ContactSegmentDelete2MutationResult = Apollo.MutationResult<ContactSegmentDelete2Mutation>;
export type ContactSegmentDelete2MutationOptions = Apollo.BaseMutationOptions<ContactSegmentDelete2Mutation, ContactSegmentDelete2MutationVariables>;
export const ContactSegmentCreateDocument = gql`
    mutation ContactSegmentCreate($name: String!, $query: ContactQuery!, $segmentGroupId: ID!) {
  contactSegmentCreate(
    name: $name
    query: $query
    segmentGroupId: $segmentGroupId
  ) {
    contactSegment {
      id
      segmentGroupId
      createdAt
      updatedAt
      name
      priority
      query
    }
  }
}
    `;
export type ContactSegmentCreateMutationFn = Apollo.MutationFunction<ContactSegmentCreateMutation, ContactSegmentCreateMutationVariables>;

/**
 * __useContactSegmentCreateMutation__
 *
 * To run a mutation, you first call `useContactSegmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSegmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSegmentCreateMutation, { data, loading, error }] = useContactSegmentCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      query: // value for 'query'
 *      segmentGroupId: // value for 'segmentGroupId'
 *   },
 * });
 */
export function useContactSegmentCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContactSegmentCreateMutation, ContactSegmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSegmentCreateMutation, ContactSegmentCreateMutationVariables>(ContactSegmentCreateDocument, options);
      }
export type ContactSegmentCreateMutationHookResult = ReturnType<typeof useContactSegmentCreateMutation>;
export type ContactSegmentCreateMutationResult = Apollo.MutationResult<ContactSegmentCreateMutation>;
export type ContactSegmentCreateMutationOptions = Apollo.BaseMutationOptions<ContactSegmentCreateMutation, ContactSegmentCreateMutationVariables>;
export const SubjectLinesMetricsDocument = gql`
    query SubjectLinesMetrics($filter: SubjectLineMetricsFilter!) {
  subjectlinesMetrics(filter: $filter) {
    subjectlines {
      subjectline {
        id
        content
        source
        tone
        creative {
          id
          title
        }
      }
      metrics {
        ...MetricFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

/**
 * __useSubjectLinesMetricsQuery__
 *
 * To run a query within a React component, call `useSubjectLinesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectLinesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectLinesMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSubjectLinesMetricsQuery(baseOptions: Apollo.QueryHookOptions<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables> & ({ variables: SubjectLinesMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables>(SubjectLinesMetricsDocument, options);
      }
export function useSubjectLinesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables>(SubjectLinesMetricsDocument, options);
        }
export function useSubjectLinesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables>(SubjectLinesMetricsDocument, options);
        }
export type SubjectLinesMetricsQueryHookResult = ReturnType<typeof useSubjectLinesMetricsQuery>;
export type SubjectLinesMetricsLazyQueryHookResult = ReturnType<typeof useSubjectLinesMetricsLazyQuery>;
export type SubjectLinesMetricsSuspenseQueryHookResult = ReturnType<typeof useSubjectLinesMetricsSuspenseQuery>;
export type SubjectLinesMetricsQueryResult = Apollo.QueryResult<SubjectLinesMetricsQuery, SubjectLinesMetricsQueryVariables>;
export const SubjectlinesMetricsExportDocument = gql`
    mutation SubjectlinesMetricsExport($columns: [String!]!, $filter: SubjectLineMetricsFilter!, $includeMetadata: Boolean, $recurringExportId: ID) {
  subjectlinesMetricsExport(
    columns: $columns
    filter: $filter
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type SubjectlinesMetricsExportMutationFn = Apollo.MutationFunction<SubjectlinesMetricsExportMutation, SubjectlinesMetricsExportMutationVariables>;

/**
 * __useSubjectlinesMetricsExportMutation__
 *
 * To run a mutation, you first call `useSubjectlinesMetricsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubjectlinesMetricsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subjectlinesMetricsExportMutation, { data, loading, error }] = useSubjectlinesMetricsExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useSubjectlinesMetricsExportMutation(baseOptions?: Apollo.MutationHookOptions<SubjectlinesMetricsExportMutation, SubjectlinesMetricsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubjectlinesMetricsExportMutation, SubjectlinesMetricsExportMutationVariables>(SubjectlinesMetricsExportDocument, options);
      }
export type SubjectlinesMetricsExportMutationHookResult = ReturnType<typeof useSubjectlinesMetricsExportMutation>;
export type SubjectlinesMetricsExportMutationResult = Apollo.MutationResult<SubjectlinesMetricsExportMutation>;
export type SubjectlinesMetricsExportMutationOptions = Apollo.BaseMutationOptions<SubjectlinesMetricsExportMutation, SubjectlinesMetricsExportMutationVariables>;
export const CampaignSavedViewsDocument = gql`
    query CampaignSavedViews {
  campaignSavedViewsV2 {
    ...CampaignSavedViewFragment
  }
}
    ${CampaignSavedViewFragmentFragmentDoc}`;

/**
 * __useCampaignSavedViewsQuery__
 *
 * To run a query within a React component, call `useCampaignSavedViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSavedViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSavedViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignSavedViewsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>(CampaignSavedViewsDocument, options);
      }
export function useCampaignSavedViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>(CampaignSavedViewsDocument, options);
        }
export function useCampaignSavedViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>(CampaignSavedViewsDocument, options);
        }
export type CampaignSavedViewsQueryHookResult = ReturnType<typeof useCampaignSavedViewsQuery>;
export type CampaignSavedViewsLazyQueryHookResult = ReturnType<typeof useCampaignSavedViewsLazyQuery>;
export type CampaignSavedViewsSuspenseQueryHookResult = ReturnType<typeof useCampaignSavedViewsSuspenseQuery>;
export type CampaignSavedViewsQueryResult = Apollo.QueryResult<CampaignSavedViewsQuery, CampaignSavedViewsQueryVariables>;
export const CampaignSavedViewCreateDocument = gql`
    mutation CampaignSavedViewCreate($title: String!, $columns: [String!]!, $customDateRange: DateRange, $filters: [SavedViewFilterInput!]!, $isDefault: Boolean!, $groupBy: CampaignGroupBy, $predefinedDateRange: PredefinedDateRange) {
  campaignSavedViewCreate(
    title: $title
    columns: $columns
    customDateRange: $customDateRange
    filters: $filters
    isDefault: $isDefault
    groupBy: $groupBy
    predefinedDateRange: $predefinedDateRange
  ) {
    createdSavedView {
      ...CampaignSavedViewFragment
    }
    campaignSavedViews {
      ...CampaignSavedViewFragment
    }
  }
}
    ${CampaignSavedViewFragmentFragmentDoc}`;
export type CampaignSavedViewCreateMutationFn = Apollo.MutationFunction<CampaignSavedViewCreateMutation, CampaignSavedViewCreateMutationVariables>;

/**
 * __useCampaignSavedViewCreateMutation__
 *
 * To run a mutation, you first call `useCampaignSavedViewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSavedViewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSavedViewCreateMutation, { data, loading, error }] = useCampaignSavedViewCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      columns: // value for 'columns'
 *      customDateRange: // value for 'customDateRange'
 *      filters: // value for 'filters'
 *      isDefault: // value for 'isDefault'
 *      groupBy: // value for 'groupBy'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *   },
 * });
 */
export function useCampaignSavedViewCreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSavedViewCreateMutation, CampaignSavedViewCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSavedViewCreateMutation, CampaignSavedViewCreateMutationVariables>(CampaignSavedViewCreateDocument, options);
      }
export type CampaignSavedViewCreateMutationHookResult = ReturnType<typeof useCampaignSavedViewCreateMutation>;
export type CampaignSavedViewCreateMutationResult = Apollo.MutationResult<CampaignSavedViewCreateMutation>;
export type CampaignSavedViewCreateMutationOptions = Apollo.BaseMutationOptions<CampaignSavedViewCreateMutation, CampaignSavedViewCreateMutationVariables>;
export const CampaignSavedViewDeleteDocument = gql`
    mutation CampaignSavedViewDelete($id: ID!) {
  campaignSavedViewDelete(id: $id) {
    campaignSavedViews {
      ...CampaignSavedViewFragment
    }
  }
}
    ${CampaignSavedViewFragmentFragmentDoc}`;
export type CampaignSavedViewDeleteMutationFn = Apollo.MutationFunction<CampaignSavedViewDeleteMutation, CampaignSavedViewDeleteMutationVariables>;

/**
 * __useCampaignSavedViewDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignSavedViewDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSavedViewDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSavedViewDeleteMutation, { data, loading, error }] = useCampaignSavedViewDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignSavedViewDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSavedViewDeleteMutation, CampaignSavedViewDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSavedViewDeleteMutation, CampaignSavedViewDeleteMutationVariables>(CampaignSavedViewDeleteDocument, options);
      }
export type CampaignSavedViewDeleteMutationHookResult = ReturnType<typeof useCampaignSavedViewDeleteMutation>;
export type CampaignSavedViewDeleteMutationResult = Apollo.MutationResult<CampaignSavedViewDeleteMutation>;
export type CampaignSavedViewDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignSavedViewDeleteMutation, CampaignSavedViewDeleteMutationVariables>;
export const CampaignSavedViewUpdateDocument = gql`
    mutation CampaignSavedViewUpdate($id: ID!, $title: String!, $columns: [String!]!, $customDateRange: DateRange, $isDefault: Boolean!, $groupBy: CampaignGroupBy, $predefinedDateRange: PredefinedDateRange, $filters: [SavedViewFilterInput!]) {
  campaignSavedViewUpdate(
    id: $id
    title: $title
    columns: $columns
    customDateRange: $customDateRange
    isDefault: $isDefault
    groupBy: $groupBy
    predefinedDateRange: $predefinedDateRange
    filters: $filters
  ) {
    campaignSavedViews {
      ...CampaignSavedViewFragment
    }
  }
}
    ${CampaignSavedViewFragmentFragmentDoc}`;
export type CampaignSavedViewUpdateMutationFn = Apollo.MutationFunction<CampaignSavedViewUpdateMutation, CampaignSavedViewUpdateMutationVariables>;

/**
 * __useCampaignSavedViewUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSavedViewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSavedViewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSavedViewUpdateMutation, { data, loading, error }] = useCampaignSavedViewUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      columns: // value for 'columns'
 *      customDateRange: // value for 'customDateRange'
 *      isDefault: // value for 'isDefault'
 *      groupBy: // value for 'groupBy'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCampaignSavedViewUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSavedViewUpdateMutation, CampaignSavedViewUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSavedViewUpdateMutation, CampaignSavedViewUpdateMutationVariables>(CampaignSavedViewUpdateDocument, options);
      }
export type CampaignSavedViewUpdateMutationHookResult = ReturnType<typeof useCampaignSavedViewUpdateMutation>;
export type CampaignSavedViewUpdateMutationResult = Apollo.MutationResult<CampaignSavedViewUpdateMutation>;
export type CampaignSavedViewUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSavedViewUpdateMutation, CampaignSavedViewUpdateMutationVariables>;
export const CreativeSavedViewsDocument = gql`
    query CreativeSavedViews {
  creativeSavedViewsV2 {
    ...CreativeSavedViewFragment
  }
}
    ${CreativeSavedViewFragmentFragmentDoc}`;

/**
 * __useCreativeSavedViewsQuery__
 *
 * To run a query within a React component, call `useCreativeSavedViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeSavedViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeSavedViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreativeSavedViewsQuery(baseOptions?: Apollo.QueryHookOptions<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>(CreativeSavedViewsDocument, options);
      }
export function useCreativeSavedViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>(CreativeSavedViewsDocument, options);
        }
export function useCreativeSavedViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>(CreativeSavedViewsDocument, options);
        }
export type CreativeSavedViewsQueryHookResult = ReturnType<typeof useCreativeSavedViewsQuery>;
export type CreativeSavedViewsLazyQueryHookResult = ReturnType<typeof useCreativeSavedViewsLazyQuery>;
export type CreativeSavedViewsSuspenseQueryHookResult = ReturnType<typeof useCreativeSavedViewsSuspenseQuery>;
export type CreativeSavedViewsQueryResult = Apollo.QueryResult<CreativeSavedViewsQuery, CreativeSavedViewsQueryVariables>;
export const CreativeSavedViewCreateDocument = gql`
    mutation CreativeSavedViewCreate($title: String!, $columns: [String!]!, $customDateRange: DateRange, $filters: [SavedViewFilterInput!]!, $groupBy: CreativeGroupBy, $isDefault: Boolean!, $predefinedDateRange: PredefinedDateRange) {
  creativeSavedViewCreate(
    title: $title
    columns: $columns
    customDateRange: $customDateRange
    filters: $filters
    groupBy: $groupBy
    isDefault: $isDefault
    predefinedDateRange: $predefinedDateRange
  ) {
    createdSavedView {
      ...CreativeSavedViewFragment
    }
    creativeSavedViews {
      ...CreativeSavedViewFragment
    }
  }
}
    ${CreativeSavedViewFragmentFragmentDoc}`;
export type CreativeSavedViewCreateMutationFn = Apollo.MutationFunction<CreativeSavedViewCreateMutation, CreativeSavedViewCreateMutationVariables>;

/**
 * __useCreativeSavedViewCreateMutation__
 *
 * To run a mutation, you first call `useCreativeSavedViewCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSavedViewCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSavedViewCreateMutation, { data, loading, error }] = useCreativeSavedViewCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      columns: // value for 'columns'
 *      customDateRange: // value for 'customDateRange'
 *      filters: // value for 'filters'
 *      groupBy: // value for 'groupBy'
 *      isDefault: // value for 'isDefault'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *   },
 * });
 */
export function useCreativeSavedViewCreateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSavedViewCreateMutation, CreativeSavedViewCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSavedViewCreateMutation, CreativeSavedViewCreateMutationVariables>(CreativeSavedViewCreateDocument, options);
      }
export type CreativeSavedViewCreateMutationHookResult = ReturnType<typeof useCreativeSavedViewCreateMutation>;
export type CreativeSavedViewCreateMutationResult = Apollo.MutationResult<CreativeSavedViewCreateMutation>;
export type CreativeSavedViewCreateMutationOptions = Apollo.BaseMutationOptions<CreativeSavedViewCreateMutation, CreativeSavedViewCreateMutationVariables>;
export const CreativeSavedViewDeleteDocument = gql`
    mutation CreativeSavedViewDelete($id: ID!) {
  creativeSavedViewDelete(id: $id) {
    creativeSavedViews {
      ...CreativeSavedViewFragment
    }
  }
}
    ${CreativeSavedViewFragmentFragmentDoc}`;
export type CreativeSavedViewDeleteMutationFn = Apollo.MutationFunction<CreativeSavedViewDeleteMutation, CreativeSavedViewDeleteMutationVariables>;

/**
 * __useCreativeSavedViewDeleteMutation__
 *
 * To run a mutation, you first call `useCreativeSavedViewDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSavedViewDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSavedViewDeleteMutation, { data, loading, error }] = useCreativeSavedViewDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreativeSavedViewDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSavedViewDeleteMutation, CreativeSavedViewDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSavedViewDeleteMutation, CreativeSavedViewDeleteMutationVariables>(CreativeSavedViewDeleteDocument, options);
      }
export type CreativeSavedViewDeleteMutationHookResult = ReturnType<typeof useCreativeSavedViewDeleteMutation>;
export type CreativeSavedViewDeleteMutationResult = Apollo.MutationResult<CreativeSavedViewDeleteMutation>;
export type CreativeSavedViewDeleteMutationOptions = Apollo.BaseMutationOptions<CreativeSavedViewDeleteMutation, CreativeSavedViewDeleteMutationVariables>;
export const CreativeSavedViewUpdateDocument = gql`
    mutation CreativeSavedViewUpdate($id: ID!, $title: String!, $columns: [String!]!, $customDateRange: DateRange, $isDefault: Boolean!, $groupBy: CreativeGroupBy, $predefinedDateRange: PredefinedDateRange, $filters: [SavedViewFilterInput!]) {
  creativeSavedViewUpdate(
    id: $id
    title: $title
    columns: $columns
    customDateRange: $customDateRange
    isDefault: $isDefault
    groupBy: $groupBy
    predefinedDateRange: $predefinedDateRange
    filters: $filters
  ) {
    creativeSavedViews {
      ...CreativeSavedViewFragment
    }
  }
}
    ${CreativeSavedViewFragmentFragmentDoc}`;
export type CreativeSavedViewUpdateMutationFn = Apollo.MutationFunction<CreativeSavedViewUpdateMutation, CreativeSavedViewUpdateMutationVariables>;

/**
 * __useCreativeSavedViewUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeSavedViewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSavedViewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSavedViewUpdateMutation, { data, loading, error }] = useCreativeSavedViewUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      columns: // value for 'columns'
 *      customDateRange: // value for 'customDateRange'
 *      isDefault: // value for 'isDefault'
 *      groupBy: // value for 'groupBy'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreativeSavedViewUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSavedViewUpdateMutation, CreativeSavedViewUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSavedViewUpdateMutation, CreativeSavedViewUpdateMutationVariables>(CreativeSavedViewUpdateDocument, options);
      }
export type CreativeSavedViewUpdateMutationHookResult = ReturnType<typeof useCreativeSavedViewUpdateMutation>;
export type CreativeSavedViewUpdateMutationResult = Apollo.MutationResult<CreativeSavedViewUpdateMutation>;
export type CreativeSavedViewUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeSavedViewUpdateMutation, CreativeSavedViewUpdateMutationVariables>;
export const AnalyticsFiscalCalendarRangesDocument = gql`
    query AnalyticsFiscalCalendarRanges($start: Int!, $end: Int!) {
  currentClient {
    id
    analyticsCalendar
    fiscalCalendar {
      weekRange(start: $start, end: $end) {
        id
        year
        week
        span {
          start
          end
        }
      }
      monthRange(start: $start, end: $end) {
        id
        year
        month
        span {
          start
          end
        }
      }
      quarterRange(start: $start, end: $end) {
        id
        year
        quarter
        span {
          start
          end
        }
      }
      yearRange(start: $start, end: $end) {
        id
        year
        span {
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsFiscalCalendarRangesQuery__
 *
 * To run a query within a React component, call `useAnalyticsFiscalCalendarRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsFiscalCalendarRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsFiscalCalendarRangesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useAnalyticsFiscalCalendarRangesQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables> & ({ variables: AnalyticsFiscalCalendarRangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables>(AnalyticsFiscalCalendarRangesDocument, options);
      }
export function useAnalyticsFiscalCalendarRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables>(AnalyticsFiscalCalendarRangesDocument, options);
        }
export function useAnalyticsFiscalCalendarRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables>(AnalyticsFiscalCalendarRangesDocument, options);
        }
export type AnalyticsFiscalCalendarRangesQueryHookResult = ReturnType<typeof useAnalyticsFiscalCalendarRangesQuery>;
export type AnalyticsFiscalCalendarRangesLazyQueryHookResult = ReturnType<typeof useAnalyticsFiscalCalendarRangesLazyQuery>;
export type AnalyticsFiscalCalendarRangesSuspenseQueryHookResult = ReturnType<typeof useAnalyticsFiscalCalendarRangesSuspenseQuery>;
export type AnalyticsFiscalCalendarRangesQueryResult = Apollo.QueryResult<AnalyticsFiscalCalendarRangesQuery, AnalyticsFiscalCalendarRangesQueryVariables>;
export const CampaignViewTagsDocument = gql`
    query CampaignViewTags($startDate: Date, $endDate: Date) {
  campaignView(startDate: $startDate, endDate: $endDate) {
    tags {
      id
      name
    }
    creativeTags {
      id
      name
    }
  }
}
    `;

/**
 * __useCampaignViewTagsQuery__
 *
 * To run a query within a React component, call `useCampaignViewTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignViewTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignViewTagsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCampaignViewTagsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>(CampaignViewTagsDocument, options);
      }
export function useCampaignViewTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>(CampaignViewTagsDocument, options);
        }
export function useCampaignViewTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>(CampaignViewTagsDocument, options);
        }
export type CampaignViewTagsQueryHookResult = ReturnType<typeof useCampaignViewTagsQuery>;
export type CampaignViewTagsLazyQueryHookResult = ReturnType<typeof useCampaignViewTagsLazyQuery>;
export type CampaignViewTagsSuspenseQueryHookResult = ReturnType<typeof useCampaignViewTagsSuspenseQuery>;
export type CampaignViewTagsQueryResult = Apollo.QueryResult<CampaignViewTagsQuery, CampaignViewTagsQueryVariables>;
export const ProgramsNamesDocument = gql`
    query ProgramsNames($after: String, $before: String, $first: Int, $last: Int) {
  programs(after: $after, before: $before, first: $first, last: $last) {
    edges {
      node {
        id
        title
      }
      cursor
    }
  }
}
    `;

/**
 * __useProgramsNamesQuery__
 *
 * To run a query within a React component, call `useProgramsNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsNamesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useProgramsNamesQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsNamesQuery, ProgramsNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsNamesQuery, ProgramsNamesQueryVariables>(ProgramsNamesDocument, options);
      }
export function useProgramsNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsNamesQuery, ProgramsNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsNamesQuery, ProgramsNamesQueryVariables>(ProgramsNamesDocument, options);
        }
export function useProgramsNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsNamesQuery, ProgramsNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsNamesQuery, ProgramsNamesQueryVariables>(ProgramsNamesDocument, options);
        }
export type ProgramsNamesQueryHookResult = ReturnType<typeof useProgramsNamesQuery>;
export type ProgramsNamesLazyQueryHookResult = ReturnType<typeof useProgramsNamesLazyQuery>;
export type ProgramsNamesSuspenseQueryHookResult = ReturnType<typeof useProgramsNamesSuspenseQuery>;
export type ProgramsNamesQueryResult = Apollo.QueryResult<ProgramsNamesQuery, ProgramsNamesQueryVariables>;
export const AccountMembersDocument = gql`
    query AccountMembers($accountId: ID!) {
  account(accountId: $accountId) {
    id
    members {
      status
      user {
        id
        firstName
        lastName
        emailAddress
      }
    }
  }
}
    `;

/**
 * __useAccountMembersQuery__
 *
 * To run a query within a React component, call `useAccountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMembersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountMembersQuery(baseOptions: Apollo.QueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables> & ({ variables: AccountMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
      }
export function useAccountMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
        }
export function useAccountMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
        }
export type AccountMembersQueryHookResult = ReturnType<typeof useAccountMembersQuery>;
export type AccountMembersLazyQueryHookResult = ReturnType<typeof useAccountMembersLazyQuery>;
export type AccountMembersSuspenseQueryHookResult = ReturnType<typeof useAccountMembersSuspenseQuery>;
export type AccountMembersQueryResult = Apollo.QueryResult<AccountMembersQuery, AccountMembersQueryVariables>;
export const AnalyticsExperimentsDocument = gql`
    query AnalyticsExperiments($campaignIdsOrTitles: [String!], $campaignStages: [CampaignStageType!], $channels: [Channel!], $excludeCampaignTagIds: [ID!], $includeCampaignTagIds: [ID!], $endDate: Date, $startDate: Date) {
  analyticsV2Experiments(
    campaignIdsOrTitles: $campaignIdsOrTitles
    campaignStages: $campaignStages
    channels: $channels
    excludeCampaignTagIds: $excludeCampaignTagIds
    includeCampaignTagIds: $includeCampaignTagIds
    endDate: $endDate
    startDate: $startDate
  ) {
    id
    title
    treatments {
      id
      title
    }
  }
}
    `;

/**
 * __useAnalyticsExperimentsQuery__
 *
 * To run a query within a React component, call `useAnalyticsExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsExperimentsQuery({
 *   variables: {
 *      campaignIdsOrTitles: // value for 'campaignIdsOrTitles'
 *      campaignStages: // value for 'campaignStages'
 *      channels: // value for 'channels'
 *      excludeCampaignTagIds: // value for 'excludeCampaignTagIds'
 *      includeCampaignTagIds: // value for 'includeCampaignTagIds'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAnalyticsExperimentsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>(AnalyticsExperimentsDocument, options);
      }
export function useAnalyticsExperimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>(AnalyticsExperimentsDocument, options);
        }
export function useAnalyticsExperimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>(AnalyticsExperimentsDocument, options);
        }
export type AnalyticsExperimentsQueryHookResult = ReturnType<typeof useAnalyticsExperimentsQuery>;
export type AnalyticsExperimentsLazyQueryHookResult = ReturnType<typeof useAnalyticsExperimentsLazyQuery>;
export type AnalyticsExperimentsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsExperimentsSuspenseQuery>;
export type AnalyticsExperimentsQueryResult = Apollo.QueryResult<AnalyticsExperimentsQuery, AnalyticsExperimentsQueryVariables>;
export const AnalyticsComparisonViewSegmentOptionsDocument = gql`
    query AnalyticsComparisonViewSegmentOptions {
  contactAudiences(limit: 10000000, archived: false, analyticsTracking: ACTIVE) {
    audiences {
      id
      name
      splits {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAnalyticsComparisonViewSegmentOptionsQuery__
 *
 * To run a query within a React component, call `useAnalyticsComparisonViewSegmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsComparisonViewSegmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsComparisonViewSegmentOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsComparisonViewSegmentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>(AnalyticsComparisonViewSegmentOptionsDocument, options);
      }
export function useAnalyticsComparisonViewSegmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>(AnalyticsComparisonViewSegmentOptionsDocument, options);
        }
export function useAnalyticsComparisonViewSegmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>(AnalyticsComparisonViewSegmentOptionsDocument, options);
        }
export type AnalyticsComparisonViewSegmentOptionsQueryHookResult = ReturnType<typeof useAnalyticsComparisonViewSegmentOptionsQuery>;
export type AnalyticsComparisonViewSegmentOptionsLazyQueryHookResult = ReturnType<typeof useAnalyticsComparisonViewSegmentOptionsLazyQuery>;
export type AnalyticsComparisonViewSegmentOptionsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsComparisonViewSegmentOptionsSuspenseQuery>;
export type AnalyticsComparisonViewSegmentOptionsQueryResult = Apollo.QueryResult<AnalyticsComparisonViewSegmentOptionsQuery, AnalyticsComparisonViewSegmentOptionsQueryVariables>;
export const MetricTypesDocument = gql`
    query MetricTypes($metricClass: MetricClass!, $metricView: MetricView, $channel: Channel) {
  metricTypes(
    metricClass: $metricClass
    metricView: $metricView
    channel: $channel
  ) {
    id
    name
    category
    customEventCategory
    group
    positivelyCorrelated
    displayByDefault
    supportsSeries
  }
}
    `;

/**
 * __useMetricTypesQuery__
 *
 * To run a query within a React component, call `useMetricTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricTypesQuery({
 *   variables: {
 *      metricClass: // value for 'metricClass'
 *      metricView: // value for 'metricView'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useMetricTypesQuery(baseOptions: Apollo.QueryHookOptions<MetricTypesQuery, MetricTypesQueryVariables> & ({ variables: MetricTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricTypesQuery, MetricTypesQueryVariables>(MetricTypesDocument, options);
      }
export function useMetricTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricTypesQuery, MetricTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricTypesQuery, MetricTypesQueryVariables>(MetricTypesDocument, options);
        }
export function useMetricTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricTypesQuery, MetricTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetricTypesQuery, MetricTypesQueryVariables>(MetricTypesDocument, options);
        }
export type MetricTypesQueryHookResult = ReturnType<typeof useMetricTypesQuery>;
export type MetricTypesLazyQueryHookResult = ReturnType<typeof useMetricTypesLazyQuery>;
export type MetricTypesSuspenseQueryHookResult = ReturnType<typeof useMetricTypesSuspenseQuery>;
export type MetricTypesQueryResult = Apollo.QueryResult<MetricTypesQuery, MetricTypesQueryVariables>;
export const RecurringExportRemindersDocument = gql`
    query RecurringExportReminders($viewType: ViewType!) {
  recurringExportReminders(viewType: $viewType) {
    id
    title
    attachCsv
    columns
    createdAt
    customDateRange
    filterData
    groupBy
    groupByFields
    includeMetadata
    predefinedDateRange
    recipients
    schedule {
      hour
      minute
      dayOfWeek
      dayOfMonth
    }
    updatedAt
    viewType
  }
}
    `;

/**
 * __useRecurringExportRemindersQuery__
 *
 * To run a query within a React component, call `useRecurringExportRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringExportRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringExportRemindersQuery({
 *   variables: {
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useRecurringExportRemindersQuery(baseOptions: Apollo.QueryHookOptions<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables> & ({ variables: RecurringExportRemindersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables>(RecurringExportRemindersDocument, options);
      }
export function useRecurringExportRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables>(RecurringExportRemindersDocument, options);
        }
export function useRecurringExportRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables>(RecurringExportRemindersDocument, options);
        }
export type RecurringExportRemindersQueryHookResult = ReturnType<typeof useRecurringExportRemindersQuery>;
export type RecurringExportRemindersLazyQueryHookResult = ReturnType<typeof useRecurringExportRemindersLazyQuery>;
export type RecurringExportRemindersSuspenseQueryHookResult = ReturnType<typeof useRecurringExportRemindersSuspenseQuery>;
export type RecurringExportRemindersQueryResult = Apollo.QueryResult<RecurringExportRemindersQuery, RecurringExportRemindersQueryVariables>;
export const DeleteRecurringExportReminderDocument = gql`
    mutation DeleteRecurringExportReminder($id: ID!) {
  deleteRecurringExportReminder(id: $id) {
    success
  }
}
    `;
export type DeleteRecurringExportReminderMutationFn = Apollo.MutationFunction<DeleteRecurringExportReminderMutation, DeleteRecurringExportReminderMutationVariables>;

/**
 * __useDeleteRecurringExportReminderMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringExportReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringExportReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringExportReminderMutation, { data, loading, error }] = useDeleteRecurringExportReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecurringExportReminderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurringExportReminderMutation, DeleteRecurringExportReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurringExportReminderMutation, DeleteRecurringExportReminderMutationVariables>(DeleteRecurringExportReminderDocument, options);
      }
export type DeleteRecurringExportReminderMutationHookResult = ReturnType<typeof useDeleteRecurringExportReminderMutation>;
export type DeleteRecurringExportReminderMutationResult = Apollo.MutationResult<DeleteRecurringExportReminderMutation>;
export type DeleteRecurringExportReminderMutationOptions = Apollo.BaseMutationOptions<DeleteRecurringExportReminderMutation, DeleteRecurringExportReminderMutationVariables>;
export const CreateRecurringExportReminderDocument = gql`
    mutation CreateRecurringExportReminder($attachCsv: Boolean, $columns: [String!]!, $customDateRange: DateRange, $filterData: JSONString!, $groupBy: CampaignGroupBy, $groupByFields: [String!], $includeMetadata: Boolean, $predefinedDateRange: PredefinedDateRange, $recipients: [String!]!, $schedule: ReminderScheduleInput!, $title: String!, $viewType: ViewType!) {
  createRecurringExportReminder(
    attachCsv: $attachCsv
    columns: $columns
    customDateRange: $customDateRange
    filterData: $filterData
    groupBy: $groupBy
    groupByFields: $groupByFields
    includeMetadata: $includeMetadata
    predefinedDateRange: $predefinedDateRange
    recipients: $recipients
    schedule: $schedule
    title: $title
    viewType: $viewType
  ) {
    reminder {
      id
    }
  }
}
    `;
export type CreateRecurringExportReminderMutationFn = Apollo.MutationFunction<CreateRecurringExportReminderMutation, CreateRecurringExportReminderMutationVariables>;

/**
 * __useCreateRecurringExportReminderMutation__
 *
 * To run a mutation, you first call `useCreateRecurringExportReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringExportReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringExportReminderMutation, { data, loading, error }] = useCreateRecurringExportReminderMutation({
 *   variables: {
 *      attachCsv: // value for 'attachCsv'
 *      columns: // value for 'columns'
 *      customDateRange: // value for 'customDateRange'
 *      filterData: // value for 'filterData'
 *      groupBy: // value for 'groupBy'
 *      groupByFields: // value for 'groupByFields'
 *      includeMetadata: // value for 'includeMetadata'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *      recipients: // value for 'recipients'
 *      schedule: // value for 'schedule'
 *      title: // value for 'title'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useCreateRecurringExportReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringExportReminderMutation, CreateRecurringExportReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringExportReminderMutation, CreateRecurringExportReminderMutationVariables>(CreateRecurringExportReminderDocument, options);
      }
export type CreateRecurringExportReminderMutationHookResult = ReturnType<typeof useCreateRecurringExportReminderMutation>;
export type CreateRecurringExportReminderMutationResult = Apollo.MutationResult<CreateRecurringExportReminderMutation>;
export type CreateRecurringExportReminderMutationOptions = Apollo.BaseMutationOptions<CreateRecurringExportReminderMutation, CreateRecurringExportReminderMutationVariables>;
export const UpdateRecurringExportReminderDocument = gql`
    mutation UpdateRecurringExportReminder($attachCsv: Boolean, $columns: [String!], $customDateRange: DateRange, $filterData: JSONString, $groupBy: CampaignGroupBy, $groupByFields: [String!], $id: ID!, $includeMetadata: Boolean, $predefinedDateRange: PredefinedDateRange, $recipients: [String!], $schedule: ReminderScheduleInput, $title: String, $viewType: ViewType) {
  updateRecurringExportReminder(
    id: $id
    attachCsv: $attachCsv
    columns: $columns
    customDateRange: $customDateRange
    filterData: $filterData
    groupBy: $groupBy
    groupByFields: $groupByFields
    includeMetadata: $includeMetadata
    predefinedDateRange: $predefinedDateRange
    recipients: $recipients
    schedule: $schedule
    title: $title
    viewType: $viewType
  ) {
    reminder {
      id
    }
  }
}
    `;
export type UpdateRecurringExportReminderMutationFn = Apollo.MutationFunction<UpdateRecurringExportReminderMutation, UpdateRecurringExportReminderMutationVariables>;

/**
 * __useUpdateRecurringExportReminderMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringExportReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringExportReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringExportReminderMutation, { data, loading, error }] = useUpdateRecurringExportReminderMutation({
 *   variables: {
 *      attachCsv: // value for 'attachCsv'
 *      columns: // value for 'columns'
 *      customDateRange: // value for 'customDateRange'
 *      filterData: // value for 'filterData'
 *      groupBy: // value for 'groupBy'
 *      groupByFields: // value for 'groupByFields'
 *      id: // value for 'id'
 *      includeMetadata: // value for 'includeMetadata'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *      recipients: // value for 'recipients'
 *      schedule: // value for 'schedule'
 *      title: // value for 'title'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useUpdateRecurringExportReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringExportReminderMutation, UpdateRecurringExportReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringExportReminderMutation, UpdateRecurringExportReminderMutationVariables>(UpdateRecurringExportReminderDocument, options);
      }
export type UpdateRecurringExportReminderMutationHookResult = ReturnType<typeof useUpdateRecurringExportReminderMutation>;
export type UpdateRecurringExportReminderMutationResult = Apollo.MutationResult<UpdateRecurringExportReminderMutation>;
export type UpdateRecurringExportReminderMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringExportReminderMutation, UpdateRecurringExportReminderMutationVariables>;
export const ExportMetricsDocument = gql`
    mutation ExportMetrics($columns: [String!], $filter: MetricsExportFilterInput!, $groupBy: [MetricsGroupBy!], $includeMetadata: Boolean, $recurringExportId: ID) {
  exportMetrics(
    columns: $columns
    filter: $filter
    groupBy: $groupBy
    includeMetadata: $includeMetadata
    recurringExportId: $recurringExportId
  ) {
    signedUrl
  }
}
    `;
export type ExportMetricsMutationFn = Apollo.MutationFunction<ExportMetricsMutation, ExportMetricsMutationVariables>;

/**
 * __useExportMetricsMutation__
 *
 * To run a mutation, you first call `useExportMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMetricsMutation, { data, loading, error }] = useExportMetricsMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *      includeMetadata: // value for 'includeMetadata'
 *      recurringExportId: // value for 'recurringExportId'
 *   },
 * });
 */
export function useExportMetricsMutation(baseOptions?: Apollo.MutationHookOptions<ExportMetricsMutation, ExportMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMetricsMutation, ExportMetricsMutationVariables>(ExportMetricsDocument, options);
      }
export type ExportMetricsMutationHookResult = ReturnType<typeof useExportMetricsMutation>;
export type ExportMetricsMutationResult = Apollo.MutationResult<ExportMetricsMutation>;
export type ExportMetricsMutationOptions = Apollo.BaseMutationOptions<ExportMetricsMutation, ExportMetricsMutationVariables>;
export const SavedFiltersDocument = gql`
    query SavedFilters($viewType: ViewType!) {
  savedFilters(viewType: $viewType) {
    ...SavedFilterFragment
  }
}
    ${SavedFilterFragmentFragmentDoc}`;

/**
 * __useSavedFiltersQuery__
 *
 * To run a query within a React component, call `useSavedFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedFiltersQuery({
 *   variables: {
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useSavedFiltersQuery(baseOptions: Apollo.QueryHookOptions<SavedFiltersQuery, SavedFiltersQueryVariables> & ({ variables: SavedFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedFiltersQuery, SavedFiltersQueryVariables>(SavedFiltersDocument, options);
      }
export function useSavedFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedFiltersQuery, SavedFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedFiltersQuery, SavedFiltersQueryVariables>(SavedFiltersDocument, options);
        }
export function useSavedFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedFiltersQuery, SavedFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedFiltersQuery, SavedFiltersQueryVariables>(SavedFiltersDocument, options);
        }
export type SavedFiltersQueryHookResult = ReturnType<typeof useSavedFiltersQuery>;
export type SavedFiltersLazyQueryHookResult = ReturnType<typeof useSavedFiltersLazyQuery>;
export type SavedFiltersSuspenseQueryHookResult = ReturnType<typeof useSavedFiltersSuspenseQuery>;
export type SavedFiltersQueryResult = Apollo.QueryResult<SavedFiltersQuery, SavedFiltersQueryVariables>;
export const CreateSavedFilterDocument = gql`
    mutation CreateSavedFilter($title: String!, $viewType: ViewType!, $filterData: JSONString!, $customDateRange: DateRange, $predefinedDateRange: PredefinedDateRange, $isDefault: Boolean) {
  createSavedFilter(
    title: $title
    viewType: $viewType
    filterData: $filterData
    customDateRange: $customDateRange
    predefinedDateRange: $predefinedDateRange
    isDefault: $isDefault
  ) {
    savedFilter {
      ...SavedFilterFragment
    }
  }
}
    ${SavedFilterFragmentFragmentDoc}`;
export type CreateSavedFilterMutationFn = Apollo.MutationFunction<CreateSavedFilterMutation, CreateSavedFilterMutationVariables>;

/**
 * __useCreateSavedFilterMutation__
 *
 * To run a mutation, you first call `useCreateSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedFilterMutation, { data, loading, error }] = useCreateSavedFilterMutation({
 *   variables: {
 *      title: // value for 'title'
 *      viewType: // value for 'viewType'
 *      filterData: // value for 'filterData'
 *      customDateRange: // value for 'customDateRange'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useCreateSavedFilterMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavedFilterMutation, CreateSavedFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavedFilterMutation, CreateSavedFilterMutationVariables>(CreateSavedFilterDocument, options);
      }
export type CreateSavedFilterMutationHookResult = ReturnType<typeof useCreateSavedFilterMutation>;
export type CreateSavedFilterMutationResult = Apollo.MutationResult<CreateSavedFilterMutation>;
export type CreateSavedFilterMutationOptions = Apollo.BaseMutationOptions<CreateSavedFilterMutation, CreateSavedFilterMutationVariables>;
export const UpdateSavedFilterDocument = gql`
    mutation UpdateSavedFilter($id: ID!, $title: String, $filterData: JSONString, $customDateRange: DateRange, $predefinedDateRange: PredefinedDateRange, $isDefault: Boolean) {
  updateSavedFilter(
    id: $id
    title: $title
    filterData: $filterData
    customDateRange: $customDateRange
    predefinedDateRange: $predefinedDateRange
    isDefault: $isDefault
  ) {
    savedFilter {
      ...SavedFilterFragment
    }
  }
}
    ${SavedFilterFragmentFragmentDoc}`;
export type UpdateSavedFilterMutationFn = Apollo.MutationFunction<UpdateSavedFilterMutation, UpdateSavedFilterMutationVariables>;

/**
 * __useUpdateSavedFilterMutation__
 *
 * To run a mutation, you first call `useUpdateSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedFilterMutation, { data, loading, error }] = useUpdateSavedFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      filterData: // value for 'filterData'
 *      customDateRange: // value for 'customDateRange'
 *      predefinedDateRange: // value for 'predefinedDateRange'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useUpdateSavedFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavedFilterMutation, UpdateSavedFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavedFilterMutation, UpdateSavedFilterMutationVariables>(UpdateSavedFilterDocument, options);
      }
export type UpdateSavedFilterMutationHookResult = ReturnType<typeof useUpdateSavedFilterMutation>;
export type UpdateSavedFilterMutationResult = Apollo.MutationResult<UpdateSavedFilterMutation>;
export type UpdateSavedFilterMutationOptions = Apollo.BaseMutationOptions<UpdateSavedFilterMutation, UpdateSavedFilterMutationVariables>;
export const DeleteSavedFilterDocument = gql`
    mutation DeleteSavedFilter($id: ID!) {
  deleteSavedFilter(id: $id) {
    success
  }
}
    `;
export type DeleteSavedFilterMutationFn = Apollo.MutationFunction<DeleteSavedFilterMutation, DeleteSavedFilterMutationVariables>;

/**
 * __useDeleteSavedFilterMutation__
 *
 * To run a mutation, you first call `useDeleteSavedFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedFilterMutation, { data, loading, error }] = useDeleteSavedFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavedFilterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedFilterMutation, DeleteSavedFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedFilterMutation, DeleteSavedFilterMutationVariables>(DeleteSavedFilterDocument, options);
      }
export type DeleteSavedFilterMutationHookResult = ReturnType<typeof useDeleteSavedFilterMutation>;
export type DeleteSavedFilterMutationResult = Apollo.MutationResult<DeleteSavedFilterMutation>;
export type DeleteSavedFilterMutationOptions = Apollo.BaseMutationOptions<DeleteSavedFilterMutation, DeleteSavedFilterMutationVariables>;
export const ContactAudienceExperimentCreateDocument = gql`
    mutation ContactAudienceExperimentCreate($name: String!, $query: ContactQuery!, $description: String!, $experimentInput: ContactAudienceExperimentAudienceInput, $splits: [ContactAudienceSplitInput]) {
  contactAudienceCreate(
    name: $name
    query: $query
    description: $description
    experimentInput: $experimentInput
    splits: $splits
  ) {
    contactAudience {
      id
      name
    }
    success
  }
}
    `;
export type ContactAudienceExperimentCreateMutationFn = Apollo.MutationFunction<ContactAudienceExperimentCreateMutation, ContactAudienceExperimentCreateMutationVariables>;

/**
 * __useContactAudienceExperimentCreateMutation__
 *
 * To run a mutation, you first call `useContactAudienceExperimentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceExperimentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceExperimentCreateMutation, { data, loading, error }] = useContactAudienceExperimentCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      query: // value for 'query'
 *      description: // value for 'description'
 *      experimentInput: // value for 'experimentInput'
 *      splits: // value for 'splits'
 *   },
 * });
 */
export function useContactAudienceExperimentCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceExperimentCreateMutation, ContactAudienceExperimentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceExperimentCreateMutation, ContactAudienceExperimentCreateMutationVariables>(ContactAudienceExperimentCreateDocument, options);
      }
export type ContactAudienceExperimentCreateMutationHookResult = ReturnType<typeof useContactAudienceExperimentCreateMutation>;
export type ContactAudienceExperimentCreateMutationResult = Apollo.MutationResult<ContactAudienceExperimentCreateMutation>;
export type ContactAudienceExperimentCreateMutationOptions = Apollo.BaseMutationOptions<ContactAudienceExperimentCreateMutation, ContactAudienceExperimentCreateMutationVariables>;
export const ContactAudienceExperimentUpdateDocument = gql`
    mutation ContactAudienceExperimentUpdate($id: ID!, $name: String, $description: String, $query: ContactQuery!, $experimentUpdateInput: ContactAudienceExperimentAudienceUpdateInput, $splits: [ContactAudienceSplitUpdateInput]) {
  contactAudienceUpdate(
    id: $id
    name: $name
    description: $description
    query: $query
    experimentUpdateInput: $experimentUpdateInput
    splits: $splits
  ) {
    contactAudience {
      id
      name
    }
    success
  }
}
    `;
export type ContactAudienceExperimentUpdateMutationFn = Apollo.MutationFunction<ContactAudienceExperimentUpdateMutation, ContactAudienceExperimentUpdateMutationVariables>;

/**
 * __useContactAudienceExperimentUpdateMutation__
 *
 * To run a mutation, you first call `useContactAudienceExperimentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceExperimentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceExperimentUpdateMutation, { data, loading, error }] = useContactAudienceExperimentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      query: // value for 'query'
 *      experimentUpdateInput: // value for 'experimentUpdateInput'
 *      splits: // value for 'splits'
 *   },
 * });
 */
export function useContactAudienceExperimentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceExperimentUpdateMutation, ContactAudienceExperimentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceExperimentUpdateMutation, ContactAudienceExperimentUpdateMutationVariables>(ContactAudienceExperimentUpdateDocument, options);
      }
export type ContactAudienceExperimentUpdateMutationHookResult = ReturnType<typeof useContactAudienceExperimentUpdateMutation>;
export type ContactAudienceExperimentUpdateMutationResult = Apollo.MutationResult<ContactAudienceExperimentUpdateMutation>;
export type ContactAudienceExperimentUpdateMutationOptions = Apollo.BaseMutationOptions<ContactAudienceExperimentUpdateMutation, ContactAudienceExperimentUpdateMutationVariables>;
export const GetActiveChannelsDocument = gql`
    query GetActiveChannels {
  channels {
    category
    channel
  }
}
    `;

/**
 * __useGetActiveChannelsQuery__
 *
 * To run a query within a React component, call `useGetActiveChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>(GetActiveChannelsDocument, options);
      }
export function useGetActiveChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>(GetActiveChannelsDocument, options);
        }
export function useGetActiveChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>(GetActiveChannelsDocument, options);
        }
export type GetActiveChannelsQueryHookResult = ReturnType<typeof useGetActiveChannelsQuery>;
export type GetActiveChannelsLazyQueryHookResult = ReturnType<typeof useGetActiveChannelsLazyQuery>;
export type GetActiveChannelsSuspenseQueryHookResult = ReturnType<typeof useGetActiveChannelsSuspenseQuery>;
export type GetActiveChannelsQueryResult = Apollo.QueryResult<GetActiveChannelsQuery, GetActiveChannelsQueryVariables>;
export const ContactAudienceAutoBuildDocument = gql`
    mutation ContactAudienceAutoBuild($attributeIds: [ID!]!) {
  contactAudienceAutoBuild(attributeIds: $attributeIds) {
    splits {
      name
      query
    }
    success
  }
}
    `;
export type ContactAudienceAutoBuildMutationFn = Apollo.MutationFunction<ContactAudienceAutoBuildMutation, ContactAudienceAutoBuildMutationVariables>;

/**
 * __useContactAudienceAutoBuildMutation__
 *
 * To run a mutation, you first call `useContactAudienceAutoBuildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceAutoBuildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceAutoBuildMutation, { data, loading, error }] = useContactAudienceAutoBuildMutation({
 *   variables: {
 *      attributeIds: // value for 'attributeIds'
 *   },
 * });
 */
export function useContactAudienceAutoBuildMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceAutoBuildMutation, ContactAudienceAutoBuildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceAutoBuildMutation, ContactAudienceAutoBuildMutationVariables>(ContactAudienceAutoBuildDocument, options);
      }
export type ContactAudienceAutoBuildMutationHookResult = ReturnType<typeof useContactAudienceAutoBuildMutation>;
export type ContactAudienceAutoBuildMutationResult = Apollo.MutationResult<ContactAudienceAutoBuildMutation>;
export type ContactAudienceAutoBuildMutationOptions = Apollo.BaseMutationOptions<ContactAudienceAutoBuildMutation, ContactAudienceAutoBuildMutationVariables>;
export const ContactAudienceBuildDocument = gql`
    query ContactAudienceBuild($query: ContactQuery!, $splits: [ContactQuery!], $channelV2: Channel) {
  contactAudienceBuild(query: $query, splits: $splits, channelV2: $channelV2) {
    id
    total
    splits {
      total
    }
  }
}
    `;

/**
 * __useContactAudienceBuildQuery__
 *
 * To run a query within a React component, call `useContactAudienceBuildQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceBuildQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudienceBuildQuery({
 *   variables: {
 *      query: // value for 'query'
 *      splits: // value for 'splits'
 *      channelV2: // value for 'channelV2'
 *   },
 * });
 */
export function useContactAudienceBuildQuery(baseOptions: Apollo.QueryHookOptions<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables> & ({ variables: ContactAudienceBuildQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables>(ContactAudienceBuildDocument, options);
      }
export function useContactAudienceBuildLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables>(ContactAudienceBuildDocument, options);
        }
export function useContactAudienceBuildSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables>(ContactAudienceBuildDocument, options);
        }
export type ContactAudienceBuildQueryHookResult = ReturnType<typeof useContactAudienceBuildQuery>;
export type ContactAudienceBuildLazyQueryHookResult = ReturnType<typeof useContactAudienceBuildLazyQuery>;
export type ContactAudienceBuildSuspenseQueryHookResult = ReturnType<typeof useContactAudienceBuildSuspenseQuery>;
export type ContactAudienceBuildQueryResult = Apollo.QueryResult<ContactAudienceBuildQuery, ContactAudienceBuildQueryVariables>;
export const ContactAudienceBuildV2Document = gql`
    query ContactAudienceBuildV2($experimentConfig: ExperimentAudienceBuildInputConfig, $channelV2: Channel) {
  contactAudienceBuildV2(
    experimentConfig: $experimentConfig
    channelV2: $channelV2
  ) {
    id
    total
    splits {
      total
    }
  }
}
    `;

/**
 * __useContactAudienceBuildV2Query__
 *
 * To run a query within a React component, call `useContactAudienceBuildV2Query` and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceBuildV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudienceBuildV2Query({
 *   variables: {
 *      experimentConfig: // value for 'experimentConfig'
 *      channelV2: // value for 'channelV2'
 *   },
 * });
 */
export function useContactAudienceBuildV2Query(baseOptions?: Apollo.QueryHookOptions<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>(ContactAudienceBuildV2Document, options);
      }
export function useContactAudienceBuildV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>(ContactAudienceBuildV2Document, options);
        }
export function useContactAudienceBuildV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>(ContactAudienceBuildV2Document, options);
        }
export type ContactAudienceBuildV2QueryHookResult = ReturnType<typeof useContactAudienceBuildV2Query>;
export type ContactAudienceBuildV2LazyQueryHookResult = ReturnType<typeof useContactAudienceBuildV2LazyQuery>;
export type ContactAudienceBuildV2SuspenseQueryHookResult = ReturnType<typeof useContactAudienceBuildV2SuspenseQuery>;
export type ContactAudienceBuildV2QueryResult = Apollo.QueryResult<ContactAudienceBuildV2Query, ContactAudienceBuildV2QueryVariables>;
export const ContactAudienceCreateDocument = gql`
    mutation ContactAudienceCreate($name: String!, $description: String, $query: ContactQuery!, $splits: [ContactAudienceSplitInput], $overrides: [ContactAudienceOverrideInput]) {
  contactAudienceCreate(
    name: $name
    description: $description
    query: $query
    splits: $splits
    overrides: $overrides
  ) {
    contactAudience {
      ...ContactAudienceBuildFields
      updatedAt
      lastCount
    }
    success
  }
}
    ${ContactAudienceBuildFieldsFragmentDoc}`;
export type ContactAudienceCreateMutationFn = Apollo.MutationFunction<ContactAudienceCreateMutation, ContactAudienceCreateMutationVariables>;

/**
 * __useContactAudienceCreateMutation__
 *
 * To run a mutation, you first call `useContactAudienceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceCreateMutation, { data, loading, error }] = useContactAudienceCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      query: // value for 'query'
 *      splits: // value for 'splits'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useContactAudienceCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceCreateMutation, ContactAudienceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceCreateMutation, ContactAudienceCreateMutationVariables>(ContactAudienceCreateDocument, options);
      }
export type ContactAudienceCreateMutationHookResult = ReturnType<typeof useContactAudienceCreateMutation>;
export type ContactAudienceCreateMutationResult = Apollo.MutationResult<ContactAudienceCreateMutation>;
export type ContactAudienceCreateMutationOptions = Apollo.BaseMutationOptions<ContactAudienceCreateMutation, ContactAudienceCreateMutationVariables>;
export const ContactAudienceUpdateDocument = gql`
    mutation ContactAudienceUpdate($id: ID!, $name: String, $description: String, $query: ContactQuery, $splits: [ContactAudienceSplitUpdateInput], $overrides: [ContactAudienceOverrideUpdateInput], $archived: Boolean, $experimentUpdateInput: ContactAudienceExperimentAudienceUpdateInput) {
  contactAudienceUpdate(
    id: $id
    name: $name
    description: $description
    query: $query
    splits: $splits
    overrides: $overrides
    archived: $archived
    experimentUpdateInput: $experimentUpdateInput
  ) {
    contactAudience {
      ...ContactAudienceBuildFields
    }
    success
  }
}
    ${ContactAudienceBuildFieldsFragmentDoc}`;
export type ContactAudienceUpdateMutationFn = Apollo.MutationFunction<ContactAudienceUpdateMutation, ContactAudienceUpdateMutationVariables>;

/**
 * __useContactAudienceUpdateMutation__
 *
 * To run a mutation, you first call `useContactAudienceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceUpdateMutation, { data, loading, error }] = useContactAudienceUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      query: // value for 'query'
 *      splits: // value for 'splits'
 *      overrides: // value for 'overrides'
 *      archived: // value for 'archived'
 *      experimentUpdateInput: // value for 'experimentUpdateInput'
 *   },
 * });
 */
export function useContactAudienceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceUpdateMutation, ContactAudienceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceUpdateMutation, ContactAudienceUpdateMutationVariables>(ContactAudienceUpdateDocument, options);
      }
export type ContactAudienceUpdateMutationHookResult = ReturnType<typeof useContactAudienceUpdateMutation>;
export type ContactAudienceUpdateMutationResult = Apollo.MutationResult<ContactAudienceUpdateMutation>;
export type ContactAudienceUpdateMutationOptions = Apollo.BaseMutationOptions<ContactAudienceUpdateMutation, ContactAudienceUpdateMutationVariables>;
export const ContactAudienceDocument = gql`
    query ContactAudience($id: ID!) {
  contactAudience(id: $id) {
    ...ContactAudienceBuildFields
  }
}
    ${ContactAudienceBuildFieldsFragmentDoc}`;

/**
 * __useContactAudienceQuery__
 *
 * To run a query within a React component, call `useContactAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudienceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactAudienceQuery(baseOptions: Apollo.QueryHookOptions<ContactAudienceQuery, ContactAudienceQueryVariables> & ({ variables: ContactAudienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudienceQuery, ContactAudienceQueryVariables>(ContactAudienceDocument, options);
      }
export function useContactAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudienceQuery, ContactAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudienceQuery, ContactAudienceQueryVariables>(ContactAudienceDocument, options);
        }
export function useContactAudienceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudienceQuery, ContactAudienceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudienceQuery, ContactAudienceQueryVariables>(ContactAudienceDocument, options);
        }
export type ContactAudienceQueryHookResult = ReturnType<typeof useContactAudienceQuery>;
export type ContactAudienceLazyQueryHookResult = ReturnType<typeof useContactAudienceLazyQuery>;
export type ContactAudienceSuspenseQueryHookResult = ReturnType<typeof useContactAudienceSuspenseQuery>;
export type ContactAudienceQueryResult = Apollo.QueryResult<ContactAudienceQuery, ContactAudienceQueryVariables>;
export const ContactAudienceDetailDocument = gql`
    query ContactAudienceDetail($id: ID!) {
  contactAudience(id: $id) {
    id
    name
    description
    type
    createdAt
    updatedAt
    query
    archived
    splits {
      id
      name
      query
    }
  }
}
    `;

/**
 * __useContactAudienceDetailQuery__
 *
 * To run a query within a React component, call `useContactAudienceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudienceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactAudienceDetailQuery(baseOptions: Apollo.QueryHookOptions<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables> & ({ variables: ContactAudienceDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables>(ContactAudienceDetailDocument, options);
      }
export function useContactAudienceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables>(ContactAudienceDetailDocument, options);
        }
export function useContactAudienceDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables>(ContactAudienceDetailDocument, options);
        }
export type ContactAudienceDetailQueryHookResult = ReturnType<typeof useContactAudienceDetailQuery>;
export type ContactAudienceDetailLazyQueryHookResult = ReturnType<typeof useContactAudienceDetailLazyQuery>;
export type ContactAudienceDetailSuspenseQueryHookResult = ReturnType<typeof useContactAudienceDetailSuspenseQuery>;
export type ContactAudienceDetailQueryResult = Apollo.QueryResult<ContactAudienceDetailQuery, ContactAudienceDetailQueryVariables>;
export const AudienceCampaignsDocument = gql`
    query AudienceCampaigns($audienceId: ID!, $page: Int!, $pageSize: Int, $sort: [CampaignSortType!]) {
  campaigns(
    page: $page
    pageSize: $pageSize
    sort: $sort
    audienceIds: [$audienceId]
  ) {
    page
    total
    results {
      id
      legacyId
      title
      stage
      sendDate
      sendSchedule {
        id
        schedule {
          ... on StaticSendSchedule {
            datetime
          }
          ... on PersonalizedSendSchedule {
            isFullDay
            datetimeRanges
          }
        }
      }
      autoSchedule
    }
  }
}
    `;

/**
 * __useAudienceCampaignsQuery__
 *
 * To run a query within a React component, call `useAudienceCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceCampaignsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAudienceCampaignsQuery(baseOptions: Apollo.QueryHookOptions<AudienceCampaignsQuery, AudienceCampaignsQueryVariables> & ({ variables: AudienceCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceCampaignsQuery, AudienceCampaignsQueryVariables>(AudienceCampaignsDocument, options);
      }
export function useAudienceCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceCampaignsQuery, AudienceCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceCampaignsQuery, AudienceCampaignsQueryVariables>(AudienceCampaignsDocument, options);
        }
export function useAudienceCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudienceCampaignsQuery, AudienceCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudienceCampaignsQuery, AudienceCampaignsQueryVariables>(AudienceCampaignsDocument, options);
        }
export type AudienceCampaignsQueryHookResult = ReturnType<typeof useAudienceCampaignsQuery>;
export type AudienceCampaignsLazyQueryHookResult = ReturnType<typeof useAudienceCampaignsLazyQuery>;
export type AudienceCampaignsSuspenseQueryHookResult = ReturnType<typeof useAudienceCampaignsSuspenseQuery>;
export type AudienceCampaignsQueryResult = Apollo.QueryResult<AudienceCampaignsQuery, AudienceCampaignsQueryVariables>;
export const TotalAudienceCampaignsDocument = gql`
    query TotalAudienceCampaigns($audienceId: ID!, $page: Int!) {
  campaigns(page: $page, audienceIds: [$audienceId]) {
    page
    total
  }
}
    `;

/**
 * __useTotalAudienceCampaignsQuery__
 *
 * To run a query within a React component, call `useTotalAudienceCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalAudienceCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalAudienceCampaignsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTotalAudienceCampaignsQuery(baseOptions: Apollo.QueryHookOptions<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables> & ({ variables: TotalAudienceCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables>(TotalAudienceCampaignsDocument, options);
      }
export function useTotalAudienceCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables>(TotalAudienceCampaignsDocument, options);
        }
export function useTotalAudienceCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables>(TotalAudienceCampaignsDocument, options);
        }
export type TotalAudienceCampaignsQueryHookResult = ReturnType<typeof useTotalAudienceCampaignsQuery>;
export type TotalAudienceCampaignsLazyQueryHookResult = ReturnType<typeof useTotalAudienceCampaignsLazyQuery>;
export type TotalAudienceCampaignsSuspenseQueryHookResult = ReturnType<typeof useTotalAudienceCampaignsSuspenseQuery>;
export type TotalAudienceCampaignsQueryResult = Apollo.QueryResult<TotalAudienceCampaignsQuery, TotalAudienceCampaignsQueryVariables>;
export const AudiencesIndexFiltersDocument = gql`
    query AudiencesIndexFilters($archived: Boolean, $campaignIds: [ID!], $inUse: Boolean, $types: [ContactAudienceType!]) {
  campaigns(page: 1, pageSize: 1000000) {
    results {
      id
      title
    }
  }
  contactAudienceFiltersCounts(
    archived: $archived
    campaignIds: $campaignIds
    inUse: $inUse
    types: $types
  ) {
    archived
    inUse
    notInUse
    perType {
      type
      count
    }
  }
}
    `;

/**
 * __useAudiencesIndexFiltersQuery__
 *
 * To run a query within a React component, call `useAudiencesIndexFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesIndexFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesIndexFiltersQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      campaignIds: // value for 'campaignIds'
 *      inUse: // value for 'inUse'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useAudiencesIndexFiltersQuery(baseOptions?: Apollo.QueryHookOptions<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>(AudiencesIndexFiltersDocument, options);
      }
export function useAudiencesIndexFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>(AudiencesIndexFiltersDocument, options);
        }
export function useAudiencesIndexFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>(AudiencesIndexFiltersDocument, options);
        }
export type AudiencesIndexFiltersQueryHookResult = ReturnType<typeof useAudiencesIndexFiltersQuery>;
export type AudiencesIndexFiltersLazyQueryHookResult = ReturnType<typeof useAudiencesIndexFiltersLazyQuery>;
export type AudiencesIndexFiltersSuspenseQueryHookResult = ReturnType<typeof useAudiencesIndexFiltersSuspenseQuery>;
export type AudiencesIndexFiltersQueryResult = Apollo.QueryResult<AudiencesIndexFiltersQuery, AudiencesIndexFiltersQueryVariables>;
export const ContactAudiencesDocument = gql`
    query ContactAudiences($limit: Int, $offset: Int, $search: String, $orderBy: ContactAudiencesOrderBy, $types: [ContactAudienceType!], $archived: Boolean, $inUse: Boolean, $campaignIds: [ID!]) {
  contactAudiences(
    limit: $limit
    offset: $offset
    search: $search
    orderBy: $orderBy
    types: $types
    archived: $archived
    inUse: $inUse
    campaignIds: $campaignIds
  ) {
    audiences {
      id
      name
      description
      updatedAt
      lastCount
      archived
      type
      query
      experimentSeed
      splits {
        id
        name
        query
        fallback
        ratio
        control
      }
      overrides {
        fieldId
        id
        splitId
        value {
          ... on ContactAudienceOverrideValueString {
            string
          }
          ... on ContactAudienceOverrideValueInteger {
            integer
          }
          ... on ContactAudienceOverrideValueFloat {
            float
          }
          ... on ContactAudienceOverrideValueBoolean {
            boolean
          }
          ... on ContactAudienceOverrideValueDateTime {
            datetime
          }
          ... on ContactAudienceOverrideValueDate {
            date
          }
        }
      }
      creativeIds
      campaignIds
    }
    total
  }
}
    `;

/**
 * __useContactAudiencesQuery__
 *
 * To run a query within a React component, call `useContactAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudiencesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      types: // value for 'types'
 *      archived: // value for 'archived'
 *      inUse: // value for 'inUse'
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useContactAudiencesQuery(baseOptions?: Apollo.QueryHookOptions<ContactAudiencesQuery, ContactAudiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudiencesQuery, ContactAudiencesQueryVariables>(ContactAudiencesDocument, options);
      }
export function useContactAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudiencesQuery, ContactAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudiencesQuery, ContactAudiencesQueryVariables>(ContactAudiencesDocument, options);
        }
export function useContactAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudiencesQuery, ContactAudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudiencesQuery, ContactAudiencesQueryVariables>(ContactAudiencesDocument, options);
        }
export type ContactAudiencesQueryHookResult = ReturnType<typeof useContactAudiencesQuery>;
export type ContactAudiencesLazyQueryHookResult = ReturnType<typeof useContactAudiencesLazyQuery>;
export type ContactAudiencesSuspenseQueryHookResult = ReturnType<typeof useContactAudiencesSuspenseQuery>;
export type ContactAudiencesQueryResult = Apollo.QueryResult<ContactAudiencesQuery, ContactAudiencesQueryVariables>;
export const ContactAudienceArchiveDocument = gql`
    mutation ContactAudienceArchive($id: ID!) {
  contactAudienceArchive(id: $id) {
    contactAudience {
      id
      archived
    }
    success
  }
}
    `;
export type ContactAudienceArchiveMutationFn = Apollo.MutationFunction<ContactAudienceArchiveMutation, ContactAudienceArchiveMutationVariables>;

/**
 * __useContactAudienceArchiveMutation__
 *
 * To run a mutation, you first call `useContactAudienceArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceArchiveMutation, { data, loading, error }] = useContactAudienceArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactAudienceArchiveMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceArchiveMutation, ContactAudienceArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceArchiveMutation, ContactAudienceArchiveMutationVariables>(ContactAudienceArchiveDocument, options);
      }
export type ContactAudienceArchiveMutationHookResult = ReturnType<typeof useContactAudienceArchiveMutation>;
export type ContactAudienceArchiveMutationResult = Apollo.MutationResult<ContactAudienceArchiveMutation>;
export type ContactAudienceArchiveMutationOptions = Apollo.BaseMutationOptions<ContactAudienceArchiveMutation, ContactAudienceArchiveMutationVariables>;
export const CreateBrandKitDocument = gql`
    mutation CreateBrandKit($input: BrandKitCreateInput!) {
  brandKitCreate(input: $input) {
    success
    brandKit {
      ...brandKitFragment
    }
  }
}
    ${BrandKitFragmentFragmentDoc}`;
export type CreateBrandKitMutationFn = Apollo.MutationFunction<CreateBrandKitMutation, CreateBrandKitMutationVariables>;

/**
 * __useCreateBrandKitMutation__
 *
 * To run a mutation, you first call `useCreateBrandKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandKitMutation, { data, loading, error }] = useCreateBrandKitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandKitMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandKitMutation, CreateBrandKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandKitMutation, CreateBrandKitMutationVariables>(CreateBrandKitDocument, options);
      }
export type CreateBrandKitMutationHookResult = ReturnType<typeof useCreateBrandKitMutation>;
export type CreateBrandKitMutationResult = Apollo.MutationResult<CreateBrandKitMutation>;
export type CreateBrandKitMutationOptions = Apollo.BaseMutationOptions<CreateBrandKitMutation, CreateBrandKitMutationVariables>;
export const UpdateBrandKitDocument = gql`
    mutation UpdateBrandKit($id: ID!, $input: BrandKitCreateInput!) {
  brandKitUpdate2(id: $id, input: $input) {
    success
    brandKit {
      ...brandKitFragment
    }
  }
}
    ${BrandKitFragmentFragmentDoc}`;
export type UpdateBrandKitMutationFn = Apollo.MutationFunction<UpdateBrandKitMutation, UpdateBrandKitMutationVariables>;

/**
 * __useUpdateBrandKitMutation__
 *
 * To run a mutation, you first call `useUpdateBrandKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandKitMutation, { data, loading, error }] = useUpdateBrandKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandKitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandKitMutation, UpdateBrandKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandKitMutation, UpdateBrandKitMutationVariables>(UpdateBrandKitDocument, options);
      }
export type UpdateBrandKitMutationHookResult = ReturnType<typeof useUpdateBrandKitMutation>;
export type UpdateBrandKitMutationResult = Apollo.MutationResult<UpdateBrandKitMutation>;
export type UpdateBrandKitMutationOptions = Apollo.BaseMutationOptions<UpdateBrandKitMutation, UpdateBrandKitMutationVariables>;
export const CustomFontsDocument = gql`
    query CustomFonts {
  customFonts {
    ...customFontFragment
  }
}
    ${CustomFontFragmentFragmentDoc}`;

/**
 * __useCustomFontsQuery__
 *
 * To run a query within a React component, call `useCustomFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFontsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomFontsQuery(baseOptions?: Apollo.QueryHookOptions<CustomFontsQuery, CustomFontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFontsQuery, CustomFontsQueryVariables>(CustomFontsDocument, options);
      }
export function useCustomFontsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFontsQuery, CustomFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFontsQuery, CustomFontsQueryVariables>(CustomFontsDocument, options);
        }
export function useCustomFontsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomFontsQuery, CustomFontsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomFontsQuery, CustomFontsQueryVariables>(CustomFontsDocument, options);
        }
export type CustomFontsQueryHookResult = ReturnType<typeof useCustomFontsQuery>;
export type CustomFontsLazyQueryHookResult = ReturnType<typeof useCustomFontsLazyQuery>;
export type CustomFontsSuspenseQueryHookResult = ReturnType<typeof useCustomFontsSuspenseQuery>;
export type CustomFontsQueryResult = Apollo.QueryResult<CustomFontsQuery, CustomFontsQueryVariables>;
export const BrandKitsDocument = gql`
    query BrandKits {
  brandKits {
    ...brandKitFragment
  }
}
    ${BrandKitFragmentFragmentDoc}`;

/**
 * __useBrandKitsQuery__
 *
 * To run a query within a React component, call `useBrandKitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandKitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandKitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandKitsQuery(baseOptions?: Apollo.QueryHookOptions<BrandKitsQuery, BrandKitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandKitsQuery, BrandKitsQueryVariables>(BrandKitsDocument, options);
      }
export function useBrandKitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandKitsQuery, BrandKitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandKitsQuery, BrandKitsQueryVariables>(BrandKitsDocument, options);
        }
export function useBrandKitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandKitsQuery, BrandKitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandKitsQuery, BrandKitsQueryVariables>(BrandKitsDocument, options);
        }
export type BrandKitsQueryHookResult = ReturnType<typeof useBrandKitsQuery>;
export type BrandKitsLazyQueryHookResult = ReturnType<typeof useBrandKitsLazyQuery>;
export type BrandKitsSuspenseQueryHookResult = ReturnType<typeof useBrandKitsSuspenseQuery>;
export type BrandKitsQueryResult = Apollo.QueryResult<BrandKitsQuery, BrandKitsQueryVariables>;
export const LayoutComponentsPaginatedDocument = gql`
    query LayoutComponentsPaginated($page: Int!, $pageSize: Int, $filters: LayoutComponentFilterInput) {
  layoutComponentsPage(page: $page, pageSize: $pageSize, filters: $filters) {
    page
    total
    results {
      id
      name
      description
      thumbnail
    }
  }
}
    `;

/**
 * __useLayoutComponentsPaginatedQuery__
 *
 * To run a query within a React component, call `useLayoutComponentsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutComponentsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutComponentsPaginatedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLayoutComponentsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables> & ({ variables: LayoutComponentsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables>(LayoutComponentsPaginatedDocument, options);
      }
export function useLayoutComponentsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables>(LayoutComponentsPaginatedDocument, options);
        }
export function useLayoutComponentsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables>(LayoutComponentsPaginatedDocument, options);
        }
export type LayoutComponentsPaginatedQueryHookResult = ReturnType<typeof useLayoutComponentsPaginatedQuery>;
export type LayoutComponentsPaginatedLazyQueryHookResult = ReturnType<typeof useLayoutComponentsPaginatedLazyQuery>;
export type LayoutComponentsPaginatedSuspenseQueryHookResult = ReturnType<typeof useLayoutComponentsPaginatedSuspenseQuery>;
export type LayoutComponentsPaginatedQueryResult = Apollo.QueryResult<LayoutComponentsPaginatedQuery, LayoutComponentsPaginatedQueryVariables>;
export const LayoutComponentArchiveDocument = gql`
    mutation LayoutComponentArchive($id: ID!) {
  layoutComponentArchive(id: $id) {
    success
    layoutComponent {
      id
    }
  }
}
    `;
export type LayoutComponentArchiveMutationFn = Apollo.MutationFunction<LayoutComponentArchiveMutation, LayoutComponentArchiveMutationVariables>;

/**
 * __useLayoutComponentArchiveMutation__
 *
 * To run a mutation, you first call `useLayoutComponentArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutComponentArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutComponentArchiveMutation, { data, loading, error }] = useLayoutComponentArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutComponentArchiveMutation(baseOptions?: Apollo.MutationHookOptions<LayoutComponentArchiveMutation, LayoutComponentArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LayoutComponentArchiveMutation, LayoutComponentArchiveMutationVariables>(LayoutComponentArchiveDocument, options);
      }
export type LayoutComponentArchiveMutationHookResult = ReturnType<typeof useLayoutComponentArchiveMutation>;
export type LayoutComponentArchiveMutationResult = Apollo.MutationResult<LayoutComponentArchiveMutation>;
export type LayoutComponentArchiveMutationOptions = Apollo.BaseMutationOptions<LayoutComponentArchiveMutation, LayoutComponentArchiveMutationVariables>;
export const LayoutComponentDuplicateDocument = gql`
    mutation LayoutComponentDuplicate($id: ID!) {
  layoutComponentDuplicate(id: $id) {
    success
    layoutComponent {
      id
      name
    }
  }
}
    `;
export type LayoutComponentDuplicateMutationFn = Apollo.MutationFunction<LayoutComponentDuplicateMutation, LayoutComponentDuplicateMutationVariables>;

/**
 * __useLayoutComponentDuplicateMutation__
 *
 * To run a mutation, you first call `useLayoutComponentDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutComponentDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutComponentDuplicateMutation, { data, loading, error }] = useLayoutComponentDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutComponentDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<LayoutComponentDuplicateMutation, LayoutComponentDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LayoutComponentDuplicateMutation, LayoutComponentDuplicateMutationVariables>(LayoutComponentDuplicateDocument, options);
      }
export type LayoutComponentDuplicateMutationHookResult = ReturnType<typeof useLayoutComponentDuplicateMutation>;
export type LayoutComponentDuplicateMutationResult = Apollo.MutationResult<LayoutComponentDuplicateMutation>;
export type LayoutComponentDuplicateMutationOptions = Apollo.BaseMutationOptions<LayoutComponentDuplicateMutation, LayoutComponentDuplicateMutationVariables>;
export const BlocksPaginatedDocument = gql`
    query BlocksPaginated($page: Int!, $pageSize: Int, $filters: BlockFilterInput) {
  blocksPage(page: $page, pageSize: $pageSize, filters: $filters) {
    page
    total
    results {
      id
      name
      description
      thumbnail
    }
  }
}
    `;

/**
 * __useBlocksPaginatedQuery__
 *
 * To run a query within a React component, call `useBlocksPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksPaginatedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBlocksPaginatedQuery(baseOptions: Apollo.QueryHookOptions<BlocksPaginatedQuery, BlocksPaginatedQueryVariables> & ({ variables: BlocksPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlocksPaginatedQuery, BlocksPaginatedQueryVariables>(BlocksPaginatedDocument, options);
      }
export function useBlocksPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlocksPaginatedQuery, BlocksPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlocksPaginatedQuery, BlocksPaginatedQueryVariables>(BlocksPaginatedDocument, options);
        }
export function useBlocksPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BlocksPaginatedQuery, BlocksPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlocksPaginatedQuery, BlocksPaginatedQueryVariables>(BlocksPaginatedDocument, options);
        }
export type BlocksPaginatedQueryHookResult = ReturnType<typeof useBlocksPaginatedQuery>;
export type BlocksPaginatedLazyQueryHookResult = ReturnType<typeof useBlocksPaginatedLazyQuery>;
export type BlocksPaginatedSuspenseQueryHookResult = ReturnType<typeof useBlocksPaginatedSuspenseQuery>;
export type BlocksPaginatedQueryResult = Apollo.QueryResult<BlocksPaginatedQuery, BlocksPaginatedQueryVariables>;
export const BlockArchiveDocument = gql`
    mutation BlockArchive($id: ID!) {
  blockArchive(id: $id) {
    success
    block {
      id
    }
  }
}
    `;
export type BlockArchiveMutationFn = Apollo.MutationFunction<BlockArchiveMutation, BlockArchiveMutationVariables>;

/**
 * __useBlockArchiveMutation__
 *
 * To run a mutation, you first call `useBlockArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockArchiveMutation, { data, loading, error }] = useBlockArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockArchiveMutation(baseOptions?: Apollo.MutationHookOptions<BlockArchiveMutation, BlockArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockArchiveMutation, BlockArchiveMutationVariables>(BlockArchiveDocument, options);
      }
export type BlockArchiveMutationHookResult = ReturnType<typeof useBlockArchiveMutation>;
export type BlockArchiveMutationResult = Apollo.MutationResult<BlockArchiveMutation>;
export type BlockArchiveMutationOptions = Apollo.BaseMutationOptions<BlockArchiveMutation, BlockArchiveMutationVariables>;
export const BlockDuplicateDocument = gql`
    mutation BlockDuplicate($id: ID!) {
  blockDuplicate(id: $id) {
    success
    block {
      id
      name
    }
  }
}
    `;
export type BlockDuplicateMutationFn = Apollo.MutationFunction<BlockDuplicateMutation, BlockDuplicateMutationVariables>;

/**
 * __useBlockDuplicateMutation__
 *
 * To run a mutation, you first call `useBlockDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockDuplicateMutation, { data, loading, error }] = useBlockDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<BlockDuplicateMutation, BlockDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockDuplicateMutation, BlockDuplicateMutationVariables>(BlockDuplicateDocument, options);
      }
export type BlockDuplicateMutationHookResult = ReturnType<typeof useBlockDuplicateMutation>;
export type BlockDuplicateMutationResult = Apollo.MutationResult<BlockDuplicateMutation>;
export type BlockDuplicateMutationOptions = Apollo.BaseMutationOptions<BlockDuplicateMutation, BlockDuplicateMutationVariables>;
export const BrandKitGenerationCreateDocument = gql`
    mutation BrandKitGenerationCreate($input: BrandKitGenerationCreateInput!) {
  brandKitGenerationCreate(input: $input) {
    success
    brandKitGeneration {
      id
      threadId
      status
      type
    }
  }
}
    `;
export type BrandKitGenerationCreateMutationFn = Apollo.MutationFunction<BrandKitGenerationCreateMutation, BrandKitGenerationCreateMutationVariables>;

/**
 * __useBrandKitGenerationCreateMutation__
 *
 * To run a mutation, you first call `useBrandKitGenerationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandKitGenerationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandKitGenerationCreateMutation, { data, loading, error }] = useBrandKitGenerationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandKitGenerationCreateMutation(baseOptions?: Apollo.MutationHookOptions<BrandKitGenerationCreateMutation, BrandKitGenerationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandKitGenerationCreateMutation, BrandKitGenerationCreateMutationVariables>(BrandKitGenerationCreateDocument, options);
      }
export type BrandKitGenerationCreateMutationHookResult = ReturnType<typeof useBrandKitGenerationCreateMutation>;
export type BrandKitGenerationCreateMutationResult = Apollo.MutationResult<BrandKitGenerationCreateMutation>;
export type BrandKitGenerationCreateMutationOptions = Apollo.BaseMutationOptions<BrandKitGenerationCreateMutation, BrandKitGenerationCreateMutationVariables>;
export const BrandKitGenerationUpdateStatusDocument = gql`
    mutation BrandKitGenerationUpdateStatus($input: BrandKitGenerationUpdateStatusInput!) {
  brandKitGenerationUpdateStatus(input: $input) {
    success
    brandKitGeneration {
      id
      status
    }
  }
}
    `;
export type BrandKitGenerationUpdateStatusMutationFn = Apollo.MutationFunction<BrandKitGenerationUpdateStatusMutation, BrandKitGenerationUpdateStatusMutationVariables>;

/**
 * __useBrandKitGenerationUpdateStatusMutation__
 *
 * To run a mutation, you first call `useBrandKitGenerationUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandKitGenerationUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandKitGenerationUpdateStatusMutation, { data, loading, error }] = useBrandKitGenerationUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandKitGenerationUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<BrandKitGenerationUpdateStatusMutation, BrandKitGenerationUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandKitGenerationUpdateStatusMutation, BrandKitGenerationUpdateStatusMutationVariables>(BrandKitGenerationUpdateStatusDocument, options);
      }
export type BrandKitGenerationUpdateStatusMutationHookResult = ReturnType<typeof useBrandKitGenerationUpdateStatusMutation>;
export type BrandKitGenerationUpdateStatusMutationResult = Apollo.MutationResult<BrandKitGenerationUpdateStatusMutation>;
export type BrandKitGenerationUpdateStatusMutationOptions = Apollo.BaseMutationOptions<BrandKitGenerationUpdateStatusMutation, BrandKitGenerationUpdateStatusMutationVariables>;
export const BrandKitGenerationsDocument = gql`
    query BrandKitGenerations {
  brandKitGenerations {
    id
    threadId
    status
    type
    createdAt
  }
}
    `;

/**
 * __useBrandKitGenerationsQuery__
 *
 * To run a query within a React component, call `useBrandKitGenerationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandKitGenerationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandKitGenerationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandKitGenerationsQuery(baseOptions?: Apollo.QueryHookOptions<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>(BrandKitGenerationsDocument, options);
      }
export function useBrandKitGenerationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>(BrandKitGenerationsDocument, options);
        }
export function useBrandKitGenerationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>(BrandKitGenerationsDocument, options);
        }
export type BrandKitGenerationsQueryHookResult = ReturnType<typeof useBrandKitGenerationsQuery>;
export type BrandKitGenerationsLazyQueryHookResult = ReturnType<typeof useBrandKitGenerationsLazyQuery>;
export type BrandKitGenerationsSuspenseQueryHookResult = ReturnType<typeof useBrandKitGenerationsSuspenseQuery>;
export type BrandKitGenerationsQueryResult = Apollo.QueryResult<BrandKitGenerationsQuery, BrandKitGenerationsQueryVariables>;
export const CampaignsWithOverlappingSendTimesDocument = gql`
    query CampaignsWithOverlappingSendTimes($campaignId: ID!) {
  campaignsWithOverlappingSendTimes(campaignId: $campaignId) {
    id
    title
  }
}
    `;

/**
 * __useCampaignsWithOverlappingSendTimesQuery__
 *
 * To run a query within a React component, call `useCampaignsWithOverlappingSendTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsWithOverlappingSendTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsWithOverlappingSendTimesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignsWithOverlappingSendTimesQuery(baseOptions: Apollo.QueryHookOptions<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables> & ({ variables: CampaignsWithOverlappingSendTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables>(CampaignsWithOverlappingSendTimesDocument, options);
      }
export function useCampaignsWithOverlappingSendTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables>(CampaignsWithOverlappingSendTimesDocument, options);
        }
export function useCampaignsWithOverlappingSendTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables>(CampaignsWithOverlappingSendTimesDocument, options);
        }
export type CampaignsWithOverlappingSendTimesQueryHookResult = ReturnType<typeof useCampaignsWithOverlappingSendTimesQuery>;
export type CampaignsWithOverlappingSendTimesLazyQueryHookResult = ReturnType<typeof useCampaignsWithOverlappingSendTimesLazyQuery>;
export type CampaignsWithOverlappingSendTimesSuspenseQueryHookResult = ReturnType<typeof useCampaignsWithOverlappingSendTimesSuspenseQuery>;
export type CampaignsWithOverlappingSendTimesQueryResult = Apollo.QueryResult<CampaignsWithOverlappingSendTimesQuery, CampaignsWithOverlappingSendTimesQueryVariables>;
export const CampaignAudienceOverlapCountDocument = gql`
    query CampaignAudienceOverlapCount($campaignId: ID!, $overlappingCampaignId: ID!) {
  campaignAudienceOverlapCount(
    campaignId: $campaignId
    overlappingCampaignId: $overlappingCampaignId
  )
}
    `;

/**
 * __useCampaignAudienceOverlapCountQuery__
 *
 * To run a query within a React component, call `useCampaignAudienceOverlapCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAudienceOverlapCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAudienceOverlapCountQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      overlappingCampaignId: // value for 'overlappingCampaignId'
 *   },
 * });
 */
export function useCampaignAudienceOverlapCountQuery(baseOptions: Apollo.QueryHookOptions<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables> & ({ variables: CampaignAudienceOverlapCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables>(CampaignAudienceOverlapCountDocument, options);
      }
export function useCampaignAudienceOverlapCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables>(CampaignAudienceOverlapCountDocument, options);
        }
export function useCampaignAudienceOverlapCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables>(CampaignAudienceOverlapCountDocument, options);
        }
export type CampaignAudienceOverlapCountQueryHookResult = ReturnType<typeof useCampaignAudienceOverlapCountQuery>;
export type CampaignAudienceOverlapCountLazyQueryHookResult = ReturnType<typeof useCampaignAudienceOverlapCountLazyQuery>;
export type CampaignAudienceOverlapCountSuspenseQueryHookResult = ReturnType<typeof useCampaignAudienceOverlapCountSuspenseQuery>;
export type CampaignAudienceOverlapCountQueryResult = Apollo.QueryResult<CampaignAudienceOverlapCountQuery, CampaignAudienceOverlapCountQueryVariables>;
export const AudiencesDocument = gql`
    query Audiences($limit: Int, $offset: Int, $search: String, $orderBy: ContactAudiencesOrderBy, $archived: Boolean) {
  contactAudiences(
    limit: $limit
    offset: $offset
    search: $search
    orderBy: $orderBy
    archived: $archived
  ) {
    audiences {
      id
      name
      description
      archived
      lastCount
      splits {
        id
        createdAt
        updatedAt
        name
      }
      type
    }
    total
  }
}
    `;

/**
 * __useAudiencesQuery__
 *
 * To run a query within a React component, call `useAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useAudiencesQuery(baseOptions?: Apollo.QueryHookOptions<AudiencesQuery, AudiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, options);
      }
export function useAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesQuery, AudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, options);
        }
export function useAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AudiencesQuery, AudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AudiencesQuery, AudiencesQueryVariables>(AudiencesDocument, options);
        }
export type AudiencesQueryHookResult = ReturnType<typeof useAudiencesQuery>;
export type AudiencesLazyQueryHookResult = ReturnType<typeof useAudiencesLazyQuery>;
export type AudiencesSuspenseQueryHookResult = ReturnType<typeof useAudiencesSuspenseQuery>;
export type AudiencesQueryResult = Apollo.QueryResult<AudiencesQuery, AudiencesQueryVariables>;
export const ContactAudienceIncludeDocument = gql`
    mutation ContactAudienceInclude($campaignId: ID!, $contactAudienceId: ID!, $selectedSplits: [ID!]!, $unselectedSplits: [ID!]!, $confirm: Boolean) {
  contactAudienceInclude(
    campaignId: $campaignId
    contactAudienceId: $contactAudienceId
    selectedSplits: $selectedSplits
    unselectedSplits: $unselectedSplits
    confirm: $confirm
  ) {
    ... on NeedsConfirmation {
      success
    }
    ... on CampaignSuccess {
      success
      campaign {
        id
        includedContactAudiences {
          ...contactAudienceConfigFragment
        }
        excludedContactAudiences {
          ...contactAudienceConfigFragment
        }
      }
    }
  }
}
    ${ContactAudienceConfigFragmentFragmentDoc}`;
export type ContactAudienceIncludeMutationFn = Apollo.MutationFunction<ContactAudienceIncludeMutation, ContactAudienceIncludeMutationVariables>;

/**
 * __useContactAudienceIncludeMutation__
 *
 * To run a mutation, you first call `useContactAudienceIncludeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceIncludeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceIncludeMutation, { data, loading, error }] = useContactAudienceIncludeMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      contactAudienceId: // value for 'contactAudienceId'
 *      selectedSplits: // value for 'selectedSplits'
 *      unselectedSplits: // value for 'unselectedSplits'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useContactAudienceIncludeMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceIncludeMutation, ContactAudienceIncludeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceIncludeMutation, ContactAudienceIncludeMutationVariables>(ContactAudienceIncludeDocument, options);
      }
export type ContactAudienceIncludeMutationHookResult = ReturnType<typeof useContactAudienceIncludeMutation>;
export type ContactAudienceIncludeMutationResult = Apollo.MutationResult<ContactAudienceIncludeMutation>;
export type ContactAudienceIncludeMutationOptions = Apollo.BaseMutationOptions<ContactAudienceIncludeMutation, ContactAudienceIncludeMutationVariables>;
export const ContactAudienceExcludeDocument = gql`
    mutation ContactAudienceExclude($campaignId: ID!, $contactAudienceId: ID!, $selectedSplits: [ID!]!, $unselectedSplits: [ID!]!) {
  contactAudienceExclude(
    campaignId: $campaignId
    contactAudienceId: $contactAudienceId
    selectedSplits: $selectedSplits
    unselectedSplits: $unselectedSplits
  ) {
    success
    campaign {
      id
      includedContactAudiences {
        ...contactAudienceConfigFragment
      }
      excludedContactAudiences {
        ...contactAudienceConfigFragment
      }
    }
  }
}
    ${ContactAudienceConfigFragmentFragmentDoc}`;
export type ContactAudienceExcludeMutationFn = Apollo.MutationFunction<ContactAudienceExcludeMutation, ContactAudienceExcludeMutationVariables>;

/**
 * __useContactAudienceExcludeMutation__
 *
 * To run a mutation, you first call `useContactAudienceExcludeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceExcludeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceExcludeMutation, { data, loading, error }] = useContactAudienceExcludeMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      contactAudienceId: // value for 'contactAudienceId'
 *      selectedSplits: // value for 'selectedSplits'
 *      unselectedSplits: // value for 'unselectedSplits'
 *   },
 * });
 */
export function useContactAudienceExcludeMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceExcludeMutation, ContactAudienceExcludeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceExcludeMutation, ContactAudienceExcludeMutationVariables>(ContactAudienceExcludeDocument, options);
      }
export type ContactAudienceExcludeMutationHookResult = ReturnType<typeof useContactAudienceExcludeMutation>;
export type ContactAudienceExcludeMutationResult = Apollo.MutationResult<ContactAudienceExcludeMutation>;
export type ContactAudienceExcludeMutationOptions = Apollo.BaseMutationOptions<ContactAudienceExcludeMutation, ContactAudienceExcludeMutationVariables>;
export const ContactAudienceConfigRemoveDocument = gql`
    mutation ContactAudienceConfigRemove($campaignId: ID!, $confirm: Boolean, $contactAudienceConfigId: ID!) {
  contactAudienceConfigRemove(
    campaignId: $campaignId
    confirm: $confirm
    contactAudienceConfigId: $contactAudienceConfigId
  ) {
    ... on NeedsConfirmation {
      success
    }
    ... on CampaignSuccess {
      success
      campaign {
        id
        includedContactAudiences {
          ...contactAudienceConfigFragment
        }
        excludedContactAudiences {
          ...contactAudienceConfigFragment
        }
      }
    }
  }
}
    ${ContactAudienceConfigFragmentFragmentDoc}`;
export type ContactAudienceConfigRemoveMutationFn = Apollo.MutationFunction<ContactAudienceConfigRemoveMutation, ContactAudienceConfigRemoveMutationVariables>;

/**
 * __useContactAudienceConfigRemoveMutation__
 *
 * To run a mutation, you first call `useContactAudienceConfigRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceConfigRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceConfigRemoveMutation, { data, loading, error }] = useContactAudienceConfigRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      confirm: // value for 'confirm'
 *      contactAudienceConfigId: // value for 'contactAudienceConfigId'
 *   },
 * });
 */
export function useContactAudienceConfigRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceConfigRemoveMutation, ContactAudienceConfigRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceConfigRemoveMutation, ContactAudienceConfigRemoveMutationVariables>(ContactAudienceConfigRemoveDocument, options);
      }
export type ContactAudienceConfigRemoveMutationHookResult = ReturnType<typeof useContactAudienceConfigRemoveMutation>;
export type ContactAudienceConfigRemoveMutationResult = Apollo.MutationResult<ContactAudienceConfigRemoveMutation>;
export type ContactAudienceConfigRemoveMutationOptions = Apollo.BaseMutationOptions<ContactAudienceConfigRemoveMutation, ContactAudienceConfigRemoveMutationVariables>;
export const ContactAudienceReorderDocument = gql`
    mutation ContactAudienceReorder($campaignId: ID!, $contactAudienceIds: [ID!]!) {
  contactAudienceReorder(
    campaignId: $campaignId
    contactAudienceIds: $contactAudienceIds
  ) {
    success
    campaign {
      id
      includedContactAudiences {
        ...contactAudienceConfigFragment
      }
      excludedContactAudiences {
        ...contactAudienceConfigFragment
      }
    }
  }
}
    ${ContactAudienceConfigFragmentFragmentDoc}`;
export type ContactAudienceReorderMutationFn = Apollo.MutationFunction<ContactAudienceReorderMutation, ContactAudienceReorderMutationVariables>;

/**
 * __useContactAudienceReorderMutation__
 *
 * To run a mutation, you first call `useContactAudienceReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceReorderMutation, { data, loading, error }] = useContactAudienceReorderMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      contactAudienceIds: // value for 'contactAudienceIds'
 *   },
 * });
 */
export function useContactAudienceReorderMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceReorderMutation, ContactAudienceReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceReorderMutation, ContactAudienceReorderMutationVariables>(ContactAudienceReorderDocument, options);
      }
export type ContactAudienceReorderMutationHookResult = ReturnType<typeof useContactAudienceReorderMutation>;
export type ContactAudienceReorderMutationResult = Apollo.MutationResult<ContactAudienceReorderMutation>;
export type ContactAudienceReorderMutationOptions = Apollo.BaseMutationOptions<ContactAudienceReorderMutation, ContactAudienceReorderMutationVariables>;
export const ContactSnapshotCountDocument = gql`
    mutation ContactSnapshotCount($excludeAudiences: [ContactSnapshotAudienceInput!]!, $includeAudiences: [ContactSnapshotAudienceInput!]!, $campaignId: ID, $channel: Channel!) {
  contactSnapshotCount(
    excludeAudiences: $excludeAudiences
    includeAudiences: $includeAudiences
    campaignId: $campaignId
    channelV2: $channel
  ) {
    count {
      total
      includeAudiences {
        id
        total
        audienceSplits {
          id
          total
        }
      }
      excludeAudiences {
        id
        total
        audienceSplits {
          id
          total
        }
      }
    }
  }
}
    `;
export type ContactSnapshotCountMutationFn = Apollo.MutationFunction<ContactSnapshotCountMutation, ContactSnapshotCountMutationVariables>;

/**
 * __useContactSnapshotCountMutation__
 *
 * To run a mutation, you first call `useContactSnapshotCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSnapshotCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSnapshotCountMutation, { data, loading, error }] = useContactSnapshotCountMutation({
 *   variables: {
 *      excludeAudiences: // value for 'excludeAudiences'
 *      includeAudiences: // value for 'includeAudiences'
 *      campaignId: // value for 'campaignId'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useContactSnapshotCountMutation(baseOptions?: Apollo.MutationHookOptions<ContactSnapshotCountMutation, ContactSnapshotCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSnapshotCountMutation, ContactSnapshotCountMutationVariables>(ContactSnapshotCountDocument, options);
      }
export type ContactSnapshotCountMutationHookResult = ReturnType<typeof useContactSnapshotCountMutation>;
export type ContactSnapshotCountMutationResult = Apollo.MutationResult<ContactSnapshotCountMutation>;
export type ContactSnapshotCountMutationOptions = Apollo.BaseMutationOptions<ContactSnapshotCountMutation, ContactSnapshotCountMutationVariables>;
export const CampaignExperienceExperimentDeleteDocument = gql`
    mutation CampaignExperienceExperimentDelete($experimentId: ID!, $campaignId: ID!) {
  campaignExperimentDelete(experimentId: $experimentId, id: $campaignId) {
    success
    campaign {
      id
      experienceExperiment {
        ...experienceExperimentFields
      }
    }
  }
}
    ${ExperienceExperimentFieldsFragmentDoc}`;
export type CampaignExperienceExperimentDeleteMutationFn = Apollo.MutationFunction<CampaignExperienceExperimentDeleteMutation, CampaignExperienceExperimentDeleteMutationVariables>;

/**
 * __useCampaignExperienceExperimentDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignExperienceExperimentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperienceExperimentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperienceExperimentDeleteMutation, { data, loading, error }] = useCampaignExperienceExperimentDeleteMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignExperienceExperimentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperienceExperimentDeleteMutation, CampaignExperienceExperimentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperienceExperimentDeleteMutation, CampaignExperienceExperimentDeleteMutationVariables>(CampaignExperienceExperimentDeleteDocument, options);
      }
export type CampaignExperienceExperimentDeleteMutationHookResult = ReturnType<typeof useCampaignExperienceExperimentDeleteMutation>;
export type CampaignExperienceExperimentDeleteMutationResult = Apollo.MutationResult<CampaignExperienceExperimentDeleteMutation>;
export type CampaignExperienceExperimentDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignExperienceExperimentDeleteMutation, CampaignExperienceExperimentDeleteMutationVariables>;
export const CampaignAddExperienceExperimentGroupDocument = gql`
    mutation CampaignAddExperienceExperimentGroup($id: ID!, $experimentGroupId: ID!) {
  campaignAddExperimentGroup(id: $id, experimentGroupId: $experimentGroupId) {
    success
    campaign {
      id
      experienceExperiment {
        ...experienceExperimentFields
      }
    }
  }
}
    ${ExperienceExperimentFieldsFragmentDoc}`;
export type CampaignAddExperienceExperimentGroupMutationFn = Apollo.MutationFunction<CampaignAddExperienceExperimentGroupMutation, CampaignAddExperienceExperimentGroupMutationVariables>;

/**
 * __useCampaignAddExperienceExperimentGroupMutation__
 *
 * To run a mutation, you first call `useCampaignAddExperienceExperimentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAddExperienceExperimentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAddExperienceExperimentGroupMutation, { data, loading, error }] = useCampaignAddExperienceExperimentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experimentGroupId: // value for 'experimentGroupId'
 *   },
 * });
 */
export function useCampaignAddExperienceExperimentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAddExperienceExperimentGroupMutation, CampaignAddExperienceExperimentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAddExperienceExperimentGroupMutation, CampaignAddExperienceExperimentGroupMutationVariables>(CampaignAddExperienceExperimentGroupDocument, options);
      }
export type CampaignAddExperienceExperimentGroupMutationHookResult = ReturnType<typeof useCampaignAddExperienceExperimentGroupMutation>;
export type CampaignAddExperienceExperimentGroupMutationResult = Apollo.MutationResult<CampaignAddExperienceExperimentGroupMutation>;
export type CampaignAddExperienceExperimentGroupMutationOptions = Apollo.BaseMutationOptions<CampaignAddExperienceExperimentGroupMutation, CampaignAddExperienceExperimentGroupMutationVariables>;
export const CampaignSetFrequencyModelDocument = gql`
    mutation CampaignSetFrequencyModel($frequencyModel: FrequencyModel!, $campaignId: ID!) {
  campaignSetFrequencyModel(frequencyModel: $frequencyModel, id: $campaignId) {
    success
    campaign {
      id
      frequencyModel
    }
  }
}
    `;
export type CampaignSetFrequencyModelMutationFn = Apollo.MutationFunction<CampaignSetFrequencyModelMutation, CampaignSetFrequencyModelMutationVariables>;

/**
 * __useCampaignSetFrequencyModelMutation__
 *
 * To run a mutation, you first call `useCampaignSetFrequencyModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSetFrequencyModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSetFrequencyModelMutation, { data, loading, error }] = useCampaignSetFrequencyModelMutation({
 *   variables: {
 *      frequencyModel: // value for 'frequencyModel'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignSetFrequencyModelMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSetFrequencyModelMutation, CampaignSetFrequencyModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSetFrequencyModelMutation, CampaignSetFrequencyModelMutationVariables>(CampaignSetFrequencyModelDocument, options);
      }
export type CampaignSetFrequencyModelMutationHookResult = ReturnType<typeof useCampaignSetFrequencyModelMutation>;
export type CampaignSetFrequencyModelMutationResult = Apollo.MutationResult<CampaignSetFrequencyModelMutation>;
export type CampaignSetFrequencyModelMutationOptions = Apollo.BaseMutationOptions<CampaignSetFrequencyModelMutation, CampaignSetFrequencyModelMutationVariables>;
export const CampaignAudiencesDocument = gql`
    query CampaignAudiences($campaignId: ID!, $audienceType: CampaignAudienceType!, $search: String, $all: Boolean) {
  campaignAudiences(
    id: $campaignId
    audienceType: $audienceType
    search: $search
    all: $all
  ) {
    id
    title
  }
}
    `;

/**
 * __useCampaignAudiencesQuery__
 *
 * To run a query within a React component, call `useCampaignAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAudiencesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceType: // value for 'audienceType'
 *      search: // value for 'search'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useCampaignAudiencesQuery(baseOptions: Apollo.QueryHookOptions<CampaignAudiencesQuery, CampaignAudiencesQueryVariables> & ({ variables: CampaignAudiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAudiencesQuery, CampaignAudiencesQueryVariables>(CampaignAudiencesDocument, options);
      }
export function useCampaignAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAudiencesQuery, CampaignAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAudiencesQuery, CampaignAudiencesQueryVariables>(CampaignAudiencesDocument, options);
        }
export function useCampaignAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignAudiencesQuery, CampaignAudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignAudiencesQuery, CampaignAudiencesQueryVariables>(CampaignAudiencesDocument, options);
        }
export type CampaignAudiencesQueryHookResult = ReturnType<typeof useCampaignAudiencesQuery>;
export type CampaignAudiencesLazyQueryHookResult = ReturnType<typeof useCampaignAudiencesLazyQuery>;
export type CampaignAudiencesSuspenseQueryHookResult = ReturnType<typeof useCampaignAudiencesSuspenseQuery>;
export type CampaignAudiencesQueryResult = Apollo.QueryResult<CampaignAudiencesQuery, CampaignAudiencesQueryVariables>;
export const CampaignDetailsDocument = gql`
    query CampaignDetails($campaignId: ID!) {
  campaign(id: $campaignId) {
    ...campaignDetailFields
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;

/**
 * __useCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDetailsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<CampaignDetailsQuery, CampaignDetailsQueryVariables> & ({ variables: CampaignDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDetailsQuery, CampaignDetailsQueryVariables>(CampaignDetailsDocument, options);
      }
export function useCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDetailsQuery, CampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDetailsQuery, CampaignDetailsQueryVariables>(CampaignDetailsDocument, options);
        }
export function useCampaignDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignDetailsQuery, CampaignDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignDetailsQuery, CampaignDetailsQueryVariables>(CampaignDetailsDocument, options);
        }
export type CampaignDetailsQueryHookResult = ReturnType<typeof useCampaignDetailsQuery>;
export type CampaignDetailsLazyQueryHookResult = ReturnType<typeof useCampaignDetailsLazyQuery>;
export type CampaignDetailsSuspenseQueryHookResult = ReturnType<typeof useCampaignDetailsSuspenseQuery>;
export type CampaignDetailsQueryResult = Apollo.QueryResult<CampaignDetailsQuery, CampaignDetailsQueryVariables>;
export const CampaignTimelineNewDocument = gql`
    query CampaignTimelineNew($campaignId: ID!) {
  campaignTimelineNew(id: $campaignId) {
    title
    user {
      id
      email
    }
    timestamp
    children {
      title
      user {
        id
        email
      }
      timestamp
    }
  }
}
    `;

/**
 * __useCampaignTimelineNewQuery__
 *
 * To run a query within a React component, call `useCampaignTimelineNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignTimelineNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignTimelineNewQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignTimelineNewQuery(baseOptions: Apollo.QueryHookOptions<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables> & ({ variables: CampaignTimelineNewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables>(CampaignTimelineNewDocument, options);
      }
export function useCampaignTimelineNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables>(CampaignTimelineNewDocument, options);
        }
export function useCampaignTimelineNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables>(CampaignTimelineNewDocument, options);
        }
export type CampaignTimelineNewQueryHookResult = ReturnType<typeof useCampaignTimelineNewQuery>;
export type CampaignTimelineNewLazyQueryHookResult = ReturnType<typeof useCampaignTimelineNewLazyQuery>;
export type CampaignTimelineNewSuspenseQueryHookResult = ReturnType<typeof useCampaignTimelineNewSuspenseQuery>;
export type CampaignTimelineNewQueryResult = Apollo.QueryResult<CampaignTimelineNewQuery, CampaignTimelineNewQueryVariables>;
export const CampaignDetailsUpdateDocument = gql`
    mutation CampaignDetailsUpdate($campaignId: ID!, $title: String, $sendDate: Date, $tagIds: [ID!]) {
  campaignDetailsUpdate(
    id: $campaignId
    title: $title
    sendDate: $sendDate
    tagIds: $tagIds
  ) {
    ... on CampaignSuccess {
      success
      campaign {
        id
        title
        sendDate
        availableSendTimes
        ...SendScheduleFragment
        tags {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${SendScheduleFragmentFragmentDoc}`;
export type CampaignDetailsUpdateMutationFn = Apollo.MutationFunction<CampaignDetailsUpdateMutation, CampaignDetailsUpdateMutationVariables>;

/**
 * __useCampaignDetailsUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignDetailsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDetailsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDetailsUpdateMutation, { data, loading, error }] = useCampaignDetailsUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      title: // value for 'title'
 *      sendDate: // value for 'sendDate'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useCampaignDetailsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDetailsUpdateMutation, CampaignDetailsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDetailsUpdateMutation, CampaignDetailsUpdateMutationVariables>(CampaignDetailsUpdateDocument, options);
      }
export type CampaignDetailsUpdateMutationHookResult = ReturnType<typeof useCampaignDetailsUpdateMutation>;
export type CampaignDetailsUpdateMutationResult = Apollo.MutationResult<CampaignDetailsUpdateMutation>;
export type CampaignDetailsUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignDetailsUpdateMutation, CampaignDetailsUpdateMutationVariables>;
export const CampaignCancelDocument = gql`
    mutation CampaignCancel($campaignId: ID!) {
  campaignCancel(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignCancelMutationFn = Apollo.MutationFunction<CampaignCancelMutation, CampaignCancelMutationVariables>;

/**
 * __useCampaignCancelMutation__
 *
 * To run a mutation, you first call `useCampaignCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCancelMutation, { data, loading, error }] = useCampaignCancelMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignCancelMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCancelMutation, CampaignCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCancelMutation, CampaignCancelMutationVariables>(CampaignCancelDocument, options);
      }
export type CampaignCancelMutationHookResult = ReturnType<typeof useCampaignCancelMutation>;
export type CampaignCancelMutationResult = Apollo.MutationResult<CampaignCancelMutation>;
export type CampaignCancelMutationOptions = Apollo.BaseMutationOptions<CampaignCancelMutation, CampaignCancelMutationVariables>;
export const CampaignDeleteDocument = gql`
    mutation CampaignDelete($campaignId: ID!) {
  campaignDelete(id: $campaignId) {
    ok
  }
}
    `;
export type CampaignDeleteMutationFn = Apollo.MutationFunction<CampaignDeleteMutation, CampaignDeleteMutationVariables>;

/**
 * __useCampaignDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDeleteMutation, { data, loading, error }] = useCampaignDeleteMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDeleteMutation, CampaignDeleteMutationVariables>(CampaignDeleteDocument, options);
      }
export type CampaignDeleteMutationHookResult = ReturnType<typeof useCampaignDeleteMutation>;
export type CampaignDeleteMutationResult = Apollo.MutationResult<CampaignDeleteMutation>;
export type CampaignDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>;
export const CampaignDuplicateDocument = gql`
    mutation CampaignDuplicate($campaignId: ID!, $sendDate: Date, $title: String, $withContactAudiences: Boolean, $tagIds: [ID!]) {
  campaignDuplicate(
    id: $campaignId
    sendDate: $sendDate
    title: $title
    withContactAudiences: $withContactAudiences
    tagIds: $tagIds
  ) {
    ... on CampaignDuplicate {
      newCampaign {
        ...campaignDetailFields
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignDuplicateMutationFn = Apollo.MutationFunction<CampaignDuplicateMutation, CampaignDuplicateMutationVariables>;

/**
 * __useCampaignDuplicateMutation__
 *
 * To run a mutation, you first call `useCampaignDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDuplicateMutation, { data, loading, error }] = useCampaignDuplicateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sendDate: // value for 'sendDate'
 *      title: // value for 'title'
 *      withContactAudiences: // value for 'withContactAudiences'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useCampaignDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDuplicateMutation, CampaignDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDuplicateMutation, CampaignDuplicateMutationVariables>(CampaignDuplicateDocument, options);
      }
export type CampaignDuplicateMutationHookResult = ReturnType<typeof useCampaignDuplicateMutation>;
export type CampaignDuplicateMutationResult = Apollo.MutationResult<CampaignDuplicateMutation>;
export type CampaignDuplicateMutationOptions = Apollo.BaseMutationOptions<CampaignDuplicateMutation, CampaignDuplicateMutationVariables>;
export const CampaignProblemsDocument = gql`
    query CampaignProblems($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    problems {
      where
      message
      blocks
      severity
    }
  }
}
    `;

/**
 * __useCampaignProblemsQuery__
 *
 * To run a query within a React component, call `useCampaignProblemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignProblemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignProblemsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignProblemsQuery(baseOptions: Apollo.QueryHookOptions<CampaignProblemsQuery, CampaignProblemsQueryVariables> & ({ variables: CampaignProblemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignProblemsQuery, CampaignProblemsQueryVariables>(CampaignProblemsDocument, options);
      }
export function useCampaignProblemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignProblemsQuery, CampaignProblemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignProblemsQuery, CampaignProblemsQueryVariables>(CampaignProblemsDocument, options);
        }
export function useCampaignProblemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignProblemsQuery, CampaignProblemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignProblemsQuery, CampaignProblemsQueryVariables>(CampaignProblemsDocument, options);
        }
export type CampaignProblemsQueryHookResult = ReturnType<typeof useCampaignProblemsQuery>;
export type CampaignProblemsLazyQueryHookResult = ReturnType<typeof useCampaignProblemsLazyQuery>;
export type CampaignProblemsSuspenseQueryHookResult = ReturnType<typeof useCampaignProblemsSuspenseQuery>;
export type CampaignProblemsQueryResult = Apollo.QueryResult<CampaignProblemsQuery, CampaignProblemsQueryVariables>;
export const CampaignApproveDocument = gql`
    mutation CampaignApprove($campaignId: ID!) {
  campaignApprove(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignApproveMutationFn = Apollo.MutationFunction<CampaignApproveMutation, CampaignApproveMutationVariables>;

/**
 * __useCampaignApproveMutation__
 *
 * To run a mutation, you first call `useCampaignApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignApproveMutation, { data, loading, error }] = useCampaignApproveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignApproveMutation(baseOptions?: Apollo.MutationHookOptions<CampaignApproveMutation, CampaignApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignApproveMutation, CampaignApproveMutationVariables>(CampaignApproveDocument, options);
      }
export type CampaignApproveMutationHookResult = ReturnType<typeof useCampaignApproveMutation>;
export type CampaignApproveMutationResult = Apollo.MutationResult<CampaignApproveMutation>;
export type CampaignApproveMutationOptions = Apollo.BaseMutationOptions<CampaignApproveMutation, CampaignApproveMutationVariables>;
export const CampaignEnableAutoSchedulingDocument = gql`
    mutation CampaignEnableAutoScheduling($campaignId: ID!) {
  campaignEnableAutoScheduling(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignEnableAutoSchedulingMutationFn = Apollo.MutationFunction<CampaignEnableAutoSchedulingMutation, CampaignEnableAutoSchedulingMutationVariables>;

/**
 * __useCampaignEnableAutoSchedulingMutation__
 *
 * To run a mutation, you first call `useCampaignEnableAutoSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignEnableAutoSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignEnableAutoSchedulingMutation, { data, loading, error }] = useCampaignEnableAutoSchedulingMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignEnableAutoSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<CampaignEnableAutoSchedulingMutation, CampaignEnableAutoSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignEnableAutoSchedulingMutation, CampaignEnableAutoSchedulingMutationVariables>(CampaignEnableAutoSchedulingDocument, options);
      }
export type CampaignEnableAutoSchedulingMutationHookResult = ReturnType<typeof useCampaignEnableAutoSchedulingMutation>;
export type CampaignEnableAutoSchedulingMutationResult = Apollo.MutationResult<CampaignEnableAutoSchedulingMutation>;
export type CampaignEnableAutoSchedulingMutationOptions = Apollo.BaseMutationOptions<CampaignEnableAutoSchedulingMutation, CampaignEnableAutoSchedulingMutationVariables>;
export const CampaignDisableAutoSchedulingDocument = gql`
    mutation CampaignDisableAutoScheduling($campaignId: ID!) {
  campaignDisableAutoScheduling(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignDisableAutoSchedulingMutationFn = Apollo.MutationFunction<CampaignDisableAutoSchedulingMutation, CampaignDisableAutoSchedulingMutationVariables>;

/**
 * __useCampaignDisableAutoSchedulingMutation__
 *
 * To run a mutation, you first call `useCampaignDisableAutoSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDisableAutoSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDisableAutoSchedulingMutation, { data, loading, error }] = useCampaignDisableAutoSchedulingMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignDisableAutoSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDisableAutoSchedulingMutation, CampaignDisableAutoSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDisableAutoSchedulingMutation, CampaignDisableAutoSchedulingMutationVariables>(CampaignDisableAutoSchedulingDocument, options);
      }
export type CampaignDisableAutoSchedulingMutationHookResult = ReturnType<typeof useCampaignDisableAutoSchedulingMutation>;
export type CampaignDisableAutoSchedulingMutationResult = Apollo.MutationResult<CampaignDisableAutoSchedulingMutation>;
export type CampaignDisableAutoSchedulingMutationOptions = Apollo.BaseMutationOptions<CampaignDisableAutoSchedulingMutation, CampaignDisableAutoSchedulingMutationVariables>;
export const CampaignRevertToDraftDocument = gql`
    mutation CampaignRevertToDraft($campaignId: ID!) {
  campaignRevertToDraft(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignRevertToDraftMutationFn = Apollo.MutationFunction<CampaignRevertToDraftMutation, CampaignRevertToDraftMutationVariables>;

/**
 * __useCampaignRevertToDraftMutation__
 *
 * To run a mutation, you first call `useCampaignRevertToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignRevertToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignRevertToDraftMutation, { data, loading, error }] = useCampaignRevertToDraftMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignRevertToDraftMutation(baseOptions?: Apollo.MutationHookOptions<CampaignRevertToDraftMutation, CampaignRevertToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignRevertToDraftMutation, CampaignRevertToDraftMutationVariables>(CampaignRevertToDraftDocument, options);
      }
export type CampaignRevertToDraftMutationHookResult = ReturnType<typeof useCampaignRevertToDraftMutation>;
export type CampaignRevertToDraftMutationResult = Apollo.MutationResult<CampaignRevertToDraftMutation>;
export type CampaignRevertToDraftMutationOptions = Apollo.BaseMutationOptions<CampaignRevertToDraftMutation, CampaignRevertToDraftMutationVariables>;
export const CampaignCancelApprovalDocument = gql`
    mutation CampaignCancelApproval($campaignId: ID!) {
  campaignCancelApproval(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignCancelApprovalMutationFn = Apollo.MutationFunction<CampaignCancelApprovalMutation, CampaignCancelApprovalMutationVariables>;

/**
 * __useCampaignCancelApprovalMutation__
 *
 * To run a mutation, you first call `useCampaignCancelApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCancelApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCancelApprovalMutation, { data, loading, error }] = useCampaignCancelApprovalMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignCancelApprovalMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCancelApprovalMutation, CampaignCancelApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCancelApprovalMutation, CampaignCancelApprovalMutationVariables>(CampaignCancelApprovalDocument, options);
      }
export type CampaignCancelApprovalMutationHookResult = ReturnType<typeof useCampaignCancelApprovalMutation>;
export type CampaignCancelApprovalMutationResult = Apollo.MutationResult<CampaignCancelApprovalMutation>;
export type CampaignCancelApprovalMutationOptions = Apollo.BaseMutationOptions<CampaignCancelApprovalMutation, CampaignCancelApprovalMutationVariables>;
export const CampaignUnscheduleDocument = gql`
    mutation CampaignUnschedule($campaignId: ID!) {
  campaignUnschedule(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignUnscheduleMutationFn = Apollo.MutationFunction<CampaignUnscheduleMutation, CampaignUnscheduleMutationVariables>;

/**
 * __useCampaignUnscheduleMutation__
 *
 * To run a mutation, you first call `useCampaignUnscheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignUnscheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignUnscheduleMutation, { data, loading, error }] = useCampaignUnscheduleMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignUnscheduleMutation(baseOptions?: Apollo.MutationHookOptions<CampaignUnscheduleMutation, CampaignUnscheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignUnscheduleMutation, CampaignUnscheduleMutationVariables>(CampaignUnscheduleDocument, options);
      }
export type CampaignUnscheduleMutationHookResult = ReturnType<typeof useCampaignUnscheduleMutation>;
export type CampaignUnscheduleMutationResult = Apollo.MutationResult<CampaignUnscheduleMutation>;
export type CampaignUnscheduleMutationOptions = Apollo.BaseMutationOptions<CampaignUnscheduleMutation, CampaignUnscheduleMutationVariables>;
export const CampaignSuspendDocument = gql`
    mutation CampaignSuspend($campaignId: ID!) {
  campaignSuspend(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignSuspendMutationFn = Apollo.MutationFunction<CampaignSuspendMutation, CampaignSuspendMutationVariables>;

/**
 * __useCampaignSuspendMutation__
 *
 * To run a mutation, you first call `useCampaignSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSuspendMutation, { data, loading, error }] = useCampaignSuspendMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignSuspendMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSuspendMutation, CampaignSuspendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSuspendMutation, CampaignSuspendMutationVariables>(CampaignSuspendDocument, options);
      }
export type CampaignSuspendMutationHookResult = ReturnType<typeof useCampaignSuspendMutation>;
export type CampaignSuspendMutationResult = Apollo.MutationResult<CampaignSuspendMutation>;
export type CampaignSuspendMutationOptions = Apollo.BaseMutationOptions<CampaignSuspendMutation, CampaignSuspendMutationVariables>;
export const CampaignTerminateDocument = gql`
    mutation CampaignTerminate($campaignId: ID!) {
  campaignTerminate(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignTerminateMutationFn = Apollo.MutationFunction<CampaignTerminateMutation, CampaignTerminateMutationVariables>;

/**
 * __useCampaignTerminateMutation__
 *
 * To run a mutation, you first call `useCampaignTerminateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTerminateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTerminateMutation, { data, loading, error }] = useCampaignTerminateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignTerminateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTerminateMutation, CampaignTerminateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTerminateMutation, CampaignTerminateMutationVariables>(CampaignTerminateDocument, options);
      }
export type CampaignTerminateMutationHookResult = ReturnType<typeof useCampaignTerminateMutation>;
export type CampaignTerminateMutationResult = Apollo.MutationResult<CampaignTerminateMutation>;
export type CampaignTerminateMutationOptions = Apollo.BaseMutationOptions<CampaignTerminateMutation, CampaignTerminateMutationVariables>;
export const CampaignLockForProofingDocument = gql`
    mutation CampaignLockForProofing($campaignId: ID!) {
  campaignLockForProofing(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignLockForProofingMutationFn = Apollo.MutationFunction<CampaignLockForProofingMutation, CampaignLockForProofingMutationVariables>;

/**
 * __useCampaignLockForProofingMutation__
 *
 * To run a mutation, you first call `useCampaignLockForProofingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignLockForProofingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignLockForProofingMutation, { data, loading, error }] = useCampaignLockForProofingMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignLockForProofingMutation(baseOptions?: Apollo.MutationHookOptions<CampaignLockForProofingMutation, CampaignLockForProofingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignLockForProofingMutation, CampaignLockForProofingMutationVariables>(CampaignLockForProofingDocument, options);
      }
export type CampaignLockForProofingMutationHookResult = ReturnType<typeof useCampaignLockForProofingMutation>;
export type CampaignLockForProofingMutationResult = Apollo.MutationResult<CampaignLockForProofingMutation>;
export type CampaignLockForProofingMutationOptions = Apollo.BaseMutationOptions<CampaignLockForProofingMutation, CampaignLockForProofingMutationVariables>;
export const CampaignScheduleDocument = gql`
    mutation CampaignSchedule($campaignId: ID!) {
  campaignSchedule(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignScheduleMutationFn = Apollo.MutationFunction<CampaignScheduleMutation, CampaignScheduleMutationVariables>;

/**
 * __useCampaignScheduleMutation__
 *
 * To run a mutation, you first call `useCampaignScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignScheduleMutation, { data, loading, error }] = useCampaignScheduleMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CampaignScheduleMutation, CampaignScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignScheduleMutation, CampaignScheduleMutationVariables>(CampaignScheduleDocument, options);
      }
export type CampaignScheduleMutationHookResult = ReturnType<typeof useCampaignScheduleMutation>;
export type CampaignScheduleMutationResult = Apollo.MutationResult<CampaignScheduleMutation>;
export type CampaignScheduleMutationOptions = Apollo.BaseMutationOptions<CampaignScheduleMutation, CampaignScheduleMutationVariables>;
export const CampaignResumeDocument = gql`
    mutation CampaignResume($campaignId: ID!) {
  campaignResume(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignResumeMutationFn = Apollo.MutationFunction<CampaignResumeMutation, CampaignResumeMutationVariables>;

/**
 * __useCampaignResumeMutation__
 *
 * To run a mutation, you first call `useCampaignResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignResumeMutation, { data, loading, error }] = useCampaignResumeMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignResumeMutation(baseOptions?: Apollo.MutationHookOptions<CampaignResumeMutation, CampaignResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignResumeMutation, CampaignResumeMutationVariables>(CampaignResumeDocument, options);
      }
export type CampaignResumeMutationHookResult = ReturnType<typeof useCampaignResumeMutation>;
export type CampaignResumeMutationResult = Apollo.MutationResult<CampaignResumeMutation>;
export type CampaignResumeMutationOptions = Apollo.BaseMutationOptions<CampaignResumeMutation, CampaignResumeMutationVariables>;
export const CampaignMarkAsPreparedDocument = gql`
    mutation CampaignMarkAsPrepared($campaignId: ID!) {
  campaignMarkAsPrepared(id: $campaignId) {
    campaign {
      ...campaignDetailFields
    }
  }
}
    ${CampaignDetailFieldsFragmentDoc}`;
export type CampaignMarkAsPreparedMutationFn = Apollo.MutationFunction<CampaignMarkAsPreparedMutation, CampaignMarkAsPreparedMutationVariables>;

/**
 * __useCampaignMarkAsPreparedMutation__
 *
 * To run a mutation, you first call `useCampaignMarkAsPreparedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignMarkAsPreparedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignMarkAsPreparedMutation, { data, loading, error }] = useCampaignMarkAsPreparedMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignMarkAsPreparedMutation(baseOptions?: Apollo.MutationHookOptions<CampaignMarkAsPreparedMutation, CampaignMarkAsPreparedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignMarkAsPreparedMutation, CampaignMarkAsPreparedMutationVariables>(CampaignMarkAsPreparedDocument, options);
      }
export type CampaignMarkAsPreparedMutationHookResult = ReturnType<typeof useCampaignMarkAsPreparedMutation>;
export type CampaignMarkAsPreparedMutationResult = Apollo.MutationResult<CampaignMarkAsPreparedMutation>;
export type CampaignMarkAsPreparedMutationOptions = Apollo.BaseMutationOptions<CampaignMarkAsPreparedMutation, CampaignMarkAsPreparedMutationVariables>;
export const CampaignAddToRecommendationRunDocument = gql`
    mutation CampaignAddToRecommendationRun($campaignId: ID!, $runType: RecommendationRunType!) {
  campaignAddToRecommendationRun(id: $campaignId, runType: $runType) {
    success
    recommendationRun {
      id
      runId
      status
      runType
      flowRunId
      flowRunUrl
      campaigns {
        id
        title
        stage
      }
    }
  }
}
    `;
export type CampaignAddToRecommendationRunMutationFn = Apollo.MutationFunction<CampaignAddToRecommendationRunMutation, CampaignAddToRecommendationRunMutationVariables>;

/**
 * __useCampaignAddToRecommendationRunMutation__
 *
 * To run a mutation, you first call `useCampaignAddToRecommendationRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAddToRecommendationRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAddToRecommendationRunMutation, { data, loading, error }] = useCampaignAddToRecommendationRunMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      runType: // value for 'runType'
 *   },
 * });
 */
export function useCampaignAddToRecommendationRunMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAddToRecommendationRunMutation, CampaignAddToRecommendationRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAddToRecommendationRunMutation, CampaignAddToRecommendationRunMutationVariables>(CampaignAddToRecommendationRunDocument, options);
      }
export type CampaignAddToRecommendationRunMutationHookResult = ReturnType<typeof useCampaignAddToRecommendationRunMutation>;
export type CampaignAddToRecommendationRunMutationResult = Apollo.MutationResult<CampaignAddToRecommendationRunMutation>;
export type CampaignAddToRecommendationRunMutationOptions = Apollo.BaseMutationOptions<CampaignAddToRecommendationRunMutation, CampaignAddToRecommendationRunMutationVariables>;
export const FetchRecommendationRunsDocument = gql`
    query FetchRecommendationRuns {
  recommendationRuns {
    id
    runId
    status
    runType
    flowRunId
    flowRunUrl
    campaigns {
      id
      title
    }
  }
}
    `;

/**
 * __useFetchRecommendationRunsQuery__
 *
 * To run a query within a React component, call `useFetchRecommendationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecommendationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecommendationRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRecommendationRunsQuery(baseOptions?: Apollo.QueryHookOptions<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>(FetchRecommendationRunsDocument, options);
      }
export function useFetchRecommendationRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>(FetchRecommendationRunsDocument, options);
        }
export function useFetchRecommendationRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>(FetchRecommendationRunsDocument, options);
        }
export type FetchRecommendationRunsQueryHookResult = ReturnType<typeof useFetchRecommendationRunsQuery>;
export type FetchRecommendationRunsLazyQueryHookResult = ReturnType<typeof useFetchRecommendationRunsLazyQuery>;
export type FetchRecommendationRunsSuspenseQueryHookResult = ReturnType<typeof useFetchRecommendationRunsSuspenseQuery>;
export type FetchRecommendationRunsQueryResult = Apollo.QueryResult<FetchRecommendationRunsQuery, FetchRecommendationRunsQueryVariables>;
export const CampaignCreateDocument = gql`
    mutation CampaignCreate($title: String!, $sendDate: Date!, $withContactAudiences: Boolean, $channel: Channel, $tagIds: [ID!]) {
  campaignCreate(
    title: $title
    sendDate: $sendDate
    withContactAudiences: $withContactAudiences
    channel: $channel
    tagIds: $tagIds
  ) {
    ... on CampaignSuccess {
      success
      campaign {
        ...campaignFields
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type CampaignCreateMutationFn = Apollo.MutationFunction<CampaignCreateMutation, CampaignCreateMutationVariables>;

/**
 * __useCampaignCreateMutation__
 *
 * To run a mutation, you first call `useCampaignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCreateMutation, { data, loading, error }] = useCampaignCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      sendDate: // value for 'sendDate'
 *      withContactAudiences: // value for 'withContactAudiences'
 *      channel: // value for 'channel'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useCampaignCreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCreateMutation, CampaignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCreateMutation, CampaignCreateMutationVariables>(CampaignCreateDocument, options);
      }
export type CampaignCreateMutationHookResult = ReturnType<typeof useCampaignCreateMutation>;
export type CampaignCreateMutationResult = Apollo.MutationResult<CampaignCreateMutation>;
export type CampaignCreateMutationOptions = Apollo.BaseMutationOptions<CampaignCreateMutation, CampaignCreateMutationVariables>;
export const RecurringCampaignCreateDocument = gql`
    mutation RecurringCampaignCreate($title: String!, $startDate: Date!, $channel: Channel!, $tagIds: [ID!]) {
  recurringCampaignCreate(
    title: $title
    startDate: $startDate
    channel: $channel
    tagIds: $tagIds
  ) {
    ... on RecurringCampaignCreateSuccess {
      success
      recurringCampaign {
        id
        title
        status
        nextOccurrence
        channel {
          category
          channel
        }
        schedule {
          startDate
          sendTime
          rrule
          endDate
          timezone
        }
        tags {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type RecurringCampaignCreateMutationFn = Apollo.MutationFunction<RecurringCampaignCreateMutation, RecurringCampaignCreateMutationVariables>;

/**
 * __useRecurringCampaignCreateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignCreateMutation, { data, loading, error }] = useRecurringCampaignCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      startDate: // value for 'startDate'
 *      channel: // value for 'channel'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useRecurringCampaignCreateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignCreateMutation, RecurringCampaignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignCreateMutation, RecurringCampaignCreateMutationVariables>(RecurringCampaignCreateDocument, options);
      }
export type RecurringCampaignCreateMutationHookResult = ReturnType<typeof useRecurringCampaignCreateMutation>;
export type RecurringCampaignCreateMutationResult = Apollo.MutationResult<RecurringCampaignCreateMutation>;
export type RecurringCampaignCreateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignCreateMutation, RecurringCampaignCreateMutationVariables>;
export const TriggeredCampaignCreateDocument = gql`
    mutation TriggeredCampaignCreate($channel: Channel!, $journeyId: String, $journeyNodeId: String, $tagIds: [ID!], $title: String!, $triggerRule: JSONString, $triggerSource: TriggerSource!) {
  triggeredCampaignCreate(
    title: $title
    journeyId: $journeyId
    journeyNodeId: $journeyNodeId
    triggerRule: $triggerRule
    channel: $channel
    tagIds: $tagIds
    triggerSource: $triggerSource
  ) {
    ... on TriggeredCampaignCreateSuccess {
      success
      triggeredCampaign {
        id
        title
        status
        stage
        triggerSource
        channel {
          category
          channel
        }
        tags {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type TriggeredCampaignCreateMutationFn = Apollo.MutationFunction<TriggeredCampaignCreateMutation, TriggeredCampaignCreateMutationVariables>;

/**
 * __useTriggeredCampaignCreateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignCreateMutation, { data, loading, error }] = useTriggeredCampaignCreateMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      journeyId: // value for 'journeyId'
 *      journeyNodeId: // value for 'journeyNodeId'
 *      tagIds: // value for 'tagIds'
 *      title: // value for 'title'
 *      triggerRule: // value for 'triggerRule'
 *      triggerSource: // value for 'triggerSource'
 *   },
 * });
 */
export function useTriggeredCampaignCreateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignCreateMutation, TriggeredCampaignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignCreateMutation, TriggeredCampaignCreateMutationVariables>(TriggeredCampaignCreateDocument, options);
      }
export type TriggeredCampaignCreateMutationHookResult = ReturnType<typeof useTriggeredCampaignCreateMutation>;
export type TriggeredCampaignCreateMutationResult = Apollo.MutationResult<TriggeredCampaignCreateMutation>;
export type TriggeredCampaignCreateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignCreateMutation, TriggeredCampaignCreateMutationVariables>;
export const CampaignAutoCreativeInclusionEnableDocument = gql`
    mutation CampaignAutoCreativeInclusionEnable($id: ID!) {
  campaignAutoCreativeInclusionEnable(id: $id) {
    success
    campaign {
      id
      autoCreativeInclusionPaused
    }
  }
}
    `;
export type CampaignAutoCreativeInclusionEnableMutationFn = Apollo.MutationFunction<CampaignAutoCreativeInclusionEnableMutation, CampaignAutoCreativeInclusionEnableMutationVariables>;

/**
 * __useCampaignAutoCreativeInclusionEnableMutation__
 *
 * To run a mutation, you first call `useCampaignAutoCreativeInclusionEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAutoCreativeInclusionEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAutoCreativeInclusionEnableMutation, { data, loading, error }] = useCampaignAutoCreativeInclusionEnableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignAutoCreativeInclusionEnableMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAutoCreativeInclusionEnableMutation, CampaignAutoCreativeInclusionEnableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAutoCreativeInclusionEnableMutation, CampaignAutoCreativeInclusionEnableMutationVariables>(CampaignAutoCreativeInclusionEnableDocument, options);
      }
export type CampaignAutoCreativeInclusionEnableMutationHookResult = ReturnType<typeof useCampaignAutoCreativeInclusionEnableMutation>;
export type CampaignAutoCreativeInclusionEnableMutationResult = Apollo.MutationResult<CampaignAutoCreativeInclusionEnableMutation>;
export type CampaignAutoCreativeInclusionEnableMutationOptions = Apollo.BaseMutationOptions<CampaignAutoCreativeInclusionEnableMutation, CampaignAutoCreativeInclusionEnableMutationVariables>;
export const CreativesWithContentChangesDocument = gql`
    query CreativesWithContentChanges($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    creativesWithContentChanges {
      id
      title
    }
  }
}
    `;

/**
 * __useCreativesWithContentChangesQuery__
 *
 * To run a query within a React component, call `useCreativesWithContentChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativesWithContentChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativesWithContentChangesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCreativesWithContentChangesQuery(baseOptions: Apollo.QueryHookOptions<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables> & ({ variables: CreativesWithContentChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables>(CreativesWithContentChangesDocument, options);
      }
export function useCreativesWithContentChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables>(CreativesWithContentChangesDocument, options);
        }
export function useCreativesWithContentChangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables>(CreativesWithContentChangesDocument, options);
        }
export type CreativesWithContentChangesQueryHookResult = ReturnType<typeof useCreativesWithContentChangesQuery>;
export type CreativesWithContentChangesLazyQueryHookResult = ReturnType<typeof useCreativesWithContentChangesLazyQuery>;
export type CreativesWithContentChangesSuspenseQueryHookResult = ReturnType<typeof useCreativesWithContentChangesSuspenseQuery>;
export type CreativesWithContentChangesQueryResult = Apollo.QueryResult<CreativesWithContentChangesQuery, CreativesWithContentChangesQueryVariables>;
export const CampaignPickupChangesDocument = gql`
    mutation CampaignPickupChanges($id: ID!) {
  campaignPickupChanges(id: $id) {
    campaign {
      id
      creativesWithContentChanges {
        id
        title
      }
    }
  }
}
    `;
export type CampaignPickupChangesMutationFn = Apollo.MutationFunction<CampaignPickupChangesMutation, CampaignPickupChangesMutationVariables>;

/**
 * __useCampaignPickupChangesMutation__
 *
 * To run a mutation, you first call `useCampaignPickupChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignPickupChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignPickupChangesMutation, { data, loading, error }] = useCampaignPickupChangesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignPickupChangesMutation(baseOptions?: Apollo.MutationHookOptions<CampaignPickupChangesMutation, CampaignPickupChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignPickupChangesMutation, CampaignPickupChangesMutationVariables>(CampaignPickupChangesDocument, options);
      }
export type CampaignPickupChangesMutationHookResult = ReturnType<typeof useCampaignPickupChangesMutation>;
export type CampaignPickupChangesMutationResult = Apollo.MutationResult<CampaignPickupChangesMutation>;
export type CampaignPickupChangesMutationOptions = Apollo.BaseMutationOptions<CampaignPickupChangesMutation, CampaignPickupChangesMutationVariables>;
export const CampaignDynamicBlocks2Document = gql`
    query CampaignDynamicBlocks2($campaignId: ID!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  campaign(id: $campaignId) {
    id
    campaignTemplate {
      dynamicContentBlockCount
      sections(contentBlockType: DYNAMIC) {
        ... on DynamicSection {
          ...DynamicSectionsFields
        }
      }
    }
  }
}
    ${DynamicSectionsFieldsFragmentDoc}`;

/**
 * __useCampaignDynamicBlocks2Query__
 *
 * To run a query within a React component, call `useCampaignDynamicBlocks2Query` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicBlocks2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDynamicBlocks2Query({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useCampaignDynamicBlocks2Query(baseOptions: Apollo.QueryHookOptions<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables> & ({ variables: CampaignDynamicBlocks2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables>(CampaignDynamicBlocks2Document, options);
      }
export function useCampaignDynamicBlocks2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables>(CampaignDynamicBlocks2Document, options);
        }
export function useCampaignDynamicBlocks2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables>(CampaignDynamicBlocks2Document, options);
        }
export type CampaignDynamicBlocks2QueryHookResult = ReturnType<typeof useCampaignDynamicBlocks2Query>;
export type CampaignDynamicBlocks2LazyQueryHookResult = ReturnType<typeof useCampaignDynamicBlocks2LazyQuery>;
export type CampaignDynamicBlocks2SuspenseQueryHookResult = ReturnType<typeof useCampaignDynamicBlocks2SuspenseQuery>;
export type CampaignDynamicBlocks2QueryResult = Apollo.QueryResult<CampaignDynamicBlocks2Query, CampaignDynamicBlocks2QueryVariables>;
export const CampaignIncompleteExperiencesDocument = gql`
    query CampaignIncompleteExperiences($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    campaignTemplate {
      sections(contentBlockType: DYNAMIC) {
        ... on DynamicSection {
          ...IncompleteDynamicSectionsFields
        }
      }
    }
  }
}
    ${IncompleteDynamicSectionsFieldsFragmentDoc}`;

/**
 * __useCampaignIncompleteExperiencesQuery__
 *
 * To run a query within a React component, call `useCampaignIncompleteExperiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignIncompleteExperiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignIncompleteExperiencesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignIncompleteExperiencesQuery(baseOptions: Apollo.QueryHookOptions<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables> & ({ variables: CampaignIncompleteExperiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables>(CampaignIncompleteExperiencesDocument, options);
      }
export function useCampaignIncompleteExperiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables>(CampaignIncompleteExperiencesDocument, options);
        }
export function useCampaignIncompleteExperiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables>(CampaignIncompleteExperiencesDocument, options);
        }
export type CampaignIncompleteExperiencesQueryHookResult = ReturnType<typeof useCampaignIncompleteExperiencesQuery>;
export type CampaignIncompleteExperiencesLazyQueryHookResult = ReturnType<typeof useCampaignIncompleteExperiencesLazyQuery>;
export type CampaignIncompleteExperiencesSuspenseQueryHookResult = ReturnType<typeof useCampaignIncompleteExperiencesSuspenseQuery>;
export type CampaignIncompleteExperiencesQueryResult = Apollo.QueryResult<CampaignIncompleteExperiencesQuery, CampaignIncompleteExperiencesQueryVariables>;
export const ExperiencesAvailableCreativesDocument = gql`
    query ExperiencesAvailableCreatives($campaignId: ID!, $sectionId: ID!, $after: String, $before: String, $first: Int, $last: Int, $selectOnly: Experiences2CreativeFilter, $targetRuleset: [TargetRuleInput!]!) {
  campaign(id: $campaignId) {
    id
    campaignTemplate {
      section(id: $sectionId) {
        ... on DynamicSection {
          id
          experiences2Complete
          experiences2Creatives(
            after: $after
            before: $before
            first: $first
            last: $last
            targetRuleset: $targetRuleset
            selectOnly: $selectOnly
          ) {
            ...ExperiencesCreativesFields
          }
          experiences2 {
            id
            autoInclude
            recsSettings {
              ignoreReuseRules
              ignoreCreativeFilters
            }
          }
        }
      }
    }
  }
}
    ${ExperiencesCreativesFieldsFragmentDoc}`;

/**
 * __useExperiencesAvailableCreativesQuery__
 *
 * To run a query within a React component, call `useExperiencesAvailableCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperiencesAvailableCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperiencesAvailableCreativesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sectionId: // value for 'sectionId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      selectOnly: // value for 'selectOnly'
 *      targetRuleset: // value for 'targetRuleset'
 *   },
 * });
 */
export function useExperiencesAvailableCreativesQuery(baseOptions: Apollo.QueryHookOptions<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables> & ({ variables: ExperiencesAvailableCreativesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables>(ExperiencesAvailableCreativesDocument, options);
      }
export function useExperiencesAvailableCreativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables>(ExperiencesAvailableCreativesDocument, options);
        }
export function useExperiencesAvailableCreativesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables>(ExperiencesAvailableCreativesDocument, options);
        }
export type ExperiencesAvailableCreativesQueryHookResult = ReturnType<typeof useExperiencesAvailableCreativesQuery>;
export type ExperiencesAvailableCreativesLazyQueryHookResult = ReturnType<typeof useExperiencesAvailableCreativesLazyQuery>;
export type ExperiencesAvailableCreativesSuspenseQueryHookResult = ReturnType<typeof useExperiencesAvailableCreativesSuspenseQuery>;
export type ExperiencesAvailableCreativesQueryResult = Apollo.QueryResult<ExperiencesAvailableCreativesQuery, ExperiencesAvailableCreativesQueryVariables>;
export const ExperiencesFilterCountsDocument = gql`
    query ExperiencesFilterCounts($campaignId: ID!, $sectionId: ID!, $targetRuleset: [TargetRuleInput!]!, $after: String, $before: String, $first: Int, $last: Int, $selectOnly: Experiences2CreativeFilter) {
  campaign(id: $campaignId) {
    id
    campaignTemplate {
      section(id: $sectionId) {
        ... on DynamicSection {
          id
          experiences2Creatives(
            after: $after
            before: $before
            first: $first
            last: $last
            selectOnly: $selectOnly
            targetRuleset: $targetRuleset
          ) {
            counts {
              allEligibleIncluded
              available
              availableDraft
              inUse
              included
              includedApproved
              incomplete
              prohibited
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExperiencesFilterCountsQuery__
 *
 * To run a query within a React component, call `useExperiencesFilterCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperiencesFilterCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperiencesFilterCountsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sectionId: // value for 'sectionId'
 *      targetRuleset: // value for 'targetRuleset'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useExperiencesFilterCountsQuery(baseOptions: Apollo.QueryHookOptions<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables> & ({ variables: ExperiencesFilterCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables>(ExperiencesFilterCountsDocument, options);
      }
export function useExperiencesFilterCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables>(ExperiencesFilterCountsDocument, options);
        }
export function useExperiencesFilterCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables>(ExperiencesFilterCountsDocument, options);
        }
export type ExperiencesFilterCountsQueryHookResult = ReturnType<typeof useExperiencesFilterCountsQuery>;
export type ExperiencesFilterCountsLazyQueryHookResult = ReturnType<typeof useExperiencesFilterCountsLazyQuery>;
export type ExperiencesFilterCountsSuspenseQueryHookResult = ReturnType<typeof useExperiencesFilterCountsSuspenseQuery>;
export type ExperiencesFilterCountsQueryResult = Apollo.QueryResult<ExperiencesFilterCountsQuery, ExperiencesFilterCountsQueryVariables>;
export const CampaignExperiences2CreateDocument = gql`
    mutation CampaignExperiences2Create($blockId: ID!, $recsSettings: Experience2RecsSettings!, $targetRuleset: [TargetRuleInput!]!, $visibility: Experience2Visibility!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  campaignExperiences2Create(
    blockId: $blockId
    recsSettings: $recsSettings
    targetRuleset: $targetRuleset
    visibility: $visibility
  ) {
    ... on CampaignExperiences2CreateSuccess {
      success
      experience {
        ...experiences2Fields
        section {
          id
        }
      }
      campaign {
        id
        campaignTemplate {
          section(id: $blockId) {
            ... on DynamicSection {
              ...DynamicSectionsFields
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${Experiences2FieldsFragmentDoc}
${DynamicSectionsFieldsFragmentDoc}`;
export type CampaignExperiences2CreateMutationFn = Apollo.MutationFunction<CampaignExperiences2CreateMutation, CampaignExperiences2CreateMutationVariables>;

/**
 * __useCampaignExperiences2CreateMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2CreateMutation, { data, loading, error }] = useCampaignExperiences2CreateMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      recsSettings: // value for 'recsSettings'
 *      targetRuleset: // value for 'targetRuleset'
 *      visibility: // value for 'visibility'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useCampaignExperiences2CreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2CreateMutation, CampaignExperiences2CreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2CreateMutation, CampaignExperiences2CreateMutationVariables>(CampaignExperiences2CreateDocument, options);
      }
export type CampaignExperiences2CreateMutationHookResult = ReturnType<typeof useCampaignExperiences2CreateMutation>;
export type CampaignExperiences2CreateMutationResult = Apollo.MutationResult<CampaignExperiences2CreateMutation>;
export type CampaignExperiences2CreateMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2CreateMutation, CampaignExperiences2CreateMutationVariables>;
export const CampaignExperiences2AttachCreativesDocument = gql`
    mutation CampaignExperiences2AttachCreatives($creativeIds: [ID!]!, $selectOnly: Experiences2CreativeFilter, $experienceId: ID!, $sectionId: ID!, $targetRuleset: [TargetRuleInput!]!, $after: String, $before: String, $first: Int, $last: Int) {
  campaignExperiences2AttachCreatives(
    creativeIds: $creativeIds
    experienceId: $experienceId
  ) {
    ... on CampaignExperiences2MutateSuccess {
      success
      campaign {
        id
        campaignTemplate {
          section(id: $sectionId) {
            ... on DynamicSection {
              id
              experiences2Complete
              experiences2Creatives(
                after: $after
                before: $before
                first: $first
                last: $last
                targetRuleset: $targetRuleset
                selectOnly: $selectOnly
              ) {
                ...ExperiencesCreativesFields
              }
              experiences2 {
                id
                autoInclude
                recsSettings {
                  ignoreReuseRules
                  ignoreCreativeFilters
                }
              }
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${ExperiencesCreativesFieldsFragmentDoc}`;
export type CampaignExperiences2AttachCreativesMutationFn = Apollo.MutationFunction<CampaignExperiences2AttachCreativesMutation, CampaignExperiences2AttachCreativesMutationVariables>;

/**
 * __useCampaignExperiences2AttachCreativesMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2AttachCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2AttachCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2AttachCreativesMutation, { data, loading, error }] = useCampaignExperiences2AttachCreativesMutation({
 *   variables: {
 *      creativeIds: // value for 'creativeIds'
 *      selectOnly: // value for 'selectOnly'
 *      experienceId: // value for 'experienceId'
 *      sectionId: // value for 'sectionId'
 *      targetRuleset: // value for 'targetRuleset'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCampaignExperiences2AttachCreativesMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2AttachCreativesMutation, CampaignExperiences2AttachCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2AttachCreativesMutation, CampaignExperiences2AttachCreativesMutationVariables>(CampaignExperiences2AttachCreativesDocument, options);
      }
export type CampaignExperiences2AttachCreativesMutationHookResult = ReturnType<typeof useCampaignExperiences2AttachCreativesMutation>;
export type CampaignExperiences2AttachCreativesMutationResult = Apollo.MutationResult<CampaignExperiences2AttachCreativesMutation>;
export type CampaignExperiences2AttachCreativesMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2AttachCreativesMutation, CampaignExperiences2AttachCreativesMutationVariables>;
export const CampaignExperiences2AttachAllCreativesDocument = gql`
    mutation CampaignExperiences2AttachAllCreatives($experienceId: ID!, $after: String, $before: String, $first: Int, $last: Int, $selectOnly: Experiences2CreativeFilter, $sectionId: ID!, $targetRuleset: [TargetRuleInput!]!) {
  campaignExperiences2AttachAllCreatives(
    experienceId: $experienceId
    selectOnly: $selectOnly
  ) {
    ... on CampaignExperiences2MutateSuccess {
      success
      campaign {
        id
        campaignTemplate {
          section(id: $sectionId) {
            ... on DynamicSection {
              id
              experiences2Complete
              experiences2Creatives(
                after: $after
                before: $before
                first: $first
                last: $last
                targetRuleset: $targetRuleset
                selectOnly: $selectOnly
              ) {
                ...ExperiencesCreativesFields
              }
              experiences2 {
                id
                autoInclude
                recsSettings {
                  ignoreReuseRules
                  ignoreCreativeFilters
                }
              }
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${ExperiencesCreativesFieldsFragmentDoc}`;
export type CampaignExperiences2AttachAllCreativesMutationFn = Apollo.MutationFunction<CampaignExperiences2AttachAllCreativesMutation, CampaignExperiences2AttachAllCreativesMutationVariables>;

/**
 * __useCampaignExperiences2AttachAllCreativesMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2AttachAllCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2AttachAllCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2AttachAllCreativesMutation, { data, loading, error }] = useCampaignExperiences2AttachAllCreativesMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      selectOnly: // value for 'selectOnly'
 *      sectionId: // value for 'sectionId'
 *      targetRuleset: // value for 'targetRuleset'
 *   },
 * });
 */
export function useCampaignExperiences2AttachAllCreativesMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2AttachAllCreativesMutation, CampaignExperiences2AttachAllCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2AttachAllCreativesMutation, CampaignExperiences2AttachAllCreativesMutationVariables>(CampaignExperiences2AttachAllCreativesDocument, options);
      }
export type CampaignExperiences2AttachAllCreativesMutationHookResult = ReturnType<typeof useCampaignExperiences2AttachAllCreativesMutation>;
export type CampaignExperiences2AttachAllCreativesMutationResult = Apollo.MutationResult<CampaignExperiences2AttachAllCreativesMutation>;
export type CampaignExperiences2AttachAllCreativesMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2AttachAllCreativesMutation, CampaignExperiences2AttachAllCreativesMutationVariables>;
export const CampaignExperiences2DetachAllCreativesDocument = gql`
    mutation CampaignExperiences2DetachAllCreatives($experienceId: ID!, $selectOnly: Experiences2CreativeFilter, $after: String, $before: String, $first: Int, $last: Int, $sectionId: ID!, $targetRuleset: [TargetRuleInput!]!) {
  campaignExperiences2DetachAllCreatives(
    experienceId: $experienceId
    selectOnly: $selectOnly
  ) {
    ... on CampaignExperiences2MutateSuccess {
      success
      campaign {
        id
        campaignTemplate {
          section(id: $sectionId) {
            ... on DynamicSection {
              id
              experiences2Complete
              experiences2Creatives(
                after: $after
                before: $before
                first: $first
                last: $last
                targetRuleset: $targetRuleset
                selectOnly: $selectOnly
              ) {
                ...ExperiencesCreativesFields
              }
              experiences2 {
                id
                autoInclude
                recsSettings {
                  ignoreReuseRules
                  ignoreCreativeFilters
                }
              }
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${ExperiencesCreativesFieldsFragmentDoc}`;
export type CampaignExperiences2DetachAllCreativesMutationFn = Apollo.MutationFunction<CampaignExperiences2DetachAllCreativesMutation, CampaignExperiences2DetachAllCreativesMutationVariables>;

/**
 * __useCampaignExperiences2DetachAllCreativesMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2DetachAllCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2DetachAllCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2DetachAllCreativesMutation, { data, loading, error }] = useCampaignExperiences2DetachAllCreativesMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *      selectOnly: // value for 'selectOnly'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sectionId: // value for 'sectionId'
 *      targetRuleset: // value for 'targetRuleset'
 *   },
 * });
 */
export function useCampaignExperiences2DetachAllCreativesMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2DetachAllCreativesMutation, CampaignExperiences2DetachAllCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2DetachAllCreativesMutation, CampaignExperiences2DetachAllCreativesMutationVariables>(CampaignExperiences2DetachAllCreativesDocument, options);
      }
export type CampaignExperiences2DetachAllCreativesMutationHookResult = ReturnType<typeof useCampaignExperiences2DetachAllCreativesMutation>;
export type CampaignExperiences2DetachAllCreativesMutationResult = Apollo.MutationResult<CampaignExperiences2DetachAllCreativesMutation>;
export type CampaignExperiences2DetachAllCreativesMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2DetachAllCreativesMutation, CampaignExperiences2DetachAllCreativesMutationVariables>;
export const CampaignExperiences2DetachCreativesDocument = gql`
    mutation CampaignExperiences2DetachCreatives($selectOnly: Experiences2CreativeFilter, $creativeIds: [ID!]!, $experienceId: ID!, $after: String, $before: String, $first: Int, $last: Int, $sectionId: ID!, $targetRuleset: [TargetRuleInput!]!) {
  campaignExperiences2DetachCreatives(
    creativeIds: $creativeIds
    experienceId: $experienceId
  ) {
    ... on CampaignExperiences2MutateSuccess {
      success
      campaign {
        id
        campaignTemplate {
          section(id: $sectionId) {
            ... on DynamicSection {
              id
              experiences2Complete
              experiences2Creatives(
                after: $after
                before: $before
                first: $first
                last: $last
                targetRuleset: $targetRuleset
                selectOnly: $selectOnly
              ) {
                ...ExperiencesCreativesFields
              }
              experiences2 {
                id
                autoInclude
                recsSettings {
                  ignoreReuseRules
                  ignoreCreativeFilters
                }
              }
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${ExperiencesCreativesFieldsFragmentDoc}`;
export type CampaignExperiences2DetachCreativesMutationFn = Apollo.MutationFunction<CampaignExperiences2DetachCreativesMutation, CampaignExperiences2DetachCreativesMutationVariables>;

/**
 * __useCampaignExperiences2DetachCreativesMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2DetachCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2DetachCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2DetachCreativesMutation, { data, loading, error }] = useCampaignExperiences2DetachCreativesMutation({
 *   variables: {
 *      selectOnly: // value for 'selectOnly'
 *      creativeIds: // value for 'creativeIds'
 *      experienceId: // value for 'experienceId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sectionId: // value for 'sectionId'
 *      targetRuleset: // value for 'targetRuleset'
 *   },
 * });
 */
export function useCampaignExperiences2DetachCreativesMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2DetachCreativesMutation, CampaignExperiences2DetachCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2DetachCreativesMutation, CampaignExperiences2DetachCreativesMutationVariables>(CampaignExperiences2DetachCreativesDocument, options);
      }
export type CampaignExperiences2DetachCreativesMutationHookResult = ReturnType<typeof useCampaignExperiences2DetachCreativesMutation>;
export type CampaignExperiences2DetachCreativesMutationResult = Apollo.MutationResult<CampaignExperiences2DetachCreativesMutation>;
export type CampaignExperiences2DetachCreativesMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2DetachCreativesMutation, CampaignExperiences2DetachCreativesMutationVariables>;
export const CampaignExperiences2UpdateVisibilityDocument = gql`
    mutation CampaignExperiences2UpdateVisibility($experienceId: ID!, $visibility: Experience2Visibility!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  campaignExperiences2UpdateVisibility(
    experienceId: $experienceId
    visibility: $visibility
  ) {
    ... on CampaignExperiences2MutateSuccess {
      success
      experience {
        ...experiences2Fields
        section {
          id
        }
      }
      campaign {
        id
        campaignTemplate {
          sections(contentBlockType: DYNAMIC) {
            ... on DynamicSection {
              ...DynamicSectionsFields
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${Experiences2FieldsFragmentDoc}
${DynamicSectionsFieldsFragmentDoc}`;
export type CampaignExperiences2UpdateVisibilityMutationFn = Apollo.MutationFunction<CampaignExperiences2UpdateVisibilityMutation, CampaignExperiences2UpdateVisibilityMutationVariables>;

/**
 * __useCampaignExperiences2UpdateVisibilityMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2UpdateVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2UpdateVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2UpdateVisibilityMutation, { data, loading, error }] = useCampaignExperiences2UpdateVisibilityMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *      visibility: // value for 'visibility'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useCampaignExperiences2UpdateVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2UpdateVisibilityMutation, CampaignExperiences2UpdateVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2UpdateVisibilityMutation, CampaignExperiences2UpdateVisibilityMutationVariables>(CampaignExperiences2UpdateVisibilityDocument, options);
      }
export type CampaignExperiences2UpdateVisibilityMutationHookResult = ReturnType<typeof useCampaignExperiences2UpdateVisibilityMutation>;
export type CampaignExperiences2UpdateVisibilityMutationResult = Apollo.MutationResult<CampaignExperiences2UpdateVisibilityMutation>;
export type CampaignExperiences2UpdateVisibilityMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2UpdateVisibilityMutation, CampaignExperiences2UpdateVisibilityMutationVariables>;
export const CampaignExperiences2BlockResetDocument = gql`
    mutation CampaignExperiences2BlockReset($blockId: ID!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  campaignExperiences2BlockReset(blockId: $blockId) {
    ... on CampaignExperiences2BlockResetSuccess {
      success
      section {
        ... on DynamicSection {
          id
          experiences2 {
            id
          }
        }
      }
      campaign {
        id
        campaignTemplate {
          sections(contentBlockType: DYNAMIC) {
            ... on DynamicSection {
              ...DynamicSectionsFields
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${DynamicSectionsFieldsFragmentDoc}`;
export type CampaignExperiences2BlockResetMutationFn = Apollo.MutationFunction<CampaignExperiences2BlockResetMutation, CampaignExperiences2BlockResetMutationVariables>;

/**
 * __useCampaignExperiences2BlockResetMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2BlockResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2BlockResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2BlockResetMutation, { data, loading, error }] = useCampaignExperiences2BlockResetMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useCampaignExperiences2BlockResetMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2BlockResetMutation, CampaignExperiences2BlockResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2BlockResetMutation, CampaignExperiences2BlockResetMutationVariables>(CampaignExperiences2BlockResetDocument, options);
      }
export type CampaignExperiences2BlockResetMutationHookResult = ReturnType<typeof useCampaignExperiences2BlockResetMutation>;
export type CampaignExperiences2BlockResetMutationResult = Apollo.MutationResult<CampaignExperiences2BlockResetMutation>;
export type CampaignExperiences2BlockResetMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2BlockResetMutation, CampaignExperiences2BlockResetMutationVariables>;
export const CampaignExperiences2DeleteDocument = gql`
    mutation CampaignExperiences2Delete($experienceId: ID!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  campaignExperiences2Delete(experienceId: $experienceId) {
    ... on CampaignExperiences2DeleteSuccess {
      success
      deletedExperienceId
      campaign {
        id
        campaignTemplate {
          sections(contentBlockType: DYNAMIC) {
            ... on DynamicSection {
              ...DynamicSectionsFields
            }
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${DynamicSectionsFieldsFragmentDoc}`;
export type CampaignExperiences2DeleteMutationFn = Apollo.MutationFunction<CampaignExperiences2DeleteMutation, CampaignExperiences2DeleteMutationVariables>;

/**
 * __useCampaignExperiences2DeleteMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2DeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2DeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2DeleteMutation, { data, loading, error }] = useCampaignExperiences2DeleteMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useCampaignExperiences2DeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2DeleteMutation, CampaignExperiences2DeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2DeleteMutation, CampaignExperiences2DeleteMutationVariables>(CampaignExperiences2DeleteDocument, options);
      }
export type CampaignExperiences2DeleteMutationHookResult = ReturnType<typeof useCampaignExperiences2DeleteMutation>;
export type CampaignExperiences2DeleteMutationResult = Apollo.MutationResult<CampaignExperiences2DeleteMutation>;
export type CampaignExperiences2DeleteMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2DeleteMutation, CampaignExperiences2DeleteMutationVariables>;
export const AvailableCreativeTagsDocument = gql`
    query AvailableCreativeTags($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    availableCreativeTags {
      id
      name
    }
  }
}
    `;

/**
 * __useAvailableCreativeTagsQuery__
 *
 * To run a query within a React component, call `useAvailableCreativeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCreativeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCreativeTagsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAvailableCreativeTagsQuery(baseOptions: Apollo.QueryHookOptions<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables> & ({ variables: AvailableCreativeTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables>(AvailableCreativeTagsDocument, options);
      }
export function useAvailableCreativeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables>(AvailableCreativeTagsDocument, options);
        }
export function useAvailableCreativeTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables>(AvailableCreativeTagsDocument, options);
        }
export type AvailableCreativeTagsQueryHookResult = ReturnType<typeof useAvailableCreativeTagsQuery>;
export type AvailableCreativeTagsLazyQueryHookResult = ReturnType<typeof useAvailableCreativeTagsLazyQuery>;
export type AvailableCreativeTagsSuspenseQueryHookResult = ReturnType<typeof useAvailableCreativeTagsSuspenseQuery>;
export type AvailableCreativeTagsQueryResult = Apollo.QueryResult<AvailableCreativeTagsQuery, AvailableCreativeTagsQueryVariables>;
export const ExperienceExperiment2Document = gql`
    query ExperienceExperiment2($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    experienceExperiment {
      id
      title
      experimentType
      status
      treatments {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useExperienceExperiment2Query__
 *
 * To run a query within a React component, call `useExperienceExperiment2Query` and pass it any options that fit your needs.
 * When your component renders, `useExperienceExperiment2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceExperiment2Query({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useExperienceExperiment2Query(baseOptions: Apollo.QueryHookOptions<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables> & ({ variables: ExperienceExperiment2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables>(ExperienceExperiment2Document, options);
      }
export function useExperienceExperiment2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables>(ExperienceExperiment2Document, options);
        }
export function useExperienceExperiment2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables>(ExperienceExperiment2Document, options);
        }
export type ExperienceExperiment2QueryHookResult = ReturnType<typeof useExperienceExperiment2Query>;
export type ExperienceExperiment2LazyQueryHookResult = ReturnType<typeof useExperienceExperiment2LazyQuery>;
export type ExperienceExperiment2SuspenseQueryHookResult = ReturnType<typeof useExperienceExperiment2SuspenseQuery>;
export type ExperienceExperiment2QueryResult = Apollo.QueryResult<ExperienceExperiment2Query, ExperienceExperiment2QueryVariables>;
export const CampaignExperiencesAutoIncludeCreativesDocument = gql`
    mutation CampaignExperiencesAutoIncludeCreatives($creativeTagIds: [ID!]!, $campaignId: ID!, $enabled: Boolean, $sectionId: ID!, $targetRuleset: [TargetRuleInput!]!, $visibility: Experience2Visibility!, $after: String, $before: String, $first: Int, $last: Int, $selectOnly: Experiences2CreativeFilter) {
  campaignExperience2AutoIncludeCreatives(
    creativeTagIds: $creativeTagIds
    id: $campaignId
    enabled: $enabled
    sectionId: $sectionId
    targetRuleset: $targetRuleset
    visibility: $visibility
  ) {
    success
    campaign {
      id
      campaignTemplate {
        section(id: $sectionId) {
          ... on DynamicSection {
            id
            experiences2Complete
            experiences2Creatives(
              after: $after
              before: $before
              first: $first
              last: $last
              targetRuleset: $targetRuleset
              selectOnly: $selectOnly
            ) {
              ...ExperiencesCreativesFields
            }
            experiences2 {
              id
              autoInclude
              recsSettings {
                ignoreReuseRules
                ignoreCreativeFilters
              }
            }
          }
        }
      }
    }
  }
}
    ${ExperiencesCreativesFieldsFragmentDoc}`;
export type CampaignExperiencesAutoIncludeCreativesMutationFn = Apollo.MutationFunction<CampaignExperiencesAutoIncludeCreativesMutation, CampaignExperiencesAutoIncludeCreativesMutationVariables>;

/**
 * __useCampaignExperiencesAutoIncludeCreativesMutation__
 *
 * To run a mutation, you first call `useCampaignExperiencesAutoIncludeCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiencesAutoIncludeCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiencesAutoIncludeCreativesMutation, { data, loading, error }] = useCampaignExperiencesAutoIncludeCreativesMutation({
 *   variables: {
 *      creativeTagIds: // value for 'creativeTagIds'
 *      campaignId: // value for 'campaignId'
 *      enabled: // value for 'enabled'
 *      sectionId: // value for 'sectionId'
 *      targetRuleset: // value for 'targetRuleset'
 *      visibility: // value for 'visibility'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useCampaignExperiencesAutoIncludeCreativesMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiencesAutoIncludeCreativesMutation, CampaignExperiencesAutoIncludeCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiencesAutoIncludeCreativesMutation, CampaignExperiencesAutoIncludeCreativesMutationVariables>(CampaignExperiencesAutoIncludeCreativesDocument, options);
      }
export type CampaignExperiencesAutoIncludeCreativesMutationHookResult = ReturnType<typeof useCampaignExperiencesAutoIncludeCreativesMutation>;
export type CampaignExperiencesAutoIncludeCreativesMutationResult = Apollo.MutationResult<CampaignExperiencesAutoIncludeCreativesMutation>;
export type CampaignExperiencesAutoIncludeCreativesMutationOptions = Apollo.BaseMutationOptions<CampaignExperiencesAutoIncludeCreativesMutation, CampaignExperiencesAutoIncludeCreativesMutationVariables>;
export const Experience2ContactCountDocument = gql`
    mutation Experience2ContactCount($experienceId: ID!) {
  experience2ContactCount(experienceId: $experienceId) {
    count {
      total
      includeAudiences {
        id
        total
      }
      excludeAudiences {
        id
        total
      }
    }
  }
}
    `;
export type Experience2ContactCountMutationFn = Apollo.MutationFunction<Experience2ContactCountMutation, Experience2ContactCountMutationVariables>;

/**
 * __useExperience2ContactCountMutation__
 *
 * To run a mutation, you first call `useExperience2ContactCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperience2ContactCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experience2ContactCountMutation, { data, loading, error }] = useExperience2ContactCountMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *   },
 * });
 */
export function useExperience2ContactCountMutation(baseOptions?: Apollo.MutationHookOptions<Experience2ContactCountMutation, Experience2ContactCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Experience2ContactCountMutation, Experience2ContactCountMutationVariables>(Experience2ContactCountDocument, options);
      }
export type Experience2ContactCountMutationHookResult = ReturnType<typeof useExperience2ContactCountMutation>;
export type Experience2ContactCountMutationResult = Apollo.MutationResult<Experience2ContactCountMutation>;
export type Experience2ContactCountMutationOptions = Apollo.BaseMutationOptions<Experience2ContactCountMutation, Experience2ContactCountMutationVariables>;
export const CampaignExperiences2UpdateNameDocument = gql`
    mutation CampaignExperiences2UpdateName($experienceId: ID!, $name: String!) {
  campaignExperiences2UpdateName(experienceId: $experienceId, name: $name) {
    ... on CampaignExperiences2SetNameSuccess {
      success
      experience {
        id
        title
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type CampaignExperiences2UpdateNameMutationFn = Apollo.MutationFunction<CampaignExperiences2UpdateNameMutation, CampaignExperiences2UpdateNameMutationVariables>;

/**
 * __useCampaignExperiences2UpdateNameMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2UpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2UpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2UpdateNameMutation, { data, loading, error }] = useCampaignExperiences2UpdateNameMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCampaignExperiences2UpdateNameMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2UpdateNameMutation, CampaignExperiences2UpdateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2UpdateNameMutation, CampaignExperiences2UpdateNameMutationVariables>(CampaignExperiences2UpdateNameDocument, options);
      }
export type CampaignExperiences2UpdateNameMutationHookResult = ReturnType<typeof useCampaignExperiences2UpdateNameMutation>;
export type CampaignExperiences2UpdateNameMutationResult = Apollo.MutationResult<CampaignExperiences2UpdateNameMutation>;
export type CampaignExperiences2UpdateNameMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2UpdateNameMutation, CampaignExperiences2UpdateNameMutationVariables>;
export const CampaignExperiences2UpdateRecsSettingsDocument = gql`
    mutation CampaignExperiences2UpdateRecsSettings($experienceId: ID!, $recsSettings: Experience2RecsSettings!) {
  campaignExperiences2UpdateRecsSettings(
    experienceId: $experienceId
    recsSettings: $recsSettings
  ) {
    ... on CampaignExperiences2MutateSuccess {
      success
      experience {
        id
        recsSettings {
          ignoreReuseRules
          ignoreCreativeFilters
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type CampaignExperiences2UpdateRecsSettingsMutationFn = Apollo.MutationFunction<CampaignExperiences2UpdateRecsSettingsMutation, CampaignExperiences2UpdateRecsSettingsMutationVariables>;

/**
 * __useCampaignExperiences2UpdateRecsSettingsMutation__
 *
 * To run a mutation, you first call `useCampaignExperiences2UpdateRecsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignExperiences2UpdateRecsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignExperiences2UpdateRecsSettingsMutation, { data, loading, error }] = useCampaignExperiences2UpdateRecsSettingsMutation({
 *   variables: {
 *      experienceId: // value for 'experienceId'
 *      recsSettings: // value for 'recsSettings'
 *   },
 * });
 */
export function useCampaignExperiences2UpdateRecsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CampaignExperiences2UpdateRecsSettingsMutation, CampaignExperiences2UpdateRecsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignExperiences2UpdateRecsSettingsMutation, CampaignExperiences2UpdateRecsSettingsMutationVariables>(CampaignExperiences2UpdateRecsSettingsDocument, options);
      }
export type CampaignExperiences2UpdateRecsSettingsMutationHookResult = ReturnType<typeof useCampaignExperiences2UpdateRecsSettingsMutation>;
export type CampaignExperiences2UpdateRecsSettingsMutationResult = Apollo.MutationResult<CampaignExperiences2UpdateRecsSettingsMutation>;
export type CampaignExperiences2UpdateRecsSettingsMutationOptions = Apollo.BaseMutationOptions<CampaignExperiences2UpdateRecsSettingsMutation, CampaignExperiences2UpdateRecsSettingsMutationVariables>;
export const CampaignAudienceAndTreatmentsDocument = gql`
    query CampaignAudienceAndTreatments($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    includedContactAudiences {
      id
      name
      splitConfigs {
        id
        selected
        name
        split {
          id
          createdAt
          updatedAt
          name
          query
        }
      }
      contactAudience {
        id
      }
    }
  }
}
    `;

/**
 * __useCampaignAudienceAndTreatmentsQuery__
 *
 * To run a query within a React component, call `useCampaignAudienceAndTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAudienceAndTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAudienceAndTreatmentsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignAudienceAndTreatmentsQuery(baseOptions: Apollo.QueryHookOptions<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables> & ({ variables: CampaignAudienceAndTreatmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables>(CampaignAudienceAndTreatmentsDocument, options);
      }
export function useCampaignAudienceAndTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables>(CampaignAudienceAndTreatmentsDocument, options);
        }
export function useCampaignAudienceAndTreatmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables>(CampaignAudienceAndTreatmentsDocument, options);
        }
export type CampaignAudienceAndTreatmentsQueryHookResult = ReturnType<typeof useCampaignAudienceAndTreatmentsQuery>;
export type CampaignAudienceAndTreatmentsLazyQueryHookResult = ReturnType<typeof useCampaignAudienceAndTreatmentsLazyQuery>;
export type CampaignAudienceAndTreatmentsSuspenseQueryHookResult = ReturnType<typeof useCampaignAudienceAndTreatmentsSuspenseQuery>;
export type CampaignAudienceAndTreatmentsQueryResult = Apollo.QueryResult<CampaignAudienceAndTreatmentsQuery, CampaignAudienceAndTreatmentsQueryVariables>;
export const PrefixDocument = gql`
    query Prefix($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    prefix {
      __typename
      ... on StaticMessage {
        message
      }
      ... on DynamicContent {
        section {
          id
          position
          contentBlock {
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePrefixQuery__
 *
 * To run a query within a React component, call `usePrefixQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrefixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrefixQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePrefixQuery(baseOptions: Apollo.QueryHookOptions<PrefixQuery, PrefixQueryVariables> & ({ variables: PrefixQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrefixQuery, PrefixQueryVariables>(PrefixDocument, options);
      }
export function usePrefixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrefixQuery, PrefixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrefixQuery, PrefixQueryVariables>(PrefixDocument, options);
        }
export function usePrefixSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrefixQuery, PrefixQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrefixQuery, PrefixQueryVariables>(PrefixDocument, options);
        }
export type PrefixQueryHookResult = ReturnType<typeof usePrefixQuery>;
export type PrefixLazyQueryHookResult = ReturnType<typeof usePrefixLazyQuery>;
export type PrefixSuspenseQueryHookResult = ReturnType<typeof usePrefixSuspenseQuery>;
export type PrefixQueryResult = Apollo.QueryResult<PrefixQuery, PrefixQueryVariables>;
export const CampaignSubjectLinePrefixModeUpdateDocument = gql`
    mutation campaignSubjectLinePrefixModeUpdate($campaignId: ID!, $mode: SubjectLineChunkMode!) {
  campaignSubjectLinePrefixModeUpdate(id: $campaignId, mode: $mode) {
    campaign {
      id
      prefix {
        __typename
      }
    }
  }
}
    `;
export type CampaignSubjectLinePrefixModeUpdateMutationFn = Apollo.MutationFunction<CampaignSubjectLinePrefixModeUpdateMutation, CampaignSubjectLinePrefixModeUpdateMutationVariables>;

/**
 * __useCampaignSubjectLinePrefixModeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSubjectLinePrefixModeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSubjectLinePrefixModeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSubjectLinePrefixModeUpdateMutation, { data, loading, error }] = useCampaignSubjectLinePrefixModeUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCampaignSubjectLinePrefixModeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSubjectLinePrefixModeUpdateMutation, CampaignSubjectLinePrefixModeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSubjectLinePrefixModeUpdateMutation, CampaignSubjectLinePrefixModeUpdateMutationVariables>(CampaignSubjectLinePrefixModeUpdateDocument, options);
      }
export type CampaignSubjectLinePrefixModeUpdateMutationHookResult = ReturnType<typeof useCampaignSubjectLinePrefixModeUpdateMutation>;
export type CampaignSubjectLinePrefixModeUpdateMutationResult = Apollo.MutationResult<CampaignSubjectLinePrefixModeUpdateMutation>;
export type CampaignSubjectLinePrefixModeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSubjectLinePrefixModeUpdateMutation, CampaignSubjectLinePrefixModeUpdateMutationVariables>;
export const CampaignStaticSubjectLinePrefixUpdateDocument = gql`
    mutation campaignStaticSubjectLinePrefixUpdate($campaignId: ID!, $message: String!) {
  campaignStaticSubjectLinePrefixUpdate(id: $campaignId, message: $message) {
    campaign {
      id
      prefix {
        ... on StaticMessage {
          message
        }
      }
    }
  }
}
    `;
export type CampaignStaticSubjectLinePrefixUpdateMutationFn = Apollo.MutationFunction<CampaignStaticSubjectLinePrefixUpdateMutation, CampaignStaticSubjectLinePrefixUpdateMutationVariables>;

/**
 * __useCampaignStaticSubjectLinePrefixUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignStaticSubjectLinePrefixUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignStaticSubjectLinePrefixUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignStaticSubjectLinePrefixUpdateMutation, { data, loading, error }] = useCampaignStaticSubjectLinePrefixUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCampaignStaticSubjectLinePrefixUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignStaticSubjectLinePrefixUpdateMutation, CampaignStaticSubjectLinePrefixUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignStaticSubjectLinePrefixUpdateMutation, CampaignStaticSubjectLinePrefixUpdateMutationVariables>(CampaignStaticSubjectLinePrefixUpdateDocument, options);
      }
export type CampaignStaticSubjectLinePrefixUpdateMutationHookResult = ReturnType<typeof useCampaignStaticSubjectLinePrefixUpdateMutation>;
export type CampaignStaticSubjectLinePrefixUpdateMutationResult = Apollo.MutationResult<CampaignStaticSubjectLinePrefixUpdateMutation>;
export type CampaignStaticSubjectLinePrefixUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignStaticSubjectLinePrefixUpdateMutation, CampaignStaticSubjectLinePrefixUpdateMutationVariables>;
export const CampaignDynamicSubjectLinePrefixUpdateDocument = gql`
    mutation campaignDynamicSubjectLinePrefixUpdate($campaignId: ID!, $sectionId: ID!) {
  campaignDynamicSubjectLinePrefixUpdate(id: $campaignId, sectionId: $sectionId) {
    campaign {
      id
      prefix {
        ... on DynamicContent {
          section {
            id
            position
            contentBlock {
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type CampaignDynamicSubjectLinePrefixUpdateMutationFn = Apollo.MutationFunction<CampaignDynamicSubjectLinePrefixUpdateMutation, CampaignDynamicSubjectLinePrefixUpdateMutationVariables>;

/**
 * __useCampaignDynamicSubjectLinePrefixUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignDynamicSubjectLinePrefixUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicSubjectLinePrefixUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDynamicSubjectLinePrefixUpdateMutation, { data, loading, error }] = useCampaignDynamicSubjectLinePrefixUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCampaignDynamicSubjectLinePrefixUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDynamicSubjectLinePrefixUpdateMutation, CampaignDynamicSubjectLinePrefixUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDynamicSubjectLinePrefixUpdateMutation, CampaignDynamicSubjectLinePrefixUpdateMutationVariables>(CampaignDynamicSubjectLinePrefixUpdateDocument, options);
      }
export type CampaignDynamicSubjectLinePrefixUpdateMutationHookResult = ReturnType<typeof useCampaignDynamicSubjectLinePrefixUpdateMutation>;
export type CampaignDynamicSubjectLinePrefixUpdateMutationResult = Apollo.MutationResult<CampaignDynamicSubjectLinePrefixUpdateMutation>;
export type CampaignDynamicSubjectLinePrefixUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignDynamicSubjectLinePrefixUpdateMutation, CampaignDynamicSubjectLinePrefixUpdateMutationVariables>;
export const PreHeaderLinkDrawerDocument = gql`
    query PreHeaderLinkDrawer($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    espConfig {
      __typename
    }
    emailServiceProvider {
      __typename
      ... on Cordial {
        cordialRequiredLinkMetadataFields: requiredLinkMetadataFields
      }
      ... on AcousticCampaign {
        acousticCampaignRequiredLinkMetadataFields: requiredLinkMetadataFields
      }
      ... on Epsilon {
        epsilonRequiredLinkMetadataFields: requiredLinkMetadataFields
      }
      ... on OracleResponsys {
        oracleResponsysRequiredLinkMetadataFields: requiredLinkMetadataFields
        linkCategories {
          id
          title
        }
      }
      ... on SalesForceMarketingCloud {
        salesforceRequiredLinkMetadataFields: requiredLinkMetadataFields
        defaultLinkMetadata {
          enableDeepLinks
          enableConversionTracking
        }
      }
    }
    preheaderAndPreview {
      ... on OnlyPreheader {
        preheader {
          __typename
          ... on StaticMessageWithLink {
            message
            link {
              ...linkFields
              linkGroup {
                id
                name
                linksCount
              }
            }
          }
        }
      }
      ... on BothPreviewPreheader {
        preheaderWithPreview {
          __typename
          ... on StaticPreheaderWithPreview {
            preview
            preheader
            link {
              ...linkFields
              linkGroup {
                id
                name
                linksCount
              }
            }
          }
        }
      }
    }
  }
}
    ${LinkFieldsFragmentDoc}`;

/**
 * __usePreHeaderLinkDrawerQuery__
 *
 * To run a query within a React component, call `usePreHeaderLinkDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreHeaderLinkDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreHeaderLinkDrawerQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePreHeaderLinkDrawerQuery(baseOptions: Apollo.QueryHookOptions<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables> & ({ variables: PreHeaderLinkDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables>(PreHeaderLinkDrawerDocument, options);
      }
export function usePreHeaderLinkDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables>(PreHeaderLinkDrawerDocument, options);
        }
export function usePreHeaderLinkDrawerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables>(PreHeaderLinkDrawerDocument, options);
        }
export type PreHeaderLinkDrawerQueryHookResult = ReturnType<typeof usePreHeaderLinkDrawerQuery>;
export type PreHeaderLinkDrawerLazyQueryHookResult = ReturnType<typeof usePreHeaderLinkDrawerLazyQuery>;
export type PreHeaderLinkDrawerSuspenseQueryHookResult = ReturnType<typeof usePreHeaderLinkDrawerSuspenseQuery>;
export type PreHeaderLinkDrawerQueryResult = Apollo.QueryResult<PreHeaderLinkDrawerQuery, PreHeaderLinkDrawerQueryVariables>;
export const CampaignPreheaderAndPreviewModeUpdateDocument = gql`
    mutation campaignPreheaderAndPreviewModeUpdate($campaignId: ID!, $mode: SubjectLineChunkMode!) {
  campaignPreheaderAndPreviewModeUpdate(id: $campaignId, mode: $mode) {
    success
    campaign {
      id
      preheaderAndPreview {
        ... on OnlyPreview {
          preview {
            __typename
          }
        }
        ... on OnlyPreheader {
          preheader {
            __typename
          }
        }
        ... on BothPreviewPreheader {
          preheaderWithPreview {
            __typename
          }
        }
      }
    }
  }
}
    `;
export type CampaignPreheaderAndPreviewModeUpdateMutationFn = Apollo.MutationFunction<CampaignPreheaderAndPreviewModeUpdateMutation, CampaignPreheaderAndPreviewModeUpdateMutationVariables>;

/**
 * __useCampaignPreheaderAndPreviewModeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignPreheaderAndPreviewModeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignPreheaderAndPreviewModeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignPreheaderAndPreviewModeUpdateMutation, { data, loading, error }] = useCampaignPreheaderAndPreviewModeUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCampaignPreheaderAndPreviewModeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignPreheaderAndPreviewModeUpdateMutation, CampaignPreheaderAndPreviewModeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignPreheaderAndPreviewModeUpdateMutation, CampaignPreheaderAndPreviewModeUpdateMutationVariables>(CampaignPreheaderAndPreviewModeUpdateDocument, options);
      }
export type CampaignPreheaderAndPreviewModeUpdateMutationHookResult = ReturnType<typeof useCampaignPreheaderAndPreviewModeUpdateMutation>;
export type CampaignPreheaderAndPreviewModeUpdateMutationResult = Apollo.MutationResult<CampaignPreheaderAndPreviewModeUpdateMutation>;
export type CampaignPreheaderAndPreviewModeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignPreheaderAndPreviewModeUpdateMutation, CampaignPreheaderAndPreviewModeUpdateMutationVariables>;
export const CampaignDynamicPreheaderAndPreviewUpdateDocument = gql`
    mutation campaignDynamicPreheaderAndPreviewUpdate($id: ID!, $sectionId: ID!) {
  campaignDynamicPreheaderAndPreviewUpdate(id: $id, sectionId: $sectionId) {
    success
    campaign {
      id
      status
      preheaderAndPreview {
        ... on OnlyPreview {
          preview {
            ... on StaticMessage {
              message
            }
            ... on DynamicContent {
              incompleteCreatives {
                id
                title
              }
              section {
                id
                title
              }
            }
          }
        }
        ... on OnlyPreheader {
          preheader {
            ... on StaticMessageWithLink {
              message
              link {
                id
                url
                linkGroup {
                  id
                  name
                  linksCount
                }
              }
            }
            ... on DynamicContent {
              incompleteCreatives {
                id
                title
              }
              section {
                id
                title
              }
            }
          }
        }
        ... on BothPreviewPreheader {
          preheaderWithPreview {
            ... on StaticPreheaderWithPreview {
              preview
              preheader
              link {
                id
                url
                shortUuid
                linkGroup {
                  id
                  name
                  linksCount
                }
              }
            }
            ... on DynamicContent {
              incompleteCreatives {
                id
                title
              }
              section {
                id
                title
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CampaignDynamicPreheaderAndPreviewUpdateMutationFn = Apollo.MutationFunction<CampaignDynamicPreheaderAndPreviewUpdateMutation, CampaignDynamicPreheaderAndPreviewUpdateMutationVariables>;

/**
 * __useCampaignDynamicPreheaderAndPreviewUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignDynamicPreheaderAndPreviewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicPreheaderAndPreviewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDynamicPreheaderAndPreviewUpdateMutation, { data, loading, error }] = useCampaignDynamicPreheaderAndPreviewUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCampaignDynamicPreheaderAndPreviewUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDynamicPreheaderAndPreviewUpdateMutation, CampaignDynamicPreheaderAndPreviewUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDynamicPreheaderAndPreviewUpdateMutation, CampaignDynamicPreheaderAndPreviewUpdateMutationVariables>(CampaignDynamicPreheaderAndPreviewUpdateDocument, options);
      }
export type CampaignDynamicPreheaderAndPreviewUpdateMutationHookResult = ReturnType<typeof useCampaignDynamicPreheaderAndPreviewUpdateMutation>;
export type CampaignDynamicPreheaderAndPreviewUpdateMutationResult = Apollo.MutationResult<CampaignDynamicPreheaderAndPreviewUpdateMutation>;
export type CampaignDynamicPreheaderAndPreviewUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignDynamicPreheaderAndPreviewUpdateMutation, CampaignDynamicPreheaderAndPreviewUpdateMutationVariables>;
export const CampaignStaticPreheaderAndPreviewUpdateDocument = gql`
    mutation campaignStaticPreheaderAndPreviewUpdate($config: StaticPreheaderAndPreview!, $id: ID!) {
  campaignStaticPreheaderAndPreviewUpdate(config: $config, id: $id) {
    success
    campaign {
      id
      preheaderAndPreview {
        ... on OnlyPreview {
          __typename
        }
        ... on OnlyPreheader {
          __typename
        }
        ... on BothPreviewPreheader {
          __typename
        }
      }
    }
  }
}
    `;
export type CampaignStaticPreheaderAndPreviewUpdateMutationFn = Apollo.MutationFunction<CampaignStaticPreheaderAndPreviewUpdateMutation, CampaignStaticPreheaderAndPreviewUpdateMutationVariables>;

/**
 * __useCampaignStaticPreheaderAndPreviewUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignStaticPreheaderAndPreviewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignStaticPreheaderAndPreviewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignStaticPreheaderAndPreviewUpdateMutation, { data, loading, error }] = useCampaignStaticPreheaderAndPreviewUpdateMutation({
 *   variables: {
 *      config: // value for 'config'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignStaticPreheaderAndPreviewUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignStaticPreheaderAndPreviewUpdateMutation, CampaignStaticPreheaderAndPreviewUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignStaticPreheaderAndPreviewUpdateMutation, CampaignStaticPreheaderAndPreviewUpdateMutationVariables>(CampaignStaticPreheaderAndPreviewUpdateDocument, options);
      }
export type CampaignStaticPreheaderAndPreviewUpdateMutationHookResult = ReturnType<typeof useCampaignStaticPreheaderAndPreviewUpdateMutation>;
export type CampaignStaticPreheaderAndPreviewUpdateMutationResult = Apollo.MutationResult<CampaignStaticPreheaderAndPreviewUpdateMutation>;
export type CampaignStaticPreheaderAndPreviewUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignStaticPreheaderAndPreviewUpdateMutation, CampaignStaticPreheaderAndPreviewUpdateMutationVariables>;
export const RemoveCampaignPreheaderLinkDocument = gql`
    mutation RemoveCampaignPreheaderLink($config: StaticPreheaderAndPreview!, $id: ID!) {
  campaignStaticPreheaderAndPreviewUpdate(config: $config, id: $id) {
    success
    campaign {
      id
      status
      preheaderAndPreview {
        ... on OnlyPreview {
          preview {
            ... on StaticMessage {
              message
            }
            ... on DynamicContent {
              incompleteCreatives {
                id
                title
              }
              section {
                id
                title
              }
            }
          }
        }
        ... on OnlyPreheader {
          preheader {
            ... on StaticMessageWithLink {
              message
              link {
                id
                url
                shortUuid
                linkGroup {
                  id
                  name
                  linksCount
                }
              }
            }
            ... on DynamicContent {
              incompleteCreatives {
                id
                title
              }
              section {
                id
                title
              }
            }
          }
        }
        ... on BothPreviewPreheader {
          preheaderWithPreview {
            ... on StaticPreheaderWithPreview {
              preview
              preheader
              link {
                id
                url
                shortUuid
                linkGroup {
                  id
                  name
                  linksCount
                }
              }
            }
            ... on DynamicContent {
              incompleteCreatives {
                id
                title
              }
              section {
                id
                title
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type RemoveCampaignPreheaderLinkMutationFn = Apollo.MutationFunction<RemoveCampaignPreheaderLinkMutation, RemoveCampaignPreheaderLinkMutationVariables>;

/**
 * __useRemoveCampaignPreheaderLinkMutation__
 *
 * To run a mutation, you first call `useRemoveCampaignPreheaderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCampaignPreheaderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCampaignPreheaderLinkMutation, { data, loading, error }] = useRemoveCampaignPreheaderLinkMutation({
 *   variables: {
 *      config: // value for 'config'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCampaignPreheaderLinkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCampaignPreheaderLinkMutation, RemoveCampaignPreheaderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCampaignPreheaderLinkMutation, RemoveCampaignPreheaderLinkMutationVariables>(RemoveCampaignPreheaderLinkDocument, options);
      }
export type RemoveCampaignPreheaderLinkMutationHookResult = ReturnType<typeof useRemoveCampaignPreheaderLinkMutation>;
export type RemoveCampaignPreheaderLinkMutationResult = Apollo.MutationResult<RemoveCampaignPreheaderLinkMutation>;
export type RemoveCampaignPreheaderLinkMutationOptions = Apollo.BaseMutationOptions<RemoveCampaignPreheaderLinkMutation, RemoveCampaignPreheaderLinkMutationVariables>;
export const CampaignStaticPreheaderAndPreviewLinkUpdateDocument = gql`
    mutation CampaignStaticPreheaderAndPreviewLinkUpdate($id: ID!, $linkGroupId: ID!) {
  campaignStaticPreheaderAndPreviewLinkUpdate(id: $id, linkGroupId: $linkGroupId) {
    success
    campaign {
      id
      status
      preheaderAndPreview {
        ... on OnlyPreview {
          preview {
            ... on StaticMessage {
              message
            }
            ... on DynamicContent {
              section {
                id
                title
              }
            }
          }
        }
        ... on OnlyPreheader {
          preheader {
            ... on StaticMessageWithLink {
              message
              link {
                id
                url
                shortUuid
                linkGroup {
                  id
                  name
                  linksCount
                }
              }
            }
            ... on DynamicContent {
              section {
                id
                title
              }
            }
          }
        }
        ... on BothPreviewPreheader {
          preheaderWithPreview {
            ... on StaticPreheaderWithPreview {
              preview
              preheader
              link {
                id
                url
                shortUuid
                linkGroup {
                  id
                  name
                  linksCount
                }
              }
            }
            ... on DynamicContent {
              section {
                id
                title
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CampaignStaticPreheaderAndPreviewLinkUpdateMutationFn = Apollo.MutationFunction<CampaignStaticPreheaderAndPreviewLinkUpdateMutation, CampaignStaticPreheaderAndPreviewLinkUpdateMutationVariables>;

/**
 * __useCampaignStaticPreheaderAndPreviewLinkUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignStaticPreheaderAndPreviewLinkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignStaticPreheaderAndPreviewLinkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignStaticPreheaderAndPreviewLinkUpdateMutation, { data, loading, error }] = useCampaignStaticPreheaderAndPreviewLinkUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      linkGroupId: // value for 'linkGroupId'
 *   },
 * });
 */
export function useCampaignStaticPreheaderAndPreviewLinkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignStaticPreheaderAndPreviewLinkUpdateMutation, CampaignStaticPreheaderAndPreviewLinkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignStaticPreheaderAndPreviewLinkUpdateMutation, CampaignStaticPreheaderAndPreviewLinkUpdateMutationVariables>(CampaignStaticPreheaderAndPreviewLinkUpdateDocument, options);
      }
export type CampaignStaticPreheaderAndPreviewLinkUpdateMutationHookResult = ReturnType<typeof useCampaignStaticPreheaderAndPreviewLinkUpdateMutation>;
export type CampaignStaticPreheaderAndPreviewLinkUpdateMutationResult = Apollo.MutationResult<CampaignStaticPreheaderAndPreviewLinkUpdateMutation>;
export type CampaignStaticPreheaderAndPreviewLinkUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignStaticPreheaderAndPreviewLinkUpdateMutation, CampaignStaticPreheaderAndPreviewLinkUpdateMutationVariables>;
export const CampaignAddInboxExperimentGroupDocument = gql`
    mutation CampaignAddInboxExperimentGroup($id: ID!, $experimentGroupId: ID!) {
  campaignAddExperimentGroup(id: $id, experimentGroupId: $experimentGroupId) {
    success
    campaign {
      id
      title
      experiments {
        id
        title
        experimentType
      }
      subjectline {
        ... on DynamicSubjectLine {
          strategies {
            strategy
            treatment {
              id
              title
              control
              order
            }
          }
        }
      }
    }
  }
}
    `;
export type CampaignAddInboxExperimentGroupMutationFn = Apollo.MutationFunction<CampaignAddInboxExperimentGroupMutation, CampaignAddInboxExperimentGroupMutationVariables>;

/**
 * __useCampaignAddInboxExperimentGroupMutation__
 *
 * To run a mutation, you first call `useCampaignAddInboxExperimentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAddInboxExperimentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAddInboxExperimentGroupMutation, { data, loading, error }] = useCampaignAddInboxExperimentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experimentGroupId: // value for 'experimentGroupId'
 *   },
 * });
 */
export function useCampaignAddInboxExperimentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAddInboxExperimentGroupMutation, CampaignAddInboxExperimentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAddInboxExperimentGroupMutation, CampaignAddInboxExperimentGroupMutationVariables>(CampaignAddInboxExperimentGroupDocument, options);
      }
export type CampaignAddInboxExperimentGroupMutationHookResult = ReturnType<typeof useCampaignAddInboxExperimentGroupMutation>;
export type CampaignAddInboxExperimentGroupMutationResult = Apollo.MutationResult<CampaignAddInboxExperimentGroupMutation>;
export type CampaignAddInboxExperimentGroupMutationOptions = Apollo.BaseMutationOptions<CampaignAddInboxExperimentGroupMutation, CampaignAddInboxExperimentGroupMutationVariables>;
export const CampaignInboxExperimentDeleteDocument = gql`
    mutation CampaignInboxExperimentDelete($experimentId: ID!, $campaignId: ID!) {
  campaignExperimentDelete(experimentId: $experimentId, id: $campaignId) {
    success
    campaign {
      id
      title
      experiments {
        id
        title
        experimentType
      }
      subjectline {
        ... on DynamicSubjectLine {
          strategies {
            strategy
            treatment {
              id
              title
              control
              order
            }
          }
        }
      }
    }
  }
}
    `;
export type CampaignInboxExperimentDeleteMutationFn = Apollo.MutationFunction<CampaignInboxExperimentDeleteMutation, CampaignInboxExperimentDeleteMutationVariables>;

/**
 * __useCampaignInboxExperimentDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignInboxExperimentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignInboxExperimentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignInboxExperimentDeleteMutation, { data, loading, error }] = useCampaignInboxExperimentDeleteMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignInboxExperimentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignInboxExperimentDeleteMutation, CampaignInboxExperimentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignInboxExperimentDeleteMutation, CampaignInboxExperimentDeleteMutationVariables>(CampaignInboxExperimentDeleteDocument, options);
      }
export type CampaignInboxExperimentDeleteMutationHookResult = ReturnType<typeof useCampaignInboxExperimentDeleteMutation>;
export type CampaignInboxExperimentDeleteMutationResult = Apollo.MutationResult<CampaignInboxExperimentDeleteMutation>;
export type CampaignInboxExperimentDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignInboxExperimentDeleteMutation, CampaignInboxExperimentDeleteMutationVariables>;
export const SubjectLineStrategyUpdateDocument = gql`
    mutation SubjectLineStrategyUpdate($campaignId: ID!, $treatmentId: ID!, $strategy: SubjectLineStrategy!) {
  campaignSubjectLineStrategyUpdate(
    id: $campaignId
    treatmentId: $treatmentId
    strategy: $strategy
  ) {
    success
    campaign {
      id
      title
      subjectline {
        ... on DynamicSubjectLine {
          ...inboxSubjectLineDynamicFields
        }
      }
      experiments(experimentTypes: [SUBJECT_LINE_STRATEGY]) {
        id
        title
        treatments {
          id
          title
          order
          control
        }
      }
    }
  }
}
    ${InboxSubjectLineDynamicFieldsFragmentDoc}`;
export type SubjectLineStrategyUpdateMutationFn = Apollo.MutationFunction<SubjectLineStrategyUpdateMutation, SubjectLineStrategyUpdateMutationVariables>;

/**
 * __useSubjectLineStrategyUpdateMutation__
 *
 * To run a mutation, you first call `useSubjectLineStrategyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubjectLineStrategyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subjectLineStrategyUpdateMutation, { data, loading, error }] = useSubjectLineStrategyUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      treatmentId: // value for 'treatmentId'
 *      strategy: // value for 'strategy'
 *   },
 * });
 */
export function useSubjectLineStrategyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SubjectLineStrategyUpdateMutation, SubjectLineStrategyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubjectLineStrategyUpdateMutation, SubjectLineStrategyUpdateMutationVariables>(SubjectLineStrategyUpdateDocument, options);
      }
export type SubjectLineStrategyUpdateMutationHookResult = ReturnType<typeof useSubjectLineStrategyUpdateMutation>;
export type SubjectLineStrategyUpdateMutationResult = Apollo.MutationResult<SubjectLineStrategyUpdateMutation>;
export type SubjectLineStrategyUpdateMutationOptions = Apollo.BaseMutationOptions<SubjectLineStrategyUpdateMutation, SubjectLineStrategyUpdateMutationVariables>;
export const SuffixDocument = gql`
    query Suffix($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    suffix {
      __typename
      ... on StaticMessage {
        message
      }
      ... on DynamicContent {
        section {
          id
          position
          contentBlock {
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSuffixQuery__
 *
 * To run a query within a React component, call `useSuffixQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuffixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuffixQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSuffixQuery(baseOptions: Apollo.QueryHookOptions<SuffixQuery, SuffixQueryVariables> & ({ variables: SuffixQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuffixQuery, SuffixQueryVariables>(SuffixDocument, options);
      }
export function useSuffixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuffixQuery, SuffixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuffixQuery, SuffixQueryVariables>(SuffixDocument, options);
        }
export function useSuffixSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuffixQuery, SuffixQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuffixQuery, SuffixQueryVariables>(SuffixDocument, options);
        }
export type SuffixQueryHookResult = ReturnType<typeof useSuffixQuery>;
export type SuffixLazyQueryHookResult = ReturnType<typeof useSuffixLazyQuery>;
export type SuffixSuspenseQueryHookResult = ReturnType<typeof useSuffixSuspenseQuery>;
export type SuffixQueryResult = Apollo.QueryResult<SuffixQuery, SuffixQueryVariables>;
export const CampaignSubjectLineSuffixModeUpdateDocument = gql`
    mutation campaignSubjectLineSuffixModeUpdate($campaignId: ID!, $mode: SubjectLineChunkMode!) {
  campaignSubjectLineSuffixModeUpdate(id: $campaignId, mode: $mode) {
    campaign {
      id
      suffix {
        __typename
      }
    }
  }
}
    `;
export type CampaignSubjectLineSuffixModeUpdateMutationFn = Apollo.MutationFunction<CampaignSubjectLineSuffixModeUpdateMutation, CampaignSubjectLineSuffixModeUpdateMutationVariables>;

/**
 * __useCampaignSubjectLineSuffixModeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSubjectLineSuffixModeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSubjectLineSuffixModeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSubjectLineSuffixModeUpdateMutation, { data, loading, error }] = useCampaignSubjectLineSuffixModeUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCampaignSubjectLineSuffixModeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSubjectLineSuffixModeUpdateMutation, CampaignSubjectLineSuffixModeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSubjectLineSuffixModeUpdateMutation, CampaignSubjectLineSuffixModeUpdateMutationVariables>(CampaignSubjectLineSuffixModeUpdateDocument, options);
      }
export type CampaignSubjectLineSuffixModeUpdateMutationHookResult = ReturnType<typeof useCampaignSubjectLineSuffixModeUpdateMutation>;
export type CampaignSubjectLineSuffixModeUpdateMutationResult = Apollo.MutationResult<CampaignSubjectLineSuffixModeUpdateMutation>;
export type CampaignSubjectLineSuffixModeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSubjectLineSuffixModeUpdateMutation, CampaignSubjectLineSuffixModeUpdateMutationVariables>;
export const CampaignStaticSubjectLineSuffixUpdateDocument = gql`
    mutation campaignStaticSubjectLineSuffixUpdate($campaignId: ID!, $message: String!) {
  campaignStaticSubjectLineSuffixUpdate(id: $campaignId, message: $message) {
    campaign {
      id
      suffix {
        ... on StaticMessage {
          message
        }
      }
    }
  }
}
    `;
export type CampaignStaticSubjectLineSuffixUpdateMutationFn = Apollo.MutationFunction<CampaignStaticSubjectLineSuffixUpdateMutation, CampaignStaticSubjectLineSuffixUpdateMutationVariables>;

/**
 * __useCampaignStaticSubjectLineSuffixUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignStaticSubjectLineSuffixUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignStaticSubjectLineSuffixUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignStaticSubjectLineSuffixUpdateMutation, { data, loading, error }] = useCampaignStaticSubjectLineSuffixUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCampaignStaticSubjectLineSuffixUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignStaticSubjectLineSuffixUpdateMutation, CampaignStaticSubjectLineSuffixUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignStaticSubjectLineSuffixUpdateMutation, CampaignStaticSubjectLineSuffixUpdateMutationVariables>(CampaignStaticSubjectLineSuffixUpdateDocument, options);
      }
export type CampaignStaticSubjectLineSuffixUpdateMutationHookResult = ReturnType<typeof useCampaignStaticSubjectLineSuffixUpdateMutation>;
export type CampaignStaticSubjectLineSuffixUpdateMutationResult = Apollo.MutationResult<CampaignStaticSubjectLineSuffixUpdateMutation>;
export type CampaignStaticSubjectLineSuffixUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignStaticSubjectLineSuffixUpdateMutation, CampaignStaticSubjectLineSuffixUpdateMutationVariables>;
export const CampaignDynamicSubjectLineSuffixUpdateDocument = gql`
    mutation campaignDynamicSubjectLineSuffixUpdate($campaignId: ID!, $sectionId: ID!) {
  campaignDynamicSubjectLineSuffixUpdate(id: $campaignId, sectionId: $sectionId) {
    campaign {
      id
      suffix {
        ... on DynamicContent {
          section {
            id
            position
            contentBlock {
              title
            }
          }
        }
      }
    }
  }
}
    `;
export type CampaignDynamicSubjectLineSuffixUpdateMutationFn = Apollo.MutationFunction<CampaignDynamicSubjectLineSuffixUpdateMutation, CampaignDynamicSubjectLineSuffixUpdateMutationVariables>;

/**
 * __useCampaignDynamicSubjectLineSuffixUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignDynamicSubjectLineSuffixUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicSubjectLineSuffixUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDynamicSubjectLineSuffixUpdateMutation, { data, loading, error }] = useCampaignDynamicSubjectLineSuffixUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCampaignDynamicSubjectLineSuffixUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDynamicSubjectLineSuffixUpdateMutation, CampaignDynamicSubjectLineSuffixUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDynamicSubjectLineSuffixUpdateMutation, CampaignDynamicSubjectLineSuffixUpdateMutationVariables>(CampaignDynamicSubjectLineSuffixUpdateDocument, options);
      }
export type CampaignDynamicSubjectLineSuffixUpdateMutationHookResult = ReturnType<typeof useCampaignDynamicSubjectLineSuffixUpdateMutation>;
export type CampaignDynamicSubjectLineSuffixUpdateMutationResult = Apollo.MutationResult<CampaignDynamicSubjectLineSuffixUpdateMutation>;
export type CampaignDynamicSubjectLineSuffixUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignDynamicSubjectLineSuffixUpdateMutation, CampaignDynamicSubjectLineSuffixUpdateMutationVariables>;
export const SubjectLineDocument = gql`
    query SubjectLine($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    subjectline {
      __typename
      ... on StaticMessage {
        message
      }
      ... on DynamicSubjectLine {
        ...inboxSubjectLineDynamicFields
      }
    }
  }
}
    ${InboxSubjectLineDynamicFieldsFragmentDoc}`;

/**
 * __useSubjectLineQuery__
 *
 * To run a query within a React component, call `useSubjectLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectLineQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSubjectLineQuery(baseOptions: Apollo.QueryHookOptions<SubjectLineQuery, SubjectLineQueryVariables> & ({ variables: SubjectLineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectLineQuery, SubjectLineQueryVariables>(SubjectLineDocument, options);
      }
export function useSubjectLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectLineQuery, SubjectLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectLineQuery, SubjectLineQueryVariables>(SubjectLineDocument, options);
        }
export function useSubjectLineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubjectLineQuery, SubjectLineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubjectLineQuery, SubjectLineQueryVariables>(SubjectLineDocument, options);
        }
export type SubjectLineQueryHookResult = ReturnType<typeof useSubjectLineQuery>;
export type SubjectLineLazyQueryHookResult = ReturnType<typeof useSubjectLineLazyQuery>;
export type SubjectLineSuspenseQueryHookResult = ReturnType<typeof useSubjectLineSuspenseQuery>;
export type SubjectLineQueryResult = Apollo.QueryResult<SubjectLineQuery, SubjectLineQueryVariables>;
export const CampaignSubjectLineModeUpdateDocument = gql`
    mutation campaignSubjectLineModeUpdate($campaignId: ID!, $mode: SubjectLineChunkMode!) {
  campaignSubjectLineModeUpdate(id: $campaignId, mode: $mode) {
    success
    campaign {
      id
      subjectline {
        __typename
      }
    }
  }
}
    `;
export type CampaignSubjectLineModeUpdateMutationFn = Apollo.MutationFunction<CampaignSubjectLineModeUpdateMutation, CampaignSubjectLineModeUpdateMutationVariables>;

/**
 * __useCampaignSubjectLineModeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSubjectLineModeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSubjectLineModeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSubjectLineModeUpdateMutation, { data, loading, error }] = useCampaignSubjectLineModeUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCampaignSubjectLineModeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSubjectLineModeUpdateMutation, CampaignSubjectLineModeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSubjectLineModeUpdateMutation, CampaignSubjectLineModeUpdateMutationVariables>(CampaignSubjectLineModeUpdateDocument, options);
      }
export type CampaignSubjectLineModeUpdateMutationHookResult = ReturnType<typeof useCampaignSubjectLineModeUpdateMutation>;
export type CampaignSubjectLineModeUpdateMutationResult = Apollo.MutationResult<CampaignSubjectLineModeUpdateMutation>;
export type CampaignSubjectLineModeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSubjectLineModeUpdateMutation, CampaignSubjectLineModeUpdateMutationVariables>;
export const CampaignStaticSubjectLineUpdateDocument = gql`
    mutation campaignStaticSubjectLineUpdate($campaignId: ID!, $message: String!) {
  campaignStaticSubjectLineUpdate(id: $campaignId, message: $message) {
    success
    campaign {
      id
      subjectline {
        ...subjectlineFields
      }
    }
  }
}
    ${SubjectlineFieldsFragmentDoc}`;
export type CampaignStaticSubjectLineUpdateMutationFn = Apollo.MutationFunction<CampaignStaticSubjectLineUpdateMutation, CampaignStaticSubjectLineUpdateMutationVariables>;

/**
 * __useCampaignStaticSubjectLineUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignStaticSubjectLineUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignStaticSubjectLineUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignStaticSubjectLineUpdateMutation, { data, loading, error }] = useCampaignStaticSubjectLineUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCampaignStaticSubjectLineUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignStaticSubjectLineUpdateMutation, CampaignStaticSubjectLineUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignStaticSubjectLineUpdateMutation, CampaignStaticSubjectLineUpdateMutationVariables>(CampaignStaticSubjectLineUpdateDocument, options);
      }
export type CampaignStaticSubjectLineUpdateMutationHookResult = ReturnType<typeof useCampaignStaticSubjectLineUpdateMutation>;
export type CampaignStaticSubjectLineUpdateMutationResult = Apollo.MutationResult<CampaignStaticSubjectLineUpdateMutation>;
export type CampaignStaticSubjectLineUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignStaticSubjectLineUpdateMutation, CampaignStaticSubjectLineUpdateMutationVariables>;
export const CampaignDynamicSubjectLineUpdateDocument = gql`
    mutation campaignDynamicSubjectLineUpdate($campaignId: ID!, $sectionIds: [ID!]!) {
  campaignDynamicSubjectLineUpdate(id: $campaignId, sectionIds: $sectionIds) {
    campaign {
      id
      subjectline {
        ...inboxSubjectLineDynamicFields
      }
    }
  }
}
    ${InboxSubjectLineDynamicFieldsFragmentDoc}`;
export type CampaignDynamicSubjectLineUpdateMutationFn = Apollo.MutationFunction<CampaignDynamicSubjectLineUpdateMutation, CampaignDynamicSubjectLineUpdateMutationVariables>;

/**
 * __useCampaignDynamicSubjectLineUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignDynamicSubjectLineUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicSubjectLineUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDynamicSubjectLineUpdateMutation, { data, loading, error }] = useCampaignDynamicSubjectLineUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sectionIds: // value for 'sectionIds'
 *   },
 * });
 */
export function useCampaignDynamicSubjectLineUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDynamicSubjectLineUpdateMutation, CampaignDynamicSubjectLineUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDynamicSubjectLineUpdateMutation, CampaignDynamicSubjectLineUpdateMutationVariables>(CampaignDynamicSubjectLineUpdateDocument, options);
      }
export type CampaignDynamicSubjectLineUpdateMutationHookResult = ReturnType<typeof useCampaignDynamicSubjectLineUpdateMutation>;
export type CampaignDynamicSubjectLineUpdateMutationResult = Apollo.MutationResult<CampaignDynamicSubjectLineUpdateMutation>;
export type CampaignDynamicSubjectLineUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignDynamicSubjectLineUpdateMutation, CampaignDynamicSubjectLineUpdateMutationVariables>;
export const AllInboxStepsDocument = gql`
    query AllInboxSteps($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    status
    title
    featureFlagExperiences2
    campaignTemplate {
      sections(contentBlockType: DYNAMIC) {
        ...dynamicContentBlockOptionsFields
      }
    }
    subjectline {
      ...inboxStaticFields
      ...inboxSubjectLineDynamicFields
      ...inboxSubjectLinePersadoFields
    }
    suffix {
      __typename
      ...inboxStaticFields
      ...inboxDynamicFields
    }
    prefix {
      __typename
      ...inboxStaticFields
      ...inboxDynamicFields
    }
    preheaderAndPreview {
      ...inboxOnlyPreheaderFields
      ...inboxOnlyPreviewFields
      ...inboxBothPreviewPreheaderFields
    }
  }
}
    ${DynamicContentBlockOptionsFieldsFragmentDoc}
${InboxStaticFieldsFragmentDoc}
${InboxSubjectLineDynamicFieldsFragmentDoc}
${InboxSubjectLinePersadoFieldsFragmentDoc}
${InboxDynamicFieldsFragmentDoc}
${InboxOnlyPreheaderFieldsFragmentDoc}
${InboxOnlyPreviewFieldsFragmentDoc}
${InboxBothPreviewPreheaderFieldsFragmentDoc}`;

/**
 * __useAllInboxStepsQuery__
 *
 * To run a query within a React component, call `useAllInboxStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInboxStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInboxStepsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAllInboxStepsQuery(baseOptions: Apollo.QueryHookOptions<AllInboxStepsQuery, AllInboxStepsQueryVariables> & ({ variables: AllInboxStepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllInboxStepsQuery, AllInboxStepsQueryVariables>(AllInboxStepsDocument, options);
      }
export function useAllInboxStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllInboxStepsQuery, AllInboxStepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllInboxStepsQuery, AllInboxStepsQueryVariables>(AllInboxStepsDocument, options);
        }
export function useAllInboxStepsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllInboxStepsQuery, AllInboxStepsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllInboxStepsQuery, AllInboxStepsQueryVariables>(AllInboxStepsDocument, options);
        }
export type AllInboxStepsQueryHookResult = ReturnType<typeof useAllInboxStepsQuery>;
export type AllInboxStepsLazyQueryHookResult = ReturnType<typeof useAllInboxStepsLazyQuery>;
export type AllInboxStepsSuspenseQueryHookResult = ReturnType<typeof useAllInboxStepsSuspenseQuery>;
export type AllInboxStepsQueryResult = Apollo.QueryResult<AllInboxStepsQuery, AllInboxStepsQueryVariables>;
export const CampaignContactIncludedAudiencesDocument = gql`
    query CampaignContactIncludedAudiences($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    includedContactAudiences {
      id
      name
      splitConfigs {
        id
        selected
        name
        split {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignContactIncludedAudiencesQuery__
 *
 * To run a query within a React component, call `useCampaignContactIncludedAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignContactIncludedAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignContactIncludedAudiencesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignContactIncludedAudiencesQuery(baseOptions: Apollo.QueryHookOptions<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables> & ({ variables: CampaignContactIncludedAudiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables>(CampaignContactIncludedAudiencesDocument, options);
      }
export function useCampaignContactIncludedAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables>(CampaignContactIncludedAudiencesDocument, options);
        }
export function useCampaignContactIncludedAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables>(CampaignContactIncludedAudiencesDocument, options);
        }
export type CampaignContactIncludedAudiencesQueryHookResult = ReturnType<typeof useCampaignContactIncludedAudiencesQuery>;
export type CampaignContactIncludedAudiencesLazyQueryHookResult = ReturnType<typeof useCampaignContactIncludedAudiencesLazyQuery>;
export type CampaignContactIncludedAudiencesSuspenseQueryHookResult = ReturnType<typeof useCampaignContactIncludedAudiencesSuspenseQuery>;
export type CampaignContactIncludedAudiencesQueryResult = Apollo.QueryResult<CampaignContactIncludedAudiencesQuery, CampaignContactIncludedAudiencesQueryVariables>;
export const CampaignIncludedCreativeTagsSearchDocument = gql`
    query CampaignIncludedCreativeTagsSearch($campaignId: ID!, $search: String) {
  campaignIncludedCreativeTags(campaignId: $campaignId, search: $search) {
    id
    name
  }
}
    `;

/**
 * __useCampaignIncludedCreativeTagsSearchQuery__
 *
 * To run a query within a React component, call `useCampaignIncludedCreativeTagsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignIncludedCreativeTagsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignIncludedCreativeTagsSearchQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCampaignIncludedCreativeTagsSearchQuery(baseOptions: Apollo.QueryHookOptions<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables> & ({ variables: CampaignIncludedCreativeTagsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables>(CampaignIncludedCreativeTagsSearchDocument, options);
      }
export function useCampaignIncludedCreativeTagsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables>(CampaignIncludedCreativeTagsSearchDocument, options);
        }
export function useCampaignIncludedCreativeTagsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables>(CampaignIncludedCreativeTagsSearchDocument, options);
        }
export type CampaignIncludedCreativeTagsSearchQueryHookResult = ReturnType<typeof useCampaignIncludedCreativeTagsSearchQuery>;
export type CampaignIncludedCreativeTagsSearchLazyQueryHookResult = ReturnType<typeof useCampaignIncludedCreativeTagsSearchLazyQuery>;
export type CampaignIncludedCreativeTagsSearchSuspenseQueryHookResult = ReturnType<typeof useCampaignIncludedCreativeTagsSearchSuspenseQuery>;
export type CampaignIncludedCreativeTagsSearchQueryResult = Apollo.QueryResult<CampaignIncludedCreativeTagsSearchQuery, CampaignIncludedCreativeTagsSearchQueryVariables>;
export const CampaignIncludedCreativesDocument = gql`
    query CampaignIncludedCreatives($campaignId: ID!, $search: String) {
  campaignIncludedCreatives(campaignId: $campaignId, search: $search) {
    title
    id
  }
}
    `;

/**
 * __useCampaignIncludedCreativesQuery__
 *
 * To run a query within a React component, call `useCampaignIncludedCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignIncludedCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignIncludedCreativesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCampaignIncludedCreativesQuery(baseOptions: Apollo.QueryHookOptions<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables> & ({ variables: CampaignIncludedCreativesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables>(CampaignIncludedCreativesDocument, options);
      }
export function useCampaignIncludedCreativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables>(CampaignIncludedCreativesDocument, options);
        }
export function useCampaignIncludedCreativesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables>(CampaignIncludedCreativesDocument, options);
        }
export type CampaignIncludedCreativesQueryHookResult = ReturnType<typeof useCampaignIncludedCreativesQuery>;
export type CampaignIncludedCreativesLazyQueryHookResult = ReturnType<typeof useCampaignIncludedCreativesLazyQuery>;
export type CampaignIncludedCreativesSuspenseQueryHookResult = ReturnType<typeof useCampaignIncludedCreativesSuspenseQuery>;
export type CampaignIncludedCreativesQueryResult = Apollo.QueryResult<CampaignIncludedCreativesQuery, CampaignIncludedCreativesQueryVariables>;
export const EmailVersionSendContactsDocument = gql`
    query EmailVersionSendContacts($campaignId: ID!) {
  emailVersionSendContacts(campaignId: $campaignId) {
    id
    emailAddress
    contactType
    contact {
      id
      firstName
      lastName
    }
    contactGroup {
      id
      title
      contacts {
        id
        emailAddress
        firstName
        lastName
      }
      contactCount
      sends
    }
    channel
    channelId
  }
}
    `;

/**
 * __useEmailVersionSendContactsQuery__
 *
 * To run a query within a React component, call `useEmailVersionSendContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailVersionSendContactsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useEmailVersionSendContactsQuery(baseOptions: Apollo.QueryHookOptions<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables> & ({ variables: EmailVersionSendContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables>(EmailVersionSendContactsDocument, options);
      }
export function useEmailVersionSendContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables>(EmailVersionSendContactsDocument, options);
        }
export function useEmailVersionSendContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables>(EmailVersionSendContactsDocument, options);
        }
export type EmailVersionSendContactsQueryHookResult = ReturnType<typeof useEmailVersionSendContactsQuery>;
export type EmailVersionSendContactsLazyQueryHookResult = ReturnType<typeof useEmailVersionSendContactsLazyQuery>;
export type EmailVersionSendContactsSuspenseQueryHookResult = ReturnType<typeof useEmailVersionSendContactsSuspenseQuery>;
export type EmailVersionSendContactsQueryResult = Apollo.QueryResult<EmailVersionSendContactsQuery, EmailVersionSendContactsQueryVariables>;
export const EmailVersionSendContactCreateDocument = gql`
    mutation EmailVersionSendContactCreate($campaignId: ID!, $emailAddress: String, $contactType: EmailVersionSendContactType!, $contactId: ID, $contactGroupId: ID, $channel: Channel, $channelId: String) {
  emailVersionSendContactCreate(
    campaignId: $campaignId
    emailAddress: $emailAddress
    contactType: $contactType
    contactId: $contactId
    contactGroupId: $contactGroupId
    channel: $channel
    channelId: $channelId
  ) {
    emailVersionSendContact {
      id
      emailAddress
      channel
      channelId
      contactType
      contact {
        id
        firstName
        lastName
        emailAddress
        sends
      }
      contactGroup {
        id
        title
        contacts {
          id
          emailAddress
          firstName
          lastName
        }
        contactCount
        sends
      }
    }
  }
}
    `;
export type EmailVersionSendContactCreateMutationFn = Apollo.MutationFunction<EmailVersionSendContactCreateMutation, EmailVersionSendContactCreateMutationVariables>;

/**
 * __useEmailVersionSendContactCreateMutation__
 *
 * To run a mutation, you first call `useEmailVersionSendContactCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendContactCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVersionSendContactCreateMutation, { data, loading, error }] = useEmailVersionSendContactCreateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      emailAddress: // value for 'emailAddress'
 *      contactType: // value for 'contactType'
 *      contactId: // value for 'contactId'
 *      contactGroupId: // value for 'contactGroupId'
 *      channel: // value for 'channel'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useEmailVersionSendContactCreateMutation(baseOptions?: Apollo.MutationHookOptions<EmailVersionSendContactCreateMutation, EmailVersionSendContactCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailVersionSendContactCreateMutation, EmailVersionSendContactCreateMutationVariables>(EmailVersionSendContactCreateDocument, options);
      }
export type EmailVersionSendContactCreateMutationHookResult = ReturnType<typeof useEmailVersionSendContactCreateMutation>;
export type EmailVersionSendContactCreateMutationResult = Apollo.MutationResult<EmailVersionSendContactCreateMutation>;
export type EmailVersionSendContactCreateMutationOptions = Apollo.BaseMutationOptions<EmailVersionSendContactCreateMutation, EmailVersionSendContactCreateMutationVariables>;
export const EmailVersionSendContactDeleteDocument = gql`
    mutation EmailVersionSendContactDelete($campaignId: ID!, $emailVersionSendContactId: ID!) {
  emailVersionSendContactDelete(
    campaignId: $campaignId
    emailVersionSendContactId: $emailVersionSendContactId
  ) {
    campaign {
      id
      title
    }
  }
}
    `;
export type EmailVersionSendContactDeleteMutationFn = Apollo.MutationFunction<EmailVersionSendContactDeleteMutation, EmailVersionSendContactDeleteMutationVariables>;

/**
 * __useEmailVersionSendContactDeleteMutation__
 *
 * To run a mutation, you first call `useEmailVersionSendContactDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendContactDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVersionSendContactDeleteMutation, { data, loading, error }] = useEmailVersionSendContactDeleteMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      emailVersionSendContactId: // value for 'emailVersionSendContactId'
 *   },
 * });
 */
export function useEmailVersionSendContactDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EmailVersionSendContactDeleteMutation, EmailVersionSendContactDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailVersionSendContactDeleteMutation, EmailVersionSendContactDeleteMutationVariables>(EmailVersionSendContactDeleteDocument, options);
      }
export type EmailVersionSendContactDeleteMutationHookResult = ReturnType<typeof useEmailVersionSendContactDeleteMutation>;
export type EmailVersionSendContactDeleteMutationResult = Apollo.MutationResult<EmailVersionSendContactDeleteMutation>;
export type EmailVersionSendContactDeleteMutationOptions = Apollo.BaseMutationOptions<EmailVersionSendContactDeleteMutation, EmailVersionSendContactDeleteMutationVariables>;
export const EmailVersionSendAdditionalAttributesDocument = gql`
    query EmailVersionSendAdditionalAttributes($campaignId: ID!) {
  emailVersionSendAdditionalAttributes(campaignId: $campaignId) {
    enableProofLabel
    defaultProofLabel
  }
}
    `;

/**
 * __useEmailVersionSendAdditionalAttributesQuery__
 *
 * To run a query within a React component, call `useEmailVersionSendAdditionalAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendAdditionalAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailVersionSendAdditionalAttributesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useEmailVersionSendAdditionalAttributesQuery(baseOptions: Apollo.QueryHookOptions<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables> & ({ variables: EmailVersionSendAdditionalAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables>(EmailVersionSendAdditionalAttributesDocument, options);
      }
export function useEmailVersionSendAdditionalAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables>(EmailVersionSendAdditionalAttributesDocument, options);
        }
export function useEmailVersionSendAdditionalAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables>(EmailVersionSendAdditionalAttributesDocument, options);
        }
export type EmailVersionSendAdditionalAttributesQueryHookResult = ReturnType<typeof useEmailVersionSendAdditionalAttributesQuery>;
export type EmailVersionSendAdditionalAttributesLazyQueryHookResult = ReturnType<typeof useEmailVersionSendAdditionalAttributesLazyQuery>;
export type EmailVersionSendAdditionalAttributesSuspenseQueryHookResult = ReturnType<typeof useEmailVersionSendAdditionalAttributesSuspenseQuery>;
export type EmailVersionSendAdditionalAttributesQueryResult = Apollo.QueryResult<EmailVersionSendAdditionalAttributesQuery, EmailVersionSendAdditionalAttributesQueryVariables>;
export const EmailVersionSendDeliverDocument = gql`
    mutation EmailVersionSendDeliver($campaignId: ID!, $sendFormat: EmailVersionSendFormatType!, $proofLabel: String!) {
  emailVersionSendDeliver(
    campaignId: $campaignId
    sendFormat: $sendFormat
    proofLabel: $proofLabel
  ) {
    success
  }
}
    `;
export type EmailVersionSendDeliverMutationFn = Apollo.MutationFunction<EmailVersionSendDeliverMutation, EmailVersionSendDeliverMutationVariables>;

/**
 * __useEmailVersionSendDeliverMutation__
 *
 * To run a mutation, you first call `useEmailVersionSendDeliverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendDeliverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVersionSendDeliverMutation, { data, loading, error }] = useEmailVersionSendDeliverMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sendFormat: // value for 'sendFormat'
 *      proofLabel: // value for 'proofLabel'
 *   },
 * });
 */
export function useEmailVersionSendDeliverMutation(baseOptions?: Apollo.MutationHookOptions<EmailVersionSendDeliverMutation, EmailVersionSendDeliverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailVersionSendDeliverMutation, EmailVersionSendDeliverMutationVariables>(EmailVersionSendDeliverDocument, options);
      }
export type EmailVersionSendDeliverMutationHookResult = ReturnType<typeof useEmailVersionSendDeliverMutation>;
export type EmailVersionSendDeliverMutationResult = Apollo.MutationResult<EmailVersionSendDeliverMutation>;
export type EmailVersionSendDeliverMutationOptions = Apollo.BaseMutationOptions<EmailVersionSendDeliverMutation, EmailVersionSendDeliverMutationVariables>;
export const CampaignProofTabDocument = gql`
    query CampaignProofTab($campaignId: ID!) {
  campaignPreview(campaignId: $campaignId) {
    finalsStatus
    proofsStatus
    proofVariantCount
  }
  campaign(id: $campaignId) {
    id
    stage
    emailServiceProvider {
      __typename
    }
    hasContactAudiences
    includedContactAudiences {
      id
      name
      splitConfigs {
        id
        selected
        name
        split {
          id
        }
      }
    }
    experiments(
      experimentTypes: [ADHOC, CONTENT_PERSONALIZATION_MODEL, ELIGIBLE_CREATIVES, PROXY_CONTROL, SEND_DATETIME, SEND_TIME_PERSONALIZATION_MODEL, SUBJECT_LINE_PERSONALIZATION_MODEL, SUBJECT_LINE_STRATEGY, TEMPLATE]
    ) {
      id
      title
      treatments {
        id
        title
        control
      }
    }
  }
  emailVersionSendAdditionalAttributes(campaignId: $campaignId) {
    enableProofLabel
    defaultProofLabel
  }
}
    `;

/**
 * __useCampaignProofTabQuery__
 *
 * To run a query within a React component, call `useCampaignProofTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignProofTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignProofTabQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignProofTabQuery(baseOptions: Apollo.QueryHookOptions<CampaignProofTabQuery, CampaignProofTabQueryVariables> & ({ variables: CampaignProofTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignProofTabQuery, CampaignProofTabQueryVariables>(CampaignProofTabDocument, options);
      }
export function useCampaignProofTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignProofTabQuery, CampaignProofTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignProofTabQuery, CampaignProofTabQueryVariables>(CampaignProofTabDocument, options);
        }
export function useCampaignProofTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignProofTabQuery, CampaignProofTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignProofTabQuery, CampaignProofTabQueryVariables>(CampaignProofTabDocument, options);
        }
export type CampaignProofTabQueryHookResult = ReturnType<typeof useCampaignProofTabQuery>;
export type CampaignProofTabLazyQueryHookResult = ReturnType<typeof useCampaignProofTabLazyQuery>;
export type CampaignProofTabSuspenseQueryHookResult = ReturnType<typeof useCampaignProofTabSuspenseQuery>;
export type CampaignProofTabQueryResult = Apollo.QueryResult<CampaignProofTabQuery, CampaignProofTabQueryVariables>;
export const CampaignProofVariantListDocument = gql`
    query CampaignProofVariantList($campaignId: ID!, $proofVariantFilter: ProofVariantFilterInput!, $limit: Int, $offset: Int) {
  campaignProofVariantList(
    campaignId: $campaignId
    proofVariantFilter: $proofVariantFilter
    limit: $limit
    offset: $offset
  ) {
    results {
      runId
      id
      subjectline
      subjectlinePrefix
      subjectlineSuffix
      previewText
      preheaderText
      recipients
      previewText
      preheaderText
      type
      desktopImageUrl
      contentBlocks {
        position
        title
        creativeTitle
      }
    }
    meta {
      totalResults
      variants
      recipients
      totalVariants
      totalRecipients
    }
  }
}
    `;

/**
 * __useCampaignProofVariantListQuery__
 *
 * To run a query within a React component, call `useCampaignProofVariantListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignProofVariantListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignProofVariantListQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      proofVariantFilter: // value for 'proofVariantFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCampaignProofVariantListQuery(baseOptions: Apollo.QueryHookOptions<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables> & ({ variables: CampaignProofVariantListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables>(CampaignProofVariantListDocument, options);
      }
export function useCampaignProofVariantListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables>(CampaignProofVariantListDocument, options);
        }
export function useCampaignProofVariantListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables>(CampaignProofVariantListDocument, options);
        }
export type CampaignProofVariantListQueryHookResult = ReturnType<typeof useCampaignProofVariantListQuery>;
export type CampaignProofVariantListLazyQueryHookResult = ReturnType<typeof useCampaignProofVariantListLazyQuery>;
export type CampaignProofVariantListSuspenseQueryHookResult = ReturnType<typeof useCampaignProofVariantListSuspenseQuery>;
export type CampaignProofVariantListQueryResult = Apollo.QueryResult<CampaignProofVariantListQuery, CampaignProofVariantListQueryVariables>;
export const EmailVersionSendsDocument = gql`
    query EmailVersionSends($campaignId: ID!) {
  emailVersionSends(campaignId: $campaignId) {
    id
    emailId
  }
}
    `;

/**
 * __useEmailVersionSendsQuery__
 *
 * To run a query within a React component, call `useEmailVersionSendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailVersionSendsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useEmailVersionSendsQuery(baseOptions: Apollo.QueryHookOptions<EmailVersionSendsQuery, EmailVersionSendsQueryVariables> & ({ variables: EmailVersionSendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailVersionSendsQuery, EmailVersionSendsQueryVariables>(EmailVersionSendsDocument, options);
      }
export function useEmailVersionSendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailVersionSendsQuery, EmailVersionSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailVersionSendsQuery, EmailVersionSendsQueryVariables>(EmailVersionSendsDocument, options);
        }
export function useEmailVersionSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailVersionSendsQuery, EmailVersionSendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailVersionSendsQuery, EmailVersionSendsQueryVariables>(EmailVersionSendsDocument, options);
        }
export type EmailVersionSendsQueryHookResult = ReturnType<typeof useEmailVersionSendsQuery>;
export type EmailVersionSendsLazyQueryHookResult = ReturnType<typeof useEmailVersionSendsLazyQuery>;
export type EmailVersionSendsSuspenseQueryHookResult = ReturnType<typeof useEmailVersionSendsSuspenseQuery>;
export type EmailVersionSendsQueryResult = Apollo.QueryResult<EmailVersionSendsQuery, EmailVersionSendsQueryVariables>;
export const EmailVersionSendCreateDocument = gql`
    mutation EmailVersionSendCreate($campaignId: ID!, $emailId: String!, $runId: Int, $audienceIds: [ID!], $audienceSplitIds: [[ID]], $creativeIds: [ID!], $creativeTagIds: [ID!], $emailAddresses: [String!], $preheaderTextContains: String, $previewTextContains: String, $subjectlineContains: String, $subjectlinePrefixContains: String, $subjectlineSuffixContains: String, $treatmentIds: [ID!]) {
  emailVersionSendCreate(
    campaignId: $campaignId
    emailId: $emailId
    runId: $runId
    audienceIds: $audienceIds
    audienceSplitIds: $audienceSplitIds
    creativeIds: $creativeIds
    creativeTagIds: $creativeTagIds
    emailAddresses: $emailAddresses
    preheaderTextContains: $preheaderTextContains
    previewTextContains: $previewTextContains
    subjectlineContains: $subjectlineContains
    subjectlinePrefixContains: $subjectlinePrefixContains
    subjectlineSuffixContains: $subjectlineSuffixContains
    treatmentIds: $treatmentIds
  ) {
    emailVersionSend {
      id
      emailId
    }
  }
}
    `;
export type EmailVersionSendCreateMutationFn = Apollo.MutationFunction<EmailVersionSendCreateMutation, EmailVersionSendCreateMutationVariables>;

/**
 * __useEmailVersionSendCreateMutation__
 *
 * To run a mutation, you first call `useEmailVersionSendCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVersionSendCreateMutation, { data, loading, error }] = useEmailVersionSendCreateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      emailId: // value for 'emailId'
 *      runId: // value for 'runId'
 *      audienceIds: // value for 'audienceIds'
 *      audienceSplitIds: // value for 'audienceSplitIds'
 *      creativeIds: // value for 'creativeIds'
 *      creativeTagIds: // value for 'creativeTagIds'
 *      emailAddresses: // value for 'emailAddresses'
 *      preheaderTextContains: // value for 'preheaderTextContains'
 *      previewTextContains: // value for 'previewTextContains'
 *      subjectlineContains: // value for 'subjectlineContains'
 *      subjectlinePrefixContains: // value for 'subjectlinePrefixContains'
 *      subjectlineSuffixContains: // value for 'subjectlineSuffixContains'
 *      treatmentIds: // value for 'treatmentIds'
 *   },
 * });
 */
export function useEmailVersionSendCreateMutation(baseOptions?: Apollo.MutationHookOptions<EmailVersionSendCreateMutation, EmailVersionSendCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailVersionSendCreateMutation, EmailVersionSendCreateMutationVariables>(EmailVersionSendCreateDocument, options);
      }
export type EmailVersionSendCreateMutationHookResult = ReturnType<typeof useEmailVersionSendCreateMutation>;
export type EmailVersionSendCreateMutationResult = Apollo.MutationResult<EmailVersionSendCreateMutation>;
export type EmailVersionSendCreateMutationOptions = Apollo.BaseMutationOptions<EmailVersionSendCreateMutation, EmailVersionSendCreateMutationVariables>;
export const EmailVersionSendDeleteDocument = gql`
    mutation EmailVersionSendDelete($emailVersionSendId: ID!) {
  emailVersionSendDelete(emailVersionSendId: $emailVersionSendId) {
    emailVersionSend {
      id
      emailId
    }
  }
}
    `;
export type EmailVersionSendDeleteMutationFn = Apollo.MutationFunction<EmailVersionSendDeleteMutation, EmailVersionSendDeleteMutationVariables>;

/**
 * __useEmailVersionSendDeleteMutation__
 *
 * To run a mutation, you first call `useEmailVersionSendDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVersionSendDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVersionSendDeleteMutation, { data, loading, error }] = useEmailVersionSendDeleteMutation({
 *   variables: {
 *      emailVersionSendId: // value for 'emailVersionSendId'
 *   },
 * });
 */
export function useEmailVersionSendDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EmailVersionSendDeleteMutation, EmailVersionSendDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailVersionSendDeleteMutation, EmailVersionSendDeleteMutationVariables>(EmailVersionSendDeleteDocument, options);
      }
export type EmailVersionSendDeleteMutationHookResult = ReturnType<typeof useEmailVersionSendDeleteMutation>;
export type EmailVersionSendDeleteMutationResult = Apollo.MutationResult<EmailVersionSendDeleteMutation>;
export type EmailVersionSendDeleteMutationOptions = Apollo.BaseMutationOptions<EmailVersionSendDeleteMutation, EmailVersionSendDeleteMutationVariables>;
export const CampaignProofVariants2Document = gql`
    query CampaignProofVariants2($campaignId: ID!, $proofVariantFilter: ProofVariantFilterInput2!, $limit: Int, $offset: Int) {
  campaignProofVariants2(
    campaignId: $campaignId
    proofVariantFilter: $proofVariantFilter
    limit: $limit
    offset: $offset
  ) {
    results {
      ... on SMSProofVariant {
        id
        runId
        body
        recipients
        type
      }
      ... on MMSProofVariant {
        id
        runId
        body
        mediaUrl
        recipients
        type
      }
      ... on PushProofVariant {
        id
        runId
        title
        body
        imageUrl
        recipients
        type
      }
    }
    meta {
      variants
      recipients
      totalVariants
      totalResults
      totalRecipients
    }
  }
}
    `;

/**
 * __useCampaignProofVariants2Query__
 *
 * To run a query within a React component, call `useCampaignProofVariants2Query` and pass it any options that fit your needs.
 * When your component renders, `useCampaignProofVariants2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignProofVariants2Query({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      proofVariantFilter: // value for 'proofVariantFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCampaignProofVariants2Query(baseOptions: Apollo.QueryHookOptions<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables> & ({ variables: CampaignProofVariants2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables>(CampaignProofVariants2Document, options);
      }
export function useCampaignProofVariants2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables>(CampaignProofVariants2Document, options);
        }
export function useCampaignProofVariants2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables>(CampaignProofVariants2Document, options);
        }
export type CampaignProofVariants2QueryHookResult = ReturnType<typeof useCampaignProofVariants2Query>;
export type CampaignProofVariants2LazyQueryHookResult = ReturnType<typeof useCampaignProofVariants2LazyQuery>;
export type CampaignProofVariants2SuspenseQueryHookResult = ReturnType<typeof useCampaignProofVariants2SuspenseQuery>;
export type CampaignProofVariants2QueryResult = Apollo.QueryResult<CampaignProofVariants2Query, CampaignProofVariants2QueryVariables>;
export const CampaignSendDateTimeExperimentDeleteDocument = gql`
    mutation CampaignSendDateTimeExperimentDelete($id: ID!, $experimentId: ID!) {
  campaignExperimentDelete(id: $id, experimentId: $experimentId) {
    campaign {
      title
      shortUuid
      sendDate
      ...SendScheduleFragment
      experiments {
        id
        title
        experimentType
        treatments {
          id
          title
          control
        }
        treatmentsCount
        status
        resultsRestrictedToStaff
        configurationRestrictedToStaff
      }
    }
  }
}
    ${SendScheduleFragmentFragmentDoc}`;
export type CampaignSendDateTimeExperimentDeleteMutationFn = Apollo.MutationFunction<CampaignSendDateTimeExperimentDeleteMutation, CampaignSendDateTimeExperimentDeleteMutationVariables>;

/**
 * __useCampaignSendDateTimeExperimentDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignSendDateTimeExperimentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSendDateTimeExperimentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSendDateTimeExperimentDeleteMutation, { data, loading, error }] = useCampaignSendDateTimeExperimentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useCampaignSendDateTimeExperimentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSendDateTimeExperimentDeleteMutation, CampaignSendDateTimeExperimentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSendDateTimeExperimentDeleteMutation, CampaignSendDateTimeExperimentDeleteMutationVariables>(CampaignSendDateTimeExperimentDeleteDocument, options);
      }
export type CampaignSendDateTimeExperimentDeleteMutationHookResult = ReturnType<typeof useCampaignSendDateTimeExperimentDeleteMutation>;
export type CampaignSendDateTimeExperimentDeleteMutationResult = Apollo.MutationResult<CampaignSendDateTimeExperimentDeleteMutation>;
export type CampaignSendDateTimeExperimentDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignSendDateTimeExperimentDeleteMutation, CampaignSendDateTimeExperimentDeleteMutationVariables>;
export const CampaignStaticSendScheduleUpdateDocument = gql`
    mutation CampaignStaticSendScheduleUpdate($campaignId: ID!, $datetime: DateTime, $treatmentId: ID) {
  campaignStaticSendScheduleUpdate(
    id: $campaignId
    datetime: $datetime
    treatmentId: $treatmentId
  ) {
    campaign {
      id
      sendDate
      availableSendTimes
      sendSchedule {
        schedule {
          __typename
          ... on StaticSendSchedule {
            datetime
          }
        }
      }
    }
  }
}
    `;
export type CampaignStaticSendScheduleUpdateMutationFn = Apollo.MutationFunction<CampaignStaticSendScheduleUpdateMutation, CampaignStaticSendScheduleUpdateMutationVariables>;

/**
 * __useCampaignStaticSendScheduleUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignStaticSendScheduleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignStaticSendScheduleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignStaticSendScheduleUpdateMutation, { data, loading, error }] = useCampaignStaticSendScheduleUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      datetime: // value for 'datetime'
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useCampaignStaticSendScheduleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignStaticSendScheduleUpdateMutation, CampaignStaticSendScheduleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignStaticSendScheduleUpdateMutation, CampaignStaticSendScheduleUpdateMutationVariables>(CampaignStaticSendScheduleUpdateDocument, options);
      }
export type CampaignStaticSendScheduleUpdateMutationHookResult = ReturnType<typeof useCampaignStaticSendScheduleUpdateMutation>;
export type CampaignStaticSendScheduleUpdateMutationResult = Apollo.MutationResult<CampaignStaticSendScheduleUpdateMutation>;
export type CampaignStaticSendScheduleUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignStaticSendScheduleUpdateMutation, CampaignStaticSendScheduleUpdateMutationVariables>;
export const CampaignScheduleTabDocument = gql`
    query CampaignScheduleTab($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    sendDate
    sendTimezone
    availableSendTimes
    scheduleInterval
    channel {
      category
      channel
    }
    experiments {
      id
      title
      experimentType
      treatments {
        id
      }
      configurationRestrictedToStaff
    }
    ...SendScheduleFragment
    pushSettings {
      expirationTimeSeconds
    }
  }
}
    ${SendScheduleFragmentFragmentDoc}`;

/**
 * __useCampaignScheduleTabQuery__
 *
 * To run a query within a React component, call `useCampaignScheduleTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignScheduleTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignScheduleTabQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignScheduleTabQuery(baseOptions: Apollo.QueryHookOptions<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables> & ({ variables: CampaignScheduleTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables>(CampaignScheduleTabDocument, options);
      }
export function useCampaignScheduleTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables>(CampaignScheduleTabDocument, options);
        }
export function useCampaignScheduleTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables>(CampaignScheduleTabDocument, options);
        }
export type CampaignScheduleTabQueryHookResult = ReturnType<typeof useCampaignScheduleTabQuery>;
export type CampaignScheduleTabLazyQueryHookResult = ReturnType<typeof useCampaignScheduleTabLazyQuery>;
export type CampaignScheduleTabSuspenseQueryHookResult = ReturnType<typeof useCampaignScheduleTabSuspenseQuery>;
export type CampaignScheduleTabQueryResult = Apollo.QueryResult<CampaignScheduleTabQuery, CampaignScheduleTabQueryVariables>;
export const CampaignPersonalizedSendScheduleUpdateDocument = gql`
    mutation CampaignPersonalizedSendScheduleUpdate($campaignId: ID!, $datetimeRanges: [DateTimeRange!], $treatmentId: ID) {
  campaignPersonalizedSendScheduleUpdate(
    id: $campaignId
    datetimeRanges: $datetimeRanges
    treatmentId: $treatmentId
  ) {
    campaign {
      id
      sendDate
      availableSendTimes
      ...SendScheduleFragment
    }
  }
}
    ${SendScheduleFragmentFragmentDoc}`;
export type CampaignPersonalizedSendScheduleUpdateMutationFn = Apollo.MutationFunction<CampaignPersonalizedSendScheduleUpdateMutation, CampaignPersonalizedSendScheduleUpdateMutationVariables>;

/**
 * __useCampaignPersonalizedSendScheduleUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignPersonalizedSendScheduleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignPersonalizedSendScheduleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignPersonalizedSendScheduleUpdateMutation, { data, loading, error }] = useCampaignPersonalizedSendScheduleUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      datetimeRanges: // value for 'datetimeRanges'
 *      treatmentId: // value for 'treatmentId'
 *   },
 * });
 */
export function useCampaignPersonalizedSendScheduleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignPersonalizedSendScheduleUpdateMutation, CampaignPersonalizedSendScheduleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignPersonalizedSendScheduleUpdateMutation, CampaignPersonalizedSendScheduleUpdateMutationVariables>(CampaignPersonalizedSendScheduleUpdateDocument, options);
      }
export type CampaignPersonalizedSendScheduleUpdateMutationHookResult = ReturnType<typeof useCampaignPersonalizedSendScheduleUpdateMutation>;
export type CampaignPersonalizedSendScheduleUpdateMutationResult = Apollo.MutationResult<CampaignPersonalizedSendScheduleUpdateMutation>;
export type CampaignPersonalizedSendScheduleUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignPersonalizedSendScheduleUpdateMutation, CampaignPersonalizedSendScheduleUpdateMutationVariables>;
export const CampaignAddScheduleExperimentGroupDocument = gql`
    mutation CampaignAddScheduleExperimentGroup($id: ID!, $experimentGroupId: ID!) {
  campaignAddExperimentGroup(id: $id, experimentGroupId: $experimentGroupId) {
    success
    campaign {
      id
      sendDate
      availableSendTimes
      experiments {
        id
        title
        experimentType
        treatments {
          id
          title
          control
        }
        resultsRestrictedToStaff
        configurationRestrictedToStaff
        treatmentsCount
        status
      }
      ...SendScheduleFragment
    }
  }
}
    ${SendScheduleFragmentFragmentDoc}`;
export type CampaignAddScheduleExperimentGroupMutationFn = Apollo.MutationFunction<CampaignAddScheduleExperimentGroupMutation, CampaignAddScheduleExperimentGroupMutationVariables>;

/**
 * __useCampaignAddScheduleExperimentGroupMutation__
 *
 * To run a mutation, you first call `useCampaignAddScheduleExperimentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAddScheduleExperimentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAddScheduleExperimentGroupMutation, { data, loading, error }] = useCampaignAddScheduleExperimentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experimentGroupId: // value for 'experimentGroupId'
 *   },
 * });
 */
export function useCampaignAddScheduleExperimentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAddScheduleExperimentGroupMutation, CampaignAddScheduleExperimentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAddScheduleExperimentGroupMutation, CampaignAddScheduleExperimentGroupMutationVariables>(CampaignAddScheduleExperimentGroupDocument, options);
      }
export type CampaignAddScheduleExperimentGroupMutationHookResult = ReturnType<typeof useCampaignAddScheduleExperimentGroupMutation>;
export type CampaignAddScheduleExperimentGroupMutationResult = Apollo.MutationResult<CampaignAddScheduleExperimentGroupMutation>;
export type CampaignAddScheduleExperimentGroupMutationOptions = Apollo.BaseMutationOptions<CampaignAddScheduleExperimentGroupMutation, CampaignAddScheduleExperimentGroupMutationVariables>;
export const CampaignPushSettingsUpdateDocument = gql`
    mutation CampaignPushSettingsUpdate($campaignId: ID!, $expirationTimeSeconds: Int!) {
  campaignPushSettingsUpdate(
    campaignId: $campaignId
    expirationTimeSeconds: $expirationTimeSeconds
  ) {
    success
    pushSettings {
      expirationTimeSeconds
    }
  }
}
    `;
export type CampaignPushSettingsUpdateMutationFn = Apollo.MutationFunction<CampaignPushSettingsUpdateMutation, CampaignPushSettingsUpdateMutationVariables>;

/**
 * __useCampaignPushSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignPushSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignPushSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignPushSettingsUpdateMutation, { data, loading, error }] = useCampaignPushSettingsUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      expirationTimeSeconds: // value for 'expirationTimeSeconds'
 *   },
 * });
 */
export function useCampaignPushSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignPushSettingsUpdateMutation, CampaignPushSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignPushSettingsUpdateMutation, CampaignPushSettingsUpdateMutationVariables>(CampaignPushSettingsUpdateDocument, options);
      }
export type CampaignPushSettingsUpdateMutationHookResult = ReturnType<typeof useCampaignPushSettingsUpdateMutation>;
export type CampaignPushSettingsUpdateMutationResult = Apollo.MutationResult<CampaignPushSettingsUpdateMutation>;
export type CampaignPushSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignPushSettingsUpdateMutation, CampaignPushSettingsUpdateMutationVariables>;
export const CampaignTextAttributeUpdateDocument = gql`
    mutation CampaignTextAttributeUpdate($attributeId: ID!, $id: ID!, $value: String) {
  campaignTextAttributeUpdate(attributeId: $attributeId, id: $id, value: $value) {
    campaign {
      id
      attributes {
        ...campaignAttributesFragment
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type CampaignTextAttributeUpdateMutationFn = Apollo.MutationFunction<CampaignTextAttributeUpdateMutation, CampaignTextAttributeUpdateMutationVariables>;

/**
 * __useCampaignTextAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignTextAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTextAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTextAttributeUpdateMutation, { data, loading, error }] = useCampaignTextAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCampaignTextAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTextAttributeUpdateMutation, CampaignTextAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTextAttributeUpdateMutation, CampaignTextAttributeUpdateMutationVariables>(CampaignTextAttributeUpdateDocument, options);
      }
export type CampaignTextAttributeUpdateMutationHookResult = ReturnType<typeof useCampaignTextAttributeUpdateMutation>;
export type CampaignTextAttributeUpdateMutationResult = Apollo.MutationResult<CampaignTextAttributeUpdateMutation>;
export type CampaignTextAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignTextAttributeUpdateMutation, CampaignTextAttributeUpdateMutationVariables>;
export const CampaignListAttributeUpdateDocument = gql`
    mutation CampaignListAttributeUpdate($attributeId: ID!, $id: ID!, $values: [String!]!) {
  campaignListAttributeUpdate(attributeId: $attributeId, id: $id, values: $values) {
    campaign {
      id
      attributes {
        ...campaignAttributesFragment
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type CampaignListAttributeUpdateMutationFn = Apollo.MutationFunction<CampaignListAttributeUpdateMutation, CampaignListAttributeUpdateMutationVariables>;

/**
 * __useCampaignListAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignListAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignListAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignListAttributeUpdateMutation, { data, loading, error }] = useCampaignListAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCampaignListAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignListAttributeUpdateMutation, CampaignListAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignListAttributeUpdateMutation, CampaignListAttributeUpdateMutationVariables>(CampaignListAttributeUpdateDocument, options);
      }
export type CampaignListAttributeUpdateMutationHookResult = ReturnType<typeof useCampaignListAttributeUpdateMutation>;
export type CampaignListAttributeUpdateMutationResult = Apollo.MutationResult<CampaignListAttributeUpdateMutation>;
export type CampaignListAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignListAttributeUpdateMutation, CampaignListAttributeUpdateMutationVariables>;
export const CampaignDateAttributeUpdateDocument = gql`
    mutation CampaignDateAttributeUpdate($attributeId: ID!, $id: ID!, $value: Date) {
  campaignDateAttributeUpdate(attributeId: $attributeId, id: $id, value: $value) {
    campaign {
      attributes {
        ...campaignAttributesFragment
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type CampaignDateAttributeUpdateMutationFn = Apollo.MutationFunction<CampaignDateAttributeUpdateMutation, CampaignDateAttributeUpdateMutationVariables>;

/**
 * __useCampaignDateAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignDateAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDateAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDateAttributeUpdateMutation, { data, loading, error }] = useCampaignDateAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCampaignDateAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDateAttributeUpdateMutation, CampaignDateAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDateAttributeUpdateMutation, CampaignDateAttributeUpdateMutationVariables>(CampaignDateAttributeUpdateDocument, options);
      }
export type CampaignDateAttributeUpdateMutationHookResult = ReturnType<typeof useCampaignDateAttributeUpdateMutation>;
export type CampaignDateAttributeUpdateMutationResult = Apollo.MutationResult<CampaignDateAttributeUpdateMutation>;
export type CampaignDateAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignDateAttributeUpdateMutation, CampaignDateAttributeUpdateMutationVariables>;
export const CampaignSelectAttributeUpdateDocument = gql`
    mutation CampaignSelectAttributeUpdate($attributeId: ID!, $id: ID!, $optionId: ID) {
  campaignSelectAttributeUpdate(
    attributeId: $attributeId
    id: $id
    optionId: $optionId
  ) {
    campaign {
      attributes {
        ...campaignAttributesFragment
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type CampaignSelectAttributeUpdateMutationFn = Apollo.MutationFunction<CampaignSelectAttributeUpdateMutation, CampaignSelectAttributeUpdateMutationVariables>;

/**
 * __useCampaignSelectAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSelectAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSelectAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSelectAttributeUpdateMutation, { data, loading, error }] = useCampaignSelectAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useCampaignSelectAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSelectAttributeUpdateMutation, CampaignSelectAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSelectAttributeUpdateMutation, CampaignSelectAttributeUpdateMutationVariables>(CampaignSelectAttributeUpdateDocument, options);
      }
export type CampaignSelectAttributeUpdateMutationHookResult = ReturnType<typeof useCampaignSelectAttributeUpdateMutation>;
export type CampaignSelectAttributeUpdateMutationResult = Apollo.MutationResult<CampaignSelectAttributeUpdateMutation>;
export type CampaignSelectAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSelectAttributeUpdateMutation, CampaignSelectAttributeUpdateMutationVariables>;
export const SettingsCustomFieldAddDocument = gql`
    mutation SettingsCustomFieldAdd($campaignId: ID!, $customFieldId: ID!) {
  campaignCustomFieldAdd(campaignId: $campaignId, customFieldId: $customFieldId) {
    campaign {
      id
      customFields {
        ...customFieldsFragment
      }
    }
  }
}
    ${CustomFieldsFragmentFragmentDoc}`;
export type SettingsCustomFieldAddMutationFn = Apollo.MutationFunction<SettingsCustomFieldAddMutation, SettingsCustomFieldAddMutationVariables>;

/**
 * __useSettingsCustomFieldAddMutation__
 *
 * To run a mutation, you first call `useSettingsCustomFieldAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsCustomFieldAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsCustomFieldAddMutation, { data, loading, error }] = useSettingsCustomFieldAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *   },
 * });
 */
export function useSettingsCustomFieldAddMutation(baseOptions?: Apollo.MutationHookOptions<SettingsCustomFieldAddMutation, SettingsCustomFieldAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsCustomFieldAddMutation, SettingsCustomFieldAddMutationVariables>(SettingsCustomFieldAddDocument, options);
      }
export type SettingsCustomFieldAddMutationHookResult = ReturnType<typeof useSettingsCustomFieldAddMutation>;
export type SettingsCustomFieldAddMutationResult = Apollo.MutationResult<SettingsCustomFieldAddMutation>;
export type SettingsCustomFieldAddMutationOptions = Apollo.BaseMutationOptions<SettingsCustomFieldAddMutation, SettingsCustomFieldAddMutationVariables>;
export const SettingsCustomFieldUpdateDocument = gql`
    mutation SettingsCustomFieldUpdate($campaignId: ID!, $customFieldId: ID!, $metadata: CampaignCustomFieldMetadataInput!) {
  campaignCustomFieldUpdate(
    campaignId: $campaignId
    customFieldId: $customFieldId
    metadata: $metadata
  ) {
    campaign {
      id
      customFields {
        ...customFieldsFragment
      }
    }
  }
}
    ${CustomFieldsFragmentFragmentDoc}`;
export type SettingsCustomFieldUpdateMutationFn = Apollo.MutationFunction<SettingsCustomFieldUpdateMutation, SettingsCustomFieldUpdateMutationVariables>;

/**
 * __useSettingsCustomFieldUpdateMutation__
 *
 * To run a mutation, you first call `useSettingsCustomFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsCustomFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsCustomFieldUpdateMutation, { data, loading, error }] = useSettingsCustomFieldUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useSettingsCustomFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SettingsCustomFieldUpdateMutation, SettingsCustomFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsCustomFieldUpdateMutation, SettingsCustomFieldUpdateMutationVariables>(SettingsCustomFieldUpdateDocument, options);
      }
export type SettingsCustomFieldUpdateMutationHookResult = ReturnType<typeof useSettingsCustomFieldUpdateMutation>;
export type SettingsCustomFieldUpdateMutationResult = Apollo.MutationResult<SettingsCustomFieldUpdateMutation>;
export type SettingsCustomFieldUpdateMutationOptions = Apollo.BaseMutationOptions<SettingsCustomFieldUpdateMutation, SettingsCustomFieldUpdateMutationVariables>;
export const SettingsCustomFieldRemoveDocument = gql`
    mutation SettingsCustomFieldRemove($campaignId: ID!, $customFieldId: ID!) {
  campaignCustomFieldRemove(
    campaignId: $campaignId
    customFieldId: $customFieldId
  ) {
    campaign {
      id
      customFields {
        ...customFieldsFragment
      }
    }
  }
}
    ${CustomFieldsFragmentFragmentDoc}`;
export type SettingsCustomFieldRemoveMutationFn = Apollo.MutationFunction<SettingsCustomFieldRemoveMutation, SettingsCustomFieldRemoveMutationVariables>;

/**
 * __useSettingsCustomFieldRemoveMutation__
 *
 * To run a mutation, you first call `useSettingsCustomFieldRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsCustomFieldRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsCustomFieldRemoveMutation, { data, loading, error }] = useSettingsCustomFieldRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *   },
 * });
 */
export function useSettingsCustomFieldRemoveMutation(baseOptions?: Apollo.MutationHookOptions<SettingsCustomFieldRemoveMutation, SettingsCustomFieldRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsCustomFieldRemoveMutation, SettingsCustomFieldRemoveMutationVariables>(SettingsCustomFieldRemoveDocument, options);
      }
export type SettingsCustomFieldRemoveMutationHookResult = ReturnType<typeof useSettingsCustomFieldRemoveMutation>;
export type SettingsCustomFieldRemoveMutationResult = Apollo.MutationResult<SettingsCustomFieldRemoveMutation>;
export type SettingsCustomFieldRemoveMutationOptions = Apollo.BaseMutationOptions<SettingsCustomFieldRemoveMutation, SettingsCustomFieldRemoveMutationVariables>;
export const CampaignAddSettingsExperimentGroupDocument = gql`
    mutation CampaignAddSettingsExperimentGroup($id: ID!, $experimentGroupId: ID!) {
  campaignAddExperimentGroup(id: $id, experimentGroupId: $experimentGroupId) {
    success
    campaign {
      id
      experiments {
        ...experimentsFragment
      }
    }
  }
}
    ${ExperimentsFragmentFragmentDoc}`;
export type CampaignAddSettingsExperimentGroupMutationFn = Apollo.MutationFunction<CampaignAddSettingsExperimentGroupMutation, CampaignAddSettingsExperimentGroupMutationVariables>;

/**
 * __useCampaignAddSettingsExperimentGroupMutation__
 *
 * To run a mutation, you first call `useCampaignAddSettingsExperimentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAddSettingsExperimentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAddSettingsExperimentGroupMutation, { data, loading, error }] = useCampaignAddSettingsExperimentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experimentGroupId: // value for 'experimentGroupId'
 *   },
 * });
 */
export function useCampaignAddSettingsExperimentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAddSettingsExperimentGroupMutation, CampaignAddSettingsExperimentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAddSettingsExperimentGroupMutation, CampaignAddSettingsExperimentGroupMutationVariables>(CampaignAddSettingsExperimentGroupDocument, options);
      }
export type CampaignAddSettingsExperimentGroupMutationHookResult = ReturnType<typeof useCampaignAddSettingsExperimentGroupMutation>;
export type CampaignAddSettingsExperimentGroupMutationResult = Apollo.MutationResult<CampaignAddSettingsExperimentGroupMutation>;
export type CampaignAddSettingsExperimentGroupMutationOptions = Apollo.BaseMutationOptions<CampaignAddSettingsExperimentGroupMutation, CampaignAddSettingsExperimentGroupMutationVariables>;
export const CampaignSettingsExperimentDeleteDocument = gql`
    mutation CampaignSettingsExperimentDelete($experimentId: ID!, $campaignId: ID!) {
  campaignExperimentDelete(experimentId: $experimentId, id: $campaignId) {
    campaign {
      id
      experiments {
        ...experimentsFragment
      }
    }
  }
}
    ${ExperimentsFragmentFragmentDoc}`;
export type CampaignSettingsExperimentDeleteMutationFn = Apollo.MutationFunction<CampaignSettingsExperimentDeleteMutation, CampaignSettingsExperimentDeleteMutationVariables>;

/**
 * __useCampaignSettingsExperimentDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignSettingsExperimentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSettingsExperimentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSettingsExperimentDeleteMutation, { data, loading, error }] = useCampaignSettingsExperimentDeleteMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignSettingsExperimentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSettingsExperimentDeleteMutation, CampaignSettingsExperimentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSettingsExperimentDeleteMutation, CampaignSettingsExperimentDeleteMutationVariables>(CampaignSettingsExperimentDeleteDocument, options);
      }
export type CampaignSettingsExperimentDeleteMutationHookResult = ReturnType<typeof useCampaignSettingsExperimentDeleteMutation>;
export type CampaignSettingsExperimentDeleteMutationResult = Apollo.MutationResult<CampaignSettingsExperimentDeleteMutation>;
export type CampaignSettingsExperimentDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignSettingsExperimentDeleteMutation, CampaignSettingsExperimentDeleteMutationVariables>;
export const CampaignMessageExtraCreateDocument = gql`
    mutation CampaignMessageExtraCreate($campaignId: ID!, $messageExtraKeyId: ID!, $value: String!) {
  campaignMessageExtraCreate(
    campaignId: $campaignId
    messageExtraKeyId: $messageExtraKeyId
    value: $value
  ) {
    campaign {
      id
      messageExtras {
        id
        messageExtraKeyId
        value
      }
    }
  }
}
    `;
export type CampaignMessageExtraCreateMutationFn = Apollo.MutationFunction<CampaignMessageExtraCreateMutation, CampaignMessageExtraCreateMutationVariables>;

/**
 * __useCampaignMessageExtraCreateMutation__
 *
 * To run a mutation, you first call `useCampaignMessageExtraCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignMessageExtraCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignMessageExtraCreateMutation, { data, loading, error }] = useCampaignMessageExtraCreateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      messageExtraKeyId: // value for 'messageExtraKeyId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCampaignMessageExtraCreateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignMessageExtraCreateMutation, CampaignMessageExtraCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignMessageExtraCreateMutation, CampaignMessageExtraCreateMutationVariables>(CampaignMessageExtraCreateDocument, options);
      }
export type CampaignMessageExtraCreateMutationHookResult = ReturnType<typeof useCampaignMessageExtraCreateMutation>;
export type CampaignMessageExtraCreateMutationResult = Apollo.MutationResult<CampaignMessageExtraCreateMutation>;
export type CampaignMessageExtraCreateMutationOptions = Apollo.BaseMutationOptions<CampaignMessageExtraCreateMutation, CampaignMessageExtraCreateMutationVariables>;
export const CampaignMessageExtraUpdateDocument = gql`
    mutation CampaignMessageExtraUpdate($messageExtraId: ID!, $messageExtraKeyId: ID!, $value: String!) {
  campaignMessageExtraUpdate(
    messageExtraId: $messageExtraId
    messageExtraKeyId: $messageExtraKeyId
    value: $value
  ) {
    campaign {
      id
      messageExtras {
        id
        messageExtraKeyId
        value
      }
    }
  }
}
    `;
export type CampaignMessageExtraUpdateMutationFn = Apollo.MutationFunction<CampaignMessageExtraUpdateMutation, CampaignMessageExtraUpdateMutationVariables>;

/**
 * __useCampaignMessageExtraUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignMessageExtraUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignMessageExtraUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignMessageExtraUpdateMutation, { data, loading, error }] = useCampaignMessageExtraUpdateMutation({
 *   variables: {
 *      messageExtraId: // value for 'messageExtraId'
 *      messageExtraKeyId: // value for 'messageExtraKeyId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCampaignMessageExtraUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignMessageExtraUpdateMutation, CampaignMessageExtraUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignMessageExtraUpdateMutation, CampaignMessageExtraUpdateMutationVariables>(CampaignMessageExtraUpdateDocument, options);
      }
export type CampaignMessageExtraUpdateMutationHookResult = ReturnType<typeof useCampaignMessageExtraUpdateMutation>;
export type CampaignMessageExtraUpdateMutationResult = Apollo.MutationResult<CampaignMessageExtraUpdateMutation>;
export type CampaignMessageExtraUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignMessageExtraUpdateMutation, CampaignMessageExtraUpdateMutationVariables>;
export const CampaignMessageExtraDeleteDocument = gql`
    mutation CampaignMessageExtraDelete($messageExtraId: ID!) {
  campaignMessageExtraDelete(messageExtraId: $messageExtraId) {
    campaign {
      id
      messageExtras {
        id
        messageExtraKeyId
        value
      }
    }
  }
}
    `;
export type CampaignMessageExtraDeleteMutationFn = Apollo.MutationFunction<CampaignMessageExtraDeleteMutation, CampaignMessageExtraDeleteMutationVariables>;

/**
 * __useCampaignMessageExtraDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignMessageExtraDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignMessageExtraDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignMessageExtraDeleteMutation, { data, loading, error }] = useCampaignMessageExtraDeleteMutation({
 *   variables: {
 *      messageExtraId: // value for 'messageExtraId'
 *   },
 * });
 */
export function useCampaignMessageExtraDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignMessageExtraDeleteMutation, CampaignMessageExtraDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignMessageExtraDeleteMutation, CampaignMessageExtraDeleteMutationVariables>(CampaignMessageExtraDeleteDocument, options);
      }
export type CampaignMessageExtraDeleteMutationHookResult = ReturnType<typeof useCampaignMessageExtraDeleteMutation>;
export type CampaignMessageExtraDeleteMutationResult = Apollo.MutationResult<CampaignMessageExtraDeleteMutation>;
export type CampaignMessageExtraDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignMessageExtraDeleteMutation, CampaignMessageExtraDeleteMutationVariables>;
export const ContactAudiencesSettingsDocument = gql`
    query ContactAudiencesSettings($countLessThanOrEqual: Int, $search: String, $limit: Int, $types: [ContactAudienceType!]) {
  contactAudiences(
    search: $search
    countLessThanOrEqual: $countLessThanOrEqual
    archived: false
    limit: $limit
    types: $types
  ) {
    audiences {
      id
      name
    }
  }
}
    `;

/**
 * __useContactAudiencesSettingsQuery__
 *
 * To run a query within a React component, call `useContactAudiencesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudiencesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudiencesSettingsQuery({
 *   variables: {
 *      countLessThanOrEqual: // value for 'countLessThanOrEqual'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useContactAudiencesSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>(ContactAudiencesSettingsDocument, options);
      }
export function useContactAudiencesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>(ContactAudiencesSettingsDocument, options);
        }
export function useContactAudiencesSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>(ContactAudiencesSettingsDocument, options);
        }
export type ContactAudiencesSettingsQueryHookResult = ReturnType<typeof useContactAudiencesSettingsQuery>;
export type ContactAudiencesSettingsLazyQueryHookResult = ReturnType<typeof useContactAudiencesSettingsLazyQuery>;
export type ContactAudiencesSettingsSuspenseQueryHookResult = ReturnType<typeof useContactAudiencesSettingsSuspenseQuery>;
export type ContactAudiencesSettingsQueryResult = Apollo.QueryResult<ContactAudiencesSettingsQuery, ContactAudiencesSettingsQueryVariables>;
export const CampaignSeedAudienceAddDocument = gql`
    mutation CampaignSeedAudienceAdd($campaignId: ID!, $audienceId: ID!) {
  campaignSeedAudienceAdd(id: $campaignId, audienceId: $audienceId) {
    campaign {
      id
      seedContactAudiences {
        id
        name
      }
    }
  }
}
    `;
export type CampaignSeedAudienceAddMutationFn = Apollo.MutationFunction<CampaignSeedAudienceAddMutation, CampaignSeedAudienceAddMutationVariables>;

/**
 * __useCampaignSeedAudienceAddMutation__
 *
 * To run a mutation, you first call `useCampaignSeedAudienceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSeedAudienceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSeedAudienceAddMutation, { data, loading, error }] = useCampaignSeedAudienceAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useCampaignSeedAudienceAddMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSeedAudienceAddMutation, CampaignSeedAudienceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSeedAudienceAddMutation, CampaignSeedAudienceAddMutationVariables>(CampaignSeedAudienceAddDocument, options);
      }
export type CampaignSeedAudienceAddMutationHookResult = ReturnType<typeof useCampaignSeedAudienceAddMutation>;
export type CampaignSeedAudienceAddMutationResult = Apollo.MutationResult<CampaignSeedAudienceAddMutation>;
export type CampaignSeedAudienceAddMutationOptions = Apollo.BaseMutationOptions<CampaignSeedAudienceAddMutation, CampaignSeedAudienceAddMutationVariables>;
export const CampaignSeedAudienceRemoveDocument = gql`
    mutation CampaignSeedAudienceRemove($campaignId: ID!, $audienceId: ID!) {
  campaignSeedAudienceRemove(id: $campaignId, audienceId: $audienceId) {
    campaign {
      id
      seedContactAudiences {
        id
        name
      }
    }
  }
}
    `;
export type CampaignSeedAudienceRemoveMutationFn = Apollo.MutationFunction<CampaignSeedAudienceRemoveMutation, CampaignSeedAudienceRemoveMutationVariables>;

/**
 * __useCampaignSeedAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useCampaignSeedAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSeedAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSeedAudienceRemoveMutation, { data, loading, error }] = useCampaignSeedAudienceRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useCampaignSeedAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSeedAudienceRemoveMutation, CampaignSeedAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSeedAudienceRemoveMutation, CampaignSeedAudienceRemoveMutationVariables>(CampaignSeedAudienceRemoveDocument, options);
      }
export type CampaignSeedAudienceRemoveMutationHookResult = ReturnType<typeof useCampaignSeedAudienceRemoveMutation>;
export type CampaignSeedAudienceRemoveMutationResult = Apollo.MutationResult<CampaignSeedAudienceRemoveMutation>;
export type CampaignSeedAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<CampaignSeedAudienceRemoveMutation, CampaignSeedAudienceRemoveMutationVariables>;
export const CampaignTextTrackingParameterUpdateDocument = gql`
    mutation CampaignTextTrackingParameterUpdate($id: ID!, $trackingParameterId: ID!, $value: String) {
  campaignTextTrackingParameterUpdate(
    id: $id
    trackingParameterId: $trackingParameterId
    value: $value
  ) {
    campaign {
      id
      trackingParameters {
        ...campaignTrackingParametersFragment
      }
    }
  }
}
    ${CampaignTrackingParametersFragmentFragmentDoc}`;
export type CampaignTextTrackingParameterUpdateMutationFn = Apollo.MutationFunction<CampaignTextTrackingParameterUpdateMutation, CampaignTextTrackingParameterUpdateMutationVariables>;

/**
 * __useCampaignTextTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignTextTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTextTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTextTrackingParameterUpdateMutation, { data, loading, error }] = useCampaignTextTrackingParameterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCampaignTextTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTextTrackingParameterUpdateMutation, CampaignTextTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTextTrackingParameterUpdateMutation, CampaignTextTrackingParameterUpdateMutationVariables>(CampaignTextTrackingParameterUpdateDocument, options);
      }
export type CampaignTextTrackingParameterUpdateMutationHookResult = ReturnType<typeof useCampaignTextTrackingParameterUpdateMutation>;
export type CampaignTextTrackingParameterUpdateMutationResult = Apollo.MutationResult<CampaignTextTrackingParameterUpdateMutation>;
export type CampaignTextTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignTextTrackingParameterUpdateMutation, CampaignTextTrackingParameterUpdateMutationVariables>;
export const CampaignSelectTrackingParameterUpdateDocument = gql`
    mutation CampaignSelectTrackingParameterUpdate($id: ID!, $trackingParameterId: ID!, $optionId: ID) {
  campaignSelectTrackingParameterUpdate(
    id: $id
    trackingParameterId: $trackingParameterId
    optionId: $optionId
  ) {
    campaign {
      id
      trackingParameters {
        ...campaignTrackingParametersFragment
      }
    }
  }
}
    ${CampaignTrackingParametersFragmentFragmentDoc}`;
export type CampaignSelectTrackingParameterUpdateMutationFn = Apollo.MutationFunction<CampaignSelectTrackingParameterUpdateMutation, CampaignSelectTrackingParameterUpdateMutationVariables>;

/**
 * __useCampaignSelectTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSelectTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSelectTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSelectTrackingParameterUpdateMutation, { data, loading, error }] = useCampaignSelectTrackingParameterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useCampaignSelectTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSelectTrackingParameterUpdateMutation, CampaignSelectTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSelectTrackingParameterUpdateMutation, CampaignSelectTrackingParameterUpdateMutationVariables>(CampaignSelectTrackingParameterUpdateDocument, options);
      }
export type CampaignSelectTrackingParameterUpdateMutationHookResult = ReturnType<typeof useCampaignSelectTrackingParameterUpdateMutation>;
export type CampaignSelectTrackingParameterUpdateMutationResult = Apollo.MutationResult<CampaignSelectTrackingParameterUpdateMutation>;
export type CampaignSelectTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSelectTrackingParameterUpdateMutation, CampaignSelectTrackingParameterUpdateMutationVariables>;
export const CampaignEditSettingsDocument = gql`
    query CampaignEditSettings($campaignId: ID!) {
  availableCustomFields {
    id
    name
    title
  }
  campaign(id: $campaignId) {
    id
    hasContactAudiences
    stage
    status
    emailServiceProvider {
      __typename
      ... on AcousticCampaign {
        id
      }
      ... on AdobeCampaign {
        id
      }
      ... on AdobeJourneyOptimizer {
        id
      }
      ... on AmazonSES {
        id
      }
      ... on Braze {
        id
      }
      ... on Cordial {
        id
      }
      ... on Epsilon {
        id
      }
      ... on OracleResponsys {
        id
      }
      ... on SalesForceMarketingCloud {
        id
      }
      ... on Zeta {
        id
      }
      ... on Blackhole {
        id
      }
      ... on Bluecore {
        id
      }
      ... on SFNext {
        id
      }
    }
    seedContactAudiences {
      id
      name
    }
    attributes {
      ...campaignAttributesFragment
    }
    trackingParameters {
      ...campaignTrackingParametersFragment
    }
    ...messageExtrasFragment
    espConfig {
      ... on CampaignSalesforceMarketingCloudConfig {
        ...espSalesForceFragment
      }
      ... on CampaignAcousticCampaignConfig {
        ...espAcousticFragment
      }
      ... on CampaignOracleResponsysConfig {
        ...espOracleFragment
      }
      ... on CampaignCordialConfig {
        ...espCordialFragment
      }
      ... on CampaignAdobeCampaignConfig {
        ...espAdobeCampaignFragment
      }
      ... on AdobeJourneyOptimizerConfig {
        ...espAdobeJourneyOptimizerFragment
      }
      ... on BlackholeConfig {
        ...espBlackholeFragment
      }
      ... on CampaignEpsilonConfig {
        ...espEpsilonFragment
      }
      ... on AmazonSESConfig {
        ...espAmazonSESFragment
      }
      ... on ZetaConfig {
        ...espZetaFragment
      }
    }
    customFields {
      ...customFieldsFragment
    }
    experiments {
      ...experimentsFragment
    }
    tags {
      ...tagsFragment
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}
${CampaignTrackingParametersFragmentFragmentDoc}
${MessageExtrasFragmentFragmentDoc}
${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspBlackholeFragmentFragmentDoc}
${EspEpsilonFragmentFragmentDoc}
${EspAmazonSesFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}
${CustomFieldsFragmentFragmentDoc}
${ExperimentsFragmentFragmentDoc}
${TagsFragmentFragmentDoc}`;

/**
 * __useCampaignEditSettingsQuery__
 *
 * To run a query within a React component, call `useCampaignEditSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEditSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEditSettingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignEditSettingsQuery(baseOptions: Apollo.QueryHookOptions<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables> & ({ variables: CampaignEditSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables>(CampaignEditSettingsDocument, options);
      }
export function useCampaignEditSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables>(CampaignEditSettingsDocument, options);
        }
export function useCampaignEditSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables>(CampaignEditSettingsDocument, options);
        }
export type CampaignEditSettingsQueryHookResult = ReturnType<typeof useCampaignEditSettingsQuery>;
export type CampaignEditSettingsLazyQueryHookResult = ReturnType<typeof useCampaignEditSettingsLazyQuery>;
export type CampaignEditSettingsSuspenseQueryHookResult = ReturnType<typeof useCampaignEditSettingsSuspenseQuery>;
export type CampaignEditSettingsQueryResult = Apollo.QueryResult<CampaignEditSettingsQuery, CampaignEditSettingsQueryVariables>;
export const TemplatesDocument = gql`
    query Templates($search: String, $page: Int!, $pageSize: Int, $isMessageBuilderTemplate: Boolean) {
  templates(
    search: $search
    page: $page
    pageSize: $pageSize
    isMessageBuilderTemplate: $isMessageBuilderTemplate
  ) {
    page
    total
    results {
      id
      title
      description
      contentBlocks {
        id
        title
        placeholderType
      }
      dynamicContentBlockCount
      staticContentBlockCount
    }
  }
}
    `;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      isMessageBuilderTemplate: // value for 'isMessageBuilderTemplate'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables> & ({ variables: TemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesSuspenseQueryHookResult = ReturnType<typeof useTemplatesSuspenseQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const CampaignTemplateUpdateDocument = gql`
    mutation CampaignTemplateUpdate($id: ID!, $templateId: ID!) {
  campaignTemplateUpdate(id: $id, templateId: $templateId) {
    campaign {
      id
      campaignTemplate {
        ...campaignTemplateFields
      }
      availableCreativeTags {
        id
        name
      }
    }
  }
}
    ${CampaignTemplateFieldsFragmentDoc}`;
export type CampaignTemplateUpdateMutationFn = Apollo.MutationFunction<CampaignTemplateUpdateMutation, CampaignTemplateUpdateMutationVariables>;

/**
 * __useCampaignTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTemplateUpdateMutation, { data, loading, error }] = useCampaignTemplateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCampaignTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTemplateUpdateMutation, CampaignTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTemplateUpdateMutation, CampaignTemplateUpdateMutationVariables>(CampaignTemplateUpdateDocument, options);
      }
export type CampaignTemplateUpdateMutationHookResult = ReturnType<typeof useCampaignTemplateUpdateMutation>;
export type CampaignTemplateUpdateMutationResult = Apollo.MutationResult<CampaignTemplateUpdateMutation>;
export type CampaignTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignTemplateUpdateMutation, CampaignTemplateUpdateMutationVariables>;
export const ContentBlocksDocument = gql`
    query ContentBlocks($search: String) {
  contentBlocks(search: $search) {
    id
    title
    description
    numPositions
    type
    status
    blockImageUrl
  }
}
    `;

/**
 * __useContentBlocksQuery__
 *
 * To run a query within a React component, call `useContentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentBlocksQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useContentBlocksQuery(baseOptions?: Apollo.QueryHookOptions<ContentBlocksQuery, ContentBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentBlocksQuery, ContentBlocksQueryVariables>(ContentBlocksDocument, options);
      }
export function useContentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentBlocksQuery, ContentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentBlocksQuery, ContentBlocksQueryVariables>(ContentBlocksDocument, options);
        }
export function useContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentBlocksQuery, ContentBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentBlocksQuery, ContentBlocksQueryVariables>(ContentBlocksDocument, options);
        }
export type ContentBlocksQueryHookResult = ReturnType<typeof useContentBlocksQuery>;
export type ContentBlocksLazyQueryHookResult = ReturnType<typeof useContentBlocksLazyQuery>;
export type ContentBlocksSuspenseQueryHookResult = ReturnType<typeof useContentBlocksSuspenseQuery>;
export type ContentBlocksQueryResult = Apollo.QueryResult<ContentBlocksQuery, ContentBlocksQueryVariables>;
export const CampaignSectionRemoveV2Document = gql`
    mutation CampaignSectionRemoveV2($campaignId: ID!, $confirm: Boolean!, $sectionId: ID!) {
  campaignSectionRemove2(
    campaignId: $campaignId
    confirm: $confirm
    sectionId: $sectionId
  ) {
    ... on NeedsConfirmation {
      success
    }
    ... on CampaignUpdateSuccess {
      success
      campaign {
        id
        campaignTemplate {
          ...campaignTemplateFields
        }
        subjectline {
          ...inboxSubjectLineDynamicFields
        }
        availableCreativeTags {
          id
          name
        }
      }
    }
  }
}
    ${CampaignTemplateFieldsFragmentDoc}
${InboxSubjectLineDynamicFieldsFragmentDoc}`;
export type CampaignSectionRemoveV2MutationFn = Apollo.MutationFunction<CampaignSectionRemoveV2Mutation, CampaignSectionRemoveV2MutationVariables>;

/**
 * __useCampaignSectionRemoveV2Mutation__
 *
 * To run a mutation, you first call `useCampaignSectionRemoveV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSectionRemoveV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSectionRemoveV2Mutation, { data, loading, error }] = useCampaignSectionRemoveV2Mutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      confirm: // value for 'confirm'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCampaignSectionRemoveV2Mutation(baseOptions?: Apollo.MutationHookOptions<CampaignSectionRemoveV2Mutation, CampaignSectionRemoveV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSectionRemoveV2Mutation, CampaignSectionRemoveV2MutationVariables>(CampaignSectionRemoveV2Document, options);
      }
export type CampaignSectionRemoveV2MutationHookResult = ReturnType<typeof useCampaignSectionRemoveV2Mutation>;
export type CampaignSectionRemoveV2MutationResult = Apollo.MutationResult<CampaignSectionRemoveV2Mutation>;
export type CampaignSectionRemoveV2MutationOptions = Apollo.BaseMutationOptions<CampaignSectionRemoveV2Mutation, CampaignSectionRemoveV2MutationVariables>;
export const CampaignSectionPrimaryUpdateDocument = gql`
    mutation CampaignSectionPrimaryUpdate($id: ID!, $sectionId: ID!) {
  campaignSectionPrimaryUpdate(id: $id, sectionId: $sectionId) {
    success
    campaign {
      id
      campaignTemplate {
        ...campaignTemplateFields
      }
    }
  }
}
    ${CampaignTemplateFieldsFragmentDoc}`;
export type CampaignSectionPrimaryUpdateMutationFn = Apollo.MutationFunction<CampaignSectionPrimaryUpdateMutation, CampaignSectionPrimaryUpdateMutationVariables>;

/**
 * __useCampaignSectionPrimaryUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSectionPrimaryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSectionPrimaryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSectionPrimaryUpdateMutation, { data, loading, error }] = useCampaignSectionPrimaryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCampaignSectionPrimaryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSectionPrimaryUpdateMutation, CampaignSectionPrimaryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSectionPrimaryUpdateMutation, CampaignSectionPrimaryUpdateMutationVariables>(CampaignSectionPrimaryUpdateDocument, options);
      }
export type CampaignSectionPrimaryUpdateMutationHookResult = ReturnType<typeof useCampaignSectionPrimaryUpdateMutation>;
export type CampaignSectionPrimaryUpdateMutationResult = Apollo.MutationResult<CampaignSectionPrimaryUpdateMutation>;
export type CampaignSectionPrimaryUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSectionPrimaryUpdateMutation, CampaignSectionPrimaryUpdateMutationVariables>;
export const CampaignSectionAddDocument = gql`
    mutation CampaignSectionAdd($campaignId: ID!, $contentBlockId: ID!, $position: Int) {
  campaignSectionAdd(
    campaignId: $campaignId
    contentBlockId: $contentBlockId
    position: $position
  ) {
    campaign {
      id
      campaignTemplate {
        ...campaignTemplateFields
      }
      subjectline {
        ...inboxSubjectLineDynamicFields
      }
      availableCreativeTags {
        id
        name
      }
    }
  }
}
    ${CampaignTemplateFieldsFragmentDoc}
${InboxSubjectLineDynamicFieldsFragmentDoc}`;
export type CampaignSectionAddMutationFn = Apollo.MutationFunction<CampaignSectionAddMutation, CampaignSectionAddMutationVariables>;

/**
 * __useCampaignSectionAddMutation__
 *
 * To run a mutation, you first call `useCampaignSectionAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSectionAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSectionAddMutation, { data, loading, error }] = useCampaignSectionAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      contentBlockId: // value for 'contentBlockId'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useCampaignSectionAddMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSectionAddMutation, CampaignSectionAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSectionAddMutation, CampaignSectionAddMutationVariables>(CampaignSectionAddDocument, options);
      }
export type CampaignSectionAddMutationHookResult = ReturnType<typeof useCampaignSectionAddMutation>;
export type CampaignSectionAddMutationResult = Apollo.MutationResult<CampaignSectionAddMutation>;
export type CampaignSectionAddMutationOptions = Apollo.BaseMutationOptions<CampaignSectionAddMutation, CampaignSectionAddMutationVariables>;
export const CampaignSectionPriorityUpdateDocument = gql`
    mutation CampaignSectionPriorityUpdate($id: ID!, $sectionIds: [ID!]!) {
  campaignSectionPriorityUpdate(id: $id, sectionIds: $sectionIds) {
    campaign {
      id
      campaignTemplate {
        ...campaignTemplateFields
      }
    }
  }
}
    ${CampaignTemplateFieldsFragmentDoc}`;
export type CampaignSectionPriorityUpdateMutationFn = Apollo.MutationFunction<CampaignSectionPriorityUpdateMutation, CampaignSectionPriorityUpdateMutationVariables>;

/**
 * __useCampaignSectionPriorityUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSectionPriorityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSectionPriorityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSectionPriorityUpdateMutation, { data, loading, error }] = useCampaignSectionPriorityUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionIds: // value for 'sectionIds'
 *   },
 * });
 */
export function useCampaignSectionPriorityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSectionPriorityUpdateMutation, CampaignSectionPriorityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSectionPriorityUpdateMutation, CampaignSectionPriorityUpdateMutationVariables>(CampaignSectionPriorityUpdateDocument, options);
      }
export type CampaignSectionPriorityUpdateMutationHookResult = ReturnType<typeof useCampaignSectionPriorityUpdateMutation>;
export type CampaignSectionPriorityUpdateMutationResult = Apollo.MutationResult<CampaignSectionPriorityUpdateMutation>;
export type CampaignSectionPriorityUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSectionPriorityUpdateMutation, CampaignSectionPriorityUpdateMutationVariables>;
export const GetCampaignTemplateDataDocument = gql`
    query GetCampaignTemplateData($campaignId: ID!) {
  campaign(id: $campaignId) {
    id
    status
    campaignTemplate {
      ...campaignTemplateFields
    }
  }
}
    ${CampaignTemplateFieldsFragmentDoc}`;

/**
 * __useGetCampaignTemplateDataQuery__
 *
 * To run a query within a React component, call `useGetCampaignTemplateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignTemplateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignTemplateDataQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignTemplateDataQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables> & ({ variables: GetCampaignTemplateDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables>(GetCampaignTemplateDataDocument, options);
      }
export function useGetCampaignTemplateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables>(GetCampaignTemplateDataDocument, options);
        }
export function useGetCampaignTemplateDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables>(GetCampaignTemplateDataDocument, options);
        }
export type GetCampaignTemplateDataQueryHookResult = ReturnType<typeof useGetCampaignTemplateDataQuery>;
export type GetCampaignTemplateDataLazyQueryHookResult = ReturnType<typeof useGetCampaignTemplateDataLazyQuery>;
export type GetCampaignTemplateDataSuspenseQueryHookResult = ReturnType<typeof useGetCampaignTemplateDataSuspenseQuery>;
export type GetCampaignTemplateDataQueryResult = Apollo.QueryResult<GetCampaignTemplateDataQuery, GetCampaignTemplateDataQueryVariables>;
export const CampaignTemplateSaveDocument = gql`
    mutation CampaignTemplateSave($campaignId: ID!, $sections: [CampaignTemplateSectionInput!]!) {
  campaignTemplateSave(campaignId: $campaignId, sections: $sections) {
    success
  }
}
    `;
export type CampaignTemplateSaveMutationFn = Apollo.MutationFunction<CampaignTemplateSaveMutation, CampaignTemplateSaveMutationVariables>;

/**
 * __useCampaignTemplateSaveMutation__
 *
 * To run a mutation, you first call `useCampaignTemplateSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTemplateSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTemplateSaveMutation, { data, loading, error }] = useCampaignTemplateSaveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sections: // value for 'sections'
 *   },
 * });
 */
export function useCampaignTemplateSaveMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTemplateSaveMutation, CampaignTemplateSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTemplateSaveMutation, CampaignTemplateSaveMutationVariables>(CampaignTemplateSaveDocument, options);
      }
export type CampaignTemplateSaveMutationHookResult = ReturnType<typeof useCampaignTemplateSaveMutation>;
export type CampaignTemplateSaveMutationResult = Apollo.MutationResult<CampaignTemplateSaveMutation>;
export type CampaignTemplateSaveMutationOptions = Apollo.BaseMutationOptions<CampaignTemplateSaveMutation, CampaignTemplateSaveMutationVariables>;
export const GetBaseTemplateDocument = gql`
    query GetBaseTemplate($baseTemplateId: ID!) {
  baseTemplate(baseTemplateId: $baseTemplateId) {
    template {
      id
      title
    }
    sections {
      id
      isPrimary
      position
      zone
      contentBlock {
        id
        title
        description
        numPositions
        type
        blockImageUrl
      }
    }
  }
}
    `;

/**
 * __useGetBaseTemplateQuery__
 *
 * To run a query within a React component, call `useGetBaseTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseTemplateQuery({
 *   variables: {
 *      baseTemplateId: // value for 'baseTemplateId'
 *   },
 * });
 */
export function useGetBaseTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetBaseTemplateQuery, GetBaseTemplateQueryVariables> & ({ variables: GetBaseTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaseTemplateQuery, GetBaseTemplateQueryVariables>(GetBaseTemplateDocument, options);
      }
export function useGetBaseTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaseTemplateQuery, GetBaseTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaseTemplateQuery, GetBaseTemplateQueryVariables>(GetBaseTemplateDocument, options);
        }
export function useGetBaseTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaseTemplateQuery, GetBaseTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaseTemplateQuery, GetBaseTemplateQueryVariables>(GetBaseTemplateDocument, options);
        }
export type GetBaseTemplateQueryHookResult = ReturnType<typeof useGetBaseTemplateQuery>;
export type GetBaseTemplateLazyQueryHookResult = ReturnType<typeof useGetBaseTemplateLazyQuery>;
export type GetBaseTemplateSuspenseQueryHookResult = ReturnType<typeof useGetBaseTemplateSuspenseQuery>;
export type GetBaseTemplateQueryResult = Apollo.QueryResult<GetBaseTemplateQuery, GetBaseTemplateQueryVariables>;
export const BaseTemplateUpdateDocument = gql`
    mutation BaseTemplateUpdate($baseTemplateId: ID!, $sections: [BaseTemplateSectionInput!]!) {
  baseTemplateUpdate(baseTemplateId: $baseTemplateId, sections: $sections) {
    success
  }
}
    `;
export type BaseTemplateUpdateMutationFn = Apollo.MutationFunction<BaseTemplateUpdateMutation, BaseTemplateUpdateMutationVariables>;

/**
 * __useBaseTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useBaseTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBaseTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [baseTemplateUpdateMutation, { data, loading, error }] = useBaseTemplateUpdateMutation({
 *   variables: {
 *      baseTemplateId: // value for 'baseTemplateId'
 *      sections: // value for 'sections'
 *   },
 * });
 */
export function useBaseTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BaseTemplateUpdateMutation, BaseTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BaseTemplateUpdateMutation, BaseTemplateUpdateMutationVariables>(BaseTemplateUpdateDocument, options);
      }
export type BaseTemplateUpdateMutationHookResult = ReturnType<typeof useBaseTemplateUpdateMutation>;
export type BaseTemplateUpdateMutationResult = Apollo.MutationResult<BaseTemplateUpdateMutation>;
export type BaseTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<BaseTemplateUpdateMutation, BaseTemplateUpdateMutationVariables>;
export const ExperimentGroupsDocument = gql`
    query ExperimentGroups {
  experimentGroups {
    id
    title
    experimentType
    configurationRestrictedToStaff
  }
}
    `;

/**
 * __useExperimentGroupsQuery__
 *
 * To run a query within a React component, call `useExperimentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExperimentGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>(ExperimentGroupsDocument, options);
      }
export function useExperimentGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>(ExperimentGroupsDocument, options);
        }
export function useExperimentGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>(ExperimentGroupsDocument, options);
        }
export type ExperimentGroupsQueryHookResult = ReturnType<typeof useExperimentGroupsQuery>;
export type ExperimentGroupsLazyQueryHookResult = ReturnType<typeof useExperimentGroupsLazyQuery>;
export type ExperimentGroupsSuspenseQueryHookResult = ReturnType<typeof useExperimentGroupsSuspenseQuery>;
export type ExperimentGroupsQueryResult = Apollo.QueryResult<ExperimentGroupsQuery, ExperimentGroupsQueryVariables>;
export const CampaignSendDateUpdateDocument = gql`
    mutation campaignSendDateUpdate($id: ID!, $date: Date!) {
  campaignSendDateUpdate(id: $id, date: $date) {
    success
    campaign {
      id
      sendDate
    }
  }
}
    `;
export type CampaignSendDateUpdateMutationFn = Apollo.MutationFunction<CampaignSendDateUpdateMutation, CampaignSendDateUpdateMutationVariables>;

/**
 * __useCampaignSendDateUpdateMutation__
 *
 * To run a mutation, you first call `useCampaignSendDateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSendDateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSendDateUpdateMutation, { data, loading, error }] = useCampaignSendDateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCampaignSendDateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSendDateUpdateMutation, CampaignSendDateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSendDateUpdateMutation, CampaignSendDateUpdateMutationVariables>(CampaignSendDateUpdateDocument, options);
      }
export type CampaignSendDateUpdateMutationHookResult = ReturnType<typeof useCampaignSendDateUpdateMutation>;
export type CampaignSendDateUpdateMutationResult = Apollo.MutationResult<CampaignSendDateUpdateMutation>;
export type CampaignSendDateUpdateMutationOptions = Apollo.BaseMutationOptions<CampaignSendDateUpdateMutation, CampaignSendDateUpdateMutationVariables>;
export const ListAllTagsDocument = gql`
    query ListAllTags {
  tags {
    ...tagsFragment
  }
}
    ${TagsFragmentFragmentDoc}`;

/**
 * __useListAllTagsQuery__
 *
 * To run a query within a React component, call `useListAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAllTagsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllTagsQuery, ListAllTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllTagsQuery, ListAllTagsQueryVariables>(ListAllTagsDocument, options);
      }
export function useListAllTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllTagsQuery, ListAllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllTagsQuery, ListAllTagsQueryVariables>(ListAllTagsDocument, options);
        }
export function useListAllTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllTagsQuery, ListAllTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllTagsQuery, ListAllTagsQueryVariables>(ListAllTagsDocument, options);
        }
export type ListAllTagsQueryHookResult = ReturnType<typeof useListAllTagsQuery>;
export type ListAllTagsLazyQueryHookResult = ReturnType<typeof useListAllTagsLazyQuery>;
export type ListAllTagsSuspenseQueryHookResult = ReturnType<typeof useListAllTagsSuspenseQuery>;
export type ListAllTagsQueryResult = Apollo.QueryResult<ListAllTagsQuery, ListAllTagsQueryVariables>;
export const CampaignTagAddDocument = gql`
    mutation CampaignTagAdd($campaignId: ID!, $tagId: ID!) {
  campaignTagCreate(id: $campaignId, tagId: $tagId) {
    campaign {
      id
      tags {
        ...tagsFragment
      }
    }
  }
}
    ${TagsFragmentFragmentDoc}`;
export type CampaignTagAddMutationFn = Apollo.MutationFunction<CampaignTagAddMutation, CampaignTagAddMutationVariables>;

/**
 * __useCampaignTagAddMutation__
 *
 * To run a mutation, you first call `useCampaignTagAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTagAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTagAddMutation, { data, loading, error }] = useCampaignTagAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useCampaignTagAddMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTagAddMutation, CampaignTagAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTagAddMutation, CampaignTagAddMutationVariables>(CampaignTagAddDocument, options);
      }
export type CampaignTagAddMutationHookResult = ReturnType<typeof useCampaignTagAddMutation>;
export type CampaignTagAddMutationResult = Apollo.MutationResult<CampaignTagAddMutation>;
export type CampaignTagAddMutationOptions = Apollo.BaseMutationOptions<CampaignTagAddMutation, CampaignTagAddMutationVariables>;
export const CampaignTagDeleteDocument = gql`
    mutation CampaignTagDelete($campaignId: ID!, $tagId: ID!) {
  campaignTagDelete(id: $campaignId, tagId: $tagId) {
    campaign {
      id
      tags {
        ...tagsFragment
      }
    }
  }
}
    ${TagsFragmentFragmentDoc}`;
export type CampaignTagDeleteMutationFn = Apollo.MutationFunction<CampaignTagDeleteMutation, CampaignTagDeleteMutationVariables>;

/**
 * __useCampaignTagDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTagDeleteMutation, { data, loading, error }] = useCampaignTagDeleteMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useCampaignTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTagDeleteMutation, CampaignTagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTagDeleteMutation, CampaignTagDeleteMutationVariables>(CampaignTagDeleteDocument, options);
      }
export type CampaignTagDeleteMutationHookResult = ReturnType<typeof useCampaignTagDeleteMutation>;
export type CampaignTagDeleteMutationResult = Apollo.MutationResult<CampaignTagDeleteMutation>;
export type CampaignTagDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignTagDeleteMutation, CampaignTagDeleteMutationVariables>;
export const FetchCampaignsDocument = gql`
    query FetchCampaigns($page: Int!, $pageSize: Int, $startEndRange: DateRange, $statusGroups: [CampaignStatusGroupType!], $sort: [CampaignSortType!], $search: SearchUID, $error: Boolean, $audienceIds: [ID!], $channels: [Channel!], $hasNewerCreativeVersions: Boolean) {
  campaigns(
    page: $page
    pageSize: $pageSize
    startEndRange: $startEndRange
    statusGroups: $statusGroups
    search: $search
    sort: $sort
    error: $error
    audienceIds: $audienceIds
    channels: $channels
    hasNewerCreativeVersions: $hasNewerCreativeVersions
  ) {
    page
    total
    results {
      ...campaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;

/**
 * __useFetchCampaignsQuery__
 *
 * To run a query within a React component, call `useFetchCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      startEndRange: // value for 'startEndRange'
 *      statusGroups: // value for 'statusGroups'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *      error: // value for 'error'
 *      audienceIds: // value for 'audienceIds'
 *      channels: // value for 'channels'
 *      hasNewerCreativeVersions: // value for 'hasNewerCreativeVersions'
 *   },
 * });
 */
export function useFetchCampaignsQuery(baseOptions: Apollo.QueryHookOptions<FetchCampaignsQuery, FetchCampaignsQueryVariables> & ({ variables: FetchCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignsQuery, FetchCampaignsQueryVariables>(FetchCampaignsDocument, options);
      }
export function useFetchCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignsQuery, FetchCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignsQuery, FetchCampaignsQueryVariables>(FetchCampaignsDocument, options);
        }
export function useFetchCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCampaignsQuery, FetchCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCampaignsQuery, FetchCampaignsQueryVariables>(FetchCampaignsDocument, options);
        }
export type FetchCampaignsQueryHookResult = ReturnType<typeof useFetchCampaignsQuery>;
export type FetchCampaignsLazyQueryHookResult = ReturnType<typeof useFetchCampaignsLazyQuery>;
export type FetchCampaignsSuspenseQueryHookResult = ReturnType<typeof useFetchCampaignsSuspenseQuery>;
export type FetchCampaignsQueryResult = Apollo.QueryResult<FetchCampaignsQuery, FetchCampaignsQueryVariables>;
export const CampaignStatusGroupCountDocument = gql`
    query CampaignStatusGroupCount($startEndRange: DateRange, $search: String) {
  campaignStatusGroupCount(startEndRange: $startEndRange, search: $search) {
    statusGroup
    count
    errors
  }
}
    `;

/**
 * __useCampaignStatusGroupCountQuery__
 *
 * To run a query within a React component, call `useCampaignStatusGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStatusGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStatusGroupCountQuery({
 *   variables: {
 *      startEndRange: // value for 'startEndRange'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCampaignStatusGroupCountQuery(baseOptions?: Apollo.QueryHookOptions<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>(CampaignStatusGroupCountDocument, options);
      }
export function useCampaignStatusGroupCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>(CampaignStatusGroupCountDocument, options);
        }
export function useCampaignStatusGroupCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>(CampaignStatusGroupCountDocument, options);
        }
export type CampaignStatusGroupCountQueryHookResult = ReturnType<typeof useCampaignStatusGroupCountQuery>;
export type CampaignStatusGroupCountLazyQueryHookResult = ReturnType<typeof useCampaignStatusGroupCountLazyQuery>;
export type CampaignStatusGroupCountSuspenseQueryHookResult = ReturnType<typeof useCampaignStatusGroupCountSuspenseQuery>;
export type CampaignStatusGroupCountQueryResult = Apollo.QueryResult<CampaignStatusGroupCountQuery, CampaignStatusGroupCountQueryVariables>;
export const RecurringCampaignOccurrencesDocument = gql`
    query RecurringCampaignOccurrences($startEndRange: DateRange!, $filter: RecurringCampaignFilterInput) {
  recurringCampaignOccurrences(startEndRange: $startEndRange, filter: $filter) {
    ...recurringCampaignOccurrenceFields
  }
}
    ${RecurringCampaignOccurrenceFieldsFragmentDoc}`;

/**
 * __useRecurringCampaignOccurrencesQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignOccurrencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignOccurrencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignOccurrencesQuery({
 *   variables: {
 *      startEndRange: // value for 'startEndRange'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRecurringCampaignOccurrencesQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables> & ({ variables: RecurringCampaignOccurrencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables>(RecurringCampaignOccurrencesDocument, options);
      }
export function useRecurringCampaignOccurrencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables>(RecurringCampaignOccurrencesDocument, options);
        }
export function useRecurringCampaignOccurrencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables>(RecurringCampaignOccurrencesDocument, options);
        }
export type RecurringCampaignOccurrencesQueryHookResult = ReturnType<typeof useRecurringCampaignOccurrencesQuery>;
export type RecurringCampaignOccurrencesLazyQueryHookResult = ReturnType<typeof useRecurringCampaignOccurrencesLazyQuery>;
export type RecurringCampaignOccurrencesSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignOccurrencesSuspenseQuery>;
export type RecurringCampaignOccurrencesQueryResult = Apollo.QueryResult<RecurringCampaignOccurrencesQuery, RecurringCampaignOccurrencesQueryVariables>;
export const FetchCampaignsAudiencesDocument = gql`
    query FetchCampaignsAudiences($page: Int!, $pageSize: Int, $startEndRange: DateRange, $statusGroups: [CampaignStatusGroupType!], $sort: [CampaignSortType!], $search: SearchUID, $error: Boolean, $audienceIds: [ID!], $hasNewerCreativeVersions: Boolean) {
  campaigns(
    page: $page
    pageSize: $pageSize
    startEndRange: $startEndRange
    statusGroups: $statusGroups
    search: $search
    sort: $sort
    error: $error
    audienceIds: $audienceIds
    hasNewerCreativeVersions: $hasNewerCreativeVersions
  ) {
    results {
      id
      status
      includedContactAudiences {
        id
        name
        contactAudience {
          id
          name
          archived
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCampaignsAudiencesQuery__
 *
 * To run a query within a React component, call `useFetchCampaignsAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignsAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignsAudiencesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      startEndRange: // value for 'startEndRange'
 *      statusGroups: // value for 'statusGroups'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *      error: // value for 'error'
 *      audienceIds: // value for 'audienceIds'
 *      hasNewerCreativeVersions: // value for 'hasNewerCreativeVersions'
 *   },
 * });
 */
export function useFetchCampaignsAudiencesQuery(baseOptions: Apollo.QueryHookOptions<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables> & ({ variables: FetchCampaignsAudiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables>(FetchCampaignsAudiencesDocument, options);
      }
export function useFetchCampaignsAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables>(FetchCampaignsAudiencesDocument, options);
        }
export function useFetchCampaignsAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables>(FetchCampaignsAudiencesDocument, options);
        }
export type FetchCampaignsAudiencesQueryHookResult = ReturnType<typeof useFetchCampaignsAudiencesQuery>;
export type FetchCampaignsAudiencesLazyQueryHookResult = ReturnType<typeof useFetchCampaignsAudiencesLazyQuery>;
export type FetchCampaignsAudiencesSuspenseQueryHookResult = ReturnType<typeof useFetchCampaignsAudiencesSuspenseQuery>;
export type FetchCampaignsAudiencesQueryResult = Apollo.QueryResult<FetchCampaignsAudiencesQuery, FetchCampaignsAudiencesQueryVariables>;
export const RecurringCampaignsDocument = gql`
    query RecurringCampaigns($first: Int, $filter: RecurringCampaignFilterInput) {
  recurringCampaigns(first: $first, filter: $filter) {
    edges {
      node {
        id
        title
        status
        stage
        stageGroup
        stateInfo {
          state
          transitions {
            label
            state
          }
          actions {
            id
            label
          }
        }
        hasPastMailings
        nextOccurrence
        channel {
          category
          channel
        }
        schedule {
          rrule
          sendTime
          startDate
          endDate
          timezone
        }
      }
    }
  }
}
    `;

/**
 * __useRecurringCampaignsQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRecurringCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>(RecurringCampaignsDocument, options);
      }
export function useRecurringCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>(RecurringCampaignsDocument, options);
        }
export function useRecurringCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>(RecurringCampaignsDocument, options);
        }
export type RecurringCampaignsQueryHookResult = ReturnType<typeof useRecurringCampaignsQuery>;
export type RecurringCampaignsLazyQueryHookResult = ReturnType<typeof useRecurringCampaignsLazyQuery>;
export type RecurringCampaignsSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignsSuspenseQuery>;
export type RecurringCampaignsQueryResult = Apollo.QueryResult<RecurringCampaignsQuery, RecurringCampaignsQueryVariables>;
export const TriggeredCampaignsDocument = gql`
    query TriggeredCampaigns($first: Int, $filter: TriggeredCampaignFilterInput) {
  triggeredCampaigns(first: $first, filter: $filter) {
    edges {
      node {
        ...triggeredCampaignFields
      }
    }
  }
}
    ${TriggeredCampaignFieldsFragmentDoc}`;

/**
 * __useTriggeredCampaignsQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTriggeredCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>(TriggeredCampaignsDocument, options);
      }
export function useTriggeredCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>(TriggeredCampaignsDocument, options);
        }
export function useTriggeredCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>(TriggeredCampaignsDocument, options);
        }
export type TriggeredCampaignsQueryHookResult = ReturnType<typeof useTriggeredCampaignsQuery>;
export type TriggeredCampaignsLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignsLazyQuery>;
export type TriggeredCampaignsSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignsSuspenseQuery>;
export type TriggeredCampaignsQueryResult = Apollo.QueryResult<TriggeredCampaignsQuery, TriggeredCampaignsQueryVariables>;
export const RecommendationRunScheduleDocument = gql`
    query RecommendationRunSchedule {
  recommendationRunSchedule {
    runTime
    sendDate
    campaignsIncluded {
      id
      title
      stage
      status
      autoSchedule
    }
    campaignsNotIncluded {
      id
      title
      stage
      status
      autoSchedule
    }
  }
}
    `;

/**
 * __useRecommendationRunScheduleQuery__
 *
 * To run a query within a React component, call `useRecommendationRunScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationRunScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationRunScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendationRunScheduleQuery(baseOptions?: Apollo.QueryHookOptions<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>(RecommendationRunScheduleDocument, options);
      }
export function useRecommendationRunScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>(RecommendationRunScheduleDocument, options);
        }
export function useRecommendationRunScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>(RecommendationRunScheduleDocument, options);
        }
export type RecommendationRunScheduleQueryHookResult = ReturnType<typeof useRecommendationRunScheduleQuery>;
export type RecommendationRunScheduleLazyQueryHookResult = ReturnType<typeof useRecommendationRunScheduleLazyQuery>;
export type RecommendationRunScheduleSuspenseQueryHookResult = ReturnType<typeof useRecommendationRunScheduleSuspenseQuery>;
export type RecommendationRunScheduleQueryResult = Apollo.QueryResult<RecommendationRunScheduleQuery, RecommendationRunScheduleQueryVariables>;
export const RecommendationRunsDocument = gql`
    query RecommendationRuns {
  recommendationRuns {
    id
    runId
    status
    runType
    flowRunId
    flowRunUrl
    campaigns {
      id
      title
      stage
    }
  }
}
    `;

/**
 * __useRecommendationRunsQuery__
 *
 * To run a query within a React component, call `useRecommendationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendationRunsQuery(baseOptions?: Apollo.QueryHookOptions<RecommendationRunsQuery, RecommendationRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationRunsQuery, RecommendationRunsQueryVariables>(RecommendationRunsDocument, options);
      }
export function useRecommendationRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationRunsQuery, RecommendationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationRunsQuery, RecommendationRunsQueryVariables>(RecommendationRunsDocument, options);
        }
export function useRecommendationRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationRunsQuery, RecommendationRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendationRunsQuery, RecommendationRunsQueryVariables>(RecommendationRunsDocument, options);
        }
export type RecommendationRunsQueryHookResult = ReturnType<typeof useRecommendationRunsQuery>;
export type RecommendationRunsLazyQueryHookResult = ReturnType<typeof useRecommendationRunsLazyQuery>;
export type RecommendationRunsSuspenseQueryHookResult = ReturnType<typeof useRecommendationRunsSuspenseQuery>;
export type RecommendationRunsQueryResult = Apollo.QueryResult<RecommendationRunsQuery, RecommendationRunsQueryVariables>;
export const RecommendationRunCancelDocument = gql`
    mutation RecommendationRunCancel($id: ID!) {
  recommendationRunCancel(id: $id) {
    success
  }
}
    `;
export type RecommendationRunCancelMutationFn = Apollo.MutationFunction<RecommendationRunCancelMutation, RecommendationRunCancelMutationVariables>;

/**
 * __useRecommendationRunCancelMutation__
 *
 * To run a mutation, you first call `useRecommendationRunCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendationRunCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendationRunCancelMutation, { data, loading, error }] = useRecommendationRunCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecommendationRunCancelMutation(baseOptions?: Apollo.MutationHookOptions<RecommendationRunCancelMutation, RecommendationRunCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendationRunCancelMutation, RecommendationRunCancelMutationVariables>(RecommendationRunCancelDocument, options);
      }
export type RecommendationRunCancelMutationHookResult = ReturnType<typeof useRecommendationRunCancelMutation>;
export type RecommendationRunCancelMutationResult = Apollo.MutationResult<RecommendationRunCancelMutation>;
export type RecommendationRunCancelMutationOptions = Apollo.BaseMutationOptions<RecommendationRunCancelMutation, RecommendationRunCancelMutationVariables>;
export const RecommendationRunStartDocument = gql`
    mutation RecommendationRunStart($id: ID!) {
  recommendationRunStart(id: $id) {
    success
    recommendationRun {
      id
      runId
      status
      runType
      flowRunId
      flowRunUrl
      campaigns {
        id
        title
        stage
      }
    }
  }
}
    `;
export type RecommendationRunStartMutationFn = Apollo.MutationFunction<RecommendationRunStartMutation, RecommendationRunStartMutationVariables>;

/**
 * __useRecommendationRunStartMutation__
 *
 * To run a mutation, you first call `useRecommendationRunStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendationRunStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendationRunStartMutation, { data, loading, error }] = useRecommendationRunStartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecommendationRunStartMutation(baseOptions?: Apollo.MutationHookOptions<RecommendationRunStartMutation, RecommendationRunStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendationRunStartMutation, RecommendationRunStartMutationVariables>(RecommendationRunStartDocument, options);
      }
export type RecommendationRunStartMutationHookResult = ReturnType<typeof useRecommendationRunStartMutation>;
export type RecommendationRunStartMutationResult = Apollo.MutationResult<RecommendationRunStartMutation>;
export type RecommendationRunStartMutationOptions = Apollo.BaseMutationOptions<RecommendationRunStartMutation, RecommendationRunStartMutationVariables>;
export const FetchLayoutDocument = gql`
    query FetchLayout($creativeId: ID!, $layoutId: ID!, $format: DocumentFormat!) {
  creative(id: $creativeId) {
    id
    __typename
    layout(id: $layoutId) {
      __typename
      id
      snapshot(format: $format)
      supportedLayoutComplexity
      hasUnpublishedChanges
      name
      upgradeStatus
      ...StudioCampaignsFragment
      updatedBy {
        fullName
      }
      updatedAt
      publishedBy {
        fullName
      }
      publishedAt
      linkLibrary {
        ...link2Fields
      }
      mediaLibrary {
        ...mediaFields
      }
      variables {
        id
        name
        providerVariable {
          id
          expression
        }
      }
      usedBrandKit {
        ...brandKitFragment
      }
    }
  }
}
    ${StudioCampaignsFragmentFragmentDoc}
${Link2FieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${BrandKitFragmentFragmentDoc}`;

/**
 * __useFetchLayoutQuery__
 *
 * To run a query within a React component, call `useFetchLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLayoutQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      layoutId: // value for 'layoutId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useFetchLayoutQuery(baseOptions: Apollo.QueryHookOptions<FetchLayoutQuery, FetchLayoutQueryVariables> & ({ variables: FetchLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLayoutQuery, FetchLayoutQueryVariables>(FetchLayoutDocument, options);
      }
export function useFetchLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLayoutQuery, FetchLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLayoutQuery, FetchLayoutQueryVariables>(FetchLayoutDocument, options);
        }
export function useFetchLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchLayoutQuery, FetchLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchLayoutQuery, FetchLayoutQueryVariables>(FetchLayoutDocument, options);
        }
export type FetchLayoutQueryHookResult = ReturnType<typeof useFetchLayoutQuery>;
export type FetchLayoutLazyQueryHookResult = ReturnType<typeof useFetchLayoutLazyQuery>;
export type FetchLayoutSuspenseQueryHookResult = ReturnType<typeof useFetchLayoutSuspenseQuery>;
export type FetchLayoutQueryResult = Apollo.QueryResult<FetchLayoutQuery, FetchLayoutQueryVariables>;
export const FetchLayoutSavedDocument = gql`
    query FetchLayoutSaved($creativeId: ID!, $layoutId: ID!, $format: DocumentFormat!) {
  creative(id: $creativeId) {
    id
    __typename
    layout(id: $layoutId) {
      __typename
      id
      snapshot(format: $format)
      published(format: $format)
      variables {
        id
        name
        providerVariable {
          id
          expression
        }
      }
    }
  }
}
    `;

/**
 * __useFetchLayoutSavedQuery__
 *
 * To run a query within a React component, call `useFetchLayoutSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLayoutSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLayoutSavedQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      layoutId: // value for 'layoutId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useFetchLayoutSavedQuery(baseOptions: Apollo.QueryHookOptions<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables> & ({ variables: FetchLayoutSavedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables>(FetchLayoutSavedDocument, options);
      }
export function useFetchLayoutSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables>(FetchLayoutSavedDocument, options);
        }
export function useFetchLayoutSavedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables>(FetchLayoutSavedDocument, options);
        }
export type FetchLayoutSavedQueryHookResult = ReturnType<typeof useFetchLayoutSavedQuery>;
export type FetchLayoutSavedLazyQueryHookResult = ReturnType<typeof useFetchLayoutSavedLazyQuery>;
export type FetchLayoutSavedSuspenseQueryHookResult = ReturnType<typeof useFetchLayoutSavedSuspenseQuery>;
export type FetchLayoutSavedQueryResult = Apollo.QueryResult<FetchLayoutSavedQuery, FetchLayoutSavedQueryVariables>;
export const StudioCampaignImportDocument = gql`
    mutation studioCampaignImport($creativeId: ID!, $templateTagId: ID!, $studioCampaignId: ID!, $studioBlockIds: [ID!]!, $format: DocumentFormat!) {
  studioCampaignImport(
    creativeId: $creativeId
    studioCampaignId: $studioCampaignId
    templateTagId: $templateTagId
    studioBlockIds: $studioBlockIds
  ) {
    success
    layout {
      id
      snapshot(format: $format)
      ...StudioCampaignsFragment
    }
  }
}
    ${StudioCampaignsFragmentFragmentDoc}`;
export type StudioCampaignImportMutationFn = Apollo.MutationFunction<StudioCampaignImportMutation, StudioCampaignImportMutationVariables>;

/**
 * __useStudioCampaignImportMutation__
 *
 * To run a mutation, you first call `useStudioCampaignImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudioCampaignImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studioCampaignImportMutation, { data, loading, error }] = useStudioCampaignImportMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      studioCampaignId: // value for 'studioCampaignId'
 *      studioBlockIds: // value for 'studioBlockIds'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useStudioCampaignImportMutation(baseOptions?: Apollo.MutationHookOptions<StudioCampaignImportMutation, StudioCampaignImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudioCampaignImportMutation, StudioCampaignImportMutationVariables>(StudioCampaignImportDocument, options);
      }
export type StudioCampaignImportMutationHookResult = ReturnType<typeof useStudioCampaignImportMutation>;
export type StudioCampaignImportMutationResult = Apollo.MutationResult<StudioCampaignImportMutation>;
export type StudioCampaignImportMutationOptions = Apollo.BaseMutationOptions<StudioCampaignImportMutation, StudioCampaignImportMutationVariables>;
export const LayoutAutoSaveDocument = gql`
    mutation layoutAutoSave($creativeId: ID!, $document: LayoutDocument!, $templateTagId: ID!, $usedBrandKitId: ID) {
  layoutSave(
    creativeId: $creativeId
    document: $document
    templateTagId: $templateTagId
    usedBrandKitId: $usedBrandKitId
  ) {
    success
  }
}
    `;
export type LayoutAutoSaveMutationFn = Apollo.MutationFunction<LayoutAutoSaveMutation, LayoutAutoSaveMutationVariables>;

/**
 * __useLayoutAutoSaveMutation__
 *
 * To run a mutation, you first call `useLayoutAutoSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutAutoSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutAutoSaveMutation, { data, loading, error }] = useLayoutAutoSaveMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      document: // value for 'document'
 *      templateTagId: // value for 'templateTagId'
 *      usedBrandKitId: // value for 'usedBrandKitId'
 *   },
 * });
 */
export function useLayoutAutoSaveMutation(baseOptions?: Apollo.MutationHookOptions<LayoutAutoSaveMutation, LayoutAutoSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LayoutAutoSaveMutation, LayoutAutoSaveMutationVariables>(LayoutAutoSaveDocument, options);
      }
export type LayoutAutoSaveMutationHookResult = ReturnType<typeof useLayoutAutoSaveMutation>;
export type LayoutAutoSaveMutationResult = Apollo.MutationResult<LayoutAutoSaveMutation>;
export type LayoutAutoSaveMutationOptions = Apollo.BaseMutationOptions<LayoutAutoSaveMutation, LayoutAutoSaveMutationVariables>;
export const LayoutSaveDocument = gql`
    mutation layoutSave($creativeId: ID!, $document: LayoutDocument!, $templateTagId: ID!, $usedBrandKitId: ID) {
  layoutPublish(
    creativeId: $creativeId
    document: $document
    templateTagId: $templateTagId
    usedBrandKitId: $usedBrandKitId
  ) {
    success
  }
}
    `;
export type LayoutSaveMutationFn = Apollo.MutationFunction<LayoutSaveMutation, LayoutSaveMutationVariables>;

/**
 * __useLayoutSaveMutation__
 *
 * To run a mutation, you first call `useLayoutSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLayoutSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [layoutSaveMutation, { data, loading, error }] = useLayoutSaveMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      document: // value for 'document'
 *      templateTagId: // value for 'templateTagId'
 *      usedBrandKitId: // value for 'usedBrandKitId'
 *   },
 * });
 */
export function useLayoutSaveMutation(baseOptions?: Apollo.MutationHookOptions<LayoutSaveMutation, LayoutSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LayoutSaveMutation, LayoutSaveMutationVariables>(LayoutSaveDocument, options);
      }
export type LayoutSaveMutationHookResult = ReturnType<typeof useLayoutSaveMutation>;
export type LayoutSaveMutationResult = Apollo.MutationResult<LayoutSaveMutation>;
export type LayoutSaveMutationOptions = Apollo.BaseMutationOptions<LayoutSaveMutation, LayoutSaveMutationVariables>;
export const LayoutComponentsDocument = gql`
    query layoutComponents($cursor: String, $count: Int, $filters: LayoutComponentFilterInput) {
  layoutComponents(first: $count, after: $cursor, filters: $filters) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...layoutComponentFragment
      }
    }
  }
}
    ${LayoutComponentFragmentFragmentDoc}`;

/**
 * __useLayoutComponentsQuery__
 *
 * To run a query within a React component, call `useLayoutComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutComponentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      count: // value for 'count'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLayoutComponentsQuery(baseOptions?: Apollo.QueryHookOptions<LayoutComponentsQuery, LayoutComponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutComponentsQuery, LayoutComponentsQueryVariables>(LayoutComponentsDocument, options);
      }
export function useLayoutComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutComponentsQuery, LayoutComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutComponentsQuery, LayoutComponentsQueryVariables>(LayoutComponentsDocument, options);
        }
export function useLayoutComponentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutComponentsQuery, LayoutComponentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutComponentsQuery, LayoutComponentsQueryVariables>(LayoutComponentsDocument, options);
        }
export type LayoutComponentsQueryHookResult = ReturnType<typeof useLayoutComponentsQuery>;
export type LayoutComponentsLazyQueryHookResult = ReturnType<typeof useLayoutComponentsLazyQuery>;
export type LayoutComponentsSuspenseQueryHookResult = ReturnType<typeof useLayoutComponentsSuspenseQuery>;
export type LayoutComponentsQueryResult = Apollo.QueryResult<LayoutComponentsQuery, LayoutComponentsQueryVariables>;
export const GetCreativeContentBlockConfigsDocument = gql`
    query GetCreativeContentBlockConfigs($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    __typename
    contentBlockConfigs {
      ...ContentBlockConfigsFields
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;

/**
 * __useGetCreativeContentBlockConfigsQuery__
 *
 * To run a query within a React component, call `useGetCreativeContentBlockConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeContentBlockConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeContentBlockConfigsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeContentBlockConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables> & ({ variables: GetCreativeContentBlockConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables>(GetCreativeContentBlockConfigsDocument, options);
      }
export function useGetCreativeContentBlockConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables>(GetCreativeContentBlockConfigsDocument, options);
        }
export function useGetCreativeContentBlockConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables>(GetCreativeContentBlockConfigsDocument, options);
        }
export type GetCreativeContentBlockConfigsQueryHookResult = ReturnType<typeof useGetCreativeContentBlockConfigsQuery>;
export type GetCreativeContentBlockConfigsLazyQueryHookResult = ReturnType<typeof useGetCreativeContentBlockConfigsLazyQuery>;
export type GetCreativeContentBlockConfigsSuspenseQueryHookResult = ReturnType<typeof useGetCreativeContentBlockConfigsSuspenseQuery>;
export type GetCreativeContentBlockConfigsQueryResult = Apollo.QueryResult<GetCreativeContentBlockConfigsQuery, GetCreativeContentBlockConfigsQueryVariables>;
export const CreateEmptyHtmlBundleDocument = gql`
    mutation CreateEmptyHtmlBundle($creativeId: ID!, $templateTagId: ID!, $title: String!) {
  creativeTemplateTagHtmlBundleCreate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    title: $title
  ) {
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type CreateEmptyHtmlBundleMutationFn = Apollo.MutationFunction<CreateEmptyHtmlBundleMutation, CreateEmptyHtmlBundleMutationVariables>;

/**
 * __useCreateEmptyHtmlBundleMutation__
 *
 * To run a mutation, you first call `useCreateEmptyHtmlBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmptyHtmlBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmptyHtmlBundleMutation, { data, loading, error }] = useCreateEmptyHtmlBundleMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateEmptyHtmlBundleMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmptyHtmlBundleMutation, CreateEmptyHtmlBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmptyHtmlBundleMutation, CreateEmptyHtmlBundleMutationVariables>(CreateEmptyHtmlBundleDocument, options);
      }
export type CreateEmptyHtmlBundleMutationHookResult = ReturnType<typeof useCreateEmptyHtmlBundleMutation>;
export type CreateEmptyHtmlBundleMutationResult = Apollo.MutationResult<CreateEmptyHtmlBundleMutation>;
export type CreateEmptyHtmlBundleMutationOptions = Apollo.BaseMutationOptions<CreateEmptyHtmlBundleMutation, CreateEmptyHtmlBundleMutationVariables>;
export const UpdateCreativeTextTemplateTagDocument = gql`
    mutation UpdateCreativeTextTemplateTag($creativeId: ID!, $templateTagId: ID!, $text: String!) {
  creativeTextTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    text: $text
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeTextTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeTextTemplateTagMutation, UpdateCreativeTextTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeTextTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeTextTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeTextTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeTextTemplateTagMutation, { data, loading, error }] = useUpdateCreativeTextTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCreativeTextTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeTextTemplateTagMutation, UpdateCreativeTextTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeTextTemplateTagMutation, UpdateCreativeTextTemplateTagMutationVariables>(UpdateCreativeTextTemplateTagDocument, options);
      }
export type UpdateCreativeTextTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeTextTemplateTagMutation>;
export type UpdateCreativeTextTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeTextTemplateTagMutation>;
export type UpdateCreativeTextTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeTextTemplateTagMutation, UpdateCreativeTextTemplateTagMutationVariables>;
export const UpdateCreativeCheckboxTemplateTagDocument = gql`
    mutation UpdateCreativeCheckboxTemplateTag($creativeId: ID!, $templateTagId: ID!, $checkboxValue: Boolean) {
  creativeCheckboxTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    checked: $checkboxValue
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeCheckboxTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeCheckboxTemplateTagMutation, UpdateCreativeCheckboxTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeCheckboxTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeCheckboxTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeCheckboxTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeCheckboxTemplateTagMutation, { data, loading, error }] = useUpdateCreativeCheckboxTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      checkboxValue: // value for 'checkboxValue'
 *   },
 * });
 */
export function useUpdateCreativeCheckboxTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeCheckboxTemplateTagMutation, UpdateCreativeCheckboxTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeCheckboxTemplateTagMutation, UpdateCreativeCheckboxTemplateTagMutationVariables>(UpdateCreativeCheckboxTemplateTagDocument, options);
      }
export type UpdateCreativeCheckboxTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeCheckboxTemplateTagMutation>;
export type UpdateCreativeCheckboxTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeCheckboxTemplateTagMutation>;
export type UpdateCreativeCheckboxTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeCheckboxTemplateTagMutation, UpdateCreativeCheckboxTemplateTagMutationVariables>;
export const UpdateCreativeDateTemplateTagDocument = gql`
    mutation UpdateCreativeDateTemplateTag($creativeId: ID!, $templateTagId: ID!, $dateValue: Date) {
  creativeDateTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    date: $dateValue
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeDateTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeDateTemplateTagMutation, UpdateCreativeDateTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeDateTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeDateTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeDateTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeDateTemplateTagMutation, { data, loading, error }] = useUpdateCreativeDateTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      dateValue: // value for 'dateValue'
 *   },
 * });
 */
export function useUpdateCreativeDateTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeDateTemplateTagMutation, UpdateCreativeDateTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeDateTemplateTagMutation, UpdateCreativeDateTemplateTagMutationVariables>(UpdateCreativeDateTemplateTagDocument, options);
      }
export type UpdateCreativeDateTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeDateTemplateTagMutation>;
export type UpdateCreativeDateTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeDateTemplateTagMutation>;
export type UpdateCreativeDateTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeDateTemplateTagMutation, UpdateCreativeDateTemplateTagMutationVariables>;
export const UpdateCreativeLinkTemplateTagDocument = gql`
    mutation UpdateCreativeLinkTemplateTag($creativeId: ID!, $templateTagId: ID!, $linkValue: ID) {
  creativeUrlTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    linkId: $linkValue
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeLinkTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeLinkTemplateTagMutation, UpdateCreativeLinkTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeLinkTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeLinkTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeLinkTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeLinkTemplateTagMutation, { data, loading, error }] = useUpdateCreativeLinkTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      linkValue: // value for 'linkValue'
 *   },
 * });
 */
export function useUpdateCreativeLinkTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeLinkTemplateTagMutation, UpdateCreativeLinkTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeLinkTemplateTagMutation, UpdateCreativeLinkTemplateTagMutationVariables>(UpdateCreativeLinkTemplateTagDocument, options);
      }
export type UpdateCreativeLinkTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeLinkTemplateTagMutation>;
export type UpdateCreativeLinkTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeLinkTemplateTagMutation>;
export type UpdateCreativeLinkTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeLinkTemplateTagMutation, UpdateCreativeLinkTemplateTagMutationVariables>;
export const UpdateCreativeSelectTemplateTagDocument = gql`
    mutation UpdateCreativeSelectTemplateTag($creativeId: ID!, $templateTagId: ID!, $choiceId: ID) {
  creativeSelectTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    choiceId: $choiceId
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeSelectTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeSelectTemplateTagMutation, UpdateCreativeSelectTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeSelectTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeSelectTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeSelectTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeSelectTemplateTagMutation, { data, loading, error }] = useUpdateCreativeSelectTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      choiceId: // value for 'choiceId'
 *   },
 * });
 */
export function useUpdateCreativeSelectTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeSelectTemplateTagMutation, UpdateCreativeSelectTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeSelectTemplateTagMutation, UpdateCreativeSelectTemplateTagMutationVariables>(UpdateCreativeSelectTemplateTagDocument, options);
      }
export type UpdateCreativeSelectTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeSelectTemplateTagMutation>;
export type UpdateCreativeSelectTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeSelectTemplateTagMutation>;
export type UpdateCreativeSelectTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeSelectTemplateTagMutation, UpdateCreativeSelectTemplateTagMutationVariables>;
export const UpdateCreativeMultiSelectTemplateTagDocument = gql`
    mutation UpdateCreativeMultiSelectTemplateTag($creativeId: ID!, $templateTagId: ID!, $choiceIds: [ID!]) {
  creativeMultiSelectTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    choiceIds: $choiceIds
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeMultiSelectTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeMultiSelectTemplateTagMutation, UpdateCreativeMultiSelectTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeMultiSelectTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeMultiSelectTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeMultiSelectTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeMultiSelectTemplateTagMutation, { data, loading, error }] = useUpdateCreativeMultiSelectTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      choiceIds: // value for 'choiceIds'
 *   },
 * });
 */
export function useUpdateCreativeMultiSelectTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeMultiSelectTemplateTagMutation, UpdateCreativeMultiSelectTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeMultiSelectTemplateTagMutation, UpdateCreativeMultiSelectTemplateTagMutationVariables>(UpdateCreativeMultiSelectTemplateTagDocument, options);
      }
export type UpdateCreativeMultiSelectTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeMultiSelectTemplateTagMutation>;
export type UpdateCreativeMultiSelectTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeMultiSelectTemplateTagMutation>;
export type UpdateCreativeMultiSelectTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeMultiSelectTemplateTagMutation, UpdateCreativeMultiSelectTemplateTagMutationVariables>;
export const UpdateCreativeImageTemplateTagDocument = gql`
    mutation UpdateCreativeImageTemplateTag($creativeId: ID!, $templateTagId: ID!, $image: ImageContentInput) {
  creativeImageTemplateTagUpdate(
    creativeId: $creativeId
    templateTagId: $templateTagId
    image: $image
  ) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type UpdateCreativeImageTemplateTagMutationFn = Apollo.MutationFunction<UpdateCreativeImageTemplateTagMutation, UpdateCreativeImageTemplateTagMutationVariables>;

/**
 * __useUpdateCreativeImageTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeImageTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeImageTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeImageTemplateTagMutation, { data, loading, error }] = useUpdateCreativeImageTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdateCreativeImageTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeImageTemplateTagMutation, UpdateCreativeImageTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeImageTemplateTagMutation, UpdateCreativeImageTemplateTagMutationVariables>(UpdateCreativeImageTemplateTagDocument, options);
      }
export type UpdateCreativeImageTemplateTagMutationHookResult = ReturnType<typeof useUpdateCreativeImageTemplateTagMutation>;
export type UpdateCreativeImageTemplateTagMutationResult = Apollo.MutationResult<UpdateCreativeImageTemplateTagMutation>;
export type UpdateCreativeImageTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeImageTemplateTagMutation, UpdateCreativeImageTemplateTagMutationVariables>;
export const ClearCreativeTemplateTagDocument = gql`
    mutation ClearCreativeTemplateTag($creativeId: ID!, $templateTagId: ID!) {
  creativeTemplateTagClear(creativeId: $creativeId, templateTagId: $templateTagId) {
    success
    creative {
      id
      __typename
      contentBlockConfigs {
        ...ContentBlockConfigsFields
      }
    }
  }
}
    ${ContentBlockConfigsFieldsFragmentDoc}`;
export type ClearCreativeTemplateTagMutationFn = Apollo.MutationFunction<ClearCreativeTemplateTagMutation, ClearCreativeTemplateTagMutationVariables>;

/**
 * __useClearCreativeTemplateTagMutation__
 *
 * To run a mutation, you first call `useClearCreativeTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCreativeTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCreativeTemplateTagMutation, { data, loading, error }] = useClearCreativeTemplateTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      templateTagId: // value for 'templateTagId'
 *   },
 * });
 */
export function useClearCreativeTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<ClearCreativeTemplateTagMutation, ClearCreativeTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearCreativeTemplateTagMutation, ClearCreativeTemplateTagMutationVariables>(ClearCreativeTemplateTagDocument, options);
      }
export type ClearCreativeTemplateTagMutationHookResult = ReturnType<typeof useClearCreativeTemplateTagMutation>;
export type ClearCreativeTemplateTagMutationResult = Apollo.MutationResult<ClearCreativeTemplateTagMutation>;
export type ClearCreativeTemplateTagMutationOptions = Apollo.BaseMutationOptions<ClearCreativeTemplateTagMutation, ClearCreativeTemplateTagMutationVariables>;
export const GetCreativeContentBlockConfigThumbnailsDocument = gql`
    query GetCreativeContentBlockConfigThumbnails($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    __typename
    contentBlockConfigs {
      __typename
      thumbnails {
        __typename
        url
      }
    }
  }
}
    `;

/**
 * __useGetCreativeContentBlockConfigThumbnailsQuery__
 *
 * To run a query within a React component, call `useGetCreativeContentBlockConfigThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeContentBlockConfigThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeContentBlockConfigThumbnailsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeContentBlockConfigThumbnailsQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables> & ({ variables: GetCreativeContentBlockConfigThumbnailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables>(GetCreativeContentBlockConfigThumbnailsDocument, options);
      }
export function useGetCreativeContentBlockConfigThumbnailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables>(GetCreativeContentBlockConfigThumbnailsDocument, options);
        }
export function useGetCreativeContentBlockConfigThumbnailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables>(GetCreativeContentBlockConfigThumbnailsDocument, options);
        }
export type GetCreativeContentBlockConfigThumbnailsQueryHookResult = ReturnType<typeof useGetCreativeContentBlockConfigThumbnailsQuery>;
export type GetCreativeContentBlockConfigThumbnailsLazyQueryHookResult = ReturnType<typeof useGetCreativeContentBlockConfigThumbnailsLazyQuery>;
export type GetCreativeContentBlockConfigThumbnailsSuspenseQueryHookResult = ReturnType<typeof useGetCreativeContentBlockConfigThumbnailsSuspenseQuery>;
export type GetCreativeContentBlockConfigThumbnailsQueryResult = Apollo.QueryResult<GetCreativeContentBlockConfigThumbnailsQuery, GetCreativeContentBlockConfigThumbnailsQueryVariables>;
export const GetCreativeContentsDocument = gql`
    query GetCreativeContents($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    __typename
    thumbnails {
      url
    }
    contents {
      id
      channel
      languageCode
      ... on PushNotification {
        title
        body
        media {
          ...mediaFields
        }
      }
      ... on TextMessage {
        body
        media {
          ...mediaFields
        }
      }
    }
  }
}
    ${MediaFieldsFragmentDoc}`;

/**
 * __useGetCreativeContentsQuery__
 *
 * To run a query within a React component, call `useGetCreativeContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeContentsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeContentsQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeContentsQuery, GetCreativeContentsQueryVariables> & ({ variables: GetCreativeContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeContentsQuery, GetCreativeContentsQueryVariables>(GetCreativeContentsDocument, options);
      }
export function useGetCreativeContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeContentsQuery, GetCreativeContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeContentsQuery, GetCreativeContentsQueryVariables>(GetCreativeContentsDocument, options);
        }
export function useGetCreativeContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeContentsQuery, GetCreativeContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeContentsQuery, GetCreativeContentsQueryVariables>(GetCreativeContentsDocument, options);
        }
export type GetCreativeContentsQueryHookResult = ReturnType<typeof useGetCreativeContentsQuery>;
export type GetCreativeContentsLazyQueryHookResult = ReturnType<typeof useGetCreativeContentsLazyQuery>;
export type GetCreativeContentsSuspenseQueryHookResult = ReturnType<typeof useGetCreativeContentsSuspenseQuery>;
export type GetCreativeContentsQueryResult = Apollo.QueryResult<GetCreativeContentsQuery, GetCreativeContentsQueryVariables>;
export const GetContentVariantsDocument = gql`
    query GetContentVariants($id: ID!) {
  creative(id: $id) {
    id
    title
    contentVariants {
      id
      languageCode
      disclaimer
      subjectLinePrefix
      subjectLineSuffix
      availabilities
      subjectLines {
        id
        content
      }
    }
  }
}
    `;

/**
 * __useGetContentVariantsQuery__
 *
 * To run a query within a React component, call `useGetContentVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentVariantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentVariantsQuery(baseOptions: Apollo.QueryHookOptions<GetContentVariantsQuery, GetContentVariantsQueryVariables> & ({ variables: GetContentVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentVariantsQuery, GetContentVariantsQueryVariables>(GetContentVariantsDocument, options);
      }
export function useGetContentVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentVariantsQuery, GetContentVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentVariantsQuery, GetContentVariantsQueryVariables>(GetContentVariantsDocument, options);
        }
export function useGetContentVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentVariantsQuery, GetContentVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentVariantsQuery, GetContentVariantsQueryVariables>(GetContentVariantsDocument, options);
        }
export type GetContentVariantsQueryHookResult = ReturnType<typeof useGetContentVariantsQuery>;
export type GetContentVariantsLazyQueryHookResult = ReturnType<typeof useGetContentVariantsLazyQuery>;
export type GetContentVariantsSuspenseQueryHookResult = ReturnType<typeof useGetContentVariantsSuspenseQuery>;
export type GetContentVariantsQueryResult = Apollo.QueryResult<GetContentVariantsQuery, GetContentVariantsQueryVariables>;
export const GetCampaignsWithContentChangesDocument = gql`
    query GetCampaignsWithContentChanges($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    campaignsWithNewerCreativeVersion {
      id
      title
      stage
      status
    }
  }
}
    `;

/**
 * __useGetCampaignsWithContentChangesQuery__
 *
 * To run a query within a React component, call `useGetCampaignsWithContentChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsWithContentChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsWithContentChangesQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCampaignsWithContentChangesQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables> & ({ variables: GetCampaignsWithContentChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables>(GetCampaignsWithContentChangesDocument, options);
      }
export function useGetCampaignsWithContentChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables>(GetCampaignsWithContentChangesDocument, options);
        }
export function useGetCampaignsWithContentChangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables>(GetCampaignsWithContentChangesDocument, options);
        }
export type GetCampaignsWithContentChangesQueryHookResult = ReturnType<typeof useGetCampaignsWithContentChangesQuery>;
export type GetCampaignsWithContentChangesLazyQueryHookResult = ReturnType<typeof useGetCampaignsWithContentChangesLazyQuery>;
export type GetCampaignsWithContentChangesSuspenseQueryHookResult = ReturnType<typeof useGetCampaignsWithContentChangesSuspenseQuery>;
export type GetCampaignsWithContentChangesQueryResult = Apollo.QueryResult<GetCampaignsWithContentChangesQuery, GetCampaignsWithContentChangesQueryVariables>;
export const GetCreativeDisclaimerTextDocument = gql`
    query GetCreativeDisclaimerText($creativeId: ID!) {
  creative(id: $creativeId) {
    ...creativeDisclaimerTextFragment
  }
}
    ${CreativeDisclaimerTextFragmentFragmentDoc}`;

/**
 * __useGetCreativeDisclaimerTextQuery__
 *
 * To run a query within a React component, call `useGetCreativeDisclaimerTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeDisclaimerTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeDisclaimerTextQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeDisclaimerTextQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables> & ({ variables: GetCreativeDisclaimerTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables>(GetCreativeDisclaimerTextDocument, options);
      }
export function useGetCreativeDisclaimerTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables>(GetCreativeDisclaimerTextDocument, options);
        }
export function useGetCreativeDisclaimerTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables>(GetCreativeDisclaimerTextDocument, options);
        }
export type GetCreativeDisclaimerTextQueryHookResult = ReturnType<typeof useGetCreativeDisclaimerTextQuery>;
export type GetCreativeDisclaimerTextLazyQueryHookResult = ReturnType<typeof useGetCreativeDisclaimerTextLazyQuery>;
export type GetCreativeDisclaimerTextSuspenseQueryHookResult = ReturnType<typeof useGetCreativeDisclaimerTextSuspenseQuery>;
export type GetCreativeDisclaimerTextQueryResult = Apollo.QueryResult<GetCreativeDisclaimerTextQuery, GetCreativeDisclaimerTextQueryVariables>;
export const UpdateCreativeDisclaimerTextDocument = gql`
    mutation UpdateCreativeDisclaimerText($creativeId: ID!, $disclaimer: String!) {
  creativeDisclaimerUpdate(creativeId: $creativeId, disclaimer: $disclaimer) {
    success
    creative {
      ...creativeDisclaimerTextFragment
    }
  }
}
    ${CreativeDisclaimerTextFragmentFragmentDoc}`;
export type UpdateCreativeDisclaimerTextMutationFn = Apollo.MutationFunction<UpdateCreativeDisclaimerTextMutation, UpdateCreativeDisclaimerTextMutationVariables>;

/**
 * __useUpdateCreativeDisclaimerTextMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeDisclaimerTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeDisclaimerTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeDisclaimerTextMutation, { data, loading, error }] = useUpdateCreativeDisclaimerTextMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      disclaimer: // value for 'disclaimer'
 *   },
 * });
 */
export function useUpdateCreativeDisclaimerTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeDisclaimerTextMutation, UpdateCreativeDisclaimerTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeDisclaimerTextMutation, UpdateCreativeDisclaimerTextMutationVariables>(UpdateCreativeDisclaimerTextDocument, options);
      }
export type UpdateCreativeDisclaimerTextMutationHookResult = ReturnType<typeof useUpdateCreativeDisclaimerTextMutation>;
export type UpdateCreativeDisclaimerTextMutationResult = Apollo.MutationResult<UpdateCreativeDisclaimerTextMutation>;
export type UpdateCreativeDisclaimerTextMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeDisclaimerTextMutation, UpdateCreativeDisclaimerTextMutationVariables>;
export const GetCreativeDisclaimerLayoutDocument = gql`
    query GetCreativeDisclaimerLayout($creativeId: ID!, $format: DocumentFormat!) {
  creative(id: $creativeId) {
    id
    __typename
    disclaimerLayout {
      document(format: $format)
      ...disclaimerLayoutFragment
    }
  }
}
    ${DisclaimerLayoutFragmentFragmentDoc}`;

/**
 * __useGetCreativeDisclaimerLayoutQuery__
 *
 * To run a query within a React component, call `useGetCreativeDisclaimerLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeDisclaimerLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeDisclaimerLayoutQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGetCreativeDisclaimerLayoutQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables> & ({ variables: GetCreativeDisclaimerLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables>(GetCreativeDisclaimerLayoutDocument, options);
      }
export function useGetCreativeDisclaimerLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables>(GetCreativeDisclaimerLayoutDocument, options);
        }
export function useGetCreativeDisclaimerLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables>(GetCreativeDisclaimerLayoutDocument, options);
        }
export type GetCreativeDisclaimerLayoutQueryHookResult = ReturnType<typeof useGetCreativeDisclaimerLayoutQuery>;
export type GetCreativeDisclaimerLayoutLazyQueryHookResult = ReturnType<typeof useGetCreativeDisclaimerLayoutLazyQuery>;
export type GetCreativeDisclaimerLayoutSuspenseQueryHookResult = ReturnType<typeof useGetCreativeDisclaimerLayoutSuspenseQuery>;
export type GetCreativeDisclaimerLayoutQueryResult = Apollo.QueryResult<GetCreativeDisclaimerLayoutQuery, GetCreativeDisclaimerLayoutQueryVariables>;
export const UpdateCreativeDisclaimerLayoutDocument = gql`
    mutation UpdateCreativeDisclaimerLayout($creativeId: ID!, $document: LayoutDocument!) {
  disclaimerLayoutSave(creativeId: $creativeId, document: $document) {
    success
  }
}
    `;
export type UpdateCreativeDisclaimerLayoutMutationFn = Apollo.MutationFunction<UpdateCreativeDisclaimerLayoutMutation, UpdateCreativeDisclaimerLayoutMutationVariables>;

/**
 * __useUpdateCreativeDisclaimerLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeDisclaimerLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeDisclaimerLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeDisclaimerLayoutMutation, { data, loading, error }] = useUpdateCreativeDisclaimerLayoutMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useUpdateCreativeDisclaimerLayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeDisclaimerLayoutMutation, UpdateCreativeDisclaimerLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeDisclaimerLayoutMutation, UpdateCreativeDisclaimerLayoutMutationVariables>(UpdateCreativeDisclaimerLayoutDocument, options);
      }
export type UpdateCreativeDisclaimerLayoutMutationHookResult = ReturnType<typeof useUpdateCreativeDisclaimerLayoutMutation>;
export type UpdateCreativeDisclaimerLayoutMutationResult = Apollo.MutationResult<UpdateCreativeDisclaimerLayoutMutation>;
export type UpdateCreativeDisclaimerLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeDisclaimerLayoutMutation, UpdateCreativeDisclaimerLayoutMutationVariables>;
export const ClearCreativeDisclaimerLayoutDocument = gql`
    mutation ClearCreativeDisclaimerLayout($creativeId: ID!) {
  disclaimerLayoutClear(creativeId: $creativeId) {
    success
    creative {
      id
      __typename
      disclaimerLayout {
        document(format: V1)
        ...disclaimerLayoutFragment
      }
    }
  }
}
    ${DisclaimerLayoutFragmentFragmentDoc}`;
export type ClearCreativeDisclaimerLayoutMutationFn = Apollo.MutationFunction<ClearCreativeDisclaimerLayoutMutation, ClearCreativeDisclaimerLayoutMutationVariables>;

/**
 * __useClearCreativeDisclaimerLayoutMutation__
 *
 * To run a mutation, you first call `useClearCreativeDisclaimerLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCreativeDisclaimerLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCreativeDisclaimerLayoutMutation, { data, loading, error }] = useClearCreativeDisclaimerLayoutMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useClearCreativeDisclaimerLayoutMutation(baseOptions?: Apollo.MutationHookOptions<ClearCreativeDisclaimerLayoutMutation, ClearCreativeDisclaimerLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearCreativeDisclaimerLayoutMutation, ClearCreativeDisclaimerLayoutMutationVariables>(ClearCreativeDisclaimerLayoutDocument, options);
      }
export type ClearCreativeDisclaimerLayoutMutationHookResult = ReturnType<typeof useClearCreativeDisclaimerLayoutMutation>;
export type ClearCreativeDisclaimerLayoutMutationResult = Apollo.MutationResult<ClearCreativeDisclaimerLayoutMutation>;
export type ClearCreativeDisclaimerLayoutMutationOptions = Apollo.BaseMutationOptions<ClearCreativeDisclaimerLayoutMutation, ClearCreativeDisclaimerLayoutMutationVariables>;
export const DisclaimerLayoutStudioCampaignImportDocument = gql`
    mutation disclaimerLayoutStudioCampaignImport($creativeId: ID!, $studioCampaignId: ID!, $studioBlockIds: [ID!]!, $format: DocumentFormat!) {
  disclaimerStudioCampaignImport(
    creativeId: $creativeId
    studioCampaignId: $studioCampaignId
    studioBlockIds: $studioBlockIds
  ) {
    success
    layout {
      id
      document(format: $format)
      ...disclaimerLayoutFragment
    }
  }
}
    ${DisclaimerLayoutFragmentFragmentDoc}`;
export type DisclaimerLayoutStudioCampaignImportMutationFn = Apollo.MutationFunction<DisclaimerLayoutStudioCampaignImportMutation, DisclaimerLayoutStudioCampaignImportMutationVariables>;

/**
 * __useDisclaimerLayoutStudioCampaignImportMutation__
 *
 * To run a mutation, you first call `useDisclaimerLayoutStudioCampaignImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisclaimerLayoutStudioCampaignImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disclaimerLayoutStudioCampaignImportMutation, { data, loading, error }] = useDisclaimerLayoutStudioCampaignImportMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      studioCampaignId: // value for 'studioCampaignId'
 *      studioBlockIds: // value for 'studioBlockIds'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useDisclaimerLayoutStudioCampaignImportMutation(baseOptions?: Apollo.MutationHookOptions<DisclaimerLayoutStudioCampaignImportMutation, DisclaimerLayoutStudioCampaignImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisclaimerLayoutStudioCampaignImportMutation, DisclaimerLayoutStudioCampaignImportMutationVariables>(DisclaimerLayoutStudioCampaignImportDocument, options);
      }
export type DisclaimerLayoutStudioCampaignImportMutationHookResult = ReturnType<typeof useDisclaimerLayoutStudioCampaignImportMutation>;
export type DisclaimerLayoutStudioCampaignImportMutationResult = Apollo.MutationResult<DisclaimerLayoutStudioCampaignImportMutation>;
export type DisclaimerLayoutStudioCampaignImportMutationOptions = Apollo.BaseMutationOptions<DisclaimerLayoutStudioCampaignImportMutation, DisclaimerLayoutStudioCampaignImportMutationVariables>;
export const CreativesContactAudiencesDocument = gql`
    query CreativesContactAudiences($limit: Int, $offset: Int, $search: String, $types: [ContactAudienceType!], $orderBy: ContactAudiencesOrderBy, $archived: Boolean) {
  contactAudiences(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    types: $types
    search: $search
    archived: $archived
  ) {
    audiences {
      id
      name
      type
      splits {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCreativesContactAudiencesQuery__
 *
 * To run a query within a React component, call `useCreativesContactAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativesContactAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativesContactAudiencesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      orderBy: // value for 'orderBy'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useCreativesContactAudiencesQuery(baseOptions?: Apollo.QueryHookOptions<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>(CreativesContactAudiencesDocument, options);
      }
export function useCreativesContactAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>(CreativesContactAudiencesDocument, options);
        }
export function useCreativesContactAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>(CreativesContactAudiencesDocument, options);
        }
export type CreativesContactAudiencesQueryHookResult = ReturnType<typeof useCreativesContactAudiencesQuery>;
export type CreativesContactAudiencesLazyQueryHookResult = ReturnType<typeof useCreativesContactAudiencesLazyQuery>;
export type CreativesContactAudiencesSuspenseQueryHookResult = ReturnType<typeof useCreativesContactAudiencesSuspenseQuery>;
export type CreativesContactAudiencesQueryResult = Apollo.QueryResult<CreativesContactAudiencesQuery, CreativesContactAudiencesQueryVariables>;
export const GetLegacyAudiencesDocument = gql`
    query GetLegacyAudiences($page: Int!, $pageSize: Int, $search: String, $types: [AudienceType!]) {
  audiences(page: $page, pageSize: $pageSize, types: $types, search: $search) {
    __typename
    results {
      id
      title
    }
  }
}
    `;

/**
 * __useGetLegacyAudiencesQuery__
 *
 * To run a query within a React component, call `useGetLegacyAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegacyAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegacyAudiencesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetLegacyAudiencesQuery(baseOptions: Apollo.QueryHookOptions<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables> & ({ variables: GetLegacyAudiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables>(GetLegacyAudiencesDocument, options);
      }
export function useGetLegacyAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables>(GetLegacyAudiencesDocument, options);
        }
export function useGetLegacyAudiencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables>(GetLegacyAudiencesDocument, options);
        }
export type GetLegacyAudiencesQueryHookResult = ReturnType<typeof useGetLegacyAudiencesQuery>;
export type GetLegacyAudiencesLazyQueryHookResult = ReturnType<typeof useGetLegacyAudiencesLazyQuery>;
export type GetLegacyAudiencesSuspenseQueryHookResult = ReturnType<typeof useGetLegacyAudiencesSuspenseQuery>;
export type GetLegacyAudiencesQueryResult = Apollo.QueryResult<GetLegacyAudiencesQuery, GetLegacyAudiencesQueryVariables>;
export const GetFiltersTabValuesDocument = gql`
    query GetFiltersTabValues($id: ID!) {
  creative(id: $id) {
    id
    status
    pairedCreatives {
      id
      title
    }
    pairedTags {
      id
      name
    }
    prohibitedCreatives {
      id
      title
    }
    prohibitedTags {
      id
      name
    }
    creativeFilters {
      audienceId
      splitId
      audienceName
      splitName
      archived
    }
    legacyFilter {
      id
      title
    }
  }
}
    `;

/**
 * __useGetFiltersTabValuesQuery__
 *
 * To run a query within a React component, call `useGetFiltersTabValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltersTabValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltersTabValuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFiltersTabValuesQuery(baseOptions: Apollo.QueryHookOptions<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables> & ({ variables: GetFiltersTabValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables>(GetFiltersTabValuesDocument, options);
      }
export function useGetFiltersTabValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables>(GetFiltersTabValuesDocument, options);
        }
export function useGetFiltersTabValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables>(GetFiltersTabValuesDocument, options);
        }
export type GetFiltersTabValuesQueryHookResult = ReturnType<typeof useGetFiltersTabValuesQuery>;
export type GetFiltersTabValuesLazyQueryHookResult = ReturnType<typeof useGetFiltersTabValuesLazyQuery>;
export type GetFiltersTabValuesSuspenseQueryHookResult = ReturnType<typeof useGetFiltersTabValuesSuspenseQuery>;
export type GetFiltersTabValuesQueryResult = Apollo.QueryResult<GetFiltersTabValuesQuery, GetFiltersTabValuesQueryVariables>;
export const GetFiltersTabTagsDocument = gql`
    query GetFiltersTabTags {
  tags {
    id
    name
  }
}
    `;

/**
 * __useGetFiltersTabTagsQuery__
 *
 * To run a query within a React component, call `useGetFiltersTabTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltersTabTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltersTabTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFiltersTabTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>(GetFiltersTabTagsDocument, options);
      }
export function useGetFiltersTabTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>(GetFiltersTabTagsDocument, options);
        }
export function useGetFiltersTabTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>(GetFiltersTabTagsDocument, options);
        }
export type GetFiltersTabTagsQueryHookResult = ReturnType<typeof useGetFiltersTabTagsQuery>;
export type GetFiltersTabTagsLazyQueryHookResult = ReturnType<typeof useGetFiltersTabTagsLazyQuery>;
export type GetFiltersTabTagsSuspenseQueryHookResult = ReturnType<typeof useGetFiltersTabTagsSuspenseQuery>;
export type GetFiltersTabTagsQueryResult = Apollo.QueryResult<GetFiltersTabTagsQuery, GetFiltersTabTagsQueryVariables>;
export const GetFiltersTabCreativesDocument = gql`
    query GetFiltersTabCreatives($page: Int!, $pageSize: Int, $orderBy: [CreativeOrderBy!], $filter: CreativeFilter) {
  creatives(page: $page, pageSize: $pageSize, orderBy: $orderBy, filter: $filter) {
    __typename
    results {
      id
      title
    }
  }
}
    `;

/**
 * __useGetFiltersTabCreativesQuery__
 *
 * To run a query within a React component, call `useGetFiltersTabCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltersTabCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltersTabCreativesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFiltersTabCreativesQuery(baseOptions: Apollo.QueryHookOptions<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables> & ({ variables: GetFiltersTabCreativesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables>(GetFiltersTabCreativesDocument, options);
      }
export function useGetFiltersTabCreativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables>(GetFiltersTabCreativesDocument, options);
        }
export function useGetFiltersTabCreativesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables>(GetFiltersTabCreativesDocument, options);
        }
export type GetFiltersTabCreativesQueryHookResult = ReturnType<typeof useGetFiltersTabCreativesQuery>;
export type GetFiltersTabCreativesLazyQueryHookResult = ReturnType<typeof useGetFiltersTabCreativesLazyQuery>;
export type GetFiltersTabCreativesSuspenseQueryHookResult = ReturnType<typeof useGetFiltersTabCreativesSuspenseQuery>;
export type GetFiltersTabCreativesQueryResult = Apollo.QueryResult<GetFiltersTabCreativesQuery, GetFiltersTabCreativesQueryVariables>;
export const AddAudienceToCreativeDocument = gql`
    mutation AddAudienceToCreative($audienceId: ID!, $confirm: Boolean, $creativeId: ID!, $splitId: ID!) {
  creativeFiltersAdd(
    audienceId: $audienceId
    confirm: $confirm
    creativeId: $creativeId
    splitId: $splitId
  ) {
    success
    creative {
      id
      creativeFilters {
        audienceId
        splitId
      }
    }
  }
}
    `;
export type AddAudienceToCreativeMutationFn = Apollo.MutationFunction<AddAudienceToCreativeMutation, AddAudienceToCreativeMutationVariables>;

/**
 * __useAddAudienceToCreativeMutation__
 *
 * To run a mutation, you first call `useAddAudienceToCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAudienceToCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAudienceToCreativeMutation, { data, loading, error }] = useAddAudienceToCreativeMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      confirm: // value for 'confirm'
 *      creativeId: // value for 'creativeId'
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useAddAudienceToCreativeMutation(baseOptions?: Apollo.MutationHookOptions<AddAudienceToCreativeMutation, AddAudienceToCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAudienceToCreativeMutation, AddAudienceToCreativeMutationVariables>(AddAudienceToCreativeDocument, options);
      }
export type AddAudienceToCreativeMutationHookResult = ReturnType<typeof useAddAudienceToCreativeMutation>;
export type AddAudienceToCreativeMutationResult = Apollo.MutationResult<AddAudienceToCreativeMutation>;
export type AddAudienceToCreativeMutationOptions = Apollo.BaseMutationOptions<AddAudienceToCreativeMutation, AddAudienceToCreativeMutationVariables>;
export const RemoveAudienceFromCreativeDocument = gql`
    mutation RemoveAudienceFromCreative($audienceId: ID!, $confirm: Boolean, $creativeId: ID!, $splitId: ID!) {
  creativeFiltersRemove(
    audienceId: $audienceId
    confirm: $confirm
    creativeId: $creativeId
    splitId: $splitId
  ) {
    success
    creative {
      id
      creativeFilters {
        audienceId
        splitId
      }
    }
  }
}
    `;
export type RemoveAudienceFromCreativeMutationFn = Apollo.MutationFunction<RemoveAudienceFromCreativeMutation, RemoveAudienceFromCreativeMutationVariables>;

/**
 * __useRemoveAudienceFromCreativeMutation__
 *
 * To run a mutation, you first call `useRemoveAudienceFromCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAudienceFromCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAudienceFromCreativeMutation, { data, loading, error }] = useRemoveAudienceFromCreativeMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      confirm: // value for 'confirm'
 *      creativeId: // value for 'creativeId'
 *      splitId: // value for 'splitId'
 *   },
 * });
 */
export function useRemoveAudienceFromCreativeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAudienceFromCreativeMutation, RemoveAudienceFromCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAudienceFromCreativeMutation, RemoveAudienceFromCreativeMutationVariables>(RemoveAudienceFromCreativeDocument, options);
      }
export type RemoveAudienceFromCreativeMutationHookResult = ReturnType<typeof useRemoveAudienceFromCreativeMutation>;
export type RemoveAudienceFromCreativeMutationResult = Apollo.MutationResult<RemoveAudienceFromCreativeMutation>;
export type RemoveAudienceFromCreativeMutationOptions = Apollo.BaseMutationOptions<RemoveAudienceFromCreativeMutation, RemoveAudienceFromCreativeMutationVariables>;
export const RemoveLegacyAudienceFromCreativeDocument = gql`
    mutation RemoveLegacyAudienceFromCreative($creativeId: ID!) {
  creativeLegacyFilterRemove(creativeId: $creativeId) {
    success
    creative {
      id
      legacyFilter {
        id
        title
      }
    }
  }
}
    `;
export type RemoveLegacyAudienceFromCreativeMutationFn = Apollo.MutationFunction<RemoveLegacyAudienceFromCreativeMutation, RemoveLegacyAudienceFromCreativeMutationVariables>;

/**
 * __useRemoveLegacyAudienceFromCreativeMutation__
 *
 * To run a mutation, you first call `useRemoveLegacyAudienceFromCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLegacyAudienceFromCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLegacyAudienceFromCreativeMutation, { data, loading, error }] = useRemoveLegacyAudienceFromCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useRemoveLegacyAudienceFromCreativeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLegacyAudienceFromCreativeMutation, RemoveLegacyAudienceFromCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLegacyAudienceFromCreativeMutation, RemoveLegacyAudienceFromCreativeMutationVariables>(RemoveLegacyAudienceFromCreativeDocument, options);
      }
export type RemoveLegacyAudienceFromCreativeMutationHookResult = ReturnType<typeof useRemoveLegacyAudienceFromCreativeMutation>;
export type RemoveLegacyAudienceFromCreativeMutationResult = Apollo.MutationResult<RemoveLegacyAudienceFromCreativeMutation>;
export type RemoveLegacyAudienceFromCreativeMutationOptions = Apollo.BaseMutationOptions<RemoveLegacyAudienceFromCreativeMutation, RemoveLegacyAudienceFromCreativeMutationVariables>;
export const AddLegacyAudienceToCreativeDocument = gql`
    mutation AddLegacyAudienceToCreative($creativeId: ID!, $audienceId: ID!) {
  creativeLegacyFilterAdd(creativeId: $creativeId, audienceId: $audienceId) {
    success
    creative {
      id
      legacyFilter {
        id
        title
      }
    }
  }
}
    `;
export type AddLegacyAudienceToCreativeMutationFn = Apollo.MutationFunction<AddLegacyAudienceToCreativeMutation, AddLegacyAudienceToCreativeMutationVariables>;

/**
 * __useAddLegacyAudienceToCreativeMutation__
 *
 * To run a mutation, you first call `useAddLegacyAudienceToCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLegacyAudienceToCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLegacyAudienceToCreativeMutation, { data, loading, error }] = useAddLegacyAudienceToCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAddLegacyAudienceToCreativeMutation(baseOptions?: Apollo.MutationHookOptions<AddLegacyAudienceToCreativeMutation, AddLegacyAudienceToCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLegacyAudienceToCreativeMutation, AddLegacyAudienceToCreativeMutationVariables>(AddLegacyAudienceToCreativeDocument, options);
      }
export type AddLegacyAudienceToCreativeMutationHookResult = ReturnType<typeof useAddLegacyAudienceToCreativeMutation>;
export type AddLegacyAudienceToCreativeMutationResult = Apollo.MutationResult<AddLegacyAudienceToCreativeMutation>;
export type AddLegacyAudienceToCreativeMutationOptions = Apollo.BaseMutationOptions<AddLegacyAudienceToCreativeMutation, AddLegacyAudienceToCreativeMutationVariables>;
export const AddPairedCreativeDocument = gql`
    mutation AddPairedCreative($creativeId: ID!, $pairedCreativeId: ID!) {
  creativePairedCreativeAdd(
    creativeId: $creativeId
    pairedCreativeId: $pairedCreativeId
  ) {
    success
    creative {
      id
      pairedCreatives {
        id
        title
      }
    }
  }
}
    `;
export type AddPairedCreativeMutationFn = Apollo.MutationFunction<AddPairedCreativeMutation, AddPairedCreativeMutationVariables>;

/**
 * __useAddPairedCreativeMutation__
 *
 * To run a mutation, you first call `useAddPairedCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPairedCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPairedCreativeMutation, { data, loading, error }] = useAddPairedCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      pairedCreativeId: // value for 'pairedCreativeId'
 *   },
 * });
 */
export function useAddPairedCreativeMutation(baseOptions?: Apollo.MutationHookOptions<AddPairedCreativeMutation, AddPairedCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPairedCreativeMutation, AddPairedCreativeMutationVariables>(AddPairedCreativeDocument, options);
      }
export type AddPairedCreativeMutationHookResult = ReturnType<typeof useAddPairedCreativeMutation>;
export type AddPairedCreativeMutationResult = Apollo.MutationResult<AddPairedCreativeMutation>;
export type AddPairedCreativeMutationOptions = Apollo.BaseMutationOptions<AddPairedCreativeMutation, AddPairedCreativeMutationVariables>;
export const RemovePairedCreativeDocument = gql`
    mutation RemovePairedCreative($creativeId: ID!, $pairedCreativeId: ID!) {
  creativePairedCreativeRemove(
    creativeId: $creativeId
    pairedCreativeId: $pairedCreativeId
  ) {
    success
    creative {
      id
      pairedCreatives {
        id
        title
      }
    }
  }
}
    `;
export type RemovePairedCreativeMutationFn = Apollo.MutationFunction<RemovePairedCreativeMutation, RemovePairedCreativeMutationVariables>;

/**
 * __useRemovePairedCreativeMutation__
 *
 * To run a mutation, you first call `useRemovePairedCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePairedCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePairedCreativeMutation, { data, loading, error }] = useRemovePairedCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      pairedCreativeId: // value for 'pairedCreativeId'
 *   },
 * });
 */
export function useRemovePairedCreativeMutation(baseOptions?: Apollo.MutationHookOptions<RemovePairedCreativeMutation, RemovePairedCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePairedCreativeMutation, RemovePairedCreativeMutationVariables>(RemovePairedCreativeDocument, options);
      }
export type RemovePairedCreativeMutationHookResult = ReturnType<typeof useRemovePairedCreativeMutation>;
export type RemovePairedCreativeMutationResult = Apollo.MutationResult<RemovePairedCreativeMutation>;
export type RemovePairedCreativeMutationOptions = Apollo.BaseMutationOptions<RemovePairedCreativeMutation, RemovePairedCreativeMutationVariables>;
export const AddPairedTagDocument = gql`
    mutation AddPairedTag($creativeId: ID!, $pairedTagId: ID!) {
  creativePairedCreativeByTagAdd(
    creativeId: $creativeId
    pairedTagId: $pairedTagId
  ) {
    success
    creative {
      id
      pairedTags {
        id
        name
      }
    }
  }
}
    `;
export type AddPairedTagMutationFn = Apollo.MutationFunction<AddPairedTagMutation, AddPairedTagMutationVariables>;

/**
 * __useAddPairedTagMutation__
 *
 * To run a mutation, you first call `useAddPairedTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPairedTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPairedTagMutation, { data, loading, error }] = useAddPairedTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      pairedTagId: // value for 'pairedTagId'
 *   },
 * });
 */
export function useAddPairedTagMutation(baseOptions?: Apollo.MutationHookOptions<AddPairedTagMutation, AddPairedTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPairedTagMutation, AddPairedTagMutationVariables>(AddPairedTagDocument, options);
      }
export type AddPairedTagMutationHookResult = ReturnType<typeof useAddPairedTagMutation>;
export type AddPairedTagMutationResult = Apollo.MutationResult<AddPairedTagMutation>;
export type AddPairedTagMutationOptions = Apollo.BaseMutationOptions<AddPairedTagMutation, AddPairedTagMutationVariables>;
export const RemovePairedTagDocument = gql`
    mutation RemovePairedTag($creativeId: ID!, $pairedTagId: ID!) {
  creativePairedCreativeByTagRemove(
    creativeId: $creativeId
    pairedTagId: $pairedTagId
  ) {
    success
    creative {
      id
      pairedTags {
        id
        name
      }
    }
  }
}
    `;
export type RemovePairedTagMutationFn = Apollo.MutationFunction<RemovePairedTagMutation, RemovePairedTagMutationVariables>;

/**
 * __useRemovePairedTagMutation__
 *
 * To run a mutation, you first call `useRemovePairedTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePairedTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePairedTagMutation, { data, loading, error }] = useRemovePairedTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      pairedTagId: // value for 'pairedTagId'
 *   },
 * });
 */
export function useRemovePairedTagMutation(baseOptions?: Apollo.MutationHookOptions<RemovePairedTagMutation, RemovePairedTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePairedTagMutation, RemovePairedTagMutationVariables>(RemovePairedTagDocument, options);
      }
export type RemovePairedTagMutationHookResult = ReturnType<typeof useRemovePairedTagMutation>;
export type RemovePairedTagMutationResult = Apollo.MutationResult<RemovePairedTagMutation>;
export type RemovePairedTagMutationOptions = Apollo.BaseMutationOptions<RemovePairedTagMutation, RemovePairedTagMutationVariables>;
export const AddProhibitedCreativeDocument = gql`
    mutation AddProhibitedCreative($creativeId: ID!, $prohibitedCreativeId: ID!) {
  creativeProhibitedCreativePairingAdd(
    creativeId: $creativeId
    prohibitedCreativeId: $prohibitedCreativeId
  ) {
    success
    creative {
      id
      prohibitedCreatives {
        id
        title
      }
    }
  }
}
    `;
export type AddProhibitedCreativeMutationFn = Apollo.MutationFunction<AddProhibitedCreativeMutation, AddProhibitedCreativeMutationVariables>;

/**
 * __useAddProhibitedCreativeMutation__
 *
 * To run a mutation, you first call `useAddProhibitedCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProhibitedCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProhibitedCreativeMutation, { data, loading, error }] = useAddProhibitedCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      prohibitedCreativeId: // value for 'prohibitedCreativeId'
 *   },
 * });
 */
export function useAddProhibitedCreativeMutation(baseOptions?: Apollo.MutationHookOptions<AddProhibitedCreativeMutation, AddProhibitedCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProhibitedCreativeMutation, AddProhibitedCreativeMutationVariables>(AddProhibitedCreativeDocument, options);
      }
export type AddProhibitedCreativeMutationHookResult = ReturnType<typeof useAddProhibitedCreativeMutation>;
export type AddProhibitedCreativeMutationResult = Apollo.MutationResult<AddProhibitedCreativeMutation>;
export type AddProhibitedCreativeMutationOptions = Apollo.BaseMutationOptions<AddProhibitedCreativeMutation, AddProhibitedCreativeMutationVariables>;
export const RemoveProhibitedCreativeDocument = gql`
    mutation RemoveProhibitedCreative($creativeId: ID!, $prohibitedCreativeId: ID!) {
  creativeProhibitedCreativePairingRemove(
    creativeId: $creativeId
    prohibitedCreativeId: $prohibitedCreativeId
  ) {
    success
    creative {
      id
      prohibitedCreatives {
        id
        title
      }
    }
  }
}
    `;
export type RemoveProhibitedCreativeMutationFn = Apollo.MutationFunction<RemoveProhibitedCreativeMutation, RemoveProhibitedCreativeMutationVariables>;

/**
 * __useRemoveProhibitedCreativeMutation__
 *
 * To run a mutation, you first call `useRemoveProhibitedCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProhibitedCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProhibitedCreativeMutation, { data, loading, error }] = useRemoveProhibitedCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      prohibitedCreativeId: // value for 'prohibitedCreativeId'
 *   },
 * });
 */
export function useRemoveProhibitedCreativeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProhibitedCreativeMutation, RemoveProhibitedCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProhibitedCreativeMutation, RemoveProhibitedCreativeMutationVariables>(RemoveProhibitedCreativeDocument, options);
      }
export type RemoveProhibitedCreativeMutationHookResult = ReturnType<typeof useRemoveProhibitedCreativeMutation>;
export type RemoveProhibitedCreativeMutationResult = Apollo.MutationResult<RemoveProhibitedCreativeMutation>;
export type RemoveProhibitedCreativeMutationOptions = Apollo.BaseMutationOptions<RemoveProhibitedCreativeMutation, RemoveProhibitedCreativeMutationVariables>;
export const AddProhibitedTagDocument = gql`
    mutation AddProhibitedTag($creativeId: ID!, $prohibitedTagId: ID!) {
  creativeProhibitedCreativePairingByTagAdd(
    creativeId: $creativeId
    prohibitedTagId: $prohibitedTagId
  ) {
    success
    creative {
      id
      prohibitedTags {
        id
        name
      }
    }
  }
}
    `;
export type AddProhibitedTagMutationFn = Apollo.MutationFunction<AddProhibitedTagMutation, AddProhibitedTagMutationVariables>;

/**
 * __useAddProhibitedTagMutation__
 *
 * To run a mutation, you first call `useAddProhibitedTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProhibitedTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProhibitedTagMutation, { data, loading, error }] = useAddProhibitedTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      prohibitedTagId: // value for 'prohibitedTagId'
 *   },
 * });
 */
export function useAddProhibitedTagMutation(baseOptions?: Apollo.MutationHookOptions<AddProhibitedTagMutation, AddProhibitedTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProhibitedTagMutation, AddProhibitedTagMutationVariables>(AddProhibitedTagDocument, options);
      }
export type AddProhibitedTagMutationHookResult = ReturnType<typeof useAddProhibitedTagMutation>;
export type AddProhibitedTagMutationResult = Apollo.MutationResult<AddProhibitedTagMutation>;
export type AddProhibitedTagMutationOptions = Apollo.BaseMutationOptions<AddProhibitedTagMutation, AddProhibitedTagMutationVariables>;
export const RemoveProhibitedTagDocument = gql`
    mutation RemoveProhibitedTag($creativeId: ID!, $prohibitedTagId: ID!) {
  creativeProhibitedCreativePairingByTagRemove(
    creativeId: $creativeId
    prohibitedTagId: $prohibitedTagId
  ) {
    success
    creative {
      id
      prohibitedTags {
        id
        name
      }
    }
  }
}
    `;
export type RemoveProhibitedTagMutationFn = Apollo.MutationFunction<RemoveProhibitedTagMutation, RemoveProhibitedTagMutationVariables>;

/**
 * __useRemoveProhibitedTagMutation__
 *
 * To run a mutation, you first call `useRemoveProhibitedTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProhibitedTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProhibitedTagMutation, { data, loading, error }] = useRemoveProhibitedTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      prohibitedTagId: // value for 'prohibitedTagId'
 *   },
 * });
 */
export function useRemoveProhibitedTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProhibitedTagMutation, RemoveProhibitedTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProhibitedTagMutation, RemoveProhibitedTagMutationVariables>(RemoveProhibitedTagDocument, options);
      }
export type RemoveProhibitedTagMutationHookResult = ReturnType<typeof useRemoveProhibitedTagMutation>;
export type RemoveProhibitedTagMutationResult = Apollo.MutationResult<RemoveProhibitedTagMutation>;
export type RemoveProhibitedTagMutationOptions = Apollo.BaseMutationOptions<RemoveProhibitedTagMutation, RemoveProhibitedTagMutationVariables>;
export const GetPersadoCampaignsDocument = gql`
    query GetPersadoCampaigns($forCreatives: Boolean) {
  currentClient {
    persadoCampaigns(forCreatives: $forCreatives) {
      externalId
      title
    }
  }
}
    `;

/**
 * __useGetPersadoCampaignsQuery__
 *
 * To run a query within a React component, call `useGetPersadoCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersadoCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersadoCampaignsQuery({
 *   variables: {
 *      forCreatives: // value for 'forCreatives'
 *   },
 * });
 */
export function useGetPersadoCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>(GetPersadoCampaignsDocument, options);
      }
export function useGetPersadoCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>(GetPersadoCampaignsDocument, options);
        }
export function useGetPersadoCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>(GetPersadoCampaignsDocument, options);
        }
export type GetPersadoCampaignsQueryHookResult = ReturnType<typeof useGetPersadoCampaignsQuery>;
export type GetPersadoCampaignsLazyQueryHookResult = ReturnType<typeof useGetPersadoCampaignsLazyQuery>;
export type GetPersadoCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetPersadoCampaignsSuspenseQuery>;
export type GetPersadoCampaignsQueryResult = Apollo.QueryResult<GetPersadoCampaignsQuery, GetPersadoCampaignsQueryVariables>;
export const GetCreativePreheaderAndPreviewDocument = gql`
    query GetCreativePreheaderAndPreview($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    status
    ...creativePreheaderAndPreviewFields
  }
}
    ${CreativePreheaderAndPreviewFieldsFragmentDoc}`;

/**
 * __useGetCreativePreheaderAndPreviewQuery__
 *
 * To run a query within a React component, call `useGetCreativePreheaderAndPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativePreheaderAndPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativePreheaderAndPreviewQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativePreheaderAndPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables> & ({ variables: GetCreativePreheaderAndPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables>(GetCreativePreheaderAndPreviewDocument, options);
      }
export function useGetCreativePreheaderAndPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables>(GetCreativePreheaderAndPreviewDocument, options);
        }
export function useGetCreativePreheaderAndPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables>(GetCreativePreheaderAndPreviewDocument, options);
        }
export type GetCreativePreheaderAndPreviewQueryHookResult = ReturnType<typeof useGetCreativePreheaderAndPreviewQuery>;
export type GetCreativePreheaderAndPreviewLazyQueryHookResult = ReturnType<typeof useGetCreativePreheaderAndPreviewLazyQuery>;
export type GetCreativePreheaderAndPreviewSuspenseQueryHookResult = ReturnType<typeof useGetCreativePreheaderAndPreviewSuspenseQuery>;
export type GetCreativePreheaderAndPreviewQueryResult = Apollo.QueryResult<GetCreativePreheaderAndPreviewQuery, GetCreativePreheaderAndPreviewQueryVariables>;
export const UpdateCreativeSubjectLinePrefixDocument = gql`
    mutation updateCreativeSubjectLinePrefix($creativeId: ID!, $content: String!) {
  creativeSubjectLinePrefixUpdate(creativeId: $creativeId, content: $content) {
    creative {
      __typename
      id
      subjectLinePrefix
    }
  }
}
    `;
export type UpdateCreativeSubjectLinePrefixMutationFn = Apollo.MutationFunction<UpdateCreativeSubjectLinePrefixMutation, UpdateCreativeSubjectLinePrefixMutationVariables>;

/**
 * __useUpdateCreativeSubjectLinePrefixMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeSubjectLinePrefixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeSubjectLinePrefixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeSubjectLinePrefixMutation, { data, loading, error }] = useUpdateCreativeSubjectLinePrefixMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateCreativeSubjectLinePrefixMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeSubjectLinePrefixMutation, UpdateCreativeSubjectLinePrefixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeSubjectLinePrefixMutation, UpdateCreativeSubjectLinePrefixMutationVariables>(UpdateCreativeSubjectLinePrefixDocument, options);
      }
export type UpdateCreativeSubjectLinePrefixMutationHookResult = ReturnType<typeof useUpdateCreativeSubjectLinePrefixMutation>;
export type UpdateCreativeSubjectLinePrefixMutationResult = Apollo.MutationResult<UpdateCreativeSubjectLinePrefixMutation>;
export type UpdateCreativeSubjectLinePrefixMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeSubjectLinePrefixMutation, UpdateCreativeSubjectLinePrefixMutationVariables>;
export const UpdateCreativeSubjectLineSuffixDocument = gql`
    mutation updateCreativeSubjectLineSuffix($creativeId: ID!, $content: String!) {
  creativeSubjectLineSuffixUpdate(creativeId: $creativeId, content: $content) {
    creative {
      __typename
      id
      subjectLineSuffix
    }
  }
}
    `;
export type UpdateCreativeSubjectLineSuffixMutationFn = Apollo.MutationFunction<UpdateCreativeSubjectLineSuffixMutation, UpdateCreativeSubjectLineSuffixMutationVariables>;

/**
 * __useUpdateCreativeSubjectLineSuffixMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeSubjectLineSuffixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeSubjectLineSuffixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeSubjectLineSuffixMutation, { data, loading, error }] = useUpdateCreativeSubjectLineSuffixMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateCreativeSubjectLineSuffixMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeSubjectLineSuffixMutation, UpdateCreativeSubjectLineSuffixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeSubjectLineSuffixMutation, UpdateCreativeSubjectLineSuffixMutationVariables>(UpdateCreativeSubjectLineSuffixDocument, options);
      }
export type UpdateCreativeSubjectLineSuffixMutationHookResult = ReturnType<typeof useUpdateCreativeSubjectLineSuffixMutation>;
export type UpdateCreativeSubjectLineSuffixMutationResult = Apollo.MutationResult<UpdateCreativeSubjectLineSuffixMutation>;
export type UpdateCreativeSubjectLineSuffixMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeSubjectLineSuffixMutation, UpdateCreativeSubjectLineSuffixMutationVariables>;
export const AddCreativeSubjectLineDocument = gql`
    mutation AddCreativeSubjectLine($creativeId: ID!, $content: String!, $isPrimary: Boolean!, $tone: String, $source: String) {
  creativeSubjectLineCreate(
    creativeId: $creativeId
    content: $content
    isPrimary: $isPrimary
    tone: $tone
    source: $source
  ) {
    ... on CreativeSuccess {
      creative {
        ...subjectLinesFragment
      }
      success
    }
  }
}
    ${SubjectLinesFragmentFragmentDoc}`;
export type AddCreativeSubjectLineMutationFn = Apollo.MutationFunction<AddCreativeSubjectLineMutation, AddCreativeSubjectLineMutationVariables>;

/**
 * __useAddCreativeSubjectLineMutation__
 *
 * To run a mutation, you first call `useAddCreativeSubjectLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreativeSubjectLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreativeSubjectLineMutation, { data, loading, error }] = useAddCreativeSubjectLineMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      content: // value for 'content'
 *      isPrimary: // value for 'isPrimary'
 *      tone: // value for 'tone'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAddCreativeSubjectLineMutation(baseOptions?: Apollo.MutationHookOptions<AddCreativeSubjectLineMutation, AddCreativeSubjectLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCreativeSubjectLineMutation, AddCreativeSubjectLineMutationVariables>(AddCreativeSubjectLineDocument, options);
      }
export type AddCreativeSubjectLineMutationHookResult = ReturnType<typeof useAddCreativeSubjectLineMutation>;
export type AddCreativeSubjectLineMutationResult = Apollo.MutationResult<AddCreativeSubjectLineMutation>;
export type AddCreativeSubjectLineMutationOptions = Apollo.BaseMutationOptions<AddCreativeSubjectLineMutation, AddCreativeSubjectLineMutationVariables>;
export const UpdateCreativeSubjectLineDocument = gql`
    mutation UpdateCreativeSubjectLine($subjectLineId: ID!, $content: String!, $isPrimary: Boolean!, $tone: String) {
  creativeSubjectLineUpdate(
    subjectLineId: $subjectLineId
    content: $content
    isPrimary: $isPrimary
    tone: $tone
  ) {
    ... on CreativeSuccess {
      creative {
        ...subjectLinesFragment
      }
      success
    }
  }
}
    ${SubjectLinesFragmentFragmentDoc}`;
export type UpdateCreativeSubjectLineMutationFn = Apollo.MutationFunction<UpdateCreativeSubjectLineMutation, UpdateCreativeSubjectLineMutationVariables>;

/**
 * __useUpdateCreativeSubjectLineMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeSubjectLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeSubjectLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeSubjectLineMutation, { data, loading, error }] = useUpdateCreativeSubjectLineMutation({
 *   variables: {
 *      subjectLineId: // value for 'subjectLineId'
 *      content: // value for 'content'
 *      isPrimary: // value for 'isPrimary'
 *      tone: // value for 'tone'
 *   },
 * });
 */
export function useUpdateCreativeSubjectLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeSubjectLineMutation, UpdateCreativeSubjectLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeSubjectLineMutation, UpdateCreativeSubjectLineMutationVariables>(UpdateCreativeSubjectLineDocument, options);
      }
export type UpdateCreativeSubjectLineMutationHookResult = ReturnType<typeof useUpdateCreativeSubjectLineMutation>;
export type UpdateCreativeSubjectLineMutationResult = Apollo.MutationResult<UpdateCreativeSubjectLineMutation>;
export type UpdateCreativeSubjectLineMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeSubjectLineMutation, UpdateCreativeSubjectLineMutationVariables>;
export const RemoveCreativeSubjectLineDocument = gql`
    mutation RemoveCreativeSubjectLine($subjectLineId: ID!) {
  creativeSubjectLineRemove(subjectLineId: $subjectLineId) {
    ... on CreativeSuccess {
      creative {
        ...subjectLinesFragment
      }
      success
    }
  }
}
    ${SubjectLinesFragmentFragmentDoc}`;
export type RemoveCreativeSubjectLineMutationFn = Apollo.MutationFunction<RemoveCreativeSubjectLineMutation, RemoveCreativeSubjectLineMutationVariables>;

/**
 * __useRemoveCreativeSubjectLineMutation__
 *
 * To run a mutation, you first call `useRemoveCreativeSubjectLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreativeSubjectLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreativeSubjectLineMutation, { data, loading, error }] = useRemoveCreativeSubjectLineMutation({
 *   variables: {
 *      subjectLineId: // value for 'subjectLineId'
 *   },
 * });
 */
export function useRemoveCreativeSubjectLineMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreativeSubjectLineMutation, RemoveCreativeSubjectLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreativeSubjectLineMutation, RemoveCreativeSubjectLineMutationVariables>(RemoveCreativeSubjectLineDocument, options);
      }
export type RemoveCreativeSubjectLineMutationHookResult = ReturnType<typeof useRemoveCreativeSubjectLineMutation>;
export type RemoveCreativeSubjectLineMutationResult = Apollo.MutationResult<RemoveCreativeSubjectLineMutation>;
export type RemoveCreativeSubjectLineMutationOptions = Apollo.BaseMutationOptions<RemoveCreativeSubjectLineMutation, RemoveCreativeSubjectLineMutationVariables>;
export const ReorderCreativeSubjectLineDocument = gql`
    mutation ReorderCreativeSubjectLine($creativeId: ID!, $subjectLineIds: [ID!]!) {
  creativeSubjectLinesReorder(
    creativeId: $creativeId
    subjectLineIds: $subjectLineIds
  ) {
    ... on CreativeSuccess {
      creative {
        id
        subjectLines {
          id
        }
      }
      success
    }
  }
}
    `;
export type ReorderCreativeSubjectLineMutationFn = Apollo.MutationFunction<ReorderCreativeSubjectLineMutation, ReorderCreativeSubjectLineMutationVariables>;

/**
 * __useReorderCreativeSubjectLineMutation__
 *
 * To run a mutation, you first call `useReorderCreativeSubjectLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCreativeSubjectLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCreativeSubjectLineMutation, { data, loading, error }] = useReorderCreativeSubjectLineMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      subjectLineIds: // value for 'subjectLineIds'
 *   },
 * });
 */
export function useReorderCreativeSubjectLineMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCreativeSubjectLineMutation, ReorderCreativeSubjectLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCreativeSubjectLineMutation, ReorderCreativeSubjectLineMutationVariables>(ReorderCreativeSubjectLineDocument, options);
      }
export type ReorderCreativeSubjectLineMutationHookResult = ReturnType<typeof useReorderCreativeSubjectLineMutation>;
export type ReorderCreativeSubjectLineMutationResult = Apollo.MutationResult<ReorderCreativeSubjectLineMutation>;
export type ReorderCreativeSubjectLineMutationOptions = Apollo.BaseMutationOptions<ReorderCreativeSubjectLineMutation, ReorderCreativeSubjectLineMutationVariables>;
export const UpdateCreativePersadoCampaignDocument = gql`
    mutation UpdateCreativePersadoCampaign($creativeId: ID!, $persadoCampaignInput: PersadoCampaignInput) {
  creativePersadoCampaignUpdate(
    creativeId: $creativeId
    persadoCampaignInput: $persadoCampaignInput
  ) {
    ... on CreativeSuccess {
      creative {
        persadoCampaign {
          id
          title
          externalId
          subjectLineScript
          bodyAmpScript
        }
        ...subjectLinesFragment
      }
      success
    }
  }
}
    ${SubjectLinesFragmentFragmentDoc}`;
export type UpdateCreativePersadoCampaignMutationFn = Apollo.MutationFunction<UpdateCreativePersadoCampaignMutation, UpdateCreativePersadoCampaignMutationVariables>;

/**
 * __useUpdateCreativePersadoCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCreativePersadoCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativePersadoCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativePersadoCampaignMutation, { data, loading, error }] = useUpdateCreativePersadoCampaignMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      persadoCampaignInput: // value for 'persadoCampaignInput'
 *   },
 * });
 */
export function useUpdateCreativePersadoCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativePersadoCampaignMutation, UpdateCreativePersadoCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativePersadoCampaignMutation, UpdateCreativePersadoCampaignMutationVariables>(UpdateCreativePersadoCampaignDocument, options);
      }
export type UpdateCreativePersadoCampaignMutationHookResult = ReturnType<typeof useUpdateCreativePersadoCampaignMutation>;
export type UpdateCreativePersadoCampaignMutationResult = Apollo.MutationResult<UpdateCreativePersadoCampaignMutation>;
export type UpdateCreativePersadoCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCreativePersadoCampaignMutation, UpdateCreativePersadoCampaignMutationVariables>;
export const ArchiveCreativeSubjectLineDocument = gql`
    mutation ArchiveCreativeSubjectLine($subjectLineId: ID!) {
  creativeSubjectLineArchive(subjectLineId: $subjectLineId) {
    ... on CreativeSuccess {
      creative {
        ...subjectLinesFragment
      }
      success
    }
  }
}
    ${SubjectLinesFragmentFragmentDoc}`;
export type ArchiveCreativeSubjectLineMutationFn = Apollo.MutationFunction<ArchiveCreativeSubjectLineMutation, ArchiveCreativeSubjectLineMutationVariables>;

/**
 * __useArchiveCreativeSubjectLineMutation__
 *
 * To run a mutation, you first call `useArchiveCreativeSubjectLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCreativeSubjectLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCreativeSubjectLineMutation, { data, loading, error }] = useArchiveCreativeSubjectLineMutation({
 *   variables: {
 *      subjectLineId: // value for 'subjectLineId'
 *   },
 * });
 */
export function useArchiveCreativeSubjectLineMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCreativeSubjectLineMutation, ArchiveCreativeSubjectLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCreativeSubjectLineMutation, ArchiveCreativeSubjectLineMutationVariables>(ArchiveCreativeSubjectLineDocument, options);
      }
export type ArchiveCreativeSubjectLineMutationHookResult = ReturnType<typeof useArchiveCreativeSubjectLineMutation>;
export type ArchiveCreativeSubjectLineMutationResult = Apollo.MutationResult<ArchiveCreativeSubjectLineMutation>;
export type ArchiveCreativeSubjectLineMutationOptions = Apollo.BaseMutationOptions<ArchiveCreativeSubjectLineMutation, ArchiveCreativeSubjectLineMutationVariables>;
export const RestoreCreativeSubjectLineDocument = gql`
    mutation RestoreCreativeSubjectLine($subjectLineId: ID!) {
  creativeSubjectLineRestore(subjectLineId: $subjectLineId) {
    ... on CreativeSuccess {
      creative {
        ...subjectLinesFragment
      }
      success
    }
  }
}
    ${SubjectLinesFragmentFragmentDoc}`;
export type RestoreCreativeSubjectLineMutationFn = Apollo.MutationFunction<RestoreCreativeSubjectLineMutation, RestoreCreativeSubjectLineMutationVariables>;

/**
 * __useRestoreCreativeSubjectLineMutation__
 *
 * To run a mutation, you first call `useRestoreCreativeSubjectLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCreativeSubjectLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCreativeSubjectLineMutation, { data, loading, error }] = useRestoreCreativeSubjectLineMutation({
 *   variables: {
 *      subjectLineId: // value for 'subjectLineId'
 *   },
 * });
 */
export function useRestoreCreativeSubjectLineMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCreativeSubjectLineMutation, RestoreCreativeSubjectLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCreativeSubjectLineMutation, RestoreCreativeSubjectLineMutationVariables>(RestoreCreativeSubjectLineDocument, options);
      }
export type RestoreCreativeSubjectLineMutationHookResult = ReturnType<typeof useRestoreCreativeSubjectLineMutation>;
export type RestoreCreativeSubjectLineMutationResult = Apollo.MutationResult<RestoreCreativeSubjectLineMutation>;
export type RestoreCreativeSubjectLineMutationOptions = Apollo.BaseMutationOptions<RestoreCreativeSubjectLineMutation, RestoreCreativeSubjectLineMutationVariables>;
export const UpdateCreativePreheaderAndPreviewDocument = gql`
    mutation UpdateCreativePreheaderAndPreview($creativeId: ID!, $preheaderLinkId: ID, $preheaderText: String, $previewText: String, $usePreheaderTextAsPreviewText: Boolean) {
  creativePreheaderAndPreviewUpdate(
    creativeId: $creativeId
    preheaderLinkId: $preheaderLinkId
    preheaderText: $preheaderText
    previewText: $previewText
    usePreheaderTextAsPreviewText: $usePreheaderTextAsPreviewText
  ) {
    __typename
    ... on CreativeSuccess {
      creative {
        id
        __typename
        ...creativePreheaderAndPreviewFields
      }
    }
    ... on ValidationErrors {
      __typename
      success
      errors {
        __typename
        field
        reason
        code
      }
    }
  }
}
    ${CreativePreheaderAndPreviewFieldsFragmentDoc}`;
export type UpdateCreativePreheaderAndPreviewMutationFn = Apollo.MutationFunction<UpdateCreativePreheaderAndPreviewMutation, UpdateCreativePreheaderAndPreviewMutationVariables>;

/**
 * __useUpdateCreativePreheaderAndPreviewMutation__
 *
 * To run a mutation, you first call `useUpdateCreativePreheaderAndPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativePreheaderAndPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativePreheaderAndPreviewMutation, { data, loading, error }] = useUpdateCreativePreheaderAndPreviewMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      preheaderLinkId: // value for 'preheaderLinkId'
 *      preheaderText: // value for 'preheaderText'
 *      previewText: // value for 'previewText'
 *      usePreheaderTextAsPreviewText: // value for 'usePreheaderTextAsPreviewText'
 *   },
 * });
 */
export function useUpdateCreativePreheaderAndPreviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativePreheaderAndPreviewMutation, UpdateCreativePreheaderAndPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativePreheaderAndPreviewMutation, UpdateCreativePreheaderAndPreviewMutationVariables>(UpdateCreativePreheaderAndPreviewDocument, options);
      }
export type UpdateCreativePreheaderAndPreviewMutationHookResult = ReturnType<typeof useUpdateCreativePreheaderAndPreviewMutation>;
export type UpdateCreativePreheaderAndPreviewMutationResult = Apollo.MutationResult<UpdateCreativePreheaderAndPreviewMutation>;
export type UpdateCreativePreheaderAndPreviewMutationOptions = Apollo.BaseMutationOptions<UpdateCreativePreheaderAndPreviewMutation, UpdateCreativePreheaderAndPreviewMutationVariables>;
export const GetCreativeReuseRuleDocument = gql`
    query GetCreativeReuseRule($creativeId: ID!) {
  creative(id: $creativeId) {
    __typename
    id
    disableReuseRules
    reuseRule {
      ...reuseRuleFields
    }
  }
}
    ${ReuseRuleFieldsFragmentDoc}`;

/**
 * __useGetCreativeReuseRuleQuery__
 *
 * To run a query within a React component, call `useGetCreativeReuseRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeReuseRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeReuseRuleQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeReuseRuleQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables> & ({ variables: GetCreativeReuseRuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables>(GetCreativeReuseRuleDocument, options);
      }
export function useGetCreativeReuseRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables>(GetCreativeReuseRuleDocument, options);
        }
export function useGetCreativeReuseRuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables>(GetCreativeReuseRuleDocument, options);
        }
export type GetCreativeReuseRuleQueryHookResult = ReturnType<typeof useGetCreativeReuseRuleQuery>;
export type GetCreativeReuseRuleLazyQueryHookResult = ReturnType<typeof useGetCreativeReuseRuleLazyQuery>;
export type GetCreativeReuseRuleSuspenseQueryHookResult = ReturnType<typeof useGetCreativeReuseRuleSuspenseQuery>;
export type GetCreativeReuseRuleQueryResult = Apollo.QueryResult<GetCreativeReuseRuleQuery, GetCreativeReuseRuleQueryVariables>;
export const CreativeDisableReuseRulesUpdateDocument = gql`
    mutation creativeDisableReuseRulesUpdate($creativeId: ID!, $disableReuseRules: Boolean!) {
  creativeDisableReuseRulesUpdate(
    creativeId: $creativeId
    disableReuseRules: $disableReuseRules
  ) {
    __typename
    ... on CreativeSuccess {
      __typename
      success
      creative {
        __typename
        id
        disableReuseRules
      }
    }
  }
}
    `;
export type CreativeDisableReuseRulesUpdateMutationFn = Apollo.MutationFunction<CreativeDisableReuseRulesUpdateMutation, CreativeDisableReuseRulesUpdateMutationVariables>;

/**
 * __useCreativeDisableReuseRulesUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeDisableReuseRulesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeDisableReuseRulesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeDisableReuseRulesUpdateMutation, { data, loading, error }] = useCreativeDisableReuseRulesUpdateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      disableReuseRules: // value for 'disableReuseRules'
 *   },
 * });
 */
export function useCreativeDisableReuseRulesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeDisableReuseRulesUpdateMutation, CreativeDisableReuseRulesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeDisableReuseRulesUpdateMutation, CreativeDisableReuseRulesUpdateMutationVariables>(CreativeDisableReuseRulesUpdateDocument, options);
      }
export type CreativeDisableReuseRulesUpdateMutationHookResult = ReturnType<typeof useCreativeDisableReuseRulesUpdateMutation>;
export type CreativeDisableReuseRulesUpdateMutationResult = Apollo.MutationResult<CreativeDisableReuseRulesUpdateMutation>;
export type CreativeDisableReuseRulesUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeDisableReuseRulesUpdateMutation, CreativeDisableReuseRulesUpdateMutationVariables>;
export const CreativeReuseRuleUpdateDocument = gql`
    mutation creativeReuseRuleUpdate($creativeId: ID!, $reuseRule: ReuseRuleInput!) {
  creativeReuseRuleUpdate(creativeId: $creativeId, reuseRule: $reuseRule) {
    __typename
    ... on CreativeReuseRuleUpdate {
      __typename
      reuseRule {
        ...reuseRuleFields
      }
    }
  }
}
    ${ReuseRuleFieldsFragmentDoc}`;
export type CreativeReuseRuleUpdateMutationFn = Apollo.MutationFunction<CreativeReuseRuleUpdateMutation, CreativeReuseRuleUpdateMutationVariables>;

/**
 * __useCreativeReuseRuleUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeReuseRuleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeReuseRuleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeReuseRuleUpdateMutation, { data, loading, error }] = useCreativeReuseRuleUpdateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      reuseRule: // value for 'reuseRule'
 *   },
 * });
 */
export function useCreativeReuseRuleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeReuseRuleUpdateMutation, CreativeReuseRuleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeReuseRuleUpdateMutation, CreativeReuseRuleUpdateMutationVariables>(CreativeReuseRuleUpdateDocument, options);
      }
export type CreativeReuseRuleUpdateMutationHookResult = ReturnType<typeof useCreativeReuseRuleUpdateMutation>;
export type CreativeReuseRuleUpdateMutationResult = Apollo.MutationResult<CreativeReuseRuleUpdateMutation>;
export type CreativeReuseRuleUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeReuseRuleUpdateMutation, CreativeReuseRuleUpdateMutationVariables>;
export const CreativeTextAttributeUpdateDocument = gql`
    mutation CreativeTextAttributeUpdate($creativeId: ID!, $attributeId: ID!, $text: String!) {
  creativeTextAttributeUpdate(
    creativeId: $creativeId
    attributeId: $attributeId
    text: $text
  ) {
    success
    creative {
      id
      attributes {
        id
        __typename
        ... on TextAttribute {
          id
          value
        }
      }
    }
  }
}
    `;
export type CreativeTextAttributeUpdateMutationFn = Apollo.MutationFunction<CreativeTextAttributeUpdateMutation, CreativeTextAttributeUpdateMutationVariables>;

/**
 * __useCreativeTextAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeTextAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeTextAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeTextAttributeUpdateMutation, { data, loading, error }] = useCreativeTextAttributeUpdateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      attributeId: // value for 'attributeId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreativeTextAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeTextAttributeUpdateMutation, CreativeTextAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeTextAttributeUpdateMutation, CreativeTextAttributeUpdateMutationVariables>(CreativeTextAttributeUpdateDocument, options);
      }
export type CreativeTextAttributeUpdateMutationHookResult = ReturnType<typeof useCreativeTextAttributeUpdateMutation>;
export type CreativeTextAttributeUpdateMutationResult = Apollo.MutationResult<CreativeTextAttributeUpdateMutation>;
export type CreativeTextAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeTextAttributeUpdateMutation, CreativeTextAttributeUpdateMutationVariables>;
export const CreativeSelectAttributeUpdateDocument = gql`
    mutation CreativeSelectAttributeUpdate($creativeId: ID!, $attributeId: ID!, $choiceId: ID) {
  creativeSelectAttributeUpdate(
    creativeId: $creativeId
    attributeId: $attributeId
    choiceId: $choiceId
  ) {
    success
    creative {
      id
      attributes {
        id
        __typename
        ... on SelectAttribute2 {
          id
          selectedId
        }
      }
    }
  }
}
    `;
export type CreativeSelectAttributeUpdateMutationFn = Apollo.MutationFunction<CreativeSelectAttributeUpdateMutation, CreativeSelectAttributeUpdateMutationVariables>;

/**
 * __useCreativeSelectAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeSelectAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSelectAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSelectAttributeUpdateMutation, { data, loading, error }] = useCreativeSelectAttributeUpdateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      attributeId: // value for 'attributeId'
 *      choiceId: // value for 'choiceId'
 *   },
 * });
 */
export function useCreativeSelectAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSelectAttributeUpdateMutation, CreativeSelectAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSelectAttributeUpdateMutation, CreativeSelectAttributeUpdateMutationVariables>(CreativeSelectAttributeUpdateDocument, options);
      }
export type CreativeSelectAttributeUpdateMutationHookResult = ReturnType<typeof useCreativeSelectAttributeUpdateMutation>;
export type CreativeSelectAttributeUpdateMutationResult = Apollo.MutationResult<CreativeSelectAttributeUpdateMutation>;
export type CreativeSelectAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeSelectAttributeUpdateMutation, CreativeSelectAttributeUpdateMutationVariables>;
export const CreativeTextTrackingParameterUpdateDocument = gql`
    mutation CreativeTextTrackingParameterUpdate($creativeId: ID!, $trackingParameterId: ID!, $text: String!) {
  creativeTextTrackingParameterUpdate(
    creativeId: $creativeId
    trackingParameterId: $trackingParameterId
    text: $text
  ) {
    success
    creative {
      id
      trackingParameters {
        id
        __typename
        ... on TextAttribute {
          id
          value
        }
      }
    }
  }
}
    `;
export type CreativeTextTrackingParameterUpdateMutationFn = Apollo.MutationFunction<CreativeTextTrackingParameterUpdateMutation, CreativeTextTrackingParameterUpdateMutationVariables>;

/**
 * __useCreativeTextTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeTextTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeTextTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeTextTrackingParameterUpdateMutation, { data, loading, error }] = useCreativeTextTrackingParameterUpdateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreativeTextTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeTextTrackingParameterUpdateMutation, CreativeTextTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeTextTrackingParameterUpdateMutation, CreativeTextTrackingParameterUpdateMutationVariables>(CreativeTextTrackingParameterUpdateDocument, options);
      }
export type CreativeTextTrackingParameterUpdateMutationHookResult = ReturnType<typeof useCreativeTextTrackingParameterUpdateMutation>;
export type CreativeTextTrackingParameterUpdateMutationResult = Apollo.MutationResult<CreativeTextTrackingParameterUpdateMutation>;
export type CreativeTextTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeTextTrackingParameterUpdateMutation, CreativeTextTrackingParameterUpdateMutationVariables>;
export const CreativeSelectTrackingParameterUpdateDocument = gql`
    mutation CreativeSelectTrackingParameterUpdate($creativeId: ID!, $trackingParameterId: ID!, $choiceId: ID) {
  creativeSelectTrackingParameterUpdate(
    creativeId: $creativeId
    trackingParameterId: $trackingParameterId
    choiceId: $choiceId
  ) {
    success
    creative {
      id
      trackingParameters {
        id
        __typename
        ... on SelectAttribute2 {
          id
          selectedId
        }
      }
    }
  }
}
    `;
export type CreativeSelectTrackingParameterUpdateMutationFn = Apollo.MutationFunction<CreativeSelectTrackingParameterUpdateMutation, CreativeSelectTrackingParameterUpdateMutationVariables>;

/**
 * __useCreativeSelectTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useCreativeSelectTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSelectTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSelectTrackingParameterUpdateMutation, { data, loading, error }] = useCreativeSelectTrackingParameterUpdateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      choiceId: // value for 'choiceId'
 *   },
 * });
 */
export function useCreativeSelectTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSelectTrackingParameterUpdateMutation, CreativeSelectTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSelectTrackingParameterUpdateMutation, CreativeSelectTrackingParameterUpdateMutationVariables>(CreativeSelectTrackingParameterUpdateDocument, options);
      }
export type CreativeSelectTrackingParameterUpdateMutationHookResult = ReturnType<typeof useCreativeSelectTrackingParameterUpdateMutation>;
export type CreativeSelectTrackingParameterUpdateMutationResult = Apollo.MutationResult<CreativeSelectTrackingParameterUpdateMutation>;
export type CreativeSelectTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<CreativeSelectTrackingParameterUpdateMutation, CreativeSelectTrackingParameterUpdateMutationVariables>;
export const UpdateCreativeAvailabilitiesDocument = gql`
    mutation UpdateCreativeAvailabilities($creativeId: ID!, $availabilities: [DateTimeRange!]) {
  creativeAvailabilitiesUpdate(
    creativeId: $creativeId
    availabilities: $availabilities
  ) {
    __typename
    ... on CreativeSuccess {
      creative {
        __typename
        id
        availabilities2
        status
      }
      success
    }
    ... on ImpactsLockedCampaigns {
      lockedCampaigns {
        id
        title
      }
    }
  }
}
    `;
export type UpdateCreativeAvailabilitiesMutationFn = Apollo.MutationFunction<UpdateCreativeAvailabilitiesMutation, UpdateCreativeAvailabilitiesMutationVariables>;

/**
 * __useUpdateCreativeAvailabilitiesMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeAvailabilitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeAvailabilitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeAvailabilitiesMutation, { data, loading, error }] = useUpdateCreativeAvailabilitiesMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      availabilities: // value for 'availabilities'
 *   },
 * });
 */
export function useUpdateCreativeAvailabilitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreativeAvailabilitiesMutation, UpdateCreativeAvailabilitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreativeAvailabilitiesMutation, UpdateCreativeAvailabilitiesMutationVariables>(UpdateCreativeAvailabilitiesDocument, options);
      }
export type UpdateCreativeAvailabilitiesMutationHookResult = ReturnType<typeof useUpdateCreativeAvailabilitiesMutation>;
export type UpdateCreativeAvailabilitiesMutationResult = Apollo.MutationResult<UpdateCreativeAvailabilitiesMutation>;
export type UpdateCreativeAvailabilitiesMutationOptions = Apollo.BaseMutationOptions<UpdateCreativeAvailabilitiesMutation, UpdateCreativeAvailabilitiesMutationVariables>;
export const ExpireCreativeDocument = gql`
    mutation ExpireCreative($creativeId: ID!) {
  creativeExpire(creativeId: $creativeId, confirm: true) {
    ... on CreativeSuccess {
      creative {
        id
        __typename
        availabilities2
        status
      }
    }
    ... on NeedsConfirmationExpireCreative {
      earliestTime
      latestTime
    }
  }
}
    `;
export type ExpireCreativeMutationFn = Apollo.MutationFunction<ExpireCreativeMutation, ExpireCreativeMutationVariables>;

/**
 * __useExpireCreativeMutation__
 *
 * To run a mutation, you first call `useExpireCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireCreativeMutation, { data, loading, error }] = useExpireCreativeMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useExpireCreativeMutation(baseOptions?: Apollo.MutationHookOptions<ExpireCreativeMutation, ExpireCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireCreativeMutation, ExpireCreativeMutationVariables>(ExpireCreativeDocument, options);
      }
export type ExpireCreativeMutationHookResult = ReturnType<typeof useExpireCreativeMutation>;
export type ExpireCreativeMutationResult = Apollo.MutationResult<ExpireCreativeMutation>;
export type ExpireCreativeMutationOptions = Apollo.BaseMutationOptions<ExpireCreativeMutation, ExpireCreativeMutationVariables>;
export const AddCreativeTagDocument = gql`
    mutation AddCreativeTag($creativeId: ID!, $tagId: ID!) {
  creativeTagCreate(creativeId: $creativeId, tagId: $tagId) {
    ... on CreativeSuccess {
      creative {
        id
        __typename
        tags {
          __typename
          id
          name
        }
      }
    }
  }
}
    `;
export type AddCreativeTagMutationFn = Apollo.MutationFunction<AddCreativeTagMutation, AddCreativeTagMutationVariables>;

/**
 * __useAddCreativeTagMutation__
 *
 * To run a mutation, you first call `useAddCreativeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreativeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreativeTagMutation, { data, loading, error }] = useAddCreativeTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useAddCreativeTagMutation(baseOptions?: Apollo.MutationHookOptions<AddCreativeTagMutation, AddCreativeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCreativeTagMutation, AddCreativeTagMutationVariables>(AddCreativeTagDocument, options);
      }
export type AddCreativeTagMutationHookResult = ReturnType<typeof useAddCreativeTagMutation>;
export type AddCreativeTagMutationResult = Apollo.MutationResult<AddCreativeTagMutation>;
export type AddCreativeTagMutationOptions = Apollo.BaseMutationOptions<AddCreativeTagMutation, AddCreativeTagMutationVariables>;
export const DeleteCreativeTagDocument = gql`
    mutation DeleteCreativeTag($creativeId: ID!, $tagId: ID!) {
  creativeTagDelete(creativeId: $creativeId, tagId: $tagId) {
    ... on CreativeSuccess {
      creative {
        id
        __typename
        tags {
          __typename
          id
          name
        }
      }
    }
  }
}
    `;
export type DeleteCreativeTagMutationFn = Apollo.MutationFunction<DeleteCreativeTagMutation, DeleteCreativeTagMutationVariables>;

/**
 * __useDeleteCreativeTagMutation__
 *
 * To run a mutation, you first call `useDeleteCreativeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreativeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreativeTagMutation, { data, loading, error }] = useDeleteCreativeTagMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteCreativeTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreativeTagMutation, DeleteCreativeTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreativeTagMutation, DeleteCreativeTagMutationVariables>(DeleteCreativeTagDocument, options);
      }
export type DeleteCreativeTagMutationHookResult = ReturnType<typeof useDeleteCreativeTagMutation>;
export type DeleteCreativeTagMutationResult = Apollo.MutationResult<DeleteCreativeTagMutation>;
export type DeleteCreativeTagMutationOptions = Apollo.BaseMutationOptions<DeleteCreativeTagMutation, DeleteCreativeTagMutationVariables>;
export const LockedCampaignsIncludingCreativeDocument = gql`
    query lockedCampaignsIncludingCreative($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    __typename
    includedInFutureLockedCampaigns {
      total
      latestSendDatetime
      futureLockedCampaigns {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useLockedCampaignsIncludingCreativeQuery__
 *
 * To run a query within a React component, call `useLockedCampaignsIncludingCreativeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLockedCampaignsIncludingCreativeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLockedCampaignsIncludingCreativeQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useLockedCampaignsIncludingCreativeQuery(baseOptions: Apollo.QueryHookOptions<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables> & ({ variables: LockedCampaignsIncludingCreativeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables>(LockedCampaignsIncludingCreativeDocument, options);
      }
export function useLockedCampaignsIncludingCreativeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables>(LockedCampaignsIncludingCreativeDocument, options);
        }
export function useLockedCampaignsIncludingCreativeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables>(LockedCampaignsIncludingCreativeDocument, options);
        }
export type LockedCampaignsIncludingCreativeQueryHookResult = ReturnType<typeof useLockedCampaignsIncludingCreativeQuery>;
export type LockedCampaignsIncludingCreativeLazyQueryHookResult = ReturnType<typeof useLockedCampaignsIncludingCreativeLazyQuery>;
export type LockedCampaignsIncludingCreativeSuspenseQueryHookResult = ReturnType<typeof useLockedCampaignsIncludingCreativeSuspenseQuery>;
export type LockedCampaignsIncludingCreativeQueryResult = Apollo.QueryResult<LockedCampaignsIncludingCreativeQuery, LockedCampaignsIncludingCreativeQueryVariables>;
export const GetCreativeAvailabilitiesDocument = gql`
    query GetCreativeAvailabilities($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    __typename
    availabilities2
  }
}
    `;

/**
 * __useGetCreativeAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetCreativeAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeAvailabilitiesQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables> & ({ variables: GetCreativeAvailabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables>(GetCreativeAvailabilitiesDocument, options);
      }
export function useGetCreativeAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables>(GetCreativeAvailabilitiesDocument, options);
        }
export function useGetCreativeAvailabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables>(GetCreativeAvailabilitiesDocument, options);
        }
export type GetCreativeAvailabilitiesQueryHookResult = ReturnType<typeof useGetCreativeAvailabilitiesQuery>;
export type GetCreativeAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetCreativeAvailabilitiesLazyQuery>;
export type GetCreativeAvailabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetCreativeAvailabilitiesSuspenseQuery>;
export type GetCreativeAvailabilitiesQueryResult = Apollo.QueryResult<GetCreativeAvailabilitiesQuery, GetCreativeAvailabilitiesQueryVariables>;
export const GetCreativeDetailsDocument = gql`
    query GetCreativeDetails($creativeId: ID!) {
  creative(id: $creativeId) {
    ...creativeDetailsFields
  }
}
    ${CreativeDetailsFieldsFragmentDoc}`;

/**
 * __useGetCreativeDetailsQuery__
 *
 * To run a query within a React component, call `useGetCreativeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeDetailsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables> & ({ variables: GetCreativeDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables>(GetCreativeDetailsDocument, options);
      }
export function useGetCreativeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables>(GetCreativeDetailsDocument, options);
        }
export function useGetCreativeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables>(GetCreativeDetailsDocument, options);
        }
export type GetCreativeDetailsQueryHookResult = ReturnType<typeof useGetCreativeDetailsQuery>;
export type GetCreativeDetailsLazyQueryHookResult = ReturnType<typeof useGetCreativeDetailsLazyQuery>;
export type GetCreativeDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCreativeDetailsSuspenseQuery>;
export type GetCreativeDetailsQueryResult = Apollo.QueryResult<GetCreativeDetailsQuery, GetCreativeDetailsQueryVariables>;
export const GetCreativeHeaderDetailsDocument = gql`
    query GetCreativeHeaderDetails($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    title
    status
    legacyId
    shortUuid
    createdAt
    createdBy {
      id
      fullName
    }
    updatedAt
    updatedBy {
      id
      fullName
    }
    approvedBy {
      id
      fullName
    }
    archivedAt
    archivedBy {
      id
      fullName
    }
    creativeFilters {
      archived
    }
  }
}
    `;

/**
 * __useGetCreativeHeaderDetailsQuery__
 *
 * To run a query within a React component, call `useGetCreativeHeaderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeHeaderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeHeaderDetailsQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeHeaderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables> & ({ variables: GetCreativeHeaderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables>(GetCreativeHeaderDetailsDocument, options);
      }
export function useGetCreativeHeaderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables>(GetCreativeHeaderDetailsDocument, options);
        }
export function useGetCreativeHeaderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables>(GetCreativeHeaderDetailsDocument, options);
        }
export type GetCreativeHeaderDetailsQueryHookResult = ReturnType<typeof useGetCreativeHeaderDetailsQuery>;
export type GetCreativeHeaderDetailsLazyQueryHookResult = ReturnType<typeof useGetCreativeHeaderDetailsLazyQuery>;
export type GetCreativeHeaderDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCreativeHeaderDetailsSuspenseQuery>;
export type GetCreativeHeaderDetailsQueryResult = Apollo.QueryResult<GetCreativeHeaderDetailsQuery, GetCreativeHeaderDetailsQueryVariables>;
export const CreativeUpdateTitleDocument = gql`
    mutation CreativeUpdateTitle($creativeId: ID!, $title: String!) {
  creativeRename(creativeId: $creativeId, title: $title) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeDetailsFields
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CreativeDetailsFieldsFragmentDoc}`;
export type CreativeUpdateTitleMutationFn = Apollo.MutationFunction<CreativeUpdateTitleMutation, CreativeUpdateTitleMutationVariables>;

/**
 * __useCreativeUpdateTitleMutation__
 *
 * To run a mutation, you first call `useCreativeUpdateTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeUpdateTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeUpdateTitleMutation, { data, loading, error }] = useCreativeUpdateTitleMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreativeUpdateTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreativeUpdateTitleMutation, CreativeUpdateTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeUpdateTitleMutation, CreativeUpdateTitleMutationVariables>(CreativeUpdateTitleDocument, options);
      }
export type CreativeUpdateTitleMutationHookResult = ReturnType<typeof useCreativeUpdateTitleMutation>;
export type CreativeUpdateTitleMutationResult = Apollo.MutationResult<CreativeUpdateTitleMutation>;
export type CreativeUpdateTitleMutationOptions = Apollo.BaseMutationOptions<CreativeUpdateTitleMutation, CreativeUpdateTitleMutationVariables>;
export const CreativeApproveDocument = gql`
    mutation CreativeApprove($creativeId: ID!) {
  creativeApprove(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeApproveMutationFn = Apollo.MutationFunction<CreativeApproveMutation, CreativeApproveMutationVariables>;

/**
 * __useCreativeApproveMutation__
 *
 * To run a mutation, you first call `useCreativeApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeApproveMutation, { data, loading, error }] = useCreativeApproveMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeApproveMutation(baseOptions?: Apollo.MutationHookOptions<CreativeApproveMutation, CreativeApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeApproveMutation, CreativeApproveMutationVariables>(CreativeApproveDocument, options);
      }
export type CreativeApproveMutationHookResult = ReturnType<typeof useCreativeApproveMutation>;
export type CreativeApproveMutationResult = Apollo.MutationResult<CreativeApproveMutation>;
export type CreativeApproveMutationOptions = Apollo.BaseMutationOptions<CreativeApproveMutation, CreativeApproveMutationVariables>;
export const CreativeRevertToDraftDocument = gql`
    mutation CreativeRevertToDraft($creativeId: ID!) {
  creativeRevertToDraft(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeRevertToDraftMutationFn = Apollo.MutationFunction<CreativeRevertToDraftMutation, CreativeRevertToDraftMutationVariables>;

/**
 * __useCreativeRevertToDraftMutation__
 *
 * To run a mutation, you first call `useCreativeRevertToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeRevertToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeRevertToDraftMutation, { data, loading, error }] = useCreativeRevertToDraftMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeRevertToDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreativeRevertToDraftMutation, CreativeRevertToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeRevertToDraftMutation, CreativeRevertToDraftMutationVariables>(CreativeRevertToDraftDocument, options);
      }
export type CreativeRevertToDraftMutationHookResult = ReturnType<typeof useCreativeRevertToDraftMutation>;
export type CreativeRevertToDraftMutationResult = Apollo.MutationResult<CreativeRevertToDraftMutation>;
export type CreativeRevertToDraftMutationOptions = Apollo.BaseMutationOptions<CreativeRevertToDraftMutation, CreativeRevertToDraftMutationVariables>;
export const CreativeRejectDocument = gql`
    mutation CreativeReject($creativeId: ID!) {
  creativeReject(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeRejectMutationFn = Apollo.MutationFunction<CreativeRejectMutation, CreativeRejectMutationVariables>;

/**
 * __useCreativeRejectMutation__
 *
 * To run a mutation, you first call `useCreativeRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeRejectMutation, { data, loading, error }] = useCreativeRejectMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeRejectMutation(baseOptions?: Apollo.MutationHookOptions<CreativeRejectMutation, CreativeRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeRejectMutation, CreativeRejectMutationVariables>(CreativeRejectDocument, options);
      }
export type CreativeRejectMutationHookResult = ReturnType<typeof useCreativeRejectMutation>;
export type CreativeRejectMutationResult = Apollo.MutationResult<CreativeRejectMutation>;
export type CreativeRejectMutationOptions = Apollo.BaseMutationOptions<CreativeRejectMutation, CreativeRejectMutationVariables>;
export const CreativeSyncToEspDocument = gql`
    mutation CreativeSyncToEsp($creativeId: ID!) {
  creativeSyncToEsp(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeSyncToEspMutationFn = Apollo.MutationFunction<CreativeSyncToEspMutation, CreativeSyncToEspMutationVariables>;

/**
 * __useCreativeSyncToEspMutation__
 *
 * To run a mutation, you first call `useCreativeSyncToEspMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeSyncToEspMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeSyncToEspMutation, { data, loading, error }] = useCreativeSyncToEspMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeSyncToEspMutation(baseOptions?: Apollo.MutationHookOptions<CreativeSyncToEspMutation, CreativeSyncToEspMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeSyncToEspMutation, CreativeSyncToEspMutationVariables>(CreativeSyncToEspDocument, options);
      }
export type CreativeSyncToEspMutationHookResult = ReturnType<typeof useCreativeSyncToEspMutation>;
export type CreativeSyncToEspMutationResult = Apollo.MutationResult<CreativeSyncToEspMutation>;
export type CreativeSyncToEspMutationOptions = Apollo.BaseMutationOptions<CreativeSyncToEspMutation, CreativeSyncToEspMutationVariables>;
export const CreativeDuplicateDocument = gql`
    mutation CreativeDuplicate($creativeId: ID!) {
  creativeDuplicate(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeDuplicateMutationFn = Apollo.MutationFunction<CreativeDuplicateMutation, CreativeDuplicateMutationVariables>;

/**
 * __useCreativeDuplicateMutation__
 *
 * To run a mutation, you first call `useCreativeDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeDuplicateMutation, { data, loading, error }] = useCreativeDuplicateMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeDuplicateMutation, CreativeDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeDuplicateMutation, CreativeDuplicateMutationVariables>(CreativeDuplicateDocument, options);
      }
export type CreativeDuplicateMutationHookResult = ReturnType<typeof useCreativeDuplicateMutation>;
export type CreativeDuplicateMutationResult = Apollo.MutationResult<CreativeDuplicateMutation>;
export type CreativeDuplicateMutationOptions = Apollo.BaseMutationOptions<CreativeDuplicateMutation, CreativeDuplicateMutationVariables>;
export const CreativeDeleteDocument = gql`
    mutation CreativeDelete($creativeId: ID!) {
  creativeDelete(creativeId: $creativeId) {
    ... on Ok {
      success
    }
  }
}
    `;
export type CreativeDeleteMutationFn = Apollo.MutationFunction<CreativeDeleteMutation, CreativeDeleteMutationVariables>;

/**
 * __useCreativeDeleteMutation__
 *
 * To run a mutation, you first call `useCreativeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeDeleteMutation, { data, loading, error }] = useCreativeDeleteMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CreativeDeleteMutation, CreativeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeDeleteMutation, CreativeDeleteMutationVariables>(CreativeDeleteDocument, options);
      }
export type CreativeDeleteMutationHookResult = ReturnType<typeof useCreativeDeleteMutation>;
export type CreativeDeleteMutationResult = Apollo.MutationResult<CreativeDeleteMutation>;
export type CreativeDeleteMutationOptions = Apollo.BaseMutationOptions<CreativeDeleteMutation, CreativeDeleteMutationVariables>;
export const CreativeArchiveDocument = gql`
    mutation CreativeArchive($creativeId: ID!) {
  creativeArchive(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeArchiveMutationFn = Apollo.MutationFunction<CreativeArchiveMutation, CreativeArchiveMutationVariables>;

/**
 * __useCreativeArchiveMutation__
 *
 * To run a mutation, you first call `useCreativeArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeArchiveMutation, { data, loading, error }] = useCreativeArchiveMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeArchiveMutation(baseOptions?: Apollo.MutationHookOptions<CreativeArchiveMutation, CreativeArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeArchiveMutation, CreativeArchiveMutationVariables>(CreativeArchiveDocument, options);
      }
export type CreativeArchiveMutationHookResult = ReturnType<typeof useCreativeArchiveMutation>;
export type CreativeArchiveMutationResult = Apollo.MutationResult<CreativeArchiveMutation>;
export type CreativeArchiveMutationOptions = Apollo.BaseMutationOptions<CreativeArchiveMutation, CreativeArchiveMutationVariables>;
export const CreativeUnarchiveDocument = gql`
    mutation CreativeUnarchive($creativeId: ID!) {
  creativeUnarchive(creativeId: $creativeId) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeUnarchiveMutationFn = Apollo.MutationFunction<CreativeUnarchiveMutation, CreativeUnarchiveMutationVariables>;

/**
 * __useCreativeUnarchiveMutation__
 *
 * To run a mutation, you first call `useCreativeUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeUnarchiveMutation, { data, loading, error }] = useCreativeUnarchiveMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCreativeUnarchiveMutation(baseOptions?: Apollo.MutationHookOptions<CreativeUnarchiveMutation, CreativeUnarchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeUnarchiveMutation, CreativeUnarchiveMutationVariables>(CreativeUnarchiveDocument, options);
      }
export type CreativeUnarchiveMutationHookResult = ReturnType<typeof useCreativeUnarchiveMutation>;
export type CreativeUnarchiveMutationResult = Apollo.MutationResult<CreativeUnarchiveMutation>;
export type CreativeUnarchiveMutationOptions = Apollo.BaseMutationOptions<CreativeUnarchiveMutation, CreativeUnarchiveMutationVariables>;
export const CreativesProofDocument = gql`
    mutation CreativesProof($channel: Channel, $channelIds: [String!], $contactGroupIds: [ID!], $contactIds: [ID!], $creativeIds: [ID!]!, $emails: [String!]) {
  creativesProof(
    channel: $channel
    channelIds: $channelIds
    contactGroupIds: $contactGroupIds
    contactIds: $contactIds
    creativeIds: $creativeIds
    emails: $emails
  ) {
    success
  }
}
    `;
export type CreativesProofMutationFn = Apollo.MutationFunction<CreativesProofMutation, CreativesProofMutationVariables>;

/**
 * __useCreativesProofMutation__
 *
 * To run a mutation, you first call `useCreativesProofMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativesProofMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativesProofMutation, { data, loading, error }] = useCreativesProofMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      channelIds: // value for 'channelIds'
 *      contactGroupIds: // value for 'contactGroupIds'
 *      contactIds: // value for 'contactIds'
 *      creativeIds: // value for 'creativeIds'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useCreativesProofMutation(baseOptions?: Apollo.MutationHookOptions<CreativesProofMutation, CreativesProofMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativesProofMutation, CreativesProofMutationVariables>(CreativesProofDocument, options);
      }
export type CreativesProofMutationHookResult = ReturnType<typeof useCreativesProofMutation>;
export type CreativesProofMutationResult = Apollo.MutationResult<CreativesProofMutation>;
export type CreativesProofMutationOptions = Apollo.BaseMutationOptions<CreativesProofMutation, CreativesProofMutationVariables>;
export const FetchCreativesDocument = gql`
    query FetchCreatives($page: Int!, $pageSize: Int, $filter: CreativeFilter, $orderBy: [CreativeOrderBy!]) {
  creatives(page: $page, pageSize: $pageSize, filter: $filter, orderBy: $orderBy) {
    page
    total
    results {
      ...creativeFields
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;

/**
 * __useFetchCreativesQuery__
 *
 * To run a query within a React component, call `useFetchCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreativesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFetchCreativesQuery(baseOptions: Apollo.QueryHookOptions<FetchCreativesQuery, FetchCreativesQueryVariables> & ({ variables: FetchCreativesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreativesQuery, FetchCreativesQueryVariables>(FetchCreativesDocument, options);
      }
export function useFetchCreativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreativesQuery, FetchCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreativesQuery, FetchCreativesQueryVariables>(FetchCreativesDocument, options);
        }
export function useFetchCreativesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCreativesQuery, FetchCreativesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCreativesQuery, FetchCreativesQueryVariables>(FetchCreativesDocument, options);
        }
export type FetchCreativesQueryHookResult = ReturnType<typeof useFetchCreativesQuery>;
export type FetchCreativesLazyQueryHookResult = ReturnType<typeof useFetchCreativesLazyQuery>;
export type FetchCreativesSuspenseQueryHookResult = ReturnType<typeof useFetchCreativesSuspenseQuery>;
export type FetchCreativesQueryResult = Apollo.QueryResult<FetchCreativesQuery, FetchCreativesQueryVariables>;
export const FetchCreativesFiltersCountsDocument = gql`
    query FetchCreativesFiltersCounts($filter: CreativeFilter) {
  creativeFiltersCounts(filter: $filter) {
    perStatus {
      status
      total
    }
    perAvailability {
      availability
      total
    }
    incomplete
    archived
  }
}
    `;

/**
 * __useFetchCreativesFiltersCountsQuery__
 *
 * To run a query within a React component, call `useFetchCreativesFiltersCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreativesFiltersCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreativesFiltersCountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchCreativesFiltersCountsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>(FetchCreativesFiltersCountsDocument, options);
      }
export function useFetchCreativesFiltersCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>(FetchCreativesFiltersCountsDocument, options);
        }
export function useFetchCreativesFiltersCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>(FetchCreativesFiltersCountsDocument, options);
        }
export type FetchCreativesFiltersCountsQueryHookResult = ReturnType<typeof useFetchCreativesFiltersCountsQuery>;
export type FetchCreativesFiltersCountsLazyQueryHookResult = ReturnType<typeof useFetchCreativesFiltersCountsLazyQuery>;
export type FetchCreativesFiltersCountsSuspenseQueryHookResult = ReturnType<typeof useFetchCreativesFiltersCountsSuspenseQuery>;
export type FetchCreativesFiltersCountsQueryResult = Apollo.QueryResult<FetchCreativesFiltersCountsQuery, FetchCreativesFiltersCountsQueryVariables>;
export const FetchCreativesFiltersDocument = gql`
    query FetchCreativesFilters($page: Int!, $pageSize: Int, $filter: CreativeFilter, $orderBy: [CreativeOrderBy!]) {
  creatives(page: $page, pageSize: $pageSize, filter: $filter, orderBy: $orderBy) {
    results {
      id
      status
      creativeFilters {
        archived
      }
    }
  }
}
    `;

/**
 * __useFetchCreativesFiltersQuery__
 *
 * To run a query within a React component, call `useFetchCreativesFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreativesFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreativesFiltersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFetchCreativesFiltersQuery(baseOptions: Apollo.QueryHookOptions<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables> & ({ variables: FetchCreativesFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables>(FetchCreativesFiltersDocument, options);
      }
export function useFetchCreativesFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables>(FetchCreativesFiltersDocument, options);
        }
export function useFetchCreativesFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables>(FetchCreativesFiltersDocument, options);
        }
export type FetchCreativesFiltersQueryHookResult = ReturnType<typeof useFetchCreativesFiltersQuery>;
export type FetchCreativesFiltersLazyQueryHookResult = ReturnType<typeof useFetchCreativesFiltersLazyQuery>;
export type FetchCreativesFiltersSuspenseQueryHookResult = ReturnType<typeof useFetchCreativesFiltersSuspenseQuery>;
export type FetchCreativesFiltersQueryResult = Apollo.QueryResult<FetchCreativesFiltersQuery, FetchCreativesFiltersQueryVariables>;
export const FetchCreativeAttributeDefinitionsDocument = gql`
    query FetchCreativeAttributeDefinitions($filterable: Boolean) {
  creativeAttributeDefinitions(filterable: $filterable) {
    id
    title
    required
    placeholder
    help
  }
}
    `;

/**
 * __useFetchCreativeAttributeDefinitionsQuery__
 *
 * To run a query within a React component, call `useFetchCreativeAttributeDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreativeAttributeDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreativeAttributeDefinitionsQuery({
 *   variables: {
 *      filterable: // value for 'filterable'
 *   },
 * });
 */
export function useFetchCreativeAttributeDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>(FetchCreativeAttributeDefinitionsDocument, options);
      }
export function useFetchCreativeAttributeDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>(FetchCreativeAttributeDefinitionsDocument, options);
        }
export function useFetchCreativeAttributeDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>(FetchCreativeAttributeDefinitionsDocument, options);
        }
export type FetchCreativeAttributeDefinitionsQueryHookResult = ReturnType<typeof useFetchCreativeAttributeDefinitionsQuery>;
export type FetchCreativeAttributeDefinitionsLazyQueryHookResult = ReturnType<typeof useFetchCreativeAttributeDefinitionsLazyQuery>;
export type FetchCreativeAttributeDefinitionsSuspenseQueryHookResult = ReturnType<typeof useFetchCreativeAttributeDefinitionsSuspenseQuery>;
export type FetchCreativeAttributeDefinitionsQueryResult = Apollo.QueryResult<FetchCreativeAttributeDefinitionsQuery, FetchCreativeAttributeDefinitionsQueryVariables>;
export const CreativeCreateDocument = gql`
    mutation CreativeCreate($title: String!, $tagIds: [ID!]) {
  creativeCreate(title: $title, tagIds: $tagIds) {
    ... on CreativeSuccess {
      success
      creative {
        ...creativeFields
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CreativeFieldsFragmentDoc}`;
export type CreativeCreateMutationFn = Apollo.MutationFunction<CreativeCreateMutation, CreativeCreateMutationVariables>;

/**
 * __useCreativeCreateMutation__
 *
 * To run a mutation, you first call `useCreativeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeCreateMutation, { data, loading, error }] = useCreativeCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useCreativeCreateMutation(baseOptions?: Apollo.MutationHookOptions<CreativeCreateMutation, CreativeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeCreateMutation, CreativeCreateMutationVariables>(CreativeCreateDocument, options);
      }
export type CreativeCreateMutationHookResult = ReturnType<typeof useCreativeCreateMutation>;
export type CreativeCreateMutationResult = Apollo.MutationResult<CreativeCreateMutation>;
export type CreativeCreateMutationOptions = Apollo.BaseMutationOptions<CreativeCreateMutation, CreativeCreateMutationVariables>;
export const CreativeExportDocument = gql`
    mutation CreativeExport($columns: [String!], $filter: CreativeFilter!) {
  creativeExport(columns: $columns, filter: $filter) {
    signedUrl
  }
}
    `;
export type CreativeExportMutationFn = Apollo.MutationFunction<CreativeExportMutation, CreativeExportMutationVariables>;

/**
 * __useCreativeExportMutation__
 *
 * To run a mutation, you first call `useCreativeExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativeExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativeExportMutation, { data, loading, error }] = useCreativeExportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreativeExportMutation(baseOptions?: Apollo.MutationHookOptions<CreativeExportMutation, CreativeExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativeExportMutation, CreativeExportMutationVariables>(CreativeExportDocument, options);
      }
export type CreativeExportMutationHookResult = ReturnType<typeof useCreativeExportMutation>;
export type CreativeExportMutationResult = Apollo.MutationResult<CreativeExportMutation>;
export type CreativeExportMutationOptions = Apollo.BaseMutationOptions<CreativeExportMutation, CreativeExportMutationVariables>;
export const DataConnectionTestExternalSftpServerDocument = gql`
    mutation DataConnectionTestExternalSftpServer($directory: String!, $host: String!, $password: String, $port: Int!, $user: String) {
  dataConnectionTestExternalSftpServer(
    directory: $directory
    host: $host
    password: $password
    port: $port
    user: $user
  ) {
    dataConnectionTest {
      status
      error {
        reason
        occurredAt
      }
    }
  }
}
    `;
export type DataConnectionTestExternalSftpServerMutationFn = Apollo.MutationFunction<DataConnectionTestExternalSftpServerMutation, DataConnectionTestExternalSftpServerMutationVariables>;

/**
 * __useDataConnectionTestExternalSftpServerMutation__
 *
 * To run a mutation, you first call `useDataConnectionTestExternalSftpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionTestExternalSftpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataConnectionTestExternalSftpServerMutation, { data, loading, error }] = useDataConnectionTestExternalSftpServerMutation({
 *   variables: {
 *      directory: // value for 'directory'
 *      host: // value for 'host'
 *      password: // value for 'password'
 *      port: // value for 'port'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useDataConnectionTestExternalSftpServerMutation(baseOptions?: Apollo.MutationHookOptions<DataConnectionTestExternalSftpServerMutation, DataConnectionTestExternalSftpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataConnectionTestExternalSftpServerMutation, DataConnectionTestExternalSftpServerMutationVariables>(DataConnectionTestExternalSftpServerDocument, options);
      }
export type DataConnectionTestExternalSftpServerMutationHookResult = ReturnType<typeof useDataConnectionTestExternalSftpServerMutation>;
export type DataConnectionTestExternalSftpServerMutationResult = Apollo.MutationResult<DataConnectionTestExternalSftpServerMutation>;
export type DataConnectionTestExternalSftpServerMutationOptions = Apollo.BaseMutationOptions<DataConnectionTestExternalSftpServerMutation, DataConnectionTestExternalSftpServerMutationVariables>;
export const DataConnectionCreateDocument = gql`
    mutation dataConnectionCreate($name: String!, $hostedSftpServer: DataConnectionHostedSFTPServerInput, $externalSftpServer: DataConnectionExternalSFTPServerInput, $externalGcsBucket: DataConnectionExternalGCSBucketInput, $hostedGcsBucket: DataConnectionHostedGCSBucketInput, $externalS3Bucket: DataConnectionExternalS3BucketInput) {
  dataConnectionCreate(
    name: $name
    hostedSftpServer: $hostedSftpServer
    externalSftpServer: $externalSftpServer
    externalGcsBucket: $externalGcsBucket
    hostedGcsBucket: $hostedGcsBucket
    externalS3Bucket: $externalS3Bucket
  ) {
    dataConnection {
      id
      createdAt
      updatedAt
      name
      status
      errors {
        reason
        occurredAt
      }
      connector {
        __typename
        ... on DataConnectionHostedSFTPServer {
          host
          user
          port
          hostedSftpPublicKey: publicKey
          publicKeys {
            name
            key
          }
        }
        ... on DataConnectionExternalSFTPServer {
          host
          port
          user
          authentication
          password
          externalSftpPublicKey: publicKey
          directory
        }
        ... on DataConnectionExternalGCSBucket {
          name
          externalGcsBucketServiceAccountEmail: serviceAccountEmail
        }
        ... on DataConnectionHostedGCSBucket {
          name
          hostedGcsBucketServiceAccountEmail: serviceAccountEmail
          hmacKeys {
            id
            secret
          }
        }
        ... on DataConnectionExternalS3Bucket {
          name
          region
          roleArn
          externalId
          prefix
        }
      }
    }
  }
}
    `;
export type DataConnectionCreateMutationFn = Apollo.MutationFunction<DataConnectionCreateMutation, DataConnectionCreateMutationVariables>;

/**
 * __useDataConnectionCreateMutation__
 *
 * To run a mutation, you first call `useDataConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataConnectionCreateMutation, { data, loading, error }] = useDataConnectionCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      hostedSftpServer: // value for 'hostedSftpServer'
 *      externalSftpServer: // value for 'externalSftpServer'
 *      externalGcsBucket: // value for 'externalGcsBucket'
 *      hostedGcsBucket: // value for 'hostedGcsBucket'
 *      externalS3Bucket: // value for 'externalS3Bucket'
 *   },
 * });
 */
export function useDataConnectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataConnectionCreateMutation, DataConnectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataConnectionCreateMutation, DataConnectionCreateMutationVariables>(DataConnectionCreateDocument, options);
      }
export type DataConnectionCreateMutationHookResult = ReturnType<typeof useDataConnectionCreateMutation>;
export type DataConnectionCreateMutationResult = Apollo.MutationResult<DataConnectionCreateMutation>;
export type DataConnectionCreateMutationOptions = Apollo.BaseMutationOptions<DataConnectionCreateMutation, DataConnectionCreateMutationVariables>;
export const DataConnectionUpdateDocument = gql`
    mutation dataConnectionUpdate($id: ID!, $name: String, $hostedSftpServer: DataConnectionHostedSFTPServerInput) {
  dataConnectionUpdate(id: $id, name: $name, hostedSftpServer: $hostedSftpServer) {
    dataConnection {
      id
      name
      connector {
        ... on DataConnectionHostedSFTPServer {
          host
          port
          user
          publicKey
          publicKeys {
            name
            key
          }
        }
      }
    }
  }
}
    `;
export type DataConnectionUpdateMutationFn = Apollo.MutationFunction<DataConnectionUpdateMutation, DataConnectionUpdateMutationVariables>;

/**
 * __useDataConnectionUpdateMutation__
 *
 * To run a mutation, you first call `useDataConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataConnectionUpdateMutation, { data, loading, error }] = useDataConnectionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      hostedSftpServer: // value for 'hostedSftpServer'
 *   },
 * });
 */
export function useDataConnectionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataConnectionUpdateMutation, DataConnectionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataConnectionUpdateMutation, DataConnectionUpdateMutationVariables>(DataConnectionUpdateDocument, options);
      }
export type DataConnectionUpdateMutationHookResult = ReturnType<typeof useDataConnectionUpdateMutation>;
export type DataConnectionUpdateMutationResult = Apollo.MutationResult<DataConnectionUpdateMutation>;
export type DataConnectionUpdateMutationOptions = Apollo.BaseMutationOptions<DataConnectionUpdateMutation, DataConnectionUpdateMutationVariables>;
export const DataConnectionHealthcheckDocument = gql`
    mutation DataConnectionHealthcheck($id: ID!) {
  dataConnectionHealthcheck(id: $id) {
    dataConnection {
      id
      createdAt
      updatedAt
      name
      status
      connector {
        __typename
        ... on DataConnectionHostedGCSBucket {
          name
          hostedGcsBucketServiceAccountEmail: serviceAccountEmail
        }
        ... on DataConnectionExternalGCSBucket {
          name
          externalGcsBucketServiceAccountEmail: serviceAccountEmail
        }
        ... on DataConnectionHostedSFTPServer {
          host
          port
          user
          publicKey
        }
        ... on DataConnectionExternalSFTPServer {
          host
          user
          password
          publicKeyExternalSFTP: publicKey
          directory
          port
        }
        ... on DataConnectionExternalS3Bucket {
          name
          region
          roleArn
          externalId
          prefix
        }
      }
      errors {
        reason
        occurredAt
      }
    }
  }
}
    `;
export type DataConnectionHealthcheckMutationFn = Apollo.MutationFunction<DataConnectionHealthcheckMutation, DataConnectionHealthcheckMutationVariables>;

/**
 * __useDataConnectionHealthcheckMutation__
 *
 * To run a mutation, you first call `useDataConnectionHealthcheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionHealthcheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataConnectionHealthcheckMutation, { data, loading, error }] = useDataConnectionHealthcheckMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataConnectionHealthcheckMutation(baseOptions?: Apollo.MutationHookOptions<DataConnectionHealthcheckMutation, DataConnectionHealthcheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataConnectionHealthcheckMutation, DataConnectionHealthcheckMutationVariables>(DataConnectionHealthcheckDocument, options);
      }
export type DataConnectionHealthcheckMutationHookResult = ReturnType<typeof useDataConnectionHealthcheckMutation>;
export type DataConnectionHealthcheckMutationResult = Apollo.MutationResult<DataConnectionHealthcheckMutation>;
export type DataConnectionHealthcheckMutationOptions = Apollo.BaseMutationOptions<DataConnectionHealthcheckMutation, DataConnectionHealthcheckMutationVariables>;
export const DataConnectionDetailDocument = gql`
    query DataConnectionDetail($id: ID!) {
  dataConnection(id: $id) {
    id
    createdAt
    updatedAt
    name
    status
    connector {
      __typename
      ... on DataConnectionHostedGCSBucket {
        name
        hostedGcsBucketServiceAccountEmail: serviceAccountEmail
        hmacKeys {
          id
          secret
        }
      }
      ... on DataConnectionExternalGCSBucket {
        name
        externalGcsBucketServiceAccountEmail: serviceAccountEmail
      }
      ... on DataConnectionHostedSFTPServer {
        host
        port
        user
        publicKey
        publicKeys {
          name
          key
        }
      }
      ... on DataConnectionExternalSFTPServer {
        host
        user
        password
        publicKeyExternalSFTP: publicKey
        directory
        port
      }
      ... on DataConnectionExternalS3Bucket {
        name
        region
        roleArn
        externalId
        prefix
      }
    }
    errors {
      reason
      occurredAt
    }
  }
}
    `;

/**
 * __useDataConnectionDetailQuery__
 *
 * To run a query within a React component, call `useDataConnectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataConnectionDetailQuery(baseOptions: Apollo.QueryHookOptions<DataConnectionDetailQuery, DataConnectionDetailQueryVariables> & ({ variables: DataConnectionDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataConnectionDetailQuery, DataConnectionDetailQueryVariables>(DataConnectionDetailDocument, options);
      }
export function useDataConnectionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataConnectionDetailQuery, DataConnectionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataConnectionDetailQuery, DataConnectionDetailQueryVariables>(DataConnectionDetailDocument, options);
        }
export function useDataConnectionDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataConnectionDetailQuery, DataConnectionDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataConnectionDetailQuery, DataConnectionDetailQueryVariables>(DataConnectionDetailDocument, options);
        }
export type DataConnectionDetailQueryHookResult = ReturnType<typeof useDataConnectionDetailQuery>;
export type DataConnectionDetailLazyQueryHookResult = ReturnType<typeof useDataConnectionDetailLazyQuery>;
export type DataConnectionDetailSuspenseQueryHookResult = ReturnType<typeof useDataConnectionDetailSuspenseQuery>;
export type DataConnectionDetailQueryResult = Apollo.QueryResult<DataConnectionDetailQuery, DataConnectionDetailQueryVariables>;
export const GenerateHmacKeyDocument = gql`
    mutation generateHmacKey($id: ID!, $hmacKeys: [HMACKeyInput!]) {
  dataConnectionUpdate(
    id: $id
    hostedGcsBucket: {generateHmacKey: true, hmacKeys: $hmacKeys}
  ) {
    dataConnection {
      id
      connector {
        ... on DataConnectionHostedGCSBucket {
          hmacKeys {
            id
            secret
          }
        }
      }
    }
  }
}
    `;
export type GenerateHmacKeyMutationFn = Apollo.MutationFunction<GenerateHmacKeyMutation, GenerateHmacKeyMutationVariables>;

/**
 * __useGenerateHmacKeyMutation__
 *
 * To run a mutation, you first call `useGenerateHmacKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHmacKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHmacKeyMutation, { data, loading, error }] = useGenerateHmacKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hmacKeys: // value for 'hmacKeys'
 *   },
 * });
 */
export function useGenerateHmacKeyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateHmacKeyMutation, GenerateHmacKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateHmacKeyMutation, GenerateHmacKeyMutationVariables>(GenerateHmacKeyDocument, options);
      }
export type GenerateHmacKeyMutationHookResult = ReturnType<typeof useGenerateHmacKeyMutation>;
export type GenerateHmacKeyMutationResult = Apollo.MutationResult<GenerateHmacKeyMutation>;
export type GenerateHmacKeyMutationOptions = Apollo.BaseMutationOptions<GenerateHmacKeyMutation, GenerateHmacKeyMutationVariables>;
export const DeleteHmacKeyDocument = gql`
    mutation deleteHmacKey($id: ID!, $hmacKeys: [HMACKeyInput!]!) {
  dataConnectionUpdate(
    id: $id
    hostedGcsBucket: {generateHmacKey: false, hmacKeys: $hmacKeys}
  ) {
    dataConnection {
      id
      connector {
        ... on DataConnectionHostedGCSBucket {
          hmacKeys {
            id
            secret
          }
        }
      }
    }
  }
}
    `;
export type DeleteHmacKeyMutationFn = Apollo.MutationFunction<DeleteHmacKeyMutation, DeleteHmacKeyMutationVariables>;

/**
 * __useDeleteHmacKeyMutation__
 *
 * To run a mutation, you first call `useDeleteHmacKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHmacKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHmacKeyMutation, { data, loading, error }] = useDeleteHmacKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hmacKeys: // value for 'hmacKeys'
 *   },
 * });
 */
export function useDeleteHmacKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHmacKeyMutation, DeleteHmacKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHmacKeyMutation, DeleteHmacKeyMutationVariables>(DeleteHmacKeyDocument, options);
      }
export type DeleteHmacKeyMutationHookResult = ReturnType<typeof useDeleteHmacKeyMutation>;
export type DeleteHmacKeyMutationResult = Apollo.MutationResult<DeleteHmacKeyMutation>;
export type DeleteHmacKeyMutationOptions = Apollo.BaseMutationOptions<DeleteHmacKeyMutation, DeleteHmacKeyMutationVariables>;
export const DataEncryptionConnectionPgpKeysDocument = gql`
    query DataEncryptionConnectionPgpKeys($connectionId: ID!) {
  dataEncryptionConnectionPgpKeys(connectionId: $connectionId) {
    encryptPgpKeys {
      ...PgpKeyFragment
    }
    decryptPgpKeys {
      ...PgpKeyFragment
    }
  }
}
    ${PgpKeyFragmentFragmentDoc}`;

/**
 * __useDataEncryptionConnectionPgpKeysQuery__
 *
 * To run a query within a React component, call `useDataEncryptionConnectionPgpKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionConnectionPgpKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataEncryptionConnectionPgpKeysQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useDataEncryptionConnectionPgpKeysQuery(baseOptions: Apollo.QueryHookOptions<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables> & ({ variables: DataEncryptionConnectionPgpKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables>(DataEncryptionConnectionPgpKeysDocument, options);
      }
export function useDataEncryptionConnectionPgpKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables>(DataEncryptionConnectionPgpKeysDocument, options);
        }
export function useDataEncryptionConnectionPgpKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables>(DataEncryptionConnectionPgpKeysDocument, options);
        }
export type DataEncryptionConnectionPgpKeysQueryHookResult = ReturnType<typeof useDataEncryptionConnectionPgpKeysQuery>;
export type DataEncryptionConnectionPgpKeysLazyQueryHookResult = ReturnType<typeof useDataEncryptionConnectionPgpKeysLazyQuery>;
export type DataEncryptionConnectionPgpKeysSuspenseQueryHookResult = ReturnType<typeof useDataEncryptionConnectionPgpKeysSuspenseQuery>;
export type DataEncryptionConnectionPgpKeysQueryResult = Apollo.QueryResult<DataEncryptionConnectionPgpKeysQuery, DataEncryptionConnectionPgpKeysQueryVariables>;
export const DataEncryptionConnectionPgpKeyAttachDocument = gql`
    mutation DataEncryptionConnectionPgpKeyAttach($connectionId: String!, $pgpKeyId: String!) {
  dataEncryptionConnectionPgpKeyAttach(
    connectionId: $connectionId
    pgpKeyId: $pgpKeyId
  ) {
    success
    connection {
      id
      pgpKeys {
        encryptPgpKeys {
          ...PgpKeyFragment
        }
        decryptPgpKeys {
          ...PgpKeyFragment
        }
      }
    }
  }
}
    ${PgpKeyFragmentFragmentDoc}`;
export type DataEncryptionConnectionPgpKeyAttachMutationFn = Apollo.MutationFunction<DataEncryptionConnectionPgpKeyAttachMutation, DataEncryptionConnectionPgpKeyAttachMutationVariables>;

/**
 * __useDataEncryptionConnectionPgpKeyAttachMutation__
 *
 * To run a mutation, you first call `useDataEncryptionConnectionPgpKeyAttachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionConnectionPgpKeyAttachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataEncryptionConnectionPgpKeyAttachMutation, { data, loading, error }] = useDataEncryptionConnectionPgpKeyAttachMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      pgpKeyId: // value for 'pgpKeyId'
 *   },
 * });
 */
export function useDataEncryptionConnectionPgpKeyAttachMutation(baseOptions?: Apollo.MutationHookOptions<DataEncryptionConnectionPgpKeyAttachMutation, DataEncryptionConnectionPgpKeyAttachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataEncryptionConnectionPgpKeyAttachMutation, DataEncryptionConnectionPgpKeyAttachMutationVariables>(DataEncryptionConnectionPgpKeyAttachDocument, options);
      }
export type DataEncryptionConnectionPgpKeyAttachMutationHookResult = ReturnType<typeof useDataEncryptionConnectionPgpKeyAttachMutation>;
export type DataEncryptionConnectionPgpKeyAttachMutationResult = Apollo.MutationResult<DataEncryptionConnectionPgpKeyAttachMutation>;
export type DataEncryptionConnectionPgpKeyAttachMutationOptions = Apollo.BaseMutationOptions<DataEncryptionConnectionPgpKeyAttachMutation, DataEncryptionConnectionPgpKeyAttachMutationVariables>;
export const DataEncryptionConnectionPgpKeyUnattachDocument = gql`
    mutation DataEncryptionConnectionPgpKeyUnattach($connectionId: String!, $pgpKeyId: String!) {
  dataEncryptionConnectionPgpKeyUnattach(
    connectionId: $connectionId
    pgpKeyId: $pgpKeyId
  ) {
    success
    connection {
      id
      pgpKeys {
        encryptPgpKeys {
          ...PgpKeyFragment
        }
        decryptPgpKeys {
          ...PgpKeyFragment
        }
      }
    }
  }
}
    ${PgpKeyFragmentFragmentDoc}`;
export type DataEncryptionConnectionPgpKeyUnattachMutationFn = Apollo.MutationFunction<DataEncryptionConnectionPgpKeyUnattachMutation, DataEncryptionConnectionPgpKeyUnattachMutationVariables>;

/**
 * __useDataEncryptionConnectionPgpKeyUnattachMutation__
 *
 * To run a mutation, you first call `useDataEncryptionConnectionPgpKeyUnattachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionConnectionPgpKeyUnattachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataEncryptionConnectionPgpKeyUnattachMutation, { data, loading, error }] = useDataEncryptionConnectionPgpKeyUnattachMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      pgpKeyId: // value for 'pgpKeyId'
 *   },
 * });
 */
export function useDataEncryptionConnectionPgpKeyUnattachMutation(baseOptions?: Apollo.MutationHookOptions<DataEncryptionConnectionPgpKeyUnattachMutation, DataEncryptionConnectionPgpKeyUnattachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataEncryptionConnectionPgpKeyUnattachMutation, DataEncryptionConnectionPgpKeyUnattachMutationVariables>(DataEncryptionConnectionPgpKeyUnattachDocument, options);
      }
export type DataEncryptionConnectionPgpKeyUnattachMutationHookResult = ReturnType<typeof useDataEncryptionConnectionPgpKeyUnattachMutation>;
export type DataEncryptionConnectionPgpKeyUnattachMutationResult = Apollo.MutationResult<DataEncryptionConnectionPgpKeyUnattachMutation>;
export type DataEncryptionConnectionPgpKeyUnattachMutationOptions = Apollo.BaseMutationOptions<DataEncryptionConnectionPgpKeyUnattachMutation, DataEncryptionConnectionPgpKeyUnattachMutationVariables>;
export const DataConnectionDeleteDocument = gql`
    mutation DataConnectionDelete($id: ID!) {
  dataConnectionDelete(id: $id) {
    success
  }
}
    `;
export type DataConnectionDeleteMutationFn = Apollo.MutationFunction<DataConnectionDeleteMutation, DataConnectionDeleteMutationVariables>;

/**
 * __useDataConnectionDeleteMutation__
 *
 * To run a mutation, you first call `useDataConnectionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataConnectionDeleteMutation, { data, loading, error }] = useDataConnectionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataConnectionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataConnectionDeleteMutation, DataConnectionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataConnectionDeleteMutation, DataConnectionDeleteMutationVariables>(DataConnectionDeleteDocument, options);
      }
export type DataConnectionDeleteMutationHookResult = ReturnType<typeof useDataConnectionDeleteMutation>;
export type DataConnectionDeleteMutationResult = Apollo.MutationResult<DataConnectionDeleteMutation>;
export type DataConnectionDeleteMutationOptions = Apollo.BaseMutationOptions<DataConnectionDeleteMutation, DataConnectionDeleteMutationVariables>;
export const DataConnectionsIndexDocument = gql`
    query DataConnectionsIndex {
  dataConnections {
    id
    createdAt
    updatedAt
    name
    status
    errors {
      reason
      occurredAt
    }
    connector {
      __typename
      ... on DataConnectionHostedGCSBucket {
        name
        hostedGcsBucketServiceAccountEmail: serviceAccountEmail
      }
      ... on DataConnectionExternalGCSBucket {
        name
        externalGcsBucketServiceAccountEmail: serviceAccountEmail
      }
      ... on DataConnectionHostedSFTPServer {
        host
        port
        user
        publicKey
      }
      ... on DataConnectionExternalSFTPServer {
        host
        password
        user
        password
      }
      ... on DataConnectionExternalS3Bucket {
        name
        region
        roleArn
        externalId
        prefix
      }
    }
  }
}
    `;

/**
 * __useDataConnectionsIndexQuery__
 *
 * To run a query within a React component, call `useDataConnectionsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionsIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataConnectionsIndexQuery(baseOptions?: Apollo.QueryHookOptions<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>(DataConnectionsIndexDocument, options);
      }
export function useDataConnectionsIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>(DataConnectionsIndexDocument, options);
        }
export function useDataConnectionsIndexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>(DataConnectionsIndexDocument, options);
        }
export type DataConnectionsIndexQueryHookResult = ReturnType<typeof useDataConnectionsIndexQuery>;
export type DataConnectionsIndexLazyQueryHookResult = ReturnType<typeof useDataConnectionsIndexLazyQuery>;
export type DataConnectionsIndexSuspenseQueryHookResult = ReturnType<typeof useDataConnectionsIndexSuspenseQuery>;
export type DataConnectionsIndexQueryResult = Apollo.QueryResult<DataConnectionsIndexQuery, DataConnectionsIndexQueryVariables>;
export const DatasetsListDocument = gql`
    query DatasetsList {
  datasets {
    datasets {
      ...DatasetsListFragment
    }
  }
}
    ${DatasetsListFragmentFragmentDoc}`;

/**
 * __useDatasetsListQuery__
 *
 * To run a query within a React component, call `useDatasetsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDatasetsListQuery(baseOptions?: Apollo.QueryHookOptions<DatasetsListQuery, DatasetsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetsListQuery, DatasetsListQueryVariables>(DatasetsListDocument, options);
      }
export function useDatasetsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetsListQuery, DatasetsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetsListQuery, DatasetsListQueryVariables>(DatasetsListDocument, options);
        }
export function useDatasetsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DatasetsListQuery, DatasetsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatasetsListQuery, DatasetsListQueryVariables>(DatasetsListDocument, options);
        }
export type DatasetsListQueryHookResult = ReturnType<typeof useDatasetsListQuery>;
export type DatasetsListLazyQueryHookResult = ReturnType<typeof useDatasetsListLazyQuery>;
export type DatasetsListSuspenseQueryHookResult = ReturnType<typeof useDatasetsListSuspenseQuery>;
export type DatasetsListQueryResult = Apollo.QueryResult<DatasetsListQuery, DatasetsListQueryVariables>;
export const DatasetFetchDocument = gql`
    query DatasetFetch($id: ID!) {
  dataset(id: $id) {
    dataset {
      ...DatasetFetchFragment
    }
  }
}
    ${DatasetFetchFragmentFragmentDoc}`;

/**
 * __useDatasetFetchQuery__
 *
 * To run a query within a React component, call `useDatasetFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetFetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDatasetFetchQuery(baseOptions: Apollo.QueryHookOptions<DatasetFetchQuery, DatasetFetchQueryVariables> & ({ variables: DatasetFetchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetFetchQuery, DatasetFetchQueryVariables>(DatasetFetchDocument, options);
      }
export function useDatasetFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetFetchQuery, DatasetFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetFetchQuery, DatasetFetchQueryVariables>(DatasetFetchDocument, options);
        }
export function useDatasetFetchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DatasetFetchQuery, DatasetFetchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatasetFetchQuery, DatasetFetchQueryVariables>(DatasetFetchDocument, options);
        }
export type DatasetFetchQueryHookResult = ReturnType<typeof useDatasetFetchQuery>;
export type DatasetFetchLazyQueryHookResult = ReturnType<typeof useDatasetFetchLazyQuery>;
export type DatasetFetchSuspenseQueryHookResult = ReturnType<typeof useDatasetFetchSuspenseQuery>;
export type DatasetFetchQueryResult = Apollo.QueryResult<DatasetFetchQuery, DatasetFetchQueryVariables>;
export const DatasetFieldsDocument = gql`
    query DatasetFields($datasetId: ID!) {
  datasetFields(datasetId: $datasetId) {
    fields {
      ...DatasetFieldsFragment
    }
  }
}
    ${DatasetFieldsFragmentFragmentDoc}`;

/**
 * __useDatasetFieldsQuery__
 *
 * To run a query within a React component, call `useDatasetFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetFieldsQuery({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDatasetFieldsQuery(baseOptions: Apollo.QueryHookOptions<DatasetFieldsQuery, DatasetFieldsQueryVariables> & ({ variables: DatasetFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetFieldsQuery, DatasetFieldsQueryVariables>(DatasetFieldsDocument, options);
      }
export function useDatasetFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetFieldsQuery, DatasetFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetFieldsQuery, DatasetFieldsQueryVariables>(DatasetFieldsDocument, options);
        }
export function useDatasetFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DatasetFieldsQuery, DatasetFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatasetFieldsQuery, DatasetFieldsQueryVariables>(DatasetFieldsDocument, options);
        }
export type DatasetFieldsQueryHookResult = ReturnType<typeof useDatasetFieldsQuery>;
export type DatasetFieldsLazyQueryHookResult = ReturnType<typeof useDatasetFieldsLazyQuery>;
export type DatasetFieldsSuspenseQueryHookResult = ReturnType<typeof useDatasetFieldsSuspenseQuery>;
export type DatasetFieldsQueryResult = Apollo.QueryResult<DatasetFieldsQuery, DatasetFieldsQueryVariables>;
export const DatasetStatisticsDocument = gql`
    query DatasetStatistics($id: ID!) {
  datasetStatistics(id: $id) {
    rowCount
    sizeOnDisk
  }
}
    `;

/**
 * __useDatasetStatisticsQuery__
 *
 * To run a query within a React component, call `useDatasetStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetStatisticsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDatasetStatisticsQuery(baseOptions: Apollo.QueryHookOptions<DatasetStatisticsQuery, DatasetStatisticsQueryVariables> & ({ variables: DatasetStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetStatisticsQuery, DatasetStatisticsQueryVariables>(DatasetStatisticsDocument, options);
      }
export function useDatasetStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetStatisticsQuery, DatasetStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetStatisticsQuery, DatasetStatisticsQueryVariables>(DatasetStatisticsDocument, options);
        }
export function useDatasetStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DatasetStatisticsQuery, DatasetStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatasetStatisticsQuery, DatasetStatisticsQueryVariables>(DatasetStatisticsDocument, options);
        }
export type DatasetStatisticsQueryHookResult = ReturnType<typeof useDatasetStatisticsQuery>;
export type DatasetStatisticsLazyQueryHookResult = ReturnType<typeof useDatasetStatisticsLazyQuery>;
export type DatasetStatisticsSuspenseQueryHookResult = ReturnType<typeof useDatasetStatisticsSuspenseQuery>;
export type DatasetStatisticsQueryResult = Apollo.QueryResult<DatasetStatisticsQuery, DatasetStatisticsQueryVariables>;
export const WarehousesListDocument = gql`
    query WarehousesList {
  warehouses {
    warehouses {
      type
      default
    }
  }
}
    `;

/**
 * __useWarehousesListQuery__
 *
 * To run a query within a React component, call `useWarehousesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useWarehousesListQuery(baseOptions?: Apollo.QueryHookOptions<WarehousesListQuery, WarehousesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WarehousesListQuery, WarehousesListQueryVariables>(WarehousesListDocument, options);
      }
export function useWarehousesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehousesListQuery, WarehousesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WarehousesListQuery, WarehousesListQueryVariables>(WarehousesListDocument, options);
        }
export function useWarehousesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WarehousesListQuery, WarehousesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WarehousesListQuery, WarehousesListQueryVariables>(WarehousesListDocument, options);
        }
export type WarehousesListQueryHookResult = ReturnType<typeof useWarehousesListQuery>;
export type WarehousesListLazyQueryHookResult = ReturnType<typeof useWarehousesListLazyQuery>;
export type WarehousesListSuspenseQueryHookResult = ReturnType<typeof useWarehousesListSuspenseQuery>;
export type WarehousesListQueryResult = Apollo.QueryResult<WarehousesListQuery, WarehousesListQueryVariables>;
export const ConnectionsListDocument = gql`
    query ConnectionsList {
  connections {
    connections {
      id
      name
    }
  }
}
    `;

/**
 * __useConnectionsListQuery__
 *
 * To run a query within a React component, call `useConnectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectionsListQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsListQuery, ConnectionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsListQuery, ConnectionsListQueryVariables>(ConnectionsListDocument, options);
      }
export function useConnectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsListQuery, ConnectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsListQuery, ConnectionsListQueryVariables>(ConnectionsListDocument, options);
        }
export function useConnectionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectionsListQuery, ConnectionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionsListQuery, ConnectionsListQueryVariables>(ConnectionsListDocument, options);
        }
export type ConnectionsListQueryHookResult = ReturnType<typeof useConnectionsListQuery>;
export type ConnectionsListLazyQueryHookResult = ReturnType<typeof useConnectionsListLazyQuery>;
export type ConnectionsListSuspenseQueryHookResult = ReturnType<typeof useConnectionsListSuspenseQuery>;
export type ConnectionsListQueryResult = Apollo.QueryResult<ConnectionsListQuery, ConnectionsListQueryVariables>;
export const ConnectionStreamsDocument = gql`
    query ConnectionStreams($connectionId: ID!) {
  connectionStreams(id: $connectionId) {
    streams {
      key
      modifiedAt
      sftpFile {
        size
      }
      gcsObject {
        size
      }
      s3Object {
        size
      }
      localFile {
        size
      }
    }
  }
}
    `;

/**
 * __useConnectionStreamsQuery__
 *
 * To run a query within a React component, call `useConnectionStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionStreamsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useConnectionStreamsQuery(baseOptions: Apollo.QueryHookOptions<ConnectionStreamsQuery, ConnectionStreamsQueryVariables> & ({ variables: ConnectionStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionStreamsQuery, ConnectionStreamsQueryVariables>(ConnectionStreamsDocument, options);
      }
export function useConnectionStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionStreamsQuery, ConnectionStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionStreamsQuery, ConnectionStreamsQueryVariables>(ConnectionStreamsDocument, options);
        }
export function useConnectionStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectionStreamsQuery, ConnectionStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionStreamsQuery, ConnectionStreamsQueryVariables>(ConnectionStreamsDocument, options);
        }
export type ConnectionStreamsQueryHookResult = ReturnType<typeof useConnectionStreamsQuery>;
export type ConnectionStreamsLazyQueryHookResult = ReturnType<typeof useConnectionStreamsLazyQuery>;
export type ConnectionStreamsSuspenseQueryHookResult = ReturnType<typeof useConnectionStreamsSuspenseQuery>;
export type ConnectionStreamsQueryResult = Apollo.QueryResult<ConnectionStreamsQuery, ConnectionStreamsQueryVariables>;
export const ConnectionStreamSchemaDocument = gql`
    query ConnectionStreamSchema($connectionId: ID!, $streamKey: String!) {
  connectionStreamSchema(id: $connectionId, streamKey: $streamKey) {
    schema {
      compression
      format {
        csv {
          delimiter
          header
          null
        }
        ndjson {
          placeholder
        }
      }
      fields {
        name
        type
      }
    }
  }
}
    `;

/**
 * __useConnectionStreamSchemaQuery__
 *
 * To run a query within a React component, call `useConnectionStreamSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionStreamSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionStreamSchemaQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      streamKey: // value for 'streamKey'
 *   },
 * });
 */
export function useConnectionStreamSchemaQuery(baseOptions: Apollo.QueryHookOptions<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables> & ({ variables: ConnectionStreamSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables>(ConnectionStreamSchemaDocument, options);
      }
export function useConnectionStreamSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables>(ConnectionStreamSchemaDocument, options);
        }
export function useConnectionStreamSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables>(ConnectionStreamSchemaDocument, options);
        }
export type ConnectionStreamSchemaQueryHookResult = ReturnType<typeof useConnectionStreamSchemaQuery>;
export type ConnectionStreamSchemaLazyQueryHookResult = ReturnType<typeof useConnectionStreamSchemaLazyQuery>;
export type ConnectionStreamSchemaSuspenseQueryHookResult = ReturnType<typeof useConnectionStreamSchemaSuspenseQuery>;
export type ConnectionStreamSchemaQueryResult = Apollo.QueryResult<ConnectionStreamSchemaQuery, ConnectionStreamSchemaQueryVariables>;
export const DatasetCreateDocument = gql`
    mutation DatasetCreate($name: String!, $description: String!, $fields: [InkDataV1DatasetCreateRequestFieldSpecInput!]!, $storageType: String!) {
  datasetCreate(
    name: $name
    description: $description
    fields: $fields
    storageType: $storageType
  ) {
    dataset {
      id
      name
    }
  }
}
    `;
export type DatasetCreateMutationFn = Apollo.MutationFunction<DatasetCreateMutation, DatasetCreateMutationVariables>;

/**
 * __useDatasetCreateMutation__
 *
 * To run a mutation, you first call `useDatasetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDatasetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [datasetCreateMutation, { data, loading, error }] = useDatasetCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      fields: // value for 'fields'
 *      storageType: // value for 'storageType'
 *   },
 * });
 */
export function useDatasetCreateMutation(baseOptions?: Apollo.MutationHookOptions<DatasetCreateMutation, DatasetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DatasetCreateMutation, DatasetCreateMutationVariables>(DatasetCreateDocument, options);
      }
export type DatasetCreateMutationHookResult = ReturnType<typeof useDatasetCreateMutation>;
export type DatasetCreateMutationResult = Apollo.MutationResult<DatasetCreateMutation>;
export type DatasetCreateMutationOptions = Apollo.BaseMutationOptions<DatasetCreateMutation, DatasetCreateMutationVariables>;
export const ModelsListDocument = gql`
    query ModelsList {
  models {
    models {
      ...ModelsListFragment
    }
  }
}
    ${ModelsListFragmentFragmentDoc}`;

/**
 * __useModelsListQuery__
 *
 * To run a query within a React component, call `useModelsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelsListQuery(baseOptions?: Apollo.QueryHookOptions<ModelsListQuery, ModelsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelsListQuery, ModelsListQueryVariables>(ModelsListDocument, options);
      }
export function useModelsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelsListQuery, ModelsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelsListQuery, ModelsListQueryVariables>(ModelsListDocument, options);
        }
export function useModelsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModelsListQuery, ModelsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelsListQuery, ModelsListQueryVariables>(ModelsListDocument, options);
        }
export type ModelsListQueryHookResult = ReturnType<typeof useModelsListQuery>;
export type ModelsListLazyQueryHookResult = ReturnType<typeof useModelsListLazyQuery>;
export type ModelsListSuspenseQueryHookResult = ReturnType<typeof useModelsListSuspenseQuery>;
export type ModelsListQueryResult = Apollo.QueryResult<ModelsListQuery, ModelsListQueryVariables>;
export const DatasetCreateFromModelDocument = gql`
    mutation DatasetCreateFromModel($modelId: ID!) {
  datasetCreateFromModel(modelId: $modelId) {
    dataset {
      id
      name
    }
  }
}
    `;
export type DatasetCreateFromModelMutationFn = Apollo.MutationFunction<DatasetCreateFromModelMutation, DatasetCreateFromModelMutationVariables>;

/**
 * __useDatasetCreateFromModelMutation__
 *
 * To run a mutation, you first call `useDatasetCreateFromModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDatasetCreateFromModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [datasetCreateFromModelMutation, { data, loading, error }] = useDatasetCreateFromModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDatasetCreateFromModelMutation(baseOptions?: Apollo.MutationHookOptions<DatasetCreateFromModelMutation, DatasetCreateFromModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DatasetCreateFromModelMutation, DatasetCreateFromModelMutationVariables>(DatasetCreateFromModelDocument, options);
      }
export type DatasetCreateFromModelMutationHookResult = ReturnType<typeof useDatasetCreateFromModelMutation>;
export type DatasetCreateFromModelMutationResult = Apollo.MutationResult<DatasetCreateFromModelMutation>;
export type DatasetCreateFromModelMutationOptions = Apollo.BaseMutationOptions<DatasetCreateFromModelMutation, DatasetCreateFromModelMutationVariables>;
export const DatasetDeleteDocument = gql`
    mutation DatasetDelete($id: ID!) {
  datasetDelete(id: $id) {
    success
  }
}
    `;
export type DatasetDeleteMutationFn = Apollo.MutationFunction<DatasetDeleteMutation, DatasetDeleteMutationVariables>;

/**
 * __useDatasetDeleteMutation__
 *
 * To run a mutation, you first call `useDatasetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDatasetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [datasetDeleteMutation, { data, loading, error }] = useDatasetDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDatasetDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DatasetDeleteMutation, DatasetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DatasetDeleteMutation, DatasetDeleteMutationVariables>(DatasetDeleteDocument, options);
      }
export type DatasetDeleteMutationHookResult = ReturnType<typeof useDatasetDeleteMutation>;
export type DatasetDeleteMutationResult = Apollo.MutationResult<DatasetDeleteMutation>;
export type DatasetDeleteMutationOptions = Apollo.BaseMutationOptions<DatasetDeleteMutation, DatasetDeleteMutationVariables>;
export const DatasetSourcesDocument = gql`
    query DatasetSources {
  jobs(spec: DATA_IMPORT) {
    jobs {
      id
      name
      status
      metrics {
        lastRunAt
      }
      schedule {
        minutely {
          interval
        }
        hourly {
          minute
        }
        daily {
          hour
          timezone
        }
      }
      spec {
        dataImport {
          destination {
            dataset {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDatasetSourcesQuery__
 *
 * To run a query within a React component, call `useDatasetSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatasetSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatasetSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDatasetSourcesQuery(baseOptions?: Apollo.QueryHookOptions<DatasetSourcesQuery, DatasetSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatasetSourcesQuery, DatasetSourcesQueryVariables>(DatasetSourcesDocument, options);
      }
export function useDatasetSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatasetSourcesQuery, DatasetSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatasetSourcesQuery, DatasetSourcesQueryVariables>(DatasetSourcesDocument, options);
        }
export function useDatasetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DatasetSourcesQuery, DatasetSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatasetSourcesQuery, DatasetSourcesQueryVariables>(DatasetSourcesDocument, options);
        }
export type DatasetSourcesQueryHookResult = ReturnType<typeof useDatasetSourcesQuery>;
export type DatasetSourcesLazyQueryHookResult = ReturnType<typeof useDatasetSourcesLazyQuery>;
export type DatasetSourcesSuspenseQueryHookResult = ReturnType<typeof useDatasetSourcesSuspenseQuery>;
export type DatasetSourcesQueryResult = Apollo.QueryResult<DatasetSourcesQuery, DatasetSourcesQueryVariables>;
export const DataJobRunCacheItemListDocument = gql`
    query DataJobRunCacheItemList($jobId: ID!, $jobRunId: ID!) {
  dataJobRunCacheItemList(jobId: $jobId, jobRunId: $jobRunId) {
    cacheItems {
      exists
      uri
    }
  }
}
    `;

/**
 * __useDataJobRunCacheItemListQuery__
 *
 * To run a query within a React component, call `useDataJobRunCacheItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataJobRunCacheItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataJobRunCacheItemListQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      jobRunId: // value for 'jobRunId'
 *   },
 * });
 */
export function useDataJobRunCacheItemListQuery(baseOptions: Apollo.QueryHookOptions<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables> & ({ variables: DataJobRunCacheItemListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables>(DataJobRunCacheItemListDocument, options);
      }
export function useDataJobRunCacheItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables>(DataJobRunCacheItemListDocument, options);
        }
export function useDataJobRunCacheItemListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables>(DataJobRunCacheItemListDocument, options);
        }
export type DataJobRunCacheItemListQueryHookResult = ReturnType<typeof useDataJobRunCacheItemListQuery>;
export type DataJobRunCacheItemListLazyQueryHookResult = ReturnType<typeof useDataJobRunCacheItemListLazyQuery>;
export type DataJobRunCacheItemListSuspenseQueryHookResult = ReturnType<typeof useDataJobRunCacheItemListSuspenseQuery>;
export type DataJobRunCacheItemListQueryResult = Apollo.QueryResult<DataJobRunCacheItemListQuery, DataJobRunCacheItemListQueryVariables>;
export const DataJobRunsDocument = gql`
    query DataJobRuns($jobId: ID!) {
  dataJobRuns(jobId: $jobId) {
    jobRuns {
      id
      lastRunAt
      lastErrorAt
      status
      metrics {
        totalRecords
        validRecords
        runDuration
        downloadDuration
      }
    }
  }
}
    `;

/**
 * __useDataJobRunsQuery__
 *
 * To run a query within a React component, call `useDataJobRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataJobRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataJobRunsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDataJobRunsQuery(baseOptions: Apollo.QueryHookOptions<DataJobRunsQuery, DataJobRunsQueryVariables> & ({ variables: DataJobRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataJobRunsQuery, DataJobRunsQueryVariables>(DataJobRunsDocument, options);
      }
export function useDataJobRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataJobRunsQuery, DataJobRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataJobRunsQuery, DataJobRunsQueryVariables>(DataJobRunsDocument, options);
        }
export function useDataJobRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataJobRunsQuery, DataJobRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataJobRunsQuery, DataJobRunsQueryVariables>(DataJobRunsDocument, options);
        }
export type DataJobRunsQueryHookResult = ReturnType<typeof useDataJobRunsQuery>;
export type DataJobRunsLazyQueryHookResult = ReturnType<typeof useDataJobRunsLazyQuery>;
export type DataJobRunsSuspenseQueryHookResult = ReturnType<typeof useDataJobRunsSuspenseQuery>;
export type DataJobRunsQueryResult = Apollo.QueryResult<DataJobRunsQuery, DataJobRunsQueryVariables>;
export const DataJobRunCancelDocument = gql`
    mutation DataJobRunCancel($jobRunId: ID!) {
  dataJobRunCancel(jobRunId: $jobRunId) {
    jobRun {
      id
      status
      canceledAt
    }
  }
}
    `;
export type DataJobRunCancelMutationFn = Apollo.MutationFunction<DataJobRunCancelMutation, DataJobRunCancelMutationVariables>;

/**
 * __useDataJobRunCancelMutation__
 *
 * To run a mutation, you first call `useDataJobRunCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobRunCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobRunCancelMutation, { data, loading, error }] = useDataJobRunCancelMutation({
 *   variables: {
 *      jobRunId: // value for 'jobRunId'
 *   },
 * });
 */
export function useDataJobRunCancelMutation(baseOptions?: Apollo.MutationHookOptions<DataJobRunCancelMutation, DataJobRunCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobRunCancelMutation, DataJobRunCancelMutationVariables>(DataJobRunCancelDocument, options);
      }
export type DataJobRunCancelMutationHookResult = ReturnType<typeof useDataJobRunCancelMutation>;
export type DataJobRunCancelMutationResult = Apollo.MutationResult<DataJobRunCancelMutation>;
export type DataJobRunCancelMutationOptions = Apollo.BaseMutationOptions<DataJobRunCancelMutation, DataJobRunCancelMutationVariables>;
export const DataJobRunResumeDocument = gql`
    mutation DataJobRunResume($jobRunId: ID!) {
  dataJobRunResume(jobRunId: $jobRunId) {
    jobRun {
      id
      status
      canceledAt
      updatedAt
    }
  }
}
    `;
export type DataJobRunResumeMutationFn = Apollo.MutationFunction<DataJobRunResumeMutation, DataJobRunResumeMutationVariables>;

/**
 * __useDataJobRunResumeMutation__
 *
 * To run a mutation, you first call `useDataJobRunResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobRunResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobRunResumeMutation, { data, loading, error }] = useDataJobRunResumeMutation({
 *   variables: {
 *      jobRunId: // value for 'jobRunId'
 *   },
 * });
 */
export function useDataJobRunResumeMutation(baseOptions?: Apollo.MutationHookOptions<DataJobRunResumeMutation, DataJobRunResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobRunResumeMutation, DataJobRunResumeMutationVariables>(DataJobRunResumeDocument, options);
      }
export type DataJobRunResumeMutationHookResult = ReturnType<typeof useDataJobRunResumeMutation>;
export type DataJobRunResumeMutationResult = Apollo.MutationResult<DataJobRunResumeMutation>;
export type DataJobRunResumeMutationOptions = Apollo.BaseMutationOptions<DataJobRunResumeMutation, DataJobRunResumeMutationVariables>;
export const DataJobsFetchDocument = gql`
    query DataJobsFetch($id: ID!) {
  dataJobsFetch(id: $id) {
    job {
      id
      name
      createdAt
      type
      archived
      status
      schedule {
        daily {
          hour
          timezone
        }
        hourly {
          minute
        }
      }
      metrics {
        totalRuns
        lastRunAt
        lastRunRecords
        avgRunDuration
        totalRunErrors
      }
      config {
        importJob {
          query
          columns {
            fieldId
            name
          }
          resource {
            compression
            connectionId
            format {
              csv {
                delimiter
                header
                null
              }
            }
            uri
          }
          tableId
          type
        }
        taggingJob {
          tags {
            id
          }
          columns {
            fieldId
            name
            isTag
          }
          resource {
            compression
            connectionId
            format {
              csv {
                delimiter
                header
                null
              }
            }
            uri
          }
          tableId
          type
        }
      }
    }
  }
}
    `;

/**
 * __useDataJobsFetchQuery__
 *
 * To run a query within a React component, call `useDataJobsFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataJobsFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataJobsFetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataJobsFetchQuery(baseOptions: Apollo.QueryHookOptions<DataJobsFetchQuery, DataJobsFetchQueryVariables> & ({ variables: DataJobsFetchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataJobsFetchQuery, DataJobsFetchQueryVariables>(DataJobsFetchDocument, options);
      }
export function useDataJobsFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataJobsFetchQuery, DataJobsFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataJobsFetchQuery, DataJobsFetchQueryVariables>(DataJobsFetchDocument, options);
        }
export function useDataJobsFetchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataJobsFetchQuery, DataJobsFetchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataJobsFetchQuery, DataJobsFetchQueryVariables>(DataJobsFetchDocument, options);
        }
export type DataJobsFetchQueryHookResult = ReturnType<typeof useDataJobsFetchQuery>;
export type DataJobsFetchLazyQueryHookResult = ReturnType<typeof useDataJobsFetchLazyQuery>;
export type DataJobsFetchSuspenseQueryHookResult = ReturnType<typeof useDataJobsFetchSuspenseQuery>;
export type DataJobsFetchQueryResult = Apollo.QueryResult<DataJobsFetchQuery, DataJobsFetchQueryVariables>;
export const DataTablesColumnMappingDocument = gql`
    query DataTablesColumnMapping {
  dataTables {
    id
    name
  }
}
    `;

/**
 * __useDataTablesColumnMappingQuery__
 *
 * To run a query within a React component, call `useDataTablesColumnMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTablesColumnMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTablesColumnMappingQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataTablesColumnMappingQuery(baseOptions?: Apollo.QueryHookOptions<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>(DataTablesColumnMappingDocument, options);
      }
export function useDataTablesColumnMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>(DataTablesColumnMappingDocument, options);
        }
export function useDataTablesColumnMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>(DataTablesColumnMappingDocument, options);
        }
export type DataTablesColumnMappingQueryHookResult = ReturnType<typeof useDataTablesColumnMappingQuery>;
export type DataTablesColumnMappingLazyQueryHookResult = ReturnType<typeof useDataTablesColumnMappingLazyQuery>;
export type DataTablesColumnMappingSuspenseQueryHookResult = ReturnType<typeof useDataTablesColumnMappingSuspenseQuery>;
export type DataTablesColumnMappingQueryResult = Apollo.QueryResult<DataTablesColumnMappingQuery, DataTablesColumnMappingQueryVariables>;
export const DataFieldsColumnMappingDocument = gql`
    query DataFieldsColumnMapping($tableId: ID!) {
  dataFields(tableId: $tableId) {
    id
    name
    displayName
    primaryKey
  }
}
    `;

/**
 * __useDataFieldsColumnMappingQuery__
 *
 * To run a query within a React component, call `useDataFieldsColumnMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFieldsColumnMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataFieldsColumnMappingQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDataFieldsColumnMappingQuery(baseOptions: Apollo.QueryHookOptions<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables> & ({ variables: DataFieldsColumnMappingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables>(DataFieldsColumnMappingDocument, options);
      }
export function useDataFieldsColumnMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables>(DataFieldsColumnMappingDocument, options);
        }
export function useDataFieldsColumnMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables>(DataFieldsColumnMappingDocument, options);
        }
export type DataFieldsColumnMappingQueryHookResult = ReturnType<typeof useDataFieldsColumnMappingQuery>;
export type DataFieldsColumnMappingLazyQueryHookResult = ReturnType<typeof useDataFieldsColumnMappingLazyQuery>;
export type DataFieldsColumnMappingSuspenseQueryHookResult = ReturnType<typeof useDataFieldsColumnMappingSuspenseQuery>;
export type DataFieldsColumnMappingQueryResult = Apollo.QueryResult<DataFieldsColumnMappingQuery, DataFieldsColumnMappingQueryVariables>;
export const DataJobCreateDocument = gql`
    mutation DataJobCreate($name: String!, $description: String, $config: DataJobConfig!, $schedule: DataJobScheduleInput) {
  dataJobCreate(
    config: $config
    name: $name
    description: $description
    schedule: $schedule
  ) {
    job {
      ...DataJobsListFragment
    }
  }
}
    ${DataJobsListFragmentFragmentDoc}`;
export type DataJobCreateMutationFn = Apollo.MutationFunction<DataJobCreateMutation, DataJobCreateMutationVariables>;

/**
 * __useDataJobCreateMutation__
 *
 * To run a mutation, you first call `useDataJobCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobCreateMutation, { data, loading, error }] = useDataJobCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      config: // value for 'config'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useDataJobCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataJobCreateMutation, DataJobCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobCreateMutation, DataJobCreateMutationVariables>(DataJobCreateDocument, options);
      }
export type DataJobCreateMutationHookResult = ReturnType<typeof useDataJobCreateMutation>;
export type DataJobCreateMutationResult = Apollo.MutationResult<DataJobCreateMutation>;
export type DataJobCreateMutationOptions = Apollo.BaseMutationOptions<DataJobCreateMutation, DataJobCreateMutationVariables>;
export const JobCreateDocument = gql`
    mutation JobCreate($name: String!, $spec: InkDataV1JobSpecInput!, $description: String, $schedule: InkDataV1JobScheduleInput) {
  jobCreate(
    name: $name
    spec: $spec
    description: $description
    schedule: $schedule
  ) {
    job {
      ...JobsListV1Fragment
    }
  }
}
    ${JobsListV1FragmentFragmentDoc}`;
export type JobCreateMutationFn = Apollo.MutationFunction<JobCreateMutation, JobCreateMutationVariables>;

/**
 * __useJobCreateMutation__
 *
 * To run a mutation, you first call `useJobCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobCreateMutation, { data, loading, error }] = useJobCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      spec: // value for 'spec'
 *      description: // value for 'description'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useJobCreateMutation(baseOptions?: Apollo.MutationHookOptions<JobCreateMutation, JobCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobCreateMutation, JobCreateMutationVariables>(JobCreateDocument, options);
      }
export type JobCreateMutationHookResult = ReturnType<typeof useJobCreateMutation>;
export type JobCreateMutationResult = Apollo.MutationResult<JobCreateMutation>;
export type JobCreateMutationOptions = Apollo.BaseMutationOptions<JobCreateMutation, JobCreateMutationVariables>;
export const GetCustomEventCategoriesDocument = gql`
    query GetCustomEventCategories {
  customEventCategories {
    id
    name
    attributionType
    hasSubidentifier
    timestampType
    contactIdentifierField {
      id
      displayName
    }
    table {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCustomEventCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCustomEventCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomEventCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomEventCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomEventCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>(GetCustomEventCategoriesDocument, options);
      }
export function useGetCustomEventCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>(GetCustomEventCategoriesDocument, options);
        }
export function useGetCustomEventCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>(GetCustomEventCategoriesDocument, options);
        }
export type GetCustomEventCategoriesQueryHookResult = ReturnType<typeof useGetCustomEventCategoriesQuery>;
export type GetCustomEventCategoriesLazyQueryHookResult = ReturnType<typeof useGetCustomEventCategoriesLazyQuery>;
export type GetCustomEventCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCustomEventCategoriesSuspenseQuery>;
export type GetCustomEventCategoriesQueryResult = Apollo.QueryResult<GetCustomEventCategoriesQuery, GetCustomEventCategoriesQueryVariables>;
export const CreateCustomEventImportJobDocument = gql`
    mutation CreateCustomEventImportJob($customEventCategoryId: ID!, $name: String!, $jobDescription: String!, $schedule: DataJobScheduleInput, $resource: DataJobResource!, $columns: [DataImportJobColumnInput!]!, $query: DataQuery) {
  customEventImportJobCreateV2(
    customEventCategoryId: $customEventCategoryId
    name: $name
    jobDescription: $jobDescription
    schedule: $schedule
    resource: $resource
    columns: $columns
    query: $query
  ) {
    importJob {
      id
      name
      description
      customEventCategoryId
    }
  }
}
    `;
export type CreateCustomEventImportJobMutationFn = Apollo.MutationFunction<CreateCustomEventImportJobMutation, CreateCustomEventImportJobMutationVariables>;

/**
 * __useCreateCustomEventImportJobMutation__
 *
 * To run a mutation, you first call `useCreateCustomEventImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomEventImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomEventImportJobMutation, { data, loading, error }] = useCreateCustomEventImportJobMutation({
 *   variables: {
 *      customEventCategoryId: // value for 'customEventCategoryId'
 *      name: // value for 'name'
 *      jobDescription: // value for 'jobDescription'
 *      schedule: // value for 'schedule'
 *      resource: // value for 'resource'
 *      columns: // value for 'columns'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCreateCustomEventImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomEventImportJobMutation, CreateCustomEventImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomEventImportJobMutation, CreateCustomEventImportJobMutationVariables>(CreateCustomEventImportJobDocument, options);
      }
export type CreateCustomEventImportJobMutationHookResult = ReturnType<typeof useCreateCustomEventImportJobMutation>;
export type CreateCustomEventImportJobMutationResult = Apollo.MutationResult<CreateCustomEventImportJobMutation>;
export type CreateCustomEventImportJobMutationOptions = Apollo.BaseMutationOptions<CreateCustomEventImportJobMutation, CreateCustomEventImportJobMutationVariables>;
export const GetEventExportContactFieldsDocument = gql`
    query GetEventExportContactFields {
  contactTableDataFields {
    id
    name
    displayName
    primaryKey
    channelsV2
    semanticFeature {
      name
    }
  }
}
    `;

/**
 * __useGetEventExportContactFieldsQuery__
 *
 * To run a query within a React component, call `useGetEventExportContactFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventExportContactFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventExportContactFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventExportContactFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>(GetEventExportContactFieldsDocument, options);
      }
export function useGetEventExportContactFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>(GetEventExportContactFieldsDocument, options);
        }
export function useGetEventExportContactFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>(GetEventExportContactFieldsDocument, options);
        }
export type GetEventExportContactFieldsQueryHookResult = ReturnType<typeof useGetEventExportContactFieldsQuery>;
export type GetEventExportContactFieldsLazyQueryHookResult = ReturnType<typeof useGetEventExportContactFieldsLazyQuery>;
export type GetEventExportContactFieldsSuspenseQueryHookResult = ReturnType<typeof useGetEventExportContactFieldsSuspenseQuery>;
export type GetEventExportContactFieldsQueryResult = Apollo.QueryResult<GetEventExportContactFieldsQuery, GetEventExportContactFieldsQueryVariables>;
export const JobsListDocument = gql`
    query JobsList($spec: JobSpecKind!) {
  jobs(spec: $spec) {
    jobs {
      ...JobsListV1Fragment
    }
  }
}
    ${JobsListV1FragmentFragmentDoc}`;

/**
 * __useJobsListQuery__
 *
 * To run a query within a React component, call `useJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsListQuery({
 *   variables: {
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useJobsListQuery(baseOptions: Apollo.QueryHookOptions<JobsListQuery, JobsListQueryVariables> & ({ variables: JobsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsListQuery, JobsListQueryVariables>(JobsListDocument, options);
      }
export function useJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsListQuery, JobsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsListQuery, JobsListQueryVariables>(JobsListDocument, options);
        }
export function useJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsListQuery, JobsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsListQuery, JobsListQueryVariables>(JobsListDocument, options);
        }
export type JobsListQueryHookResult = ReturnType<typeof useJobsListQuery>;
export type JobsListLazyQueryHookResult = ReturnType<typeof useJobsListLazyQuery>;
export type JobsListSuspenseQueryHookResult = ReturnType<typeof useJobsListSuspenseQuery>;
export type JobsListQueryResult = Apollo.QueryResult<JobsListQuery, JobsListQueryVariables>;
export const JobFetchDocument = gql`
    query JobFetch($id: ID!) {
  job(id: $id) {
    job {
      id
      name
      description
      createdAt
      status
      schedule {
        daily {
          hour
          timezone
        }
        hourly {
          minute
        }
        minutely {
          interval
        }
      }
      metrics {
        totalRuns
        lastRunAt
        totalRunFailures
        lastRunFailureAt
      }
      spec {
        eventExport {
          eventType
          columns
          dataConnectionIds
          maxRecordsPerFile
          contactDataTableConfig {
            dedupeByContactId
            fields
          }
          format {
            csv {
              compression
              delimiter
              arrayFormat
              emptyValueFormat
              customEmptyValue
              flattenSeparator
              quoteCharacter
              quotingStrategy
            }
            parquet {
              compression
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useJobFetchQuery__
 *
 * To run a query within a React component, call `useJobFetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobFetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobFetchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobFetchQuery(baseOptions: Apollo.QueryHookOptions<JobFetchQuery, JobFetchQueryVariables> & ({ variables: JobFetchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobFetchQuery, JobFetchQueryVariables>(JobFetchDocument, options);
      }
export function useJobFetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobFetchQuery, JobFetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobFetchQuery, JobFetchQueryVariables>(JobFetchDocument, options);
        }
export function useJobFetchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobFetchQuery, JobFetchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobFetchQuery, JobFetchQueryVariables>(JobFetchDocument, options);
        }
export type JobFetchQueryHookResult = ReturnType<typeof useJobFetchQuery>;
export type JobFetchLazyQueryHookResult = ReturnType<typeof useJobFetchLazyQuery>;
export type JobFetchSuspenseQueryHookResult = ReturnType<typeof useJobFetchSuspenseQuery>;
export type JobFetchQueryResult = Apollo.QueryResult<JobFetchQuery, JobFetchQueryVariables>;
export const JobRunsListDocument = gql`
    query JobRunsList($jobId: ID!) {
  jobRuns(jobId: $jobId) {
    jobRuns {
      id
      jobId
      status
      lastRunAt
      completedAt
      createdAt
      metrics {
        runDuration
      }
    }
  }
}
    `;

/**
 * __useJobRunsListQuery__
 *
 * To run a query within a React component, call `useJobRunsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRunsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRunsListQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobRunsListQuery(baseOptions: Apollo.QueryHookOptions<JobRunsListQuery, JobRunsListQueryVariables> & ({ variables: JobRunsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRunsListQuery, JobRunsListQueryVariables>(JobRunsListDocument, options);
      }
export function useJobRunsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRunsListQuery, JobRunsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRunsListQuery, JobRunsListQueryVariables>(JobRunsListDocument, options);
        }
export function useJobRunsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobRunsListQuery, JobRunsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobRunsListQuery, JobRunsListQueryVariables>(JobRunsListDocument, options);
        }
export type JobRunsListQueryHookResult = ReturnType<typeof useJobRunsListQuery>;
export type JobRunsListLazyQueryHookResult = ReturnType<typeof useJobRunsListLazyQuery>;
export type JobRunsListSuspenseQueryHookResult = ReturnType<typeof useJobRunsListSuspenseQuery>;
export type JobRunsListQueryResult = Apollo.QueryResult<JobRunsListQuery, JobRunsListQueryVariables>;
export const JobPauseDocument = gql`
    mutation JobPause($id: ID!) {
  jobPause(id: $id) {
    job {
      id
      status
    }
  }
}
    `;
export type JobPauseMutationFn = Apollo.MutationFunction<JobPauseMutation, JobPauseMutationVariables>;

/**
 * __useJobPauseMutation__
 *
 * To run a mutation, you first call `useJobPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobPauseMutation, { data, loading, error }] = useJobPauseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobPauseMutation(baseOptions?: Apollo.MutationHookOptions<JobPauseMutation, JobPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobPauseMutation, JobPauseMutationVariables>(JobPauseDocument, options);
      }
export type JobPauseMutationHookResult = ReturnType<typeof useJobPauseMutation>;
export type JobPauseMutationResult = Apollo.MutationResult<JobPauseMutation>;
export type JobPauseMutationOptions = Apollo.BaseMutationOptions<JobPauseMutation, JobPauseMutationVariables>;
export const JobResumeDocument = gql`
    mutation JobResume($id: ID!) {
  jobResume(id: $id) {
    job {
      id
      status
    }
  }
}
    `;
export type JobResumeMutationFn = Apollo.MutationFunction<JobResumeMutation, JobResumeMutationVariables>;

/**
 * __useJobResumeMutation__
 *
 * To run a mutation, you first call `useJobResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobResumeMutation, { data, loading, error }] = useJobResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobResumeMutation(baseOptions?: Apollo.MutationHookOptions<JobResumeMutation, JobResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobResumeMutation, JobResumeMutationVariables>(JobResumeDocument, options);
      }
export type JobResumeMutationHookResult = ReturnType<typeof useJobResumeMutation>;
export type JobResumeMutationResult = Apollo.MutationResult<JobResumeMutation>;
export type JobResumeMutationOptions = Apollo.BaseMutationOptions<JobResumeMutation, JobResumeMutationVariables>;
export const JobDeleteDocument = gql`
    mutation JobDelete($id: ID!) {
  jobDelete(id: $id) {
    id
    success
  }
}
    `;
export type JobDeleteMutationFn = Apollo.MutationFunction<JobDeleteMutation, JobDeleteMutationVariables>;

/**
 * __useJobDeleteMutation__
 *
 * To run a mutation, you first call `useJobDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobDeleteMutation, { data, loading, error }] = useJobDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobDeleteMutation(baseOptions?: Apollo.MutationHookOptions<JobDeleteMutation, JobDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobDeleteMutation, JobDeleteMutationVariables>(JobDeleteDocument, options);
      }
export type JobDeleteMutationHookResult = ReturnType<typeof useJobDeleteMutation>;
export type JobDeleteMutationResult = Apollo.MutationResult<JobDeleteMutation>;
export type JobDeleteMutationOptions = Apollo.BaseMutationOptions<JobDeleteMutation, JobDeleteMutationVariables>;
export const ConnectionsDocument = gql`
    query Connections {
  connections {
    connections {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useConnectionsQuery__
 *
 * To run a query within a React component, call `useConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
      }
export function useConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export function useConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export type ConnectionsQueryHookResult = ReturnType<typeof useConnectionsQuery>;
export type ConnectionsLazyQueryHookResult = ReturnType<typeof useConnectionsLazyQuery>;
export type ConnectionsSuspenseQueryHookResult = ReturnType<typeof useConnectionsSuspenseQuery>;
export type ConnectionsQueryResult = Apollo.QueryResult<ConnectionsQuery, ConnectionsQueryVariables>;
export const DataJobsListDocument = gql`
    query DataJobsList {
  dataJobsList {
    jobs {
      ...DataJobsListFragment
    }
  }
}
    ${DataJobsListFragmentFragmentDoc}`;

/**
 * __useDataJobsListQuery__
 *
 * To run a query within a React component, call `useDataJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataJobsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataJobsListQuery(baseOptions?: Apollo.QueryHookOptions<DataJobsListQuery, DataJobsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataJobsListQuery, DataJobsListQueryVariables>(DataJobsListDocument, options);
      }
export function useDataJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataJobsListQuery, DataJobsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataJobsListQuery, DataJobsListQueryVariables>(DataJobsListDocument, options);
        }
export function useDataJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataJobsListQuery, DataJobsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataJobsListQuery, DataJobsListQueryVariables>(DataJobsListDocument, options);
        }
export type DataJobsListQueryHookResult = ReturnType<typeof useDataJobsListQuery>;
export type DataJobsListLazyQueryHookResult = ReturnType<typeof useDataJobsListLazyQuery>;
export type DataJobsListSuspenseQueryHookResult = ReturnType<typeof useDataJobsListSuspenseQuery>;
export type DataJobsListQueryResult = Apollo.QueryResult<DataJobsListQuery, DataJobsListQueryVariables>;
export const JobsTablesListDocument = gql`
    query JobsTablesList {
  dataTables {
    id
    name
  }
}
    `;

/**
 * __useJobsTablesListQuery__
 *
 * To run a query within a React component, call `useJobsTablesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsTablesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsTablesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobsTablesListQuery(baseOptions?: Apollo.QueryHookOptions<JobsTablesListQuery, JobsTablesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsTablesListQuery, JobsTablesListQueryVariables>(JobsTablesListDocument, options);
      }
export function useJobsTablesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsTablesListQuery, JobsTablesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsTablesListQuery, JobsTablesListQueryVariables>(JobsTablesListDocument, options);
        }
export function useJobsTablesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsTablesListQuery, JobsTablesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsTablesListQuery, JobsTablesListQueryVariables>(JobsTablesListDocument, options);
        }
export type JobsTablesListQueryHookResult = ReturnType<typeof useJobsTablesListQuery>;
export type JobsTablesListLazyQueryHookResult = ReturnType<typeof useJobsTablesListLazyQuery>;
export type JobsTablesListSuspenseQueryHookResult = ReturnType<typeof useJobsTablesListSuspenseQuery>;
export type JobsTablesListQueryResult = Apollo.QueryResult<JobsTablesListQuery, JobsTablesListQueryVariables>;
export const DataJobArchiveDocument = gql`
    mutation DataJobArchive($id: ID!) {
  dataJobArchive(id: $id) {
    job {
      id
      status
      archived
    }
  }
}
    `;
export type DataJobArchiveMutationFn = Apollo.MutationFunction<DataJobArchiveMutation, DataJobArchiveMutationVariables>;

/**
 * __useDataJobArchiveMutation__
 *
 * To run a mutation, you first call `useDataJobArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobArchiveMutation, { data, loading, error }] = useDataJobArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataJobArchiveMutation(baseOptions?: Apollo.MutationHookOptions<DataJobArchiveMutation, DataJobArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobArchiveMutation, DataJobArchiveMutationVariables>(DataJobArchiveDocument, options);
      }
export type DataJobArchiveMutationHookResult = ReturnType<typeof useDataJobArchiveMutation>;
export type DataJobArchiveMutationResult = Apollo.MutationResult<DataJobArchiveMutation>;
export type DataJobArchiveMutationOptions = Apollo.BaseMutationOptions<DataJobArchiveMutation, DataJobArchiveMutationVariables>;
export const DataJobPauseDocument = gql`
    mutation DataJobPause($id: ID!) {
  dataJobPause(id: $id) {
    job {
      id
      status
    }
  }
}
    `;
export type DataJobPauseMutationFn = Apollo.MutationFunction<DataJobPauseMutation, DataJobPauseMutationVariables>;

/**
 * __useDataJobPauseMutation__
 *
 * To run a mutation, you first call `useDataJobPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobPauseMutation, { data, loading, error }] = useDataJobPauseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataJobPauseMutation(baseOptions?: Apollo.MutationHookOptions<DataJobPauseMutation, DataJobPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobPauseMutation, DataJobPauseMutationVariables>(DataJobPauseDocument, options);
      }
export type DataJobPauseMutationHookResult = ReturnType<typeof useDataJobPauseMutation>;
export type DataJobPauseMutationResult = Apollo.MutationResult<DataJobPauseMutation>;
export type DataJobPauseMutationOptions = Apollo.BaseMutationOptions<DataJobPauseMutation, DataJobPauseMutationVariables>;
export const DataJobResumeDocument = gql`
    mutation DataJobResume($id: ID!) {
  dataJobResume(id: $id) {
    job {
      id
      status
    }
  }
}
    `;
export type DataJobResumeMutationFn = Apollo.MutationFunction<DataJobResumeMutation, DataJobResumeMutationVariables>;

/**
 * __useDataJobResumeMutation__
 *
 * To run a mutation, you first call `useDataJobResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobResumeMutation, { data, loading, error }] = useDataJobResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataJobResumeMutation(baseOptions?: Apollo.MutationHookOptions<DataJobResumeMutation, DataJobResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobResumeMutation, DataJobResumeMutationVariables>(DataJobResumeDocument, options);
      }
export type DataJobResumeMutationHookResult = ReturnType<typeof useDataJobResumeMutation>;
export type DataJobResumeMutationResult = Apollo.MutationResult<DataJobResumeMutation>;
export type DataJobResumeMutationOptions = Apollo.BaseMutationOptions<DataJobResumeMutation, DataJobResumeMutationVariables>;
export const DataJobDeleteDocument = gql`
    mutation DataJobDelete($id: ID!) {
  dataJobDelete(id: $id) {
    id
  }
}
    `;
export type DataJobDeleteMutationFn = Apollo.MutationFunction<DataJobDeleteMutation, DataJobDeleteMutationVariables>;

/**
 * __useDataJobDeleteMutation__
 *
 * To run a mutation, you first call `useDataJobDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataJobDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataJobDeleteMutation, { data, loading, error }] = useDataJobDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataJobDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataJobDeleteMutation, DataJobDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataJobDeleteMutation, DataJobDeleteMutationVariables>(DataJobDeleteDocument, options);
      }
export type DataJobDeleteMutationHookResult = ReturnType<typeof useDataJobDeleteMutation>;
export type DataJobDeleteMutationResult = Apollo.MutationResult<DataJobDeleteMutation>;
export type DataJobDeleteMutationOptions = Apollo.BaseMutationOptions<DataJobDeleteMutation, DataJobDeleteMutationVariables>;
export const DataConnectionDocument = gql`
    query DataConnection($id: ID!) {
  dataConnection(id: $id) {
    name
  }
}
    `;

/**
 * __useDataConnectionQuery__
 *
 * To run a query within a React component, call `useDataConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataConnectionQuery(baseOptions: Apollo.QueryHookOptions<DataConnectionQuery, DataConnectionQueryVariables> & ({ variables: DataConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataConnectionQuery, DataConnectionQueryVariables>(DataConnectionDocument, options);
      }
export function useDataConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataConnectionQuery, DataConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataConnectionQuery, DataConnectionQueryVariables>(DataConnectionDocument, options);
        }
export function useDataConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataConnectionQuery, DataConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataConnectionQuery, DataConnectionQueryVariables>(DataConnectionDocument, options);
        }
export type DataConnectionQueryHookResult = ReturnType<typeof useDataConnectionQuery>;
export type DataConnectionLazyQueryHookResult = ReturnType<typeof useDataConnectionLazyQuery>;
export type DataConnectionSuspenseQueryHookResult = ReturnType<typeof useDataConnectionSuspenseQuery>;
export type DataConnectionQueryResult = Apollo.QueryResult<DataConnectionQuery, DataConnectionQueryVariables>;
export const DataConnectionsDocument = gql`
    query DataConnections {
  dataConnections {
    id
    name
    status
  }
}
    `;

/**
 * __useDataConnectionsQuery__
 *
 * To run a query within a React component, call `useDataConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<DataConnectionsQuery, DataConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataConnectionsQuery, DataConnectionsQueryVariables>(DataConnectionsDocument, options);
      }
export function useDataConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataConnectionsQuery, DataConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataConnectionsQuery, DataConnectionsQueryVariables>(DataConnectionsDocument, options);
        }
export function useDataConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataConnectionsQuery, DataConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataConnectionsQuery, DataConnectionsQueryVariables>(DataConnectionsDocument, options);
        }
export type DataConnectionsQueryHookResult = ReturnType<typeof useDataConnectionsQuery>;
export type DataConnectionsLazyQueryHookResult = ReturnType<typeof useDataConnectionsLazyQuery>;
export type DataConnectionsSuspenseQueryHookResult = ReturnType<typeof useDataConnectionsSuspenseQuery>;
export type DataConnectionsQueryResult = Apollo.QueryResult<DataConnectionsQuery, DataConnectionsQueryVariables>;
export const DataConnectionStreamsDocument = gql`
    query DataConnectionStreams($id: ID!) {
  dataConnectionStreams(id: $id) {
    streams {
      uri
      modifiedAt
      stream {
        ... on DataConnectionSFTPFile {
          path
          size
        }
        ... on DataConnectionGCSObject {
          name
          size
        }
        ... on DataConnectionS3Object {
          name
          size
        }
      }
    }
  }
}
    `;

/**
 * __useDataConnectionStreamsQuery__
 *
 * To run a query within a React component, call `useDataConnectionStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionStreamsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataConnectionStreamsQuery(baseOptions: Apollo.QueryHookOptions<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables> & ({ variables: DataConnectionStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables>(DataConnectionStreamsDocument, options);
      }
export function useDataConnectionStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables>(DataConnectionStreamsDocument, options);
        }
export function useDataConnectionStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables>(DataConnectionStreamsDocument, options);
        }
export type DataConnectionStreamsQueryHookResult = ReturnType<typeof useDataConnectionStreamsQuery>;
export type DataConnectionStreamsLazyQueryHookResult = ReturnType<typeof useDataConnectionStreamsLazyQuery>;
export type DataConnectionStreamsSuspenseQueryHookResult = ReturnType<typeof useDataConnectionStreamsSuspenseQuery>;
export type DataConnectionStreamsQueryResult = Apollo.QueryResult<DataConnectionStreamsQuery, DataConnectionStreamsQueryVariables>;
export const DataConnectionStreamSchemaDocument = gql`
    query DataConnectionStreamSchema($id: ID!, $streamUri: String!) {
  dataConnectionStreamSchema(id: $id, streamUri: $streamUri) {
    schema {
      uri
      compression
      columns {
        name
        type
        values
      }
      format {
        delimiter
        header
        null
      }
    }
  }
}
    `;

/**
 * __useDataConnectionStreamSchemaQuery__
 *
 * To run a query within a React component, call `useDataConnectionStreamSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionStreamSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionStreamSchemaQuery({
 *   variables: {
 *      id: // value for 'id'
 *      streamUri: // value for 'streamUri'
 *   },
 * });
 */
export function useDataConnectionStreamSchemaQuery(baseOptions: Apollo.QueryHookOptions<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables> & ({ variables: DataConnectionStreamSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables>(DataConnectionStreamSchemaDocument, options);
      }
export function useDataConnectionStreamSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables>(DataConnectionStreamSchemaDocument, options);
        }
export function useDataConnectionStreamSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables>(DataConnectionStreamSchemaDocument, options);
        }
export type DataConnectionStreamSchemaQueryHookResult = ReturnType<typeof useDataConnectionStreamSchemaQuery>;
export type DataConnectionStreamSchemaLazyQueryHookResult = ReturnType<typeof useDataConnectionStreamSchemaLazyQuery>;
export type DataConnectionStreamSchemaSuspenseQueryHookResult = ReturnType<typeof useDataConnectionStreamSchemaSuspenseQuery>;
export type DataConnectionStreamSchemaQueryResult = Apollo.QueryResult<DataConnectionStreamSchemaQuery, DataConnectionStreamSchemaQueryVariables>;
export const GetCreativeContentDocument = gql`
    query GetCreativeContent($creativeId: ID!) {
  creative(id: $creativeId) {
    id
    contents {
      id
      channel
      languageCode
      ... on PushNotification {
        title
        body
        media {
          ...mediaFields
        }
        ...platformLinksFields
      }
      ... on TextMessage {
        body
        shortenLinks
        media {
          ...mediaFields
        }
      }
    }
  }
}
    ${MediaFieldsFragmentDoc}
${PlatformLinksFieldsFragmentDoc}`;

/**
 * __useGetCreativeContentQuery__
 *
 * To run a query within a React component, call `useGetCreativeContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeContentQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeContentQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeContentQuery, GetCreativeContentQueryVariables> & ({ variables: GetCreativeContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeContentQuery, GetCreativeContentQueryVariables>(GetCreativeContentDocument, options);
      }
export function useGetCreativeContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeContentQuery, GetCreativeContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeContentQuery, GetCreativeContentQueryVariables>(GetCreativeContentDocument, options);
        }
export function useGetCreativeContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeContentQuery, GetCreativeContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeContentQuery, GetCreativeContentQueryVariables>(GetCreativeContentDocument, options);
        }
export type GetCreativeContentQueryHookResult = ReturnType<typeof useGetCreativeContentQuery>;
export type GetCreativeContentLazyQueryHookResult = ReturnType<typeof useGetCreativeContentLazyQuery>;
export type GetCreativeContentSuspenseQueryHookResult = ReturnType<typeof useGetCreativeContentSuspenseQuery>;
export type GetCreativeContentQueryResult = Apollo.QueryResult<GetCreativeContentQuery, GetCreativeContentQueryVariables>;
export const SavePushNotificationDocument = gql`
    mutation SavePushNotification($creativeId: ID!, $input: PushNotificationInput!) {
  pushNotificationSave(creativeId: $creativeId, input: $input) {
    success
    pushNotification {
      id
      title
      body
      media {
        uri
      }
      ...platformLinksFields
    }
  }
}
    ${PlatformLinksFieldsFragmentDoc}`;
export type SavePushNotificationMutationFn = Apollo.MutationFunction<SavePushNotificationMutation, SavePushNotificationMutationVariables>;

/**
 * __useSavePushNotificationMutation__
 *
 * To run a mutation, you first call `useSavePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePushNotificationMutation, { data, loading, error }] = useSavePushNotificationMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SavePushNotificationMutation, SavePushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePushNotificationMutation, SavePushNotificationMutationVariables>(SavePushNotificationDocument, options);
      }
export type SavePushNotificationMutationHookResult = ReturnType<typeof useSavePushNotificationMutation>;
export type SavePushNotificationMutationResult = Apollo.MutationResult<SavePushNotificationMutation>;
export type SavePushNotificationMutationOptions = Apollo.BaseMutationOptions<SavePushNotificationMutation, SavePushNotificationMutationVariables>;
export const DeletePushNotificationDocument = gql`
    mutation DeletePushNotification($pushNotificationId: ID!) {
  pushNotificationDelete(pushNotificationId: $pushNotificationId) {
    success
  }
}
    `;
export type DeletePushNotificationMutationFn = Apollo.MutationFunction<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>;

/**
 * __useDeletePushNotificationMutation__
 *
 * To run a mutation, you first call `useDeletePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePushNotificationMutation, { data, loading, error }] = useDeletePushNotificationMutation({
 *   variables: {
 *      pushNotificationId: // value for 'pushNotificationId'
 *   },
 * });
 */
export function useDeletePushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>(DeletePushNotificationDocument, options);
      }
export type DeletePushNotificationMutationHookResult = ReturnType<typeof useDeletePushNotificationMutation>;
export type DeletePushNotificationMutationResult = Apollo.MutationResult<DeletePushNotificationMutation>;
export type DeletePushNotificationMutationOptions = Apollo.BaseMutationOptions<DeletePushNotificationMutation, DeletePushNotificationMutationVariables>;
export const SaveTextMessageDocument = gql`
    mutation SaveTextMessage($creativeId: ID!, $channel: String!, $input: TextMessageInput!) {
  textMessageSave(creativeId: $creativeId, channel: $channel, input: $input) {
    success
    textMessage {
      id
      body
      media {
        ...mediaFields
      }
    }
  }
}
    ${MediaFieldsFragmentDoc}`;
export type SaveTextMessageMutationFn = Apollo.MutationFunction<SaveTextMessageMutation, SaveTextMessageMutationVariables>;

/**
 * __useSaveTextMessageMutation__
 *
 * To run a mutation, you first call `useSaveTextMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTextMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTextMessageMutation, { data, loading, error }] = useSaveTextMessageMutation({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *      channel: // value for 'channel'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTextMessageMutation(baseOptions?: Apollo.MutationHookOptions<SaveTextMessageMutation, SaveTextMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTextMessageMutation, SaveTextMessageMutationVariables>(SaveTextMessageDocument, options);
      }
export type SaveTextMessageMutationHookResult = ReturnType<typeof useSaveTextMessageMutation>;
export type SaveTextMessageMutationResult = Apollo.MutationResult<SaveTextMessageMutation>;
export type SaveTextMessageMutationOptions = Apollo.BaseMutationOptions<SaveTextMessageMutation, SaveTextMessageMutationVariables>;
export const DeleteTextMessageDocument = gql`
    mutation DeleteTextMessage($textMessageId: ID!) {
  textMessageDelete(textMessageId: $textMessageId) {
    success
  }
}
    `;
export type DeleteTextMessageMutationFn = Apollo.MutationFunction<DeleteTextMessageMutation, DeleteTextMessageMutationVariables>;

/**
 * __useDeleteTextMessageMutation__
 *
 * To run a mutation, you first call `useDeleteTextMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTextMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTextMessageMutation, { data, loading, error }] = useDeleteTextMessageMutation({
 *   variables: {
 *      textMessageId: // value for 'textMessageId'
 *   },
 * });
 */
export function useDeleteTextMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTextMessageMutation, DeleteTextMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTextMessageMutation, DeleteTextMessageMutationVariables>(DeleteTextMessageDocument, options);
      }
export type DeleteTextMessageMutationHookResult = ReturnType<typeof useDeleteTextMessageMutation>;
export type DeleteTextMessageMutationResult = Apollo.MutationResult<DeleteTextMessageMutation>;
export type DeleteTextMessageMutationOptions = Apollo.BaseMutationOptions<DeleteTextMessageMutation, DeleteTextMessageMutationVariables>;
export const NotificationsSettingsDocument = gql`
    query NotificationsSettings {
  notificationsSettings {
    category
    emailEnabled
    event
    inAppEnabled
    timingPreference {
      hoursBefore
      daysBefore
      absoluteTime
      excludeWeekends
    }
  }
}
    `;

/**
 * __useNotificationsSettingsQuery__
 *
 * To run a query within a React component, call `useNotificationsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>(NotificationsSettingsDocument, options);
      }
export function useNotificationsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>(NotificationsSettingsDocument, options);
        }
export function useNotificationsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>(NotificationsSettingsDocument, options);
        }
export type NotificationsSettingsQueryHookResult = ReturnType<typeof useNotificationsSettingsQuery>;
export type NotificationsSettingsLazyQueryHookResult = ReturnType<typeof useNotificationsSettingsLazyQuery>;
export type NotificationsSettingsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSettingsSuspenseQuery>;
export type NotificationsSettingsQueryResult = Apollo.QueryResult<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>;
export const UpdateNotificationsSettingDocument = gql`
    mutation UpdateNotificationsSetting($category: String!, $emailEnabled: Boolean, $inAppEnabled: Boolean, $event: String!, $timingPreference: NotificationTimingPreferenceInput) {
  updateNotificationsSetting(
    category: $category
    emailEnabled: $emailEnabled
    inAppEnabled: $inAppEnabled
    event: $event
    timingPreference: $timingPreference
  ) {
    setting {
      category
      emailEnabled
      inAppEnabled
      event
      timingPreference {
        hoursBefore
        daysBefore
        absoluteTime
        excludeWeekends
      }
    }
  }
}
    `;
export type UpdateNotificationsSettingMutationFn = Apollo.MutationFunction<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>;

/**
 * __useUpdateNotificationsSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsSettingMutation, { data, loading, error }] = useUpdateNotificationsSettingMutation({
 *   variables: {
 *      category: // value for 'category'
 *      emailEnabled: // value for 'emailEnabled'
 *      inAppEnabled: // value for 'inAppEnabled'
 *      event: // value for 'event'
 *      timingPreference: // value for 'timingPreference'
 *   },
 * });
 */
export function useUpdateNotificationsSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>(UpdateNotificationsSettingDocument, options);
      }
export type UpdateNotificationsSettingMutationHookResult = ReturnType<typeof useUpdateNotificationsSettingMutation>;
export type UpdateNotificationsSettingMutationResult = Apollo.MutationResult<UpdateNotificationsSettingMutation>;
export type UpdateNotificationsSettingMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>;
export const KnockTokenDocument = gql`
    mutation KnockToken {
  knockToken {
    token
  }
}
    `;
export type KnockTokenMutationFn = Apollo.MutationFunction<KnockTokenMutation, KnockTokenMutationVariables>;

/**
 * __useKnockTokenMutation__
 *
 * To run a mutation, you first call `useKnockTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnockTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knockTokenMutation, { data, loading, error }] = useKnockTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useKnockTokenMutation(baseOptions?: Apollo.MutationHookOptions<KnockTokenMutation, KnockTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KnockTokenMutation, KnockTokenMutationVariables>(KnockTokenDocument, options);
      }
export type KnockTokenMutationHookResult = ReturnType<typeof useKnockTokenMutation>;
export type KnockTokenMutationResult = Apollo.MutationResult<KnockTokenMutation>;
export type KnockTokenMutationOptions = Apollo.BaseMutationOptions<KnockTokenMutation, KnockTokenMutationVariables>;
export const CampaignAlertConfigDocument = gql`
    query CampaignAlertConfig {
  campaignAlertConfig {
    sourceId
    label
    operators {
      id
      label
      applicableCategories
    }
    eligibilityPredicates {
      id
      label
      config
    }
    valueTypeByCategory {
      category
      valueType
      min
      max
    }
    availableMetrics {
      id
      name
      category
      customEventCategory
      group
      positivelyCorrelated
      displayByDefault
    }
  }
}
    `;

/**
 * __useCampaignAlertConfigQuery__
 *
 * To run a query within a React component, call `useCampaignAlertConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAlertConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAlertConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignAlertConfigQuery(baseOptions?: Apollo.QueryHookOptions<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>(CampaignAlertConfigDocument, options);
      }
export function useCampaignAlertConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>(CampaignAlertConfigDocument, options);
        }
export function useCampaignAlertConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>(CampaignAlertConfigDocument, options);
        }
export type CampaignAlertConfigQueryHookResult = ReturnType<typeof useCampaignAlertConfigQuery>;
export type CampaignAlertConfigLazyQueryHookResult = ReturnType<typeof useCampaignAlertConfigLazyQuery>;
export type CampaignAlertConfigSuspenseQueryHookResult = ReturnType<typeof useCampaignAlertConfigSuspenseQuery>;
export type CampaignAlertConfigQueryResult = Apollo.QueryResult<CampaignAlertConfigQuery, CampaignAlertConfigQueryVariables>;
export const AlertRulesDocument = gql`
    query AlertRules {
  alertRulesWithSubscriptions {
    ...AlertRuleFields
  }
}
    ${AlertRuleFieldsFragmentDoc}`;

/**
 * __useAlertRulesQuery__
 *
 * To run a query within a React component, call `useAlertRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertRulesQuery(baseOptions?: Apollo.QueryHookOptions<AlertRulesQuery, AlertRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertRulesQuery, AlertRulesQueryVariables>(AlertRulesDocument, options);
      }
export function useAlertRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertRulesQuery, AlertRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertRulesQuery, AlertRulesQueryVariables>(AlertRulesDocument, options);
        }
export function useAlertRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertRulesQuery, AlertRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertRulesQuery, AlertRulesQueryVariables>(AlertRulesDocument, options);
        }
export type AlertRulesQueryHookResult = ReturnType<typeof useAlertRulesQuery>;
export type AlertRulesLazyQueryHookResult = ReturnType<typeof useAlertRulesLazyQuery>;
export type AlertRulesSuspenseQueryHookResult = ReturnType<typeof useAlertRulesSuspenseQuery>;
export type AlertRulesQueryResult = Apollo.QueryResult<AlertRulesQuery, AlertRulesQueryVariables>;
export const CreateAlertRuleDocument = gql`
    mutation CreateAlertRule($title: String!, $sourceId: String!, $entityId: String, $criteria: [AlertCriterionInput!]!, $eligibility: [AlertEligibilityInput!]!) {
  alertRuleCreate(
    title: $title
    sourceId: $sourceId
    entityId: $entityId
    criteria: $criteria
    eligibility: $eligibility
  ) {
    rule {
      hashid
      title
      entityId
    }
  }
}
    `;
export type CreateAlertRuleMutationFn = Apollo.MutationFunction<CreateAlertRuleMutation, CreateAlertRuleMutationVariables>;

/**
 * __useCreateAlertRuleMutation__
 *
 * To run a mutation, you first call `useCreateAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertRuleMutation, { data, loading, error }] = useCreateAlertRuleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      sourceId: // value for 'sourceId'
 *      entityId: // value for 'entityId'
 *      criteria: // value for 'criteria'
 *      eligibility: // value for 'eligibility'
 *   },
 * });
 */
export function useCreateAlertRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertRuleMutation, CreateAlertRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertRuleMutation, CreateAlertRuleMutationVariables>(CreateAlertRuleDocument, options);
      }
export type CreateAlertRuleMutationHookResult = ReturnType<typeof useCreateAlertRuleMutation>;
export type CreateAlertRuleMutationResult = Apollo.MutationResult<CreateAlertRuleMutation>;
export type CreateAlertRuleMutationOptions = Apollo.BaseMutationOptions<CreateAlertRuleMutation, CreateAlertRuleMutationVariables>;
export const UpdateAlertRuleDocument = gql`
    mutation UpdateAlertRule($ruleHashid: String!, $title: String, $sourceId: String, $entityId: String, $criteria: [AlertCriterionInput!], $eligibility: [AlertEligibilityInput!]) {
  alertRuleModify(
    ruleHashid: $ruleHashid
    title: $title
    sourceId: $sourceId
    entityId: $entityId
    criteria: $criteria
    eligibility: $eligibility
  ) {
    rule {
      hashid
      title
      entityId
    }
  }
}
    `;
export type UpdateAlertRuleMutationFn = Apollo.MutationFunction<UpdateAlertRuleMutation, UpdateAlertRuleMutationVariables>;

/**
 * __useUpdateAlertRuleMutation__
 *
 * To run a mutation, you first call `useUpdateAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertRuleMutation, { data, loading, error }] = useUpdateAlertRuleMutation({
 *   variables: {
 *      ruleHashid: // value for 'ruleHashid'
 *      title: // value for 'title'
 *      sourceId: // value for 'sourceId'
 *      entityId: // value for 'entityId'
 *      criteria: // value for 'criteria'
 *      eligibility: // value for 'eligibility'
 *   },
 * });
 */
export function useUpdateAlertRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertRuleMutation, UpdateAlertRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertRuleMutation, UpdateAlertRuleMutationVariables>(UpdateAlertRuleDocument, options);
      }
export type UpdateAlertRuleMutationHookResult = ReturnType<typeof useUpdateAlertRuleMutation>;
export type UpdateAlertRuleMutationResult = Apollo.MutationResult<UpdateAlertRuleMutation>;
export type UpdateAlertRuleMutationOptions = Apollo.BaseMutationOptions<UpdateAlertRuleMutation, UpdateAlertRuleMutationVariables>;
export const DeleteAlertRuleDocument = gql`
    mutation DeleteAlertRule($ruleHashid: String!) {
  alertRuleDelete(ruleHashid: $ruleHashid) {
    success
  }
}
    `;
export type DeleteAlertRuleMutationFn = Apollo.MutationFunction<DeleteAlertRuleMutation, DeleteAlertRuleMutationVariables>;

/**
 * __useDeleteAlertRuleMutation__
 *
 * To run a mutation, you first call `useDeleteAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertRuleMutation, { data, loading, error }] = useDeleteAlertRuleMutation({
 *   variables: {
 *      ruleHashid: // value for 'ruleHashid'
 *   },
 * });
 */
export function useDeleteAlertRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertRuleMutation, DeleteAlertRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertRuleMutation, DeleteAlertRuleMutationVariables>(DeleteAlertRuleDocument, options);
      }
export type DeleteAlertRuleMutationHookResult = ReturnType<typeof useDeleteAlertRuleMutation>;
export type DeleteAlertRuleMutationResult = Apollo.MutationResult<DeleteAlertRuleMutation>;
export type DeleteAlertRuleMutationOptions = Apollo.BaseMutationOptions<DeleteAlertRuleMutation, DeleteAlertRuleMutationVariables>;
export const SubscribeAlertRuleDocument = gql`
    mutation SubscribeAlertRule($ruleHashid: String!, $channel: String!) {
  alertRuleSubscribe(ruleHashid: $ruleHashid, channel: $channel) {
    success
  }
}
    `;
export type SubscribeAlertRuleMutationFn = Apollo.MutationFunction<SubscribeAlertRuleMutation, SubscribeAlertRuleMutationVariables>;

/**
 * __useSubscribeAlertRuleMutation__
 *
 * To run a mutation, you first call `useSubscribeAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeAlertRuleMutation, { data, loading, error }] = useSubscribeAlertRuleMutation({
 *   variables: {
 *      ruleHashid: // value for 'ruleHashid'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useSubscribeAlertRuleMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeAlertRuleMutation, SubscribeAlertRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeAlertRuleMutation, SubscribeAlertRuleMutationVariables>(SubscribeAlertRuleDocument, options);
      }
export type SubscribeAlertRuleMutationHookResult = ReturnType<typeof useSubscribeAlertRuleMutation>;
export type SubscribeAlertRuleMutationResult = Apollo.MutationResult<SubscribeAlertRuleMutation>;
export type SubscribeAlertRuleMutationOptions = Apollo.BaseMutationOptions<SubscribeAlertRuleMutation, SubscribeAlertRuleMutationVariables>;
export const UnsubscribeAlertRuleDocument = gql`
    mutation UnsubscribeAlertRule($ruleHashid: String!, $channel: String!) {
  alertRuleUnsubscribe(ruleHashid: $ruleHashid, channel: $channel) {
    success
  }
}
    `;
export type UnsubscribeAlertRuleMutationFn = Apollo.MutationFunction<UnsubscribeAlertRuleMutation, UnsubscribeAlertRuleMutationVariables>;

/**
 * __useUnsubscribeAlertRuleMutation__
 *
 * To run a mutation, you first call `useUnsubscribeAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeAlertRuleMutation, { data, loading, error }] = useUnsubscribeAlertRuleMutation({
 *   variables: {
 *      ruleHashid: // value for 'ruleHashid'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useUnsubscribeAlertRuleMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeAlertRuleMutation, UnsubscribeAlertRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeAlertRuleMutation, UnsubscribeAlertRuleMutationVariables>(UnsubscribeAlertRuleDocument, options);
      }
export type UnsubscribeAlertRuleMutationHookResult = ReturnType<typeof useUnsubscribeAlertRuleMutation>;
export type UnsubscribeAlertRuleMutationResult = Apollo.MutationResult<UnsubscribeAlertRuleMutation>;
export type UnsubscribeAlertRuleMutationOptions = Apollo.BaseMutationOptions<UnsubscribeAlertRuleMutation, UnsubscribeAlertRuleMutationVariables>;
export const JobsAlertPickerListDocument = gql`
    query JobsAlertPickerList {
  jobsAlertPickerList {
    id
    name
  }
}
    `;

/**
 * __useJobsAlertPickerListQuery__
 *
 * To run a query within a React component, call `useJobsAlertPickerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsAlertPickerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsAlertPickerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobsAlertPickerListQuery(baseOptions?: Apollo.QueryHookOptions<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>(JobsAlertPickerListDocument, options);
      }
export function useJobsAlertPickerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>(JobsAlertPickerListDocument, options);
        }
export function useJobsAlertPickerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>(JobsAlertPickerListDocument, options);
        }
export type JobsAlertPickerListQueryHookResult = ReturnType<typeof useJobsAlertPickerListQuery>;
export type JobsAlertPickerListLazyQueryHookResult = ReturnType<typeof useJobsAlertPickerListLazyQuery>;
export type JobsAlertPickerListSuspenseQueryHookResult = ReturnType<typeof useJobsAlertPickerListSuspenseQuery>;
export type JobsAlertPickerListQueryResult = Apollo.QueryResult<JobsAlertPickerListQuery, JobsAlertPickerListQueryVariables>;
export const ProgramAudienceIncludeDocument = gql`
    mutation ProgramAudienceInclude($audienceId: ID!, $programId: ID!, $selected: [ID!]!, $unselected: [ID!]!) {
  programAudienceInclude(
    audienceId: $audienceId
    programId: $programId
    selected: $selected
    unselected: $unselected
  ) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramAudienceIncludeMutationFn = Apollo.MutationFunction<ProgramAudienceIncludeMutation, ProgramAudienceIncludeMutationVariables>;

/**
 * __useProgramAudienceIncludeMutation__
 *
 * To run a mutation, you first call `useProgramAudienceIncludeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramAudienceIncludeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programAudienceIncludeMutation, { data, loading, error }] = useProgramAudienceIncludeMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      programId: // value for 'programId'
 *      selected: // value for 'selected'
 *      unselected: // value for 'unselected'
 *   },
 * });
 */
export function useProgramAudienceIncludeMutation(baseOptions?: Apollo.MutationHookOptions<ProgramAudienceIncludeMutation, ProgramAudienceIncludeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramAudienceIncludeMutation, ProgramAudienceIncludeMutationVariables>(ProgramAudienceIncludeDocument, options);
      }
export type ProgramAudienceIncludeMutationHookResult = ReturnType<typeof useProgramAudienceIncludeMutation>;
export type ProgramAudienceIncludeMutationResult = Apollo.MutationResult<ProgramAudienceIncludeMutation>;
export type ProgramAudienceIncludeMutationOptions = Apollo.BaseMutationOptions<ProgramAudienceIncludeMutation, ProgramAudienceIncludeMutationVariables>;
export const ProgramAudienceExcludeDocument = gql`
    mutation ProgramAudienceExclude($audienceId: ID!, $programId: ID!) {
  programAudienceExclude(audienceId: $audienceId, programId: $programId) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramAudienceExcludeMutationFn = Apollo.MutationFunction<ProgramAudienceExcludeMutation, ProgramAudienceExcludeMutationVariables>;

/**
 * __useProgramAudienceExcludeMutation__
 *
 * To run a mutation, you first call `useProgramAudienceExcludeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramAudienceExcludeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programAudienceExcludeMutation, { data, loading, error }] = useProgramAudienceExcludeMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramAudienceExcludeMutation(baseOptions?: Apollo.MutationHookOptions<ProgramAudienceExcludeMutation, ProgramAudienceExcludeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramAudienceExcludeMutation, ProgramAudienceExcludeMutationVariables>(ProgramAudienceExcludeDocument, options);
      }
export type ProgramAudienceExcludeMutationHookResult = ReturnType<typeof useProgramAudienceExcludeMutation>;
export type ProgramAudienceExcludeMutationResult = Apollo.MutationResult<ProgramAudienceExcludeMutation>;
export type ProgramAudienceExcludeMutationOptions = Apollo.BaseMutationOptions<ProgramAudienceExcludeMutation, ProgramAudienceExcludeMutationVariables>;
export const ProgramAudienceRemoveDocument = gql`
    mutation ProgramAudienceRemove($audienceId: ID!, $programId: ID!) {
  programAudienceRemove(audienceId: $audienceId, programId: $programId) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramAudienceRemoveMutationFn = Apollo.MutationFunction<ProgramAudienceRemoveMutation, ProgramAudienceRemoveMutationVariables>;

/**
 * __useProgramAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useProgramAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programAudienceRemoveMutation, { data, loading, error }] = useProgramAudienceRemoveMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ProgramAudienceRemoveMutation, ProgramAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramAudienceRemoveMutation, ProgramAudienceRemoveMutationVariables>(ProgramAudienceRemoveDocument, options);
      }
export type ProgramAudienceRemoveMutationHookResult = ReturnType<typeof useProgramAudienceRemoveMutation>;
export type ProgramAudienceRemoveMutationResult = Apollo.MutationResult<ProgramAudienceRemoveMutation>;
export type ProgramAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<ProgramAudienceRemoveMutation, ProgramAudienceRemoveMutationVariables>;
export const ProgramAudienceReorderDocument = gql`
    mutation ProgramAudienceReorder($audienceIds: [ID!]!, $programId: ID!) {
  programAudienceReorder(audienceIds: $audienceIds, programId: $programId) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramAudienceReorderMutationFn = Apollo.MutationFunction<ProgramAudienceReorderMutation, ProgramAudienceReorderMutationVariables>;

/**
 * __useProgramAudienceReorderMutation__
 *
 * To run a mutation, you first call `useProgramAudienceReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramAudienceReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programAudienceReorderMutation, { data, loading, error }] = useProgramAudienceReorderMutation({
 *   variables: {
 *      audienceIds: // value for 'audienceIds'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramAudienceReorderMutation(baseOptions?: Apollo.MutationHookOptions<ProgramAudienceReorderMutation, ProgramAudienceReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramAudienceReorderMutation, ProgramAudienceReorderMutationVariables>(ProgramAudienceReorderDocument, options);
      }
export type ProgramAudienceReorderMutationHookResult = ReturnType<typeof useProgramAudienceReorderMutation>;
export type ProgramAudienceReorderMutationResult = Apollo.MutationResult<ProgramAudienceReorderMutation>;
export type ProgramAudienceReorderMutationOptions = Apollo.BaseMutationOptions<ProgramAudienceReorderMutation, ProgramAudienceReorderMutationVariables>;
export const ProgramFieldAddDocument = gql`
    mutation ProgramFieldAdd($programId: ID!, $fieldId: ID!, $override: ContactAudienceOverrideValueInput) {
  programFieldAdd(programId: $programId, fieldId: $fieldId, override: $override) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramFieldAddMutationFn = Apollo.MutationFunction<ProgramFieldAddMutation, ProgramFieldAddMutationVariables>;

/**
 * __useProgramFieldAddMutation__
 *
 * To run a mutation, you first call `useProgramFieldAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramFieldAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programFieldAddMutation, { data, loading, error }] = useProgramFieldAddMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      fieldId: // value for 'fieldId'
 *      override: // value for 'override'
 *   },
 * });
 */
export function useProgramFieldAddMutation(baseOptions?: Apollo.MutationHookOptions<ProgramFieldAddMutation, ProgramFieldAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramFieldAddMutation, ProgramFieldAddMutationVariables>(ProgramFieldAddDocument, options);
      }
export type ProgramFieldAddMutationHookResult = ReturnType<typeof useProgramFieldAddMutation>;
export type ProgramFieldAddMutationResult = Apollo.MutationResult<ProgramFieldAddMutation>;
export type ProgramFieldAddMutationOptions = Apollo.BaseMutationOptions<ProgramFieldAddMutation, ProgramFieldAddMutationVariables>;
export const ProgramFieldRemoveDocument = gql`
    mutation ProgramFieldRemove($programId: ID!, $fieldId: ID!) {
  programFieldRemove(programId: $programId, fieldId: $fieldId) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramFieldRemoveMutationFn = Apollo.MutationFunction<ProgramFieldRemoveMutation, ProgramFieldRemoveMutationVariables>;

/**
 * __useProgramFieldRemoveMutation__
 *
 * To run a mutation, you first call `useProgramFieldRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramFieldRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programFieldRemoveMutation, { data, loading, error }] = useProgramFieldRemoveMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useProgramFieldRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ProgramFieldRemoveMutation, ProgramFieldRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramFieldRemoveMutation, ProgramFieldRemoveMutationVariables>(ProgramFieldRemoveDocument, options);
      }
export type ProgramFieldRemoveMutationHookResult = ReturnType<typeof useProgramFieldRemoveMutation>;
export type ProgramFieldRemoveMutationResult = Apollo.MutationResult<ProgramFieldRemoveMutation>;
export type ProgramFieldRemoveMutationOptions = Apollo.BaseMutationOptions<ProgramFieldRemoveMutation, ProgramFieldRemoveMutationVariables>;
export const ProgramFieldUpdateDocument = gql`
    mutation ProgramFieldUpdate($fieldId: ID!, $programId: ID!, $override: ContactAudienceOverrideValueInput) {
  programFieldUpdate(
    fieldId: $fieldId
    programId: $programId
    override: $override
  ) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramFieldUpdateMutationFn = Apollo.MutationFunction<ProgramFieldUpdateMutation, ProgramFieldUpdateMutationVariables>;

/**
 * __useProgramFieldUpdateMutation__
 *
 * To run a mutation, you first call `useProgramFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programFieldUpdateMutation, { data, loading, error }] = useProgramFieldUpdateMutation({
 *   variables: {
 *      fieldId: // value for 'fieldId'
 *      programId: // value for 'programId'
 *      override: // value for 'override'
 *   },
 * });
 */
export function useProgramFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProgramFieldUpdateMutation, ProgramFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramFieldUpdateMutation, ProgramFieldUpdateMutationVariables>(ProgramFieldUpdateDocument, options);
      }
export type ProgramFieldUpdateMutationHookResult = ReturnType<typeof useProgramFieldUpdateMutation>;
export type ProgramFieldUpdateMutationResult = Apollo.MutationResult<ProgramFieldUpdateMutation>;
export type ProgramFieldUpdateMutationOptions = Apollo.BaseMutationOptions<ProgramFieldUpdateMutation, ProgramFieldUpdateMutationVariables>;
export const ProgramContentDocument = gql`
    query ProgramContent($programId: ID!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  program(id: $programId) {
    id
    includedAudiences {
      id
    }
    uberTemplate {
      id
      variations {
        id
        title
        contentBlocks {
          id
          isPrimary
          position
          contentBlock {
            id
            title
            type
            numPositions
          }
          experiences2 {
            ...ProgramExperience2Fields
          }
        }
      }
    }
  }
}
    ${ProgramExperience2FieldsFragmentDoc}`;

/**
 * __useProgramContentQuery__
 *
 * To run a query within a React component, call `useProgramContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramContentQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useProgramContentQuery(baseOptions: Apollo.QueryHookOptions<ProgramContentQuery, ProgramContentQueryVariables> & ({ variables: ProgramContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramContentQuery, ProgramContentQueryVariables>(ProgramContentDocument, options);
      }
export function useProgramContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramContentQuery, ProgramContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramContentQuery, ProgramContentQueryVariables>(ProgramContentDocument, options);
        }
export function useProgramContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramContentQuery, ProgramContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramContentQuery, ProgramContentQueryVariables>(ProgramContentDocument, options);
        }
export type ProgramContentQueryHookResult = ReturnType<typeof useProgramContentQuery>;
export type ProgramContentLazyQueryHookResult = ReturnType<typeof useProgramContentLazyQuery>;
export type ProgramContentSuspenseQueryHookResult = ReturnType<typeof useProgramContentSuspenseQuery>;
export type ProgramContentQueryResult = Apollo.QueryResult<ProgramContentQuery, ProgramContentQueryVariables>;
export const Experience2UpdateDocument = gql`
    mutation Experience2Update($excludedCreativeIds: [ID!]!, $excludedTagIds: [ID!]!, $experienceId: ID!, $includedTagIds: [ID!]!, $title: String!, $visibility: Experience2Visibility!, $page: Int!, $pageSize: Int, $selectOnly: Experiences2CreativeFilter) {
  experience2Update(
    excludedCreativeIds: $excludedCreativeIds
    excludedTagIds: $excludedTagIds
    experienceId: $experienceId
    includedTagIds: $includedTagIds
    title: $title
    visibility: $visibility
  ) {
    success
    experience2 {
      ...ProgramExperience2Fields
    }
  }
}
    ${ProgramExperience2FieldsFragmentDoc}`;
export type Experience2UpdateMutationFn = Apollo.MutationFunction<Experience2UpdateMutation, Experience2UpdateMutationVariables>;

/**
 * __useExperience2UpdateMutation__
 *
 * To run a mutation, you first call `useExperience2UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperience2UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experience2UpdateMutation, { data, loading, error }] = useExperience2UpdateMutation({
 *   variables: {
 *      excludedCreativeIds: // value for 'excludedCreativeIds'
 *      excludedTagIds: // value for 'excludedTagIds'
 *      experienceId: // value for 'experienceId'
 *      includedTagIds: // value for 'includedTagIds'
 *      title: // value for 'title'
 *      visibility: // value for 'visibility'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      selectOnly: // value for 'selectOnly'
 *   },
 * });
 */
export function useExperience2UpdateMutation(baseOptions?: Apollo.MutationHookOptions<Experience2UpdateMutation, Experience2UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Experience2UpdateMutation, Experience2UpdateMutationVariables>(Experience2UpdateDocument, options);
      }
export type Experience2UpdateMutationHookResult = ReturnType<typeof useExperience2UpdateMutation>;
export type Experience2UpdateMutationResult = Apollo.MutationResult<Experience2UpdateMutation>;
export type Experience2UpdateMutationOptions = Apollo.BaseMutationOptions<Experience2UpdateMutation, Experience2UpdateMutationVariables>;
export const TagsDocument = gql`
    query Tags($filter: String) {
  tags(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export function useTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const ProgramTemplateDocument = gql`
    query ProgramTemplate($programId: ID!) {
  program(id: $programId) {
    id
    stateInfo {
      state
    }
    uberTemplate {
      ...UberTemplateFields
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;

/**
 * __useProgramTemplateQuery__
 *
 * To run a query within a React component, call `useProgramTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramTemplateQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramTemplateQuery(baseOptions: Apollo.QueryHookOptions<ProgramTemplateQuery, ProgramTemplateQueryVariables> & ({ variables: ProgramTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramTemplateQuery, ProgramTemplateQueryVariables>(ProgramTemplateDocument, options);
      }
export function useProgramTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramTemplateQuery, ProgramTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramTemplateQuery, ProgramTemplateQueryVariables>(ProgramTemplateDocument, options);
        }
export function useProgramTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramTemplateQuery, ProgramTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramTemplateQuery, ProgramTemplateQueryVariables>(ProgramTemplateDocument, options);
        }
export type ProgramTemplateQueryHookResult = ReturnType<typeof useProgramTemplateQuery>;
export type ProgramTemplateLazyQueryHookResult = ReturnType<typeof useProgramTemplateLazyQuery>;
export type ProgramTemplateSuspenseQueryHookResult = ReturnType<typeof useProgramTemplateSuspenseQuery>;
export type ProgramTemplateQueryResult = Apollo.QueryResult<ProgramTemplateQuery, ProgramTemplateQueryVariables>;
export const ProgramTemplateAddDocument = gql`
    mutation ProgramTemplateAdd($programId: ID!, $templateId: ID!, $title: String) {
  programTemplateAdd(
    programId: $programId
    templateId: $templateId
    title: $title
  ) {
    success
    program {
      id
      stateInfo {
        state
      }
      uberTemplate {
        ...UberTemplateFields
      }
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;
export type ProgramTemplateAddMutationFn = Apollo.MutationFunction<ProgramTemplateAddMutation, ProgramTemplateAddMutationVariables>;

/**
 * __useProgramTemplateAddMutation__
 *
 * To run a mutation, you first call `useProgramTemplateAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramTemplateAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programTemplateAddMutation, { data, loading, error }] = useProgramTemplateAddMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      templateId: // value for 'templateId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useProgramTemplateAddMutation(baseOptions?: Apollo.MutationHookOptions<ProgramTemplateAddMutation, ProgramTemplateAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramTemplateAddMutation, ProgramTemplateAddMutationVariables>(ProgramTemplateAddDocument, options);
      }
export type ProgramTemplateAddMutationHookResult = ReturnType<typeof useProgramTemplateAddMutation>;
export type ProgramTemplateAddMutationResult = Apollo.MutationResult<ProgramTemplateAddMutation>;
export type ProgramTemplateAddMutationOptions = Apollo.BaseMutationOptions<ProgramTemplateAddMutation, ProgramTemplateAddMutationVariables>;
export const ProgramUberTemplateVariationRemoveDocument = gql`
    mutation ProgramUberTemplateVariationRemove($programId: ID!, $variationId: ID!) {
  programUberTemplateVariationRemove(
    programId: $programId
    variationId: $variationId
  ) {
    success
    program {
      id
      stateInfo {
        state
      }
      uberTemplate {
        ...UberTemplateFields
      }
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;
export type ProgramUberTemplateVariationRemoveMutationFn = Apollo.MutationFunction<ProgramUberTemplateVariationRemoveMutation, ProgramUberTemplateVariationRemoveMutationVariables>;

/**
 * __useProgramUberTemplateVariationRemoveMutation__
 *
 * To run a mutation, you first call `useProgramUberTemplateVariationRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramUberTemplateVariationRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programUberTemplateVariationRemoveMutation, { data, loading, error }] = useProgramUberTemplateVariationRemoveMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      variationId: // value for 'variationId'
 *   },
 * });
 */
export function useProgramUberTemplateVariationRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ProgramUberTemplateVariationRemoveMutation, ProgramUberTemplateVariationRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramUberTemplateVariationRemoveMutation, ProgramUberTemplateVariationRemoveMutationVariables>(ProgramUberTemplateVariationRemoveDocument, options);
      }
export type ProgramUberTemplateVariationRemoveMutationHookResult = ReturnType<typeof useProgramUberTemplateVariationRemoveMutation>;
export type ProgramUberTemplateVariationRemoveMutationResult = Apollo.MutationResult<ProgramUberTemplateVariationRemoveMutation>;
export type ProgramUberTemplateVariationRemoveMutationOptions = Apollo.BaseMutationOptions<ProgramUberTemplateVariationRemoveMutation, ProgramUberTemplateVariationRemoveMutationVariables>;
export const UberTemplateVariationContentblockRemoveDocument = gql`
    mutation UberTemplateVariationContentblockRemove($programId: ID!, $contentBlockId: ID!, $confirm: Boolean) {
  uberTemplateVariationContentblockRemove(
    programId: $programId
    confirm: $confirm
    uberTemplateContentBlockId: $contentBlockId
  ) {
    ... on ProgramSuccess {
      success
      program {
        id
        stateInfo {
          state
        }
        uberTemplate {
          ...UberTemplateFields
        }
      }
    }
    ... on NeedsConfirmation {
      success
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;
export type UberTemplateVariationContentblockRemoveMutationFn = Apollo.MutationFunction<UberTemplateVariationContentblockRemoveMutation, UberTemplateVariationContentblockRemoveMutationVariables>;

/**
 * __useUberTemplateVariationContentblockRemoveMutation__
 *
 * To run a mutation, you first call `useUberTemplateVariationContentblockRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUberTemplateVariationContentblockRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uberTemplateVariationContentblockRemoveMutation, { data, loading, error }] = useUberTemplateVariationContentblockRemoveMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      contentBlockId: // value for 'contentBlockId'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useUberTemplateVariationContentblockRemoveMutation(baseOptions?: Apollo.MutationHookOptions<UberTemplateVariationContentblockRemoveMutation, UberTemplateVariationContentblockRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UberTemplateVariationContentblockRemoveMutation, UberTemplateVariationContentblockRemoveMutationVariables>(UberTemplateVariationContentblockRemoveDocument, options);
      }
export type UberTemplateVariationContentblockRemoveMutationHookResult = ReturnType<typeof useUberTemplateVariationContentblockRemoveMutation>;
export type UberTemplateVariationContentblockRemoveMutationResult = Apollo.MutationResult<UberTemplateVariationContentblockRemoveMutation>;
export type UberTemplateVariationContentblockRemoveMutationOptions = Apollo.BaseMutationOptions<UberTemplateVariationContentblockRemoveMutation, UberTemplateVariationContentblockRemoveMutationVariables>;
export const UberTemplateVariationContentblockAddDocument = gql`
    mutation UberTemplateVariationContentblockAdd($contentBlockId: ID!, $isPrimary: Boolean, $position: Int!, $programId: ID!, $variationId: ID!) {
  uberTemplateVariationContentblockAdd(
    contentBlockId: $contentBlockId
    isPrimary: $isPrimary
    position: $position
    programId: $programId
    variationId: $variationId
  ) {
    success
    program {
      id
      stateInfo {
        state
      }
      uberTemplate {
        ...UberTemplateFields
      }
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;
export type UberTemplateVariationContentblockAddMutationFn = Apollo.MutationFunction<UberTemplateVariationContentblockAddMutation, UberTemplateVariationContentblockAddMutationVariables>;

/**
 * __useUberTemplateVariationContentblockAddMutation__
 *
 * To run a mutation, you first call `useUberTemplateVariationContentblockAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUberTemplateVariationContentblockAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uberTemplateVariationContentblockAddMutation, { data, loading, error }] = useUberTemplateVariationContentblockAddMutation({
 *   variables: {
 *      contentBlockId: // value for 'contentBlockId'
 *      isPrimary: // value for 'isPrimary'
 *      position: // value for 'position'
 *      programId: // value for 'programId'
 *      variationId: // value for 'variationId'
 *   },
 * });
 */
export function useUberTemplateVariationContentblockAddMutation(baseOptions?: Apollo.MutationHookOptions<UberTemplateVariationContentblockAddMutation, UberTemplateVariationContentblockAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UberTemplateVariationContentblockAddMutation, UberTemplateVariationContentblockAddMutationVariables>(UberTemplateVariationContentblockAddDocument, options);
      }
export type UberTemplateVariationContentblockAddMutationHookResult = ReturnType<typeof useUberTemplateVariationContentblockAddMutation>;
export type UberTemplateVariationContentblockAddMutationResult = Apollo.MutationResult<UberTemplateVariationContentblockAddMutation>;
export type UberTemplateVariationContentblockAddMutationOptions = Apollo.BaseMutationOptions<UberTemplateVariationContentblockAddMutation, UberTemplateVariationContentblockAddMutationVariables>;
export const UberTemplateVariationContentblockPriorityUpdateDocument = gql`
    mutation UberTemplateVariationContentblockPriorityUpdate($programId: ID!, $contentBlockIds: [ID!]!, $variationId: ID!) {
  uberTemplateVariationContentblockPriorityUpdate(
    programId: $programId
    uberTemplateContentBlockIds: $contentBlockIds
    variationId: $variationId
  ) {
    ... on ProgramSuccess {
      success
      program {
        id
        stateInfo {
          state
        }
        uberTemplate {
          ...UberTemplateFields
        }
      }
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;
export type UberTemplateVariationContentblockPriorityUpdateMutationFn = Apollo.MutationFunction<UberTemplateVariationContentblockPriorityUpdateMutation, UberTemplateVariationContentblockPriorityUpdateMutationVariables>;

/**
 * __useUberTemplateVariationContentblockPriorityUpdateMutation__
 *
 * To run a mutation, you first call `useUberTemplateVariationContentblockPriorityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUberTemplateVariationContentblockPriorityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uberTemplateVariationContentblockPriorityUpdateMutation, { data, loading, error }] = useUberTemplateVariationContentblockPriorityUpdateMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      contentBlockIds: // value for 'contentBlockIds'
 *      variationId: // value for 'variationId'
 *   },
 * });
 */
export function useUberTemplateVariationContentblockPriorityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UberTemplateVariationContentblockPriorityUpdateMutation, UberTemplateVariationContentblockPriorityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UberTemplateVariationContentblockPriorityUpdateMutation, UberTemplateVariationContentblockPriorityUpdateMutationVariables>(UberTemplateVariationContentblockPriorityUpdateDocument, options);
      }
export type UberTemplateVariationContentblockPriorityUpdateMutationHookResult = ReturnType<typeof useUberTemplateVariationContentblockPriorityUpdateMutation>;
export type UberTemplateVariationContentblockPriorityUpdateMutationResult = Apollo.MutationResult<UberTemplateVariationContentblockPriorityUpdateMutation>;
export type UberTemplateVariationContentblockPriorityUpdateMutationOptions = Apollo.BaseMutationOptions<UberTemplateVariationContentblockPriorityUpdateMutation, UberTemplateVariationContentblockPriorityUpdateMutationVariables>;
export const UberTemplateVariationPrimaryContentblockUpdateDocument = gql`
    mutation UberTemplateVariationPrimaryContentblockUpdate($programId: ID!, $contentBlockId: ID!) {
  uberTemplateVariationPrimaryContentblockUpdate(
    programId: $programId
    uberTemplateContentBlockId: $contentBlockId
  ) {
    success
    program {
      id
      stateInfo {
        state
      }
      uberTemplate {
        ...UberTemplateFields
      }
    }
  }
}
    ${UberTemplateFieldsFragmentDoc}`;
export type UberTemplateVariationPrimaryContentblockUpdateMutationFn = Apollo.MutationFunction<UberTemplateVariationPrimaryContentblockUpdateMutation, UberTemplateVariationPrimaryContentblockUpdateMutationVariables>;

/**
 * __useUberTemplateVariationPrimaryContentblockUpdateMutation__
 *
 * To run a mutation, you first call `useUberTemplateVariationPrimaryContentblockUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUberTemplateVariationPrimaryContentblockUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uberTemplateVariationPrimaryContentblockUpdateMutation, { data, loading, error }] = useUberTemplateVariationPrimaryContentblockUpdateMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      contentBlockId: // value for 'contentBlockId'
 *   },
 * });
 */
export function useUberTemplateVariationPrimaryContentblockUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UberTemplateVariationPrimaryContentblockUpdateMutation, UberTemplateVariationPrimaryContentblockUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UberTemplateVariationPrimaryContentblockUpdateMutation, UberTemplateVariationPrimaryContentblockUpdateMutationVariables>(UberTemplateVariationPrimaryContentblockUpdateDocument, options);
      }
export type UberTemplateVariationPrimaryContentblockUpdateMutationHookResult = ReturnType<typeof useUberTemplateVariationPrimaryContentblockUpdateMutation>;
export type UberTemplateVariationPrimaryContentblockUpdateMutationResult = Apollo.MutationResult<UberTemplateVariationPrimaryContentblockUpdateMutation>;
export type UberTemplateVariationPrimaryContentblockUpdateMutationOptions = Apollo.BaseMutationOptions<UberTemplateVariationPrimaryContentblockUpdateMutation, UberTemplateVariationPrimaryContentblockUpdateMutationVariables>;
export const ProgramAvailableCreativeTagsDocument = gql`
    query ProgramAvailableCreativeTags($programId: ID!) {
  program(id: $programId) {
    id
    availableCreativeTags {
      id
      name
    }
  }
}
    `;

/**
 * __useProgramAvailableCreativeTagsQuery__
 *
 * To run a query within a React component, call `useProgramAvailableCreativeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAvailableCreativeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAvailableCreativeTagsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramAvailableCreativeTagsQuery(baseOptions: Apollo.QueryHookOptions<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables> & ({ variables: ProgramAvailableCreativeTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables>(ProgramAvailableCreativeTagsDocument, options);
      }
export function useProgramAvailableCreativeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables>(ProgramAvailableCreativeTagsDocument, options);
        }
export function useProgramAvailableCreativeTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables>(ProgramAvailableCreativeTagsDocument, options);
        }
export type ProgramAvailableCreativeTagsQueryHookResult = ReturnType<typeof useProgramAvailableCreativeTagsQuery>;
export type ProgramAvailableCreativeTagsLazyQueryHookResult = ReturnType<typeof useProgramAvailableCreativeTagsLazyQuery>;
export type ProgramAvailableCreativeTagsSuspenseQueryHookResult = ReturnType<typeof useProgramAvailableCreativeTagsSuspenseQuery>;
export type ProgramAvailableCreativeTagsQueryResult = Apollo.QueryResult<ProgramAvailableCreativeTagsQuery, ProgramAvailableCreativeTagsQueryVariables>;
export const ProgramCreateDocument = gql`
    mutation ProgramCreate($title: String!, $description: String!) {
  programCreate(title: $title, description: $description) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
    ... on ValidationErrors {
      errors {
        code
        field
        reason
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramCreateMutationFn = Apollo.MutationFunction<ProgramCreateMutation, ProgramCreateMutationVariables>;

/**
 * __useProgramCreateMutation__
 *
 * To run a mutation, you first call `useProgramCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programCreateMutation, { data, loading, error }] = useProgramCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useProgramCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProgramCreateMutation, ProgramCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramCreateMutation, ProgramCreateMutationVariables>(ProgramCreateDocument, options);
      }
export type ProgramCreateMutationHookResult = ReturnType<typeof useProgramCreateMutation>;
export type ProgramCreateMutationResult = Apollo.MutationResult<ProgramCreateMutation>;
export type ProgramCreateMutationOptions = Apollo.BaseMutationOptions<ProgramCreateMutation, ProgramCreateMutationVariables>;
export const ProgramUpdateDocument = gql`
    mutation ProgramUpdate($description: String!, $title: String!, $programId: ID!, $isArchived: Boolean) {
  programUpdate(
    description: $description
    title: $title
    programId: $programId
    isArchived: $isArchived
  ) {
    ... on ProgramSuccess {
      success
      program {
        ...ProgramFields
      }
    }
    ... on ValidationErrors {
      errors {
        code
        field
        reason
      }
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramUpdateMutationFn = Apollo.MutationFunction<ProgramUpdateMutation, ProgramUpdateMutationVariables>;

/**
 * __useProgramUpdateMutation__
 *
 * To run a mutation, you first call `useProgramUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programUpdateMutation, { data, loading, error }] = useProgramUpdateMutation({
 *   variables: {
 *      description: // value for 'description'
 *      title: // value for 'title'
 *      programId: // value for 'programId'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useProgramUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProgramUpdateMutation, ProgramUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramUpdateMutation, ProgramUpdateMutationVariables>(ProgramUpdateDocument, options);
      }
export type ProgramUpdateMutationHookResult = ReturnType<typeof useProgramUpdateMutation>;
export type ProgramUpdateMutationResult = Apollo.MutationResult<ProgramUpdateMutation>;
export type ProgramUpdateMutationOptions = Apollo.BaseMutationOptions<ProgramUpdateMutation, ProgramUpdateMutationVariables>;
export const ProgramDocument = gql`
    query Program($programId: ID!) {
  program(id: $programId) {
    ...ProgramFields
  }
}
    ${ProgramFieldsFragmentDoc}`;

/**
 * __useProgramQuery__
 *
 * To run a query within a React component, call `useProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramQuery(baseOptions: Apollo.QueryHookOptions<ProgramQuery, ProgramQueryVariables> & ({ variables: ProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
      }
export function useProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
        }
export function useProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
        }
export type ProgramQueryHookResult = ReturnType<typeof useProgramQuery>;
export type ProgramLazyQueryHookResult = ReturnType<typeof useProgramLazyQuery>;
export type ProgramSuspenseQueryHookResult = ReturnType<typeof useProgramSuspenseQuery>;
export type ProgramQueryResult = Apollo.QueryResult<ProgramQuery, ProgramQueryVariables>;
export const ProgramStateDocument = gql`
    query ProgramState($programId: ID!) {
  program(id: $programId) {
    id
    title
    isQuiet
    stateInfo {
      ...ProgramStateInfoFields
    }
  }
}
    ${ProgramStateInfoFieldsFragmentDoc}`;

/**
 * __useProgramStateQuery__
 *
 * To run a query within a React component, call `useProgramStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramStateQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramStateQuery(baseOptions: Apollo.QueryHookOptions<ProgramStateQuery, ProgramStateQueryVariables> & ({ variables: ProgramStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramStateQuery, ProgramStateQueryVariables>(ProgramStateDocument, options);
      }
export function useProgramStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramStateQuery, ProgramStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramStateQuery, ProgramStateQueryVariables>(ProgramStateDocument, options);
        }
export function useProgramStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramStateQuery, ProgramStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramStateQuery, ProgramStateQueryVariables>(ProgramStateDocument, options);
        }
export type ProgramStateQueryHookResult = ReturnType<typeof useProgramStateQuery>;
export type ProgramStateLazyQueryHookResult = ReturnType<typeof useProgramStateLazyQuery>;
export type ProgramStateSuspenseQueryHookResult = ReturnType<typeof useProgramStateSuspenseQuery>;
export type ProgramStateQueryResult = Apollo.QueryResult<ProgramStateQuery, ProgramStateQueryVariables>;
export const ProgramsDocument = gql`
    query Programs($after: String, $before: String, $first: Int, $last: Int, $filter: ProgramFilterInput) {
  programs(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
  ) {
    counts {
      total
      draft
      locked
      active
      completed
      suspended
      archived
    }
    edges {
      node {
        ...ProgramFields
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;

/**
 * __useProgramsQuery__
 *
 * To run a query within a React component, call `useProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
      }
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export function useProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsSuspenseQueryHookResult = ReturnType<typeof useProgramsSuspenseQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
export const ProgramsCountsDocument = gql`
    query ProgramsCounts {
  programs {
    counts {
      total
      draft
      locked
      active
      completed
      suspended
      archived
    }
  }
}
    `;

/**
 * __useProgramsCountsQuery__
 *
 * To run a query within a React component, call `useProgramsCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramsCountsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsCountsQuery, ProgramsCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsCountsQuery, ProgramsCountsQueryVariables>(ProgramsCountsDocument, options);
      }
export function useProgramsCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsCountsQuery, ProgramsCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsCountsQuery, ProgramsCountsQueryVariables>(ProgramsCountsDocument, options);
        }
export function useProgramsCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsCountsQuery, ProgramsCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsCountsQuery, ProgramsCountsQueryVariables>(ProgramsCountsDocument, options);
        }
export type ProgramsCountsQueryHookResult = ReturnType<typeof useProgramsCountsQuery>;
export type ProgramsCountsLazyQueryHookResult = ReturnType<typeof useProgramsCountsLazyQuery>;
export type ProgramsCountsSuspenseQueryHookResult = ReturnType<typeof useProgramsCountsSuspenseQuery>;
export type ProgramsCountsQueryResult = Apollo.QueryResult<ProgramsCountsQuery, ProgramsCountsQueryVariables>;
export const AvailableCustomFieldsDocument = gql`
    query AvailableCustomFields($filter: String) {
  availableCustomFields(filter: $filter) {
    id
    name
    title
    dataType
  }
}
    `;

/**
 * __useAvailableCustomFieldsQuery__
 *
 * To run a query within a React component, call `useAvailableCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCustomFieldsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAvailableCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>(AvailableCustomFieldsDocument, options);
      }
export function useAvailableCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>(AvailableCustomFieldsDocument, options);
        }
export function useAvailableCustomFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>(AvailableCustomFieldsDocument, options);
        }
export type AvailableCustomFieldsQueryHookResult = ReturnType<typeof useAvailableCustomFieldsQuery>;
export type AvailableCustomFieldsLazyQueryHookResult = ReturnType<typeof useAvailableCustomFieldsLazyQuery>;
export type AvailableCustomFieldsSuspenseQueryHookResult = ReturnType<typeof useAvailableCustomFieldsSuspenseQuery>;
export type AvailableCustomFieldsQueryResult = Apollo.QueryResult<AvailableCustomFieldsQuery, AvailableCustomFieldsQueryVariables>;
export const ProgramStateTransitionDocument = gql`
    mutation ProgramStateTransition($programId: ID!, $state: ProgramStateType!) {
  programStateTransition(programId: $programId, state: $state) {
    success
    program {
      id
      stateInfo {
        state
        history {
          state
          user {
            fullName
          }
          timestamp
        }
        transitions {
          label
          state
          permission {
            ... on TransitionPermissionAllowed {
              allowed
            }
            ... on TransitionPermissionDenied {
              allowed
              code
              message
            }
          }
        }
        actions {
          id
          label
        }
      }
    }
  }
}
    `;
export type ProgramStateTransitionMutationFn = Apollo.MutationFunction<ProgramStateTransitionMutation, ProgramStateTransitionMutationVariables>;

/**
 * __useProgramStateTransitionMutation__
 *
 * To run a mutation, you first call `useProgramStateTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramStateTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programStateTransitionMutation, { data, loading, error }] = useProgramStateTransitionMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useProgramStateTransitionMutation(baseOptions?: Apollo.MutationHookOptions<ProgramStateTransitionMutation, ProgramStateTransitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramStateTransitionMutation, ProgramStateTransitionMutationVariables>(ProgramStateTransitionDocument, options);
      }
export type ProgramStateTransitionMutationHookResult = ReturnType<typeof useProgramStateTransitionMutation>;
export type ProgramStateTransitionMutationResult = Apollo.MutationResult<ProgramStateTransitionMutation>;
export type ProgramStateTransitionMutationOptions = Apollo.BaseMutationOptions<ProgramStateTransitionMutation, ProgramStateTransitionMutationVariables>;
export const ProgramSeedAudienceAddDocument = gql`
    mutation ProgramSeedAudienceAdd($programId: ID!, $audienceId: ID!) {
  programSeedAudienceAdd(programId: $programId, audienceId: $audienceId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramSeedAudienceAddMutationFn = Apollo.MutationFunction<ProgramSeedAudienceAddMutation, ProgramSeedAudienceAddMutationVariables>;

/**
 * __useProgramSeedAudienceAddMutation__
 *
 * To run a mutation, you first call `useProgramSeedAudienceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramSeedAudienceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programSeedAudienceAddMutation, { data, loading, error }] = useProgramSeedAudienceAddMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useProgramSeedAudienceAddMutation(baseOptions?: Apollo.MutationHookOptions<ProgramSeedAudienceAddMutation, ProgramSeedAudienceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramSeedAudienceAddMutation, ProgramSeedAudienceAddMutationVariables>(ProgramSeedAudienceAddDocument, options);
      }
export type ProgramSeedAudienceAddMutationHookResult = ReturnType<typeof useProgramSeedAudienceAddMutation>;
export type ProgramSeedAudienceAddMutationResult = Apollo.MutationResult<ProgramSeedAudienceAddMutation>;
export type ProgramSeedAudienceAddMutationOptions = Apollo.BaseMutationOptions<ProgramSeedAudienceAddMutation, ProgramSeedAudienceAddMutationVariables>;
export const ProgramSeedAudienceRemoveDocument = gql`
    mutation ProgramSeedAudienceRemove($programId: ID!, $audienceId: ID!) {
  programSeedAudienceRemove(programId: $programId, audienceId: $audienceId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramSeedAudienceRemoveMutationFn = Apollo.MutationFunction<ProgramSeedAudienceRemoveMutation, ProgramSeedAudienceRemoveMutationVariables>;

/**
 * __useProgramSeedAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useProgramSeedAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramSeedAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programSeedAudienceRemoveMutation, { data, loading, error }] = useProgramSeedAudienceRemoveMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useProgramSeedAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ProgramSeedAudienceRemoveMutation, ProgramSeedAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramSeedAudienceRemoveMutation, ProgramSeedAudienceRemoveMutationVariables>(ProgramSeedAudienceRemoveDocument, options);
      }
export type ProgramSeedAudienceRemoveMutationHookResult = ReturnType<typeof useProgramSeedAudienceRemoveMutation>;
export type ProgramSeedAudienceRemoveMutationResult = Apollo.MutationResult<ProgramSeedAudienceRemoveMutation>;
export type ProgramSeedAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<ProgramSeedAudienceRemoveMutation, ProgramSeedAudienceRemoveMutationVariables>;
export const QuietHourRuleAddDocument = gql`
    mutation QuietHourRuleAdd($programId: ID!, $name: String, $endTime: Time!, $startTime: Time!, $daysOfWeek: [DaysOfWeek!]!) {
  quietHourRuleAdd(
    programId: $programId
    name: $name
    startTime: $startTime
    endTime: $endTime
    daysOfWeek: $daysOfWeek
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type QuietHourRuleAddMutationFn = Apollo.MutationFunction<QuietHourRuleAddMutation, QuietHourRuleAddMutationVariables>;

/**
 * __useQuietHourRuleAddMutation__
 *
 * To run a mutation, you first call `useQuietHourRuleAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuietHourRuleAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quietHourRuleAddMutation, { data, loading, error }] = useQuietHourRuleAddMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      name: // value for 'name'
 *      endTime: // value for 'endTime'
 *      startTime: // value for 'startTime'
 *      daysOfWeek: // value for 'daysOfWeek'
 *   },
 * });
 */
export function useQuietHourRuleAddMutation(baseOptions?: Apollo.MutationHookOptions<QuietHourRuleAddMutation, QuietHourRuleAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuietHourRuleAddMutation, QuietHourRuleAddMutationVariables>(QuietHourRuleAddDocument, options);
      }
export type QuietHourRuleAddMutationHookResult = ReturnType<typeof useQuietHourRuleAddMutation>;
export type QuietHourRuleAddMutationResult = Apollo.MutationResult<QuietHourRuleAddMutation>;
export type QuietHourRuleAddMutationOptions = Apollo.BaseMutationOptions<QuietHourRuleAddMutation, QuietHourRuleAddMutationVariables>;
export const QuietHourRuleUpdateDocument = gql`
    mutation QuietHourRuleUpdate($daysOfWeek: [DaysOfWeek!]!, $endTime: Time!, $name: String, $programId: ID!, $ruleId: ID!, $startTime: Time!) {
  quietHourRuleUpdate(
    programId: $programId
    ruleId: $ruleId
    name: $name
    startTime: $startTime
    endTime: $endTime
    daysOfWeek: $daysOfWeek
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type QuietHourRuleUpdateMutationFn = Apollo.MutationFunction<QuietHourRuleUpdateMutation, QuietHourRuleUpdateMutationVariables>;

/**
 * __useQuietHourRuleUpdateMutation__
 *
 * To run a mutation, you first call `useQuietHourRuleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuietHourRuleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quietHourRuleUpdateMutation, { data, loading, error }] = useQuietHourRuleUpdateMutation({
 *   variables: {
 *      daysOfWeek: // value for 'daysOfWeek'
 *      endTime: // value for 'endTime'
 *      name: // value for 'name'
 *      programId: // value for 'programId'
 *      ruleId: // value for 'ruleId'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useQuietHourRuleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<QuietHourRuleUpdateMutation, QuietHourRuleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuietHourRuleUpdateMutation, QuietHourRuleUpdateMutationVariables>(QuietHourRuleUpdateDocument, options);
      }
export type QuietHourRuleUpdateMutationHookResult = ReturnType<typeof useQuietHourRuleUpdateMutation>;
export type QuietHourRuleUpdateMutationResult = Apollo.MutationResult<QuietHourRuleUpdateMutation>;
export type QuietHourRuleUpdateMutationOptions = Apollo.BaseMutationOptions<QuietHourRuleUpdateMutation, QuietHourRuleUpdateMutationVariables>;
export const QuietPeriodRuleAddDocument = gql`
    mutation QuietPeriodRuleAdd($endDatetime: DateTime!, $name: String, $programId: ID!, $startDatetime: DateTime!) {
  quietPeriodRuleAdd(
    programId: $programId
    name: $name
    endDatetime: $endDatetime
    startDatetime: $startDatetime
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type QuietPeriodRuleAddMutationFn = Apollo.MutationFunction<QuietPeriodRuleAddMutation, QuietPeriodRuleAddMutationVariables>;

/**
 * __useQuietPeriodRuleAddMutation__
 *
 * To run a mutation, you first call `useQuietPeriodRuleAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuietPeriodRuleAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quietPeriodRuleAddMutation, { data, loading, error }] = useQuietPeriodRuleAddMutation({
 *   variables: {
 *      endDatetime: // value for 'endDatetime'
 *      name: // value for 'name'
 *      programId: // value for 'programId'
 *      startDatetime: // value for 'startDatetime'
 *   },
 * });
 */
export function useQuietPeriodRuleAddMutation(baseOptions?: Apollo.MutationHookOptions<QuietPeriodRuleAddMutation, QuietPeriodRuleAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuietPeriodRuleAddMutation, QuietPeriodRuleAddMutationVariables>(QuietPeriodRuleAddDocument, options);
      }
export type QuietPeriodRuleAddMutationHookResult = ReturnType<typeof useQuietPeriodRuleAddMutation>;
export type QuietPeriodRuleAddMutationResult = Apollo.MutationResult<QuietPeriodRuleAddMutation>;
export type QuietPeriodRuleAddMutationOptions = Apollo.BaseMutationOptions<QuietPeriodRuleAddMutation, QuietPeriodRuleAddMutationVariables>;
export const QuietPeriodRuleUpdateDocument = gql`
    mutation QuietPeriodRuleUpdate($endDatetime: DateTime!, $name: String, $programId: ID!, $ruleId: ID!, $startDatetime: DateTime!) {
  quietPeriodRuleUpdate(
    programId: $programId
    ruleId: $ruleId
    name: $name
    endDatetime: $endDatetime
    startDatetime: $startDatetime
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type QuietPeriodRuleUpdateMutationFn = Apollo.MutationFunction<QuietPeriodRuleUpdateMutation, QuietPeriodRuleUpdateMutationVariables>;

/**
 * __useQuietPeriodRuleUpdateMutation__
 *
 * To run a mutation, you first call `useQuietPeriodRuleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuietPeriodRuleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quietPeriodRuleUpdateMutation, { data, loading, error }] = useQuietPeriodRuleUpdateMutation({
 *   variables: {
 *      endDatetime: // value for 'endDatetime'
 *      name: // value for 'name'
 *      programId: // value for 'programId'
 *      ruleId: // value for 'ruleId'
 *      startDatetime: // value for 'startDatetime'
 *   },
 * });
 */
export function useQuietPeriodRuleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<QuietPeriodRuleUpdateMutation, QuietPeriodRuleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuietPeriodRuleUpdateMutation, QuietPeriodRuleUpdateMutationVariables>(QuietPeriodRuleUpdateDocument, options);
      }
export type QuietPeriodRuleUpdateMutationHookResult = ReturnType<typeof useQuietPeriodRuleUpdateMutation>;
export type QuietPeriodRuleUpdateMutationResult = Apollo.MutationResult<QuietPeriodRuleUpdateMutation>;
export type QuietPeriodRuleUpdateMutationOptions = Apollo.BaseMutationOptions<QuietPeriodRuleUpdateMutation, QuietPeriodRuleUpdateMutationVariables>;
export const QuietRuleRemoveDocument = gql`
    mutation QuietRuleRemove($programId: ID!, $ruleId: ID!) {
  quietRuleRemove(programId: $programId, ruleId: $ruleId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type QuietRuleRemoveMutationFn = Apollo.MutationFunction<QuietRuleRemoveMutation, QuietRuleRemoveMutationVariables>;

/**
 * __useQuietRuleRemoveMutation__
 *
 * To run a mutation, you first call `useQuietRuleRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuietRuleRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quietRuleRemoveMutation, { data, loading, error }] = useQuietRuleRemoveMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useQuietRuleRemoveMutation(baseOptions?: Apollo.MutationHookOptions<QuietRuleRemoveMutation, QuietRuleRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuietRuleRemoveMutation, QuietRuleRemoveMutationVariables>(QuietRuleRemoveDocument, options);
      }
export type QuietRuleRemoveMutationHookResult = ReturnType<typeof useQuietRuleRemoveMutation>;
export type QuietRuleRemoveMutationResult = Apollo.MutationResult<QuietRuleRemoveMutation>;
export type QuietRuleRemoveMutationOptions = Apollo.BaseMutationOptions<QuietRuleRemoveMutation, QuietRuleRemoveMutationVariables>;
export const ProgramTagAddDocument = gql`
    mutation ProgramTagAdd($programId: ID!, $tagId: ID!) {
  programTagAdd(programId: $programId, tagId: $tagId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramTagAddMutationFn = Apollo.MutationFunction<ProgramTagAddMutation, ProgramTagAddMutationVariables>;

/**
 * __useProgramTagAddMutation__
 *
 * To run a mutation, you first call `useProgramTagAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramTagAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programTagAddMutation, { data, loading, error }] = useProgramTagAddMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useProgramTagAddMutation(baseOptions?: Apollo.MutationHookOptions<ProgramTagAddMutation, ProgramTagAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramTagAddMutation, ProgramTagAddMutationVariables>(ProgramTagAddDocument, options);
      }
export type ProgramTagAddMutationHookResult = ReturnType<typeof useProgramTagAddMutation>;
export type ProgramTagAddMutationResult = Apollo.MutationResult<ProgramTagAddMutation>;
export type ProgramTagAddMutationOptions = Apollo.BaseMutationOptions<ProgramTagAddMutation, ProgramTagAddMutationVariables>;
export const ProgramTagRemoveDocument = gql`
    mutation ProgramTagRemove($programId: ID!, $tagId: ID!) {
  programTagRemove(programId: $programId, tagId: $tagId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramTagRemoveMutationFn = Apollo.MutationFunction<ProgramTagRemoveMutation, ProgramTagRemoveMutationVariables>;

/**
 * __useProgramTagRemoveMutation__
 *
 * To run a mutation, you first call `useProgramTagRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramTagRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programTagRemoveMutation, { data, loading, error }] = useProgramTagRemoveMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useProgramTagRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ProgramTagRemoveMutation, ProgramTagRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramTagRemoveMutation, ProgramTagRemoveMutationVariables>(ProgramTagRemoveDocument, options);
      }
export type ProgramTagRemoveMutationHookResult = ReturnType<typeof useProgramTagRemoveMutation>;
export type ProgramTagRemoveMutationResult = Apollo.MutationResult<ProgramTagRemoveMutation>;
export type ProgramTagRemoveMutationOptions = Apollo.BaseMutationOptions<ProgramTagRemoveMutation, ProgramTagRemoveMutationVariables>;
export const ProgramTextTrackingParameterUpdateDocument = gql`
    mutation ProgramTextTrackingParameterUpdate($programId: ID!, $trackingParameterId: ID!, $value: String) {
  programTextTrackingParameterUpdate(
    programId: $programId
    trackingParameterId: $trackingParameterId
    value: $value
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramTextTrackingParameterUpdateMutationFn = Apollo.MutationFunction<ProgramTextTrackingParameterUpdateMutation, ProgramTextTrackingParameterUpdateMutationVariables>;

/**
 * __useProgramTextTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useProgramTextTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramTextTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programTextTrackingParameterUpdateMutation, { data, loading, error }] = useProgramTextTrackingParameterUpdateMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useProgramTextTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProgramTextTrackingParameterUpdateMutation, ProgramTextTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramTextTrackingParameterUpdateMutation, ProgramTextTrackingParameterUpdateMutationVariables>(ProgramTextTrackingParameterUpdateDocument, options);
      }
export type ProgramTextTrackingParameterUpdateMutationHookResult = ReturnType<typeof useProgramTextTrackingParameterUpdateMutation>;
export type ProgramTextTrackingParameterUpdateMutationResult = Apollo.MutationResult<ProgramTextTrackingParameterUpdateMutation>;
export type ProgramTextTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<ProgramTextTrackingParameterUpdateMutation, ProgramTextTrackingParameterUpdateMutationVariables>;
export const ProgramSelectTrackingParameterUpdateDocument = gql`
    mutation ProgramSelectTrackingParameterUpdate($optionId: ID, $programId: ID!, $trackingParameterId: ID!) {
  programSelectTrackingParameterUpdate(
    optionId: $optionId
    programId: $programId
    trackingParameterId: $trackingParameterId
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramSelectTrackingParameterUpdateMutationFn = Apollo.MutationFunction<ProgramSelectTrackingParameterUpdateMutation, ProgramSelectTrackingParameterUpdateMutationVariables>;

/**
 * __useProgramSelectTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useProgramSelectTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramSelectTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programSelectTrackingParameterUpdateMutation, { data, loading, error }] = useProgramSelectTrackingParameterUpdateMutation({
 *   variables: {
 *      optionId: // value for 'optionId'
 *      programId: // value for 'programId'
 *      trackingParameterId: // value for 'trackingParameterId'
 *   },
 * });
 */
export function useProgramSelectTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProgramSelectTrackingParameterUpdateMutation, ProgramSelectTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramSelectTrackingParameterUpdateMutation, ProgramSelectTrackingParameterUpdateMutationVariables>(ProgramSelectTrackingParameterUpdateDocument, options);
      }
export type ProgramSelectTrackingParameterUpdateMutationHookResult = ReturnType<typeof useProgramSelectTrackingParameterUpdateMutation>;
export type ProgramSelectTrackingParameterUpdateMutationResult = Apollo.MutationResult<ProgramSelectTrackingParameterUpdateMutation>;
export type ProgramSelectTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<ProgramSelectTrackingParameterUpdateMutation, ProgramSelectTrackingParameterUpdateMutationVariables>;
export const ProgramCustomFieldRemoveDocument = gql`
    mutation ProgramCustomFieldRemove($customFieldId: ID!, $programId: ID!) {
  programCustomFieldRemove(customFieldId: $customFieldId, programId: $programId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramCustomFieldRemoveMutationFn = Apollo.MutationFunction<ProgramCustomFieldRemoveMutation, ProgramCustomFieldRemoveMutationVariables>;

/**
 * __useProgramCustomFieldRemoveMutation__
 *
 * To run a mutation, you first call `useProgramCustomFieldRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramCustomFieldRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programCustomFieldRemoveMutation, { data, loading, error }] = useProgramCustomFieldRemoveMutation({
 *   variables: {
 *      customFieldId: // value for 'customFieldId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramCustomFieldRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ProgramCustomFieldRemoveMutation, ProgramCustomFieldRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramCustomFieldRemoveMutation, ProgramCustomFieldRemoveMutationVariables>(ProgramCustomFieldRemoveDocument, options);
      }
export type ProgramCustomFieldRemoveMutationHookResult = ReturnType<typeof useProgramCustomFieldRemoveMutation>;
export type ProgramCustomFieldRemoveMutationResult = Apollo.MutationResult<ProgramCustomFieldRemoveMutation>;
export type ProgramCustomFieldRemoveMutationOptions = Apollo.BaseMutationOptions<ProgramCustomFieldRemoveMutation, ProgramCustomFieldRemoveMutationVariables>;
export const ProgramCustomFieldAddDocument = gql`
    mutation ProgramCustomFieldAdd($customFieldId: ID!, $programId: ID!) {
  programCustomFieldAdd(customFieldId: $customFieldId, programId: $programId) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramCustomFieldAddMutationFn = Apollo.MutationFunction<ProgramCustomFieldAddMutation, ProgramCustomFieldAddMutationVariables>;

/**
 * __useProgramCustomFieldAddMutation__
 *
 * To run a mutation, you first call `useProgramCustomFieldAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramCustomFieldAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programCustomFieldAddMutation, { data, loading, error }] = useProgramCustomFieldAddMutation({
 *   variables: {
 *      customFieldId: // value for 'customFieldId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramCustomFieldAddMutation(baseOptions?: Apollo.MutationHookOptions<ProgramCustomFieldAddMutation, ProgramCustomFieldAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramCustomFieldAddMutation, ProgramCustomFieldAddMutationVariables>(ProgramCustomFieldAddDocument, options);
      }
export type ProgramCustomFieldAddMutationHookResult = ReturnType<typeof useProgramCustomFieldAddMutation>;
export type ProgramCustomFieldAddMutationResult = Apollo.MutationResult<ProgramCustomFieldAddMutation>;
export type ProgramCustomFieldAddMutationOptions = Apollo.BaseMutationOptions<ProgramCustomFieldAddMutation, ProgramCustomFieldAddMutationVariables>;
export const ProgramCustomFieldUpdateDocument = gql`
    mutation ProgramCustomFieldUpdate($customFieldId: ID!, $metadata: CustomFieldMetadataInput!, $programId: ID!) {
  programCustomFieldUpdate(
    customFieldId: $customFieldId
    programId: $programId
    metadata: $metadata
  ) {
    success
    program {
      ...ProgramFields
    }
  }
}
    ${ProgramFieldsFragmentDoc}`;
export type ProgramCustomFieldUpdateMutationFn = Apollo.MutationFunction<ProgramCustomFieldUpdateMutation, ProgramCustomFieldUpdateMutationVariables>;

/**
 * __useProgramCustomFieldUpdateMutation__
 *
 * To run a mutation, you first call `useProgramCustomFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramCustomFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programCustomFieldUpdateMutation, { data, loading, error }] = useProgramCustomFieldUpdateMutation({
 *   variables: {
 *      customFieldId: // value for 'customFieldId'
 *      metadata: // value for 'metadata'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramCustomFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProgramCustomFieldUpdateMutation, ProgramCustomFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProgramCustomFieldUpdateMutation, ProgramCustomFieldUpdateMutationVariables>(ProgramCustomFieldUpdateDocument, options);
      }
export type ProgramCustomFieldUpdateMutationHookResult = ReturnType<typeof useProgramCustomFieldUpdateMutation>;
export type ProgramCustomFieldUpdateMutationResult = Apollo.MutationResult<ProgramCustomFieldUpdateMutation>;
export type ProgramCustomFieldUpdateMutationOptions = Apollo.BaseMutationOptions<ProgramCustomFieldUpdateMutation, ProgramCustomFieldUpdateMutationVariables>;
export const ProgramProofVariantListDocument = gql`
    query ProgramProofVariantList($programId: ID!, $proofVariantFilter: ProofVariantFilterInput!, $limit: Int, $offset: Int, $sendDate: Date!) {
  programProofVariantList(
    programId: $programId
    proofVariantFilter: $proofVariantFilter
    limit: $limit
    offset: $offset
    sendDate: $sendDate
  ) {
    results {
      runId
      id
      subjectline
      subjectlinePrefix
      subjectlineSuffix
      previewText
      preheaderText
      recipients
      previewText
      preheaderText
      type
      desktopImageUrl
      contentBlocks {
        position
        title
        creativeTitle
      }
    }
    meta {
      totalResults
      variants
      recipients
      totalVariants
      totalRecipients
    }
  }
}
    `;

/**
 * __useProgramProofVariantListQuery__
 *
 * To run a query within a React component, call `useProgramProofVariantListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramProofVariantListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramProofVariantListQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      proofVariantFilter: // value for 'proofVariantFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sendDate: // value for 'sendDate'
 *   },
 * });
 */
export function useProgramProofVariantListQuery(baseOptions: Apollo.QueryHookOptions<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables> & ({ variables: ProgramProofVariantListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables>(ProgramProofVariantListDocument, options);
      }
export function useProgramProofVariantListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables>(ProgramProofVariantListDocument, options);
        }
export function useProgramProofVariantListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables>(ProgramProofVariantListDocument, options);
        }
export type ProgramProofVariantListQueryHookResult = ReturnType<typeof useProgramProofVariantListQuery>;
export type ProgramProofVariantListLazyQueryHookResult = ReturnType<typeof useProgramProofVariantListLazyQuery>;
export type ProgramProofVariantListSuspenseQueryHookResult = ReturnType<typeof useProgramProofVariantListSuspenseQuery>;
export type ProgramProofVariantListQueryResult = Apollo.QueryResult<ProgramProofVariantListQuery, ProgramProofVariantListQueryVariables>;
export const RecurringCampaignAudienceConfigDocument = gql`
    query RecurringCampaignAudienceConfig($campaignId: ID!) {
  recurringCampaign(id: $campaignId) {
    ...RecurringCampaignAudienceFields
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;

/**
 * __useRecurringCampaignAudienceConfigQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignAudienceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignAudienceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignAudienceConfigQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRecurringCampaignAudienceConfigQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables> & ({ variables: RecurringCampaignAudienceConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables>(RecurringCampaignAudienceConfigDocument, options);
      }
export function useRecurringCampaignAudienceConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables>(RecurringCampaignAudienceConfigDocument, options);
        }
export function useRecurringCampaignAudienceConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables>(RecurringCampaignAudienceConfigDocument, options);
        }
export type RecurringCampaignAudienceConfigQueryHookResult = ReturnType<typeof useRecurringCampaignAudienceConfigQuery>;
export type RecurringCampaignAudienceConfigLazyQueryHookResult = ReturnType<typeof useRecurringCampaignAudienceConfigLazyQuery>;
export type RecurringCampaignAudienceConfigSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignAudienceConfigSuspenseQuery>;
export type RecurringCampaignAudienceConfigQueryResult = Apollo.QueryResult<RecurringCampaignAudienceConfigQuery, RecurringCampaignAudienceConfigQueryVariables>;
export const RecurringCampaignAudienceIncludeDocument = gql`
    mutation RecurringCampaignAudienceInclude($id: ID!, $audienceId: ID!, $selectedSplits: [ID!]!, $unselectedSplits: [ID!]!) {
  recurringCampaignAudienceInclude(
    id: $id
    audienceId: $audienceId
    selectedSplits: $selectedSplits
    unselectedSplits: $unselectedSplits
  ) {
    ... on RecurringCampaignAudienceSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignAudienceIncludeMutationFn = Apollo.MutationFunction<RecurringCampaignAudienceIncludeMutation, RecurringCampaignAudienceIncludeMutationVariables>;

/**
 * __useRecurringCampaignAudienceIncludeMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignAudienceIncludeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignAudienceIncludeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignAudienceIncludeMutation, { data, loading, error }] = useRecurringCampaignAudienceIncludeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      audienceId: // value for 'audienceId'
 *      selectedSplits: // value for 'selectedSplits'
 *      unselectedSplits: // value for 'unselectedSplits'
 *   },
 * });
 */
export function useRecurringCampaignAudienceIncludeMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignAudienceIncludeMutation, RecurringCampaignAudienceIncludeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignAudienceIncludeMutation, RecurringCampaignAudienceIncludeMutationVariables>(RecurringCampaignAudienceIncludeDocument, options);
      }
export type RecurringCampaignAudienceIncludeMutationHookResult = ReturnType<typeof useRecurringCampaignAudienceIncludeMutation>;
export type RecurringCampaignAudienceIncludeMutationResult = Apollo.MutationResult<RecurringCampaignAudienceIncludeMutation>;
export type RecurringCampaignAudienceIncludeMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignAudienceIncludeMutation, RecurringCampaignAudienceIncludeMutationVariables>;
export const RecurringCampaignAudienceExcludeDocument = gql`
    mutation RecurringCampaignAudienceExclude($id: ID!, $audienceId: ID!) {
  recurringCampaignAudienceExclude(id: $id, audienceId: $audienceId) {
    ... on RecurringCampaignAudienceSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignAudienceExcludeMutationFn = Apollo.MutationFunction<RecurringCampaignAudienceExcludeMutation, RecurringCampaignAudienceExcludeMutationVariables>;

/**
 * __useRecurringCampaignAudienceExcludeMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignAudienceExcludeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignAudienceExcludeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignAudienceExcludeMutation, { data, loading, error }] = useRecurringCampaignAudienceExcludeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useRecurringCampaignAudienceExcludeMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignAudienceExcludeMutation, RecurringCampaignAudienceExcludeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignAudienceExcludeMutation, RecurringCampaignAudienceExcludeMutationVariables>(RecurringCampaignAudienceExcludeDocument, options);
      }
export type RecurringCampaignAudienceExcludeMutationHookResult = ReturnType<typeof useRecurringCampaignAudienceExcludeMutation>;
export type RecurringCampaignAudienceExcludeMutationResult = Apollo.MutationResult<RecurringCampaignAudienceExcludeMutation>;
export type RecurringCampaignAudienceExcludeMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignAudienceExcludeMutation, RecurringCampaignAudienceExcludeMutationVariables>;
export const RecurringCampaignAudienceRemoveDocument = gql`
    mutation RecurringCampaignAudienceRemove($id: ID!, $audienceId: ID!) {
  recurringCampaignAudienceRemove(id: $id, audienceId: $audienceId) {
    ... on RecurringCampaignAudienceSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignAudienceRemoveMutationFn = Apollo.MutationFunction<RecurringCampaignAudienceRemoveMutation, RecurringCampaignAudienceRemoveMutationVariables>;

/**
 * __useRecurringCampaignAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignAudienceRemoveMutation, { data, loading, error }] = useRecurringCampaignAudienceRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useRecurringCampaignAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignAudienceRemoveMutation, RecurringCampaignAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignAudienceRemoveMutation, RecurringCampaignAudienceRemoveMutationVariables>(RecurringCampaignAudienceRemoveDocument, options);
      }
export type RecurringCampaignAudienceRemoveMutationHookResult = ReturnType<typeof useRecurringCampaignAudienceRemoveMutation>;
export type RecurringCampaignAudienceRemoveMutationResult = Apollo.MutationResult<RecurringCampaignAudienceRemoveMutation>;
export type RecurringCampaignAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignAudienceRemoveMutation, RecurringCampaignAudienceRemoveMutationVariables>;
export const RecurringCampaignAudienceReorderDocument = gql`
    mutation RecurringCampaignAudienceReorder($id: ID!, $audienceIds: [ID!]!) {
  recurringCampaignAudienceReorder(id: $id, audienceIds: $audienceIds) {
    ... on RecurringCampaignAudienceSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignAudienceReorderMutationFn = Apollo.MutationFunction<RecurringCampaignAudienceReorderMutation, RecurringCampaignAudienceReorderMutationVariables>;

/**
 * __useRecurringCampaignAudienceReorderMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignAudienceReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignAudienceReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignAudienceReorderMutation, { data, loading, error }] = useRecurringCampaignAudienceReorderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      audienceIds: // value for 'audienceIds'
 *   },
 * });
 */
export function useRecurringCampaignAudienceReorderMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignAudienceReorderMutation, RecurringCampaignAudienceReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignAudienceReorderMutation, RecurringCampaignAudienceReorderMutationVariables>(RecurringCampaignAudienceReorderDocument, options);
      }
export type RecurringCampaignAudienceReorderMutationHookResult = ReturnType<typeof useRecurringCampaignAudienceReorderMutation>;
export type RecurringCampaignAudienceReorderMutationResult = Apollo.MutationResult<RecurringCampaignAudienceReorderMutation>;
export type RecurringCampaignAudienceReorderMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignAudienceReorderMutation, RecurringCampaignAudienceReorderMutationVariables>;
export const RecurringCampaignFieldAddDocument = gql`
    mutation RecurringCampaignFieldAdd($id: ID!, $fieldId: ID!, $override: ContactAudienceOverrideValueInput) {
  recurringCampaignFieldAdd(id: $id, fieldId: $fieldId, override: $override) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignFieldAddMutationFn = Apollo.MutationFunction<RecurringCampaignFieldAddMutation, RecurringCampaignFieldAddMutationVariables>;

/**
 * __useRecurringCampaignFieldAddMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignFieldAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignFieldAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignFieldAddMutation, { data, loading, error }] = useRecurringCampaignFieldAddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldId: // value for 'fieldId'
 *      override: // value for 'override'
 *   },
 * });
 */
export function useRecurringCampaignFieldAddMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignFieldAddMutation, RecurringCampaignFieldAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignFieldAddMutation, RecurringCampaignFieldAddMutationVariables>(RecurringCampaignFieldAddDocument, options);
      }
export type RecurringCampaignFieldAddMutationHookResult = ReturnType<typeof useRecurringCampaignFieldAddMutation>;
export type RecurringCampaignFieldAddMutationResult = Apollo.MutationResult<RecurringCampaignFieldAddMutation>;
export type RecurringCampaignFieldAddMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignFieldAddMutation, RecurringCampaignFieldAddMutationVariables>;
export const RecurringCampaignFieldUpdateDocument = gql`
    mutation RecurringCampaignFieldUpdate($id: ID!, $fieldId: ID!, $override: ContactAudienceOverrideValueInput, $newFieldId: ID) {
  recurringCampaignFieldUpdate(
    id: $id
    fieldId: $fieldId
    override: $override
    newFieldId: $newFieldId
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignFieldUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignFieldUpdateMutation, RecurringCampaignFieldUpdateMutationVariables>;

/**
 * __useRecurringCampaignFieldUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignFieldUpdateMutation, { data, loading, error }] = useRecurringCampaignFieldUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldId: // value for 'fieldId'
 *      override: // value for 'override'
 *      newFieldId: // value for 'newFieldId'
 *   },
 * });
 */
export function useRecurringCampaignFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignFieldUpdateMutation, RecurringCampaignFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignFieldUpdateMutation, RecurringCampaignFieldUpdateMutationVariables>(RecurringCampaignFieldUpdateDocument, options);
      }
export type RecurringCampaignFieldUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignFieldUpdateMutation>;
export type RecurringCampaignFieldUpdateMutationResult = Apollo.MutationResult<RecurringCampaignFieldUpdateMutation>;
export type RecurringCampaignFieldUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignFieldUpdateMutation, RecurringCampaignFieldUpdateMutationVariables>;
export const RecurringCampaignFieldRemoveDocument = gql`
    mutation RecurringCampaignFieldRemove($id: ID!, $fieldId: ID!) {
  recurringCampaignFieldRemove(id: $id, fieldId: $fieldId) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        ...RecurringCampaignAudienceFields
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
      }
    }
  }
}
    ${RecurringCampaignAudienceFieldsFragmentDoc}`;
export type RecurringCampaignFieldRemoveMutationFn = Apollo.MutationFunction<RecurringCampaignFieldRemoveMutation, RecurringCampaignFieldRemoveMutationVariables>;

/**
 * __useRecurringCampaignFieldRemoveMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignFieldRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignFieldRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignFieldRemoveMutation, { data, loading, error }] = useRecurringCampaignFieldRemoveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useRecurringCampaignFieldRemoveMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignFieldRemoveMutation, RecurringCampaignFieldRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignFieldRemoveMutation, RecurringCampaignFieldRemoveMutationVariables>(RecurringCampaignFieldRemoveDocument, options);
      }
export type RecurringCampaignFieldRemoveMutationHookResult = ReturnType<typeof useRecurringCampaignFieldRemoveMutation>;
export type RecurringCampaignFieldRemoveMutationResult = Apollo.MutationResult<RecurringCampaignFieldRemoveMutation>;
export type RecurringCampaignFieldRemoveMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignFieldRemoveMutation, RecurringCampaignFieldRemoveMutationVariables>;
export const RecurringCampaignDetailsDocument = gql`
    query RecurringCampaignDetails($campaignId: ID!) {
  recurringCampaign(id: $campaignId) {
    ...recurringCampaignFields
  }
}
    ${RecurringCampaignFieldsFragmentDoc}`;

/**
 * __useRecurringCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignDetailsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRecurringCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables> & ({ variables: RecurringCampaignDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables>(RecurringCampaignDetailsDocument, options);
      }
export function useRecurringCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables>(RecurringCampaignDetailsDocument, options);
        }
export function useRecurringCampaignDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables>(RecurringCampaignDetailsDocument, options);
        }
export type RecurringCampaignDetailsQueryHookResult = ReturnType<typeof useRecurringCampaignDetailsQuery>;
export type RecurringCampaignDetailsLazyQueryHookResult = ReturnType<typeof useRecurringCampaignDetailsLazyQuery>;
export type RecurringCampaignDetailsSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignDetailsSuspenseQuery>;
export type RecurringCampaignDetailsQueryResult = Apollo.QueryResult<RecurringCampaignDetailsQuery, RecurringCampaignDetailsQueryVariables>;
export const RecurringCampaignDeleteDocument = gql`
    mutation RecurringCampaignDelete($campaignId: ID!) {
  recurringCampaignDelete(id: $campaignId) {
    ... on RecurringCampaignDeleteSuccess {
      success
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type RecurringCampaignDeleteMutationFn = Apollo.MutationFunction<RecurringCampaignDeleteMutation, RecurringCampaignDeleteMutationVariables>;

/**
 * __useRecurringCampaignDeleteMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignDeleteMutation, { data, loading, error }] = useRecurringCampaignDeleteMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRecurringCampaignDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignDeleteMutation, RecurringCampaignDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignDeleteMutation, RecurringCampaignDeleteMutationVariables>(RecurringCampaignDeleteDocument, options);
      }
export type RecurringCampaignDeleteMutationHookResult = ReturnType<typeof useRecurringCampaignDeleteMutation>;
export type RecurringCampaignDeleteMutationResult = Apollo.MutationResult<RecurringCampaignDeleteMutation>;
export type RecurringCampaignDeleteMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignDeleteMutation, RecurringCampaignDeleteMutationVariables>;
export const RecurringCampaignDetailsUpdateDocument = gql`
    mutation RecurringCampaignDetailsUpdate($id: ID!, $title: String, $startDate: Date, $tagIds: [ID!]) {
  recurringCampaignDetailsUpdate(
    id: $id
    title: $title
    startDate: $startDate
    tagIds: $tagIds
  ) {
    ... on RecurringCampaignDetailsUpdateSuccess {
      success
      recurringCampaign {
        id
        title
        schedule {
          startDate
          sendTime
          rrule
          endDate
          timezone
        }
        availableSendTimes
        tags {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type RecurringCampaignDetailsUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignDetailsUpdateMutation, RecurringCampaignDetailsUpdateMutationVariables>;

/**
 * __useRecurringCampaignDetailsUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignDetailsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignDetailsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignDetailsUpdateMutation, { data, loading, error }] = useRecurringCampaignDetailsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      startDate: // value for 'startDate'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useRecurringCampaignDetailsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignDetailsUpdateMutation, RecurringCampaignDetailsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignDetailsUpdateMutation, RecurringCampaignDetailsUpdateMutationVariables>(RecurringCampaignDetailsUpdateDocument, options);
      }
export type RecurringCampaignDetailsUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignDetailsUpdateMutation>;
export type RecurringCampaignDetailsUpdateMutationResult = Apollo.MutationResult<RecurringCampaignDetailsUpdateMutation>;
export type RecurringCampaignDetailsUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignDetailsUpdateMutation, RecurringCampaignDetailsUpdateMutationVariables>;
export const RecurringCampaignDuplicateDocument = gql`
    mutation RecurringCampaignDuplicate($id: ID!, $startDate: Date!, $title: String!, $tagIds: [ID!]) {
  recurringCampaignDuplicate(
    id: $id
    startDate: $startDate
    title: $title
    tagIds: $tagIds
  ) {
    ... on RecurringCampaignDuplicateSuccess {
      success
      recurringCampaign {
        ...recurringCampaignFields
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${RecurringCampaignFieldsFragmentDoc}`;
export type RecurringCampaignDuplicateMutationFn = Apollo.MutationFunction<RecurringCampaignDuplicateMutation, RecurringCampaignDuplicateMutationVariables>;

/**
 * __useRecurringCampaignDuplicateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignDuplicateMutation, { data, loading, error }] = useRecurringCampaignDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      title: // value for 'title'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useRecurringCampaignDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignDuplicateMutation, RecurringCampaignDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignDuplicateMutation, RecurringCampaignDuplicateMutationVariables>(RecurringCampaignDuplicateDocument, options);
      }
export type RecurringCampaignDuplicateMutationHookResult = ReturnType<typeof useRecurringCampaignDuplicateMutation>;
export type RecurringCampaignDuplicateMutationResult = Apollo.MutationResult<RecurringCampaignDuplicateMutation>;
export type RecurringCampaignDuplicateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignDuplicateMutation, RecurringCampaignDuplicateMutationVariables>;
export const RecurringCampaignStateTransitionDocument = gql`
    mutation RecurringCampaignStateTransition($id: ID!, $state: RecurringCampaignStatus!) {
  recurringCampaignStateTransition(id: $id, state: $state) {
    ... on RecurringCampaignStateTransitionSuccess {
      success
      recurringCampaign {
        id
        status
        stage
        stageGroup
        lastStatus {
          status
          label
          timestamp
          user {
            fullName
          }
        }
        stateInfo {
          state
          transitions {
            state
            label
            permission {
              ... on RecurringCampaignTransitionPermissionAllowed {
                allowed
              }
              ... on RecurringCampaignTransitionPermissionDenied {
                allowed
                message
                code
              }
            }
          }
          actions {
            id
            label
          }
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        code
        field
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignStateTransitionMutationFn = Apollo.MutationFunction<RecurringCampaignStateTransitionMutation, RecurringCampaignStateTransitionMutationVariables>;

/**
 * __useRecurringCampaignStateTransitionMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignStateTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignStateTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignStateTransitionMutation, { data, loading, error }] = useRecurringCampaignStateTransitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useRecurringCampaignStateTransitionMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignStateTransitionMutation, RecurringCampaignStateTransitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignStateTransitionMutation, RecurringCampaignStateTransitionMutationVariables>(RecurringCampaignStateTransitionDocument, options);
      }
export type RecurringCampaignStateTransitionMutationHookResult = ReturnType<typeof useRecurringCampaignStateTransitionMutation>;
export type RecurringCampaignStateTransitionMutationResult = Apollo.MutationResult<RecurringCampaignStateTransitionMutation>;
export type RecurringCampaignStateTransitionMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignStateTransitionMutation, RecurringCampaignStateTransitionMutationVariables>;
export const RecurringCampaignMessageDocument = gql`
    query RecurringCampaignMessage($id: ID!, $useDraft: Boolean) {
  recurringCampaignMessage(id: $id, useDraft: $useDraft) {
    id
    layoutDocument
    inboxPreview {
      id
      subjectLineDynamicBlockId
      subjectLinePrefix
      subjectLineSuffix
      preheaderDynamicBlockId
    }
  }
}
    `;

/**
 * __useRecurringCampaignMessageQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useDraft: // value for 'useDraft'
 *   },
 * });
 */
export function useRecurringCampaignMessageQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables> & ({ variables: RecurringCampaignMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables>(RecurringCampaignMessageDocument, options);
      }
export function useRecurringCampaignMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables>(RecurringCampaignMessageDocument, options);
        }
export function useRecurringCampaignMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables>(RecurringCampaignMessageDocument, options);
        }
export type RecurringCampaignMessageQueryHookResult = ReturnType<typeof useRecurringCampaignMessageQuery>;
export type RecurringCampaignMessageLazyQueryHookResult = ReturnType<typeof useRecurringCampaignMessageLazyQuery>;
export type RecurringCampaignMessageSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignMessageSuspenseQuery>;
export type RecurringCampaignMessageQueryResult = Apollo.QueryResult<RecurringCampaignMessageQuery, RecurringCampaignMessageQueryVariables>;
export const RecurringCampaignMessageAddDynamicBlockDocument = gql`
    mutation RecurringCampaignMessageAddDynamicBlock($id: ID!) {
  recurringCampaignMessageAddDynamicBlock(id: $id) {
    __typename
    ... on RecurringCampaignMessageAddDynamicBlockSuccess {
      success
      slotUri
      blockId
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageAddDynamicBlockMutationFn = Apollo.MutationFunction<RecurringCampaignMessageAddDynamicBlockMutation, RecurringCampaignMessageAddDynamicBlockMutationVariables>;

/**
 * __useRecurringCampaignMessageAddDynamicBlockMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageAddDynamicBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageAddDynamicBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageAddDynamicBlockMutation, { data, loading, error }] = useRecurringCampaignMessageAddDynamicBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecurringCampaignMessageAddDynamicBlockMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageAddDynamicBlockMutation, RecurringCampaignMessageAddDynamicBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageAddDynamicBlockMutation, RecurringCampaignMessageAddDynamicBlockMutationVariables>(RecurringCampaignMessageAddDynamicBlockDocument, options);
      }
export type RecurringCampaignMessageAddDynamicBlockMutationHookResult = ReturnType<typeof useRecurringCampaignMessageAddDynamicBlockMutation>;
export type RecurringCampaignMessageAddDynamicBlockMutationResult = Apollo.MutationResult<RecurringCampaignMessageAddDynamicBlockMutation>;
export type RecurringCampaignMessageAddDynamicBlockMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageAddDynamicBlockMutation, RecurringCampaignMessageAddDynamicBlockMutationVariables>;
export const RecurringCampaignMessageLayoutUpdateDocument = gql`
    mutation RecurringCampaignMessageLayoutUpdate($id: ID!, $document: RecurringCampaignMessageLayoutDocument!) {
  recurringCampaignMessageLayoutUpdate(id: $id, document: $document) {
    __typename
    ... on RecurringCampaignMessageLayoutUpdateSuccess {
      success
      updatedAt
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageLayoutUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignMessageLayoutUpdateMutation, RecurringCampaignMessageLayoutUpdateMutationVariables>;

/**
 * __useRecurringCampaignMessageLayoutUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageLayoutUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageLayoutUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageLayoutUpdateMutation, { data, loading, error }] = useRecurringCampaignMessageLayoutUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useRecurringCampaignMessageLayoutUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageLayoutUpdateMutation, RecurringCampaignMessageLayoutUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageLayoutUpdateMutation, RecurringCampaignMessageLayoutUpdateMutationVariables>(RecurringCampaignMessageLayoutUpdateDocument, options);
      }
export type RecurringCampaignMessageLayoutUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignMessageLayoutUpdateMutation>;
export type RecurringCampaignMessageLayoutUpdateMutationResult = Apollo.MutationResult<RecurringCampaignMessageLayoutUpdateMutation>;
export type RecurringCampaignMessageLayoutUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageLayoutUpdateMutation, RecurringCampaignMessageLayoutUpdateMutationVariables>;
export const RecurringCampaignMessageSaveDocument = gql`
    mutation RecurringCampaignMessageSave($id: ID!, $document: RecurringCampaignMessageLayoutDocument!, $inboxPreview: RecurringCampaignMessageInboxPreviewUpdateInput) {
  recurringCampaignMessageSave(
    id: $id
    document: $document
    inboxPreview: $inboxPreview
  ) {
    __typename
    ... on RecurringCampaignMessageSaveSuccess {
      success
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageSaveMutationFn = Apollo.MutationFunction<RecurringCampaignMessageSaveMutation, RecurringCampaignMessageSaveMutationVariables>;

/**
 * __useRecurringCampaignMessageSaveMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageSaveMutation, { data, loading, error }] = useRecurringCampaignMessageSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      document: // value for 'document'
 *      inboxPreview: // value for 'inboxPreview'
 *   },
 * });
 */
export function useRecurringCampaignMessageSaveMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageSaveMutation, RecurringCampaignMessageSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageSaveMutation, RecurringCampaignMessageSaveMutationVariables>(RecurringCampaignMessageSaveDocument, options);
      }
export type RecurringCampaignMessageSaveMutationHookResult = ReturnType<typeof useRecurringCampaignMessageSaveMutation>;
export type RecurringCampaignMessageSaveMutationResult = Apollo.MutationResult<RecurringCampaignMessageSaveMutation>;
export type RecurringCampaignMessageSaveMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageSaveMutation, RecurringCampaignMessageSaveMutationVariables>;
export const RecurringCampaignMessageDiscardDocument = gql`
    mutation RecurringCampaignMessageDiscard($id: ID!) {
  recurringCampaignMessageDiscard(id: $id) {
    __typename
    ... on RecurringCampaignMessageDiscardSuccess {
      success
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageDiscardMutationFn = Apollo.MutationFunction<RecurringCampaignMessageDiscardMutation, RecurringCampaignMessageDiscardMutationVariables>;

/**
 * __useRecurringCampaignMessageDiscardMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageDiscardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageDiscardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageDiscardMutation, { data, loading, error }] = useRecurringCampaignMessageDiscardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecurringCampaignMessageDiscardMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageDiscardMutation, RecurringCampaignMessageDiscardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageDiscardMutation, RecurringCampaignMessageDiscardMutationVariables>(RecurringCampaignMessageDiscardDocument, options);
      }
export type RecurringCampaignMessageDiscardMutationHookResult = ReturnType<typeof useRecurringCampaignMessageDiscardMutation>;
export type RecurringCampaignMessageDiscardMutationResult = Apollo.MutationResult<RecurringCampaignMessageDiscardMutation>;
export type RecurringCampaignMessageDiscardMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageDiscardMutation, RecurringCampaignMessageDiscardMutationVariables>;
export const RecurringCampaignMessageDynamicBlockInboxContentDocument = gql`
    query RecurringCampaignMessageDynamicBlockInboxContent($id: ID!, $blockIds: [ID!]) {
  recurringCampaignMessage(id: $id) {
    id
    dynamicBlocks(ids: $blockIds) {
      id
      experience {
        id
        selectedCreative {
          id
          subjectLines {
            id
            content
          }
          preheaderText2 {
            __typename
            ... on InboxTextSetting {
              enabled
              content
            }
          }
          previewText2 {
            __typename
            ... on InboxTextSetting {
              enabled
              content
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRecurringCampaignMessageDynamicBlockInboxContentQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignMessageDynamicBlockInboxContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageDynamicBlockInboxContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignMessageDynamicBlockInboxContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      blockIds: // value for 'blockIds'
 *   },
 * });
 */
export function useRecurringCampaignMessageDynamicBlockInboxContentQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables> & ({ variables: RecurringCampaignMessageDynamicBlockInboxContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables>(RecurringCampaignMessageDynamicBlockInboxContentDocument, options);
      }
export function useRecurringCampaignMessageDynamicBlockInboxContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables>(RecurringCampaignMessageDynamicBlockInboxContentDocument, options);
        }
export function useRecurringCampaignMessageDynamicBlockInboxContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables>(RecurringCampaignMessageDynamicBlockInboxContentDocument, options);
        }
export type RecurringCampaignMessageDynamicBlockInboxContentQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockInboxContentQuery>;
export type RecurringCampaignMessageDynamicBlockInboxContentLazyQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockInboxContentLazyQuery>;
export type RecurringCampaignMessageDynamicBlockInboxContentSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockInboxContentSuspenseQuery>;
export type RecurringCampaignMessageDynamicBlockInboxContentQueryResult = Apollo.QueryResult<RecurringCampaignMessageDynamicBlockInboxContentQuery, RecurringCampaignMessageDynamicBlockInboxContentQueryVariables>;
export const RecurringCampaignMessageInboxPreviewUpdateDocument = gql`
    mutation RecurringCampaignMessageInboxPreviewUpdate($id: ID!, $input: RecurringCampaignMessageInboxPreviewUpdateInput!) {
  recurringCampaignMessageInboxPreviewUpdate(id: $id, input: $input) {
    __typename
    ... on RecurringCampaignMessageInboxPreviewUpdateSuccess {
      success
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageInboxPreviewUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignMessageInboxPreviewUpdateMutation, RecurringCampaignMessageInboxPreviewUpdateMutationVariables>;

/**
 * __useRecurringCampaignMessageInboxPreviewUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageInboxPreviewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageInboxPreviewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageInboxPreviewUpdateMutation, { data, loading, error }] = useRecurringCampaignMessageInboxPreviewUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringCampaignMessageInboxPreviewUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageInboxPreviewUpdateMutation, RecurringCampaignMessageInboxPreviewUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageInboxPreviewUpdateMutation, RecurringCampaignMessageInboxPreviewUpdateMutationVariables>(RecurringCampaignMessageInboxPreviewUpdateDocument, options);
      }
export type RecurringCampaignMessageInboxPreviewUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignMessageInboxPreviewUpdateMutation>;
export type RecurringCampaignMessageInboxPreviewUpdateMutationResult = Apollo.MutationResult<RecurringCampaignMessageInboxPreviewUpdateMutation>;
export type RecurringCampaignMessageInboxPreviewUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageInboxPreviewUpdateMutation, RecurringCampaignMessageInboxPreviewUpdateMutationVariables>;
export const RecurringCampaignMessageDynamicBlockCreativeContentDocument = gql`
    query RecurringCampaignMessageDynamicBlockCreativeContent($id: ID!, $blockIds: [ID!]) {
  recurringCampaignMessage(id: $id) {
    id
    dynamicBlocks(ids: $blockIds) {
      id
      experience {
        id
        creativeLayout {
          published(format: V1)
        }
      }
    }
  }
}
    `;

/**
 * __useRecurringCampaignMessageDynamicBlockCreativeContentQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignMessageDynamicBlockCreativeContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageDynamicBlockCreativeContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignMessageDynamicBlockCreativeContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      blockIds: // value for 'blockIds'
 *   },
 * });
 */
export function useRecurringCampaignMessageDynamicBlockCreativeContentQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables> & ({ variables: RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables>(RecurringCampaignMessageDynamicBlockCreativeContentDocument, options);
      }
export function useRecurringCampaignMessageDynamicBlockCreativeContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables>(RecurringCampaignMessageDynamicBlockCreativeContentDocument, options);
        }
export function useRecurringCampaignMessageDynamicBlockCreativeContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables>(RecurringCampaignMessageDynamicBlockCreativeContentDocument, options);
        }
export type RecurringCampaignMessageDynamicBlockCreativeContentQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockCreativeContentQuery>;
export type RecurringCampaignMessageDynamicBlockCreativeContentLazyQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockCreativeContentLazyQuery>;
export type RecurringCampaignMessageDynamicBlockCreativeContentSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockCreativeContentSuspenseQuery>;
export type RecurringCampaignMessageDynamicBlockCreativeContentQueryResult = Apollo.QueryResult<RecurringCampaignMessageDynamicBlockCreativeContentQuery, RecurringCampaignMessageDynamicBlockCreativeContentQueryVariables>;
export const RecurringCampaignMessageDynamicBlockDisclaimerContentDocument = gql`
    query RecurringCampaignMessageDynamicBlockDisclaimerContent($id: ID!, $blockIds: [ID!]) {
  recurringCampaignMessage(id: $id) {
    id
    dynamicBlocks(ids: $blockIds) {
      id
      experience {
        id
        selectedCreative {
          id
          disclaimer
        }
      }
    }
  }
}
    `;

/**
 * __useRecurringCampaignMessageDynamicBlockDisclaimerContentQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignMessageDynamicBlockDisclaimerContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageDynamicBlockDisclaimerContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignMessageDynamicBlockDisclaimerContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      blockIds: // value for 'blockIds'
 *   },
 * });
 */
export function useRecurringCampaignMessageDynamicBlockDisclaimerContentQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables> & ({ variables: RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables>(RecurringCampaignMessageDynamicBlockDisclaimerContentDocument, options);
      }
export function useRecurringCampaignMessageDynamicBlockDisclaimerContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables>(RecurringCampaignMessageDynamicBlockDisclaimerContentDocument, options);
        }
export function useRecurringCampaignMessageDynamicBlockDisclaimerContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables>(RecurringCampaignMessageDynamicBlockDisclaimerContentDocument, options);
        }
export type RecurringCampaignMessageDynamicBlockDisclaimerContentQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockDisclaimerContentQuery>;
export type RecurringCampaignMessageDynamicBlockDisclaimerContentLazyQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockDisclaimerContentLazyQuery>;
export type RecurringCampaignMessageDynamicBlockDisclaimerContentSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockDisclaimerContentSuspenseQuery>;
export type RecurringCampaignMessageDynamicBlockDisclaimerContentQueryResult = Apollo.QueryResult<RecurringCampaignMessageDynamicBlockDisclaimerContentQuery, RecurringCampaignMessageDynamicBlockDisclaimerContentQueryVariables>;
export const RecurringCampaignMessageAvailableCreativesDocument = gql`
    query RecurringCampaignMessageAvailableCreatives($id: ID!, $filter: RecurringCampaignAvailableCreativesFilter, $first: Int, $after: String) {
  recurringCampaignMessageAvailableCreatives(
    id: $id
    filter: $filter
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        title
        status
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useRecurringCampaignMessageAvailableCreativesQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignMessageAvailableCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageAvailableCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignMessageAvailableCreativesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRecurringCampaignMessageAvailableCreativesQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables> & ({ variables: RecurringCampaignMessageAvailableCreativesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables>(RecurringCampaignMessageAvailableCreativesDocument, options);
      }
export function useRecurringCampaignMessageAvailableCreativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables>(RecurringCampaignMessageAvailableCreativesDocument, options);
        }
export function useRecurringCampaignMessageAvailableCreativesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables>(RecurringCampaignMessageAvailableCreativesDocument, options);
        }
export type RecurringCampaignMessageAvailableCreativesQueryHookResult = ReturnType<typeof useRecurringCampaignMessageAvailableCreativesQuery>;
export type RecurringCampaignMessageAvailableCreativesLazyQueryHookResult = ReturnType<typeof useRecurringCampaignMessageAvailableCreativesLazyQuery>;
export type RecurringCampaignMessageAvailableCreativesSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignMessageAvailableCreativesSuspenseQuery>;
export type RecurringCampaignMessageAvailableCreativesQueryResult = Apollo.QueryResult<RecurringCampaignMessageAvailableCreativesQuery, RecurringCampaignMessageAvailableCreativesQueryVariables>;
export const RecurringCampaignMessageDynamicBlockExperienceCreateDocument = gql`
    mutation RecurringCampaignMessageDynamicBlockExperienceCreate($id: ID!, $blockId: ID!) {
  recurringCampaignMessageDynamicBlockExperienceCreate(id: $id, blockId: $blockId) {
    __typename
    ... on RecurringCampaignMessageDynamicBlockExperienceCreateSuccess {
      success
      id
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageDynamicBlockExperienceCreateMutationFn = Apollo.MutationFunction<RecurringCampaignMessageDynamicBlockExperienceCreateMutation, RecurringCampaignMessageDynamicBlockExperienceCreateMutationVariables>;

/**
 * __useRecurringCampaignMessageDynamicBlockExperienceCreateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageDynamicBlockExperienceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageDynamicBlockExperienceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageDynamicBlockExperienceCreateMutation, { data, loading, error }] = useRecurringCampaignMessageDynamicBlockExperienceCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useRecurringCampaignMessageDynamicBlockExperienceCreateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageDynamicBlockExperienceCreateMutation, RecurringCampaignMessageDynamicBlockExperienceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageDynamicBlockExperienceCreateMutation, RecurringCampaignMessageDynamicBlockExperienceCreateMutationVariables>(RecurringCampaignMessageDynamicBlockExperienceCreateDocument, options);
      }
export type RecurringCampaignMessageDynamicBlockExperienceCreateMutationHookResult = ReturnType<typeof useRecurringCampaignMessageDynamicBlockExperienceCreateMutation>;
export type RecurringCampaignMessageDynamicBlockExperienceCreateMutationResult = Apollo.MutationResult<RecurringCampaignMessageDynamicBlockExperienceCreateMutation>;
export type RecurringCampaignMessageDynamicBlockExperienceCreateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageDynamicBlockExperienceCreateMutation, RecurringCampaignMessageDynamicBlockExperienceCreateMutationVariables>;
export const RecurringCampaignMessageExperienceSelectCreativeDocument = gql`
    mutation RecurringCampaignMessageExperienceSelectCreative($id: ID!, $experienceId: ID!, $creativeId: ID!) {
  recurringCampaignMessageExperienceSelectCreative(
    id: $id
    experienceId: $experienceId
    creativeId: $creativeId
  ) {
    __typename
    ... on RecurringCampaignMessageExperienceSelectCreativeSuccess {
      success
      id
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type RecurringCampaignMessageExperienceSelectCreativeMutationFn = Apollo.MutationFunction<RecurringCampaignMessageExperienceSelectCreativeMutation, RecurringCampaignMessageExperienceSelectCreativeMutationVariables>;

/**
 * __useRecurringCampaignMessageExperienceSelectCreativeMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignMessageExperienceSelectCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignMessageExperienceSelectCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignMessageExperienceSelectCreativeMutation, { data, loading, error }] = useRecurringCampaignMessageExperienceSelectCreativeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experienceId: // value for 'experienceId'
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useRecurringCampaignMessageExperienceSelectCreativeMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignMessageExperienceSelectCreativeMutation, RecurringCampaignMessageExperienceSelectCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignMessageExperienceSelectCreativeMutation, RecurringCampaignMessageExperienceSelectCreativeMutationVariables>(RecurringCampaignMessageExperienceSelectCreativeDocument, options);
      }
export type RecurringCampaignMessageExperienceSelectCreativeMutationHookResult = ReturnType<typeof useRecurringCampaignMessageExperienceSelectCreativeMutation>;
export type RecurringCampaignMessageExperienceSelectCreativeMutationResult = Apollo.MutationResult<RecurringCampaignMessageExperienceSelectCreativeMutation>;
export type RecurringCampaignMessageExperienceSelectCreativeMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignMessageExperienceSelectCreativeMutation, RecurringCampaignMessageExperienceSelectCreativeMutationVariables>;
export const RecurringCampaignScheduleDocument = gql`
    query RecurringCampaignSchedule($campaignId: ID!) {
  recurringCampaign(id: $campaignId) {
    id
    availableSendTimes
    schedule {
      startDate
      sendTime
      rrule
      endDate
      timezone
    }
  }
}
    `;

/**
 * __useRecurringCampaignScheduleQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignScheduleQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRecurringCampaignScheduleQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables> & ({ variables: RecurringCampaignScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables>(RecurringCampaignScheduleDocument, options);
      }
export function useRecurringCampaignScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables>(RecurringCampaignScheduleDocument, options);
        }
export function useRecurringCampaignScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables>(RecurringCampaignScheduleDocument, options);
        }
export type RecurringCampaignScheduleQueryHookResult = ReturnType<typeof useRecurringCampaignScheduleQuery>;
export type RecurringCampaignScheduleLazyQueryHookResult = ReturnType<typeof useRecurringCampaignScheduleLazyQuery>;
export type RecurringCampaignScheduleSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignScheduleSuspenseQuery>;
export type RecurringCampaignScheduleQueryResult = Apollo.QueryResult<RecurringCampaignScheduleQuery, RecurringCampaignScheduleQueryVariables>;
export const RecurringCampaignScheduleUpdateDocument = gql`
    mutation RecurringCampaignScheduleUpdate($id: ID!, $input: RecurringCampaignScheduleUpdateInput!) {
  recurringCampaignScheduleUpdate(id: $id, input: $input) {
    ... on RecurringCampaignScheduleUpdateSuccess {
      success
      recurringCampaign {
        id
        schedule {
          startDate
          sendTime
          rrule
          endDate
          timezone
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type RecurringCampaignScheduleUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignScheduleUpdateMutation, RecurringCampaignScheduleUpdateMutationVariables>;

/**
 * __useRecurringCampaignScheduleUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignScheduleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignScheduleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignScheduleUpdateMutation, { data, loading, error }] = useRecurringCampaignScheduleUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringCampaignScheduleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignScheduleUpdateMutation, RecurringCampaignScheduleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignScheduleUpdateMutation, RecurringCampaignScheduleUpdateMutationVariables>(RecurringCampaignScheduleUpdateDocument, options);
      }
export type RecurringCampaignScheduleUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignScheduleUpdateMutation>;
export type RecurringCampaignScheduleUpdateMutationResult = Apollo.MutationResult<RecurringCampaignScheduleUpdateMutation>;
export type RecurringCampaignScheduleUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignScheduleUpdateMutation, RecurringCampaignScheduleUpdateMutationVariables>;
export const RecurringCampaignTextAttributeUpdateDocument = gql`
    mutation RecurringCampaignTextAttributeUpdate($attributeId: ID!, $id: ID!, $value: String) {
  recurringCampaignTextAttributeUpdate(
    attributeId: $attributeId
    id: $id
    value: $value
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type RecurringCampaignTextAttributeUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignTextAttributeUpdateMutation, RecurringCampaignTextAttributeUpdateMutationVariables>;

/**
 * __useRecurringCampaignTextAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignTextAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignTextAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignTextAttributeUpdateMutation, { data, loading, error }] = useRecurringCampaignTextAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useRecurringCampaignTextAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignTextAttributeUpdateMutation, RecurringCampaignTextAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignTextAttributeUpdateMutation, RecurringCampaignTextAttributeUpdateMutationVariables>(RecurringCampaignTextAttributeUpdateDocument, options);
      }
export type RecurringCampaignTextAttributeUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignTextAttributeUpdateMutation>;
export type RecurringCampaignTextAttributeUpdateMutationResult = Apollo.MutationResult<RecurringCampaignTextAttributeUpdateMutation>;
export type RecurringCampaignTextAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignTextAttributeUpdateMutation, RecurringCampaignTextAttributeUpdateMutationVariables>;
export const RecurringCampaignDateAttributeUpdateDocument = gql`
    mutation RecurringCampaignDateAttributeUpdate($attributeId: ID!, $id: ID!, $value: Date) {
  recurringCampaignDateAttributeUpdate(
    attributeId: $attributeId
    id: $id
    value: $value
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type RecurringCampaignDateAttributeUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignDateAttributeUpdateMutation, RecurringCampaignDateAttributeUpdateMutationVariables>;

/**
 * __useRecurringCampaignDateAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignDateAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignDateAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignDateAttributeUpdateMutation, { data, loading, error }] = useRecurringCampaignDateAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useRecurringCampaignDateAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignDateAttributeUpdateMutation, RecurringCampaignDateAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignDateAttributeUpdateMutation, RecurringCampaignDateAttributeUpdateMutationVariables>(RecurringCampaignDateAttributeUpdateDocument, options);
      }
export type RecurringCampaignDateAttributeUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignDateAttributeUpdateMutation>;
export type RecurringCampaignDateAttributeUpdateMutationResult = Apollo.MutationResult<RecurringCampaignDateAttributeUpdateMutation>;
export type RecurringCampaignDateAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignDateAttributeUpdateMutation, RecurringCampaignDateAttributeUpdateMutationVariables>;
export const RecurringCampaignSelectAttributeUpdateDocument = gql`
    mutation RecurringCampaignSelectAttributeUpdate($attributeId: ID!, $id: ID!, $optionId: ID) {
  recurringCampaignSelectAttributeUpdate(
    attributeId: $attributeId
    id: $id
    optionId: $optionId
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type RecurringCampaignSelectAttributeUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignSelectAttributeUpdateMutation, RecurringCampaignSelectAttributeUpdateMutationVariables>;

/**
 * __useRecurringCampaignSelectAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignSelectAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignSelectAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignSelectAttributeUpdateMutation, { data, loading, error }] = useRecurringCampaignSelectAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useRecurringCampaignSelectAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignSelectAttributeUpdateMutation, RecurringCampaignSelectAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignSelectAttributeUpdateMutation, RecurringCampaignSelectAttributeUpdateMutationVariables>(RecurringCampaignSelectAttributeUpdateDocument, options);
      }
export type RecurringCampaignSelectAttributeUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignSelectAttributeUpdateMutation>;
export type RecurringCampaignSelectAttributeUpdateMutationResult = Apollo.MutationResult<RecurringCampaignSelectAttributeUpdateMutation>;
export type RecurringCampaignSelectAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignSelectAttributeUpdateMutation, RecurringCampaignSelectAttributeUpdateMutationVariables>;
export const RecurringCampaignListAttributeUpdateDocument = gql`
    mutation RecurringCampaignListAttributeUpdate($attributeId: ID!, $id: ID!, $values: [String!]!) {
  recurringCampaignListAttributeUpdate(
    attributeId: $attributeId
    id: $id
    values: $values
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type RecurringCampaignListAttributeUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignListAttributeUpdateMutation, RecurringCampaignListAttributeUpdateMutationVariables>;

/**
 * __useRecurringCampaignListAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignListAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignListAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignListAttributeUpdateMutation, { data, loading, error }] = useRecurringCampaignListAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useRecurringCampaignListAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignListAttributeUpdateMutation, RecurringCampaignListAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignListAttributeUpdateMutation, RecurringCampaignListAttributeUpdateMutationVariables>(RecurringCampaignListAttributeUpdateDocument, options);
      }
export type RecurringCampaignListAttributeUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignListAttributeUpdateMutation>;
export type RecurringCampaignListAttributeUpdateMutationResult = Apollo.MutationResult<RecurringCampaignListAttributeUpdateMutation>;
export type RecurringCampaignListAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignListAttributeUpdateMutation, RecurringCampaignListAttributeUpdateMutationVariables>;
export const RecurringSettingsCustomFieldAddDocument = gql`
    mutation RecurringSettingsCustomFieldAdd($campaignId: ID!, $customFieldId: ID!) {
  recurringCampaignCustomFieldAdd(id: $campaignId, customFieldId: $customFieldId) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        customFields {
          ...recurringCustomFieldsFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${RecurringCustomFieldsFragmentFragmentDoc}`;
export type RecurringSettingsCustomFieldAddMutationFn = Apollo.MutationFunction<RecurringSettingsCustomFieldAddMutation, RecurringSettingsCustomFieldAddMutationVariables>;

/**
 * __useRecurringSettingsCustomFieldAddMutation__
 *
 * To run a mutation, you first call `useRecurringSettingsCustomFieldAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSettingsCustomFieldAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSettingsCustomFieldAddMutation, { data, loading, error }] = useRecurringSettingsCustomFieldAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *   },
 * });
 */
export function useRecurringSettingsCustomFieldAddMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSettingsCustomFieldAddMutation, RecurringSettingsCustomFieldAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSettingsCustomFieldAddMutation, RecurringSettingsCustomFieldAddMutationVariables>(RecurringSettingsCustomFieldAddDocument, options);
      }
export type RecurringSettingsCustomFieldAddMutationHookResult = ReturnType<typeof useRecurringSettingsCustomFieldAddMutation>;
export type RecurringSettingsCustomFieldAddMutationResult = Apollo.MutationResult<RecurringSettingsCustomFieldAddMutation>;
export type RecurringSettingsCustomFieldAddMutationOptions = Apollo.BaseMutationOptions<RecurringSettingsCustomFieldAddMutation, RecurringSettingsCustomFieldAddMutationVariables>;
export const RecurringSettingsCustomFieldUpdateDocument = gql`
    mutation RecurringSettingsCustomFieldUpdate($campaignId: ID!, $customFieldId: ID!, $value: String) {
  recurringCampaignCustomFieldUpdate(
    id: $campaignId
    customFieldId: $customFieldId
    value: $value
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        customFields {
          ...recurringCustomFieldsFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${RecurringCustomFieldsFragmentFragmentDoc}`;
export type RecurringSettingsCustomFieldUpdateMutationFn = Apollo.MutationFunction<RecurringSettingsCustomFieldUpdateMutation, RecurringSettingsCustomFieldUpdateMutationVariables>;

/**
 * __useRecurringSettingsCustomFieldUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringSettingsCustomFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSettingsCustomFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSettingsCustomFieldUpdateMutation, { data, loading, error }] = useRecurringSettingsCustomFieldUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useRecurringSettingsCustomFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSettingsCustomFieldUpdateMutation, RecurringSettingsCustomFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSettingsCustomFieldUpdateMutation, RecurringSettingsCustomFieldUpdateMutationVariables>(RecurringSettingsCustomFieldUpdateDocument, options);
      }
export type RecurringSettingsCustomFieldUpdateMutationHookResult = ReturnType<typeof useRecurringSettingsCustomFieldUpdateMutation>;
export type RecurringSettingsCustomFieldUpdateMutationResult = Apollo.MutationResult<RecurringSettingsCustomFieldUpdateMutation>;
export type RecurringSettingsCustomFieldUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringSettingsCustomFieldUpdateMutation, RecurringSettingsCustomFieldUpdateMutationVariables>;
export const RecurringSettingsCustomFieldRemoveDocument = gql`
    mutation RecurringSettingsCustomFieldRemove($campaignId: ID!, $customFieldId: ID!) {
  recurringCampaignCustomFieldRemove(
    id: $campaignId
    customFieldId: $customFieldId
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        customFields {
          ...recurringCustomFieldsFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${RecurringCustomFieldsFragmentFragmentDoc}`;
export type RecurringSettingsCustomFieldRemoveMutationFn = Apollo.MutationFunction<RecurringSettingsCustomFieldRemoveMutation, RecurringSettingsCustomFieldRemoveMutationVariables>;

/**
 * __useRecurringSettingsCustomFieldRemoveMutation__
 *
 * To run a mutation, you first call `useRecurringSettingsCustomFieldRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringSettingsCustomFieldRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringSettingsCustomFieldRemoveMutation, { data, loading, error }] = useRecurringSettingsCustomFieldRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *   },
 * });
 */
export function useRecurringSettingsCustomFieldRemoveMutation(baseOptions?: Apollo.MutationHookOptions<RecurringSettingsCustomFieldRemoveMutation, RecurringSettingsCustomFieldRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringSettingsCustomFieldRemoveMutation, RecurringSettingsCustomFieldRemoveMutationVariables>(RecurringSettingsCustomFieldRemoveDocument, options);
      }
export type RecurringSettingsCustomFieldRemoveMutationHookResult = ReturnType<typeof useRecurringSettingsCustomFieldRemoveMutation>;
export type RecurringSettingsCustomFieldRemoveMutationResult = Apollo.MutationResult<RecurringSettingsCustomFieldRemoveMutation>;
export type RecurringSettingsCustomFieldRemoveMutationOptions = Apollo.BaseMutationOptions<RecurringSettingsCustomFieldRemoveMutation, RecurringSettingsCustomFieldRemoveMutationVariables>;
export const RecurringCampaignEmailServiceProviderUpdateDocument = gql`
    mutation RecurringCampaignEmailServiceProviderUpdate($id: ID!, $emailServiceProviderId: ID!) {
  recurringCampaignEmailServiceProviderUpdate(
    id: $id
    emailServiceProviderId: $emailServiceProviderId
  ) {
    ... on RecurringCampaignEspConfigUpdateSuccess {
      success
      recurringCampaign {
        id
        emailServiceProvider {
          __typename
          ... on AcousticCampaign {
            id
          }
          ... on AdobeCampaign {
            id
          }
          ... on AdobeJourneyOptimizer {
            id
          }
          ... on AmazonSES {
            id
          }
          ... on Braze {
            id
          }
          ... on Cordial {
            id
          }
          ... on OracleResponsys {
            id
          }
          ... on SalesForceMarketingCloud {
            id
          }
          ... on Zeta {
            id
          }
        }
        espConfig {
          ... on CampaignSalesforceMarketingCloudConfig {
            ...espSalesForceFragment
          }
          ... on CampaignAcousticCampaignConfig {
            ...espAcousticFragment
          }
          ... on CampaignOracleResponsysConfig {
            ...espOracleFragment
          }
          ... on CampaignCordialConfig {
            ...espCordialFragment
          }
          ... on CampaignAdobeCampaignConfig {
            ...espAdobeCampaignFragment
          }
          ... on AdobeJourneyOptimizerConfig {
            ...espAdobeJourneyOptimizerFragment
          }
          ... on BlackholeConfig {
            ...espBlackholeFragment
          }
          ... on CampaignEpsilonConfig {
            ...espEpsilonFragment
          }
          ... on AmazonSESConfig {
            ...espAmazonSESFragment
          }
          ... on ZetaConfig {
            ...espZetaFragment
          }
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
      }
    }
  }
}
    ${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspBlackholeFragmentFragmentDoc}
${EspEpsilonFragmentFragmentDoc}
${EspAmazonSesFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}`;
export type RecurringCampaignEmailServiceProviderUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignEmailServiceProviderUpdateMutation, RecurringCampaignEmailServiceProviderUpdateMutationVariables>;

/**
 * __useRecurringCampaignEmailServiceProviderUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignEmailServiceProviderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignEmailServiceProviderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignEmailServiceProviderUpdateMutation, { data, loading, error }] = useRecurringCampaignEmailServiceProviderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailServiceProviderId: // value for 'emailServiceProviderId'
 *   },
 * });
 */
export function useRecurringCampaignEmailServiceProviderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignEmailServiceProviderUpdateMutation, RecurringCampaignEmailServiceProviderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignEmailServiceProviderUpdateMutation, RecurringCampaignEmailServiceProviderUpdateMutationVariables>(RecurringCampaignEmailServiceProviderUpdateDocument, options);
      }
export type RecurringCampaignEmailServiceProviderUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignEmailServiceProviderUpdateMutation>;
export type RecurringCampaignEmailServiceProviderUpdateMutationResult = Apollo.MutationResult<RecurringCampaignEmailServiceProviderUpdateMutation>;
export type RecurringCampaignEmailServiceProviderUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignEmailServiceProviderUpdateMutation, RecurringCampaignEmailServiceProviderUpdateMutationVariables>;
export const RecurringCampaignSeedAudienceAddDocument = gql`
    mutation RecurringCampaignSeedAudienceAdd($campaignId: ID!, $audienceId: ID!) {
  recurringCampaignSeedAudienceAdd(id: $campaignId, audienceId: $audienceId) {
    ... on RecurringCampaignAudienceSuccess {
      success
      recurringCampaign {
        id
        seedContactAudiences {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type RecurringCampaignSeedAudienceAddMutationFn = Apollo.MutationFunction<RecurringCampaignSeedAudienceAddMutation, RecurringCampaignSeedAudienceAddMutationVariables>;

/**
 * __useRecurringCampaignSeedAudienceAddMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignSeedAudienceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignSeedAudienceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignSeedAudienceAddMutation, { data, loading, error }] = useRecurringCampaignSeedAudienceAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useRecurringCampaignSeedAudienceAddMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignSeedAudienceAddMutation, RecurringCampaignSeedAudienceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignSeedAudienceAddMutation, RecurringCampaignSeedAudienceAddMutationVariables>(RecurringCampaignSeedAudienceAddDocument, options);
      }
export type RecurringCampaignSeedAudienceAddMutationHookResult = ReturnType<typeof useRecurringCampaignSeedAudienceAddMutation>;
export type RecurringCampaignSeedAudienceAddMutationResult = Apollo.MutationResult<RecurringCampaignSeedAudienceAddMutation>;
export type RecurringCampaignSeedAudienceAddMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignSeedAudienceAddMutation, RecurringCampaignSeedAudienceAddMutationVariables>;
export const RecurringCampaignSeedAudienceRemoveDocument = gql`
    mutation RecurringCampaignSeedAudienceRemove($campaignId: ID!, $audienceId: ID!) {
  recurringCampaignSeedAudienceRemove(id: $campaignId, audienceId: $audienceId) {
    ... on RecurringCampaignAudienceSuccess {
      success
      recurringCampaign {
        id
        seedContactAudiences {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type RecurringCampaignSeedAudienceRemoveMutationFn = Apollo.MutationFunction<RecurringCampaignSeedAudienceRemoveMutation, RecurringCampaignSeedAudienceRemoveMutationVariables>;

/**
 * __useRecurringCampaignSeedAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignSeedAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignSeedAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignSeedAudienceRemoveMutation, { data, loading, error }] = useRecurringCampaignSeedAudienceRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useRecurringCampaignSeedAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignSeedAudienceRemoveMutation, RecurringCampaignSeedAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignSeedAudienceRemoveMutation, RecurringCampaignSeedAudienceRemoveMutationVariables>(RecurringCampaignSeedAudienceRemoveDocument, options);
      }
export type RecurringCampaignSeedAudienceRemoveMutationHookResult = ReturnType<typeof useRecurringCampaignSeedAudienceRemoveMutation>;
export type RecurringCampaignSeedAudienceRemoveMutationResult = Apollo.MutationResult<RecurringCampaignSeedAudienceRemoveMutation>;
export type RecurringCampaignSeedAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignSeedAudienceRemoveMutation, RecurringCampaignSeedAudienceRemoveMutationVariables>;
export const RecurringCampaignTextTrackingParameterUpdateDocument = gql`
    mutation RecurringCampaignTextTrackingParameterUpdate($id: ID!, $trackingParameterId: ID!, $value: String) {
  recurringCampaignTextTrackingParameterUpdate(
    id: $id
    trackingParameterId: $trackingParameterId
    value: $value
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        trackingParameters {
          ...campaignTrackingParametersFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignTrackingParametersFragmentFragmentDoc}`;
export type RecurringCampaignTextTrackingParameterUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignTextTrackingParameterUpdateMutation, RecurringCampaignTextTrackingParameterUpdateMutationVariables>;

/**
 * __useRecurringCampaignTextTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignTextTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignTextTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignTextTrackingParameterUpdateMutation, { data, loading, error }] = useRecurringCampaignTextTrackingParameterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useRecurringCampaignTextTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignTextTrackingParameterUpdateMutation, RecurringCampaignTextTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignTextTrackingParameterUpdateMutation, RecurringCampaignTextTrackingParameterUpdateMutationVariables>(RecurringCampaignTextTrackingParameterUpdateDocument, options);
      }
export type RecurringCampaignTextTrackingParameterUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignTextTrackingParameterUpdateMutation>;
export type RecurringCampaignTextTrackingParameterUpdateMutationResult = Apollo.MutationResult<RecurringCampaignTextTrackingParameterUpdateMutation>;
export type RecurringCampaignTextTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignTextTrackingParameterUpdateMutation, RecurringCampaignTextTrackingParameterUpdateMutationVariables>;
export const RecurringCampaignSelectTrackingParameterUpdateDocument = gql`
    mutation RecurringCampaignSelectTrackingParameterUpdate($id: ID!, $trackingParameterId: ID!, $optionId: ID) {
  recurringCampaignSelectTrackingParameterUpdate(
    id: $id
    trackingParameterId: $trackingParameterId
    optionId: $optionId
  ) {
    ... on RecurringCampaignAttributeUpdateSuccess {
      success
      recurringCampaign {
        id
        trackingParameters {
          ...campaignTrackingParametersFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignTrackingParametersFragmentFragmentDoc}`;
export type RecurringCampaignSelectTrackingParameterUpdateMutationFn = Apollo.MutationFunction<RecurringCampaignSelectTrackingParameterUpdateMutation, RecurringCampaignSelectTrackingParameterUpdateMutationVariables>;

/**
 * __useRecurringCampaignSelectTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringCampaignSelectTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignSelectTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringCampaignSelectTrackingParameterUpdateMutation, { data, loading, error }] = useRecurringCampaignSelectTrackingParameterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useRecurringCampaignSelectTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecurringCampaignSelectTrackingParameterUpdateMutation, RecurringCampaignSelectTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecurringCampaignSelectTrackingParameterUpdateMutation, RecurringCampaignSelectTrackingParameterUpdateMutationVariables>(RecurringCampaignSelectTrackingParameterUpdateDocument, options);
      }
export type RecurringCampaignSelectTrackingParameterUpdateMutationHookResult = ReturnType<typeof useRecurringCampaignSelectTrackingParameterUpdateMutation>;
export type RecurringCampaignSelectTrackingParameterUpdateMutationResult = Apollo.MutationResult<RecurringCampaignSelectTrackingParameterUpdateMutation>;
export type RecurringCampaignSelectTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<RecurringCampaignSelectTrackingParameterUpdateMutation, RecurringCampaignSelectTrackingParameterUpdateMutationVariables>;
export const RecurringCampaignSettingsDocument = gql`
    query RecurringCampaignSettings($campaignId: ID!) {
  availableCustomFields {
    id
    name
    title
  }
  recurringCampaign(id: $campaignId) {
    id
    status
    seedContactAudiences {
      id
      name
    }
    attributes {
      ...campaignAttributesFragment
    }
    trackingParameters {
      ...campaignTrackingParametersFragment
    }
    emailServiceProvider {
      __typename
      ... on AcousticCampaign {
        id
      }
      ... on AdobeCampaign {
        id
      }
      ... on AdobeJourneyOptimizer {
        id
      }
      ... on AmazonSES {
        id
      }
      ... on Braze {
        id
      }
      ... on Cordial {
        id
      }
      ... on OracleResponsys {
        id
      }
      ... on SalesForceMarketingCloud {
        id
      }
      ... on Zeta {
        id
      }
    }
    espConfig {
      ... on CampaignSalesforceMarketingCloudConfig {
        ...espSalesForceFragment
      }
      ... on CampaignAcousticCampaignConfig {
        ...espAcousticFragment
      }
      ... on CampaignOracleResponsysConfig {
        ...espOracleFragment
      }
      ... on CampaignCordialConfig {
        ...espCordialFragment
      }
      ... on CampaignAdobeCampaignConfig {
        ...espAdobeCampaignFragment
      }
      ... on AdobeJourneyOptimizerConfig {
        ...espAdobeJourneyOptimizerFragment
      }
      ... on BlackholeConfig {
        ...espBlackholeFragment
      }
      ... on CampaignEpsilonConfig {
        ...espEpsilonFragment
      }
      ... on AmazonSESConfig {
        ...espAmazonSESFragment
      }
      ... on ZetaConfig {
        ...espZetaFragment
      }
    }
    customFields {
      ...recurringCustomFieldsFragment
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}
${CampaignTrackingParametersFragmentFragmentDoc}
${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspBlackholeFragmentFragmentDoc}
${EspEpsilonFragmentFragmentDoc}
${EspAmazonSesFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}
${RecurringCustomFieldsFragmentFragmentDoc}`;

/**
 * __useRecurringCampaignSettingsQuery__
 *
 * To run a query within a React component, call `useRecurringCampaignSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringCampaignSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringCampaignSettingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useRecurringCampaignSettingsQuery(baseOptions: Apollo.QueryHookOptions<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables> & ({ variables: RecurringCampaignSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables>(RecurringCampaignSettingsDocument, options);
      }
export function useRecurringCampaignSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables>(RecurringCampaignSettingsDocument, options);
        }
export function useRecurringCampaignSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables>(RecurringCampaignSettingsDocument, options);
        }
export type RecurringCampaignSettingsQueryHookResult = ReturnType<typeof useRecurringCampaignSettingsQuery>;
export type RecurringCampaignSettingsLazyQueryHookResult = ReturnType<typeof useRecurringCampaignSettingsLazyQuery>;
export type RecurringCampaignSettingsSuspenseQueryHookResult = ReturnType<typeof useRecurringCampaignSettingsSuspenseQuery>;
export type RecurringCampaignSettingsQueryResult = Apollo.QueryResult<RecurringCampaignSettingsQuery, RecurringCampaignSettingsQueryVariables>;
export const AnalyticsCustomEventCategoriesDocument = gql`
    query AnalyticsCustomEventCategories {
  customEventCategories {
    id
    name
    attributionType
    hasSubidentifier
    timestampType
    contactIdentifierField {
      id
      displayName
    }
    table {
      id
      name
      semanticCategory {
        id
        name
      }
    }
    tags {
      id
      key
      value
    }
  }
}
    `;

/**
 * __useAnalyticsCustomEventCategoriesQuery__
 *
 * To run a query within a React component, call `useAnalyticsCustomEventCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCustomEventCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>(AnalyticsCustomEventCategoriesDocument, options);
      }
export function useAnalyticsCustomEventCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>(AnalyticsCustomEventCategoriesDocument, options);
        }
export function useAnalyticsCustomEventCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>(AnalyticsCustomEventCategoriesDocument, options);
        }
export type AnalyticsCustomEventCategoriesQueryHookResult = ReturnType<typeof useAnalyticsCustomEventCategoriesQuery>;
export type AnalyticsCustomEventCategoriesLazyQueryHookResult = ReturnType<typeof useAnalyticsCustomEventCategoriesLazyQuery>;
export type AnalyticsCustomEventCategoriesSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCustomEventCategoriesSuspenseQuery>;
export type AnalyticsCustomEventCategoriesQueryResult = Apollo.QueryResult<AnalyticsCustomEventCategoriesQuery, AnalyticsCustomEventCategoriesQueryVariables>;
export const AnalyticsCustomEventTagsDocument = gql`
    query AnalyticsCustomEventTags {
  customEventTags {
    id
    key
    value
  }
}
    `;

/**
 * __useAnalyticsCustomEventTagsQuery__
 *
 * To run a query within a React component, call `useAnalyticsCustomEventTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsCustomEventTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsCustomEventTagsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>(AnalyticsCustomEventTagsDocument, options);
      }
export function useAnalyticsCustomEventTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>(AnalyticsCustomEventTagsDocument, options);
        }
export function useAnalyticsCustomEventTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>(AnalyticsCustomEventTagsDocument, options);
        }
export type AnalyticsCustomEventTagsQueryHookResult = ReturnType<typeof useAnalyticsCustomEventTagsQuery>;
export type AnalyticsCustomEventTagsLazyQueryHookResult = ReturnType<typeof useAnalyticsCustomEventTagsLazyQuery>;
export type AnalyticsCustomEventTagsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsCustomEventTagsSuspenseQuery>;
export type AnalyticsCustomEventTagsQueryResult = Apollo.QueryResult<AnalyticsCustomEventTagsQuery, AnalyticsCustomEventTagsQueryVariables>;
export const AnalyticsCustomEventCategoryCreateDocument = gql`
    mutation AnalyticsCustomEventCategoryCreate($name: String!, $attributionType: AttributionType, $contactIdentifierFieldId: ID, $hasSubidentifier: Boolean, $timestampType: TimestampType) {
  customEventCategoryCreate(
    name: $name
    attributionType: $attributionType
    contactIdentifierFieldId: $contactIdentifierFieldId
    hasSubidentifier: $hasSubidentifier
    timestampType: $timestampType
  ) {
    category {
      id
      name
      attributionType
      hasSubidentifier
      timestampType
      tags {
        id
        name
      }
    }
  }
}
    `;
export type AnalyticsCustomEventCategoryCreateMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryCreateMutation, AnalyticsCustomEventCategoryCreateMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryCreateMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryCreateMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      attributionType: // value for 'attributionType'
 *      contactIdentifierFieldId: // value for 'contactIdentifierFieldId'
 *      hasSubidentifier: // value for 'hasSubidentifier'
 *      timestampType: // value for 'timestampType'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryCreateMutation, AnalyticsCustomEventCategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryCreateMutation, AnalyticsCustomEventCategoryCreateMutationVariables>(AnalyticsCustomEventCategoryCreateDocument, options);
      }
export type AnalyticsCustomEventCategoryCreateMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryCreateMutation>;
export type AnalyticsCustomEventCategoryCreateMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryCreateMutation>;
export type AnalyticsCustomEventCategoryCreateMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryCreateMutation, AnalyticsCustomEventCategoryCreateMutationVariables>;
export const AnalyticsCustomEventCategoryUpdateDocument = gql`
    mutation AnalyticsCustomEventCategoryUpdate($id: ID!, $name: String!) {
  customEventCategoryUpdate(id: $id, name: $name) {
    category {
      id
      name
      tags {
        id
        name
      }
    }
  }
}
    `;
export type AnalyticsCustomEventCategoryUpdateMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryUpdateMutation, AnalyticsCustomEventCategoryUpdateMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryUpdateMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryUpdateMutation, AnalyticsCustomEventCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryUpdateMutation, AnalyticsCustomEventCategoryUpdateMutationVariables>(AnalyticsCustomEventCategoryUpdateDocument, options);
      }
export type AnalyticsCustomEventCategoryUpdateMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryUpdateMutation>;
export type AnalyticsCustomEventCategoryUpdateMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryUpdateMutation>;
export type AnalyticsCustomEventCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryUpdateMutation, AnalyticsCustomEventCategoryUpdateMutationVariables>;
export const AnalyticsCustomEventCategoryDeleteDocument = gql`
    mutation AnalyticsCustomEventCategoryDelete($id: ID!) {
  customEventCategoryDelete(id: $id) {
    success
  }
}
    `;
export type AnalyticsCustomEventCategoryDeleteMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryDeleteMutation, AnalyticsCustomEventCategoryDeleteMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryDeleteMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryDeleteMutation, AnalyticsCustomEventCategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryDeleteMutation, AnalyticsCustomEventCategoryDeleteMutationVariables>(AnalyticsCustomEventCategoryDeleteDocument, options);
      }
export type AnalyticsCustomEventCategoryDeleteMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryDeleteMutation>;
export type AnalyticsCustomEventCategoryDeleteMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryDeleteMutation>;
export type AnalyticsCustomEventCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryDeleteMutation, AnalyticsCustomEventCategoryDeleteMutationVariables>;
export const AnalyticsCustomEventCategoryAttachTagDocument = gql`
    mutation AnalyticsCustomEventCategoryAttachTag($id: ID!, $channelId: ID!) {
  customEventCategoryAttachTag(id: $id, channelId: $channelId) {
    category {
      id
      name
      tags {
        id
        key
        value
      }
    }
  }
}
    `;
export type AnalyticsCustomEventCategoryAttachTagMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryAttachTagMutation, AnalyticsCustomEventCategoryAttachTagMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryAttachTagMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryAttachTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryAttachTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryAttachTagMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryAttachTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryAttachTagMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryAttachTagMutation, AnalyticsCustomEventCategoryAttachTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryAttachTagMutation, AnalyticsCustomEventCategoryAttachTagMutationVariables>(AnalyticsCustomEventCategoryAttachTagDocument, options);
      }
export type AnalyticsCustomEventCategoryAttachTagMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryAttachTagMutation>;
export type AnalyticsCustomEventCategoryAttachTagMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryAttachTagMutation>;
export type AnalyticsCustomEventCategoryAttachTagMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryAttachTagMutation, AnalyticsCustomEventCategoryAttachTagMutationVariables>;
export const AnalyticsCustomEventCategoryDetachTagDocument = gql`
    mutation AnalyticsCustomEventCategoryDetachTag($id: ID!, $channelId: ID!) {
  customEventCategoryDetachTag(id: $id, channelId: $channelId) {
    category {
      id
      name
      tags {
        id
        key
        value
      }
    }
  }
}
    `;
export type AnalyticsCustomEventCategoryDetachTagMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryDetachTagMutation, AnalyticsCustomEventCategoryDetachTagMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryDetachTagMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryDetachTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryDetachTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryDetachTagMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryDetachTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryDetachTagMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryDetachTagMutation, AnalyticsCustomEventCategoryDetachTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryDetachTagMutation, AnalyticsCustomEventCategoryDetachTagMutationVariables>(AnalyticsCustomEventCategoryDetachTagDocument, options);
      }
export type AnalyticsCustomEventCategoryDetachTagMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryDetachTagMutation>;
export type AnalyticsCustomEventCategoryDetachTagMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryDetachTagMutation>;
export type AnalyticsCustomEventCategoryDetachTagMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryDetachTagMutation, AnalyticsCustomEventCategoryDetachTagMutationVariables>;
export const AnalyticsCustomEventCategoryAttachCesTagDocument = gql`
    mutation AnalyticsCustomEventCategoryAttachCesTag($id: ID!) {
  customEventCategoryAttachCesTag(id: $id) {
    category {
      id
      name
      tags {
        id
        key
        value
      }
    }
  }
}
    `;
export type AnalyticsCustomEventCategoryAttachCesTagMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryAttachCesTagMutation, AnalyticsCustomEventCategoryAttachCesTagMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryAttachCesTagMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryAttachCesTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryAttachCesTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryAttachCesTagMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryAttachCesTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryAttachCesTagMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryAttachCesTagMutation, AnalyticsCustomEventCategoryAttachCesTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryAttachCesTagMutation, AnalyticsCustomEventCategoryAttachCesTagMutationVariables>(AnalyticsCustomEventCategoryAttachCesTagDocument, options);
      }
export type AnalyticsCustomEventCategoryAttachCesTagMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryAttachCesTagMutation>;
export type AnalyticsCustomEventCategoryAttachCesTagMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryAttachCesTagMutation>;
export type AnalyticsCustomEventCategoryAttachCesTagMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryAttachCesTagMutation, AnalyticsCustomEventCategoryAttachCesTagMutationVariables>;
export const AnalyticsCustomEventCategoryDetachCesTagDocument = gql`
    mutation AnalyticsCustomEventCategoryDetachCesTag($id: ID!) {
  customEventCategoryDetachCesTag(id: $id) {
    category {
      id
      name
      tags {
        id
        key
        value
      }
    }
  }
}
    `;
export type AnalyticsCustomEventCategoryDetachCesTagMutationFn = Apollo.MutationFunction<AnalyticsCustomEventCategoryDetachCesTagMutation, AnalyticsCustomEventCategoryDetachCesTagMutationVariables>;

/**
 * __useAnalyticsCustomEventCategoryDetachCesTagMutation__
 *
 * To run a mutation, you first call `useAnalyticsCustomEventCategoryDetachCesTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsCustomEventCategoryDetachCesTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsCustomEventCategoryDetachCesTagMutation, { data, loading, error }] = useAnalyticsCustomEventCategoryDetachCesTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalyticsCustomEventCategoryDetachCesTagMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsCustomEventCategoryDetachCesTagMutation, AnalyticsCustomEventCategoryDetachCesTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsCustomEventCategoryDetachCesTagMutation, AnalyticsCustomEventCategoryDetachCesTagMutationVariables>(AnalyticsCustomEventCategoryDetachCesTagDocument, options);
      }
export type AnalyticsCustomEventCategoryDetachCesTagMutationHookResult = ReturnType<typeof useAnalyticsCustomEventCategoryDetachCesTagMutation>;
export type AnalyticsCustomEventCategoryDetachCesTagMutationResult = Apollo.MutationResult<AnalyticsCustomEventCategoryDetachCesTagMutation>;
export type AnalyticsCustomEventCategoryDetachCesTagMutationOptions = Apollo.BaseMutationOptions<AnalyticsCustomEventCategoryDetachCesTagMutation, AnalyticsCustomEventCategoryDetachCesTagMutationVariables>;
export const GetContactTablesDocument = gql`
    query GetContactTables {
  dataTables {
    id
    name
    semanticCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useGetContactTablesQuery__
 *
 * To run a query within a React component, call `useGetContactTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactTablesQuery(baseOptions?: Apollo.QueryHookOptions<GetContactTablesQuery, GetContactTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactTablesQuery, GetContactTablesQueryVariables>(GetContactTablesDocument, options);
      }
export function useGetContactTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactTablesQuery, GetContactTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactTablesQuery, GetContactTablesQueryVariables>(GetContactTablesDocument, options);
        }
export function useGetContactTablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactTablesQuery, GetContactTablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactTablesQuery, GetContactTablesQueryVariables>(GetContactTablesDocument, options);
        }
export type GetContactTablesQueryHookResult = ReturnType<typeof useGetContactTablesQuery>;
export type GetContactTablesLazyQueryHookResult = ReturnType<typeof useGetContactTablesLazyQuery>;
export type GetContactTablesSuspenseQueryHookResult = ReturnType<typeof useGetContactTablesSuspenseQuery>;
export type GetContactTablesQueryResult = Apollo.QueryResult<GetContactTablesQuery, GetContactTablesQueryVariables>;
export const GetDataTableFieldsDocument = gql`
    query GetDataTableFields($tableId: ID!) {
  dataFields(tableId: $tableId) {
    id
    name
    displayName
    type
  }
}
    `;

/**
 * __useGetDataTableFieldsQuery__
 *
 * To run a query within a React component, call `useGetDataTableFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataTableFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataTableFieldsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetDataTableFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables> & ({ variables: GetDataTableFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables>(GetDataTableFieldsDocument, options);
      }
export function useGetDataTableFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables>(GetDataTableFieldsDocument, options);
        }
export function useGetDataTableFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables>(GetDataTableFieldsDocument, options);
        }
export type GetDataTableFieldsQueryHookResult = ReturnType<typeof useGetDataTableFieldsQuery>;
export type GetDataTableFieldsLazyQueryHookResult = ReturnType<typeof useGetDataTableFieldsLazyQuery>;
export type GetDataTableFieldsSuspenseQueryHookResult = ReturnType<typeof useGetDataTableFieldsSuspenseQuery>;
export type GetDataTableFieldsQueryResult = Apollo.QueryResult<GetDataTableFieldsQuery, GetDataTableFieldsQueryVariables>;
export const AnalyticsSettingSegmentsDocument = gql`
    query AnalyticsSettingSegments {
  contactAudiences(limit: 10000000, archived: false, types: [SEGMENT]) {
    audiences {
      id
      name
      splits {
        id
      }
      analyticsTracking
    }
  }
}
    `;

/**
 * __useAnalyticsSettingSegmentsQuery__
 *
 * To run a query within a React component, call `useAnalyticsSettingSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSettingSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSettingSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsSettingSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>(AnalyticsSettingSegmentsDocument, options);
      }
export function useAnalyticsSettingSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>(AnalyticsSettingSegmentsDocument, options);
        }
export function useAnalyticsSettingSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>(AnalyticsSettingSegmentsDocument, options);
        }
export type AnalyticsSettingSegmentsQueryHookResult = ReturnType<typeof useAnalyticsSettingSegmentsQuery>;
export type AnalyticsSettingSegmentsLazyQueryHookResult = ReturnType<typeof useAnalyticsSettingSegmentsLazyQuery>;
export type AnalyticsSettingSegmentsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSettingSegmentsSuspenseQuery>;
export type AnalyticsSettingSegmentsQueryResult = Apollo.QueryResult<AnalyticsSettingSegmentsQuery, AnalyticsSettingSegmentsQueryVariables>;
export const ContactAudienceAnalyticsTrackingDocument = gql`
    mutation ContactAudienceAnalyticsTracking($id: ID!, $analyticsTracking: ContactAudienceAnalyticsTracking!) {
  contactAudienceAnalyticsTracking(id: $id, analyticsTracking: $analyticsTracking) {
    contactAudience {
      id
      name
      analyticsTracking
    }
  }
}
    `;
export type ContactAudienceAnalyticsTrackingMutationFn = Apollo.MutationFunction<ContactAudienceAnalyticsTrackingMutation, ContactAudienceAnalyticsTrackingMutationVariables>;

/**
 * __useContactAudienceAnalyticsTrackingMutation__
 *
 * To run a mutation, you first call `useContactAudienceAnalyticsTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceAnalyticsTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactAudienceAnalyticsTrackingMutation, { data, loading, error }] = useContactAudienceAnalyticsTrackingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      analyticsTracking: // value for 'analyticsTracking'
 *   },
 * });
 */
export function useContactAudienceAnalyticsTrackingMutation(baseOptions?: Apollo.MutationHookOptions<ContactAudienceAnalyticsTrackingMutation, ContactAudienceAnalyticsTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactAudienceAnalyticsTrackingMutation, ContactAudienceAnalyticsTrackingMutationVariables>(ContactAudienceAnalyticsTrackingDocument, options);
      }
export type ContactAudienceAnalyticsTrackingMutationHookResult = ReturnType<typeof useContactAudienceAnalyticsTrackingMutation>;
export type ContactAudienceAnalyticsTrackingMutationResult = Apollo.MutationResult<ContactAudienceAnalyticsTrackingMutation>;
export type ContactAudienceAnalyticsTrackingMutationOptions = Apollo.BaseMutationOptions<ContactAudienceAnalyticsTrackingMutation, ContactAudienceAnalyticsTrackingMutationVariables>;
export const AnalyticsKpiDefinitionDocument = gql`
    query AnalyticsKpiDefinition {
  currentClient {
    id
    analyticsConfiguration {
      kpiDefinition {
        eventSelections {
          eventType
          eventSourceId
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsKpiDefinitionQuery__
 *
 * To run a query within a React component, call `useAnalyticsKpiDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsKpiDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsKpiDefinitionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsKpiDefinitionQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>(AnalyticsKpiDefinitionDocument, options);
      }
export function useAnalyticsKpiDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>(AnalyticsKpiDefinitionDocument, options);
        }
export function useAnalyticsKpiDefinitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>(AnalyticsKpiDefinitionDocument, options);
        }
export type AnalyticsKpiDefinitionQueryHookResult = ReturnType<typeof useAnalyticsKpiDefinitionQuery>;
export type AnalyticsKpiDefinitionLazyQueryHookResult = ReturnType<typeof useAnalyticsKpiDefinitionLazyQuery>;
export type AnalyticsKpiDefinitionSuspenseQueryHookResult = ReturnType<typeof useAnalyticsKpiDefinitionSuspenseQuery>;
export type AnalyticsKpiDefinitionQueryResult = Apollo.QueryResult<AnalyticsKpiDefinitionQuery, AnalyticsKpiDefinitionQueryVariables>;
export const AnalyticsKpiEventSelectionsReplaceDocument = gql`
    mutation AnalyticsKpiEventSelectionsReplace($selections: [AnalyticsKPIEventSelectionInput!]!) {
  analyticsKpiEventSelectionsReplace(selections: $selections) {
    client {
      id
      analyticsConfiguration {
        kpiDefinition {
          eventSelections {
            eventType
            eventSourceId
          }
        }
      }
    }
  }
}
    `;
export type AnalyticsKpiEventSelectionsReplaceMutationFn = Apollo.MutationFunction<AnalyticsKpiEventSelectionsReplaceMutation, AnalyticsKpiEventSelectionsReplaceMutationVariables>;

/**
 * __useAnalyticsKpiEventSelectionsReplaceMutation__
 *
 * To run a mutation, you first call `useAnalyticsKpiEventSelectionsReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsKpiEventSelectionsReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsKpiEventSelectionsReplaceMutation, { data, loading, error }] = useAnalyticsKpiEventSelectionsReplaceMutation({
 *   variables: {
 *      selections: // value for 'selections'
 *   },
 * });
 */
export function useAnalyticsKpiEventSelectionsReplaceMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsKpiEventSelectionsReplaceMutation, AnalyticsKpiEventSelectionsReplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsKpiEventSelectionsReplaceMutation, AnalyticsKpiEventSelectionsReplaceMutationVariables>(AnalyticsKpiEventSelectionsReplaceDocument, options);
      }
export type AnalyticsKpiEventSelectionsReplaceMutationHookResult = ReturnType<typeof useAnalyticsKpiEventSelectionsReplaceMutation>;
export type AnalyticsKpiEventSelectionsReplaceMutationResult = Apollo.MutationResult<AnalyticsKpiEventSelectionsReplaceMutation>;
export type AnalyticsKpiEventSelectionsReplaceMutationOptions = Apollo.BaseMutationOptions<AnalyticsKpiEventSelectionsReplaceMutation, AnalyticsKpiEventSelectionsReplaceMutationVariables>;
export const AnalyticsSettingsDocument = gql`
    query AnalyticsSettings {
  currentClient {
    id
    analyticsCalendar
    analyticsCurrency
    analyticsStatSigThreshold
    analyticsAttributionWindow
    analyticsRevenueCap
    analyticsRevenueCapEnabled
    analyticsExportDecimalPrecision
    analyticsExportRateFormat
    analyticsShowProjectedMetrics
    fiscalCalendar {
      currentWeek
    }
  }
}
    `;

/**
 * __useAnalyticsSettingsQuery__
 *
 * To run a query within a React component, call `useAnalyticsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>(AnalyticsSettingsDocument, options);
      }
export function useAnalyticsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>(AnalyticsSettingsDocument, options);
        }
export function useAnalyticsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>(AnalyticsSettingsDocument, options);
        }
export type AnalyticsSettingsQueryHookResult = ReturnType<typeof useAnalyticsSettingsQuery>;
export type AnalyticsSettingsLazyQueryHookResult = ReturnType<typeof useAnalyticsSettingsLazyQuery>;
export type AnalyticsSettingsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSettingsSuspenseQuery>;
export type AnalyticsSettingsQueryResult = Apollo.QueryResult<AnalyticsSettingsQuery, AnalyticsSettingsQueryVariables>;
export const AnalyticsConfigUpdateDocument = gql`
    mutation AnalyticsConfigUpdate($analyticsAttributionWindow: AnalyticsAttributionWindow, $analyticsCalendar: AnalyticsCalendar, $analyticsCurrency: AnalyticsCurrency, $analyticsStatSigThreshold: Float, $analyticsRevenueCap: Float, $analyticsRevenueCapEnabled: Boolean, $analyticsExportDecimalPrecision: Int, $analyticsExportRateFormat: AnalyticsExportRateFormat, $analyticsShowProjectedMetrics: Boolean) {
  analyticsConfigurationUpdate(
    analyticsAttributionWindow: $analyticsAttributionWindow
    analyticsCalendar: $analyticsCalendar
    analyticsCurrency: $analyticsCurrency
    analyticsStatSigThreshold: $analyticsStatSigThreshold
    analyticsRevenueCap: $analyticsRevenueCap
    analyticsRevenueCapEnabled: $analyticsRevenueCapEnabled
    analyticsExportDecimalPrecision: $analyticsExportDecimalPrecision
    analyticsExportRateFormat: $analyticsExportRateFormat
    analyticsShowProjectedMetrics: $analyticsShowProjectedMetrics
  ) {
    client {
      id
      analyticsCalendar
      analyticsCurrency
      analyticsStatSigThreshold
      analyticsRevenueCap
      analyticsRevenueCapEnabled
      analyticsExportDecimalPrecision
      analyticsExportRateFormat
      analyticsAttributionWindow
      fiscalCalendar {
        currentWeek
      }
      analyticsShowProjectedMetrics
    }
  }
}
    `;
export type AnalyticsConfigUpdateMutationFn = Apollo.MutationFunction<AnalyticsConfigUpdateMutation, AnalyticsConfigUpdateMutationVariables>;

/**
 * __useAnalyticsConfigUpdateMutation__
 *
 * To run a mutation, you first call `useAnalyticsConfigUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsConfigUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsConfigUpdateMutation, { data, loading, error }] = useAnalyticsConfigUpdateMutation({
 *   variables: {
 *      analyticsAttributionWindow: // value for 'analyticsAttributionWindow'
 *      analyticsCalendar: // value for 'analyticsCalendar'
 *      analyticsCurrency: // value for 'analyticsCurrency'
 *      analyticsStatSigThreshold: // value for 'analyticsStatSigThreshold'
 *      analyticsRevenueCap: // value for 'analyticsRevenueCap'
 *      analyticsRevenueCapEnabled: // value for 'analyticsRevenueCapEnabled'
 *      analyticsExportDecimalPrecision: // value for 'analyticsExportDecimalPrecision'
 *      analyticsExportRateFormat: // value for 'analyticsExportRateFormat'
 *      analyticsShowProjectedMetrics: // value for 'analyticsShowProjectedMetrics'
 *   },
 * });
 */
export function useAnalyticsConfigUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsConfigUpdateMutation, AnalyticsConfigUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsConfigUpdateMutation, AnalyticsConfigUpdateMutationVariables>(AnalyticsConfigUpdateDocument, options);
      }
export type AnalyticsConfigUpdateMutationHookResult = ReturnType<typeof useAnalyticsConfigUpdateMutation>;
export type AnalyticsConfigUpdateMutationResult = Apollo.MutationResult<AnalyticsConfigUpdateMutation>;
export type AnalyticsConfigUpdateMutationOptions = Apollo.BaseMutationOptions<AnalyticsConfigUpdateMutation, AnalyticsConfigUpdateMutationVariables>;
export const CreativePurposesDocument = gql`
    query CreativePurposes {
  creativePurposes {
    id
    name
    description
    color
    position
    isArchived
  }
}
    `;

/**
 * __useCreativePurposesQuery__
 *
 * To run a query within a React component, call `useCreativePurposesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativePurposesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativePurposesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreativePurposesQuery(baseOptions?: Apollo.QueryHookOptions<CreativePurposesQuery, CreativePurposesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativePurposesQuery, CreativePurposesQueryVariables>(CreativePurposesDocument, options);
      }
export function useCreativePurposesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativePurposesQuery, CreativePurposesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativePurposesQuery, CreativePurposesQueryVariables>(CreativePurposesDocument, options);
        }
export function useCreativePurposesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreativePurposesQuery, CreativePurposesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreativePurposesQuery, CreativePurposesQueryVariables>(CreativePurposesDocument, options);
        }
export type CreativePurposesQueryHookResult = ReturnType<typeof useCreativePurposesQuery>;
export type CreativePurposesLazyQueryHookResult = ReturnType<typeof useCreativePurposesLazyQuery>;
export type CreativePurposesSuspenseQueryHookResult = ReturnType<typeof useCreativePurposesSuspenseQuery>;
export type CreativePurposesQueryResult = Apollo.QueryResult<CreativePurposesQuery, CreativePurposesQueryVariables>;
export const CreativePurposeCreateDocument = gql`
    mutation CreativePurposeCreate($name: String!, $color: String!, $description: String) {
  creativePurposeCreate(name: $name, color: $color, description: $description) {
    __typename
    ... on CreativePurposeSuccess {
      success
      purpose {
        id
        name
        description
        color
        position
        isArchived
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
      }
    }
  }
}
    `;
export type CreativePurposeCreateMutationFn = Apollo.MutationFunction<CreativePurposeCreateMutation, CreativePurposeCreateMutationVariables>;

/**
 * __useCreativePurposeCreateMutation__
 *
 * To run a mutation, you first call `useCreativePurposeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativePurposeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativePurposeCreateMutation, { data, loading, error }] = useCreativePurposeCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreativePurposeCreateMutation(baseOptions?: Apollo.MutationHookOptions<CreativePurposeCreateMutation, CreativePurposeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativePurposeCreateMutation, CreativePurposeCreateMutationVariables>(CreativePurposeCreateDocument, options);
      }
export type CreativePurposeCreateMutationHookResult = ReturnType<typeof useCreativePurposeCreateMutation>;
export type CreativePurposeCreateMutationResult = Apollo.MutationResult<CreativePurposeCreateMutation>;
export type CreativePurposeCreateMutationOptions = Apollo.BaseMutationOptions<CreativePurposeCreateMutation, CreativePurposeCreateMutationVariables>;
export const CreativePurposeEditDocument = gql`
    mutation CreativePurposeEdit($id: ID!, $name: String, $description: String, $color: String) {
  creativePurposeEdit(
    id: $id
    name: $name
    description: $description
    color: $color
  ) {
    __typename
    ... on CreativePurposeSuccess {
      success
      purpose {
        id
        name
        description
        color
        position
        isArchived
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
      }
    }
  }
}
    `;
export type CreativePurposeEditMutationFn = Apollo.MutationFunction<CreativePurposeEditMutation, CreativePurposeEditMutationVariables>;

/**
 * __useCreativePurposeEditMutation__
 *
 * To run a mutation, you first call `useCreativePurposeEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativePurposeEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativePurposeEditMutation, { data, loading, error }] = useCreativePurposeEditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useCreativePurposeEditMutation(baseOptions?: Apollo.MutationHookOptions<CreativePurposeEditMutation, CreativePurposeEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativePurposeEditMutation, CreativePurposeEditMutationVariables>(CreativePurposeEditDocument, options);
      }
export type CreativePurposeEditMutationHookResult = ReturnType<typeof useCreativePurposeEditMutation>;
export type CreativePurposeEditMutationResult = Apollo.MutationResult<CreativePurposeEditMutation>;
export type CreativePurposeEditMutationOptions = Apollo.BaseMutationOptions<CreativePurposeEditMutation, CreativePurposeEditMutationVariables>;
export const CreativePurposeArchiveDocument = gql`
    mutation CreativePurposeArchive($id: ID!) {
  creativePurposeArchive(id: $id) {
    __typename
    ... on CreativePurposeSuccess {
      success
      purpose {
        id
        name
        description
        color
        position
        isArchived
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
      }
    }
  }
}
    `;
export type CreativePurposeArchiveMutationFn = Apollo.MutationFunction<CreativePurposeArchiveMutation, CreativePurposeArchiveMutationVariables>;

/**
 * __useCreativePurposeArchiveMutation__
 *
 * To run a mutation, you first call `useCreativePurposeArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativePurposeArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativePurposeArchiveMutation, { data, loading, error }] = useCreativePurposeArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreativePurposeArchiveMutation(baseOptions?: Apollo.MutationHookOptions<CreativePurposeArchiveMutation, CreativePurposeArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativePurposeArchiveMutation, CreativePurposeArchiveMutationVariables>(CreativePurposeArchiveDocument, options);
      }
export type CreativePurposeArchiveMutationHookResult = ReturnType<typeof useCreativePurposeArchiveMutation>;
export type CreativePurposeArchiveMutationResult = Apollo.MutationResult<CreativePurposeArchiveMutation>;
export type CreativePurposeArchiveMutationOptions = Apollo.BaseMutationOptions<CreativePurposeArchiveMutation, CreativePurposeArchiveMutationVariables>;
export const CreativePurposeUnarchiveDocument = gql`
    mutation CreativePurposeUnarchive($id: ID!) {
  creativePurposeUnarchive(id: $id) {
    __typename
    ... on CreativePurposeSuccess {
      success
      purpose {
        id
        name
        description
        color
        position
        isArchived
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
      }
    }
  }
}
    `;
export type CreativePurposeUnarchiveMutationFn = Apollo.MutationFunction<CreativePurposeUnarchiveMutation, CreativePurposeUnarchiveMutationVariables>;

/**
 * __useCreativePurposeUnarchiveMutation__
 *
 * To run a mutation, you first call `useCreativePurposeUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreativePurposeUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creativePurposeUnarchiveMutation, { data, loading, error }] = useCreativePurposeUnarchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreativePurposeUnarchiveMutation(baseOptions?: Apollo.MutationHookOptions<CreativePurposeUnarchiveMutation, CreativePurposeUnarchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreativePurposeUnarchiveMutation, CreativePurposeUnarchiveMutationVariables>(CreativePurposeUnarchiveDocument, options);
      }
export type CreativePurposeUnarchiveMutationHookResult = ReturnType<typeof useCreativePurposeUnarchiveMutation>;
export type CreativePurposeUnarchiveMutationResult = Apollo.MutationResult<CreativePurposeUnarchiveMutation>;
export type CreativePurposeUnarchiveMutationOptions = Apollo.BaseMutationOptions<CreativePurposeUnarchiveMutation, CreativePurposeUnarchiveMutationVariables>;
export const UpdateLinkDomainAllowlistDocument = gql`
    mutation updateLinkDomainAllowlist($enforceLinkDomainAllowlist: Boolean!, $linkDomainAllowlist: [String!]!) {
  updateLinkDomainAllowlist(
    enforceLinkDomainAllowlist: $enforceLinkDomainAllowlist
    linkDomainAllowlist: $linkDomainAllowlist
  ) {
    success
    client {
      id
      enforceLinkDomainAllowlist
      linkDomainAllowlist
    }
  }
}
    `;
export type UpdateLinkDomainAllowlistMutationFn = Apollo.MutationFunction<UpdateLinkDomainAllowlistMutation, UpdateLinkDomainAllowlistMutationVariables>;

/**
 * __useUpdateLinkDomainAllowlistMutation__
 *
 * To run a mutation, you first call `useUpdateLinkDomainAllowlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkDomainAllowlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkDomainAllowlistMutation, { data, loading, error }] = useUpdateLinkDomainAllowlistMutation({
 *   variables: {
 *      enforceLinkDomainAllowlist: // value for 'enforceLinkDomainAllowlist'
 *      linkDomainAllowlist: // value for 'linkDomainAllowlist'
 *   },
 * });
 */
export function useUpdateLinkDomainAllowlistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkDomainAllowlistMutation, UpdateLinkDomainAllowlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkDomainAllowlistMutation, UpdateLinkDomainAllowlistMutationVariables>(UpdateLinkDomainAllowlistDocument, options);
      }
export type UpdateLinkDomainAllowlistMutationHookResult = ReturnType<typeof useUpdateLinkDomainAllowlistMutation>;
export type UpdateLinkDomainAllowlistMutationResult = Apollo.MutationResult<UpdateLinkDomainAllowlistMutation>;
export type UpdateLinkDomainAllowlistMutationOptions = Apollo.BaseMutationOptions<UpdateLinkDomainAllowlistMutation, UpdateLinkDomainAllowlistMutationVariables>;
export const DataEncryptionConfigUpdateDocument = gql`
    mutation DataEncryptionConfigUpdate($gpgPublicKey: String!) {
  dataEncryptionConfigUpdate(gpgPublicKey: $gpgPublicKey) {
    config {
      ...DataEncryptionConfigFragment
    }
  }
}
    ${DataEncryptionConfigFragmentFragmentDoc}`;
export type DataEncryptionConfigUpdateMutationFn = Apollo.MutationFunction<DataEncryptionConfigUpdateMutation, DataEncryptionConfigUpdateMutationVariables>;

/**
 * __useDataEncryptionConfigUpdateMutation__
 *
 * To run a mutation, you first call `useDataEncryptionConfigUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionConfigUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataEncryptionConfigUpdateMutation, { data, loading, error }] = useDataEncryptionConfigUpdateMutation({
 *   variables: {
 *      gpgPublicKey: // value for 'gpgPublicKey'
 *   },
 * });
 */
export function useDataEncryptionConfigUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataEncryptionConfigUpdateMutation, DataEncryptionConfigUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataEncryptionConfigUpdateMutation, DataEncryptionConfigUpdateMutationVariables>(DataEncryptionConfigUpdateDocument, options);
      }
export type DataEncryptionConfigUpdateMutationHookResult = ReturnType<typeof useDataEncryptionConfigUpdateMutation>;
export type DataEncryptionConfigUpdateMutationResult = Apollo.MutationResult<DataEncryptionConfigUpdateMutation>;
export type DataEncryptionConfigUpdateMutationOptions = Apollo.BaseMutationOptions<DataEncryptionConfigUpdateMutation, DataEncryptionConfigUpdateMutationVariables>;
export const DataEncryptionConfigDocument = gql`
    query DataEncryptionConfig {
  dataEncryptionConfig {
    ...DataEncryptionConfigFragment
  }
}
    ${DataEncryptionConfigFragmentFragmentDoc}`;

/**
 * __useDataEncryptionConfigQuery__
 *
 * To run a query within a React component, call `useDataEncryptionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataEncryptionConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataEncryptionConfigQuery(baseOptions?: Apollo.QueryHookOptions<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>(DataEncryptionConfigDocument, options);
      }
export function useDataEncryptionConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>(DataEncryptionConfigDocument, options);
        }
export function useDataEncryptionConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>(DataEncryptionConfigDocument, options);
        }
export type DataEncryptionConfigQueryHookResult = ReturnType<typeof useDataEncryptionConfigQuery>;
export type DataEncryptionConfigLazyQueryHookResult = ReturnType<typeof useDataEncryptionConfigLazyQuery>;
export type DataEncryptionConfigSuspenseQueryHookResult = ReturnType<typeof useDataEncryptionConfigSuspenseQuery>;
export type DataEncryptionConfigQueryResult = Apollo.QueryResult<DataEncryptionConfigQuery, DataEncryptionConfigQueryVariables>;
export const DataEncryptionPgpKeysDocument = gql`
    query DataEncryptionPgpKeys {
  dataEncryptionPgpKeys {
    ...PgpKeysListFragment
  }
}
    ${PgpKeysListFragmentFragmentDoc}`;

/**
 * __useDataEncryptionPgpKeysQuery__
 *
 * To run a query within a React component, call `useDataEncryptionPgpKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionPgpKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataEncryptionPgpKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataEncryptionPgpKeysQuery(baseOptions?: Apollo.QueryHookOptions<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>(DataEncryptionPgpKeysDocument, options);
      }
export function useDataEncryptionPgpKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>(DataEncryptionPgpKeysDocument, options);
        }
export function useDataEncryptionPgpKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>(DataEncryptionPgpKeysDocument, options);
        }
export type DataEncryptionPgpKeysQueryHookResult = ReturnType<typeof useDataEncryptionPgpKeysQuery>;
export type DataEncryptionPgpKeysLazyQueryHookResult = ReturnType<typeof useDataEncryptionPgpKeysLazyQuery>;
export type DataEncryptionPgpKeysSuspenseQueryHookResult = ReturnType<typeof useDataEncryptionPgpKeysSuspenseQuery>;
export type DataEncryptionPgpKeysQueryResult = Apollo.QueryResult<DataEncryptionPgpKeysQuery, DataEncryptionPgpKeysQueryVariables>;
export const DataEncryptionPgpKeyCreateDocument = gql`
    mutation DataEncryptionPgpKeyCreate($name: String!, $encryptKey: DataEncryptionPGPEncryptKeyInput, $decryptKey: DataEncryptionPGPDecryptKeyInput) {
  dataEncryptionPgpKeyCreate(
    name: $name
    encryptKey: $encryptKey
    decryptKey: $decryptKey
  ) {
    pgpKey {
      ...PgpKeyFragment
    }
  }
}
    ${PgpKeyFragmentFragmentDoc}`;
export type DataEncryptionPgpKeyCreateMutationFn = Apollo.MutationFunction<DataEncryptionPgpKeyCreateMutation, DataEncryptionPgpKeyCreateMutationVariables>;

/**
 * __useDataEncryptionPgpKeyCreateMutation__
 *
 * To run a mutation, you first call `useDataEncryptionPgpKeyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionPgpKeyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataEncryptionPgpKeyCreateMutation, { data, loading, error }] = useDataEncryptionPgpKeyCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      encryptKey: // value for 'encryptKey'
 *      decryptKey: // value for 'decryptKey'
 *   },
 * });
 */
export function useDataEncryptionPgpKeyCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataEncryptionPgpKeyCreateMutation, DataEncryptionPgpKeyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataEncryptionPgpKeyCreateMutation, DataEncryptionPgpKeyCreateMutationVariables>(DataEncryptionPgpKeyCreateDocument, options);
      }
export type DataEncryptionPgpKeyCreateMutationHookResult = ReturnType<typeof useDataEncryptionPgpKeyCreateMutation>;
export type DataEncryptionPgpKeyCreateMutationResult = Apollo.MutationResult<DataEncryptionPgpKeyCreateMutation>;
export type DataEncryptionPgpKeyCreateMutationOptions = Apollo.BaseMutationOptions<DataEncryptionPgpKeyCreateMutation, DataEncryptionPgpKeyCreateMutationVariables>;
export const DataEncryptionPgpKeyUpdateDocument = gql`
    mutation DataEncryptionPgpKeyUpdate($id: String!, $name: String, $encryptKey: DataEncryptionPGPEncryptKeyInput, $decryptKey: DataEncryptionPGPDecryptKeyInput) {
  dataEncryptionPgpKeyUpdate(
    id: $id
    name: $name
    encryptKey: $encryptKey
    decryptKey: $decryptKey
  ) {
    pgpKey {
      ...PgpKeyFragment
    }
  }
}
    ${PgpKeyFragmentFragmentDoc}`;
export type DataEncryptionPgpKeyUpdateMutationFn = Apollo.MutationFunction<DataEncryptionPgpKeyUpdateMutation, DataEncryptionPgpKeyUpdateMutationVariables>;

/**
 * __useDataEncryptionPgpKeyUpdateMutation__
 *
 * To run a mutation, you first call `useDataEncryptionPgpKeyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionPgpKeyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataEncryptionPgpKeyUpdateMutation, { data, loading, error }] = useDataEncryptionPgpKeyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      encryptKey: // value for 'encryptKey'
 *      decryptKey: // value for 'decryptKey'
 *   },
 * });
 */
export function useDataEncryptionPgpKeyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataEncryptionPgpKeyUpdateMutation, DataEncryptionPgpKeyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataEncryptionPgpKeyUpdateMutation, DataEncryptionPgpKeyUpdateMutationVariables>(DataEncryptionPgpKeyUpdateDocument, options);
      }
export type DataEncryptionPgpKeyUpdateMutationHookResult = ReturnType<typeof useDataEncryptionPgpKeyUpdateMutation>;
export type DataEncryptionPgpKeyUpdateMutationResult = Apollo.MutationResult<DataEncryptionPgpKeyUpdateMutation>;
export type DataEncryptionPgpKeyUpdateMutationOptions = Apollo.BaseMutationOptions<DataEncryptionPgpKeyUpdateMutation, DataEncryptionPgpKeyUpdateMutationVariables>;
export const DataEncryptionPgpKeyDeleteDocument = gql`
    mutation DataEncryptionPgpKeyDelete($id: String!) {
  dataEncryptionPgpKeyDelete(id: $id) {
    success
    pgpKeys {
      ...PgpKeysListFragment
    }
  }
}
    ${PgpKeysListFragmentFragmentDoc}`;
export type DataEncryptionPgpKeyDeleteMutationFn = Apollo.MutationFunction<DataEncryptionPgpKeyDeleteMutation, DataEncryptionPgpKeyDeleteMutationVariables>;

/**
 * __useDataEncryptionPgpKeyDeleteMutation__
 *
 * To run a mutation, you first call `useDataEncryptionPgpKeyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataEncryptionPgpKeyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataEncryptionPgpKeyDeleteMutation, { data, loading, error }] = useDataEncryptionPgpKeyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataEncryptionPgpKeyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataEncryptionPgpKeyDeleteMutation, DataEncryptionPgpKeyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataEncryptionPgpKeyDeleteMutation, DataEncryptionPgpKeyDeleteMutationVariables>(DataEncryptionPgpKeyDeleteDocument, options);
      }
export type DataEncryptionPgpKeyDeleteMutationHookResult = ReturnType<typeof useDataEncryptionPgpKeyDeleteMutation>;
export type DataEncryptionPgpKeyDeleteMutationResult = Apollo.MutationResult<DataEncryptionPgpKeyDeleteMutation>;
export type DataEncryptionPgpKeyDeleteMutationOptions = Apollo.BaseMutationOptions<DataEncryptionPgpKeyDeleteMutation, DataEncryptionPgpKeyDeleteMutationVariables>;
export const TrackingTokenCreateDocument = gql`
    mutation TrackingTokenCreate($name: String!, $mode: TrackingTokenMode!) {
  trackingTokenCreate(name: $name, mode: $mode) {
    token {
      id
      createdAt
      name
      key
      mode
    }
  }
}
    `;
export type TrackingTokenCreateMutationFn = Apollo.MutationFunction<TrackingTokenCreateMutation, TrackingTokenCreateMutationVariables>;

/**
 * __useTrackingTokenCreateMutation__
 *
 * To run a mutation, you first call `useTrackingTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackingTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackingTokenCreateMutation, { data, loading, error }] = useTrackingTokenCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useTrackingTokenCreateMutation(baseOptions?: Apollo.MutationHookOptions<TrackingTokenCreateMutation, TrackingTokenCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackingTokenCreateMutation, TrackingTokenCreateMutationVariables>(TrackingTokenCreateDocument, options);
      }
export type TrackingTokenCreateMutationHookResult = ReturnType<typeof useTrackingTokenCreateMutation>;
export type TrackingTokenCreateMutationResult = Apollo.MutationResult<TrackingTokenCreateMutation>;
export type TrackingTokenCreateMutationOptions = Apollo.BaseMutationOptions<TrackingTokenCreateMutation, TrackingTokenCreateMutationVariables>;
export const TrackingTokenDeleteDocument = gql`
    mutation TrackingTokenDelete($id: ID!) {
  trackingTokenDelete(id: $id) {
    id
  }
}
    `;
export type TrackingTokenDeleteMutationFn = Apollo.MutationFunction<TrackingTokenDeleteMutation, TrackingTokenDeleteMutationVariables>;

/**
 * __useTrackingTokenDeleteMutation__
 *
 * To run a mutation, you first call `useTrackingTokenDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackingTokenDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackingTokenDeleteMutation, { data, loading, error }] = useTrackingTokenDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrackingTokenDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TrackingTokenDeleteMutation, TrackingTokenDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackingTokenDeleteMutation, TrackingTokenDeleteMutationVariables>(TrackingTokenDeleteDocument, options);
      }
export type TrackingTokenDeleteMutationHookResult = ReturnType<typeof useTrackingTokenDeleteMutation>;
export type TrackingTokenDeleteMutationResult = Apollo.MutationResult<TrackingTokenDeleteMutation>;
export type TrackingTokenDeleteMutationOptions = Apollo.BaseMutationOptions<TrackingTokenDeleteMutation, TrackingTokenDeleteMutationVariables>;
export const TrackingTokenListDocument = gql`
    query TrackingTokenList {
  trackingTokenList {
    id
    createdAt
    name
    key
    mode
  }
}
    `;

/**
 * __useTrackingTokenListQuery__
 *
 * To run a query within a React component, call `useTrackingTokenListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingTokenListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingTokenListQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrackingTokenListQuery(baseOptions?: Apollo.QueryHookOptions<TrackingTokenListQuery, TrackingTokenListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingTokenListQuery, TrackingTokenListQueryVariables>(TrackingTokenListDocument, options);
      }
export function useTrackingTokenListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingTokenListQuery, TrackingTokenListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingTokenListQuery, TrackingTokenListQueryVariables>(TrackingTokenListDocument, options);
        }
export function useTrackingTokenListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackingTokenListQuery, TrackingTokenListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackingTokenListQuery, TrackingTokenListQueryVariables>(TrackingTokenListDocument, options);
        }
export type TrackingTokenListQueryHookResult = ReturnType<typeof useTrackingTokenListQuery>;
export type TrackingTokenListLazyQueryHookResult = ReturnType<typeof useTrackingTokenListLazyQuery>;
export type TrackingTokenListSuspenseQueryHookResult = ReturnType<typeof useTrackingTokenListSuspenseQuery>;
export type TrackingTokenListQueryResult = Apollo.QueryResult<TrackingTokenListQuery, TrackingTokenListQueryVariables>;
export const AnalyticsWebEventsActivityDocument = gql`
    query AnalyticsWebEventsActivity($tokenId: ID!, $createdAtStart: DateTime, $createdAtEnd: DateTime) {
  analyticsWebEventsActivity(
    tokenId: $tokenId
    createdAtStart: $createdAtStart
    createdAtEnd: $createdAtEnd
  ) {
    eventType
    count
    mostRecent
  }
}
    `;

/**
 * __useAnalyticsWebEventsActivityQuery__
 *
 * To run a query within a React component, call `useAnalyticsWebEventsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsWebEventsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsWebEventsActivityQuery({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *      createdAtStart: // value for 'createdAtStart'
 *      createdAtEnd: // value for 'createdAtEnd'
 *   },
 * });
 */
export function useAnalyticsWebEventsActivityQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables> & ({ variables: AnalyticsWebEventsActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables>(AnalyticsWebEventsActivityDocument, options);
      }
export function useAnalyticsWebEventsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables>(AnalyticsWebEventsActivityDocument, options);
        }
export function useAnalyticsWebEventsActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables>(AnalyticsWebEventsActivityDocument, options);
        }
export type AnalyticsWebEventsActivityQueryHookResult = ReturnType<typeof useAnalyticsWebEventsActivityQuery>;
export type AnalyticsWebEventsActivityLazyQueryHookResult = ReturnType<typeof useAnalyticsWebEventsActivityLazyQuery>;
export type AnalyticsWebEventsActivitySuspenseQueryHookResult = ReturnType<typeof useAnalyticsWebEventsActivitySuspenseQuery>;
export type AnalyticsWebEventsActivityQueryResult = Apollo.QueryResult<AnalyticsWebEventsActivityQuery, AnalyticsWebEventsActivityQueryVariables>;
export const DataSubjectRequestsCreateBatchDocument = gql`
    mutation DataSubjectRequestsCreateBatch($requests: [DSRInput!]!) {
  dataSubjectRequestsBatchCreate(requests: $requests) {
    dataSubjectRequests {
      id
      actorName
      status
      source
      createdAt
      updatedAt
    }
  }
}
    `;
export type DataSubjectRequestsCreateBatchMutationFn = Apollo.MutationFunction<DataSubjectRequestsCreateBatchMutation, DataSubjectRequestsCreateBatchMutationVariables>;

/**
 * __useDataSubjectRequestsCreateBatchMutation__
 *
 * To run a mutation, you first call `useDataSubjectRequestsCreateBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataSubjectRequestsCreateBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataSubjectRequestsCreateBatchMutation, { data, loading, error }] = useDataSubjectRequestsCreateBatchMutation({
 *   variables: {
 *      requests: // value for 'requests'
 *   },
 * });
 */
export function useDataSubjectRequestsCreateBatchMutation(baseOptions?: Apollo.MutationHookOptions<DataSubjectRequestsCreateBatchMutation, DataSubjectRequestsCreateBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataSubjectRequestsCreateBatchMutation, DataSubjectRequestsCreateBatchMutationVariables>(DataSubjectRequestsCreateBatchDocument, options);
      }
export type DataSubjectRequestsCreateBatchMutationHookResult = ReturnType<typeof useDataSubjectRequestsCreateBatchMutation>;
export type DataSubjectRequestsCreateBatchMutationResult = Apollo.MutationResult<DataSubjectRequestsCreateBatchMutation>;
export type DataSubjectRequestsCreateBatchMutationOptions = Apollo.BaseMutationOptions<DataSubjectRequestsCreateBatchMutation, DataSubjectRequestsCreateBatchMutationVariables>;
export const DataTablesUserPrivacyDocument = gql`
    query DataTablesUserPrivacy {
  dataTables {
    id
    name
    semanticCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useDataTablesUserPrivacyQuery__
 *
 * To run a query within a React component, call `useDataTablesUserPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTablesUserPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTablesUserPrivacyQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataTablesUserPrivacyQuery(baseOptions?: Apollo.QueryHookOptions<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>(DataTablesUserPrivacyDocument, options);
      }
export function useDataTablesUserPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>(DataTablesUserPrivacyDocument, options);
        }
export function useDataTablesUserPrivacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>(DataTablesUserPrivacyDocument, options);
        }
export type DataTablesUserPrivacyQueryHookResult = ReturnType<typeof useDataTablesUserPrivacyQuery>;
export type DataTablesUserPrivacyLazyQueryHookResult = ReturnType<typeof useDataTablesUserPrivacyLazyQuery>;
export type DataTablesUserPrivacySuspenseQueryHookResult = ReturnType<typeof useDataTablesUserPrivacySuspenseQuery>;
export type DataTablesUserPrivacyQueryResult = Apollo.QueryResult<DataTablesUserPrivacyQuery, DataTablesUserPrivacyQueryVariables>;
export const DataFieldsUserPrivacyDocument = gql`
    query DataFieldsUserPrivacy($tableId: ID!) {
  dataFields(tableId: $tableId, types: []) {
    id
    name
    displayName
    primaryKey
  }
}
    `;

/**
 * __useDataFieldsUserPrivacyQuery__
 *
 * To run a query within a React component, call `useDataFieldsUserPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFieldsUserPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataFieldsUserPrivacyQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDataFieldsUserPrivacyQuery(baseOptions: Apollo.QueryHookOptions<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables> & ({ variables: DataFieldsUserPrivacyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables>(DataFieldsUserPrivacyDocument, options);
      }
export function useDataFieldsUserPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables>(DataFieldsUserPrivacyDocument, options);
        }
export function useDataFieldsUserPrivacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables>(DataFieldsUserPrivacyDocument, options);
        }
export type DataFieldsUserPrivacyQueryHookResult = ReturnType<typeof useDataFieldsUserPrivacyQuery>;
export type DataFieldsUserPrivacyLazyQueryHookResult = ReturnType<typeof useDataFieldsUserPrivacyLazyQuery>;
export type DataFieldsUserPrivacySuspenseQueryHookResult = ReturnType<typeof useDataFieldsUserPrivacySuspenseQuery>;
export type DataFieldsUserPrivacyQueryResult = Apollo.QueryResult<DataFieldsUserPrivacyQuery, DataFieldsUserPrivacyQueryVariables>;
export const DataSubjectRequestsDocument = gql`
    query DataSubjectRequests($type: InkDavinciDsrV1DSRTypeEnum, $status: InkDavinciDsrV1DSRStatusEnum, $subjectFieldName: String, $subjectFieldValue: String) {
  dataSubjectRequests(
    type: $type
    status: $status
    subjectFieldName: $subjectFieldName
    subjectFieldValue: $subjectFieldValue
  ) {
    id
    actorName
    status
    source
    createdAt
    updatedAt
    datasourceStatuses {
      datasource
      status
      errorMessage
    }
  }
}
    `;

/**
 * __useDataSubjectRequestsQuery__
 *
 * To run a query within a React component, call `useDataSubjectRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSubjectRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSubjectRequestsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      subjectFieldName: // value for 'subjectFieldName'
 *      subjectFieldValue: // value for 'subjectFieldValue'
 *   },
 * });
 */
export function useDataSubjectRequestsQuery(baseOptions?: Apollo.QueryHookOptions<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>(DataSubjectRequestsDocument, options);
      }
export function useDataSubjectRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>(DataSubjectRequestsDocument, options);
        }
export function useDataSubjectRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>(DataSubjectRequestsDocument, options);
        }
export type DataSubjectRequestsQueryHookResult = ReturnType<typeof useDataSubjectRequestsQuery>;
export type DataSubjectRequestsLazyQueryHookResult = ReturnType<typeof useDataSubjectRequestsLazyQuery>;
export type DataSubjectRequestsSuspenseQueryHookResult = ReturnType<typeof useDataSubjectRequestsSuspenseQuery>;
export type DataSubjectRequestsQueryResult = Apollo.QueryResult<DataSubjectRequestsQuery, DataSubjectRequestsQueryVariables>;
export const PlatformApplicationsDocument = gql`
    query PlatformApplications($organizationId: ID!) {
  platformApplications(organizationId: $organizationId) {
    ...PlatformApplicationFields
  }
}
    ${PlatformApplicationFieldsFragmentDoc}`;

/**
 * __usePlatformApplicationsQuery__
 *
 * To run a query within a React component, call `usePlatformApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformApplicationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePlatformApplicationsQuery(baseOptions: Apollo.QueryHookOptions<PlatformApplicationsQuery, PlatformApplicationsQueryVariables> & ({ variables: PlatformApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformApplicationsQuery, PlatformApplicationsQueryVariables>(PlatformApplicationsDocument, options);
      }
export function usePlatformApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformApplicationsQuery, PlatformApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformApplicationsQuery, PlatformApplicationsQueryVariables>(PlatformApplicationsDocument, options);
        }
export function usePlatformApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformApplicationsQuery, PlatformApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformApplicationsQuery, PlatformApplicationsQueryVariables>(PlatformApplicationsDocument, options);
        }
export type PlatformApplicationsQueryHookResult = ReturnType<typeof usePlatformApplicationsQuery>;
export type PlatformApplicationsLazyQueryHookResult = ReturnType<typeof usePlatformApplicationsLazyQuery>;
export type PlatformApplicationsSuspenseQueryHookResult = ReturnType<typeof usePlatformApplicationsSuspenseQuery>;
export type PlatformApplicationsQueryResult = Apollo.QueryResult<PlatformApplicationsQuery, PlatformApplicationsQueryVariables>;
export const PlatformApplicationDocument = gql`
    query PlatformApplication($id: ID!) {
  platformApplication(id: $id) {
    ...PlatformApplicationFields
  }
}
    ${PlatformApplicationFieldsFragmentDoc}`;

/**
 * __usePlatformApplicationQuery__
 *
 * To run a query within a React component, call `usePlatformApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlatformApplicationQuery(baseOptions: Apollo.QueryHookOptions<PlatformApplicationQuery, PlatformApplicationQueryVariables> & ({ variables: PlatformApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformApplicationQuery, PlatformApplicationQueryVariables>(PlatformApplicationDocument, options);
      }
export function usePlatformApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformApplicationQuery, PlatformApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformApplicationQuery, PlatformApplicationQueryVariables>(PlatformApplicationDocument, options);
        }
export function usePlatformApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformApplicationQuery, PlatformApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformApplicationQuery, PlatformApplicationQueryVariables>(PlatformApplicationDocument, options);
        }
export type PlatformApplicationQueryHookResult = ReturnType<typeof usePlatformApplicationQuery>;
export type PlatformApplicationLazyQueryHookResult = ReturnType<typeof usePlatformApplicationLazyQuery>;
export type PlatformApplicationSuspenseQueryHookResult = ReturnType<typeof usePlatformApplicationSuspenseQuery>;
export type PlatformApplicationQueryResult = Apollo.QueryResult<PlatformApplicationQuery, PlatformApplicationQueryVariables>;
export const PlatformApplicationCreateDocument = gql`
    mutation PlatformApplicationCreate($input: CreatePlatformApplicationInput!) {
  platformApplicationCreate(input: $input) {
    application {
      ...PlatformApplicationFields
    }
  }
}
    ${PlatformApplicationFieldsFragmentDoc}`;
export type PlatformApplicationCreateMutationFn = Apollo.MutationFunction<PlatformApplicationCreateMutation, PlatformApplicationCreateMutationVariables>;

/**
 * __usePlatformApplicationCreateMutation__
 *
 * To run a mutation, you first call `usePlatformApplicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlatformApplicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [platformApplicationCreateMutation, { data, loading, error }] = usePlatformApplicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlatformApplicationCreateMutation(baseOptions?: Apollo.MutationHookOptions<PlatformApplicationCreateMutation, PlatformApplicationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlatformApplicationCreateMutation, PlatformApplicationCreateMutationVariables>(PlatformApplicationCreateDocument, options);
      }
export type PlatformApplicationCreateMutationHookResult = ReturnType<typeof usePlatformApplicationCreateMutation>;
export type PlatformApplicationCreateMutationResult = Apollo.MutationResult<PlatformApplicationCreateMutation>;
export type PlatformApplicationCreateMutationOptions = Apollo.BaseMutationOptions<PlatformApplicationCreateMutation, PlatformApplicationCreateMutationVariables>;
export const PlatformApplicationUpdateDocument = gql`
    mutation PlatformApplicationUpdate($id: ID!, $input: UpdatePlatformApplicationInput!) {
  platformApplicationUpdate(id: $id, input: $input) {
    application {
      ...PlatformApplicationFields
    }
  }
}
    ${PlatformApplicationFieldsFragmentDoc}`;
export type PlatformApplicationUpdateMutationFn = Apollo.MutationFunction<PlatformApplicationUpdateMutation, PlatformApplicationUpdateMutationVariables>;

/**
 * __usePlatformApplicationUpdateMutation__
 *
 * To run a mutation, you first call `usePlatformApplicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlatformApplicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [platformApplicationUpdateMutation, { data, loading, error }] = usePlatformApplicationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlatformApplicationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PlatformApplicationUpdateMutation, PlatformApplicationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlatformApplicationUpdateMutation, PlatformApplicationUpdateMutationVariables>(PlatformApplicationUpdateDocument, options);
      }
export type PlatformApplicationUpdateMutationHookResult = ReturnType<typeof usePlatformApplicationUpdateMutation>;
export type PlatformApplicationUpdateMutationResult = Apollo.MutationResult<PlatformApplicationUpdateMutation>;
export type PlatformApplicationUpdateMutationOptions = Apollo.BaseMutationOptions<PlatformApplicationUpdateMutation, PlatformApplicationUpdateMutationVariables>;
export const PlatformApplicationSuspendDocument = gql`
    mutation PlatformApplicationSuspend($id: ID!) {
  platformApplicationSuspend(id: $id) {
    application {
      ...PlatformApplicationFields
    }
  }
}
    ${PlatformApplicationFieldsFragmentDoc}`;
export type PlatformApplicationSuspendMutationFn = Apollo.MutationFunction<PlatformApplicationSuspendMutation, PlatformApplicationSuspendMutationVariables>;

/**
 * __usePlatformApplicationSuspendMutation__
 *
 * To run a mutation, you first call `usePlatformApplicationSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlatformApplicationSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [platformApplicationSuspendMutation, { data, loading, error }] = usePlatformApplicationSuspendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlatformApplicationSuspendMutation(baseOptions?: Apollo.MutationHookOptions<PlatformApplicationSuspendMutation, PlatformApplicationSuspendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlatformApplicationSuspendMutation, PlatformApplicationSuspendMutationVariables>(PlatformApplicationSuspendDocument, options);
      }
export type PlatformApplicationSuspendMutationHookResult = ReturnType<typeof usePlatformApplicationSuspendMutation>;
export type PlatformApplicationSuspendMutationResult = Apollo.MutationResult<PlatformApplicationSuspendMutation>;
export type PlatformApplicationSuspendMutationOptions = Apollo.BaseMutationOptions<PlatformApplicationSuspendMutation, PlatformApplicationSuspendMutationVariables>;
export const PlatformApplicationActivateDocument = gql`
    mutation PlatformApplicationActivate($id: ID!) {
  platformApplicationActivate(id: $id) {
    application {
      ...PlatformApplicationFields
    }
  }
}
    ${PlatformApplicationFieldsFragmentDoc}`;
export type PlatformApplicationActivateMutationFn = Apollo.MutationFunction<PlatformApplicationActivateMutation, PlatformApplicationActivateMutationVariables>;

/**
 * __usePlatformApplicationActivateMutation__
 *
 * To run a mutation, you first call `usePlatformApplicationActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlatformApplicationActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [platformApplicationActivateMutation, { data, loading, error }] = usePlatformApplicationActivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlatformApplicationActivateMutation(baseOptions?: Apollo.MutationHookOptions<PlatformApplicationActivateMutation, PlatformApplicationActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlatformApplicationActivateMutation, PlatformApplicationActivateMutationVariables>(PlatformApplicationActivateDocument, options);
      }
export type PlatformApplicationActivateMutationHookResult = ReturnType<typeof usePlatformApplicationActivateMutation>;
export type PlatformApplicationActivateMutationResult = Apollo.MutationResult<PlatformApplicationActivateMutation>;
export type PlatformApplicationActivateMutationOptions = Apollo.BaseMutationOptions<PlatformApplicationActivateMutation, PlatformApplicationActivateMutationVariables>;
export const CreateCredentialDocument = gql`
    mutation CreateCredential($applicationId: ID!, $name: String!, $expiresAt: DateTime!) {
  createCredential(
    applicationId: $applicationId
    name: $name
    expiresAt: $expiresAt
  ) {
    credential {
      id
      name
      secret
    }
  }
}
    `;
export type CreateCredentialMutationFn = Apollo.MutationFunction<CreateCredentialMutation, CreateCredentialMutationVariables>;

/**
 * __useCreateCredentialMutation__
 *
 * To run a mutation, you first call `useCreateCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCredentialMutation, { data, loading, error }] = useCreateCredentialMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      name: // value for 'name'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateCredentialMutation(baseOptions?: Apollo.MutationHookOptions<CreateCredentialMutation, CreateCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCredentialMutation, CreateCredentialMutationVariables>(CreateCredentialDocument, options);
      }
export type CreateCredentialMutationHookResult = ReturnType<typeof useCreateCredentialMutation>;
export type CreateCredentialMutationResult = Apollo.MutationResult<CreateCredentialMutation>;
export type CreateCredentialMutationOptions = Apollo.BaseMutationOptions<CreateCredentialMutation, CreateCredentialMutationVariables>;
export const RevokeCredentialDocument = gql`
    mutation RevokeCredential($applicationId: ID!, $credentialId: ID!) {
  revokeCredential(applicationId: $applicationId, credentialId: $credentialId) {
    credential {
      ...CredentialsFields
    }
  }
}
    ${CredentialsFieldsFragmentDoc}`;
export type RevokeCredentialMutationFn = Apollo.MutationFunction<RevokeCredentialMutation, RevokeCredentialMutationVariables>;

/**
 * __useRevokeCredentialMutation__
 *
 * To run a mutation, you first call `useRevokeCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCredentialMutation, { data, loading, error }] = useRevokeCredentialMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      credentialId: // value for 'credentialId'
 *   },
 * });
 */
export function useRevokeCredentialMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCredentialMutation, RevokeCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCredentialMutation, RevokeCredentialMutationVariables>(RevokeCredentialDocument, options);
      }
export type RevokeCredentialMutationHookResult = ReturnType<typeof useRevokeCredentialMutation>;
export type RevokeCredentialMutationResult = Apollo.MutationResult<RevokeCredentialMutation>;
export type RevokeCredentialMutationOptions = Apollo.BaseMutationOptions<RevokeCredentialMutation, RevokeCredentialMutationVariables>;
export const ScopesByCategoryDocument = gql`
    query ScopesByCategory {
  scopesByCategory {
    name
    scopes {
      category
      description
      value
    }
  }
}
    `;

/**
 * __useScopesByCategoryQuery__
 *
 * To run a query within a React component, call `useScopesByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopesByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopesByCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useScopesByCategoryQuery(baseOptions?: Apollo.QueryHookOptions<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>(ScopesByCategoryDocument, options);
      }
export function useScopesByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>(ScopesByCategoryDocument, options);
        }
export function useScopesByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>(ScopesByCategoryDocument, options);
        }
export type ScopesByCategoryQueryHookResult = ReturnType<typeof useScopesByCategoryQuery>;
export type ScopesByCategoryLazyQueryHookResult = ReturnType<typeof useScopesByCategoryLazyQuery>;
export type ScopesByCategorySuspenseQueryHookResult = ReturnType<typeof useScopesByCategorySuspenseQuery>;
export type ScopesByCategoryQueryResult = Apollo.QueryResult<ScopesByCategoryQuery, ScopesByCategoryQueryVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($emailAddress: String!, $firstName: String, $lastName: String, $organizationId: ID!, $accountId: ID, $accountRoles: [AccountRoleInput!]) {
  userCreate2(
    emailAddress: $emailAddress
    firstName: $firstName
    lastName: $lastName
    organizationId: $organizationId
    accountId: $accountId
    accountRoles: $accountRoles
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      organizationId: // value for 'organizationId'
 *      accountId: // value for 'accountId'
 *      accountRoles: // value for 'accountRoles'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserCreateWithRoleDocument = gql`
    mutation UserCreateWithRole($emailAddress: String!, $firstName: String, $lastName: String, $organizationId: ID!, $accountId: ID, $accountRoles: [AccountRoleWithRequiredRoleInput!]!) {
  userCreateWithRole(
    emailAddress: $emailAddress
    firstName: $firstName
    lastName: $lastName
    organizationId: $organizationId
    accountId: $accountId
    accountRoles: $accountRoles
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserCreateWithRoleMutationFn = Apollo.MutationFunction<UserCreateWithRoleMutation, UserCreateWithRoleMutationVariables>;

/**
 * __useUserCreateWithRoleMutation__
 *
 * To run a mutation, you first call `useUserCreateWithRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateWithRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateWithRoleMutation, { data, loading, error }] = useUserCreateWithRoleMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      organizationId: // value for 'organizationId'
 *      accountId: // value for 'accountId'
 *      accountRoles: // value for 'accountRoles'
 *   },
 * });
 */
export function useUserCreateWithRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateWithRoleMutation, UserCreateWithRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateWithRoleMutation, UserCreateWithRoleMutationVariables>(UserCreateWithRoleDocument, options);
      }
export type UserCreateWithRoleMutationHookResult = ReturnType<typeof useUserCreateWithRoleMutation>;
export type UserCreateWithRoleMutationResult = Apollo.MutationResult<UserCreateWithRoleMutation>;
export type UserCreateWithRoleMutationOptions = Apollo.BaseMutationOptions<UserCreateWithRoleMutation, UserCreateWithRoleMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($firstName: String!, $lastName: String!, $userIdentifier: UserIdentifierInput!, $accountRoles: [AccountRoleInput!]) {
  userUpdate2(
    firstName: $firstName
    lastName: $lastName
    userIdentifier: $userIdentifier
    accountRoles: $accountRoles
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      userIdentifier: // value for 'userIdentifier'
 *      accountRoles: // value for 'accountRoles'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserSuspendDocument = gql`
    mutation UserSuspend($userId: ID!) {
  userSuspend2(userId: $userId) {
    success
  }
}
    `;
export type UserSuspendMutationFn = Apollo.MutationFunction<UserSuspendMutation, UserSuspendMutationVariables>;

/**
 * __useUserSuspendMutation__
 *
 * To run a mutation, you first call `useUserSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSuspendMutation, { data, loading, error }] = useUserSuspendMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSuspendMutation(baseOptions?: Apollo.MutationHookOptions<UserSuspendMutation, UserSuspendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSuspendMutation, UserSuspendMutationVariables>(UserSuspendDocument, options);
      }
export type UserSuspendMutationHookResult = ReturnType<typeof useUserSuspendMutation>;
export type UserSuspendMutationResult = Apollo.MutationResult<UserSuspendMutation>;
export type UserSuspendMutationOptions = Apollo.BaseMutationOptions<UserSuspendMutation, UserSuspendMutationVariables>;
export const UserUnsuspendDocument = gql`
    mutation UserUnsuspend($userId: ID!) {
  userUnsuspend2(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserUnsuspendMutationFn = Apollo.MutationFunction<UserUnsuspendMutation, UserUnsuspendMutationVariables>;

/**
 * __useUserUnsuspendMutation__
 *
 * To run a mutation, you first call `useUserUnsuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUnsuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUnsuspendMutation, { data, loading, error }] = useUserUnsuspendMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserUnsuspendMutation(baseOptions?: Apollo.MutationHookOptions<UserUnsuspendMutation, UserUnsuspendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUnsuspendMutation, UserUnsuspendMutationVariables>(UserUnsuspendDocument, options);
      }
export type UserUnsuspendMutationHookResult = ReturnType<typeof useUserUnsuspendMutation>;
export type UserUnsuspendMutationResult = Apollo.MutationResult<UserUnsuspendMutation>;
export type UserUnsuspendMutationOptions = Apollo.BaseMutationOptions<UserUnsuspendMutation, UserUnsuspendMutationVariables>;
export const AccountUserCreateDocument = gql`
    mutation AccountUserCreate($accountId: ID!, $emailAddresses: [String!]!) {
  accountUserBulkCreate(accountId: $accountId, emailAddresses: $emailAddresses) {
    success
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUserCreateMutationFn = Apollo.MutationFunction<AccountUserCreateMutation, AccountUserCreateMutationVariables>;

/**
 * __useAccountUserCreateMutation__
 *
 * To run a mutation, you first call `useAccountUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserCreateMutation, { data, loading, error }] = useAccountUserCreateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      emailAddresses: // value for 'emailAddresses'
 *   },
 * });
 */
export function useAccountUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserCreateMutation, AccountUserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserCreateMutation, AccountUserCreateMutationVariables>(AccountUserCreateDocument, options);
      }
export type AccountUserCreateMutationHookResult = ReturnType<typeof useAccountUserCreateMutation>;
export type AccountUserCreateMutationResult = Apollo.MutationResult<AccountUserCreateMutation>;
export type AccountUserCreateMutationOptions = Apollo.BaseMutationOptions<AccountUserCreateMutation, AccountUserCreateMutationVariables>;
export const AccountUserBulkCreateWithRolesDocument = gql`
    mutation AccountUserBulkCreateWithRoles($accountId: ID!, $emailAddresses: [String!]!, $roleId: ID!) {
  accountUserBulkCreateWithRoles(
    accountId: $accountId
    emailAddresses: $emailAddresses
    roleId: $roleId
  ) {
    success
    results {
      successfulEmailList
      failureEmailList
    }
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUserBulkCreateWithRolesMutationFn = Apollo.MutationFunction<AccountUserBulkCreateWithRolesMutation, AccountUserBulkCreateWithRolesMutationVariables>;

/**
 * __useAccountUserBulkCreateWithRolesMutation__
 *
 * To run a mutation, you first call `useAccountUserBulkCreateWithRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserBulkCreateWithRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserBulkCreateWithRolesMutation, { data, loading, error }] = useAccountUserBulkCreateWithRolesMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      emailAddresses: // value for 'emailAddresses'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAccountUserBulkCreateWithRolesMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserBulkCreateWithRolesMutation, AccountUserBulkCreateWithRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserBulkCreateWithRolesMutation, AccountUserBulkCreateWithRolesMutationVariables>(AccountUserBulkCreateWithRolesDocument, options);
      }
export type AccountUserBulkCreateWithRolesMutationHookResult = ReturnType<typeof useAccountUserBulkCreateWithRolesMutation>;
export type AccountUserBulkCreateWithRolesMutationResult = Apollo.MutationResult<AccountUserBulkCreateWithRolesMutation>;
export type AccountUserBulkCreateWithRolesMutationOptions = Apollo.BaseMutationOptions<AccountUserBulkCreateWithRolesMutation, AccountUserBulkCreateWithRolesMutationVariables>;
export const AccountUserInviteDocument = gql`
    mutation AccountUserInvite($accountId: ID!, $accountRoleId: ID!, $emailAddress: String!, $firstName: String, $lastName: String) {
  accountUserInvite(
    accountId: $accountId
    accountRoleId: $accountRoleId
    emailAddress: $emailAddress
    firstName: $firstName
    lastName: $lastName
  ) {
    success
  }
}
    `;
export type AccountUserInviteMutationFn = Apollo.MutationFunction<AccountUserInviteMutation, AccountUserInviteMutationVariables>;

/**
 * __useAccountUserInviteMutation__
 *
 * To run a mutation, you first call `useAccountUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserInviteMutation, { data, loading, error }] = useAccountUserInviteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      accountRoleId: // value for 'accountRoleId'
 *      emailAddress: // value for 'emailAddress'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useAccountUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserInviteMutation, AccountUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserInviteMutation, AccountUserInviteMutationVariables>(AccountUserInviteDocument, options);
      }
export type AccountUserInviteMutationHookResult = ReturnType<typeof useAccountUserInviteMutation>;
export type AccountUserInviteMutationResult = Apollo.MutationResult<AccountUserInviteMutation>;
export type AccountUserInviteMutationOptions = Apollo.BaseMutationOptions<AccountUserInviteMutation, AccountUserInviteMutationVariables>;
export const AccountUserByEmailDocument = gql`
    query AccountUserByEmail($accountId: ID!, $emailAddress: String!) {
  accountUserByEmail(accountId: $accountId, emailAddress: $emailAddress) {
    id
    firstName
    lastName
    emailAddress
    userStatus
    homeOrganizationId
    accountMembershipStatus
  }
}
    `;

/**
 * __useAccountUserByEmailQuery__
 *
 * To run a query within a React component, call `useAccountUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUserByEmailQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useAccountUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<AccountUserByEmailQuery, AccountUserByEmailQueryVariables> & ({ variables: AccountUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>(AccountUserByEmailDocument, options);
      }
export function useAccountUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>(AccountUserByEmailDocument, options);
        }
export function useAccountUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>(AccountUserByEmailDocument, options);
        }
export type AccountUserByEmailQueryHookResult = ReturnType<typeof useAccountUserByEmailQuery>;
export type AccountUserByEmailLazyQueryHookResult = ReturnType<typeof useAccountUserByEmailLazyQuery>;
export type AccountUserByEmailSuspenseQueryHookResult = ReturnType<typeof useAccountUserByEmailSuspenseQuery>;
export type AccountUserByEmailQueryResult = Apollo.QueryResult<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>;
export const AccountUserSuspendDocument = gql`
    mutation AccountUserSuspend($accountId: ID!, $userId: ID!) {
  accountUserSuspend2(accountId: $accountId, userId: $userId) {
    success
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUserSuspendMutationFn = Apollo.MutationFunction<AccountUserSuspendMutation, AccountUserSuspendMutationVariables>;

/**
 * __useAccountUserSuspendMutation__
 *
 * To run a mutation, you first call `useAccountUserSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserSuspendMutation, { data, loading, error }] = useAccountUserSuspendMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserSuspendMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserSuspendMutation, AccountUserSuspendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserSuspendMutation, AccountUserSuspendMutationVariables>(AccountUserSuspendDocument, options);
      }
export type AccountUserSuspendMutationHookResult = ReturnType<typeof useAccountUserSuspendMutation>;
export type AccountUserSuspendMutationResult = Apollo.MutationResult<AccountUserSuspendMutation>;
export type AccountUserSuspendMutationOptions = Apollo.BaseMutationOptions<AccountUserSuspendMutation, AccountUserSuspendMutationVariables>;
export const AccountUserInviteCancelDocument = gql`
    mutation AccountUserInviteCancel($accountId: ID!, $userId: ID!) {
  accountUserInviteCancel(accountId: $accountId, userId: $userId) {
    success
    accountUser {
      ...AccountMemberStatusFields
    }
  }
}
    ${AccountMemberStatusFieldsFragmentDoc}`;
export type AccountUserInviteCancelMutationFn = Apollo.MutationFunction<AccountUserInviteCancelMutation, AccountUserInviteCancelMutationVariables>;

/**
 * __useAccountUserInviteCancelMutation__
 *
 * To run a mutation, you first call `useAccountUserInviteCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserInviteCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserInviteCancelMutation, { data, loading, error }] = useAccountUserInviteCancelMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserInviteCancelMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserInviteCancelMutation, AccountUserInviteCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserInviteCancelMutation, AccountUserInviteCancelMutationVariables>(AccountUserInviteCancelDocument, options);
      }
export type AccountUserInviteCancelMutationHookResult = ReturnType<typeof useAccountUserInviteCancelMutation>;
export type AccountUserInviteCancelMutationResult = Apollo.MutationResult<AccountUserInviteCancelMutation>;
export type AccountUserInviteCancelMutationOptions = Apollo.BaseMutationOptions<AccountUserInviteCancelMutation, AccountUserInviteCancelMutationVariables>;
export const AccountUserReinviteDocument = gql`
    mutation AccountUserReinvite($accountId: ID!, $userId: ID!) {
  accountUserReinvite(accountId: $accountId, userId: $userId) {
    success
    accountUser {
      ...AccountMemberStatusFields
    }
  }
}
    ${AccountMemberStatusFieldsFragmentDoc}`;
export type AccountUserReinviteMutationFn = Apollo.MutationFunction<AccountUserReinviteMutation, AccountUserReinviteMutationVariables>;

/**
 * __useAccountUserReinviteMutation__
 *
 * To run a mutation, you first call `useAccountUserReinviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserReinviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserReinviteMutation, { data, loading, error }] = useAccountUserReinviteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserReinviteMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserReinviteMutation, AccountUserReinviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserReinviteMutation, AccountUserReinviteMutationVariables>(AccountUserReinviteDocument, options);
      }
export type AccountUserReinviteMutationHookResult = ReturnType<typeof useAccountUserReinviteMutation>;
export type AccountUserReinviteMutationResult = Apollo.MutationResult<AccountUserReinviteMutation>;
export type AccountUserReinviteMutationOptions = Apollo.BaseMutationOptions<AccountUserReinviteMutation, AccountUserReinviteMutationVariables>;
export const AccountUserReactivateDocument = gql`
    mutation AccountUserReactivate($accountId: ID!, $userId: ID!) {
  accountUserReactivate(accountId: $accountId, userId: $userId) {
    success
    accountUser {
      ...AccountMemberStatusFields
    }
  }
}
    ${AccountMemberStatusFieldsFragmentDoc}`;
export type AccountUserReactivateMutationFn = Apollo.MutationFunction<AccountUserReactivateMutation, AccountUserReactivateMutationVariables>;

/**
 * __useAccountUserReactivateMutation__
 *
 * To run a mutation, you first call `useAccountUserReactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserReactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserReactivateMutation, { data, loading, error }] = useAccountUserReactivateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserReactivateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserReactivateMutation, AccountUserReactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserReactivateMutation, AccountUserReactivateMutationVariables>(AccountUserReactivateDocument, options);
      }
export type AccountUserReactivateMutationHookResult = ReturnType<typeof useAccountUserReactivateMutation>;
export type AccountUserReactivateMutationResult = Apollo.MutationResult<AccountUserReactivateMutation>;
export type AccountUserReactivateMutationOptions = Apollo.BaseMutationOptions<AccountUserReactivateMutation, AccountUserReactivateMutationVariables>;
export const AccountUserRemoveDocument = gql`
    mutation AccountUserRemove($accountId: ID!, $userId: ID!) {
  accountUserRemove(accountId: $accountId, userId: $userId) {
    success
    accountUser {
      ...AccountMemberStatusFields
    }
  }
}
    ${AccountMemberStatusFieldsFragmentDoc}`;
export type AccountUserRemoveMutationFn = Apollo.MutationFunction<AccountUserRemoveMutation, AccountUserRemoveMutationVariables>;

/**
 * __useAccountUserRemoveMutation__
 *
 * To run a mutation, you first call `useAccountUserRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserRemoveMutation, { data, loading, error }] = useAccountUserRemoveMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserRemoveMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserRemoveMutation, AccountUserRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserRemoveMutation, AccountUserRemoveMutationVariables>(AccountUserRemoveDocument, options);
      }
export type AccountUserRemoveMutationHookResult = ReturnType<typeof useAccountUserRemoveMutation>;
export type AccountUserRemoveMutationResult = Apollo.MutationResult<AccountUserRemoveMutation>;
export type AccountUserRemoveMutationOptions = Apollo.BaseMutationOptions<AccountUserRemoveMutation, AccountUserRemoveMutationVariables>;
export const UserRoleCreateDocument = gql`
    mutation UserRoleCreate($roleName: ID!, $userId: ID!) {
  userRoleCreate2(roleName: $roleName, userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserRoleCreateMutationFn = Apollo.MutationFunction<UserRoleCreateMutation, UserRoleCreateMutationVariables>;

/**
 * __useUserRoleCreateMutation__
 *
 * To run a mutation, you first call `useUserRoleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRoleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRoleCreateMutation, { data, loading, error }] = useUserRoleCreateMutation({
 *   variables: {
 *      roleName: // value for 'roleName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserRoleCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserRoleCreateMutation, UserRoleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRoleCreateMutation, UserRoleCreateMutationVariables>(UserRoleCreateDocument, options);
      }
export type UserRoleCreateMutationHookResult = ReturnType<typeof useUserRoleCreateMutation>;
export type UserRoleCreateMutationResult = Apollo.MutationResult<UserRoleCreateMutation>;
export type UserRoleCreateMutationOptions = Apollo.BaseMutationOptions<UserRoleCreateMutation, UserRoleCreateMutationVariables>;
export const UserRoleDeleteDocument = gql`
    mutation UserRoleDelete($roleName: ID!, $userId: ID!) {
  userRoleDelete2(roleName: $roleName, userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserRoleDeleteMutationFn = Apollo.MutationFunction<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>;

/**
 * __useUserRoleDeleteMutation__
 *
 * To run a mutation, you first call `useUserRoleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRoleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRoleDeleteMutation, { data, loading, error }] = useUserRoleDeleteMutation({
 *   variables: {
 *      roleName: // value for 'roleName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserRoleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>(UserRoleDeleteDocument, options);
      }
export type UserRoleDeleteMutationHookResult = ReturnType<typeof useUserRoleDeleteMutation>;
export type UserRoleDeleteMutationResult = Apollo.MutationResult<UserRoleDeleteMutation>;
export type UserRoleDeleteMutationOptions = Apollo.BaseMutationOptions<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>;
export const OrganizationUserRoleAssignDocument = gql`
    mutation OrganizationUserRoleAssign($userId: ID!, $organizationRoleId: ID!) {
  organizationUserRoleAssign(
    userId: $userId
    organizationRoleId: $organizationRoleId
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserRoleAssignMutationFn = Apollo.MutationFunction<OrganizationUserRoleAssignMutation, OrganizationUserRoleAssignMutationVariables>;

/**
 * __useOrganizationUserRoleAssignMutation__
 *
 * To run a mutation, you first call `useOrganizationUserRoleAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserRoleAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserRoleAssignMutation, { data, loading, error }] = useOrganizationUserRoleAssignMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationRoleId: // value for 'organizationRoleId'
 *   },
 * });
 */
export function useOrganizationUserRoleAssignMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserRoleAssignMutation, OrganizationUserRoleAssignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserRoleAssignMutation, OrganizationUserRoleAssignMutationVariables>(OrganizationUserRoleAssignDocument, options);
      }
export type OrganizationUserRoleAssignMutationHookResult = ReturnType<typeof useOrganizationUserRoleAssignMutation>;
export type OrganizationUserRoleAssignMutationResult = Apollo.MutationResult<OrganizationUserRoleAssignMutation>;
export type OrganizationUserRoleAssignMutationOptions = Apollo.BaseMutationOptions<OrganizationUserRoleAssignMutation, OrganizationUserRoleAssignMutationVariables>;
export const AccountUserRoleCreateDocument = gql`
    mutation AccountUserRoleCreate($accountId: ID!, $roleName: ID!, $userId: ID!) {
  accountUserRoleCreate2(
    accountId: $accountId
    roleName: $roleName
    userId: $userId
  ) {
    success
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUserRoleCreateMutationFn = Apollo.MutationFunction<AccountUserRoleCreateMutation, AccountUserRoleCreateMutationVariables>;

/**
 * __useAccountUserRoleCreateMutation__
 *
 * To run a mutation, you first call `useAccountUserRoleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserRoleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserRoleCreateMutation, { data, loading, error }] = useAccountUserRoleCreateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      roleName: // value for 'roleName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserRoleCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserRoleCreateMutation, AccountUserRoleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserRoleCreateMutation, AccountUserRoleCreateMutationVariables>(AccountUserRoleCreateDocument, options);
      }
export type AccountUserRoleCreateMutationHookResult = ReturnType<typeof useAccountUserRoleCreateMutation>;
export type AccountUserRoleCreateMutationResult = Apollo.MutationResult<AccountUserRoleCreateMutation>;
export type AccountUserRoleCreateMutationOptions = Apollo.BaseMutationOptions<AccountUserRoleCreateMutation, AccountUserRoleCreateMutationVariables>;
export const AccountUserRoleDeleteDocument = gql`
    mutation AccountUserRoleDelete($accountId: ID!, $roleName: ID!, $userId: ID!) {
  accountUserRoleDelete2(
    accountId: $accountId
    roleName: $roleName
    userId: $userId
  ) {
    success
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUserRoleDeleteMutationFn = Apollo.MutationFunction<AccountUserRoleDeleteMutation, AccountUserRoleDeleteMutationVariables>;

/**
 * __useAccountUserRoleDeleteMutation__
 *
 * To run a mutation, you first call `useAccountUserRoleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserRoleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserRoleDeleteMutation, { data, loading, error }] = useAccountUserRoleDeleteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      roleName: // value for 'roleName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountUserRoleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserRoleDeleteMutation, AccountUserRoleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserRoleDeleteMutation, AccountUserRoleDeleteMutationVariables>(AccountUserRoleDeleteDocument, options);
      }
export type AccountUserRoleDeleteMutationHookResult = ReturnType<typeof useAccountUserRoleDeleteMutation>;
export type AccountUserRoleDeleteMutationResult = Apollo.MutationResult<AccountUserRoleDeleteMutation>;
export type AccountUserRoleDeleteMutationOptions = Apollo.BaseMutationOptions<AccountUserRoleDeleteMutation, AccountUserRoleDeleteMutationVariables>;
export const AccountUserSwitchRoleDocument = gql`
    mutation AccountUserSwitchRole($userId: ID!, $roleId: ID!) {
  accountUserSwitchRole(userId: $userId, roleId: $roleId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type AccountUserSwitchRoleMutationFn = Apollo.MutationFunction<AccountUserSwitchRoleMutation, AccountUserSwitchRoleMutationVariables>;

/**
 * __useAccountUserSwitchRoleMutation__
 *
 * To run a mutation, you first call `useAccountUserSwitchRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserSwitchRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserSwitchRoleMutation, { data, loading, error }] = useAccountUserSwitchRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAccountUserSwitchRoleMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserSwitchRoleMutation, AccountUserSwitchRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserSwitchRoleMutation, AccountUserSwitchRoleMutationVariables>(AccountUserSwitchRoleDocument, options);
      }
export type AccountUserSwitchRoleMutationHookResult = ReturnType<typeof useAccountUserSwitchRoleMutation>;
export type AccountUserSwitchRoleMutationResult = Apollo.MutationResult<AccountUserSwitchRoleMutation>;
export type AccountUserSwitchRoleMutationOptions = Apollo.BaseMutationOptions<AccountUserSwitchRoleMutation, AccountUserSwitchRoleMutationVariables>;
export const OrganizationUserUpdateDocument = gql`
    mutation OrganizationUserUpdate($userId: ID!, $firstName: String!, $lastName: String!, $accountRoles: [AccountRoleWithRequiredRoleInput!]!) {
  organizationUserUpdate(
    userId: $userId
    firstName: $firstName
    lastName: $lastName
    accountRoles: $accountRoles
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
    results {
      userUpdateFailed
      successfulAccountIds
      failedAccountIds
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserUpdateMutationFn = Apollo.MutationFunction<OrganizationUserUpdateMutation, OrganizationUserUpdateMutationVariables>;

/**
 * __useOrganizationUserUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserUpdateMutation, { data, loading, error }] = useOrganizationUserUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      accountRoles: // value for 'accountRoles'
 *   },
 * });
 */
export function useOrganizationUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserUpdateMutation, OrganizationUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserUpdateMutation, OrganizationUserUpdateMutationVariables>(OrganizationUserUpdateDocument, options);
      }
export type OrganizationUserUpdateMutationHookResult = ReturnType<typeof useOrganizationUserUpdateMutation>;
export type OrganizationUserUpdateMutationResult = Apollo.MutationResult<OrganizationUserUpdateMutation>;
export type OrganizationUserUpdateMutationOptions = Apollo.BaseMutationOptions<OrganizationUserUpdateMutation, OrganizationUserUpdateMutationVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID, $activeOnly: Boolean) {
  organization(organizationId: $organizationId) {
    id
    name
    deactivated
    createdAt
    authConnection
    updatedAt
    organizationRoles {
      id
      name
    }
    members2 {
      id
      firstName
      lastName
      emailAddress
      lastLogin
      status
      userType
      inviteExpiresAt
      createdAt
      isAdmin
      isOwner
      organizationRole
      isSuperuser
      roles {
        id
        name
        accountId
      }
      organizationAccountMembers {
        account {
          id
          displayName
          createdAt
        }
        status
      }
    }
    accountSummaries(activeOnly: $activeOnly) {
      id
      displayName
      deactivated
      createdAt
      updatedAt
      userCount
      roles {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export function useOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationSuspenseQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const AccountDocument = gql`
    query Account($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables> & ({ variables: AccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export function useAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountSuspenseQueryHookResult = ReturnType<typeof useAccountSuspenseQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AccountCreateDocument = gql`
    mutation AccountCreate($displayName: String!, $organizationId: ID!) {
  accountCreate(displayName: $displayName, organizationId: $organizationId) {
    success
    account {
      id
      displayName
      createdAt
      members {
        user {
          id
        }
      }
    }
  }
}
    `;
export type AccountCreateMutationFn = Apollo.MutationFunction<AccountCreateMutation, AccountCreateMutationVariables>;

/**
 * __useAccountCreateMutation__
 *
 * To run a mutation, you first call `useAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountCreateMutation, { data, loading, error }] = useAccountCreateMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountCreateMutation, AccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountCreateMutation, AccountCreateMutationVariables>(AccountCreateDocument, options);
      }
export type AccountCreateMutationHookResult = ReturnType<typeof useAccountCreateMutation>;
export type AccountCreateMutationResult = Apollo.MutationResult<AccountCreateMutation>;
export type AccountCreateMutationOptions = Apollo.BaseMutationOptions<AccountCreateMutation, AccountCreateMutationVariables>;
export const AccountDeactivateDocument = gql`
    mutation AccountDeactivate($id: ID!) {
  accountDeactivate(id: $id) {
    success
  }
}
    `;
export type AccountDeactivateMutationFn = Apollo.MutationFunction<AccountDeactivateMutation, AccountDeactivateMutationVariables>;

/**
 * __useAccountDeactivateMutation__
 *
 * To run a mutation, you first call `useAccountDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeactivateMutation, { data, loading, error }] = useAccountDeactivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<AccountDeactivateMutation, AccountDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountDeactivateMutation, AccountDeactivateMutationVariables>(AccountDeactivateDocument, options);
      }
export type AccountDeactivateMutationHookResult = ReturnType<typeof useAccountDeactivateMutation>;
export type AccountDeactivateMutationResult = Apollo.MutationResult<AccountDeactivateMutation>;
export type AccountDeactivateMutationOptions = Apollo.BaseMutationOptions<AccountDeactivateMutation, AccountDeactivateMutationVariables>;
export const AccountReactivateDocument = gql`
    mutation AccountReactivate($id: ID!) {
  accountReactivate(id: $id) {
    success
    organization {
      id
      name
      updatedAt
      accountSummaries {
        id
        displayName
        deactivated
        createdAt
        updatedAt
        userCount
      }
    }
  }
}
    `;
export type AccountReactivateMutationFn = Apollo.MutationFunction<AccountReactivateMutation, AccountReactivateMutationVariables>;

/**
 * __useAccountReactivateMutation__
 *
 * To run a mutation, you first call `useAccountReactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountReactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountReactivateMutation, { data, loading, error }] = useAccountReactivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountReactivateMutation(baseOptions?: Apollo.MutationHookOptions<AccountReactivateMutation, AccountReactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountReactivateMutation, AccountReactivateMutationVariables>(AccountReactivateDocument, options);
      }
export type AccountReactivateMutationHookResult = ReturnType<typeof useAccountReactivateMutation>;
export type AccountReactivateMutationResult = Apollo.MutationResult<AccountReactivateMutation>;
export type AccountReactivateMutationOptions = Apollo.BaseMutationOptions<AccountReactivateMutation, AccountReactivateMutationVariables>;
export const OrganizationUserDocument = gql`
    query OrganizationUser($userId: ID) {
  organizationUser2(userId: $userId) {
    ...OrganizationUser2Fields
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;

/**
 * __useOrganizationUserQuery__
 *
 * To run a query within a React component, call `useOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationUserQuery, OrganizationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationUserQuery, OrganizationUserQueryVariables>(OrganizationUserDocument, options);
      }
export function useOrganizationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationUserQuery, OrganizationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationUserQuery, OrganizationUserQueryVariables>(OrganizationUserDocument, options);
        }
export function useOrganizationUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationUserQuery, OrganizationUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationUserQuery, OrganizationUserQueryVariables>(OrganizationUserDocument, options);
        }
export type OrganizationUserQueryHookResult = ReturnType<typeof useOrganizationUserQuery>;
export type OrganizationUserLazyQueryHookResult = ReturnType<typeof useOrganizationUserLazyQuery>;
export type OrganizationUserSuspenseQueryHookResult = ReturnType<typeof useOrganizationUserSuspenseQuery>;
export type OrganizationUserQueryResult = Apollo.QueryResult<OrganizationUserQuery, OrganizationUserQueryVariables>;
export const OrganizationsDocument = gql`
    query Organizations {
  organizations {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
      }
export function useOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export function useOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export type OrganizationsQueryHookResult = ReturnType<typeof useOrganizationsQuery>;
export type OrganizationsLazyQueryHookResult = ReturnType<typeof useOrganizationsLazyQuery>;
export type OrganizationsSuspenseQueryHookResult = ReturnType<typeof useOrganizationsSuspenseQuery>;
export type OrganizationsQueryResult = Apollo.QueryResult<OrganizationsQuery, OrganizationsQueryVariables>;
export const OrganizationCreateDocument = gql`
    mutation OrganizationCreate($name: String!, $allowlistedDomains: [String!], $authConnectionId: String, $enableMfa: Boolean) {
  organizationCreate(
    name: $name
    allowlistedDomains: $allowlistedDomains
    authConnection: $authConnectionId
    enableMfa: $enableMfa
  ) {
    success
    organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type OrganizationCreateMutationFn = Apollo.MutationFunction<OrganizationCreateMutation, OrganizationCreateMutationVariables>;

/**
 * __useOrganizationCreateMutation__
 *
 * To run a mutation, you first call `useOrganizationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationCreateMutation, { data, loading, error }] = useOrganizationCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      allowlistedDomains: // value for 'allowlistedDomains'
 *      authConnectionId: // value for 'authConnectionId'
 *      enableMfa: // value for 'enableMfa'
 *   },
 * });
 */
export function useOrganizationCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationCreateMutation, OrganizationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationCreateMutation, OrganizationCreateMutationVariables>(OrganizationCreateDocument, options);
      }
export type OrganizationCreateMutationHookResult = ReturnType<typeof useOrganizationCreateMutation>;
export type OrganizationCreateMutationResult = Apollo.MutationResult<OrganizationCreateMutation>;
export type OrganizationCreateMutationOptions = Apollo.BaseMutationOptions<OrganizationCreateMutation, OrganizationCreateMutationVariables>;
export const OrganizationDeactivateDocument = gql`
    mutation OrganizationDeactivate($id: ID!) {
  organizationDeactivate(id: $id) {
    success
  }
}
    `;
export type OrganizationDeactivateMutationFn = Apollo.MutationFunction<OrganizationDeactivateMutation, OrganizationDeactivateMutationVariables>;

/**
 * __useOrganizationDeactivateMutation__
 *
 * To run a mutation, you first call `useOrganizationDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDeactivateMutation, { data, loading, error }] = useOrganizationDeactivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationDeactivateMutation, OrganizationDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationDeactivateMutation, OrganizationDeactivateMutationVariables>(OrganizationDeactivateDocument, options);
      }
export type OrganizationDeactivateMutationHookResult = ReturnType<typeof useOrganizationDeactivateMutation>;
export type OrganizationDeactivateMutationResult = Apollo.MutationResult<OrganizationDeactivateMutation>;
export type OrganizationDeactivateMutationOptions = Apollo.BaseMutationOptions<OrganizationDeactivateMutation, OrganizationDeactivateMutationVariables>;
export const OrganizationReactivateDocument = gql`
    mutation OrganizationReactivate($id: ID!) {
  organizationReactivate(id: $id) {
    success
    organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type OrganizationReactivateMutationFn = Apollo.MutationFunction<OrganizationReactivateMutation, OrganizationReactivateMutationVariables>;

/**
 * __useOrganizationReactivateMutation__
 *
 * To run a mutation, you first call `useOrganizationReactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationReactivateMutation, { data, loading, error }] = useOrganizationReactivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationReactivateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationReactivateMutation, OrganizationReactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationReactivateMutation, OrganizationReactivateMutationVariables>(OrganizationReactivateDocument, options);
      }
export type OrganizationReactivateMutationHookResult = ReturnType<typeof useOrganizationReactivateMutation>;
export type OrganizationReactivateMutationResult = Apollo.MutationResult<OrganizationReactivateMutation>;
export type OrganizationReactivateMutationOptions = Apollo.BaseMutationOptions<OrganizationReactivateMutation, OrganizationReactivateMutationVariables>;
export const OrganizationUpdateDocument = gql`
    mutation OrganizationUpdate($id: ID!, $name: String, $allowlistedDomains: [String!], $authConnectionId: String, $enableMfa: Boolean) {
  organizationUpdate(
    id: $id
    name: $name
    allowlistedDomains: $allowlistedDomains
    authConnection: $authConnectionId
    enableMfa: $enableMfa
  ) {
    success
    organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type OrganizationUpdateMutationFn = Apollo.MutationFunction<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;

/**
 * __useOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMutation, { data, loading, error }] = useOrganizationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      allowlistedDomains: // value for 'allowlistedDomains'
 *      authConnectionId: // value for 'authConnectionId'
 *      enableMfa: // value for 'enableMfa'
 *   },
 * });
 */
export function useOrganizationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>(OrganizationUpdateDocument, options);
      }
export type OrganizationUpdateMutationHookResult = ReturnType<typeof useOrganizationUpdateMutation>;
export type OrganizationUpdateMutationResult = Apollo.MutationResult<OrganizationUpdateMutation>;
export type OrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;
export const UserInvitationResendDocument = gql`
    mutation UserInvitationResend($userIdentifier: UserIdentifierInput!) {
  userInvitationResend2(userIdentifier: $userIdentifier) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserInvitationResendMutationFn = Apollo.MutationFunction<UserInvitationResendMutation, UserInvitationResendMutationVariables>;

/**
 * __useUserInvitationResendMutation__
 *
 * To run a mutation, you first call `useUserInvitationResendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInvitationResendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInvitationResendMutation, { data, loading, error }] = useUserInvitationResendMutation({
 *   variables: {
 *      userIdentifier: // value for 'userIdentifier'
 *   },
 * });
 */
export function useUserInvitationResendMutation(baseOptions?: Apollo.MutationHookOptions<UserInvitationResendMutation, UserInvitationResendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserInvitationResendMutation, UserInvitationResendMutationVariables>(UserInvitationResendDocument, options);
      }
export type UserInvitationResendMutationHookResult = ReturnType<typeof useUserInvitationResendMutation>;
export type UserInvitationResendMutationResult = Apollo.MutationResult<UserInvitationResendMutation>;
export type UserInvitationResendMutationOptions = Apollo.BaseMutationOptions<UserInvitationResendMutation, UserInvitationResendMutationVariables>;
export const UserAccountInviteApproveDocument = gql`
    mutation UserAccountInviteApprove($accountId: ID!, $emailAddress: String!) {
  userAccountInviteApprove(accountId: $accountId, emailAddress: $emailAddress) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserAccountInviteApproveMutationFn = Apollo.MutationFunction<UserAccountInviteApproveMutation, UserAccountInviteApproveMutationVariables>;

/**
 * __useUserAccountInviteApproveMutation__
 *
 * To run a mutation, you first call `useUserAccountInviteApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccountInviteApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccountInviteApproveMutation, { data, loading, error }] = useUserAccountInviteApproveMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useUserAccountInviteApproveMutation(baseOptions?: Apollo.MutationHookOptions<UserAccountInviteApproveMutation, UserAccountInviteApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccountInviteApproveMutation, UserAccountInviteApproveMutationVariables>(UserAccountInviteApproveDocument, options);
      }
export type UserAccountInviteApproveMutationHookResult = ReturnType<typeof useUserAccountInviteApproveMutation>;
export type UserAccountInviteApproveMutationResult = Apollo.MutationResult<UserAccountInviteApproveMutation>;
export type UserAccountInviteApproveMutationOptions = Apollo.BaseMutationOptions<UserAccountInviteApproveMutation, UserAccountInviteApproveMutationVariables>;
export const UserAccountInviteDeclineDocument = gql`
    mutation UserAccountInviteDecline($accountId: ID!, $emailAddress: String!) {
  userAccountInviteDecline(accountId: $accountId, emailAddress: $emailAddress) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserAccountInviteDeclineMutationFn = Apollo.MutationFunction<UserAccountInviteDeclineMutation, UserAccountInviteDeclineMutationVariables>;

/**
 * __useUserAccountInviteDeclineMutation__
 *
 * To run a mutation, you first call `useUserAccountInviteDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccountInviteDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccountInviteDeclineMutation, { data, loading, error }] = useUserAccountInviteDeclineMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useUserAccountInviteDeclineMutation(baseOptions?: Apollo.MutationHookOptions<UserAccountInviteDeclineMutation, UserAccountInviteDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccountInviteDeclineMutation, UserAccountInviteDeclineMutationVariables>(UserAccountInviteDeclineDocument, options);
      }
export type UserAccountInviteDeclineMutationHookResult = ReturnType<typeof useUserAccountInviteDeclineMutation>;
export type UserAccountInviteDeclineMutationResult = Apollo.MutationResult<UserAccountInviteDeclineMutation>;
export type UserAccountInviteDeclineMutationOptions = Apollo.BaseMutationOptions<UserAccountInviteDeclineMutation, UserAccountInviteDeclineMutationVariables>;
export const UserInvitationCancelDocument = gql`
    mutation UserInvitationCancel($userId: ID!, $orgId: ID!) {
  userInvitationCancel2(userId: $userId, orgId: $orgId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type UserInvitationCancelMutationFn = Apollo.MutationFunction<UserInvitationCancelMutation, UserInvitationCancelMutationVariables>;

/**
 * __useUserInvitationCancelMutation__
 *
 * To run a mutation, you first call `useUserInvitationCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInvitationCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInvitationCancelMutation, { data, loading, error }] = useUserInvitationCancelMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUserInvitationCancelMutation(baseOptions?: Apollo.MutationHookOptions<UserInvitationCancelMutation, UserInvitationCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserInvitationCancelMutation, UserInvitationCancelMutationVariables>(UserInvitationCancelDocument, options);
      }
export type UserInvitationCancelMutationHookResult = ReturnType<typeof useUserInvitationCancelMutation>;
export type UserInvitationCancelMutationResult = Apollo.MutationResult<UserInvitationCancelMutation>;
export type UserInvitationCancelMutationOptions = Apollo.BaseMutationOptions<UserInvitationCancelMutation, UserInvitationCancelMutationVariables>;
export const OrganizationUserInviteDocument = gql`
    mutation OrganizationUserInvite($organizationId: ID!, $emailAddress: String!, $firstName: String, $lastName: String, $accountId: ID, $accountRoleId: ID) {
  organizationUserInvite(
    organizationId: $organizationId
    emailAddress: $emailAddress
    firstName: $firstName
    lastName: $lastName
    accountId: $accountId
    accountRoleId: $accountRoleId
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserInviteMutationFn = Apollo.MutationFunction<OrganizationUserInviteMutation, OrganizationUserInviteMutationVariables>;

/**
 * __useOrganizationUserInviteMutation__
 *
 * To run a mutation, you first call `useOrganizationUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserInviteMutation, { data, loading, error }] = useOrganizationUserInviteMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      emailAddress: // value for 'emailAddress'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      accountId: // value for 'accountId'
 *      accountRoleId: // value for 'accountRoleId'
 *   },
 * });
 */
export function useOrganizationUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserInviteMutation, OrganizationUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserInviteMutation, OrganizationUserInviteMutationVariables>(OrganizationUserInviteDocument, options);
      }
export type OrganizationUserInviteMutationHookResult = ReturnType<typeof useOrganizationUserInviteMutation>;
export type OrganizationUserInviteMutationResult = Apollo.MutationResult<OrganizationUserInviteMutation>;
export type OrganizationUserInviteMutationOptions = Apollo.BaseMutationOptions<OrganizationUserInviteMutation, OrganizationUserInviteMutationVariables>;
export const AccountUserAddDocument = gql`
    mutation AccountUserAdd($accountId: ID!, $userId: ID!, $accountRoleId: ID!) {
  accountUserAdd(
    accountId: $accountId
    userId: $userId
    accountRoleId: $accountRoleId
  ) {
    success
    user {
      ...OrganizationUser2Fields
    }
    accountUser {
      ...AccountMemberStatusFields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}
${AccountMemberStatusFieldsFragmentDoc}`;
export type AccountUserAddMutationFn = Apollo.MutationFunction<AccountUserAddMutation, AccountUserAddMutationVariables>;

/**
 * __useAccountUserAddMutation__
 *
 * To run a mutation, you first call `useAccountUserAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserAddMutation, { data, loading, error }] = useAccountUserAddMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *      accountRoleId: // value for 'accountRoleId'
 *   },
 * });
 */
export function useAccountUserAddMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserAddMutation, AccountUserAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserAddMutation, AccountUserAddMutationVariables>(AccountUserAddDocument, options);
      }
export type AccountUserAddMutationHookResult = ReturnType<typeof useAccountUserAddMutation>;
export type AccountUserAddMutationResult = Apollo.MutationResult<AccountUserAddMutation>;
export type AccountUserAddMutationOptions = Apollo.BaseMutationOptions<AccountUserAddMutation, AccountUserAddMutationVariables>;
export const OrganizationUserInviteCancelDocument = gql`
    mutation OrganizationUserInviteCancel($userId: ID!) {
  organizationUserInviteCancel(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserInviteCancelMutationFn = Apollo.MutationFunction<OrganizationUserInviteCancelMutation, OrganizationUserInviteCancelMutationVariables>;

/**
 * __useOrganizationUserInviteCancelMutation__
 *
 * To run a mutation, you first call `useOrganizationUserInviteCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserInviteCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserInviteCancelMutation, { data, loading, error }] = useOrganizationUserInviteCancelMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserInviteCancelMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserInviteCancelMutation, OrganizationUserInviteCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserInviteCancelMutation, OrganizationUserInviteCancelMutationVariables>(OrganizationUserInviteCancelDocument, options);
      }
export type OrganizationUserInviteCancelMutationHookResult = ReturnType<typeof useOrganizationUserInviteCancelMutation>;
export type OrganizationUserInviteCancelMutationResult = Apollo.MutationResult<OrganizationUserInviteCancelMutation>;
export type OrganizationUserInviteCancelMutationOptions = Apollo.BaseMutationOptions<OrganizationUserInviteCancelMutation, OrganizationUserInviteCancelMutationVariables>;
export const OrganizationUserInviteApproveDocument = gql`
    mutation OrganizationUserInviteApprove($userId: ID!) {
  organizationUserInviteApprove(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserInviteApproveMutationFn = Apollo.MutationFunction<OrganizationUserInviteApproveMutation, OrganizationUserInviteApproveMutationVariables>;

/**
 * __useOrganizationUserInviteApproveMutation__
 *
 * To run a mutation, you first call `useOrganizationUserInviteApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserInviteApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserInviteApproveMutation, { data, loading, error }] = useOrganizationUserInviteApproveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserInviteApproveMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserInviteApproveMutation, OrganizationUserInviteApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserInviteApproveMutation, OrganizationUserInviteApproveMutationVariables>(OrganizationUserInviteApproveDocument, options);
      }
export type OrganizationUserInviteApproveMutationHookResult = ReturnType<typeof useOrganizationUserInviteApproveMutation>;
export type OrganizationUserInviteApproveMutationResult = Apollo.MutationResult<OrganizationUserInviteApproveMutation>;
export type OrganizationUserInviteApproveMutationOptions = Apollo.BaseMutationOptions<OrganizationUserInviteApproveMutation, OrganizationUserInviteApproveMutationVariables>;
export const OrganizationUserInviteDeclineDocument = gql`
    mutation OrganizationUserInviteDecline($userId: ID!) {
  organizationUserInviteDecline(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserInviteDeclineMutationFn = Apollo.MutationFunction<OrganizationUserInviteDeclineMutation, OrganizationUserInviteDeclineMutationVariables>;

/**
 * __useOrganizationUserInviteDeclineMutation__
 *
 * To run a mutation, you first call `useOrganizationUserInviteDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserInviteDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserInviteDeclineMutation, { data, loading, error }] = useOrganizationUserInviteDeclineMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserInviteDeclineMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserInviteDeclineMutation, OrganizationUserInviteDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserInviteDeclineMutation, OrganizationUserInviteDeclineMutationVariables>(OrganizationUserInviteDeclineDocument, options);
      }
export type OrganizationUserInviteDeclineMutationHookResult = ReturnType<typeof useOrganizationUserInviteDeclineMutation>;
export type OrganizationUserInviteDeclineMutationResult = Apollo.MutationResult<OrganizationUserInviteDeclineMutation>;
export type OrganizationUserInviteDeclineMutationOptions = Apollo.BaseMutationOptions<OrganizationUserInviteDeclineMutation, OrganizationUserInviteDeclineMutationVariables>;
export const OrganizationUserReinviteDocument = gql`
    mutation OrganizationUserReinvite($userId: ID!) {
  organizationUserReinvite(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserReinviteMutationFn = Apollo.MutationFunction<OrganizationUserReinviteMutation, OrganizationUserReinviteMutationVariables>;

/**
 * __useOrganizationUserReinviteMutation__
 *
 * To run a mutation, you first call `useOrganizationUserReinviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserReinviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserReinviteMutation, { data, loading, error }] = useOrganizationUserReinviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserReinviteMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserReinviteMutation, OrganizationUserReinviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserReinviteMutation, OrganizationUserReinviteMutationVariables>(OrganizationUserReinviteDocument, options);
      }
export type OrganizationUserReinviteMutationHookResult = ReturnType<typeof useOrganizationUserReinviteMutation>;
export type OrganizationUserReinviteMutationResult = Apollo.MutationResult<OrganizationUserReinviteMutation>;
export type OrganizationUserReinviteMutationOptions = Apollo.BaseMutationOptions<OrganizationUserReinviteMutation, OrganizationUserReinviteMutationVariables>;
export const OrganizationUserReactivateDocument = gql`
    mutation OrganizationUserReactivate($userId: ID!) {
  organizationUserReactivate(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserReactivateMutationFn = Apollo.MutationFunction<OrganizationUserReactivateMutation, OrganizationUserReactivateMutationVariables>;

/**
 * __useOrganizationUserReactivateMutation__
 *
 * To run a mutation, you first call `useOrganizationUserReactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserReactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserReactivateMutation, { data, loading, error }] = useOrganizationUserReactivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserReactivateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserReactivateMutation, OrganizationUserReactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserReactivateMutation, OrganizationUserReactivateMutationVariables>(OrganizationUserReactivateDocument, options);
      }
export type OrganizationUserReactivateMutationHookResult = ReturnType<typeof useOrganizationUserReactivateMutation>;
export type OrganizationUserReactivateMutationResult = Apollo.MutationResult<OrganizationUserReactivateMutation>;
export type OrganizationUserReactivateMutationOptions = Apollo.BaseMutationOptions<OrganizationUserReactivateMutation, OrganizationUserReactivateMutationVariables>;
export const OrganizationUserRemoveDocument = gql`
    mutation OrganizationUserRemove($userId: ID!) {
  organizationUserRemove(userId: $userId) {
    success
    user {
      ...OrganizationUser2Fields
    }
  }
}
    ${OrganizationUser2FieldsFragmentDoc}`;
export type OrganizationUserRemoveMutationFn = Apollo.MutationFunction<OrganizationUserRemoveMutation, OrganizationUserRemoveMutationVariables>;

/**
 * __useOrganizationUserRemoveMutation__
 *
 * To run a mutation, you first call `useOrganizationUserRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUserRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUserRemoveMutation, { data, loading, error }] = useOrganizationUserRemoveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganizationUserRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUserRemoveMutation, OrganizationUserRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUserRemoveMutation, OrganizationUserRemoveMutationVariables>(OrganizationUserRemoveDocument, options);
      }
export type OrganizationUserRemoveMutationHookResult = ReturnType<typeof useOrganizationUserRemoveMutation>;
export type OrganizationUserRemoveMutationResult = Apollo.MutationResult<OrganizationUserRemoveMutation>;
export type OrganizationUserRemoveMutationOptions = Apollo.BaseMutationOptions<OrganizationUserRemoveMutation, OrganizationUserRemoveMutationVariables>;
export const AccountRoleCreateDocument = gql`
    mutation AccountRoleCreate($accountId: ID!, $name: String!, $title: String!, $description: String!) {
  accountRoleCreate(
    accountId: $accountId
    name: $name
    title: $title
    description: $description
  ) {
    success
    accountRole {
      ...AccountRoleFields
    }
  }
}
    ${AccountRoleFieldsFragmentDoc}`;
export type AccountRoleCreateMutationFn = Apollo.MutationFunction<AccountRoleCreateMutation, AccountRoleCreateMutationVariables>;

/**
 * __useAccountRoleCreateMutation__
 *
 * To run a mutation, you first call `useAccountRoleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRoleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRoleCreateMutation, { data, loading, error }] = useAccountRoleCreateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      name: // value for 'name'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAccountRoleCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountRoleCreateMutation, AccountRoleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRoleCreateMutation, AccountRoleCreateMutationVariables>(AccountRoleCreateDocument, options);
      }
export type AccountRoleCreateMutationHookResult = ReturnType<typeof useAccountRoleCreateMutation>;
export type AccountRoleCreateMutationResult = Apollo.MutationResult<AccountRoleCreateMutation>;
export type AccountRoleCreateMutationOptions = Apollo.BaseMutationOptions<AccountRoleCreateMutation, AccountRoleCreateMutationVariables>;
export const AccountRoleUpdateDocument = gql`
    mutation AccountRoleUpdate($accountRoleId: ID!, $title: String!, $description: String) {
  accountRoleUpdate(
    accountRoleId: $accountRoleId
    title: $title
    description: $description
  ) {
    success
    accountRole {
      ...AccountRoleFields
    }
  }
}
    ${AccountRoleFieldsFragmentDoc}`;
export type AccountRoleUpdateMutationFn = Apollo.MutationFunction<AccountRoleUpdateMutation, AccountRoleUpdateMutationVariables>;

/**
 * __useAccountRoleUpdateMutation__
 *
 * To run a mutation, you first call `useAccountRoleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRoleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRoleUpdateMutation, { data, loading, error }] = useAccountRoleUpdateMutation({
 *   variables: {
 *      accountRoleId: // value for 'accountRoleId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAccountRoleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccountRoleUpdateMutation, AccountRoleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRoleUpdateMutation, AccountRoleUpdateMutationVariables>(AccountRoleUpdateDocument, options);
      }
export type AccountRoleUpdateMutationHookResult = ReturnType<typeof useAccountRoleUpdateMutation>;
export type AccountRoleUpdateMutationResult = Apollo.MutationResult<AccountRoleUpdateMutation>;
export type AccountRoleUpdateMutationOptions = Apollo.BaseMutationOptions<AccountRoleUpdateMutation, AccountRoleUpdateMutationVariables>;
export const AccountRoleDeleteDocument = gql`
    mutation AccountRoleDelete($accountRoleId: ID!, $replacementAccountRoleId: ID) {
  accountRoleDelete(
    accountRoleId: $accountRoleId
    replacementAccountRoleId: $replacementAccountRoleId
  ) {
    success
  }
}
    `;
export type AccountRoleDeleteMutationFn = Apollo.MutationFunction<AccountRoleDeleteMutation, AccountRoleDeleteMutationVariables>;

/**
 * __useAccountRoleDeleteMutation__
 *
 * To run a mutation, you first call `useAccountRoleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRoleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRoleDeleteMutation, { data, loading, error }] = useAccountRoleDeleteMutation({
 *   variables: {
 *      accountRoleId: // value for 'accountRoleId'
 *      replacementAccountRoleId: // value for 'replacementAccountRoleId'
 *   },
 * });
 */
export function useAccountRoleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AccountRoleDeleteMutation, AccountRoleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRoleDeleteMutation, AccountRoleDeleteMutationVariables>(AccountRoleDeleteDocument, options);
      }
export type AccountRoleDeleteMutationHookResult = ReturnType<typeof useAccountRoleDeleteMutation>;
export type AccountRoleDeleteMutationResult = Apollo.MutationResult<AccountRoleDeleteMutation>;
export type AccountRoleDeleteMutationOptions = Apollo.BaseMutationOptions<AccountRoleDeleteMutation, AccountRoleDeleteMutationVariables>;
export const AvailablePermissionsDocument = gql`
    query AvailablePermissions {
  availablePermissions {
    id
    title
    description
    permissions
    dependsOn
  }
}
    `;

/**
 * __useAvailablePermissionsQuery__
 *
 * To run a query within a React component, call `useAvailablePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailablePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>(AvailablePermissionsDocument, options);
      }
export function useAvailablePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>(AvailablePermissionsDocument, options);
        }
export function useAvailablePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>(AvailablePermissionsDocument, options);
        }
export type AvailablePermissionsQueryHookResult = ReturnType<typeof useAvailablePermissionsQuery>;
export type AvailablePermissionsLazyQueryHookResult = ReturnType<typeof useAvailablePermissionsLazyQuery>;
export type AvailablePermissionsSuspenseQueryHookResult = ReturnType<typeof useAvailablePermissionsSuspenseQuery>;
export type AvailablePermissionsQueryResult = Apollo.QueryResult<AvailablePermissionsQuery, AvailablePermissionsQueryVariables>;
export const AccountRolePermissionsAddDocument = gql`
    mutation AccountRolePermissionsAdd($accountRoleId: ID!, $permissionIds: [ID!]!) {
  accountRolePermissionsAdd(
    accountRoleId: $accountRoleId
    permissionIds: $permissionIds
  ) {
    success
    accountRole {
      ...AccountRoleFields
    }
  }
}
    ${AccountRoleFieldsFragmentDoc}`;
export type AccountRolePermissionsAddMutationFn = Apollo.MutationFunction<AccountRolePermissionsAddMutation, AccountRolePermissionsAddMutationVariables>;

/**
 * __useAccountRolePermissionsAddMutation__
 *
 * To run a mutation, you first call `useAccountRolePermissionsAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRolePermissionsAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRolePermissionsAddMutation, { data, loading, error }] = useAccountRolePermissionsAddMutation({
 *   variables: {
 *      accountRoleId: // value for 'accountRoleId'
 *      permissionIds: // value for 'permissionIds'
 *   },
 * });
 */
export function useAccountRolePermissionsAddMutation(baseOptions?: Apollo.MutationHookOptions<AccountRolePermissionsAddMutation, AccountRolePermissionsAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRolePermissionsAddMutation, AccountRolePermissionsAddMutationVariables>(AccountRolePermissionsAddDocument, options);
      }
export type AccountRolePermissionsAddMutationHookResult = ReturnType<typeof useAccountRolePermissionsAddMutation>;
export type AccountRolePermissionsAddMutationResult = Apollo.MutationResult<AccountRolePermissionsAddMutation>;
export type AccountRolePermissionsAddMutationOptions = Apollo.BaseMutationOptions<AccountRolePermissionsAddMutation, AccountRolePermissionsAddMutationVariables>;
export const AccountRolePermissionsRemoveDocument = gql`
    mutation AccountRolePermissionsRemove($accountRoleId: ID!, $permissionIds: [ID!]!) {
  accountRolePermissionsRemove(
    accountRoleId: $accountRoleId
    permissionIds: $permissionIds
  ) {
    success
    accountRole {
      ...AccountRoleFields
    }
  }
}
    ${AccountRoleFieldsFragmentDoc}`;
export type AccountRolePermissionsRemoveMutationFn = Apollo.MutationFunction<AccountRolePermissionsRemoveMutation, AccountRolePermissionsRemoveMutationVariables>;

/**
 * __useAccountRolePermissionsRemoveMutation__
 *
 * To run a mutation, you first call `useAccountRolePermissionsRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRolePermissionsRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRolePermissionsRemoveMutation, { data, loading, error }] = useAccountRolePermissionsRemoveMutation({
 *   variables: {
 *      accountRoleId: // value for 'accountRoleId'
 *      permissionIds: // value for 'permissionIds'
 *   },
 * });
 */
export function useAccountRolePermissionsRemoveMutation(baseOptions?: Apollo.MutationHookOptions<AccountRolePermissionsRemoveMutation, AccountRolePermissionsRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRolePermissionsRemoveMutation, AccountRolePermissionsRemoveMutationVariables>(AccountRolePermissionsRemoveDocument, options);
      }
export type AccountRolePermissionsRemoveMutationHookResult = ReturnType<typeof useAccountRolePermissionsRemoveMutation>;
export type AccountRolePermissionsRemoveMutationResult = Apollo.MutationResult<AccountRolePermissionsRemoveMutation>;
export type AccountRolePermissionsRemoveMutationOptions = Apollo.BaseMutationOptions<AccountRolePermissionsRemoveMutation, AccountRolePermissionsRemoveMutationVariables>;
export const DataTableDeleteDocument = gql`
    mutation DataTableDelete($id: ID!) {
  dataTableDelete(id: $id) {
    success
    id
  }
}
    `;
export type DataTableDeleteMutationFn = Apollo.MutationFunction<DataTableDeleteMutation, DataTableDeleteMutationVariables>;

/**
 * __useDataTableDeleteMutation__
 *
 * To run a mutation, you first call `useDataTableDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataTableDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataTableDeleteMutation, { data, loading, error }] = useDataTableDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataTableDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataTableDeleteMutation, DataTableDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataTableDeleteMutation, DataTableDeleteMutationVariables>(DataTableDeleteDocument, options);
      }
export type DataTableDeleteMutationHookResult = ReturnType<typeof useDataTableDeleteMutation>;
export type DataTableDeleteMutationResult = Apollo.MutationResult<DataTableDeleteMutation>;
export type DataTableDeleteMutationOptions = Apollo.BaseMutationOptions<DataTableDeleteMutation, DataTableDeleteMutationVariables>;
export const DataTableCreateDocument = gql`
    mutation DataTableCreate($name: String!, $description: String!, $semanticCategory: ID) {
  dataTableCreate(
    name: $name
    description: $description
    semanticCategory: $semanticCategory
  ) {
    success
    table {
      ...DataTablesFragment
    }
  }
}
    ${DataTablesFragmentFragmentDoc}`;
export type DataTableCreateMutationFn = Apollo.MutationFunction<DataTableCreateMutation, DataTableCreateMutationVariables>;

/**
 * __useDataTableCreateMutation__
 *
 * To run a mutation, you first call `useDataTableCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataTableCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataTableCreateMutation, { data, loading, error }] = useDataTableCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      semanticCategory: // value for 'semanticCategory'
 *   },
 * });
 */
export function useDataTableCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataTableCreateMutation, DataTableCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataTableCreateMutation, DataTableCreateMutationVariables>(DataTableCreateDocument, options);
      }
export type DataTableCreateMutationHookResult = ReturnType<typeof useDataTableCreateMutation>;
export type DataTableCreateMutationResult = Apollo.MutationResult<DataTableCreateMutation>;
export type DataTableCreateMutationOptions = Apollo.BaseMutationOptions<DataTableCreateMutation, DataTableCreateMutationVariables>;
export const DataFieldsCreateDocument = gql`
    mutation DataFieldsCreate($name: String!, $displayName: String!, $description: String, $primaryKey: Boolean!, $tableId: ID!, $type: DataFieldType!, $semanticFeature: ID, $channels: [Channel!]) {
  dataFieldCreate(
    name: $name
    displayName: $displayName
    description: $description
    primaryKey: $primaryKey
    tableId: $tableId
    type: $type
    semanticFeature: $semanticFeature
    channelsV2: $channels
  ) {
    success
    field {
      ...DataFieldsFragment
    }
  }
}
    ${DataFieldsFragmentFragmentDoc}`;
export type DataFieldsCreateMutationFn = Apollo.MutationFunction<DataFieldsCreateMutation, DataFieldsCreateMutationVariables>;

/**
 * __useDataFieldsCreateMutation__
 *
 * To run a mutation, you first call `useDataFieldsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataFieldsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataFieldsCreateMutation, { data, loading, error }] = useDataFieldsCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      primaryKey: // value for 'primaryKey'
 *      tableId: // value for 'tableId'
 *      type: // value for 'type'
 *      semanticFeature: // value for 'semanticFeature'
 *      channels: // value for 'channels'
 *   },
 * });
 */
export function useDataFieldsCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataFieldsCreateMutation, DataFieldsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataFieldsCreateMutation, DataFieldsCreateMutationVariables>(DataFieldsCreateDocument, options);
      }
export type DataFieldsCreateMutationHookResult = ReturnType<typeof useDataFieldsCreateMutation>;
export type DataFieldsCreateMutationResult = Apollo.MutationResult<DataFieldsCreateMutation>;
export type DataFieldsCreateMutationOptions = Apollo.BaseMutationOptions<DataFieldsCreateMutation, DataFieldsCreateMutationVariables>;
export const DataFieldUpdateDocument = gql`
    mutation DataFieldUpdate($id: ID!, $name: String!, $displayName: String!, $description: String, $semanticFeature: ID, $type: DataFieldType, $channels: [Channel!]) {
  dataFieldUpdate(
    id: $id
    name: $name
    displayName: $displayName
    description: $description
    semanticFeature: $semanticFeature
    type: $type
    channelsV2: $channels
  ) {
    success
    field {
      ...DataFieldsFragment
    }
  }
}
    ${DataFieldsFragmentFragmentDoc}`;
export type DataFieldUpdateMutationFn = Apollo.MutationFunction<DataFieldUpdateMutation, DataFieldUpdateMutationVariables>;

/**
 * __useDataFieldUpdateMutation__
 *
 * To run a mutation, you first call `useDataFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataFieldUpdateMutation, { data, loading, error }] = useDataFieldUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      semanticFeature: // value for 'semanticFeature'
 *      type: // value for 'type'
 *      channels: // value for 'channels'
 *   },
 * });
 */
export function useDataFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataFieldUpdateMutation, DataFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataFieldUpdateMutation, DataFieldUpdateMutationVariables>(DataFieldUpdateDocument, options);
      }
export type DataFieldUpdateMutationHookResult = ReturnType<typeof useDataFieldUpdateMutation>;
export type DataFieldUpdateMutationResult = Apollo.MutationResult<DataFieldUpdateMutation>;
export type DataFieldUpdateMutationOptions = Apollo.BaseMutationOptions<DataFieldUpdateMutation, DataFieldUpdateMutationVariables>;
export const DataFieldDocument = gql`
    query DataField($id: ID!) {
  dataField(id: $id) {
    ...DataFieldsFragment
  }
}
    ${DataFieldsFragmentFragmentDoc}`;

/**
 * __useDataFieldQuery__
 *
 * To run a query within a React component, call `useDataFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataFieldQuery(baseOptions: Apollo.QueryHookOptions<DataFieldQuery, DataFieldQueryVariables> & ({ variables: DataFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataFieldQuery, DataFieldQueryVariables>(DataFieldDocument, options);
      }
export function useDataFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataFieldQuery, DataFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataFieldQuery, DataFieldQueryVariables>(DataFieldDocument, options);
        }
export function useDataFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataFieldQuery, DataFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataFieldQuery, DataFieldQueryVariables>(DataFieldDocument, options);
        }
export type DataFieldQueryHookResult = ReturnType<typeof useDataFieldQuery>;
export type DataFieldLazyQueryHookResult = ReturnType<typeof useDataFieldLazyQuery>;
export type DataFieldSuspenseQueryHookResult = ReturnType<typeof useDataFieldSuspenseQuery>;
export type DataFieldQueryResult = Apollo.QueryResult<DataFieldQuery, DataFieldQueryVariables>;
export const DataFieldDeleteDocument = gql`
    mutation DataFieldDelete($id: ID!) {
  dataFieldDelete(id: $id) {
    success
    id
  }
}
    `;
export type DataFieldDeleteMutationFn = Apollo.MutationFunction<DataFieldDeleteMutation, DataFieldDeleteMutationVariables>;

/**
 * __useDataFieldDeleteMutation__
 *
 * To run a mutation, you first call `useDataFieldDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataFieldDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataFieldDeleteMutation, { data, loading, error }] = useDataFieldDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataFieldDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataFieldDeleteMutation, DataFieldDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataFieldDeleteMutation, DataFieldDeleteMutationVariables>(DataFieldDeleteDocument, options);
      }
export type DataFieldDeleteMutationHookResult = ReturnType<typeof useDataFieldDeleteMutation>;
export type DataFieldDeleteMutationResult = Apollo.MutationResult<DataFieldDeleteMutation>;
export type DataFieldDeleteMutationOptions = Apollo.BaseMutationOptions<DataFieldDeleteMutation, DataFieldDeleteMutationVariables>;
export const DataRelationsCreateDocument = gql`
    mutation DataRelationsCreate($sourceFieldId: ID!, $relatedFieldId: ID!) {
  dataRelationsCreate(
    sourceFieldId: $sourceFieldId
    relatedFieldId: $relatedFieldId
  ) {
    relation {
      id
      sourceField {
        id
        name
      }
      relatedField {
        id
        name
      }
      sourceTable {
        id
        name
      }
      relatedTable {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
}
    `;
export type DataRelationsCreateMutationFn = Apollo.MutationFunction<DataRelationsCreateMutation, DataRelationsCreateMutationVariables>;

/**
 * __useDataRelationsCreateMutation__
 *
 * To run a mutation, you first call `useDataRelationsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataRelationsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataRelationsCreateMutation, { data, loading, error }] = useDataRelationsCreateMutation({
 *   variables: {
 *      sourceFieldId: // value for 'sourceFieldId'
 *      relatedFieldId: // value for 'relatedFieldId'
 *   },
 * });
 */
export function useDataRelationsCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataRelationsCreateMutation, DataRelationsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataRelationsCreateMutation, DataRelationsCreateMutationVariables>(DataRelationsCreateDocument, options);
      }
export type DataRelationsCreateMutationHookResult = ReturnType<typeof useDataRelationsCreateMutation>;
export type DataRelationsCreateMutationResult = Apollo.MutationResult<DataRelationsCreateMutation>;
export type DataRelationsCreateMutationOptions = Apollo.BaseMutationOptions<DataRelationsCreateMutation, DataRelationsCreateMutationVariables>;
export const DataRelationsDeleteDocument = gql`
    mutation DataRelationsDelete($id: ID!) {
  dataRelationsDelete(id: $id) {
    success
    id
  }
}
    `;
export type DataRelationsDeleteMutationFn = Apollo.MutationFunction<DataRelationsDeleteMutation, DataRelationsDeleteMutationVariables>;

/**
 * __useDataRelationsDeleteMutation__
 *
 * To run a mutation, you first call `useDataRelationsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataRelationsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataRelationsDeleteMutation, { data, loading, error }] = useDataRelationsDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataRelationsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataRelationsDeleteMutation, DataRelationsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataRelationsDeleteMutation, DataRelationsDeleteMutationVariables>(DataRelationsDeleteDocument, options);
      }
export type DataRelationsDeleteMutationHookResult = ReturnType<typeof useDataRelationsDeleteMutation>;
export type DataRelationsDeleteMutationResult = Apollo.MutationResult<DataRelationsDeleteMutation>;
export type DataRelationsDeleteMutationOptions = Apollo.BaseMutationOptions<DataRelationsDeleteMutation, DataRelationsDeleteMutationVariables>;
export const DataRelationsDocument = gql`
    query DataRelations($tableId: ID!) {
  dataRelations(tableId: $tableId) {
    relations {
      id
      sourceField {
        id
        name
      }
      relatedField {
        id
        name
      }
      sourceTable {
        id
        name
      }
      relatedTable {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
}
    `;

/**
 * __useDataRelationsQuery__
 *
 * To run a query within a React component, call `useDataRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataRelationsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDataRelationsQuery(baseOptions: Apollo.QueryHookOptions<DataRelationsQuery, DataRelationsQueryVariables> & ({ variables: DataRelationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataRelationsQuery, DataRelationsQueryVariables>(DataRelationsDocument, options);
      }
export function useDataRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataRelationsQuery, DataRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataRelationsQuery, DataRelationsQueryVariables>(DataRelationsDocument, options);
        }
export function useDataRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataRelationsQuery, DataRelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataRelationsQuery, DataRelationsQueryVariables>(DataRelationsDocument, options);
        }
export type DataRelationsQueryHookResult = ReturnType<typeof useDataRelationsQuery>;
export type DataRelationsLazyQueryHookResult = ReturnType<typeof useDataRelationsLazyQuery>;
export type DataRelationsSuspenseQueryHookResult = ReturnType<typeof useDataRelationsSuspenseQuery>;
export type DataRelationsQueryResult = Apollo.QueryResult<DataRelationsQuery, DataRelationsQueryVariables>;
export const DataTagUpdateDocument = gql`
    mutation DataTagUpdate($id: ID!, $name: String!, $expiresAt: DateTime) {
  dataTagUpdate(id: $id, name: $name, expiresAt: $expiresAt) {
    tag {
      id
      name
      expiresAt
    }
  }
}
    `;
export type DataTagUpdateMutationFn = Apollo.MutationFunction<DataTagUpdateMutation, DataTagUpdateMutationVariables>;

/**
 * __useDataTagUpdateMutation__
 *
 * To run a mutation, you first call `useDataTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataTagUpdateMutation, { data, loading, error }] = useDataTagUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useDataTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataTagUpdateMutation, DataTagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataTagUpdateMutation, DataTagUpdateMutationVariables>(DataTagUpdateDocument, options);
      }
export type DataTagUpdateMutationHookResult = ReturnType<typeof useDataTagUpdateMutation>;
export type DataTagUpdateMutationResult = Apollo.MutationResult<DataTagUpdateMutation>;
export type DataTagUpdateMutationOptions = Apollo.BaseMutationOptions<DataTagUpdateMutation, DataTagUpdateMutationVariables>;
export const DataTagCreateDocument = gql`
    mutation DataTagCreate($tableId: ID!, $name: String!, $expiresAt: DateTime) {
  dataTagCreate(tableId: $tableId, name: $name, expiresAt: $expiresAt) {
    tag {
      id
      name
      expiresAt
    }
  }
}
    `;
export type DataTagCreateMutationFn = Apollo.MutationFunction<DataTagCreateMutation, DataTagCreateMutationVariables>;

/**
 * __useDataTagCreateMutation__
 *
 * To run a mutation, you first call `useDataTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataTagCreateMutation, { data, loading, error }] = useDataTagCreateMutation({
 *   variables: {
 *      tableId: // value for 'tableId'
 *      name: // value for 'name'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useDataTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataTagCreateMutation, DataTagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataTagCreateMutation, DataTagCreateMutationVariables>(DataTagCreateDocument, options);
      }
export type DataTagCreateMutationHookResult = ReturnType<typeof useDataTagCreateMutation>;
export type DataTagCreateMutationResult = Apollo.MutationResult<DataTagCreateMutation>;
export type DataTagCreateMutationOptions = Apollo.BaseMutationOptions<DataTagCreateMutation, DataTagCreateMutationVariables>;
export const DataTagDocument = gql`
    query DataTag($id: ID!) {
  dataTag(id: $id) {
    tag {
      id
      name
      expiresAt
    }
  }
}
    `;

/**
 * __useDataTagQuery__
 *
 * To run a query within a React component, call `useDataTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataTagQuery(baseOptions: Apollo.QueryHookOptions<DataTagQuery, DataTagQueryVariables> & ({ variables: DataTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTagQuery, DataTagQueryVariables>(DataTagDocument, options);
      }
export function useDataTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTagQuery, DataTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTagQuery, DataTagQueryVariables>(DataTagDocument, options);
        }
export function useDataTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTagQuery, DataTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTagQuery, DataTagQueryVariables>(DataTagDocument, options);
        }
export type DataTagQueryHookResult = ReturnType<typeof useDataTagQuery>;
export type DataTagLazyQueryHookResult = ReturnType<typeof useDataTagLazyQuery>;
export type DataTagSuspenseQueryHookResult = ReturnType<typeof useDataTagSuspenseQuery>;
export type DataTagQueryResult = Apollo.QueryResult<DataTagQuery, DataTagQueryVariables>;
export const DataTagDeleteDocument = gql`
    mutation DataTagDelete($id: ID!) {
  dataTagDelete(id: $id) {
    id
    success
  }
}
    `;
export type DataTagDeleteMutationFn = Apollo.MutationFunction<DataTagDeleteMutation, DataTagDeleteMutationVariables>;

/**
 * __useDataTagDeleteMutation__
 *
 * To run a mutation, you first call `useDataTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataTagDeleteMutation, { data, loading, error }] = useDataTagDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataTagDeleteMutation, DataTagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataTagDeleteMutation, DataTagDeleteMutationVariables>(DataTagDeleteDocument, options);
      }
export type DataTagDeleteMutationHookResult = ReturnType<typeof useDataTagDeleteMutation>;
export type DataTagDeleteMutationResult = Apollo.MutationResult<DataTagDeleteMutation>;
export type DataTagDeleteMutationOptions = Apollo.BaseMutationOptions<DataTagDeleteMutation, DataTagDeleteMutationVariables>;
export const DataTagDeletableDocument = gql`
    query DataTagDeletable($id: String!) {
  dataTagDeletable(id: $id) {
    deletable
  }
}
    `;

/**
 * __useDataTagDeletableQuery__
 *
 * To run a query within a React component, call `useDataTagDeletableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTagDeletableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTagDeletableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataTagDeletableQuery(baseOptions: Apollo.QueryHookOptions<DataTagDeletableQuery, DataTagDeletableQueryVariables> & ({ variables: DataTagDeletableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTagDeletableQuery, DataTagDeletableQueryVariables>(DataTagDeletableDocument, options);
      }
export function useDataTagDeletableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTagDeletableQuery, DataTagDeletableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTagDeletableQuery, DataTagDeletableQueryVariables>(DataTagDeletableDocument, options);
        }
export function useDataTagDeletableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTagDeletableQuery, DataTagDeletableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTagDeletableQuery, DataTagDeletableQueryVariables>(DataTagDeletableDocument, options);
        }
export type DataTagDeletableQueryHookResult = ReturnType<typeof useDataTagDeletableQuery>;
export type DataTagDeletableLazyQueryHookResult = ReturnType<typeof useDataTagDeletableLazyQuery>;
export type DataTagDeletableSuspenseQueryHookResult = ReturnType<typeof useDataTagDeletableSuspenseQuery>;
export type DataTagDeletableQueryResult = Apollo.QueryResult<DataTagDeletableQuery, DataTagDeletableQueryVariables>;
export const DataTagsDeletableDocument = gql`
    query DataTagsDeletable {
  dataTagsDeletable {
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useDataTagsDeletableQuery__
 *
 * To run a query within a React component, call `useDataTagsDeletableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTagsDeletableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTagsDeletableQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataTagsDeletableQuery(baseOptions?: Apollo.QueryHookOptions<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>(DataTagsDeletableDocument, options);
      }
export function useDataTagsDeletableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>(DataTagsDeletableDocument, options);
        }
export function useDataTagsDeletableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>(DataTagsDeletableDocument, options);
        }
export type DataTagsDeletableQueryHookResult = ReturnType<typeof useDataTagsDeletableQuery>;
export type DataTagsDeletableLazyQueryHookResult = ReturnType<typeof useDataTagsDeletableLazyQuery>;
export type DataTagsDeletableSuspenseQueryHookResult = ReturnType<typeof useDataTagsDeletableSuspenseQuery>;
export type DataTagsDeletableQueryResult = Apollo.QueryResult<DataTagsDeletableQuery, DataTagsDeletableQueryVariables>;
export const DataTagsDocument = gql`
    query DataTags($tableId: ID!) {
  dataTags(tableId: $tableId) {
    tags {
      id
      name
      expiresAt
    }
  }
}
    `;

/**
 * __useDataTagsQuery__
 *
 * To run a query within a React component, call `useDataTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTagsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDataTagsQuery(baseOptions: Apollo.QueryHookOptions<DataTagsQuery, DataTagsQueryVariables> & ({ variables: DataTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTagsQuery, DataTagsQueryVariables>(DataTagsDocument, options);
      }
export function useDataTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTagsQuery, DataTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTagsQuery, DataTagsQueryVariables>(DataTagsDocument, options);
        }
export function useDataTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTagsQuery, DataTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTagsQuery, DataTagsQueryVariables>(DataTagsDocument, options);
        }
export type DataTagsQueryHookResult = ReturnType<typeof useDataTagsQuery>;
export type DataTagsLazyQueryHookResult = ReturnType<typeof useDataTagsLazyQuery>;
export type DataTagsSuspenseQueryHookResult = ReturnType<typeof useDataTagsSuspenseQuery>;
export type DataTagsQueryResult = Apollo.QueryResult<DataTagsQuery, DataTagsQueryVariables>;
export const DataTableUpdateDocument = gql`
    mutation DataTableUpdate($id: ID!, $name: String!, $description: String!, $semanticCategory: ID, $rowTtlDays: Int) {
  dataTableUpdate(
    id: $id
    name: $name
    description: $description
    semanticCategory: $semanticCategory
    rowTtlDays: $rowTtlDays
  ) {
    success
    table {
      ...DataTablesFragment
    }
  }
}
    ${DataTablesFragmentFragmentDoc}`;
export type DataTableUpdateMutationFn = Apollo.MutationFunction<DataTableUpdateMutation, DataTableUpdateMutationVariables>;

/**
 * __useDataTableUpdateMutation__
 *
 * To run a mutation, you first call `useDataTableUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataTableUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataTableUpdateMutation, { data, loading, error }] = useDataTableUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      semanticCategory: // value for 'semanticCategory'
 *      rowTtlDays: // value for 'rowTtlDays'
 *   },
 * });
 */
export function useDataTableUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataTableUpdateMutation, DataTableUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataTableUpdateMutation, DataTableUpdateMutationVariables>(DataTableUpdateDocument, options);
      }
export type DataTableUpdateMutationHookResult = ReturnType<typeof useDataTableUpdateMutation>;
export type DataTableUpdateMutationResult = Apollo.MutationResult<DataTableUpdateMutation>;
export type DataTableUpdateMutationOptions = Apollo.BaseMutationOptions<DataTableUpdateMutation, DataTableUpdateMutationVariables>;
export const DataTableDocument = gql`
    query DataTable($id: ID!) {
  dataTable(id: $id) {
    ...DataTablesFragment
    rowCount
  }
}
    ${DataTablesFragmentFragmentDoc}`;

/**
 * __useDataTableQuery__
 *
 * To run a query within a React component, call `useDataTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataTableQuery(baseOptions: Apollo.QueryHookOptions<DataTableQuery, DataTableQueryVariables> & ({ variables: DataTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTableQuery, DataTableQueryVariables>(DataTableDocument, options);
      }
export function useDataTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTableQuery, DataTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTableQuery, DataTableQueryVariables>(DataTableDocument, options);
        }
export function useDataTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTableQuery, DataTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTableQuery, DataTableQueryVariables>(DataTableDocument, options);
        }
export type DataTableQueryHookResult = ReturnType<typeof useDataTableQuery>;
export type DataTableLazyQueryHookResult = ReturnType<typeof useDataTableLazyQuery>;
export type DataTableSuspenseQueryHookResult = ReturnType<typeof useDataTableSuspenseQuery>;
export type DataTableQueryResult = Apollo.QueryResult<DataTableQuery, DataTableQueryVariables>;
export const DataFieldsDocument = gql`
    query DataFields($tableId: ID!) {
  dataFields(tableId: $tableId) {
    ...DataFieldsFragment
  }
}
    ${DataFieldsFragmentFragmentDoc}`;

/**
 * __useDataFieldsQuery__
 *
 * To run a query within a React component, call `useDataFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataFieldsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDataFieldsQuery(baseOptions: Apollo.QueryHookOptions<DataFieldsQuery, DataFieldsQueryVariables> & ({ variables: DataFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataFieldsQuery, DataFieldsQueryVariables>(DataFieldsDocument, options);
      }
export function useDataFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataFieldsQuery, DataFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataFieldsQuery, DataFieldsQueryVariables>(DataFieldsDocument, options);
        }
export function useDataFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataFieldsQuery, DataFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataFieldsQuery, DataFieldsQueryVariables>(DataFieldsDocument, options);
        }
export type DataFieldsQueryHookResult = ReturnType<typeof useDataFieldsQuery>;
export type DataFieldsLazyQueryHookResult = ReturnType<typeof useDataFieldsLazyQuery>;
export type DataFieldsSuspenseQueryHookResult = ReturnType<typeof useDataFieldsSuspenseQuery>;
export type DataFieldsQueryResult = Apollo.QueryResult<DataFieldsQuery, DataFieldsQueryVariables>;
export const SemanticCategoriesDocument = gql`
    query SemanticCategories {
  semanticCategories {
    categories {
      id
      name
      title
      description
      isUsed
      features {
        id
        name
        title
        description
        types
        isUsed
      }
    }
  }
}
    `;

/**
 * __useSemanticCategoriesQuery__
 *
 * To run a query within a React component, call `useSemanticCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSemanticCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>(SemanticCategoriesDocument, options);
      }
export function useSemanticCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>(SemanticCategoriesDocument, options);
        }
export function useSemanticCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>(SemanticCategoriesDocument, options);
        }
export type SemanticCategoriesQueryHookResult = ReturnType<typeof useSemanticCategoriesQuery>;
export type SemanticCategoriesLazyQueryHookResult = ReturnType<typeof useSemanticCategoriesLazyQuery>;
export type SemanticCategoriesSuspenseQueryHookResult = ReturnType<typeof useSemanticCategoriesSuspenseQuery>;
export type SemanticCategoriesQueryResult = Apollo.QueryResult<SemanticCategoriesQuery, SemanticCategoriesQueryVariables>;
export const DataTableLockDocument = gql`
    query DataTableLock($id: ID!) {
  dataTableLock(id: $id) {
    tableLock {
      id
      locked
    }
  }
}
    `;

/**
 * __useDataTableLockQuery__
 *
 * To run a query within a React component, call `useDataTableLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTableLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTableLockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataTableLockQuery(baseOptions: Apollo.QueryHookOptions<DataTableLockQuery, DataTableLockQueryVariables> & ({ variables: DataTableLockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTableLockQuery, DataTableLockQueryVariables>(DataTableLockDocument, options);
      }
export function useDataTableLockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTableLockQuery, DataTableLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTableLockQuery, DataTableLockQueryVariables>(DataTableLockDocument, options);
        }
export function useDataTableLockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTableLockQuery, DataTableLockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTableLockQuery, DataTableLockQueryVariables>(DataTableLockDocument, options);
        }
export type DataTableLockQueryHookResult = ReturnType<typeof useDataTableLockQuery>;
export type DataTableLockLazyQueryHookResult = ReturnType<typeof useDataTableLockLazyQuery>;
export type DataTableLockSuspenseQueryHookResult = ReturnType<typeof useDataTableLockSuspenseQuery>;
export type DataTableLockQueryResult = Apollo.QueryResult<DataTableLockQuery, DataTableLockQueryVariables>;
export const DataTablesDocument = gql`
    query DataTables {
  dataTables {
    ...DataTablesFragment
  }
}
    ${DataTablesFragmentFragmentDoc}`;

/**
 * __useDataTablesQuery__
 *
 * To run a query within a React component, call `useDataTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataTablesQuery(baseOptions?: Apollo.QueryHookOptions<DataTablesQuery, DataTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTablesQuery, DataTablesQueryVariables>(DataTablesDocument, options);
      }
export function useDataTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTablesQuery, DataTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTablesQuery, DataTablesQueryVariables>(DataTablesDocument, options);
        }
export function useDataTablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataTablesQuery, DataTablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataTablesQuery, DataTablesQueryVariables>(DataTablesDocument, options);
        }
export type DataTablesQueryHookResult = ReturnType<typeof useDataTablesQuery>;
export type DataTablesLazyQueryHookResult = ReturnType<typeof useDataTablesLazyQuery>;
export type DataTablesSuspenseQueryHookResult = ReturnType<typeof useDataTablesSuspenseQuery>;
export type DataTablesQueryResult = Apollo.QueryResult<DataTablesQuery, DataTablesQueryVariables>;
export const TriggeredCampaignMessageDocument = gql`
    query TriggeredCampaignMessage($id: ID!, $useDraft: Boolean) {
  triggeredCampaignMessage(id: $id, useDraft: $useDraft) {
    id
    layoutDocument
    inboxPreview {
      id
      subjectLineDynamicBlockId
      subjectLinePrefix
      subjectLineSuffix
      preheaderDynamicBlockId
    }
  }
}
    `;

/**
 * __useTriggeredCampaignMessageQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useDraft: // value for 'useDraft'
 *   },
 * });
 */
export function useTriggeredCampaignMessageQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables> & ({ variables: TriggeredCampaignMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables>(TriggeredCampaignMessageDocument, options);
      }
export function useTriggeredCampaignMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables>(TriggeredCampaignMessageDocument, options);
        }
export function useTriggeredCampaignMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables>(TriggeredCampaignMessageDocument, options);
        }
export type TriggeredCampaignMessageQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageQuery>;
export type TriggeredCampaignMessageLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageLazyQuery>;
export type TriggeredCampaignMessageSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageSuspenseQuery>;
export type TriggeredCampaignMessageQueryResult = Apollo.QueryResult<TriggeredCampaignMessageQuery, TriggeredCampaignMessageQueryVariables>;
export const TriggeredCampaignMessageAddDynamicBlockDocument = gql`
    mutation TriggeredCampaignMessageAddDynamicBlock($id: ID!) {
  triggeredCampaignMessageAddDynamicBlock(id: $id) {
    __typename
    ... on TriggeredCampaignMessageAddDynamicBlockSuccess {
      success
      slotUri
      blockId
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageAddDynamicBlockMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageAddDynamicBlockMutation, TriggeredCampaignMessageAddDynamicBlockMutationVariables>;

/**
 * __useTriggeredCampaignMessageAddDynamicBlockMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageAddDynamicBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageAddDynamicBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageAddDynamicBlockMutation, { data, loading, error }] = useTriggeredCampaignMessageAddDynamicBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggeredCampaignMessageAddDynamicBlockMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageAddDynamicBlockMutation, TriggeredCampaignMessageAddDynamicBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageAddDynamicBlockMutation, TriggeredCampaignMessageAddDynamicBlockMutationVariables>(TriggeredCampaignMessageAddDynamicBlockDocument, options);
      }
export type TriggeredCampaignMessageAddDynamicBlockMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageAddDynamicBlockMutation>;
export type TriggeredCampaignMessageAddDynamicBlockMutationResult = Apollo.MutationResult<TriggeredCampaignMessageAddDynamicBlockMutation>;
export type TriggeredCampaignMessageAddDynamicBlockMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageAddDynamicBlockMutation, TriggeredCampaignMessageAddDynamicBlockMutationVariables>;
export const TriggeredCampaignMessageLayoutUpdateDocument = gql`
    mutation TriggeredCampaignMessageLayoutUpdate($id: ID!, $document: TriggeredCampaignMessageLayoutDocument!) {
  triggeredCampaignMessageLayoutUpdate(id: $id, document: $document) {
    __typename
    ... on TriggeredCampaignMessageLayoutUpdateSuccess {
      success
      updatedAt
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageLayoutUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageLayoutUpdateMutation, TriggeredCampaignMessageLayoutUpdateMutationVariables>;

/**
 * __useTriggeredCampaignMessageLayoutUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageLayoutUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageLayoutUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageLayoutUpdateMutation, { data, loading, error }] = useTriggeredCampaignMessageLayoutUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useTriggeredCampaignMessageLayoutUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageLayoutUpdateMutation, TriggeredCampaignMessageLayoutUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageLayoutUpdateMutation, TriggeredCampaignMessageLayoutUpdateMutationVariables>(TriggeredCampaignMessageLayoutUpdateDocument, options);
      }
export type TriggeredCampaignMessageLayoutUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageLayoutUpdateMutation>;
export type TriggeredCampaignMessageLayoutUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignMessageLayoutUpdateMutation>;
export type TriggeredCampaignMessageLayoutUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageLayoutUpdateMutation, TriggeredCampaignMessageLayoutUpdateMutationVariables>;
export const TriggeredCampaignMessageSaveDocument = gql`
    mutation TriggeredCampaignMessageSave($id: ID!, $document: TriggeredCampaignMessageLayoutDocument!, $inboxPreview: TriggeredCampaignMessageInboxPreviewUpdateInput) {
  triggeredCampaignMessageSave(
    id: $id
    document: $document
    inboxPreview: $inboxPreview
  ) {
    __typename
    ... on TriggeredCampaignMessageSaveSuccess {
      success
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageSaveMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageSaveMutation, TriggeredCampaignMessageSaveMutationVariables>;

/**
 * __useTriggeredCampaignMessageSaveMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageSaveMutation, { data, loading, error }] = useTriggeredCampaignMessageSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      document: // value for 'document'
 *      inboxPreview: // value for 'inboxPreview'
 *   },
 * });
 */
export function useTriggeredCampaignMessageSaveMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageSaveMutation, TriggeredCampaignMessageSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageSaveMutation, TriggeredCampaignMessageSaveMutationVariables>(TriggeredCampaignMessageSaveDocument, options);
      }
export type TriggeredCampaignMessageSaveMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageSaveMutation>;
export type TriggeredCampaignMessageSaveMutationResult = Apollo.MutationResult<TriggeredCampaignMessageSaveMutation>;
export type TriggeredCampaignMessageSaveMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageSaveMutation, TriggeredCampaignMessageSaveMutationVariables>;
export const TriggeredCampaignMessageDiscardDocument = gql`
    mutation TriggeredCampaignMessageDiscard($id: ID!) {
  triggeredCampaignMessageDiscard(id: $id) {
    __typename
    ... on TriggeredCampaignMessageDiscardSuccess {
      success
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageDiscardMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageDiscardMutation, TriggeredCampaignMessageDiscardMutationVariables>;

/**
 * __useTriggeredCampaignMessageDiscardMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageDiscardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageDiscardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageDiscardMutation, { data, loading, error }] = useTriggeredCampaignMessageDiscardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggeredCampaignMessageDiscardMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageDiscardMutation, TriggeredCampaignMessageDiscardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageDiscardMutation, TriggeredCampaignMessageDiscardMutationVariables>(TriggeredCampaignMessageDiscardDocument, options);
      }
export type TriggeredCampaignMessageDiscardMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageDiscardMutation>;
export type TriggeredCampaignMessageDiscardMutationResult = Apollo.MutationResult<TriggeredCampaignMessageDiscardMutation>;
export type TriggeredCampaignMessageDiscardMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageDiscardMutation, TriggeredCampaignMessageDiscardMutationVariables>;
export const TriggeredCampaignMessageDynamicBlockInboxContentDocument = gql`
    query TriggeredCampaignMessageDynamicBlockInboxContent($id: ID!, $blockIds: [ID!]) {
  triggeredCampaignMessage(id: $id) {
    id
    dynamicBlocks(ids: $blockIds) {
      id
      experience {
        id
        selectedCreative {
          id
          subjectLines {
            id
            content
          }
          preheaderText2 {
            __typename
            ... on InboxTextSetting {
              enabled
              content
            }
          }
          previewText2 {
            __typename
            ... on InboxTextSetting {
              enabled
              content
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTriggeredCampaignMessageDynamicBlockInboxContentQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignMessageDynamicBlockInboxContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageDynamicBlockInboxContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignMessageDynamicBlockInboxContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      blockIds: // value for 'blockIds'
 *   },
 * });
 */
export function useTriggeredCampaignMessageDynamicBlockInboxContentQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables> & ({ variables: TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables>(TriggeredCampaignMessageDynamicBlockInboxContentDocument, options);
      }
export function useTriggeredCampaignMessageDynamicBlockInboxContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables>(TriggeredCampaignMessageDynamicBlockInboxContentDocument, options);
        }
export function useTriggeredCampaignMessageDynamicBlockInboxContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables>(TriggeredCampaignMessageDynamicBlockInboxContentDocument, options);
        }
export type TriggeredCampaignMessageDynamicBlockInboxContentQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockInboxContentQuery>;
export type TriggeredCampaignMessageDynamicBlockInboxContentLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockInboxContentLazyQuery>;
export type TriggeredCampaignMessageDynamicBlockInboxContentSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockInboxContentSuspenseQuery>;
export type TriggeredCampaignMessageDynamicBlockInboxContentQueryResult = Apollo.QueryResult<TriggeredCampaignMessageDynamicBlockInboxContentQuery, TriggeredCampaignMessageDynamicBlockInboxContentQueryVariables>;
export const TriggeredCampaignMessageInboxPreviewUpdateDocument = gql`
    mutation TriggeredCampaignMessageInboxPreviewUpdate($id: ID!, $input: TriggeredCampaignMessageInboxPreviewUpdateInput!) {
  triggeredCampaignMessageInboxPreviewUpdate(id: $id, input: $input) {
    __typename
    ... on TriggeredCampaignMessageInboxPreviewUpdateSuccess {
      success
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageInboxPreviewUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageInboxPreviewUpdateMutation, TriggeredCampaignMessageInboxPreviewUpdateMutationVariables>;

/**
 * __useTriggeredCampaignMessageInboxPreviewUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageInboxPreviewUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageInboxPreviewUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageInboxPreviewUpdateMutation, { data, loading, error }] = useTriggeredCampaignMessageInboxPreviewUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggeredCampaignMessageInboxPreviewUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageInboxPreviewUpdateMutation, TriggeredCampaignMessageInboxPreviewUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageInboxPreviewUpdateMutation, TriggeredCampaignMessageInboxPreviewUpdateMutationVariables>(TriggeredCampaignMessageInboxPreviewUpdateDocument, options);
      }
export type TriggeredCampaignMessageInboxPreviewUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageInboxPreviewUpdateMutation>;
export type TriggeredCampaignMessageInboxPreviewUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignMessageInboxPreviewUpdateMutation>;
export type TriggeredCampaignMessageInboxPreviewUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageInboxPreviewUpdateMutation, TriggeredCampaignMessageInboxPreviewUpdateMutationVariables>;
export const TriggeredCampaignMessageDynamicBlockCreativeContentDocument = gql`
    query TriggeredCampaignMessageDynamicBlockCreativeContent($id: ID!, $blockIds: [ID!]) {
  triggeredCampaignMessage(id: $id) {
    id
    dynamicBlocks(ids: $blockIds) {
      id
      experience {
        id
        creativeLayout {
          published(format: V1)
        }
      }
    }
  }
}
    `;

/**
 * __useTriggeredCampaignMessageDynamicBlockCreativeContentQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignMessageDynamicBlockCreativeContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageDynamicBlockCreativeContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignMessageDynamicBlockCreativeContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      blockIds: // value for 'blockIds'
 *   },
 * });
 */
export function useTriggeredCampaignMessageDynamicBlockCreativeContentQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables> & ({ variables: TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables>(TriggeredCampaignMessageDynamicBlockCreativeContentDocument, options);
      }
export function useTriggeredCampaignMessageDynamicBlockCreativeContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables>(TriggeredCampaignMessageDynamicBlockCreativeContentDocument, options);
        }
export function useTriggeredCampaignMessageDynamicBlockCreativeContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables>(TriggeredCampaignMessageDynamicBlockCreativeContentDocument, options);
        }
export type TriggeredCampaignMessageDynamicBlockCreativeContentQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockCreativeContentQuery>;
export type TriggeredCampaignMessageDynamicBlockCreativeContentLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockCreativeContentLazyQuery>;
export type TriggeredCampaignMessageDynamicBlockCreativeContentSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockCreativeContentSuspenseQuery>;
export type TriggeredCampaignMessageDynamicBlockCreativeContentQueryResult = Apollo.QueryResult<TriggeredCampaignMessageDynamicBlockCreativeContentQuery, TriggeredCampaignMessageDynamicBlockCreativeContentQueryVariables>;
export const TriggeredCampaignMessageDynamicBlockDisclaimerContentDocument = gql`
    query TriggeredCampaignMessageDynamicBlockDisclaimerContent($id: ID!, $blockIds: [ID!]) {
  triggeredCampaignMessage(id: $id) {
    id
    dynamicBlocks(ids: $blockIds) {
      id
      experience {
        id
        selectedCreative {
          id
          disclaimer
        }
      }
    }
  }
}
    `;

/**
 * __useTriggeredCampaignMessageDynamicBlockDisclaimerContentQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignMessageDynamicBlockDisclaimerContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageDynamicBlockDisclaimerContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignMessageDynamicBlockDisclaimerContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      blockIds: // value for 'blockIds'
 *   },
 * });
 */
export function useTriggeredCampaignMessageDynamicBlockDisclaimerContentQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables> & ({ variables: TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables>(TriggeredCampaignMessageDynamicBlockDisclaimerContentDocument, options);
      }
export function useTriggeredCampaignMessageDynamicBlockDisclaimerContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables>(TriggeredCampaignMessageDynamicBlockDisclaimerContentDocument, options);
        }
export function useTriggeredCampaignMessageDynamicBlockDisclaimerContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables>(TriggeredCampaignMessageDynamicBlockDisclaimerContentDocument, options);
        }
export type TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockDisclaimerContentQuery>;
export type TriggeredCampaignMessageDynamicBlockDisclaimerContentLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockDisclaimerContentLazyQuery>;
export type TriggeredCampaignMessageDynamicBlockDisclaimerContentSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockDisclaimerContentSuspenseQuery>;
export type TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryResult = Apollo.QueryResult<TriggeredCampaignMessageDynamicBlockDisclaimerContentQuery, TriggeredCampaignMessageDynamicBlockDisclaimerContentQueryVariables>;
export const TriggeredCampaignMessageAvailableCreativesDocument = gql`
    query TriggeredCampaignMessageAvailableCreatives($id: ID!, $filter: TriggeredCampaignAvailableCreativesFilter, $first: Int, $after: String) {
  triggeredCampaignMessageAvailableCreatives(
    id: $id
    filter: $filter
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        title
        status
        bestThumbnail {
          url
        }
        tags {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTriggeredCampaignMessageAvailableCreativesQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignMessageAvailableCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageAvailableCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignMessageAvailableCreativesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTriggeredCampaignMessageAvailableCreativesQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables> & ({ variables: TriggeredCampaignMessageAvailableCreativesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables>(TriggeredCampaignMessageAvailableCreativesDocument, options);
      }
export function useTriggeredCampaignMessageAvailableCreativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables>(TriggeredCampaignMessageAvailableCreativesDocument, options);
        }
export function useTriggeredCampaignMessageAvailableCreativesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables>(TriggeredCampaignMessageAvailableCreativesDocument, options);
        }
export type TriggeredCampaignMessageAvailableCreativesQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageAvailableCreativesQuery>;
export type TriggeredCampaignMessageAvailableCreativesLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageAvailableCreativesLazyQuery>;
export type TriggeredCampaignMessageAvailableCreativesSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignMessageAvailableCreativesSuspenseQuery>;
export type TriggeredCampaignMessageAvailableCreativesQueryResult = Apollo.QueryResult<TriggeredCampaignMessageAvailableCreativesQuery, TriggeredCampaignMessageAvailableCreativesQueryVariables>;
export const TriggeredCampaignMessageDynamicBlockExperienceCreateDocument = gql`
    mutation TriggeredCampaignMessageDynamicBlockExperienceCreate($id: ID!, $blockId: ID!) {
  triggeredCampaignMessageDynamicBlockExperienceCreate(id: $id, blockId: $blockId) {
    __typename
    ... on TriggeredCampaignMessageDynamicBlockExperienceCreateSuccess {
      success
      id
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageDynamicBlockExperienceCreateMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageDynamicBlockExperienceCreateMutation, TriggeredCampaignMessageDynamicBlockExperienceCreateMutationVariables>;

/**
 * __useTriggeredCampaignMessageDynamicBlockExperienceCreateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageDynamicBlockExperienceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageDynamicBlockExperienceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageDynamicBlockExperienceCreateMutation, { data, loading, error }] = useTriggeredCampaignMessageDynamicBlockExperienceCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useTriggeredCampaignMessageDynamicBlockExperienceCreateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageDynamicBlockExperienceCreateMutation, TriggeredCampaignMessageDynamicBlockExperienceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageDynamicBlockExperienceCreateMutation, TriggeredCampaignMessageDynamicBlockExperienceCreateMutationVariables>(TriggeredCampaignMessageDynamicBlockExperienceCreateDocument, options);
      }
export type TriggeredCampaignMessageDynamicBlockExperienceCreateMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageDynamicBlockExperienceCreateMutation>;
export type TriggeredCampaignMessageDynamicBlockExperienceCreateMutationResult = Apollo.MutationResult<TriggeredCampaignMessageDynamicBlockExperienceCreateMutation>;
export type TriggeredCampaignMessageDynamicBlockExperienceCreateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageDynamicBlockExperienceCreateMutation, TriggeredCampaignMessageDynamicBlockExperienceCreateMutationVariables>;
export const TriggeredCampaignMessageExperienceSelectCreativeDocument = gql`
    mutation TriggeredCampaignMessageExperienceSelectCreative($id: ID!, $experienceId: ID!, $creativeId: ID!) {
  triggeredCampaignMessageExperienceSelectCreative(
    id: $id
    experienceId: $experienceId
    creativeId: $creativeId
  ) {
    __typename
    ... on TriggeredCampaignMessageExperienceSelectCreativeSuccess {
      success
      id
    }
    ... on ValidationErrors {
      success
      errors {
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignMessageExperienceSelectCreativeMutationFn = Apollo.MutationFunction<TriggeredCampaignMessageExperienceSelectCreativeMutation, TriggeredCampaignMessageExperienceSelectCreativeMutationVariables>;

/**
 * __useTriggeredCampaignMessageExperienceSelectCreativeMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignMessageExperienceSelectCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignMessageExperienceSelectCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignMessageExperienceSelectCreativeMutation, { data, loading, error }] = useTriggeredCampaignMessageExperienceSelectCreativeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      experienceId: // value for 'experienceId'
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useTriggeredCampaignMessageExperienceSelectCreativeMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignMessageExperienceSelectCreativeMutation, TriggeredCampaignMessageExperienceSelectCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignMessageExperienceSelectCreativeMutation, TriggeredCampaignMessageExperienceSelectCreativeMutationVariables>(TriggeredCampaignMessageExperienceSelectCreativeDocument, options);
      }
export type TriggeredCampaignMessageExperienceSelectCreativeMutationHookResult = ReturnType<typeof useTriggeredCampaignMessageExperienceSelectCreativeMutation>;
export type TriggeredCampaignMessageExperienceSelectCreativeMutationResult = Apollo.MutationResult<TriggeredCampaignMessageExperienceSelectCreativeMutation>;
export type TriggeredCampaignMessageExperienceSelectCreativeMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignMessageExperienceSelectCreativeMutation, TriggeredCampaignMessageExperienceSelectCreativeMutationVariables>;
export const TriggeredCampaignTextAttributeUpdateDocument = gql`
    mutation TriggeredCampaignTextAttributeUpdate($attributeId: ID!, $id: ID!, $value: String) {
  triggeredCampaignTextAttributeUpdate(
    attributeId: $attributeId
    id: $id
    value: $value
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type TriggeredCampaignTextAttributeUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignTextAttributeUpdateMutation, TriggeredCampaignTextAttributeUpdateMutationVariables>;

/**
 * __useTriggeredCampaignTextAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignTextAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignTextAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignTextAttributeUpdateMutation, { data, loading, error }] = useTriggeredCampaignTextAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTriggeredCampaignTextAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignTextAttributeUpdateMutation, TriggeredCampaignTextAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignTextAttributeUpdateMutation, TriggeredCampaignTextAttributeUpdateMutationVariables>(TriggeredCampaignTextAttributeUpdateDocument, options);
      }
export type TriggeredCampaignTextAttributeUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignTextAttributeUpdateMutation>;
export type TriggeredCampaignTextAttributeUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignTextAttributeUpdateMutation>;
export type TriggeredCampaignTextAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignTextAttributeUpdateMutation, TriggeredCampaignTextAttributeUpdateMutationVariables>;
export const TriggeredCampaignSelectAttributeUpdateDocument = gql`
    mutation TriggeredCampaignSelectAttributeUpdate($attributeId: ID!, $id: ID!, $optionId: ID) {
  triggeredCampaignSelectAttributeUpdate(
    attributeId: $attributeId
    id: $id
    optionId: $optionId
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type TriggeredCampaignSelectAttributeUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignSelectAttributeUpdateMutation, TriggeredCampaignSelectAttributeUpdateMutationVariables>;

/**
 * __useTriggeredCampaignSelectAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignSelectAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignSelectAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignSelectAttributeUpdateMutation, { data, loading, error }] = useTriggeredCampaignSelectAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useTriggeredCampaignSelectAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignSelectAttributeUpdateMutation, TriggeredCampaignSelectAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignSelectAttributeUpdateMutation, TriggeredCampaignSelectAttributeUpdateMutationVariables>(TriggeredCampaignSelectAttributeUpdateDocument, options);
      }
export type TriggeredCampaignSelectAttributeUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignSelectAttributeUpdateMutation>;
export type TriggeredCampaignSelectAttributeUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignSelectAttributeUpdateMutation>;
export type TriggeredCampaignSelectAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignSelectAttributeUpdateMutation, TriggeredCampaignSelectAttributeUpdateMutationVariables>;
export const TriggeredCampaignListAttributeUpdateDocument = gql`
    mutation TriggeredCampaignListAttributeUpdate($attributeId: ID!, $id: ID!, $values: [String!]!) {
  triggeredCampaignListAttributeUpdate(
    attributeId: $attributeId
    id: $id
    values: $values
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type TriggeredCampaignListAttributeUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignListAttributeUpdateMutation, TriggeredCampaignListAttributeUpdateMutationVariables>;

/**
 * __useTriggeredCampaignListAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignListAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignListAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignListAttributeUpdateMutation, { data, loading, error }] = useTriggeredCampaignListAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useTriggeredCampaignListAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignListAttributeUpdateMutation, TriggeredCampaignListAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignListAttributeUpdateMutation, TriggeredCampaignListAttributeUpdateMutationVariables>(TriggeredCampaignListAttributeUpdateDocument, options);
      }
export type TriggeredCampaignListAttributeUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignListAttributeUpdateMutation>;
export type TriggeredCampaignListAttributeUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignListAttributeUpdateMutation>;
export type TriggeredCampaignListAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignListAttributeUpdateMutation, TriggeredCampaignListAttributeUpdateMutationVariables>;
export const TriggeredCampaignDateAttributeUpdateDocument = gql`
    mutation TriggeredCampaignDateAttributeUpdate($attributeId: ID!, $id: ID!, $value: Date) {
  triggeredCampaignDateAttributeUpdate(
    attributeId: $attributeId
    id: $id
    value: $value
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        attributes {
          ...campaignAttributesFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}`;
export type TriggeredCampaignDateAttributeUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignDateAttributeUpdateMutation, TriggeredCampaignDateAttributeUpdateMutationVariables>;

/**
 * __useTriggeredCampaignDateAttributeUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignDateAttributeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignDateAttributeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignDateAttributeUpdateMutation, { data, loading, error }] = useTriggeredCampaignDateAttributeUpdateMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTriggeredCampaignDateAttributeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignDateAttributeUpdateMutation, TriggeredCampaignDateAttributeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignDateAttributeUpdateMutation, TriggeredCampaignDateAttributeUpdateMutationVariables>(TriggeredCampaignDateAttributeUpdateDocument, options);
      }
export type TriggeredCampaignDateAttributeUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignDateAttributeUpdateMutation>;
export type TriggeredCampaignDateAttributeUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignDateAttributeUpdateMutation>;
export type TriggeredCampaignDateAttributeUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignDateAttributeUpdateMutation, TriggeredCampaignDateAttributeUpdateMutationVariables>;
export const TriggeredSettingsCustomFieldAddDocument = gql`
    mutation TriggeredSettingsCustomFieldAdd($campaignId: ID!, $customFieldId: ID!) {
  triggeredCampaignCustomFieldAdd(id: $campaignId, customFieldId: $customFieldId) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        customFields {
          ...triggeredCustomFieldsFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${TriggeredCustomFieldsFragmentFragmentDoc}`;
export type TriggeredSettingsCustomFieldAddMutationFn = Apollo.MutationFunction<TriggeredSettingsCustomFieldAddMutation, TriggeredSettingsCustomFieldAddMutationVariables>;

/**
 * __useTriggeredSettingsCustomFieldAddMutation__
 *
 * To run a mutation, you first call `useTriggeredSettingsCustomFieldAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredSettingsCustomFieldAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredSettingsCustomFieldAddMutation, { data, loading, error }] = useTriggeredSettingsCustomFieldAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *   },
 * });
 */
export function useTriggeredSettingsCustomFieldAddMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredSettingsCustomFieldAddMutation, TriggeredSettingsCustomFieldAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredSettingsCustomFieldAddMutation, TriggeredSettingsCustomFieldAddMutationVariables>(TriggeredSettingsCustomFieldAddDocument, options);
      }
export type TriggeredSettingsCustomFieldAddMutationHookResult = ReturnType<typeof useTriggeredSettingsCustomFieldAddMutation>;
export type TriggeredSettingsCustomFieldAddMutationResult = Apollo.MutationResult<TriggeredSettingsCustomFieldAddMutation>;
export type TriggeredSettingsCustomFieldAddMutationOptions = Apollo.BaseMutationOptions<TriggeredSettingsCustomFieldAddMutation, TriggeredSettingsCustomFieldAddMutationVariables>;
export const TriggeredSettingsCustomFieldUpdateDocument = gql`
    mutation TriggeredSettingsCustomFieldUpdate($campaignId: ID!, $customFieldId: ID!, $value: String) {
  triggeredCampaignCustomFieldUpdate(
    id: $campaignId
    customFieldId: $customFieldId
    value: $value
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        customFields {
          ...triggeredCustomFieldsFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${TriggeredCustomFieldsFragmentFragmentDoc}`;
export type TriggeredSettingsCustomFieldUpdateMutationFn = Apollo.MutationFunction<TriggeredSettingsCustomFieldUpdateMutation, TriggeredSettingsCustomFieldUpdateMutationVariables>;

/**
 * __useTriggeredSettingsCustomFieldUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredSettingsCustomFieldUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredSettingsCustomFieldUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredSettingsCustomFieldUpdateMutation, { data, loading, error }] = useTriggeredSettingsCustomFieldUpdateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTriggeredSettingsCustomFieldUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredSettingsCustomFieldUpdateMutation, TriggeredSettingsCustomFieldUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredSettingsCustomFieldUpdateMutation, TriggeredSettingsCustomFieldUpdateMutationVariables>(TriggeredSettingsCustomFieldUpdateDocument, options);
      }
export type TriggeredSettingsCustomFieldUpdateMutationHookResult = ReturnType<typeof useTriggeredSettingsCustomFieldUpdateMutation>;
export type TriggeredSettingsCustomFieldUpdateMutationResult = Apollo.MutationResult<TriggeredSettingsCustomFieldUpdateMutation>;
export type TriggeredSettingsCustomFieldUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredSettingsCustomFieldUpdateMutation, TriggeredSettingsCustomFieldUpdateMutationVariables>;
export const TriggeredSettingsCustomFieldRemoveDocument = gql`
    mutation TriggeredSettingsCustomFieldRemove($campaignId: ID!, $customFieldId: ID!) {
  triggeredCampaignCustomFieldRemove(
    id: $campaignId
    customFieldId: $customFieldId
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        customFields {
          ...triggeredCustomFieldsFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${TriggeredCustomFieldsFragmentFragmentDoc}`;
export type TriggeredSettingsCustomFieldRemoveMutationFn = Apollo.MutationFunction<TriggeredSettingsCustomFieldRemoveMutation, TriggeredSettingsCustomFieldRemoveMutationVariables>;

/**
 * __useTriggeredSettingsCustomFieldRemoveMutation__
 *
 * To run a mutation, you first call `useTriggeredSettingsCustomFieldRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredSettingsCustomFieldRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredSettingsCustomFieldRemoveMutation, { data, loading, error }] = useTriggeredSettingsCustomFieldRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      customFieldId: // value for 'customFieldId'
 *   },
 * });
 */
export function useTriggeredSettingsCustomFieldRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredSettingsCustomFieldRemoveMutation, TriggeredSettingsCustomFieldRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredSettingsCustomFieldRemoveMutation, TriggeredSettingsCustomFieldRemoveMutationVariables>(TriggeredSettingsCustomFieldRemoveDocument, options);
      }
export type TriggeredSettingsCustomFieldRemoveMutationHookResult = ReturnType<typeof useTriggeredSettingsCustomFieldRemoveMutation>;
export type TriggeredSettingsCustomFieldRemoveMutationResult = Apollo.MutationResult<TriggeredSettingsCustomFieldRemoveMutation>;
export type TriggeredSettingsCustomFieldRemoveMutationOptions = Apollo.BaseMutationOptions<TriggeredSettingsCustomFieldRemoveMutation, TriggeredSettingsCustomFieldRemoveMutationVariables>;
export const TriggeredCampaignEmailServiceProviderUpdateDocument = gql`
    mutation TriggeredCampaignEmailServiceProviderUpdate($id: ID!, $emailServiceProviderId: ID!) {
  triggeredCampaignEmailServiceProviderUpdate(
    id: $id
    emailServiceProviderId: $emailServiceProviderId
  ) {
    ... on TriggeredCampaignEspConfigUpdateSuccess {
      success
      triggeredCampaign {
        id
        emailServiceProvider {
          __typename
          ... on AcousticCampaign {
            id
          }
          ... on AdobeCampaign {
            id
          }
          ... on AdobeJourneyOptimizer {
            id
          }
          ... on AmazonSES {
            id
          }
          ... on Braze {
            id
          }
          ... on Cordial {
            id
          }
          ... on OracleResponsys {
            id
          }
          ... on SalesForceMarketingCloud {
            id
          }
          ... on Zeta {
            id
          }
        }
        espConfig {
          ... on CampaignSalesforceMarketingCloudConfig {
            ...espSalesForceFragment
          }
          ... on CampaignAcousticCampaignConfig {
            ...espAcousticFragment
          }
          ... on CampaignOracleResponsysConfig {
            ...espOracleFragment
          }
          ... on CampaignCordialConfig {
            ...espCordialFragment
          }
          ... on CampaignAdobeCampaignConfig {
            ...espAdobeCampaignFragment
          }
          ... on AdobeJourneyOptimizerConfig {
            ...espAdobeJourneyOptimizerFragment
          }
          ... on BlackholeConfig {
            ...espBlackholeFragment
          }
          ... on CampaignEpsilonConfig {
            ...espEpsilonFragment
          }
          ... on AmazonSESConfig {
            ...espAmazonSESFragment
          }
          ... on ZetaConfig {
            ...espZetaFragment
          }
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
      }
    }
  }
}
    ${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspBlackholeFragmentFragmentDoc}
${EspEpsilonFragmentFragmentDoc}
${EspAmazonSesFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}`;
export type TriggeredCampaignEmailServiceProviderUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignEmailServiceProviderUpdateMutation, TriggeredCampaignEmailServiceProviderUpdateMutationVariables>;

/**
 * __useTriggeredCampaignEmailServiceProviderUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignEmailServiceProviderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignEmailServiceProviderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignEmailServiceProviderUpdateMutation, { data, loading, error }] = useTriggeredCampaignEmailServiceProviderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailServiceProviderId: // value for 'emailServiceProviderId'
 *   },
 * });
 */
export function useTriggeredCampaignEmailServiceProviderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignEmailServiceProviderUpdateMutation, TriggeredCampaignEmailServiceProviderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignEmailServiceProviderUpdateMutation, TriggeredCampaignEmailServiceProviderUpdateMutationVariables>(TriggeredCampaignEmailServiceProviderUpdateDocument, options);
      }
export type TriggeredCampaignEmailServiceProviderUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignEmailServiceProviderUpdateMutation>;
export type TriggeredCampaignEmailServiceProviderUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignEmailServiceProviderUpdateMutation>;
export type TriggeredCampaignEmailServiceProviderUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignEmailServiceProviderUpdateMutation, TriggeredCampaignEmailServiceProviderUpdateMutationVariables>;
export const TriggeredCampaignSeedAudienceAddDocument = gql`
    mutation TriggeredCampaignSeedAudienceAdd($campaignId: ID!, $audienceId: ID!) {
  triggeredCampaignSeedAudienceAdd(id: $campaignId, audienceId: $audienceId) {
    ... on TriggeredCampaignAudienceSuccess {
      success
      triggeredCampaign {
        id
        seedContactAudiences {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type TriggeredCampaignSeedAudienceAddMutationFn = Apollo.MutationFunction<TriggeredCampaignSeedAudienceAddMutation, TriggeredCampaignSeedAudienceAddMutationVariables>;

/**
 * __useTriggeredCampaignSeedAudienceAddMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignSeedAudienceAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignSeedAudienceAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignSeedAudienceAddMutation, { data, loading, error }] = useTriggeredCampaignSeedAudienceAddMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useTriggeredCampaignSeedAudienceAddMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignSeedAudienceAddMutation, TriggeredCampaignSeedAudienceAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignSeedAudienceAddMutation, TriggeredCampaignSeedAudienceAddMutationVariables>(TriggeredCampaignSeedAudienceAddDocument, options);
      }
export type TriggeredCampaignSeedAudienceAddMutationHookResult = ReturnType<typeof useTriggeredCampaignSeedAudienceAddMutation>;
export type TriggeredCampaignSeedAudienceAddMutationResult = Apollo.MutationResult<TriggeredCampaignSeedAudienceAddMutation>;
export type TriggeredCampaignSeedAudienceAddMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignSeedAudienceAddMutation, TriggeredCampaignSeedAudienceAddMutationVariables>;
export const TriggeredCampaignSeedAudienceRemoveDocument = gql`
    mutation TriggeredCampaignSeedAudienceRemove($campaignId: ID!, $audienceId: ID!) {
  triggeredCampaignSeedAudienceRemove(id: $campaignId, audienceId: $audienceId) {
    ... on TriggeredCampaignAudienceSuccess {
      success
      triggeredCampaign {
        id
        seedContactAudiences {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type TriggeredCampaignSeedAudienceRemoveMutationFn = Apollo.MutationFunction<TriggeredCampaignSeedAudienceRemoveMutation, TriggeredCampaignSeedAudienceRemoveMutationVariables>;

/**
 * __useTriggeredCampaignSeedAudienceRemoveMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignSeedAudienceRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignSeedAudienceRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignSeedAudienceRemoveMutation, { data, loading, error }] = useTriggeredCampaignSeedAudienceRemoveMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useTriggeredCampaignSeedAudienceRemoveMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignSeedAudienceRemoveMutation, TriggeredCampaignSeedAudienceRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignSeedAudienceRemoveMutation, TriggeredCampaignSeedAudienceRemoveMutationVariables>(TriggeredCampaignSeedAudienceRemoveDocument, options);
      }
export type TriggeredCampaignSeedAudienceRemoveMutationHookResult = ReturnType<typeof useTriggeredCampaignSeedAudienceRemoveMutation>;
export type TriggeredCampaignSeedAudienceRemoveMutationResult = Apollo.MutationResult<TriggeredCampaignSeedAudienceRemoveMutation>;
export type TriggeredCampaignSeedAudienceRemoveMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignSeedAudienceRemoveMutation, TriggeredCampaignSeedAudienceRemoveMutationVariables>;
export const TriggeredCampaignTextTrackingParameterUpdateDocument = gql`
    mutation TriggeredCampaignTextTrackingParameterUpdate($id: ID!, $trackingParameterId: ID!, $value: String) {
  triggeredCampaignTextTrackingParameterUpdate(
    id: $id
    trackingParameterId: $trackingParameterId
    value: $value
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        trackingParameters {
          ...campaignTrackingParametersFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignTrackingParametersFragmentFragmentDoc}`;
export type TriggeredCampaignTextTrackingParameterUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignTextTrackingParameterUpdateMutation, TriggeredCampaignTextTrackingParameterUpdateMutationVariables>;

/**
 * __useTriggeredCampaignTextTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignTextTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignTextTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignTextTrackingParameterUpdateMutation, { data, loading, error }] = useTriggeredCampaignTextTrackingParameterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTriggeredCampaignTextTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignTextTrackingParameterUpdateMutation, TriggeredCampaignTextTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignTextTrackingParameterUpdateMutation, TriggeredCampaignTextTrackingParameterUpdateMutationVariables>(TriggeredCampaignTextTrackingParameterUpdateDocument, options);
      }
export type TriggeredCampaignTextTrackingParameterUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignTextTrackingParameterUpdateMutation>;
export type TriggeredCampaignTextTrackingParameterUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignTextTrackingParameterUpdateMutation>;
export type TriggeredCampaignTextTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignTextTrackingParameterUpdateMutation, TriggeredCampaignTextTrackingParameterUpdateMutationVariables>;
export const TriggeredCampaignSelectTrackingParameterUpdateDocument = gql`
    mutation TriggeredCampaignSelectTrackingParameterUpdate($id: ID!, $trackingParameterId: ID!, $optionId: ID) {
  triggeredCampaignSelectTrackingParameterUpdate(
    id: $id
    trackingParameterId: $trackingParameterId
    optionId: $optionId
  ) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        trackingParameters {
          ...campaignTrackingParametersFragment
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    ${CampaignTrackingParametersFragmentFragmentDoc}`;
export type TriggeredCampaignSelectTrackingParameterUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignSelectTrackingParameterUpdateMutation, TriggeredCampaignSelectTrackingParameterUpdateMutationVariables>;

/**
 * __useTriggeredCampaignSelectTrackingParameterUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignSelectTrackingParameterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignSelectTrackingParameterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignSelectTrackingParameterUpdateMutation, { data, loading, error }] = useTriggeredCampaignSelectTrackingParameterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingParameterId: // value for 'trackingParameterId'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useTriggeredCampaignSelectTrackingParameterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignSelectTrackingParameterUpdateMutation, TriggeredCampaignSelectTrackingParameterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignSelectTrackingParameterUpdateMutation, TriggeredCampaignSelectTrackingParameterUpdateMutationVariables>(TriggeredCampaignSelectTrackingParameterUpdateDocument, options);
      }
export type TriggeredCampaignSelectTrackingParameterUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignSelectTrackingParameterUpdateMutation>;
export type TriggeredCampaignSelectTrackingParameterUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignSelectTrackingParameterUpdateMutation>;
export type TriggeredCampaignSelectTrackingParameterUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignSelectTrackingParameterUpdateMutation, TriggeredCampaignSelectTrackingParameterUpdateMutationVariables>;
export const TriggeredCampaignSettingsDocument = gql`
    query TriggeredCampaignSettings($campaignId: ID!) {
  availableCustomFields {
    id
    name
    title
  }
  triggeredCampaign(id: $campaignId) {
    id
    status
    seedContactAudiences {
      id
      name
    }
    attributes {
      ...campaignAttributesFragment
    }
    trackingParameters {
      ...campaignTrackingParametersFragment
    }
    emailServiceProvider {
      __typename
      ... on AcousticCampaign {
        id
      }
      ... on AdobeCampaign {
        id
      }
      ... on AdobeJourneyOptimizer {
        id
      }
      ... on AmazonSES {
        id
      }
      ... on Braze {
        id
      }
      ... on Cordial {
        id
      }
      ... on OracleResponsys {
        id
      }
      ... on SalesForceMarketingCloud {
        id
      }
      ... on Zeta {
        id
      }
    }
    espConfig {
      ... on CampaignSalesforceMarketingCloudConfig {
        ...espSalesForceFragment
      }
      ... on CampaignAcousticCampaignConfig {
        ...espAcousticFragment
      }
      ... on CampaignOracleResponsysConfig {
        ...espOracleFragment
      }
      ... on CampaignCordialConfig {
        ...espCordialFragment
      }
      ... on CampaignAdobeCampaignConfig {
        ...espAdobeCampaignFragment
      }
      ... on AdobeJourneyOptimizerConfig {
        ...espAdobeJourneyOptimizerFragment
      }
      ... on BlackholeConfig {
        ...espBlackholeFragment
      }
      ... on CampaignEpsilonConfig {
        ...espEpsilonFragment
      }
      ... on AmazonSESConfig {
        ...espAmazonSESFragment
      }
      ... on ZetaConfig {
        ...espZetaFragment
      }
    }
    customFields {
      ...triggeredCustomFieldsFragment
    }
  }
}
    ${CampaignAttributesFragmentFragmentDoc}
${CampaignTrackingParametersFragmentFragmentDoc}
${EspSalesForceFragmentFragmentDoc}
${EspAcousticFragmentFragmentDoc}
${EspOracleFragmentFragmentDoc}
${EspCordialFragmentFragmentDoc}
${EspAdobeCampaignFragmentFragmentDoc}
${EspAdobeJourneyOptimizerFragmentFragmentDoc}
${EspBlackholeFragmentFragmentDoc}
${EspEpsilonFragmentFragmentDoc}
${EspAmazonSesFragmentFragmentDoc}
${EspZetaFragmentFragmentDoc}
${TriggeredCustomFieldsFragmentFragmentDoc}`;

/**
 * __useTriggeredCampaignSettingsQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignSettingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useTriggeredCampaignSettingsQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables> & ({ variables: TriggeredCampaignSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables>(TriggeredCampaignSettingsDocument, options);
      }
export function useTriggeredCampaignSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables>(TriggeredCampaignSettingsDocument, options);
        }
export function useTriggeredCampaignSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables>(TriggeredCampaignSettingsDocument, options);
        }
export type TriggeredCampaignSettingsQueryHookResult = ReturnType<typeof useTriggeredCampaignSettingsQuery>;
export type TriggeredCampaignSettingsLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignSettingsLazyQuery>;
export type TriggeredCampaignSettingsSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignSettingsSuspenseQuery>;
export type TriggeredCampaignSettingsQueryResult = Apollo.QueryResult<TriggeredCampaignSettingsQuery, TriggeredCampaignSettingsQueryVariables>;
export const TriggeredCampaignTriggerTabDocument = gql`
    query TriggeredCampaignTriggerTab($id: ID!) {
  triggeredCampaign(id: $id) {
    id
    triggerSource
    reEntryCriteria
    patternEngineBinding {
      patternUuid
      triggerRule
    }
  }
}
    `;

/**
 * __useTriggeredCampaignTriggerTabQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignTriggerTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignTriggerTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignTriggerTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggeredCampaignTriggerTabQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables> & ({ variables: TriggeredCampaignTriggerTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables>(TriggeredCampaignTriggerTabDocument, options);
      }
export function useTriggeredCampaignTriggerTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables>(TriggeredCampaignTriggerTabDocument, options);
        }
export function useTriggeredCampaignTriggerTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables>(TriggeredCampaignTriggerTabDocument, options);
        }
export type TriggeredCampaignTriggerTabQueryHookResult = ReturnType<typeof useTriggeredCampaignTriggerTabQuery>;
export type TriggeredCampaignTriggerTabLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignTriggerTabLazyQuery>;
export type TriggeredCampaignTriggerTabSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignTriggerTabSuspenseQuery>;
export type TriggeredCampaignTriggerTabQueryResult = Apollo.QueryResult<TriggeredCampaignTriggerTabQuery, TriggeredCampaignTriggerTabQueryVariables>;
export const TriggeredCampaignTriggerRuleUpdateDocument = gql`
    mutation TriggeredCampaignTriggerRuleUpdate($id: ID!, $triggerRule: JSONString!) {
  triggeredCampaignTriggerRuleUpdate(id: $id, triggerRule: $triggerRule) {
    __typename
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        triggerSource
        patternEngineBinding {
          patternUuid
          triggerRule
        }
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignTriggerRuleUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignTriggerRuleUpdateMutation, TriggeredCampaignTriggerRuleUpdateMutationVariables>;

/**
 * __useTriggeredCampaignTriggerRuleUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignTriggerRuleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignTriggerRuleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignTriggerRuleUpdateMutation, { data, loading, error }] = useTriggeredCampaignTriggerRuleUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      triggerRule: // value for 'triggerRule'
 *   },
 * });
 */
export function useTriggeredCampaignTriggerRuleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignTriggerRuleUpdateMutation, TriggeredCampaignTriggerRuleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignTriggerRuleUpdateMutation, TriggeredCampaignTriggerRuleUpdateMutationVariables>(TriggeredCampaignTriggerRuleUpdateDocument, options);
      }
export type TriggeredCampaignTriggerRuleUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignTriggerRuleUpdateMutation>;
export type TriggeredCampaignTriggerRuleUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignTriggerRuleUpdateMutation>;
export type TriggeredCampaignTriggerRuleUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignTriggerRuleUpdateMutation, TriggeredCampaignTriggerRuleUpdateMutationVariables>;
export const TriggeredCampaignReEntryCriteriaUpdateDocument = gql`
    mutation TriggeredCampaignReEntryCriteriaUpdate($id: ID!, $reEntryCriteria: TriggeredCampaignReEntryCriteria!) {
  triggeredCampaignReEntryCriteriaUpdate(
    id: $id
    reEntryCriteria: $reEntryCriteria
  ) {
    __typename
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        reEntryCriteria
      }
    }
    ... on ValidationErrors {
      success
      errors {
        field
        reason
      }
    }
  }
}
    `;
export type TriggeredCampaignReEntryCriteriaUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignReEntryCriteriaUpdateMutation, TriggeredCampaignReEntryCriteriaUpdateMutationVariables>;

/**
 * __useTriggeredCampaignReEntryCriteriaUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignReEntryCriteriaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignReEntryCriteriaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignReEntryCriteriaUpdateMutation, { data, loading, error }] = useTriggeredCampaignReEntryCriteriaUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reEntryCriteria: // value for 'reEntryCriteria'
 *   },
 * });
 */
export function useTriggeredCampaignReEntryCriteriaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignReEntryCriteriaUpdateMutation, TriggeredCampaignReEntryCriteriaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignReEntryCriteriaUpdateMutation, TriggeredCampaignReEntryCriteriaUpdateMutationVariables>(TriggeredCampaignReEntryCriteriaUpdateDocument, options);
      }
export type TriggeredCampaignReEntryCriteriaUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignReEntryCriteriaUpdateMutation>;
export type TriggeredCampaignReEntryCriteriaUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignReEntryCriteriaUpdateMutation>;
export type TriggeredCampaignReEntryCriteriaUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignReEntryCriteriaUpdateMutation, TriggeredCampaignReEntryCriteriaUpdateMutationVariables>;
export const TriggeredCampaignDocument = gql`
    query TriggeredCampaign($id: ID!) {
  triggeredCampaign(id: $id) {
    id
    hashid
    title
    status
    stage
    triggerSource
    channel {
      category
      channel
    }
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useTriggeredCampaignQuery__
 *
 * To run a query within a React component, call `useTriggeredCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggeredCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggeredCampaignQuery(baseOptions: Apollo.QueryHookOptions<TriggeredCampaignQuery, TriggeredCampaignQueryVariables> & ({ variables: TriggeredCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TriggeredCampaignQuery, TriggeredCampaignQueryVariables>(TriggeredCampaignDocument, options);
      }
export function useTriggeredCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TriggeredCampaignQuery, TriggeredCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TriggeredCampaignQuery, TriggeredCampaignQueryVariables>(TriggeredCampaignDocument, options);
        }
export function useTriggeredCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TriggeredCampaignQuery, TriggeredCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TriggeredCampaignQuery, TriggeredCampaignQueryVariables>(TriggeredCampaignDocument, options);
        }
export type TriggeredCampaignQueryHookResult = ReturnType<typeof useTriggeredCampaignQuery>;
export type TriggeredCampaignLazyQueryHookResult = ReturnType<typeof useTriggeredCampaignLazyQuery>;
export type TriggeredCampaignSuspenseQueryHookResult = ReturnType<typeof useTriggeredCampaignSuspenseQuery>;
export type TriggeredCampaignQueryResult = Apollo.QueryResult<TriggeredCampaignQuery, TriggeredCampaignQueryVariables>;
export const TriggeredCampaignStateTransitionDocument = gql`
    mutation TriggeredCampaignStateTransition($id: ID!, $state: TriggeredCampaignStatus!) {
  triggeredCampaignStateTransition(id: $id, state: $state) {
    ... on TriggeredCampaignAttributeUpdateSuccess {
      success
      triggeredCampaign {
        id
        status
        stage
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type TriggeredCampaignStateTransitionMutationFn = Apollo.MutationFunction<TriggeredCampaignStateTransitionMutation, TriggeredCampaignStateTransitionMutationVariables>;

/**
 * __useTriggeredCampaignStateTransitionMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignStateTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignStateTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignStateTransitionMutation, { data, loading, error }] = useTriggeredCampaignStateTransitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useTriggeredCampaignStateTransitionMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignStateTransitionMutation, TriggeredCampaignStateTransitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignStateTransitionMutation, TriggeredCampaignStateTransitionMutationVariables>(TriggeredCampaignStateTransitionDocument, options);
      }
export type TriggeredCampaignStateTransitionMutationHookResult = ReturnType<typeof useTriggeredCampaignStateTransitionMutation>;
export type TriggeredCampaignStateTransitionMutationResult = Apollo.MutationResult<TriggeredCampaignStateTransitionMutation>;
export type TriggeredCampaignStateTransitionMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignStateTransitionMutation, TriggeredCampaignStateTransitionMutationVariables>;
export const TriggeredCampaignDeleteDocument = gql`
    mutation TriggeredCampaignDelete($id: ID!) {
  triggeredCampaignDelete(id: $id) {
    ... on TriggeredCampaignDeleteSuccess {
      success
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type TriggeredCampaignDeleteMutationFn = Apollo.MutationFunction<TriggeredCampaignDeleteMutation, TriggeredCampaignDeleteMutationVariables>;

/**
 * __useTriggeredCampaignDeleteMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignDeleteMutation, { data, loading, error }] = useTriggeredCampaignDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggeredCampaignDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignDeleteMutation, TriggeredCampaignDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignDeleteMutation, TriggeredCampaignDeleteMutationVariables>(TriggeredCampaignDeleteDocument, options);
      }
export type TriggeredCampaignDeleteMutationHookResult = ReturnType<typeof useTriggeredCampaignDeleteMutation>;
export type TriggeredCampaignDeleteMutationResult = Apollo.MutationResult<TriggeredCampaignDeleteMutation>;
export type TriggeredCampaignDeleteMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignDeleteMutation, TriggeredCampaignDeleteMutationVariables>;
export const TriggeredCampaignDetailsUpdateDocument = gql`
    mutation TriggeredCampaignDetailsUpdate($id: ID!, $title: String, $tagIds: [ID!]) {
  triggeredCampaignDetailsUpdate(id: $id, title: $title, tagIds: $tagIds) {
    ... on TriggeredCampaignDetailsUpdateSuccess {
      success
      triggeredCampaign {
        id
        title
        tags {
          id
          name
        }
      }
    }
    ... on ValidationErrors {
      errors {
        field
        reason
        code
      }
    }
  }
}
    `;
export type TriggeredCampaignDetailsUpdateMutationFn = Apollo.MutationFunction<TriggeredCampaignDetailsUpdateMutation, TriggeredCampaignDetailsUpdateMutationVariables>;

/**
 * __useTriggeredCampaignDetailsUpdateMutation__
 *
 * To run a mutation, you first call `useTriggeredCampaignDetailsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggeredCampaignDetailsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggeredCampaignDetailsUpdateMutation, { data, loading, error }] = useTriggeredCampaignDetailsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useTriggeredCampaignDetailsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggeredCampaignDetailsUpdateMutation, TriggeredCampaignDetailsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggeredCampaignDetailsUpdateMutation, TriggeredCampaignDetailsUpdateMutationVariables>(TriggeredCampaignDetailsUpdateDocument, options);
      }
export type TriggeredCampaignDetailsUpdateMutationHookResult = ReturnType<typeof useTriggeredCampaignDetailsUpdateMutation>;
export type TriggeredCampaignDetailsUpdateMutationResult = Apollo.MutationResult<TriggeredCampaignDetailsUpdateMutation>;
export type TriggeredCampaignDetailsUpdateMutationOptions = Apollo.BaseMutationOptions<TriggeredCampaignDetailsUpdateMutation, TriggeredCampaignDetailsUpdateMutationVariables>;
export const CurrentSessionDocument = gql`
    query CurrentSession {
  availableClients {
    id
    displayName
  }
  currentUser {
    id
    isStaff
    initials
    fullName
    email
    featureAccess
    hasSeenCampaignV2Intro
    isSuspended
    isDeveloper
  }
}
    `;

/**
 * __useCurrentSessionQuery__
 *
 * To run a query within a React component, call `useCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentSessionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentSessionQuery, CurrentSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentSessionQuery, CurrentSessionQueryVariables>(CurrentSessionDocument, options);
      }
export function useCurrentSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentSessionQuery, CurrentSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentSessionQuery, CurrentSessionQueryVariables>(CurrentSessionDocument, options);
        }
export function useCurrentSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentSessionQuery, CurrentSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentSessionQuery, CurrentSessionQueryVariables>(CurrentSessionDocument, options);
        }
export type CurrentSessionQueryHookResult = ReturnType<typeof useCurrentSessionQuery>;
export type CurrentSessionLazyQueryHookResult = ReturnType<typeof useCurrentSessionLazyQuery>;
export type CurrentSessionSuspenseQueryHookResult = ReturnType<typeof useCurrentSessionSuspenseQuery>;
export type CurrentSessionQueryResult = Apollo.QueryResult<CurrentSessionQuery, CurrentSessionQueryVariables>;
export const CurrentClientDocument = gql`
    query CurrentClient {
  currentClient {
    id
    name
    displayName
    squareLogo
    timezone
    defaultStoInterval
    analyticsCalendar
    analyticsCurrency
    analyticsStatSigThreshold
    analyticsAttributionWindow
    analyticsExportDecimalPrecision
    analyticsExportRateFormat
    autoInclude
    emailServiceProviders {
      ...espMetadataFields
    }
    defaultBlockConfiguration {
      mode
      personalization
    }
    emailServiceProvider {
      ...espMetadataFields
    }
    fiscalCalendar {
      currentWeek
    }
    enablePersadoCampaign
    enableProofing
    enableNewProofRecommendationRun
    enableConversionTracking
    desktopEmailWidth
    mobileEmailWidth
    ...featureFlagsFragment
    ...channelFeatureFlagsFragment
    reuseRule {
      ...reuseRuleFields
    }
    tones
    primarySubjectLineRequired
    preheaderTextSetting
    enableDisclaimerLayouts
    enforceLinkDomainAllowlist
    linkDomainAllowlist
    canUploadImages
    hasCdnConfig
  }
}
    ${EspMetadataFieldsFragmentDoc}
${FeatureFlagsFragmentFragmentDoc}
${ChannelFeatureFlagsFragmentFragmentDoc}
${ReuseRuleFieldsFragmentDoc}`;

/**
 * __useCurrentClientQuery__
 *
 * To run a query within a React component, call `useCurrentClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentClientQuery(baseOptions?: Apollo.QueryHookOptions<CurrentClientQuery, CurrentClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentClientQuery, CurrentClientQueryVariables>(CurrentClientDocument, options);
      }
export function useCurrentClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentClientQuery, CurrentClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentClientQuery, CurrentClientQueryVariables>(CurrentClientDocument, options);
        }
export function useCurrentClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentClientQuery, CurrentClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentClientQuery, CurrentClientQueryVariables>(CurrentClientDocument, options);
        }
export type CurrentClientQueryHookResult = ReturnType<typeof useCurrentClientQuery>;
export type CurrentClientLazyQueryHookResult = ReturnType<typeof useCurrentClientLazyQuery>;
export type CurrentClientSuspenseQueryHookResult = ReturnType<typeof useCurrentClientSuspenseQuery>;
export type CurrentClientQueryResult = Apollo.QueryResult<CurrentClientQuery, CurrentClientQueryVariables>;
export const GetUserPermissionsForAccountDocument = gql`
    query GetUserPermissionsForAccount($clientId: ID!) {
  userPermissionsForAccount(clientId: $clientId) {
    permissions {
      name
      title
      description
    }
  }
}
    `;

/**
 * __useGetUserPermissionsForAccountQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsForAccountQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetUserPermissionsForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables> & ({ variables: GetUserPermissionsForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables>(GetUserPermissionsForAccountDocument, options);
      }
export function useGetUserPermissionsForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables>(GetUserPermissionsForAccountDocument, options);
        }
export function useGetUserPermissionsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables>(GetUserPermissionsForAccountDocument, options);
        }
export type GetUserPermissionsForAccountQueryHookResult = ReturnType<typeof useGetUserPermissionsForAccountQuery>;
export type GetUserPermissionsForAccountLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsForAccountLazyQuery>;
export type GetUserPermissionsForAccountSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsForAccountSuspenseQuery>;
export type GetUserPermissionsForAccountQueryResult = Apollo.QueryResult<GetUserPermissionsForAccountQuery, GetUserPermissionsForAccountQueryVariables>;
export const GetBlockDocument = gql`
    query GetBlock($id: ID!) {
  block(id: $id) {
    ...blockFragment
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useGetBlockQuery__
 *
 * To run a query within a React component, call `useGetBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockQuery(baseOptions: Apollo.QueryHookOptions<GetBlockQuery, GetBlockQueryVariables> & ({ variables: GetBlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockQuery, GetBlockQueryVariables>(GetBlockDocument, options);
      }
export function useGetBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockQuery, GetBlockQueryVariables>(GetBlockDocument, options);
        }
export function useGetBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlockQuery, GetBlockQueryVariables>(GetBlockDocument, options);
        }
export type GetBlockQueryHookResult = ReturnType<typeof useGetBlockQuery>;
export type GetBlockLazyQueryHookResult = ReturnType<typeof useGetBlockLazyQuery>;
export type GetBlockSuspenseQueryHookResult = ReturnType<typeof useGetBlockSuspenseQuery>;
export type GetBlockQueryResult = Apollo.QueryResult<GetBlockQuery, GetBlockQueryVariables>;
export const BlockRenameDocument = gql`
    mutation BlockRename($id: ID!, $name: String!) {
  blockRename(id: $id, name: $name) {
    success
    block {
      id
      name
      updatedAt
    }
  }
}
    `;
export type BlockRenameMutationFn = Apollo.MutationFunction<BlockRenameMutation, BlockRenameMutationVariables>;

/**
 * __useBlockRenameMutation__
 *
 * To run a mutation, you first call `useBlockRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockRenameMutation, { data, loading, error }] = useBlockRenameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useBlockRenameMutation(baseOptions?: Apollo.MutationHookOptions<BlockRenameMutation, BlockRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockRenameMutation, BlockRenameMutationVariables>(BlockRenameDocument, options);
      }
export type BlockRenameMutationHookResult = ReturnType<typeof useBlockRenameMutation>;
export type BlockRenameMutationResult = Apollo.MutationResult<BlockRenameMutation>;
export type BlockRenameMutationOptions = Apollo.BaseMutationOptions<BlockRenameMutation, BlockRenameMutationVariables>;
export const BlockSaveDocument = gql`
    mutation BlockSave($id: ID, $name: String!, $document: LayoutDocument!, $description: String, $usedBrandKitId: ID, $draft: Boolean = false) {
  blockSave(
    id: $id
    name: $name
    document: $document
    description: $description
    usedBrandKitId: $usedBrandKitId
    draft: $draft
  ) {
    success
    block {
      ...blockFragment
    }
  }
}
    ${BlockFragmentFragmentDoc}`;
export type BlockSaveMutationFn = Apollo.MutationFunction<BlockSaveMutation, BlockSaveMutationVariables>;

/**
 * __useBlockSaveMutation__
 *
 * To run a mutation, you first call `useBlockSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockSaveMutation, { data, loading, error }] = useBlockSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      document: // value for 'document'
 *      description: // value for 'description'
 *      usedBrandKitId: // value for 'usedBrandKitId'
 *      draft: // value for 'draft'
 *   },
 * });
 */
export function useBlockSaveMutation(baseOptions?: Apollo.MutationHookOptions<BlockSaveMutation, BlockSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockSaveMutation, BlockSaveMutationVariables>(BlockSaveDocument, options);
      }
export type BlockSaveMutationHookResult = ReturnType<typeof useBlockSaveMutation>;
export type BlockSaveMutationResult = Apollo.MutationResult<BlockSaveMutation>;
export type BlockSaveMutationOptions = Apollo.BaseMutationOptions<BlockSaveMutation, BlockSaveMutationVariables>;
export const ContentComponentSaveDocument = gql`
    mutation ContentComponentSave($id: ID, $name: String!, $document: LayoutDocument!, $description: String, $usedBrandKitId: ID) {
  layoutComponentSave(
    id: $id
    name: $name
    document: $document
    description: $description
    usedBrandKitId: $usedBrandKitId
  ) {
    success
    layoutComponent {
      ...layoutComponentFragment
    }
  }
}
    ${LayoutComponentFragmentFragmentDoc}`;
export type ContentComponentSaveMutationFn = Apollo.MutationFunction<ContentComponentSaveMutation, ContentComponentSaveMutationVariables>;

/**
 * __useContentComponentSaveMutation__
 *
 * To run a mutation, you first call `useContentComponentSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentComponentSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentComponentSaveMutation, { data, loading, error }] = useContentComponentSaveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      document: // value for 'document'
 *      description: // value for 'description'
 *      usedBrandKitId: // value for 'usedBrandKitId'
 *   },
 * });
 */
export function useContentComponentSaveMutation(baseOptions?: Apollo.MutationHookOptions<ContentComponentSaveMutation, ContentComponentSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentComponentSaveMutation, ContentComponentSaveMutationVariables>(ContentComponentSaveDocument, options);
      }
export type ContentComponentSaveMutationHookResult = ReturnType<typeof useContentComponentSaveMutation>;
export type ContentComponentSaveMutationResult = Apollo.MutationResult<ContentComponentSaveMutation>;
export type ContentComponentSaveMutationOptions = Apollo.BaseMutationOptions<ContentComponentSaveMutation, ContentComponentSaveMutationVariables>;
export const LayoutComponentThumbnailDocument = gql`
    query LayoutComponentThumbnail($id: ID!) {
  layoutComponent(id: $id) {
    id
    thumbnail
  }
}
    `;

/**
 * __useLayoutComponentThumbnailQuery__
 *
 * To run a query within a React component, call `useLayoutComponentThumbnailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutComponentThumbnailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutComponentThumbnailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutComponentThumbnailQuery(baseOptions: Apollo.QueryHookOptions<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables> & ({ variables: LayoutComponentThumbnailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables>(LayoutComponentThumbnailDocument, options);
      }
export function useLayoutComponentThumbnailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables>(LayoutComponentThumbnailDocument, options);
        }
export function useLayoutComponentThumbnailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables>(LayoutComponentThumbnailDocument, options);
        }
export type LayoutComponentThumbnailQueryHookResult = ReturnType<typeof useLayoutComponentThumbnailQuery>;
export type LayoutComponentThumbnailLazyQueryHookResult = ReturnType<typeof useLayoutComponentThumbnailLazyQuery>;
export type LayoutComponentThumbnailSuspenseQueryHookResult = ReturnType<typeof useLayoutComponentThumbnailSuspenseQuery>;
export type LayoutComponentThumbnailQueryResult = Apollo.QueryResult<LayoutComponentThumbnailQuery, LayoutComponentThumbnailQueryVariables>;
export const ContentComponentRenameDocument = gql`
    mutation ContentComponentRename($id: ID!, $name: String!) {
  layoutComponentRename(id: $id, name: $name) {
    success
    layoutComponent {
      id
      name
    }
  }
}
    `;
export type ContentComponentRenameMutationFn = Apollo.MutationFunction<ContentComponentRenameMutation, ContentComponentRenameMutationVariables>;

/**
 * __useContentComponentRenameMutation__
 *
 * To run a mutation, you first call `useContentComponentRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentComponentRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentComponentRenameMutation, { data, loading, error }] = useContentComponentRenameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useContentComponentRenameMutation(baseOptions?: Apollo.MutationHookOptions<ContentComponentRenameMutation, ContentComponentRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentComponentRenameMutation, ContentComponentRenameMutationVariables>(ContentComponentRenameDocument, options);
      }
export type ContentComponentRenameMutationHookResult = ReturnType<typeof useContentComponentRenameMutation>;
export type ContentComponentRenameMutationResult = Apollo.MutationResult<ContentComponentRenameMutation>;
export type ContentComponentRenameMutationOptions = Apollo.BaseMutationOptions<ContentComponentRenameMutation, ContentComponentRenameMutationVariables>;
export const LayoutComponentDocument = gql`
    query LayoutComponent($id: ID!) {
  layoutComponent(id: $id) {
    ...layoutComponentFragment
  }
}
    ${LayoutComponentFragmentFragmentDoc}`;

/**
 * __useLayoutComponentQuery__
 *
 * To run a query within a React component, call `useLayoutComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutComponentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutComponentQuery(baseOptions: Apollo.QueryHookOptions<LayoutComponentQuery, LayoutComponentQueryVariables> & ({ variables: LayoutComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutComponentQuery, LayoutComponentQueryVariables>(LayoutComponentDocument, options);
      }
export function useLayoutComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutComponentQuery, LayoutComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutComponentQuery, LayoutComponentQueryVariables>(LayoutComponentDocument, options);
        }
export function useLayoutComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutComponentQuery, LayoutComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutComponentQuery, LayoutComponentQueryVariables>(LayoutComponentDocument, options);
        }
export type LayoutComponentQueryHookResult = ReturnType<typeof useLayoutComponentQuery>;
export type LayoutComponentLazyQueryHookResult = ReturnType<typeof useLayoutComponentLazyQuery>;
export type LayoutComponentSuspenseQueryHookResult = ReturnType<typeof useLayoutComponentSuspenseQuery>;
export type LayoutComponentQueryResult = Apollo.QueryResult<LayoutComponentQuery, LayoutComponentQueryVariables>;
export const ProofContactsAndGroupsDocument = gql`
    query ProofContactsAndGroups($search: String!, $channel: Channel) {
  proofContacts(search: $search, sort: SENDS_DESC, channel: $channel) {
    id
    channel
    emailAddress
    channelId
    firstName
    lastName
    sends
    previewContactGroups {
      id
      title
      contactCount
    }
  }
  proofContactGroups(search: $search, sort: SENDS_DESC, channel: $channel) {
    id
    title
    contacts {
      id
      channel
      channelId
      emailAddress
      firstName
      lastName
    }
    contactCount
    sends
  }
}
    `;

/**
 * __useProofContactsAndGroupsQuery__
 *
 * To run a query within a React component, call `useProofContactsAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProofContactsAndGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProofContactsAndGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProofContactsAndGroupsQuery(baseOptions: Apollo.QueryHookOptions<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables> & ({ variables: ProofContactsAndGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables>(ProofContactsAndGroupsDocument, options);
      }
export function useProofContactsAndGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables>(ProofContactsAndGroupsDocument, options);
        }
export function useProofContactsAndGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables>(ProofContactsAndGroupsDocument, options);
        }
export type ProofContactsAndGroupsQueryHookResult = ReturnType<typeof useProofContactsAndGroupsQuery>;
export type ProofContactsAndGroupsLazyQueryHookResult = ReturnType<typeof useProofContactsAndGroupsLazyQuery>;
export type ProofContactsAndGroupsSuspenseQueryHookResult = ReturnType<typeof useProofContactsAndGroupsSuspenseQuery>;
export type ProofContactsAndGroupsQueryResult = Apollo.QueryResult<ProofContactsAndGroupsQuery, ProofContactsAndGroupsQueryVariables>;
export const ContactAudienceFieldsDocument = gql`
    query ContactAudienceFields {
  contactAudienceFields {
    tables {
      id
      name
      fields {
        id
        displayName
        name
        type
      }
    }
  }
}
    `;

/**
 * __useContactAudienceFieldsQuery__
 *
 * To run a query within a React component, call `useContactAudienceFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAudienceFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAudienceFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactAudienceFieldsQuery(baseOptions?: Apollo.QueryHookOptions<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>(ContactAudienceFieldsDocument, options);
      }
export function useContactAudienceFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>(ContactAudienceFieldsDocument, options);
        }
export function useContactAudienceFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>(ContactAudienceFieldsDocument, options);
        }
export type ContactAudienceFieldsQueryHookResult = ReturnType<typeof useContactAudienceFieldsQuery>;
export type ContactAudienceFieldsLazyQueryHookResult = ReturnType<typeof useContactAudienceFieldsLazyQuery>;
export type ContactAudienceFieldsSuspenseQueryHookResult = ReturnType<typeof useContactAudienceFieldsSuspenseQuery>;
export type ContactAudienceFieldsQueryResult = Apollo.QueryResult<ContactAudienceFieldsQuery, ContactAudienceFieldsQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  tags {
    id
    name
    __typename
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetCreativeMetadataDocument = gql`
    query GetCreativeMetadata($creativeId: ID!) {
  creative(id: $creativeId) {
    __typename
    id
    title
    status
  }
}
    `;

/**
 * __useGetCreativeMetadataQuery__
 *
 * To run a query within a React component, call `useGetCreativeMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreativeMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreativeMetadataQuery({
 *   variables: {
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useGetCreativeMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables> & ({ variables: GetCreativeMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables>(GetCreativeMetadataDocument, options);
      }
export function useGetCreativeMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables>(GetCreativeMetadataDocument, options);
        }
export function useGetCreativeMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables>(GetCreativeMetadataDocument, options);
        }
export type GetCreativeMetadataQueryHookResult = ReturnType<typeof useGetCreativeMetadataQuery>;
export type GetCreativeMetadataLazyQueryHookResult = ReturnType<typeof useGetCreativeMetadataLazyQuery>;
export type GetCreativeMetadataSuspenseQueryHookResult = ReturnType<typeof useGetCreativeMetadataSuspenseQuery>;
export type GetCreativeMetadataQueryResult = Apollo.QueryResult<GetCreativeMetadataQuery, GetCreativeMetadataQueryVariables>;
export const SendTimeMetricsDocument = gql`
    query SendTimeMetrics($campaignId: ID!) {
  analyticsCampaignSendTimeMetrics(campaignId: $campaignId) {
    sendTime
    sends
  }
}
    `;

/**
 * __useSendTimeMetricsQuery__
 *
 * To run a query within a React component, call `useSendTimeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendTimeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendTimeMetricsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSendTimeMetricsQuery(baseOptions: Apollo.QueryHookOptions<SendTimeMetricsQuery, SendTimeMetricsQueryVariables> & ({ variables: SendTimeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendTimeMetricsQuery, SendTimeMetricsQueryVariables>(SendTimeMetricsDocument, options);
      }
export function useSendTimeMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendTimeMetricsQuery, SendTimeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendTimeMetricsQuery, SendTimeMetricsQueryVariables>(SendTimeMetricsDocument, options);
        }
export function useSendTimeMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SendTimeMetricsQuery, SendTimeMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SendTimeMetricsQuery, SendTimeMetricsQueryVariables>(SendTimeMetricsDocument, options);
        }
export type SendTimeMetricsQueryHookResult = ReturnType<typeof useSendTimeMetricsQuery>;
export type SendTimeMetricsLazyQueryHookResult = ReturnType<typeof useSendTimeMetricsLazyQuery>;
export type SendTimeMetricsSuspenseQueryHookResult = ReturnType<typeof useSendTimeMetricsSuspenseQuery>;
export type SendTimeMetricsQueryResult = Apollo.QueryResult<SendTimeMetricsQuery, SendTimeMetricsQueryVariables>;